(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.utuSdk = {}));
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function getAugmentedNamespace(n) {
		if (n.__esModule) return n;
		var a = Object.defineProperty({}, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	function createCommonjsModule$1(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}

	var check = function (it) {
	  return it && it.Math == Math && it;
	}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


	var global$1 = // eslint-disable-next-line es-x/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	// Detect IE8's incomplete defineProperty implementation


	var descriptors = !fails(function () {
	  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] != 7;
	});

	var functionBindNative = !fails(function () {
	  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
	  var test = function () {
	    /* empty */
	  }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});

	var call$2 = Function.prototype.call;
	var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
	  return call$2.apply(call$2, arguments);
	};

	var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe

	var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

	var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({
	  1: 2
	}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

	var f$8 = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$2(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;

	var objectPropertyIsEnumerable = {
		f: f$8
	};

	var createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var FunctionPrototype$2 = Function.prototype;
	var bind$2 = FunctionPrototype$2.bind;
	var call$1 = FunctionPrototype$2.call;
	var uncurryThis = functionBindNative && bind$2.bind(call$1, call$1);
	var functionUncurryThis = functionBindNative ? function (fn) {
	  return fn && uncurryThis(fn);
	} : function (fn) {
	  return fn && function () {
	    return call$1.apply(fn, arguments);
	  };
	};

	var toString$4 = functionUncurryThis({}.toString);
	var stringSlice$3 = functionUncurryThis(''.slice);

	var classofRaw = function (it) {
	  return stringSlice$3(toString$4(it), 8, -1);
	};

	var $Object$4 = Object;
	var split$1 = functionUncurryThis(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

	var indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object$4('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classofRaw(it) == 'String' ? split$1(it, '') : $Object$4(it);
	} : $Object$4;

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined$1 = function (it) {
	  return it === null || it === undefined;
	};

	var $TypeError$f = TypeError; // `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible

	var requireObjectCoercible = function (it) {
	  if (isNullOrUndefined$1(it)) throw $TypeError$f("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings




	var toIndexedObject = function (it) {
	  return indexedObject(requireObjectCoercible(it));
	};

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	var isCallable = function (argument) {
	  return typeof argument == 'function';
	};

	var documentAll = typeof document == 'object' && document.all; // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot

	var SPECIAL_DOCUMENT_ALL = typeof documentAll == 'undefined' && documentAll !== undefined;
	var isObject$2 = SPECIAL_DOCUMENT_ALL ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};

	var getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global$1[namespace]) : global$1[namespace] && global$1[namespace][method];
	};

	var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

	var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

	var process$1 = global$1.process;
	var Deno = global$1.Deno;
	var versions = process$1 && process$1.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version$k;

	if (v8) {
	  match = v8.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us

	  version$k = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	} // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0


	if (!version$k && engineUserAgent) {
	  match = engineUserAgent.match(/Edge\/(\d+)/);

	  if (!match || match[1] >= 74) {
	    match = engineUserAgent.match(/Chrome\/(\d+)/);
	    if (match) version$k = +match[1];
	  }
	}

	var engineV8Version = version$k;

	/* eslint-disable es-x/no-symbol -- required for testing */

	// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing


	var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

	  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && engineV8Version && engineV8Version < 41;
	});

	/* eslint-disable es-x/no-symbol -- required for testing */

	var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var $Object$3 = Object;
	var isSymbol$1 = useSymbolAsUid ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
	};

	var $String$3 = String;

	var tryToString = function (argument) {
	  try {
	    return $String$3(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var $TypeError$e = TypeError; // `Assert: IsCallable(argument) is true`

	var aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw $TypeError$e(tryToString(argument) + ' is not a function');
	};

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod


	var getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined$1(func) ? undefined : aCallable(func);
	};

	var $TypeError$d = TypeError; // `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive

	var ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject$2(val = functionCall(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject$2(val = functionCall(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject$2(val = functionCall(fn, input))) return val;
	  throw $TypeError$d("Can't convert object to primitive value");
	};

	// eslint-disable-next-line es-x/no-object-defineproperty -- safe


	var defineProperty$3 = Object.defineProperty;

	var defineGlobalProperty = function (key, value) {
	  try {
	    defineProperty$3(global$1, key, {
	      value: value,
	      configurable: true,
	      writable: true
	    });
	  } catch (error) {
	    global$1[key] = value;
	  }

	  return value;
	};

	var SHARED = '__core-js_shared__';
	var store$1 = global$1[SHARED] || defineGlobalProperty(SHARED, {});
	var sharedStore = store$1;

	var shared = createCommonjsModule$1(function (module) {
	(module.exports = function (key, value) {
	  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.25.1',
	  mode: 'global',
	  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.25.1/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});
	});

	var $Object$2 = Object; // `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject

	var toObject$1 = function (argument) {
	  return $Object$2(requireObjectCoercible(argument));
	};

	var hasOwnProperty$1 = functionUncurryThis({}.hasOwnProperty); // `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es-x/no-object-hasown -- safe

	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty$1(toObject$1(it), key);
	};

	var id$1 = 0;
	var postfix = Math.random();
	var toString$3 = functionUncurryThis(1.0.toString);

	var uid = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id$1 + postfix, 36);
	};

	var WellKnownSymbolsStore = shared('wks');
	var Symbol$1 = global$1.Symbol;
	var symbolFor = Symbol$1 && Symbol$1['for'];
	var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

	var wellKnownSymbol = function (name) {
	  if (!hasOwnProperty_1(WellKnownSymbolsStore, name) || !(symbolConstructorDetection || typeof WellKnownSymbolsStore[name] == 'string')) {
	    var description = 'Symbol.' + name;

	    if (symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)) {
	      WellKnownSymbolsStore[name] = Symbol$1[name];
	    } else if (useSymbolAsUid && symbolFor) {
	      WellKnownSymbolsStore[name] = symbolFor(description);
	    } else {
	      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
	    }
	  }

	  return WellKnownSymbolsStore[name];
	};

	var $TypeError$c = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive'); // `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive

	var toPrimitive = function (input, pref) {
	  if (!isObject$2(input) || isSymbol$1(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;

	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = functionCall(exoticToPrim, input, pref);
	    if (!isObject$2(result) || isSymbol$1(result)) return result;
	    throw $TypeError$c("Can't convert object to primitive value");
	  }

	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey


	var toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol$1(key) ? key : key + '';
	};

	var document$1 = global$1.document; // typeof document.createElement is 'object' in old IE

	var EXISTS$1 = isObject$2(document$1) && isObject$2(document$1.createElement);

	var documentCreateElement = function (it) {
	  return EXISTS$1 ? document$1.createElement(it) : {};
	};

	// Thanks to IE8 for its funny defineProperty


	var ie8DomDefine = !descriptors && !fails(function () {
	  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
	  return Object.defineProperty(documentCreateElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a != 7;
	});

	// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe


	var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

	var f$7 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (ie8DomDefine) try {
	    return $getOwnPropertyDescriptor$1(O, P);
	  } catch (error) {
	    /* empty */
	  }
	  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
	};

	var objectGetOwnPropertyDescriptor = {
		f: f$7
	};

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334


	var v8PrototypeDefineBug = descriptors && fails(function () {
	  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () {
	    /* empty */
	  }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype != 42;
	});

	var $String$2 = String;
	var $TypeError$b = TypeError; // `Assert: Type(argument) is Object`

	var anObject = function (argument) {
	  if (isObject$2(argument)) return argument;
	  throw $TypeError$b($String$2(argument) + ' is not an object');
	};

	var $TypeError$a = TypeError; // eslint-disable-next-line es-x/no-object-defineproperty -- safe

	var $defineProperty = Object.defineProperty; // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe

	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE$1 = 'configurable';
	var WRITABLE = 'writable'; // `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty

	var f$6 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);

	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);

	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  }

	  return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (ie8DomDefine) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {
	    /* empty */
	  }
	  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$a('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var objectDefineProperty = {
		f: f$6
	};

	var createNonEnumerableProperty = descriptors ? function (object, key, value) {
	  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var FunctionPrototype$1 = Function.prototype; // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe

	var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
	var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name'); // additional protection from minified / mangled / dropped function names

	var PROPER = EXISTS && function something() {
	  /* empty */
	}.name === 'something';

	var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable);
	var functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};

	var functionToString$1 = functionUncurryThis(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

	if (!isCallable(sharedStore.inspectSource)) {
	  sharedStore.inspectSource = function (it) {
	    return functionToString$1(it);
	  };
	}

	var inspectSource = sharedStore.inspectSource;

	var WeakMap$2 = global$1.WeakMap;
	var weakMapBasicDetection = isCallable(WeakMap$2) && /native code/.test(String(WeakMap$2));

	var keys$1 = shared('keys');

	var sharedKey = function (key) {
	  return keys$1[key] || (keys$1[key] = uid(key));
	};

	var hiddenKeys$1 = {};

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$2 = global$1.TypeError;
	var WeakMap$1 = global$1.WeakMap;
	var set$2, get$1, has$8;

	var enforce = function (it) {
	  return has$8(it) ? get$1(it) : set$2(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;

	    if (!isObject$2(it) || (state = get$1(it)).type !== TYPE) {
	      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
	    }

	    return state;
	  };
	};

	if (weakMapBasicDetection || sharedStore.state) {
	  var store = sharedStore.state || (sharedStore.state = new WeakMap$1());
	  var wmget = functionUncurryThis(store.get);
	  var wmhas = functionUncurryThis(store.has);
	  var wmset = functionUncurryThis(store.set);

	  set$2 = function (it, metadata) {
	    if (wmhas(store, it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    wmset(store, it, metadata);
	    return metadata;
	  };

	  get$1 = function (it) {
	    return wmget(store, it) || {};
	  };

	  has$8 = function (it) {
	    return wmhas(store, it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys$1[STATE] = true;

	  set$2 = function (it, metadata) {
	    if (hasOwnProperty_1(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };

	  get$1 = function (it) {
	    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
	  };

	  has$8 = function (it) {
	    return hasOwnProperty_1(it, STATE);
	  };
	}

	var internalState = {
	  set: set$2,
	  get: get$1,
	  has: has$8,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var makeBuiltIn_1 = createCommonjsModule$1(function (module) {
	var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;





	var enforceInternalState = internalState.enforce;
	var getInternalState = internalState.get; // eslint-disable-next-line es-x/no-object-defineproperty -- safe

	var defineProperty = Object.defineProperty;
	var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
	  return defineProperty(function () {
	    /* empty */
	  }, 'length', {
	    value: 8
	  }).length !== 8;
	});
	var TEMPLATE = String(String).split('String');

	var makeBuiltIn = module.exports = function (value, name, options) {
	  if (String(name).slice(0, 7) === 'Symbol(') {
	    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
	  }

	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;

	  if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
	    if (descriptors) defineProperty(value, 'name', {
	      value: name,
	      configurable: true
	    });else value.name = name;
	  }

	  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', {
	      value: options.arity
	    });
	  }

	  try {
	    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
	      if (descriptors) defineProperty(value, 'prototype', {
	        writable: false
	      }); // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) {
	    /* empty */
	  }

	  var state = enforceInternalState(value);

	  if (!hasOwnProperty_1(state, 'source')) {
	    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
	  }

	  return value;
	}; // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required


	Function.prototype.toString = makeBuiltIn(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');
	});

	var defineBuiltIn = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn_1(value, name, options);

	  if (options.global) {
	    if (simple) O[key] = value;else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
	    } catch (error) {
	      /* empty */
	    }

	    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  }

	  return O;
	};

	var ceil = Math.ceil;
	var floor = Math.floor; // `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es-x/no-math-trunc -- safe

	var mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity


	var toIntegerOrInfinity = function (argument) {
	  var number = +argument; // eslint-disable-next-line no-self-compare -- NaN check

	  return number !== number || number === 0 ? 0 : mathTrunc(number);
	};

	var max$2 = Math.max;
	var min$2 = Math.min; // Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

	var toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
	};

	var min$1 = Math.min; // `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength

	var toLength = function (argument) {
	  return argument > 0 ? min$1(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike


	var lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};

	// `Array.prototype.{ indexOf, includes }` methods implementation


	var createMethod$4 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value; // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check

	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

	      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$4(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$4(false)
	};

	var indexOf$2 = arrayIncludes.indexOf;



	var push$3 = functionUncurryThis([].push);

	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;

	  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$3(result, key); // Don't enum bug & hidden keys


	  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
	    ~indexOf$2(result, key) || push$3(result, key);
	  }

	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	var hiddenKeys = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe

	var f$5 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return objectKeysInternal(O, hiddenKeys);
	};

	var objectGetOwnPropertyNames = {
		f: f$5
	};

	// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
	var f$4 = Object.getOwnPropertySymbols;

	var objectGetOwnPropertySymbols = {
		f: f$4
	};

	var concat$3 = functionUncurryThis([].concat); // all object keys, includes non-enumerable and symbols

	var ownKeys$3 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = objectGetOwnPropertyNames.f(anObject(it));
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  return getOwnPropertySymbols ? concat$3(keys, getOwnPropertySymbols(it)) : keys;
	};

	var copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys$3(source);
	  var defineProperty = objectDefineProperty.f;
	  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];

	    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};

	var replacement = /#|\.prototype\./;

	var isForced = function (feature, detection) {
	  var value = data[normalize$1(feature)];
	  return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
	};

	var normalize$1 = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	var isForced_1 = isForced;

	var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;










	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/


	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

	  if (GLOBAL) {
	    target = global$1;
	  } else if (STATIC) {
	    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = (global$1[TARGET] || {}).prototype;
	  }

	  if (target) for (key in source) {
	    sourceProperty = source[key];

	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor$1(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];

	    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    } // add a flag to not completely full polyfills


	    if (options.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }

	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};

	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call; // eslint-disable-next-line es-x/no-reflect -- safe

	var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es-x/no-array-isarray -- safe


	var isArray$5 = Array.isArray || function isArray(argument) {
	  return classofRaw(argument) == 'Array';
	};

	var arraySlice$1 = functionUncurryThis([].slice);

	var $stringify = getBuiltIn('JSON', 'stringify');
	var exec$2 = functionUncurryThis(/./.exec);
	var charAt$3 = functionUncurryThis(''.charAt);
	var charCodeAt$2 = functionUncurryThis(''.charCodeAt);
	var replace$3 = functionUncurryThis(''.replace);
	var numberToString = functionUncurryThis(1.0.toString);
	var tester = /[\uD800-\uDFFF]/g;
	var low = /^[\uD800-\uDBFF]$/;
	var hi = /^[\uDC00-\uDFFF]$/;
	var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
	  var symbol = getBuiltIn('Symbol')(); // MS Edge converts symbol values to JSON as {}

	  return $stringify([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
	  || $stringify({
	    a: symbol
	  }) != '{}' // V8 throws on boxed symbols
	  || $stringify(Object(symbol)) != '{}';
	}); // https://github.com/tc39/proposal-well-formed-stringify

	var ILL_FORMED_UNICODE = fails(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
	});

	var stringifyWithSymbolsFix = function (it, replacer) {
	  var args = arraySlice$1(arguments);
	  var $replacer = replacer;
	  if (!isObject$2(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined

	  if (!isArray$5(replacer)) replacer = function (key, value) {
	    if (isCallable($replacer)) value = functionCall($replacer, this, key, value);
	    if (!isSymbol$1(value)) return value;
	  };
	  args[1] = replacer;
	  return functionApply($stringify, null, args);
	};

	var fixIllFormed = function (match, offset, string) {
	  var prev = charAt$3(string, offset - 1);
	  var next = charAt$3(string, offset + 1);

	  if (exec$2(low, match) && !exec$2(hi, next) || exec$2(hi, match) && !exec$2(low, prev)) {
	    return '\\u' + numberToString(charCodeAt$2(match, 0), 16);
	  }

	  return match;
	};

	if ($stringify) {
	  // `JSON.stringify` method
	  // https://tc39.es/ecma262/#sec-json.stringify
	  _export({
	    target: 'JSON',
	    stat: true,
	    arity: 3,
	    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
	  }, {
	    // eslint-disable-next-line no-unused-vars -- required for `.length`
	    stringify: function stringify(it, replacer, space) {
	      var args = arraySlice$1(arguments);
	      var result = functionApply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
	      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$3(result, tester, fixIllFormed) : result;
	    }
	  });
	}

	var n$2,l$3,u$3,t$3,o$3,r$6,f$3={},e$3=[],c$4=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function s$5(n,l){for(var u in l)n[u]=l[u];return n}function a$4(n){var l=n.parentNode;l&&l.removeChild(n);}function h$2(l,u,i){var t,o,r,f={};for(r in u)"key"==r?t=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?n$2.call(arguments,2):i),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps)void 0===f[r]&&(f[r]=l.defaultProps[r]);return v$2(l,f,t,o,null)}function v$2(n,i,t,o,r){var f={type:n,props:i,key:t,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==r?++u$3:r};return null==r&&null!=l$3.vnode&&l$3.vnode(f),f}function p$1(n){return n.children}function d$2(n,l){this.props=n,this.context=l;}function _$1(n,l){if(null==l)return n.__?_$1(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?_$1(n):null}function k$1(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return k$1(n)}}function b$1(n){(!n.__d&&(n.__d=!0)&&t$3.push(n)&&!g$2.__r++||o$3!==l$3.debounceRendering)&&((o$3=l$3.debounceRendering)||setTimeout)(g$2);}function g$2(){for(var n;g$2.__r=t$3.length;)n=t$3.sort(function(n,l){return n.__v.__b-l.__v.__b}),t$3=[],n.some(function(n){var l,u,i,t,o,r;n.__d&&(o=(t=(l=n).__v).__e,(r=l.__P)&&(u=[],(i=s$5({},t)).__v=t.__v+1,j$3(r,t,i,l.__n,void 0!==r.ownerSVGElement,null!=t.__h?[o]:null,u,null==o?_$1(t):o,t.__h),z$2(u,t),t.__e!=o&&k$1(t)));});}function w$2(n,l,u,i,t,o,r,c,s,a){var h,y,d,k,b,g,w,x=i&&i.__k||e$3,C=x.length;for(u.__k=[],h=0;h<l.length;h++)if(null!=(k=u.__k[h]=null==(k=l[h])||"boolean"==typeof k?null:"string"==typeof k||"number"==typeof k||"bigint"==typeof k?v$2(null,k,null,null,k):Array.isArray(k)?v$2(p$1,{children:k},null,null,null):k.__b>0?v$2(k.type,k.props,k.key,null,k.__v):k)){if(k.__=u,k.__b=u.__b+1,null===(d=x[h])||d&&k.key==d.key&&k.type===d.type)x[h]=void 0;else for(y=0;y<C;y++){if((d=x[y])&&k.key==d.key&&k.type===d.type){x[y]=void 0;break}d=null;}j$3(n,k,d=d||f$3,t,o,r,c,s,a),b=k.__e,(y=k.ref)&&d.ref!=y&&(w||(w=[]),d.ref&&w.push(d.ref,null,k),w.push(y,k.__c||b,k)),null!=b?(null==g&&(g=b),"function"==typeof k.type&&k.__k===d.__k?k.__d=s=m$1(k,s,n):s=A$1(n,k,d,x,b,s),"function"==typeof u.type&&(u.__d=s)):s&&d.__e==s&&s.parentNode!=n&&(s=_$1(d));}for(u.__e=g,h=C;h--;)null!=x[h]&&("function"==typeof u.type&&null!=x[h].__e&&x[h].__e==u.__d&&(u.__d=_$1(i,h+1)),N(x[h],x[h]));if(w)for(h=0;h<w.length;h++)M(w[h],w[++h],w[++h]);}function m$1(n,l,u){for(var i,t=n.__k,o=0;t&&o<t.length;o++)(i=t[o])&&(i.__=n,l="function"==typeof i.type?m$1(i,l,u):A$1(u,i,i,t,i.__e,l));return l}function x$1(n,l){return l=l||[],null==n||"boolean"==typeof n||(Array.isArray(n)?n.some(function(n){x$1(n,l);}):l.push(n)),l}function A$1(n,l,u,i,t,o){var r,f,e;if(void 0!==l.__d)r=l.__d,l.__d=void 0;else if(null==u||t!=o||null==t.parentNode)n:if(null==o||o.parentNode!==n)n.appendChild(t),r=null;else {for(f=o,e=0;(f=f.nextSibling)&&e<i.length;e+=2)if(f==t)break n;n.insertBefore(t,o),r=o;}return void 0!==r?r:t.nextSibling}function C$1(n,l,u,i,t){var o;for(o in u)"children"===o||"key"===o||o in l||H$1(n,o,null,u[o],i);for(o in l)t&&"function"!=typeof l[o]||"children"===o||"key"===o||"value"===o||"checked"===o||u[o]===l[o]||H$1(n,o,l[o],u[o],i);}function $$1(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]=null==u?"":"number"!=typeof u||c$4.test(l)?u:u+"px";}function H$1(n,l,u,i,t){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof i&&(n.style.cssText=i=""),i)for(l in i)u&&l in u||$$1(n.style,l,"");if(u)for(l in u)i&&u[l]===i[l]||$$1(n.style,l,u[l]);}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?i||n.addEventListener(l,o?T$2:I,o):n.removeEventListener(l,o?T$2:I,o);else if("dangerouslySetInnerHTML"!==l){if(t)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null!=u&&(!1!==u||"a"===l[0]&&"r"===l[1])?n.setAttribute(l,u):n.removeAttribute(l));}}function I(n){this.l[n.type+!1](l$3.event?l$3.event(n):n);}function T$2(n){this.l[n.type+!0](l$3.event?l$3.event(n):n);}function j$3(n,u,i,t,o,r,f,e,c){var a,h,v,y,_,k,b,g,m,x,A,C,$,H=u.type;if(void 0!==u.constructor)return null;null!=i.__h&&(c=i.__h,e=u.__e=i.__e,u.__h=null,r=[e]),(a=l$3.__b)&&a(u);try{n:if("function"==typeof H){if(g=u.props,m=(a=H.contextType)&&t[a.__c],x=a?m?m.props.value:a.__:t,i.__c?b=(h=u.__c=i.__c).__=h.__E:("prototype"in H&&H.prototype.render?u.__c=h=new H(g,x):(u.__c=h=new d$2(g,x),h.constructor=H,h.render=O$1),m&&m.sub(h),h.props=g,h.state||(h.state={}),h.context=x,h.__n=t,v=h.__d=!0,h.__h=[]),null==h.__s&&(h.__s=h.state),null!=H.getDerivedStateFromProps&&(h.__s==h.state&&(h.__s=s$5({},h.__s)),s$5(h.__s,H.getDerivedStateFromProps(g,h.__s))),y=h.props,_=h.state,v)null==H.getDerivedStateFromProps&&null!=h.componentWillMount&&h.componentWillMount(),null!=h.componentDidMount&&h.__h.push(h.componentDidMount);else {if(null==H.getDerivedStateFromProps&&g!==y&&null!=h.componentWillReceiveProps&&h.componentWillReceiveProps(g,x),!h.__e&&null!=h.shouldComponentUpdate&&!1===h.shouldComponentUpdate(g,h.__s,x)||u.__v===i.__v){h.props=g,h.state=h.__s,u.__v!==i.__v&&(h.__d=!1),h.__v=u,u.__e=i.__e,u.__k=i.__k,u.__k.forEach(function(n){n&&(n.__=u);}),h.__h.length&&f.push(h);break n}null!=h.componentWillUpdate&&h.componentWillUpdate(g,h.__s,x),null!=h.componentDidUpdate&&h.__h.push(function(){h.componentDidUpdate(y,_,k);});}if(h.context=x,h.props=g,h.__v=u,h.__P=n,A=l$3.__r,C=0,"prototype"in H&&H.prototype.render)h.state=h.__s,h.__d=!1,A&&A(u),a=h.render(h.props,h.state,h.context);else do{h.__d=!1,A&&A(u),a=h.render(h.props,h.state,h.context),h.state=h.__s;}while(h.__d&&++C<25);h.state=h.__s,null!=h.getChildContext&&(t=s$5(s$5({},t),h.getChildContext())),v||null==h.getSnapshotBeforeUpdate||(k=h.getSnapshotBeforeUpdate(y,_)),$=null!=a&&a.type===p$1&&null==a.key?a.props.children:a,w$2(n,Array.isArray($)?$:[$],u,i,t,o,r,f,e,c),h.base=u.__e,u.__h=null,h.__h.length&&f.push(h),b&&(h.__E=h.__=null),h.__e=!1;}else null==r&&u.__v===i.__v?(u.__k=i.__k,u.__e=i.__e):u.__e=L$1(i.__e,u,i,t,o,r,f,c);(a=l$3.diffed)&&a(u);}catch(n){u.__v=null,(c||null!=r)&&(u.__e=e,u.__h=!!c,r[r.indexOf(e)]=null),l$3.__e(n,u,i);}}function z$2(n,u){l$3.__c&&l$3.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l$3.__e(n,u.__v);}});}function L$1(l,u,i,t,o,r,e,c){var s,h,v,y=i.props,p=u.props,d=u.type,k=0;if("svg"===d&&(o=!0),null!=r)for(;k<r.length;k++)if((s=r[k])&&"setAttribute"in s==!!d&&(d?s.localName===d:3===s.nodeType)){l=s,r[k]=null;break}if(null==l){if(null===d)return document.createTextNode(p);l=o?document.createElementNS("http://www.w3.org/2000/svg",d):document.createElement(d,p.is&&p),r=null,c=!1;}if(null===d)y===p||c&&l.data===p||(l.data=p);else {if(r=r&&n$2.call(l.childNodes),h=(y=i.props||f$3).dangerouslySetInnerHTML,v=p.dangerouslySetInnerHTML,!c){if(null!=r)for(y={},k=0;k<l.attributes.length;k++)y[l.attributes[k].name]=l.attributes[k].value;(v||h)&&(v&&(h&&v.__html==h.__html||v.__html===l.innerHTML)||(l.innerHTML=v&&v.__html||""));}if(C$1(l,p,y,o,c),v)u.__k=[];else if(k=u.props.children,w$2(l,Array.isArray(k)?k:[k],u,i,t,o&&"foreignObject"!==d,r,e,r?r[0]:i.__k&&_$1(i,0),c),null!=r)for(k=r.length;k--;)null!=r[k]&&a$4(r[k]);c||("value"in p&&void 0!==(k=p.value)&&(k!==l.value||"progress"===d&&!k||"option"===d&&k!==y.value)&&H$1(l,"value",k,y.value,!1),"checked"in p&&void 0!==(k=p.checked)&&k!==l.checked&&H$1(l,"checked",k,y.checked,!1));}return l}function M(n,u,i){try{"function"==typeof n?n(u):n.current=u;}catch(n){l$3.__e(n,i);}}function N(n,u,i){var t,o;if(l$3.unmount&&l$3.unmount(n),(t=n.ref)&&(t.current&&t.current!==n.__e||M(t,null,u)),null!=(t=n.__c)){if(t.componentWillUnmount)try{t.componentWillUnmount();}catch(n){l$3.__e(n,u);}t.base=t.__P=null;}if(t=n.__k)for(o=0;o<t.length;o++)t[o]&&N(t[o],u,"function"!=typeof n.type);i||null==n.__e||a$4(n.__e),n.__e=n.__d=void 0;}function O$1(n,l,u){return this.constructor(n,u)}function P$1(u,i,t){var o,r,e;l$3.__&&l$3.__(u,i),r=(o="function"==typeof t)?null:t&&t.__k||i.__k,e=[],j$3(i,u=(!o&&t||i).__k=h$2(p$1,null,[u]),r||f$3,f$3,void 0!==i.ownerSVGElement,!o&&t?[t]:r?null:i.firstChild?n$2.call(i.childNodes):null,e,!o&&t?t:r?r.__e:i.firstChild,o),z$2(e,u);}function S$1(n,l){P$1(n,l,S$1);}function q$2(l,u,i){var t,o,r,f=s$5({},l.props);for(r in u)"key"==r?t=u[r]:"ref"==r?o=u[r]:f[r]=u[r];return arguments.length>2&&(f.children=arguments.length>3?n$2.call(arguments,2):i),v$2(l.type,f,t||l.key,o||l.ref,null)}function B(n,l){var u={__c:l="__cC"+r$6++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,i;return this.getChildContext||(u=[],(i={})[l]=this,this.getChildContext=function(){return i},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(b$1);},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n);};}),n.children}};return u.Provider.__=u.Consumer.contextType=u}n$2=e$3.slice,l$3={__e:function(n,l,u,i){for(var t,o,r;l=l.__;)if((t=l.__c)&&!t.__)try{if((o=t.constructor)&&null!=o.getDerivedStateFromError&&(t.setState(o.getDerivedStateFromError(n)),r=t.__d),null!=t.componentDidCatch&&(t.componentDidCatch(n,i||{}),r=t.__d),r)return t.__E=t}catch(l){n=l;}throw n}},u$3=0,d$2.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=s$5({},this.state),"function"==typeof n&&(n=n(s$5({},u),this.props)),n&&s$5(u,n),null!=n&&this.__v&&(l&&this.__h.push(l),b$1(this));},d$2.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),b$1(this));},d$2.prototype.render=p$1,t$3=[],g$2.__r=0,r$6=0;

	function r$5() {
	  return (r$5 = Object.assign || function (t) {
	    for (var e = 1; e < arguments.length; e++) {
	      var n = arguments[e];

	      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
	    }

	    return t;
	  }).apply(this, arguments);
	}

	function i$2(t) {
	  this.getChildContext = function () {
	    return t.context;
	  };

	  var e = t.children,
	      n = function (t, e) {
	    if (null == t) return {};
	    var n,
	        o,
	        r = {},
	        i = Object.keys(t);

	    for (o = 0; o < i.length; o++) e.indexOf(n = i[o]) >= 0 || (r[n] = t[n]);

	    return r;
	  }(t, ["context", "children"]);

	  return q$2(e, n);
	}

	function a$3() {
	  var o = new CustomEvent("_preact", {
	    detail: {},
	    bubbles: !0,
	    cancelable: !0
	  });
	  this.dispatchEvent(o), this._vdom = h$2(i$2, r$5({}, this._props, {
	    context: o.detail.context
	  }), function e(n, o) {
	    if (3 === n.nodeType) return n.data;
	    if (1 !== n.nodeType) return null;
	    var r = [],
	        i = {},
	        a = 0,
	        c = n.attributes,
	        l = n.childNodes;

	    for (a = c.length; a--;) "slot" !== c[a].name && (i[c[a].name] = c[a].value, i[s$4(c[a].name)] = c[a].value);

	    for (a = l.length; a--;) {
	      var p = e(l[a], null),
	          d = l[a].slot;
	      d ? i[d] = h$2(u$2, {
	        name: d
	      }, p) : r[a] = p;
	    }

	    var h = o ? h$2(u$2, null, r) : r;
	    return h$2(o || n.nodeName.toLowerCase(), i, h);
	  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? S$1 : P$1)(this._vdom, this._root);
	}

	function s$4(t) {
	  return t.replace(/-(\w)/g, function (t, e) {
	    return e ? e.toUpperCase() : "";
	  });
	}

	function c$3(t, e, r) {
	  if (this._vdom) {
	    var i = {};
	    i[t] = r = null == r ? void 0 : r, i[s$4(t)] = r, this._vdom = q$2(this._vdom, i), P$1(this._vdom, this._root);
	  }
	}

	function l$2() {
	  P$1(this._vdom = null, this._root);
	}

	function u$2(e, n) {
	  var o = this;
	  return h$2("slot", r$5({}, e, {
	    ref: function (t) {
	      t ? (o.ref = t, o._listener || (o._listener = function (t) {
	        t.stopPropagation(), t.detail.context = n;
	      }, t.addEventListener("_preact", o._listener))) : o.ref.removeEventListener("_preact", o._listener);
	    }
	  }));
	}

	function register$2 (t, e, n, o) {
	  function r() {
	    var e = Reflect.construct(HTMLElement, [], r);
	    return e._vdomComponent = t, e._root = o && o.shadow ? e.attachShadow({
	      mode: "open"
	    }) : e, e;
	  }

	  return (r.prototype = Object.create(HTMLElement.prototype)).constructor = r, r.prototype.connectedCallback = a$3, r.prototype.attributeChangedCallback = c$3, r.prototype.disconnectedCallback = l$2, n = n || t.observedAttributes || Object.keys(t.propTypes || {}), r.observedAttributes = n, n.forEach(function (t) {
	    Object.defineProperty(r.prototype, t, {
	      get: function () {
	        return this._vdom.props[t];
	      },
	      set: function (e) {
	        this._vdom ? this.attributeChangedCallback(t, null, e) : (this._props || (this._props = {}), this._props[t] = e, this.connectedCallback());
	        var n = typeof e;
	        null != e && "string" !== n && "boolean" !== n && "number" !== n || this.setAttribute(t, e);
	      }
	    });
	  }), customElements.define(e || t.tagName || t.displayName || t.name, r);
	}

	var t$2,r$4,u$1,i$1,o$2=0,c$2=[],f$2=[],e$2=l$3.__b,a$2=l$3.__r,v$1=l$3.diffed,l$1=l$3.__c,m=l$3.unmount;function d$1(t,u){l$3.__h&&l$3.__h(r$4,t,o$2||u),o$2=0;var i=r$4.__H||(r$4.__H={__:[],__h:[]});return t>=i.__.length&&i.__.push({__V:f$2}),i.__[t]}function p(n){return o$2=1,y(z$1,n)}function y(n,u,i){var o=d$1(t$2++,2);if(o.t=n,!o.__c&&(o.__=[i?i(u):z$1(void 0,u),function(n){var t=o.__N?o.__N[0]:o.__[0],r=o.t(t,n);t!==r&&(o.__N=[r,o.__[1]],o.__c.setState({}));}],o.__c=r$4,!r$4.u)){r$4.u=!0;var c=r$4.shouldComponentUpdate;r$4.shouldComponentUpdate=function(n,t,r){if(!o.__c.__H)return !0;var u=o.__c.__H.__.filter(function(n){return n.__c});if(u.every(function(n){return !n.__N}))return !c||c.call(this,n,t,r);var i=!1;return u.forEach(function(n){if(n.__N){var t=n.__[0];n.__=n.__N,n.__N=void 0,t!==n.__[0]&&(i=!0);}}),!!i&&(!c||c.call(this,n,t,r))};}return o.__N||o.__}function h$1(u,i){var o=d$1(t$2++,3);!l$3.__s&&w$1(o.__H,i)&&(o.__=u,o.i=i,r$4.__H.__h.push(o));}function s$3(u,i){var o=d$1(t$2++,4);!l$3.__s&&w$1(o.__H,i)&&(o.__=u,o.i=i,r$4.__h.push(o));}function _(n){return o$2=5,F$1(function(){return {current:n}},[])}function F$1(n,r){var u=d$1(t$2++,7);return w$1(u.__H,r)?(u.__V=n(),u.i=r,u.__h=n,u.__V):u.__}function T$1(n,t){return o$2=8,F$1(function(){return n},t)}function q$1(n){var u=r$4.context[n.__c],i=d$1(t$2++,9);return i.c=n,u?(null==i.__&&(i.__=!0,u.sub(r$4)),u.props.value):n.__}function b(){for(var t;t=c$2.shift();)if(t.__P&&t.__H)try{t.__H.__h.forEach(j$2),t.__H.__h.forEach(k),t.__H.__h=[];}catch(r){t.__H.__h=[],l$3.__e(r,t.__v);}}l$3.__b=function(n){r$4=null,e$2&&e$2(n);},l$3.__r=function(n){a$2&&a$2(n),t$2=0;var i=(r$4=n.__c).__H;i&&(u$1===r$4?(i.__h=[],r$4.__h=[],i.__.forEach(function(n){n.__N&&(n.__=n.__N),n.__V=f$2,n.__N=n.i=void 0;})):(i.__h.forEach(j$2),i.__h.forEach(k),i.__h=[])),u$1=r$4;},l$3.diffed=function(t){v$1&&v$1(t);var o=t.__c;o&&o.__H&&(o.__H.__h.length&&(1!==c$2.push(o)&&i$1===l$3.requestAnimationFrame||((i$1=l$3.requestAnimationFrame)||function(n){var t,r=function(){clearTimeout(u),g$1&&cancelAnimationFrame(t),setTimeout(n);},u=setTimeout(r,100);g$1&&(t=requestAnimationFrame(r));})(b)),o.__H.__.forEach(function(n){n.i&&(n.__H=n.i),n.__V!==f$2&&(n.__=n.__V),n.i=void 0,n.__V=f$2;})),u$1=r$4=null;},l$3.__c=function(t,r){r.some(function(t){try{t.__h.forEach(j$2),t.__h=t.__h.filter(function(n){return !n.__||k(n)});}catch(u){r.some(function(n){n.__h&&(n.__h=[]);}),r=[],l$3.__e(u,t.__v);}}),l$1&&l$1(t,r);},l$3.unmount=function(t){m&&m(t);var r,u=t.__c;u&&u.__H&&(u.__H.__.forEach(function(n){try{j$2(n);}catch(n){r=n;}}),r&&l$3.__e(r,u.__v));};var g$1="function"==typeof requestAnimationFrame;function j$2(n){var t=r$4,u=n.__c;"function"==typeof u&&(n.__c=void 0,u()),r$4=t;}function k(n){var t=r$4;n.__c=n.__(),r$4=t;}function w$1(n,t){return !n||n.length!==t.length||t.some(function(t,r){return t!==n[r]})}function z$1(n,t){return "function"==typeof t?t(n):t}

	function ownKeys$2(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
	      _defineProperty$2(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }

	  return target;
	}

	function _regeneratorRuntime() {
	  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

	  _regeneratorRuntime = function () {
	    return exports;
	  };

	  var exports = {},
	      Op = Object.prototype,
	      hasOwn = Op.hasOwnProperty,
	      $Symbol = "function" == typeof Symbol ? Symbol : {},
	      iteratorSymbol = $Symbol.iterator || "@@iterator",
	      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
	      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  function define(obj, key, value) {
	    return Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: !0,
	      configurable: !0,
	      writable: !0
	    }), obj[key];
	  }

	  try {
	    define({}, "");
	  } catch (err) {
	    define = function (obj, key, value) {
	      return obj[key] = value;
	    };
	  }

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
	        generator = Object.create(protoGenerator.prototype),
	        context = new Context(tryLocsList || []);
	    return generator._invoke = function (innerFn, self, context) {
	      var state = "suspendedStart";
	      return function (method, arg) {
	        if ("executing" === state) throw new Error("Generator is already running");

	        if ("completed" === state) {
	          if ("throw" === method) throw arg;
	          return doneResult();
	        }

	        for (context.method = method, context.arg = arg;;) {
	          var delegate = context.delegate;

	          if (delegate) {
	            var delegateResult = maybeInvokeDelegate(delegate, context);

	            if (delegateResult) {
	              if (delegateResult === ContinueSentinel) continue;
	              return delegateResult;
	            }
	          }

	          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
	            if ("suspendedStart" === state) throw state = "completed", context.arg;
	            context.dispatchException(context.arg);
	          } else "return" === context.method && context.abrupt("return", context.arg);
	          state = "executing";
	          var record = tryCatch(innerFn, self, context);

	          if ("normal" === record.type) {
	            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
	            return {
	              value: record.arg,
	              done: context.done
	            };
	          }

	          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
	        }
	      };
	    }(innerFn, self, context), generator;
	  }

	  function tryCatch(fn, obj, arg) {
	    try {
	      return {
	        type: "normal",
	        arg: fn.call(obj, arg)
	      };
	    } catch (err) {
	      return {
	        type: "throw",
	        arg: err
	      };
	    }
	  }

	  exports.wrap = wrap;
	  var ContinueSentinel = {};

	  function Generator() {}

	  function GeneratorFunction() {}

	  function GeneratorFunctionPrototype() {}

	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	  var getProto = Object.getPrototypeOf,
	      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      define(prototype, method, function (arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }

	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);

	      if ("throw" !== record.type) {
	        var result = record.arg,
	            value = result.value;
	        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
	          invoke("next", value, resolve, reject);
	        }, function (err) {
	          invoke("throw", err, resolve, reject);
	        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
	          result.value = unwrapped, resolve(result);
	        }, function (error) {
	          return invoke("throw", error, resolve, reject);
	        });
	      }

	      reject(record.arg);
	    }

	    var previousPromise;

	    this._invoke = function (method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    };
	  }

	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];

	    if (undefined === method) {
	      if (context.delegate = null, "throw" === context.method) {
	        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
	        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);
	    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
	    var info = record.arg;
	    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
	  }

	  function pushTryEntry(locs) {
	    var entry = {
	      tryLoc: locs[0]
	    };
	    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal", delete record.arg, entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    this.tryEntries = [{
	      tryLoc: "root"
	    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
	  }

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) return iteratorMethod.call(iterable);
	      if ("function" == typeof iterable.next) return iterable;

	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

	          return next.value = undefined, next.done = !0, next;
	        };

	        return next.next = next;
	      }
	    }

	    return {
	      next: doneResult
	    };
	  }

	  function doneResult() {
	    return {
	      value: undefined,
	      done: !0
	    };
	  }

	  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
	    var ctor = "function" == typeof genFun && genFun.constructor;
	    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
	  }, exports.mark = function (genFun) {
	    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
	  }, exports.awrap = function (arg) {
	    return {
	      __await: arg
	    };
	  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    void 0 === PromiseImpl && (PromiseImpl = Promise);
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
	    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
	    return this;
	  }), define(Gp, "toString", function () {
	    return "[object Generator]";
	  }), exports.keys = function (object) {
	    var keys = [];

	    for (var key in object) keys.push(key);

	    return keys.reverse(), function next() {
	      for (; keys.length;) {
	        var key = keys.pop();
	        if (key in object) return next.value = key, next.done = !1, next;
	      }

	      return next.done = !0, next;
	    };
	  }, exports.values = values, Context.prototype = {
	    constructor: Context,
	    reset: function (skipTempReset) {
	      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
	    },
	    stop: function () {
	      this.done = !0;
	      var rootRecord = this.tryEntries[0].completion;
	      if ("throw" === rootRecord.type) throw rootRecord.arg;
	      return this.rval;
	    },
	    dispatchException: function (exception) {
	      if (this.done) throw exception;
	      var context = this;

	      function handle(loc, caught) {
	        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i],
	            record = entry.completion;
	        if ("root" === entry.tryLoc) return handle("end");

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc"),
	              hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
	            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
	          } else {
	            if (!hasFinally) throw new Error("try statement without catch or finally");
	            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
	          }
	        }
	      }
	    },
	    abrupt: function (type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];

	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
	      var record = finallyEntry ? finallyEntry.completion : {};
	      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
	    },
	    complete: function (record, afterLoc) {
	      if ("throw" === record.type) throw record.arg;
	      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
	    },
	    finish: function (finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
	      }
	    },
	    catch: function (tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];

	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;

	          if ("throw" === record.type) {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }

	          return thrown;
	        }
	      }

	      throw new Error("illegal catch attempt");
	    },
	    delegateYield: function (iterable, resultName, nextLoc) {
	      return this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
	    }
	  }, exports;
	}

	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }

	  if (info.done) {
	    resolve(value);
	  } else {
	    Promise.resolve(value).then(_next, _throw);
	  }
	}

	function _asyncToGenerator(fn) {
	  return function () {
	    var self = this,
	        args = arguments;
	    return new Promise(function (resolve, reject) {
	      var gen = fn.apply(self, args);

	      function _next(value) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
	      }

	      function _throw(err) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
	      }

	      _next(undefined);
	    });
	  };
	}

	function _defineProperty$2(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function _extends$1() {
	  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };
	  return _extends$1.apply(this, arguments);
	}

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};

	  var target = _objectWithoutPropertiesLoose(source, excluded);

	  var key, i;

	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }

	  return target;
	}

	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}

	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;

	  var _s, _e;

	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

	  return arr2;
	}

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	var $TypeError$9 = TypeError;
	var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

	var doesNotExceedSafeInteger = function (it) {
	  if (it > MAX_SAFE_INTEGER$1) throw $TypeError$9('Maximum allowed index exceeded');
	  return it;
	};

	var createProperty = function (object, key, value) {
	  var propertyKey = toPropertyKey(key);
	  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
	};

	var TO_STRING_TAG$4 = wellKnownSymbol('toStringTag');
	var test = {};
	test[TO_STRING_TAG$4] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
	var $Object$1 = Object; // ES3 wrong here

	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {
	    /* empty */
	  }
	}; // getting tag from ES6+ `Object.prototype.toString`


	var classof = toStringTagSupport ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
	  : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$3)) == 'string' ? tag // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
	  : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};

	var noop$1 = function () {
	  /* empty */
	};

	var empty = [];
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec$1 = functionUncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.exec(noop$1);

	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;

	  try {
	    construct(noop$1, empty, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};

	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;

	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction':
	      return false;
	  }

	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};

	isConstructorLegacy.sham = true; // `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor

	var isConstructor = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
	    called = true;
	  }) || called;
	}) ? isConstructorLegacy : isConstructorModern;

	var SPECIES$4 = wellKnownSymbol('species');
	var $Array$2 = Array; // a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate

	var arraySpeciesConstructor = function (originalArray) {
	  var C;

	  if (isArray$5(originalArray)) {
	    C = originalArray.constructor; // cross-realm fallback

	    if (isConstructor(C) && (C === $Array$2 || isArray$5(C.prototype))) C = undefined;else if (isObject$2(C)) {
	      C = C[SPECIES$4];
	      if (C === null) C = undefined;
	    }
	  }

	  return C === undefined ? $Array$2 : C;
	};

	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate


	var arraySpeciesCreate = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};

	var SPECIES$3 = wellKnownSymbol('species');

	var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return engineV8Version >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};

	    constructor[SPECIES$3] = function () {
	      return {
	        foo: 1
	      };
	    };

	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};

	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable'); // We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679

	var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

	var isConcatSpreadable = function (O) {
	  if (!isObject$2(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray$5(O);
	};

	var FORCED$1 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species

	_export({
	  target: 'Array',
	  proto: true,
	  arity: 1,
	  forced: FORCED$1
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject$1(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;

	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];

	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike(E);
	        doesNotExceedSafeInteger(n + len);

	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        doesNotExceedSafeInteger(n + 1);
	        createProperty(A, n++, E);
	      }
	    }

	    A.length = n;
	    return A;
	  }
	});

	var $String$1 = String;

	var toString$2 = function (argument) {
	  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
	  return $String$1(argument);
	};

	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags


	var regexpFlags = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.hasIndices) result += 'd';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.unicodeSets) result += 'v';
	  if (that.sticky) result += 'y';
	  return result;
	};

	// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError


	var $RegExp$2 = global$1.RegExp;
	var UNSUPPORTED_Y$2 = fails(function () {
	  var re = $RegExp$2('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') != null;
	}); // UC Browser bug
	// https://github.com/zloirock/core-js/issues/1008

	var MISSED_STICKY = UNSUPPORTED_Y$2 || fails(function () {
	  return !$RegExp$2('a', 'y').sticky;
	});
	var BROKEN_CARET = UNSUPPORTED_Y$2 || fails(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = $RegExp$2('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') != null;
	});
	var regexpStickyHelpers = {
	  BROKEN_CARET: BROKEN_CARET,
	  MISSED_STICKY: MISSED_STICKY,
	  UNSUPPORTED_Y: UNSUPPORTED_Y$2
	};

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es-x/no-object-keys -- safe


	var objectKeys = Object.keys || function keys(O) {
	  return objectKeysInternal(O, enumBugKeys);
	};

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es-x/no-object-defineproperties -- safe


	var f$1 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;

	  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);

	  return O;
	};

	var objectDefineProperties = {
		f: f$1
	};

	var html = getBuiltIn('document', 'documentElement');

	/* global ActiveXObject -- old IE, WSH */

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO$1 = sharedKey('IE_PROTO');

	var EmptyConstructor = function () {
	  /* empty */
	};

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak

	  return temp;
	}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	}; // Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug


	var activeXDocument;

	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) {
	    /* ignore */
	  }

	  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH

	  var length = enumBugKeys.length;

	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];

	  return NullProtoObject();
	};

	hiddenKeys$1[IE_PROTO$1] = true; // `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es-x/no-object-create -- safe

	var objectCreate = Object.create || function create(O, Properties) {
	  var result;

	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

	    result[IE_PROTO$1] = O;
	  } else result = NullProtoObject();

	  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
	};

	// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError


	var $RegExp$1 = global$1.RegExp;
	var regexpUnsupportedDotAll = fails(function () {
	  var re = $RegExp$1('.', 's');
	  return !(re.dotAll && re.exec('\n') && re.flags === 's');
	});

	// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError


	var $RegExp = global$1.RegExp;
	var regexpUnsupportedNcg = fails(function () {
	  var re = $RegExp('(?<a>b)', 'g');
	  return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
	});

	/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

	/* eslint-disable regexp/no-useless-quantifier -- testing */















	var getInternalState = internalState.get;





	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var nativeExec = RegExp.prototype.exec;
	var patchedExec = nativeExec;
	var charAt$2 = functionUncurryThis(''.charAt);
	var indexOf$1 = functionUncurryThis(''.indexOf);
	var replace$2 = functionUncurryThis(''.replace);
	var stringSlice$2 = functionUncurryThis(''.slice);

	var UPDATES_LAST_INDEX_WRONG = function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  functionCall(nativeExec, re1, 'a');
	  functionCall(nativeExec, re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	}();

	var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

	if (PATCH) {
	  patchedExec = function exec(string) {
	    var re = this;
	    var state = getInternalState(re);
	    var str = toString$2(string);
	    var raw = state.raw;
	    var result, reCopy, lastIndex, match, i, object, group;

	    if (raw) {
	      raw.lastIndex = re.lastIndex;
	      result = functionCall(patchedExec, raw, str);
	      re.lastIndex = raw.lastIndex;
	      return result;
	    }

	    var groups = state.groups;
	    var sticky = UNSUPPORTED_Y$1 && re.sticky;
	    var flags = functionCall(regexpFlags, re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;

	    if (sticky) {
	      flags = replace$2(flags, 'y', '');

	      if (indexOf$1(flags, 'g') === -1) {
	        flags += 'g';
	      }

	      strCopy = stringSlice$2(str, re.lastIndex); // Support anchored sticky behavior.

	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$2(str, re.lastIndex - 1) !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      } // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.


	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }

	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
	    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

	    if (sticky) {
	      if (match) {
	        match.input = stringSlice$2(match.input, charsAdded);
	        match[0] = stringSlice$2(match[0], charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }

	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
	      functionCall(nativeReplace, match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    if (match && groups) {
	      match.groups = object = objectCreate(null);

	      for (i = 0; i < groups.length; i++) {
	        group = groups[i];
	        object[group[0]] = match[group[1]];
	      }
	    }

	    return match;
	  };
	}

	var regexpExec = patchedExec;

	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec


	_export({
	  target: 'RegExp',
	  proto: true,
	  forced: /./.exec !== regexpExec
	}, {
	  exec: regexpExec
	});

	var SPECIES$2 = wellKnownSymbol('species');
	var RegExpPrototype = RegExp.prototype;

	var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
	  var SYMBOL = wellKnownSymbol(KEY);
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};

	    O[SYMBOL] = function () {
	      return 7;
	    };

	    return ''[KEY](O) != 7;
	  });
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;

	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.

	      re.constructor = {};

	      re.constructor[SPECIES$2] = function () {
	        return re;
	      };

	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }

	    re.exec = function () {
	      execCalled = true;
	      return null;
	    };

	    re[SYMBOL]('');
	    return !execCalled;
	  });

	  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
	    var uncurriedNativeRegExpMethod = functionUncurryThis(/./[SYMBOL]);
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var uncurriedNativeMethod = functionUncurryThis(nativeMethod);
	      var $exec = regexp.exec;

	      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return {
	            done: true,
	            value: uncurriedNativeRegExpMethod(regexp, str, arg2)
	          };
	        }

	        return {
	          done: true,
	          value: uncurriedNativeMethod(str, regexp, arg2)
	        };
	      }

	      return {
	        done: false
	      };
	    });
	    defineBuiltIn(String.prototype, KEY, methods[0]);
	    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
	  }

	  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};

	var MATCH$1 = wellKnownSymbol('match'); // `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp

	var isRegexp = function (it) {
	  var isRegExp;
	  return isObject$2(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
	};

	var $TypeError$8 = TypeError; // `Assert: IsConstructor(argument) is true`

	var aConstructor = function (argument) {
	  if (isConstructor(argument)) return argument;
	  throw $TypeError$8(tryToString(argument) + ' is not a constructor');
	};

	var SPECIES$1 = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor

	var speciesConstructor = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || isNullOrUndefined$1(S = anObject(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
	};

	var charAt$1 = functionUncurryThis(''.charAt);
	var charCodeAt$1 = functionUncurryThis(''.charCodeAt);
	var stringSlice$1 = functionUncurryThis(''.slice);

	var createMethod$3 = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString$2(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt$1(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$1(S, position) : first : CONVERT_TO_STRING ? stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod$3(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod$3(true)
	};

	var charAt = stringMultibyte.charAt; // `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex


	var advanceStringIndex = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};

	var $Array$1 = Array;
	var max$1 = Math.max;

	var arraySliceSimple = function (O, start, end) {
	  var length = lengthOfArrayLike(O);
	  var k = toAbsoluteIndex(start, length);
	  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	  var result = $Array$1(max$1(fin - k, 0));

	  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);

	  result.length = n;
	  return result;
	};

	var $TypeError$7 = TypeError; // `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec

	var regexpExecAbstract = function (R, S) {
	  var exec = R.exec;

	  if (isCallable(exec)) {
	    var result = functionCall(exec, R, S);
	    if (result !== null) anObject(result);
	    return result;
	  }

	  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
	  throw $TypeError$7('RegExp#exec called on incompatible receiver');
	};

	var UNSUPPORTED_Y = regexpStickyHelpers.UNSUPPORTED_Y;
	var MAX_UINT32 = 0xFFFFFFFF;
	var min = Math.min;
	var $push = [].push;
	var exec = functionUncurryThis(/./.exec);
	var push$2 = functionUncurryThis($push);
	var stringSlice = functionUncurryThis(''.slice); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper

	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;

	  re.exec = function () {
	    return originalExec.apply(this, arguments);
	  };

	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	}); // @@split logic

	fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit;

	  if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
	  '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = toString$2(requireObjectCoercible(this));
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

	      if (!isRegexp(separator)) {
	        return functionCall(nativeSplit, string, separator, lim);
	      }

	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;

	      while (match = functionCall(regexpExec, separatorCopy, string)) {
	        lastIndex = separatorCopy.lastIndex;

	        if (lastIndex > lastLastIndex) {
	          push$2(output, stringSlice(string, lastLastIndex, match.index));
	          if (match.length > 1 && match.index < string.length) functionApply($push, output, arraySliceSimple(match, 1));
	          lastLength = match[0].length;
	          lastLastIndex = lastIndex;
	          if (output.length >= lim) break;
	        }

	        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
	      }

	      if (lastLastIndex === string.length) {
	        if (lastLength || !exec(separatorCopy, '')) push$2(output, '');
	      } else push$2(output, stringSlice(string, lastLastIndex));

	      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
	    }; // Chakra, V8

	  } else if ('0'.split(undefined, 0).length) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
	    };
	  } else internalSplit = nativeSplit;

	  return [// `String.prototype.split` method
	  // https://tc39.es/ecma262/#sec-string.prototype.split
	  function split(separator, limit) {
	    var O = requireObjectCoercible(this);
	    var splitter = isNullOrUndefined$1(separator) ? undefined : getMethod(separator, SPLIT);
	    return splitter ? functionCall(splitter, separator, O, limit) : functionCall(internalSplit, toString$2(O), separator, limit);
	  }, // `RegExp.prototype[@@split]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	  //
	  // NOTE: This cannot be properly polyfilled in engines that don't support
	  // the 'y' flag.
	  function (string, limit) {
	    var rx = anObject(this);
	    var S = toString$2(string);
	    var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
	    if (res.done) return res.value;
	    var C = speciesConstructor(rx, RegExp);
	    var unicodeMatching = rx.unicode;
	    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
	    // simulate the 'y' flag.

	    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	    if (lim === 0) return [];
	    if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
	    var p = 0;
	    var q = 0;
	    var A = [];

	    while (q < S.length) {
	      splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	      var z = regexpExecAbstract(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
	      var e;

	      if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
	        q = advanceStringIndex(S, q, unicodeMatching);
	      } else {
	        push$2(A, stringSlice(S, p, q));
	        if (A.length === lim) return A;

	        for (var i = 1; i <= z.length - 1; i++) {
	          push$2(A, z[i]);
	          if (A.length === lim) return A;
	        }

	        q = p = e;
	      }
	    }

	    push$2(A, stringSlice(S, p));
	    return A;
	  }];
	}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

	var bind$1 = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);

	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    return fn.apply(thisArg, args);
	  };
	};

	// utils is a library of generic helper functions non-specific to axios


	var toString$1 = Object.prototype.toString;
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */

	function isArray$4(val) {
	  return toString$1.call(val) === '[object Array]';
	}
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */


	function isUndefined$1(val) {
	  return typeof val === 'undefined';
	}
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */


	function isBuffer$1(val) {
	  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */


	function isArrayBuffer(val) {
	  return toString$1.call(val) === '[object ArrayBuffer]';
	}
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */


	function isFormData(val) {
	  return typeof FormData !== 'undefined' && val instanceof FormData;
	}
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */


	function isArrayBufferView(val) {
	  var result;

	  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
	  }

	  return result;
	}
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */


	function isString$2(val) {
	  return typeof val === 'string';
	}
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */


	function isNumber$1(val) {
	  return typeof val === 'number';
	}
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */


	function isObject$1(val) {
	  return val !== null && typeof val === 'object';
	}
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */


	function isPlainObject(val) {
	  if (toString$1.call(val) !== '[object Object]') {
	    return false;
	  }

	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */


	function isDate$1(val) {
	  return toString$1.call(val) === '[object Date]';
	}
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */


	function isFile(val) {
	  return toString$1.call(val) === '[object File]';
	}
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */


	function isBlob(val) {
	  return toString$1.call(val) === '[object Blob]';
	}
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */


	function isFunction$1(val) {
	  return toString$1.call(val) === '[object Function]';
	}
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */


	function isStream(val) {
	  return isObject$1(val) && isFunction$1(val.pipe);
	}
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */


	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */


	function trim$1(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */


	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
	    return false;
	  }

	  return typeof window !== 'undefined' && typeof document !== 'undefined';
	}
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */


	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  } // Force an array if not already something iterable


	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }

	  if (isArray$4(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */


	function
	  /* obj1, obj2, obj3, ... */
	merge$1() {
	  var result = {};

	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge$1(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge$1({}, val);
	    } else if (isArray$4(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }

	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }

	  return result;
	}
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */


	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind$1(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */


	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }

	  return content;
	}

	var utils$2 = {
	  isArray: isArray$4,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer$1,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString$2,
	  isNumber: isNumber$1,
	  isObject: isObject$1,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined$1,
	  isDate: isDate$1,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction$1,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge$1,
	  extend: extend,
	  trim: trim$1,
	  stripBOM: stripBOM
	};

	function encode$6(val) {
	  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	}
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */


	var buildURL = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }

	  var serializedParams;

	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils$2.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	    utils$2.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }

	      if (utils$2.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }

	      utils$2.forEach(val, function parseValue(v) {
	        if (utils$2.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils$2.isObject(v)) {
	          v = JSON.stringify(v);
	        }

	        parts.push(encode$6(key) + '=' + encode$6(v));
	      });
	    });
	    serializedParams = parts.join('&');
	  }

	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');

	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }

	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }

	  return url;
	};

	function InterceptorManager() {
	  this.handlers = [];
	}
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */


	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */


	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */


	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils$2.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};

	var InterceptorManager_1 = InterceptorManager;

	var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
	  utils$2.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};

	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */

	var enhanceError = function enhanceError(error, config, code, request, response) {
	  error.config = config;

	  if (code) {
	    error.code = code;
	  }

	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;

	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };

	  return error;
	};

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */


	var createError = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */


	var settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;

	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
	  }
	};

	var cookies = utils$2.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
	function standardBrowserEnv() {
	  return {
	    write: function write(name, value, expires, path, domain, secure) {
	      var cookie = [];
	      cookie.push(name + '=' + encodeURIComponent(value));

	      if (utils$2.isNumber(expires)) {
	        cookie.push('expires=' + new Date(expires).toGMTString());
	      }

	      if (utils$2.isString(path)) {
	        cookie.push('path=' + path);
	      }

	      if (utils$2.isString(domain)) {
	        cookie.push('domain=' + domain);
	      }

	      if (secure === true) {
	        cookie.push('secure');
	      }

	      document.cookie = cookie.join('; ');
	    },
	    read: function read(name) {
	      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	      return match ? decodeURIComponent(match[3]) : null;
	    },
	    remove: function remove(name) {
	      this.write(name, '', Date.now() - 86400000);
	    }
	  };
	}() : // Non standard browser env (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return {
	    write: function write() {},
	    read: function read() {
	      return null;
	    },
	    remove: function remove() {}
	  };
	}();

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */

	var isAbsoluteURL = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */

	var combineURLs = function combineURLs(baseURL, relativeURL) {
	  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
	};

	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */


	var buildFullPath = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }

	  return requestedURL;
	};

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers


	var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */

	var parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) {
	    return parsed;
	  }

	  utils$2.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils$2.trim(line.substr(0, i)).toLowerCase();
	    val = utils$2.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }

	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	  return parsed;
	};

	var isURLSameOrigin = utils$2.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
	// whether the request URL is of the same origin as current location.
	function standardBrowserEnv() {
	  var msie = /(msie|trident)/i.test(navigator.userAgent);
	  var urlParsingNode = document.createElement('a');
	  var originURL;
	  /**
	  * Parse a URL to discover it's components
	  *
	  * @param {String} url The URL to be parsed
	  * @returns {Object}
	  */

	  function resolveURL(url) {
	    var href = url;

	    if (msie) {
	      // IE needs attribute set twice to normalize properties
	      urlParsingNode.setAttribute('href', href);
	      href = urlParsingNode.href;
	    }

	    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

	    return {
	      href: urlParsingNode.href,
	      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	      host: urlParsingNode.host,
	      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	      hostname: urlParsingNode.hostname,
	      port: urlParsingNode.port,
	      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
	    };
	  }

	  originURL = resolveURL(window.location.href);
	  /**
	  * Determine if a URL shares the same origin as the current location
	  *
	  * @param {String} requestURL The URL to test
	  * @returns {boolean} True if URL shares the same origin, otherwise false
	  */

	  return function isURLSameOrigin(requestURL) {
	    var parsed = utils$2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
	    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
	  };
	}() : // Non standard browser envs (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return function isURLSameOrigin() {
	    return true;
	  };
	}();

	var xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;

	    if (utils$2.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest(); // HTTP basic authentication

	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      } // Prepare the response


	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	      settle(resolve, reject, response); // Clean up request

	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        } // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request


	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        } // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'


	        setTimeout(onloadend);
	      };
	    } // Handle browser request cancellation (as opposed to a manual cancellation)


	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Handle low level network errors


	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request)); // Clean up request

	      request = null;
	    }; // Handle timeout


	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }

	      reject(createError(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.


	    if (utils$2.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    } // Add headers to the request


	    if ('setRequestHeader' in request) {
	      utils$2.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    } // Add withCredentials to request if needed


	    if (!utils$2.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    } // Add responseType to request if needed


	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    } // Handle progress if needed


	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    } // Not all browsers support upload events


	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }

	        request.abort();
	        reject(cancel); // Clean up request

	        request = null;
	      });
	    }

	    if (!requestData) {
	      requestData = null;
	    } // Send the request


	    request.send(requestData);
	  });
	};

	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};

	function setContentTypeIfUnset(headers, value) {
	  if (!utils$2.isUndefined(headers) && utils$2.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}

	function getDefaultAdapter() {
	  var adapter;

	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = xhr;
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = xhr;
	  }

	  return adapter;
	}

	function stringifySafely(rawValue, parser, encoder) {
	  if (utils$2.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils$2.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }

	  return (encoder || JSON.stringify)(rawValue);
	}

	var defaults$2 = {
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	  adapter: getDefaultAdapter(),
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');

	    if (utils$2.isFormData(data) || utils$2.isArrayBuffer(data) || utils$2.isBuffer(data) || utils$2.isStream(data) || utils$2.isFile(data) || utils$2.isBlob(data)) {
	      return data;
	    }

	    if (utils$2.isArrayBufferView(data)) {
	      return data.buffer;
	    }

	    if (utils$2.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }

	    if (utils$2.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }

	    return data;
	  }],
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

	    if (strictJSONParsing || forcedJSONParsing && utils$2.isString(data) && data.length) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }

	          throw e;
	        }
	      }
	    }

	    return data;
	  }],

	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	  maxContentLength: -1,
	  maxBodyLength: -1,
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	defaults$2.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	utils$2.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults$2.headers[method] = {};
	});
	utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults$2.headers[method] = utils$2.merge(DEFAULT_CONTENT_TYPE);
	});
	var defaults_1 = defaults$2;

	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */


	var transformData = function transformData(data, headers, fns) {
	  var context = this || defaults_1;
	  /*eslint no-param-reassign:0*/

	  utils$2.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	  return data;
	};

	var isCancel = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};

	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */


	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */


	var dispatchRequest = function dispatchRequest(config) {
	  throwIfCancellationRequested(config); // Ensure headers exist

	  config.headers = config.headers || {}; // Transform request data

	  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

	  config.headers = utils$2.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
	  utils$2.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
	    delete config.headers[method];
	  });
	  var adapter = config.adapter || defaults_1.adapter;
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config); // Transform response data

	    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config); // Transform response data

	      if (reason && reason.response) {
	        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
	      }
	    }

	    return Promise.reject(reason);
	  });
	};

	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */


	var mergeConfig = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
	  var directMergeKeys = ['validateStatus'];

	  function getMergedValue(target, source) {
	    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
	      return utils$2.merge(target, source);
	    } else if (utils$2.isPlainObject(source)) {
	      return utils$2.merge({}, source);
	    } else if (utils$2.isArray(source)) {
	      return source.slice();
	    }

	    return source;
	  }

	  function mergeDeepProperties(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils$2.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }

	  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils$2.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	  utils$2.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
	  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
	    return axiosKeys.indexOf(key) === -1;
	  });
	  utils$2.forEach(otherKeys, mergeDeepProperties);
	  return config;
	};

	var _args = [
		[
			"axios@0.21.4",
			"/Users/yannick/Projects/utu/utu-trust-sdk/packages/utu-web-components"
		]
	];
	var _from = "axios@0.21.4";
	var _id = "axios@0.21.4";
	var _inBundle = false;
	var _integrity = "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==";
	var _location = "/axios";
	var _phantomChildren = {
	};
	var _requested = {
		type: "version",
		registry: true,
		raw: "axios@0.21.4",
		name: "axios",
		escapedName: "axios",
		rawSpec: "0.21.4",
		saveSpec: null,
		fetchSpec: "0.21.4"
	};
	var _requiredBy = [
		"/",
		"/localtunnel"
	];
	var _resolved = "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz";
	var _spec = "0.21.4";
	var _where = "/Users/yannick/Projects/utu/utu-trust-sdk/packages/utu-web-components";
	var author = {
		name: "Matt Zabriskie"
	};
	var browser = {
		"./lib/adapters/http.js": "./lib/adapters/xhr.js"
	};
	var bugs = {
		url: "https://github.com/axios/axios/issues"
	};
	var bundlesize = [
		{
			path: "./dist/axios.min.js",
			threshold: "5kB"
		}
	];
	var dependencies = {
		"follow-redirects": "^1.14.0"
	};
	var description = "Promise based HTTP client for the browser and node.js";
	var devDependencies = {
		coveralls: "^3.0.0",
		"es6-promise": "^4.2.4",
		grunt: "^1.3.0",
		"grunt-banner": "^0.6.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-clean": "^1.1.0",
		"grunt-contrib-watch": "^1.0.0",
		"grunt-eslint": "^23.0.0",
		"grunt-karma": "^4.0.0",
		"grunt-mocha-test": "^0.13.3",
		"grunt-ts": "^6.0.0-beta.19",
		"grunt-webpack": "^4.0.2",
		"istanbul-instrumenter-loader": "^1.0.0",
		"jasmine-core": "^2.4.1",
		karma: "^6.3.2",
		"karma-chrome-launcher": "^3.1.0",
		"karma-firefox-launcher": "^2.1.0",
		"karma-jasmine": "^1.1.1",
		"karma-jasmine-ajax": "^0.1.13",
		"karma-safari-launcher": "^1.0.0",
		"karma-sauce-launcher": "^4.3.6",
		"karma-sinon": "^1.0.5",
		"karma-sourcemap-loader": "^0.3.8",
		"karma-webpack": "^4.0.2",
		"load-grunt-tasks": "^3.5.2",
		minimist: "^1.2.0",
		mocha: "^8.2.1",
		sinon: "^4.5.0",
		"terser-webpack-plugin": "^4.2.3",
		typescript: "^4.0.5",
		"url-search-params": "^0.10.0",
		webpack: "^4.44.2",
		"webpack-dev-server": "^3.11.0"
	};
	var homepage = "https://axios-http.com";
	var jsdelivr = "dist/axios.min.js";
	var keywords = [
		"xhr",
		"http",
		"ajax",
		"promise",
		"node"
	];
	var license = "MIT";
	var main = "index.js";
	var name = "axios";
	var repository = {
		type: "git",
		url: "git+https://github.com/axios/axios.git"
	};
	var scripts = {
		build: "NODE_ENV=production grunt build",
		coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
		examples: "node ./examples/server.js",
		fix: "eslint --fix lib/**/*.js",
		postversion: "git push && git push --tags",
		preversion: "npm test",
		start: "node ./sandbox/server.js",
		test: "grunt test",
		version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
	};
	var typings = "./index.d.ts";
	var unpkg = "dist/axios.min.js";
	var version$j = "0.21.4";
	var pkg = {
		_args: _args,
		_from: _from,
		_id: _id,
		_inBundle: _inBundle,
		_integrity: _integrity,
		_location: _location,
		_phantomChildren: _phantomChildren,
		_requested: _requested,
		_requiredBy: _requiredBy,
		_resolved: _resolved,
		_spec: _spec,
		_where: _where,
		author: author,
		browser: browser,
		bugs: bugs,
		bundlesize: bundlesize,
		dependencies: dependencies,
		description: description,
		devDependencies: devDependencies,
		homepage: homepage,
		jsdelivr: jsdelivr,
		keywords: keywords,
		license: license,
		main: main,
		name: name,
		repository: repository,
		scripts: scripts,
		typings: typings,
		unpkg: unpkg,
		version: version$j
	};

	var validators$1 = {}; // eslint-disable-next-line func-names

	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
	  validators$1[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	var deprecatedWarnings = {};
	var currentVerArr = pkg.version.split('.');
	/**
	 * Compare package versions
	 * @param {string} version
	 * @param {string?} thanVersion
	 * @returns {boolean}
	 */

	function isOlderVersion(version, thanVersion) {
	  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
	  var destVer = version.split('.');

	  for (var i = 0; i < 3; i++) {
	    if (pkgVersionArr[i] > destVer[i]) {
	      return true;
	    } else if (pkgVersionArr[i] < destVer[i]) {
	      return false;
	    }
	  }

	  return false;
	}
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator
	 * @param {string?} version
	 * @param {string} message
	 * @returns {function}
	 */


	validators$1.transitional = function transitional(validator, version, message) {
	  var isDeprecated = version && isOlderVersion(version);

	  function formatMessage(opt, desc) {
	    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  } // eslint-disable-next-line func-names


	  return function (value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed in ' + version));
	    }

	    if (isDeprecated && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

	      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
	    }

	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */


	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }

	  var keys = Object.keys(options);
	  var i = keys.length;

	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];

	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);

	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }

	      continue;
	    }

	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}

	var validator = {
	  isOlderVersion: isOlderVersion,
	  assertOptions: assertOptions,
	  validators: validators$1
	};

	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */

	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager_1(),
	    response: new InterceptorManager_1()
	  };
	}
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */


	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }

	  config = mergeConfig(this.defaults, config); // Set config.method

	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }

	  var transitional = config.transitional;

	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
	    }, false);
	  } // filter out skipped interceptors


	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }

	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	  var promise;

	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	    promise = Promise.resolve(config);

	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }

	    return promise;
	  }

	  var newConfig = config;

	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();

	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }

	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }

	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }

	  return promise;
	};

	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	}; // Provide aliases for supported request methods


	utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function (url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function (url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	var Axios_1 = Axios;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */

	function Cancel(message) {
	  this.message = message;
	}

	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel.prototype.__CANCEL__ = true;
	var Cancel_1 = Cancel;

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */


	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel_1(message);
	    resolvePromise(token.reason);
	  });
	}
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */


	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */


	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	var CancelToken_1 = CancelToken;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */

	var spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */

	var isAxiosError = function isAxiosError(payload) {
	  return typeof payload === 'object' && payload.isAxiosError === true;
	};

	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */


	function createInstance(defaultConfig) {
	  var context = new Axios_1(defaultConfig);
	  var instance = bind$1(Axios_1.prototype.request, context); // Copy axios.prototype to instance

	  utils$2.extend(instance, Axios_1.prototype, context); // Copy context to instance

	  utils$2.extend(instance, context);
	  return instance;
	} // Create the default instance to be exported


	var axios$1 = createInstance(defaults_1); // Expose Axios class to allow class inheritance

	axios$1.Axios = Axios_1; // Factory for creating new instances

	axios$1.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
	}; // Expose Cancel & CancelToken


	axios$1.Cancel = Cancel_1;
	axios$1.CancelToken = CancelToken_1;
	axios$1.isCancel = isCancel; // Expose all/spread

	axios$1.all = function all(promises) {
	  return Promise.all(promises);
	};

	axios$1.spread = spread; // Expose isAxiosError

	axios$1.isAxiosError = isAxiosError;
	var axios_1 = axios$1; // Allow use of default import syntax in TypeScript

	var _default$1 = axios$1;
	axios_1.default = _default$1;

	var axios = axios_1;

	/* eslint complexity: [2, 18], max-statements: [2, 33] */

	var shams = function hasSymbols() {
	  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
	    return false;
	  }

	  if (typeof Symbol.iterator === 'symbol') {
	    return true;
	  }

	  var obj = {};
	  var sym = Symbol('test');
	  var symObj = Object(sym);

	  if (typeof sym === 'string') {
	    return false;
	  }

	  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
	    return false;
	  }

	  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
	    return false;
	  } // temp disabled per https://github.com/ljharb/object.assign/issues/17
	  // if (sym instanceof Symbol) { return false; }
	  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	  // if (!(symObj instanceof Symbol)) { return false; }
	  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
	  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


	  var symVal = 42;
	  obj[sym] = symVal;

	  for (sym in obj) {
	    return false;
	  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop


	  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
	    return false;
	  }

	  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
	    return false;
	  }

	  var syms = Object.getOwnPropertySymbols(obj);

	  if (syms.length !== 1 || syms[0] !== sym) {
	    return false;
	  }

	  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
	    return false;
	  }

	  if (typeof Object.getOwnPropertyDescriptor === 'function') {
	    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

	    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
	      return false;
	    }
	  }

	  return true;
	};

	var origSymbol = typeof Symbol !== 'undefined' && Symbol;



	var hasSymbols$1 = function hasNativeSymbols() {
	  if (typeof origSymbol !== 'function') {
	    return false;
	  }

	  if (typeof Symbol !== 'function') {
	    return false;
	  }

	  if (typeof origSymbol('foo') !== 'symbol') {
	    return false;
	  }

	  if (typeof Symbol('bar') !== 'symbol') {
	    return false;
	  }

	  return shams();
	};

	/* eslint no-invalid-this: 1 */

	var ERROR_MESSAGE$1 = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr$1 = Object.prototype.toString;
	var funcType = '[object Function]';

	var implementation = function bind(that) {
	  var target = this;

	  if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
	    throw new TypeError(ERROR_MESSAGE$1 + target);
	  }

	  var args = slice.call(arguments, 1);
	  var bound;

	  var binder = function () {
	    if (this instanceof bound) {
	      var result = target.apply(this, args.concat(slice.call(arguments)));

	      if (Object(result) === result) {
	        return result;
	      }

	      return this;
	    } else {
	      return target.apply(that, args.concat(slice.call(arguments)));
	    }
	  };

	  var boundLength = Math.max(0, target.length - args.length);
	  var boundArgs = [];

	  for (var i = 0; i < boundLength; i++) {
	    boundArgs.push('$' + i);
	  }

	  bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

	  if (target.prototype) {
	    var Empty = function Empty() {};

	    Empty.prototype = target.prototype;
	    bound.prototype = new Empty();
	    Empty.prototype = null;
	  }

	  return bound;
	};

	var functionBind = Function.prototype.bind || implementation;

	var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

	var undefined$1;
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError$6 = TypeError; // eslint-disable-next-line consistent-return

	var getEvalledConstructor = function (expressionSyntax) {
	  try {
	    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	  } catch (e) {}
	};

	var $gOPD = Object.getOwnPropertyDescriptor;

	if ($gOPD) {
	  try {
	    $gOPD({}, '');
	  } catch (e) {
	    $gOPD = null; // this is IE 8, which has a broken gOPD
	  }
	}

	var throwTypeError = function () {
	  throw new $TypeError$6();
	};

	var ThrowTypeError = $gOPD ? function () {
	  try {
	    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
	    arguments.callee; // IE 8 does not throw here

	    return throwTypeError;
	  } catch (calleeThrows) {
	    try {
	      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
	      return $gOPD(arguments, 'callee').get;
	    } catch (gOPDthrows) {
	      return throwTypeError;
	    }
	  }
	}() : throwTypeError;

	var hasSymbols = hasSymbols$1();

	var getProto = Object.getPrototypeOf || function (x) {
	  return x.__proto__;
	}; // eslint-disable-line no-proto


	var needsEval = {};
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);
	var INTRINSICS = {
	  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	  '%Array%': Array,
	  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	  '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
	  '%AsyncFromSyncIteratorPrototype%': undefined$1,
	  '%AsyncFunction%': needsEval,
	  '%AsyncGenerator%': needsEval,
	  '%AsyncGeneratorFunction%': needsEval,
	  '%AsyncIteratorPrototype%': needsEval,
	  '%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	  '%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	  '%Boolean%': Boolean,
	  '%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	  '%Date%': Date,
	  '%decodeURI%': decodeURI,
	  '%decodeURIComponent%': decodeURIComponent,
	  '%encodeURI%': encodeURI,
	  '%encodeURIComponent%': encodeURIComponent,
	  '%Error%': Error,
	  '%eval%': eval,
	  // eslint-disable-line no-eval
	  '%EvalError%': EvalError,
	  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	  '%Function%': $Function,
	  '%GeneratorFunction%': needsEval,
	  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	  '%isFinite%': isFinite,
	  '%isNaN%': isNaN,
	  '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	  '%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	  '%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	  '%Math%': Math,
	  '%Number%': Number,
	  '%Object%': Object,
	  '%parseFloat%': parseFloat,
	  '%parseInt%': parseInt,
	  '%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	  '%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	  '%RangeError%': RangeError,
	  '%ReferenceError%': ReferenceError,
	  '%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	  '%RegExp%': RegExp,
	  '%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	  '%String%': String,
	  '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
	  '%Symbol%': hasSymbols ? Symbol : undefined$1,
	  '%SyntaxError%': $SyntaxError,
	  '%ThrowTypeError%': ThrowTypeError,
	  '%TypedArray%': TypedArray,
	  '%TypeError%': $TypeError$6,
	  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	  '%URIError%': URIError,
	  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
	};

	var doEval = function doEval(name) {
	  var value;

	  if (name === '%AsyncFunction%') {
	    value = getEvalledConstructor('async function () {}');
	  } else if (name === '%GeneratorFunction%') {
	    value = getEvalledConstructor('function* () {}');
	  } else if (name === '%AsyncGeneratorFunction%') {
	    value = getEvalledConstructor('async function* () {}');
	  } else if (name === '%AsyncGenerator%') {
	    var fn = doEval('%AsyncGeneratorFunction%');

	    if (fn) {
	      value = fn.prototype;
	    }
	  } else if (name === '%AsyncIteratorPrototype%') {
	    var gen = doEval('%AsyncGenerator%');

	    if (gen) {
	      value = getProto(gen.prototype);
	    }
	  }

	  INTRINSICS[name] = value;
	  return value;
	};

	var LEGACY_ALIASES = {
	  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	  '%ArrayPrototype%': ['Array', 'prototype'],
	  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
	  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	  '%BooleanPrototype%': ['Boolean', 'prototype'],
	  '%DataViewPrototype%': ['DataView', 'prototype'],
	  '%DatePrototype%': ['Date', 'prototype'],
	  '%ErrorPrototype%': ['Error', 'prototype'],
	  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
	  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	  '%FunctionPrototype%': ['Function', 'prototype'],
	  '%Generator%': ['GeneratorFunction', 'prototype'],
	  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	  '%JSONParse%': ['JSON', 'parse'],
	  '%JSONStringify%': ['JSON', 'stringify'],
	  '%MapPrototype%': ['Map', 'prototype'],
	  '%NumberPrototype%': ['Number', 'prototype'],
	  '%ObjectPrototype%': ['Object', 'prototype'],
	  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	  '%PromisePrototype%': ['Promise', 'prototype'],
	  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	  '%Promise_all%': ['Promise', 'all'],
	  '%Promise_reject%': ['Promise', 'reject'],
	  '%Promise_resolve%': ['Promise', 'resolve'],
	  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
	  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	  '%RegExpPrototype%': ['RegExp', 'prototype'],
	  '%SetPrototype%': ['Set', 'prototype'],
	  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	  '%StringPrototype%': ['String', 'prototype'],
	  '%SymbolPrototype%': ['Symbol', 'prototype'],
	  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
	  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	  '%URIErrorPrototype%': ['URIError', 'prototype'],
	  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
	  '%WeakSetPrototype%': ['WeakSet', 'prototype']
	};





	var $concat$1 = functionBind.call(Function.call, Array.prototype.concat);
	var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
	var $replace$1 = functionBind.call(Function.call, String.prototype.replace);
	var $strSlice = functionBind.call(Function.call, String.prototype.slice);
	var $exec = functionBind.call(Function.call, RegExp.prototype.exec);
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */

	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g;
	/** Used to match backslashes in property paths. */

	var stringToPath$1 = function stringToPath(string) {
	  var first = $strSlice(string, 0, 1);
	  var last = $strSlice(string, -1);

	  if (first === '%' && last !== '%') {
	    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	  } else if (last === '%' && first !== '%') {
	    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	  }

	  var result = [];
	  $replace$1(string, rePropName, function (match, number, quote, subString) {
	    result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	  });
	  return result;
	};
	/* end adaptation */


	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	  var intrinsicName = name;
	  var alias;

	  if (src(LEGACY_ALIASES, intrinsicName)) {
	    alias = LEGACY_ALIASES[intrinsicName];
	    intrinsicName = '%' + alias[0] + '%';
	  }

	  if (src(INTRINSICS, intrinsicName)) {
	    var value = INTRINSICS[intrinsicName];

	    if (value === needsEval) {
	      value = doEval(intrinsicName);
	    }

	    if (typeof value === 'undefined' && !allowMissing) {
	      throw new $TypeError$6('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	    }

	    return {
	      alias: alias,
	      name: intrinsicName,
	      value: value
	    };
	  }

	  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};

	var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	  if (typeof name !== 'string' || name.length === 0) {
	    throw new $TypeError$6('intrinsic name must be a non-empty string');
	  }

	  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
	    throw new $TypeError$6('"allowMissing" argument must be a boolean');
	  }

	  if ($exec(/^%?[^%]*%?$/g, name) === null) {
	    throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	  }

	  var parts = stringToPath$1(name);
	  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	  var intrinsicRealName = intrinsic.name;
	  var value = intrinsic.value;
	  var skipFurtherCaching = false;
	  var alias = intrinsic.alias;

	  if (alias) {
	    intrinsicBaseName = alias[0];
	    $spliceApply(parts, $concat$1([0, 1], alias));
	  }

	  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
	    var part = parts[i];
	    var first = $strSlice(part, 0, 1);
	    var last = $strSlice(part, -1);

	    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
	      throw new $SyntaxError('property names with quotes must have matching quotes');
	    }

	    if (part === 'constructor' || !isOwn) {
	      skipFurtherCaching = true;
	    }

	    intrinsicBaseName += '.' + part;
	    intrinsicRealName = '%' + intrinsicBaseName + '%';

	    if (src(INTRINSICS, intrinsicRealName)) {
	      value = INTRINSICS[intrinsicRealName];
	    } else if (value != null) {
	      if (!(part in value)) {
	        if (!allowMissing) {
	          throw new $TypeError$6('base intrinsic for ' + name + ' exists, but the property is not available.');
	        }

	        return void undefined$1;
	      }

	      if ($gOPD && i + 1 >= parts.length) {
	        var desc = $gOPD(value, part);
	        isOwn = !!desc; // By convention, when a data property is converted to an accessor
	        // property to emulate a data property that does not suffer from
	        // the override mistake, that accessor's getter is marked with
	        // an `originalValue` property. Here, when we detect this, we
	        // uphold the illusion by pretending to see that original data
	        // property, i.e., returning the value rather than the getter
	        // itself.

	        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
	          value = desc.get;
	        } else {
	          value = value[part];
	        }
	      } else {
	        isOwn = src(value, part);
	        value = value[part];
	      }

	      if (isOwn && !skipFurtherCaching) {
	        INTRINSICS[intrinsicRealName] = value;
	      }
	    }
	  }

	  return value;
	};

	var callBind = createCommonjsModule$1(function (module) {





	var $apply = getIntrinsic('%Function.prototype.apply%');
	var $call = getIntrinsic('%Function.prototype.call%');
	var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);
	var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
	var $max = getIntrinsic('%Math.max%');

	if ($defineProperty) {
	  try {
	    $defineProperty({}, 'a', {
	      value: 1
	    });
	  } catch (e) {
	    // IE 8 has a broken defineProperty
	    $defineProperty = null;
	  }
	}

	module.exports = function callBind(originalFunction) {
	  var func = $reflectApply(functionBind, $call, arguments);

	  if ($gOPD && $defineProperty) {
	    var desc = $gOPD(func, 'length');

	    if (desc.configurable) {
	      // original length, plus the receiver, minus any additional arguments (after the receiver)
	      $defineProperty(func, 'length', {
	        value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
	      });
	    }
	  }

	  return func;
	};

	var applyBind = function applyBind() {
	  return $reflectApply(functionBind, $apply, arguments);
	};

	if ($defineProperty) {
	  $defineProperty(module.exports, 'apply', {
	    value: applyBind
	  });
	} else {
	  module.exports.apply = applyBind;
	}
	});

	var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

	var callBound = function callBoundIntrinsic(name, allowMissing) {
	  var intrinsic = getIntrinsic(name, !!allowMissing);

	  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
	    return callBind(intrinsic);
	  }

	  return intrinsic;
	};

	var _nodeResolve_empty = {};

	var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': _nodeResolve_empty
	});

	var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

	var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString$1 = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object'; // ie, `has-tostringtag/shams

	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
	? function (O) {
	  return O.__proto__; // eslint-disable-line no-proto
	} : null);

	function addNumericSeparator(num, str) {
	  if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
	    return str;
	  }

	  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;

	  if (typeof num === 'number') {
	    var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)

	    if (int !== num) {
	      var intStr = String(int);
	      var dec = $slice.call(str, intStr.length + 1);
	      return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	    }
	  }

	  return $replace.call(str, sepRegex, '$&_');
	}



	var inspectCustom = require$$0.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

	var objectInspect = function inspect_(obj, options, depth, seen) {
	  var opts = options || {};

	  if (has$7(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
	    throw new TypeError('option "quoteStyle" must be "single" or "double"');
	  }

	  if (has$7(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
	    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	  }

	  var customInspect = has$7(opts, 'customInspect') ? opts.customInspect : true;

	  if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	    throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	  }

	  if (has$7(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
	    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	  }

	  if (has$7(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	  }

	  var numericSeparator = opts.numericSeparator;

	  if (typeof obj === 'undefined') {
	    return 'undefined';
	  }

	  if (obj === null) {
	    return 'null';
	  }

	  if (typeof obj === 'boolean') {
	    return obj ? 'true' : 'false';
	  }

	  if (typeof obj === 'string') {
	    return inspectString(obj, opts);
	  }

	  if (typeof obj === 'number') {
	    if (obj === 0) {
	      return Infinity / obj > 0 ? '0' : '-0';
	    }

	    var str = String(obj);
	    return numericSeparator ? addNumericSeparator(obj, str) : str;
	  }

	  if (typeof obj === 'bigint') {
	    var bigIntStr = String(obj) + 'n';
	    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	  }

	  var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;

	  if (typeof depth === 'undefined') {
	    depth = 0;
	  }

	  if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	    return isArray$3(obj) ? '[Array]' : '[Object]';
	  }

	  var indent = getIndent(opts, depth);

	  if (typeof seen === 'undefined') {
	    seen = [];
	  } else if (indexOf(seen, obj) >= 0) {
	    return '[Circular]';
	  }

	  function inspect(value, from, noIndent) {
	    if (from) {
	      seen = $arrSlice.call(seen);
	      seen.push(from);
	    }

	    if (noIndent) {
	      var newOpts = {
	        depth: opts.depth
	      };

	      if (has$7(opts, 'quoteStyle')) {
	        newOpts.quoteStyle = opts.quoteStyle;
	      }

	      return inspect_(value, newOpts, depth + 1, seen);
	    }

	    return inspect_(value, opts, depth + 1, seen);
	  }

	  if (typeof obj === 'function' && !isRegExp$1(obj)) {
	    // in older engines, regexes are callable
	    var name = nameOf(obj);
	    var keys = arrObjKeys(obj, inspect);
	    return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	  }

	  if (isSymbol(obj)) {
	    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	    return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	  }

	  if (isElement(obj)) {
	    var s = '<' + $toLowerCase.call(String(obj.nodeName));
	    var attrs = obj.attributes || [];

	    for (var i = 0; i < attrs.length; i++) {
	      s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	    }

	    s += '>';

	    if (obj.childNodes && obj.childNodes.length) {
	      s += '...';
	    }

	    s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	    return s;
	  }

	  if (isArray$3(obj)) {
	    if (obj.length === 0) {
	      return '[]';
	    }

	    var xs = arrObjKeys(obj, inspect);

	    if (indent && !singleLineValues(xs)) {
	      return '[' + indentedJoin(xs, indent) + ']';
	    }

	    return '[ ' + $join.call(xs, ', ') + ' ]';
	  }

	  if (isError(obj)) {
	    var parts = arrObjKeys(obj, inspect);

	    if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	      return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	    }

	    if (parts.length === 0) {
	      return '[' + String(obj) + ']';
	    }

	    return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	  }

	  if (typeof obj === 'object' && customInspect) {
	    if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && require$$0) {
	      return require$$0(obj, {
	        depth: maxDepth - depth
	      });
	    } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	      return obj.inspect();
	    }
	  }

	  if (isMap(obj)) {
	    var mapParts = [];
	    mapForEach.call(obj, function (value, key) {
	      mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	    });
	    return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	  }

	  if (isSet(obj)) {
	    var setParts = [];
	    setForEach.call(obj, function (value) {
	      setParts.push(inspect(value, obj));
	    });
	    return collectionOf('Set', setSize.call(obj), setParts, indent);
	  }

	  if (isWeakMap(obj)) {
	    return weakCollectionOf('WeakMap');
	  }

	  if (isWeakSet(obj)) {
	    return weakCollectionOf('WeakSet');
	  }

	  if (isWeakRef(obj)) {
	    return weakCollectionOf('WeakRef');
	  }

	  if (isNumber(obj)) {
	    return markBoxed(inspect(Number(obj)));
	  }

	  if (isBigInt(obj)) {
	    return markBoxed(inspect(bigIntValueOf.call(obj)));
	  }

	  if (isBoolean$1(obj)) {
	    return markBoxed(booleanValueOf.call(obj));
	  }

	  if (isString$1(obj)) {
	    return markBoxed(inspect(String(obj)));
	  }

	  if (!isDate(obj) && !isRegExp$1(obj)) {
	    var ys = arrObjKeys(obj, inspect);
	    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	    var protoTag = obj instanceof Object ? '' : 'null prototype';
	    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	    var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	    var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');

	    if (ys.length === 0) {
	      return tag + '{}';
	    }

	    if (indent) {
	      return tag + '{' + indentedJoin(ys, indent) + '}';
	    }

	    return tag + '{ ' + $join.call(ys, ', ') + ' }';
	  }

	  return String(obj);
	};

	function wrapQuotes(s, defaultStyle, opts) {
	  var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
	  return quoteChar + s + quoteChar;
	}

	function quote(s) {
	  return $replace.call(String(s), /"/g, '&quot;');
	}

	function isArray$3(obj) {
	  return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	}

	function isDate(obj) {
	  return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	}

	function isRegExp$1(obj) {
	  return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	}

	function isError(obj) {
	  return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	}

	function isString$1(obj) {
	  return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	}

	function isNumber(obj) {
	  return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	}

	function isBoolean$1(obj) {
	  return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
	} // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives


	function isSymbol(obj) {
	  if (hasShammedSymbols) {
	    return obj && typeof obj === 'object' && obj instanceof Symbol;
	  }

	  if (typeof obj === 'symbol') {
	    return true;
	  }

	  if (!obj || typeof obj !== 'object' || !symToString) {
	    return false;
	  }

	  try {
	    symToString.call(obj);
	    return true;
	  } catch (e) {}

	  return false;
	}

	function isBigInt(obj) {
	  if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	    return false;
	  }

	  try {
	    bigIntValueOf.call(obj);
	    return true;
	  } catch (e) {}

	  return false;
	}

	var hasOwn = Object.prototype.hasOwnProperty || function (key) {
	  return key in this;
	};

	function has$7(obj, key) {
	  return hasOwn.call(obj, key);
	}

	function toStr(obj) {
	  return objectToString$1.call(obj);
	}

	function nameOf(f) {
	  if (f.name) {
	    return f.name;
	  }

	  var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);

	  if (m) {
	    return m[1];
	  }

	  return null;
	}

	function indexOf(xs, x) {
	  if (xs.indexOf) {
	    return xs.indexOf(x);
	  }

	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) {
	      return i;
	    }
	  }

	  return -1;
	}

	function isMap(x) {
	  if (!mapSize || !x || typeof x !== 'object') {
	    return false;
	  }

	  try {
	    mapSize.call(x);

	    try {
	      setSize.call(x);
	    } catch (s) {
	      return true;
	    }

	    return x instanceof Map; // core-js workaround, pre-v2.5.0
	  } catch (e) {}

	  return false;
	}

	function isWeakMap(x) {
	  if (!weakMapHas || !x || typeof x !== 'object') {
	    return false;
	  }

	  try {
	    weakMapHas.call(x, weakMapHas);

	    try {
	      weakSetHas.call(x, weakSetHas);
	    } catch (s) {
	      return true;
	    }

	    return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	  } catch (e) {}

	  return false;
	}

	function isWeakRef(x) {
	  if (!weakRefDeref || !x || typeof x !== 'object') {
	    return false;
	  }

	  try {
	    weakRefDeref.call(x);
	    return true;
	  } catch (e) {}

	  return false;
	}

	function isSet(x) {
	  if (!setSize || !x || typeof x !== 'object') {
	    return false;
	  }

	  try {
	    setSize.call(x);

	    try {
	      mapSize.call(x);
	    } catch (m) {
	      return true;
	    }

	    return x instanceof Set; // core-js workaround, pre-v2.5.0
	  } catch (e) {}

	  return false;
	}

	function isWeakSet(x) {
	  if (!weakSetHas || !x || typeof x !== 'object') {
	    return false;
	  }

	  try {
	    weakSetHas.call(x, weakSetHas);

	    try {
	      weakMapHas.call(x, weakMapHas);
	    } catch (s) {
	      return true;
	    }

	    return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	  } catch (e) {}

	  return false;
	}

	function isElement(x) {
	  if (!x || typeof x !== 'object') {
	    return false;
	  }

	  if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	    return true;
	  }

	  return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}

	function inspectString(str, opts) {
	  if (str.length > opts.maxStringLength) {
	    var remaining = str.length - opts.maxStringLength;
	    var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	  } // eslint-disable-next-line no-control-regex


	  var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	  return wrapQuotes(s, 'single', opts);
	}

	function lowbyte(c) {
	  var n = c.charCodeAt(0);
	  var x = {
	    8: 'b',
	    9: 't',
	    10: 'n',
	    12: 'f',
	    13: 'r'
	  }[n];

	  if (x) {
	    return '\\' + x;
	  }

	  return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}

	function markBoxed(str) {
	  return 'Object(' + str + ')';
	}

	function weakCollectionOf(type) {
	  return type + ' { ? }';
	}

	function collectionOf(type, size, entries, indent) {
	  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	  return type + ' (' + size + ') {' + joinedEntries + '}';
	}

	function singleLineValues(xs) {
	  for (var i = 0; i < xs.length; i++) {
	    if (indexOf(xs[i], '\n') >= 0) {
	      return false;
	    }
	  }

	  return true;
	}

	function getIndent(opts, depth) {
	  var baseIndent;

	  if (opts.indent === '\t') {
	    baseIndent = '\t';
	  } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	    baseIndent = $join.call(Array(opts.indent + 1), ' ');
	  } else {
	    return null;
	  }

	  return {
	    base: baseIndent,
	    prev: $join.call(Array(depth + 1), baseIndent)
	  };
	}

	function indentedJoin(xs, indent) {
	  if (xs.length === 0) {
	    return '';
	  }

	  var lineJoiner = '\n' + indent.prev + indent.base;
	  return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}

	function arrObjKeys(obj, inspect) {
	  var isArr = isArray$3(obj);
	  var xs = [];

	  if (isArr) {
	    xs.length = obj.length;

	    for (var i = 0; i < obj.length; i++) {
	      xs[i] = has$7(obj, i) ? inspect(obj[i], obj) : '';
	    }
	  }

	  var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	  var symMap;

	  if (hasShammedSymbols) {
	    symMap = {};

	    for (var k = 0; k < syms.length; k++) {
	      symMap['$' + syms[k]] = syms[k];
	    }
	  }

	  for (var key in obj) {
	    // eslint-disable-line no-restricted-syntax
	    if (!has$7(obj, key)) {
	      continue;
	    } // eslint-disable-line no-restricted-syntax, no-continue


	    if (isArr && String(Number(key)) === key && key < obj.length) {
	      continue;
	    } // eslint-disable-line no-restricted-syntax, no-continue


	    if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	      // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	      continue; // eslint-disable-line no-restricted-syntax, no-continue
	    } else if ($test.call(/[^\w$]/, key)) {
	      xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	    } else {
	      xs.push(key + ': ' + inspect(obj[key], obj));
	    }
	  }

	  if (typeof gOPS === 'function') {
	    for (var j = 0; j < syms.length; j++) {
	      if (isEnumerable.call(obj, syms[j])) {
	        xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	      }
	    }
	  }

	  return xs;
	}

	var inspect = objectInspect;

	var $TypeError$5 = getIntrinsic('%TypeError%');
	var $WeakMap = getIntrinsic('%WeakMap%', true);
	var $Map = getIntrinsic('%Map%', true);
	var $weakMapGet = callBound('WeakMap.prototype.get', true);
	var $weakMapSet = callBound('WeakMap.prototype.set', true);
	var $weakMapHas = callBound('WeakMap.prototype.has', true);
	var $mapGet = callBound('Map.prototype.get', true);
	var $mapSet = callBound('Map.prototype.set', true);
	var $mapHas = callBound('Map.prototype.has', true);
	/*
	 * This function traverses the list returning the node corresponding to the
	 * given key.
	 *
	 * That node is also moved to the head of the list, so that if it's accessed
	 * again we don't need to traverse the whole list. By doing so, all the recently
	 * used nodes can be accessed relatively quickly.
	 */

	var listGetNode = function (list, key) {
	  // eslint-disable-line consistent-return
	  for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
	    if (curr.key === key) {
	      prev.next = curr.next;
	      curr.next = list.next;
	      list.next = curr; // eslint-disable-line no-param-reassign

	      return curr;
	    }
	  }
	};

	var listGet = function (objects, key) {
	  var node = listGetNode(objects, key);
	  return node && node.value;
	};

	var listSet = function (objects, key, value) {
	  var node = listGetNode(objects, key);

	  if (node) {
	    node.value = value;
	  } else {
	    // Prepend the new node to the beginning of the list
	    objects.next = {
	      // eslint-disable-line no-param-reassign
	      key: key,
	      next: objects.next,
	      value: value
	    };
	  }
	};

	var listHas = function (objects, key) {
	  return !!listGetNode(objects, key);
	};

	var sideChannel = function getSideChannel() {
	  var $wm;
	  var $m;
	  var $o;
	  var channel = {
	    assert: function (key) {
	      if (!channel.has(key)) {
	        throw new $TypeError$5('Side channel does not contain ' + inspect(key));
	      }
	    },
	    get: function (key) {
	      // eslint-disable-line consistent-return
	      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
	        if ($wm) {
	          return $weakMapGet($wm, key);
	        }
	      } else if ($Map) {
	        if ($m) {
	          return $mapGet($m, key);
	        }
	      } else {
	        if ($o) {
	          // eslint-disable-line no-lonely-if
	          return listGet($o, key);
	        }
	      }
	    },
	    has: function (key) {
	      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
	        if ($wm) {
	          return $weakMapHas($wm, key);
	        }
	      } else if ($Map) {
	        if ($m) {
	          return $mapHas($m, key);
	        }
	      } else {
	        if ($o) {
	          // eslint-disable-line no-lonely-if
	          return listHas($o, key);
	        }
	      }

	      return false;
	    },
	    set: function (key, value) {
	      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
	        if (!$wm) {
	          $wm = new $WeakMap();
	        }

	        $weakMapSet($wm, key, value);
	      } else if ($Map) {
	        if (!$m) {
	          $m = new $Map();
	        }

	        $mapSet($m, key, value);
	      } else {
	        if (!$o) {
	          /*
	           * Initialize the linked list as an empty node, so that we don't have
	           * to special-case handling of the first node: we can always refer to
	           * it as (previous node).next, instead of something like (list).head
	           */
	          $o = {
	            key: {},
	            next: null
	          };
	        }

	        listSet($o, key, value);
	      }
	    }
	  };
	  return channel;
	};

	var replace$1 = String.prototype.replace;
	var percentTwenties = /%20/g;
	var Format = {
	  RFC1738: 'RFC1738',
	  RFC3986: 'RFC3986'
	};
	var formats = {
	  'default': Format.RFC3986,
	  formatters: {
	    RFC1738: function (value) {
	      return replace$1.call(value, percentTwenties, '+');
	    },
	    RFC3986: function (value) {
	      return String(value);
	    }
	  },
	  RFC1738: Format.RFC1738,
	  RFC3986: Format.RFC3986
	};

	var has$6 = Object.prototype.hasOwnProperty;
	var isArray$2 = Array.isArray;

	var hexTable = function () {
	  var array = [];

	  for (var i = 0; i < 256; ++i) {
	    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	  }

	  return array;
	}();

	var compactQueue = function compactQueue(queue) {
	  while (queue.length > 1) {
	    var item = queue.pop();
	    var obj = item.obj[item.prop];

	    if (isArray$2(obj)) {
	      var compacted = [];

	      for (var j = 0; j < obj.length; ++j) {
	        if (typeof obj[j] !== 'undefined') {
	          compacted.push(obj[j]);
	        }
	      }

	      item.obj[item.prop] = compacted;
	    }
	  }
	};

	var arrayToObject = function arrayToObject(source, options) {
	  var obj = options && options.plainObjects ? Object.create(null) : {};

	  for (var i = 0; i < source.length; ++i) {
	    if (typeof source[i] !== 'undefined') {
	      obj[i] = source[i];
	    }
	  }

	  return obj;
	};

	var merge = function merge(target, source, options) {
	  /* eslint no-param-reassign: 0 */
	  if (!source) {
	    return target;
	  }

	  if (typeof source !== 'object') {
	    if (isArray$2(target)) {
	      target.push(source);
	    } else if (target && typeof target === 'object') {
	      if (options && (options.plainObjects || options.allowPrototypes) || !has$6.call(Object.prototype, source)) {
	        target[source] = true;
	      }
	    } else {
	      return [target, source];
	    }

	    return target;
	  }

	  if (!target || typeof target !== 'object') {
	    return [target].concat(source);
	  }

	  var mergeTarget = target;

	  if (isArray$2(target) && !isArray$2(source)) {
	    mergeTarget = arrayToObject(target, options);
	  }

	  if (isArray$2(target) && isArray$2(source)) {
	    source.forEach(function (item, i) {
	      if (has$6.call(target, i)) {
	        var targetItem = target[i];

	        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	          target[i] = merge(targetItem, item, options);
	        } else {
	          target.push(item);
	        }
	      } else {
	        target[i] = item;
	      }
	    });
	    return target;
	  }

	  return Object.keys(source).reduce(function (acc, key) {
	    var value = source[key];

	    if (has$6.call(acc, key)) {
	      acc[key] = merge(acc[key], value, options);
	    } else {
	      acc[key] = value;
	    }

	    return acc;
	  }, mergeTarget);
	};

	var assign = function assignSingleSource(target, source) {
	  return Object.keys(source).reduce(function (acc, key) {
	    acc[key] = source[key];
	    return acc;
	  }, target);
	};

	var decode$4 = function (str, decoder, charset) {
	  var strWithoutPlus = str.replace(/\+/g, ' ');

	  if (charset === 'iso-8859-1') {
	    // unescape never throws, no try...catch needed:
	    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	  } // utf-8


	  try {
	    return decodeURIComponent(strWithoutPlus);
	  } catch (e) {
	    return strWithoutPlus;
	  }
	};

	var encode$5 = function encode(str, defaultEncoder, charset, kind, format) {
	  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	  // It has been adapted here for stricter adherence to RFC 3986
	  if (str.length === 0) {
	    return str;
	  }

	  var string = str;

	  if (typeof str === 'symbol') {
	    string = Symbol.prototype.toString.call(str);
	  } else if (typeof str !== 'string') {
	    string = String(str);
	  }

	  if (charset === 'iso-8859-1') {
	    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	    });
	  }

	  var out = '';

	  for (var i = 0; i < string.length; ++i) {
	    var c = string.charCodeAt(i);

	    if (c === 0x2D // -
	    || c === 0x2E // .
	    || c === 0x5F // _
	    || c === 0x7E // ~
	    || c >= 0x30 && c <= 0x39 // 0-9
	    || c >= 0x41 && c <= 0x5A // a-z
	    || c >= 0x61 && c <= 0x7A // A-Z
	    || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
	    ) {
	      out += string.charAt(i);
	      continue;
	    }

	    if (c < 0x80) {
	      out = out + hexTable[c];
	      continue;
	    }

	    if (c < 0x800) {
	      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
	      continue;
	    }

	    if (c < 0xD800 || c >= 0xE000) {
	      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
	      continue;
	    }

	    i += 1;
	    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
	    /* eslint operator-linebreak: [2, "before"] */

	    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
	  }

	  return out;
	};

	var compact$1 = function compact(value) {
	  var queue = [{
	    obj: {
	      o: value
	    },
	    prop: 'o'
	  }];
	  var refs = [];

	  for (var i = 0; i < queue.length; ++i) {
	    var item = queue[i];
	    var obj = item.obj[item.prop];
	    var keys = Object.keys(obj);

	    for (var j = 0; j < keys.length; ++j) {
	      var key = keys[j];
	      var val = obj[key];

	      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	        queue.push({
	          obj: obj,
	          prop: key
	        });
	        refs.push(val);
	      }
	    }
	  }

	  compactQueue(queue);
	  return value;
	};

	var isRegExp = function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	};

	var isBuffer = function isBuffer(obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }

	  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};

	var combine = function combine(a, b) {
	  return [].concat(a, b);
	};

	var maybeMap = function maybeMap(val, fn) {
	  if (isArray$2(val)) {
	    var mapped = [];

	    for (var i = 0; i < val.length; i += 1) {
	      mapped.push(fn(val[i]));
	    }

	    return mapped;
	  }

	  return fn(val);
	};

	var utils$1 = {
	  arrayToObject: arrayToObject,
	  assign: assign,
	  combine: combine,
	  compact: compact$1,
	  decode: decode$4,
	  encode: encode$5,
	  isBuffer: isBuffer,
	  isRegExp: isRegExp,
	  maybeMap: maybeMap,
	  merge: merge
	};

	var has$5 = Object.prototype.hasOwnProperty;
	var arrayPrefixGenerators = {
	  brackets: function brackets(prefix) {
	    return prefix + '[]';
	  },
	  comma: 'comma',
	  indices: function indices(prefix, key) {
	    return prefix + '[' + key + ']';
	  },
	  repeat: function repeat(prefix) {
	    return prefix;
	  }
	};
	var isArray$1 = Array.isArray;
	var split = String.prototype.split;
	var push$1 = Array.prototype.push;

	var pushToArray = function (arr, valueOrArray) {
	  push$1.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
	};

	var toISO = Date.prototype.toISOString;
	var defaultFormat = formats['default'];
	var defaults$1 = {
	  addQueryPrefix: false,
	  allowDots: false,
	  charset: 'utf-8',
	  charsetSentinel: false,
	  delimiter: '&',
	  encode: true,
	  encoder: utils$1.encode,
	  encodeValuesOnly: false,
	  format: defaultFormat,
	  formatter: formats.formatters[defaultFormat],
	  // deprecated
	  indices: false,
	  serializeDate: function serializeDate(date) {
	    return toISO.call(date);
	  },
	  skipNulls: false,
	  strictNullHandling: false
	};

	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
	};

	var sentinel = {};

	var stringify$1 = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel$1) {
	  var obj = object;
	  var tmpSc = sideChannel$1;
	  var step = 0;
	  var findFlag = false;

	  while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
	    // Where object last appeared in the ref tree
	    var pos = tmpSc.get(object);
	    step += 1;

	    if (typeof pos !== 'undefined') {
	      if (pos === step) {
	        throw new RangeError('Cyclic object value');
	      } else {
	        findFlag = true; // Break while
	      }
	    }

	    if (typeof tmpSc.get(sentinel) === 'undefined') {
	      step = 0;
	    }
	  }

	  if (typeof filter === 'function') {
	    obj = filter(prefix, obj);
	  } else if (obj instanceof Date) {
	    obj = serializeDate(obj);
	  } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
	    obj = utils$1.maybeMap(obj, function (value) {
	      if (value instanceof Date) {
	        return serializeDate(value);
	      }

	      return value;
	    });
	  }

	  if (obj === null) {
	    if (strictNullHandling) {
	      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
	    }

	    obj = '';
	  }

	  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
	    if (encoder) {
	      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);

	      if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
	        var valuesArray = split.call(String(obj), ',');
	        var valuesJoined = '';

	        for (var i = 0; i < valuesArray.length; ++i) {
	          valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, 'value', format));
	        }

	        return [formatter(keyValue) + (commaRoundTrip && isArray$1(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
	      }

	      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
	    }

	    return [formatter(prefix) + '=' + formatter(String(obj))];
	  }

	  var values = [];

	  if (typeof obj === 'undefined') {
	    return values;
	  }

	  var objKeys;

	  if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
	    // we need to join elements in
	    objKeys = [{
	      value: obj.length > 0 ? obj.join(',') || null : void undefined
	    }];
	  } else if (isArray$1(filter)) {
	    objKeys = filter;
	  } else {
	    var keys = Object.keys(obj);
	    objKeys = sort ? keys.sort(sort) : keys;
	  }

	  var adjustedPrefix = commaRoundTrip && isArray$1(obj) && obj.length === 1 ? prefix + '[]' : prefix;

	  for (var j = 0; j < objKeys.length; ++j) {
	    var key = objKeys[j];
	    var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

	    if (skipNulls && value === null) {
	      continue;
	    }

	    var keyPrefix = isArray$1(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
	    sideChannel$1.set(object, step);
	    var valueSideChannel = sideChannel();
	    valueSideChannel.set(sentinel, sideChannel$1);
	    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
	  }

	  return values;
	};

	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	  if (!opts) {
	    return defaults$1;
	  }

	  if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
	    throw new TypeError('Encoder has to be a function.');
	  }

	  var charset = opts.charset || defaults$1.charset;

	  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	  }

	  var format = formats['default'];

	  if (typeof opts.format !== 'undefined') {
	    if (!has$5.call(formats.formatters, opts.format)) {
	      throw new TypeError('Unknown format option provided.');
	    }

	    format = opts.format;
	  }

	  var formatter = formats.formatters[format];
	  var filter = defaults$1.filter;

	  if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
	    filter = opts.filter;
	  }

	  return {
	    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
	    allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
	    charset: charset,
	    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
	    delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
	    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
	    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
	    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
	    filter: filter,
	    format: format,
	    formatter: formatter,
	    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
	    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
	    sort: typeof opts.sort === 'function' ? opts.sort : null,
	    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
	  };
	};

	var stringify_1 = function (object, opts) {
	  var obj = object;
	  var options = normalizeStringifyOptions(opts);
	  var objKeys;
	  var filter;

	  if (typeof options.filter === 'function') {
	    filter = options.filter;
	    obj = filter('', obj);
	  } else if (isArray$1(options.filter)) {
	    filter = options.filter;
	    objKeys = filter;
	  }

	  var keys = [];

	  if (typeof obj !== 'object' || obj === null) {
	    return '';
	  }

	  var arrayFormat;

	  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	    arrayFormat = opts.arrayFormat;
	  } else if (opts && 'indices' in opts) {
	    arrayFormat = opts.indices ? 'indices' : 'repeat';
	  } else {
	    arrayFormat = 'indices';
	  }

	  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

	  if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
	    throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
	  }

	  var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

	  if (!objKeys) {
	    objKeys = Object.keys(obj);
	  }

	  if (options.sort) {
	    objKeys.sort(options.sort);
	  }

	  var sideChannel$1 = sideChannel();

	  for (var i = 0; i < objKeys.length; ++i) {
	    var key = objKeys[i];

	    if (options.skipNulls && obj[key] === null) {
	      continue;
	    }

	    pushToArray(keys, stringify$1(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel$1));
	  }

	  var joined = keys.join(options.delimiter);
	  var prefix = options.addQueryPrefix === true ? '?' : '';

	  if (options.charsetSentinel) {
	    if (options.charset === 'iso-8859-1') {
	      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	      prefix += 'utf8=%26%2310003%3B&';
	    } else {
	      // encodeURIComponent('✓')
	      prefix += 'utf8=%E2%9C%93&';
	    }
	  }

	  return joined.length > 0 ? prefix + joined : '';
	};

	var has$4 = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	var defaults = {
	  allowDots: false,
	  allowPrototypes: false,
	  allowSparse: false,
	  arrayLimit: 20,
	  charset: 'utf-8',
	  charsetSentinel: false,
	  comma: false,
	  decoder: utils$1.decode,
	  delimiter: '&',
	  depth: 5,
	  ignoreQueryPrefix: false,
	  interpretNumericEntities: false,
	  parameterLimit: 1000,
	  parseArrays: true,
	  plainObjects: false,
	  strictNullHandling: false
	};

	var interpretNumericEntities = function (str) {
	  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	    return String.fromCharCode(parseInt(numberStr, 10));
	  });
	};

	var parseArrayValue = function (val, options) {
	  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	    return val.split(',');
	  }

	  return val;
	}; // This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.


	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

	var parseValues = function parseQueryStringValues(str, options) {
	  var obj = {};
	  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	  var parts = cleanStr.split(options.delimiter, limit);
	  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

	  var i;
	  var charset = options.charset;

	  if (options.charsetSentinel) {
	    for (i = 0; i < parts.length; ++i) {
	      if (parts[i].indexOf('utf8=') === 0) {
	        if (parts[i] === charsetSentinel) {
	          charset = 'utf-8';
	        } else if (parts[i] === isoSentinel) {
	          charset = 'iso-8859-1';
	        }

	        skipIndex = i;
	        i = parts.length; // The eslint settings do not allow break;
	      }
	    }
	  }

	  for (i = 0; i < parts.length; ++i) {
	    if (i === skipIndex) {
	      continue;
	    }

	    var part = parts[i];
	    var bracketEqualsPos = part.indexOf(']=');
	    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	    var key, val;

	    if (pos === -1) {
	      key = options.decoder(part, defaults.decoder, charset, 'key');
	      val = options.strictNullHandling ? null : '';
	    } else {
	      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	      val = utils$1.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
	        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	      });
	    }

	    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	      val = interpretNumericEntities(val);
	    }

	    if (part.indexOf('[]=') > -1) {
	      val = isArray(val) ? [val] : val;
	    }

	    if (has$4.call(obj, key)) {
	      obj[key] = utils$1.combine(obj[key], val);
	    } else {
	      obj[key] = val;
	    }
	  }

	  return obj;
	};

	var parseObject = function (chain, val, options, valuesParsed) {
	  var leaf = valuesParsed ? val : parseArrayValue(val, options);

	  for (var i = chain.length - 1; i >= 0; --i) {
	    var obj;
	    var root = chain[i];

	    if (root === '[]' && options.parseArrays) {
	      obj = [].concat(leaf);
	    } else {
	      obj = options.plainObjects ? Object.create(null) : {};
	      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	      var index = parseInt(cleanRoot, 10);

	      if (!options.parseArrays && cleanRoot === '') {
	        obj = {
	          0: leaf
	        };
	      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
	        obj = [];
	        obj[index] = leaf;
	      } else if (cleanRoot !== '__proto__') {
	        obj[cleanRoot] = leaf;
	      }
	    }

	    leaf = obj;
	  }

	  return leaf;
	};

	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	  if (!givenKey) {
	    return;
	  } // Transform dot notation to bracket notation


	  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

	  var brackets = /(\[[^[\]]*])/;
	  var child = /(\[[^[\]]*])/g; // Get the parent

	  var segment = options.depth > 0 && brackets.exec(key);
	  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

	  var keys = [];

	  if (parent) {
	    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	    if (!options.plainObjects && has$4.call(Object.prototype, parent)) {
	      if (!options.allowPrototypes) {
	        return;
	      }
	    }

	    keys.push(parent);
	  } // Loop through children appending to the array until we hit depth


	  var i = 0;

	  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	    i += 1;

	    if (!options.plainObjects && has$4.call(Object.prototype, segment[1].slice(1, -1))) {
	      if (!options.allowPrototypes) {
	        return;
	      }
	    }

	    keys.push(segment[1]);
	  } // If there's a remainder, just add whatever is left


	  if (segment) {
	    keys.push('[' + key.slice(segment.index) + ']');
	  }

	  return parseObject(keys, val, options, valuesParsed);
	};

	var normalizeParseOptions = function normalizeParseOptions(opts) {
	  if (!opts) {
	    return defaults;
	  }

	  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	    throw new TypeError('Decoder has to be a function.');
	  }

	  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	  }

	  var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	  return {
	    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	    allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
	    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	    charset: charset,
	    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	    delimiter: typeof opts.delimiter === 'string' || utils$1.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
	    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	    parseArrays: opts.parseArrays !== false,
	    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	  };
	};

	var parse$2 = function (str, opts) {
	  var options = normalizeParseOptions(opts);

	  if (str === '' || str === null || typeof str === 'undefined') {
	    return options.plainObjects ? Object.create(null) : {};
	  }

	  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

	  var keys = Object.keys(tempObj);

	  for (var i = 0; i < keys.length; ++i) {
	    var key = keys[i];
	    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	    obj = utils$1.merge(obj, newObj, options);
	  }

	  if (options.allowSparse === true) {
	    return obj;
	  }

	  return utils$1.compact(obj);
	};

	var lib = {
	  formats: formats,
	  parse: parse$2,
	  stringify: stringify_1
	};

	var dist = createCommonjsModule$1(function (module, exports) {
	!function (e, t) {
	  module.exports = t() ;
	}(commonjsGlobal, function () {
	  return function (e) {
	    var t = {};

	    function n(r) {
	      if (t[r]) return t[r].exports;
	      var i = t[r] = {
	        i: r,
	        l: !1,
	        exports: {}
	      };
	      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
	    }

	    return n.m = e, n.c = t, n.d = function (e, t, r) {
	      n.o(e, t) || Object.defineProperty(e, t, {
	        enumerable: !0,
	        get: r
	      });
	    }, n.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
	        value: "Module"
	      }), Object.defineProperty(e, "__esModule", {
	        value: !0
	      });
	    }, n.t = function (e, t) {
	      if (1 & t && (e = n(e)), 8 & t) return e;
	      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
	      var r = Object.create(null);
	      if (n.r(r), Object.defineProperty(r, "default", {
	        enumerable: !0,
	        value: e
	      }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
	        return e[t];
	      }.bind(null, i));
	      return r;
	    }, n.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };
	      return n.d(t, "a", t), t;
	    }, n.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, n.p = "", n(n.s = 21);
	  }([function (e, t, n) {

	    e.exports = n(23);
	  }, function (e, t, n) {

	    n.r(t), n.d(t, "__extends", function () {
	      return i;
	    }), n.d(t, "__assign", function () {
	      return o;
	    }), n.d(t, "__rest", function () {
	      return a;
	    }), n.d(t, "__decorate", function () {
	      return l;
	    }), n.d(t, "__param", function () {
	      return u;
	    }), n.d(t, "__metadata", function () {
	      return c;
	    }), n.d(t, "__awaiter", function () {
	      return s;
	    }), n.d(t, "__generator", function () {
	      return A;
	    }), n.d(t, "__exportStar", function () {
	      return d;
	    }), n.d(t, "__values", function () {
	      return f;
	    }), n.d(t, "__read", function () {
	      return I;
	    }), n.d(t, "__spread", function () {
	      return g;
	    }), n.d(t, "__spreadArrays", function () {
	      return M;
	    }), n.d(t, "__await", function () {
	      return p;
	    }), n.d(t, "__asyncGenerator", function () {
	      return N;
	    }), n.d(t, "__asyncDelegator", function () {
	      return y;
	    }), n.d(t, "__asyncValues", function () {
	      return v;
	    }), n.d(t, "__makeTemplateObject", function () {
	      return h;
	    }), n.d(t, "__importStar", function () {
	      return j;
	    }), n.d(t, "__importDefault", function () {
	      return m;
	    });
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0
	    
	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.
	    
	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */

	    var r = function (e, t) {
	      return (r = Object.setPrototypeOf || {
	        __proto__: []
	      } instanceof Array && function (e, t) {
	        e.__proto__ = t;
	      } || function (e, t) {
	        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
	      })(e, t);
	    };

	    function i(e, t) {
	      function n() {
	        this.constructor = e;
	      }

	      r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
	    }

	    var o = function () {
	      return (o = Object.assign || function (e) {
	        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);

	        return e;
	      }).apply(this, arguments);
	    };

	    function a(e, t) {
	      var n = {};

	      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);

	      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
	        var i = 0;

	        for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	      }

	      return n;
	    }

	    function l(e, t, n, r) {
	      var i,
	          o = arguments.length,
	          a = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
	      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (i = e[l]) && (a = (o < 3 ? i(a) : o > 3 ? i(t, n, a) : i(t, n)) || a);
	      return o > 3 && a && Object.defineProperty(t, n, a), a;
	    }

	    function u(e, t) {
	      return function (n, r) {
	        t(n, r, e);
	      };
	    }

	    function c(e, t) {
	      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
	    }

	    function s(e, t, n, r) {
	      return new (n || (n = Promise))(function (i, o) {
	        function a(e) {
	          try {
	            u(r.next(e));
	          } catch (e) {
	            o(e);
	          }
	        }

	        function l(e) {
	          try {
	            u(r.throw(e));
	          } catch (e) {
	            o(e);
	          }
	        }

	        function u(e) {
	          e.done ? i(e.value) : new n(function (t) {
	            t(e.value);
	          }).then(a, l);
	        }

	        u((r = r.apply(e, t || [])).next());
	      });
	    }

	    function A(e, t) {
	      var n,
	          r,
	          i,
	          o,
	          a = {
	        label: 0,
	        sent: function () {
	          if (1 & i[0]) throw i[1];
	          return i[1];
	        },
	        trys: [],
	        ops: []
	      };
	      return o = {
	        next: l(0),
	        throw: l(1),
	        return: l(2)
	      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
	        return this;
	      }), o;

	      function l(o) {
	        return function (l) {
	          return function (o) {
	            if (n) throw new TypeError("Generator is already executing.");

	            for (; a;) try {
	              if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

	              switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
	                case 0:
	                case 1:
	                  i = o;
	                  break;

	                case 4:
	                  return a.label++, {
	                    value: o[1],
	                    done: !1
	                  };

	                case 5:
	                  a.label++, r = o[1], o = [0];
	                  continue;

	                case 7:
	                  o = a.ops.pop(), a.trys.pop();
	                  continue;

	                default:
	                  if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
	                    a = 0;
	                    continue;
	                  }

	                  if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
	                    a.label = o[1];
	                    break;
	                  }

	                  if (6 === o[0] && a.label < i[1]) {
	                    a.label = i[1], i = o;
	                    break;
	                  }

	                  if (i && a.label < i[2]) {
	                    a.label = i[2], a.ops.push(o);
	                    break;
	                  }

	                  i[2] && a.ops.pop(), a.trys.pop();
	                  continue;
	              }

	              o = t.call(e, a);
	            } catch (e) {
	              o = [6, e], r = 0;
	            } finally {
	              n = i = 0;
	            }

	            if (5 & o[0]) throw o[1];
	            return {
	              value: o[0] ? o[1] : void 0,
	              done: !0
	            };
	          }([o, l]);
	        };
	      }
	    }

	    function d(e, t) {
	      for (var n in e) t.hasOwnProperty(n) || (t[n] = e[n]);
	    }

	    function f(e) {
	      var t = "function" == typeof Symbol && e[Symbol.iterator],
	          n = 0;
	      return t ? t.call(e) : {
	        next: function () {
	          return e && n >= e.length && (e = void 0), {
	            value: e && e[n++],
	            done: !e
	          };
	        }
	      };
	    }

	    function I(e, t) {
	      var n = "function" == typeof Symbol && e[Symbol.iterator];
	      if (!n) return e;
	      var r,
	          i,
	          o = n.call(e),
	          a = [];

	      try {
	        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) a.push(r.value);
	      } catch (e) {
	        i = {
	          error: e
	        };
	      } finally {
	        try {
	          r && !r.done && (n = o.return) && n.call(o);
	        } finally {
	          if (i) throw i.error;
	        }
	      }

	      return a;
	    }

	    function g() {
	      for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(I(arguments[t]));

	      return e;
	    }

	    function M() {
	      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;

	      var r = Array(e),
	          i = 0;

	      for (t = 0; t < n; t++) for (var o = arguments[t], a = 0, l = o.length; a < l; a++, i++) r[i] = o[a];

	      return r;
	    }

	    function p(e) {
	      return this instanceof p ? (this.v = e, this) : new p(e);
	    }

	    function N(e, t, n) {
	      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	      var r,
	          i = n.apply(e, t || []),
	          o = [];
	      return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
	        return this;
	      }, r;

	      function a(e) {
	        i[e] && (r[e] = function (t) {
	          return new Promise(function (n, r) {
	            o.push([e, t, n, r]) > 1 || l(e, t);
	          });
	        });
	      }

	      function l(e, t) {
	        try {
	          !function (e) {
	            e.value instanceof p ? Promise.resolve(e.value.v).then(u, c) : s(o[0][2], e);
	          }(i[e](t));
	        } catch (e) {
	          s(o[0][3], e);
	        }
	      }

	      function u(e) {
	        l("next", e);
	      }

	      function c(e) {
	        l("throw", e);
	      }

	      function s(e, t) {
	        e(t), o.shift(), o.length && l(o[0][0], o[0][1]);
	      }
	    }

	    function y(e) {
	      var t, n;
	      return t = {}, r("next"), r("throw", function (e) {
	        throw e;
	      }), r("return"), t[Symbol.iterator] = function () {
	        return this;
	      }, t;

	      function r(r, i) {
	        t[r] = e[r] ? function (t) {
	          return (n = !n) ? {
	            value: p(e[r](t)),
	            done: "return" === r
	          } : i ? i(t) : t;
	        } : i;
	      }
	    }

	    function v(e) {
	      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	      var t,
	          n = e[Symbol.asyncIterator];
	      return n ? n.call(e) : (e = f(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
	        return this;
	      }, t);

	      function r(n) {
	        t[n] = e[n] && function (t) {
	          return new Promise(function (r, i) {
	            (function (e, t, n, r) {
	              Promise.resolve(r).then(function (t) {
	                e({
	                  value: t,
	                  done: n
	                });
	              }, t);
	            })(r, i, (t = e[n](t)).done, t.value);
	          });
	        };
	      }
	    }

	    function h(e, t) {
	      return Object.defineProperty ? Object.defineProperty(e, "raw", {
	        value: t
	      }) : e.raw = t, e;
	    }

	    function j(e) {
	      if (e && e.__esModule) return e;
	      var t = {};
	      if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
	      return t.default = e, t;
	    }

	    function m(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);
	    r.__exportStar(n(10), t), r.__exportStar(n(27), t), r.__exportStar(n(28), t), r.__exportStar(n(29), t);
	  }, function (e, t, n) {

	    var r;
	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var i = n(1),
	        o = i.__importDefault(n(30)),
	        a = i.__importDefault(n(31));

	    t.themesList = ((r = {
	      default: o.default
	    })[o.default.name] = o.default, r[a.default.name] = a.default, r);
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = n(1),
	        i = n(11),
	        o = r.__importDefault(n(44)),
	        a = r.__importDefault(n(45)),
	        l = r.__importDefault(n(46)),
	        u = r.__importDefault(n(47)),
	        c = r.__importDefault(n(48)),
	        s = r.__importDefault(n(49)),
	        A = r.__importDefault(n(50)),
	        d = r.__importDefault(n(51));

	    t.FALLBACK = i.FALLBACK_INJECTED, t.WALLETCONNECT_PROVIDER = {
	      id: "walletconnect",
	      name: "WalletConnect",
	      logo: o.default,
	      type: "qrcode",
	      check: "isWalletConnect",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: ["infuraId"]
	      }
	    }, t.PORTIS_PROVIDER = {
	      id: "portis",
	      name: "Portis",
	      logo: a.default,
	      type: "web",
	      check: "isPortis",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: ["id"]
	      }
	    }, t.FORTMATIC_PROVIDER = {
	      id: "fortmatic",
	      name: "Fortmatic",
	      logo: u.default,
	      type: "web",
	      check: "isFortmatic",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: ["key"]
	      }
	    }, t.SQUARELINK_PROVIDER = {
	      id: "squarelink",
	      name: "Squarelink",
	      logo: l.default,
	      type: "web",
	      check: "isSquarelink",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: ["id"]
	      }
	    }, t.TORUS_PROVIDER = {
	      id: "torus",
	      name: "Torus",
	      logo: s.default,
	      type: "web",
	      check: "isTorus",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.ARKANE_PROVIDER = {
	      id: "arkane",
	      name: "Arkane",
	      logo: c.default,
	      type: "web",
	      check: "isArkane",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: ["clientId"]
	      }
	    }, t.AUTHEREUM_PROVIDER = {
	      id: "authereum",
	      name: "Authereum",
	      logo: A.default,
	      type: "web",
	      check: "isAuthereum",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.BURNERCONNECT_PROVIDER = {
	      id: "burnerconnect",
	      name: "Burner Connect",
	      logo: d.default,
	      type: "web",
	      check: "isBurnerProvider",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.providers = r.__spread(i.injected, [t.WALLETCONNECT_PROVIDER, t.SQUARELINK_PROVIDER, t.PORTIS_PROVIDER, t.FORTMATIC_PROVIDER, t.ARKANE_PROVIDER, t.TORUS_PROVIDER, t.AUTHEREUM_PROVIDER, t.BURNERCONNECT_PROVIDER]), r.__exportStar(n(52), t);
	  }, function (e, t, n) {

	    !function e() {
	      if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
	        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
	      } catch (e) {
	        console.error(e);
	      }
	    }(), e.exports = n(24);
	  }, function (e, t, n) {
	    e.exports = function e(t) {

	      var n = /^\0+/g,
	          r = /[\0\r\f]/g,
	          i = /: */g,
	          o = /zoo|gra/,
	          a = /([,: ])(transform)/g,
	          l = /,+\s*(?![^(]*[)])/g,
	          u = / +\s*(?![^(]*[)])/g,
	          c = / *[\0] */g,
	          s = /,\r+?/g,
	          A = /([\t\r\n ])*\f?&/g,
	          d = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
	          f = /\W+/g,
	          I = /@(k\w+)\s*(\S*)\s*/,
	          g = /::(place)/g,
	          M = /:(read-only)/g,
	          p = /\s+(?=[{\];=:>])/g,
	          N = /([[}=:>])\s+/g,
	          y = /(\{[^{]+?);(?=\})/g,
	          v = /\s{2,}/g,
	          h = /([^\(])(:+) */g,
	          j = /[svh]\w+-[tblr]{2}/,
	          m = /\(\s*(.*)\s*\)/g,
	          w = /([\s\S]*?);/g,
	          C = /-self|flex-/g,
	          b = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	          E = /stretch|:\s*\w+\-(?:conte|avail)/,
	          D = /([^-])(image-set\()/,
	          T = "-webkit-",
	          x = "-moz-",
	          S = "-ms-",
	          z = 59,
	          L = 125,
	          k = 123,
	          Q = 40,
	          O = 41,
	          P = 91,
	          B = 93,
	          U = 10,
	          Y = 13,
	          R = 9,
	          G = 64,
	          Z = 32,
	          H = 38,
	          F = 45,
	          J = 95,
	          V = 42,
	          W = 44,
	          X = 58,
	          K = 39,
	          q = 34,
	          _ = 47,
	          $ = 62,
	          ee = 43,
	          te = 126,
	          ne = 0,
	          re = 12,
	          ie = 11,
	          oe = 107,
	          ae = 109,
	          le = 115,
	          ue = 112,
	          ce = 111,
	          se = 105,
	          Ae = 99,
	          de = 100,
	          fe = 112,
	          Ie = 1,
	          ge = 1,
	          Me = 0,
	          pe = 1,
	          Ne = 1,
	          ye = 1,
	          ve = 0,
	          he = 0,
	          je = 0,
	          me = [],
	          we = [],
	          Ce = 0,
	          be = null,
	          Ee = -2,
	          De = -1,
	          Te = 0,
	          xe = 1,
	          Se = 2,
	          ze = 3,
	          Le = 0,
	          ke = 1,
	          Qe = "",
	          Oe = "",
	          Pe = "";

	      function Be(e, t, i, o, a) {
	        for (var l, u, s = 0, A = 0, d = 0, f = 0, p = 0, N = 0, y = 0, v = 0, j = 0, w = 0, C = 0, b = 0, E = 0, D = 0, J = 0, ve = 0, we = 0, be = 0, Ee = 0, De = i.length, Ye = De - 1, Je = "", Ve = "", We = "", Xe = "", Ke = "", qe = ""; J < De;) {
	          if (y = i.charCodeAt(J), J === Ye && A + f + d + s !== 0 && (0 !== A && (y = A === _ ? U : _), f = d = s = 0, De++, Ye++), A + f + d + s === 0) {
	            if (J === Ye && (ve > 0 && (Ve = Ve.replace(r, "")), Ve.trim().length > 0)) {
	              switch (y) {
	                case Z:
	                case R:
	                case z:
	                case Y:
	                case U:
	                  break;

	                default:
	                  Ve += i.charAt(J);
	              }

	              y = z;
	            }

	            if (1 === we) switch (y) {
	              case k:
	              case L:
	              case z:
	              case q:
	              case K:
	              case Q:
	              case O:
	              case W:
	                we = 0;

	              case R:
	              case Y:
	              case U:
	              case Z:
	                break;

	              default:
	                for (we = 0, Ee = J, p = y, J--, y = z; Ee < De;) switch (i.charCodeAt(Ee++)) {
	                  case U:
	                  case Y:
	                  case z:
	                    ++J, y = p, Ee = De;
	                    break;

	                  case X:
	                    ve > 0 && (++J, y = p);

	                  case k:
	                    Ee = De;
	                }

	            }

	            switch (y) {
	              case k:
	                for (p = (Ve = Ve.trim()).charCodeAt(0), C = 1, Ee = ++J; J < De;) {
	                  switch (y = i.charCodeAt(J)) {
	                    case k:
	                      C++;
	                      break;

	                    case L:
	                      C--;
	                      break;

	                    case _:
	                      switch (N = i.charCodeAt(J + 1)) {
	                        case V:
	                        case _:
	                          J = Fe(N, J, Ye, i);
	                      }

	                      break;

	                    case P:
	                      y++;

	                    case Q:
	                      y++;

	                    case q:
	                    case K:
	                      for (; J++ < Ye && i.charCodeAt(J) !== y;);

	                  }

	                  if (0 === C) break;
	                  J++;
	                }

	                switch (We = i.substring(Ee, J), p === ne && (p = (Ve = Ve.replace(n, "").trim()).charCodeAt(0)), p) {
	                  case G:
	                    switch (ve > 0 && (Ve = Ve.replace(r, "")), N = Ve.charCodeAt(1)) {
	                      case de:
	                      case ae:
	                      case le:
	                      case F:
	                        l = t;
	                        break;

	                      default:
	                        l = me;
	                    }

	                    if (Ee = (We = Be(t, l, We, N, a + 1)).length, je > 0 && 0 === Ee && (Ee = Ve.length), Ce > 0 && (l = Ue(me, Ve, be), u = He(ze, We, l, t, ge, Ie, Ee, N, a, o), Ve = l.join(""), void 0 !== u && 0 === (Ee = (We = u.trim()).length) && (N = 0, We = "")), Ee > 0) switch (N) {
	                      case le:
	                        Ve = Ve.replace(m, Ze);

	                      case de:
	                      case ae:
	                      case F:
	                        We = Ve + "{" + We + "}";
	                        break;

	                      case oe:
	                        We = (Ve = Ve.replace(I, "$1 $2" + (ke > 0 ? Qe : ""))) + "{" + We + "}", We = 1 === Ne || 2 === Ne && Ge("@" + We, 3) ? "@" + T + We + "@" + We : "@" + We;
	                        break;

	                      default:
	                        We = Ve + We, o === fe && (Xe += We, We = "");
	                    } else We = "";
	                    break;

	                  default:
	                    We = Be(t, Ue(t, Ve, be), We, o, a + 1);
	                }

	                Ke += We, b = 0, we = 0, D = 0, ve = 0, be = 0, E = 0, Ve = "", We = "", y = i.charCodeAt(++J);
	                break;

	              case L:
	              case z:
	                if ((Ee = (Ve = (ve > 0 ? Ve.replace(r, "") : Ve).trim()).length) > 1) switch (0 === D && ((p = Ve.charCodeAt(0)) === F || p > 96 && p < 123) && (Ee = (Ve = Ve.replace(" ", ":")).length), Ce > 0 && void 0 !== (u = He(xe, Ve, t, e, ge, Ie, Xe.length, o, a, o)) && 0 === (Ee = (Ve = u.trim()).length) && (Ve = "\0\0"), p = Ve.charCodeAt(0), N = Ve.charCodeAt(1), p) {
	                  case ne:
	                    break;

	                  case G:
	                    if (N === se || N === Ae) {
	                      qe += Ve + i.charAt(J);
	                      break;
	                    }

	                  default:
	                    if (Ve.charCodeAt(Ee - 1) === X) break;
	                    Xe += Re(Ve, p, N, Ve.charCodeAt(2));
	                }
	                b = 0, we = 0, D = 0, ve = 0, be = 0, Ve = "", y = i.charCodeAt(++J);
	            }
	          }

	          switch (y) {
	            case Y:
	            case U:
	              if (A + f + d + s + he === 0) switch (w) {
	                case O:
	                case K:
	                case q:
	                case G:
	                case te:
	                case $:
	                case V:
	                case ee:
	                case _:
	                case F:
	                case X:
	                case W:
	                case z:
	                case k:
	                case L:
	                  break;

	                default:
	                  D > 0 && (we = 1);
	              }
	              A === _ ? A = 0 : pe + b === 0 && o !== oe && Ve.length > 0 && (ve = 1, Ve += "\0"), Ce * Le > 0 && He(Te, Ve, t, e, ge, Ie, Xe.length, o, a, o), Ie = 1, ge++;
	              break;

	            case z:
	            case L:
	              if (A + f + d + s === 0) {
	                Ie++;
	                break;
	              }

	            default:
	              switch (Ie++, Je = i.charAt(J), y) {
	                case R:
	                case Z:
	                  if (f + s + A === 0) switch (v) {
	                    case W:
	                    case X:
	                    case R:
	                    case Z:
	                      Je = "";
	                      break;

	                    default:
	                      y !== Z && (Je = " ");
	                  }
	                  break;

	                case ne:
	                  Je = "\\0";
	                  break;

	                case re:
	                  Je = "\\f";
	                  break;

	                case ie:
	                  Je = "\\v";
	                  break;

	                case H:
	                  f + A + s === 0 && pe > 0 && (be = 1, ve = 1, Je = "\f" + Je);
	                  break;

	                case 108:
	                  if (f + A + s + Me === 0 && D > 0) switch (J - D) {
	                    case 2:
	                      v === ue && i.charCodeAt(J - 3) === X && (Me = v);

	                    case 8:
	                      j === ce && (Me = j);
	                  }
	                  break;

	                case X:
	                  f + A + s === 0 && (D = J);
	                  break;

	                case W:
	                  A + d + f + s === 0 && (ve = 1, Je += "\r");
	                  break;

	                case q:
	                case K:
	                  0 === A && (f = f === y ? 0 : 0 === f ? y : f);
	                  break;

	                case P:
	                  f + A + d === 0 && s++;
	                  break;

	                case B:
	                  f + A + d === 0 && s--;
	                  break;

	                case O:
	                  f + A + s === 0 && d--;
	                  break;

	                case Q:
	                  if (f + A + s === 0) {
	                    if (0 === b) switch (2 * v + 3 * j) {
	                      case 533:
	                        break;

	                      default:
	                        C = 0, b = 1;
	                    }
	                    d++;
	                  }

	                  break;

	                case G:
	                  A + d + f + s + D + E === 0 && (E = 1);
	                  break;

	                case V:
	                case _:
	                  if (f + s + d > 0) break;

	                  switch (A) {
	                    case 0:
	                      switch (2 * y + 3 * i.charCodeAt(J + 1)) {
	                        case 235:
	                          A = _;
	                          break;

	                        case 220:
	                          Ee = J, A = V;
	                      }

	                      break;

	                    case V:
	                      y === _ && v === V && Ee + 2 !== J && (33 === i.charCodeAt(Ee + 2) && (Xe += i.substring(Ee, J + 1)), Je = "", A = 0);
	                  }

	              }

	              if (0 === A) {
	                if (pe + f + s + E === 0 && o !== oe && y !== z) switch (y) {
	                  case W:
	                  case te:
	                  case $:
	                  case ee:
	                  case O:
	                  case Q:
	                    if (0 === b) {
	                      switch (v) {
	                        case R:
	                        case Z:
	                        case U:
	                        case Y:
	                          Je += "\0";
	                          break;

	                        default:
	                          Je = "\0" + Je + (y === W ? "" : "\0");
	                      }

	                      ve = 1;
	                    } else switch (y) {
	                      case Q:
	                        D + 7 === J && 108 === v && (D = 0), b = ++C;
	                        break;

	                      case O:
	                        0 == (b = --C) && (ve = 1, Je += "\0");
	                    }

	                    break;

	                  case R:
	                  case Z:
	                    switch (v) {
	                      case ne:
	                      case k:
	                      case L:
	                      case z:
	                      case W:
	                      case re:
	                      case R:
	                      case Z:
	                      case U:
	                      case Y:
	                        break;

	                      default:
	                        0 === b && (ve = 1, Je += "\0");
	                    }

	                }
	                Ve += Je, y !== Z && y !== R && (w = y);
	              }

	          }

	          j = v, v = y, J++;
	        }

	        if (Ee = Xe.length, je > 0 && 0 === Ee && 0 === Ke.length && 0 === t[0].length == 0 && (o !== ae || 1 === t.length && (pe > 0 ? Oe : Pe) === t[0]) && (Ee = t.join(",").length + 2), Ee > 0) {
	          if (l = 0 === pe && o !== oe ? function (e) {
	            for (var t, n, i = 0, o = e.length, a = Array(o); i < o; ++i) {
	              for (var l = e[i].split(c), u = "", s = 0, A = 0, d = 0, f = 0, I = l.length; s < I; ++s) if (!(0 === (A = (n = l[s]).length) && I > 1)) {
	                if (d = u.charCodeAt(u.length - 1), f = n.charCodeAt(0), t = "", 0 !== s) switch (d) {
	                  case V:
	                  case te:
	                  case $:
	                  case ee:
	                  case Z:
	                  case Q:
	                    break;

	                  default:
	                    t = " ";
	                }

	                switch (f) {
	                  case H:
	                    n = t + Oe;

	                  case te:
	                  case $:
	                  case ee:
	                  case Z:
	                  case O:
	                  case Q:
	                    break;

	                  case P:
	                    n = t + n + Oe;
	                    break;

	                  case X:
	                    switch (2 * n.charCodeAt(1) + 3 * n.charCodeAt(2)) {
	                      case 530:
	                        if (ye > 0) {
	                          n = t + n.substring(8, A - 1);
	                          break;
	                        }

	                      default:
	                        (s < 1 || l[s - 1].length < 1) && (n = t + Oe + n);
	                    }

	                    break;

	                  case W:
	                    t = "";

	                  default:
	                    n = A > 1 && n.indexOf(":") > 0 ? t + n.replace(h, "$1" + Oe + "$2") : t + n + Oe;
	                }

	                u += n;
	              }

	              a[i] = u.replace(r, "").trim();
	            }

	            return a;
	          }(t) : t, Ce > 0 && void 0 !== (u = He(Se, Xe, l, e, ge, Ie, Ee, o, a, o)) && 0 === (Xe = u).length) return qe + Xe + Ke;

	          if (Xe = l.join(",") + "{" + Xe + "}", Ne * Me != 0) {
	            switch (2 !== Ne || Ge(Xe, 2) || (Me = 0), Me) {
	              case ce:
	                Xe = Xe.replace(M, ":" + x + "$1") + Xe;
	                break;

	              case ue:
	                Xe = Xe.replace(g, "::" + T + "input-$1") + Xe.replace(g, "::" + x + "$1") + Xe.replace(g, ":" + S + "input-$1") + Xe;
	            }

	            Me = 0;
	          }
	        }

	        return qe + Xe + Ke;
	      }

	      function Ue(e, t, n) {
	        var r = t.trim().split(s),
	            i = r,
	            o = r.length,
	            a = e.length;

	        switch (a) {
	          case 0:
	          case 1:
	            for (var l = 0, u = 0 === a ? "" : e[0] + " "; l < o; ++l) i[l] = Ye(u, i[l], n, a).trim();

	            break;

	          default:
	            l = 0;
	            var c = 0;

	            for (i = []; l < o; ++l) for (var A = 0; A < a; ++A) i[c++] = Ye(e[A] + " ", r[l], n, a).trim();

	        }

	        return i;
	      }

	      function Ye(e, t, n, r) {
	        var i = t,
	            o = i.charCodeAt(0);

	        switch (o < 33 && (o = (i = i.trim()).charCodeAt(0)), o) {
	          case H:
	            switch (pe + r) {
	              case 0:
	              case 1:
	                if (0 === e.trim().length) break;

	              default:
	                return i.replace(A, "$1" + e.trim());
	            }

	            break;

	          case X:
	            switch (i.charCodeAt(1)) {
	              case 103:
	                if (ye > 0 && pe > 0) return i.replace(d, "$1").replace(A, "$1" + Pe);
	                break;

	              default:
	                return e.trim() + i.replace(A, "$1" + e.trim());
	            }

	          default:
	            if (n * pe > 0 && i.indexOf("\f") > 0) return i.replace(A, (e.charCodeAt(0) === X ? "" : "$1") + e.trim());
	        }

	        return e + i;
	      }

	      function Re(e, t, n, r) {
	        var c,
	            s = 0,
	            A = e + ";",
	            d = 2 * t + 3 * n + 4 * r;
	        if (944 === d) return function (e) {
	          var t = e.length,
	              n = e.indexOf(":", 9) + 1,
	              r = e.substring(0, n).trim(),
	              i = e.substring(n, t - 1).trim();

	          switch (e.charCodeAt(9) * ke) {
	            case 0:
	              break;

	            case F:
	              if (110 !== e.charCodeAt(10)) break;

	            default:
	              for (var o = i.split((i = "", l)), a = 0, n = 0, t = o.length; a < t; n = 0, ++a) {
	                for (var c = o[a], s = c.split(u); c = s[n];) {
	                  var A = c.charCodeAt(0);
	                  if (1 === ke && (A > G && A < 90 || A > 96 && A < 123 || A === J || A === F && c.charCodeAt(1) !== F)) switch (isNaN(parseFloat(c)) + (-1 !== c.indexOf("("))) {
	                    case 1:
	                      switch (c) {
	                        case "infinite":
	                        case "alternate":
	                        case "backwards":
	                        case "running":
	                        case "normal":
	                        case "forwards":
	                        case "both":
	                        case "none":
	                        case "linear":
	                        case "ease":
	                        case "ease-in":
	                        case "ease-out":
	                        case "ease-in-out":
	                        case "paused":
	                        case "reverse":
	                        case "alternate-reverse":
	                        case "inherit":
	                        case "initial":
	                        case "unset":
	                        case "step-start":
	                        case "step-end":
	                          break;

	                        default:
	                          c += Qe;
	                      }

	                  }
	                  s[n++] = c;
	                }

	                i += (0 === a ? "" : ",") + s.join(" ");
	              }

	          }

	          return i = r + i + ";", 1 === Ne || 2 === Ne && Ge(i, 1) ? T + i + i : i;
	        }(A);
	        if (0 === Ne || 2 === Ne && !Ge(A, 1)) return A;

	        switch (d) {
	          case 1015:
	            return 97 === A.charCodeAt(10) ? T + A + A : A;

	          case 951:
	            return 116 === A.charCodeAt(3) ? T + A + A : A;

	          case 963:
	            return 110 === A.charCodeAt(5) ? T + A + A : A;

	          case 1009:
	            if (100 !== A.charCodeAt(4)) break;

	          case 969:
	          case 942:
	            return T + A + A;

	          case 978:
	            return T + A + x + A + A;

	          case 1019:
	          case 983:
	            return T + A + x + A + S + A + A;

	          case 883:
	            return A.charCodeAt(8) === F ? T + A + A : A.indexOf("image-set(", 11) > 0 ? A.replace(D, "$1" + T + "$2") + A : A;

	          case 932:
	            if (A.charCodeAt(4) === F) switch (A.charCodeAt(5)) {
	              case 103:
	                return T + "box-" + A.replace("-grow", "") + T + A + S + A.replace("grow", "positive") + A;

	              case 115:
	                return T + A + S + A.replace("shrink", "negative") + A;

	              case 98:
	                return T + A + S + A.replace("basis", "preferred-size") + A;
	            }
	            return T + A + S + A + A;

	          case 964:
	            return T + A + S + "flex-" + A + A;

	          case 1023:
	            if (99 !== A.charCodeAt(8)) break;
	            return c = A.substring(A.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), T + "box-pack" + c + T + A + S + "flex-pack" + c + A;

	          case 1005:
	            return o.test(A) ? A.replace(i, ":" + T) + A.replace(i, ":" + x) + A : A;

	          case 1e3:
	            switch (s = (c = A.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(s)) {
	              case 226:
	                c = A.replace(j, "tb");
	                break;

	              case 232:
	                c = A.replace(j, "tb-rl");
	                break;

	              case 220:
	                c = A.replace(j, "lr");
	                break;

	              default:
	                return A;
	            }

	            return T + A + S + c + A;

	          case 1017:
	            if (-1 === A.indexOf("sticky", 9)) return A;

	          case 975:
	            switch (s = (A = e).length - 10, d = (c = (33 === A.charCodeAt(s) ? A.substring(0, s) : A).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
	              case 203:
	                if (c.charCodeAt(8) < 111) break;

	              case 115:
	                A = A.replace(c, T + c) + ";" + A;
	                break;

	              case 207:
	              case 102:
	                A = A.replace(c, T + (d > 102 ? "inline-" : "") + "box") + ";" + A.replace(c, T + c) + ";" + A.replace(c, S + c + "box") + ";" + A;
	            }

	            return A + ";";

	          case 938:
	            if (A.charCodeAt(5) === F) switch (A.charCodeAt(6)) {
	              case 105:
	                return c = A.replace("-items", ""), T + A + T + "box-" + c + S + "flex-" + c + A;

	              case 115:
	                return T + A + S + "flex-item-" + A.replace(C, "") + A;

	              default:
	                return T + A + S + "flex-line-pack" + A.replace("align-content", "").replace(C, "") + A;
	            }
	            break;

	          case 973:
	          case 989:
	            if (A.charCodeAt(3) !== F || 122 === A.charCodeAt(4)) break;

	          case 931:
	          case 953:
	            if (!0 === E.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? Re(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : A.replace(c, T + c) + A.replace(c, x + c.replace("fill-", "")) + A;
	            break;

	          case 962:
	            if (A = T + A + (102 === A.charCodeAt(5) ? S + A : "") + A, n + r === 211 && 105 === A.charCodeAt(13) && A.indexOf("transform", 10) > 0) return A.substring(0, A.indexOf(";", 27) + 1).replace(a, "$1" + T + "$2") + A;
	        }

	        return A;
	      }

	      function Ge(e, t) {
	        var n = e.indexOf(1 === t ? ":" : "{"),
	            r = e.substring(0, 3 !== t ? n : 10),
	            i = e.substring(n + 1, e.length - 1);
	        return be(2 !== t ? r : r.replace(b, "$1"), i, t);
	      }

	      function Ze(e, t) {
	        var n = Re(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
	        return n !== t + ";" ? n.replace(w, " or ($1)").substring(4) : "(" + t + ")";
	      }

	      function He(e, t, n, r, i, o, a, l, u, c) {
	        for (var s, A = 0, d = t; A < Ce; ++A) switch (s = we[A].call(Ve, e, d, n, r, i, o, a, l, u, c)) {
	          case void 0:
	          case !1:
	          case !0:
	          case null:
	            break;

	          default:
	            d = s;
	        }

	        if (d !== t) return d;
	      }

	      function Fe(e, t, n, r) {
	        for (var i = t + 1; i < n; ++i) switch (r.charCodeAt(i)) {
	          case _:
	            if (e === V && r.charCodeAt(i - 1) === V && t + 2 !== i) return i + 1;
	            break;

	          case U:
	            if (e === _) return i + 1;
	        }

	        return i;
	      }

	      function Je(e) {
	        for (var t in e) {
	          var n = e[t];

	          switch (t) {
	            case "keyframe":
	              ke = 0 | n;
	              break;

	            case "global":
	              ye = 0 | n;
	              break;

	            case "cascade":
	              pe = 0 | n;
	              break;

	            case "compress":
	              ve = 0 | n;
	              break;

	            case "semicolon":
	              he = 0 | n;
	              break;

	            case "preserve":
	              je = 0 | n;
	              break;

	            case "prefix":
	              be = null, n ? "function" != typeof n ? Ne = 1 : (Ne = 2, be = n) : Ne = 0;
	          }
	        }

	        return Je;
	      }

	      function Ve(t, n) {
	        if (void 0 !== this && this.constructor === Ve) return e(t);
	        var i = t,
	            o = i.charCodeAt(0);
	        o < 33 && (o = (i = i.trim()).charCodeAt(0)), ke > 0 && (Qe = i.replace(f, o === P ? "" : "-")), o = 1, 1 === pe ? Pe = i : Oe = i;
	        var a,
	            l = [Pe];
	        Ce > 0 && void 0 !== (a = He(De, n, l, l, ge, Ie, 0, 0, 0, 0)) && "string" == typeof a && (n = a);
	        var u = Be(me, l, n, 0, 0);
	        return Ce > 0 && void 0 !== (a = He(Ee, u, l, l, ge, Ie, u.length, 0, 0, 0)) && "string" != typeof (u = a) && (o = 0), Qe = "", Pe = "", Oe = "", Me = 0, ge = 1, Ie = 1, ve * o == 0 ? u : u.replace(r, "").replace(p, "").replace(N, "$1").replace(y, "$1").replace(v, " ");
	      }

	      return Ve.use = function e(t) {
	        switch (t) {
	          case void 0:
	          case null:
	            Ce = we.length = 0;
	            break;

	          default:
	            if ("function" == typeof t) we[Ce++] = t;else if ("object" == typeof t) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else Le = 0 | !!t;
	        }

	        return e;
	      }, Ve.set = Je, void 0 !== t && Je(t), Ve;
	    }(null);
	  }, function (e, t, n) {

	    e.exports = n(67);
	  }, function (e, t, n) {

	    function r(e, t) {
	      if (e.length !== t.length) return !1;

	      for (var n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;

	      return !0;
	    }

	    t.a = function (e, t) {
	      var n;
	      void 0 === t && (t = r);
	      var i,
	          o = [],
	          a = !1;
	      return function () {
	        for (var r = [], l = 0; l < arguments.length; l++) r[l] = arguments[l];

	        return a && n === this && t(r, o) ? i : (i = e.apply(this, r), a = !0, n = this, o = r, i);
	      };
	    };
	  }, function (e, t, n) {
	    /*
	    object-assign
	    (c) Sindre Sorhus
	    @license MIT
	    */

	    var r = Object.getOwnPropertySymbols,
	        i = Object.prototype.hasOwnProperty,
	        o = Object.prototype.propertyIsEnumerable;
	    e.exports = function () {
	      try {
	        if (!Object.assign) return !1;
	        var e = new String("abc");
	        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

	        for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;

	        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
	          return t[e];
	        }).join("")) return !1;
	        var r = {};
	        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
	          r[e] = e;
	        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
	      } catch (e) {
	        return !1;
	      }
	    }() ? Object.assign : function (e, t) {
	      for (var n, a, l = function (e) {
	        if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
	        return Object(e);
	      }(e), u = 1; u < arguments.length; u++) {
	        for (var c in n = Object(arguments[u])) i.call(n, c) && (l[c] = n[c]);

	        if (r) {
	          a = r(n);

	          for (var s = 0; s < a.length; s++) o.call(n, a[s]) && (l[a[s]] = n[a[s]]);
	        }
	      }

	      return l;
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    }), t.EMPTY_CHAIN_DATA = {
	      chainId: 0,
	      chain: "",
	      network: "",
	      networkId: 0
	    }, t.chainList = {
	      1: {
	        chainId: 1,
	        chain: "ETH",
	        network: "mainnet",
	        networkId: 1
	      },
	      2: {
	        chainId: 2,
	        chain: "EXP",
	        network: "mainnet",
	        networkId: 1
	      },
	      3: {
	        chainId: 3,
	        chain: "ETH",
	        network: "ropsten",
	        networkId: 3
	      },
	      4: {
	        chainId: 4,
	        chain: "ETH",
	        network: "rinkeby",
	        networkId: 4
	      },
	      5: {
	        chainId: 5,
	        chain: "ETH",
	        network: "goerli",
	        networkId: 5
	      },
	      6: {
	        chainId: 6,
	        chain: "ETC",
	        network: "kotti",
	        networkId: 6
	      },
	      8: {
	        chainId: 8,
	        chain: "UBQ",
	        network: "mainnet",
	        networkId: 88
	      },
	      9: {
	        chainId: 9,
	        chain: "UBQ",
	        network: "mainnet",
	        networkId: 2
	      },
	      11: {
	        chainId: 11,
	        chain: "META",
	        network: "mainnet",
	        networkId: 11
	      },
	      12: {
	        chainId: 12,
	        chain: "META",
	        network: "testnet",
	        networkId: 12
	      },
	      18: {
	        chainId: 18,
	        chain: "TST",
	        network: "testnet",
	        networkId: 18
	      },
	      30: {
	        chainId: 30,
	        chain: "RSK",
	        network: "mainnet",
	        networkId: 30
	      },
	      31: {
	        chainId: 31,
	        chain: "RSK",
	        network: "testnet",
	        networkId: 31
	      },
	      42: {
	        chainId: 42,
	        chain: "ETH",
	        network: "kovan",
	        networkId: 42
	      },
	      60: {
	        chainId: 60,
	        chain: "GO",
	        network: "mainnet",
	        networkId: 60
	      },
	      61: {
	        chainId: 61,
	        chain: "ETC",
	        network: "mainnet",
	        networkId: 1
	      },
	      62: {
	        chainId: 62,
	        chain: "ETC",
	        network: "testnet",
	        networkId: 2
	      },
	      63: {
	        chainId: 63,
	        chain: "ETC",
	        network: "testnet",
	        networkId: 7
	      },
	      64: {
	        chainId: 64,
	        chain: "ELLA",
	        network: "mainnet",
	        networkId: 64
	      },
	      76: {
	        chainId: 76,
	        chain: "MIX",
	        network: "mainnet",
	        networkId: 76
	      },
	      77: {
	        chainId: 77,
	        chain: "POA",
	        network: "sokol",
	        networkId: 77
	      },
	      88: {
	        chainId: 88,
	        chain: "TOMO",
	        network: "mainnet",
	        networkId: 88
	      },
	      99: {
	        chainId: 99,
	        chain: "POA",
	        network: "core",
	        networkId: 99
	      },
	      100: {
	        chainId: 100,
	        chain: "XDAI",
	        network: "mainnet",
	        networkId: 100
	      },
	      101: {
	        chainId: 101,
	        chain: "ETI",
	        network: "mainnet",
	        networkId: 1
	      },
	      108: {
	        chainId: 108,
	        chain: "TT",
	        network: "mainnet",
	        networkId: 108
	      },
	      162: {
	        chainId: 162,
	        chain: "PHT",
	        network: "sirius",
	        networkId: 162
	      },
	      163: {
	        chainId: 163,
	        chain: "PHT",
	        network: "mainnet",
	        networkId: 163
	      },
	      211: {
	        chainId: 211,
	        chain: "FTN",
	        network: "freight",
	        networkId: 0
	      },
	      269: {
	        chainId: 269,
	        chain: "HPB",
	        network: "mainnet",
	        networkId: 100
	      },
	      385: {
	        chainId: 385,
	        chain: "CRO",
	        network: "mainnet",
	        networkId: 385
	      },
	      820: {
	        chainId: 820,
	        chain: "CLO",
	        network: "mainnet",
	        networkId: 1
	      },
	      821: {
	        chainId: 821,
	        chain: "CLO",
	        network: "testnet",
	        networkId: 2
	      }
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = n(1),
	        i = r.__importDefault(n(32)),
	        o = r.__importDefault(n(33)),
	        a = r.__importDefault(n(34)),
	        l = r.__importDefault(n(35)),
	        u = r.__importDefault(n(36)),
	        c = r.__importDefault(n(37)),
	        s = r.__importDefault(n(38)),
	        A = r.__importDefault(n(39)),
	        d = r.__importDefault(n(40)),
	        f = r.__importDefault(n(41)),
	        I = r.__importDefault(n(42)),
	        g = r.__importDefault(n(43));

	    t.FALLBACK_INJECTED = {
	      id: "injected",
	      name: "Web3",
	      logo: i.default,
	      type: "injected",
	      check: "isWeb3",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.METAMASK_INJECTED = {
	      id: "injected",
	      name: "MetaMask",
	      logo: o.default,
	      type: "injected",
	      check: "isMetaMask",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.SAFE_INJECTED = {
	      id: "injected",
	      name: "Safe",
	      logo: a.default,
	      type: "injected",
	      check: "isSafe",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.NIFTY_INJECTED = {
	      id: "injected",
	      name: "Nifty",
	      logo: l.default,
	      type: "injected",
	      check: "isNiftyWallet",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.DAPPER_INJECTED = {
	      id: "injected",
	      name: "Dapper",
	      logo: c.default,
	      type: "injected",
	      check: "isDapper",
	      styled: {
	        noShadow: !0
	      },
	      package: {
	        required: []
	      }
	    }, t.OPERA_INJECTED = {
	      id: "injected",
	      name: "Opera",
	      logo: g.default,
	      type: "injected",
	      check: "isOpera",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.TRUST_INJECTED = {
	      id: "injected",
	      name: "Trust",
	      logo: u.default,
	      type: "injected",
	      check: "isTrust",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.COINBASE_INJECTED = {
	      id: "injected",
	      name: "Coinbase",
	      logo: s.default,
	      type: "injected",
	      check: "isToshi",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.CIPHER_INJECTED = {
	      id: "injected",
	      name: "Cipher",
	      logo: A.default,
	      type: "injected",
	      check: "isCipher",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.IMTOKEN_INJECTED = {
	      id: "injected",
	      name: "imToken",
	      logo: d.default,
	      type: "injected",
	      check: "isImToken",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.STATUS_INJECTED = {
	      id: "injected",
	      name: "Status",
	      logo: f.default,
	      type: "injected",
	      check: "isStatus",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.TOKENARY_INJECTED = {
	      id: "injected",
	      name: "Tokenary",
	      logo: I.default,
	      type: "injected",
	      check: "isTokenary",
	      styled: {
	        noShadow: !1
	      },
	      package: {
	        required: []
	      }
	    }, t.injected = [t.FALLBACK_INJECTED, t.METAMASK_INJECTED, t.SAFE_INJECTED, t.NIFTY_INJECTED, t.DAPPER_INJECTED, t.OPERA_INJECTED, t.TRUST_INJECTED, t.COINBASE_INJECTED, t.CIPHER_INJECTED, t.IMTOKEN_INJECTED, t.STATUS_INJECTED, t.TOKENARY_INJECTED];
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);
	    r.__exportStar(n(62), t), r.__exportStar(n(15), t);
	  }, function (e, t, n) {
	    e.exports = n(63)();
	  }, function (e, t, n) {

	    n.r(t), function (e, r) {
	      n.d(t, "createGlobalStyle", function () {
	        return ot;
	      }), n.d(t, "css", function () {
	        return ye;
	      }), n.d(t, "isStyledComponent", function () {
	        return E;
	      }), n.d(t, "keyframes", function () {
	        return lt;
	      }), n.d(t, "ServerStyleSheet", function () {
	        return Ke;
	      }), n.d(t, "StyleSheetConsumer", function () {
	        return _e;
	      }), n.d(t, "StyleSheetContext", function () {
	        return qe;
	      }), n.d(t, "StyleSheetManager", function () {
	        return $e;
	      }), n.d(t, "ThemeConsumer", function () {
	        return We;
	      }), n.d(t, "ThemeContext", function () {
	        return Ve;
	      }), n.d(t, "ThemeProvider", function () {
	        return Xe;
	      }), n.d(t, "withTheme", function () {
	        return ut;
	      }), n.d(t, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function () {
	        return ct;
	      });

	      var i = n(6),
	          o = n.n(i),
	          a = n(18),
	          l = n.n(a),
	          u = n(0),
	          c = n.n(u),
	          s = n(19),
	          A = n(7),
	          d = n(8),
	          f = (n(13), n(5), n(20)),
	          I = function (e, t) {
	        for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1]);

	        return n;
	      },
	          g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
	        return typeof e;
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	      },
	          M = function (e, t) {
	        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	      },
	          p = function () {
	        function e(e, t) {
	          for (var n = 0; n < t.length; n++) {
	            var r = t[n];
	            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
	          }
	        }

	        return function (t, n, r) {
	          return n && e(t.prototype, n), r && e(t, r), t;
	        };
	      }(),
	          N = Object.assign || function (e) {
	        for (var t = 1; t < arguments.length; t++) {
	          var n = arguments[t];

	          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
	        }

	        return e;
	      },
	          y = function (e, t) {
	        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
	        e.prototype = Object.create(t && t.prototype, {
	          constructor: {
	            value: e,
	            enumerable: !1,
	            writable: !0,
	            configurable: !0
	          }
	        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
	      },
	          v = function (e, t) {
	        var n = {};

	        for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);

	        return n;
	      },
	          h = function (e, t) {
	        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        return !t || "object" != typeof t && "function" != typeof t ? e : t;
	      },
	          j = function (e) {
	        return "object" === (void 0 === e ? "undefined" : g(e)) && e.constructor === Object;
	      },
	          m = Object.freeze([]),
	          w = Object.freeze({});

	      function C(e) {
	        return "function" == typeof e;
	      }

	      function b(e) {
	        return e.displayName || e.name || "Component";
	      }

	      function E(e) {
	        return e && "string" == typeof e.styledComponentId;
	      }

	      var D = void 0 !== e && e.env.SC_ATTR || "data-styled",
	          T = "undefined" != typeof window && "HTMLElement" in window,
	          x = "boolean" == typeof SC_DISABLE_SPEEDY && SC_DISABLE_SPEEDY || !1,
	          S = {};

	      var z = function (e) {
	        function t(n) {
	          M(this, t);

	          for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];

	          var a = h(this, e.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + n + " for more information. " + (i ? "Additional arguments: " + i.join(", ") : "")));
	          return h(a);
	        }

	        return y(t, e), t;
	      }(Error),
	          L = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm,
	          k = function (e) {
	        var t = "" + (e || ""),
	            n = [];
	        return t.replace(L, function (e, t, r) {
	          return n.push({
	            componentId: t,
	            matchIndex: r
	          }), e;
	        }), n.map(function (e, r) {
	          var i = e.componentId,
	              o = e.matchIndex,
	              a = n[r + 1];
	          return {
	            componentId: i,
	            cssFromDOM: a ? t.slice(o, a.matchIndex) : t.slice(o)
	          };
	        });
	      },
	          Q = /^\s*\/\/.*$/gm,
	          O = new o.a({
	        global: !1,
	        cascade: !0,
	        keyframe: !1,
	        prefix: !1,
	        compress: !1,
	        semicolon: !0
	      }),
	          P = new o.a({
	        global: !1,
	        cascade: !0,
	        keyframe: !1,
	        prefix: !0,
	        compress: !1,
	        semicolon: !1
	      }),
	          B = [],
	          U = function (e) {
	        if (-2 === e) {
	          var t = B;
	          return B = [], t;
	        }
	      },
	          Y = l()(function (e) {
	        B.push(e);
	      }),
	          R = void 0,
	          G = void 0,
	          Z = void 0,
	          H = function (e, t, n) {
	        return t > 0 && -1 !== n.slice(0, t).indexOf(G) && n.slice(t - G.length, t) !== G ? "." + R : e;
	      };

	      P.use([function (e, t, n) {
	        2 === e && n.length && n[0].lastIndexOf(G) > 0 && (n[0] = n[0].replace(Z, H));
	      }, Y, U]), O.use([Y, U]);

	      var F = function (e) {
	        return O("", e);
	      };

	      function J(e, t, n) {
	        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "&",
	            i = e.join("").replace(Q, ""),
	            o = t && n ? n + " " + t + " { " + i + " }" : i;
	        return R = r, G = t, Z = new RegExp("\\" + G + "\\b", "g"), P(n || !t ? "" : t, o);
	      }

	      var V = function () {
	        return n.nc;
	      },
	          W = function (e, t, n) {
	        n && ((e[t] || (e[t] = Object.create(null)))[n] = !0);
	      },
	          X = function (e, t) {
	        e[t] = Object.create(null);
	      },
	          K = function (e) {
	        return function (t, n) {
	          return void 0 !== e[t] && e[t][n];
	        };
	      },
	          q = function (e) {
	        var t = "";

	        for (var n in e) t += Object.keys(e[n]).join(" ") + " ";

	        return t.trim();
	      },
	          _ = function (e) {
	        if (e.sheet) return e.sheet;

	        for (var t = document.styleSheets.length, n = 0; n < t; n += 1) {
	          var r = document.styleSheets[n];
	          if (r.ownerNode === e) return r;
	        }

	        throw new z(10);
	      },
	          $ = function (e, t, n) {
	        if (!t) return !1;
	        var r = e.cssRules.length;

	        try {
	          e.insertRule(t, n <= r ? n : r);
	        } catch (e) {
	          return !1;
	        }

	        return !0;
	      },
	          ee = function (e) {
	        return "\n/* sc-component-id: " + e + " */\n";
	      },
	          te = function (e, t) {
	        for (var n = 0, r = 0; r <= t; r += 1) n += e[r];

	        return n;
	      },
	          ne = function (e, t) {
	        return function (n) {
	          var r = V();
	          return "<style " + [r && 'nonce="' + r + '"', D + '="' + q(t) + '"', 'data-styled-version="4.2.0"', n].filter(Boolean).join(" ") + ">" + e() + "</style>";
	        };
	      },
	          re = function (e, t) {
	        return function () {
	          var n,
	              r = ((n = {})[D] = q(t), n["data-styled-version"] = "4.2.0", n),
	              i = V();
	          return i && (r.nonce = i), c.a.createElement("style", N({}, r, {
	            dangerouslySetInnerHTML: {
	              __html: e()
	            }
	          }));
	        };
	      },
	          ie = function (e) {
	        return function () {
	          return Object.keys(e);
	        };
	      },
	          oe = function (e) {
	        return document.createTextNode(ee(e));
	      },
	          ae = function e(t, n) {
	        var r = void 0 === t ? Object.create(null) : t,
	            i = void 0 === n ? Object.create(null) : n,
	            o = function (e) {
	          var t = i[e];
	          return void 0 !== t ? t : i[e] = [""];
	        },
	            a = function () {
	          var e = "";

	          for (var t in i) {
	            var n = i[t][0];
	            n && (e += ee(t) + n);
	          }

	          return e;
	        };

	        return {
	          clone: function () {
	            var t = function (e) {
	              var t = Object.create(null);

	              for (var n in e) t[n] = N({}, e[n]);

	              return t;
	            }(r),
	                n = Object.create(null);

	            for (var o in i) n[o] = [i[o][0]];

	            return e(t, n);
	          },
	          css: a,
	          getIds: ie(i),
	          hasNameForId: K(r),
	          insertMarker: o,
	          insertRules: function (e, t, n) {
	            o(e)[0] += t.join(" "), W(r, e, n);
	          },
	          removeRules: function (e) {
	            var t = i[e];
	            void 0 !== t && (t[0] = "", X(r, e));
	          },
	          sealed: !1,
	          styleTag: null,
	          toElement: re(a, r),
	          toHTML: ne(a, r)
	        };
	      },
	          le = function (e, t, n, r, i) {
	        if (T && !n) {
	          var o = function (e, t, n) {
	            var r = document.createElement("style");
	            r.setAttribute(D, ""), r.setAttribute("data-styled-version", "4.2.0");
	            var i = V();
	            if (i && r.setAttribute("nonce", i), r.appendChild(document.createTextNode("")), e && !t) e.appendChild(r);else {
	              if (!t || !e || !t.parentNode) throw new z(6);
	              t.parentNode.insertBefore(r, n ? t : t.nextSibling);
	            }
	            return r;
	          }(e, t, r);

	          return x ? function (e, t) {
	            var n = Object.create(null),
	                r = Object.create(null),
	                i = void 0 !== t,
	                o = !1,
	                a = function (t) {
	              var i = r[t];
	              return void 0 !== i ? i : (r[t] = oe(t), e.appendChild(r[t]), n[t] = Object.create(null), r[t]);
	            },
	                l = function () {
	              var e = "";

	              for (var t in r) e += r[t].data;

	              return e;
	            };

	            return {
	              clone: function () {
	                throw new z(5);
	              },
	              css: l,
	              getIds: ie(r),
	              hasNameForId: K(n),
	              insertMarker: a,
	              insertRules: function (e, r, l) {
	                for (var u = a(e), c = [], s = r.length, A = 0; A < s; A += 1) {
	                  var d = r[A],
	                      f = i;
	                  if (f && -1 !== d.indexOf("@import")) c.push(d);else {
	                    f = !1;
	                    var I = A === s - 1 ? "" : " ";
	                    u.appendData("" + d + I);
	                  }
	                }

	                W(n, e, l), i && c.length > 0 && (o = !0, t().insertRules(e + "-import", c));
	              },
	              removeRules: function (a) {
	                var l = r[a];

	                if (void 0 !== l) {
	                  var u = oe(a);
	                  e.replaceChild(u, l), r[a] = u, X(n, a), i && o && t().removeRules(a + "-import");
	                }
	              },
	              sealed: !1,
	              styleTag: e,
	              toElement: re(l, n),
	              toHTML: ne(l, n)
	            };
	          }(o, i) : function (e, t) {
	            var n = Object.create(null),
	                r = Object.create(null),
	                i = [],
	                o = void 0 !== t,
	                a = !1,
	                l = function (e) {
	              var t = r[e];
	              return void 0 !== t ? t : (r[e] = i.length, i.push(0), X(n, e), r[e]);
	            },
	                u = function () {
	              var t = _(e).cssRules,
	                  n = "";

	              for (var o in r) {
	                n += ee(o);

	                for (var a = r[o], l = te(i, a), u = l - i[a]; u < l; u += 1) {
	                  var c = t[u];
	                  void 0 !== c && (n += c.cssText);
	                }
	              }

	              return n;
	            };

	            return {
	              clone: function () {
	                throw new z(5);
	              },
	              css: u,
	              getIds: ie(r),
	              hasNameForId: K(n),
	              insertMarker: l,
	              insertRules: function (r, u, c) {
	                for (var s = l(r), A = _(e), d = te(i, s), f = 0, I = [], g = u.length, M = 0; M < g; M += 1) {
	                  var p = u[M],
	                      N = o;
	                  N && -1 !== p.indexOf("@import") ? I.push(p) : $(A, p, d + f) && (N = !1, f += 1);
	                }

	                o && I.length > 0 && (a = !0, t().insertRules(r + "-import", I)), i[s] += f, W(n, r, c);
	              },
	              removeRules: function (l) {
	                var u = r[l];

	                if (void 0 !== u) {
	                  var c = i[u];
	                  !function (e, t, n) {
	                    for (var r = t - n, i = t; i > r; i -= 1) e.deleteRule(i);
	                  }(_(e), te(i, u) - 1, c), i[u] = 0, X(n, l), o && a && t().removeRules(l + "-import");
	                }
	              },
	              sealed: !1,
	              styleTag: e,
	              toElement: re(u, n),
	              toHTML: ne(u, n)
	            };
	          }(o, i);
	        }

	        return ae();
	      },
	          ue = /\s+/,
	          ce = void 0;

	      ce = T ? x ? 40 : 1e3 : -1;

	      var se = 0,
	          Ae = void 0,
	          de = function () {
	        function e() {
	          var t = this,
	              n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : T ? document.head : null,
	              r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
	          M(this, e), this.getImportRuleTag = function () {
	            var e = t.importRuleTag;
	            if (void 0 !== e) return e;
	            var n = t.tags[0];
	            return t.importRuleTag = le(t.target, n ? n.styleTag : null, t.forceServer, !0);
	          }, se += 1, this.id = se, this.forceServer = r, this.target = r ? null : n, this.tagMap = {}, this.deferred = {}, this.rehydratedNames = {}, this.ignoreRehydratedNames = {}, this.tags = [], this.capacity = 1, this.clones = [];
	        }

	        return e.prototype.rehydrate = function () {
	          if (!T || this.forceServer) return this;
	          var e = [],
	              t = [],
	              n = !1,
	              r = document.querySelectorAll("style[" + D + '][data-styled-version="4.2.0"]'),
	              i = r.length;
	          if (!i) return this;

	          for (var o = 0; o < i; o += 1) {
	            var a = r[o];
	            n || (n = !!a.getAttribute("data-styled-streamed"));

	            for (var l, u = (a.getAttribute(D) || "").trim().split(ue), c = u.length, s = 0; s < c; s += 1) l = u[s], this.rehydratedNames[l] = !0;

	            t.push.apply(t, k(a.textContent)), e.push(a);
	          }

	          var A = t.length;
	          if (!A) return this;
	          var d = this.makeTag(null);
	          !function (e, t, n) {
	            for (var r = 0, i = n.length; r < i; r += 1) {
	              var o = n[r],
	                  a = o.componentId,
	                  l = o.cssFromDOM,
	                  u = F(l);
	              e.insertRules(a, u);
	            }

	            for (var c = 0, s = t.length; c < s; c += 1) {
	              var A = t[c];
	              A.parentNode && A.parentNode.removeChild(A);
	            }
	          }(d, e, t), this.capacity = Math.max(1, ce - A), this.tags.push(d);

	          for (var f = 0; f < A; f += 1) this.tagMap[t[f].componentId] = d;

	          return this;
	        }, e.reset = function () {
	          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
	          Ae = new e(void 0, t).rehydrate();
	        }, e.prototype.clone = function () {
	          var t = new e(this.target, this.forceServer);
	          return this.clones.push(t), t.tags = this.tags.map(function (e) {
	            for (var n = e.getIds(), r = e.clone(), i = 0; i < n.length; i += 1) t.tagMap[n[i]] = r;

	            return r;
	          }), t.rehydratedNames = N({}, this.rehydratedNames), t.deferred = N({}, this.deferred), t;
	        }, e.prototype.sealAllTags = function () {
	          this.capacity = 1, this.tags.forEach(function (e) {
	            e.sealed = !0;
	          });
	        }, e.prototype.makeTag = function (e) {
	          var t = e ? e.styleTag : null;
	          return le(this.target, t, this.forceServer, !1, this.getImportRuleTag);
	        }, e.prototype.getTagForId = function (e) {
	          var t = this.tagMap[e];
	          if (void 0 !== t && !t.sealed) return t;
	          var n = this.tags[this.tags.length - 1];
	          return this.capacity -= 1, 0 === this.capacity && (this.capacity = ce, n = this.makeTag(n), this.tags.push(n)), this.tagMap[e] = n;
	        }, e.prototype.hasId = function (e) {
	          return void 0 !== this.tagMap[e];
	        }, e.prototype.hasNameForId = function (e, t) {
	          if (void 0 === this.ignoreRehydratedNames[e] && this.rehydratedNames[t]) return !0;
	          var n = this.tagMap[e];
	          return void 0 !== n && n.hasNameForId(e, t);
	        }, e.prototype.deferredInject = function (e, t) {
	          if (void 0 === this.tagMap[e]) {
	            for (var n = this.clones, r = 0; r < n.length; r += 1) n[r].deferredInject(e, t);

	            this.getTagForId(e).insertMarker(e), this.deferred[e] = t;
	          }
	        }, e.prototype.inject = function (e, t, n) {
	          for (var r = this.clones, i = 0; i < r.length; i += 1) r[i].inject(e, t, n);

	          var o = this.getTagForId(e);

	          if (void 0 !== this.deferred[e]) {
	            var a = this.deferred[e].concat(t);
	            o.insertRules(e, a, n), this.deferred[e] = void 0;
	          } else o.insertRules(e, t, n);
	        }, e.prototype.remove = function (e) {
	          var t = this.tagMap[e];

	          if (void 0 !== t) {
	            for (var n = this.clones, r = 0; r < n.length; r += 1) n[r].remove(e);

	            t.removeRules(e), this.ignoreRehydratedNames[e] = !0, this.deferred[e] = void 0;
	          }
	        }, e.prototype.toHTML = function () {
	          return this.tags.map(function (e) {
	            return e.toHTML();
	          }).join("");
	        }, e.prototype.toReactElements = function () {
	          var e = this.id;
	          return this.tags.map(function (t, n) {
	            var r = "sc-" + e + "-" + n;
	            return Object(u.cloneElement)(t.toElement(), {
	              key: r
	            });
	          });
	        }, p(e, null, [{
	          key: "master",
	          get: function () {
	            return Ae || (Ae = new e().rehydrate());
	          }
	        }, {
	          key: "instance",
	          get: function () {
	            return e.master;
	          }
	        }]), e;
	      }(),
	          fe = function () {
	        function e(t, n) {
	          var r = this;
	          M(this, e), this.inject = function (e) {
	            e.hasNameForId(r.id, r.name) || e.inject(r.id, r.rules, r.name);
	          }, this.toString = function () {
	            throw new z(12, String(r.name));
	          }, this.name = t, this.rules = n, this.id = "sc-keyframes-" + t;
	        }

	        return e.prototype.getName = function () {
	          return this.name;
	        }, e;
	      }(),
	          Ie = /([A-Z])/g,
	          ge = /^ms-/;

	      var Me = function (e) {
	        return void 0 === e || null === e || !1 === e || "" === e;
	      },
	          pe = function e(t, n) {
	        var r = Object.keys(t).filter(function (e) {
	          return !Me(t[e]);
	        }).map(function (n) {
	          return j(t[n]) ? e(t[n], n) : function (e) {
	            return e.replace(Ie, "-$1").toLowerCase().replace(ge, "-ms-");
	          }(n) + ": " + function (e, t) {
	            return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in s.a ? String(t).trim() : t + "px";
	          }(n, t[n]) + ";";
	        }).join(" ");
	        return n ? n + " {\n  " + r + "\n}" : r;
	      };

	      function Ne(e, t, n) {
	        if (Array.isArray(e)) {
	          for (var r, i = [], o = 0, a = e.length; o < a; o += 1) null !== (r = Ne(e[o], t, n)) && (Array.isArray(r) ? i.push.apply(i, r) : i.push(r));

	          return i;
	        }

	        return Me(e) ? null : E(e) ? "." + e.styledComponentId : C(e) ? function (e) {
	          return "function" == typeof e && !(e.prototype && e.prototype.isReactComponent);
	        }(e) && t ? Ne(e(t), t, n) : e : e instanceof fe ? n ? (e.inject(n), e.getName()) : e : j(e) ? pe(e) : e.toString();
	      }

	      function ye(e) {
	        for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];

	        return C(e) || j(e) ? Ne(I(m, [e].concat(n))) : Ne(I(e, n));
	      }

	      function ve(e) {
	        for (var t, n = 0 | e.length, r = 0 | n, i = 0; n >= 4;) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(i) | (255 & e.charCodeAt(++i)) << 8 | (255 & e.charCodeAt(++i)) << 16 | (255 & e.charCodeAt(++i)) << 24)) + ((1540483477 * (t >>> 16) & 65535) << 16), r = 1540483477 * (65535 & r) + ((1540483477 * (r >>> 16) & 65535) << 16) ^ (t = 1540483477 * (65535 & (t ^= t >>> 24)) + ((1540483477 * (t >>> 16) & 65535) << 16)), n -= 4, ++i;

	        switch (n) {
	          case 3:
	            r ^= (255 & e.charCodeAt(i + 2)) << 16;

	          case 2:
	            r ^= (255 & e.charCodeAt(i + 1)) << 8;

	          case 1:
	            r = 1540483477 * (65535 & (r ^= 255 & e.charCodeAt(i))) + ((1540483477 * (r >>> 16) & 65535) << 16);
	        }

	        return ((r = 1540483477 * (65535 & (r ^= r >>> 13)) + ((1540483477 * (r >>> 16) & 65535) << 16)) ^ r >>> 15) >>> 0;
	      }

	      var he = 52,
	          je = function (e) {
	        return String.fromCharCode(e + (e > 25 ? 39 : 97));
	      };

	      function me(e) {
	        var t = "",
	            n = void 0;

	        for (n = e; n > he; n = Math.floor(n / he)) t = je(n % he) + t;

	        return je(n % he) + t;
	      }

	      function we(e, t) {
	        for (var n = 0; n < e.length; n += 1) {
	          var r = e[n];
	          if (Array.isArray(r) && !we(r, t)) return !1;
	          if (C(r) && !E(r)) return !1;
	        }

	        return !t.some(function (e) {
	          return C(e) || function (e) {
	            for (var t in e) if (C(e[t])) return !0;

	            return !1;
	          }(e);
	        });
	      }

	      var Ce,
	          Ee = function (e) {
	        return me(ve(e));
	      },
	          De = function () {
	        function e(t, n, r) {
	          M(this, e), this.rules = t, this.isStatic = we(t, n), this.componentId = r, de.master.hasId(r) || de.master.deferredInject(r, []);
	        }

	        return e.prototype.generateAndInjectStyles = function (e, t) {
	          var n = this.isStatic,
	              r = this.componentId,
	              i = this.lastClassName;
	          if (T && n && "string" == typeof i && t.hasNameForId(r, i)) return i;
	          var o = Ne(this.rules, e, t),
	              a = Ee(this.componentId + o.join(""));
	          return t.hasNameForId(r, a) || t.inject(this.componentId, J(o, "." + a, void 0, r), a), this.lastClassName = a, a;
	        }, e.generateName = function (e) {
	          return Ee(e);
	        }, e;
	      }(),
	          Te = function (e, t) {
	        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w,
	            r = !!n && e.theme === n.theme;
	        return e.theme && !r ? e.theme : t || n.theme;
	      },
	          xe = /[[\].#*$><+~=|^:(),"'`-]+/g,
	          Se = /(^-|-$)/g;

	      function ze(e) {
	        return e.replace(xe, "-").replace(Se, "");
	      }

	      function Le(e) {
	        return "string" == typeof e && !0;
	      }

	      var ke = {
	        childContextTypes: !0,
	        contextTypes: !0,
	        defaultProps: !0,
	        displayName: !0,
	        getDerivedStateFromProps: !0,
	        propTypes: !0,
	        type: !0
	      },
	          Qe = {
	        name: !0,
	        length: !0,
	        prototype: !0,
	        caller: !0,
	        callee: !0,
	        arguments: !0,
	        arity: !0
	      },
	          Oe = ((Ce = {})[A.ForwardRef] = {
	        $$typeof: !0,
	        render: !0
	      }, Ce),
	          Pe = Object.defineProperty,
	          Be = Object.getOwnPropertyNames,
	          Ue = Object.getOwnPropertySymbols,
	          Ye = void 0 === Ue ? function () {
	        return [];
	      } : Ue,
	          Re = Object.getOwnPropertyDescriptor,
	          Ge = Object.getPrototypeOf,
	          Ze = Object.prototype,
	          He = Array.prototype;

	      function Fe(e, t, n) {
	        if ("string" != typeof t) {
	          var r = Ge(t);
	          r && r !== Ze && Fe(e, r, n);

	          for (var i = He.concat(Be(t), Ye(t)), o = Oe[e.$$typeof] || ke, a = Oe[t.$$typeof] || ke, l = i.length, u = void 0, c = void 0; l--;) if (c = i[l], !(Qe[c] || n && n[c] || a && a[c] || o && o[c]) && (u = Re(t, c))) try {
	            Pe(e, c, u);
	          } catch (e) {}

	          return e;
	        }

	        return e;
	      }

	      function Je(e) {
	        return !!(e && e.prototype && e.prototype.isReactComponent);
	      }

	      var Ve = Object(u.createContext)(),
	          We = Ve.Consumer,
	          Xe = function (e) {
	        function t(n) {
	          M(this, t);
	          var r = h(this, e.call(this, n));
	          return r.getContext = Object(d.a)(r.getContext.bind(r)), r.renderInner = r.renderInner.bind(r), r;
	        }

	        return y(t, e), t.prototype.render = function () {
	          return this.props.children ? c.a.createElement(Ve.Consumer, null, this.renderInner) : null;
	        }, t.prototype.renderInner = function (e) {
	          var t = this.getContext(this.props.theme, e);
	          return c.a.createElement(Ve.Provider, {
	            value: t
	          }, c.a.Children.only(this.props.children));
	        }, t.prototype.getTheme = function (e, t) {
	          if (C(e)) return e(t);
	          if (null === e || Array.isArray(e) || "object" !== (void 0 === e ? "undefined" : g(e))) throw new z(8);
	          return N({}, t, e);
	        }, t.prototype.getContext = function (e, t) {
	          return this.getTheme(e, t);
	        }, t;
	      }(u.Component),
	          Ke = function () {
	        function e() {
	          M(this, e), this.masterSheet = de.master, this.instance = this.masterSheet.clone(), this.sealed = !1;
	        }

	        return e.prototype.seal = function () {
	          if (!this.sealed) {
	            var e = this.masterSheet.clones.indexOf(this.instance);
	            this.masterSheet.clones.splice(e, 1), this.sealed = !0;
	          }
	        }, e.prototype.collectStyles = function (e) {
	          if (this.sealed) throw new z(2);
	          return c.a.createElement($e, {
	            sheet: this.instance
	          }, e);
	        }, e.prototype.getStyleTags = function () {
	          return this.seal(), this.instance.toHTML();
	        }, e.prototype.getStyleElement = function () {
	          return this.seal(), this.instance.toReactElements();
	        }, e.prototype.interleaveWithNodeStream = function (e) {
	          throw new z(3);
	        }, e;
	      }(),
	          qe = Object(u.createContext)(),
	          _e = qe.Consumer,
	          $e = function (e) {
	        function t(n) {
	          M(this, t);
	          var r = h(this, e.call(this, n));
	          return r.getContext = Object(d.a)(r.getContext), r;
	        }

	        return y(t, e), t.prototype.getContext = function (e, t) {
	          if (e) return e;
	          if (t) return new de(t);
	          throw new z(4);
	        }, t.prototype.render = function () {
	          var e = this.props,
	              t = e.children,
	              n = e.sheet,
	              r = e.target;
	          return c.a.createElement(qe.Provider, {
	            value: this.getContext(n, r)
	          }, t);
	        }, t;
	      }(u.Component),
	          et = ({});

	      var tt = function (e) {
	        function t() {
	          M(this, t);
	          var n = h(this, e.call(this));
	          return n.attrs = {}, n.renderOuter = n.renderOuter.bind(n), n.renderInner = n.renderInner.bind(n), n;
	        }

	        return y(t, e), t.prototype.render = function () {
	          return c.a.createElement(_e, null, this.renderOuter);
	        }, t.prototype.renderOuter = function () {
	          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : de.master;
	          return this.styleSheet = e, this.props.forwardedComponent.componentStyle.isStatic ? this.renderInner() : c.a.createElement(We, null, this.renderInner);
	        }, t.prototype.renderInner = function (e) {
	          var t = this.props.forwardedComponent,
	              n = t.componentStyle,
	              r = t.defaultProps,
	              i = (t.displayName, t.foldedComponentIds),
	              o = t.styledComponentId,
	              a = t.target,
	              l = void 0;
	          l = n.isStatic ? this.generateAndInjectStyles(w, this.props) : void 0 !== e ? this.generateAndInjectStyles(Te(this.props, e, r), this.props) : this.generateAndInjectStyles(this.props.theme || w, this.props);
	          var c = this.props.as || this.attrs.as || a,
	              s = Le(c),
	              A = {},
	              d = N({}, this.attrs, this.props),
	              I = void 0;

	          for (I in d) "forwardedComponent" !== I && "as" !== I && "suppressClassNameWarning" !== I && ("forwardedRef" === I ? A.ref = d[I] : s && !Object(f.a)(I) || (A[I] = d[I]));

	          return this.props.style && this.attrs.style && (A.style = N({}, this.attrs.style, this.props.style)), A.className = Array.prototype.concat(i, this.props.className, o, this.attrs.className, l).filter(Boolean).join(" "), Object(u.createElement)(c, A);
	        }, t.prototype.buildExecutionContext = function (e, t, n) {
	          var r = this,
	              i = N({}, t, {
	            theme: e
	          });
	          return n.length ? (this.attrs = {}, n.forEach(function (e) {
	            var t = e,
	                n = !1,
	                o = void 0,
	                a = void 0;

	            for (a in C(t) && (t = t(i), n = !0), t) o = t[a], n || !C(o) || Je(o) || E(o) || (o = o(i)), r.attrs[a] = o, i[a] = o;
	          }), i) : i;
	        }, t.prototype.generateAndInjectStyles = function (e, t) {
	          var n = t.forwardedComponent,
	              r = n.attrs,
	              i = n.componentStyle;
	          n.warnTooManyClasses;
	          return i.isStatic && !r.length ? i.generateAndInjectStyles(w, this.styleSheet) : i.generateAndInjectStyles(this.buildExecutionContext(e, t, r), this.styleSheet);
	        }, t;
	      }(u.Component);

	      function nt(e, t, n) {
	        var r = E(e),
	            i = !Le(e),
	            o = t.displayName,
	            a = void 0 === o ? function (e) {
	          return Le(e) ? "styled." + e : "Styled(" + b(e) + ")";
	        }(e) : o,
	            l = t.componentId,
	            u = void 0 === l ? function (e, t, n) {
	          var r = "string" != typeof t ? "sc" : ze(t),
	              i = (et[r] || 0) + 1;
	          et[r] = i;
	          var o = r + "-" + e.generateName(r + i);
	          return n ? n + "-" + o : o;
	        }(De, t.displayName, t.parentComponentId) : l,
	            s = t.ParentComponent,
	            A = void 0 === s ? tt : s,
	            d = t.attrs,
	            f = void 0 === d ? m : d,
	            I = t.displayName && t.componentId ? ze(t.displayName) + "-" + t.componentId : t.componentId || u,
	            g = r && e.attrs ? Array.prototype.concat(e.attrs, f).filter(Boolean) : f,
	            M = new De(r ? e.componentStyle.rules.concat(n) : n, g, I),
	            p = c.a.forwardRef(function (e, t) {
	          return c.a.createElement(A, N({}, e, {
	            forwardedComponent: p,
	            forwardedRef: t
	          }));
	        });
	        return p.attrs = g, p.componentStyle = M, p.displayName = a, p.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : m, p.styledComponentId = I, p.target = r ? e.target : e, p.withComponent = function (e) {
	          var r = t.componentId,
	              i = v(t, ["componentId"]),
	              o = r && r + "-" + (Le(e) ? e : ze(b(e)));
	          return nt(e, N({}, i, {
	            attrs: g,
	            componentId: o,
	            ParentComponent: A
	          }), n);
	        }, p.toString = function () {
	          return "." + p.styledComponentId;
	        }, i && Fe(p, e, {
	          attrs: !0,
	          componentStyle: !0,
	          displayName: !0,
	          foldedComponentIds: !0,
	          styledComponentId: !0,
	          target: !0,
	          withComponent: !0
	        }), p;
	      }

	      var rt = function (e) {
	        return function e(t, n) {
	          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w;
	          if (!Object(A.isValidElementType)(n)) throw new z(1, String(n));

	          var i = function () {
	            return t(n, r, ye.apply(void 0, arguments));
	          };

	          return i.withConfig = function (i) {
	            return e(t, n, N({}, r, i));
	          }, i.attrs = function (i) {
	            return e(t, n, N({}, r, {
	              attrs: Array.prototype.concat(r.attrs, i).filter(Boolean)
	            }));
	          }, i;
	        }(nt, e);
	      };

	      ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (e) {
	        rt[e] = rt(e);
	      });

	      var it = function () {
	        function e(t, n) {
	          M(this, e), this.rules = t, this.componentId = n, this.isStatic = we(t, m), de.master.hasId(n) || de.master.deferredInject(n, []);
	        }

	        return e.prototype.createStyles = function (e, t) {
	          var n = J(Ne(this.rules, e, t), "");
	          t.inject(this.componentId, n);
	        }, e.prototype.removeStyles = function (e) {
	          var t = this.componentId;
	          e.hasId(t) && e.remove(t);
	        }, e.prototype.renderStyles = function (e, t) {
	          this.removeStyles(t), this.createStyles(e, t);
	        }, e;
	      }();

	      function ot(e) {
	        for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];

	        var i = ye.apply(void 0, [e].concat(n)),
	            o = "sc-global-" + ve(JSON.stringify(i)),
	            a = new it(i, o),
	            l = function (e) {
	          function t(n) {
	            M(this, t);
	            var r = h(this, e.call(this, n)),
	                i = r.constructor,
	                o = i.globalStyle,
	                a = i.styledComponentId;
	            return T && (window.scCGSHMRCache[a] = (window.scCGSHMRCache[a] || 0) + 1), r.state = {
	              globalStyle: o,
	              styledComponentId: a
	            }, r;
	          }

	          return y(t, e), t.prototype.componentWillUnmount = function () {
	            window.scCGSHMRCache[this.state.styledComponentId] && (window.scCGSHMRCache[this.state.styledComponentId] -= 1), 0 === window.scCGSHMRCache[this.state.styledComponentId] && this.state.globalStyle.removeStyles(this.styleSheet);
	          }, t.prototype.render = function () {
	            var e = this;
	            return c.a.createElement(_e, null, function (t) {
	              e.styleSheet = t || de.master;
	              var n = e.state.globalStyle;
	              return n.isStatic ? (n.renderStyles(S, e.styleSheet), null) : c.a.createElement(We, null, function (t) {
	                var r = e.constructor.defaultProps,
	                    i = N({}, e.props);
	                return void 0 !== t && (i.theme = Te(e.props, t, r)), n.renderStyles(i, e.styleSheet), null;
	              });
	            });
	          }, t;
	        }(c.a.Component);

	        return l.globalStyle = a, l.styledComponentId = o, l;
	      }

	      T && (window.scCGSHMRCache = {});

	      var at = function (e) {
	        return e.replace(/\s|\\n/g, "");
	      };

	      function lt(e) {
	        for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];

	        var i = ye.apply(void 0, [e].concat(n)),
	            o = me(ve(at(JSON.stringify(i))));
	        return new fe(o, J(i, o, "@keyframes"));
	      }

	      var ut = function (e) {
	        var t = c.a.forwardRef(function (t, n) {
	          return c.a.createElement(We, null, function (r) {
	            var i = e.defaultProps,
	                o = Te(t, r, i);
	            return c.a.createElement(e, N({}, t, {
	              theme: o,
	              ref: n
	            }));
	          });
	        });
	        return Fe(t, e), t.displayName = "WithTheme(" + b(e) + ")", t;
	      },
	          ct = {
	        StyleSheet: de
	      };

	      t.default = rt;
	    }.call(this, n(65), n(66)(e));
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r,
	        i,
	        o,
	        a,
	        l,
	        u = n(1),
	        c = u.__importStar(n(0)),
	        s = u.__importDefault(n(14)),
	        A = n(2),
	        d = s.default.div(r || (r = u.__makeTemplateObject(["\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: ", ";\n  box-shadow: ", ";\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"], ["\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: ", ";\n  box-shadow: ", ";\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"])), function (e) {
	      return e.noShadow ? "visible" : "hidden";
	    }, function (e) {
	      return e.noShadow ? "none" : "0 4px 6px 0 rgba(50, 50, 93, 0.11), 0 1px 3px 0 rgba(0, 0, 0, 0.08), inset 0 0 1px 0 rgba(0, 0, 0, 0.06)";
	    }),
	        f = s.default.div(i || (i = u.__makeTemplateObject(["\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ", ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"], ["\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ", ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"])), function (e) {
	      return e.themeColors.main;
	    }),
	        I = s.default.div(o || (o = u.__makeTemplateObject(["\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ", ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"], ["\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ", ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"])), function (e) {
	      return e.themeColors.secondary;
	    }),
	        g = s.default.div(a || (a = u.__makeTemplateObject(["\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"], ["\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"])), function (e) {
	      return e.themeColors.background;
	    }),
	        M = s.default.div(l || (l = u.__makeTemplateObject(["\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ", ";\n  @media (hover: hover) {\n    &:hover ", " {\n      background-color: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ", ";\n  @media (hover: hover) {\n    &:hover ", " {\n      background-color: ", ";\n    }\n  }\n"])), function (e) {
	      return "1px solid " + e.themeColors.border;
	    }, g, function (e) {
	      return e.themeColors.hover;
	    });

	    t.Provider = function (e) {
	      var t = e.name,
	          n = e.themeColors,
	          r = e.onClick,
	          i = u.__rest(e, ["name", "themeColors", "onClick"]),
	          o = A.getProviderInfoByName(t),
	          a = A.formatProviderDescription(o);

	      return c.createElement(M, u.__assign({
	        themeColors: n,
	        className: A.PROVIDER_WRAPPER_CLASSNAME,
	        onClick: r
	      }, i), c.createElement(g, {
	        themeColors: n,
	        className: A.PROVIDER_CONTAINER_CLASSNAME
	      }, c.createElement(d, {
	        className: A.PROVIDER_ICON_CLASSNAME,
	        noShadow: o.styled.noShadow
	      }, c.createElement("img", {
	        src: o.logo,
	        alt: o.name
	      })), c.createElement(f, {
	        themeColors: n,
	        className: A.PROVIDER_NAME_CLASSNAME
	      }, o.name), c.createElement(I, {
	        themeColors: n,
	        className: A.PROVIDER_DESCRIPTION_CLASSNAME
	      }, a)));
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);
	    r.__exportStar(n(17), t), r.__exportStar(n(68), t);
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = function () {
	      function e() {
	        this._eventCallbacks = [];
	      }

	      return e.prototype.on = function (e) {
	        this._eventCallbacks.push(e);
	      }, e.prototype.off = function (e) {
	        e ? e.callback ? this._eventCallbacks = this._eventCallbacks.filter(function (t) {
	          return t.event !== e.event || t.callback !== e.callback;
	        }) : this._eventCallbacks = this._eventCallbacks.filter(function (t) {
	          return t.event !== e.event;
	        }) : this._eventCallbacks = [];
	      }, e.prototype.trigger = function (e, t) {
	        var n = this._eventCallbacks.filter(function (t) {
	          return t.event === e;
	        });

	        n && n.length && n.forEach(function (e) {
	          e.callback(t);
	        });
	      }, e;
	    }();

	    t.EventController = r;
	  }, function (e, t, n) {
	    e.exports = function () {

	      return function (e) {
	        function t(t) {
	          if (t) try {
	            e(t + "}");
	          } catch (e) {}
	        }

	        return function (n, r, i, o, a, l, u, c, s, A) {
	          switch (n) {
	            case 1:
	              if (0 === s && 64 === r.charCodeAt(0)) return e(r + ";"), "";
	              break;

	            case 2:
	              if (0 === c) return r + "/*|*/";
	              break;

	            case 3:
	              switch (c) {
	                case 102:
	                case 112:
	                  return e(i[0] + r), "";

	                default:
	                  return r + (0 === A ? "/*|*/" : "");
	              }

	            case -2:
	              r.split("/*|*/}").forEach(t);
	          }
	        };
	      };
	    }();
	  }, function (e, t, n) {

	    t.a = {
	      animationIterationCount: 1,
	      borderImageOutset: 1,
	      borderImageSlice: 1,
	      borderImageWidth: 1,
	      boxFlex: 1,
	      boxFlexGroup: 1,
	      boxOrdinalGroup: 1,
	      columnCount: 1,
	      columns: 1,
	      flex: 1,
	      flexGrow: 1,
	      flexPositive: 1,
	      flexShrink: 1,
	      flexNegative: 1,
	      flexOrder: 1,
	      gridRow: 1,
	      gridRowEnd: 1,
	      gridRowSpan: 1,
	      gridRowStart: 1,
	      gridColumn: 1,
	      gridColumnEnd: 1,
	      gridColumnSpan: 1,
	      gridColumnStart: 1,
	      msGridRow: 1,
	      msGridRowSpan: 1,
	      msGridColumn: 1,
	      msGridColumnSpan: 1,
	      fontWeight: 1,
	      lineHeight: 1,
	      opacity: 1,
	      order: 1,
	      orphans: 1,
	      tabSize: 1,
	      widows: 1,
	      zIndex: 1,
	      zoom: 1,
	      WebkitLineClamp: 1,
	      fillOpacity: 1,
	      floodOpacity: 1,
	      stopOpacity: 1,
	      strokeDasharray: 1,
	      strokeDashoffset: 1,
	      strokeMiterlimit: 1,
	      strokeOpacity: 1,
	      strokeWidth: 1
	    };
	  }, function (e, t, n) {

	    var r = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
	        i = function (e) {
	      var t = {};
	      return function (n) {
	        return void 0 === t[n] && (t[n] = e(n)), t[n];
	      };
	    }(function (e) {
	      return r.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
	    });

	    t.a = i;
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1),
	        i = n(22);
	    r.__exportStar(n(12), t), r.__exportStar(n(16), t), r.__exportStar(n(4), t), r.__exportStar(n(2), t), r.__exportStar(n(3), t), t.default = i.Core;
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = n(1),
	        i = r.__importStar(n(0)),
	        o = r.__importStar(n(5)),
	        a = n(2),
	        l = n(3),
	        u = n(12),
	        c = n(16),
	        s = {
	      show: !1
	    },
	        A = {
	      lightboxOpacity: .4,
	      theme: l.themesList.default.name,
	      cacheProvider: !1,
	      providerOptions: {},
	      network: ""
	    },
	        d = function () {
	      function e(e) {
	        var t = this;
	        this.show = s.show, this.eventController = new c.EventController(), this.connect = function () {
	          return new Promise(function (e, n) {
	            return r.__awaiter(t, void 0, void 0, function () {
	              return r.__generator(this, function (t) {
	                switch (t.label) {
	                  case 0:
	                    return this.on(a.CONNECT_EVENT, function (t) {
	                      return e(t);
	                    }), [4, this.toggleModal()];

	                  case 1:
	                    return t.sent(), [2];
	                }
	              });
	            });
	          });
	        }, this.connectTo = function (e) {
	          return new Promise(function (n, i) {
	            return r.__awaiter(t, void 0, void 0, function () {
	              var t;
	              return r.__generator(this, function (r) {
	                switch (r.label) {
	                  case 0:
	                    return this.on(a.CONNECT_EVENT, function (e) {
	                      return n(e);
	                    }), (t = this.providerController.getProviderMappingEntry(e)) ? [4, this.providerController.connectTo(t.id, t.connector)] : [2, i(new Error("Cannot connect to provider (" + e + "), check provider options"))];

	                  case 1:
	                    return r.sent(), [2];
	                }
	              });
	            });
	          });
	        }, this._toggleModal = function () {
	          return r.__awaiter(t, void 0, void 0, function () {
	            var e, t;
	            return r.__generator(this, function (n) {
	              switch (n.label) {
	                case 0:
	                  return e = "undefined" != typeof window ? document : "", (t = e ? e.body || e.getElementsByTagName("body")[0] : "") && (this.show ? t.style.overflow = "" : t.style.overflow = "hidden"), [4, this.updateState({
	                    show: !this.show
	                  })];

	                case 1:
	                  return n.sent(), [2];
	              }
	            });
	          });
	        }, this.onError = function (e) {
	          return r.__awaiter(t, void 0, void 0, function () {
	            return r.__generator(this, function (t) {
	              switch (t.label) {
	                case 0:
	                  return this.show ? [4, this._toggleModal()] : [3, 2];

	                case 1:
	                  t.sent(), t.label = 2;

	                case 2:
	                  return this.eventController.trigger(a.ERROR_EVENT, e), [2];
	              }
	            });
	          });
	        }, this.onConnect = function (e) {
	          return r.__awaiter(t, void 0, void 0, function () {
	            return r.__generator(this, function (t) {
	              switch (t.label) {
	                case 0:
	                  return this.show ? [4, this._toggleModal()] : [3, 2];

	                case 1:
	                  t.sent(), t.label = 2;

	                case 2:
	                  return this.eventController.trigger(a.CONNECT_EVENT, e), [2];
	              }
	            });
	          });
	        }, this.onClose = function () {
	          return r.__awaiter(t, void 0, void 0, function () {
	            return r.__generator(this, function (e) {
	              switch (e.label) {
	                case 0:
	                  return this.show ? [4, this._toggleModal()] : [3, 2];

	                case 1:
	                  e.sent(), e.label = 2;

	                case 2:
	                  return this.eventController.trigger(a.CLOSE_EVENT), [2];
	              }
	            });
	          });
	        }, this.updateState = function (e) {
	          return r.__awaiter(t, void 0, void 0, function () {
	            var t = this;
	            return r.__generator(this, function (n) {
	              switch (n.label) {
	                case 0:
	                  return Object.keys(e).forEach(function (n) {
	                    t[n] = e[n];
	                  }), [4, window.updateWeb3Modal(e)];

	                case 1:
	                  return n.sent(), [2];
	              }
	            });
	          });
	        }, this.resetState = function () {
	          return t.updateState(r.__assign({}, s));
	        };

	        var n = r.__assign(r.__assign({}, A), e);

	        this.lightboxOpacity = n.lightboxOpacity, this.themeColors = a.getThemeColors(n.theme), this.providerController = new c.ProviderController({
	          cacheProvider: n.cacheProvider,
	          providerOptions: n.providerOptions,
	          network: n.network
	        }), this.providerController.on(a.CONNECT_EVENT, function (e) {
	          return t.onConnect(e);
	        }), this.providerController.on(a.ERROR_EVENT, function (e) {
	          return t.onError(e);
	        }), this.providers = this.providerController.getProviders(), this.renderModal();
	      }

	      return Object.defineProperty(e.prototype, "cachedProvider", {
	        get: function () {
	          return this.providerController.cachedProvider;
	        },
	        enumerable: !0,
	        configurable: !0
	      }), e.prototype.toggleModal = function () {
	        return r.__awaiter(this, void 0, void 0, function () {
	          return r.__generator(this, function (e) {
	            switch (e.label) {
	              case 0:
	                return this.cachedProvider ? [4, this.providerController.connectToCachedProvider()] : [3, 2];

	              case 1:
	                return e.sent(), [2];

	              case 2:
	                return this.providers && 1 === this.providers.length && this.providers[0].name ? [4, this.providers[0].onClick()] : [3, 4];

	              case 3:
	                return e.sent(), [2];

	              case 4:
	                return [4, this._toggleModal()];

	              case 5:
	                return e.sent(), [2];
	            }
	          });
	        });
	      }, e.prototype.on = function (e, t) {
	        var n = this;
	        return this.eventController.on({
	          event: e,
	          callback: t
	        }), function () {
	          return n.eventController.off({
	            event: e,
	            callback: t
	          });
	        };
	      }, e.prototype.off = function (e, t) {
	        this.eventController.off({
	          event: e,
	          callback: t
	        });
	      }, e.prototype.clearCachedProvider = function () {
	        this.providerController.clearCachedProvider();
	      }, e.prototype.setCachedProvider = function (e) {
	        this.providerController.setCachedProvider(e);
	      }, e.prototype.updateTheme = function (e) {
	        return r.__awaiter(this, void 0, void 0, function () {
	          return r.__generator(this, function (t) {
	            switch (t.label) {
	              case 0:
	                return this.themeColors = a.getThemeColors(e), [4, this.updateState({
	                  themeColors: this.themeColors
	                })];

	              case 1:
	                return t.sent(), [2];
	            }
	          });
	        });
	      }, e.prototype.renderModal = function () {
	        var e = document.createElement("div");
	        e.id = a.WEB3_CONNECT_MODAL_ID, document.body.appendChild(e), o.render(i.createElement(u.Modal, {
	          themeColors: this.themeColors,
	          providers: this.providers,
	          onClose: this.onClose,
	          resetState: this.resetState,
	          lightboxOpacity: this.lightboxOpacity
	        }), document.getElementById(a.WEB3_CONNECT_MODAL_ID));
	      }, e;
	    }();

	    t.Core = d;
	  }, function (e, t, n) {
	    /** @license React v16.9.0
	     * react.production.min.js
	     *
	     * Copyright (c) Facebook, Inc. and its affiliates.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     */

	    var r = n(9),
	        i = "function" == typeof Symbol && Symbol.for,
	        o = i ? Symbol.for("react.element") : 60103,
	        a = i ? Symbol.for("react.portal") : 60106,
	        l = i ? Symbol.for("react.fragment") : 60107,
	        u = i ? Symbol.for("react.strict_mode") : 60108,
	        c = i ? Symbol.for("react.profiler") : 60114,
	        s = i ? Symbol.for("react.provider") : 60109,
	        A = i ? Symbol.for("react.context") : 60110,
	        d = i ? Symbol.for("react.forward_ref") : 60112,
	        f = i ? Symbol.for("react.suspense") : 60113,
	        I = i ? Symbol.for("react.suspense_list") : 60120,
	        g = i ? Symbol.for("react.memo") : 60115,
	        M = i ? Symbol.for("react.lazy") : 60116;
	    var p = "function" == typeof Symbol && Symbol.iterator;

	    function N(e) {
	      for (var t = e.message, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, r = 1; r < arguments.length; r++) n += "&args[]=" + encodeURIComponent(arguments[r]);

	      return e.message = "Minified React error #" + t + "; visit " + n + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e;
	    }

	    var y = {
	      isMounted: function () {
	        return !1;
	      },
	      enqueueForceUpdate: function () {},
	      enqueueReplaceState: function () {},
	      enqueueSetState: function () {}
	    },
	        v = {};

	    function h(e, t, n) {
	      this.props = e, this.context = t, this.refs = v, this.updater = n || y;
	    }

	    function j() {}

	    function m(e, t, n) {
	      this.props = e, this.context = t, this.refs = v, this.updater = n || y;
	    }

	    h.prototype.isReactComponent = {}, h.prototype.setState = function (e, t) {
	      if ("object" != typeof e && "function" != typeof e && null != e) throw N(Error(85));
	      this.updater.enqueueSetState(this, e, t, "setState");
	    }, h.prototype.forceUpdate = function (e) {
	      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	    }, j.prototype = h.prototype;
	    var w = m.prototype = new j();
	    w.constructor = m, r(w, h.prototype), w.isPureReactComponent = !0;
	    var C = {
	      current: null
	    },
	        b = {
	      suspense: null
	    },
	        E = {
	      current: null
	    },
	        D = Object.prototype.hasOwnProperty,
	        T = {
	      key: !0,
	      ref: !0,
	      __self: !0,
	      __source: !0
	    };

	    function x(e, t, n) {
	      var r = void 0,
	          i = {},
	          a = null,
	          l = null;
	      if (null != t) for (r in void 0 !== t.ref && (l = t.ref), void 0 !== t.key && (a = "" + t.key), t) D.call(t, r) && !T.hasOwnProperty(r) && (i[r] = t[r]);
	      var u = arguments.length - 2;
	      if (1 === u) i.children = n;else if (1 < u) {
	        for (var c = Array(u), s = 0; s < u; s++) c[s] = arguments[s + 2];

	        i.children = c;
	      }
	      if (e && e.defaultProps) for (r in u = e.defaultProps) void 0 === i[r] && (i[r] = u[r]);
	      return {
	        $$typeof: o,
	        type: e,
	        key: a,
	        ref: l,
	        props: i,
	        _owner: E.current
	      };
	    }

	    function S(e) {
	      return "object" == typeof e && null !== e && e.$$typeof === o;
	    }

	    var z = /\/+/g,
	        L = [];

	    function k(e, t, n, r) {
	      if (L.length) {
	        var i = L.pop();
	        return i.result = e, i.keyPrefix = t, i.func = n, i.context = r, i.count = 0, i;
	      }

	      return {
	        result: e,
	        keyPrefix: t,
	        func: n,
	        context: r,
	        count: 0
	      };
	    }

	    function Q(e) {
	      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > L.length && L.push(e);
	    }

	    function O(e, t, n) {
	      return null == e ? 0 : function e(t, n, r, i) {
	        var l = typeof t;
	        "undefined" !== l && "boolean" !== l || (t = null);
	        var u = !1;
	        if (null === t) u = !0;else switch (l) {
	          case "string":
	          case "number":
	            u = !0;
	            break;

	          case "object":
	            switch (t.$$typeof) {
	              case o:
	              case a:
	                u = !0;
	            }

	        }
	        if (u) return r(i, t, "" === n ? "." + P(t, 0) : n), 1;
	        if (u = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var c = 0; c < t.length; c++) {
	          var s = n + P(l = t[c], c);
	          u += e(l, s, r, i);
	        } else if (s = null === t || "object" != typeof t ? null : "function" == typeof (s = p && t[p] || t["@@iterator"]) ? s : null, "function" == typeof s) for (t = s.call(t), c = 0; !(l = t.next()).done;) u += e(l = l.value, s = n + P(l, c++), r, i);else if ("object" === l) throw r = "" + t, N(Error(31), "[object Object]" === r ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, "");
	        return u;
	      }(e, "", t, n);
	    }

	    function P(e, t) {
	      return "object" == typeof e && null !== e && null != e.key ? function (e) {
	        var t = {
	          "=": "=0",
	          ":": "=2"
	        };
	        return "$" + ("" + e).replace(/[=:]/g, function (e) {
	          return t[e];
	        });
	      }(e.key) : t.toString(36);
	    }

	    function B(e, t) {
	      e.func.call(e.context, t, e.count++);
	    }

	    function U(e, t, n) {
	      var r = e.result,
	          i = e.keyPrefix;
	      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? Y(e, r, n, function (e) {
	        return e;
	      }) : null != e && (S(e) && (e = function (e, t) {
	        return {
	          $$typeof: o,
	          type: e.type,
	          key: t,
	          ref: e.ref,
	          props: e.props,
	          _owner: e._owner
	        };
	      }(e, i + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(z, "$&/") + "/") + n)), r.push(e));
	    }

	    function Y(e, t, n, r, i) {
	      var o = "";
	      null != n && (o = ("" + n).replace(z, "$&/") + "/"), O(e, U, t = k(t, o, r, i)), Q(t);
	    }

	    function R() {
	      var e = C.current;
	      if (null === e) throw N(Error(321));
	      return e;
	    }

	    var G = {
	      Children: {
	        map: function (e, t, n) {
	          if (null == e) return e;
	          var r = [];
	          return Y(e, r, null, t, n), r;
	        },
	        forEach: function (e, t, n) {
	          if (null == e) return e;
	          O(e, B, t = k(null, null, t, n)), Q(t);
	        },
	        count: function (e) {
	          return O(e, function () {
	            return null;
	          }, null);
	        },
	        toArray: function (e) {
	          var t = [];
	          return Y(e, t, null, function (e) {
	            return e;
	          }), t;
	        },
	        only: function (e) {
	          if (!S(e)) throw N(Error(143));
	          return e;
	        }
	      },
	      createRef: function () {
	        return {
	          current: null
	        };
	      },
	      Component: h,
	      PureComponent: m,
	      createContext: function (e, t) {
	        return void 0 === t && (t = null), (e = {
	          $$typeof: A,
	          _calculateChangedBits: t,
	          _currentValue: e,
	          _currentValue2: e,
	          _threadCount: 0,
	          Provider: null,
	          Consumer: null
	        }).Provider = {
	          $$typeof: s,
	          _context: e
	        }, e.Consumer = e;
	      },
	      forwardRef: function (e) {
	        return {
	          $$typeof: d,
	          render: e
	        };
	      },
	      lazy: function (e) {
	        return {
	          $$typeof: M,
	          _ctor: e,
	          _status: -1,
	          _result: null
	        };
	      },
	      memo: function (e, t) {
	        return {
	          $$typeof: g,
	          type: e,
	          compare: void 0 === t ? null : t
	        };
	      },
	      useCallback: function (e, t) {
	        return R().useCallback(e, t);
	      },
	      useContext: function (e, t) {
	        return R().useContext(e, t);
	      },
	      useEffect: function (e, t) {
	        return R().useEffect(e, t);
	      },
	      useImperativeHandle: function (e, t, n) {
	        return R().useImperativeHandle(e, t, n);
	      },
	      useDebugValue: function () {},
	      useLayoutEffect: function (e, t) {
	        return R().useLayoutEffect(e, t);
	      },
	      useMemo: function (e, t) {
	        return R().useMemo(e, t);
	      },
	      useReducer: function (e, t, n) {
	        return R().useReducer(e, t, n);
	      },
	      useRef: function (e) {
	        return R().useRef(e);
	      },
	      useState: function (e) {
	        return R().useState(e);
	      },
	      Fragment: l,
	      Profiler: c,
	      StrictMode: u,
	      Suspense: f,
	      unstable_SuspenseList: I,
	      createElement: x,
	      cloneElement: function (e, t, n) {
	        if (null === e || void 0 === e) throw N(Error(267), e);
	        var i = void 0,
	            a = r({}, e.props),
	            l = e.key,
	            u = e.ref,
	            c = e._owner;

	        if (null != t) {
	          void 0 !== t.ref && (u = t.ref, c = E.current), void 0 !== t.key && (l = "" + t.key);
	          var s = void 0;

	          for (i in e.type && e.type.defaultProps && (s = e.type.defaultProps), t) D.call(t, i) && !T.hasOwnProperty(i) && (a[i] = void 0 === t[i] && void 0 !== s ? s[i] : t[i]);
	        }

	        if (1 === (i = arguments.length - 2)) a.children = n;else if (1 < i) {
	          s = Array(i);

	          for (var A = 0; A < i; A++) s[A] = arguments[A + 2];

	          a.children = s;
	        }
	        return {
	          $$typeof: o,
	          type: e.type,
	          key: l,
	          ref: u,
	          props: a,
	          _owner: c
	        };
	      },
	      createFactory: function (e) {
	        var t = x.bind(null, e);
	        return t.type = e, t;
	      },
	      isValidElement: S,
	      version: "16.9.0",
	      unstable_withSuspenseConfig: function (e, t) {
	        var n = b.suspense;
	        b.suspense = void 0 === t ? null : t;

	        try {
	          e();
	        } finally {
	          b.suspense = n;
	        }
	      },
	      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
	        ReactCurrentDispatcher: C,
	        ReactCurrentBatchConfig: b,
	        ReactCurrentOwner: E,
	        IsSomeRendererActing: {
	          current: !1
	        },
	        assign: r
	      }
	    },
	        Z = {
	      default: G
	    },
	        H = Z && G || Z;
	    e.exports = H.default || H;
	  }, function (e, t, n) {
	    /** @license React v16.9.0
	     * react-dom.production.min.js
	     *
	     * Copyright (c) Facebook, Inc. and its affiliates.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     */

	    var r = n(0),
	        i = n(9),
	        o = n(25);

	    function a(e) {
	      for (var t = e.message, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, r = 1; r < arguments.length; r++) n += "&args[]=" + encodeURIComponent(arguments[r]);

	      return e.message = "Minified React error #" + t + "; visit " + n + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e;
	    }

	    if (!r) throw a(Error(227));
	    var l = null,
	        u = {};

	    function c() {
	      if (l) for (var e in u) {
	        var t = u[e],
	            n = l.indexOf(e);
	        if (!(-1 < n)) throw a(Error(96), e);

	        if (!A[n]) {
	          if (!t.extractEvents) throw a(Error(97), e);

	          for (var r in A[n] = t, n = t.eventTypes) {
	            var i = void 0,
	                o = n[r],
	                c = t,
	                f = r;
	            if (d.hasOwnProperty(f)) throw a(Error(99), f);
	            d[f] = o;
	            var I = o.phasedRegistrationNames;

	            if (I) {
	              for (i in I) I.hasOwnProperty(i) && s(I[i], c, f);

	              i = !0;
	            } else o.registrationName ? (s(o.registrationName, c, f), i = !0) : i = !1;

	            if (!i) throw a(Error(98), r, e);
	          }
	        }
	      }
	    }

	    function s(e, t, n) {
	      if (f[e]) throw a(Error(100), e);
	      f[e] = t, I[e] = t.eventTypes[n].dependencies;
	    }

	    var A = [],
	        d = {},
	        f = {},
	        I = {};
	    var g = !1,
	        M = null,
	        p = !1,
	        N = null,
	        y = {
	      onError: function (e) {
	        g = !0, M = e;
	      }
	    };

	    function v(e, t, n, r, i, o, a, l, u) {
	      g = !1, M = null, function (e, t, n, r, i, o, a, l, u) {
	        var c = Array.prototype.slice.call(arguments, 3);

	        try {
	          t.apply(n, c);
	        } catch (e) {
	          this.onError(e);
	        }
	      }.apply(y, arguments);
	    }

	    var h = null,
	        j = null,
	        m = null;

	    function w(e, t, n) {
	      var r = e.type || "unknown-event";
	      e.currentTarget = m(n), function (e, t, n, r, i, o, l, u, c) {
	        if (v.apply(this, arguments), g) {
	          if (!g) throw a(Error(198));
	          var s = M;
	          g = !1, M = null, p || (p = !0, N = s);
	        }
	      }(r, t, void 0, e), e.currentTarget = null;
	    }

	    function C(e, t) {
	      if (null == t) throw a(Error(30));
	      return null == e ? t : Array.isArray(e) ? Array.isArray(t) ? (e.push.apply(e, t), e) : (e.push(t), e) : Array.isArray(t) ? [e].concat(t) : [e, t];
	    }

	    function b(e, t, n) {
	      Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
	    }

	    var E = null;

	    function D(e) {
	      if (e) {
	        var t = e._dispatchListeners,
	            n = e._dispatchInstances;
	        if (Array.isArray(t)) for (var r = 0; r < t.length && !e.isPropagationStopped(); r++) w(e, t[r], n[r]);else t && w(e, t, n);
	        e._dispatchListeners = null, e._dispatchInstances = null, e.isPersistent() || e.constructor.release(e);
	      }
	    }

	    function T(e) {
	      if (null !== e && (E = C(E, e)), e = E, E = null, e) {
	        if (b(e, D), E) throw a(Error(95));
	        if (p) throw e = N, p = !1, N = null, e;
	      }
	    }

	    var x = {
	      injectEventPluginOrder: function (e) {
	        if (l) throw a(Error(101));
	        l = Array.prototype.slice.call(e), c();
	      },
	      injectEventPluginsByName: function (e) {
	        var t,
	            n = !1;

	        for (t in e) if (e.hasOwnProperty(t)) {
	          var r = e[t];

	          if (!u.hasOwnProperty(t) || u[t] !== r) {
	            if (u[t]) throw a(Error(102), t);
	            u[t] = r, n = !0;
	          }
	        }

	        n && c();
	      }
	    };

	    function S(e, t) {
	      var n = e.stateNode;
	      if (!n) return null;
	      var r = h(n);
	      if (!r) return null;
	      n = r[t];

	      e: switch (t) {
	        case "onClick":
	        case "onClickCapture":
	        case "onDoubleClick":
	        case "onDoubleClickCapture":
	        case "onMouseDown":
	        case "onMouseDownCapture":
	        case "onMouseMove":
	        case "onMouseMoveCapture":
	        case "onMouseUp":
	        case "onMouseUpCapture":
	          (r = !r.disabled) || (r = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !r;
	          break e;

	        default:
	          e = !1;
	      }

	      if (e) return null;
	      if (n && "function" != typeof n) throw a(Error(231), t, typeof n);
	      return n;
	    }

	    var z = Math.random().toString(36).slice(2),
	        L = "__reactInternalInstance$" + z,
	        k = "__reactEventHandlers$" + z;

	    function Q(e) {
	      if (e[L]) return e[L];

	      for (; !e[L];) {
	        if (!e.parentNode) return null;
	        e = e.parentNode;
	      }

	      return 5 === (e = e[L]).tag || 6 === e.tag ? e : null;
	    }

	    function O(e) {
	      return !(e = e[L]) || 5 !== e.tag && 6 !== e.tag ? null : e;
	    }

	    function P(e) {
	      if (5 === e.tag || 6 === e.tag) return e.stateNode;
	      throw a(Error(33));
	    }

	    function B(e) {
	      return e[k] || null;
	    }

	    function U(e) {
	      do {
	        e = e.return;
	      } while (e && 5 !== e.tag);

	      return e || null;
	    }

	    function Y(e, t, n) {
	      (t = S(e, n.dispatchConfig.phasedRegistrationNames[t])) && (n._dispatchListeners = C(n._dispatchListeners, t), n._dispatchInstances = C(n._dispatchInstances, e));
	    }

	    function R(e) {
	      if (e && e.dispatchConfig.phasedRegistrationNames) {
	        for (var t = e._targetInst, n = []; t;) n.push(t), t = U(t);

	        for (t = n.length; 0 < t--;) Y(n[t], "captured", e);

	        for (t = 0; t < n.length; t++) Y(n[t], "bubbled", e);
	      }
	    }

	    function G(e, t, n) {
	      e && n && n.dispatchConfig.registrationName && (t = S(e, n.dispatchConfig.registrationName)) && (n._dispatchListeners = C(n._dispatchListeners, t), n._dispatchInstances = C(n._dispatchInstances, e));
	    }

	    function Z(e) {
	      e && e.dispatchConfig.registrationName && G(e._targetInst, null, e);
	    }

	    function H(e) {
	      b(e, R);
	    }

	    var F = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement);

	    function J(e, t) {
	      var n = {};
	      return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	    }

	    var V = {
	      animationend: J("Animation", "AnimationEnd"),
	      animationiteration: J("Animation", "AnimationIteration"),
	      animationstart: J("Animation", "AnimationStart"),
	      transitionend: J("Transition", "TransitionEnd")
	    },
	        W = {},
	        X = {};

	    function K(e) {
	      if (W[e]) return W[e];
	      if (!V[e]) return e;
	      var t,
	          n = V[e];

	      for (t in n) if (n.hasOwnProperty(t) && t in X) return W[e] = n[t];

	      return e;
	    }

	    F && (X = document.createElement("div").style, "AnimationEvent" in window || (delete V.animationend.animation, delete V.animationiteration.animation, delete V.animationstart.animation), "TransitionEvent" in window || delete V.transitionend.transition);

	    var q = K("animationend"),
	        _ = K("animationiteration"),
	        $ = K("animationstart"),
	        ee = K("transitionend"),
	        te = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
	        ne = null,
	        re = null,
	        ie = null;

	    function oe() {
	      if (ie) return ie;
	      var e,
	          t,
	          n = re,
	          r = n.length,
	          i = "value" in ne ? ne.value : ne.textContent,
	          o = i.length;

	      for (e = 0; e < r && n[e] === i[e]; e++);

	      var a = r - e;

	      for (t = 1; t <= a && n[r - t] === i[o - t]; t++);

	      return ie = i.slice(e, 1 < t ? 1 - t : void 0);
	    }

	    function ae() {
	      return !0;
	    }

	    function le() {
	      return !1;
	    }

	    function ue(e, t, n, r) {
	      for (var i in this.dispatchConfig = e, this._targetInst = t, this.nativeEvent = n, e = this.constructor.Interface) e.hasOwnProperty(i) && ((t = e[i]) ? this[i] = t(n) : "target" === i ? this.target = r : this[i] = n[i]);

	      return this.isDefaultPrevented = (null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue) ? ae : le, this.isPropagationStopped = le, this;
	    }

	    function ce(e, t, n, r) {
	      if (this.eventPool.length) {
	        var i = this.eventPool.pop();
	        return this.call(i, e, t, n, r), i;
	      }

	      return new this(e, t, n, r);
	    }

	    function se(e) {
	      if (!(e instanceof this)) throw a(Error(279));
	      e.destructor(), 10 > this.eventPool.length && this.eventPool.push(e);
	    }

	    function Ae(e) {
	      e.eventPool = [], e.getPooled = ce, e.release = se;
	    }

	    i(ue.prototype, {
	      preventDefault: function () {
	        this.defaultPrevented = !0;
	        var e = this.nativeEvent;
	        e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = ae);
	      },
	      stopPropagation: function () {
	        var e = this.nativeEvent;
	        e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = ae);
	      },
	      persist: function () {
	        this.isPersistent = ae;
	      },
	      isPersistent: le,
	      destructor: function () {
	        var e,
	            t = this.constructor.Interface;

	        for (e in t) this[e] = null;

	        this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = le, this._dispatchInstances = this._dispatchListeners = null;
	      }
	    }), ue.Interface = {
	      type: null,
	      target: null,
	      currentTarget: function () {
	        return null;
	      },
	      eventPhase: null,
	      bubbles: null,
	      cancelable: null,
	      timeStamp: function (e) {
	        return e.timeStamp || Date.now();
	      },
	      defaultPrevented: null,
	      isTrusted: null
	    }, ue.extend = function (e) {
	      function t() {}

	      function n() {
	        return r.apply(this, arguments);
	      }

	      var r = this;
	      t.prototype = r.prototype;
	      var o = new t();
	      return i(o, n.prototype), n.prototype = o, n.prototype.constructor = n, n.Interface = i({}, r.Interface, e), n.extend = r.extend, Ae(n), n;
	    }, Ae(ue);
	    var de = ue.extend({
	      data: null
	    }),
	        fe = ue.extend({
	      data: null
	    }),
	        Ie = [9, 13, 27, 32],
	        ge = F && "CompositionEvent" in window,
	        Me = null;
	    F && "documentMode" in document && (Me = document.documentMode);
	    var pe = F && "TextEvent" in window && !Me,
	        Ne = F && (!ge || Me && 8 < Me && 11 >= Me),
	        ye = String.fromCharCode(32),
	        ve = {
	      beforeInput: {
	        phasedRegistrationNames: {
	          bubbled: "onBeforeInput",
	          captured: "onBeforeInputCapture"
	        },
	        dependencies: ["compositionend", "keypress", "textInput", "paste"]
	      },
	      compositionEnd: {
	        phasedRegistrationNames: {
	          bubbled: "onCompositionEnd",
	          captured: "onCompositionEndCapture"
	        },
	        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
	      },
	      compositionStart: {
	        phasedRegistrationNames: {
	          bubbled: "onCompositionStart",
	          captured: "onCompositionStartCapture"
	        },
	        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
	      },
	      compositionUpdate: {
	        phasedRegistrationNames: {
	          bubbled: "onCompositionUpdate",
	          captured: "onCompositionUpdateCapture"
	        },
	        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
	      }
	    },
	        he = !1;

	    function je(e, t) {
	      switch (e) {
	        case "keyup":
	          return -1 !== Ie.indexOf(t.keyCode);

	        case "keydown":
	          return 229 !== t.keyCode;

	        case "keypress":
	        case "mousedown":
	        case "blur":
	          return !0;

	        default:
	          return !1;
	      }
	    }

	    function me(e) {
	      return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
	    }

	    var we = !1;
	    var Ce = {
	      eventTypes: ve,
	      extractEvents: function (e, t, n, r) {
	        var i = void 0,
	            o = void 0;
	        if (ge) e: {
	          switch (e) {
	            case "compositionstart":
	              i = ve.compositionStart;
	              break e;

	            case "compositionend":
	              i = ve.compositionEnd;
	              break e;

	            case "compositionupdate":
	              i = ve.compositionUpdate;
	              break e;
	          }

	          i = void 0;
	        } else we ? je(e, n) && (i = ve.compositionEnd) : "keydown" === e && 229 === n.keyCode && (i = ve.compositionStart);
	        return i ? (Ne && "ko" !== n.locale && (we || i !== ve.compositionStart ? i === ve.compositionEnd && we && (o = oe()) : (re = "value" in (ne = r) ? ne.value : ne.textContent, we = !0)), i = de.getPooled(i, t, n, r), o ? i.data = o : null !== (o = me(n)) && (i.data = o), H(i), o = i) : o = null, (e = pe ? function (e, t) {
	          switch (e) {
	            case "compositionend":
	              return me(t);

	            case "keypress":
	              return 32 !== t.which ? null : (he = !0, ye);

	            case "textInput":
	              return (e = t.data) === ye && he ? null : e;

	            default:
	              return null;
	          }
	        }(e, n) : function (e, t) {
	          if (we) return "compositionend" === e || !ge && je(e, t) ? (e = oe(), ie = re = ne = null, we = !1, e) : null;

	          switch (e) {
	            case "paste":
	              return null;

	            case "keypress":
	              if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
	                if (t.char && 1 < t.char.length) return t.char;
	                if (t.which) return String.fromCharCode(t.which);
	              }

	              return null;

	            case "compositionend":
	              return Ne && "ko" !== t.locale ? null : t.data;

	            default:
	              return null;
	          }
	        }(e, n)) ? ((t = fe.getPooled(ve.beforeInput, t, n, r)).data = e, H(t)) : t = null, null === o ? t : null === t ? o : [o, t];
	      }
	    },
	        be = null,
	        Ee = null,
	        De = null;

	    function Te(e) {
	      if (e = j(e)) {
	        if ("function" != typeof be) throw a(Error(280));
	        var t = h(e.stateNode);
	        be(e.stateNode, e.type, t);
	      }
	    }

	    function xe(e) {
	      Ee ? De ? De.push(e) : De = [e] : Ee = e;
	    }

	    function Se() {
	      if (Ee) {
	        var e = Ee,
	            t = De;
	        if (De = Ee = null, Te(e), t) for (e = 0; e < t.length; e++) Te(t[e]);
	      }
	    }

	    function ze(e, t) {
	      return e(t);
	    }

	    function Le(e, t, n, r) {
	      return e(t, n, r);
	    }

	    function ke() {}

	    var Qe = ze,
	        Oe = !1;

	    function Pe() {
	      null === Ee && null === De || (ke(), Se());
	    }

	    var Be = {
	      color: !0,
	      date: !0,
	      datetime: !0,
	      "datetime-local": !0,
	      email: !0,
	      month: !0,
	      number: !0,
	      password: !0,
	      range: !0,
	      search: !0,
	      tel: !0,
	      text: !0,
	      time: !0,
	      url: !0,
	      week: !0
	    };

	    function Ue(e) {
	      var t = e && e.nodeName && e.nodeName.toLowerCase();
	      return "input" === t ? !!Be[e.type] : "textarea" === t;
	    }

	    function Ye(e) {
	      return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
	    }

	    function Re(e) {
	      if (!F) return !1;
	      var t = ((e = "on" + e) in document);
	      return t || ((t = document.createElement("div")).setAttribute(e, "return;"), t = "function" == typeof t[e]), t;
	    }

	    function Ge(e) {
	      var t = e.type;
	      return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
	    }

	    function Ze(e) {
	      e._valueTracker || (e._valueTracker = function (e) {
	        var t = Ge(e) ? "checked" : "value",
	            n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
	            r = "" + e[t];

	        if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
	          var i = n.get,
	              o = n.set;
	          return Object.defineProperty(e, t, {
	            configurable: !0,
	            get: function () {
	              return i.call(this);
	            },
	            set: function (e) {
	              r = "" + e, o.call(this, e);
	            }
	          }), Object.defineProperty(e, t, {
	            enumerable: n.enumerable
	          }), {
	            getValue: function () {
	              return r;
	            },
	            setValue: function (e) {
	              r = "" + e;
	            },
	            stopTracking: function () {
	              e._valueTracker = null, delete e[t];
	            }
	          };
	        }
	      }(e));
	    }

	    function He(e) {
	      if (!e) return !1;
	      var t = e._valueTracker;
	      if (!t) return !0;
	      var n = t.getValue(),
	          r = "";
	      return e && (r = Ge(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
	    }

	    var Fe = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	    Fe.hasOwnProperty("ReactCurrentDispatcher") || (Fe.ReactCurrentDispatcher = {
	      current: null
	    }), Fe.hasOwnProperty("ReactCurrentBatchConfig") || (Fe.ReactCurrentBatchConfig = {
	      suspense: null
	    });

	    var Je = /^(.*)[\\\/]/,
	        Ve = "function" == typeof Symbol && Symbol.for,
	        We = Ve ? Symbol.for("react.element") : 60103,
	        Xe = Ve ? Symbol.for("react.portal") : 60106,
	        Ke = Ve ? Symbol.for("react.fragment") : 60107,
	        qe = Ve ? Symbol.for("react.strict_mode") : 60108,
	        _e = Ve ? Symbol.for("react.profiler") : 60114,
	        $e = Ve ? Symbol.for("react.provider") : 60109,
	        et = Ve ? Symbol.for("react.context") : 60110,
	        tt = Ve ? Symbol.for("react.concurrent_mode") : 60111,
	        nt = Ve ? Symbol.for("react.forward_ref") : 60112,
	        rt = Ve ? Symbol.for("react.suspense") : 60113,
	        it = Ve ? Symbol.for("react.suspense_list") : 60120,
	        ot = Ve ? Symbol.for("react.memo") : 60115,
	        at = Ve ? Symbol.for("react.lazy") : 60116;
	    var lt = "function" == typeof Symbol && Symbol.iterator;

	    function ut(e) {
	      return null === e || "object" != typeof e ? null : "function" == typeof (e = lt && e[lt] || e["@@iterator"]) ? e : null;
	    }

	    function ct(e) {
	      if (null == e) return null;
	      if ("function" == typeof e) return e.displayName || e.name || null;
	      if ("string" == typeof e) return e;

	      switch (e) {
	        case Ke:
	          return "Fragment";

	        case Xe:
	          return "Portal";

	        case _e:
	          return "Profiler";

	        case qe:
	          return "StrictMode";

	        case rt:
	          return "Suspense";

	        case it:
	          return "SuspenseList";
	      }

	      if ("object" == typeof e) switch (e.$$typeof) {
	        case et:
	          return "Context.Consumer";

	        case $e:
	          return "Context.Provider";

	        case nt:
	          var t = e.render;
	          return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");

	        case ot:
	          return ct(e.type);

	        case at:
	          if (e = 1 === e._status ? e._result : null) return ct(e);
	      }
	      return null;
	    }

	    function st(e) {
	      var t = "";

	      do {
	        e: switch (e.tag) {
	          case 3:
	          case 4:
	          case 6:
	          case 7:
	          case 10:
	          case 9:
	            var n = "";
	            break e;

	          default:
	            var r = e._debugOwner,
	                i = e._debugSource,
	                o = ct(e.type);
	            n = null, r && (n = ct(r.type)), r = o, o = "", i ? o = " (at " + i.fileName.replace(Je, "") + ":" + i.lineNumber + ")" : n && (o = " (created by " + n + ")"), n = "\n    in " + (r || "Unknown") + o;
	        }

	        t += n, e = e.return;
	      } while (e);

	      return t;
	    }

	    var At = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
	        dt = Object.prototype.hasOwnProperty,
	        ft = {},
	        It = {};

	    function gt(e, t, n, r, i, o) {
	      this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o;
	    }

	    var Mt = {};
	    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
	      Mt[e] = new gt(e, 0, !1, e, null, !1);
	    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
	      var t = e[0];
	      Mt[t] = new gt(t, 1, !1, e[1], null, !1);
	    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
	      Mt[e] = new gt(e, 2, !1, e.toLowerCase(), null, !1);
	    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
	      Mt[e] = new gt(e, 2, !1, e, null, !1);
	    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
	      Mt[e] = new gt(e, 3, !1, e.toLowerCase(), null, !1);
	    }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
	      Mt[e] = new gt(e, 3, !0, e, null, !1);
	    }), ["capture", "download"].forEach(function (e) {
	      Mt[e] = new gt(e, 4, !1, e, null, !1);
	    }), ["cols", "rows", "size", "span"].forEach(function (e) {
	      Mt[e] = new gt(e, 6, !1, e, null, !1);
	    }), ["rowSpan", "start"].forEach(function (e) {
	      Mt[e] = new gt(e, 5, !1, e.toLowerCase(), null, !1);
	    });
	    var pt = /[\-:]([a-z])/g;

	    function Nt(e) {
	      return e[1].toUpperCase();
	    }

	    function yt(e, t, n, r) {
	      var i = Mt.hasOwnProperty(t) ? Mt[t] : null;
	      (null !== i ? 0 === i.type : !r && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function (e, t, n, r) {
	        if (null === t || void 0 === t || function (e, t, n, r) {
	          if (null !== n && 0 === n.type) return !1;

	          switch (typeof t) {
	            case "function":
	            case "symbol":
	              return !0;

	            case "boolean":
	              return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);

	            default:
	              return !1;
	          }
	        }(e, t, n, r)) return !0;
	        if (r) return !1;
	        if (null !== n) switch (n.type) {
	          case 3:
	            return !t;

	          case 4:
	            return !1 === t;

	          case 5:
	            return isNaN(t);

	          case 6:
	            return isNaN(t) || 1 > t;
	        }
	        return !1;
	      }(t, n, i, r) && (n = null), r || null === i ? function (e) {
	        return !!dt.call(It, e) || !dt.call(ft, e) && (At.test(e) ? It[e] = !0 : (ft[e] = !0, !1));
	      }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i.mustUseProperty ? e[i.propertyName] = null === n ? 3 !== i.type && "" : n : (t = i.attributeName, r = i.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (i = i.type) || 4 === i && !0 === n ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
	    }

	    function vt(e) {
	      switch (typeof e) {
	        case "boolean":
	        case "number":
	        case "object":
	        case "string":
	        case "undefined":
	          return e;

	        default:
	          return "";
	      }
	    }

	    function ht(e, t) {
	      var n = t.checked;
	      return i({}, t, {
	        defaultChecked: void 0,
	        defaultValue: void 0,
	        value: void 0,
	        checked: null != n ? n : e._wrapperState.initialChecked
	      });
	    }

	    function jt(e, t) {
	      var n = null == t.defaultValue ? "" : t.defaultValue,
	          r = null != t.checked ? t.checked : t.defaultChecked;
	      n = vt(null != t.value ? t.value : n), e._wrapperState = {
	        initialChecked: r,
	        initialValue: n,
	        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
	      };
	    }

	    function mt(e, t) {
	      null != (t = t.checked) && yt(e, "checked", t, !1);
	    }

	    function wt(e, t) {
	      mt(e, t);
	      var n = vt(t.value),
	          r = t.type;
	      if (null != n) "number" === r ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if ("submit" === r || "reset" === r) return void e.removeAttribute("value");
	      t.hasOwnProperty("value") ? bt(e, t.type, n) : t.hasOwnProperty("defaultValue") && bt(e, t.type, vt(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
	    }

	    function Ct(e, t, n) {
	      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
	        var r = t.type;
	        if (!("submit" !== r && "reset" !== r || void 0 !== t.value && null !== t.value)) return;
	        t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
	      }

	      "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !e.defaultChecked, e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
	    }

	    function bt(e, t, n) {
	      "number" === t && e.ownerDocument.activeElement === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
	    }

	    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
	      var t = e.replace(pt, Nt);
	      Mt[t] = new gt(t, 1, !1, e, null, !1);
	    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
	      var t = e.replace(pt, Nt);
	      Mt[t] = new gt(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
	    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
	      var t = e.replace(pt, Nt);
	      Mt[t] = new gt(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
	    }), ["tabIndex", "crossOrigin"].forEach(function (e) {
	      Mt[e] = new gt(e, 1, !1, e.toLowerCase(), null, !1);
	    }), Mt.xlinkHref = new gt("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (e) {
	      Mt[e] = new gt(e, 1, !1, e.toLowerCase(), null, !0);
	    });
	    var Et = {
	      change: {
	        phasedRegistrationNames: {
	          bubbled: "onChange",
	          captured: "onChangeCapture"
	        },
	        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
	      }
	    };

	    function Dt(e, t, n) {
	      return (e = ue.getPooled(Et.change, e, t, n)).type = "change", xe(n), H(e), e;
	    }

	    var Tt = null,
	        xt = null;

	    function St(e) {
	      T(e);
	    }

	    function zt(e) {
	      if (He(P(e))) return e;
	    }

	    function Lt(e, t) {
	      if ("change" === e) return t;
	    }

	    var kt = !1;

	    function Qt() {
	      Tt && (Tt.detachEvent("onpropertychange", Ot), xt = Tt = null);
	    }

	    function Ot(e) {
	      if ("value" === e.propertyName && zt(xt)) if (e = Dt(xt, e, Ye(e)), Oe) T(e);else {
	        Oe = !0;

	        try {
	          ze(St, e);
	        } finally {
	          Oe = !1, Pe();
	        }
	      }
	    }

	    function Pt(e, t, n) {
	      "focus" === e ? (Qt(), xt = n, (Tt = t).attachEvent("onpropertychange", Ot)) : "blur" === e && Qt();
	    }

	    function Bt(e) {
	      if ("selectionchange" === e || "keyup" === e || "keydown" === e) return zt(xt);
	    }

	    function Ut(e, t) {
	      if ("click" === e) return zt(t);
	    }

	    function Yt(e, t) {
	      if ("input" === e || "change" === e) return zt(t);
	    }

	    F && (kt = Re("input") && (!document.documentMode || 9 < document.documentMode));
	    var Rt = {
	      eventTypes: Et,
	      _isInputEventSupported: kt,
	      extractEvents: function (e, t, n, r) {
	        var i = t ? P(t) : window,
	            o = void 0,
	            a = void 0,
	            l = i.nodeName && i.nodeName.toLowerCase();
	        if ("select" === l || "input" === l && "file" === i.type ? o = Lt : Ue(i) ? kt ? o = Yt : (o = Bt, a = Pt) : (l = i.nodeName) && "input" === l.toLowerCase() && ("checkbox" === i.type || "radio" === i.type) && (o = Ut), o && (o = o(e, t))) return Dt(o, n, r);
	        a && a(e, i, t), "blur" === e && (e = i._wrapperState) && e.controlled && "number" === i.type && bt(i, "number", i.value);
	      }
	    },
	        Gt = ue.extend({
	      view: null,
	      detail: null
	    }),
	        Zt = {
	      Alt: "altKey",
	      Control: "ctrlKey",
	      Meta: "metaKey",
	      Shift: "shiftKey"
	    };

	    function Ht(e) {
	      var t = this.nativeEvent;
	      return t.getModifierState ? t.getModifierState(e) : !!(e = Zt[e]) && !!t[e];
	    }

	    function Ft() {
	      return Ht;
	    }

	    var Jt = 0,
	        Vt = 0,
	        Wt = !1,
	        Xt = !1,
	        Kt = Gt.extend({
	      screenX: null,
	      screenY: null,
	      clientX: null,
	      clientY: null,
	      pageX: null,
	      pageY: null,
	      ctrlKey: null,
	      shiftKey: null,
	      altKey: null,
	      metaKey: null,
	      getModifierState: Ft,
	      button: null,
	      buttons: null,
	      relatedTarget: function (e) {
	        return e.relatedTarget || (e.fromElement === e.srcElement ? e.toElement : e.fromElement);
	      },
	      movementX: function (e) {
	        if ("movementX" in e) return e.movementX;
	        var t = Jt;
	        return Jt = e.screenX, Wt ? "mousemove" === e.type ? e.screenX - t : 0 : (Wt = !0, 0);
	      },
	      movementY: function (e) {
	        if ("movementY" in e) return e.movementY;
	        var t = Vt;
	        return Vt = e.screenY, Xt ? "mousemove" === e.type ? e.screenY - t : 0 : (Xt = !0, 0);
	      }
	    }),
	        qt = Kt.extend({
	      pointerId: null,
	      width: null,
	      height: null,
	      pressure: null,
	      tangentialPressure: null,
	      tiltX: null,
	      tiltY: null,
	      twist: null,
	      pointerType: null,
	      isPrimary: null
	    }),
	        _t = {
	      mouseEnter: {
	        registrationName: "onMouseEnter",
	        dependencies: ["mouseout", "mouseover"]
	      },
	      mouseLeave: {
	        registrationName: "onMouseLeave",
	        dependencies: ["mouseout", "mouseover"]
	      },
	      pointerEnter: {
	        registrationName: "onPointerEnter",
	        dependencies: ["pointerout", "pointerover"]
	      },
	      pointerLeave: {
	        registrationName: "onPointerLeave",
	        dependencies: ["pointerout", "pointerover"]
	      }
	    },
	        $t = {
	      eventTypes: _t,
	      extractEvents: function (e, t, n, r) {
	        var i = "mouseover" === e || "pointerover" === e,
	            o = "mouseout" === e || "pointerout" === e;
	        if (i && (n.relatedTarget || n.fromElement) || !o && !i) return null;
	        if (i = r.window === r ? r : (i = r.ownerDocument) ? i.defaultView || i.parentWindow : window, o ? (o = t, t = (t = n.relatedTarget || n.toElement) ? Q(t) : null) : o = null, o === t) return null;
	        var a = void 0,
	            l = void 0,
	            u = void 0,
	            c = void 0;
	        "mouseout" === e || "mouseover" === e ? (a = Kt, l = _t.mouseLeave, u = _t.mouseEnter, c = "mouse") : "pointerout" !== e && "pointerover" !== e || (a = qt, l = _t.pointerLeave, u = _t.pointerEnter, c = "pointer");
	        var s = null == o ? i : P(o);
	        if (i = null == t ? i : P(t), (e = a.getPooled(l, o, n, r)).type = c + "leave", e.target = s, e.relatedTarget = i, (n = a.getPooled(u, t, n, r)).type = c + "enter", n.target = i, n.relatedTarget = s, r = t, o && r) e: {
	          for (i = r, c = 0, a = t = o; a; a = U(a)) c++;

	          for (a = 0, u = i; u; u = U(u)) a++;

	          for (; 0 < c - a;) t = U(t), c--;

	          for (; 0 < a - c;) i = U(i), a--;

	          for (; c--;) {
	            if (t === i || t === i.alternate) break e;
	            t = U(t), i = U(i);
	          }

	          t = null;
	        } else t = null;

	        for (i = t, t = []; o && o !== i && (null === (c = o.alternate) || c !== i);) t.push(o), o = U(o);

	        for (o = []; r && r !== i && (null === (c = r.alternate) || c !== i);) o.push(r), r = U(r);

	        for (r = 0; r < t.length; r++) G(t[r], "bubbled", e);

	        for (r = o.length; 0 < r--;) G(o[r], "captured", n);

	        return [e, n];
	      }
	    };

	    function en(e, t) {
	      return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
	    }

	    var tn = Object.prototype.hasOwnProperty;

	    function nn(e, t) {
	      if (en(e, t)) return !0;
	      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
	      var n = Object.keys(e),
	          r = Object.keys(t);
	      if (n.length !== r.length) return !1;

	      for (r = 0; r < n.length; r++) if (!tn.call(t, n[r]) || !en(e[n[r]], t[n[r]])) return !1;

	      return !0;
	    }

	    function rn(e, t) {
	      return {
	        responder: e,
	        props: t
	      };
	    }

	    function on(e) {
	      var t = e;
	      if (e.alternate) for (; t.return;) t = t.return;else {
	        if (0 != (2 & t.effectTag)) return 1;

	        for (; t.return;) if (0 != (2 & (t = t.return).effectTag)) return 1;
	      }
	      return 3 === t.tag ? 2 : 3;
	    }

	    function an(e) {
	      if (2 !== on(e)) throw a(Error(188));
	    }

	    function ln(e) {
	      if (!(e = function (e) {
	        var t = e.alternate;

	        if (!t) {
	          if (3 === (t = on(e))) throw a(Error(188));
	          return 1 === t ? null : e;
	        }

	        for (var n = e, r = t;;) {
	          var i = n.return;
	          if (null === i) break;
	          var o = i.alternate;

	          if (null === o) {
	            if (null !== (r = i.return)) {
	              n = r;
	              continue;
	            }

	            break;
	          }

	          if (i.child === o.child) {
	            for (o = i.child; o;) {
	              if (o === n) return an(i), e;
	              if (o === r) return an(i), t;
	              o = o.sibling;
	            }

	            throw a(Error(188));
	          }

	          if (n.return !== r.return) n = i, r = o;else {
	            for (var l = !1, u = i.child; u;) {
	              if (u === n) {
	                l = !0, n = i, r = o;
	                break;
	              }

	              if (u === r) {
	                l = !0, r = i, n = o;
	                break;
	              }

	              u = u.sibling;
	            }

	            if (!l) {
	              for (u = o.child; u;) {
	                if (u === n) {
	                  l = !0, n = o, r = i;
	                  break;
	                }

	                if (u === r) {
	                  l = !0, r = o, n = i;
	                  break;
	                }

	                u = u.sibling;
	              }

	              if (!l) throw a(Error(189));
	            }
	          }
	          if (n.alternate !== r) throw a(Error(190));
	        }

	        if (3 !== n.tag) throw a(Error(188));
	        return n.stateNode.current === n ? e : t;
	      }(e))) return null;

	      for (var t = e;;) {
	        if (5 === t.tag || 6 === t.tag) return t;
	        if (t.child) t.child.return = t, t = t.child;else {
	          if (t === e) break;

	          for (; !t.sibling;) {
	            if (!t.return || t.return === e) return null;
	            t = t.return;
	          }

	          t.sibling.return = t.return, t = t.sibling;
	        }
	      }

	      return null;
	    }
	    var un = ue.extend({
	      animationName: null,
	      elapsedTime: null,
	      pseudoElement: null
	    }),
	        cn = ue.extend({
	      clipboardData: function (e) {
	        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	      }
	    }),
	        sn = Gt.extend({
	      relatedTarget: null
	    });

	    function An(e) {
	      var t = e.keyCode;
	      return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
	    }

	    for (var dn = {
	      Esc: "Escape",
	      Spacebar: " ",
	      Left: "ArrowLeft",
	      Up: "ArrowUp",
	      Right: "ArrowRight",
	      Down: "ArrowDown",
	      Del: "Delete",
	      Win: "OS",
	      Menu: "ContextMenu",
	      Apps: "ContextMenu",
	      Scroll: "ScrollLock",
	      MozPrintableKey: "Unidentified"
	    }, fn = {
	      8: "Backspace",
	      9: "Tab",
	      12: "Clear",
	      13: "Enter",
	      16: "Shift",
	      17: "Control",
	      18: "Alt",
	      19: "Pause",
	      20: "CapsLock",
	      27: "Escape",
	      32: " ",
	      33: "PageUp",
	      34: "PageDown",
	      35: "End",
	      36: "Home",
	      37: "ArrowLeft",
	      38: "ArrowUp",
	      39: "ArrowRight",
	      40: "ArrowDown",
	      45: "Insert",
	      46: "Delete",
	      112: "F1",
	      113: "F2",
	      114: "F3",
	      115: "F4",
	      116: "F5",
	      117: "F6",
	      118: "F7",
	      119: "F8",
	      120: "F9",
	      121: "F10",
	      122: "F11",
	      123: "F12",
	      144: "NumLock",
	      145: "ScrollLock",
	      224: "Meta"
	    }, In = Gt.extend({
	      key: function (e) {
	        if (e.key) {
	          var t = dn[e.key] || e.key;
	          if ("Unidentified" !== t) return t;
	        }

	        return "keypress" === e.type ? 13 === (e = An(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? fn[e.keyCode] || "Unidentified" : "";
	      },
	      location: null,
	      ctrlKey: null,
	      shiftKey: null,
	      altKey: null,
	      metaKey: null,
	      repeat: null,
	      locale: null,
	      getModifierState: Ft,
	      charCode: function (e) {
	        return "keypress" === e.type ? An(e) : 0;
	      },
	      keyCode: function (e) {
	        return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
	      },
	      which: function (e) {
	        return "keypress" === e.type ? An(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
	      }
	    }), gn = Kt.extend({
	      dataTransfer: null
	    }), Mn = Gt.extend({
	      touches: null,
	      targetTouches: null,
	      changedTouches: null,
	      altKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      shiftKey: null,
	      getModifierState: Ft
	    }), pn = ue.extend({
	      propertyName: null,
	      elapsedTime: null,
	      pseudoElement: null
	    }), Nn = Kt.extend({
	      deltaX: function (e) {
	        return ("deltaX" in e) ? e.deltaX : ("wheelDeltaX" in e) ? -e.wheelDeltaX : 0;
	      },
	      deltaY: function (e) {
	        return ("deltaY" in e) ? e.deltaY : ("wheelDeltaY" in e) ? -e.wheelDeltaY : ("wheelDelta" in e) ? -e.wheelDelta : 0;
	      },
	      deltaZ: null,
	      deltaMode: null
	    }), yn = [["blur", "blur", 0], ["cancel", "cancel", 0], ["click", "click", 0], ["close", "close", 0], ["contextmenu", "contextMenu", 0], ["copy", "copy", 0], ["cut", "cut", 0], ["auxclick", "auxClick", 0], ["dblclick", "doubleClick", 0], ["dragend", "dragEnd", 0], ["dragstart", "dragStart", 0], ["drop", "drop", 0], ["focus", "focus", 0], ["input", "input", 0], ["invalid", "invalid", 0], ["keydown", "keyDown", 0], ["keypress", "keyPress", 0], ["keyup", "keyUp", 0], ["mousedown", "mouseDown", 0], ["mouseup", "mouseUp", 0], ["paste", "paste", 0], ["pause", "pause", 0], ["play", "play", 0], ["pointercancel", "pointerCancel", 0], ["pointerdown", "pointerDown", 0], ["pointerup", "pointerUp", 0], ["ratechange", "rateChange", 0], ["reset", "reset", 0], ["seeked", "seeked", 0], ["submit", "submit", 0], ["touchcancel", "touchCancel", 0], ["touchend", "touchEnd", 0], ["touchstart", "touchStart", 0], ["volumechange", "volumeChange", 0], ["drag", "drag", 1], ["dragenter", "dragEnter", 1], ["dragexit", "dragExit", 1], ["dragleave", "dragLeave", 1], ["dragover", "dragOver", 1], ["mousemove", "mouseMove", 1], ["mouseout", "mouseOut", 1], ["mouseover", "mouseOver", 1], ["pointermove", "pointerMove", 1], ["pointerout", "pointerOut", 1], ["pointerover", "pointerOver", 1], ["scroll", "scroll", 1], ["toggle", "toggle", 1], ["touchmove", "touchMove", 1], ["wheel", "wheel", 1], ["abort", "abort", 2], [q, "animationEnd", 2], [_, "animationIteration", 2], [$, "animationStart", 2], ["canplay", "canPlay", 2], ["canplaythrough", "canPlayThrough", 2], ["durationchange", "durationChange", 2], ["emptied", "emptied", 2], ["encrypted", "encrypted", 2], ["ended", "ended", 2], ["error", "error", 2], ["gotpointercapture", "gotPointerCapture", 2], ["load", "load", 2], ["loadeddata", "loadedData", 2], ["loadedmetadata", "loadedMetadata", 2], ["loadstart", "loadStart", 2], ["lostpointercapture", "lostPointerCapture", 2], ["playing", "playing", 2], ["progress", "progress", 2], ["seeking", "seeking", 2], ["stalled", "stalled", 2], ["suspend", "suspend", 2], ["timeupdate", "timeUpdate", 2], [ee, "transitionEnd", 2], ["waiting", "waiting", 2]], vn = {}, hn = {}, jn = 0; jn < yn.length; jn++) {
	      var mn = yn[jn],
	          wn = mn[0],
	          Cn = mn[1],
	          bn = mn[2],
	          En = "on" + (Cn[0].toUpperCase() + Cn.slice(1)),
	          Dn = {
	        phasedRegistrationNames: {
	          bubbled: En,
	          captured: En + "Capture"
	        },
	        dependencies: [wn],
	        eventPriority: bn
	      };
	      vn[Cn] = Dn, hn[wn] = Dn;
	    }

	    var Tn = {
	      eventTypes: vn,
	      getEventPriority: function (e) {
	        return void 0 !== (e = hn[e]) ? e.eventPriority : 2;
	      },
	      extractEvents: function (e, t, n, r) {
	        var i = hn[e];
	        if (!i) return null;

	        switch (e) {
	          case "keypress":
	            if (0 === An(n)) return null;

	          case "keydown":
	          case "keyup":
	            e = In;
	            break;

	          case "blur":
	          case "focus":
	            e = sn;
	            break;

	          case "click":
	            if (2 === n.button) return null;

	          case "auxclick":
	          case "dblclick":
	          case "mousedown":
	          case "mousemove":
	          case "mouseup":
	          case "mouseout":
	          case "mouseover":
	          case "contextmenu":
	            e = Kt;
	            break;

	          case "drag":
	          case "dragend":
	          case "dragenter":
	          case "dragexit":
	          case "dragleave":
	          case "dragover":
	          case "dragstart":
	          case "drop":
	            e = gn;
	            break;

	          case "touchcancel":
	          case "touchend":
	          case "touchmove":
	          case "touchstart":
	            e = Mn;
	            break;

	          case q:
	          case _:
	          case $:
	            e = un;
	            break;

	          case ee:
	            e = pn;
	            break;

	          case "scroll":
	            e = Gt;
	            break;

	          case "wheel":
	            e = Nn;
	            break;

	          case "copy":
	          case "cut":
	          case "paste":
	            e = cn;
	            break;

	          case "gotpointercapture":
	          case "lostpointercapture":
	          case "pointercancel":
	          case "pointerdown":
	          case "pointermove":
	          case "pointerout":
	          case "pointerover":
	          case "pointerup":
	            e = qt;
	            break;

	          default:
	            e = ue;
	        }

	        return H(t = e.getPooled(i, t, n, r)), t;
	      }
	    },
	        xn = Tn.getEventPriority,
	        Sn = [];

	    function zn(e) {
	      var t = e.targetInst,
	          n = t;

	      do {
	        if (!n) {
	          e.ancestors.push(n);
	          break;
	        }

	        var r;

	        for (r = n; r.return;) r = r.return;

	        if (!(r = 3 !== r.tag ? null : r.stateNode.containerInfo)) break;
	        e.ancestors.push(n), n = Q(r);
	      } while (n);

	      for (n = 0; n < e.ancestors.length; n++) {
	        t = e.ancestors[n];
	        var i = Ye(e.nativeEvent);
	        r = e.topLevelType;

	        for (var o = e.nativeEvent, a = null, l = 0; l < A.length; l++) {
	          var u = A[l];
	          u && (u = u.extractEvents(r, t, o, i)) && (a = C(a, u));
	        }

	        T(a);
	      }
	    }

	    var Ln = !0;

	    function kn(e, t) {
	      Qn(t, e, !1);
	    }

	    function Qn(e, t, n) {
	      switch (xn(t)) {
	        case 0:
	          var r = function (e, t, n) {
	            Oe || ke();
	            var r = On,
	                i = Oe;
	            Oe = !0;

	            try {
	              Le(r, e, t, n);
	            } finally {
	              (Oe = i) || Pe();
	            }
	          }.bind(null, t, 1);

	          break;

	        case 1:
	          r = function (e, t, n) {
	            On(e, t, n);
	          }.bind(null, t, 1);

	          break;

	        default:
	          r = On.bind(null, t, 1);
	      }

	      n ? e.addEventListener(t, r, !0) : e.addEventListener(t, r, !1);
	    }

	    function On(e, t, n) {
	      if (Ln) {
	        if (null === (t = Q(t = Ye(n))) || "number" != typeof t.tag || 2 === on(t) || (t = null), Sn.length) {
	          var r = Sn.pop();
	          r.topLevelType = e, r.nativeEvent = n, r.targetInst = t, e = r;
	        } else e = {
	          topLevelType: e,
	          nativeEvent: n,
	          targetInst: t,
	          ancestors: []
	        };

	        try {
	          if (n = e, Oe) zn(n);else {
	            Oe = !0;

	            try {
	              Qe(zn, n, void 0);
	            } finally {
	              Oe = !1, Pe();
	            }
	          }
	        } finally {
	          e.topLevelType = null, e.nativeEvent = null, e.targetInst = null, e.ancestors.length = 0, 10 > Sn.length && Sn.push(e);
	        }
	      }
	    }

	    var Pn = new ("function" == typeof WeakMap ? WeakMap : Map)();

	    function Bn(e) {
	      var t = Pn.get(e);
	      return void 0 === t && (t = new Set(), Pn.set(e, t)), t;
	    }

	    function Un(e) {
	      if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;

	      try {
	        return e.activeElement || e.body;
	      } catch (t) {
	        return e.body;
	      }
	    }

	    function Yn(e) {
	      for (; e && e.firstChild;) e = e.firstChild;

	      return e;
	    }

	    function Rn(e, t) {
	      var n,
	          r = Yn(e);

	      for (e = 0; r;) {
	        if (3 === r.nodeType) {
	          if (n = e + r.textContent.length, e <= t && n >= t) return {
	            node: r,
	            offset: t - e
	          };
	          e = n;
	        }

	        e: {
	          for (; r;) {
	            if (r.nextSibling) {
	              r = r.nextSibling;
	              break e;
	            }

	            r = r.parentNode;
	          }

	          r = void 0;
	        }

	        r = Yn(r);
	      }
	    }

	    function Gn() {
	      for (var e = window, t = Un(); t instanceof e.HTMLIFrameElement;) {
	        try {
	          var n = "string" == typeof t.contentWindow.location.href;
	        } catch (e) {
	          n = !1;
	        }

	        if (!n) break;
	        t = Un((e = t.contentWindow).document);
	      }

	      return t;
	    }

	    function Zn(e) {
	      var t = e && e.nodeName && e.nodeName.toLowerCase();
	      return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
	    }

	    var Hn = F && "documentMode" in document && 11 >= document.documentMode,
	        Fn = {
	      select: {
	        phasedRegistrationNames: {
	          bubbled: "onSelect",
	          captured: "onSelectCapture"
	        },
	        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
	      }
	    },
	        Jn = null,
	        Vn = null,
	        Wn = null,
	        Xn = !1;

	    function Kn(e, t) {
	      var n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
	      return Xn || null == Jn || Jn !== Un(n) ? null : ("selectionStart" in (n = Jn) && Zn(n) ? n = {
	        start: n.selectionStart,
	        end: n.selectionEnd
	      } : n = {
	        anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
	        anchorOffset: n.anchorOffset,
	        focusNode: n.focusNode,
	        focusOffset: n.focusOffset
	      }, Wn && nn(Wn, n) ? null : (Wn = n, (e = ue.getPooled(Fn.select, Vn, e, t)).type = "select", e.target = Jn, H(e), e));
	    }

	    var qn = {
	      eventTypes: Fn,
	      extractEvents: function (e, t, n, r) {
	        var i,
	            o = r.window === r ? r.document : 9 === r.nodeType ? r : r.ownerDocument;

	        if (!(i = !o)) {
	          e: {
	            o = Bn(o), i = I.onSelect;

	            for (var a = 0; a < i.length; a++) if (!o.has(i[a])) {
	              o = !1;
	              break e;
	            }

	            o = !0;
	          }

	          i = !o;
	        }

	        if (i) return null;

	        switch (o = t ? P(t) : window, e) {
	          case "focus":
	            (Ue(o) || "true" === o.contentEditable) && (Jn = o, Vn = t, Wn = null);
	            break;

	          case "blur":
	            Wn = Vn = Jn = null;
	            break;

	          case "mousedown":
	            Xn = !0;
	            break;

	          case "contextmenu":
	          case "mouseup":
	          case "dragend":
	            return Xn = !1, Kn(n, r);

	          case "selectionchange":
	            if (Hn) break;

	          case "keydown":
	          case "keyup":
	            return Kn(n, r);
	        }

	        return null;
	      }
	    };

	    function _n(e, t) {
	      return e = i({
	        children: void 0
	      }, t), (t = function (e) {
	        var t = "";
	        return r.Children.forEach(e, function (e) {
	          null != e && (t += e);
	        }), t;
	      }(t.children)) && (e.children = t), e;
	    }

	    function $n(e, t, n, r) {
	      if (e = e.options, t) {
	        t = {};

	        for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;

	        for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
	      } else {
	        for (n = "" + vt(n), t = null, i = 0; i < e.length; i++) {
	          if (e[i].value === n) return e[i].selected = !0, void (r && (e[i].defaultSelected = !0));
	          null !== t || e[i].disabled || (t = e[i]);
	        }

	        null !== t && (t.selected = !0);
	      }
	    }

	    function er(e, t) {
	      if (null != t.dangerouslySetInnerHTML) throw a(Error(91));
	      return i({}, t, {
	        value: void 0,
	        defaultValue: void 0,
	        children: "" + e._wrapperState.initialValue
	      });
	    }

	    function tr(e, t) {
	      var n = t.value;

	      if (null == n) {
	        if (n = t.defaultValue, null != (t = t.children)) {
	          if (null != n) throw a(Error(92));

	          if (Array.isArray(t)) {
	            if (!(1 >= t.length)) throw a(Error(93));
	            t = t[0];
	          }

	          n = t;
	        }

	        null == n && (n = "");
	      }

	      e._wrapperState = {
	        initialValue: vt(n)
	      };
	    }

	    function nr(e, t) {
	      var n = vt(t.value),
	          r = vt(t.defaultValue);
	      null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != r && (e.defaultValue = "" + r);
	    }

	    function rr(e) {
	      var t = e.textContent;
	      t === e._wrapperState.initialValue && (e.value = t);
	    }

	    x.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), h = B, j = O, m = P, x.injectEventPluginsByName({
	      SimpleEventPlugin: Tn,
	      EnterLeaveEventPlugin: $t,
	      ChangeEventPlugin: Rt,
	      SelectEventPlugin: qn,
	      BeforeInputEventPlugin: Ce
	    });
	    var ir = {
	      html: "http://www.w3.org/1999/xhtml",
	      mathml: "http://www.w3.org/1998/Math/MathML",
	      svg: "http://www.w3.org/2000/svg"
	    };

	    function or(e) {
	      switch (e) {
	        case "svg":
	          return "http://www.w3.org/2000/svg";

	        case "math":
	          return "http://www.w3.org/1998/Math/MathML";

	        default:
	          return "http://www.w3.org/1999/xhtml";
	      }
	    }

	    function ar(e, t) {
	      return null == e || "http://www.w3.org/1999/xhtml" === e ? or(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
	    }

	    var lr = void 0,
	        ur = function (e) {
	      return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (t, n, r, i) {
	        MSApp.execUnsafeLocalFunction(function () {
	          return e(t, n);
	        });
	      } : e;
	    }(function (e, t) {
	      if (e.namespaceURI !== ir.svg || "innerHTML" in e) e.innerHTML = t;else {
	        for ((lr = lr || document.createElement("div")).innerHTML = "<svg>" + t + "</svg>", t = lr.firstChild; e.firstChild;) e.removeChild(e.firstChild);

	        for (; t.firstChild;) e.appendChild(t.firstChild);
	      }
	    });

	    function cr(e, t) {
	      if (t) {
	        var n = e.firstChild;
	        if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
	      }

	      e.textContent = t;
	    }

	    var sr = {
	      animationIterationCount: !0,
	      borderImageOutset: !0,
	      borderImageSlice: !0,
	      borderImageWidth: !0,
	      boxFlex: !0,
	      boxFlexGroup: !0,
	      boxOrdinalGroup: !0,
	      columnCount: !0,
	      columns: !0,
	      flex: !0,
	      flexGrow: !0,
	      flexPositive: !0,
	      flexShrink: !0,
	      flexNegative: !0,
	      flexOrder: !0,
	      gridArea: !0,
	      gridRow: !0,
	      gridRowEnd: !0,
	      gridRowSpan: !0,
	      gridRowStart: !0,
	      gridColumn: !0,
	      gridColumnEnd: !0,
	      gridColumnSpan: !0,
	      gridColumnStart: !0,
	      fontWeight: !0,
	      lineClamp: !0,
	      lineHeight: !0,
	      opacity: !0,
	      order: !0,
	      orphans: !0,
	      tabSize: !0,
	      widows: !0,
	      zIndex: !0,
	      zoom: !0,
	      fillOpacity: !0,
	      floodOpacity: !0,
	      stopOpacity: !0,
	      strokeDasharray: !0,
	      strokeDashoffset: !0,
	      strokeMiterlimit: !0,
	      strokeOpacity: !0,
	      strokeWidth: !0
	    },
	        Ar = ["Webkit", "ms", "Moz", "O"];

	    function dr(e, t, n) {
	      return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || sr.hasOwnProperty(e) && sr[e] ? ("" + t).trim() : t + "px";
	    }

	    function fr(e, t) {
	      for (var n in e = e.style, t) if (t.hasOwnProperty(n)) {
	        var r = 0 === n.indexOf("--"),
	            i = dr(n, t[n], r);
	        "float" === n && (n = "cssFloat"), r ? e.setProperty(n, i) : e[n] = i;
	      }
	    }

	    Object.keys(sr).forEach(function (e) {
	      Ar.forEach(function (t) {
	        t = t + e.charAt(0).toUpperCase() + e.substring(1), sr[t] = sr[e];
	      });
	    });
	    var Ir = i({
	      menuitem: !0
	    }, {
	      area: !0,
	      base: !0,
	      br: !0,
	      col: !0,
	      embed: !0,
	      hr: !0,
	      img: !0,
	      input: !0,
	      keygen: !0,
	      link: !0,
	      meta: !0,
	      param: !0,
	      source: !0,
	      track: !0,
	      wbr: !0
	    });

	    function gr(e, t) {
	      if (t) {
	        if (Ir[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw a(Error(137), e, "");

	        if (null != t.dangerouslySetInnerHTML) {
	          if (null != t.children) throw a(Error(60));
	          if (!("object" == typeof t.dangerouslySetInnerHTML && "__html" in t.dangerouslySetInnerHTML)) throw a(Error(61));
	        }

	        if (null != t.style && "object" != typeof t.style) throw a(Error(62), "");
	      }
	    }

	    function Mr(e, t) {
	      if (-1 === e.indexOf("-")) return "string" == typeof t.is;

	      switch (e) {
	        case "annotation-xml":
	        case "color-profile":
	        case "font-face":
	        case "font-face-src":
	        case "font-face-uri":
	        case "font-face-format":
	        case "font-face-name":
	        case "missing-glyph":
	          return !1;

	        default:
	          return !0;
	      }
	    }

	    function pr(e, t) {
	      var n = Bn(e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument);
	      t = I[t];

	      for (var r = 0; r < t.length; r++) {
	        var i = t[r];

	        if (!n.has(i)) {
	          switch (i) {
	            case "scroll":
	              Qn(e, "scroll", !0);
	              break;

	            case "focus":
	            case "blur":
	              Qn(e, "focus", !0), Qn(e, "blur", !0), n.add("blur"), n.add("focus");
	              break;

	            case "cancel":
	            case "close":
	              Re(i) && Qn(e, i, !0);
	              break;

	            case "invalid":
	            case "submit":
	            case "reset":
	              break;

	            default:
	              -1 === te.indexOf(i) && kn(i, e);
	          }

	          n.add(i);
	        }
	      }
	    }

	    function Nr() {}

	    var yr = null,
	        vr = null;

	    function hr(e, t) {
	      switch (e) {
	        case "button":
	        case "input":
	        case "select":
	        case "textarea":
	          return !!t.autoFocus;
	      }

	      return !1;
	    }

	    function jr(e, t) {
	      return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
	    }

	    var mr = "function" == typeof setTimeout ? setTimeout : void 0,
	        wr = "function" == typeof clearTimeout ? clearTimeout : void 0;

	    function Cr(e) {
	      for (; null != e; e = e.nextSibling) {
	        var t = e.nodeType;
	        if (1 === t || 3 === t) break;
	      }

	      return e;
	    }
	    var br = [],
	        Er = -1;

	    function Dr(e) {
	      0 > Er || (e.current = br[Er], br[Er] = null, Er--);
	    }

	    function Tr(e, t) {
	      br[++Er] = e.current, e.current = t;
	    }

	    var xr = {},
	        Sr = {
	      current: xr
	    },
	        zr = {
	      current: !1
	    },
	        Lr = xr;

	    function kr(e, t) {
	      var n = e.type.contextTypes;
	      if (!n) return xr;
	      var r = e.stateNode;
	      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
	      var i,
	          o = {};

	      for (i in n) o[i] = t[i];

	      return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = o), o;
	    }

	    function Qr(e) {
	      return null !== (e = e.childContextTypes) && void 0 !== e;
	    }

	    function Or(e) {
	      Dr(zr), Dr(Sr);
	    }

	    function Pr(e) {
	      Dr(zr), Dr(Sr);
	    }

	    function Br(e, t, n) {
	      if (Sr.current !== xr) throw a(Error(168));
	      Tr(Sr, t), Tr(zr, n);
	    }

	    function Ur(e, t, n) {
	      var r = e.stateNode;
	      if (e = t.childContextTypes, "function" != typeof r.getChildContext) return n;

	      for (var o in r = r.getChildContext()) if (!(o in e)) throw a(Error(108), ct(t) || "Unknown", o);

	      return i({}, n, r);
	    }

	    function Yr(e) {
	      var t = e.stateNode;
	      return t = t && t.__reactInternalMemoizedMergedChildContext || xr, Lr = Sr.current, Tr(Sr, t), Tr(zr, zr.current), !0;
	    }

	    function Rr(e, t, n) {
	      var r = e.stateNode;
	      if (!r) throw a(Error(169));
	      n ? (t = Ur(e, t, Lr), r.__reactInternalMemoizedMergedChildContext = t, Dr(zr), Dr(Sr), Tr(Sr, t)) : Dr(zr), Tr(zr, n);
	    }

	    var Gr = o.unstable_runWithPriority,
	        Zr = o.unstable_scheduleCallback,
	        Hr = o.unstable_cancelCallback,
	        Fr = o.unstable_shouldYield,
	        Jr = o.unstable_requestPaint,
	        Vr = o.unstable_now,
	        Wr = o.unstable_getCurrentPriorityLevel,
	        Xr = o.unstable_ImmediatePriority,
	        Kr = o.unstable_UserBlockingPriority,
	        qr = o.unstable_NormalPriority,
	        _r = o.unstable_LowPriority,
	        $r = o.unstable_IdlePriority,
	        ei = {},
	        ti = void 0 !== Jr ? Jr : function () {},
	        ni = null,
	        ri = null,
	        ii = !1,
	        oi = Vr(),
	        ai = 1e4 > oi ? Vr : function () {
	      return Vr() - oi;
	    };

	    function li() {
	      switch (Wr()) {
	        case Xr:
	          return 99;

	        case Kr:
	          return 98;

	        case qr:
	          return 97;

	        case _r:
	          return 96;

	        case $r:
	          return 95;

	        default:
	          throw a(Error(332));
	      }
	    }

	    function ui(e) {
	      switch (e) {
	        case 99:
	          return Xr;

	        case 98:
	          return Kr;

	        case 97:
	          return qr;

	        case 96:
	          return _r;

	        case 95:
	          return $r;

	        default:
	          throw a(Error(332));
	      }
	    }

	    function ci(e, t) {
	      return e = ui(e), Gr(e, t);
	    }

	    function si(e, t, n) {
	      return e = ui(e), Zr(e, t, n);
	    }

	    function Ai(e) {
	      return null === ni ? (ni = [e], ri = Zr(Xr, fi)) : ni.push(e), ei;
	    }

	    function di() {
	      null !== ri && Hr(ri), fi();
	    }

	    function fi() {
	      if (!ii && null !== ni) {
	        ii = !0;
	        var e = 0;

	        try {
	          var t = ni;
	          ci(99, function () {
	            for (; e < t.length; e++) {
	              var n = t[e];

	              do {
	                n = n(!0);
	              } while (null !== n);
	            }
	          }), ni = null;
	        } catch (t) {
	          throw null !== ni && (ni = ni.slice(e + 1)), Zr(Xr, di), t;
	        } finally {
	          ii = !1;
	        }
	      }
	    }

	    function Ii(e, t) {
	      return 1073741823 === t ? 99 : 1 === t ? 95 : 0 >= (e = 10 * (1073741821 - t) - 10 * (1073741821 - e)) ? 99 : 250 >= e ? 98 : 5250 >= e ? 97 : 95;
	    }

	    function gi(e, t) {
	      if (e && e.defaultProps) for (var n in t = i({}, t), e = e.defaultProps) void 0 === t[n] && (t[n] = e[n]);
	      return t;
	    }

	    var Mi = {
	      current: null
	    },
	        pi = null,
	        Ni = null,
	        yi = null;

	    function vi() {
	      yi = Ni = pi = null;
	    }

	    function hi(e, t) {
	      var n = e.type._context;
	      Tr(Mi, n._currentValue), n._currentValue = t;
	    }

	    function ji(e) {
	      var t = Mi.current;
	      Dr(Mi), e.type._context._currentValue = t;
	    }

	    function mi(e, t) {
	      for (; null !== e;) {
	        var n = e.alternate;
	        if (e.childExpirationTime < t) e.childExpirationTime = t, null !== n && n.childExpirationTime < t && (n.childExpirationTime = t);else {
	          if (!(null !== n && n.childExpirationTime < t)) break;
	          n.childExpirationTime = t;
	        }
	        e = e.return;
	      }
	    }

	    function wi(e, t) {
	      pi = e, yi = Ni = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (ua = !0), e.firstContext = null);
	    }

	    function Ci(e, t) {
	      if (yi !== e && !1 !== t && 0 !== t) if ("number" == typeof t && 1073741823 !== t || (yi = e, t = 1073741823), t = {
	        context: e,
	        observedBits: t,
	        next: null
	      }, null === Ni) {
	        if (null === pi) throw a(Error(308));
	        Ni = t, pi.dependencies = {
	          expirationTime: 0,
	          firstContext: t,
	          responders: null
	        };
	      } else Ni = Ni.next = t;
	      return e._currentValue;
	    }

	    var bi = !1;

	    function Ei(e) {
	      return {
	        baseState: e,
	        firstUpdate: null,
	        lastUpdate: null,
	        firstCapturedUpdate: null,
	        lastCapturedUpdate: null,
	        firstEffect: null,
	        lastEffect: null,
	        firstCapturedEffect: null,
	        lastCapturedEffect: null
	      };
	    }

	    function Di(e) {
	      return {
	        baseState: e.baseState,
	        firstUpdate: e.firstUpdate,
	        lastUpdate: e.lastUpdate,
	        firstCapturedUpdate: null,
	        lastCapturedUpdate: null,
	        firstEffect: null,
	        lastEffect: null,
	        firstCapturedEffect: null,
	        lastCapturedEffect: null
	      };
	    }

	    function Ti(e, t) {
	      return {
	        expirationTime: e,
	        suspenseConfig: t,
	        tag: 0,
	        payload: null,
	        callback: null,
	        next: null,
	        nextEffect: null
	      };
	    }

	    function xi(e, t) {
	      null === e.lastUpdate ? e.firstUpdate = e.lastUpdate = t : (e.lastUpdate.next = t, e.lastUpdate = t);
	    }

	    function Si(e, t) {
	      var n = e.alternate;

	      if (null === n) {
	        var r = e.updateQueue,
	            i = null;
	        null === r && (r = e.updateQueue = Ei(e.memoizedState));
	      } else r = e.updateQueue, i = n.updateQueue, null === r ? null === i ? (r = e.updateQueue = Ei(e.memoizedState), i = n.updateQueue = Ei(n.memoizedState)) : r = e.updateQueue = Di(i) : null === i && (i = n.updateQueue = Di(r));

	      null === i || r === i ? xi(r, t) : null === r.lastUpdate || null === i.lastUpdate ? (xi(r, t), xi(i, t)) : (xi(r, t), i.lastUpdate = t);
	    }

	    function zi(e, t) {
	      var n = e.updateQueue;
	      null === (n = null === n ? e.updateQueue = Ei(e.memoizedState) : Li(e, n)).lastCapturedUpdate ? n.firstCapturedUpdate = n.lastCapturedUpdate = t : (n.lastCapturedUpdate.next = t, n.lastCapturedUpdate = t);
	    }

	    function Li(e, t) {
	      var n = e.alternate;
	      return null !== n && t === n.updateQueue && (t = e.updateQueue = Di(t)), t;
	    }

	    function ki(e, t, n, r, o, a) {
	      switch (n.tag) {
	        case 1:
	          return "function" == typeof (e = n.payload) ? e.call(a, r, o) : e;

	        case 3:
	          e.effectTag = -2049 & e.effectTag | 64;

	        case 0:
	          if (null === (o = "function" == typeof (e = n.payload) ? e.call(a, r, o) : e) || void 0 === o) break;
	          return i({}, r, o);

	        case 2:
	          bi = !0;
	      }

	      return r;
	    }

	    function Qi(e, t, n, r, i) {
	      bi = !1;

	      for (var o = (t = Li(e, t)).baseState, a = null, l = 0, u = t.firstUpdate, c = o; null !== u;) {
	        var s = u.expirationTime;
	        s < i ? (null === a && (a = u, o = c), l < s && (l = s)) : (Ul(s, u.suspenseConfig), c = ki(e, 0, u, c, n, r), null !== u.callback && (e.effectTag |= 32, u.nextEffect = null, null === t.lastEffect ? t.firstEffect = t.lastEffect = u : (t.lastEffect.nextEffect = u, t.lastEffect = u))), u = u.next;
	      }

	      for (s = null, u = t.firstCapturedUpdate; null !== u;) {
	        var A = u.expirationTime;
	        A < i ? (null === s && (s = u, null === a && (o = c)), l < A && (l = A)) : (c = ki(e, 0, u, c, n, r), null !== u.callback && (e.effectTag |= 32, u.nextEffect = null, null === t.lastCapturedEffect ? t.firstCapturedEffect = t.lastCapturedEffect = u : (t.lastCapturedEffect.nextEffect = u, t.lastCapturedEffect = u))), u = u.next;
	      }

	      null === a && (t.lastUpdate = null), null === s ? t.lastCapturedUpdate = null : e.effectTag |= 32, null === a && null === s && (o = c), t.baseState = o, t.firstUpdate = a, t.firstCapturedUpdate = s, e.expirationTime = l, e.memoizedState = c;
	    }

	    function Oi(e, t, n) {
	      null !== t.firstCapturedUpdate && (null !== t.lastUpdate && (t.lastUpdate.next = t.firstCapturedUpdate, t.lastUpdate = t.lastCapturedUpdate), t.firstCapturedUpdate = t.lastCapturedUpdate = null), Pi(t.firstEffect, n), t.firstEffect = t.lastEffect = null, Pi(t.firstCapturedEffect, n), t.firstCapturedEffect = t.lastCapturedEffect = null;
	    }

	    function Pi(e, t) {
	      for (; null !== e;) {
	        var n = e.callback;

	        if (null !== n) {
	          e.callback = null;
	          var r = t;
	          if ("function" != typeof n) throw a(Error(191), n);
	          n.call(r);
	        }

	        e = e.nextEffect;
	      }
	    }

	    var Bi = Fe.ReactCurrentBatchConfig,
	        Ui = new r.Component().refs;

	    function Yi(e, t, n, r) {
	      n = null === (n = n(r, t = e.memoizedState)) || void 0 === n ? t : i({}, t, n), e.memoizedState = n, null !== (r = e.updateQueue) && 0 === e.expirationTime && (r.baseState = n);
	    }

	    var Ri = {
	      isMounted: function (e) {
	        return !!(e = e._reactInternalFiber) && 2 === on(e);
	      },
	      enqueueSetState: function (e, t, n) {
	        e = e._reactInternalFiber;
	        var r = bl(),
	            i = Bi.suspense;
	        (i = Ti(r = El(r, e, i), i)).payload = t, void 0 !== n && null !== n && (i.callback = n), Si(e, i), Tl(e, r);
	      },
	      enqueueReplaceState: function (e, t, n) {
	        e = e._reactInternalFiber;
	        var r = bl(),
	            i = Bi.suspense;
	        (i = Ti(r = El(r, e, i), i)).tag = 1, i.payload = t, void 0 !== n && null !== n && (i.callback = n), Si(e, i), Tl(e, r);
	      },
	      enqueueForceUpdate: function (e, t) {
	        e = e._reactInternalFiber;
	        var n = bl(),
	            r = Bi.suspense;
	        (r = Ti(n = El(n, e, r), r)).tag = 2, void 0 !== t && null !== t && (r.callback = t), Si(e, r), Tl(e, n);
	      }
	    };

	    function Gi(e, t, n, r, i, o, a) {
	      return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, o, a) : !t.prototype || !t.prototype.isPureReactComponent || !nn(n, r) || !nn(i, o);
	    }

	    function Zi(e, t, n) {
	      var r = !1,
	          i = xr,
	          o = t.contextType;
	      return "object" == typeof o && null !== o ? o = Ci(o) : (i = Qr(t) ? Lr : Sr.current, o = (r = null !== (r = t.contextTypes) && void 0 !== r) ? kr(e, i) : xr), t = new t(n, o), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Ri, e.stateNode = t, t._reactInternalFiber = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
	    }

	    function Hi(e, t, n, r) {
	      e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ri.enqueueReplaceState(t, t.state, null);
	    }

	    function Fi(e, t, n, r) {
	      var i = e.stateNode;
	      i.props = n, i.state = e.memoizedState, i.refs = Ui;
	      var o = t.contextType;
	      "object" == typeof o && null !== o ? i.context = Ci(o) : (o = Qr(t) ? Lr : Sr.current, i.context = kr(e, o)), null !== (o = e.updateQueue) && (Qi(e, o, n, i, r), i.state = e.memoizedState), "function" == typeof (o = t.getDerivedStateFromProps) && (Yi(e, t, o, n), i.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && Ri.enqueueReplaceState(i, i.state, null), null !== (o = e.updateQueue) && (Qi(e, o, n, i, r), i.state = e.memoizedState)), "function" == typeof i.componentDidMount && (e.effectTag |= 4);
	    }

	    var Ji = Array.isArray;

	    function Vi(e, t, n) {
	      if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
	        if (n._owner) {
	          var r = void 0;

	          if (n = n._owner) {
	            if (1 !== n.tag) throw a(Error(309));
	            r = n.stateNode;
	          }

	          if (!r) throw a(Error(147), e);
	          var i = "" + e;
	          return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === i ? t.ref : ((t = function (e) {
	            var t = r.refs;
	            t === Ui && (t = r.refs = {}), null === e ? delete t[i] : t[i] = e;
	          })._stringRef = i, t);
	        }

	        if ("string" != typeof e) throw a(Error(284));
	        if (!n._owner) throw a(Error(290), e);
	      }

	      return e;
	    }

	    function Wi(e, t) {
	      if ("textarea" !== e.type) throw a(Error(31), "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, "");
	    }

	    function Xi(e) {
	      function t(t, n) {
	        if (e) {
	          var r = t.lastEffect;
	          null !== r ? (r.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
	        }
	      }

	      function n(n, r) {
	        if (!e) return null;

	        for (; null !== r;) t(n, r), r = r.sibling;

	        return null;
	      }

	      function r(e, t) {
	        for (e = new Map(); null !== t;) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;

	        return e;
	      }

	      function i(e, t, n) {
	        return (e = _l(e, t)).index = 0, e.sibling = null, e;
	      }

	      function o(t, n, r) {
	        return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.effectTag = 2, n) : r : (t.effectTag = 2, n) : n;
	      }

	      function l(t) {
	        return e && null === t.alternate && (t.effectTag = 2), t;
	      }

	      function u(e, t, n, r) {
	        return null === t || 6 !== t.tag ? ((t = tu(n, e.mode, r)).return = e, t) : ((t = i(t, n)).return = e, t);
	      }

	      function c(e, t, n, r) {
	        return null !== t && t.elementType === n.type ? ((r = i(t, n.props)).ref = Vi(e, t, n), r.return = e, r) : ((r = $l(n.type, n.key, n.props, null, e.mode, r)).ref = Vi(e, t, n), r.return = e, r);
	      }

	      function s(e, t, n, r) {
	        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = nu(n, e.mode, r)).return = e, t) : ((t = i(t, n.children || [])).return = e, t);
	      }

	      function A(e, t, n, r, o) {
	        return null === t || 7 !== t.tag ? ((t = eu(n, e.mode, r, o)).return = e, t) : ((t = i(t, n)).return = e, t);
	      }

	      function d(e, t, n) {
	        if ("string" == typeof t || "number" == typeof t) return (t = tu("" + t, e.mode, n)).return = e, t;

	        if ("object" == typeof t && null !== t) {
	          switch (t.$$typeof) {
	            case We:
	              return (n = $l(t.type, t.key, t.props, null, e.mode, n)).ref = Vi(e, null, t), n.return = e, n;

	            case Xe:
	              return (t = nu(t, e.mode, n)).return = e, t;
	          }

	          if (Ji(t) || ut(t)) return (t = eu(t, e.mode, n, null)).return = e, t;
	          Wi(e, t);
	        }

	        return null;
	      }

	      function f(e, t, n, r) {
	        var i = null !== t ? t.key : null;
	        if ("string" == typeof n || "number" == typeof n) return null !== i ? null : u(e, t, "" + n, r);

	        if ("object" == typeof n && null !== n) {
	          switch (n.$$typeof) {
	            case We:
	              return n.key === i ? n.type === Ke ? A(e, t, n.props.children, r, i) : c(e, t, n, r) : null;

	            case Xe:
	              return n.key === i ? s(e, t, n, r) : null;
	          }

	          if (Ji(n) || ut(n)) return null !== i ? null : A(e, t, n, r, null);
	          Wi(e, n);
	        }

	        return null;
	      }

	      function I(e, t, n, r, i) {
	        if ("string" == typeof r || "number" == typeof r) return u(t, e = e.get(n) || null, "" + r, i);

	        if ("object" == typeof r && null !== r) {
	          switch (r.$$typeof) {
	            case We:
	              return e = e.get(null === r.key ? n : r.key) || null, r.type === Ke ? A(t, e, r.props.children, i, r.key) : c(t, e, r, i);

	            case Xe:
	              return s(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
	          }

	          if (Ji(r) || ut(r)) return A(t, e = e.get(n) || null, r, i, null);
	          Wi(t, r);
	        }

	        return null;
	      }

	      function g(i, a, l, u) {
	        for (var c = null, s = null, A = a, g = a = 0, M = null; null !== A && g < l.length; g++) {
	          A.index > g ? (M = A, A = null) : M = A.sibling;
	          var p = f(i, A, l[g], u);

	          if (null === p) {
	            null === A && (A = M);
	            break;
	          }

	          e && A && null === p.alternate && t(i, A), a = o(p, a, g), null === s ? c = p : s.sibling = p, s = p, A = M;
	        }

	        if (g === l.length) return n(i, A), c;

	        if (null === A) {
	          for (; g < l.length; g++) null !== (A = d(i, l[g], u)) && (a = o(A, a, g), null === s ? c = A : s.sibling = A, s = A);

	          return c;
	        }

	        for (A = r(i, A); g < l.length; g++) null !== (M = I(A, i, g, l[g], u)) && (e && null !== M.alternate && A.delete(null === M.key ? g : M.key), a = o(M, a, g), null === s ? c = M : s.sibling = M, s = M);

	        return e && A.forEach(function (e) {
	          return t(i, e);
	        }), c;
	      }

	      function M(i, l, u, c) {
	        var s = ut(u);
	        if ("function" != typeof s) throw a(Error(150));
	        if (null == (u = s.call(u))) throw a(Error(151));

	        for (var A = s = null, g = l, M = l = 0, p = null, N = u.next(); null !== g && !N.done; M++, N = u.next()) {
	          g.index > M ? (p = g, g = null) : p = g.sibling;
	          var y = f(i, g, N.value, c);

	          if (null === y) {
	            null === g && (g = p);
	            break;
	          }

	          e && g && null === y.alternate && t(i, g), l = o(y, l, M), null === A ? s = y : A.sibling = y, A = y, g = p;
	        }

	        if (N.done) return n(i, g), s;

	        if (null === g) {
	          for (; !N.done; M++, N = u.next()) null !== (N = d(i, N.value, c)) && (l = o(N, l, M), null === A ? s = N : A.sibling = N, A = N);

	          return s;
	        }

	        for (g = r(i, g); !N.done; M++, N = u.next()) null !== (N = I(g, i, M, N.value, c)) && (e && null !== N.alternate && g.delete(null === N.key ? M : N.key), l = o(N, l, M), null === A ? s = N : A.sibling = N, A = N);

	        return e && g.forEach(function (e) {
	          return t(i, e);
	        }), s;
	      }

	      return function (e, r, o, u) {
	        var c = "object" == typeof o && null !== o && o.type === Ke && null === o.key;
	        c && (o = o.props.children);
	        var s = "object" == typeof o && null !== o;
	        if (s) switch (o.$$typeof) {
	          case We:
	            e: {
	              for (s = o.key, c = r; null !== c;) {
	                if (c.key === s) {
	                  if (7 === c.tag ? o.type === Ke : c.elementType === o.type) {
	                    n(e, c.sibling), (r = i(c, o.type === Ke ? o.props.children : o.props)).ref = Vi(e, c, o), r.return = e, e = r;
	                    break e;
	                  }

	                  n(e, c);
	                  break;
	                }

	                t(e, c), c = c.sibling;
	              }

	              o.type === Ke ? ((r = eu(o.props.children, e.mode, u, o.key)).return = e, e = r) : ((u = $l(o.type, o.key, o.props, null, e.mode, u)).ref = Vi(e, r, o), u.return = e, e = u);
	            }

	            return l(e);

	          case Xe:
	            e: {
	              for (c = o.key; null !== r;) {
	                if (r.key === c) {
	                  if (4 === r.tag && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
	                    n(e, r.sibling), (r = i(r, o.children || [])).return = e, e = r;
	                    break e;
	                  }

	                  n(e, r);
	                  break;
	                }

	                t(e, r), r = r.sibling;
	              }

	              (r = nu(o, e.mode, u)).return = e, e = r;
	            }

	            return l(e);
	        }
	        if ("string" == typeof o || "number" == typeof o) return o = "" + o, null !== r && 6 === r.tag ? (n(e, r.sibling), (r = i(r, o)).return = e, e = r) : (n(e, r), (r = tu(o, e.mode, u)).return = e, e = r), l(e);
	        if (Ji(o)) return g(e, r, o, u);
	        if (ut(o)) return M(e, r, o, u);
	        if (s && Wi(e, o), void 0 === o && !c) switch (e.tag) {
	          case 1:
	          case 0:
	            throw e = e.type, a(Error(152), e.displayName || e.name || "Component");
	        }
	        return n(e, r);
	      };
	    }

	    var Ki = Xi(!0),
	        qi = Xi(!1),
	        _i = {},
	        $i = {
	      current: _i
	    },
	        eo = {
	      current: _i
	    },
	        to = {
	      current: _i
	    };

	    function no(e) {
	      if (e === _i) throw a(Error(174));
	      return e;
	    }

	    function ro(e, t) {
	      Tr(to, t), Tr(eo, e), Tr($i, _i);
	      var n = t.nodeType;

	      switch (n) {
	        case 9:
	        case 11:
	          t = (t = t.documentElement) ? t.namespaceURI : ar(null, "");
	          break;

	        default:
	          t = ar(t = (n = 8 === n ? t.parentNode : t).namespaceURI || null, n = n.tagName);
	      }

	      Dr($i), Tr($i, t);
	    }

	    function io(e) {
	      Dr($i), Dr(eo), Dr(to);
	    }

	    function oo(e) {
	      no(to.current);
	      var t = no($i.current),
	          n = ar(t, e.type);
	      t !== n && (Tr(eo, e), Tr($i, n));
	    }

	    function ao(e) {
	      eo.current === e && (Dr($i), Dr(eo));
	    }

	    var lo = 1,
	        uo = 1,
	        co = 2,
	        so = {
	      current: 0
	    };

	    function Ao(e) {
	      for (var t = e; null !== t;) {
	        if (13 === t.tag) {
	          if (null !== t.memoizedState) return t;
	        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
	          if (0 != (64 & t.effectTag)) return t;
	        } else if (null !== t.child) {
	          t.child.return = t, t = t.child;
	          continue;
	        }

	        if (t === e) break;

	        for (; null === t.sibling;) {
	          if (null === t.return || t.return === e) return null;
	          t = t.return;
	        }

	        t.sibling.return = t.return, t = t.sibling;
	      }

	      return null;
	    }

	    var fo = 0,
	        Io = 2,
	        go = 4,
	        Mo = 8,
	        po = 16,
	        No = 32,
	        yo = 64,
	        vo = 128,
	        ho = Fe.ReactCurrentDispatcher,
	        jo = 0,
	        mo = null,
	        wo = null,
	        Co = null,
	        bo = null,
	        Eo = null,
	        Do = null,
	        To = 0,
	        xo = null,
	        So = 0,
	        zo = !1,
	        Lo = null,
	        ko = 0;

	    function Qo() {
	      throw a(Error(321));
	    }

	    function Oo(e, t) {
	      if (null === t) return !1;

	      for (var n = 0; n < t.length && n < e.length; n++) if (!en(e[n], t[n])) return !1;

	      return !0;
	    }

	    function Po(e, t, n, r, i, o) {
	      if (jo = o, mo = t, Co = null !== e ? e.memoizedState : null, ho.current = null === Co ? Ko : qo, t = n(r, i), zo) {
	        do {
	          zo = !1, ko += 1, Co = null !== e ? e.memoizedState : null, Do = bo, xo = Eo = wo = null, ho.current = qo, t = n(r, i);
	        } while (zo);

	        Lo = null, ko = 0;
	      }

	      if (ho.current = Xo, (e = mo).memoizedState = bo, e.expirationTime = To, e.updateQueue = xo, e.effectTag |= So, e = null !== wo && null !== wo.next, jo = 0, Do = Eo = bo = Co = wo = mo = null, To = 0, xo = null, So = 0, e) throw a(Error(300));
	      return t;
	    }

	    function Bo() {
	      ho.current = Xo, jo = 0, Do = Eo = bo = Co = wo = mo = null, To = 0, xo = null, So = 0, zo = !1, Lo = null, ko = 0;
	    }

	    function Uo() {
	      var e = {
	        memoizedState: null,
	        baseState: null,
	        queue: null,
	        baseUpdate: null,
	        next: null
	      };
	      return null === Eo ? bo = Eo = e : Eo = Eo.next = e, Eo;
	    }

	    function Yo() {
	      if (null !== Do) Do = (Eo = Do).next, Co = null !== (wo = Co) ? wo.next : null;else {
	        if (null === Co) throw a(Error(310));
	        var e = {
	          memoizedState: (wo = Co).memoizedState,
	          baseState: wo.baseState,
	          queue: wo.queue,
	          baseUpdate: wo.baseUpdate,
	          next: null
	        };
	        Eo = null === Eo ? bo = e : Eo.next = e, Co = wo.next;
	      }
	      return Eo;
	    }

	    function Ro(e, t) {
	      return "function" == typeof t ? t(e) : t;
	    }

	    function Go(e) {
	      var t = Yo(),
	          n = t.queue;
	      if (null === n) throw a(Error(311));

	      if (n.lastRenderedReducer = e, 0 < ko) {
	        var r = n.dispatch;

	        if (null !== Lo) {
	          var i = Lo.get(n);

	          if (void 0 !== i) {
	            Lo.delete(n);
	            var o = t.memoizedState;

	            do {
	              o = e(o, i.action), i = i.next;
	            } while (null !== i);

	            return en(o, t.memoizedState) || (ua = !0), t.memoizedState = o, t.baseUpdate === n.last && (t.baseState = o), n.lastRenderedState = o, [o, r];
	          }
	        }

	        return [t.memoizedState, r];
	      }

	      r = n.last;
	      var l = t.baseUpdate;

	      if (o = t.baseState, null !== l ? (null !== r && (r.next = null), r = l.next) : r = null !== r ? r.next : null, null !== r) {
	        var u = i = null,
	            c = r,
	            s = !1;

	        do {
	          var A = c.expirationTime;
	          A < jo ? (s || (s = !0, u = l, i = o), A > To && (To = A)) : (Ul(A, c.suspenseConfig), o = c.eagerReducer === e ? c.eagerState : e(o, c.action)), l = c, c = c.next;
	        } while (null !== c && c !== r);

	        s || (u = l, i = o), en(o, t.memoizedState) || (ua = !0), t.memoizedState = o, t.baseUpdate = u, t.baseState = i, n.lastRenderedState = o;
	      }

	      return [t.memoizedState, n.dispatch];
	    }

	    function Zo(e, t, n, r) {
	      return e = {
	        tag: e,
	        create: t,
	        destroy: n,
	        deps: r,
	        next: null
	      }, null === xo ? (xo = {
	        lastEffect: null
	      }).lastEffect = e.next = e : null === (t = xo.lastEffect) ? xo.lastEffect = e.next = e : (n = t.next, t.next = e, e.next = n, xo.lastEffect = e), e;
	    }

	    function Ho(e, t, n, r) {
	      var i = Uo();
	      So |= e, i.memoizedState = Zo(t, n, void 0, void 0 === r ? null : r);
	    }

	    function Fo(e, t, n, r) {
	      var i = Yo();
	      r = void 0 === r ? null : r;
	      var o = void 0;

	      if (null !== wo) {
	        var a = wo.memoizedState;
	        if (o = a.destroy, null !== r && Oo(r, a.deps)) return void Zo(fo, n, o, r);
	      }

	      So |= e, i.memoizedState = Zo(t, n, o, r);
	    }

	    function Jo(e, t) {
	      return "function" == typeof t ? (e = e(), t(e), function () {
	        t(null);
	      }) : null !== t && void 0 !== t ? (e = e(), t.current = e, function () {
	        t.current = null;
	      }) : void 0;
	    }

	    function Vo() {}

	    function Wo(e, t, n) {
	      if (!(25 > ko)) throw a(Error(301));
	      var r = e.alternate;
	      if (e === mo || null !== r && r === mo) {
	        if (zo = !0, e = {
	          expirationTime: jo,
	          suspenseConfig: null,
	          action: n,
	          eagerReducer: null,
	          eagerState: null,
	          next: null
	        }, null === Lo && (Lo = new Map()), void 0 === (n = Lo.get(t))) Lo.set(t, e);else {
	          for (t = n; null !== t.next;) t = t.next;

	          t.next = e;
	        }
	      } else {
	        var i = bl(),
	            o = Bi.suspense;
	        o = {
	          expirationTime: i = El(i, e, o),
	          suspenseConfig: o,
	          action: n,
	          eagerReducer: null,
	          eagerState: null,
	          next: null
	        };
	        var l = t.last;
	        if (null === l) o.next = o;else {
	          var u = l.next;
	          null !== u && (o.next = u), l.next = o;
	        }
	        if (t.last = o, 0 === e.expirationTime && (null === r || 0 === r.expirationTime) && null !== (r = t.lastRenderedReducer)) try {
	          var c = t.lastRenderedState,
	              s = r(c, n);
	          if (o.eagerReducer = r, o.eagerState = s, en(s, c)) return;
	        } catch (e) {}
	        Tl(e, i);
	      }
	    }

	    var Xo = {
	      readContext: Ci,
	      useCallback: Qo,
	      useContext: Qo,
	      useEffect: Qo,
	      useImperativeHandle: Qo,
	      useLayoutEffect: Qo,
	      useMemo: Qo,
	      useReducer: Qo,
	      useRef: Qo,
	      useState: Qo,
	      useDebugValue: Qo,
	      useResponder: Qo
	    },
	        Ko = {
	      readContext: Ci,
	      useCallback: function (e, t) {
	        return Uo().memoizedState = [e, void 0 === t ? null : t], e;
	      },
	      useContext: Ci,
	      useEffect: function (e, t) {
	        return Ho(516, vo | yo, e, t);
	      },
	      useImperativeHandle: function (e, t, n) {
	        return n = null !== n && void 0 !== n ? n.concat([e]) : null, Ho(4, go | No, Jo.bind(null, t, e), n);
	      },
	      useLayoutEffect: function (e, t) {
	        return Ho(4, go | No, e, t);
	      },
	      useMemo: function (e, t) {
	        var n = Uo();
	        return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
	      },
	      useReducer: function (e, t, n) {
	        var r = Uo();
	        return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = (e = r.queue = {
	          last: null,
	          dispatch: null,
	          lastRenderedReducer: e,
	          lastRenderedState: t
	        }).dispatch = Wo.bind(null, mo, e), [r.memoizedState, e];
	      },
	      useRef: function (e) {
	        return e = {
	          current: e
	        }, Uo().memoizedState = e;
	      },
	      useState: function (e) {
	        var t = Uo();
	        return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
	          last: null,
	          dispatch: null,
	          lastRenderedReducer: Ro,
	          lastRenderedState: e
	        }).dispatch = Wo.bind(null, mo, e), [t.memoizedState, e];
	      },
	      useDebugValue: Vo,
	      useResponder: rn
	    },
	        qo = {
	      readContext: Ci,
	      useCallback: function (e, t) {
	        var n = Yo();
	        t = void 0 === t ? null : t;
	        var r = n.memoizedState;
	        return null !== r && null !== t && Oo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	      },
	      useContext: Ci,
	      useEffect: function (e, t) {
	        return Fo(516, vo | yo, e, t);
	      },
	      useImperativeHandle: function (e, t, n) {
	        return n = null !== n && void 0 !== n ? n.concat([e]) : null, Fo(4, go | No, Jo.bind(null, t, e), n);
	      },
	      useLayoutEffect: function (e, t) {
	        return Fo(4, go | No, e, t);
	      },
	      useMemo: function (e, t) {
	        var n = Yo();
	        t = void 0 === t ? null : t;
	        var r = n.memoizedState;
	        return null !== r && null !== t && Oo(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
	      },
	      useReducer: Go,
	      useRef: function () {
	        return Yo().memoizedState;
	      },
	      useState: function (e) {
	        return Go(Ro);
	      },
	      useDebugValue: Vo,
	      useResponder: rn
	    },
	        _o = null,
	        $o = null,
	        ea = !1;

	    function ta(e, t) {
	      var n = Kl(5, null, null, 0);
	      n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
	    }

	    function na(e, t) {
	      switch (e.tag) {
	        case 5:
	          var n = e.type;
	          return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);

	        case 6:
	          return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);

	        case 13:
	        default:
	          return !1;
	      }
	    }

	    function ra(e) {
	      if (ea) {
	        var t = $o;

	        if (t) {
	          var n = t;

	          if (!na(e, t)) {
	            if (!(t = Cr(n.nextSibling)) || !na(e, t)) return e.effectTag |= 2, ea = !1, void (_o = e);
	            ta(_o, n);
	          }

	          _o = e, $o = Cr(t.firstChild);
	        } else e.effectTag |= 2, ea = !1, _o = e;
	      }
	    }

	    function ia(e) {
	      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 18 !== e.tag;) e = e.return;

	      _o = e;
	    }

	    function oa(e) {
	      if (e !== _o) return !1;
	      if (!ea) return ia(e), ea = !0, !1;
	      var t = e.type;
	      if (5 !== e.tag || "head" !== t && "body" !== t && !jr(t, e.memoizedProps)) for (t = $o; t;) ta(e, t), t = Cr(t.nextSibling);
	      return ia(e), $o = _o ? Cr(e.stateNode.nextSibling) : null, !0;
	    }

	    function aa() {
	      $o = _o = null, ea = !1;
	    }

	    var la = Fe.ReactCurrentOwner,
	        ua = !1;

	    function ca(e, t, n, r) {
	      t.child = null === e ? qi(t, null, n, r) : Ki(t, e.child, n, r);
	    }

	    function sa(e, t, n, r, i) {
	      n = n.render;
	      var o = t.ref;
	      return wi(t, i), r = Po(e, t, n, r, o, i), null === e || ua ? (t.effectTag |= 1, ca(e, t, r, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), ja(e, t, i));
	    }

	    function Aa(e, t, n, r, i, o) {
	      if (null === e) {
	        var a = n.type;
	        return "function" != typeof a || ql(a) || void 0 !== a.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = $l(n.type, null, r, null, t.mode, o)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = a, da(e, t, a, r, i, o));
	      }

	      return a = e.child, i < o && (i = a.memoizedProps, (n = null !== (n = n.compare) ? n : nn)(i, r) && e.ref === t.ref) ? ja(e, t, o) : (t.effectTag |= 1, (e = _l(a, r)).ref = t.ref, e.return = t, t.child = e);
	    }

	    function da(e, t, n, r, i, o) {
	      return null !== e && nn(e.memoizedProps, r) && e.ref === t.ref && (ua = !1, i < o) ? ja(e, t, o) : Ia(e, t, n, r, o);
	    }

	    function fa(e, t) {
	      var n = t.ref;
	      (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
	    }

	    function Ia(e, t, n, r, i) {
	      var o = Qr(n) ? Lr : Sr.current;
	      return o = kr(t, o), wi(t, i), n = Po(e, t, n, r, o, i), null === e || ua ? (t.effectTag |= 1, ca(e, t, n, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), ja(e, t, i));
	    }

	    function ga(e, t, n, r, i) {
	      if (Qr(n)) {
	        var o = !0;
	        Yr(t);
	      } else o = !1;

	      if (wi(t, i), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), Zi(t, n, r), Fi(t, n, r, i), r = !0;else if (null === e) {
	        var a = t.stateNode,
	            l = t.memoizedProps;
	        a.props = l;
	        var u = a.context,
	            c = n.contextType;
	        "object" == typeof c && null !== c ? c = Ci(c) : c = kr(t, c = Qr(n) ? Lr : Sr.current);
	        var s = n.getDerivedStateFromProps,
	            A = "function" == typeof s || "function" == typeof a.getSnapshotBeforeUpdate;
	        A || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (l !== r || u !== c) && Hi(t, a, r, c), bi = !1;
	        var d = t.memoizedState;
	        u = a.state = d;
	        var f = t.updateQueue;
	        null !== f && (Qi(t, f, r, a, i), u = t.memoizedState), l !== r || d !== u || zr.current || bi ? ("function" == typeof s && (Yi(t, n, s, r), u = t.memoizedState), (l = bi || Gi(t, n, l, r, d, u, c)) ? (A || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), t.memoizedProps = r, t.memoizedState = u), a.props = r, a.state = u, a.context = c, r = l) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), r = !1);
	      } else a = t.stateNode, l = t.memoizedProps, a.props = t.type === t.elementType ? l : gi(t.type, l), u = a.context, "object" == typeof (c = n.contextType) && null !== c ? c = Ci(c) : c = kr(t, c = Qr(n) ? Lr : Sr.current), (A = "function" == typeof (s = n.getDerivedStateFromProps) || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (l !== r || u !== c) && Hi(t, a, r, c), bi = !1, u = t.memoizedState, d = a.state = u, null !== (f = t.updateQueue) && (Qi(t, f, r, a, i), d = t.memoizedState), l !== r || u !== d || zr.current || bi ? ("function" == typeof s && (Yi(t, n, s, r), d = t.memoizedState), (s = bi || Gi(t, n, l, r, u, d, c)) ? (A || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, d, c), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, d, c)), "function" == typeof a.componentDidUpdate && (t.effectTag |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof a.componentDidUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = r, t.memoizedState = d), a.props = r, a.state = d, a.context = c, r = s) : ("function" != typeof a.componentDidUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), r = !1);
	      return Ma(e, t, n, r, o, i);
	    }

	    function Ma(e, t, n, r, i, o) {
	      fa(e, t);
	      var a = 0 != (64 & t.effectTag);
	      if (!r && !a) return i && Rr(t, n, !1), ja(e, t, o);
	      r = t.stateNode, la.current = t;
	      var l = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
	      return t.effectTag |= 1, null !== e && a ? (t.child = Ki(t, e.child, null, o), t.child = Ki(t, null, l, o)) : ca(e, t, l, o), t.memoizedState = r.state, i && Rr(t, n, !0), t.child;
	    }

	    function pa(e) {
	      var t = e.stateNode;
	      t.pendingContext ? Br(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Br(0, t.context, !1), ro(e, t.containerInfo);
	    }

	    var Na = {};

	    function ya(e, t, n) {
	      var r,
	          i = t.mode,
	          o = t.pendingProps,
	          a = so.current,
	          l = null,
	          u = !1;
	      if ((r = 0 != (64 & t.effectTag)) || (r = 0 != (a & co) && (null === e || null !== e.memoizedState)), r ? (l = Na, u = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === o.fallback || !0 === o.unstable_avoidThisFallback || (a |= uo), Tr(so, a &= lo), null === e) {
	        if (u) {
	          if (o = o.fallback, (e = eu(null, i, 0, null)).return = t, 0 == (2 & t.mode)) for (u = null !== t.memoizedState ? t.child.child : t.child, e.child = u; null !== u;) u.return = e, u = u.sibling;
	          (n = eu(o, i, n, null)).return = t, e.sibling = n, i = e;
	        } else i = n = qi(t, null, o.children, n);
	      } else {
	        if (null !== e.memoizedState) {
	          if (i = (a = e.child).sibling, u) {
	            if (o = o.fallback, (n = _l(a, a.pendingProps)).return = t, 0 == (2 & t.mode) && (u = null !== t.memoizedState ? t.child.child : t.child) !== a.child) for (n.child = u; null !== u;) u.return = n, u = u.sibling;
	            (o = _l(i, o, i.expirationTime)).return = t, n.sibling = o, i = n, n.childExpirationTime = 0, n = o;
	          } else i = n = Ki(t, a.child, o.children, n);
	        } else if (a = e.child, u) {
	          if (u = o.fallback, (o = eu(null, i, 0, null)).return = t, o.child = a, null !== a && (a.return = o), 0 == (2 & t.mode)) for (a = null !== t.memoizedState ? t.child.child : t.child, o.child = a; null !== a;) a.return = o, a = a.sibling;
	          (n = eu(u, i, n, null)).return = t, o.sibling = n, n.effectTag |= 2, i = o, o.childExpirationTime = 0;
	        } else n = i = Ki(t, a, o.children, n);
	        t.stateNode = e.stateNode;
	      }
	      return t.memoizedState = l, t.child = i, n;
	    }

	    function va(e, t, n, r, i) {
	      var o = e.memoizedState;
	      null === o ? e.memoizedState = {
	        isBackwards: t,
	        rendering: null,
	        last: r,
	        tail: n,
	        tailExpiration: 0,
	        tailMode: i
	      } : (o.isBackwards = t, o.rendering = null, o.last = r, o.tail = n, o.tailExpiration = 0, o.tailMode = i);
	    }

	    function ha(e, t, n) {
	      var r = t.pendingProps,
	          i = r.revealOrder,
	          o = r.tail;
	      if (ca(e, t, r.children, n), 0 != ((r = so.current) & co)) r = r & lo | co, t.effectTag |= 64;else {
	        if (null !== e && 0 != (64 & e.effectTag)) e: for (e = t.child; null !== e;) {
	          if (13 === e.tag) {
	            if (null !== e.memoizedState) {
	              e.expirationTime < n && (e.expirationTime = n);
	              var a = e.alternate;
	              null !== a && a.expirationTime < n && (a.expirationTime = n), mi(e.return, n);
	            }
	          } else if (null !== e.child) {
	            e.child.return = e, e = e.child;
	            continue;
	          }

	          if (e === t) break e;

	          for (; null === e.sibling;) {
	            if (null === e.return || e.return === t) break e;
	            e = e.return;
	          }

	          e.sibling.return = e.return, e = e.sibling;
	        }
	        r &= lo;
	      }
	      if (Tr(so, r), 0 == (2 & t.mode)) t.memoizedState = null;else switch (i) {
	        case "forwards":
	          for (n = t.child, i = null; null !== n;) null !== (r = n.alternate) && null === Ao(r) && (i = n), n = n.sibling;

	          null === (n = i) ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), va(t, !1, i, n, o);
	          break;

	        case "backwards":
	          for (n = null, i = t.child, t.child = null; null !== i;) {
	            if (null !== (r = i.alternate) && null === Ao(r)) {
	              t.child = i;
	              break;
	            }

	            r = i.sibling, i.sibling = n, n = i, i = r;
	          }

	          va(t, !0, n, null, o);
	          break;

	        case "together":
	          va(t, !1, null, null, void 0);
	          break;

	        default:
	          t.memoizedState = null;
	      }
	      return t.child;
	    }

	    function ja(e, t, n) {
	      if (null !== e && (t.dependencies = e.dependencies), t.childExpirationTime < n) return null;
	      if (null !== e && t.child !== e.child) throw a(Error(153));

	      if (null !== t.child) {
	        for (n = _l(e = t.child, e.pendingProps, e.expirationTime), t.child = n, n.return = t; null !== e.sibling;) e = e.sibling, (n = n.sibling = _l(e, e.pendingProps, e.expirationTime)).return = t;

	        n.sibling = null;
	      }

	      return t.child;
	    }

	    function ma(e) {
	      e.effectTag |= 4;
	    }

	    var wa = void 0,
	        Ca = void 0,
	        ba = void 0,
	        Ea = void 0;

	    function Da(e, t) {
	      switch (e.tailMode) {
	        case "hidden":
	          t = e.tail;

	          for (var n = null; null !== t;) null !== t.alternate && (n = t), t = t.sibling;

	          null === n ? e.tail = null : n.sibling = null;
	          break;

	        case "collapsed":
	          n = e.tail;

	          for (var r = null; null !== n;) null !== n.alternate && (r = n), n = n.sibling;

	          null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
	      }
	    }

	    function Ta(e) {
	      switch (e.tag) {
	        case 1:
	          Qr(e.type) && Or();
	          var t = e.effectTag;
	          return 2048 & t ? (e.effectTag = -2049 & t | 64, e) : null;

	        case 3:
	          if (io(), Pr(), 0 != (64 & (t = e.effectTag))) throw a(Error(285));
	          return e.effectTag = -2049 & t | 64, e;

	        case 5:
	          return ao(e), null;

	        case 13:
	          return Dr(so), 2048 & (t = e.effectTag) ? (e.effectTag = -2049 & t | 64, e) : null;

	        case 18:
	          return null;

	        case 19:
	          return Dr(so), null;

	        case 4:
	          return io(), null;

	        case 10:
	          return ji(e), null;

	        default:
	          return null;
	      }
	    }

	    function xa(e, t) {
	      return {
	        value: e,
	        source: t,
	        stack: st(t)
	      };
	    }

	    wa = function (e, t) {
	      for (var n = t.child; null !== n;) {
	        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);else if (20 === n.tag) e.appendChild(n.stateNode.instance);else if (4 !== n.tag && null !== n.child) {
	          n.child.return = n, n = n.child;
	          continue;
	        }
	        if (n === t) break;

	        for (; null === n.sibling;) {
	          if (null === n.return || n.return === t) return;
	          n = n.return;
	        }

	        n.sibling.return = n.return, n = n.sibling;
	      }
	    }, Ca = function () {}, ba = function (e, t, n, r, o) {
	      var a = e.memoizedProps;

	      if (a !== r) {
	        var l = t.stateNode;

	        switch (no($i.current), e = null, n) {
	          case "input":
	            a = ht(l, a), r = ht(l, r), e = [];
	            break;

	          case "option":
	            a = _n(l, a), r = _n(l, r), e = [];
	            break;

	          case "select":
	            a = i({}, a, {
	              value: void 0
	            }), r = i({}, r, {
	              value: void 0
	            }), e = [];
	            break;

	          case "textarea":
	            a = er(l, a), r = er(l, r), e = [];
	            break;

	          default:
	            "function" != typeof a.onClick && "function" == typeof r.onClick && (l.onclick = Nr);
	        }

	        gr(n, r), l = n = void 0;
	        var u = null;

	        for (n in a) if (!r.hasOwnProperty(n) && a.hasOwnProperty(n) && null != a[n]) if ("style" === n) {
	          var c = a[n];

	          for (l in c) c.hasOwnProperty(l) && (u || (u = {}), u[l] = "");
	        } else "dangerouslySetInnerHTML" !== n && "children" !== n && "suppressContentEditableWarning" !== n && "suppressHydrationWarning" !== n && "autoFocus" !== n && (f.hasOwnProperty(n) ? e || (e = []) : (e = e || []).push(n, null));

	        for (n in r) {
	          var s = r[n];
	          if (c = null != a ? a[n] : void 0, r.hasOwnProperty(n) && s !== c && (null != s || null != c)) if ("style" === n) {
	            if (c) {
	              for (l in c) !c.hasOwnProperty(l) || s && s.hasOwnProperty(l) || (u || (u = {}), u[l] = "");

	              for (l in s) s.hasOwnProperty(l) && c[l] !== s[l] && (u || (u = {}), u[l] = s[l]);
	            } else u || (e || (e = []), e.push(n, u)), u = s;
	          } else "dangerouslySetInnerHTML" === n ? (s = s ? s.__html : void 0, c = c ? c.__html : void 0, null != s && c !== s && (e = e || []).push(n, "" + s)) : "children" === n ? c === s || "string" != typeof s && "number" != typeof s || (e = e || []).push(n, "" + s) : "suppressContentEditableWarning" !== n && "suppressHydrationWarning" !== n && (f.hasOwnProperty(n) ? (null != s && pr(o, n), e || c === s || (e = [])) : (e = e || []).push(n, s));
	        }

	        u && (e = e || []).push("style", u), o = e, (t.updateQueue = o) && ma(t);
	      }
	    }, Ea = function (e, t, n, r) {
	      n !== r && ma(t);
	    };
	    var Sa = "function" == typeof WeakSet ? WeakSet : Set;

	    function za(e, t) {
	      var n = t.source,
	          r = t.stack;
	      null === r && null !== n && (r = st(n)), null !== n && ct(n.type), t = t.value, null !== e && 1 === e.tag && ct(e.type);

	      try {
	        console.error(t);
	      } catch (e) {
	        setTimeout(function () {
	          throw e;
	        });
	      }
	    }

	    function La(e) {
	      var t = e.ref;
	      if (null !== t) if ("function" == typeof t) try {
	        t(null);
	      } catch (t) {
	        Fl(e, t);
	      } else t.current = null;
	    }

	    function ka(e, t, n) {
	      if (null !== (n = null !== (n = n.updateQueue) ? n.lastEffect : null)) {
	        var r = n = n.next;

	        do {
	          if ((r.tag & e) !== fo) {
	            var i = r.destroy;
	            r.destroy = void 0, void 0 !== i && i();
	          }

	          (r.tag & t) !== fo && (i = r.create, r.destroy = i()), r = r.next;
	        } while (r !== n);
	      }
	    }

	    function Qa(e, t) {
	      switch ("function" == typeof Xl && Xl(e), e.tag) {
	        case 0:
	        case 11:
	        case 14:
	        case 15:
	          var n = e.updateQueue;

	          if (null !== n && null !== (n = n.lastEffect)) {
	            var r = n.next;
	            ci(97 < t ? 97 : t, function () {
	              var t = r;

	              do {
	                var n = t.destroy;

	                if (void 0 !== n) {
	                  var i = e;

	                  try {
	                    n();
	                  } catch (e) {
	                    Fl(i, e);
	                  }
	                }

	                t = t.next;
	              } while (t !== r);
	            });
	          }

	          break;

	        case 1:
	          La(e), "function" == typeof (t = e.stateNode).componentWillUnmount && function (e, t) {
	            try {
	              t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
	            } catch (t) {
	              Fl(e, t);
	            }
	          }(e, t);
	          break;

	        case 5:
	          La(e);
	          break;

	        case 4:
	          Ua(e, t);
	      }
	    }

	    function Oa(e, t) {
	      for (var n = e;;) if (Qa(n, t), null !== n.child && 4 !== n.tag) n.child.return = n, n = n.child;else {
	        if (n === e) break;

	        for (; null === n.sibling;) {
	          if (null === n.return || n.return === e) return;
	          n = n.return;
	        }

	        n.sibling.return = n.return, n = n.sibling;
	      }
	    }

	    function Pa(e) {
	      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
	    }

	    function Ba(e) {
	      e: {
	        for (var t = e.return; null !== t;) {
	          if (Pa(t)) {
	            var n = t;
	            break e;
	          }

	          t = t.return;
	        }

	        throw a(Error(160));
	      }

	      switch (t = n.stateNode, n.tag) {
	        case 5:
	          var r = !1;
	          break;

	        case 3:
	        case 4:
	          t = t.containerInfo, r = !0;
	          break;

	        default:
	          throw a(Error(161));
	      }

	      16 & n.effectTag && (cr(t, ""), n.effectTag &= -17);

	      e: t: for (n = e;;) {
	        for (; null === n.sibling;) {
	          if (null === n.return || Pa(n.return)) {
	            n = null;
	            break e;
	          }

	          n = n.return;
	        }

	        for (n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;) {
	          if (2 & n.effectTag) continue t;
	          if (null === n.child || 4 === n.tag) continue t;
	          n.child.return = n, n = n.child;
	        }

	        if (!(2 & n.effectTag)) {
	          n = n.stateNode;
	          break e;
	        }
	      }

	      for (var i = e;;) {
	        var o = 5 === i.tag || 6 === i.tag;

	        if (o || 20 === i.tag) {
	          var l = o ? i.stateNode : i.stateNode.instance;
	          if (n) {
	            if (r) {
	              var u = l;
	              l = n, 8 === (o = t).nodeType ? o.parentNode.insertBefore(u, l) : o.insertBefore(u, l);
	            } else t.insertBefore(l, n);
	          } else r ? (8 === (u = t).nodeType ? (o = u.parentNode).insertBefore(l, u) : (o = u).appendChild(l), null !== (u = u._reactRootContainer) && void 0 !== u || null !== o.onclick || (o.onclick = Nr)) : t.appendChild(l);
	        } else if (4 !== i.tag && null !== i.child) {
	          i.child.return = i, i = i.child;
	          continue;
	        }

	        if (i === e) break;

	        for (; null === i.sibling;) {
	          if (null === i.return || i.return === e) return;
	          i = i.return;
	        }

	        i.sibling.return = i.return, i = i.sibling;
	      }
	    }

	    function Ua(e, t) {
	      for (var n = e, r = !1, i = void 0, o = void 0;;) {
	        if (!r) {
	          r = n.return;

	          e: for (;;) {
	            if (null === r) throw a(Error(160));

	            switch (i = r.stateNode, r.tag) {
	              case 5:
	                o = !1;
	                break e;

	              case 3:
	              case 4:
	                i = i.containerInfo, o = !0;
	                break e;
	            }

	            r = r.return;
	          }

	          r = !0;
	        }

	        if (5 === n.tag || 6 === n.tag) {
	          if (Oa(n, t), o) {
	            var l = i,
	                u = n.stateNode;
	            8 === l.nodeType ? l.parentNode.removeChild(u) : l.removeChild(u);
	          } else i.removeChild(n.stateNode);
	        } else if (20 === n.tag) u = n.stateNode.instance, Oa(n, t), o ? 8 === (l = i).nodeType ? l.parentNode.removeChild(u) : l.removeChild(u) : i.removeChild(u);else if (4 === n.tag) {
	          if (null !== n.child) {
	            i = n.stateNode.containerInfo, o = !0, n.child.return = n, n = n.child;
	            continue;
	          }
	        } else if (Qa(n, t), null !== n.child) {
	          n.child.return = n, n = n.child;
	          continue;
	        }
	        if (n === e) break;

	        for (; null === n.sibling;) {
	          if (null === n.return || n.return === e) return;
	          4 === (n = n.return).tag && (r = !1);
	        }

	        n.sibling.return = n.return, n = n.sibling;
	      }
	    }

	    function Ya(e, t) {
	      switch (t.tag) {
	        case 0:
	        case 11:
	        case 14:
	        case 15:
	          ka(go, Mo, t);
	          break;

	        case 1:
	          break;

	        case 5:
	          var n = t.stateNode;

	          if (null != n) {
	            var r = t.memoizedProps,
	                i = null !== e ? e.memoizedProps : r;
	            e = t.type;
	            var o = t.updateQueue;

	            if (t.updateQueue = null, null !== o) {
	              for (n[k] = r, "input" === e && "radio" === r.type && null != r.name && mt(n, r), Mr(e, i), t = Mr(e, r), i = 0; i < o.length; i += 2) {
	                var l = o[i],
	                    u = o[i + 1];
	                "style" === l ? fr(n, u) : "dangerouslySetInnerHTML" === l ? ur(n, u) : "children" === l ? cr(n, u) : yt(n, l, u, t);
	              }

	              switch (e) {
	                case "input":
	                  wt(n, r);
	                  break;

	                case "textarea":
	                  nr(n, r);
	                  break;

	                case "select":
	                  t = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!r.multiple, null != (e = r.value) ? $n(n, !!r.multiple, e, !1) : t !== !!r.multiple && (null != r.defaultValue ? $n(n, !!r.multiple, r.defaultValue, !0) : $n(n, !!r.multiple, r.multiple ? [] : "", !1));
	              }
	            }
	          }

	          break;

	        case 6:
	          if (null === t.stateNode) throw a(Error(162));
	          t.stateNode.nodeValue = t.memoizedProps;
	          break;

	        case 3:
	        case 12:
	          break;

	        case 13:
	          if (n = t, null === t.memoizedState ? r = !1 : (r = !0, n = t.child, dl = ai()), null !== n) e: for (e = n;;) {
	            if (5 === e.tag) o = e.stateNode, r ? "function" == typeof (o = o.style).setProperty ? o.setProperty("display", "none", "important") : o.display = "none" : (o = e.stateNode, i = void 0 !== (i = e.memoizedProps.style) && null !== i && i.hasOwnProperty("display") ? i.display : null, o.style.display = dr("display", i));else if (6 === e.tag) e.stateNode.nodeValue = r ? "" : e.memoizedProps;else {
	              if (13 === e.tag && null !== e.memoizedState) {
	                (o = e.child.sibling).return = e, e = o;
	                continue;
	              }

	              if (null !== e.child) {
	                e.child.return = e, e = e.child;
	                continue;
	              }
	            }
	            if (e === n) break e;

	            for (; null === e.sibling;) {
	              if (null === e.return || e.return === n) break e;
	              e = e.return;
	            }

	            e.sibling.return = e.return, e = e.sibling;
	          }
	          Ra(t);
	          break;

	        case 19:
	          Ra(t);
	          break;

	        case 17:
	        case 20:
	          break;

	        default:
	          throw a(Error(163));
	      }
	    }

	    function Ra(e) {
	      var t = e.updateQueue;

	      if (null !== t) {
	        e.updateQueue = null;
	        var n = e.stateNode;
	        null === n && (n = e.stateNode = new Sa()), t.forEach(function (t) {
	          var r = function (e, t) {
	            var n = e.stateNode;
	            null !== n && n.delete(t), n = bl(), t = El(n, e, null), n = Ii(n, t), null !== (e = xl(e, t)) && Sl(e, n, t);
	          }.bind(null, e, t);

	          n.has(t) || (n.add(t), t.then(r, r));
	        });
	      }
	    }

	    var Ga = "function" == typeof WeakMap ? WeakMap : Map;

	    function Za(e, t, n) {
	      (n = Ti(n, null)).tag = 3, n.payload = {
	        element: null
	      };
	      var r = t.value;
	      return n.callback = function () {
	        gl || (gl = !0, Ml = r), za(e, t);
	      }, n;
	    }

	    function Ha(e, t, n) {
	      (n = Ti(n, null)).tag = 3;
	      var r = e.type.getDerivedStateFromError;

	      if ("function" == typeof r) {
	        var i = t.value;

	        n.payload = function () {
	          return za(e, t), r(i);
	        };
	      }

	      var o = e.stateNode;
	      return null !== o && "function" == typeof o.componentDidCatch && (n.callback = function () {
	        "function" != typeof r && (null === pl ? pl = new Set([this]) : pl.add(this), za(e, t));
	        var n = t.stack;
	        this.componentDidCatch(t.value, {
	          componentStack: null !== n ? n : ""
	        });
	      }), n;
	    }

	    var Fa = Math.ceil,
	        Ja = Fe.ReactCurrentDispatcher,
	        Va = Fe.ReactCurrentOwner,
	        Wa = 0,
	        Xa = 8,
	        Ka = 16,
	        qa = 32,
	        _a = 0,
	        $a = 1,
	        el = 2,
	        tl = 3,
	        nl = 4,
	        rl = Wa,
	        il = null,
	        ol = null,
	        al = 0,
	        ll = _a,
	        ul = 1073741823,
	        cl = 1073741823,
	        sl = null,
	        Al = !1,
	        dl = 0,
	        fl = 500,
	        Il = null,
	        gl = !1,
	        Ml = null,
	        pl = null,
	        Nl = !1,
	        yl = null,
	        vl = 90,
	        hl = 0,
	        jl = null,
	        ml = 0,
	        wl = null,
	        Cl = 0;

	    function bl() {
	      return (rl & (Ka | qa)) !== Wa ? 1073741821 - (ai() / 10 | 0) : 0 !== Cl ? Cl : Cl = 1073741821 - (ai() / 10 | 0);
	    }

	    function El(e, t, n) {
	      if (0 == (2 & (t = t.mode))) return 1073741823;
	      var r = li();
	      if (0 == (4 & t)) return 99 === r ? 1073741823 : 1073741822;
	      if ((rl & Ka) !== Wa) return al;
	      if (null !== n) e = 1073741821 - 25 * (1 + ((1073741821 - e + (0 | n.timeoutMs || 5e3) / 10) / 25 | 0));else switch (r) {
	        case 99:
	          e = 1073741823;
	          break;

	        case 98:
	          e = 1073741821 - 10 * (1 + ((1073741821 - e + 15) / 10 | 0));
	          break;

	        case 97:
	        case 96:
	          e = 1073741821 - 25 * (1 + ((1073741821 - e + 500) / 25 | 0));
	          break;

	        case 95:
	          e = 1;
	          break;

	        default:
	          throw a(Error(326));
	      }
	      return null !== il && e === al && --e, e;
	    }

	    var Dl = 0;

	    function Tl(e, t) {
	      if (50 < ml) throw ml = 0, wl = null, a(Error(185));

	      if (null !== (e = xl(e, t))) {
	        e.pingTime = 0;
	        var n = li();
	        if (1073741823 === t) {
	          if ((rl & Xa) !== Wa && (rl & (Ka | qa)) === Wa) for (var r = Bl(e, 1073741823, !0); null !== r;) r = r(!0);else Sl(e, 99, 1073741823), rl === Wa && di();
	        } else Sl(e, n, t);
	        (4 & rl) === Wa || 98 !== n && 99 !== n || (null === jl ? jl = new Map([[e, t]]) : (void 0 === (n = jl.get(e)) || n > t) && jl.set(e, t));
	      }
	    }

	    function xl(e, t) {
	      e.expirationTime < t && (e.expirationTime = t);
	      var n = e.alternate;
	      null !== n && n.expirationTime < t && (n.expirationTime = t);
	      var r = e.return,
	          i = null;
	      if (null === r && 3 === e.tag) i = e.stateNode;else for (; null !== r;) {
	        if (n = r.alternate, r.childExpirationTime < t && (r.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === r.return && 3 === r.tag) {
	          i = r.stateNode;
	          break;
	        }

	        r = r.return;
	      }
	      return null !== i && (t > i.firstPendingTime && (i.firstPendingTime = t), 0 === (e = i.lastPendingTime) || t < e) && (i.lastPendingTime = t), i;
	    }

	    function Sl(e, t, n) {
	      if (e.callbackExpirationTime < n) {
	        var r = e.callbackNode;
	        null !== r && r !== ei && Hr(r), e.callbackExpirationTime = n, 1073741823 === n ? e.callbackNode = Ai(zl.bind(null, e, Bl.bind(null, e, n))) : (r = null, 1 !== n && (r = {
	          timeout: 10 * (1073741821 - n) - ai()
	        }), e.callbackNode = si(t, zl.bind(null, e, Bl.bind(null, e, n)), r));
	      }
	    }

	    function zl(e, t, n) {
	      var r = e.callbackNode,
	          i = null;

	      try {
	        return null !== (i = t(n)) ? zl.bind(null, e, i) : null;
	      } finally {
	        null === i && r === e.callbackNode && (e.callbackNode = null, e.callbackExpirationTime = 0);
	      }
	    }

	    function Ll() {
	      (rl & (1 | Ka | qa)) === Wa && (function () {
	        if (null !== jl) {
	          var e = jl;
	          jl = null, e.forEach(function (e, t) {
	            Ai(Bl.bind(null, t, e));
	          }), di();
	        }
	      }(), Zl());
	    }

	    function kl(e, t) {
	      var n = rl;
	      rl |= 1;

	      try {
	        return e(t);
	      } finally {
	        (rl = n) === Wa && di();
	      }
	    }

	    function Ql(e, t, n, r) {
	      var i = rl;
	      rl |= 4;

	      try {
	        return ci(98, e.bind(null, t, n, r));
	      } finally {
	        (rl = i) === Wa && di();
	      }
	    }

	    function Ol(e, t) {
	      var n = rl;
	      rl &= -2, rl |= Xa;

	      try {
	        return e(t);
	      } finally {
	        (rl = n) === Wa && di();
	      }
	    }

	    function Pl(e, t) {
	      e.finishedWork = null, e.finishedExpirationTime = 0;
	      var n = e.timeoutHandle;
	      if (-1 !== n && (e.timeoutHandle = -1, wr(n)), null !== ol) for (n = ol.return; null !== n;) {
	        var r = n;

	        switch (r.tag) {
	          case 1:
	            var i = r.type.childContextTypes;
	            null !== i && void 0 !== i && Or();
	            break;

	          case 3:
	            io(), Pr();
	            break;

	          case 5:
	            ao(r);
	            break;

	          case 4:
	            io();
	            break;

	          case 13:
	          case 19:
	            Dr(so);
	            break;

	          case 10:
	            ji(r);
	        }

	        n = n.return;
	      }
	      il = e, ol = _l(e.current, null), al = t, ll = _a, cl = ul = 1073741823, sl = null, Al = !1;
	    }

	    function Bl(e, t, n) {
	      if ((rl & (Ka | qa)) !== Wa) throw a(Error(327));
	      if (e.firstPendingTime < t) return null;
	      if (n && e.finishedExpirationTime === t) return Gl.bind(null, e);
	      if (Zl(), e !== il || t !== al) Pl(e, t);else if (ll === tl) if (Al) Pl(e, t);else {
	        var r = e.lastPendingTime;
	        if (r < t) return Bl.bind(null, e, r);
	      }

	      if (null !== ol) {
	        r = rl, rl |= Ka;
	        var i = Ja.current;

	        if (null === i && (i = Xo), Ja.current = Xo, n) {
	          if (1073741823 !== t) {
	            var o = bl();
	            if (o < t) return rl = r, vi(), Ja.current = i, Bl.bind(null, e, o);
	          }
	        } else Cl = 0;

	        for (;;) try {
	          if (n) for (; null !== ol;) ol = Yl(ol);else for (; null !== ol && !Fr();) ol = Yl(ol);
	          break;
	        } catch (n) {
	          if (vi(), Bo(), null === (o = ol) || null === o.return) throw Pl(e, t), rl = r, n;

	          e: {
	            var l = e,
	                u = o.return,
	                c = o,
	                s = n,
	                A = al;

	            if (c.effectTag |= 1024, c.firstEffect = c.lastEffect = null, null !== s && "object" == typeof s && "function" == typeof s.then) {
	              var d = s,
	                  f = 0 != (so.current & uo);
	              s = u;

	              do {
	                var I;

	                if ((I = 13 === s.tag) && (null !== s.memoizedState ? I = !1 : I = void 0 !== (I = s.memoizedProps).fallback && (!0 !== I.unstable_avoidThisFallback || !f)), I) {
	                  if (null === (u = s.updateQueue) ? ((u = new Set()).add(d), s.updateQueue = u) : u.add(d), 0 == (2 & s.mode)) {
	                    s.effectTag |= 64, c.effectTag &= -1957, 1 === c.tag && (null === c.alternate ? c.tag = 17 : ((A = Ti(1073741823, null)).tag = 2, Si(c, A))), c.expirationTime = 1073741823;
	                    break e;
	                  }

	                  c = l, l = A, null === (f = c.pingCache) ? (f = c.pingCache = new Ga(), u = new Set(), f.set(d, u)) : void 0 === (u = f.get(d)) && (u = new Set(), f.set(d, u)), u.has(l) || (u.add(l), c = Jl.bind(null, c, d, l), d.then(c, c)), s.effectTag |= 2048, s.expirationTime = A;
	                  break e;
	                }

	                s = s.return;
	              } while (null !== s);

	              s = Error((ct(c.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + st(c));
	            }

	            ll !== nl && (ll = $a), s = xa(s, c), c = u;

	            do {
	              switch (c.tag) {
	                case 3:
	                  c.effectTag |= 2048, c.expirationTime = A, zi(c, A = Za(c, s, A));
	                  break e;

	                case 1:
	                  if (d = s, l = c.type, u = c.stateNode, 0 == (64 & c.effectTag) && ("function" == typeof l.getDerivedStateFromError || null !== u && "function" == typeof u.componentDidCatch && (null === pl || !pl.has(u)))) {
	                    c.effectTag |= 2048, c.expirationTime = A, zi(c, A = Ha(c, d, A));
	                    break e;
	                  }

	              }

	              c = c.return;
	            } while (null !== c);
	          }

	          ol = Rl(o);
	        }

	        if (rl = r, vi(), Ja.current = i, null !== ol) return Bl.bind(null, e, t);
	      }

	      if (e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, function (e, t) {
	        var n = e.firstBatch;
	        return !!(null !== n && n._defer && n._expirationTime >= t) && (si(97, function () {
	          return n._onComplete(), null;
	        }), !0);
	      }(e, t)) return null;

	      switch (il = null, ll) {
	        case _a:
	          throw a(Error(328));

	        case $a:
	          return (r = e.lastPendingTime) < t ? Bl.bind(null, e, r) : n ? Gl.bind(null, e) : (Pl(e, t), Ai(Bl.bind(null, e, t)), null);

	        case el:
	          return 1073741823 === ul && !n && 10 < (n = dl + fl - ai()) ? Al ? (Pl(e, t), Bl.bind(null, e, t)) : (r = e.lastPendingTime) < t ? Bl.bind(null, e, r) : (e.timeoutHandle = mr(Gl.bind(null, e), n), null) : Gl.bind(null, e);

	        case tl:
	          if (!n) {
	            if (Al) return Pl(e, t), Bl.bind(null, e, t);
	            if ((n = e.lastPendingTime) < t) return Bl.bind(null, e, n);
	            if (1073741823 !== cl ? n = 10 * (1073741821 - cl) - ai() : 1073741823 === ul ? n = 0 : (n = 10 * (1073741821 - ul) - 5e3, t = 10 * (1073741821 - t) - (r = ai()), 0 > (n = r - n) && (n = 0), t < (n = (120 > n ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * Fa(n / 1960)) - n) && (n = t)), 10 < n) return e.timeoutHandle = mr(Gl.bind(null, e), n), null;
	          }

	          return Gl.bind(null, e);

	        case nl:
	          return !n && 1073741823 !== ul && null !== sl && (r = ul, 0 >= (t = 0 | (i = sl).busyMinDurationMs) ? t = 0 : (n = 0 | i.busyDelayMs, t = (r = ai() - (10 * (1073741821 - r) - (0 | i.timeoutMs || 5e3))) <= n ? 0 : n + t - r), 10 < t) ? (e.timeoutHandle = mr(Gl.bind(null, e), t), null) : Gl.bind(null, e);

	        default:
	          throw a(Error(329));
	      }
	    }

	    function Ul(e, t) {
	      e < ul && 1 < e && (ul = e), null !== t && e < cl && 1 < e && (cl = e, sl = t);
	    }

	    function Yl(e) {
	      var t = Vl(e.alternate, e, al);
	      return e.memoizedProps = e.pendingProps, null === t && (t = Rl(e)), Va.current = null, t;
	    }

	    function Rl(e) {
	      ol = e;

	      do {
	        var t = ol.alternate;

	        if (e = ol.return, 0 == (1024 & ol.effectTag)) {
	          e: {
	            var n = t,
	                r = al,
	                o = (t = ol).pendingProps;

	            switch (t.tag) {
	              case 2:
	              case 16:
	                break;

	              case 15:
	              case 0:
	                break;

	              case 1:
	                Qr(t.type) && Or();
	                break;

	              case 3:
	                io(), Pr(), (r = t.stateNode).pendingContext && (r.context = r.pendingContext, r.pendingContext = null), null !== n && null !== n.child || (oa(t), t.effectTag &= -3), Ca(t);
	                break;

	              case 5:
	                ao(t), r = no(to.current);
	                var l = t.type;
	                if (null !== n && null != t.stateNode) ba(n, t, l, o, r), n.ref !== t.ref && (t.effectTag |= 128);else if (o) {
	                  var u = no($i.current);

	                  if (oa(t)) {
	                    o = void 0, l = (n = t).stateNode;
	                    var c = n.type,
	                        s = n.memoizedProps;

	                    switch (l[L] = n, l[k] = s, c) {
	                      case "iframe":
	                      case "object":
	                      case "embed":
	                        kn("load", l);
	                        break;

	                      case "video":
	                      case "audio":
	                        for (var A = 0; A < te.length; A++) kn(te[A], l);

	                        break;

	                      case "source":
	                        kn("error", l);
	                        break;

	                      case "img":
	                      case "image":
	                      case "link":
	                        kn("error", l), kn("load", l);
	                        break;

	                      case "form":
	                        kn("reset", l), kn("submit", l);
	                        break;

	                      case "details":
	                        kn("toggle", l);
	                        break;

	                      case "input":
	                        jt(l, s), kn("invalid", l), pr(r, "onChange");
	                        break;

	                      case "select":
	                        l._wrapperState = {
	                          wasMultiple: !!s.multiple
	                        }, kn("invalid", l), pr(r, "onChange");
	                        break;

	                      case "textarea":
	                        tr(l, s), kn("invalid", l), pr(r, "onChange");
	                    }

	                    for (o in gr(c, s), A = null, s) s.hasOwnProperty(o) && (u = s[o], "children" === o ? "string" == typeof u ? l.textContent !== u && (A = ["children", u]) : "number" == typeof u && l.textContent !== "" + u && (A = ["children", "" + u]) : f.hasOwnProperty(o) && null != u && pr(r, o));

	                    switch (c) {
	                      case "input":
	                        Ze(l), Ct(l, s, !0);
	                        break;

	                      case "textarea":
	                        Ze(l), rr(l);
	                        break;

	                      case "select":
	                      case "option":
	                        break;

	                      default:
	                        "function" == typeof s.onClick && (l.onclick = Nr);
	                    }

	                    r = A, n.updateQueue = r, null !== r && ma(t);
	                  } else {
	                    s = l, n = o, c = t, A = 9 === r.nodeType ? r : r.ownerDocument, u === ir.html && (u = or(s)), u === ir.html ? "script" === s ? ((s = A.createElement("div")).innerHTML = "<script><\/script>", A = s.removeChild(s.firstChild)) : "string" == typeof n.is ? A = A.createElement(s, {
	                      is: n.is
	                    }) : (A = A.createElement(s), "select" === s && (s = A, n.multiple ? s.multiple = !0 : n.size && (s.size = n.size))) : A = A.createElementNS(u, s), (s = A)[L] = c, s[k] = n, wa(n = s, t, !1, !1), c = n;
	                    var d = r,
	                        I = Mr(l, o);

	                    switch (l) {
	                      case "iframe":
	                      case "object":
	                      case "embed":
	                        kn("load", c), r = o;
	                        break;

	                      case "video":
	                      case "audio":
	                        for (r = 0; r < te.length; r++) kn(te[r], c);

	                        r = o;
	                        break;

	                      case "source":
	                        kn("error", c), r = o;
	                        break;

	                      case "img":
	                      case "image":
	                      case "link":
	                        kn("error", c), kn("load", c), r = o;
	                        break;

	                      case "form":
	                        kn("reset", c), kn("submit", c), r = o;
	                        break;

	                      case "details":
	                        kn("toggle", c), r = o;
	                        break;

	                      case "input":
	                        jt(c, o), r = ht(c, o), kn("invalid", c), pr(d, "onChange");
	                        break;

	                      case "option":
	                        r = _n(c, o);
	                        break;

	                      case "select":
	                        c._wrapperState = {
	                          wasMultiple: !!o.multiple
	                        }, r = i({}, o, {
	                          value: void 0
	                        }), kn("invalid", c), pr(d, "onChange");
	                        break;

	                      case "textarea":
	                        tr(c, o), r = er(c, o), kn("invalid", c), pr(d, "onChange");
	                        break;

	                      default:
	                        r = o;
	                    }

	                    gr(l, r), s = void 0, A = l, u = c;
	                    var g = r;

	                    for (s in g) if (g.hasOwnProperty(s)) {
	                      var M = g[s];
	                      "style" === s ? fr(u, M) : "dangerouslySetInnerHTML" === s ? null != (M = M ? M.__html : void 0) && ur(u, M) : "children" === s ? "string" == typeof M ? ("textarea" !== A || "" !== M) && cr(u, M) : "number" == typeof M && cr(u, "" + M) : "suppressContentEditableWarning" !== s && "suppressHydrationWarning" !== s && "autoFocus" !== s && (f.hasOwnProperty(s) ? null != M && pr(d, s) : null != M && yt(u, s, M, I));
	                    }

	                    switch (l) {
	                      case "input":
	                        Ze(c), Ct(c, o, !1);
	                        break;

	                      case "textarea":
	                        Ze(c), rr(c);
	                        break;

	                      case "option":
	                        null != o.value && c.setAttribute("value", "" + vt(o.value));
	                        break;

	                      case "select":
	                        r = c, c = o, r.multiple = !!c.multiple, null != (s = c.value) ? $n(r, !!c.multiple, s, !1) : null != c.defaultValue && $n(r, !!c.multiple, c.defaultValue, !0);
	                        break;

	                      default:
	                        "function" == typeof r.onClick && (c.onclick = Nr);
	                    }

	                    hr(l, o) && ma(t), t.stateNode = n;
	                  }

	                  null !== t.ref && (t.effectTag |= 128);
	                } else if (null === t.stateNode) throw a(Error(166));
	                break;

	              case 6:
	                if (n && null != t.stateNode) Ea(n, t, n.memoizedProps, o);else {
	                  if ("string" != typeof o && null === t.stateNode) throw a(Error(166));
	                  n = no(to.current), no($i.current), oa(t) ? (r = t.stateNode, n = t.memoizedProps, r[L] = t, r.nodeValue !== n && ma(t)) : (r = t, (n = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(o))[L] = t, r.stateNode = n);
	                }
	                break;

	              case 11:
	                break;

	              case 13:
	                if (Dr(so), o = t.memoizedState, 0 != (64 & t.effectTag)) {
	                  t.expirationTime = r;
	                  break e;
	                }

	                r = null !== o, o = !1, null === n ? oa(t) : (o = null !== (l = n.memoizedState), r || null === l || null !== (l = n.child.sibling) && (null !== (c = t.firstEffect) ? (t.firstEffect = l, l.nextEffect = c) : (t.firstEffect = t.lastEffect = l, l.nextEffect = null), l.effectTag = 8)), r && !o && 0 != (2 & t.mode) && (null === n && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (so.current & uo) ? ll === _a && (ll = el) : ll !== _a && ll !== el || (ll = tl)), (r || o) && (t.effectTag |= 4);
	                break;

	              case 7:
	              case 8:
	              case 12:
	                break;

	              case 4:
	                io(), Ca(t);
	                break;

	              case 10:
	                ji(t);
	                break;

	              case 9:
	              case 14:
	                break;

	              case 17:
	                Qr(t.type) && Or();
	                break;

	              case 18:
	                break;

	              case 19:
	                if (Dr(so), null === (o = t.memoizedState)) break;

	                if (l = 0 != (64 & t.effectTag), null === (c = o.rendering)) {
	                  if (l) Da(o, !1);else if (ll !== _a || null !== n && 0 != (64 & n.effectTag)) for (n = t.child; null !== n;) {
	                    if (null !== (c = Ao(n))) {
	                      for (t.effectTag |= 64, Da(o, !1), null !== (n = c.updateQueue) && (t.updateQueue = n, t.effectTag |= 4), t.firstEffect = t.lastEffect = null, n = t.child; null !== n;) l = r, (o = n).effectTag &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (c = o.alternate) ? (o.childExpirationTime = 0, o.expirationTime = l, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null) : (o.childExpirationTime = c.childExpirationTime, o.expirationTime = c.expirationTime, o.child = c.child, o.memoizedProps = c.memoizedProps, o.memoizedState = c.memoizedState, o.updateQueue = c.updateQueue, l = c.dependencies, o.dependencies = null === l ? null : {
	                        expirationTime: l.expirationTime,
	                        firstContext: l.firstContext,
	                        responders: l.responders
	                      }), n = n.sibling;

	                      Tr(so, so.current & lo | co), t = t.child;
	                      break e;
	                    }

	                    n = n.sibling;
	                  }
	                } else {
	                  if (!l) if (null !== (n = Ao(c))) {
	                    if (t.effectTag |= 64, l = !0, Da(o, !0), null === o.tail && "hidden" === o.tailMode) {
	                      null !== (r = n.updateQueue) && (t.updateQueue = r, t.effectTag |= 4), null !== (t = t.lastEffect = o.lastEffect) && (t.nextEffect = null);
	                      break;
	                    }
	                  } else ai() > o.tailExpiration && 1 < r && (t.effectTag |= 64, l = !0, Da(o, !1), t.expirationTime = t.childExpirationTime = r - 1);
	                  o.isBackwards ? (c.sibling = t.child, t.child = c) : (null !== (r = o.last) ? r.sibling = c : t.child = c, o.last = c);
	                }

	                if (null !== o.tail) {
	                  0 === o.tailExpiration && (o.tailExpiration = ai() + 500), r = o.tail, o.rendering = r, o.tail = r.sibling, o.lastEffect = t.lastEffect, r.sibling = null, n = so.current, Tr(so, n = l ? n & lo | co : n & lo), t = r;
	                  break e;
	                }

	                break;

	              case 20:
	                break;

	              default:
	                throw a(Error(156));
	            }

	            t = null;
	          }

	          if (r = ol, 1 === al || 1 !== r.childExpirationTime) {
	            for (n = 0, o = r.child; null !== o;) l = o.expirationTime, c = o.childExpirationTime, l > n && (n = l), c > n && (n = c), o = o.sibling;

	            r.childExpirationTime = n;
	          }

	          if (null !== t) return t;
	          null !== e && 0 == (1024 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = ol.firstEffect), null !== ol.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = ol.firstEffect), e.lastEffect = ol.lastEffect), 1 < ol.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = ol : e.firstEffect = ol, e.lastEffect = ol));
	        } else {
	          if (null !== (t = Ta(ol))) return t.effectTag &= 1023, t;
	          null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 1024);
	        }

	        if (null !== (t = ol.sibling)) return t;
	        ol = e;
	      } while (null !== ol);

	      return ll === _a && (ll = nl), null;
	    }

	    function Gl(e) {
	      var t = li();
	      return ci(99, function (e, t) {
	        if (Zl(), (rl & (Ka | qa)) !== Wa) throw a(Error(327));
	        var n = e.finishedWork,
	            r = e.finishedExpirationTime;
	        if (null === n) return null;
	        if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw a(Error(177));
	        e.callbackNode = null, e.callbackExpirationTime = 0;
	        var i = n.expirationTime,
	            o = n.childExpirationTime;

	        if (i = o > i ? o : i, e.firstPendingTime = i, i < e.lastPendingTime && (e.lastPendingTime = i), e === il && (ol = il = null, al = 0), 1 < n.effectTag ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n : i = n.firstEffect, null !== i) {
	          o = rl, rl |= qa, Va.current = null, yr = Ln;
	          var l = Gn();

	          if (Zn(l)) {
	            if ("selectionStart" in l) var u = {
	              start: l.selectionStart,
	              end: l.selectionEnd
	            };else e: {
	              var c = (u = (u = l.ownerDocument) && u.defaultView || window).getSelection && u.getSelection();

	              if (c && 0 !== c.rangeCount) {
	                u = c.anchorNode;
	                var s = c.anchorOffset,
	                    A = c.focusNode;
	                c = c.focusOffset;

	                try {
	                  u.nodeType, A.nodeType;
	                } catch (e) {
	                  u = null;
	                  break e;
	                }

	                var d = 0,
	                    f = -1,
	                    I = -1,
	                    g = 0,
	                    M = 0,
	                    p = l,
	                    N = null;

	                t: for (;;) {
	                  for (var y; p !== u || 0 !== s && 3 !== p.nodeType || (f = d + s), p !== A || 0 !== c && 3 !== p.nodeType || (I = d + c), 3 === p.nodeType && (d += p.nodeValue.length), null !== (y = p.firstChild);) N = p, p = y;

	                  for (;;) {
	                    if (p === l) break t;
	                    if (N === u && ++g === s && (f = d), N === A && ++M === c && (I = d), null !== (y = p.nextSibling)) break;
	                    N = (p = N).parentNode;
	                  }

	                  p = y;
	                }

	                u = -1 === f || -1 === I ? null : {
	                  start: f,
	                  end: I
	                };
	              } else u = null;
	            }
	            u = u || {
	              start: 0,
	              end: 0
	            };
	          } else u = null;

	          vr = {
	            focusedElem: l,
	            selectionRange: u
	          }, Ln = !1, Il = i;

	          do {
	            try {
	              for (; null !== Il;) {
	                if (0 != (256 & Il.effectTag)) {
	                  var v = Il.alternate;

	                  switch ((l = Il).tag) {
	                    case 0:
	                    case 11:
	                    case 15:
	                      ka(Io, fo, l);
	                      break;

	                    case 1:
	                      if (256 & l.effectTag && null !== v) {
	                        var h = v.memoizedProps,
	                            j = v.memoizedState,
	                            m = l.stateNode,
	                            w = m.getSnapshotBeforeUpdate(l.elementType === l.type ? h : gi(l.type, h), j);
	                        m.__reactInternalSnapshotBeforeUpdate = w;
	                      }

	                      break;

	                    case 3:
	                    case 5:
	                    case 6:
	                    case 4:
	                    case 17:
	                      break;

	                    default:
	                      throw a(Error(163));
	                  }
	                }

	                Il = Il.nextEffect;
	              }
	            } catch (e) {
	              if (null === Il) throw a(Error(330));
	              Fl(Il, e), Il = Il.nextEffect;
	            }
	          } while (null !== Il);

	          Il = i;

	          do {
	            try {
	              for (v = t; null !== Il;) {
	                var C = Il.effectTag;

	                if (16 & C && cr(Il.stateNode, ""), 128 & C) {
	                  var b = Il.alternate;

	                  if (null !== b) {
	                    var E = b.ref;
	                    null !== E && ("function" == typeof E ? E(null) : E.current = null);
	                  }
	                }

	                switch (14 & C) {
	                  case 2:
	                    Ba(Il), Il.effectTag &= -3;
	                    break;

	                  case 6:
	                    Ba(Il), Il.effectTag &= -3, Ya(Il.alternate, Il);
	                    break;

	                  case 4:
	                    Ya(Il.alternate, Il);
	                    break;

	                  case 8:
	                    Ua(h = Il, v), h.return = null, h.child = null, h.memoizedState = null, h.updateQueue = null, h.dependencies = null;
	                    var D = h.alternate;
	                    null !== D && (D.return = null, D.child = null, D.memoizedState = null, D.updateQueue = null, D.dependencies = null);
	                }

	                Il = Il.nextEffect;
	              }
	            } catch (e) {
	              if (null === Il) throw a(Error(330));
	              Fl(Il, e), Il = Il.nextEffect;
	            }
	          } while (null !== Il);

	          if (E = vr, b = Gn(), C = E.focusedElem, v = E.selectionRange, b !== C && C && C.ownerDocument && function e(t, n) {
	            return !(!t || !n) && (t === n || (!t || 3 !== t.nodeType) && (n && 3 === n.nodeType ? e(t, n.parentNode) : "contains" in t ? t.contains(n) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n))));
	          }(C.ownerDocument.documentElement, C)) {
	            null !== v && Zn(C) && (b = v.start, void 0 === (E = v.end) && (E = b), "selectionStart" in C ? (C.selectionStart = b, C.selectionEnd = Math.min(E, C.value.length)) : (E = (b = C.ownerDocument || document) && b.defaultView || window).getSelection && (E = E.getSelection(), h = C.textContent.length, D = Math.min(v.start, h), v = void 0 === v.end ? D : Math.min(v.end, h), !E.extend && D > v && (h = v, v = D, D = h), h = Rn(C, D), j = Rn(C, v), h && j && (1 !== E.rangeCount || E.anchorNode !== h.node || E.anchorOffset !== h.offset || E.focusNode !== j.node || E.focusOffset !== j.offset) && ((b = b.createRange()).setStart(h.node, h.offset), E.removeAllRanges(), D > v ? (E.addRange(b), E.extend(j.node, j.offset)) : (b.setEnd(j.node, j.offset), E.addRange(b))))), b = [];

	            for (E = C; E = E.parentNode;) 1 === E.nodeType && b.push({
	              element: E,
	              left: E.scrollLeft,
	              top: E.scrollTop
	            });

	            for ("function" == typeof C.focus && C.focus(), C = 0; C < b.length; C++) (E = b[C]).element.scrollLeft = E.left, E.element.scrollTop = E.top;
	          }

	          vr = null, Ln = !!yr, yr = null, e.current = n, Il = i;

	          do {
	            try {
	              for (C = r; null !== Il;) {
	                var T = Il.effectTag;

	                if (36 & T) {
	                  var x = Il.alternate;

	                  switch (E = C, (b = Il).tag) {
	                    case 0:
	                    case 11:
	                    case 15:
	                      ka(po, No, b);
	                      break;

	                    case 1:
	                      var S = b.stateNode;
	                      if (4 & b.effectTag) if (null === x) S.componentDidMount();else {
	                        var z = b.elementType === b.type ? x.memoizedProps : gi(b.type, x.memoizedProps);
	                        S.componentDidUpdate(z, x.memoizedState, S.__reactInternalSnapshotBeforeUpdate);
	                      }
	                      var L = b.updateQueue;
	                      null !== L && Oi(0, L, S);
	                      break;

	                    case 3:
	                      var k = b.updateQueue;

	                      if (null !== k) {
	                        if (D = null, null !== b.child) switch (b.child.tag) {
	                          case 5:
	                            D = b.child.stateNode;
	                            break;

	                          case 1:
	                            D = b.child.stateNode;
	                        }
	                        Oi(0, k, D);
	                      }

	                      break;

	                    case 5:
	                      var Q = b.stateNode;
	                      null === x && 4 & b.effectTag && (E = Q, hr(b.type, b.memoizedProps) && E.focus());
	                      break;

	                    case 6:
	                    case 4:
	                    case 12:
	                      break;

	                    case 13:
	                    case 19:
	                    case 17:
	                    case 20:
	                      break;

	                    default:
	                      throw a(Error(163));
	                  }
	                }

	                if (128 & T) {
	                  var O = Il.ref;

	                  if (null !== O) {
	                    var P = Il.stateNode;

	                    switch (Il.tag) {
	                      case 5:
	                        var B = P;
	                        break;

	                      default:
	                        B = P;
	                    }

	                    "function" == typeof O ? O(B) : O.current = B;
	                  }
	                }

	                512 & T && (Nl = !0), Il = Il.nextEffect;
	              }
	            } catch (e) {
	              if (null === Il) throw a(Error(330));
	              Fl(Il, e), Il = Il.nextEffect;
	            }
	          } while (null !== Il);

	          Il = null, ti(), rl = o;
	        } else e.current = n;

	        if (Nl) Nl = !1, yl = e, hl = r, vl = t;else for (Il = i; null !== Il;) t = Il.nextEffect, Il.nextEffect = null, Il = t;
	        if (0 !== (t = e.firstPendingTime) ? (T = Ii(T = bl(), t), Sl(e, T, t)) : pl = null, "function" == typeof Wl && Wl(n.stateNode, r), 1073741823 === t ? e === wl ? ml++ : (ml = 0, wl = e) : ml = 0, gl) throw gl = !1, e = Ml, Ml = null, e;
	        return (rl & Xa) !== Wa ? null : (di(), null);
	      }.bind(null, e, t)), null !== yl && si(97, function () {
	        return Zl(), null;
	      }), null;
	    }

	    function Zl() {
	      if (null === yl) return !1;
	      var e = yl,
	          t = hl,
	          n = vl;
	      return yl = null, hl = 0, vl = 90, ci(97 < n ? 97 : n, function (e) {
	        if ((rl & (Ka | qa)) !== Wa) throw a(Error(331));
	        var t = rl;

	        for (rl |= qa, e = e.current.firstEffect; null !== e;) {
	          try {
	            var n = e;
	            if (0 != (512 & n.effectTag)) switch (n.tag) {
	              case 0:
	              case 11:
	              case 15:
	                ka(vo, fo, n), ka(fo, yo, n);
	            }
	          } catch (t) {
	            if (null === e) throw a(Error(330));
	            Fl(e, t);
	          }

	          n = e.nextEffect, e.nextEffect = null, e = n;
	        }

	        return rl = t, di(), !0;
	      }.bind(null, e, t));
	    }

	    function Hl(e, t, n) {
	      Si(e, t = Za(e, t = xa(n, t), 1073741823)), null !== (e = xl(e, 1073741823)) && Sl(e, 99, 1073741823);
	    }

	    function Fl(e, t) {
	      if (3 === e.tag) Hl(e, e, t);else for (var n = e.return; null !== n;) {
	        if (3 === n.tag) {
	          Hl(n, e, t);
	          break;
	        }

	        if (1 === n.tag) {
	          var r = n.stateNode;

	          if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === pl || !pl.has(r))) {
	            Si(n, e = Ha(n, e = xa(t, e), 1073741823)), null !== (n = xl(n, 1073741823)) && Sl(n, 99, 1073741823);
	            break;
	          }
	        }

	        n = n.return;
	      }
	    }

	    function Jl(e, t, n) {
	      var r = e.pingCache;
	      null !== r && r.delete(t), il === e && al === n ? ll === tl || ll === el && 1073741823 === ul && ai() - dl < fl ? Pl(e, al) : Al = !0 : e.lastPendingTime < n || 0 !== (t = e.pingTime) && t < n || (e.pingTime = n, e.finishedExpirationTime === n && (e.finishedExpirationTime = 0, e.finishedWork = null), Sl(e, t = Ii(t = bl(), n), n));
	    }

	    var Vl = void 0;

	    Vl = function (e, t, n) {
	      var r = t.expirationTime;

	      if (null !== e) {
	        var i = t.pendingProps;
	        if (e.memoizedProps !== i || zr.current) ua = !0;else if (r < n) {
	          switch (ua = !1, t.tag) {
	            case 3:
	              pa(t), aa();
	              break;

	            case 5:
	              if (oo(t), 4 & t.mode && 1 !== n && i.hidden) return t.expirationTime = t.childExpirationTime = 1, null;
	              break;

	            case 1:
	              Qr(t.type) && Yr(t);
	              break;

	            case 4:
	              ro(t, t.stateNode.containerInfo);
	              break;

	            case 10:
	              hi(t, t.memoizedProps.value);
	              break;

	            case 13:
	              if (null !== t.memoizedState) return 0 !== (r = t.child.childExpirationTime) && r >= n ? ya(e, t, n) : (Tr(so, so.current & lo), null !== (t = ja(e, t, n)) ? t.sibling : null);
	              Tr(so, so.current & lo);
	              break;

	            case 19:
	              if (r = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
	                if (r) return ha(e, t, n);
	                t.effectTag |= 64;
	              }

	              if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null), Tr(so, so.current), !r) return null;
	          }

	          return ja(e, t, n);
	        }
	      } else ua = !1;

	      switch (t.expirationTime = 0, t.tag) {
	        case 2:
	          if (r = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, i = kr(t, Sr.current), wi(t, n), i = Po(null, t, r, e, i, n), t.effectTag |= 1, "object" == typeof i && null !== i && "function" == typeof i.render && void 0 === i.$$typeof) {
	            if (t.tag = 1, Bo(), Qr(r)) {
	              var o = !0;
	              Yr(t);
	            } else o = !1;

	            t.memoizedState = null !== i.state && void 0 !== i.state ? i.state : null;
	            var l = r.getDerivedStateFromProps;
	            "function" == typeof l && Yi(t, r, l, e), i.updater = Ri, t.stateNode = i, i._reactInternalFiber = t, Fi(t, r, e, n), t = Ma(null, t, r, !0, o, n);
	          } else t.tag = 0, ca(null, t, i, n), t = t.child;

	          return t;

	        case 16:
	          switch (i = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, i = function (e) {
	            var t = e._result;

	            switch (e._status) {
	              case 1:
	                return t;

	              case 2:
	              case 0:
	                throw t;

	              default:
	                switch (e._status = 0, (t = (t = e._ctor)()).then(function (t) {
	                  0 === e._status && (t = t.default, e._status = 1, e._result = t);
	                }, function (t) {
	                  0 === e._status && (e._status = 2, e._result = t);
	                }), e._status) {
	                  case 1:
	                    return e._result;

	                  case 2:
	                    throw e._result;
	                }

	                throw e._result = t, t;
	            }
	          }(i), t.type = i, o = t.tag = function (e) {
	            if ("function" == typeof e) return ql(e) ? 1 : 0;

	            if (void 0 !== e && null !== e) {
	              if ((e = e.$$typeof) === nt) return 11;
	              if (e === ot) return 14;
	            }

	            return 2;
	          }(i), e = gi(i, e), o) {
	            case 0:
	              t = Ia(null, t, i, e, n);
	              break;

	            case 1:
	              t = ga(null, t, i, e, n);
	              break;

	            case 11:
	              t = sa(null, t, i, e, n);
	              break;

	            case 14:
	              t = Aa(null, t, i, gi(i.type, e), r, n);
	              break;

	            default:
	              throw a(Error(306), i, "");
	          }

	          return t;

	        case 0:
	          return r = t.type, i = t.pendingProps, Ia(e, t, r, i = t.elementType === r ? i : gi(r, i), n);

	        case 1:
	          return r = t.type, i = t.pendingProps, ga(e, t, r, i = t.elementType === r ? i : gi(r, i), n);

	        case 3:
	          if (pa(t), null === (r = t.updateQueue)) throw a(Error(282));
	          return i = null !== (i = t.memoizedState) ? i.element : null, Qi(t, r, t.pendingProps, null, n), (r = t.memoizedState.element) === i ? (aa(), t = ja(e, t, n)) : (i = t.stateNode, (i = (null === e || null === e.child) && i.hydrate) && ($o = Cr(t.stateNode.containerInfo.firstChild), _o = t, i = ea = !0), i ? (t.effectTag |= 2, t.child = qi(t, null, r, n)) : (ca(e, t, r, n), aa()), t = t.child), t;

	        case 5:
	          return oo(t), null === e && ra(t), r = t.type, i = t.pendingProps, o = null !== e ? e.memoizedProps : null, l = i.children, jr(r, i) ? l = null : null !== o && jr(r, o) && (t.effectTag |= 16), fa(e, t), 4 & t.mode && 1 !== n && i.hidden ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (ca(e, t, l, n), t = t.child), t;

	        case 6:
	          return null === e && ra(t), null;

	        case 13:
	          return ya(e, t, n);

	        case 4:
	          return ro(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = Ki(t, null, r, n) : ca(e, t, r, n), t.child;

	        case 11:
	          return r = t.type, i = t.pendingProps, sa(e, t, r, i = t.elementType === r ? i : gi(r, i), n);

	        case 7:
	          return ca(e, t, t.pendingProps, n), t.child;

	        case 8:
	        case 12:
	          return ca(e, t, t.pendingProps.children, n), t.child;

	        case 10:
	          e: {
	            if (r = t.type._context, i = t.pendingProps, l = t.memoizedProps, hi(t, o = i.value), null !== l) {
	              var u = l.value;

	              if (0 === (o = en(u, o) ? 0 : 0 | ("function" == typeof r._calculateChangedBits ? r._calculateChangedBits(u, o) : 1073741823))) {
	                if (l.children === i.children && !zr.current) {
	                  t = ja(e, t, n);
	                  break e;
	                }
	              } else for (null !== (u = t.child) && (u.return = t); null !== u;) {
	                var c = u.dependencies;

	                if (null !== c) {
	                  l = u.child;

	                  for (var s = c.firstContext; null !== s;) {
	                    if (s.context === r && 0 != (s.observedBits & o)) {
	                      1 === u.tag && ((s = Ti(n, null)).tag = 2, Si(u, s)), u.expirationTime < n && (u.expirationTime = n), null !== (s = u.alternate) && s.expirationTime < n && (s.expirationTime = n), mi(u.return, n), c.expirationTime < n && (c.expirationTime = n);
	                      break;
	                    }

	                    s = s.next;
	                  }
	                } else l = 10 === u.tag && u.type === t.type ? null : u.child;

	                if (null !== l) l.return = u;else for (l = u; null !== l;) {
	                  if (l === t) {
	                    l = null;
	                    break;
	                  }

	                  if (null !== (u = l.sibling)) {
	                    u.return = l.return, l = u;
	                    break;
	                  }

	                  l = l.return;
	                }
	                u = l;
	              }
	            }

	            ca(e, t, i.children, n), t = t.child;
	          }

	          return t;

	        case 9:
	          return i = t.type, r = (o = t.pendingProps).children, wi(t, n), r = r(i = Ci(i, o.unstable_observedBits)), t.effectTag |= 1, ca(e, t, r, n), t.child;

	        case 14:
	          return o = gi(i = t.type, t.pendingProps), Aa(e, t, i, o = gi(i.type, o), r, n);

	        case 15:
	          return da(e, t, t.type, t.pendingProps, r, n);

	        case 17:
	          return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : gi(r, i), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, Qr(r) ? (e = !0, Yr(t)) : e = !1, wi(t, n), Zi(t, r, i), Fi(t, r, i, n), Ma(null, t, r, !0, e, n);

	        case 19:
	          return ha(e, t, n);
	      }

	      throw a(Error(156));
	    };

	    var Wl = null,
	        Xl = null;

	    function Kl(e, t, n, r) {
	      return new function (e, t, n, r) {
	        this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
	      }(e, t, n, r);
	    }

	    function ql(e) {
	      return !(!(e = e.prototype) || !e.isReactComponent);
	    }

	    function _l(e, t) {
	      var n = e.alternate;
	      return null === n ? ((n = Kl(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
	        expirationTime: t.expirationTime,
	        firstContext: t.firstContext,
	        responders: t.responders
	      }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
	    }

	    function $l(e, t, n, r, i, o) {
	      var l = 2;
	      if (r = e, "function" == typeof e) ql(e) && (l = 1);else if ("string" == typeof e) l = 5;else e: switch (e) {
	        case Ke:
	          return eu(n.children, i, o, t);

	        case tt:
	          l = 8, i |= 7;
	          break;

	        case qe:
	          l = 8, i |= 1;
	          break;

	        case _e:
	          return (e = Kl(12, n, t, 8 | i)).elementType = _e, e.type = _e, e.expirationTime = o, e;

	        case rt:
	          return (e = Kl(13, n, t, i)).type = rt, e.elementType = rt, e.expirationTime = o, e;

	        case it:
	          return (e = Kl(19, n, t, i)).elementType = it, e.expirationTime = o, e;

	        default:
	          if ("object" == typeof e && null !== e) switch (e.$$typeof) {
	            case $e:
	              l = 10;
	              break e;

	            case et:
	              l = 9;
	              break e;

	            case nt:
	              l = 11;
	              break e;

	            case ot:
	              l = 14;
	              break e;

	            case at:
	              l = 16, r = null;
	              break e;
	          }
	          throw a(Error(130), null == e ? e : typeof e, "");
	      }
	      return (t = Kl(l, n, t, i)).elementType = e, t.type = r, t.expirationTime = o, t;
	    }

	    function eu(e, t, n, r) {
	      return (e = Kl(7, e, r, t)).expirationTime = n, e;
	    }

	    function tu(e, t, n) {
	      return (e = Kl(6, e, null, t)).expirationTime = n, e;
	    }

	    function nu(e, t, n) {
	      return (t = Kl(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
	        containerInfo: e.containerInfo,
	        pendingChildren: null,
	        implementation: e.implementation
	      }, t;
	    }

	    function ru(e, t, n) {
	      return e = new function (e, t, n) {
	        this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = this.firstBatch = null, this.pingTime = this.lastPendingTime = this.firstPendingTime = this.callbackExpirationTime = 0;
	      }(e, t, n), t = Kl(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0), e.current = t, t.stateNode = e;
	    }

	    function iu(e, t, n, r, i, o) {
	      var l = t.current;

	      e: if (n) {
	        n = n._reactInternalFiber;

	        t: {
	          if (2 !== on(n) || 1 !== n.tag) throw a(Error(170));
	          var u = n;

	          do {
	            switch (u.tag) {
	              case 3:
	                u = u.stateNode.context;
	                break t;

	              case 1:
	                if (Qr(u.type)) {
	                  u = u.stateNode.__reactInternalMemoizedMergedChildContext;
	                  break t;
	                }

	            }

	            u = u.return;
	          } while (null !== u);

	          throw a(Error(171));
	        }

	        if (1 === n.tag) {
	          var c = n.type;

	          if (Qr(c)) {
	            n = Ur(n, c, u);
	            break e;
	          }
	        }

	        n = u;
	      } else n = xr;

	      return null === t.context ? t.context = n : t.pendingContext = n, t = o, (i = Ti(r, i)).payload = {
	        element: e
	      }, null !== (t = void 0 === t ? null : t) && (i.callback = t), Si(l, i), Tl(l, r), r;
	    }

	    function ou(e, t, n, r) {
	      var i = t.current,
	          o = bl(),
	          a = Bi.suspense;
	      return iu(e, t, n, i = El(o, i, a), a, r);
	    }

	    function au(e) {
	      if (!(e = e.current).child) return null;

	      switch (e.child.tag) {
	        case 5:
	        default:
	          return e.child.stateNode;
	      }
	    }

	    function lu(e) {
	      var t = 1073741821 - 25 * (1 + ((1073741821 - bl() + 500) / 25 | 0));
	      t <= Dl && --t, this._expirationTime = Dl = t, this._root = e, this._callbacks = this._next = null, this._hasChildren = this._didComplete = !1, this._children = null, this._defer = !0;
	    }

	    function uu() {
	      this._callbacks = null, this._didCommit = !1, this._onCommit = this._onCommit.bind(this);
	    }

	    function cu(e, t, n) {
	      this._internalRoot = ru(e, t, n);
	    }

	    function su(e, t) {
	      this._internalRoot = ru(e, 2, t);
	    }

	    function Au(e) {
	      return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
	    }

	    function du(e, t, n, r, i) {
	      var o = n._reactRootContainer,
	          a = void 0;

	      if (o) {
	        if (a = o._internalRoot, "function" == typeof i) {
	          var l = i;

	          i = function () {
	            var e = au(a);
	            l.call(e);
	          };
	        }

	        ou(t, a, e, i);
	      } else {
	        if (o = n._reactRootContainer = function (e, t) {
	          if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for (var n; n = e.lastChild;) e.removeChild(n);
	          return new cu(e, 0, t);
	        }(n, r), a = o._internalRoot, "function" == typeof i) {
	          var u = i;

	          i = function () {
	            var e = au(a);
	            u.call(e);
	          };
	        }

	        Ol(function () {
	          ou(t, a, e, i);
	        });
	      }

	      return au(a);
	    }

	    function fu(e, t) {
	      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
	      if (!Au(t)) throw a(Error(200));
	      return function (e, t, n) {
	        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
	        return {
	          $$typeof: Xe,
	          key: null == r ? null : "" + r,
	          children: e,
	          containerInfo: t,
	          implementation: n
	        };
	      }(e, t, null, n);
	    }

	    be = function (e, t, n) {
	      switch (t) {
	        case "input":
	          if (wt(e, n), t = n.name, "radio" === n.type && null != t) {
	            for (n = e; n.parentNode;) n = n.parentNode;

	            for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
	              var r = n[t];

	              if (r !== e && r.form === e.form) {
	                var i = B(r);
	                if (!i) throw a(Error(90));
	                He(r), wt(r, i);
	              }
	            }
	          }

	          break;

	        case "textarea":
	          nr(e, n);
	          break;

	        case "select":
	          null != (t = n.value) && $n(e, !!n.multiple, t, !1);
	      }
	    }, lu.prototype.render = function (e) {
	      if (!this._defer) throw a(Error(250));
	      this._hasChildren = !0, this._children = e;
	      var t = this._root._internalRoot,
	          n = this._expirationTime,
	          r = new uu();
	      return iu(e, t, null, n, null, r._onCommit), r;
	    }, lu.prototype.then = function (e) {
	      if (this._didComplete) e();else {
	        var t = this._callbacks;
	        null === t && (t = this._callbacks = []), t.push(e);
	      }
	    }, lu.prototype.commit = function () {
	      var e = this._root._internalRoot,
	          t = e.firstBatch;
	      if (!this._defer || null === t) throw a(Error(251));

	      if (this._hasChildren) {
	        var n = this._expirationTime;

	        if (t !== this) {
	          this._hasChildren && (n = this._expirationTime = t._expirationTime, this.render(this._children));

	          for (var r = null, i = t; i !== this;) r = i, i = i._next;

	          if (null === r) throw a(Error(251));
	          r._next = i._next, this._next = t, e.firstBatch = this;
	        }

	        if (this._defer = !1, t = n, (rl & (Ka | qa)) !== Wa) throw a(Error(253));
	        Ai(Bl.bind(null, e, t)), di(), t = this._next, this._next = null, null !== (t = e.firstBatch = t) && t._hasChildren && t.render(t._children);
	      } else this._next = null, this._defer = !1;
	    }, lu.prototype._onComplete = function () {
	      if (!this._didComplete) {
	        this._didComplete = !0;
	        var e = this._callbacks;
	        if (null !== e) for (var t = 0; t < e.length; t++) (0, e[t])();
	      }
	    }, uu.prototype.then = function (e) {
	      if (this._didCommit) e();else {
	        var t = this._callbacks;
	        null === t && (t = this._callbacks = []), t.push(e);
	      }
	    }, uu.prototype._onCommit = function () {
	      if (!this._didCommit) {
	        this._didCommit = !0;
	        var e = this._callbacks;
	        if (null !== e) for (var t = 0; t < e.length; t++) {
	          var n = e[t];
	          if ("function" != typeof n) throw a(Error(191), n);
	          n();
	        }
	      }
	    }, su.prototype.render = cu.prototype.render = function (e, t) {
	      var n = this._internalRoot,
	          r = new uu();
	      return null !== (t = void 0 === t ? null : t) && r.then(t), ou(e, n, null, r._onCommit), r;
	    }, su.prototype.unmount = cu.prototype.unmount = function (e) {
	      var t = this._internalRoot,
	          n = new uu();
	      return null !== (e = void 0 === e ? null : e) && n.then(e), ou(null, t, null, n._onCommit), n;
	    }, su.prototype.createBatch = function () {
	      var e = new lu(this),
	          t = e._expirationTime,
	          n = this._internalRoot,
	          r = n.firstBatch;
	      if (null === r) n.firstBatch = e, e._next = null;else {
	        for (n = null; null !== r && r._expirationTime >= t;) n = r, r = r._next;

	        e._next = r, null !== n && (n._next = e);
	      }
	      return e;
	    }, ze = kl, Le = Ql, ke = Ll, Qe = function (e, t) {
	      var n = rl;
	      rl |= 2;

	      try {
	        return e(t);
	      } finally {
	        (rl = n) === Wa && di();
	      }
	    };
	    var Iu = {
	      createPortal: fu,
	      findDOMNode: function (e) {
	        if (null == e) e = null;else if (1 !== e.nodeType) {
	          var t = e._reactInternalFiber;

	          if (void 0 === t) {
	            if ("function" == typeof e.render) throw a(Error(188));
	            throw a(Error(268), Object.keys(e));
	          }

	          e = null === (e = ln(t)) ? null : e.stateNode;
	        }
	        return e;
	      },
	      hydrate: function (e, t, n) {
	        if (!Au(t)) throw a(Error(200));
	        return du(null, e, t, !0, n);
	      },
	      render: function (e, t, n) {
	        if (!Au(t)) throw a(Error(200));
	        return du(null, e, t, !1, n);
	      },
	      unstable_renderSubtreeIntoContainer: function (e, t, n, r) {
	        if (!Au(n)) throw a(Error(200));
	        if (null == e || void 0 === e._reactInternalFiber) throw a(Error(38));
	        return du(e, t, n, !1, r);
	      },
	      unmountComponentAtNode: function (e) {
	        if (!Au(e)) throw a(Error(40));
	        return !!e._reactRootContainer && (Ol(function () {
	          du(null, null, e, !1, function () {
	            e._reactRootContainer = null;
	          });
	        }), !0);
	      },
	      unstable_createPortal: function () {
	        return fu.apply(void 0, arguments);
	      },
	      unstable_batchedUpdates: kl,
	      unstable_interactiveUpdates: function (e, t, n, r) {
	        return Ll(), Ql(e, t, n, r);
	      },
	      unstable_discreteUpdates: Ql,
	      unstable_flushDiscreteUpdates: Ll,
	      flushSync: function (e, t) {
	        if ((rl & (Ka | qa)) !== Wa) throw a(Error(187));
	        var n = rl;
	        rl |= 1;

	        try {
	          return ci(99, e.bind(null, t));
	        } finally {
	          rl = n, di();
	        }
	      },
	      unstable_createRoot: function (e, t) {
	        if (!Au(e)) throw a(Error(299), "unstable_createRoot");
	        return new su(e, null != t && !0 === t.hydrate);
	      },
	      unstable_createSyncRoot: function (e, t) {
	        if (!Au(e)) throw a(Error(299), "unstable_createRoot");
	        return new cu(e, 1, null != t && !0 === t.hydrate);
	      },
	      unstable_flushControlled: function (e) {
	        var t = rl;
	        rl |= 1;

	        try {
	          ci(99, e);
	        } finally {
	          (rl = t) === Wa && di();
	        }
	      },
	      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
	        Events: [O, P, B, x.injectEventPluginsByName, d, H, function (e) {
	          b(e, Z);
	        }, xe, Se, On, T, Zl, {
	          current: !1
	        }]
	      }
	    };
	    !function (e) {
	      var t = e.findFiberByHostInstance;

	      (function (e) {
	        if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
	        var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
	        if (t.isDisabled || !t.supportsFiber) return !0;

	        try {
	          var n = t.inject(e);
	          Wl = function (e) {
	            try {
	              t.onCommitFiberRoot(n, e, void 0, 64 == (64 & e.current.effectTag));
	            } catch (e) {}
	          }, Xl = function (e) {
	            try {
	              t.onCommitFiberUnmount(n, e);
	            } catch (e) {}
	          };
	        } catch (e) {}
	      })(i({}, e, {
	        overrideHookState: null,
	        overrideProps: null,
	        setSuspenseHandler: null,
	        scheduleUpdate: null,
	        currentDispatcherRef: Fe.ReactCurrentDispatcher,
	        findHostInstanceByFiber: function (e) {
	          return null === (e = ln(e)) ? null : e.stateNode;
	        },
	        findFiberByHostInstance: function (e) {
	          return t ? t(e) : null;
	        },
	        findHostInstancesForRefresh: null,
	        scheduleRefresh: null,
	        scheduleRoot: null,
	        setRefreshHandler: null,
	        getCurrentFiber: null
	      }));
	    }({
	      findFiberByHostInstance: Q,
	      bundleType: 0,
	      version: "16.9.0",
	      rendererPackageName: "react-dom"
	    });
	    var gu = {
	      default: Iu
	    },
	        Mu = gu && Iu || gu;
	    e.exports = Mu.default || Mu;
	  }, function (e, t, n) {

	    e.exports = n(26);
	  }, function (e, t, n) {
	    /** @license React v0.15.0
	     * scheduler.production.min.js
	     *
	     * Copyright (c) Facebook, Inc. and its affiliates.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     */

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = void 0,
	        i = void 0,
	        o = void 0,
	        a = void 0,
	        l = void 0;

	    if (t.unstable_now = void 0, t.unstable_forceFrameRate = void 0, "undefined" == typeof window || "function" != typeof MessageChannel) {
	      var u = null,
	          c = null,
	          s = function () {
	        if (null !== u) try {
	          var e = t.unstable_now();
	          u(!0, e), u = null;
	        } catch (e) {
	          throw setTimeout(s, 0), e;
	        }
	      };

	      t.unstable_now = function () {
	        return Date.now();
	      }, r = function (e) {
	        null !== u ? setTimeout(r, 0, e) : (u = e, setTimeout(s, 0));
	      }, i = function (e, t) {
	        c = setTimeout(e, t);
	      }, o = function () {
	        clearTimeout(c);
	      }, a = function () {
	        return !1;
	      }, l = t.unstable_forceFrameRate = function () {};
	    } else {
	      var A = window.performance,
	          d = window.Date,
	          f = window.setTimeout,
	          I = window.clearTimeout,
	          g = window.requestAnimationFrame,
	          M = window.cancelAnimationFrame;
	      "undefined" != typeof console && ("function" != typeof g && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof M && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")), t.unstable_now = "object" == typeof A && "function" == typeof A.now ? function () {
	        return A.now();
	      } : function () {
	        return d.now();
	      };
	      var p = !1,
	          N = null,
	          y = -1,
	          v = -1,
	          h = 33.33,
	          j = -1,
	          m = -1,
	          w = 0,
	          C = !1;
	      a = function () {
	        return t.unstable_now() >= w;
	      }, l = function () {}, t.unstable_forceFrameRate = function (e) {
	        0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : 0 < e ? (h = Math.floor(1e3 / e), C = !0) : (h = 33.33, C = !1);
	      };

	      var b = function () {
	        if (null !== N) {
	          var e = t.unstable_now(),
	              n = 0 < w - e;

	          try {
	            N(n, e) || (N = null);
	          } catch (e) {
	            throw D.postMessage(null), e;
	          }
	        }
	      },
	          E = new MessageChannel(),
	          D = E.port2;

	      E.port1.onmessage = b;

	      var T = function (e) {
	        if (null === N) m = j = -1, p = !1;else {
	          p = !0, g(function (e) {
	            I(y), T(e);
	          });

	          var n = function () {
	            w = t.unstable_now() + h / 2, b(), y = f(n, 3 * h);
	          };

	          if (y = f(n, 3 * h), -1 !== j && .1 < e - j) {
	            var r = e - j;
	            !C && -1 !== m && r < h && m < h && 8.33 > (h = r < m ? m : r) && (h = 8.33), m = r;
	          }

	          j = e, w = e + h, D.postMessage(null);
	        }
	      };

	      r = function (e) {
	        N = e, p || (p = !0, g(function (e) {
	          T(e);
	        }));
	      }, i = function (e, n) {
	        v = f(function () {
	          e(t.unstable_now());
	        }, n);
	      }, o = function () {
	        I(v), v = -1;
	      };
	    }

	    var x = null,
	        S = null,
	        z = null,
	        L = 3,
	        k = !1,
	        Q = !1,
	        O = !1;

	    function P(e, t) {
	      var n = e.next;
	      if (n === e) x = null;else {
	        e === x && (x = n);
	        var r = e.previous;
	        r.next = n, n.previous = r;
	      }
	      e.next = e.previous = null, n = e.callback, r = L;
	      var i = z;
	      L = e.priorityLevel, z = e;

	      try {
	        var o = e.expirationTime <= t;

	        switch (L) {
	          case 1:
	            var a = n(o);
	            break;

	          case 2:
	          case 3:
	          case 4:
	            a = n(o);
	            break;

	          case 5:
	            a = n(o);
	        }
	      } catch (e) {
	        throw e;
	      } finally {
	        L = r, z = i;
	      }

	      if ("function" == typeof a) if (t = e.expirationTime, e.callback = a, null === x) x = e.next = e.previous = e;else {
	        a = null, o = x;

	        do {
	          if (t <= o.expirationTime) {
	            a = o;
	            break;
	          }

	          o = o.next;
	        } while (o !== x);

	        null === a ? a = x : a === x && (x = e), (t = a.previous).next = a.previous = e, e.next = a, e.previous = t;
	      }
	    }

	    function B(e) {
	      if (null !== S && S.startTime <= e) do {
	        var t = S,
	            n = t.next;
	        if (t === n) S = null;else {
	          S = n;
	          var r = t.previous;
	          r.next = n, n.previous = r;
	        }
	        t.next = t.previous = null, G(t, t.expirationTime);
	      } while (null !== S && S.startTime <= e);
	    }

	    function U(e) {
	      O = !1, B(e), Q || (null !== x ? (Q = !0, r(Y)) : null !== S && i(U, S.startTime - e));
	    }

	    function Y(e, n) {
	      Q = !1, O && (O = !1, o()), B(n), k = !0;

	      try {
	        if (e) {
	          if (null !== x) do {
	            P(x, n), B(n = t.unstable_now());
	          } while (null !== x && !a());
	        } else for (; null !== x && x.expirationTime <= n;) P(x, n), B(n = t.unstable_now());

	        return null !== x || (null !== S && i(U, S.startTime - n), !1);
	      } finally {
	        k = !1;
	      }
	    }

	    function R(e) {
	      switch (e) {
	        case 1:
	          return -1;

	        case 2:
	          return 250;

	        case 5:
	          return 1073741823;

	        case 4:
	          return 1e4;

	        default:
	          return 5e3;
	      }
	    }

	    function G(e, t) {
	      if (null === x) x = e.next = e.previous = e;else {
	        var n = null,
	            r = x;

	        do {
	          if (t < r.expirationTime) {
	            n = r;
	            break;
	          }

	          r = r.next;
	        } while (r !== x);

	        null === n ? n = x : n === x && (x = e), (t = n.previous).next = n.previous = e, e.next = n, e.previous = t;
	      }
	    }

	    var Z = l;
	    t.unstable_ImmediatePriority = 1, t.unstable_UserBlockingPriority = 2, t.unstable_NormalPriority = 3, t.unstable_IdlePriority = 5, t.unstable_LowPriority = 4, t.unstable_runWithPriority = function (e, t) {
	      switch (e) {
	        case 1:
	        case 2:
	        case 3:
	        case 4:
	        case 5:
	          break;

	        default:
	          e = 3;
	      }

	      var n = L;
	      L = e;

	      try {
	        return t();
	      } finally {
	        L = n;
	      }
	    }, t.unstable_next = function (e) {
	      switch (L) {
	        case 1:
	        case 2:
	        case 3:
	          var t = 3;
	          break;

	        default:
	          t = L;
	      }

	      var n = L;
	      L = t;

	      try {
	        return e();
	      } finally {
	        L = n;
	      }
	    }, t.unstable_scheduleCallback = function (e, n, a) {
	      var l = t.unstable_now();

	      if ("object" == typeof a && null !== a) {
	        var u = a.delay;
	        u = "number" == typeof u && 0 < u ? l + u : l, a = "number" == typeof a.timeout ? a.timeout : R(e);
	      } else a = R(e), u = l;

	      if (e = {
	        callback: n,
	        priorityLevel: e,
	        startTime: u,
	        expirationTime: a = u + a,
	        next: null,
	        previous: null
	      }, u > l) {
	        if (a = u, null === S) S = e.next = e.previous = e;else {
	          n = null;
	          var c = S;

	          do {
	            if (a < c.startTime) {
	              n = c;
	              break;
	            }

	            c = c.next;
	          } while (c !== S);

	          null === n ? n = S : n === S && (S = e), (a = n.previous).next = n.previous = e, e.next = n, e.previous = a;
	        }
	        null === x && S === e && (O ? o() : O = !0, i(U, u - l));
	      } else G(e, a), Q || k || (Q = !0, r(Y));

	      return e;
	    }, t.unstable_cancelCallback = function (e) {
	      var t = e.next;

	      if (null !== t) {
	        if (e === t) e === x ? x = null : e === S && (S = null);else {
	          e === x ? x = t : e === S && (S = t);
	          var n = e.previous;
	          n.next = t, t.previous = n;
	        }
	        e.next = e.previous = null;
	      }
	    }, t.unstable_wrapCallback = function (e) {
	      var t = L;
	      return function () {
	        var n = L;
	        L = t;

	        try {
	          return e.apply(this, arguments);
	        } finally {
	          L = n;
	        }
	      };
	    }, t.unstable_getCurrentPriorityLevel = function () {
	      return L;
	    }, t.unstable_shouldYield = function () {
	      var e = t.unstable_now();
	      return B(e), null !== z && null !== x && x.startTime <= e && x.expirationTime < z.expirationTime || a();
	    }, t.unstable_requestPaint = Z, t.unstable_continueExecution = function () {
	      Q || k || (Q = !0, r(Y));
	    }, t.unstable_pauseExecution = function () {}, t.unstable_getFirstCallbackNode = function () {
	      return x;
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    }), t.WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID", t.INJECTED_PROVIDER_ID = "injected", t.CACHED_PROVIDER_KEY = "WEB3_CONNECT_CACHED_PROVIDER", t.CONNECT_EVENT = "connect", t.ERROR_EVENT = "error", t.CLOSE_EVENT = "close", t.MODAL_LIGHTBOX_CLASSNAME = "web3modal-modal-lightbox", t.MODAL_CONTAINER_CLASSNAME = "web3modal-modal-container", t.MODAL_HITBOX_CLASSNAME = "web3modal-modal-hitbox", t.MODAL_CARD_CLASSNAME = "web3modal-modal-card", t.PROVIDER_WRAPPER_CLASSNAME = "web3modal-provider-wrapper", t.PROVIDER_CONTAINER_CLASSNAME = "web3modal-provider-container", t.PROVIDER_ICON_CLASSNAME = "web3modal-provider-icon", t.PROVIDER_NAME_CLASSNAME = "web3modal-provider-name", t.PROVIDER_DESCRIPTION_CLASSNAME = "web3modal-provider-description", t.CONNECT_BUTTON_CLASSNAME = "web3modal-connect-button";
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);
	    "undefined" != typeof window && void 0 !== window.localStorage && (t.local = window.localStorage), t.setLocal = function (e, n) {
	      var r = JSON.stringify(n);
	      t.local && t.local.setItem(e, r);
	    }, t.getLocal = function (e) {
	      var n = null,
	          r = null;
	      if (t.local && (r = t.local.getItem(e)), r && "string" == typeof r) try {
	        n = JSON.parse(r);
	      } catch (e) {
	        return null;
	      }
	      return n;
	    }, t.removeLocal = function (e) {
	      t.local && t.local.removeItem(e);
	    }, t.updateLocal = function (e, n) {
	      var i = t.getLocal(e) || {},
	          o = r.__assign(r.__assign({}, i), n);

	      t.setLocal(e, o);
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(10),
	        i = n(3),
	        o = n(4),
	        a = n(11);

	    function l() {
	      var e = {
	        injectedAvailable: !!window.ethereum || !!window.web3
	      };

	      if (e.injectedAvailable) {
	        var t = !0;
	        o.providers.forEach(function (n) {
	          u(n.check) && (e[n.check] = !0, t = !1);
	        }), t && (e[a.FALLBACK_INJECTED.check] = !0);
	      }

	      return e;
	    }

	    function u(e) {
	      return window.ethereum ? !!(window.ethereum[e] || window.web3 && window.web3.currentProvider) && (!window.web3 || window.web3.currentProvider[e]) : !(!window.web3 || !window.web3.currentProvider) && window.web3.currentProvider[e];
	    }

	    function c() {
	      var e = null,
	          t = l();
	      t.injectedAvailable && (delete t.injectedAvailable, e = s(Object.keys(t)));
	      return e;
	    }

	    function s(e) {
	      return A(f(e));
	    }

	    function A(e) {
	      return e ? d(o.providers, function (t) {
	        return t.check === e;
	      }, o.FALLBACK) : o.FALLBACK;
	    }

	    function d(e, t, n) {
	      var r = n,
	          i = e.filter(t);
	      return i && i.length && (r = i[0]), r;
	    }

	    function f(e) {
	      return e && e.length ? e.length > 1 && (e[0] === a.METAMASK_INJECTED.check || e[0] === a.CIPHER_INJECTED.check) ? e[1] : e[0] : o.FALLBACK.check;
	    }

	    t.checkInjectedProviders = l, t.verifyInjectedProvider = u, t.getInjectedProvider = c, t.getInjectedProviderName = function () {
	      var e = c();
	      return e ? e.name : null;
	    }, t.getProviderInfo = function (e) {
	      return e ? s(o.providers.filter(function (t) {
	        return e[t.check];
	      }).map(function (e) {
	        return e.check;
	      })) : o.FALLBACK;
	    }, t.getProviderInfoFromChecksArray = s, t.getProviderInfoByName = function (e) {
	      return e ? d(o.providers, function (t) {
	        return t.name === e;
	      }, o.FALLBACK) : o.FALLBACK;
	    }, t.getProviderInfoById = function (e) {
	      return e ? d(o.providers, function (t) {
	        return t.id === e;
	      }, o.FALLBACK) : o.FALLBACK;
	    }, t.getProviderInfoByCheck = A, t.isMobile = function () {
	      return !(!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) && !/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0, 4)) && !function () {
	        try {
	          return document.createEvent("TouchEvent"), !0;
	        } catch (e) {
	          return !1;
	        }
	      }());
	    }, t.formatProviderDescription = function (e) {
	      var t = "";

	      switch (e.type) {
	        case "injected":
	          t = "Connect to your " + e.name + " Wallet";
	          break;

	        case "web":
	          t = "Connect with your " + e.name + " account";
	          break;

	        case "qrcode":
	          t = "Scan with " + e.name + " to connect";
	      }

	      return t;
	    }, t.filterMatches = d, t.filterProviderChecks = f, t.getChainId = function (e) {
	      return d(Object.values(r.chainList), function (t) {
	        return t.network === e;
	      }, r.EMPTY_CHAIN_DATA).chainId;
	    }, t.getThemeColors = function (e) {
	      return "string" == typeof e ? i.themesList[e].colors : e;
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    t.default = {
	      name: "light",
	      colors: {
	        background: "rgb(255, 255, 255)",
	        main: "rgb(12, 12, 13)",
	        secondary: "rgb(169, 169, 188)",
	        border: "rgba(195, 195, 195, 0.14)",
	        hover: "rgba(195, 195, 195, 0.14)"
	      }
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    t.default = {
	      name: "dark",
	      colors: {
	        background: "rgb(39, 49, 56)",
	        main: "rgb(199, 199, 199)",
	        secondary: "rgb(136, 136, 136)",
	        border: "rgba(195, 195, 195, 0.14)",
	        hover: "rgb(16, 26, 32)"
	      }
	    };
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDAgNDQwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwOGM3Mzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnNhbnNfd2hpdGUgY29weTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIwLDkuODJDMTAzLjkyLDkuODIsOS44MiwxMDMuOTIsOS44MiwyMjBTMTAzLjkyLDQzMC4xOCwyMjAsNDMwLjE4LDQzMC4xOCwzMzYuMDgsNDMwLjE4LDIyMCwzMzYuMDgsOS44MiwyMjAsOS44MlpNMzczLjgzLDIzMS40N0gyNzYuM2E1OS40MSw1OS40MSwwLDEsMSwuNDUtMjAuNjdoOTcuMDhhMTAuMzQsMTAuMzQsMCwxLDEsMCwyMC42N1oiLz48L3N2Zz4=";
	  }, function (e, t) {
	    e.exports = "data:image/png;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNTguOCAxODQiIHZpZXdCb3g9IjAgMCAxNTguOCAxODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzU0IDM1MSkiPjxwYXRoIGQ9Im0tMjc0LjYtMzQzLjdjMjkuMyAyMi43IDYyLjkgMjEuMyA3Mi41IDIxLjMtMi4xIDEyOS4xLTE4LjEgMTExLjktNzIuNSAxNDguMS01NC40LTM2LjItNzAuMy0xOS03Mi40LTE0OC4xIDkuNSAwIDQzIDEuNCA3Mi40LTIxLjN6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0ibS0yNzQuNi0zNDMuNyA0LjItNS41Yy0yLjUtMS45LTYtMS45LTguNSAwem03Mi41IDIxLjMgNi45LjFjMC0xLjktLjctMy42LTItNS0xLjMtMS4zLTMuMS0yLjEtNC45LTIuMXptLTcyLjUgMTQ4LjEtMy44IDUuOGMyLjMgMS41IDUuMyAxLjUgNy43IDB6bS03Mi40LTE0OC4xdi02LjljLTEuOSAwLTMuNi43LTQuOSAyLjEtMS4zIDEuMy0yIDMuMS0yIDV6bTY4LjEtMTUuOGMzMS40IDI0LjMgNjcuMyAyMi43IDc2LjcgMjIuN3YtMTMuOGMtOS44IDAtNDEuMSAxLjItNjguMy0xOS45em02OS44IDE1LjdjLS41IDMyLjEtMS45IDU0LjgtNC41IDcxLjYtMi42IDE2LjYtNi4yIDI2LjYtMTEgMzMuNi00LjggNy4zLTEwLjggMTEuNi0xOS43IDE2LjktOSA1LjQtMjAuMyAxMS4yLTM0LjMgMjAuNGw3LjcgMTEuNWMxMy4zLTguOCAyNC4zLTE0LjUgMzMuNy0yMC4xIDkuNS01LjcgMTcuOC0xMS45IDI0LjEtMjEgNi4zLTkuNCAxMC41LTIxLjYgMTMuMi0zOS4yIDIuNy0xNy40IDQuMS00MSA0LjYtNzMuNXptLTYxLjcgMTQyLjRjLTEzLjktOS4zLTI1LjMtMTUuMS0zNC4yLTIwLjRzLTE0LjktOS42LTE5LjctMTYuOWMtNC43LTctOC40LTE2LjktMTAuOS0zMy42LTIuNi0xNi44LTMuOS0zOS40LTQuNS03MS42bC0xMy45LjNjLjUgMzIuNCAyIDU2IDQuNiA3My41IDIuNyAxNy42IDYuOCAyOS44IDEzLjEgMzkuMiA2LjMgOS4xIDE0LjYgMTUuMyAyNCAyMSA5LjQgNS42IDIwLjQgMTEuMiAzMy43IDIwLjF6bS03Ni4yLTEzNS40YzkuMyAwIDQ1LjMgMS42IDc2LjYtMjIuN2wtOC40LTExYy0yNy4yIDIxLjEtNTguNSAxOS45LTY4LjIgMTkuOXoiIGZpbGw9IiMzMzc1YmIiLz48L2c+PC9zdmc+";
	  }, function (e, t) {
	    e.exports = "data:image/png;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjU5LjkyOCIgY3k9IjU5LjkyOCIgcj0iNTkuOTI4Ii8+PGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIwJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJjIj48c3RvcCBzdG9wLWNvbG9yPSIjMkU2NkY4IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iIzEyNEFEQiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTE5IDY0YzAgMjQuODUzIDIwLjE0NyA0NSA0NSA0NXM0NS0yMC4xNDcgNDUtNDUtMjAuMTQ3LTQ1LTQ1LTQ1LTQ1IDIwLjE0Ny00NSA0NXptMzMuNS0xNC41YTMgMyAwIDAgMC0zIDN2MjNhMyAzIDAgMCAwIDMgM2gyM2EzIDMgMCAwIDAgMy0zdi0yM2EzIDMgMCAwIDAtMy0zaC0yM3oiIGZpbGw9IiNGRkYiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2IpIj48cGF0aCBkPSJNMCAwaDExOS44NTZ2MTE5Ljg1NkgweiIvPjxyZWN0IGZpbGw9InVybCgjYykiIGZpbGwtcnVsZT0ibm9uemVybyIgd2lkdGg9IjExOS44NTYiIGhlaWdodD0iMTE5Ljg1NiIgcng9IjQ4Ii8+PHBhdGggZD0iTTI0Ljk3IDU5LjkyOGMwIDE5LjMwNyAxNS42NTEgMzQuOTU4IDM0Ljk1OCAzNC45NThzMzQuOTU4LTE1LjY1MSAzNC45NTgtMzQuOTU4Uzc5LjIzNSAyNC45NyA1OS45MjggMjQuOTcgMjQuOTcgNDAuNjIgMjQuOTcgNTkuOTI4em0yNi4wMjQtMTEuMjY0YTIuMzMgMi4zMyAwIDAgMC0yLjMzIDIuMzN2MTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzIDIuMzNoMTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzLTIuMzNWNTAuOTk0YTIuMzMgMi4zMyAwIDAgMC0yLjMzLTIuMzNINTAuOTk0eiIgZmlsbD0iI0ZGRiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMjMuOTg2NiAwIDAgLTE2Ljk0NiA2NTk3LjEzNTMgNTY5NS40OTA3KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSItMjcyLjUyNzIiIHgyPSItMjc1LjEyMDciIHkxPSIzMzUuNTUzMiIgeTI9IjMzMi45NTk3Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxMWM0ZDEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDYyYWQiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Im02My44IDEwLjljMi4xIDI4LjYtMTYuMiA0Mi4xLTMyLjcgNDMuNi0xNS4zIDEuMy0yOS43LTguMS0zMS0yMi41LTEtMTEuOSA2LjMtMTcgMTIuMS0xNy41IDYtLjUgMTEgMy42IDExLjQgOC42LjQgNC44LTIuNiA3LTQuNiA3LjItMS42LjEtMy43LS45LTMuOS0zLS4yLTEuOC41LTIuMS40LTQtLjMtMy41LTMuMy0zLjktNS0zLjctMiAuMi01LjcgMi41LTUuMSA4LjQuNSA1LjkgNi4yIDEwLjYgMTMuNiA5LjkgOC0uNyAxMy42LTYuOSAxNC0xNS43IDAtLjUuMS0uOS4zLTEuMy4xLS4yLjItLjQuMy0uNS4yLS4zLjQtLjUuNy0uOC4yLS4yLjUtLjUuNy0uOCAzLjUtMy4zIDE2LjEtMTEuMSAyOC04LjYuNC0uMi44LjIuOC43IiBmaWxsPSJ1cmwoI2EpIi8+PC9zdmc+";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAwIiBoZWlnaHQ9IjIwMDAiPjxjaXJjbGUgY3g9IjEwMDAiIGN5PSIxMDAwIiByPSIxMDAwIiBmaWxsPSIjNWI2ZGVlIi8+PHBhdGggZD0iTTgzMS4yNyA5MzguNzlhNTcxLjUgNTcxLjUgMCAwIDAtMTA0IDguOTVjMjguMjUtMjYxLjI4IDI0Ni00NTkuMTIgNTA1LjI0LTQ1OS4xIDE1OC43MyAwIDI2Ny40OSA3Ny43MiAyNjcuNDkgMjM4LjY0cy0xMzAuNTQgMjM4LjY0LTMyMSAyMzguNjRjLTE0MC41OC0uMDEtMjA3LjEzLTI3LjEzLTM0Ny43My0yNy4xM20tMTAuMjcgOTUuM2MtMTkwLjQ1IDAtMzIxIDc3LjcyLTMyMSAyMzguNjRzMTA4Ljc2IDIzOC42NCAyNjcuNDkgMjM4LjY0YzI1OS4yNyAwIDQ3Ny0xOTcuODIgNTA1LjI0LTQ1OS4xYTU3MS41IDU3MS41IDAgMCAxLTEwNCA4Ljk1Yy0xNDAuNi0uMDEtMjA3LjE1LTI3LjEzLTM0Ny43My0yNy4xMyIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
	  }, function (e, t) {
	    e.exports = "data:image/png;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAxLjM4IDQ1NS44NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNC40NSAyNjIuMTEgMTAuOTMtNC43NSAxMzUuMzEtNTguODIgMTQ2LjI0IDYzLjU3LTU0Ljk1IDExMy40My0xMzQuMzMgMTktMTAxLTEwOXoiIGZpbGw9IiMxMzM0NDQiLz48cGF0aCBkPSJtMjY2LjUxIDE5Mi4xNmExNTAuNDMgMTUwLjQzIDAgMCAwIC05NS44Mi01M3EtMS4yLS4xNy0yLjQtLjNhMTUyLjM2IDE1Mi4zNiAwIDAgMCAtMzUuMiAwcS0xLjIuMTQtMi40LjNhMTUwLjQzIDE1MC40MyAwIDAgMCAtOTUuODIgNTNsLTYuMDggMTAuMDgtMTAuMTMgMTYuNzYtNy40MSAxMi4zMWMtLjE0LjMzLS4yOC42Ny0uNDEgMWwtLjA5LjIzIDE2LjM1IDkuNjcgMTAzLjYgNjEuMjggMjAgMTEuODN2LTE0Ni40N2wtMjAgOS4wOHYtMjEuOTNsMjAtOS4wOSAyMCA5LjA5IDEwMS45IDQ2LjI4eiIgZmlsbD0iI2M0MjM3MCIvPjxwYXRoIGQ9Im0zMDEuMzggMjk4LjU2YzAgNDguNzgtMjMuMTggOTQuNDItNTkuMTIgMTIzLjg0YTE0OS40NSAxNDkuNDUgMCAwIDEgLTQ3LjY0IDI2LjM3IDEzOS41MSAxMzkuNTEgMCAwIDEgLTQzLjkzIDcuMWMtODMuMjIgMC0xNTAuNjktNzQuMDktMTUwLjY5LTE1Ny4zMWExNTAuNDkgMTUwLjQ5IDAgMCAxIDQuNDUtMzYuNDVsMTQ2LjI0IDg2LjUxIDE0Ni4yNC04Ni41MWExNTAuNDkgMTUwLjQ5IDAgMCAxIDQuNDUgMzYuNDV6IiBmaWxsPSIjMWM0ZDZiIi8+PHBhdGggZD0ibTEzMy4wOSAxMzguODkgMTcuNiA3Ljk5LTIwIDkuMDl2LTE4LjE3eiIvPjxwYXRoIGQ9Im0xMzAuNjkgMTc3LjkzIDIwLTkuMDh2MTQ2LjUzbC0yMC0xMS44M3oiLz48cGF0aCBkPSJtMTUwLjY5IDE2OC44NXYxNDYuNTNsMTQwLjEzLTgyLjg5eiIgZmlsbD0iIzFkNDI1OSIvPjxwYXRoIGQ9Im0xNTAuNjkgMHYxNjguODVsMTQwLjEzIDYzLjY0eiIgZmlsbD0iIzRiNmI5YSIvPjxwYXRoIGQ9Im0xNTAuNjkgMTY4Ljg1djE0Ni41M2wtMjAtMTEuODMtMTE5Ljk1LTcxLS4xOC0uMTEuMjctLjEyYy4xMy0uMzMuMjctLjY3LjQxLTFsMTcuNTMtMjkuMDkgMTAxLjkyLTQ2LjIzdjIyeiIgZmlsbD0iIzM0MzUzNSIvPjxwYXRoIGQ9Im0xNTAuNjkgMTY4Ljg1djE0Ni41M2wtMjAtMTEuODMtMTE5Ljk1LTcwLjk1LS4xOC0uMTEuMjctLjEyIDExOS44Ni01NC40NHoiIGZpbGw9IiMzZTU1NzgiLz48cGF0aCBkPSJtMTUwLjY5IDB2MTY4Ljg1bC0xNDAuMTMgNjMuNjR6IiBmaWxsPSIjNmRiMmQ4Ii8+PGcgZmlsbD0iIzMzNWY4YSI+PHBhdGggZD0ibTk0IDQ0My44NWMyLjA5LjkyIDQuMjEgMS43OSA2LjM0IDIuNjFxLTMuMjYtMS4yMy02LjM0LTIuNjF6Ii8+PHBhdGggZD0ibTEwMC4yOSA0NDYuNDZjMi4xNC44MiA0LjI5IDEuNTkgNi40NyAyLjMxcS0zLjI3LTEuMDctNi40Ny0yLjMxeiIvPjxwYXRoIGQ9Im0xMTIuMzMgNDUwLjQ5YzEuNjYuNDcgMy4zMy45MiA1IDEuMzNxLTIuNTEtLjYyLTUtMS4zM3oiLz48L2c+PHBhdGggZD0ibTQuNDUgMjYyLjExIDE0Ni4yNCA4Ni41MWExNjcuNDggMTY3LjQ4IDAgMCAxIC0xMC40NyAzOC4zOGMtMTEuNyAyOC4yOC0zNS4zNCA1OC4xOS04MS4wOCAzNS40NC0zNS45Ni0yOS40NC01OS4xNC03NS4xLTU5LjE0LTEyMy44OGExNTAuNDkgMTUwLjQ5IDAgMCAxIDQuNDUtMzYuNDV6IiBmaWxsPSIjNmRiMmQ4Ii8+PHBhdGggZD0ibTI0Mi4yNCA0MjIuNDEtLjM2LjI5Yy0uNzYuNjItMS41MiAxLjIzLTIuMjkgMS44M2wtLjIuMTZxLTEuMjUgMS0yLjUyIDEuOTJjLS45MS42OC0xLjgzIDEuMzYtMi43NiAycy0xLjg2IDEuMzEtMi44IDEuOTUtMS42NiAxLjEyLTIuNDkgMS42NmwtLjQ2LjNjLS44OC41Ny0xLjc2IDEuMTMtMi42NCAxLjY3YTIuNjMgMi42MyAwIDAgMSAtLjMzLjJjLS45MS41Ny0xLjgyIDEuMTItMi43NCAxLjY1cy0yIDEuMTUtMyAxLjctMiAxLjA4LTMgMS42bC0uMTEuMDZjLTEgLjUyLTIgMS0zIDEuNTJzLTIgMS0zLjA4IDEuNDktMi4wOCAxLTMuMTIgMS40MmMtMi4wOS45Mi00LjIxIDEuNzktNi4zNCAyLjYxcy00LjI5IDEuNTktNi40NyAyLjMxYy0uODcuMjktMS43NC41Ny0yLjYyLjg0cy0yIC42LTIuOTUuODhjLTEuNjYuNDctMy4zMy45Mi01IDEuMzMtLjYzLjE2LTEuMjcuMzEtMS45MS40NWwtMS4wNy4yNWMtLjg5LjItMS43OC4zOS0yLjY4LjU3cy0xLjY0LjMzLTIuNDcuNDgtMS41MS4yOC0yLjI3LjQtMS42OC4yNy0yLjUyLjM5Yy0uNDEuMDctLjgyLjEzLTEuMjQuMThsLTEuODkuMjUtMS4wNS4xM2MtLjY5LjA5LTEuMzkuMTYtMi4wOS4yMy0uODYuMDktMS43MS4xNy0yLjU3LjI0LS42Ny4wNS0xLjM0LjExLTIgLjE1cy0xLjE2LjA4LTEuNzUuMWgtLjA4Yy0uNjggMC0xLjM2LjA4LTIgLjEtLjk0IDAtMS44OS4wNy0yLjg0LjA5cy0xLjkgMC0yLjg2IDAtMS45MSAwLTIuODYgMC0xLjkgMC0yLjg0LS4wOWMtLjY5IDAtMS4zNy0uMDYtMi4wNS0uMWgtLjA4Yy0uNTkgMC0xLjE3LS4wNi0xLjc1LS4xcy0xLjM0LS4xLTItLjE1Yy0uODYtLjA3LTEuNzEtLjE1LTIuNTctLjI0LS43LS4wNy0xLjQtLjE0LTIuMDktLjIzbC0xLS4xM2MtLjYzLS4wNy0xLjI2LS4xNi0xLjg5LS4yNS0uNDIgMC0uODMtLjExLTEuMjQtLjE4cS0xLjI3LS4xOC0yLjUyLS4zOWMtLjc2LS4xMi0xLjUyLS4yNi0yLjI3LS40cy0xLjY1LS4zMS0yLjQ3LS40OC0xLjc5LS4zNy0yLjY4LS41N2wtMS4wNy0uMjVjLS42NC0uMTQtMS4yOC0uMjktMS45MS0uNDUtMS42OC0uNDEtMy4zNS0uODYtNS0xLjMzbC0zLS44OGMtLjg4LS4yNy0xLjc1LS41NS0yLjYyLS44NC0yLjE4LS43Mi00LjMzLTEuNDktNi40Ny0yLjMxcy00LjI5LTEuNjctNi4yOS0yLjU5Yy0xLS40Ni0yLjA4LS45NC0zLjEyLTEuNDJzLTIuMDYtMS0zLjA4LTEuNDktMi0xLTMtMS41MmwtLjExLS4wNmMtMS0uNTItMi0xLjA2LTMtMS42cy0yLTEuMTItMy0xLjctMS43OS0xLjA2LTIuNjktMS42NWwtLjMzLS4yYy0uODgtLjU0LTEuNzYtMS4xLTIuNjQtMS42N2wtLjQ2LS4zYy0uODMtLjU0LTEuNjctMS4xLTIuNDktMS42NnMtMS44OC0xLjI5LTIuOC0xLjk1LTEuODUtMS4zNC0yLjc2LTItMS42OS0xLjI3LTIuNTItMS45MmwtLjItLjE2Yy0uNzctLjYtMS41My0xLjIxLTIuMjktMS44M2wtLjM2LS4yOWM0NS43NCAyMi43NSA2OS4zOC03LjE2IDgxLjA4LTM1LjQ0YTE2Ny40OCAxNjcuNDggMCAwIDAgMTAuNDctMzguMzUgMTY3LjQ3IDE2Ny40NyAwIDAgMCAxMC40NiAzOC4zNmMxMS43IDI4LjI1IDM1LjM0IDU4LjE2IDgxLjA4IDM1LjQxeiIgZmlsbD0iIzUyOWJiYSIvPjxwYXRoIGQ9Im0xODQgNDUxLjgyYzEuNjgtLjQxIDMuMzUtLjg2IDUtMS4zM3EtMi40NC43Mi01IDEuMzN6IiBmaWxsPSIjMzM1ZjhhIi8+PHBhdGggZD0ibTE5NC42MiA0NDguNzdjMi4xOC0uNzIgNC4zMy0xLjQ5IDYuNDctMi4zMXEtMy4xOSAxLjI0LTYuNDcgMi4zMXoiIGZpbGw9IiMzMzVmOGEiLz48cGF0aCBkPSJtMjAxLjA5IDQ0Ni40NmMyLjEzLS44MiA0LjI1LTEuNjkgNi4zNC0yLjYxcS0zLjEzIDEuMzgtNi4zNCAyLjYxeiIgZmlsbD0iIzMzNWY4YSIvPjxwYXRoIGQ9Im0zMDEuMzggMjk4LjU2YzAgNDguNzgtMjMuMTkgOTQuNDMtNTkuMTQgMTIzLjg1LTQ1Ljc0IDIyLjc1LTY5LjM4LTcuMTYtODEuMDgtMzUuNDRhMTY3LjQ3IDE2Ny40NyAwIDAgMSAtMTAuNDctMzguMzVsMTQ2LjI0LTg2LjUxYTE1MC40OSAxNTAuNDkgMCAwIDEgNC40NSAzNi40NXoiIGZpbGw9IiM0YjZiOWEiLz48L3N2Zz4=";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMgMjMuMDUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTAgMGgxOGE1IDUgMCAwIDEgNSA1djEzLjA1YTUgNSAwIDAgMSAtNSA1aC0xM2E1IDUgMCAwIDEgLTUtNXptMy4yNCAyLjl2MTUuMjNhMiAyIDAgMCAwIDIgMmgxMi41NGEyIDIgMCAwIDAgMi0ydi0xMy4yM2EyIDIgMCAwIDAgLTItMnptMy41IDBoMy4yNnYxMS42M2EyIDIgMCAwIDEgLTIgMmgtNC43NnYtMi44MWgzLjV6bTkuNSAxNy4yM2gtMy4xOHYtMTEuNjNhMiAyIDAgMCAxIDItMmg0LjcydjIuODFoLTMuNXoiIGZpbGw9IiMzOTY0ZGYiLz48L3N2Zz4=";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYzIiB2aWV3Qm94PSIwIDAgNjMgNjMiIHdpZHRoPSI2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0zMS42MzkzLjk4NDM3NWgxNS4zMjc0IDE1LjMyNzV2MTUuMjk5MDI1aC0xNS4zMjc1LTE1LjMyNzQtMTUuMzI3NXYxNS4yOTg5Ljk4MSAxNC4yMjg5LjA4OTEgMTUuMjA5OWgtMTUuMzI3NDI1di0xNS4yMDk5LS4wODkxLTE0LjIyODktLjk4MS0xNS4yOTg5LTE1LjI5OTAyNWgxNS4zMjc0MjV6bTE1LjMyNzQgNDUuODA4MzI1aC0xNS4yMzgxdi0xNS4yMDk4aDMwLjU1NjZ2MTUuNzQ0OWMwIDMuOTE0LTEuNTU3MSA3LjY2OC00LjMyOTEgMTAuNDM2NXMtNi41MzE5IDQuMzI1LTEwLjQ1MzMgNC4zMjc0aC0uNTM2MXoiIGZpbGw9IiM2MTdiZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,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";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2Ny4wNyA3MiI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzM5OTZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFydGJvYXJkIDU8L3RpdGxlPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMzkuOTkiIGhlaWdodD0iMjEuNzEiLz48cmVjdCBjbGFzcz0iYSIgeD0iMTguMjgiIHk9IjAuMDMiIHdpZHRoPSIyMS43MSIgaGVpZ2h0PSI3MS45NyIvPjxjaXJjbGUgY2xhc3M9ImEiIGN4PSI1Ni4yMiIgY3k9IjEwLjg1IiByPSIxMC44NSIvPjwvc3ZnPg==";
	  }, function (e, t) {
	    e.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iNTk2LjAwMDAwMHB0IiBoZWlnaHQ9IjU5Ni4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDU5Ni4wMDAwMDAgNTk2LjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgo8bWV0YWRhdGE+CkNyZWF0ZWQgYnkgcG90cmFjZSAxLjE1LCB3cml0dGVuIGJ5IFBldGVyIFNlbGluZ2VyIDIwMDEtMjAxNwo8L21ldGFkYXRhPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCw1OTYuMDAwMDAwKSBzY2FsZSgwLjEwMDAwMCwtMC4xMDAwMDApIgpmaWxsPSIjRkY0QzJGIiBzdHJva2U9Im5vbmUiPgo8cGF0aCBkPSJNMTg3MCA0OTY0IGMtMzAwIC05NiAtNjAyIC0xOTIgLTY3MyAtMjE0IGwtMTI3IC00MSAwIC04ODIgYzAgLTUyOAo0IC05MjYgMTAgLTk5MiA0NCAtNDYyIDI0NCAtOTAwIDU3OCAtMTI2NCA3NiAtODMgMTI4MiAtMTEzNCAxMzE2IC0xMTQ3IDE0Ci01IDEwNzQgODk5IDEyNDggMTA2NSAzMDIgMjg3IDUzOCA3MDcgNjIyIDExMDkgNDQgMjEyIDQ3IDI5MSA0NCAxMjMxIGwtMwo4ODQgLTY3OSAyMTQgYy0zNzMgMTE3IC02ODAgMjEyIC02ODIgMjExIC0xIC0yIDU1IC0xMTMgMTI2IC0yNDggbDEyOSAtMjQ1CjE5MyAtNjIgYzEwNiAtMzQgMjY2IC04NSAzNTYgLTExMyBsMTYzIC01MSAtNCAtODEyIGMtMyAtNzgwIC00IC04MTYgLTI0Ci05MDcgLTc2IC0zNDMgLTIzMyAtNjM0IC00NzQgLTg4MCAtNDYgLTQ3IC0yODAgLTI1NCAtNTE5IC00NTkgLTIzOSAtMjA2Ci00NDcgLTM4NSAtNDYyIC0zOTkgbC0yNiAtMjQgLTQ1OSAzOTUgYy01NjEgNDg0IC02NDUgNTY2IC03NzkgNzcyIC0xMDMgMTU5Ci0xNzkgMzMwIC0yMjUgNTA3IC00NSAxODAgLTQ5IDI0NyAtNDkgMTA0OSBsMCA3NTcgMTQzIDQ1IGM3OCAyNSAyMzggNzYgMzU1CjExMyAxMTYgMzcgMjEyIDcxIDIxMiA3NCAwIDMgNTYgMTEzIDEyNSAyNDQgNjkgMTMyIDEyNSAyNDEgMTI1IDI0MyAwIDYgLTEyCjIgLTU2MCAtMTczeiIvPgo8cGF0aCBkPSJNMjk1NCA1MTA4IGMtOSAtMTggLTI2MSAtNDk5IC01NTkgLTEwNjggbC01NDIgLTEwMzUgOCAtODQgYzE4IC0xNzIKODIgLTM1NCAxODYgLTUxOSAzNyAtNjAgNDggLTcxIDU4IC02MCA2IDcgMjA0IDM4MSA0NDAgODMxIDIzNSA0NDkgNDMwIDgxNwo0MzQgODE3IDMgMCAyMDEgLTM2NCA0MzkgLTgwOCAyMzggLTQ0NCA0MzcgLTgxNSA0NDMgLTgyNSAxMCAtMTcgMTIgLTE2IDI4IDUKMTAzIDEzNSAxODggMzU4IDIxMiA1NTUgbDEyIDEwMCAtNTY4IDEwNTkgYy0zMTIgNTgyIC01NjkgMTA2MSAtNTcxIDEwNjIgLTEKMiAtMTAgLTExIC0yMCAtMzB6Ii8+CjxwYXRoIGQ9Ik0yNzAwIDI1NjEgbC0yNzUgLTU0OSAxNTUgLTEzNSBjODUgLTc0IDIxMCAtMTgxIDI3NyAtMjM3IGwxMjMgLTEwMgoyNyAyMiBjMTYgMTIgMTM5IDExOSAyNzQgMjM4IGwyNDcgMjE2IC0yNzQgNTQ4IGMtMTUxIDMwMSAtMjc1IDU0OCAtMjc3IDU0OAotMSAwIC0xMjYgLTI0NyAtMjc3IC01NDl6Ii8+CjwvZz4KPC9zdmc+Cg==";
	  }, function (e, t) {
	    e.exports = "data:image/png;base64,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";
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = n(1),
	        i = r.__importDefault(n(53)),
	        o = r.__importDefault(n(54)),
	        a = r.__importDefault(n(55)),
	        l = r.__importDefault(n(56)),
	        u = r.__importDefault(n(57)),
	        c = r.__importDefault(n(58)),
	        s = r.__importDefault(n(59)),
	        A = r.__importDefault(n(60)),
	        d = r.__importDefault(n(61));

	    t.connectors = {
	      injected: i.default,
	      walletconnect: o.default,
	      portis: a.default,
	      torus: u.default,
	      fortmatic: l.default,
	      squarelink: c.default,
	      arkane: s.default,
	      authereum: A.default,
	      burnerconnect: d.default
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function () {
	      return r.__awaiter(void 0, void 0, void 0, function () {
	        var e;
	        return r.__generator(this, function (t) {
	          switch (t.label) {
	            case 0:
	              if (e = null, !window.ethereum) return [3, 5];
	              e = window.ethereum, t.label = 1;

	            case 1:
	              return t.trys.push([1, 3,, 4]), [4, window.ethereum.enable()];

	            case 2:
	              return t.sent(), [3, 4];

	            case 3:
	              throw t.sent(), new Error("User Rejected");

	            case 4:
	              return [3, 6];

	            case 5:
	              if (!window.web3) throw new Error("No Web3 Provider found");
	              e = window.web3.currentProvider, t.label = 6;

	            case 6:
	              return [2, e];
	          }
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1),
	        i = n(2);

	    t.default = function (e, t) {
	      return new Promise(function (n, o) {
	        return r.__awaiter(void 0, void 0, void 0, function () {
	          var o, a, l, u, c;
	          return r.__generator(this, function (r) {
	            switch (r.label) {
	              case 0:
	                return o = "https://bridge.walletconnect.org", a = !0, l = "", u = 1, t && (o = t.bridge || o, a = void 0 !== t.qrcode ? t.qrcode : a, l = t.infuraId || "", u = t.network && i.getChainId(t.network) ? i.getChainId(t.network) : 1), [4, (c = new e({
	                  bridge: o,
	                  qrcode: a,
	                  infuraId: l,
	                  chainId: u
	                })).enable()];

	              case 1:
	                return r.sent(), n(c), [2];
	            }
	          });
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return new Promise(function (n, i) {
	        return r.__awaiter(void 0, void 0, void 0, function () {
	          var o, a, l, u, c;
	          return r.__generator(this, function (r) {
	            switch (r.label) {
	              case 0:
	                if (!t || !t.id) return [3, 5];
	                r.label = 1;

	              case 1:
	                return r.trys.push([1, 3,, 4]), o = t.id, a = t.network || "mainnet", l = t.config, [4, (u = new e(o, a, l)).provider.enable()];

	              case 2:
	                return r.sent(), u.provider._portis = u, n(u.provider), [3, 4];

	              case 3:
	                return c = r.sent(), [2, i(c)];

	              case 4:
	                return [3, 6];

	              case 5:
	                return [2, i(new Error("Missing Portis Id"))];

	              case 6:
	                return [2];
	            }
	          });
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return r.__awaiter(void 0, void 0, void 0, function () {
	        var n, i, o;
	        return r.__generator(this, function (r) {
	          switch (r.label) {
	            case 0:
	              if (!t || !t.key) return [3, 7];
	              r.label = 1;

	            case 1:
	              return r.trys.push([1, 5,, 6]), n = t.key, [4, (i = new e(n, t.network)).getProvider()];

	            case 2:
	              return (o = r.sent()).fm = i, [4, i.user.login()];

	            case 3:
	              return r.sent(), [4, i.user.isLoggedIn()];

	            case 4:
	              if (r.sent()) return [2, o];
	              throw new Error("Failed to login to Fortmatic");

	            case 5:
	              throw r.sent();

	            case 6:
	              return [3, 8];

	            case 7:
	              throw new Error("Missing Fortmatic key");

	            case 8:
	              return [2];
	          }
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return r.__awaiter(void 0, void 0, void 0, function () {
	        return r.__generator(this, function (n) {
	          return [2, new Promise(function (n, i) {
	            return r.__awaiter(void 0, void 0, void 0, function () {
	              var o, a, l, u, c, s, A, d, f, I;
	              return r.__generator(this, function (r) {
	                switch (r.label) {
	                  case 0:
	                    return r.trys.push([0, 3,, 4]), o = "bottom-left", a = "production", l = !0, u = !1, c = {}, s = {
	                      host: "mainnet"
	                    }, A = void 0, s = t.network ? {
	                      host: t.network
	                    } : s, t.config && (o = t.config.buttonPosition || o, a = t.config.buildEnv || a, l = t.config.enableLogging || l, u = t.config.showTorusButton || u, c = t.config.enabledVerifiers || c), [4, (d = new e({
	                      buttonPosition: o
	                    })).init({
	                      buildEnv: a,
	                      enableLogging: l,
	                      network: s,
	                      showTorusButton: u,
	                      enabledVerifiers: c
	                    })];

	                  case 1:
	                    return r.sent(), t.loginParams && (A = t.loginParams.verifier), [4, d.login({
	                      verifier: A
	                    })];

	                  case 2:
	                    return r.sent(), (f = d.provider).torus = d, n(f), [3, 4];

	                  case 3:
	                    return I = r.sent(), i(I), [3, 4];

	                  case 4:
	                    return [2];
	                }
	              });
	            });
	          })];
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return new Promise(function (n, i) {
	        return r.__awaiter(void 0, void 0, void 0, function () {
	          var o, a, l, u, c;
	          return r.__generator(this, function (r) {
	            switch (r.label) {
	              case 0:
	                if (!t || !t.id) return [3, 6];
	                r.label = 1;

	              case 1:
	                return r.trys.push([1, 4,, 5]), o = t.id, a = t.network || "mainnet", l = t.config, [4, (u = new e(o, a, l)).getProvider()];

	              case 2:
	                return (c = r.sent()).sqlk = u, [4, c.enable()];

	              case 3:
	                return r.sent(), [2, n(c)];

	              case 4:
	                return r.sent(), [2, i(new Error("Failed to login to Squarelink"))];

	              case 5:
	                return [3, 7];

	              case 6:
	                return [2, i(new Error("Missing Squarelink Id"))];

	              case 7:
	                return [2];
	            }
	          });
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return new Promise(function (e, n) {
	        return r.__awaiter(void 0, void 0, void 0, function () {
	          var i, o, a;
	          return r.__generator(this, function (r) {
	            switch (r.label) {
	              case 0:
	                if (!t || !t.clientId) return [3, 5];
	                r.label = 1;

	              case 1:
	                return r.trys.push([1, 3,, 4]), i = {
	                  clientId: t.clientId,
	                  rpcUrl: t.nodeUrl,
	                  environment: t.environment,
	                  signMethod: "POPUP"
	                }, [4, window.Arkane.createArkaneProviderEngine(i)];

	              case 2:
	                return o = r.sent(), [2, e(o)];

	              case 3:
	                return a = r.sent(), console.error(a), [2, n(new Error("Failed to login to Arkane 2"))];

	              case 4:
	                return [3, 6];

	              case 5:
	                return [2, n(new Error("Please provide an Arkane client id"))];

	              case 6:
	                return [2];
	            }
	          });
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return new Promise(function (n, i) {
	        return r.__awaiter(void 0, void 0, void 0, function () {
	          var o, a, l;
	          return r.__generator(this, function (r) {
	            switch (r.label) {
	              case 0:
	                return r.trys.push([0, 2,, 3]), o = new e(t.network), (a = o.getProvider()).authereum = o, [4, a.enable()];

	              case 1:
	                return r.sent(), n(a), [3, 3];

	              case 2:
	                return l = r.sent(), [2, i(l)];

	              case 3:
	                return [2];
	            }
	          });
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = n(1);

	    t.default = function (e, t) {
	      return r.__awaiter(void 0, void 0, void 0, function () {
	        var n;
	        return r.__generator(this, function (r) {
	          switch (r.label) {
	            case 0:
	              return t.defaultNetwork = t.defaultNetwork || t.network, [4, (n = new e(t)).enable()];

	            case 1:
	              return r.sent(), [2, n];
	          }
	        });
	      });
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r,
	        i,
	        o,
	        a,
	        l = n(1),
	        u = l.__importStar(n(0)),
	        c = l.__importStar(n(13)),
	        s = l.__importDefault(n(14)),
	        A = n(15),
	        d = n(2),
	        f = s.default.div(r || (r = l.__makeTemplateObject(["\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  margin-left: -50vw;\n  top: ", ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ", ";\n  opacity: ", ";\n  visibility: ", ";\n  pointer-events: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"], ["\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  margin-left: -50vw;\n  top: ", ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ", ";\n  opacity: ", ";\n  visibility: ", ";\n  pointer-events: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"])), function (e) {
	      var t = e.offset;
	      return t ? "-" + t + "px" : 0;
	    }, function (e) {
	      var t = e.opacity,
	          n = .4;
	      return "number" == typeof t && (n = t), "rgba(0, 0, 0, " + n + ")";
	    }, function (e) {
	      return e.show ? 1 : 0;
	    }, function (e) {
	      return e.show ? "visible" : "hidden";
	    }, function (e) {
	      return e.show ? "auto" : "none";
	    }),
	        I = s.default.div(i || (i = l.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ", ";\n  visibility: ", ";\n  pointer-events: ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ", ";\n  visibility: ", ";\n  pointer-events: ", ";\n"])), function (e) {
	      return e.show ? 1 : 0;
	    }, function (e) {
	      return e.show ? "visible" : "hidden";
	    }, function (e) {
	      return e.show ? "auto" : "none";
	    }),
	        g = s.default.div(o || (o = l.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"]))),
	        M = s.default.div(a || (a = l.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ", ";\n  visibility: ", ";\n  pointer-events: ", ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ", ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ", ";\n    grid-template-columns: 1fr;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ", ";\n  visibility: ", ";\n  pointer-events: ", ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ", ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ", ";\n    grid-template-columns: 1fr;\n  }\n"])), function (e) {
	      return e.themeColors.background;
	    }, function (e) {
	      return e.show ? 1 : 0;
	    }, function (e) {
	      return e.show ? "visible" : "hidden";
	    }, function (e) {
	      return e.show ? "auto" : "none";
	    }, function (e) {
	      var t = e.maxWidth;
	      return t ? t + "px" : "800px";
	    }, function (e) {
	      var t = e.maxWidth;
	      return t ? t + "px" : "500px";
	    }),
	        p = {
	      show: !1,
	      lightboxOffset: 0
	    },
	        N = function (e) {
	      function t(t) {
	        var n = e.call(this, t) || this;
	        return n.state = l.__assign({}, p), n.render = function () {
	          var e = n.state,
	              t = e.show,
	              r = e.lightboxOffset,
	              i = n.props,
	              o = i.onClose,
	              a = i.lightboxOpacity,
	              l = i.providers,
	              c = i.themeColors;
	          return u.createElement(f, {
	            className: d.MODAL_LIGHTBOX_CLASSNAME,
	            offset: r,
	            opacity: a,
	            ref: function (e) {
	              return n.lightboxRef = e;
	            },
	            show: t
	          }, u.createElement(I, {
	            className: d.MODAL_CONTAINER_CLASSNAME,
	            show: t
	          }, u.createElement(g, {
	            className: d.MODAL_HITBOX_CLASSNAME,
	            onClick: o
	          }), u.createElement(M, {
	            className: d.MODAL_CARD_CLASSNAME,
	            show: t,
	            themeColors: c,
	            maxWidth: l.length < 3 ? 500 : 800,
	            ref: function (e) {
	              return n.mainModalCard = e;
	            }
	          }, l.map(function (e) {
	            return e ? u.createElement(A.Provider, {
	              name: e.name,
	              themeColors: c,
	              onClick: e.onClick
	            }) : null;
	          }))));
	        }, window.updateWeb3Modal = function (e) {
	          return l.__awaiter(n, void 0, void 0, function () {
	            return l.__generator(this, function (t) {
	              return this.setState(e), [2];
	            });
	          });
	        }, n;
	      }

	      return l.__extends(t, e), t.prototype.componentDidUpdate = function (e, t) {
	        if (t.show && !this.state.show && this.props.resetState(), this.lightboxRef) {
	          var n = this.lightboxRef.getBoundingClientRect(),
	              r = n.top > 0 ? n.top : 0;
	          r !== p.lightboxOffset && r !== this.state.lightboxOffset && this.setState({
	            lightboxOffset: r
	          });
	        }
	      }, t.propTypes = {
	        providers: c.object.isRequired,
	        onClose: c.func.isRequired,
	        resetState: c.func.isRequired,
	        lightboxOpacity: c.number.isRequired
	      }, t;
	    }(u.Component);

	    t.Modal = N;
	  }, function (e, t, n) {

	    var r = n(64);

	    function i() {}

	    function o() {}

	    o.resetWarningCache = i, e.exports = function () {
	      function e(e, t, n, i, o, a) {
	        if (a !== r) {
	          var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
	          throw l.name = "Invariant Violation", l;
	        }
	      }

	      function t() {
	        return e;
	      }

	      e.isRequired = e;
	      var n = {
	        array: e,
	        bool: e,
	        func: e,
	        number: e,
	        object: e,
	        string: e,
	        symbol: e,
	        any: e,
	        arrayOf: t,
	        element: e,
	        elementType: e,
	        instanceOf: t,
	        node: e,
	        objectOf: t,
	        oneOf: t,
	        oneOfType: t,
	        shape: t,
	        exact: t,
	        checkPropTypes: o,
	        resetWarningCache: i
	      };
	      return n.PropTypes = n, n;
	    };
	  }, function (e, t, n) {

	    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
	  }, function (e, t) {
	    var n,
	        r,
	        i = e.exports = {};

	    function o() {
	      throw new Error("setTimeout has not been defined");
	    }

	    function a() {
	      throw new Error("clearTimeout has not been defined");
	    }

	    function l(e) {
	      if (n === setTimeout) return setTimeout(e, 0);
	      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

	      try {
	        return n(e, 0);
	      } catch (t) {
	        try {
	          return n.call(null, e, 0);
	        } catch (t) {
	          return n.call(this, e, 0);
	        }
	      }
	    }

	    !function () {
	      try {
	        n = "function" == typeof setTimeout ? setTimeout : o;
	      } catch (e) {
	        n = o;
	      }

	      try {
	        r = "function" == typeof clearTimeout ? clearTimeout : a;
	      } catch (e) {
	        r = a;
	      }
	    }();
	    var u,
	        c = [],
	        s = !1,
	        A = -1;

	    function d() {
	      s && u && (s = !1, u.length ? c = u.concat(c) : A = -1, c.length && f());
	    }

	    function f() {
	      if (!s) {
	        var e = l(d);
	        s = !0;

	        for (var t = c.length; t;) {
	          for (u = c, c = []; ++A < t;) u && u[A].run();

	          A = -1, t = c.length;
	        }

	        u = null, s = !1, function (e) {
	          if (r === clearTimeout) return clearTimeout(e);
	          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

	          try {
	            r(e);
	          } catch (t) {
	            try {
	              return r.call(null, e);
	            } catch (t) {
	              return r.call(this, e);
	            }
	          }
	        }(e);
	      }
	    }

	    function I(e, t) {
	      this.fun = e, this.array = t;
	    }

	    function g() {}

	    i.nextTick = function (e) {
	      var t = new Array(arguments.length - 1);
	      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
	      c.push(new I(e, t)), 1 !== c.length || s || l(f);
	    }, I.prototype.run = function () {
	      this.fun.apply(null, this.array);
	    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (e) {
	      return [];
	    }, i.binding = function (e) {
	      throw new Error("process.binding is not supported");
	    }, i.cwd = function () {
	      return "/";
	    }, i.chdir = function (e) {
	      throw new Error("process.chdir is not supported");
	    }, i.umask = function () {
	      return 0;
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      if (!e.webpackPolyfill) {
	        var t = Object.create(e);
	        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
	          enumerable: !0,
	          get: function () {
	            return t.l;
	          }
	        }), Object.defineProperty(t, "id", {
	          enumerable: !0,
	          get: function () {
	            return t.i;
	          }
	        }), Object.defineProperty(t, "exports", {
	          enumerable: !0
	        }), t.webpackPolyfill = 1;
	      }

	      return t;
	    };
	  }, function (e, t, n) {
	    /** @license React v16.9.0
	     * react-is.production.min.js
	     *
	     * Copyright (c) Facebook, Inc. and its affiliates.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     */

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });
	    var r = "function" == typeof Symbol && Symbol.for,
	        i = r ? Symbol.for("react.element") : 60103,
	        o = r ? Symbol.for("react.portal") : 60106,
	        a = r ? Symbol.for("react.fragment") : 60107,
	        l = r ? Symbol.for("react.strict_mode") : 60108,
	        u = r ? Symbol.for("react.profiler") : 60114,
	        c = r ? Symbol.for("react.provider") : 60109,
	        s = r ? Symbol.for("react.context") : 60110,
	        A = r ? Symbol.for("react.async_mode") : 60111,
	        d = r ? Symbol.for("react.concurrent_mode") : 60111,
	        f = r ? Symbol.for("react.forward_ref") : 60112,
	        I = r ? Symbol.for("react.suspense") : 60113,
	        g = r ? Symbol.for("react.suspense_list") : 60120,
	        M = r ? Symbol.for("react.memo") : 60115,
	        p = r ? Symbol.for("react.lazy") : 60116,
	        N = r ? Symbol.for("react.fundamental") : 60117,
	        y = r ? Symbol.for("react.responder") : 60118;

	    function v(e) {
	      if ("object" == typeof e && null !== e) {
	        var t = e.$$typeof;

	        switch (t) {
	          case i:
	            switch (e = e.type) {
	              case A:
	              case d:
	              case a:
	              case u:
	              case l:
	              case I:
	                return e;

	              default:
	                switch (e = e && e.$$typeof) {
	                  case s:
	                  case f:
	                  case c:
	                    return e;

	                  default:
	                    return t;
	                }

	            }

	          case p:
	          case M:
	          case o:
	            return t;
	        }
	      }
	    }

	    function h(e) {
	      return v(e) === d;
	    }

	    t.typeOf = v, t.AsyncMode = A, t.ConcurrentMode = d, t.ContextConsumer = s, t.ContextProvider = c, t.Element = i, t.ForwardRef = f, t.Fragment = a, t.Lazy = p, t.Memo = M, t.Portal = o, t.Profiler = u, t.StrictMode = l, t.Suspense = I, t.isValidElementType = function (e) {
	      return "string" == typeof e || "function" == typeof e || e === a || e === d || e === u || e === l || e === I || e === g || "object" == typeof e && null !== e && (e.$$typeof === p || e.$$typeof === M || e.$$typeof === c || e.$$typeof === s || e.$$typeof === f || e.$$typeof === N || e.$$typeof === y);
	    }, t.isAsyncMode = function (e) {
	      return h(e) || v(e) === A;
	    }, t.isConcurrentMode = h, t.isContextConsumer = function (e) {
	      return v(e) === s;
	    }, t.isContextProvider = function (e) {
	      return v(e) === c;
	    }, t.isElement = function (e) {
	      return "object" == typeof e && null !== e && e.$$typeof === i;
	    }, t.isForwardRef = function (e) {
	      return v(e) === f;
	    }, t.isFragment = function (e) {
	      return v(e) === a;
	    }, t.isLazy = function (e) {
	      return v(e) === p;
	    }, t.isMemo = function (e) {
	      return v(e) === M;
	    }, t.isPortal = function (e) {
	      return v(e) === o;
	    }, t.isProfiler = function (e) {
	      return v(e) === u;
	    }, t.isStrictMode = function (e) {
	      return v(e) === l;
	    }, t.isSuspense = function (e) {
	      return v(e) === I;
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = n(1),
	        i = n(4),
	        o = n(2),
	        a = n(17),
	        l = function () {
	      function e(e) {
	        var t = this;
	        this.cachedProvider = "", this.shouldCacheProvider = !1, this.eventController = new a.EventController(), this.injectedProvider = null, this.providerMapping = [], this.network = "", this.getProviders = function () {
	          var e = o.isMobile(),
	              n = t.providerMapping.map(function (e) {
	            return e.id;
	          }),
	              i = t.injectedProvider && !t.providerOptions.disableInjectedProvider,
	              a = [];
	          return i && e ? a.push(o.INJECTED_PROVIDER_ID) : (i && a.push(o.INJECTED_PROVIDER_ID), n.forEach(function (e) {
	            e !== o.INJECTED_PROVIDER_ID && t.shouldDisplayProvider(e) && a.push(e);
	          })), a.map(function (e) {
	            var n = t.getProviderMappingEntry(e);

	            if (void 0 !== n) {
	              var i = n.id,
	                  o = n.name,
	                  a = n.connector;
	              return {
	                name: o,
	                onClick: function () {
	                  return t.connectTo(i, a);
	                }
	              };
	            }

	            return {
	              name: "",
	              onClick: function () {
	                return r.__awaiter(t, void 0, void 0, function () {
	                  return r.__generator(this, function (e) {
	                    return [2];
	                  });
	                });
	              }
	            };
	          });
	        }, this.connectTo = function (e, n) {
	          return r.__awaiter(t, void 0, void 0, function () {
	            var t, i, a, l;
	            return r.__generator(this, function (u) {
	              switch (u.label) {
	                case 0:
	                  return u.trys.push([0, 2,, 3]), t = this.getProviderOption(e, "package"), i = this.getProviderOption(e, "options"), a = r.__assign({
	                    network: this.network || void 0
	                  }, i), [4, n(t, a)];

	                case 1:
	                  return l = u.sent(), this.eventController.trigger(o.CONNECT_EVENT, l), this.shouldCacheProvider && this.cachedProvider !== e && this.setCachedProvider(e), [3, 3];

	                case 2:
	                  return u.sent(), this.eventController.trigger(o.ERROR_EVENT), [3, 3];

	                case 3:
	                  return [2];
	              }
	            });
	          });
	        }, this.cachedProvider = o.getLocal(o.CACHED_PROVIDER_KEY) || "", this.shouldCacheProvider = e.cacheProvider, this.providerOptions = e.providerOptions, this.network = e.network, this.injectedProvider = o.getInjectedProviderName(), this.providerMapping = Object.keys(i.connectors).map(function (e) {
	          var n = o.getProviderInfoById(e);
	          return {
	            id: e,
	            name: e !== o.INJECTED_PROVIDER_ID ? n.name : t.injectedProvider || "",
	            connector: i.connectors[e],
	            package: n.package
	          };
	        });
	      }

	      return e.prototype.shouldDisplayProvider = function (e) {
	        var t = this.getProviderMappingEntry(e);

	        if (t) {
	          var n = this.providerOptions[e];
	          if (n) if (!!n.package) {
	            var r = t.package.required;
	            if (!r.length) return !0;
	            var i = n.options;

	            if (i && Object.keys(i).length) {
	              var o = r.filter(function (e) {
	                return e in i;
	              });
	              if (r.length === o.length) return !0;
	            }
	          }
	        }

	        return !1;
	      }, e.prototype.getProviderMappingEntry = function (e) {
	        var t = this.providerMapping.filter(function (t) {
	          return t.id.toLowerCase() === e.toLowerCase() ? t : void 0;
	        }).filter(function (e) {
	          return !!e;
	        });
	        if (t && t.length) return t[0];
	      }, e.prototype.getProviderOption = function (e, t) {
	        return this.providerOptions && this.providerOptions[e] && this.providerOptions[e][t] ? this.providerOptions[e][t] : {};
	      }, e.prototype.clearCachedProvider = function () {
	        this.cachedProvider = "", o.removeLocal(o.CACHED_PROVIDER_KEY);
	      }, e.prototype.setCachedProvider = function (e) {
	        this.cachedProvider = e, o.setLocal(o.CACHED_PROVIDER_KEY, e);
	      }, e.prototype.connectToCachedProvider = function () {
	        return r.__awaiter(this, void 0, void 0, function () {
	          var e;
	          return r.__generator(this, function (t) {
	            switch (t.label) {
	              case 0:
	                return (e = this.getProviderMappingEntry(this.cachedProvider)) ? [4, this.connectTo(e.id, e.connector)] : [3, 2];

	              case 1:
	                t.sent(), t.label = 2;

	              case 2:
	                return [2];
	            }
	          });
	        });
	      }, e.prototype.on = function (e, t) {
	        var n = this;
	        return this.eventController.on({
	          event: e,
	          callback: t
	        }), function () {
	          return n.eventController.off({
	            event: e,
	            callback: t
	          });
	        };
	      }, e.prototype.off = function (e, t) {
	        this.eventController.off({
	          event: e,
	          callback: t
	        });
	      }, e;
	    }();

	    t.ProviderController = l;
	  }]);
	});
	});

	var Web3Modal = /*@__PURE__*/getDefaultExportFromCjs(dist);

	var bundle$4 = createCommonjsModule$1(function (module, exports) {
	!function (e, t) {
	  module.exports = t() ;
	}(window, function () {
	  return function (e) {
	    var t = {};

	    function n(r) {
	      if (t[r]) return t[r].exports;
	      var i = t[r] = {
	        i: r,
	        l: !1,
	        exports: {}
	      };
	      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
	    }

	    return n.m = e, n.c = t, n.d = function (e, t, r) {
	      n.o(e, t) || Object.defineProperty(e, t, {
	        enumerable: !0,
	        get: r
	      });
	    }, n.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
	        value: "Module"
	      }), Object.defineProperty(e, "__esModule", {
	        value: !0
	      });
	    }, n.t = function (e, t) {
	      if (1 & t && (e = n(e)), 8 & t) return e;
	      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
	      var r = Object.create(null);
	      if (n.r(r), Object.defineProperty(r, "default", {
	        enumerable: !0,
	        value: e
	      }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
	        return e[t];
	      }.bind(null, i));
	      return r;
	    }, n.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };
	      return n.d(t, "a", t), t;
	    }, n.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, n.p = "", n(n.s = 0);
	  }([function (e, t, n) {

	    var r,
	        i = this && this.__extends || (r = function (e, t) {
	      return (r = Object.setPrototypeOf || {
	        __proto__: []
	      } instanceof Array && function (e, t) {
	        e.__proto__ = t;
	      } || function (e, t) {
	        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
	      })(e, t);
	    }, function (e, t) {
	      function n() {
	        this.constructor = e;
	      }

	      r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
	    }),
	        o = this && this.__assign || function () {
	      return (o = Object.assign || function (e) {
	        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);

	        return e;
	      }).apply(this, arguments);
	    },
	        s = this && this.__awaiter || function (e, t, n, r) {
	      return new (n || (n = Promise))(function (i, o) {
	        function s(e) {
	          try {
	            u(r.next(e));
	          } catch (e) {
	            o(e);
	          }
	        }

	        function a(e) {
	          try {
	            u(r.throw(e));
	          } catch (e) {
	            o(e);
	          }
	        }

	        function u(e) {
	          var t;
	          e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
	            e(t);
	          })).then(s, a);
	        }

	        u((r = r.apply(e, t || [])).next());
	      });
	    },
	        a = this && this.__generator || function (e, t) {
	      var n,
	          r,
	          i,
	          o,
	          s = {
	        label: 0,
	        sent: function () {
	          if (1 & i[0]) throw i[1];
	          return i[1];
	        },
	        trys: [],
	        ops: []
	      };
	      return o = {
	        next: a(0),
	        throw: a(1),
	        return: a(2)
	      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
	        return this;
	      }), o;

	      function a(o) {
	        return function (a) {
	          return function (o) {
	            if (n) throw new TypeError("Generator is already executing.");

	            for (; s;) try {
	              if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

	              switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
	                case 0:
	                case 1:
	                  i = o;
	                  break;

	                case 4:
	                  return s.label++, {
	                    value: o[1],
	                    done: !1
	                  };

	                case 5:
	                  s.label++, r = o[1], o = [0];
	                  continue;

	                case 7:
	                  o = s.ops.pop(), s.trys.pop();
	                  continue;

	                default:
	                  if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
	                    s = 0;
	                    continue;
	                  }

	                  if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
	                    s.label = o[1];
	                    break;
	                  }

	                  if (6 === o[0] && s.label < i[1]) {
	                    s.label = i[1], i = o;
	                    break;
	                  }

	                  if (i && s.label < i[2]) {
	                    s.label = i[2], s.ops.push(o);
	                    break;
	                  }

	                  i[2] && s.ops.pop(), s.trys.pop();
	                  continue;
	              }

	              o = t.call(e, s);
	            } catch (e) {
	              o = [6, e], r = 0;
	            } finally {
	              n = i = 0;
	            }

	            if (5 & o[0]) throw o[1];
	            return {
	              value: o[0] ? o[1] : void 0,
	              done: !0
	            };
	          }([o, a]);
	        };
	      }
	    },
	        u = this && this.__importDefault || function (e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    };

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var c = n(1),
	        l = u(n(2)),
	        f = u(n(3)),
	        d = u(n(4)),
	        h = u(n(5)),
	        p = function (e) {
	      function t(t) {
	        var n = void 0 === t ? {} : t,
	            r = n.hubUrl,
	            i = void 0 === r ? "https://burnerconnect.xyz/" : r,
	            o = n.defaultNetwork,
	            s = void 0 === o ? "1" : o,
	            a = n.defaultWallets,
	            u = void 0 === a ? [] : a,
	            c = e.call(this) || this;
	        return c.isBurnerProvider = !0, c.connected = !1, c.walletBridge = null, c.wallet = null, c._nextJsonRpcId = 0, c.walletSelector = new h.default(), c.defaultWallets = [], c.network = s, c.hub = new l.default(i), c.defaultWallets = u, c.on = null, window.addEventListener("message", function (e) {
	          c.walletBridge && e.origin === c.walletBridge.origin && e.data.message && "accountsChanged" === e.data.message && c.emit("accountsChanged", e.data.accounts);
	        }), c;
	      }

	      return i(t, e), t.prototype.setNetwork = function (e) {
	        e !== this.network && (this.network = e, this.emit("chainChanged", e));
	      }, t.prototype.getAssets = function () {
	        return s(this, void 0, void 0, function () {
	          var e;
	          return a(this, function (t) {
	            switch (t.label) {
	              case 0:
	                return [4, (e = this.getBridge()).ensureIFrame()];

	              case 1:
	                return t.sent(), [4, e.sendCommand("getAssets")];

	              case 2:
	                return [2, t.sent()];
	            }
	          });
	        });
	      }, t.prototype.enable = function () {
	        var e = this;
	        return this.connected ? Promise.resolve() : new Promise(function (t, n) {
	          return s(e, void 0, void 0, function () {
	            var e,
	                r = this;
	            return a(this, function (i) {
	              switch (i.label) {
	                case 0:
	                  this.walletSelector.onClose(function () {
	                    r.walletSelector.close(), n();
	                  }), i.label = 1;

	                case 1:
	                  return i.trys.push([1, 7, 8, 9]), this.walletSelector.showStarting(), [4, this.showPrompt()];

	                case 2:
	                  return i.sent(), [4, this.needsPopup()];

	                case 3:
	                  return i.sent() ? [4, this.showPopup()] : [3, 5];

	                case 4:
	                  i.sent(), i.label = 5;

	                case 5:
	                  return this.walletBridge = new f.default(this.wallet.origin), [4, this.walletBridge.ensureIFrame()];

	                case 6:
	                  return i.sent(), this.getBridge().send({
	                    id: 1e8 * Math.random() | 0,
	                    method: "eth_accounts",
	                    network: this.network
	                  }), this.connected = !0, this.emit("connect"), t(), [3, 9];

	                case 7:
	                  return e = i.sent(), console.error(e), n(), [3, 9];

	                case 8:
	                  return this.walletSelector.close(), [7];

	                case 9:
	                  return [2];
	              }
	            });
	          });
	        });
	      }, t.prototype.showPrompt = function () {
	        return s(this, void 0, void 0, function () {
	          var e;
	          return a(this, function (t) {
	            switch (t.label) {
	              case 0:
	                return [4, this.walletSelector.showSelector(this.hub, this.defaultWallets)];

	              case 1:
	                return e = t.sent(), this.walletSelector.showConnecting(e.name), this.wallet = e, [2];
	            }
	          });
	        });
	      }, t.prototype.needsPopup = function () {
	        return s(this, void 0, void 0, function () {
	          var e, t;
	          return a(this, function (n) {
	            switch (n.label) {
	              case 0:
	                return [4, (e = new d.default(this.wallet.origin)).needsPopup()];

	              case 1:
	                return t = n.sent(), e.remove(), [2, t];
	            }
	          });
	        });
	      }, t.prototype.showPopup = function () {
	        return s(this, void 0, void 0, function () {
	          var e;
	          return a(this, function (t) {
	            switch (t.label) {
	              case 0:
	                return [4, (e = new d.default(this.wallet.origin)).showPopup(this.walletSelector.getPanel())];

	              case 1:
	                return t.sent(), e.remove(), [2];
	            }
	          });
	        });
	      }, t.prototype.send = function (e, t) {
	        if (void 0 === t && (t = []), !e || "string" != typeof e) return new Error("Method is not a valid string.");
	        if (!(t instanceof Array)) return new Error("Params is not a valid array.");
	        var n = {
	          jsonrpc: "2.0",
	          id: this._nextJsonRpcId++,
	          method: e,
	          params: t
	        };
	        return this.getBridge().send(o({
	          network: this.network
	        }, n));
	      }, t.prototype.sendAsync = function (e, t) {
	        if (!this.connected) throw new Error("BurnerConnect Provider is not connected");
	        this.getBridge().send(o({
	          network: this.network
	        }, e)).then(function (n) {
	          var r = n.result;
	          return t(null, {
	            id: e.id,
	            jsonrpc: "2.0",
	            result: r
	          });
	        }).catch(function (e) {
	          return t(e);
	        });
	      }, t.prototype.getBridge = function () {
	        if (!this.walletBridge) throw new Error("BurnerConnect is not yet connected");
	        return this.walletBridge;
	      }, t;
	    }(c.EventEmitter);

	    t.default = p;
	  }, function (e, t, n) {

	    var r,
	        i = "object" == typeof Reflect ? Reflect : null,
	        o = i && "function" == typeof i.apply ? i.apply : function (e, t, n) {
	      return Function.prototype.apply.call(e, t, n);
	    };
	    r = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (e) {
	      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	    } : function (e) {
	      return Object.getOwnPropertyNames(e);
	    };

	    var s = Number.isNaN || function (e) {
	      return e != e;
	    };

	    function a() {
	      a.init.call(this);
	    }

	    e.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
	    var u = 10;

	    function c(e) {
	      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
	    }

	    function l(e) {
	      return void 0 === e._maxListeners ? a.defaultMaxListeners : e._maxListeners;
	    }

	    function f(e, t, n, r) {
	      var i, o, s, a;
	      if (c(n), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), s = o[t]), void 0 === s) s = o[t] = n, ++e._eventsCount;else if ("function" == typeof s ? s = o[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), (i = l(e)) > 0 && s.length > i && !s.warned) {
	        s.warned = !0;
	        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
	        u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = s.length, a = u, console && console.warn && console.warn(a);
	      }
	      return e;
	    }

	    function d() {
	      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	    }

	    function h(e, t, n) {
	      var r = {
	        fired: !1,
	        wrapFn: void 0,
	        target: e,
	        type: t,
	        listener: n
	      },
	          i = d.bind(r);
	      return i.listener = n, r.wrapFn = i, i;
	    }

	    function p(e, t, n) {
	      var r = e._events;
	      if (void 0 === r) return [];
	      var i = r[t];
	      return void 0 === i ? [] : "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (e) {
	        for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];

	        return t;
	      }(i) : v(i, i.length);
	    }

	    function m(e) {
	      var t = this._events;

	      if (void 0 !== t) {
	        var n = t[e];
	        if ("function" == typeof n) return 1;
	        if (void 0 !== n) return n.length;
	      }

	      return 0;
	    }

	    function v(e, t) {
	      for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e[r];

	      return n;
	    }

	    Object.defineProperty(a, "defaultMaxListeners", {
	      enumerable: !0,
	      get: function () {
	        return u;
	      },
	      set: function (e) {
	        if ("number" != typeof e || e < 0 || s(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
	        u = e;
	      }
	    }), a.init = function () {
	      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	    }, a.prototype.setMaxListeners = function (e) {
	      if ("number" != typeof e || e < 0 || s(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
	      return this._maxListeners = e, this;
	    }, a.prototype.getMaxListeners = function () {
	      return l(this);
	    }, a.prototype.emit = function (e) {
	      for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);

	      var r = "error" === e,
	          i = this._events;
	      if (void 0 !== i) r = r && void 0 === i.error;else if (!r) return !1;

	      if (r) {
	        var s;
	        if (t.length > 0 && (s = t[0]), s instanceof Error) throw s;
	        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
	        throw a.context = s, a;
	      }

	      var u = i[e];
	      if (void 0 === u) return !1;
	      if ("function" == typeof u) o(u, this, t);else {
	        var c = u.length,
	            l = v(u, c);

	        for (n = 0; n < c; ++n) o(l[n], this, t);
	      }
	      return !0;
	    }, a.prototype.addListener = function (e, t) {
	      return f(this, e, t, !1);
	    }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (e, t) {
	      return f(this, e, t, !0);
	    }, a.prototype.once = function (e, t) {
	      return c(t), this.on(e, h(this, e, t)), this;
	    }, a.prototype.prependOnceListener = function (e, t) {
	      return c(t), this.prependListener(e, h(this, e, t)), this;
	    }, a.prototype.removeListener = function (e, t) {
	      var n, r, i, o, s;
	      if (c(t), void 0 === (r = this._events)) return this;
	      if (void 0 === (n = r[e])) return this;
	      if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
	        for (i = -1, o = n.length - 1; o >= 0; o--) if (n[o] === t || n[o].listener === t) {
	          s = n[o].listener, i = o;
	          break;
	        }

	        if (i < 0) return this;
	        0 === i ? n.shift() : function (e, t) {
	          for (; t + 1 < e.length; t++) e[t] = e[t + 1];

	          e.pop();
	        }(n, i), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, s || t);
	      }
	      return this;
	    }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (e) {
	      var t, n, r;
	      if (void 0 === (n = this._events)) return this;
	      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;

	      if (0 === arguments.length) {
	        var i,
	            o = Object.keys(n);

	        for (r = 0; r < o.length; ++r) "removeListener" !== (i = o[r]) && this.removeAllListeners(i);

	        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
	      }

	      if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
	      return this;
	    }, a.prototype.listeners = function (e) {
	      return p(this, e, !0);
	    }, a.prototype.rawListeners = function (e) {
	      return p(this, e, !1);
	    }, a.listenerCount = function (e, t) {
	      return "function" == typeof e.listenerCount ? e.listenerCount(t) : m.call(e, t);
	    }, a.prototype.listenerCount = m, a.prototype.eventNames = function () {
	      return this._eventsCount > 0 ? r(this._events) : [];
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = function () {
	      function e(e) {
	        this.iframe = null, this.msgId = 0, this.url = e;
	      }

	      return e.prototype.ensureIFrame = function () {
	        var e = this;
	        return this.iframe ? Promise.resolve(this.iframe) : new Promise(function (t) {
	          e.iframe = document.createElement("iframe"), e.iframe.src = e.url, e.iframe.style.cssText = "height:0; width:0; border:none", e.iframe.addEventListener("load", function () {
	            return t();
	          }), document.body.appendChild(e.iframe);
	        });
	      }, e.prototype.getFrame = function (e) {
	        var t = this;
	        this.iframe = document.createElement("iframe");
	        var n = this.url + "/selector.html";
	        return e && e.length > 0 && (n += "#wallets=" + encodeURIComponent(JSON.stringify(e))), this.iframe.src = n, this.iframe.style.border = "none", this.iframe.sandbox = "allow-storage-access-by-user-activation allow-scripts allow-same-origin", window.addEventListener("message", function (e) {
	          "setHeight" === e.data.message && (t.iframe.style.height = e.data.height + "px");
	        }), this.iframe;
	      }, e.prototype.awaitSelection = function () {
	        return new Promise(function (e) {
	          window.addEventListener("message", function (t) {
	            "walletSelected" === t.data.message && e(t.data.wallet);
	          });
	        });
	      }, e.prototype.send = function (e) {
	        var t = this;
	        return new Promise(function (n) {
	          var r = t.msgId++,
	              i = function (e) {
	            e.data.id === r && (window.removeEventListener("message", i), n(e.data.response));
	          };

	          window.addEventListener("message", i), t.iframe.contentWindow.postMessage({
	            command: e,
	            id: r
	          }, t.url);
	        });
	      }, e;
	    }();

	    t.default = r;
	  }, function (e, t, n) {

	    var r = this && this.__awaiter || function (e, t, n, r) {
	      return new (n || (n = Promise))(function (i, o) {
	        function s(e) {
	          try {
	            u(r.next(e));
	          } catch (e) {
	            o(e);
	          }
	        }

	        function a(e) {
	          try {
	            u(r.throw(e));
	          } catch (e) {
	            o(e);
	          }
	        }

	        function u(e) {
	          var t;
	          e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
	            e(t);
	          })).then(s, a);
	        }

	        u((r = r.apply(e, t || [])).next());
	      });
	    },
	        i = this && this.__generator || function (e, t) {
	      var n,
	          r,
	          i,
	          o,
	          s = {
	        label: 0,
	        sent: function () {
	          if (1 & i[0]) throw i[1];
	          return i[1];
	        },
	        trys: [],
	        ops: []
	      };
	      return o = {
	        next: a(0),
	        throw: a(1),
	        return: a(2)
	      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
	        return this;
	      }), o;

	      function a(o) {
	        return function (a) {
	          return function (o) {
	            if (n) throw new TypeError("Generator is already executing.");

	            for (; s;) try {
	              if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

	              switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
	                case 0:
	                case 1:
	                  i = o;
	                  break;

	                case 4:
	                  return s.label++, {
	                    value: o[1],
	                    done: !1
	                  };

	                case 5:
	                  s.label++, r = o[1], o = [0];
	                  continue;

	                case 7:
	                  o = s.ops.pop(), s.trys.pop();
	                  continue;

	                default:
	                  if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
	                    s = 0;
	                    continue;
	                  }

	                  if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
	                    s.label = o[1];
	                    break;
	                  }

	                  if (6 === o[0] && s.label < i[1]) {
	                    s.label = i[1], i = o;
	                    break;
	                  }

	                  if (i && s.label < i[2]) {
	                    s.label = i[2], s.ops.push(o);
	                    break;
	                  }

	                  i[2] && s.ops.pop(), s.trys.pop();
	                  continue;
	              }

	              o = t.call(e, s);
	            } catch (e) {
	              o = [6, e], r = 0;
	            } finally {
	              n = i = 0;
	            }

	            if (5 & o[0]) throw o[1];
	            return {
	              value: o[0] ? o[1] : void 0,
	              done: !0
	            };
	          }([o, a]);
	        };
	      }
	    };

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var o = function () {
	      function e(e) {
	        this.iframe = null, this.msgId = 0, this.origin = e;
	      }

	      return e.prototype.send = function (e) {
	        return r(this, void 0, void 0, function () {
	          return i(this, function (t) {
	            switch (t.label) {
	              case 0:
	                return [4, this.ensureIFrame()];

	              case 1:
	                return t.sent(), [4, this.sendCommand("send", e)];

	              case 2:
	                return [2, t.sent()];
	            }
	          });
	        });
	      }, e.prototype.ensureIFrame = function () {
	        var e = this;
	        return this.iframeLoadPromise ? this.iframeLoadPromise : (this.iframeLoadPromise = new Promise(function (t) {
	          e.iframe = document.createElement("iframe"), e.iframe.src = e.origin + "/burnerconnect-bridge.html", e.iframe.style.cssText = "height:0; width:0; border:none; position: absolute";

	          var n = function (r) {
	            "frameLoaded" === r.data.message && (window.removeEventListener("message", n), t(e.iframe));
	          };

	          window.addEventListener("message", n), document.body.appendChild(e.iframe);
	        }), this.iframeLoadPromise);
	      }, e.prototype.getFrame = function () {
	        if (!this.iframe) throw new Error("No iframe");
	        return this.iframe;
	      }, e.prototype.sendCommand = function (e, t) {
	        var n = this;
	        return new Promise(function (r) {
	          var i = n.msgId++,
	              o = function (e) {
	            e.data.id === i && (window.removeEventListener("message", o), r(e.data.response));
	          };

	          window.addEventListener("message", o), n.iframe.contentWindow.postMessage({
	            command: e,
	            id: i,
	            params: t
	          }, n.origin);
	        });
	      }, e.prototype.remove = function () {
	        var e = this.getFrame();
	        e.parentNode.removeChild(e);
	      }, e;
	    }();

	    t.default = o;
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = function () {
	      function e(e) {
	        this.iframe = null, this.msgId = 0, this.origin = e;
	      }

	      return e.prototype.createIframe = function (e) {
	        var t = this;

	        if (void 0 === e && (e = !1), this.iframe = document.createElement("iframe"), this.iframe.src = this.origin + "/burnerconnect-login.html", this.iframe.style.cssText = e ? "border:none; width: 100%" : "height:0; width:0; border:none; position: absolute", e) {
	          window.addEventListener("message", function (e) {
	            "setSize" === e.data.message && (t.iframe.style.height = e.data.height + "px");
	          });
	        }

	        return this.iframe;
	      }, e.prototype.needsPopup = function () {
	        var e = this;
	        return new Promise(function (t) {
	          var n = e.createIframe();
	          window.addEventListener("message", function (e) {
	            "needsPopup" === e.data.message ? t(!0) : "ready" === e.data.message && t(!1);
	          }), document.body.appendChild(n);
	        });
	      }, e.prototype.showPopup = function (e) {
	        var t = this;
	        return new Promise(function (n) {
	          var r = t.createIframe(!0);
	          window.addEventListener("message", function (e) {
	            "ready" === e.data.message && n();
	          }), e.appendChild(r);
	        });
	      }, e.prototype.getFrame = function () {
	        if (!this.iframe) throw new Error("No iframe");
	        return this.iframe;
	      }, e.prototype.remove = function () {
	        var e = this.getFrame();
	        e.parentNode.removeChild(e);
	      }, e;
	    }();

	    t.default = r;
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var r = function () {
	      function e() {
	        this.closeListeners = [];
	      }

	      return e.prototype.getPanel = function () {
	        var e = this;

	        if (this.container || (this.container = document.createElement("div"), this.container.style.cssText = "\n        display: flex;\n        flex-direction: column;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba(200, 200, 200, 0.5);\n        z-index: 10000001;\n        align-items: center;\n      ", document.body.appendChild(this.container)), !this.panel) {
	          var t = document.createElement("div");
	          t.style.cssText = "\n        display: flex;\n        flex-direction: column;\n        padding: 8px;\n        margin: 8px;\n        border-radius: 8px;\n        background: #ffffff;\n        max-width: 500px;\n      ";
	          var n = document.createElement("button");
	          n.innerText = "x", n.style.cssText = "\n        margin-left: auto;\n      ", n.addEventListener("click", function () {
	            return e.closeListeners.forEach(function (e) {
	              return e();
	            });
	          }), t.appendChild(n);
	          var r = document.createElement("div");
	          t.appendChild(r), this.panel = r, this.container.appendChild(t);
	        }

	        return this.panel;
	      }, e.prototype.showStarting = function () {
	        this.getPanel().innerHTML = "<h2>Fetching your Burner Wallets...</h2>";
	      }, e.prototype.showSelector = function (e, t) {
	        return this.getPanel().appendChild(e.getFrame(t)), e.awaitSelection();
	      }, e.prototype.showFrame = function (e) {
	        var t = this.getPanel();
	        t.innerHTML = "", e.style.height = "100px", e.style.width = "100px", t.appendChild(e);
	      }, e.prototype.showConnecting = function (e) {
	        this.getPanel().innerHTML = "<h2>Connecting to " + e + "...</h2>";
	      }, e.prototype.close = function () {
	        document.body.removeChild(this.container), this.container = null, this.panel = null;
	      }, e.prototype.onClose = function (e) {
	        this.closeListeners.push(e);
	      }, e;
	    }();

	    t.default = r;
	  }]);
	});
	});

	var BurnerConnectProvider = /*@__PURE__*/getDefaultExportFromCjs(bundle$4);

	/*
	 *  base64.js
	 *
	 *  Licensed under the BSD 3-Clause License.
	 *    http://opensource.org/licenses/BSD-3-Clause
	 *
	 *  References:
	 *    http://en.wikipedia.org/wiki/Base64
	 */

	var base64 = createCommonjsModule$1(function (module, exports) {

	(function (global, factory) {
	  module.exports = factory(global) ;
	})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal, function (global) {

	  global = global || {};
	  var _Base64 = global.Base64;
	  var version = "2.6.4"; // constants

	  var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	  var b64tab = function (bin) {
	    var t = {};

	    for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;

	    return t;
	  }(b64chars);

	  var fromCharCode = String.fromCharCode; // encoder stuff

	  var cb_utob = function (c) {
	    if (c.length < 2) {
	      var cc = c.charCodeAt(0);
	      return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
	    } else {
	      var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
	      return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
	    }
	  };

	  var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;

	  var utob = function (u) {
	    return u.replace(re_utob, cb_utob);
	  };

	  var cb_encode = function (ccc) {
	    var padlen = [0, 2, 1][ccc.length % 3],
	        ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0),
	        chars = [b64chars.charAt(ord >>> 18), b64chars.charAt(ord >>> 12 & 63), padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63), padlen >= 1 ? '=' : b64chars.charAt(ord & 63)];
	    return chars.join('');
	  };

	  var btoa = global.btoa && typeof global.btoa == 'function' ? function (b) {
	    return global.btoa(b);
	  } : function (b) {
	    if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
	    return b.replace(/[\s\S]{1,3}/g, cb_encode);
	  };

	  var _encode = function (u) {
	    return btoa(utob(String(u)));
	  };

	  var mkUriSafe = function (b64) {
	    return b64.replace(/[+\/]/g, function (m0) {
	      return m0 == '+' ? '-' : '_';
	    }).replace(/=/g, '');
	  };

	  var encode = function (u, urisafe) {
	    return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
	  };

	  var encodeURI = function (u) {
	    return encode(u, true);
	  };

	  var fromUint8Array;
	  if (global.Uint8Array) fromUint8Array = function (a, urisafe) {
	    // return btoa(fromCharCode.apply(null, a));
	    var b64 = '';

	    for (var i = 0, l = a.length; i < l; i += 3) {
	      var a0 = a[i],
	          a1 = a[i + 1],
	          a2 = a[i + 2];
	      var ord = a0 << 16 | a1 << 8 | a2;
	      b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
	    }

	    return urisafe ? mkUriSafe(b64) : b64;
	  }; // decoder stuff

	  var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;

	  var cb_btou = function (cccc) {
	    switch (cccc.length) {
	      case 4:
	        var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
	            offset = cp - 0x10000;
	        return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);

	      case 3:
	        return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));

	      default:
	        return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
	    }
	  };

	  var btou = function (b) {
	    return b.replace(re_btou, cb_btou);
	  };

	  var cb_decode = function (cccc) {
	    var len = cccc.length,
	        padlen = len % 4,
	        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0),
	        chars = [fromCharCode(n >>> 16), fromCharCode(n >>> 8 & 0xff), fromCharCode(n & 0xff)];
	    chars.length -= [0, 0, 2, 1][padlen];
	    return chars.join('');
	  };

	  var _atob = global.atob && typeof global.atob == 'function' ? function (a) {
	    return global.atob(a);
	  } : function (a) {
	    return a.replace(/\S{1,4}/g, cb_decode);
	  };

	  var atob = function (a) {
	    return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
	  };

	  var _decode = function (a) {
	    return btou(_atob(a));
	  };

	  var _fromURI = function (a) {
	    return String(a).replace(/[-_]/g, function (m0) {
	      return m0 == '-' ? '+' : '/';
	    }).replace(/[^A-Za-z0-9\+\/]/g, '');
	  };

	  var decode = function (a) {
	    return _decode(_fromURI(a));
	  };

	  var toUint8Array;
	  if (global.Uint8Array) toUint8Array = function (a) {
	    return Uint8Array.from(atob(_fromURI(a)), function (c) {
	      return c.charCodeAt(0);
	    });
	  };

	  var noConflict = function () {
	    var Base64 = global.Base64;
	    global.Base64 = _Base64;
	    return Base64;
	  }; // export Base64


	  global.Base64 = {
	    VERSION: version,
	    atob: atob,
	    btoa: btoa,
	    fromBase64: decode,
	    toBase64: encode,
	    utob: utob,
	    encode: encode,
	    encodeURI: encodeURI,
	    btou: btou,
	    decode: decode,
	    noConflict: noConflict,
	    fromUint8Array: fromUint8Array,
	    toUint8Array: toUint8Array
	  }; // if ES5 is available, make Base64.extendString() available

	  if (typeof Object.defineProperty === 'function') {
	    var noEnum = function (v) {
	      return {
	        value: v,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      };
	    };

	    global.Base64.extendString = function () {
	      Object.defineProperty(String.prototype, 'fromBase64', noEnum(function () {
	        return decode(this);
	      }));
	      Object.defineProperty(String.prototype, 'toBase64', noEnum(function (urisafe) {
	        return encode(this, urisafe);
	      }));
	      Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function () {
	        return encode(this, true);
	      }));
	    };
	  } //
	  // export Base64 to the namespace
	  //


	  if (global['Meteor']) {
	    // Meteor.js
	    Base64 = global.Base64;
	  } // module.exports and AMD are mutually exclusive.
	  // module.exports has precedence.


	  if (module.exports) {
	    module.exports.Base64 = global.Base64;
	  } // that's it!


	  return {
	    Base64: global.Base64
	  };
	});
	});

	/**
	 * Check if we're required to add a port number.
	 *
	 * @see https://url.spec.whatwg.org/#default-port
	 * @param {Number|String} port Port number we need to check
	 * @param {String} protocol Protocol we need to check against.
	 * @returns {Boolean} Is it a default port for the given protocol
	 * @api private
	 */

	var requiresPort = function required(port, protocol) {
	  protocol = protocol.split(':')[0];
	  port = +port;
	  if (!port) return false;

	  switch (protocol) {
	    case 'http':
	    case 'ws':
	      return port !== 80;

	    case 'https':
	    case 'wss':
	      return port !== 443;

	    case 'ftp':
	      return port !== 21;

	    case 'gopher':
	      return port !== 70;

	    case 'file':
	      return false;
	  }

	  return port !== 0;
	};

	var has$3 = Object.prototype.hasOwnProperty,
	    undef;
	/**
	 * Decode a URI encoded string.
	 *
	 * @param {String} input The URI encoded string.
	 * @returns {String|Null} The decoded string.
	 * @api private
	 */

	function decode$3(input) {
	  try {
	    return decodeURIComponent(input.replace(/\+/g, ' '));
	  } catch (e) {
	    return null;
	  }
	}
	/**
	 * Attempts to encode a given input.
	 *
	 * @param {String} input The string that needs to be encoded.
	 * @returns {String|Null} The encoded string.
	 * @api private
	 */


	function encode$4(input) {
	  try {
	    return encodeURIComponent(input);
	  } catch (e) {
	    return null;
	  }
	}
	/**
	 * Simple query string parser.
	 *
	 * @param {String} query The query string that needs to be parsed.
	 * @returns {Object}
	 * @api public
	 */


	function querystring(query) {
	  var parser = /([^=?#&]+)=?([^&]*)/g,
	      result = {},
	      part;

	  while (part = parser.exec(query)) {
	    var key = decode$3(part[1]),
	        value = decode$3(part[2]); //
	    // Prevent overriding of existing properties. This ensures that build-in
	    // methods like `toString` or __proto__ are not overriden by malicious
	    // querystrings.
	    //
	    // In the case if failed decoding, we want to omit the key/value pairs
	    // from the result.
	    //

	    if (key === null || value === null || key in result) continue;
	    result[key] = value;
	  }

	  return result;
	}
	/**
	 * Transform a query string to an object.
	 *
	 * @param {Object} obj Object that should be transformed.
	 * @param {String} prefix Optional prefix.
	 * @returns {String}
	 * @api public
	 */


	function querystringify(obj, prefix) {
	  prefix = prefix || '';
	  var pairs = [],
	      value,
	      key; //
	  // Optionally prefix with a '?' if needed
	  //

	  if ('string' !== typeof prefix) prefix = '?';

	  for (key in obj) {
	    if (has$3.call(obj, key)) {
	      value = obj[key]; //
	      // Edge cases where we actually want to encode the value to an empty
	      // string instead of the stringified value.
	      //

	      if (!value && (value === null || value === undef || isNaN(value))) {
	        value = '';
	      }

	      key = encode$4(key);
	      value = encode$4(value); //
	      // If we failed to encode the strings, we should bail out as we don't
	      // want to add invalid strings to the query.
	      //

	      if (key === null || value === null) continue;
	      pairs.push(key + '=' + value);
	    }
	  }

	  return pairs.length ? prefix + pairs.join('&') : '';
	} //
	// Expose the module.
	//


	var stringify = querystringify;
	var parse$1 = querystring;

	var querystringify_1 = {
		stringify: stringify,
		parse: parse$1
	};

	var controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/,
	    CRHTLF = /[\n\r\t]/g,
	    slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
	    port = /:\d+$/,
	    protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i,
	    windowsDriveLetter = /^[a-zA-Z]:/;
	/**
	 * Remove control characters and whitespace from the beginning of a string.
	 *
	 * @param {Object|String} str String to trim.
	 * @returns {String} A new string representing `str` stripped of control
	 *     characters and whitespace from its beginning.
	 * @public
	 */


	function trimLeft(str) {
	  return (str ? str : '').toString().replace(controlOrWhitespace, '');
	}
	/**
	 * These are the parse rules for the URL parser, it informs the parser
	 * about:
	 *
	 * 0. The char it Needs to parse, if it's a string it should be done using
	 *    indexOf, RegExp using exec and NaN means set as current value.
	 * 1. The property we should set when parsing this value.
	 * 2. Indication if it's backwards or forward parsing, when set as number it's
	 *    the value of extra chars that should be split off.
	 * 3. Inherit from location if non existing in the parser.
	 * 4. `toLowerCase` the resulting value.
	 */


	var rules = [['#', 'hash'], // Extract from the back.
	['?', 'query'], // Extract from the back.
	function sanitize(address, url) {
	  // Sanitize what is left of the address
	  return isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
	}, ['/', 'pathname'], // Extract from the back.
	['@', 'auth', 1], // Extract from the front.
	[NaN, 'host', undefined, 1, 1], // Set left over value.
	[/:(\d*)$/, 'port', undefined, 1], // RegExp the back.
	[NaN, 'hostname', undefined, 1, 1] // Set left over.
	];
	/**
	 * These properties should not be copied or inherited from. This is only needed
	 * for all non blob URL's as a blob URL does not include a hash, only the
	 * origin.
	 *
	 * @type {Object}
	 * @private
	 */

	var ignore = {
	  hash: 1,
	  query: 1
	};
	/**
	 * The location object differs when your code is loaded through a normal page,
	 * Worker or through a worker using a blob. And with the blobble begins the
	 * trouble as the location object will contain the URL of the blob, not the
	 * location of the page where our code is loaded in. The actual origin is
	 * encoded in the `pathname` so we can thankfully generate a good "default"
	 * location from it so we can generate proper relative URL's again.
	 *
	 * @param {Object|String} loc Optional default location object.
	 * @returns {Object} lolcation object.
	 * @public
	 */

	function lolcation(loc) {
	  var globalVar;
	  if (typeof window !== 'undefined') globalVar = window;else if (typeof commonjsGlobal !== 'undefined') globalVar = commonjsGlobal;else if (typeof self !== 'undefined') globalVar = self;else globalVar = {};
	  var location = globalVar.location || {};
	  loc = loc || location;
	  var finaldestination = {},
	      type = typeof loc,
	      key;

	  if ('blob:' === loc.protocol) {
	    finaldestination = new Url(unescape(loc.pathname), {});
	  } else if ('string' === type) {
	    finaldestination = new Url(loc, {});

	    for (key in ignore) delete finaldestination[key];
	  } else if ('object' === type) {
	    for (key in loc) {
	      if (key in ignore) continue;
	      finaldestination[key] = loc[key];
	    }

	    if (finaldestination.slashes === undefined) {
	      finaldestination.slashes = slashes.test(loc.href);
	    }
	  }

	  return finaldestination;
	}
	/**
	 * Check whether a protocol scheme is special.
	 *
	 * @param {String} The protocol scheme of the URL
	 * @return {Boolean} `true` if the protocol scheme is special, else `false`
	 * @private
	 */


	function isSpecial(scheme) {
	  return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
	}
	/**
	 * @typedef ProtocolExtract
	 * @type Object
	 * @property {String} protocol Protocol matched in the URL, in lowercase.
	 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
	 * @property {String} rest Rest of the URL that is not part of the protocol.
	 */

	/**
	 * Extract protocol information from a URL with/without double slash ("//").
	 *
	 * @param {String} address URL we want to extract from.
	 * @param {Object} location
	 * @return {ProtocolExtract} Extracted information.
	 * @private
	 */


	function extractProtocol(address, location) {
	  address = trimLeft(address);
	  address = address.replace(CRHTLF, '');
	  location = location || {};
	  var match = protocolre.exec(address);
	  var protocol = match[1] ? match[1].toLowerCase() : '';
	  var forwardSlashes = !!match[2];
	  var otherSlashes = !!match[3];
	  var slashesCount = 0;
	  var rest;

	  if (forwardSlashes) {
	    if (otherSlashes) {
	      rest = match[2] + match[3] + match[4];
	      slashesCount = match[2].length + match[3].length;
	    } else {
	      rest = match[2] + match[4];
	      slashesCount = match[2].length;
	    }
	  } else {
	    if (otherSlashes) {
	      rest = match[3] + match[4];
	      slashesCount = match[3].length;
	    } else {
	      rest = match[4];
	    }
	  }

	  if (protocol === 'file:') {
	    if (slashesCount >= 2) {
	      rest = rest.slice(2);
	    }
	  } else if (isSpecial(protocol)) {
	    rest = match[4];
	  } else if (protocol) {
	    if (forwardSlashes) {
	      rest = rest.slice(2);
	    }
	  } else if (slashesCount >= 2 && isSpecial(location.protocol)) {
	    rest = match[4];
	  }

	  return {
	    protocol: protocol,
	    slashes: forwardSlashes || isSpecial(protocol),
	    slashesCount: slashesCount,
	    rest: rest
	  };
	}
	/**
	 * Resolve a relative URL pathname against a base URL pathname.
	 *
	 * @param {String} relative Pathname of the relative URL.
	 * @param {String} base Pathname of the base URL.
	 * @return {String} Resolved pathname.
	 * @private
	 */


	function resolve(relative, base) {
	  if (relative === '') return base;
	  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')),
	      i = path.length,
	      last = path[i - 1],
	      unshift = false,
	      up = 0;

	  while (i--) {
	    if (path[i] === '.') {
	      path.splice(i, 1);
	    } else if (path[i] === '..') {
	      path.splice(i, 1);
	      up++;
	    } else if (up) {
	      if (i === 0) unshift = true;
	      path.splice(i, 1);
	      up--;
	    }
	  }

	  if (unshift) path.unshift('');
	  if (last === '.' || last === '..') path.push('');
	  return path.join('/');
	}
	/**
	 * The actual URL instance. Instead of returning an object we've opted-in to
	 * create an actual constructor as it's much more memory efficient and
	 * faster and it pleases my OCD.
	 *
	 * It is worth noting that we should not use `URL` as class name to prevent
	 * clashes with the global URL instance that got introduced in browsers.
	 *
	 * @constructor
	 * @param {String} address URL we want to parse.
	 * @param {Object|String} [location] Location defaults for relative paths.
	 * @param {Boolean|Function} [parser] Parser for the query string.
	 * @private
	 */


	function Url(address, location, parser) {
	  address = trimLeft(address);
	  address = address.replace(CRHTLF, '');

	  if (!(this instanceof Url)) {
	    return new Url(address, location, parser);
	  }

	  var relative,
	      extracted,
	      parse,
	      instruction,
	      index,
	      key,
	      instructions = rules.slice(),
	      type = typeof location,
	      url = this,
	      i = 0; //
	  // The following if statements allows this module two have compatibility with
	  // 2 different API:
	  //
	  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
	  //    where the boolean indicates that the query string should also be parsed.
	  //
	  // 2. The `URL` interface of the browser which accepts a URL, object as
	  //    arguments. The supplied object will be used as default values / fall-back
	  //    for relative paths.
	  //

	  if ('object' !== type && 'string' !== type) {
	    parser = location;
	    location = null;
	  }

	  if (parser && 'function' !== typeof parser) parser = querystringify_1.parse;
	  location = lolcation(location); //
	  // Extract protocol information before running the instructions.
	  //

	  extracted = extractProtocol(address || '', location);
	  relative = !extracted.protocol && !extracted.slashes;
	  url.slashes = extracted.slashes || relative && location.slashes;
	  url.protocol = extracted.protocol || location.protocol || '';
	  address = extracted.rest; //
	  // When the authority component is absent the URL starts with a path
	  // component.
	  //

	  if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) {
	    instructions[3] = [/(.*)/, 'pathname'];
	  }

	  for (; i < instructions.length; i++) {
	    instruction = instructions[i];

	    if (typeof instruction === 'function') {
	      address = instruction(address, url);
	      continue;
	    }

	    parse = instruction[0];
	    key = instruction[1];

	    if (parse !== parse) {
	      url[key] = address;
	    } else if ('string' === typeof parse) {
	      index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);

	      if (~index) {
	        if ('number' === typeof instruction[2]) {
	          url[key] = address.slice(0, index);
	          address = address.slice(index + instruction[2]);
	        } else {
	          url[key] = address.slice(index);
	          address = address.slice(0, index);
	        }
	      }
	    } else if (index = parse.exec(address)) {
	      url[key] = index[1];
	      address = address.slice(0, index.index);
	    }

	    url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : ''); //
	    // Hostname, host and protocol should be lowercased so they can be used to
	    // create a proper `origin`.
	    //

	    if (instruction[4]) url[key] = url[key].toLowerCase();
	  } //
	  // Also parse the supplied query string in to an object. If we're supplied
	  // with a custom parser as function use that instead of the default build-in
	  // parser.
	  //


	  if (parser) url.query = parser(url.query); //
	  // If the URL is relative, resolve the pathname against the base URL.
	  //

	  if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) {
	    url.pathname = resolve(url.pathname, location.pathname);
	  } //
	  // Default to a / for pathname if none exists. This normalizes the URL
	  // to always have a /
	  //


	  if (url.pathname.charAt(0) !== '/' && isSpecial(url.protocol)) {
	    url.pathname = '/' + url.pathname;
	  } //
	  // We should not add port numbers if they are already the default port number
	  // for a given protocol. As the host also contains the port number we're going
	  // override it with the hostname which contains no port number.
	  //


	  if (!requiresPort(url.port, url.protocol)) {
	    url.host = url.hostname;
	    url.port = '';
	  } //
	  // Parse down the `auth` for the username and password.
	  //


	  url.username = url.password = '';

	  if (url.auth) {
	    index = url.auth.indexOf(':');

	    if (~index) {
	      url.username = url.auth.slice(0, index);
	      url.username = encodeURIComponent(decodeURIComponent(url.username));
	      url.password = url.auth.slice(index + 1);
	      url.password = encodeURIComponent(decodeURIComponent(url.password));
	    } else {
	      url.username = encodeURIComponent(decodeURIComponent(url.auth));
	    }

	    url.auth = url.password ? url.username + ':' + url.password : url.username;
	  }

	  url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null'; //
	  // The href is just the compiled result.
	  //

	  url.href = url.toString();
	}
	/**
	 * This is convenience method for changing properties in the URL instance to
	 * insure that they all propagate correctly.
	 *
	 * @param {String} part          Property we need to adjust.
	 * @param {Mixed} value          The newly assigned value.
	 * @param {Boolean|Function} fn  When setting the query, it will be the function
	 *                               used to parse the query.
	 *                               When setting the protocol, double slash will be
	 *                               removed from the final url if it is true.
	 * @returns {URL} URL instance for chaining.
	 * @public
	 */


	function set$1(part, value, fn) {
	  var url = this;

	  switch (part) {
	    case 'query':
	      if ('string' === typeof value && value.length) {
	        value = (fn || querystringify_1.parse)(value);
	      }

	      url[part] = value;
	      break;

	    case 'port':
	      url[part] = value;

	      if (!requiresPort(value, url.protocol)) {
	        url.host = url.hostname;
	        url[part] = '';
	      } else if (value) {
	        url.host = url.hostname + ':' + value;
	      }

	      break;

	    case 'hostname':
	      url[part] = value;
	      if (url.port) value += ':' + url.port;
	      url.host = value;
	      break;

	    case 'host':
	      url[part] = value;

	      if (port.test(value)) {
	        value = value.split(':');
	        url.port = value.pop();
	        url.hostname = value.join(':');
	      } else {
	        url.hostname = value;
	        url.port = '';
	      }

	      break;

	    case 'protocol':
	      url.protocol = value.toLowerCase();
	      url.slashes = !fn;
	      break;

	    case 'pathname':
	    case 'hash':
	      if (value) {
	        var char = part === 'pathname' ? '/' : '#';
	        url[part] = value.charAt(0) !== char ? char + value : value;
	      } else {
	        url[part] = value;
	      }

	      break;

	    case 'username':
	    case 'password':
	      url[part] = encodeURIComponent(value);
	      break;

	    case 'auth':
	      var index = value.indexOf(':');

	      if (~index) {
	        url.username = value.slice(0, index);
	        url.username = encodeURIComponent(decodeURIComponent(url.username));
	        url.password = value.slice(index + 1);
	        url.password = encodeURIComponent(decodeURIComponent(url.password));
	      } else {
	        url.username = encodeURIComponent(decodeURIComponent(value));
	      }

	  }

	  for (var i = 0; i < rules.length; i++) {
	    var ins = rules[i];
	    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
	  }

	  url.auth = url.password ? url.username + ':' + url.password : url.username;
	  url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
	  url.href = url.toString();
	  return url;
	}
	/**
	 * Transform the properties back in to a valid and full URL string.
	 *
	 * @param {Function} stringify Optional query stringify function.
	 * @returns {String} Compiled version of the URL.
	 * @public
	 */


	function toString(stringify) {
	  if (!stringify || 'function' !== typeof stringify) stringify = querystringify_1.stringify;
	  var query,
	      url = this,
	      host = url.host,
	      protocol = url.protocol;
	  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
	  var result = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? '//' : '');

	  if (url.username) {
	    result += url.username;
	    if (url.password) result += ':' + url.password;
	    result += '@';
	  } else if (url.password) {
	    result += ':' + url.password;
	    result += '@';
	  } else if (url.protocol !== 'file:' && isSpecial(url.protocol) && !host && url.pathname !== '/') {
	    //
	    // Add back the empty userinfo, otherwise the original invalid URL
	    // might be transformed into a valid one with `url.pathname` as host.
	    //
	    result += '@';
	  } //
	  // Trailing colon is removed from `url.host` when it is parsed. If it still
	  // ends with a colon, then add back the trailing colon that was removed. This
	  // prevents an invalid URL from being transformed into a valid one.
	  //


	  if (host[host.length - 1] === ':' || port.test(url.hostname) && !url.port) {
	    host += ':';
	  }

	  result += host + url.pathname;
	  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
	  if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
	  if (url.hash) result += url.hash;
	  return result;
	}

	Url.prototype = {
	  set: set$1,
	  toString: toString
	}; //
	// Expose the URL parser and some additional properties that might be useful for
	// others or testing.
	//

	Url.extractProtocol = extractProtocol;
	Url.location = lolcation;
	Url.trimLeft = trimLeft;
	Url.qs = querystringify_1;
	var urlParse = Url;

	function _typeof$1(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof$1 = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof$1 = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof$1(obj);
	}

	function _defineProperties$8(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$9(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$8(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$8(Constructor, staticProps);
	  return Constructor;
	}

	function _classCallCheck$9(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _inherits$2(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf$1(subClass, superClass);
	}

	function _createSuper$1(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf$1(Derived),
	        result;

	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf$1(this).constructor;

	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }

	    return _possibleConstructorReturn$2(this, result);
	  };
	}

	function _possibleConstructorReturn$2(self, call) {
	  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
	    return call;
	  }

	  return _assertThisInitialized$1(self);
	}

	function _assertThisInitialized$1(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;

	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;

	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }

	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);

	      _cache.set(Class, Wrapper);
	    }

	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
	    }

	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf$1(Wrapper, Class);
	  };

	  return _wrapNativeSuper(Class);
	}

	function _construct(Parent, args, Class) {
	  if (_isNativeReflectConstruct$1()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf$1(instance, Class.prototype);
	      return instance;
	    };
	  }

	  return _construct.apply(null, arguments);
	}

	function _isNativeReflectConstruct$1() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}

	function _setPrototypeOf$1(o, p) {
	  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf$1(o, p);
	}

	function _getPrototypeOf$1(o) {
	  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf$1(o);
	}

	var DetailedError = /*#__PURE__*/function (_Error) {
	  _inherits$2(DetailedError, _Error);

	  var _super = _createSuper$1(DetailedError);

	  function DetailedError(message) {
	    var _this;

	    var causingErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var req = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var res = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	    _classCallCheck$9(this, DetailedError);

	    _this = _super.call(this, message);
	    _this.originalRequest = req;
	    _this.originalResponse = res;
	    _this.causingError = causingErr;

	    if (causingErr != null) {
	      message += ", caused by ".concat(causingErr.toString());
	    }

	    if (req != null) {
	      var requestId = req.getHeader('X-Request-ID') || 'n/a';
	      var method = req.getMethod();
	      var url = req.getURL();
	      var status = res ? res.getStatus() : 'n/a';
	      var body = res ? res.getBody() || '' : 'n/a';
	      message += ", originated from request (method: ".concat(method, ", url: ").concat(url, ", response code: ").concat(status, ", response text: ").concat(body, ", request id: ").concat(requestId, ")");
	    }

	    _this.message = message;
	    return _this;
	  }

	  return _createClass$9(DetailedError);
	}( /*#__PURE__*/_wrapNativeSuper(Error));

	/* eslint no-console: "off" */
	function log(msg) {
	  return;
	}

	/**
	 * Generate a UUID v4 based on random numbers. We intentioanlly use the less
	 * secure Math.random function here since the more secure crypto.getRandomNumbers
	 * is not available on all platforms.
	 * This is not a problem for us since we use the UUID only for generating a
	 * request ID, so we can correlate server logs to client errors.
	 *
	 * This function is taken from following site:
	 * https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
	 *
	 * @return {string} The generate UUID
	 */
	function uuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c == 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	}

	function ownKeys$1(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread$1(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys$1(Object(source), true).forEach(function (key) {
	        _defineProperty$1(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$1(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _defineProperty$1(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function _classCallCheck$8(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$7(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$8(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$7(Constructor, staticProps);
	  return Constructor;
	}
	var defaultOptions$1 = {
	  endpoint: null,
	  uploadUrl: null,
	  metadata: {},
	  fingerprint: null,
	  uploadSize: null,
	  onProgress: null,
	  onChunkComplete: null,
	  onSuccess: null,
	  onError: null,
	  _onUploadUrlAvailable: null,
	  overridePatchMethod: false,
	  headers: {},
	  addRequestId: false,
	  onBeforeRequest: null,
	  onAfterResponse: null,
	  onShouldRetry: null,
	  chunkSize: Infinity,
	  retryDelays: [0, 1000, 3000, 5000],
	  parallelUploads: 1,
	  storeFingerprintForResuming: true,
	  removeFingerprintOnSuccess: false,
	  uploadLengthDeferred: false,
	  uploadDataDuringCreation: false,
	  urlStorage: null,
	  fileReader: null,
	  httpStack: null
	};

	var BaseUpload = /*#__PURE__*/function () {
	  function BaseUpload(file, options) {
	    _classCallCheck$8(this, BaseUpload); // Warn about removed options from previous versions


	    this.options = options; // Cast chunkSize to integer

	    this.options.chunkSize = +this.options.chunkSize; // The storage module used to store URLs

	    this._urlStorage = this.options.urlStorage; // The underlying File/Blob object

	    this.file = file; // The URL against which the file will be uploaded

	    this.url = null; // The underlying request object for the current PATCH request

	    this._req = null; // The fingerpinrt for the current file (set after start())

	    this._fingerprint = null; // The key that the URL storage returned when saving an URL with a fingerprint,

	    this._urlStorageKey = null; // The offset used in the current PATCH request

	    this._offset = null; // True if the current PATCH request has been aborted

	    this._aborted = false; // The file's size in bytes

	    this._size = null; // The Source object which will wrap around the given file and provides us
	    // with a unified interface for getting its size and slice chunks from its
	    // content allowing us to easily handle Files, Blobs, Buffers and Streams.

	    this._source = null; // The current count of attempts which have been made. Zero indicates none.

	    this._retryAttempt = 0; // The timeout's ID which is used to delay the next retry

	    this._retryTimeout = null; // The offset of the remote upload before the latest attempt was started.

	    this._offsetBeforeRetry = 0; // An array of BaseUpload instances which are used for uploading the different
	    // parts, if the parallelUploads option is used.

	    this._parallelUploads = null; // An array of upload URLs which are used for uploading the different
	    // parts, if the parallelUploads option is used.

	    this._parallelUploadUrls = null;
	  }
	  /**
	   * Use the Termination extension to delete an upload from the server by sending a DELETE
	   * request to the specified upload URL. This is only possible if the server supports the
	   * Termination extension. If the `options.retryDelays` property is set, the method will
	   * also retry if an error ocurrs.
	   *
	   * @param {String} url The upload's URL which will be terminated.
	   * @param {object} options Optional options for influencing HTTP requests.
	   * @return {Promise} The Promise will be resolved/rejected when the requests finish.
	   */


	  _createClass$8(BaseUpload, [{
	    key: "findPreviousUploads",
	    value: function findPreviousUploads() {
	      var _this = this;

	      return this.options.fingerprint(this.file, this.options).then(function (fingerprint) {
	        return _this._urlStorage.findUploadsByFingerprint(fingerprint);
	      });
	    }
	  }, {
	    key: "resumeFromPreviousUpload",
	    value: function resumeFromPreviousUpload(previousUpload) {
	      this.url = previousUpload.uploadUrl || null;
	      this._parallelUploadUrls = previousUpload.parallelUploadUrls || null;
	      this._urlStorageKey = previousUpload.urlStorageKey;
	    }
	  }, {
	    key: "start",
	    value: function start() {
	      var _this2 = this;

	      var file = this.file;

	      if (!file) {
	        this._emitError(new Error('tus: no file or stream to upload provided'));

	        return;
	      }

	      if (!this.options.endpoint && !this.options.uploadUrl) {
	        this._emitError(new Error('tus: neither an endpoint or an upload URL is provided'));

	        return;
	      }

	      var retryDelays = this.options.retryDelays;

	      if (retryDelays != null && Object.prototype.toString.call(retryDelays) !== '[object Array]') {
	        this._emitError(new Error('tus: the `retryDelays` option must either be an array or null'));

	        return;
	      }

	      if (this.options.parallelUploads > 1) {
	        // Test which options are incompatible with parallel uploads.
	        ['uploadUrl', 'uploadSize', 'uploadLengthDeferred'].forEach(function (optionName) {
	          if (_this2.options[optionName]) {
	            _this2._emitError(new Error("tus: cannot use the ".concat(optionName, " option when parallelUploads is enabled")));
	          }
	        });
	      }

	      this.options.fingerprint(file, this.options).then(function (fingerprint) {

	        _this2._fingerprint = fingerprint;

	        if (_this2._source) {
	          return _this2._source;
	        }

	        return _this2.options.fileReader.openFile(file, _this2.options.chunkSize);
	      }).then(function (source) {
	        _this2._source = source; // If the upload was configured to use multiple requests or if we resume from
	        // an upload which used multiple requests, we start a parallel upload.

	        if (_this2.options.parallelUploads > 1 || _this2._parallelUploadUrls != null) {
	          _this2._startParallelUpload();
	        } else {
	          _this2._startSingleUpload();
	        }
	      })["catch"](function (err) {
	        _this2._emitError(err);
	      });
	    }
	    /**
	     * Initiate the uploading procedure for a parallelized upload, where one file is split into
	     * multiple request which are run in parallel.
	     *
	     * @api private
	     */

	  }, {
	    key: "_startParallelUpload",
	    value: function _startParallelUpload() {
	      var _this3 = this;

	      var totalSize = this._size = this._source.size;
	      var totalProgress = 0;
	      this._parallelUploads = [];
	      var partCount = this._parallelUploadUrls != null ? this._parallelUploadUrls.length : this.options.parallelUploads; // The input file will be split into multiple slices which are uploaded in separate
	      // requests. Here we generate the start and end position for the slices.

	      var parts = splitSizeIntoParts(this._source.size, partCount, this._parallelUploadUrls); // Create an empty list for storing the upload URLs

	      this._parallelUploadUrls = new Array(parts.length); // Generate a promise for each slice that will be resolve if the respective
	      // upload is completed.

	      var uploads = parts.map(function (part, index) {
	        var lastPartProgress = 0;
	        return _this3._source.slice(part.start, part.end).then(function (_ref) {
	          var value = _ref.value;
	          return new Promise(function (resolve, reject) {
	            // Merge with the user supplied options but overwrite some values.
	            var options = _objectSpread$1(_objectSpread$1({}, _this3.options), {}, {
	              // If available, the partial upload should be resumed from a previous URL.
	              uploadUrl: part.uploadUrl || null,
	              // We take manually care of resuming for partial uploads, so they should
	              // not be stored in the URL storage.
	              storeFingerprintForResuming: false,
	              removeFingerprintOnSuccess: false,
	              // Reset the parallelUploads option to not cause recursion.
	              parallelUploads: 1,
	              metadata: {},
	              // Add the header to indicate the this is a partial upload.
	              headers: _objectSpread$1(_objectSpread$1({}, _this3.options.headers), {}, {
	                'Upload-Concat': 'partial'
	              }),
	              // Reject or resolve the promise if the upload errors or completes.
	              onSuccess: resolve,
	              onError: reject,
	              // Based in the progress for this partial upload, calculate the progress
	              // for the entire final upload.
	              onProgress: function onProgress(newPartProgress) {
	                totalProgress = totalProgress - lastPartProgress + newPartProgress;
	                lastPartProgress = newPartProgress;

	                _this3._emitProgress(totalProgress, totalSize);
	              },
	              // Wait until every partial upload has an upload URL, so we can add
	              // them to the URL storage.
	              _onUploadUrlAvailable: function _onUploadUrlAvailable() {
	                _this3._parallelUploadUrls[index] = upload.url; // Test if all uploads have received an URL

	                if (_this3._parallelUploadUrls.filter(function (u) {
	                  return !!u;
	                }).length === parts.length) {
	                  _this3._saveUploadInUrlStorage();
	                }
	              }
	            });

	            var upload = new BaseUpload(value, options);
	            upload.start(); // Store the upload in an array, so we can later abort them if necessary.

	            _this3._parallelUploads.push(upload);
	          });
	        });
	      });
	      var req; // Wait until all partial uploads are finished and we can send the POST request for
	      // creating the final upload.

	      Promise.all(uploads).then(function () {
	        req = _this3._openRequest('POST', _this3.options.endpoint);
	        req.setHeader('Upload-Concat', "final;".concat(_this3._parallelUploadUrls.join(' '))); // Add metadata if values have been added

	        var metadata = encodeMetadata(_this3.options.metadata);

	        if (metadata !== '') {
	          req.setHeader('Upload-Metadata', metadata);
	        }

	        return _this3._sendRequest(req, null);
	      }).then(function (res) {
	        if (!inStatusCategory(res.getStatus(), 200)) {
	          _this3._emitHttpError(req, res, 'tus: unexpected response while creating upload');

	          return;
	        }

	        var location = res.getHeader('Location');

	        if (location == null) {
	          _this3._emitHttpError(req, res, 'tus: invalid or missing Location header');

	          return;
	        }

	        _this3.url = resolveUrl(_this3.options.endpoint, location);
	        log("Created upload at ".concat(_this3.url));

	        _this3._emitSuccess();
	      })["catch"](function (err) {
	        _this3._emitError(err);
	      });
	    }
	    /**
	     * Initiate the uploading procedure for a non-parallel upload. Here the entire file is
	     * uploaded in a sequential matter.
	     *
	     * @api private
	     */

	  }, {
	    key: "_startSingleUpload",
	    value: function _startSingleUpload() {
	      // First, we look at the uploadLengthDeferred option.
	      // Next, we check if the caller has supplied a manual upload size.
	      // Finally, we try to use the calculated size from the source object.
	      if (this.options.uploadLengthDeferred) {
	        this._size = null;
	      } else if (this.options.uploadSize != null) {
	        this._size = +this.options.uploadSize;

	        if (isNaN(this._size)) {
	          this._emitError(new Error('tus: cannot convert `uploadSize` option into a number'));

	          return;
	        }
	      } else {
	        this._size = this._source.size;

	        if (this._size == null) {
	          this._emitError(new Error("tus: cannot automatically derive upload's size from input. Specify it manually using the `uploadSize` option or use the `uploadLengthDeferred` option"));

	          return;
	        }
	      } // Reset the aborted flag when the upload is started or else the
	      // _performUpload will stop before sending a request if the upload has been
	      // aborted previously.


	      this._aborted = false; // The upload had been started previously and we should reuse this URL.

	      if (this.url != null) {
	        log("Resuming upload from previous URL: ".concat(this.url));

	        this._resumeUpload();

	        return;
	      } // A URL has manually been specified, so we try to resume


	      if (this.options.uploadUrl != null) {
	        log("Resuming upload from provided URL: ".concat(this.options.uploadUrl));
	        this.url = this.options.uploadUrl;

	        this._resumeUpload();

	        return;
	      } // An upload has not started for the file yet, so we start a new one

	      this._createUpload();
	    }
	    /**
	     * Abort any running request and stop the current upload. After abort is called, no event
	     * handler will be invoked anymore. You can use the `start` method to resume the upload
	     * again.
	     * If `shouldTerminate` is true, the `terminate` function will be called to remove the
	     * current upload from the server.
	     *
	     * @param {boolean} shouldTerminate True if the upload should be deleted from the server.
	     * @return {Promise} The Promise will be resolved/rejected when the requests finish.
	     */

	  }, {
	    key: "abort",
	    value: function abort(shouldTerminate) {
	      var _this4 = this; // Count the number of arguments to see if a callback is being provided in the old style required by tus-js-client 1.x, then throw an error if it is.
	      // `arguments` is a JavaScript built-in variable that contains all of the function's arguments.


	      if (arguments.length > 1 && typeof arguments[1] === 'function') {
	        throw new Error('tus: the abort function does not accept a callback since v2 anymore; please use the returned Promise instead');
	      } // Stop any parallel partial uploads, that have been started in _startParallelUploads.


	      if (this._parallelUploads != null) {
	        this._parallelUploads.forEach(function (upload) {
	          upload.abort(shouldTerminate);
	        });
	      } // Stop any current running request.


	      if (this._req !== null) {
	        this._req.abort();

	        this._source.close();
	      }

	      this._aborted = true; // Stop any timeout used for initiating a retry.

	      if (this._retryTimeout != null) {
	        clearTimeout(this._retryTimeout);
	        this._retryTimeout = null;
	      }

	      if (!shouldTerminate || this.url == null) {
	        return Promise.resolve();
	      }

	      return BaseUpload.terminate(this.url, this.options) // Remove entry from the URL storage since the upload URL is no longer valid.
	      .then(function () {
	        return _this4._removeFromUrlStorage();
	      });
	    }
	  }, {
	    key: "_emitHttpError",
	    value: function _emitHttpError(req, res, message, causingErr) {
	      this._emitError(new DetailedError(message, causingErr, req, res));
	    }
	  }, {
	    key: "_emitError",
	    value: function _emitError(err) {
	      var _this5 = this; // Do not emit errors, e.g. from aborted HTTP requests, if the upload has been stopped.


	      if (this._aborted) return; // Check if we should retry, when enabled, before sending the error to the user.

	      if (this.options.retryDelays != null) {
	        // We will reset the attempt counter if
	        // - we were already able to connect to the server (offset != null) and
	        // - we were able to upload a small chunk of data to the server
	        var shouldResetDelays = this._offset != null && this._offset > this._offsetBeforeRetry;

	        if (shouldResetDelays) {
	          this._retryAttempt = 0;
	        }

	        if (shouldRetry(err, this._retryAttempt, this.options)) {
	          var delay = this.options.retryDelays[this._retryAttempt++];
	          this._offsetBeforeRetry = this._offset;
	          this._retryTimeout = setTimeout(function () {
	            _this5.start();
	          }, delay);
	          return;
	        }
	      }

	      if (typeof this.options.onError === 'function') {
	        this.options.onError(err);
	      } else {
	        throw err;
	      }
	    }
	    /**
	     * Publishes notification if the upload has been successfully completed.
	     *
	     * @api private
	     */

	  }, {
	    key: "_emitSuccess",
	    value: function _emitSuccess() {
	      if (this.options.removeFingerprintOnSuccess) {
	        // Remove stored fingerprint and corresponding endpoint. This causes
	        // new uploads of the same file to be treated as a different file.
	        this._removeFromUrlStorage();
	      }

	      if (typeof this.options.onSuccess === 'function') {
	        this.options.onSuccess();
	      }
	    }
	    /**
	     * Publishes notification when data has been sent to the server. This
	     * data may not have been accepted by the server yet.
	     *
	     * @param {number} bytesSent  Number of bytes sent to the server.
	     * @param {number} bytesTotal Total number of bytes to be sent to the server.
	     * @api private
	     */

	  }, {
	    key: "_emitProgress",
	    value: function _emitProgress(bytesSent, bytesTotal) {
	      if (typeof this.options.onProgress === 'function') {
	        this.options.onProgress(bytesSent, bytesTotal);
	      }
	    }
	    /**
	     * Publishes notification when a chunk of data has been sent to the server
	     * and accepted by the server.
	     * @param {number} chunkSize  Size of the chunk that was accepted by the server.
	     * @param {number} bytesAccepted Total number of bytes that have been
	     *                                accepted by the server.
	     * @param {number} bytesTotal Total number of bytes to be sent to the server.
	     * @api private
	     */

	  }, {
	    key: "_emitChunkComplete",
	    value: function _emitChunkComplete(chunkSize, bytesAccepted, bytesTotal) {
	      if (typeof this.options.onChunkComplete === 'function') {
	        this.options.onChunkComplete(chunkSize, bytesAccepted, bytesTotal);
	      }
	    }
	    /**
	     * Create a new upload using the creation extension by sending a POST
	     * request to the endpoint. After successful creation the file will be
	     * uploaded
	     *
	     * @api private
	     */

	  }, {
	    key: "_createUpload",
	    value: function _createUpload() {
	      var _this6 = this;

	      if (!this.options.endpoint) {
	        this._emitError(new Error('tus: unable to create upload because no endpoint is provided'));

	        return;
	      }

	      var req = this._openRequest('POST', this.options.endpoint);

	      if (this.options.uploadLengthDeferred) {
	        req.setHeader('Upload-Defer-Length', 1);
	      } else {
	        req.setHeader('Upload-Length', this._size);
	      } // Add metadata if values have been added


	      var metadata = encodeMetadata(this.options.metadata);

	      if (metadata !== '') {
	        req.setHeader('Upload-Metadata', metadata);
	      }

	      var promise;

	      if (this.options.uploadDataDuringCreation && !this.options.uploadLengthDeferred) {
	        this._offset = 0;
	        promise = this._addChunkToRequest(req);
	      } else {
	        promise = this._sendRequest(req, null);
	      }

	      promise.then(function (res) {
	        if (!inStatusCategory(res.getStatus(), 200)) {
	          _this6._emitHttpError(req, res, 'tus: unexpected response while creating upload');

	          return;
	        }

	        var location = res.getHeader('Location');

	        if (location == null) {
	          _this6._emitHttpError(req, res, 'tus: invalid or missing Location header');

	          return;
	        }

	        _this6.url = resolveUrl(_this6.options.endpoint, location);
	        log("Created upload at ".concat(_this6.url));

	        if (typeof _this6.options._onUploadUrlAvailable === 'function') {
	          _this6.options._onUploadUrlAvailable();
	        }

	        if (_this6._size === 0) {
	          // Nothing to upload and file was successfully created
	          _this6._emitSuccess();

	          _this6._source.close();

	          return;
	        }

	        _this6._saveUploadInUrlStorage();

	        if (_this6.options.uploadDataDuringCreation) {
	          _this6._handleUploadResponse(req, res);
	        } else {
	          _this6._offset = 0;

	          _this6._performUpload();
	        }
	      })["catch"](function (err) {
	        _this6._emitHttpError(req, null, 'tus: failed to create upload', err);
	      });
	    }
	    /*
	     * Try to resume an existing upload. First a HEAD request will be sent
	     * to retrieve the offset. If the request fails a new upload will be
	     * created. In the case of a successful response the file will be uploaded.
	     *
	     * @api private
	     */

	  }, {
	    key: "_resumeUpload",
	    value: function _resumeUpload() {
	      var _this7 = this;

	      var req = this._openRequest('HEAD', this.url);

	      var promise = this._sendRequest(req, null);

	      promise.then(function (res) {
	        var status = res.getStatus();

	        if (!inStatusCategory(status, 200)) {
	          if (inStatusCategory(status, 400)) {
	            // Remove stored fingerprint and corresponding endpoint,
	            // on client errors since the file can not be found
	            _this7._removeFromUrlStorage();
	          } // If the upload is locked (indicated by the 423 Locked status code), we
	          // emit an error instead of directly starting a new upload. This way the
	          // retry logic can catch the error and will retry the upload. An upload
	          // is usually locked for a short period of time and will be available
	          // afterwards.


	          if (status === 423) {
	            _this7._emitHttpError(req, res, 'tus: upload is currently locked; retry later');

	            return;
	          }

	          if (!_this7.options.endpoint) {
	            // Don't attempt to create a new upload if no endpoint is provided.
	            _this7._emitHttpError(req, res, 'tus: unable to resume upload (new upload cannot be created without an endpoint)');

	            return;
	          } // Try to create a new upload


	          _this7.url = null;

	          _this7._createUpload();

	          return;
	        }

	        var offset = parseInt(res.getHeader('Upload-Offset'), 10);

	        if (isNaN(offset)) {
	          _this7._emitHttpError(req, res, 'tus: invalid or missing offset value');

	          return;
	        }

	        var length = parseInt(res.getHeader('Upload-Length'), 10);

	        if (isNaN(length) && !_this7.options.uploadLengthDeferred) {
	          _this7._emitHttpError(req, res, 'tus: invalid or missing length value');

	          return;
	        }

	        if (typeof _this7.options._onUploadUrlAvailable === 'function') {
	          _this7.options._onUploadUrlAvailable();
	        } // Upload has already been completed and we do not need to send additional
	        // data to the server


	        if (offset === length) {
	          _this7._emitProgress(length, length);

	          _this7._emitSuccess();

	          return;
	        }

	        _this7._offset = offset;

	        _this7._performUpload();
	      })["catch"](function (err) {
	        _this7._emitHttpError(req, null, 'tus: failed to resume upload', err);
	      });
	    }
	    /**
	     * Start uploading the file using PATCH requests. The file will be divided
	     * into chunks as specified in the chunkSize option. During the upload
	     * the onProgress event handler may be invoked multiple times.
	     *
	     * @api private
	     */

	  }, {
	    key: "_performUpload",
	    value: function _performUpload() {
	      var _this8 = this; // If the upload has been aborted, we will not send the next PATCH request.
	      // This is important if the abort method was called during a callback, such
	      // as onChunkComplete or onProgress.


	      if (this._aborted) {
	        return;
	      }

	      var req; // Some browser and servers may not support the PATCH method. For those
	      // cases, you can tell tus-js-client to use a POST request with the
	      // X-HTTP-Method-Override header for simulating a PATCH request.

	      if (this.options.overridePatchMethod) {
	        req = this._openRequest('POST', this.url);
	        req.setHeader('X-HTTP-Method-Override', 'PATCH');
	      } else {
	        req = this._openRequest('PATCH', this.url);
	      }

	      req.setHeader('Upload-Offset', this._offset);

	      var promise = this._addChunkToRequest(req);

	      promise.then(function (res) {
	        if (!inStatusCategory(res.getStatus(), 200)) {
	          _this8._emitHttpError(req, res, 'tus: unexpected response while uploading chunk');

	          return;
	        }

	        _this8._handleUploadResponse(req, res);
	      })["catch"](function (err) {
	        // Don't emit an error if the upload was aborted manually
	        if (_this8._aborted) {
	          return;
	        }

	        _this8._emitHttpError(req, null, "tus: failed to upload chunk at offset ".concat(_this8._offset), err);
	      });
	    }
	    /**
	     * _addChunktoRequest reads a chunk from the source and sends it using the
	     * supplied request object. It will not handle the response.
	     *
	     * @api private
	     */

	  }, {
	    key: "_addChunkToRequest",
	    value: function _addChunkToRequest(req) {
	      var _this9 = this;

	      var start = this._offset;
	      var end = this._offset + this.options.chunkSize;
	      req.setProgressHandler(function (bytesSent) {
	        _this9._emitProgress(start + bytesSent, _this9._size);
	      });
	      req.setHeader('Content-Type', 'application/offset+octet-stream'); // The specified chunkSize may be Infinity or the calcluated end position
	      // may exceed the file's size. In both cases, we limit the end position to
	      // the input's total size for simpler calculations and correctness.

	      if ((end === Infinity || end > this._size) && !this.options.uploadLengthDeferred) {
	        end = this._size;
	      }

	      return this._source.slice(start, end).then(function (_ref2) {
	        var value = _ref2.value,
	            done = _ref2.done; // If the upload length is deferred, the upload size was not specified during
	        // upload creation. So, if the file reader is done reading, we know the total
	        // upload size and can tell the tus server.

	        if (_this9.options.uploadLengthDeferred && done) {
	          _this9._size = _this9._offset + (value && value.size ? value.size : 0);
	          req.setHeader('Upload-Length', _this9._size);
	        }

	        if (value === null) {
	          return _this9._sendRequest(req);
	        }

	        _this9._emitProgress(_this9._offset, _this9._size);

	        return _this9._sendRequest(req, value);
	      });
	    }
	    /**
	     * _handleUploadResponse is used by requests that haven been sent using _addChunkToRequest
	     * and already have received a response.
	     *
	     * @api private
	     */

	  }, {
	    key: "_handleUploadResponse",
	    value: function _handleUploadResponse(req, res) {
	      var offset = parseInt(res.getHeader('Upload-Offset'), 10);

	      if (isNaN(offset)) {
	        this._emitHttpError(req, res, 'tus: invalid or missing offset value');

	        return;
	      }

	      this._emitProgress(offset, this._size);

	      this._emitChunkComplete(offset - this._offset, offset, this._size);

	      this._offset = offset;

	      if (offset == this._size) {
	        // Yay, finally done :)
	        this._emitSuccess();

	        this._source.close();

	        return;
	      }

	      this._performUpload();
	    }
	    /**
	     * Create a new HTTP request object with the given method and URL.
	     *
	     * @api private
	     */

	  }, {
	    key: "_openRequest",
	    value: function _openRequest(method, url) {
	      var req = openRequest(method, url, this.options);
	      this._req = req;
	      return req;
	    }
	    /**
	     * Remove the entry in the URL storage, if it has been saved before.
	     *
	     * @api private
	     */

	  }, {
	    key: "_removeFromUrlStorage",
	    value: function _removeFromUrlStorage() {
	      var _this10 = this;

	      if (!this._urlStorageKey) return;

	      this._urlStorage.removeUpload(this._urlStorageKey)["catch"](function (err) {
	        _this10._emitError(err);
	      });

	      this._urlStorageKey = null;
	    }
	    /**
	     * Add the upload URL to the URL storage, if possible.
	     *
	     * @api private
	     */

	  }, {
	    key: "_saveUploadInUrlStorage",
	    value: function _saveUploadInUrlStorage() {
	      var _this11 = this; // Only if a fingerprint was calculated for the input (i.e. not a stream), we can store the upload URL.


	      if (!this.options.storeFingerprintForResuming || !this._fingerprint) {
	        return;
	      }

	      var storedUpload = {
	        size: this._size,
	        metadata: this.options.metadata,
	        creationTime: new Date().toString()
	      };

	      if (this._parallelUploads) {
	        // Save multiple URLs if the parallelUploads option is used ...
	        storedUpload.parallelUploadUrls = this._parallelUploadUrls;
	      } else {
	        // ... otherwise we just save the one available URL.
	        storedUpload.uploadUrl = this.url;
	      }

	      this._urlStorage.addUpload(this._fingerprint, storedUpload).then(function (urlStorageKey) {
	        return _this11._urlStorageKey = urlStorageKey;
	      })["catch"](function (err) {
	        _this11._emitError(err);
	      });
	    }
	    /**
	     * Send a request with the provided body.
	     *
	     * @api private
	     */

	  }, {
	    key: "_sendRequest",
	    value: function _sendRequest(req) {
	      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      return sendRequest(req, body, this.options);
	    }
	  }], [{
	    key: "terminate",
	    value: function terminate(url, options) {
	      // Count the number of arguments to see if a callback is being provided as the last
	      // argument in the old style required by tus-js-client 1.x, then throw an error if it is.
	      // `arguments` is a JavaScript built-in variable that contains all of the function's arguments.
	      if (arguments.length > 1 && typeof arguments[arguments.length - 1] === 'function') {
	        throw new Error('tus: the terminate function does not accept a callback since v2 anymore; please use the returned Promise instead');
	      } // Note that in order for the trick above to work, a default value cannot be set for `options`,
	      // so the check below replaces the old default `{}`.


	      if (options === undefined) {
	        options = {};
	      }

	      var req = openRequest('DELETE', url, options);
	      return sendRequest(req, null, options).then(function (res) {
	        // A 204 response indicates a successfull request
	        if (res.getStatus() === 204) {
	          return;
	        }

	        throw new DetailedError('tus: unexpected response while terminating upload', null, req, res);
	      })["catch"](function (err) {
	        if (!(err instanceof DetailedError)) {
	          err = new DetailedError('tus: failed to terminate upload', err, req, null);
	        }

	        if (!shouldRetry(err, 0, options)) {
	          throw err;
	        } // Instead of keeping track of the retry attempts, we remove the first element from the delays
	        // array. If the array is empty, all retry attempts are used up and we will bubble up the error.
	        // We recursively call the terminate function will removing elements from the retryDelays array.


	        var delay = options.retryDelays[0];
	        var remainingDelays = options.retryDelays.slice(1);

	        var newOptions = _objectSpread$1(_objectSpread$1({}, options), {}, {
	          retryDelays: remainingDelays
	        });

	        return new Promise(function (resolve) {
	          return setTimeout(resolve, delay);
	        }).then(function () {
	          return BaseUpload.terminate(url, newOptions);
	        });
	      });
	    }
	  }]);

	  return BaseUpload;
	}();

	function encodeMetadata(metadata) {
	  var encoded = [];

	  for (var key in metadata) {
	    encoded.push("".concat(key, " ").concat(base64.Base64.encode(metadata[key])));
	  }

	  return encoded.join(',');
	}
	/**
	 * Checks whether a given status is in the range of the expected category.
	 * For example, only a status between 200 and 299 will satisfy the category 200.
	 *
	 * @api private
	 */


	function inStatusCategory(status, category) {
	  return status >= category && status < category + 100;
	}
	/**
	 * Create a new HTTP request with the specified method and URL.
	 * The necessary headers that are included in every request
	 * will be added, including the request ID.
	 *
	 * @api private
	 */


	function openRequest(method, url, options) {
	  var req = options.httpStack.createRequest(method, url);
	  req.setHeader('Tus-Resumable', '1.0.0');
	  var headers = options.headers || {};

	  for (var name in headers) {
	    req.setHeader(name, headers[name]);
	  }

	  if (options.addRequestId) {
	    var requestId = uuid();
	    req.setHeader('X-Request-ID', requestId);
	  }

	  return req;
	}
	/**
	 * Send a request with the provided body while invoking the onBeforeRequest
	 * and onAfterResponse callbacks.
	 *
	 * @api private
	 */


	function sendRequest(req, body, options) {
	  var onBeforeRequestPromise = typeof options.onBeforeRequest === 'function' ? Promise.resolve(options.onBeforeRequest(req)) : Promise.resolve();
	  return onBeforeRequestPromise.then(function () {
	    return req.send(body).then(function (res) {
	      var onAfterResponsePromise = typeof options.onAfterResponse === 'function' ? Promise.resolve(options.onAfterResponse(req, res)) : Promise.resolve();
	      return onAfterResponsePromise.then(function () {
	        return res;
	      });
	    });
	  });
	}
	/**
	 * Checks whether the browser running this code has internet access.
	 * This function will always return true in the node.js environment
	 *
	 * @api private
	 */


	function isOnline() {
	  var online = true;

	  if (typeof window !== 'undefined' && 'navigator' in window && window.navigator.onLine === false) {
	    online = false;
	  }

	  return online;
	}
	/**
	 * Checks whether or not it is ok to retry a request.
	 * @param {Error} err the error returned from the last request
	 * @param {number} retryAttempt the number of times the request has already been retried
	 * @param {object} options tus Upload options
	 *
	 * @api private
	 */


	function shouldRetry(err, retryAttempt, options) {
	  // We only attempt a retry if
	  // - retryDelays option is set
	  // - we didn't exceed the maxium number of retries, yet, and
	  // - this error was caused by a request or it's response and
	  // - the error is server error (i.e. not a status 4xx except a 409 or 423) or
	  // a onShouldRetry is specified and returns true
	  // - the browser does not indicate that we are offline
	  if (options.retryDelays == null || retryAttempt >= options.retryDelays.length || err.originalRequest == null) {
	    return false;
	  }

	  if (options && typeof options.onShouldRetry === 'function') {
	    return options.onShouldRetry(err, retryAttempt, options);
	  }

	  var status = err.originalResponse ? err.originalResponse.getStatus() : 0;
	  return (!inStatusCategory(status, 400) || status === 409 || status === 423) && isOnline();
	}
	/**
	 * Resolve a relative link given the origin as source. For example,
	 * if a HTTP request to http://example.com/files/ returns a Location
	 * header with the value /upload/abc, the resolved URL will be:
	 * http://example.com/upload/abc
	 */


	function resolveUrl(origin, link) {
	  return new urlParse(link, origin).toString();
	}
	/**
	 * Calculate the start and end positions for the parts if an upload
	 * is split into multiple parallel requests.
	 *
	 * @param {number} totalSize The byte size of the upload, which will be split.
	 * @param {number} partCount The number in how many parts the upload will be split.
	 * @param {string[]} previousUrls The upload URLs for previous parts.
	 * @return {object[]}
	 * @api private
	 */


	function splitSizeIntoParts(totalSize, partCount, previousUrls) {
	  var partSize = Math.floor(totalSize / partCount);
	  var parts = [];

	  for (var i = 0; i < partCount; i++) {
	    parts.push({
	      start: partSize * i,
	      end: partSize * (i + 1)
	    });
	  }

	  parts[partCount - 1].end = totalSize; // Attach URLs from previous uploads, if available.

	  if (previousUrls) {
	    parts.forEach(function (part, index) {
	      part.uploadUrl = previousUrls[index] || null;
	    });
	  }

	  return parts;
	}

	BaseUpload.defaultOptions = defaultOptions$1;

	function _classCallCheck$7(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$6(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$7(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$6(Constructor, staticProps);
	  return Constructor;
	}
	/* eslint no-unused-vars: "off" */


	var NoopUrlStorage = /*#__PURE__*/function () {
	  function NoopUrlStorage() {
	    _classCallCheck$7(this, NoopUrlStorage);
	  }

	  _createClass$7(NoopUrlStorage, [{
	    key: "listAllUploads",
	    value: function listAllUploads() {
	      return Promise.resolve([]);
	    }
	  }, {
	    key: "findUploadsByFingerprint",
	    value: function findUploadsByFingerprint(fingerprint) {
	      return Promise.resolve([]);
	    }
	  }, {
	    key: "removeUpload",
	    value: function removeUpload(urlStorageKey) {
	      return Promise.resolve();
	    }
	  }, {
	    key: "addUpload",
	    value: function addUpload(fingerprint, upload) {
	      return Promise.resolve(null);
	    }
	  }]);

	  return NoopUrlStorage;
	}();

	function _classCallCheck$6(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$5(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$6(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$5(Constructor, staticProps);
	  return Constructor;
	}
	/* global window, localStorage */


	var hasStorage = false;

	try {
	  hasStorage = 'localStorage' in window; // Attempt to store and read entries from the local storage to detect Private
	  // Mode on Safari on iOS (see #49)

	  var key$2 = 'tusSupport';
	  localStorage.setItem(key$2, localStorage.getItem(key$2));
	} catch (e) {
	  // If we try to access localStorage inside a sandboxed iframe, a SecurityError
	  // is thrown. When in private mode on iOS Safari, a QuotaExceededError is
	  // thrown (see #49)
	  if (e.code === e.SECURITY_ERR || e.code === e.QUOTA_EXCEEDED_ERR) {
	    hasStorage = false;
	  } else {
	    throw e;
	  }
	}

	var canStoreURLs = hasStorage;
	var WebStorageUrlStorage = /*#__PURE__*/function () {
	  function WebStorageUrlStorage() {
	    _classCallCheck$6(this, WebStorageUrlStorage);
	  }

	  _createClass$6(WebStorageUrlStorage, [{
	    key: "findAllUploads",
	    value: function findAllUploads() {
	      var results = this._findEntries('tus::');

	      return Promise.resolve(results);
	    }
	  }, {
	    key: "findUploadsByFingerprint",
	    value: function findUploadsByFingerprint(fingerprint) {
	      var results = this._findEntries("tus::".concat(fingerprint, "::"));

	      return Promise.resolve(results);
	    }
	  }, {
	    key: "removeUpload",
	    value: function removeUpload(urlStorageKey) {
	      localStorage.removeItem(urlStorageKey);
	      return Promise.resolve();
	    }
	  }, {
	    key: "addUpload",
	    value: function addUpload(fingerprint, upload) {
	      var id = Math.round(Math.random() * 1e12);
	      var key = "tus::".concat(fingerprint, "::").concat(id);
	      localStorage.setItem(key, JSON.stringify(upload));
	      return Promise.resolve(key);
	    }
	  }, {
	    key: "_findEntries",
	    value: function _findEntries(prefix) {
	      var results = [];

	      for (var i = 0; i < localStorage.length; i++) {
	        var _key = localStorage.key(i);

	        if (_key.indexOf(prefix) !== 0) continue;

	        try {
	          var upload = JSON.parse(localStorage.getItem(_key));
	          upload.urlStorageKey = _key;
	          results.push(upload);
	        } catch (e) {// The JSON parse error is intentionally ignored here, so a malformed
	          // entry in the storage cannot prevent an upload.
	        }
	      }

	      return results;
	    }
	  }]);

	  return WebStorageUrlStorage;
	}();

	function _classCallCheck$5(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$4(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$5(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$4(Constructor, staticProps);
	  return Constructor;
	}
	/* eslint-disable max-classes-per-file */


	var XHRHttpStack = /*#__PURE__*/function () {
	  function XHRHttpStack() {
	    _classCallCheck$5(this, XHRHttpStack);
	  }

	  _createClass$5(XHRHttpStack, [{
	    key: "createRequest",
	    value: function createRequest(method, url) {
	      return new Request(method, url);
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return 'XHRHttpStack';
	    }
	  }]);

	  return XHRHttpStack;
	}();

	var Request = /*#__PURE__*/function () {
	  function Request(method, url) {
	    _classCallCheck$5(this, Request);

	    this._xhr = new XMLHttpRequest();

	    this._xhr.open(method, url, true);

	    this._method = method;
	    this._url = url;
	    this._headers = {};
	  }

	  _createClass$5(Request, [{
	    key: "getMethod",
	    value: function getMethod() {
	      return this._method;
	    }
	  }, {
	    key: "getURL",
	    value: function getURL() {
	      return this._url;
	    }
	  }, {
	    key: "setHeader",
	    value: function setHeader(header, value) {
	      this._xhr.setRequestHeader(header, value);

	      this._headers[header] = value;
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader(header) {
	      return this._headers[header];
	    }
	  }, {
	    key: "setProgressHandler",
	    value: function setProgressHandler(progressHandler) {
	      // Test support for progress events before attaching an event listener
	      if (!('upload' in this._xhr)) {
	        return;
	      }

	      this._xhr.upload.onprogress = function (e) {
	        if (!e.lengthComputable) {
	          return;
	        }

	        progressHandler(e.loaded);
	      };
	    }
	  }, {
	    key: "send",
	    value: function send() {
	      var _this = this;

	      var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      return new Promise(function (resolve, reject) {
	        _this._xhr.onload = function () {
	          resolve(new Response(_this._xhr));
	        };

	        _this._xhr.onerror = function (err) {
	          reject(err);
	        };

	        _this._xhr.send(body);
	      });
	    }
	  }, {
	    key: "abort",
	    value: function abort() {
	      this._xhr.abort();

	      return Promise.resolve();
	    }
	  }, {
	    key: "getUnderlyingObject",
	    value: function getUnderlyingObject() {
	      return this._xhr;
	    }
	  }]);

	  return Request;
	}();

	var Response = /*#__PURE__*/function () {
	  function Response(xhr) {
	    _classCallCheck$5(this, Response);

	    this._xhr = xhr;
	  }

	  _createClass$5(Response, [{
	    key: "getStatus",
	    value: function getStatus() {
	      return this._xhr.status;
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader(header) {
	      return this._xhr.getResponseHeader(header);
	    }
	  }, {
	    key: "getBody",
	    value: function getBody() {
	      return this._xhr.responseText;
	    }
	  }, {
	    key: "getUnderlyingObject",
	    value: function getUnderlyingObject() {
	      return this._xhr;
	    }
	  }]);

	  return Response;
	}();

	var isReactNative = function isReactNative() {
	  return typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative';
	};

	/**
	 * uriToBlob resolves a URI to a Blob object. This is used for
	 * React Native to retrieve a file (identified by a file://
	 * URI) as a blob.
	 */
	function uriToBlob(uri) {
	  return new Promise(function (resolve, reject) {
	    var xhr = new XMLHttpRequest();
	    xhr.responseType = 'blob';

	    xhr.onload = function () {
	      var blob = xhr.response;
	      resolve(blob);
	    };

	    xhr.onerror = function (err) {
	      reject(err);
	    };

	    xhr.open('GET', uri);
	    xhr.send();
	  });
	}

	var isCordova = function isCordova() {
	  return typeof window != 'undefined' && (typeof window.PhoneGap != 'undefined' || typeof window.Cordova != 'undefined' || typeof window.cordova != 'undefined');
	};

	/**
	 * readAsByteArray converts a File object to a Uint8Array.
	 * This function is only used on the Apache Cordova platform.
	 * See https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-file/index.html#read-a-file
	 */
	function readAsByteArray(chunk) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();

	    reader.onload = function () {
	      var value = new Uint8Array(reader.result);
	      resolve({
	        value: value
	      });
	    };

	    reader.onerror = function (err) {
	      reject(err);
	    };

	    reader.readAsArrayBuffer(chunk);
	  });
	}

	function _classCallCheck$4(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$3(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$4(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$3(Constructor, staticProps);
	  return Constructor;
	}

	var FileSource = /*#__PURE__*/function () {
	  // Make this.size a method
	  function FileSource(file) {
	    _classCallCheck$4(this, FileSource);

	    this._file = file;
	    this.size = file.size;
	  }

	  _createClass$4(FileSource, [{
	    key: "slice",
	    value: function slice(start, end) {
	      // In Apache Cordova applications, a File must be resolved using
	      // FileReader instances, see
	      // https://cordova.apache.org/docs/en/8.x/reference/cordova-plugin-file/index.html#read-a-file
	      if (isCordova()) {
	        return readAsByteArray(this._file.slice(start, end));
	      }

	      var value = this._file.slice(start, end);

	      return Promise.resolve({
	        value: value
	      });
	    }
	  }, {
	    key: "close",
	    value: function close() {// Nothing to do here since we don't need to release any resources.
	    }
	  }]);

	  return FileSource;
	}();

	function _classCallCheck$3(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$2(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$3(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$2(Constructor, staticProps);
	  return Constructor;
	}

	function len(blobOrArray) {
	  if (blobOrArray === undefined) return 0;
	  if (blobOrArray.size !== undefined) return blobOrArray.size;
	  return blobOrArray.length;
	}
	/*
	  Typed arrays and blobs don't have a concat method.
	  This function helps StreamSource accumulate data to reach chunkSize.
	*/


	function concat$2(a, b) {
	  if (a.concat) {
	    // Is `a` an Array?
	    return a.concat(b);
	  }

	  if (a instanceof Blob) {
	    return new Blob([a, b], {
	      type: a.type
	    });
	  }

	  if (a.set) {
	    // Is `a` a typed array?
	    var c = new a.constructor(a.length + b.length);
	    c.set(a);
	    c.set(b, a.length);
	    return c;
	  }

	  throw new Error('Unknown data type');
	}

	var StreamSource = /*#__PURE__*/function () {
	  function StreamSource(reader, chunkSize) {
	    _classCallCheck$3(this, StreamSource);

	    this._chunkSize = chunkSize;
	    this._buffer = undefined;
	    this._bufferOffset = 0;
	    this._reader = reader;
	    this._done = false;
	  }

	  _createClass$3(StreamSource, [{
	    key: "slice",
	    value: function slice(start, end) {
	      if (start < this._bufferOffset) {
	        return Promise.reject(new Error("Requested data is before the reader's current offset"));
	      }

	      return this._readUntilEnoughDataOrDone(start, end);
	    }
	  }, {
	    key: "_readUntilEnoughDataOrDone",
	    value: function _readUntilEnoughDataOrDone(start, end) {
	      var _this = this;

	      var hasEnoughData = end <= this._bufferOffset + len(this._buffer);

	      if (this._done || hasEnoughData) {
	        var value = this._getDataFromBuffer(start, end);

	        var done = value == null ? this._done : false;
	        return Promise.resolve({
	          value: value,
	          done: done
	        });
	      }

	      return this._reader.read().then(function (_ref) {
	        var value = _ref.value,
	            done = _ref.done;

	        if (done) {
	          _this._done = true;
	        } else if (_this._buffer === undefined) {
	          _this._buffer = value;
	        } else {
	          _this._buffer = concat$2(_this._buffer, value);
	        }

	        return _this._readUntilEnoughDataOrDone(start, end);
	      });
	    }
	  }, {
	    key: "_getDataFromBuffer",
	    value: function _getDataFromBuffer(start, end) {
	      // Remove data from buffer before `start`.
	      // Data might be reread from the buffer if an upload fails, so we can only
	      // safely delete data when it comes *before* what is currently being read.
	      if (start > this._bufferOffset) {
	        this._buffer = this._buffer.slice(start - this._bufferOffset);
	        this._bufferOffset = start;
	      } // If the buffer is empty after removing old data, all data has been read.


	      var hasAllDataBeenRead = len(this._buffer) === 0;

	      if (this._done && hasAllDataBeenRead) {
	        return null;
	      } // We already removed data before `start`, so we just return the first
	      // chunk from the buffer.


	      return this._buffer.slice(0, end - start);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      if (this._reader.cancel) {
	        this._reader.cancel();
	      }
	    }
	  }]);

	  return StreamSource;
	}();

	function _classCallCheck$2(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$1(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$2(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$1(Constructor, staticProps);
	  return Constructor;
	}

	var FileReader$1 = /*#__PURE__*/function () {
	  function FileReader() {
	    _classCallCheck$2(this, FileReader);
	  }

	  _createClass$2(FileReader, [{
	    key: "openFile",
	    value: function openFile(input, chunkSize) {
	      // In React Native, when user selects a file, instead of a File or Blob,
	      // you usually get a file object {} with a uri property that contains
	      // a local path to the file. We use XMLHttpRequest to fetch
	      // the file blob, before uploading with tus.
	      if (isReactNative() && input && typeof input.uri !== 'undefined') {
	        return uriToBlob(input.uri).then(function (blob) {
	          return new FileSource(blob);
	        })["catch"](function (err) {
	          throw new Error("tus: cannot fetch `file.uri` as Blob, make sure the uri is correct and accessible. ".concat(err));
	        });
	      } // Since we emulate the Blob type in our tests (not all target browsers
	      // support it), we cannot use `instanceof` for testing whether the input value
	      // can be handled. Instead, we simply check is the slice() function and the
	      // size property are available.


	      if (typeof input.slice === 'function' && typeof input.size !== 'undefined') {
	        return Promise.resolve(new FileSource(input));
	      }

	      if (typeof input.read === 'function') {
	        chunkSize = +chunkSize;

	        if (!isFinite(chunkSize)) {
	          return Promise.reject(new Error('cannot create source for stream without a finite value for the `chunkSize` option'));
	        }

	        return Promise.resolve(new StreamSource(input, chunkSize));
	      }

	      return Promise.reject(new Error('source object may only be an instance of File, Blob, or Reader in this environment'));
	    }
	  }]);

	  return FileReader;
	}();

	/**
	 * Generate a fingerprint for a file which will be used the store the endpoint
	 *
	 * @param {File} file
	 * @param {Object} options
	 * @param {Function} callback
	 */

	function fingerprint(file, options) {
	  if (isReactNative()) {
	    return Promise.resolve(reactNativeFingerprint(file, options));
	  }

	  return Promise.resolve(['tus-br', file.name, file.type, file.size, file.lastModified, options.endpoint].join('-'));
	}

	function reactNativeFingerprint(file, options) {
	  var exifHash = file.exif ? hashCode(JSON.stringify(file.exif)) : 'noexif';
	  return ['tus-rn', file.name || 'noname', file.size || 'nosize', exifHash, options.endpoint].join('/');
	}

	function hashCode(str) {
	  // from https://stackoverflow.com/a/8831937/151666
	  var hash = 0;

	  if (str.length === 0) {
	    return hash;
	  }

	  for (var i = 0; i < str.length; i++) {
	    var _char = str.charCodeAt(i);

	    hash = (hash << 5) - hash + _char;
	    hash &= hash; // Convert to 32bit integer
	  }

	  return hash;
	}

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	function _classCallCheck$1(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$1(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	function _inherits$1(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}

	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf(o, p);
	}

	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();

	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;

	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;

	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }

	    return _possibleConstructorReturn$1(this, result);
	  };
	}

	function _possibleConstructorReturn$1(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }

	  return _assertThisInitialized(self);
	}

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var defaultOptions = _objectSpread(_objectSpread({}, BaseUpload.defaultOptions), {}, {
	  httpStack: new XHRHttpStack(),
	  fileReader: new FileReader$1(),
	  urlStorage: canStoreURLs ? new WebStorageUrlStorage() : new NoopUrlStorage(),
	  fingerprint: fingerprint
	});

	var Upload = /*#__PURE__*/function (_BaseUpload) {
	  _inherits$1(Upload, _BaseUpload);

	  var _super = _createSuper(Upload);

	  function Upload() {
	    var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    _classCallCheck$1(this, Upload);

	    options = _objectSpread(_objectSpread({}, defaultOptions), options);
	    return _super.call(this, file, options);
	  }

	  _createClass$1(Upload, null, [{
	    key: "terminate",
	    value: function terminate(url, options, cb) {
	      options = _objectSpread(_objectSpread({}, defaultOptions), options);
	      return BaseUpload.terminate(url, options, cb);
	    }
	  }]);

	  return Upload;
	}(BaseUpload);

	// Names that are part of the external SDK interface, i.e. those which our clients use.
	// Names of all provided x-tags.
	var TAG_HEADER = "x-utu-header";
	var TAG_ROOT = "x-utu-root";
	var TAG_UTU_APP_LINK = "x-utu-app-link";
	var TAG_RECOMMENDATION = "x-utu-recommendation";
	var TAG_FEEDBACK_FORM = "x-utu-feedback-form";
	var TAG_FEEDBACK_FORM_POPUP = "x-utu-feedback-form-popup";
	var TAG_FEEDBACK_DETAILS_POPUP = "x-utu-feedback-details-popup";
	var TAG_FEEDBACK_DETAILS = "x-utu-feedback-details";
	var TAG_WALLET_CONNECT = "x-utu-wallet-connect";
	var TAG_WALLET_DISCONNECT = "x-utu-wallet-disconnect";
	var TAG_UTT_BALANCE = "x-utt-balance"; // Attribute names of all attributes provided by all TAGs.

	var ATTR_API_URL = "api-url";
	var ATTR_BTN_COLOR = "btn-color";
	var ATTR_THEME_COLOR = "theme-color";
	var ATTR_SOURCE_UUID = "source-uuid";
	var ATTR_TARGET_TYPE = "target-type";
	var ATTR_TARGET_UUIDS = "target-uuids";
	var ATTR_TARGET_UUID = "target-uuid";
	var ATTR_ENDORSEMENT_NETWORK = "endorsement-network";
	var ATTR_TRANSACTION_ID = "transaction-id"; // API BASE URLs

	var UTU_API_BASE_URL_PRODUCTION = "https://api.ututrust.com";
	var UTU_API_BASE_URL_TEST = "https://stage-api.ututrust.com";
	var UTU_SOCIAL_LINK_URL_PRODUCTION = "https://app.utu.io";
	var UTU_SOCIAL_LINK_URL_TEST = "https://stage-app.utu.io";
	var CORE_API_BASE = "/core-api";
	var UPLOADER_API_BASE = "/uploader-api";
	var VIDEO_PUBLISHED_BASE = "/published-videos"; // API resource paths

	var API_RANKING = "/ranking";
	var API_FEEDBACK = "/feedback";
	var API_BADGES = "/badges";
	var API_FEEDBACK_SUMMARY = "/feedbackSummary";
	var API_VERIFY_ADDRESS = "/identity-api/verify-address"; // Events

	var EVENT_UTU_CONFIG = "utuConfig";
	var EVENT_UTU_IDENTITY_DATA_READY = "utuIdentityDataReady"; // Local Storage Keys

	var LOCAL_STORAGE_KEY_UTU_IDENTITY_DATA = "utu-identity-data"; // Supported UTT networks

	var NETWORK_NAME;

	(function (NETWORK_NAME) {
	  NETWORK_NAME["polygon_mainnet"] = "polygon_mainnet";
	  NETWORK_NAME["polygon_mumbai"] = "polygon_mumbai";
	})(NETWORK_NAME || (NETWORK_NAME = {}));

	var UTT_CONTRACT_ADDRESS_TEST = "0x19bc90FfBDCaD53c48eF0b08A67B0D2563AEE2a8";

	function e$1(e) {
	  this.message = e;
	}

	e$1.prototype = new Error(), e$1.prototype.name = "InvalidCharacterError";

	var r$3 = "undefined" != typeof window && window.atob && window.atob.bind(window) || function (r) {
	  var t = String(r).replace(/=+$/, "");
	  if (t.length % 4 == 1) throw new e$1("'atob' failed: The string to be decoded is not correctly encoded.");

	  for (var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) ? c += String.fromCharCode(255 & n >> (-2 * a & 6)) : 0) o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);

	  return c;
	};

	function t$1(e) {
	  var t = e.replace(/-/g, "+").replace(/_/g, "/");

	  switch (t.length % 4) {
	    case 0:
	      break;

	    case 2:
	      t += "==";
	      break;

	    case 3:
	      t += "=";
	      break;

	    default:
	      throw "Illegal base64url string!";
	  }

	  try {
	    return function (e) {
	      return decodeURIComponent(r$3(e).replace(/(.)/g, function (e, r) {
	        var t = r.charCodeAt(0).toString(16).toUpperCase();
	        return t.length < 2 && (t = "0" + t), "%" + t;
	      }));
	    }(t);
	  } catch (e) {
	    return r$3(t);
	  }
	}

	function n$1(e) {
	  this.message = e;
	}

	function o$1(e, r) {
	  if ("string" != typeof e) throw new n$1("Invalid token specified");
	  var o = !0 === (r = r || {}).header ? 0 : 1;

	  try {
	    return JSON.parse(t$1(e.split(".")[o]));
	  } catch (e) {
	    throw new n$1("Invalid token specified: " + e.message);
	  }
	}

	n$1.prototype = new Error(), n$1.prototype.name = "InvalidTokenError";

	var bn = createCommonjsModule$1(function (module) {
	(function (module, exports) {

	  function assert(val, msg) {
	    if (!val) throw new Error(msg || 'Assertion failed');
	  } // Could use `inherits` module, but don't want to move from single file
	  // architecture yet.


	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;

	    var TempCtor = function () {};

	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  } // BN


	  function BN(number, base, endian) {
	    if (BN.isBN(number)) {
	      return number;
	    }

	    this.negative = 0;
	    this.words = null;
	    this.length = 0; // Reduction context

	    this.red = null;

	    if (number !== null) {
	      if (base === 'le' || base === 'be') {
	        endian = base;
	        base = 10;
	      }

	      this._init(number || 0, base || 10, endian || 'be');
	    }
	  }

	  if (typeof module === 'object') {
	    module.exports = BN;
	  } else {
	    exports.BN = BN;
	  }

	  BN.BN = BN;
	  BN.wordSize = 26;
	  var Buffer;

	  try {
	    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
	      Buffer = window.Buffer;
	    } else {
	      Buffer = require$$0.Buffer;
	    }
	  } catch (e) {}

	  BN.isBN = function isBN(num) {
	    if (num instanceof BN) {
	      return true;
	    }

	    return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
	  };

	  BN.max = function max(left, right) {
	    if (left.cmp(right) > 0) return left;
	    return right;
	  };

	  BN.min = function min(left, right) {
	    if (left.cmp(right) < 0) return left;
	    return right;
	  };

	  BN.prototype._init = function init(number, base, endian) {
	    if (typeof number === 'number') {
	      return this._initNumber(number, base, endian);
	    }

	    if (typeof number === 'object') {
	      return this._initArray(number, base, endian);
	    }

	    if (base === 'hex') {
	      base = 16;
	    }

	    assert(base === (base | 0) && base >= 2 && base <= 36);
	    number = number.toString().replace(/\s+/g, '');
	    var start = 0;

	    if (number[0] === '-') {
	      start++;
	      this.negative = 1;
	    }

	    if (start < number.length) {
	      if (base === 16) {
	        this._parseHex(number, start, endian);
	      } else {
	        this._parseBase(number, base, start);

	        if (endian === 'le') {
	          this._initArray(this.toArray(), base, endian);
	        }
	      }
	    }
	  };

	  BN.prototype._initNumber = function _initNumber(number, base, endian) {
	    if (number < 0) {
	      this.negative = 1;
	      number = -number;
	    }

	    if (number < 0x4000000) {
	      this.words = [number & 0x3ffffff];
	      this.length = 1;
	    } else if (number < 0x10000000000000) {
	      this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff];
	      this.length = 2;
	    } else {
	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)

	      this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff, 1];
	      this.length = 3;
	    }

	    if (endian !== 'le') return; // Reverse the bytes

	    this._initArray(this.toArray(), base, endian);
	  };

	  BN.prototype._initArray = function _initArray(number, base, endian) {
	    // Perhaps a Uint8Array
	    assert(typeof number.length === 'number');

	    if (number.length <= 0) {
	      this.words = [0];
	      this.length = 1;
	      return this;
	    }

	    this.length = Math.ceil(number.length / 3);
	    this.words = new Array(this.length);

	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }

	    var j, w;
	    var off = 0;

	    if (endian === 'be') {
	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
	        w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
	        this.words[j] |= w << off & 0x3ffffff;
	        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
	        off += 24;

	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    } else if (endian === 'le') {
	      for (i = 0, j = 0; i < number.length; i += 3) {
	        w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
	        this.words[j] |= w << off & 0x3ffffff;
	        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
	        off += 24;

	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    }

	    return this._strip();
	  };

	  function parseHex4Bits(string, index) {
	    var c = string.charCodeAt(index); // '0' - '9'

	    if (c >= 48 && c <= 57) {
	      return c - 48; // 'A' - 'F'
	    } else if (c >= 65 && c <= 70) {
	      return c - 55; // 'a' - 'f'
	    } else if (c >= 97 && c <= 102) {
	      return c - 87;
	    } else {
	      assert(false, 'Invalid character in ' + string);
	    }
	  }

	  function parseHexByte(string, lowerBound, index) {
	    var r = parseHex4Bits(string, index);

	    if (index - 1 >= lowerBound) {
	      r |= parseHex4Bits(string, index - 1) << 4;
	    }

	    return r;
	  }

	  BN.prototype._parseHex = function _parseHex(number, start, endian) {
	    // Create possibly bigger array to ensure that it fits the number
	    this.length = Math.ceil((number.length - start) / 6);
	    this.words = new Array(this.length);

	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    } // 24-bits chunks


	    var off = 0;
	    var j = 0;
	    var w;

	    if (endian === 'be') {
	      for (i = number.length - 1; i >= start; i -= 2) {
	        w = parseHexByte(number, start, i) << off;
	        this.words[j] |= w & 0x3ffffff;

	        if (off >= 18) {
	          off -= 18;
	          j += 1;
	          this.words[j] |= w >>> 26;
	        } else {
	          off += 8;
	        }
	      }
	    } else {
	      var parseLength = number.length - start;

	      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
	        w = parseHexByte(number, start, i) << off;
	        this.words[j] |= w & 0x3ffffff;

	        if (off >= 18) {
	          off -= 18;
	          j += 1;
	          this.words[j] |= w >>> 26;
	        } else {
	          off += 8;
	        }
	      }
	    }

	    this._strip();
	  };

	  function parseBase(str, start, end, mul) {
	    var r = 0;
	    var b = 0;
	    var len = Math.min(str.length, end);

	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	      r *= mul; // 'a'

	      if (c >= 49) {
	        b = c - 49 + 0xa; // 'A'
	      } else if (c >= 17) {
	        b = c - 17 + 0xa; // '0' - '9'
	      } else {
	        b = c;
	      }

	      assert(c >= 0 && b < mul, 'Invalid character');
	      r += b;
	    }

	    return r;
	  }

	  BN.prototype._parseBase = function _parseBase(number, base, start) {
	    // Initialize as zero
	    this.words = [0];
	    this.length = 1; // Find length of limb in base

	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
	      limbLen++;
	    }

	    limbLen--;
	    limbPow = limbPow / base | 0;
	    var total = number.length - start;
	    var mod = total % limbLen;
	    var end = Math.min(total, total - mod) + start;
	    var word = 0;

	    for (var i = start; i < end; i += limbLen) {
	      word = parseBase(number, i, i + limbLen, base);
	      this.imuln(limbPow);

	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }

	    if (mod !== 0) {
	      var pow = 1;
	      word = parseBase(number, i, number.length, base);

	      for (i = 0; i < mod; i++) {
	        pow *= base;
	      }

	      this.imuln(pow);

	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }

	    this._strip();
	  };

	  BN.prototype.copy = function copy(dest) {
	    dest.words = new Array(this.length);

	    for (var i = 0; i < this.length; i++) {
	      dest.words[i] = this.words[i];
	    }

	    dest.length = this.length;
	    dest.negative = this.negative;
	    dest.red = this.red;
	  };

	  function move(dest, src) {
	    dest.words = src.words;
	    dest.length = src.length;
	    dest.negative = src.negative;
	    dest.red = src.red;
	  }

	  BN.prototype._move = function _move(dest) {
	    move(dest, this);
	  };

	  BN.prototype.clone = function clone() {
	    var r = new BN(null);
	    this.copy(r);
	    return r;
	  };

	  BN.prototype._expand = function _expand(size) {
	    while (this.length < size) {
	      this.words[this.length++] = 0;
	    }

	    return this;
	  }; // Remove leading `0` from `this`


	  BN.prototype._strip = function strip() {
	    while (this.length > 1 && this.words[this.length - 1] === 0) {
	      this.length--;
	    }

	    return this._normSign();
	  };

	  BN.prototype._normSign = function _normSign() {
	    // -0 = 0
	    if (this.length === 1 && this.words[0] === 0) {
	      this.negative = 0;
	    }

	    return this;
	  }; // Check Symbol.for because not everywhere where Symbol defined
	  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility


	  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
	    try {
	      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
	    } catch (e) {
	      BN.prototype.inspect = inspect;
	    }
	  } else {
	    BN.prototype.inspect = inspect;
	  }

	  function inspect() {
	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
	  }
	  /*
	   var zeros = [];
	  var groupSizes = [];
	  var groupBases = [];
	   var s = '';
	  var i = -1;
	  while (++i < BN.wordSize) {
	    zeros[i] = s;
	    s += '0';
	  }
	  groupSizes[0] = 0;
	  groupSizes[1] = 0;
	  groupBases[0] = 0;
	  groupBases[1] = 0;
	  var base = 2 - 1;
	  while (++base < 36 + 1) {
	    var groupSize = 0;
	    var groupBase = 1;
	    while (groupBase < (1 << BN.wordSize) / base) {
	      groupBase *= base;
	      groupSize += 1;
	    }
	    groupSizes[base] = groupSize;
	    groupBases[base] = groupBase;
	  }
	   */


	  var zeros = ['', '0', '00', '000', '0000', '00000', '000000', '0000000', '00000000', '000000000', '0000000000', '00000000000', '000000000000', '0000000000000', '00000000000000', '000000000000000', '0000000000000000', '00000000000000000', '000000000000000000', '0000000000000000000', '00000000000000000000', '000000000000000000000', '0000000000000000000000', '00000000000000000000000', '000000000000000000000000', '0000000000000000000000000'];
	  var groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
	  var groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

	  BN.prototype.toString = function toString(base, padding) {
	    base = base || 10;
	    padding = padding | 0 || 1;
	    var out;

	    if (base === 16 || base === 'hex') {
	      out = '';
	      var off = 0;
	      var carry = 0;

	      for (var i = 0; i < this.length; i++) {
	        var w = this.words[i];
	        var word = ((w << off | carry) & 0xffffff).toString(16);
	        carry = w >>> 24 - off & 0xffffff;
	        off += 2;

	        if (off >= 26) {
	          off -= 26;
	          i--;
	        }

	        if (carry !== 0 || i !== this.length - 1) {
	          out = zeros[6 - word.length] + word + out;
	        } else {
	          out = word + out;
	        }
	      }

	      if (carry !== 0) {
	        out = carry.toString(16) + out;
	      }

	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }

	      if (this.negative !== 0) {
	        out = '-' + out;
	      }

	      return out;
	    }

	    if (base === (base | 0) && base >= 2 && base <= 36) {
	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
	      var groupSize = groupSizes[base]; // var groupBase = Math.pow(base, groupSize);

	      var groupBase = groupBases[base];
	      out = '';
	      var c = this.clone();
	      c.negative = 0;

	      while (!c.isZero()) {
	        var r = c.modrn(groupBase).toString(base);
	        c = c.idivn(groupBase);

	        if (!c.isZero()) {
	          out = zeros[groupSize - r.length] + r + out;
	        } else {
	          out = r + out;
	        }
	      }

	      if (this.isZero()) {
	        out = '0' + out;
	      }

	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }

	      if (this.negative !== 0) {
	        out = '-' + out;
	      }

	      return out;
	    }

	    assert(false, 'Base should be between 2 and 36');
	  };

	  BN.prototype.toNumber = function toNumber() {
	    var ret = this.words[0];

	    if (this.length === 2) {
	      ret += this.words[1] * 0x4000000;
	    } else if (this.length === 3 && this.words[2] === 0x01) {
	      // NOTE: at this stage it is known that the top bit is set
	      ret += 0x10000000000000 + this.words[1] * 0x4000000;
	    } else if (this.length > 2) {
	      assert(false, 'Number can only safely store up to 53 bits');
	    }

	    return this.negative !== 0 ? -ret : ret;
	  };

	  BN.prototype.toJSON = function toJSON() {
	    return this.toString(16, 2);
	  };

	  if (Buffer) {
	    BN.prototype.toBuffer = function toBuffer(endian, length) {
	      return this.toArrayLike(Buffer, endian, length);
	    };
	  }

	  BN.prototype.toArray = function toArray(endian, length) {
	    return this.toArrayLike(Array, endian, length);
	  };

	  var allocate = function allocate(ArrayType, size) {
	    if (ArrayType.allocUnsafe) {
	      return ArrayType.allocUnsafe(size);
	    }

	    return new ArrayType(size);
	  };

	  BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
	    this._strip();

	    var byteLength = this.byteLength();
	    var reqLength = length || Math.max(1, byteLength);
	    assert(byteLength <= reqLength, 'byte array longer than desired length');
	    assert(reqLength > 0, 'Requested array length <= 0');
	    var res = allocate(ArrayType, reqLength);
	    var postfix = endian === 'le' ? 'LE' : 'BE';
	    this['_toArrayLike' + postfix](res, byteLength);
	    return res;
	  };

	  BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
	    var position = 0;
	    var carry = 0;

	    for (var i = 0, shift = 0; i < this.length; i++) {
	      var word = this.words[i] << shift | carry;
	      res[position++] = word & 0xff;

	      if (position < res.length) {
	        res[position++] = word >> 8 & 0xff;
	      }

	      if (position < res.length) {
	        res[position++] = word >> 16 & 0xff;
	      }

	      if (shift === 6) {
	        if (position < res.length) {
	          res[position++] = word >> 24 & 0xff;
	        }

	        carry = 0;
	        shift = 0;
	      } else {
	        carry = word >>> 24;
	        shift += 2;
	      }
	    }

	    if (position < res.length) {
	      res[position++] = carry;

	      while (position < res.length) {
	        res[position++] = 0;
	      }
	    }
	  };

	  BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
	    var position = res.length - 1;
	    var carry = 0;

	    for (var i = 0, shift = 0; i < this.length; i++) {
	      var word = this.words[i] << shift | carry;
	      res[position--] = word & 0xff;

	      if (position >= 0) {
	        res[position--] = word >> 8 & 0xff;
	      }

	      if (position >= 0) {
	        res[position--] = word >> 16 & 0xff;
	      }

	      if (shift === 6) {
	        if (position >= 0) {
	          res[position--] = word >> 24 & 0xff;
	        }

	        carry = 0;
	        shift = 0;
	      } else {
	        carry = word >>> 24;
	        shift += 2;
	      }
	    }

	    if (position >= 0) {
	      res[position--] = carry;

	      while (position >= 0) {
	        res[position--] = 0;
	      }
	    }
	  };

	  if (Math.clz32) {
	    BN.prototype._countBits = function _countBits(w) {
	      return 32 - Math.clz32(w);
	    };
	  } else {
	    BN.prototype._countBits = function _countBits(w) {
	      var t = w;
	      var r = 0;

	      if (t >= 0x1000) {
	        r += 13;
	        t >>>= 13;
	      }

	      if (t >= 0x40) {
	        r += 7;
	        t >>>= 7;
	      }

	      if (t >= 0x8) {
	        r += 4;
	        t >>>= 4;
	      }

	      if (t >= 0x02) {
	        r += 2;
	        t >>>= 2;
	      }

	      return r + t;
	    };
	  }

	  BN.prototype._zeroBits = function _zeroBits(w) {
	    // Short-cut
	    if (w === 0) return 26;
	    var t = w;
	    var r = 0;

	    if ((t & 0x1fff) === 0) {
	      r += 13;
	      t >>>= 13;
	    }

	    if ((t & 0x7f) === 0) {
	      r += 7;
	      t >>>= 7;
	    }

	    if ((t & 0xf) === 0) {
	      r += 4;
	      t >>>= 4;
	    }

	    if ((t & 0x3) === 0) {
	      r += 2;
	      t >>>= 2;
	    }

	    if ((t & 0x1) === 0) {
	      r++;
	    }

	    return r;
	  }; // Return number of used bits in a BN


	  BN.prototype.bitLength = function bitLength() {
	    var w = this.words[this.length - 1];

	    var hi = this._countBits(w);

	    return (this.length - 1) * 26 + hi;
	  };

	  function toBitArray(num) {
	    var w = new Array(num.bitLength());

	    for (var bit = 0; bit < w.length; bit++) {
	      var off = bit / 26 | 0;
	      var wbit = bit % 26;
	      w[bit] = num.words[off] >>> wbit & 0x01;
	    }

	    return w;
	  } // Number of trailing zero bits


	  BN.prototype.zeroBits = function zeroBits() {
	    if (this.isZero()) return 0;
	    var r = 0;

	    for (var i = 0; i < this.length; i++) {
	      var b = this._zeroBits(this.words[i]);

	      r += b;
	      if (b !== 26) break;
	    }

	    return r;
	  };

	  BN.prototype.byteLength = function byteLength() {
	    return Math.ceil(this.bitLength() / 8);
	  };

	  BN.prototype.toTwos = function toTwos(width) {
	    if (this.negative !== 0) {
	      return this.abs().inotn(width).iaddn(1);
	    }

	    return this.clone();
	  };

	  BN.prototype.fromTwos = function fromTwos(width) {
	    if (this.testn(width - 1)) {
	      return this.notn(width).iaddn(1).ineg();
	    }

	    return this.clone();
	  };

	  BN.prototype.isNeg = function isNeg() {
	    return this.negative !== 0;
	  }; // Return negative clone of `this`


	  BN.prototype.neg = function neg() {
	    return this.clone().ineg();
	  };

	  BN.prototype.ineg = function ineg() {
	    if (!this.isZero()) {
	      this.negative ^= 1;
	    }

	    return this;
	  }; // Or `num` with `this` in-place


	  BN.prototype.iuor = function iuor(num) {
	    while (this.length < num.length) {
	      this.words[this.length++] = 0;
	    }

	    for (var i = 0; i < num.length; i++) {
	      this.words[i] = this.words[i] | num.words[i];
	    }

	    return this._strip();
	  };

	  BN.prototype.ior = function ior(num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuor(num);
	  }; // Or `num` with `this`


	  BN.prototype.or = function or(num) {
	    if (this.length > num.length) return this.clone().ior(num);
	    return num.clone().ior(this);
	  };

	  BN.prototype.uor = function uor(num) {
	    if (this.length > num.length) return this.clone().iuor(num);
	    return num.clone().iuor(this);
	  }; // And `num` with `this` in-place


	  BN.prototype.iuand = function iuand(num) {
	    // b = min-length(num, this)
	    var b;

	    if (this.length > num.length) {
	      b = num;
	    } else {
	      b = this;
	    }

	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = this.words[i] & num.words[i];
	    }

	    this.length = b.length;
	    return this._strip();
	  };

	  BN.prototype.iand = function iand(num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuand(num);
	  }; // And `num` with `this`


	  BN.prototype.and = function and(num) {
	    if (this.length > num.length) return this.clone().iand(num);
	    return num.clone().iand(this);
	  };

	  BN.prototype.uand = function uand(num) {
	    if (this.length > num.length) return this.clone().iuand(num);
	    return num.clone().iuand(this);
	  }; // Xor `num` with `this` in-place


	  BN.prototype.iuxor = function iuxor(num) {
	    // a.length > b.length
	    var a;
	    var b;

	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }

	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = a.words[i] ^ b.words[i];
	    }

	    if (this !== a) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }

	    this.length = a.length;
	    return this._strip();
	  };

	  BN.prototype.ixor = function ixor(num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuxor(num);
	  }; // Xor `num` with `this`


	  BN.prototype.xor = function xor(num) {
	    if (this.length > num.length) return this.clone().ixor(num);
	    return num.clone().ixor(this);
	  };

	  BN.prototype.uxor = function uxor(num) {
	    if (this.length > num.length) return this.clone().iuxor(num);
	    return num.clone().iuxor(this);
	  }; // Not ``this`` with ``width`` bitwidth


	  BN.prototype.inotn = function inotn(width) {
	    assert(typeof width === 'number' && width >= 0);
	    var bytesNeeded = Math.ceil(width / 26) | 0;
	    var bitsLeft = width % 26; // Extend the buffer with leading zeroes

	    this._expand(bytesNeeded);

	    if (bitsLeft > 0) {
	      bytesNeeded--;
	    } // Handle complete words


	    for (var i = 0; i < bytesNeeded; i++) {
	      this.words[i] = ~this.words[i] & 0x3ffffff;
	    } // Handle the residue


	    if (bitsLeft > 0) {
	      this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
	    } // And remove leading zeroes


	    return this._strip();
	  };

	  BN.prototype.notn = function notn(width) {
	    return this.clone().inotn(width);
	  }; // Set `bit` of `this`


	  BN.prototype.setn = function setn(bit, val) {
	    assert(typeof bit === 'number' && bit >= 0);
	    var off = bit / 26 | 0;
	    var wbit = bit % 26;

	    this._expand(off + 1);

	    if (val) {
	      this.words[off] = this.words[off] | 1 << wbit;
	    } else {
	      this.words[off] = this.words[off] & ~(1 << wbit);
	    }

	    return this._strip();
	  }; // Add `num` to `this` in-place


	  BN.prototype.iadd = function iadd(num) {
	    var r; // negative + positive

	    if (this.negative !== 0 && num.negative === 0) {
	      this.negative = 0;
	      r = this.isub(num);
	      this.negative ^= 1;
	      return this._normSign(); // positive + negative
	    } else if (this.negative === 0 && num.negative !== 0) {
	      num.negative = 0;
	      r = this.isub(num);
	      num.negative = 1;
	      return r._normSign();
	    } // a.length > b.length


	    var a, b;

	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }

	    var carry = 0;

	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }

	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }

	    this.length = a.length;

	    if (carry !== 0) {
	      this.words[this.length] = carry;
	      this.length++; // Copy the rest of the words
	    } else if (a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }

	    return this;
	  }; // Add `num` to `this`


	  BN.prototype.add = function add(num) {
	    var res;

	    if (num.negative !== 0 && this.negative === 0) {
	      num.negative = 0;
	      res = this.sub(num);
	      num.negative ^= 1;
	      return res;
	    } else if (num.negative === 0 && this.negative !== 0) {
	      this.negative = 0;
	      res = num.sub(this);
	      this.negative = 1;
	      return res;
	    }

	    if (this.length > num.length) return this.clone().iadd(num);
	    return num.clone().iadd(this);
	  }; // Subtract `num` from `this` in-place


	  BN.prototype.isub = function isub(num) {
	    // this - (-num) = this + num
	    if (num.negative !== 0) {
	      num.negative = 0;
	      var r = this.iadd(num);
	      num.negative = 1;
	      return r._normSign(); // -this - num = -(this + num)
	    } else if (this.negative !== 0) {
	      this.negative = 0;
	      this.iadd(num);
	      this.negative = 1;
	      return this._normSign();
	    } // At this point both numbers are positive


	    var cmp = this.cmp(num); // Optimization - zeroify

	    if (cmp === 0) {
	      this.negative = 0;
	      this.length = 1;
	      this.words[0] = 0;
	      return this;
	    } // a > b


	    var a, b;

	    if (cmp > 0) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }

	    var carry = 0;

	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }

	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    } // Copy rest of the words


	    if (carry === 0 && i < a.length && a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }

	    this.length = Math.max(this.length, i);

	    if (a !== this) {
	      this.negative = 1;
	    }

	    return this._strip();
	  }; // Subtract `num` from `this`


	  BN.prototype.sub = function sub(num) {
	    return this.clone().isub(num);
	  };

	  function smallMulTo(self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    var len = self.length + num.length | 0;
	    out.length = len;
	    len = len - 1 | 0; // Peel one iteration (compiler can't do it, because of code complexity)

	    var a = self.words[0] | 0;
	    var b = num.words[0] | 0;
	    var r = a * b;
	    var lo = r & 0x3ffffff;
	    var carry = r / 0x4000000 | 0;
	    out.words[0] = lo;

	    for (var k = 1; k < len; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = carry >>> 26;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);

	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = k - j | 0;
	        a = self.words[i] | 0;
	        b = num.words[j] | 0;
	        r = a * b + rword;
	        ncarry += r / 0x4000000 | 0;
	        rword = r & 0x3ffffff;
	      }

	      out.words[k] = rword | 0;
	      carry = ncarry | 0;
	    }

	    if (carry !== 0) {
	      out.words[k] = carry | 0;
	    } else {
	      out.length--;
	    }

	    return out._strip();
	  } // TODO(indutny): it may be reasonable to omit it for users who don't need
	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
	  // multiplication (like elliptic secp256k1).


	  var comb10MulTo = function comb10MulTo(self, num, out) {
	    var a = self.words;
	    var b = num.words;
	    var o = out.words;
	    var c = 0;
	    var lo;
	    var mid;
	    var hi;
	    var a0 = a[0] | 0;
	    var al0 = a0 & 0x1fff;
	    var ah0 = a0 >>> 13;
	    var a1 = a[1] | 0;
	    var al1 = a1 & 0x1fff;
	    var ah1 = a1 >>> 13;
	    var a2 = a[2] | 0;
	    var al2 = a2 & 0x1fff;
	    var ah2 = a2 >>> 13;
	    var a3 = a[3] | 0;
	    var al3 = a3 & 0x1fff;
	    var ah3 = a3 >>> 13;
	    var a4 = a[4] | 0;
	    var al4 = a4 & 0x1fff;
	    var ah4 = a4 >>> 13;
	    var a5 = a[5] | 0;
	    var al5 = a5 & 0x1fff;
	    var ah5 = a5 >>> 13;
	    var a6 = a[6] | 0;
	    var al6 = a6 & 0x1fff;
	    var ah6 = a6 >>> 13;
	    var a7 = a[7] | 0;
	    var al7 = a7 & 0x1fff;
	    var ah7 = a7 >>> 13;
	    var a8 = a[8] | 0;
	    var al8 = a8 & 0x1fff;
	    var ah8 = a8 >>> 13;
	    var a9 = a[9] | 0;
	    var al9 = a9 & 0x1fff;
	    var ah9 = a9 >>> 13;
	    var b0 = b[0] | 0;
	    var bl0 = b0 & 0x1fff;
	    var bh0 = b0 >>> 13;
	    var b1 = b[1] | 0;
	    var bl1 = b1 & 0x1fff;
	    var bh1 = b1 >>> 13;
	    var b2 = b[2] | 0;
	    var bl2 = b2 & 0x1fff;
	    var bh2 = b2 >>> 13;
	    var b3 = b[3] | 0;
	    var bl3 = b3 & 0x1fff;
	    var bh3 = b3 >>> 13;
	    var b4 = b[4] | 0;
	    var bl4 = b4 & 0x1fff;
	    var bh4 = b4 >>> 13;
	    var b5 = b[5] | 0;
	    var bl5 = b5 & 0x1fff;
	    var bh5 = b5 >>> 13;
	    var b6 = b[6] | 0;
	    var bl6 = b6 & 0x1fff;
	    var bh6 = b6 >>> 13;
	    var b7 = b[7] | 0;
	    var bl7 = b7 & 0x1fff;
	    var bh7 = b7 >>> 13;
	    var b8 = b[8] | 0;
	    var bl8 = b8 & 0x1fff;
	    var bh8 = b8 >>> 13;
	    var b9 = b[9] | 0;
	    var bl9 = b9 & 0x1fff;
	    var bh9 = b9 >>> 13;
	    out.negative = self.negative ^ num.negative;
	    out.length = 19;
	    /* k = 0 */

	    lo = Math.imul(al0, bl0);
	    mid = Math.imul(al0, bh0);
	    mid = mid + Math.imul(ah0, bl0) | 0;
	    hi = Math.imul(ah0, bh0);
	    var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
	    w0 &= 0x3ffffff;
	    /* k = 1 */

	    lo = Math.imul(al1, bl0);
	    mid = Math.imul(al1, bh0);
	    mid = mid + Math.imul(ah1, bl0) | 0;
	    hi = Math.imul(ah1, bh0);
	    lo = lo + Math.imul(al0, bl1) | 0;
	    mid = mid + Math.imul(al0, bh1) | 0;
	    mid = mid + Math.imul(ah0, bl1) | 0;
	    hi = hi + Math.imul(ah0, bh1) | 0;
	    var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
	    w1 &= 0x3ffffff;
	    /* k = 2 */

	    lo = Math.imul(al2, bl0);
	    mid = Math.imul(al2, bh0);
	    mid = mid + Math.imul(ah2, bl0) | 0;
	    hi = Math.imul(ah2, bh0);
	    lo = lo + Math.imul(al1, bl1) | 0;
	    mid = mid + Math.imul(al1, bh1) | 0;
	    mid = mid + Math.imul(ah1, bl1) | 0;
	    hi = hi + Math.imul(ah1, bh1) | 0;
	    lo = lo + Math.imul(al0, bl2) | 0;
	    mid = mid + Math.imul(al0, bh2) | 0;
	    mid = mid + Math.imul(ah0, bl2) | 0;
	    hi = hi + Math.imul(ah0, bh2) | 0;
	    var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
	    w2 &= 0x3ffffff;
	    /* k = 3 */

	    lo = Math.imul(al3, bl0);
	    mid = Math.imul(al3, bh0);
	    mid = mid + Math.imul(ah3, bl0) | 0;
	    hi = Math.imul(ah3, bh0);
	    lo = lo + Math.imul(al2, bl1) | 0;
	    mid = mid + Math.imul(al2, bh1) | 0;
	    mid = mid + Math.imul(ah2, bl1) | 0;
	    hi = hi + Math.imul(ah2, bh1) | 0;
	    lo = lo + Math.imul(al1, bl2) | 0;
	    mid = mid + Math.imul(al1, bh2) | 0;
	    mid = mid + Math.imul(ah1, bl2) | 0;
	    hi = hi + Math.imul(ah1, bh2) | 0;
	    lo = lo + Math.imul(al0, bl3) | 0;
	    mid = mid + Math.imul(al0, bh3) | 0;
	    mid = mid + Math.imul(ah0, bl3) | 0;
	    hi = hi + Math.imul(ah0, bh3) | 0;
	    var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
	    w3 &= 0x3ffffff;
	    /* k = 4 */

	    lo = Math.imul(al4, bl0);
	    mid = Math.imul(al4, bh0);
	    mid = mid + Math.imul(ah4, bl0) | 0;
	    hi = Math.imul(ah4, bh0);
	    lo = lo + Math.imul(al3, bl1) | 0;
	    mid = mid + Math.imul(al3, bh1) | 0;
	    mid = mid + Math.imul(ah3, bl1) | 0;
	    hi = hi + Math.imul(ah3, bh1) | 0;
	    lo = lo + Math.imul(al2, bl2) | 0;
	    mid = mid + Math.imul(al2, bh2) | 0;
	    mid = mid + Math.imul(ah2, bl2) | 0;
	    hi = hi + Math.imul(ah2, bh2) | 0;
	    lo = lo + Math.imul(al1, bl3) | 0;
	    mid = mid + Math.imul(al1, bh3) | 0;
	    mid = mid + Math.imul(ah1, bl3) | 0;
	    hi = hi + Math.imul(ah1, bh3) | 0;
	    lo = lo + Math.imul(al0, bl4) | 0;
	    mid = mid + Math.imul(al0, bh4) | 0;
	    mid = mid + Math.imul(ah0, bl4) | 0;
	    hi = hi + Math.imul(ah0, bh4) | 0;
	    var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
	    w4 &= 0x3ffffff;
	    /* k = 5 */

	    lo = Math.imul(al5, bl0);
	    mid = Math.imul(al5, bh0);
	    mid = mid + Math.imul(ah5, bl0) | 0;
	    hi = Math.imul(ah5, bh0);
	    lo = lo + Math.imul(al4, bl1) | 0;
	    mid = mid + Math.imul(al4, bh1) | 0;
	    mid = mid + Math.imul(ah4, bl1) | 0;
	    hi = hi + Math.imul(ah4, bh1) | 0;
	    lo = lo + Math.imul(al3, bl2) | 0;
	    mid = mid + Math.imul(al3, bh2) | 0;
	    mid = mid + Math.imul(ah3, bl2) | 0;
	    hi = hi + Math.imul(ah3, bh2) | 0;
	    lo = lo + Math.imul(al2, bl3) | 0;
	    mid = mid + Math.imul(al2, bh3) | 0;
	    mid = mid + Math.imul(ah2, bl3) | 0;
	    hi = hi + Math.imul(ah2, bh3) | 0;
	    lo = lo + Math.imul(al1, bl4) | 0;
	    mid = mid + Math.imul(al1, bh4) | 0;
	    mid = mid + Math.imul(ah1, bl4) | 0;
	    hi = hi + Math.imul(ah1, bh4) | 0;
	    lo = lo + Math.imul(al0, bl5) | 0;
	    mid = mid + Math.imul(al0, bh5) | 0;
	    mid = mid + Math.imul(ah0, bl5) | 0;
	    hi = hi + Math.imul(ah0, bh5) | 0;
	    var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
	    w5 &= 0x3ffffff;
	    /* k = 6 */

	    lo = Math.imul(al6, bl0);
	    mid = Math.imul(al6, bh0);
	    mid = mid + Math.imul(ah6, bl0) | 0;
	    hi = Math.imul(ah6, bh0);
	    lo = lo + Math.imul(al5, bl1) | 0;
	    mid = mid + Math.imul(al5, bh1) | 0;
	    mid = mid + Math.imul(ah5, bl1) | 0;
	    hi = hi + Math.imul(ah5, bh1) | 0;
	    lo = lo + Math.imul(al4, bl2) | 0;
	    mid = mid + Math.imul(al4, bh2) | 0;
	    mid = mid + Math.imul(ah4, bl2) | 0;
	    hi = hi + Math.imul(ah4, bh2) | 0;
	    lo = lo + Math.imul(al3, bl3) | 0;
	    mid = mid + Math.imul(al3, bh3) | 0;
	    mid = mid + Math.imul(ah3, bl3) | 0;
	    hi = hi + Math.imul(ah3, bh3) | 0;
	    lo = lo + Math.imul(al2, bl4) | 0;
	    mid = mid + Math.imul(al2, bh4) | 0;
	    mid = mid + Math.imul(ah2, bl4) | 0;
	    hi = hi + Math.imul(ah2, bh4) | 0;
	    lo = lo + Math.imul(al1, bl5) | 0;
	    mid = mid + Math.imul(al1, bh5) | 0;
	    mid = mid + Math.imul(ah1, bl5) | 0;
	    hi = hi + Math.imul(ah1, bh5) | 0;
	    lo = lo + Math.imul(al0, bl6) | 0;
	    mid = mid + Math.imul(al0, bh6) | 0;
	    mid = mid + Math.imul(ah0, bl6) | 0;
	    hi = hi + Math.imul(ah0, bh6) | 0;
	    var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
	    w6 &= 0x3ffffff;
	    /* k = 7 */

	    lo = Math.imul(al7, bl0);
	    mid = Math.imul(al7, bh0);
	    mid = mid + Math.imul(ah7, bl0) | 0;
	    hi = Math.imul(ah7, bh0);
	    lo = lo + Math.imul(al6, bl1) | 0;
	    mid = mid + Math.imul(al6, bh1) | 0;
	    mid = mid + Math.imul(ah6, bl1) | 0;
	    hi = hi + Math.imul(ah6, bh1) | 0;
	    lo = lo + Math.imul(al5, bl2) | 0;
	    mid = mid + Math.imul(al5, bh2) | 0;
	    mid = mid + Math.imul(ah5, bl2) | 0;
	    hi = hi + Math.imul(ah5, bh2) | 0;
	    lo = lo + Math.imul(al4, bl3) | 0;
	    mid = mid + Math.imul(al4, bh3) | 0;
	    mid = mid + Math.imul(ah4, bl3) | 0;
	    hi = hi + Math.imul(ah4, bh3) | 0;
	    lo = lo + Math.imul(al3, bl4) | 0;
	    mid = mid + Math.imul(al3, bh4) | 0;
	    mid = mid + Math.imul(ah3, bl4) | 0;
	    hi = hi + Math.imul(ah3, bh4) | 0;
	    lo = lo + Math.imul(al2, bl5) | 0;
	    mid = mid + Math.imul(al2, bh5) | 0;
	    mid = mid + Math.imul(ah2, bl5) | 0;
	    hi = hi + Math.imul(ah2, bh5) | 0;
	    lo = lo + Math.imul(al1, bl6) | 0;
	    mid = mid + Math.imul(al1, bh6) | 0;
	    mid = mid + Math.imul(ah1, bl6) | 0;
	    hi = hi + Math.imul(ah1, bh6) | 0;
	    lo = lo + Math.imul(al0, bl7) | 0;
	    mid = mid + Math.imul(al0, bh7) | 0;
	    mid = mid + Math.imul(ah0, bl7) | 0;
	    hi = hi + Math.imul(ah0, bh7) | 0;
	    var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
	    w7 &= 0x3ffffff;
	    /* k = 8 */

	    lo = Math.imul(al8, bl0);
	    mid = Math.imul(al8, bh0);
	    mid = mid + Math.imul(ah8, bl0) | 0;
	    hi = Math.imul(ah8, bh0);
	    lo = lo + Math.imul(al7, bl1) | 0;
	    mid = mid + Math.imul(al7, bh1) | 0;
	    mid = mid + Math.imul(ah7, bl1) | 0;
	    hi = hi + Math.imul(ah7, bh1) | 0;
	    lo = lo + Math.imul(al6, bl2) | 0;
	    mid = mid + Math.imul(al6, bh2) | 0;
	    mid = mid + Math.imul(ah6, bl2) | 0;
	    hi = hi + Math.imul(ah6, bh2) | 0;
	    lo = lo + Math.imul(al5, bl3) | 0;
	    mid = mid + Math.imul(al5, bh3) | 0;
	    mid = mid + Math.imul(ah5, bl3) | 0;
	    hi = hi + Math.imul(ah5, bh3) | 0;
	    lo = lo + Math.imul(al4, bl4) | 0;
	    mid = mid + Math.imul(al4, bh4) | 0;
	    mid = mid + Math.imul(ah4, bl4) | 0;
	    hi = hi + Math.imul(ah4, bh4) | 0;
	    lo = lo + Math.imul(al3, bl5) | 0;
	    mid = mid + Math.imul(al3, bh5) | 0;
	    mid = mid + Math.imul(ah3, bl5) | 0;
	    hi = hi + Math.imul(ah3, bh5) | 0;
	    lo = lo + Math.imul(al2, bl6) | 0;
	    mid = mid + Math.imul(al2, bh6) | 0;
	    mid = mid + Math.imul(ah2, bl6) | 0;
	    hi = hi + Math.imul(ah2, bh6) | 0;
	    lo = lo + Math.imul(al1, bl7) | 0;
	    mid = mid + Math.imul(al1, bh7) | 0;
	    mid = mid + Math.imul(ah1, bl7) | 0;
	    hi = hi + Math.imul(ah1, bh7) | 0;
	    lo = lo + Math.imul(al0, bl8) | 0;
	    mid = mid + Math.imul(al0, bh8) | 0;
	    mid = mid + Math.imul(ah0, bl8) | 0;
	    hi = hi + Math.imul(ah0, bh8) | 0;
	    var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
	    w8 &= 0x3ffffff;
	    /* k = 9 */

	    lo = Math.imul(al9, bl0);
	    mid = Math.imul(al9, bh0);
	    mid = mid + Math.imul(ah9, bl0) | 0;
	    hi = Math.imul(ah9, bh0);
	    lo = lo + Math.imul(al8, bl1) | 0;
	    mid = mid + Math.imul(al8, bh1) | 0;
	    mid = mid + Math.imul(ah8, bl1) | 0;
	    hi = hi + Math.imul(ah8, bh1) | 0;
	    lo = lo + Math.imul(al7, bl2) | 0;
	    mid = mid + Math.imul(al7, bh2) | 0;
	    mid = mid + Math.imul(ah7, bl2) | 0;
	    hi = hi + Math.imul(ah7, bh2) | 0;
	    lo = lo + Math.imul(al6, bl3) | 0;
	    mid = mid + Math.imul(al6, bh3) | 0;
	    mid = mid + Math.imul(ah6, bl3) | 0;
	    hi = hi + Math.imul(ah6, bh3) | 0;
	    lo = lo + Math.imul(al5, bl4) | 0;
	    mid = mid + Math.imul(al5, bh4) | 0;
	    mid = mid + Math.imul(ah5, bl4) | 0;
	    hi = hi + Math.imul(ah5, bh4) | 0;
	    lo = lo + Math.imul(al4, bl5) | 0;
	    mid = mid + Math.imul(al4, bh5) | 0;
	    mid = mid + Math.imul(ah4, bl5) | 0;
	    hi = hi + Math.imul(ah4, bh5) | 0;
	    lo = lo + Math.imul(al3, bl6) | 0;
	    mid = mid + Math.imul(al3, bh6) | 0;
	    mid = mid + Math.imul(ah3, bl6) | 0;
	    hi = hi + Math.imul(ah3, bh6) | 0;
	    lo = lo + Math.imul(al2, bl7) | 0;
	    mid = mid + Math.imul(al2, bh7) | 0;
	    mid = mid + Math.imul(ah2, bl7) | 0;
	    hi = hi + Math.imul(ah2, bh7) | 0;
	    lo = lo + Math.imul(al1, bl8) | 0;
	    mid = mid + Math.imul(al1, bh8) | 0;
	    mid = mid + Math.imul(ah1, bl8) | 0;
	    hi = hi + Math.imul(ah1, bh8) | 0;
	    lo = lo + Math.imul(al0, bl9) | 0;
	    mid = mid + Math.imul(al0, bh9) | 0;
	    mid = mid + Math.imul(ah0, bl9) | 0;
	    hi = hi + Math.imul(ah0, bh9) | 0;
	    var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
	    w9 &= 0x3ffffff;
	    /* k = 10 */

	    lo = Math.imul(al9, bl1);
	    mid = Math.imul(al9, bh1);
	    mid = mid + Math.imul(ah9, bl1) | 0;
	    hi = Math.imul(ah9, bh1);
	    lo = lo + Math.imul(al8, bl2) | 0;
	    mid = mid + Math.imul(al8, bh2) | 0;
	    mid = mid + Math.imul(ah8, bl2) | 0;
	    hi = hi + Math.imul(ah8, bh2) | 0;
	    lo = lo + Math.imul(al7, bl3) | 0;
	    mid = mid + Math.imul(al7, bh3) | 0;
	    mid = mid + Math.imul(ah7, bl3) | 0;
	    hi = hi + Math.imul(ah7, bh3) | 0;
	    lo = lo + Math.imul(al6, bl4) | 0;
	    mid = mid + Math.imul(al6, bh4) | 0;
	    mid = mid + Math.imul(ah6, bl4) | 0;
	    hi = hi + Math.imul(ah6, bh4) | 0;
	    lo = lo + Math.imul(al5, bl5) | 0;
	    mid = mid + Math.imul(al5, bh5) | 0;
	    mid = mid + Math.imul(ah5, bl5) | 0;
	    hi = hi + Math.imul(ah5, bh5) | 0;
	    lo = lo + Math.imul(al4, bl6) | 0;
	    mid = mid + Math.imul(al4, bh6) | 0;
	    mid = mid + Math.imul(ah4, bl6) | 0;
	    hi = hi + Math.imul(ah4, bh6) | 0;
	    lo = lo + Math.imul(al3, bl7) | 0;
	    mid = mid + Math.imul(al3, bh7) | 0;
	    mid = mid + Math.imul(ah3, bl7) | 0;
	    hi = hi + Math.imul(ah3, bh7) | 0;
	    lo = lo + Math.imul(al2, bl8) | 0;
	    mid = mid + Math.imul(al2, bh8) | 0;
	    mid = mid + Math.imul(ah2, bl8) | 0;
	    hi = hi + Math.imul(ah2, bh8) | 0;
	    lo = lo + Math.imul(al1, bl9) | 0;
	    mid = mid + Math.imul(al1, bh9) | 0;
	    mid = mid + Math.imul(ah1, bl9) | 0;
	    hi = hi + Math.imul(ah1, bh9) | 0;
	    var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
	    w10 &= 0x3ffffff;
	    /* k = 11 */

	    lo = Math.imul(al9, bl2);
	    mid = Math.imul(al9, bh2);
	    mid = mid + Math.imul(ah9, bl2) | 0;
	    hi = Math.imul(ah9, bh2);
	    lo = lo + Math.imul(al8, bl3) | 0;
	    mid = mid + Math.imul(al8, bh3) | 0;
	    mid = mid + Math.imul(ah8, bl3) | 0;
	    hi = hi + Math.imul(ah8, bh3) | 0;
	    lo = lo + Math.imul(al7, bl4) | 0;
	    mid = mid + Math.imul(al7, bh4) | 0;
	    mid = mid + Math.imul(ah7, bl4) | 0;
	    hi = hi + Math.imul(ah7, bh4) | 0;
	    lo = lo + Math.imul(al6, bl5) | 0;
	    mid = mid + Math.imul(al6, bh5) | 0;
	    mid = mid + Math.imul(ah6, bl5) | 0;
	    hi = hi + Math.imul(ah6, bh5) | 0;
	    lo = lo + Math.imul(al5, bl6) | 0;
	    mid = mid + Math.imul(al5, bh6) | 0;
	    mid = mid + Math.imul(ah5, bl6) | 0;
	    hi = hi + Math.imul(ah5, bh6) | 0;
	    lo = lo + Math.imul(al4, bl7) | 0;
	    mid = mid + Math.imul(al4, bh7) | 0;
	    mid = mid + Math.imul(ah4, bl7) | 0;
	    hi = hi + Math.imul(ah4, bh7) | 0;
	    lo = lo + Math.imul(al3, bl8) | 0;
	    mid = mid + Math.imul(al3, bh8) | 0;
	    mid = mid + Math.imul(ah3, bl8) | 0;
	    hi = hi + Math.imul(ah3, bh8) | 0;
	    lo = lo + Math.imul(al2, bl9) | 0;
	    mid = mid + Math.imul(al2, bh9) | 0;
	    mid = mid + Math.imul(ah2, bl9) | 0;
	    hi = hi + Math.imul(ah2, bh9) | 0;
	    var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
	    w11 &= 0x3ffffff;
	    /* k = 12 */

	    lo = Math.imul(al9, bl3);
	    mid = Math.imul(al9, bh3);
	    mid = mid + Math.imul(ah9, bl3) | 0;
	    hi = Math.imul(ah9, bh3);
	    lo = lo + Math.imul(al8, bl4) | 0;
	    mid = mid + Math.imul(al8, bh4) | 0;
	    mid = mid + Math.imul(ah8, bl4) | 0;
	    hi = hi + Math.imul(ah8, bh4) | 0;
	    lo = lo + Math.imul(al7, bl5) | 0;
	    mid = mid + Math.imul(al7, bh5) | 0;
	    mid = mid + Math.imul(ah7, bl5) | 0;
	    hi = hi + Math.imul(ah7, bh5) | 0;
	    lo = lo + Math.imul(al6, bl6) | 0;
	    mid = mid + Math.imul(al6, bh6) | 0;
	    mid = mid + Math.imul(ah6, bl6) | 0;
	    hi = hi + Math.imul(ah6, bh6) | 0;
	    lo = lo + Math.imul(al5, bl7) | 0;
	    mid = mid + Math.imul(al5, bh7) | 0;
	    mid = mid + Math.imul(ah5, bl7) | 0;
	    hi = hi + Math.imul(ah5, bh7) | 0;
	    lo = lo + Math.imul(al4, bl8) | 0;
	    mid = mid + Math.imul(al4, bh8) | 0;
	    mid = mid + Math.imul(ah4, bl8) | 0;
	    hi = hi + Math.imul(ah4, bh8) | 0;
	    lo = lo + Math.imul(al3, bl9) | 0;
	    mid = mid + Math.imul(al3, bh9) | 0;
	    mid = mid + Math.imul(ah3, bl9) | 0;
	    hi = hi + Math.imul(ah3, bh9) | 0;
	    var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
	    w12 &= 0x3ffffff;
	    /* k = 13 */

	    lo = Math.imul(al9, bl4);
	    mid = Math.imul(al9, bh4);
	    mid = mid + Math.imul(ah9, bl4) | 0;
	    hi = Math.imul(ah9, bh4);
	    lo = lo + Math.imul(al8, bl5) | 0;
	    mid = mid + Math.imul(al8, bh5) | 0;
	    mid = mid + Math.imul(ah8, bl5) | 0;
	    hi = hi + Math.imul(ah8, bh5) | 0;
	    lo = lo + Math.imul(al7, bl6) | 0;
	    mid = mid + Math.imul(al7, bh6) | 0;
	    mid = mid + Math.imul(ah7, bl6) | 0;
	    hi = hi + Math.imul(ah7, bh6) | 0;
	    lo = lo + Math.imul(al6, bl7) | 0;
	    mid = mid + Math.imul(al6, bh7) | 0;
	    mid = mid + Math.imul(ah6, bl7) | 0;
	    hi = hi + Math.imul(ah6, bh7) | 0;
	    lo = lo + Math.imul(al5, bl8) | 0;
	    mid = mid + Math.imul(al5, bh8) | 0;
	    mid = mid + Math.imul(ah5, bl8) | 0;
	    hi = hi + Math.imul(ah5, bh8) | 0;
	    lo = lo + Math.imul(al4, bl9) | 0;
	    mid = mid + Math.imul(al4, bh9) | 0;
	    mid = mid + Math.imul(ah4, bl9) | 0;
	    hi = hi + Math.imul(ah4, bh9) | 0;
	    var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
	    w13 &= 0x3ffffff;
	    /* k = 14 */

	    lo = Math.imul(al9, bl5);
	    mid = Math.imul(al9, bh5);
	    mid = mid + Math.imul(ah9, bl5) | 0;
	    hi = Math.imul(ah9, bh5);
	    lo = lo + Math.imul(al8, bl6) | 0;
	    mid = mid + Math.imul(al8, bh6) | 0;
	    mid = mid + Math.imul(ah8, bl6) | 0;
	    hi = hi + Math.imul(ah8, bh6) | 0;
	    lo = lo + Math.imul(al7, bl7) | 0;
	    mid = mid + Math.imul(al7, bh7) | 0;
	    mid = mid + Math.imul(ah7, bl7) | 0;
	    hi = hi + Math.imul(ah7, bh7) | 0;
	    lo = lo + Math.imul(al6, bl8) | 0;
	    mid = mid + Math.imul(al6, bh8) | 0;
	    mid = mid + Math.imul(ah6, bl8) | 0;
	    hi = hi + Math.imul(ah6, bh8) | 0;
	    lo = lo + Math.imul(al5, bl9) | 0;
	    mid = mid + Math.imul(al5, bh9) | 0;
	    mid = mid + Math.imul(ah5, bl9) | 0;
	    hi = hi + Math.imul(ah5, bh9) | 0;
	    var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
	    w14 &= 0x3ffffff;
	    /* k = 15 */

	    lo = Math.imul(al9, bl6);
	    mid = Math.imul(al9, bh6);
	    mid = mid + Math.imul(ah9, bl6) | 0;
	    hi = Math.imul(ah9, bh6);
	    lo = lo + Math.imul(al8, bl7) | 0;
	    mid = mid + Math.imul(al8, bh7) | 0;
	    mid = mid + Math.imul(ah8, bl7) | 0;
	    hi = hi + Math.imul(ah8, bh7) | 0;
	    lo = lo + Math.imul(al7, bl8) | 0;
	    mid = mid + Math.imul(al7, bh8) | 0;
	    mid = mid + Math.imul(ah7, bl8) | 0;
	    hi = hi + Math.imul(ah7, bh8) | 0;
	    lo = lo + Math.imul(al6, bl9) | 0;
	    mid = mid + Math.imul(al6, bh9) | 0;
	    mid = mid + Math.imul(ah6, bl9) | 0;
	    hi = hi + Math.imul(ah6, bh9) | 0;
	    var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
	    w15 &= 0x3ffffff;
	    /* k = 16 */

	    lo = Math.imul(al9, bl7);
	    mid = Math.imul(al9, bh7);
	    mid = mid + Math.imul(ah9, bl7) | 0;
	    hi = Math.imul(ah9, bh7);
	    lo = lo + Math.imul(al8, bl8) | 0;
	    mid = mid + Math.imul(al8, bh8) | 0;
	    mid = mid + Math.imul(ah8, bl8) | 0;
	    hi = hi + Math.imul(ah8, bh8) | 0;
	    lo = lo + Math.imul(al7, bl9) | 0;
	    mid = mid + Math.imul(al7, bh9) | 0;
	    mid = mid + Math.imul(ah7, bl9) | 0;
	    hi = hi + Math.imul(ah7, bh9) | 0;
	    var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
	    w16 &= 0x3ffffff;
	    /* k = 17 */

	    lo = Math.imul(al9, bl8);
	    mid = Math.imul(al9, bh8);
	    mid = mid + Math.imul(ah9, bl8) | 0;
	    hi = Math.imul(ah9, bh8);
	    lo = lo + Math.imul(al8, bl9) | 0;
	    mid = mid + Math.imul(al8, bh9) | 0;
	    mid = mid + Math.imul(ah8, bl9) | 0;
	    hi = hi + Math.imul(ah8, bh9) | 0;
	    var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
	    w17 &= 0x3ffffff;
	    /* k = 18 */

	    lo = Math.imul(al9, bl9);
	    mid = Math.imul(al9, bh9);
	    mid = mid + Math.imul(ah9, bl9) | 0;
	    hi = Math.imul(ah9, bh9);
	    var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
	    c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
	    w18 &= 0x3ffffff;
	    o[0] = w0;
	    o[1] = w1;
	    o[2] = w2;
	    o[3] = w3;
	    o[4] = w4;
	    o[5] = w5;
	    o[6] = w6;
	    o[7] = w7;
	    o[8] = w8;
	    o[9] = w9;
	    o[10] = w10;
	    o[11] = w11;
	    o[12] = w12;
	    o[13] = w13;
	    o[14] = w14;
	    o[15] = w15;
	    o[16] = w16;
	    o[17] = w17;
	    o[18] = w18;

	    if (c !== 0) {
	      o[19] = c;
	      out.length++;
	    }

	    return out;
	  }; // Polyfill comb


	  if (!Math.imul) {
	    comb10MulTo = smallMulTo;
	  }

	  function bigMulTo(self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    out.length = self.length + num.length;
	    var carry = 0;
	    var hncarry = 0;

	    for (var k = 0; k < out.length - 1; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = hncarry;
	      hncarry = 0;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);

	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = k - j;
	        var a = self.words[i] | 0;
	        var b = num.words[j] | 0;
	        var r = a * b;
	        var lo = r & 0x3ffffff;
	        ncarry = ncarry + (r / 0x4000000 | 0) | 0;
	        lo = lo + rword | 0;
	        rword = lo & 0x3ffffff;
	        ncarry = ncarry + (lo >>> 26) | 0;
	        hncarry += ncarry >>> 26;
	        ncarry &= 0x3ffffff;
	      }

	      out.words[k] = rword;
	      carry = ncarry;
	      ncarry = hncarry;
	    }

	    if (carry !== 0) {
	      out.words[k] = carry;
	    } else {
	      out.length--;
	    }

	    return out._strip();
	  }

	  function jumboMulTo(self, num, out) {
	    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
	    // var fftm = new FFTM();
	    // return fftm.mulp(self, num, out);
	    return bigMulTo(self, num, out);
	  }

	  BN.prototype.mulTo = function mulTo(num, out) {
	    var res;
	    var len = this.length + num.length;

	    if (this.length === 10 && num.length === 10) {
	      res = comb10MulTo(this, num, out);
	    } else if (len < 63) {
	      res = smallMulTo(this, num, out);
	    } else if (len < 1024) {
	      res = bigMulTo(this, num, out);
	    } else {
	      res = jumboMulTo(this, num, out);
	    }

	    return res;
	  }; // Cooley-Tukey algorithm for FFT


	  BN.prototype.mul = function mul(num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return this.mulTo(num, out);
	  }; // Multiply employing FFT


	  BN.prototype.mulf = function mulf(num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return jumboMulTo(this, num, out);
	  }; // In-place Multiplication


	  BN.prototype.imul = function imul(num) {
	    return this.clone().mulTo(num, this);
	  };

	  BN.prototype.imuln = function imuln(num) {
	    var isNegNum = num < 0;
	    if (isNegNum) num = -num;
	    assert(typeof num === 'number');
	    assert(num < 0x4000000); // Carry

	    var carry = 0;

	    for (var i = 0; i < this.length; i++) {
	      var w = (this.words[i] | 0) * num;
	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
	      carry >>= 26;
	      carry += w / 0x4000000 | 0; // NOTE: lo is 27bit maximum

	      carry += lo >>> 26;
	      this.words[i] = lo & 0x3ffffff;
	    }

	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }

	    return isNegNum ? this.ineg() : this;
	  };

	  BN.prototype.muln = function muln(num) {
	    return this.clone().imuln(num);
	  }; // `this` * `this`


	  BN.prototype.sqr = function sqr() {
	    return this.mul(this);
	  }; // `this` * `this` in-place


	  BN.prototype.isqr = function isqr() {
	    return this.imul(this.clone());
	  }; // Math.pow(`this`, `num`)


	  BN.prototype.pow = function pow(num) {
	    var w = toBitArray(num);
	    if (w.length === 0) return new BN(1); // Skip leading zeroes

	    var res = this;

	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
	      if (w[i] !== 0) break;
	    }

	    if (++i < w.length) {
	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
	        if (w[i] === 0) continue;
	        res = res.mul(q);
	      }
	    }

	    return res;
	  }; // Shift-left in-place


	  BN.prototype.iushln = function iushln(bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	    var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
	    var i;

	    if (r !== 0) {
	      var carry = 0;

	      for (i = 0; i < this.length; i++) {
	        var newCarry = this.words[i] & carryMask;
	        var c = (this.words[i] | 0) - newCarry << r;
	        this.words[i] = c | carry;
	        carry = newCarry >>> 26 - r;
	      }

	      if (carry) {
	        this.words[i] = carry;
	        this.length++;
	      }
	    }

	    if (s !== 0) {
	      for (i = this.length - 1; i >= 0; i--) {
	        this.words[i + s] = this.words[i];
	      }

	      for (i = 0; i < s; i++) {
	        this.words[i] = 0;
	      }

	      this.length += s;
	    }

	    return this._strip();
	  };

	  BN.prototype.ishln = function ishln(bits) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushln(bits);
	  }; // Shift-right in-place
	  // NOTE: `hint` is a lowest bit before trailing zeroes
	  // NOTE: if `extended` is present - it will be filled with destroyed bits


	  BN.prototype.iushrn = function iushrn(bits, hint, extended) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var h;

	    if (hint) {
	      h = (hint - hint % 26) / 26;
	    } else {
	      h = 0;
	    }

	    var r = bits % 26;
	    var s = Math.min((bits - r) / 26, this.length);
	    var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
	    var maskedWords = extended;
	    h -= s;
	    h = Math.max(0, h); // Extended mode, copy masked part

	    if (maskedWords) {
	      for (var i = 0; i < s; i++) {
	        maskedWords.words[i] = this.words[i];
	      }

	      maskedWords.length = s;
	    }

	    if (s === 0) ; else if (this.length > s) {
	      this.length -= s;

	      for (i = 0; i < this.length; i++) {
	        this.words[i] = this.words[i + s];
	      }
	    } else {
	      this.words[0] = 0;
	      this.length = 1;
	    }

	    var carry = 0;

	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
	      var word = this.words[i] | 0;
	      this.words[i] = carry << 26 - r | word >>> r;
	      carry = word & mask;
	    } // Push carried bits as a mask


	    if (maskedWords && carry !== 0) {
	      maskedWords.words[maskedWords.length++] = carry;
	    }

	    if (this.length === 0) {
	      this.words[0] = 0;
	      this.length = 1;
	    }

	    return this._strip();
	  };

	  BN.prototype.ishrn = function ishrn(bits, hint, extended) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushrn(bits, hint, extended);
	  }; // Shift-left


	  BN.prototype.shln = function shln(bits) {
	    return this.clone().ishln(bits);
	  };

	  BN.prototype.ushln = function ushln(bits) {
	    return this.clone().iushln(bits);
	  }; // Shift-right


	  BN.prototype.shrn = function shrn(bits) {
	    return this.clone().ishrn(bits);
	  };

	  BN.prototype.ushrn = function ushrn(bits) {
	    return this.clone().iushrn(bits);
	  }; // Test if n bit is set


	  BN.prototype.testn = function testn(bit) {
	    assert(typeof bit === 'number' && bit >= 0);
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r; // Fast case: bit is much higher than all existing words

	    if (this.length <= s) return false; // Check bit and return

	    var w = this.words[s];
	    return !!(w & q);
	  }; // Return only lowers bits of number (in-place)


	  BN.prototype.imaskn = function imaskn(bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	    assert(this.negative === 0, 'imaskn works only with positive numbers');

	    if (this.length <= s) {
	      return this;
	    }

	    if (r !== 0) {
	      s++;
	    }

	    this.length = Math.min(s, this.length);

	    if (r !== 0) {
	      var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
	      this.words[this.length - 1] &= mask;
	    }

	    return this._strip();
	  }; // Return only lowers bits of number


	  BN.prototype.maskn = function maskn(bits) {
	    return this.clone().imaskn(bits);
	  }; // Add plain number `num` to `this`


	  BN.prototype.iaddn = function iaddn(num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.isubn(-num); // Possible sign change

	    if (this.negative !== 0) {
	      if (this.length === 1 && (this.words[0] | 0) <= num) {
	        this.words[0] = num - (this.words[0] | 0);
	        this.negative = 0;
	        return this;
	      }

	      this.negative = 0;
	      this.isubn(num);
	      this.negative = 1;
	      return this;
	    } // Add without checks


	    return this._iaddn(num);
	  };

	  BN.prototype._iaddn = function _iaddn(num) {
	    this.words[0] += num; // Carry

	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
	      this.words[i] -= 0x4000000;

	      if (i === this.length - 1) {
	        this.words[i + 1] = 1;
	      } else {
	        this.words[i + 1]++;
	      }
	    }

	    this.length = Math.max(this.length, i + 1);
	    return this;
	  }; // Subtract plain number `num` from `this`


	  BN.prototype.isubn = function isubn(num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.iaddn(-num);

	    if (this.negative !== 0) {
	      this.negative = 0;
	      this.iaddn(num);
	      this.negative = 1;
	      return this;
	    }

	    this.words[0] -= num;

	    if (this.length === 1 && this.words[0] < 0) {
	      this.words[0] = -this.words[0];
	      this.negative = 1;
	    } else {
	      // Carry
	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
	        this.words[i] += 0x4000000;
	        this.words[i + 1] -= 1;
	      }
	    }

	    return this._strip();
	  };

	  BN.prototype.addn = function addn(num) {
	    return this.clone().iaddn(num);
	  };

	  BN.prototype.subn = function subn(num) {
	    return this.clone().isubn(num);
	  };

	  BN.prototype.iabs = function iabs() {
	    this.negative = 0;
	    return this;
	  };

	  BN.prototype.abs = function abs() {
	    return this.clone().iabs();
	  };

	  BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
	    var len = num.length + shift;
	    var i;

	    this._expand(len);

	    var w;
	    var carry = 0;

	    for (i = 0; i < num.length; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      var right = (num.words[i] | 0) * mul;
	      w -= right & 0x3ffffff;
	      carry = (w >> 26) - (right / 0x4000000 | 0);
	      this.words[i + shift] = w & 0x3ffffff;
	    }

	    for (; i < this.length - shift; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      carry = w >> 26;
	      this.words[i + shift] = w & 0x3ffffff;
	    }

	    if (carry === 0) return this._strip(); // Subtraction overflow

	    assert(carry === -1);
	    carry = 0;

	    for (i = 0; i < this.length; i++) {
	      w = -(this.words[i] | 0) + carry;
	      carry = w >> 26;
	      this.words[i] = w & 0x3ffffff;
	    }

	    this.negative = 1;
	    return this._strip();
	  };

	  BN.prototype._wordDiv = function _wordDiv(num, mode) {
	    var shift = this.length - num.length;
	    var a = this.clone();
	    var b = num; // Normalize

	    var bhi = b.words[b.length - 1] | 0;

	    var bhiBits = this._countBits(bhi);

	    shift = 26 - bhiBits;

	    if (shift !== 0) {
	      b = b.ushln(shift);
	      a.iushln(shift);
	      bhi = b.words[b.length - 1] | 0;
	    } // Initialize quotient


	    var m = a.length - b.length;
	    var q;

	    if (mode !== 'mod') {
	      q = new BN(null);
	      q.length = m + 1;
	      q.words = new Array(q.length);

	      for (var i = 0; i < q.length; i++) {
	        q.words[i] = 0;
	      }
	    }

	    var diff = a.clone()._ishlnsubmul(b, 1, m);

	    if (diff.negative === 0) {
	      a = diff;

	      if (q) {
	        q.words[m] = 1;
	      }
	    }

	    for (var j = m - 1; j >= 0; j--) {
	      var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0); // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
	      // (0x7ffffff)

	      qj = Math.min(qj / bhi | 0, 0x3ffffff);

	      a._ishlnsubmul(b, qj, j);

	      while (a.negative !== 0) {
	        qj--;
	        a.negative = 0;

	        a._ishlnsubmul(b, 1, j);

	        if (!a.isZero()) {
	          a.negative ^= 1;
	        }
	      }

	      if (q) {
	        q.words[j] = qj;
	      }
	    }

	    if (q) {
	      q._strip();
	    }

	    a._strip(); // Denormalize


	    if (mode !== 'div' && shift !== 0) {
	      a.iushrn(shift);
	    }

	    return {
	      div: q || null,
	      mod: a
	    };
	  }; // NOTE: 1) `mode` can be set to `mod` to request mod only,
	  //       to `div` to request div only, or be absent to
	  //       request both div & mod
	  //       2) `positive` is true if unsigned mod is requested


	  BN.prototype.divmod = function divmod(num, mode, positive) {
	    assert(!num.isZero());

	    if (this.isZero()) {
	      return {
	        div: new BN(0),
	        mod: new BN(0)
	      };
	    }

	    var div, mod, res;

	    if (this.negative !== 0 && num.negative === 0) {
	      res = this.neg().divmod(num, mode);

	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }

	      if (mode !== 'div') {
	        mod = res.mod.neg();

	        if (positive && mod.negative !== 0) {
	          mod.iadd(num);
	        }
	      }

	      return {
	        div: div,
	        mod: mod
	      };
	    }

	    if (this.negative === 0 && num.negative !== 0) {
	      res = this.divmod(num.neg(), mode);

	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }

	      return {
	        div: div,
	        mod: res.mod
	      };
	    }

	    if ((this.negative & num.negative) !== 0) {
	      res = this.neg().divmod(num.neg(), mode);

	      if (mode !== 'div') {
	        mod = res.mod.neg();

	        if (positive && mod.negative !== 0) {
	          mod.isub(num);
	        }
	      }

	      return {
	        div: res.div,
	        mod: mod
	      };
	    } // Both numbers are positive at this point
	    // Strip both numbers to approximate shift value


	    if (num.length > this.length || this.cmp(num) < 0) {
	      return {
	        div: new BN(0),
	        mod: this
	      };
	    } // Very short reduction


	    if (num.length === 1) {
	      if (mode === 'div') {
	        return {
	          div: this.divn(num.words[0]),
	          mod: null
	        };
	      }

	      if (mode === 'mod') {
	        return {
	          div: null,
	          mod: new BN(this.modrn(num.words[0]))
	        };
	      }

	      return {
	        div: this.divn(num.words[0]),
	        mod: new BN(this.modrn(num.words[0]))
	      };
	    }

	    return this._wordDiv(num, mode);
	  }; // Find `this` / `num`


	  BN.prototype.div = function div(num) {
	    return this.divmod(num, 'div', false).div;
	  }; // Find `this` % `num`


	  BN.prototype.mod = function mod(num) {
	    return this.divmod(num, 'mod', false).mod;
	  };

	  BN.prototype.umod = function umod(num) {
	    return this.divmod(num, 'mod', true).mod;
	  }; // Find Round(`this` / `num`)


	  BN.prototype.divRound = function divRound(num) {
	    var dm = this.divmod(num); // Fast case - exact division

	    if (dm.mod.isZero()) return dm.div;
	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
	    var half = num.ushrn(1);
	    var r2 = num.andln(1);
	    var cmp = mod.cmp(half); // Round down

	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div; // Round up

	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
	  };

	  BN.prototype.modrn = function modrn(num) {
	    var isNegNum = num < 0;
	    if (isNegNum) num = -num;
	    assert(num <= 0x3ffffff);
	    var p = (1 << 26) % num;
	    var acc = 0;

	    for (var i = this.length - 1; i >= 0; i--) {
	      acc = (p * acc + (this.words[i] | 0)) % num;
	    }

	    return isNegNum ? -acc : acc;
	  }; // WARNING: DEPRECATED


	  BN.prototype.modn = function modn(num) {
	    return this.modrn(num);
	  }; // In-place division by number


	  BN.prototype.idivn = function idivn(num) {
	    var isNegNum = num < 0;
	    if (isNegNum) num = -num;
	    assert(num <= 0x3ffffff);
	    var carry = 0;

	    for (var i = this.length - 1; i >= 0; i--) {
	      var w = (this.words[i] | 0) + carry * 0x4000000;
	      this.words[i] = w / num | 0;
	      carry = w % num;
	    }

	    this._strip();

	    return isNegNum ? this.ineg() : this;
	  };

	  BN.prototype.divn = function divn(num) {
	    return this.clone().idivn(num);
	  };

	  BN.prototype.egcd = function egcd(p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	    var x = this;
	    var y = p.clone();

	    if (x.negative !== 0) {
	      x = x.umod(p);
	    } else {
	      x = x.clone();
	    } // A * x + B * y = x


	    var A = new BN(1);
	    var B = new BN(0); // C * x + D * y = y

	    var C = new BN(0);
	    var D = new BN(1);
	    var g = 0;

	    while (x.isEven() && y.isEven()) {
	      x.iushrn(1);
	      y.iushrn(1);
	      ++g;
	    }

	    var yp = y.clone();
	    var xp = x.clone();

	    while (!x.isZero()) {
	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);

	      if (i > 0) {
	        x.iushrn(i);

	        while (i-- > 0) {
	          if (A.isOdd() || B.isOdd()) {
	            A.iadd(yp);
	            B.isub(xp);
	          }

	          A.iushrn(1);
	          B.iushrn(1);
	        }
	      }

	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);

	      if (j > 0) {
	        y.iushrn(j);

	        while (j-- > 0) {
	          if (C.isOdd() || D.isOdd()) {
	            C.iadd(yp);
	            D.isub(xp);
	          }

	          C.iushrn(1);
	          D.iushrn(1);
	        }
	      }

	      if (x.cmp(y) >= 0) {
	        x.isub(y);
	        A.isub(C);
	        B.isub(D);
	      } else {
	        y.isub(x);
	        C.isub(A);
	        D.isub(B);
	      }
	    }

	    return {
	      a: C,
	      b: D,
	      gcd: y.iushln(g)
	    };
	  }; // This is reduced incarnation of the binary EEA
	  // above, designated to invert members of the
	  // _prime_ fields F(p) at a maximal speed


	  BN.prototype._invmp = function _invmp(p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	    var a = this;
	    var b = p.clone();

	    if (a.negative !== 0) {
	      a = a.umod(p);
	    } else {
	      a = a.clone();
	    }

	    var x1 = new BN(1);
	    var x2 = new BN(0);
	    var delta = b.clone();

	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);

	      if (i > 0) {
	        a.iushrn(i);

	        while (i-- > 0) {
	          if (x1.isOdd()) {
	            x1.iadd(delta);
	          }

	          x1.iushrn(1);
	        }
	      }

	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);

	      if (j > 0) {
	        b.iushrn(j);

	        while (j-- > 0) {
	          if (x2.isOdd()) {
	            x2.iadd(delta);
	          }

	          x2.iushrn(1);
	        }
	      }

	      if (a.cmp(b) >= 0) {
	        a.isub(b);
	        x1.isub(x2);
	      } else {
	        b.isub(a);
	        x2.isub(x1);
	      }
	    }

	    var res;

	    if (a.cmpn(1) === 0) {
	      res = x1;
	    } else {
	      res = x2;
	    }

	    if (res.cmpn(0) < 0) {
	      res.iadd(p);
	    }

	    return res;
	  };

	  BN.prototype.gcd = function gcd(num) {
	    if (this.isZero()) return num.abs();
	    if (num.isZero()) return this.abs();
	    var a = this.clone();
	    var b = num.clone();
	    a.negative = 0;
	    b.negative = 0; // Remove common factor of two

	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
	      a.iushrn(1);
	      b.iushrn(1);
	    }

	    do {
	      while (a.isEven()) {
	        a.iushrn(1);
	      }

	      while (b.isEven()) {
	        b.iushrn(1);
	      }

	      var r = a.cmp(b);

	      if (r < 0) {
	        // Swap `a` and `b` to make `a` always bigger than `b`
	        var t = a;
	        a = b;
	        b = t;
	      } else if (r === 0 || b.cmpn(1) === 0) {
	        break;
	      }

	      a.isub(b);
	    } while (true);

	    return b.iushln(shift);
	  }; // Invert number in the field F(num)


	  BN.prototype.invm = function invm(num) {
	    return this.egcd(num).a.umod(num);
	  };

	  BN.prototype.isEven = function isEven() {
	    return (this.words[0] & 1) === 0;
	  };

	  BN.prototype.isOdd = function isOdd() {
	    return (this.words[0] & 1) === 1;
	  }; // And first word and num


	  BN.prototype.andln = function andln(num) {
	    return this.words[0] & num;
	  }; // Increment at the bit position in-line


	  BN.prototype.bincn = function bincn(bit) {
	    assert(typeof bit === 'number');
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r; // Fast case: bit is much higher than all existing words

	    if (this.length <= s) {
	      this._expand(s + 1);

	      this.words[s] |= q;
	      return this;
	    } // Add bit and propagate, if needed


	    var carry = q;

	    for (var i = s; carry !== 0 && i < this.length; i++) {
	      var w = this.words[i] | 0;
	      w += carry;
	      carry = w >>> 26;
	      w &= 0x3ffffff;
	      this.words[i] = w;
	    }

	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }

	    return this;
	  };

	  BN.prototype.isZero = function isZero() {
	    return this.length === 1 && this.words[0] === 0;
	  };

	  BN.prototype.cmpn = function cmpn(num) {
	    var negative = num < 0;
	    if (this.negative !== 0 && !negative) return -1;
	    if (this.negative === 0 && negative) return 1;

	    this._strip();

	    var res;

	    if (this.length > 1) {
	      res = 1;
	    } else {
	      if (negative) {
	        num = -num;
	      }

	      assert(num <= 0x3ffffff, 'Number is too big');
	      var w = this.words[0] | 0;
	      res = w === num ? 0 : w < num ? -1 : 1;
	    }

	    if (this.negative !== 0) return -res | 0;
	    return res;
	  }; // Compare two numbers and return:
	  // 1 - if `this` > `num`
	  // 0 - if `this` == `num`
	  // -1 - if `this` < `num`


	  BN.prototype.cmp = function cmp(num) {
	    if (this.negative !== 0 && num.negative === 0) return -1;
	    if (this.negative === 0 && num.negative !== 0) return 1;
	    var res = this.ucmp(num);
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  }; // Unsigned comparison


	  BN.prototype.ucmp = function ucmp(num) {
	    // At this point both numbers have the same sign
	    if (this.length > num.length) return 1;
	    if (this.length < num.length) return -1;
	    var res = 0;

	    for (var i = this.length - 1; i >= 0; i--) {
	      var a = this.words[i] | 0;
	      var b = num.words[i] | 0;
	      if (a === b) continue;

	      if (a < b) {
	        res = -1;
	      } else if (a > b) {
	        res = 1;
	      }

	      break;
	    }

	    return res;
	  };

	  BN.prototype.gtn = function gtn(num) {
	    return this.cmpn(num) === 1;
	  };

	  BN.prototype.gt = function gt(num) {
	    return this.cmp(num) === 1;
	  };

	  BN.prototype.gten = function gten(num) {
	    return this.cmpn(num) >= 0;
	  };

	  BN.prototype.gte = function gte(num) {
	    return this.cmp(num) >= 0;
	  };

	  BN.prototype.ltn = function ltn(num) {
	    return this.cmpn(num) === -1;
	  };

	  BN.prototype.lt = function lt(num) {
	    return this.cmp(num) === -1;
	  };

	  BN.prototype.lten = function lten(num) {
	    return this.cmpn(num) <= 0;
	  };

	  BN.prototype.lte = function lte(num) {
	    return this.cmp(num) <= 0;
	  };

	  BN.prototype.eqn = function eqn(num) {
	    return this.cmpn(num) === 0;
	  };

	  BN.prototype.eq = function eq(num) {
	    return this.cmp(num) === 0;
	  }; //
	  // A reduce context, could be using montgomery or something better, depending
	  // on the `m` itself.
	  //


	  BN.red = function red(num) {
	    return new Red(num);
	  };

	  BN.prototype.toRed = function toRed(ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    assert(this.negative === 0, 'red works only with positives');
	    return ctx.convertTo(this)._forceRed(ctx);
	  };

	  BN.prototype.fromRed = function fromRed() {
	    assert(this.red, 'fromRed works only with numbers in reduction context');
	    return this.red.convertFrom(this);
	  };

	  BN.prototype._forceRed = function _forceRed(ctx) {
	    this.red = ctx;
	    return this;
	  };

	  BN.prototype.forceRed = function forceRed(ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    return this._forceRed(ctx);
	  };

	  BN.prototype.redAdd = function redAdd(num) {
	    assert(this.red, 'redAdd works only with red numbers');
	    return this.red.add(this, num);
	  };

	  BN.prototype.redIAdd = function redIAdd(num) {
	    assert(this.red, 'redIAdd works only with red numbers');
	    return this.red.iadd(this, num);
	  };

	  BN.prototype.redSub = function redSub(num) {
	    assert(this.red, 'redSub works only with red numbers');
	    return this.red.sub(this, num);
	  };

	  BN.prototype.redISub = function redISub(num) {
	    assert(this.red, 'redISub works only with red numbers');
	    return this.red.isub(this, num);
	  };

	  BN.prototype.redShl = function redShl(num) {
	    assert(this.red, 'redShl works only with red numbers');
	    return this.red.shl(this, num);
	  };

	  BN.prototype.redMul = function redMul(num) {
	    assert(this.red, 'redMul works only with red numbers');

	    this.red._verify2(this, num);

	    return this.red.mul(this, num);
	  };

	  BN.prototype.redIMul = function redIMul(num) {
	    assert(this.red, 'redMul works only with red numbers');

	    this.red._verify2(this, num);

	    return this.red.imul(this, num);
	  };

	  BN.prototype.redSqr = function redSqr() {
	    assert(this.red, 'redSqr works only with red numbers');

	    this.red._verify1(this);

	    return this.red.sqr(this);
	  };

	  BN.prototype.redISqr = function redISqr() {
	    assert(this.red, 'redISqr works only with red numbers');

	    this.red._verify1(this);

	    return this.red.isqr(this);
	  }; // Square root over p


	  BN.prototype.redSqrt = function redSqrt() {
	    assert(this.red, 'redSqrt works only with red numbers');

	    this.red._verify1(this);

	    return this.red.sqrt(this);
	  };

	  BN.prototype.redInvm = function redInvm() {
	    assert(this.red, 'redInvm works only with red numbers');

	    this.red._verify1(this);

	    return this.red.invm(this);
	  }; // Return negative clone of `this` % `red modulo`


	  BN.prototype.redNeg = function redNeg() {
	    assert(this.red, 'redNeg works only with red numbers');

	    this.red._verify1(this);

	    return this.red.neg(this);
	  };

	  BN.prototype.redPow = function redPow(num) {
	    assert(this.red && !num.red, 'redPow(normalNum)');

	    this.red._verify1(this);

	    return this.red.pow(this, num);
	  }; // Prime numbers with efficient reduction


	  var primes = {
	    k256: null,
	    p224: null,
	    p192: null,
	    p25519: null
	  }; // Pseudo-Mersenne prime

	  function MPrime(name, p) {
	    // P = 2 ^ N - K
	    this.name = name;
	    this.p = new BN(p, 16);
	    this.n = this.p.bitLength();
	    this.k = new BN(1).iushln(this.n).isub(this.p);
	    this.tmp = this._tmp();
	  }

	  MPrime.prototype._tmp = function _tmp() {
	    var tmp = new BN(null);
	    tmp.words = new Array(Math.ceil(this.n / 13));
	    return tmp;
	  };

	  MPrime.prototype.ireduce = function ireduce(num) {
	    // Assumes that `num` is less than `P^2`
	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
	    var r = num;
	    var rlen;

	    do {
	      this.split(r, this.tmp);
	      r = this.imulK(r);
	      r = r.iadd(this.tmp);
	      rlen = r.bitLength();
	    } while (rlen > this.n);

	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);

	    if (cmp === 0) {
	      r.words[0] = 0;
	      r.length = 1;
	    } else if (cmp > 0) {
	      r.isub(this.p);
	    } else {
	      if (r.strip !== undefined) {
	        // r is a BN v4 instance
	        r.strip();
	      } else {
	        // r is a BN v5 instance
	        r._strip();
	      }
	    }

	    return r;
	  };

	  MPrime.prototype.split = function split(input, out) {
	    input.iushrn(this.n, 0, out);
	  };

	  MPrime.prototype.imulK = function imulK(num) {
	    return num.imul(this.k);
	  };

	  function K256() {
	    MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
	  }

	  inherits(K256, MPrime);

	  K256.prototype.split = function split(input, output) {
	    // 256 = 9 * 26 + 22
	    var mask = 0x3fffff;
	    var outLen = Math.min(input.length, 9);

	    for (var i = 0; i < outLen; i++) {
	      output.words[i] = input.words[i];
	    }

	    output.length = outLen;

	    if (input.length <= 9) {
	      input.words[0] = 0;
	      input.length = 1;
	      return;
	    } // Shift by 9 limbs


	    var prev = input.words[9];
	    output.words[output.length++] = prev & mask;

	    for (i = 10; i < input.length; i++) {
	      var next = input.words[i] | 0;
	      input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
	      prev = next;
	    }

	    prev >>>= 22;
	    input.words[i - 10] = prev;

	    if (prev === 0 && input.length > 10) {
	      input.length -= 10;
	    } else {
	      input.length -= 9;
	    }
	  };

	  K256.prototype.imulK = function imulK(num) {
	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
	    num.words[num.length] = 0;
	    num.words[num.length + 1] = 0;
	    num.length += 2; // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390

	    var lo = 0;

	    for (var i = 0; i < num.length; i++) {
	      var w = num.words[i] | 0;
	      lo += w * 0x3d1;
	      num.words[i] = lo & 0x3ffffff;
	      lo = w * 0x40 + (lo / 0x4000000 | 0);
	    } // Fast length reduction


	    if (num.words[num.length - 1] === 0) {
	      num.length--;

	      if (num.words[num.length - 1] === 0) {
	        num.length--;
	      }
	    }

	    return num;
	  };

	  function P224() {
	    MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
	  }

	  inherits(P224, MPrime);

	  function P192() {
	    MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
	  }

	  inherits(P192, MPrime);

	  function P25519() {
	    // 2 ^ 255 - 19
	    MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
	  }

	  inherits(P25519, MPrime);

	  P25519.prototype.imulK = function imulK(num) {
	    // K = 0x13
	    var carry = 0;

	    for (var i = 0; i < num.length; i++) {
	      var hi = (num.words[i] | 0) * 0x13 + carry;
	      var lo = hi & 0x3ffffff;
	      hi >>>= 26;
	      num.words[i] = lo;
	      carry = hi;
	    }

	    if (carry !== 0) {
	      num.words[num.length++] = carry;
	    }

	    return num;
	  }; // Exported mostly for testing purposes, use plain name instead


	  BN._prime = function prime(name) {
	    // Cached version of prime
	    if (primes[name]) return primes[name];
	    var prime;

	    if (name === 'k256') {
	      prime = new K256();
	    } else if (name === 'p224') {
	      prime = new P224();
	    } else if (name === 'p192') {
	      prime = new P192();
	    } else if (name === 'p25519') {
	      prime = new P25519();
	    } else {
	      throw new Error('Unknown prime ' + name);
	    }

	    primes[name] = prime;
	    return prime;
	  }; //
	  // Base reduction engine
	  //


	  function Red(m) {
	    if (typeof m === 'string') {
	      var prime = BN._prime(m);

	      this.m = prime.p;
	      this.prime = prime;
	    } else {
	      assert(m.gtn(1), 'modulus must be greater than 1');
	      this.m = m;
	      this.prime = null;
	    }
	  }

	  Red.prototype._verify1 = function _verify1(a) {
	    assert(a.negative === 0, 'red works only with positives');
	    assert(a.red, 'red works only with red numbers');
	  };

	  Red.prototype._verify2 = function _verify2(a, b) {
	    assert((a.negative | b.negative) === 0, 'red works only with positives');
	    assert(a.red && a.red === b.red, 'red works only with red numbers');
	  };

	  Red.prototype.imod = function imod(a) {
	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
	    move(a, a.umod(this.m)._forceRed(this));
	    return a;
	  };

	  Red.prototype.neg = function neg(a) {
	    if (a.isZero()) {
	      return a.clone();
	    }

	    return this.m.sub(a)._forceRed(this);
	  };

	  Red.prototype.add = function add(a, b) {
	    this._verify2(a, b);

	    var res = a.add(b);

	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }

	    return res._forceRed(this);
	  };

	  Red.prototype.iadd = function iadd(a, b) {
	    this._verify2(a, b);

	    var res = a.iadd(b);

	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }

	    return res;
	  };

	  Red.prototype.sub = function sub(a, b) {
	    this._verify2(a, b);

	    var res = a.sub(b);

	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }

	    return res._forceRed(this);
	  };

	  Red.prototype.isub = function isub(a, b) {
	    this._verify2(a, b);

	    var res = a.isub(b);

	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }

	    return res;
	  };

	  Red.prototype.shl = function shl(a, num) {
	    this._verify1(a);

	    return this.imod(a.ushln(num));
	  };

	  Red.prototype.imul = function imul(a, b) {
	    this._verify2(a, b);

	    return this.imod(a.imul(b));
	  };

	  Red.prototype.mul = function mul(a, b) {
	    this._verify2(a, b);

	    return this.imod(a.mul(b));
	  };

	  Red.prototype.isqr = function isqr(a) {
	    return this.imul(a, a.clone());
	  };

	  Red.prototype.sqr = function sqr(a) {
	    return this.mul(a, a);
	  };

	  Red.prototype.sqrt = function sqrt(a) {
	    if (a.isZero()) return a.clone();
	    var mod3 = this.m.andln(3);
	    assert(mod3 % 2 === 1); // Fast case

	    if (mod3 === 3) {
	      var pow = this.m.add(new BN(1)).iushrn(2);
	      return this.pow(a, pow);
	    } // Tonelli-Shanks algorithm (Totally unoptimized and slow)
	    //
	    // Find Q and S, that Q * 2 ^ S = (P - 1)


	    var q = this.m.subn(1);
	    var s = 0;

	    while (!q.isZero() && q.andln(1) === 0) {
	      s++;
	      q.iushrn(1);
	    }

	    assert(!q.isZero());
	    var one = new BN(1).toRed(this);
	    var nOne = one.redNeg(); // Find quadratic non-residue
	    // NOTE: Max is such because of generalized Riemann hypothesis.

	    var lpow = this.m.subn(1).iushrn(1);
	    var z = this.m.bitLength();
	    z = new BN(2 * z * z).toRed(this);

	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
	      z.redIAdd(nOne);
	    }

	    var c = this.pow(z, q);
	    var r = this.pow(a, q.addn(1).iushrn(1));
	    var t = this.pow(a, q);
	    var m = s;

	    while (t.cmp(one) !== 0) {
	      var tmp = t;

	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
	        tmp = tmp.redSqr();
	      }

	      assert(i < m);
	      var b = this.pow(c, new BN(1).iushln(m - i - 1));
	      r = r.redMul(b);
	      c = b.redSqr();
	      t = t.redMul(c);
	      m = i;
	    }

	    return r;
	  };

	  Red.prototype.invm = function invm(a) {
	    var inv = a._invmp(this.m);

	    if (inv.negative !== 0) {
	      inv.negative = 0;
	      return this.imod(inv).redNeg();
	    } else {
	      return this.imod(inv);
	    }
	  };

	  Red.prototype.pow = function pow(a, num) {
	    if (num.isZero()) return new BN(1).toRed(this);
	    if (num.cmpn(1) === 0) return a.clone();
	    var windowSize = 4;
	    var wnd = new Array(1 << windowSize);
	    wnd[0] = new BN(1).toRed(this);
	    wnd[1] = a;

	    for (var i = 2; i < wnd.length; i++) {
	      wnd[i] = this.mul(wnd[i - 1], a);
	    }

	    var res = wnd[0];
	    var current = 0;
	    var currentLen = 0;
	    var start = num.bitLength() % 26;

	    if (start === 0) {
	      start = 26;
	    }

	    for (i = num.length - 1; i >= 0; i--) {
	      var word = num.words[i];

	      for (var j = start - 1; j >= 0; j--) {
	        var bit = word >> j & 1;

	        if (res !== wnd[0]) {
	          res = this.sqr(res);
	        }

	        if (bit === 0 && current === 0) {
	          currentLen = 0;
	          continue;
	        }

	        current <<= 1;
	        current |= bit;
	        currentLen++;
	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
	        res = this.mul(res, wnd[current]);
	        currentLen = 0;
	        current = 0;
	      }

	      start = 26;
	    }

	    return res;
	  };

	  Red.prototype.convertTo = function convertTo(num) {
	    var r = num.umod(this.m);
	    return r === num ? r.clone() : r;
	  };

	  Red.prototype.convertFrom = function convertFrom(num) {
	    var res = num.clone();
	    res.red = null;
	    return res;
	  }; //
	  // Montgomery method engine
	  //


	  BN.mont = function mont(num) {
	    return new Mont(num);
	  };

	  function Mont(m) {
	    Red.call(this, m);
	    this.shift = this.m.bitLength();

	    if (this.shift % 26 !== 0) {
	      this.shift += 26 - this.shift % 26;
	    }

	    this.r = new BN(1).iushln(this.shift);
	    this.r2 = this.imod(this.r.sqr());
	    this.rinv = this.r._invmp(this.m);
	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
	    this.minv = this.minv.umod(this.r);
	    this.minv = this.r.sub(this.minv);
	  }

	  inherits(Mont, Red);

	  Mont.prototype.convertTo = function convertTo(num) {
	    return this.imod(num.ushln(this.shift));
	  };

	  Mont.prototype.convertFrom = function convertFrom(num) {
	    var r = this.imod(num.mul(this.rinv));
	    r.red = null;
	    return r;
	  };

	  Mont.prototype.imul = function imul(a, b) {
	    if (a.isZero() || b.isZero()) {
	      a.words[0] = 0;
	      a.length = 1;
	      return a;
	    }

	    var t = a.imul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;

	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }

	    return res._forceRed(this);
	  };

	  Mont.prototype.mul = function mul(a, b) {
	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
	    var t = a.mul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;

	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }

	    return res._forceRed(this);
	  };

	  Mont.prototype.invm = function invm(a) {
	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
	    var res = this.imod(a._invmp(this.m).mul(this.r2));
	    return res._forceRed(this);
	  };
	})(module, commonjsGlobal);
	});

	const version$i = "logger/5.7.0";

	let _permanentCensorErrors = false;
	let _censorErrors = false;
	const LogLevels = {
	  debug: 1,
	  "default": 2,
	  info: 2,
	  warning: 3,
	  error: 4,
	  off: 5
	};
	let _logLevel = LogLevels["default"];
	let _globalLogger = null;

	function _checkNormalize() {
	  try {
	    const missing = []; // Make sure all forms of normalization are supported

	    ["NFD", "NFC", "NFKD", "NFKC"].forEach(form => {
	      try {
	        if ("test".normalize(form) !== "test") {
	          throw new Error("bad normalize");
	        }

	        ;
	      } catch (error) {
	        missing.push(form);
	      }
	    });

	    if (missing.length) {
	      throw new Error("missing " + missing.join(", "));
	    }

	    if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) {
	      throw new Error("broken implementation");
	    }
	  } catch (error) {
	    return error.message;
	  }

	  return null;
	}

	const _normalizeError = _checkNormalize();

	var LogLevel;

	(function (LogLevel) {
	  LogLevel["DEBUG"] = "DEBUG";
	  LogLevel["INFO"] = "INFO";
	  LogLevel["WARNING"] = "WARNING";
	  LogLevel["ERROR"] = "ERROR";
	  LogLevel["OFF"] = "OFF";
	})(LogLevel || (LogLevel = {}));

	var ErrorCode;

	(function (ErrorCode) {
	  ///////////////////
	  // Generic Errors
	  // Unknown Error
	  ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR"; // Not Implemented

	  ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED"; // Unsupported Operation
	  //   - operation

	  ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION"; // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
	  //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)

	  ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR"; // Some sort of bad response from the server

	  ErrorCode["SERVER_ERROR"] = "SERVER_ERROR"; // Timeout

	  ErrorCode["TIMEOUT"] = "TIMEOUT"; ///////////////////
	  // Operational  Errors
	  // Buffer Overrun

	  ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN"; // Numeric Fault
	  //   - operation: the operation being executed
	  //   - fault: the reason this faulted

	  ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT"; ///////////////////
	  // Argument Errors
	  // Missing new operator to an object
	  //  - name: The name of the class

	  ErrorCode["MISSING_NEW"] = "MISSING_NEW"; // Invalid argument (e.g. value is incompatible with type) to a function:
	  //   - argument: The argument name that was invalid
	  //   - value: The value of the argument

	  ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT"; // Missing argument to a function:
	  //   - count: The number of arguments received
	  //   - expectedCount: The number of arguments expected

	  ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT"; // Too many arguments
	  //   - count: The number of arguments received
	  //   - expectedCount: The number of arguments expected

	  ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT"; ///////////////////
	  // Blockchain Errors
	  // Call exception
	  //  - transaction: the transaction
	  //  - address?: the contract address
	  //  - args?: The arguments passed into the function
	  //  - method?: The Solidity method signature
	  //  - errorSignature?: The EIP848 error signature
	  //  - errorArgs?: The EIP848 error parameters
	  //  - reason: The reason (only for EIP848 "Error(string)")

	  ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION"; // Insufficient funds (< value + gasLimit * gasPrice)
	  //   - transaction: the transaction attempted

	  ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS"; // Nonce has already been used
	  //   - transaction: the transaction attempted

	  ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED"; // The replacement fee for the transaction is too low
	  //   - transaction: the transaction attempted

	  ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED"; // The gas limit could not be estimated
	  //   - transaction: the transaction passed to estimateGas

	  ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT"; // The transaction was replaced by one with a higher gas price
	  //   - reason: "cancelled", "replaced" or "repriced"
	  //   - cancelled: true if reason == "cancelled" or reason == "replaced")
	  //   - hash: original transaction hash
	  //   - replacement: the full TransactionsResponse for the replacement
	  //   - receipt: the receipt of the replacement

	  ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED"; ///////////////////
	  // Interaction Errors
	  // The user rejected the action, such as signing a message or sending
	  // a transaction

	  ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
	})(ErrorCode || (ErrorCode = {}));
	const HEX = "0123456789abcdef";
	class Logger {
	  constructor(version) {
	    Object.defineProperty(this, "version", {
	      enumerable: true,
	      value: version,
	      writable: false
	    });
	  }

	  _log(logLevel, args) {
	    const level = logLevel.toLowerCase();

	    if (LogLevels[level] == null) {
	      this.throwArgumentError("invalid log level name", "logLevel", logLevel);
	    }

	    if (_logLevel > LogLevels[level]) {
	      return;
	    }

	    console.log.apply(console, args);
	  }

	  debug(...args) {
	    this._log(Logger.levels.DEBUG, args);
	  }

	  info(...args) {
	    this._log(Logger.levels.INFO, args);
	  }

	  warn(...args) {
	    this._log(Logger.levels.WARNING, args);
	  }

	  makeError(message, code, params) {
	    // Errors are being censored
	    if (_censorErrors) {
	      return this.makeError("censored error", code, {});
	    }

	    if (!code) {
	      code = Logger.errors.UNKNOWN_ERROR;
	    }

	    if (!params) {
	      params = {};
	    }

	    const messageDetails = [];
	    Object.keys(params).forEach(key => {
	      const value = params[key];

	      try {
	        if (value instanceof Uint8Array) {
	          let hex = "";

	          for (let i = 0; i < value.length; i++) {
	            hex += HEX[value[i] >> 4];
	            hex += HEX[value[i] & 0x0f];
	          }

	          messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
	        } else {
	          messageDetails.push(key + "=" + JSON.stringify(value));
	        }
	      } catch (error) {
	        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
	      }
	    });
	    messageDetails.push(`code=${code}`);
	    messageDetails.push(`version=${this.version}`);
	    const reason = message;
	    let url = "";

	    switch (code) {
	      case ErrorCode.NUMERIC_FAULT:
	        {
	          url = "NUMERIC_FAULT";
	          const fault = message;

	          switch (fault) {
	            case "overflow":
	            case "underflow":
	            case "division-by-zero":
	              url += "-" + fault;
	              break;

	            case "negative-power":
	            case "negative-width":
	              url += "-unsupported";
	              break;

	            case "unbound-bitwise-result":
	              url += "-unbound-result";
	              break;
	          }

	          break;
	        }

	      case ErrorCode.CALL_EXCEPTION:
	      case ErrorCode.INSUFFICIENT_FUNDS:
	      case ErrorCode.MISSING_NEW:
	      case ErrorCode.NONCE_EXPIRED:
	      case ErrorCode.REPLACEMENT_UNDERPRICED:
	      case ErrorCode.TRANSACTION_REPLACED:
	      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
	        url = code;
	        break;
	    }

	    if (url) {
	      message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
	    }

	    if (messageDetails.length) {
	      message += " (" + messageDetails.join(", ") + ")";
	    } // @TODO: Any??


	    const error = new Error(message);
	    error.reason = reason;
	    error.code = code;
	    Object.keys(params).forEach(function (key) {
	      error[key] = params[key];
	    });
	    return error;
	  }

	  throwError(message, code, params) {
	    throw this.makeError(message, code, params);
	  }

	  throwArgumentError(message, name, value) {
	    return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
	      argument: name,
	      value: value
	    });
	  }

	  assert(condition, message, code, params) {
	    if (!!condition) {
	      return;
	    }

	    this.throwError(message, code, params);
	  }

	  assertArgument(condition, message, name, value) {
	    if (!!condition) {
	      return;
	    }

	    this.throwArgumentError(message, name, value);
	  }

	  checkNormalize(message) {

	    if (_normalizeError) {
	      this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "String.prototype.normalize",
	        form: _normalizeError
	      });
	    }
	  }

	  checkSafeUint53(value, message) {
	    if (typeof value !== "number") {
	      return;
	    }

	    if (message == null) {
	      message = "value not safe";
	    }

	    if (value < 0 || value >= 0x1fffffffffffff) {
	      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
	        operation: "checkSafeInteger",
	        fault: "out-of-safe-range",
	        value: value
	      });
	    }

	    if (value % 1) {
	      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
	        operation: "checkSafeInteger",
	        fault: "non-integer",
	        value: value
	      });
	    }
	  }

	  checkArgumentCount(count, expectedCount, message) {
	    if (message) {
	      message = ": " + message;
	    } else {
	      message = "";
	    }

	    if (count < expectedCount) {
	      this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
	        count: count,
	        expectedCount: expectedCount
	      });
	    }

	    if (count > expectedCount) {
	      this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
	        count: count,
	        expectedCount: expectedCount
	      });
	    }
	  }

	  checkNew(target, kind) {
	    if (target === Object || target == null) {
	      this.throwError("missing new", Logger.errors.MISSING_NEW, {
	        name: kind.name
	      });
	    }
	  }

	  checkAbstract(target, kind) {
	    if (target === kind) {
	      this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, {
	        name: target.name,
	        operation: "new"
	      });
	    } else if (target === Object || target == null) {
	      this.throwError("missing new", Logger.errors.MISSING_NEW, {
	        name: kind.name
	      });
	    }
	  }

	  static globalLogger() {
	    if (!_globalLogger) {
	      _globalLogger = new Logger(version$i);
	    }

	    return _globalLogger;
	  }

	  static setCensorship(censorship, permanent) {
	    if (!censorship && permanent) {
	      this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "setCensorship"
	      });
	    }

	    if (_permanentCensorErrors) {
	      if (!censorship) {
	        return;
	      }

	      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "setCensorship"
	      });
	    }

	    _censorErrors = !!censorship;
	    _permanentCensorErrors = !!permanent;
	  }

	  static setLogLevel(logLevel) {
	    const level = LogLevels[logLevel.toLowerCase()];

	    if (level == null) {
	      Logger.globalLogger().warn("invalid log level - " + logLevel);
	      return;
	    }

	    _logLevel = level;
	  }

	  static from(version) {
	    return new Logger(version);
	  }

	}
	Logger.errors = ErrorCode;
	Logger.levels = LogLevel;

	const version$h = "bytes/5.7.0";

	const logger$o = new Logger(version$h); ///////////////////////////////

	function isHexable(value) {
	  return !!value.toHexString;
	}

	function addSlice(array) {
	  if (array.slice) {
	    return array;
	  }

	  array.slice = function () {
	    const args = Array.prototype.slice.call(arguments);
	    return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
	  };

	  return array;
	}

	function isBytesLike(value) {
	  return isHexString(value) && !(value.length % 2) || isBytes(value);
	}

	function isInteger(value) {
	  return typeof value === "number" && value == value && value % 1 === 0;
	}

	function isBytes(value) {
	  if (value == null) {
	    return false;
	  }

	  if (value.constructor === Uint8Array) {
	    return true;
	  }

	  if (typeof value === "string") {
	    return false;
	  }

	  if (!isInteger(value.length) || value.length < 0) {
	    return false;
	  }

	  for (let i = 0; i < value.length; i++) {
	    const v = value[i];

	    if (!isInteger(v) || v < 0 || v >= 256) {
	      return false;
	    }
	  }

	  return true;
	}
	function arrayify(value, options) {
	  if (!options) {
	    options = {};
	  }

	  if (typeof value === "number") {
	    logger$o.checkSafeUint53(value, "invalid arrayify value");
	    const result = [];

	    while (value) {
	      result.unshift(value & 0xff);
	      value = parseInt(String(value / 256));
	    }

	    if (result.length === 0) {
	      result.push(0);
	    }

	    return addSlice(new Uint8Array(result));
	  }

	  if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
	    value = "0x" + value;
	  }

	  if (isHexable(value)) {
	    value = value.toHexString();
	  }

	  if (isHexString(value)) {
	    let hex = value.substring(2);

	    if (hex.length % 2) {
	      if (options.hexPad === "left") {
	        hex = "0" + hex;
	      } else if (options.hexPad === "right") {
	        hex += "0";
	      } else {
	        logger$o.throwArgumentError("hex data is odd-length", "value", value);
	      }
	    }

	    const result = [];

	    for (let i = 0; i < hex.length; i += 2) {
	      result.push(parseInt(hex.substring(i, i + 2), 16));
	    }

	    return addSlice(new Uint8Array(result));
	  }

	  if (isBytes(value)) {
	    return addSlice(new Uint8Array(value));
	  }

	  return logger$o.throwArgumentError("invalid arrayify value", "value", value);
	}
	function concat$1(items) {
	  const objects = items.map(item => arrayify(item));
	  const length = objects.reduce((accum, item) => accum + item.length, 0);
	  const result = new Uint8Array(length);
	  objects.reduce((offset, object) => {
	    result.set(object, offset);
	    return offset + object.length;
	  }, 0);
	  return addSlice(result);
	}
	function stripZeros(value) {
	  let result = arrayify(value);

	  if (result.length === 0) {
	    return result;
	  } // Find the first non-zero entry


	  let start = 0;

	  while (start < result.length && result[start] === 0) {
	    start++;
	  } // If we started with zeros, strip them


	  if (start) {
	    result = result.slice(start);
	  }

	  return result;
	}
	function zeroPad(value, length) {
	  value = arrayify(value);

	  if (value.length > length) {
	    logger$o.throwArgumentError("value out of range", "value", arguments[0]);
	  }

	  const result = new Uint8Array(length);
	  result.set(value, length - value.length);
	  return addSlice(result);
	}
	function isHexString(value, length) {
	  if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
	    return false;
	  }

	  if (length && value.length !== 2 + 2 * length) {
	    return false;
	  }

	  return true;
	}
	const HexCharacters = "0123456789abcdef";
	function hexlify(value, options) {
	  if (!options) {
	    options = {};
	  }

	  if (typeof value === "number") {
	    logger$o.checkSafeUint53(value, "invalid hexlify value");
	    let hex = "";

	    while (value) {
	      hex = HexCharacters[value & 0xf] + hex;
	      value = Math.floor(value / 16);
	    }

	    if (hex.length) {
	      if (hex.length % 2) {
	        hex = "0" + hex;
	      }

	      return "0x" + hex;
	    }

	    return "0x00";
	  }

	  if (typeof value === "bigint") {
	    value = value.toString(16);

	    if (value.length % 2) {
	      return "0x0" + value;
	    }

	    return "0x" + value;
	  }

	  if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
	    value = "0x" + value;
	  }

	  if (isHexable(value)) {
	    return value.toHexString();
	  }

	  if (isHexString(value)) {
	    if (value.length % 2) {
	      if (options.hexPad === "left") {
	        value = "0x0" + value.substring(2);
	      } else if (options.hexPad === "right") {
	        value += "0";
	      } else {
	        logger$o.throwArgumentError("hex data is odd-length", "value", value);
	      }
	    }

	    return value.toLowerCase();
	  }

	  if (isBytes(value)) {
	    let result = "0x";

	    for (let i = 0; i < value.length; i++) {
	      let v = value[i];
	      result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
	    }

	    return result;
	  }

	  return logger$o.throwArgumentError("invalid hexlify value", "value", value);
	}
	/*
	function unoddify(value: BytesLike | Hexable | number): BytesLike | Hexable | number {
	    if (typeof(value) === "string" && value.length % 2 && value.substring(0, 2) === "0x") {
	        return "0x0" + value.substring(2);
	    }
	    return value;
	}
	*/

	function hexDataLength(data) {
	  if (typeof data !== "string") {
	    data = hexlify(data);
	  } else if (!isHexString(data) || data.length % 2) {
	    return null;
	  }

	  return (data.length - 2) / 2;
	}
	function hexDataSlice(data, offset, endOffset) {
	  if (typeof data !== "string") {
	    data = hexlify(data);
	  } else if (!isHexString(data) || data.length % 2) {
	    logger$o.throwArgumentError("invalid hexData", "value", data);
	  }

	  offset = 2 + 2 * offset;

	  if (endOffset != null) {
	    return "0x" + data.substring(offset, 2 + 2 * endOffset);
	  }

	  return "0x" + data.substring(offset);
	}
	function hexConcat(items) {
	  let result = "0x";
	  items.forEach(item => {
	    result += hexlify(item).substring(2);
	  });
	  return result;
	}
	function hexValue(value) {
	  const trimmed = hexStripZeros(hexlify(value, {
	    hexPad: "left"
	  }));

	  if (trimmed === "0x") {
	    return "0x0";
	  }

	  return trimmed;
	}
	function hexStripZeros(value) {
	  if (typeof value !== "string") {
	    value = hexlify(value);
	  }

	  if (!isHexString(value)) {
	    logger$o.throwArgumentError("invalid hex string", "value", value);
	  }

	  value = value.substring(2);
	  let offset = 0;

	  while (offset < value.length && value[offset] === "0") {
	    offset++;
	  }

	  return "0x" + value.substring(offset);
	}
	function hexZeroPad(value, length) {
	  if (typeof value !== "string") {
	    value = hexlify(value);
	  } else if (!isHexString(value)) {
	    logger$o.throwArgumentError("invalid hex string", "value", value);
	  }

	  if (value.length > 2 * length + 2) {
	    logger$o.throwArgumentError("value out of range", "value", arguments[1]);
	  }

	  while (value.length < 2 * length + 2) {
	    value = "0x0" + value.substring(2);
	  }

	  return value;
	}
	function splitSignature(signature) {
	  const result = {
	    r: "0x",
	    s: "0x",
	    _vs: "0x",
	    recoveryParam: 0,
	    v: 0,
	    yParityAndS: "0x",
	    compact: "0x"
	  };

	  if (isBytesLike(signature)) {
	    let bytes = arrayify(signature); // Get the r, s and v

	    if (bytes.length === 64) {
	      // EIP-2098; pull the v from the top bit of s and clear it
	      result.v = 27 + (bytes[32] >> 7);
	      bytes[32] &= 0x7f;
	      result.r = hexlify(bytes.slice(0, 32));
	      result.s = hexlify(bytes.slice(32, 64));
	    } else if (bytes.length === 65) {
	      result.r = hexlify(bytes.slice(0, 32));
	      result.s = hexlify(bytes.slice(32, 64));
	      result.v = bytes[64];
	    } else {
	      logger$o.throwArgumentError("invalid signature string", "signature", signature);
	    } // Allow a recid to be used as the v


	    if (result.v < 27) {
	      if (result.v === 0 || result.v === 1) {
	        result.v += 27;
	      } else {
	        logger$o.throwArgumentError("signature invalid v byte", "signature", signature);
	      }
	    } // Compute recoveryParam from v


	    result.recoveryParam = 1 - result.v % 2; // Compute _vs from recoveryParam and s

	    if (result.recoveryParam) {
	      bytes[32] |= 0x80;
	    }

	    result._vs = hexlify(bytes.slice(32, 64));
	  } else {
	    result.r = signature.r;
	    result.s = signature.s;
	    result.v = signature.v;
	    result.recoveryParam = signature.recoveryParam;
	    result._vs = signature._vs; // If the _vs is available, use it to populate missing s, v and recoveryParam
	    // and verify non-missing s, v and recoveryParam

	    if (result._vs != null) {
	      const vs = zeroPad(arrayify(result._vs), 32);
	      result._vs = hexlify(vs); // Set or check the recid

	      const recoveryParam = vs[0] >= 128 ? 1 : 0;

	      if (result.recoveryParam == null) {
	        result.recoveryParam = recoveryParam;
	      } else if (result.recoveryParam !== recoveryParam) {
	        logger$o.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
	      } // Set or check the s


	      vs[0] &= 0x7f;
	      const s = hexlify(vs);

	      if (result.s == null) {
	        result.s = s;
	      } else if (result.s !== s) {
	        logger$o.throwArgumentError("signature v mismatch _vs", "signature", signature);
	      }
	    } // Use recid and v to populate each other


	    if (result.recoveryParam == null) {
	      if (result.v == null) {
	        logger$o.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
	      } else if (result.v === 0 || result.v === 1) {
	        result.recoveryParam = result.v;
	      } else {
	        result.recoveryParam = 1 - result.v % 2;
	      }
	    } else {
	      if (result.v == null) {
	        result.v = 27 + result.recoveryParam;
	      } else {
	        const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;

	        if (result.recoveryParam !== recId) {
	          logger$o.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
	        }
	      }
	    }

	    if (result.r == null || !isHexString(result.r)) {
	      logger$o.throwArgumentError("signature missing or invalid r", "signature", signature);
	    } else {
	      result.r = hexZeroPad(result.r, 32);
	    }

	    if (result.s == null || !isHexString(result.s)) {
	      logger$o.throwArgumentError("signature missing or invalid s", "signature", signature);
	    } else {
	      result.s = hexZeroPad(result.s, 32);
	    }

	    const vs = arrayify(result.s);

	    if (vs[0] >= 128) {
	      logger$o.throwArgumentError("signature s out of range", "signature", signature);
	    }

	    if (result.recoveryParam) {
	      vs[0] |= 0x80;
	    }

	    const _vs = hexlify(vs);

	    if (result._vs) {
	      if (!isHexString(result._vs)) {
	        logger$o.throwArgumentError("signature invalid _vs", "signature", signature);
	      }

	      result._vs = hexZeroPad(result._vs, 32);
	    } // Set or check the _vs


	    if (result._vs == null) {
	      result._vs = _vs;
	    } else if (result._vs !== _vs) {
	      logger$o.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
	    }
	  }

	  result.yParityAndS = result._vs;
	  result.compact = result.r + result.yParityAndS.substring(2);
	  return result;
	}

	const version$g = "bignumber/5.7.0";

	var BN = bn.BN;
	const logger$n = new Logger(version$g);
	const _constructorGuard$3 = {};
	const MAX_SAFE = 0x1fffffffffffff;
	function isBigNumberish(value) {
	  return value != null && (BigNumber.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || isHexString(value) || typeof value === "bigint" || isBytes(value));
	} // Only warn about passing 10 into radix once

	let _warnedToStringRadix = false;
	class BigNumber {
	  constructor(constructorGuard, hex) {
	    if (constructorGuard !== _constructorGuard$3) {
	      logger$n.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "new (BigNumber)"
	      });
	    }

	    this._hex = hex;
	    this._isBigNumber = true;
	    Object.freeze(this);
	  }

	  fromTwos(value) {
	    return toBigNumber(toBN(this).fromTwos(value));
	  }

	  toTwos(value) {
	    return toBigNumber(toBN(this).toTwos(value));
	  }

	  abs() {
	    if (this._hex[0] === "-") {
	      return BigNumber.from(this._hex.substring(1));
	    }

	    return this;
	  }

	  add(other) {
	    return toBigNumber(toBN(this).add(toBN(other)));
	  }

	  sub(other) {
	    return toBigNumber(toBN(this).sub(toBN(other)));
	  }

	  div(other) {
	    const o = BigNumber.from(other);

	    if (o.isZero()) {
	      throwFault$1("division-by-zero", "div");
	    }

	    return toBigNumber(toBN(this).div(toBN(other)));
	  }

	  mul(other) {
	    return toBigNumber(toBN(this).mul(toBN(other)));
	  }

	  mod(other) {
	    const value = toBN(other);

	    if (value.isNeg()) {
	      throwFault$1("division-by-zero", "mod");
	    }

	    return toBigNumber(toBN(this).umod(value));
	  }

	  pow(other) {
	    const value = toBN(other);

	    if (value.isNeg()) {
	      throwFault$1("negative-power", "pow");
	    }

	    return toBigNumber(toBN(this).pow(value));
	  }

	  and(other) {
	    const value = toBN(other);

	    if (this.isNegative() || value.isNeg()) {
	      throwFault$1("unbound-bitwise-result", "and");
	    }

	    return toBigNumber(toBN(this).and(value));
	  }

	  or(other) {
	    const value = toBN(other);

	    if (this.isNegative() || value.isNeg()) {
	      throwFault$1("unbound-bitwise-result", "or");
	    }

	    return toBigNumber(toBN(this).or(value));
	  }

	  xor(other) {
	    const value = toBN(other);

	    if (this.isNegative() || value.isNeg()) {
	      throwFault$1("unbound-bitwise-result", "xor");
	    }

	    return toBigNumber(toBN(this).xor(value));
	  }

	  mask(value) {
	    if (this.isNegative() || value < 0) {
	      throwFault$1("negative-width", "mask");
	    }

	    return toBigNumber(toBN(this).maskn(value));
	  }

	  shl(value) {
	    if (this.isNegative() || value < 0) {
	      throwFault$1("negative-width", "shl");
	    }

	    return toBigNumber(toBN(this).shln(value));
	  }

	  shr(value) {
	    if (this.isNegative() || value < 0) {
	      throwFault$1("negative-width", "shr");
	    }

	    return toBigNumber(toBN(this).shrn(value));
	  }

	  eq(other) {
	    return toBN(this).eq(toBN(other));
	  }

	  lt(other) {
	    return toBN(this).lt(toBN(other));
	  }

	  lte(other) {
	    return toBN(this).lte(toBN(other));
	  }

	  gt(other) {
	    return toBN(this).gt(toBN(other));
	  }

	  gte(other) {
	    return toBN(this).gte(toBN(other));
	  }

	  isNegative() {
	    return this._hex[0] === "-";
	  }

	  isZero() {
	    return toBN(this).isZero();
	  }

	  toNumber() {
	    try {
	      return toBN(this).toNumber();
	    } catch (error) {
	      throwFault$1("overflow", "toNumber", this.toString());
	    }

	    return null;
	  }

	  toBigInt() {
	    try {
	      return BigInt(this.toString());
	    } catch (e) {}

	    return logger$n.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
	      value: this.toString()
	    });
	  }

	  toString() {
	    // Lots of people expect this, which we do not support, so check (See: #889)
	    if (arguments.length > 0) {
	      if (arguments[0] === 10) {
	        if (!_warnedToStringRadix) {
	          _warnedToStringRadix = true;
	          logger$n.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
	        }
	      } else if (arguments[0] === 16) {
	        logger$n.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {});
	      } else {
	        logger$n.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {});
	      }
	    }

	    return toBN(this).toString(10);
	  }

	  toHexString() {
	    return this._hex;
	  }

	  toJSON(key) {
	    return {
	      type: "BigNumber",
	      hex: this.toHexString()
	    };
	  }

	  static from(value) {
	    if (value instanceof BigNumber) {
	      return value;
	    }

	    if (typeof value === "string") {
	      if (value.match(/^-?0x[0-9a-f]+$/i)) {
	        return new BigNumber(_constructorGuard$3, toHex$1(value));
	      }

	      if (value.match(/^-?[0-9]+$/)) {
	        return new BigNumber(_constructorGuard$3, toHex$1(new BN(value)));
	      }

	      return logger$n.throwArgumentError("invalid BigNumber string", "value", value);
	    }

	    if (typeof value === "number") {
	      if (value % 1) {
	        throwFault$1("underflow", "BigNumber.from", value);
	      }

	      if (value >= MAX_SAFE || value <= -MAX_SAFE) {
	        throwFault$1("overflow", "BigNumber.from", value);
	      }

	      return BigNumber.from(String(value));
	    }

	    const anyValue = value;

	    if (typeof anyValue === "bigint") {
	      return BigNumber.from(anyValue.toString());
	    }

	    if (isBytes(anyValue)) {
	      return BigNumber.from(hexlify(anyValue));
	    }

	    if (anyValue) {
	      // Hexable interface (takes priority)
	      if (anyValue.toHexString) {
	        const hex = anyValue.toHexString();

	        if (typeof hex === "string") {
	          return BigNumber.from(hex);
	        }
	      } else {
	        // For now, handle legacy JSON-ified values (goes away in v6)
	        let hex = anyValue._hex; // New-form JSON

	        if (hex == null && anyValue.type === "BigNumber") {
	          hex = anyValue.hex;
	        }

	        if (typeof hex === "string") {
	          if (isHexString(hex) || hex[0] === "-" && isHexString(hex.substring(1))) {
	            return BigNumber.from(hex);
	          }
	        }
	      }
	    }

	    return logger$n.throwArgumentError("invalid BigNumber value", "value", value);
	  }

	  static isBigNumber(value) {
	    return !!(value && value._isBigNumber);
	  }

	} // Normalize the hex string

	function toHex$1(value) {
	  // For BN, call on the hex string
	  if (typeof value !== "string") {
	    return toHex$1(value.toString(16));
	  } // If negative, prepend the negative sign to the normalized positive value


	  if (value[0] === "-") {
	    // Strip off the negative sign
	    value = value.substring(1); // Cannot have multiple negative signs (e.g. "--0x04")

	    if (value[0] === "-") {
	      logger$n.throwArgumentError("invalid hex", "value", value);
	    } // Call toHex on the positive component


	    value = toHex$1(value); // Do not allow "-0x00"

	    if (value === "0x00") {
	      return value;
	    } // Negate the value


	    return "-" + value;
	  } // Add a "0x" prefix if missing


	  if (value.substring(0, 2) !== "0x") {
	    value = "0x" + value;
	  } // Normalize zero


	  if (value === "0x") {
	    return "0x00";
	  } // Make the string even length


	  if (value.length % 2) {
	    value = "0x0" + value.substring(2);
	  } // Trim to smallest even-length string


	  while (value.length > 4 && value.substring(0, 4) === "0x00") {
	    value = "0x" + value.substring(4);
	  }

	  return value;
	}

	function toBigNumber(value) {
	  return BigNumber.from(toHex$1(value));
	}

	function toBN(value) {
	  const hex = BigNumber.from(value).toHexString();

	  if (hex[0] === "-") {
	    return new BN("-" + hex.substring(3), 16);
	  }

	  return new BN(hex.substring(2), 16);
	}

	function throwFault$1(fault, operation, value) {
	  const params = {
	    fault: fault,
	    operation: operation
	  };

	  if (value != null) {
	    params.value = value;
	  }

	  return logger$n.throwError(fault, Logger.errors.NUMERIC_FAULT, params);
	} // value should have no prefix


	function _base36To16(value) {
	  return new BN(value, 36).toString(16);
	} // value should have no prefix

	const logger$m = new Logger(version$g);
	const _constructorGuard$2 = {};
	const Zero$2 = BigNumber.from(0);
	const NegativeOne$2 = BigNumber.from(-1);

	function throwFault(message, fault, operation, value) {
	  const params = {
	    fault: fault,
	    operation: operation
	  };

	  if (value !== undefined) {
	    params.value = value;
	  }

	  return logger$m.throwError(message, Logger.errors.NUMERIC_FAULT, params);
	} // Constant to pull zeros from for multipliers


	let zeros = "0";

	while (zeros.length < 256) {
	  zeros += zeros;
	} // Returns a string "1" followed by decimal "0"s


	function getMultiplier(decimals) {
	  if (typeof decimals !== "number") {
	    try {
	      decimals = BigNumber.from(decimals).toNumber();
	    } catch (e) {}
	  }

	  if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
	    return "1" + zeros.substring(0, decimals);
	  }

	  return logger$m.throwArgumentError("invalid decimal size", "decimals", decimals);
	}

	function formatFixed(value, decimals) {
	  if (decimals == null) {
	    decimals = 0;
	  }

	  const multiplier = getMultiplier(decimals); // Make sure wei is a big number (convert as necessary)

	  value = BigNumber.from(value);
	  const negative = value.lt(Zero$2);

	  if (negative) {
	    value = value.mul(NegativeOne$2);
	  }

	  let fraction = value.mod(multiplier).toString();

	  while (fraction.length < multiplier.length - 1) {
	    fraction = "0" + fraction;
	  } // Strip training 0


	  fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
	  const whole = value.div(multiplier).toString();

	  if (multiplier.length === 1) {
	    value = whole;
	  } else {
	    value = whole + "." + fraction;
	  }

	  if (negative) {
	    value = "-" + value;
	  }

	  return value;
	}
	function parseFixed(value, decimals) {
	  if (decimals == null) {
	    decimals = 0;
	  }

	  const multiplier = getMultiplier(decimals);

	  if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) {
	    logger$m.throwArgumentError("invalid decimal value", "value", value);
	  } // Is it negative?


	  const negative = value.substring(0, 1) === "-";

	  if (negative) {
	    value = value.substring(1);
	  }

	  if (value === ".") {
	    logger$m.throwArgumentError("missing value", "value", value);
	  } // Split it into a whole and fractional part


	  const comps = value.split(".");

	  if (comps.length > 2) {
	    logger$m.throwArgumentError("too many decimal points", "value", value);
	  }

	  let whole = comps[0],
	      fraction = comps[1];

	  if (!whole) {
	    whole = "0";
	  }

	  if (!fraction) {
	    fraction = "0";
	  } // Trim trailing zeros


	  while (fraction[fraction.length - 1] === "0") {
	    fraction = fraction.substring(0, fraction.length - 1);
	  } // Check the fraction doesn't exceed our decimals size


	  if (fraction.length > multiplier.length - 1) {
	    throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
	  } // If decimals is 0, we have an empty string for fraction


	  if (fraction === "") {
	    fraction = "0";
	  } // Fully pad the string with zeros to get to wei


	  while (fraction.length < multiplier.length - 1) {
	    fraction += "0";
	  }

	  const wholeValue = BigNumber.from(whole);
	  const fractionValue = BigNumber.from(fraction);
	  let wei = wholeValue.mul(multiplier).add(fractionValue);

	  if (negative) {
	    wei = wei.mul(NegativeOne$2);
	  }

	  return wei;
	}
	class FixedFormat {
	  constructor(constructorGuard, signed, width, decimals) {
	    if (constructorGuard !== _constructorGuard$2) {
	      logger$m.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "new FixedFormat"
	      });
	    }

	    this.signed = signed;
	    this.width = width;
	    this.decimals = decimals;
	    this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
	    this._multiplier = getMultiplier(decimals);
	    Object.freeze(this);
	  }

	  static from(value) {
	    if (value instanceof FixedFormat) {
	      return value;
	    }

	    if (typeof value === "number") {
	      value = `fixed128x${value}`;
	    }

	    let signed = true;
	    let width = 128;
	    let decimals = 18;

	    if (typeof value === "string") {
	      if (value === "fixed") ; else if (value === "ufixed") {
	        signed = false;
	      } else {
	        const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);

	        if (!match) {
	          logger$m.throwArgumentError("invalid fixed format", "format", value);
	        }

	        signed = match[1] !== "u";
	        width = parseInt(match[2]);
	        decimals = parseInt(match[3]);
	      }
	    } else if (value) {
	      const check = (key, type, defaultValue) => {
	        if (value[key] == null) {
	          return defaultValue;
	        }

	        if (typeof value[key] !== type) {
	          logger$m.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
	        }

	        return value[key];
	      };

	      signed = check("signed", "boolean", signed);
	      width = check("width", "number", width);
	      decimals = check("decimals", "number", decimals);
	    }

	    if (width % 8) {
	      logger$m.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
	    }

	    if (decimals > 80) {
	      logger$m.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
	    }

	    return new FixedFormat(_constructorGuard$2, signed, width, decimals);
	  }

	}
	class FixedNumber {
	  constructor(constructorGuard, hex, value, format) {
	    if (constructorGuard !== _constructorGuard$2) {
	      logger$m.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "new FixedFormat"
	      });
	    }

	    this.format = format;
	    this._hex = hex;
	    this._value = value;
	    this._isFixedNumber = true;
	    Object.freeze(this);
	  }

	  _checkFormat(other) {
	    if (this.format.name !== other.format.name) {
	      logger$m.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
	    }
	  }

	  addUnsafe(other) {
	    this._checkFormat(other);

	    const a = parseFixed(this._value, this.format.decimals);
	    const b = parseFixed(other._value, other.format.decimals);
	    return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
	  }

	  subUnsafe(other) {
	    this._checkFormat(other);

	    const a = parseFixed(this._value, this.format.decimals);
	    const b = parseFixed(other._value, other.format.decimals);
	    return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
	  }

	  mulUnsafe(other) {
	    this._checkFormat(other);

	    const a = parseFixed(this._value, this.format.decimals);
	    const b = parseFixed(other._value, other.format.decimals);
	    return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
	  }

	  divUnsafe(other) {
	    this._checkFormat(other);

	    const a = parseFixed(this._value, this.format.decimals);
	    const b = parseFixed(other._value, other.format.decimals);
	    return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
	  }

	  floor() {
	    const comps = this.toString().split(".");

	    if (comps.length === 1) {
	      comps.push("0");
	    }

	    let result = FixedNumber.from(comps[0], this.format);
	    const hasFraction = !comps[1].match(/^(0*)$/);

	    if (this.isNegative() && hasFraction) {
	      result = result.subUnsafe(ONE.toFormat(result.format));
	    }

	    return result;
	  }

	  ceiling() {
	    const comps = this.toString().split(".");

	    if (comps.length === 1) {
	      comps.push("0");
	    }

	    let result = FixedNumber.from(comps[0], this.format);
	    const hasFraction = !comps[1].match(/^(0*)$/);

	    if (!this.isNegative() && hasFraction) {
	      result = result.addUnsafe(ONE.toFormat(result.format));
	    }

	    return result;
	  } // @TODO: Support other rounding algorithms


	  round(decimals) {
	    if (decimals == null) {
	      decimals = 0;
	    } // If we are already in range, we're done


	    const comps = this.toString().split(".");

	    if (comps.length === 1) {
	      comps.push("0");
	    }

	    if (decimals < 0 || decimals > 80 || decimals % 1) {
	      logger$m.throwArgumentError("invalid decimal count", "decimals", decimals);
	    }

	    if (comps[1].length <= decimals) {
	      return this;
	    }

	    const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
	    const bump = BUMP.toFormat(this.format);
	    return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
	  }

	  isZero() {
	    return this._value === "0.0" || this._value === "0";
	  }

	  isNegative() {
	    return this._value[0] === "-";
	  }

	  toString() {
	    return this._value;
	  }

	  toHexString(width) {
	    if (width == null) {
	      return this._hex;
	    }

	    if (width % 8) {
	      logger$m.throwArgumentError("invalid byte width", "width", width);
	    }

	    const hex = BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
	    return hexZeroPad(hex, width / 8);
	  }

	  toUnsafeFloat() {
	    return parseFloat(this.toString());
	  }

	  toFormat(format) {
	    return FixedNumber.fromString(this._value, format);
	  }

	  static fromValue(value, decimals, format) {
	    // If decimals looks more like a format, and there is no format, shift the parameters
	    if (format == null && decimals != null && !isBigNumberish(decimals)) {
	      format = decimals;
	      decimals = null;
	    }

	    if (decimals == null) {
	      decimals = 0;
	    }

	    if (format == null) {
	      format = "fixed";
	    }

	    return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
	  }

	  static fromString(value, format) {
	    if (format == null) {
	      format = "fixed";
	    }

	    const fixedFormat = FixedFormat.from(format);
	    const numeric = parseFixed(value, fixedFormat.decimals);

	    if (!fixedFormat.signed && numeric.lt(Zero$2)) {
	      throwFault("unsigned value cannot be negative", "overflow", "value", value);
	    }

	    let hex = null;

	    if (fixedFormat.signed) {
	      hex = numeric.toTwos(fixedFormat.width).toHexString();
	    } else {
	      hex = numeric.toHexString();
	      hex = hexZeroPad(hex, fixedFormat.width / 8);
	    }

	    const decimal = formatFixed(numeric, fixedFormat.decimals);
	    return new FixedNumber(_constructorGuard$2, hex, decimal, fixedFormat);
	  }

	  static fromBytes(value, format) {
	    if (format == null) {
	      format = "fixed";
	    }

	    const fixedFormat = FixedFormat.from(format);

	    if (arrayify(value).length > fixedFormat.width / 8) {
	      throw new Error("overflow");
	    }

	    let numeric = BigNumber.from(value);

	    if (fixedFormat.signed) {
	      numeric = numeric.fromTwos(fixedFormat.width);
	    }

	    const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
	    const decimal = formatFixed(numeric, fixedFormat.decimals);
	    return new FixedNumber(_constructorGuard$2, hex, decimal, fixedFormat);
	  }

	  static from(value, format) {
	    if (typeof value === "string") {
	      return FixedNumber.fromString(value, format);
	    }

	    if (isBytes(value)) {
	      return FixedNumber.fromBytes(value, format);
	    }

	    try {
	      return FixedNumber.fromValue(value, 0, format);
	    } catch (error) {
	      // Allow NUMERIC_FAULT to bubble up
	      if (error.code !== Logger.errors.INVALID_ARGUMENT) {
	        throw error;
	      }
	    }

	    return logger$m.throwArgumentError("invalid FixedNumber value", "value", value);
	  }

	  static isFixedNumber(value) {
	    return !!(value && value._isFixedNumber);
	  }

	}
	const ONE = FixedNumber.from(1);
	const BUMP = FixedNumber.from("0.5");

	const version$f = "properties/5.7.0";

	var __awaiter$8 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$l = new Logger(version$f);
	function defineReadOnly(object, name, value) {
	  Object.defineProperty(object, name, {
	    enumerable: true,
	    value: value,
	    writable: false
	  });
	} // Crawl up the constructor chain to find a static method

	function getStatic(ctor, key) {
	  for (let i = 0; i < 32; i++) {
	    if (ctor[key]) {
	      return ctor[key];
	    }

	    if (!ctor.prototype || typeof ctor.prototype !== "object") {
	      break;
	    }

	    ctor = Object.getPrototypeOf(ctor.prototype).constructor;
	  }

	  return null;
	}
	function resolveProperties(object) {
	  return __awaiter$8(this, void 0, void 0, function* () {
	    const promises = Object.keys(object).map(key => {
	      const value = object[key];
	      return Promise.resolve(value).then(v => ({
	        key: key,
	        value: v
	      }));
	    });
	    const results = yield Promise.all(promises);
	    return results.reduce((accum, result) => {
	      accum[result.key] = result.value;
	      return accum;
	    }, {});
	  });
	}
	function checkProperties(object, properties) {
	  if (!object || typeof object !== "object") {
	    logger$l.throwArgumentError("invalid object", "object", object);
	  }

	  Object.keys(object).forEach(key => {
	    if (!properties[key]) {
	      logger$l.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
	    }
	  });
	}
	function shallowCopy(object) {
	  const result = {};

	  for (const key in object) {
	    result[key] = object[key];
	  }

	  return result;
	}
	const opaque = {
	  bigint: true,
	  boolean: true,
	  "function": true,
	  number: true,
	  string: true
	};

	function _isFrozen(object) {
	  // Opaque objects are not mutable, so safe to copy by assignment
	  if (object === undefined || object === null || opaque[typeof object]) {
	    return true;
	  }

	  if (Array.isArray(object) || typeof object === "object") {
	    if (!Object.isFrozen(object)) {
	      return false;
	    }

	    const keys = Object.keys(object);

	    for (let i = 0; i < keys.length; i++) {
	      let value = null;

	      try {
	        value = object[keys[i]];
	      } catch (error) {
	        // If accessing a value triggers an error, it is a getter
	        // designed to do so (e.g. Result) and is therefore "frozen"
	        continue;
	      }

	      if (!_isFrozen(value)) {
	        return false;
	      }
	    }

	    return true;
	  }

	  return logger$l.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
	} // Returns a new copy of object, such that no properties may be replaced.
	// New properties may be added only to objects.


	function _deepCopy(object) {
	  if (_isFrozen(object)) {
	    return object;
	  } // Arrays are mutable, so we need to create a copy


	  if (Array.isArray(object)) {
	    return Object.freeze(object.map(item => deepCopy(item)));
	  }

	  if (typeof object === "object") {
	    const result = {};

	    for (const key in object) {
	      const value = object[key];

	      if (value === undefined) {
	        continue;
	      }

	      defineReadOnly(result, key, deepCopy(value));
	    }

	    return result;
	  }

	  return logger$l.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
	}

	function deepCopy(object) {
	  return _deepCopy(object);
	}
	class Description {
	  constructor(info) {
	    for (const key in info) {
	      this[key] = deepCopy(info[key]);
	    }
	  }

	}

	const version$e = "abi/5.7.0";

	const logger$k = new Logger(version$e);
	const _constructorGuard$1 = {};
	let ModifiersBytes = {
	  calldata: true,
	  memory: true,
	  storage: true
	};
	let ModifiersNest = {
	  calldata: true,
	  memory: true
	};

	function checkModifier(type, name) {
	  if (type === "bytes" || type === "string") {
	    if (ModifiersBytes[name]) {
	      return true;
	    }
	  } else if (type === "address") {
	    if (name === "payable") {
	      return true;
	    }
	  } else if (type.indexOf("[") >= 0 || type === "tuple") {
	    if (ModifiersNest[name]) {
	      return true;
	    }
	  }

	  if (ModifiersBytes[name] || name === "payable") {
	    logger$k.throwArgumentError("invalid modifier", "name", name);
	  }

	  return false;
	} // @TODO: Make sure that children of an indexed tuple are marked with a null indexed


	function parseParamType(param, allowIndexed) {
	  let originalParam = param;

	  function throwError(i) {
	    logger$k.throwArgumentError(`unexpected character at position ${i}`, "param", param);
	  }

	  param = param.replace(/\s/g, " ");

	  function newNode(parent) {
	    let node = {
	      type: "",
	      name: "",
	      parent: parent,
	      state: {
	        allowType: true
	      }
	    };

	    if (allowIndexed) {
	      node.indexed = false;
	    }

	    return node;
	  }

	  let parent = {
	    type: "",
	    name: "",
	    state: {
	      allowType: true
	    }
	  };
	  let node = parent;

	  for (let i = 0; i < param.length; i++) {
	    let c = param[i];

	    switch (c) {
	      case "(":
	        if (node.state.allowType && node.type === "") {
	          node.type = "tuple";
	        } else if (!node.state.allowParams) {
	          throwError(i);
	        }

	        node.state.allowType = false;
	        node.type = verifyType(node.type);
	        node.components = [newNode(node)];
	        node = node.components[0];
	        break;

	      case ")":
	        delete node.state;

	        if (node.name === "indexed") {
	          if (!allowIndexed) {
	            throwError(i);
	          }

	          node.indexed = true;
	          node.name = "";
	        }

	        if (checkModifier(node.type, node.name)) {
	          node.name = "";
	        }

	        node.type = verifyType(node.type);
	        let child = node;
	        node = node.parent;

	        if (!node) {
	          throwError(i);
	        }

	        delete child.parent;
	        node.state.allowParams = false;
	        node.state.allowName = true;
	        node.state.allowArray = true;
	        break;

	      case ",":
	        delete node.state;

	        if (node.name === "indexed") {
	          if (!allowIndexed) {
	            throwError(i);
	          }

	          node.indexed = true;
	          node.name = "";
	        }

	        if (checkModifier(node.type, node.name)) {
	          node.name = "";
	        }

	        node.type = verifyType(node.type);
	        let sibling = newNode(node.parent); //{ type: "", name: "", parent: node.parent, state: { allowType: true } };

	        node.parent.components.push(sibling);
	        delete node.parent;
	        node = sibling;
	        break;
	      // Hit a space...

	      case " ":
	        // If reading type, the type is done and may read a param or name
	        if (node.state.allowType) {
	          if (node.type !== "") {
	            node.type = verifyType(node.type);
	            delete node.state.allowType;
	            node.state.allowName = true;
	            node.state.allowParams = true;
	          }
	        } // If reading name, the name is done


	        if (node.state.allowName) {
	          if (node.name !== "") {
	            if (node.name === "indexed") {
	              if (!allowIndexed) {
	                throwError(i);
	              }

	              if (node.indexed) {
	                throwError(i);
	              }

	              node.indexed = true;
	              node.name = "";
	            } else if (checkModifier(node.type, node.name)) {
	              node.name = "";
	            } else {
	              node.state.allowName = false;
	            }
	          }
	        }

	        break;

	      case "[":
	        if (!node.state.allowArray) {
	          throwError(i);
	        }

	        node.type += c;
	        node.state.allowArray = false;
	        node.state.allowName = false;
	        node.state.readArray = true;
	        break;

	      case "]":
	        if (!node.state.readArray) {
	          throwError(i);
	        }

	        node.type += c;
	        node.state.readArray = false;
	        node.state.allowArray = true;
	        node.state.allowName = true;
	        break;

	      default:
	        if (node.state.allowType) {
	          node.type += c;
	          node.state.allowParams = true;
	          node.state.allowArray = true;
	        } else if (node.state.allowName) {
	          node.name += c;
	          delete node.state.allowArray;
	        } else if (node.state.readArray) {
	          node.type += c;
	        } else {
	          throwError(i);
	        }

	    }
	  }

	  if (node.parent) {
	    logger$k.throwArgumentError("unexpected eof", "param", param);
	  }

	  delete parent.state;

	  if (node.name === "indexed") {
	    if (!allowIndexed) {
	      throwError(originalParam.length - 7);
	    }

	    if (node.indexed) {
	      throwError(originalParam.length - 7);
	    }

	    node.indexed = true;
	    node.name = "";
	  } else if (checkModifier(node.type, node.name)) {
	    node.name = "";
	  }

	  parent.type = verifyType(parent.type);
	  return parent;
	}

	function populate(object, params) {
	  for (let key in params) {
	    defineReadOnly(object, key, params[key]);
	  }
	}

	const FormatTypes = Object.freeze({
	  // Bare formatting, as is needed for computing a sighash of an event or function
	  sighash: "sighash",
	  // Human-Readable with Minimal spacing and without names (compact human-readable)
	  minimal: "minimal",
	  // Human-Readable with nice spacing, including all names
	  full: "full",
	  // JSON-format a la Solidity
	  json: "json"
	});
	const paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
	class ParamType {
	  constructor(constructorGuard, params) {
	    if (constructorGuard !== _constructorGuard$1) {
	      logger$k.throwError("use fromString", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "new ParamType()"
	      });
	    }

	    populate(this, params);
	    let match = this.type.match(paramTypeArray);

	    if (match) {
	      populate(this, {
	        arrayLength: parseInt(match[2] || "-1"),
	        arrayChildren: ParamType.fromObject({
	          type: match[1],
	          components: this.components
	        }),
	        baseType: "array"
	      });
	    } else {
	      populate(this, {
	        arrayLength: null,
	        arrayChildren: null,
	        baseType: this.components != null ? "tuple" : this.type
	      });
	    }

	    this._isParamType = true;
	    Object.freeze(this);
	  } // Format the parameter fragment
	  //   - sighash: "(uint256,address)"
	  //   - minimal: "tuple(uint256,address) indexed"
	  //   - full:    "tuple(uint256 foo, address bar) indexed baz"


	  format(format) {
	    if (!format) {
	      format = FormatTypes.sighash;
	    }

	    if (!FormatTypes[format]) {
	      logger$k.throwArgumentError("invalid format type", "format", format);
	    }

	    if (format === FormatTypes.json) {
	      let result = {
	        type: this.baseType === "tuple" ? "tuple" : this.type,
	        name: this.name || undefined
	      };

	      if (typeof this.indexed === "boolean") {
	        result.indexed = this.indexed;
	      }

	      if (this.components) {
	        result.components = this.components.map(comp => JSON.parse(comp.format(format)));
	      }

	      return JSON.stringify(result);
	    }

	    let result = ""; // Array

	    if (this.baseType === "array") {
	      result += this.arrayChildren.format(format);
	      result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
	    } else {
	      if (this.baseType === "tuple") {
	        if (format !== FormatTypes.sighash) {
	          result += this.type;
	        }

	        result += "(" + this.components.map(comp => comp.format(format)).join(format === FormatTypes.full ? ", " : ",") + ")";
	      } else {
	        result += this.type;
	      }
	    }

	    if (format !== FormatTypes.sighash) {
	      if (this.indexed === true) {
	        result += " indexed";
	      }

	      if (format === FormatTypes.full && this.name) {
	        result += " " + this.name;
	      }
	    }

	    return result;
	  }

	  static from(value, allowIndexed) {
	    if (typeof value === "string") {
	      return ParamType.fromString(value, allowIndexed);
	    }

	    return ParamType.fromObject(value);
	  }

	  static fromObject(value) {
	    if (ParamType.isParamType(value)) {
	      return value;
	    }

	    return new ParamType(_constructorGuard$1, {
	      name: value.name || null,
	      type: verifyType(value.type),
	      indexed: value.indexed == null ? null : !!value.indexed,
	      components: value.components ? value.components.map(ParamType.fromObject) : null
	    });
	  }

	  static fromString(value, allowIndexed) {
	    function ParamTypify(node) {
	      return ParamType.fromObject({
	        name: node.name,
	        type: node.type,
	        indexed: node.indexed,
	        components: node.components
	      });
	    }

	    return ParamTypify(parseParamType(value, !!allowIndexed));
	  }

	  static isParamType(value) {
	    return !!(value != null && value._isParamType);
	  }

	}

	function parseParams(value, allowIndex) {
	  return splitNesting(value).map(param => ParamType.fromString(param, allowIndex));
	}

	class Fragment {
	  constructor(constructorGuard, params) {
	    if (constructorGuard !== _constructorGuard$1) {
	      logger$k.throwError("use a static from method", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "new Fragment()"
	      });
	    }

	    populate(this, params);
	    this._isFragment = true;
	    Object.freeze(this);
	  }

	  static from(value) {
	    if (Fragment.isFragment(value)) {
	      return value;
	    }

	    if (typeof value === "string") {
	      return Fragment.fromString(value);
	    }

	    return Fragment.fromObject(value);
	  }

	  static fromObject(value) {
	    if (Fragment.isFragment(value)) {
	      return value;
	    }

	    switch (value.type) {
	      case "function":
	        return FunctionFragment.fromObject(value);

	      case "event":
	        return EventFragment.fromObject(value);

	      case "constructor":
	        return ConstructorFragment.fromObject(value);

	      case "error":
	        return ErrorFragment.fromObject(value);

	      case "fallback":
	      case "receive":
	        // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
	        return null;
	    }

	    return logger$k.throwArgumentError("invalid fragment object", "value", value);
	  }

	  static fromString(value) {
	    // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
	    value = value.replace(/\s/g, " ");
	    value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
	    value = value.trim();

	    if (value.split(" ")[0] === "event") {
	      return EventFragment.fromString(value.substring(5).trim());
	    } else if (value.split(" ")[0] === "function") {
	      return FunctionFragment.fromString(value.substring(8).trim());
	    } else if (value.split("(")[0].trim() === "constructor") {
	      return ConstructorFragment.fromString(value.trim());
	    } else if (value.split(" ")[0] === "error") {
	      return ErrorFragment.fromString(value.substring(5).trim());
	    }

	    return logger$k.throwArgumentError("unsupported fragment", "value", value);
	  }

	  static isFragment(value) {
	    return !!(value && value._isFragment);
	  }

	}
	class EventFragment extends Fragment {
	  format(format) {
	    if (!format) {
	      format = FormatTypes.sighash;
	    }

	    if (!FormatTypes[format]) {
	      logger$k.throwArgumentError("invalid format type", "format", format);
	    }

	    if (format === FormatTypes.json) {
	      return JSON.stringify({
	        type: "event",
	        anonymous: this.anonymous,
	        name: this.name,
	        inputs: this.inputs.map(input => JSON.parse(input.format(format)))
	      });
	    }

	    let result = "";

	    if (format !== FormatTypes.sighash) {
	      result += "event ";
	    }

	    result += this.name + "(" + this.inputs.map(input => input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";

	    if (format !== FormatTypes.sighash) {
	      if (this.anonymous) {
	        result += "anonymous ";
	      }
	    }

	    return result.trim();
	  }

	  static from(value) {
	    if (typeof value === "string") {
	      return EventFragment.fromString(value);
	    }

	    return EventFragment.fromObject(value);
	  }

	  static fromObject(value) {
	    if (EventFragment.isEventFragment(value)) {
	      return value;
	    }

	    if (value.type !== "event") {
	      logger$k.throwArgumentError("invalid event object", "value", value);
	    }

	    const params = {
	      name: verifyIdentifier(value.name),
	      anonymous: value.anonymous,
	      inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : [],
	      type: "event"
	    };
	    return new EventFragment(_constructorGuard$1, params);
	  }

	  static fromString(value) {
	    let match = value.match(regexParen);

	    if (!match) {
	      logger$k.throwArgumentError("invalid event string", "value", value);
	    }

	    let anonymous = false;
	    match[3].split(" ").forEach(modifier => {
	      switch (modifier.trim()) {
	        case "anonymous":
	          anonymous = true;
	          break;

	        case "":
	          break;

	        default:
	          logger$k.warn("unknown modifier: " + modifier);
	      }
	    });
	    return EventFragment.fromObject({
	      name: match[1].trim(),
	      anonymous: anonymous,
	      inputs: parseParams(match[2], true),
	      type: "event"
	    });
	  }

	  static isEventFragment(value) {
	    return value && value._isFragment && value.type === "event";
	  }

	}

	function parseGas(value, params) {
	  params.gas = null;
	  let comps = value.split("@");

	  if (comps.length !== 1) {
	    if (comps.length > 2) {
	      logger$k.throwArgumentError("invalid human-readable ABI signature", "value", value);
	    }

	    if (!comps[1].match(/^[0-9]+$/)) {
	      logger$k.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
	    }

	    params.gas = BigNumber.from(comps[1]);
	    return comps[0];
	  }

	  return value;
	}

	function parseModifiers(value, params) {
	  params.constant = false;
	  params.payable = false;
	  params.stateMutability = "nonpayable";
	  value.split(" ").forEach(modifier => {
	    switch (modifier.trim()) {
	      case "constant":
	        params.constant = true;
	        break;

	      case "payable":
	        params.payable = true;
	        params.stateMutability = "payable";
	        break;

	      case "nonpayable":
	        params.payable = false;
	        params.stateMutability = "nonpayable";
	        break;

	      case "pure":
	        params.constant = true;
	        params.stateMutability = "pure";
	        break;

	      case "view":
	        params.constant = true;
	        params.stateMutability = "view";
	        break;
	    }
	  });
	}

	function verifyState(value) {
	  let result = {
	    constant: false,
	    payable: true,
	    stateMutability: "payable"
	  };

	  if (value.stateMutability != null) {
	    result.stateMutability = value.stateMutability; // Set (and check things are consistent) the constant property

	    result.constant = result.stateMutability === "view" || result.stateMutability === "pure";

	    if (value.constant != null) {
	      if (!!value.constant !== result.constant) {
	        logger$k.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
	      }
	    } // Set (and check things are consistent) the payable property


	    result.payable = result.stateMutability === "payable";

	    if (value.payable != null) {
	      if (!!value.payable !== result.payable) {
	        logger$k.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
	      }
	    }
	  } else if (value.payable != null) {
	    result.payable = !!value.payable; // If payable we can assume non-constant; otherwise we can't assume

	    if (value.constant == null && !result.payable && value.type !== "constructor") {
	      logger$k.throwArgumentError("unable to determine stateMutability", "value", value);
	    }

	    result.constant = !!value.constant;

	    if (result.constant) {
	      result.stateMutability = "view";
	    } else {
	      result.stateMutability = result.payable ? "payable" : "nonpayable";
	    }

	    if (result.payable && result.constant) {
	      logger$k.throwArgumentError("cannot have constant payable function", "value", value);
	    }
	  } else if (value.constant != null) {
	    result.constant = !!value.constant;
	    result.payable = !result.constant;
	    result.stateMutability = result.constant ? "view" : "payable";
	  } else if (value.type !== "constructor") {
	    logger$k.throwArgumentError("unable to determine stateMutability", "value", value);
	  }

	  return result;
	}

	class ConstructorFragment extends Fragment {
	  format(format) {
	    if (!format) {
	      format = FormatTypes.sighash;
	    }

	    if (!FormatTypes[format]) {
	      logger$k.throwArgumentError("invalid format type", "format", format);
	    }

	    if (format === FormatTypes.json) {
	      return JSON.stringify({
	        type: "constructor",
	        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
	        payable: this.payable,
	        gas: this.gas ? this.gas.toNumber() : undefined,
	        inputs: this.inputs.map(input => JSON.parse(input.format(format)))
	      });
	    }

	    if (format === FormatTypes.sighash) {
	      logger$k.throwError("cannot format a constructor for sighash", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "format(sighash)"
	      });
	    }

	    let result = "constructor(" + this.inputs.map(input => input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";

	    if (this.stateMutability && this.stateMutability !== "nonpayable") {
	      result += this.stateMutability + " ";
	    }

	    return result.trim();
	  }

	  static from(value) {
	    if (typeof value === "string") {
	      return ConstructorFragment.fromString(value);
	    }

	    return ConstructorFragment.fromObject(value);
	  }

	  static fromObject(value) {
	    if (ConstructorFragment.isConstructorFragment(value)) {
	      return value;
	    }

	    if (value.type !== "constructor") {
	      logger$k.throwArgumentError("invalid constructor object", "value", value);
	    }

	    let state = verifyState(value);

	    if (state.constant) {
	      logger$k.throwArgumentError("constructor cannot be constant", "value", value);
	    }

	    const params = {
	      name: null,
	      type: value.type,
	      inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : [],
	      payable: state.payable,
	      stateMutability: state.stateMutability,
	      gas: value.gas ? BigNumber.from(value.gas) : null
	    };
	    return new ConstructorFragment(_constructorGuard$1, params);
	  }

	  static fromString(value) {
	    let params = {
	      type: "constructor"
	    };
	    value = parseGas(value, params);
	    let parens = value.match(regexParen);

	    if (!parens || parens[1].trim() !== "constructor") {
	      logger$k.throwArgumentError("invalid constructor string", "value", value);
	    }

	    params.inputs = parseParams(parens[2].trim(), false);
	    parseModifiers(parens[3].trim(), params);
	    return ConstructorFragment.fromObject(params);
	  }

	  static isConstructorFragment(value) {
	    return value && value._isFragment && value.type === "constructor";
	  }

	}
	class FunctionFragment extends ConstructorFragment {
	  format(format) {
	    if (!format) {
	      format = FormatTypes.sighash;
	    }

	    if (!FormatTypes[format]) {
	      logger$k.throwArgumentError("invalid format type", "format", format);
	    }

	    if (format === FormatTypes.json) {
	      return JSON.stringify({
	        type: "function",
	        name: this.name,
	        constant: this.constant,
	        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
	        payable: this.payable,
	        gas: this.gas ? this.gas.toNumber() : undefined,
	        inputs: this.inputs.map(input => JSON.parse(input.format(format))),
	        outputs: this.outputs.map(output => JSON.parse(output.format(format)))
	      });
	    }

	    let result = "";

	    if (format !== FormatTypes.sighash) {
	      result += "function ";
	    }

	    result += this.name + "(" + this.inputs.map(input => input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";

	    if (format !== FormatTypes.sighash) {
	      if (this.stateMutability) {
	        if (this.stateMutability !== "nonpayable") {
	          result += this.stateMutability + " ";
	        }
	      } else if (this.constant) {
	        result += "view ";
	      }

	      if (this.outputs && this.outputs.length) {
	        result += "returns (" + this.outputs.map(output => output.format(format)).join(", ") + ") ";
	      }

	      if (this.gas != null) {
	        result += "@" + this.gas.toString() + " ";
	      }
	    }

	    return result.trim();
	  }

	  static from(value) {
	    if (typeof value === "string") {
	      return FunctionFragment.fromString(value);
	    }

	    return FunctionFragment.fromObject(value);
	  }

	  static fromObject(value) {
	    if (FunctionFragment.isFunctionFragment(value)) {
	      return value;
	    }

	    if (value.type !== "function") {
	      logger$k.throwArgumentError("invalid function object", "value", value);
	    }

	    let state = verifyState(value);
	    const params = {
	      type: value.type,
	      name: verifyIdentifier(value.name),
	      constant: state.constant,
	      inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : [],
	      outputs: value.outputs ? value.outputs.map(ParamType.fromObject) : [],
	      payable: state.payable,
	      stateMutability: state.stateMutability,
	      gas: value.gas ? BigNumber.from(value.gas) : null
	    };
	    return new FunctionFragment(_constructorGuard$1, params);
	  }

	  static fromString(value) {
	    let params = {
	      type: "function"
	    };
	    value = parseGas(value, params);
	    let comps = value.split(" returns ");

	    if (comps.length > 2) {
	      logger$k.throwArgumentError("invalid function string", "value", value);
	    }

	    let parens = comps[0].match(regexParen);

	    if (!parens) {
	      logger$k.throwArgumentError("invalid function signature", "value", value);
	    }

	    params.name = parens[1].trim();

	    if (params.name) {
	      verifyIdentifier(params.name);
	    }

	    params.inputs = parseParams(parens[2], false);
	    parseModifiers(parens[3].trim(), params); // We have outputs

	    if (comps.length > 1) {
	      let returns = comps[1].match(regexParen);

	      if (returns[1].trim() != "" || returns[3].trim() != "") {
	        logger$k.throwArgumentError("unexpected tokens", "value", value);
	      }

	      params.outputs = parseParams(returns[2], false);
	    } else {
	      params.outputs = [];
	    }

	    return FunctionFragment.fromObject(params);
	  }

	  static isFunctionFragment(value) {
	    return value && value._isFragment && value.type === "function";
	  }

	} //export class StructFragment extends Fragment {
	//}

	function checkForbidden(fragment) {
	  const sig = fragment.format();

	  if (sig === "Error(string)" || sig === "Panic(uint256)") {
	    logger$k.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
	  }

	  return fragment;
	}

	class ErrorFragment extends Fragment {
	  format(format) {
	    if (!format) {
	      format = FormatTypes.sighash;
	    }

	    if (!FormatTypes[format]) {
	      logger$k.throwArgumentError("invalid format type", "format", format);
	    }

	    if (format === FormatTypes.json) {
	      return JSON.stringify({
	        type: "error",
	        name: this.name,
	        inputs: this.inputs.map(input => JSON.parse(input.format(format)))
	      });
	    }

	    let result = "";

	    if (format !== FormatTypes.sighash) {
	      result += "error ";
	    }

	    result += this.name + "(" + this.inputs.map(input => input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";
	    return result.trim();
	  }

	  static from(value) {
	    if (typeof value === "string") {
	      return ErrorFragment.fromString(value);
	    }

	    return ErrorFragment.fromObject(value);
	  }

	  static fromObject(value) {
	    if (ErrorFragment.isErrorFragment(value)) {
	      return value;
	    }

	    if (value.type !== "error") {
	      logger$k.throwArgumentError("invalid error object", "value", value);
	    }

	    const params = {
	      type: value.type,
	      name: verifyIdentifier(value.name),
	      inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : []
	    };
	    return checkForbidden(new ErrorFragment(_constructorGuard$1, params));
	  }

	  static fromString(value) {
	    let params = {
	      type: "error"
	    };
	    let parens = value.match(regexParen);

	    if (!parens) {
	      logger$k.throwArgumentError("invalid error signature", "value", value);
	    }

	    params.name = parens[1].trim();

	    if (params.name) {
	      verifyIdentifier(params.name);
	    }

	    params.inputs = parseParams(parens[2], false);
	    return checkForbidden(ErrorFragment.fromObject(params));
	  }

	  static isErrorFragment(value) {
	    return value && value._isFragment && value.type === "error";
	  }

	}

	function verifyType(type) {
	  // These need to be transformed to their full description
	  if (type.match(/^uint($|[^1-9])/)) {
	    type = "uint256" + type.substring(4);
	  } else if (type.match(/^int($|[^1-9])/)) {
	    type = "int256" + type.substring(3);
	  } // @TODO: more verification


	  return type;
	} // See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234


	const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");

	function verifyIdentifier(value) {
	  if (!value || !value.match(regexIdentifier)) {
	    logger$k.throwArgumentError(`invalid identifier "${value}"`, "value", value);
	  }

	  return value;
	}

	const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");

	function splitNesting(value) {
	  value = value.trim();
	  let result = [];
	  let accum = "";
	  let depth = 0;

	  for (let offset = 0; offset < value.length; offset++) {
	    let c = value[offset];

	    if (c === "," && depth === 0) {
	      result.push(accum);
	      accum = "";
	    } else {
	      accum += c;

	      if (c === "(") {
	        depth++;
	      } else if (c === ")") {
	        depth--;

	        if (depth === -1) {
	          logger$k.throwArgumentError("unbalanced parenthesis", "value", value);
	        }
	      }
	    }
	  }

	  if (accum) {
	    result.push(accum);
	  }

	  return result;
	}

	const logger$j = new Logger(version$e);
	function checkResultErrors(result) {
	  // Find the first error (if any)
	  const errors = [];

	  const checkErrors = function (path, object) {
	    if (!Array.isArray(object)) {
	      return;
	    }

	    for (let key in object) {
	      const childPath = path.slice();
	      childPath.push(key);

	      try {
	        checkErrors(childPath, object[key]);
	      } catch (error) {
	        errors.push({
	          path: childPath,
	          error: error
	        });
	      }
	    }
	  };

	  checkErrors([], result);
	  return errors;
	}
	class Coder {
	  constructor(name, type, localName, dynamic) {
	    // @TODO: defineReadOnly these
	    this.name = name;
	    this.type = type;
	    this.localName = localName;
	    this.dynamic = dynamic;
	  }

	  _throwError(message, value) {
	    logger$j.throwArgumentError(message, this.localName, value);
	  }

	}
	class Writer {
	  constructor(wordSize) {
	    defineReadOnly(this, "wordSize", wordSize || 32);
	    this._data = [];
	    this._dataLength = 0;
	    this._padding = new Uint8Array(wordSize);
	  }

	  get data() {
	    return hexConcat(this._data);
	  }

	  get length() {
	    return this._dataLength;
	  }

	  _writeData(data) {
	    this._data.push(data);

	    this._dataLength += data.length;
	    return data.length;
	  }

	  appendWriter(writer) {
	    return this._writeData(concat$1(writer._data));
	  } // Arrayish items; padded on the right to wordSize


	  writeBytes(value) {
	    let bytes = arrayify(value);
	    const paddingOffset = bytes.length % this.wordSize;

	    if (paddingOffset) {
	      bytes = concat$1([bytes, this._padding.slice(paddingOffset)]);
	    }

	    return this._writeData(bytes);
	  }

	  _getValue(value) {
	    let bytes = arrayify(BigNumber.from(value));

	    if (bytes.length > this.wordSize) {
	      logger$j.throwError("value out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
	        length: this.wordSize,
	        offset: bytes.length
	      });
	    }

	    if (bytes.length % this.wordSize) {
	      bytes = concat$1([this._padding.slice(bytes.length % this.wordSize), bytes]);
	    }

	    return bytes;
	  } // BigNumberish items; padded on the left to wordSize


	  writeValue(value) {
	    return this._writeData(this._getValue(value));
	  }

	  writeUpdatableValue() {
	    const offset = this._data.length;

	    this._data.push(this._padding);

	    this._dataLength += this.wordSize;
	    return value => {
	      this._data[offset] = this._getValue(value);
	    };
	  }

	}
	class Reader {
	  constructor(data, wordSize, coerceFunc, allowLoose) {
	    defineReadOnly(this, "_data", arrayify(data));
	    defineReadOnly(this, "wordSize", wordSize || 32);
	    defineReadOnly(this, "_coerceFunc", coerceFunc);
	    defineReadOnly(this, "allowLoose", allowLoose);
	    this._offset = 0;
	  }

	  get data() {
	    return hexlify(this._data);
	  }

	  get consumed() {
	    return this._offset;
	  } // The default Coerce function


	  static coerce(name, value) {
	    let match = name.match("^u?int([0-9]+)$");

	    if (match && parseInt(match[1]) <= 48) {
	      value = value.toNumber();
	    }

	    return value;
	  }

	  coerce(name, value) {
	    if (this._coerceFunc) {
	      return this._coerceFunc(name, value);
	    }

	    return Reader.coerce(name, value);
	  }

	  _peekBytes(offset, length, loose) {
	    let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;

	    if (this._offset + alignedLength > this._data.length) {
	      if (this.allowLoose && loose && this._offset + length <= this._data.length) {
	        alignedLength = length;
	      } else {
	        logger$j.throwError("data out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
	          length: this._data.length,
	          offset: this._offset + alignedLength
	        });
	      }
	    }

	    return this._data.slice(this._offset, this._offset + alignedLength);
	  }

	  subReader(offset) {
	    return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
	  }

	  readBytes(length, loose) {
	    let bytes = this._peekBytes(0, length, !!loose);

	    this._offset += bytes.length; // @TODO: Make sure the length..end bytes are all 0?

	    return bytes.slice(0, length);
	  }

	  readValue() {
	    return BigNumber.from(this.readBytes(this.wordSize));
	  }

	}

	/**
	 * [js-sha3]{@link https://github.com/emn178/js-sha3}
	 *
	 * @version 0.8.0
	 * @author Chen, Yi-Cyuan [emn178@gmail.com]
	 * @copyright Chen, Yi-Cyuan 2015-2018
	 * @license MIT
	 */

	var sha3 = createCommonjsModule$1(function (module) {
	/*jslint bitwise: true */
	(function () {

	  var INPUT_ERROR = 'input is invalid type';
	  var FINALIZE_ERROR = 'finalize already called';
	  var WINDOW = typeof window === 'object';
	  var root = WINDOW ? window : {};

	  if (root.JS_SHA3_NO_WINDOW) {
	    WINDOW = false;
	  }

	  var WEB_WORKER = !WINDOW && typeof self === 'object';
	  var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;

	  if (NODE_JS) {
	    root = commonjsGlobal;
	  } else if (WEB_WORKER) {
	    root = self;
	  }

	  var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && 'object' === 'object' && module.exports;
	  var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
	  var HEX_CHARS = '0123456789abcdef'.split('');
	  var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
	  var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
	  var KECCAK_PADDING = [1, 256, 65536, 16777216];
	  var PADDING = [6, 1536, 393216, 100663296];
	  var SHIFT = [0, 8, 16, 24];
	  var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
	  var BITS = [224, 256, 384, 512];
	  var SHAKE_BITS = [128, 256];
	  var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
	  var CSHAKE_BYTEPAD = {
	    '128': 168,
	    '256': 136
	  };

	  if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
	    Array.isArray = function (obj) {
	      return Object.prototype.toString.call(obj) === '[object Array]';
	    };
	  }

	  if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
	    ArrayBuffer.isView = function (obj) {
	      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
	    };
	  }

	  var createOutputMethod = function (bits, padding, outputType) {
	    return function (message) {
	      return new Keccak(bits, padding, bits).update(message)[outputType]();
	    };
	  };

	  var createShakeOutputMethod = function (bits, padding, outputType) {
	    return function (message, outputBits) {
	      return new Keccak(bits, padding, outputBits).update(message)[outputType]();
	    };
	  };

	  var createCshakeOutputMethod = function (bits, padding, outputType) {
	    return function (message, outputBits, n, s) {
	      return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
	    };
	  };

	  var createKmacOutputMethod = function (bits, padding, outputType) {
	    return function (key, message, outputBits, s) {
	      return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
	    };
	  };

	  var createOutputMethods = function (method, createMethod, bits, padding) {
	    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
	      var type = OUTPUT_TYPES[i];
	      method[type] = createMethod(bits, padding, type);
	    }

	    return method;
	  };

	  var createMethod = function (bits, padding) {
	    var method = createOutputMethod(bits, padding, 'hex');

	    method.create = function () {
	      return new Keccak(bits, padding, bits);
	    };

	    method.update = function (message) {
	      return method.create().update(message);
	    };

	    return createOutputMethods(method, createOutputMethod, bits, padding);
	  };

	  var createShakeMethod = function (bits, padding) {
	    var method = createShakeOutputMethod(bits, padding, 'hex');

	    method.create = function (outputBits) {
	      return new Keccak(bits, padding, outputBits);
	    };

	    method.update = function (message, outputBits) {
	      return method.create(outputBits).update(message);
	    };

	    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
	  };

	  var createCshakeMethod = function (bits, padding) {
	    var w = CSHAKE_BYTEPAD[bits];
	    var method = createCshakeOutputMethod(bits, padding, 'hex');

	    method.create = function (outputBits, n, s) {
	      if (!n && !s) {
	        return methods['shake' + bits].create(outputBits);
	      } else {
	        return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
	      }
	    };

	    method.update = function (message, outputBits, n, s) {
	      return method.create(outputBits, n, s).update(message);
	    };

	    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
	  };

	  var createKmacMethod = function (bits, padding) {
	    var w = CSHAKE_BYTEPAD[bits];
	    var method = createKmacOutputMethod(bits, padding, 'hex');

	    method.create = function (key, outputBits, s) {
	      return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
	    };

	    method.update = function (key, message, outputBits, s) {
	      return method.create(key, outputBits, s).update(message);
	    };

	    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
	  };

	  var algorithms = [{
	    name: 'keccak',
	    padding: KECCAK_PADDING,
	    bits: BITS,
	    createMethod: createMethod
	  }, {
	    name: 'sha3',
	    padding: PADDING,
	    bits: BITS,
	    createMethod: createMethod
	  }, {
	    name: 'shake',
	    padding: SHAKE_PADDING,
	    bits: SHAKE_BITS,
	    createMethod: createShakeMethod
	  }, {
	    name: 'cshake',
	    padding: CSHAKE_PADDING,
	    bits: SHAKE_BITS,
	    createMethod: createCshakeMethod
	  }, {
	    name: 'kmac',
	    padding: CSHAKE_PADDING,
	    bits: SHAKE_BITS,
	    createMethod: createKmacMethod
	  }];
	  var methods = {},
	      methodNames = [];

	  for (var i = 0; i < algorithms.length; ++i) {
	    var algorithm = algorithms[i];
	    var bits = algorithm.bits;

	    for (var j = 0; j < bits.length; ++j) {
	      var methodName = algorithm.name + '_' + bits[j];
	      methodNames.push(methodName);
	      methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);

	      if (algorithm.name !== 'sha3') {
	        var newMethodName = algorithm.name + bits[j];
	        methodNames.push(newMethodName);
	        methods[newMethodName] = methods[methodName];
	      }
	    }
	  }

	  function Keccak(bits, padding, outputBits) {
	    this.blocks = [];
	    this.s = [];
	    this.padding = padding;
	    this.outputBits = outputBits;
	    this.reset = true;
	    this.finalized = false;
	    this.block = 0;
	    this.start = 0;
	    this.blockCount = 1600 - (bits << 1) >> 5;
	    this.byteCount = this.blockCount << 2;
	    this.outputBlocks = outputBits >> 5;
	    this.extraBytes = (outputBits & 31) >> 3;

	    for (var i = 0; i < 50; ++i) {
	      this.s[i] = 0;
	    }
	  }

	  Keccak.prototype.update = function (message) {
	    if (this.finalized) {
	      throw new Error(FINALIZE_ERROR);
	    }

	    var notString,
	        type = typeof message;

	    if (type !== 'string') {
	      if (type === 'object') {
	        if (message === null) {
	          throw new Error(INPUT_ERROR);
	        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
	          message = new Uint8Array(message);
	        } else if (!Array.isArray(message)) {
	          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
	            throw new Error(INPUT_ERROR);
	          }
	        }
	      } else {
	        throw new Error(INPUT_ERROR);
	      }

	      notString = true;
	    }

	    var blocks = this.blocks,
	        byteCount = this.byteCount,
	        length = message.length,
	        blockCount = this.blockCount,
	        index = 0,
	        s = this.s,
	        i,
	        code;

	    while (index < length) {
	      if (this.reset) {
	        this.reset = false;
	        blocks[0] = this.block;

	        for (i = 1; i < blockCount + 1; ++i) {
	          blocks[i] = 0;
	        }
	      }

	      if (notString) {
	        for (i = this.start; index < length && i < byteCount; ++index) {
	          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
	        }
	      } else {
	        for (i = this.start; index < length && i < byteCount; ++index) {
	          code = message.charCodeAt(index);

	          if (code < 0x80) {
	            blocks[i >> 2] |= code << SHIFT[i++ & 3];
	          } else if (code < 0x800) {
	            blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
	          } else if (code < 0xd800 || code >= 0xe000) {
	            blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
	          } else {
	            code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
	            blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
	          }
	        }
	      }

	      this.lastByteIndex = i;

	      if (i >= byteCount) {
	        this.start = i - byteCount;
	        this.block = blocks[blockCount];

	        for (i = 0; i < blockCount; ++i) {
	          s[i] ^= blocks[i];
	        }

	        f(s);
	        this.reset = true;
	      } else {
	        this.start = i;
	      }
	    }

	    return this;
	  };

	  Keccak.prototype.encode = function (x, right) {
	    var o = x & 255,
	        n = 1;
	    var bytes = [o];
	    x = x >> 8;
	    o = x & 255;

	    while (o > 0) {
	      bytes.unshift(o);
	      x = x >> 8;
	      o = x & 255;
	      ++n;
	    }

	    if (right) {
	      bytes.push(n);
	    } else {
	      bytes.unshift(n);
	    }

	    this.update(bytes);
	    return bytes.length;
	  };

	  Keccak.prototype.encodeString = function (str) {
	    var notString,
	        type = typeof str;

	    if (type !== 'string') {
	      if (type === 'object') {
	        if (str === null) {
	          throw new Error(INPUT_ERROR);
	        } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
	          str = new Uint8Array(str);
	        } else if (!Array.isArray(str)) {
	          if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
	            throw new Error(INPUT_ERROR);
	          }
	        }
	      } else {
	        throw new Error(INPUT_ERROR);
	      }

	      notString = true;
	    }

	    var bytes = 0,
	        length = str.length;

	    if (notString) {
	      bytes = length;
	    } else {
	      for (var i = 0; i < str.length; ++i) {
	        var code = str.charCodeAt(i);

	        if (code < 0x80) {
	          bytes += 1;
	        } else if (code < 0x800) {
	          bytes += 2;
	        } else if (code < 0xd800 || code >= 0xe000) {
	          bytes += 3;
	        } else {
	          code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
	          bytes += 4;
	        }
	      }
	    }

	    bytes += this.encode(bytes * 8);
	    this.update(str);
	    return bytes;
	  };

	  Keccak.prototype.bytepad = function (strs, w) {
	    var bytes = this.encode(w);

	    for (var i = 0; i < strs.length; ++i) {
	      bytes += this.encodeString(strs[i]);
	    }

	    var paddingBytes = w - bytes % w;
	    var zeros = [];
	    zeros.length = paddingBytes;
	    this.update(zeros);
	    return this;
	  };

	  Keccak.prototype.finalize = function () {
	    if (this.finalized) {
	      return;
	    }

	    this.finalized = true;
	    var blocks = this.blocks,
	        i = this.lastByteIndex,
	        blockCount = this.blockCount,
	        s = this.s;
	    blocks[i >> 2] |= this.padding[i & 3];

	    if (this.lastByteIndex === this.byteCount) {
	      blocks[0] = blocks[blockCount];

	      for (i = 1; i < blockCount + 1; ++i) {
	        blocks[i] = 0;
	      }
	    }

	    blocks[blockCount - 1] |= 0x80000000;

	    for (i = 0; i < blockCount; ++i) {
	      s[i] ^= blocks[i];
	    }

	    f(s);
	  };

	  Keccak.prototype.toString = Keccak.prototype.hex = function () {
	    this.finalize();
	    var blockCount = this.blockCount,
	        s = this.s,
	        outputBlocks = this.outputBlocks,
	        extraBytes = this.extraBytes,
	        i = 0,
	        j = 0;
	    var hex = '',
	        block;

	    while (j < outputBlocks) {
	      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
	        block = s[i];
	        hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
	      }

	      if (j % blockCount === 0) {
	        f(s);
	        i = 0;
	      }
	    }

	    if (extraBytes) {
	      block = s[i];
	      hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];

	      if (extraBytes > 1) {
	        hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
	      }

	      if (extraBytes > 2) {
	        hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
	      }
	    }

	    return hex;
	  };

	  Keccak.prototype.arrayBuffer = function () {
	    this.finalize();
	    var blockCount = this.blockCount,
	        s = this.s,
	        outputBlocks = this.outputBlocks,
	        extraBytes = this.extraBytes,
	        i = 0,
	        j = 0;
	    var bytes = this.outputBits >> 3;
	    var buffer;

	    if (extraBytes) {
	      buffer = new ArrayBuffer(outputBlocks + 1 << 2);
	    } else {
	      buffer = new ArrayBuffer(bytes);
	    }

	    var array = new Uint32Array(buffer);

	    while (j < outputBlocks) {
	      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
	        array[j] = s[i];
	      }

	      if (j % blockCount === 0) {
	        f(s);
	      }
	    }

	    if (extraBytes) {
	      array[i] = s[i];
	      buffer = buffer.slice(0, bytes);
	    }

	    return buffer;
	  };

	  Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

	  Keccak.prototype.digest = Keccak.prototype.array = function () {
	    this.finalize();
	    var blockCount = this.blockCount,
	        s = this.s,
	        outputBlocks = this.outputBlocks,
	        extraBytes = this.extraBytes,
	        i = 0,
	        j = 0;
	    var array = [],
	        offset,
	        block;

	    while (j < outputBlocks) {
	      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
	        offset = j << 2;
	        block = s[i];
	        array[offset] = block & 0xFF;
	        array[offset + 1] = block >> 8 & 0xFF;
	        array[offset + 2] = block >> 16 & 0xFF;
	        array[offset + 3] = block >> 24 & 0xFF;
	      }

	      if (j % blockCount === 0) {
	        f(s);
	      }
	    }

	    if (extraBytes) {
	      offset = j << 2;
	      block = s[i];
	      array[offset] = block & 0xFF;

	      if (extraBytes > 1) {
	        array[offset + 1] = block >> 8 & 0xFF;
	      }

	      if (extraBytes > 2) {
	        array[offset + 2] = block >> 16 & 0xFF;
	      }
	    }

	    return array;
	  };

	  function Kmac(bits, padding, outputBits) {
	    Keccak.call(this, bits, padding, outputBits);
	  }

	  Kmac.prototype = new Keccak();

	  Kmac.prototype.finalize = function () {
	    this.encode(this.outputBits, true);
	    return Keccak.prototype.finalize.call(this);
	  };

	  var f = function (s) {
	    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;

	    for (n = 0; n < 48; n += 2) {
	      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
	      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
	      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
	      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
	      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
	      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
	      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
	      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
	      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
	      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
	      h = c8 ^ (c2 << 1 | c3 >>> 31);
	      l = c9 ^ (c3 << 1 | c2 >>> 31);
	      s[0] ^= h;
	      s[1] ^= l;
	      s[10] ^= h;
	      s[11] ^= l;
	      s[20] ^= h;
	      s[21] ^= l;
	      s[30] ^= h;
	      s[31] ^= l;
	      s[40] ^= h;
	      s[41] ^= l;
	      h = c0 ^ (c4 << 1 | c5 >>> 31);
	      l = c1 ^ (c5 << 1 | c4 >>> 31);
	      s[2] ^= h;
	      s[3] ^= l;
	      s[12] ^= h;
	      s[13] ^= l;
	      s[22] ^= h;
	      s[23] ^= l;
	      s[32] ^= h;
	      s[33] ^= l;
	      s[42] ^= h;
	      s[43] ^= l;
	      h = c2 ^ (c6 << 1 | c7 >>> 31);
	      l = c3 ^ (c7 << 1 | c6 >>> 31);
	      s[4] ^= h;
	      s[5] ^= l;
	      s[14] ^= h;
	      s[15] ^= l;
	      s[24] ^= h;
	      s[25] ^= l;
	      s[34] ^= h;
	      s[35] ^= l;
	      s[44] ^= h;
	      s[45] ^= l;
	      h = c4 ^ (c8 << 1 | c9 >>> 31);
	      l = c5 ^ (c9 << 1 | c8 >>> 31);
	      s[6] ^= h;
	      s[7] ^= l;
	      s[16] ^= h;
	      s[17] ^= l;
	      s[26] ^= h;
	      s[27] ^= l;
	      s[36] ^= h;
	      s[37] ^= l;
	      s[46] ^= h;
	      s[47] ^= l;
	      h = c6 ^ (c0 << 1 | c1 >>> 31);
	      l = c7 ^ (c1 << 1 | c0 >>> 31);
	      s[8] ^= h;
	      s[9] ^= l;
	      s[18] ^= h;
	      s[19] ^= l;
	      s[28] ^= h;
	      s[29] ^= l;
	      s[38] ^= h;
	      s[39] ^= l;
	      s[48] ^= h;
	      s[49] ^= l;
	      b0 = s[0];
	      b1 = s[1];
	      b32 = s[11] << 4 | s[10] >>> 28;
	      b33 = s[10] << 4 | s[11] >>> 28;
	      b14 = s[20] << 3 | s[21] >>> 29;
	      b15 = s[21] << 3 | s[20] >>> 29;
	      b46 = s[31] << 9 | s[30] >>> 23;
	      b47 = s[30] << 9 | s[31] >>> 23;
	      b28 = s[40] << 18 | s[41] >>> 14;
	      b29 = s[41] << 18 | s[40] >>> 14;
	      b20 = s[2] << 1 | s[3] >>> 31;
	      b21 = s[3] << 1 | s[2] >>> 31;
	      b2 = s[13] << 12 | s[12] >>> 20;
	      b3 = s[12] << 12 | s[13] >>> 20;
	      b34 = s[22] << 10 | s[23] >>> 22;
	      b35 = s[23] << 10 | s[22] >>> 22;
	      b16 = s[33] << 13 | s[32] >>> 19;
	      b17 = s[32] << 13 | s[33] >>> 19;
	      b48 = s[42] << 2 | s[43] >>> 30;
	      b49 = s[43] << 2 | s[42] >>> 30;
	      b40 = s[5] << 30 | s[4] >>> 2;
	      b41 = s[4] << 30 | s[5] >>> 2;
	      b22 = s[14] << 6 | s[15] >>> 26;
	      b23 = s[15] << 6 | s[14] >>> 26;
	      b4 = s[25] << 11 | s[24] >>> 21;
	      b5 = s[24] << 11 | s[25] >>> 21;
	      b36 = s[34] << 15 | s[35] >>> 17;
	      b37 = s[35] << 15 | s[34] >>> 17;
	      b18 = s[45] << 29 | s[44] >>> 3;
	      b19 = s[44] << 29 | s[45] >>> 3;
	      b10 = s[6] << 28 | s[7] >>> 4;
	      b11 = s[7] << 28 | s[6] >>> 4;
	      b42 = s[17] << 23 | s[16] >>> 9;
	      b43 = s[16] << 23 | s[17] >>> 9;
	      b24 = s[26] << 25 | s[27] >>> 7;
	      b25 = s[27] << 25 | s[26] >>> 7;
	      b6 = s[36] << 21 | s[37] >>> 11;
	      b7 = s[37] << 21 | s[36] >>> 11;
	      b38 = s[47] << 24 | s[46] >>> 8;
	      b39 = s[46] << 24 | s[47] >>> 8;
	      b30 = s[8] << 27 | s[9] >>> 5;
	      b31 = s[9] << 27 | s[8] >>> 5;
	      b12 = s[18] << 20 | s[19] >>> 12;
	      b13 = s[19] << 20 | s[18] >>> 12;
	      b44 = s[29] << 7 | s[28] >>> 25;
	      b45 = s[28] << 7 | s[29] >>> 25;
	      b26 = s[38] << 8 | s[39] >>> 24;
	      b27 = s[39] << 8 | s[38] >>> 24;
	      b8 = s[48] << 14 | s[49] >>> 18;
	      b9 = s[49] << 14 | s[48] >>> 18;
	      s[0] = b0 ^ ~b2 & b4;
	      s[1] = b1 ^ ~b3 & b5;
	      s[10] = b10 ^ ~b12 & b14;
	      s[11] = b11 ^ ~b13 & b15;
	      s[20] = b20 ^ ~b22 & b24;
	      s[21] = b21 ^ ~b23 & b25;
	      s[30] = b30 ^ ~b32 & b34;
	      s[31] = b31 ^ ~b33 & b35;
	      s[40] = b40 ^ ~b42 & b44;
	      s[41] = b41 ^ ~b43 & b45;
	      s[2] = b2 ^ ~b4 & b6;
	      s[3] = b3 ^ ~b5 & b7;
	      s[12] = b12 ^ ~b14 & b16;
	      s[13] = b13 ^ ~b15 & b17;
	      s[22] = b22 ^ ~b24 & b26;
	      s[23] = b23 ^ ~b25 & b27;
	      s[32] = b32 ^ ~b34 & b36;
	      s[33] = b33 ^ ~b35 & b37;
	      s[42] = b42 ^ ~b44 & b46;
	      s[43] = b43 ^ ~b45 & b47;
	      s[4] = b4 ^ ~b6 & b8;
	      s[5] = b5 ^ ~b7 & b9;
	      s[14] = b14 ^ ~b16 & b18;
	      s[15] = b15 ^ ~b17 & b19;
	      s[24] = b24 ^ ~b26 & b28;
	      s[25] = b25 ^ ~b27 & b29;
	      s[34] = b34 ^ ~b36 & b38;
	      s[35] = b35 ^ ~b37 & b39;
	      s[44] = b44 ^ ~b46 & b48;
	      s[45] = b45 ^ ~b47 & b49;
	      s[6] = b6 ^ ~b8 & b0;
	      s[7] = b7 ^ ~b9 & b1;
	      s[16] = b16 ^ ~b18 & b10;
	      s[17] = b17 ^ ~b19 & b11;
	      s[26] = b26 ^ ~b28 & b20;
	      s[27] = b27 ^ ~b29 & b21;
	      s[36] = b36 ^ ~b38 & b30;
	      s[37] = b37 ^ ~b39 & b31;
	      s[46] = b46 ^ ~b48 & b40;
	      s[47] = b47 ^ ~b49 & b41;
	      s[8] = b8 ^ ~b0 & b2;
	      s[9] = b9 ^ ~b1 & b3;
	      s[18] = b18 ^ ~b10 & b12;
	      s[19] = b19 ^ ~b11 & b13;
	      s[28] = b28 ^ ~b20 & b22;
	      s[29] = b29 ^ ~b21 & b23;
	      s[38] = b38 ^ ~b30 & b32;
	      s[39] = b39 ^ ~b31 & b33;
	      s[48] = b48 ^ ~b40 & b42;
	      s[49] = b49 ^ ~b41 & b43;
	      s[0] ^= RC[n];
	      s[1] ^= RC[n + 1];
	    }
	  };

	  if (COMMON_JS) {
	    module.exports = methods;
	  } else {
	    for (i = 0; i < methodNames.length; ++i) {
	      root[methodNames[i]] = methods[methodNames[i]];
	    }
	  }
	})();
	});

	var sha3$1 = sha3;

	function keccak256(data) {
	  return '0x' + sha3$1.keccak_256(arrayify(data));
	}

	const version$d = "rlp/5.7.0";

	const logger$i = new Logger(version$d);

	function arrayifyInteger(value) {
	  const result = [];

	  while (value) {
	    result.unshift(value & 0xff);
	    value >>= 8;
	  }

	  return result;
	}

	function unarrayifyInteger(data, offset, length) {
	  let result = 0;

	  for (let i = 0; i < length; i++) {
	    result = result * 256 + data[offset + i];
	  }

	  return result;
	}

	function _encode(object) {
	  if (Array.isArray(object)) {
	    let payload = [];
	    object.forEach(function (child) {
	      payload = payload.concat(_encode(child));
	    });

	    if (payload.length <= 55) {
	      payload.unshift(0xc0 + payload.length);
	      return payload;
	    }

	    const length = arrayifyInteger(payload.length);
	    length.unshift(0xf7 + length.length);
	    return length.concat(payload);
	  }

	  if (!isBytesLike(object)) {
	    logger$i.throwArgumentError("RLP object must be BytesLike", "object", object);
	  }

	  const data = Array.prototype.slice.call(arrayify(object));

	  if (data.length === 1 && data[0] <= 0x7f) {
	    return data;
	  } else if (data.length <= 55) {
	    data.unshift(0x80 + data.length);
	    return data;
	  }

	  const length = arrayifyInteger(data.length);
	  length.unshift(0xb7 + length.length);
	  return length.concat(data);
	}

	function encode$3(object) {
	  return hexlify(_encode(object));
	}

	function _decodeChildren(data, offset, childOffset, length) {
	  const result = [];

	  while (childOffset < offset + 1 + length) {
	    const decoded = _decode(data, childOffset);

	    result.push(decoded.result);
	    childOffset += decoded.consumed;

	    if (childOffset > offset + 1 + length) {
	      logger$i.throwError("child data too short", Logger.errors.BUFFER_OVERRUN, {});
	    }
	  }

	  return {
	    consumed: 1 + length,
	    result: result
	  };
	} // returns { consumed: number, result: Object }


	function _decode(data, offset) {
	  if (data.length === 0) {
	    logger$i.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {});
	  } // Array with extra length prefix


	  if (data[offset] >= 0xf8) {
	    const lengthLength = data[offset] - 0xf7;

	    if (offset + 1 + lengthLength > data.length) {
	      logger$i.throwError("data short segment too short", Logger.errors.BUFFER_OVERRUN, {});
	    }

	    const length = unarrayifyInteger(data, offset + 1, lengthLength);

	    if (offset + 1 + lengthLength + length > data.length) {
	      logger$i.throwError("data long segment too short", Logger.errors.BUFFER_OVERRUN, {});
	    }

	    return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
	  } else if (data[offset] >= 0xc0) {
	    const length = data[offset] - 0xc0;

	    if (offset + 1 + length > data.length) {
	      logger$i.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
	    }

	    return _decodeChildren(data, offset, offset + 1, length);
	  } else if (data[offset] >= 0xb8) {
	    const lengthLength = data[offset] - 0xb7;

	    if (offset + 1 + lengthLength > data.length) {
	      logger$i.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
	    }

	    const length = unarrayifyInteger(data, offset + 1, lengthLength);

	    if (offset + 1 + lengthLength + length > data.length) {
	      logger$i.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
	    }

	    const result = hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
	    return {
	      consumed: 1 + lengthLength + length,
	      result: result
	    };
	  } else if (data[offset] >= 0x80) {
	    const length = data[offset] - 0x80;

	    if (offset + 1 + length > data.length) {
	      logger$i.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {});
	    }

	    const result = hexlify(data.slice(offset + 1, offset + 1 + length));
	    return {
	      consumed: 1 + length,
	      result: result
	    };
	  }

	  return {
	    consumed: 1,
	    result: hexlify(data[offset])
	  };
	}

	function decode$2(data) {
	  const bytes = arrayify(data);

	  const decoded = _decode(bytes, 0);

	  if (decoded.consumed !== bytes.length) {
	    logger$i.throwArgumentError("invalid rlp data", "data", data);
	  }

	  return decoded.result;
	}

	const version$c = "address/5.7.0";

	const logger$h = new Logger(version$c);

	function getChecksumAddress(address) {
	  if (!isHexString(address, 20)) {
	    logger$h.throwArgumentError("invalid address", "address", address);
	  }

	  address = address.toLowerCase();
	  const chars = address.substring(2).split("");
	  const expanded = new Uint8Array(40);

	  for (let i = 0; i < 40; i++) {
	    expanded[i] = chars[i].charCodeAt(0);
	  }

	  const hashed = arrayify(keccak256(expanded));

	  for (let i = 0; i < 40; i += 2) {
	    if (hashed[i >> 1] >> 4 >= 8) {
	      chars[i] = chars[i].toUpperCase();
	    }

	    if ((hashed[i >> 1] & 0x0f) >= 8) {
	      chars[i + 1] = chars[i + 1].toUpperCase();
	    }
	  }

	  return "0x" + chars.join("");
	} // Shims for environments that are missing some required constants and functions


	const MAX_SAFE_INTEGER = 0x1fffffffffffff;

	function log10(x) {
	  if (Math.log10) {
	    return Math.log10(x);
	  }

	  return Math.log(x) / Math.LN10;
	} // See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
	// Create lookup table


	const ibanLookup = {};

	for (let i = 0; i < 10; i++) {
	  ibanLookup[String(i)] = String(i);
	}

	for (let i = 0; i < 26; i++) {
	  ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
	} // How many decimal digits can we process? (for 64-bit float, this is 15)


	const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));

	function ibanChecksum(address) {
	  address = address.toUpperCase();
	  address = address.substring(4) + address.substring(0, 2) + "00";
	  let expanded = address.split("").map(c => {
	    return ibanLookup[c];
	  }).join(""); // Javascript can handle integers safely up to 15 (decimal) digits

	  while (expanded.length >= safeDigits) {
	    let block = expanded.substring(0, safeDigits);
	    expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
	  }

	  let checksum = String(98 - parseInt(expanded, 10) % 97);

	  while (checksum.length < 2) {
	    checksum = "0" + checksum;
	  }

	  return checksum;
	}
	function getAddress(address) {
	  let result = null;

	  if (typeof address !== "string") {
	    logger$h.throwArgumentError("invalid address", "address", address);
	  }

	  if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
	    // Missing the 0x prefix
	    if (address.substring(0, 2) !== "0x") {
	      address = "0x" + address;
	    }

	    result = getChecksumAddress(address); // It is a checksummed address with a bad checksum

	    if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
	      logger$h.throwArgumentError("bad address checksum", "address", address);
	    } // Maybe ICAP? (we only support direct mode)

	  } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
	    // It is an ICAP address with a bad checksum
	    if (address.substring(2, 4) !== ibanChecksum(address)) {
	      logger$h.throwArgumentError("bad icap checksum", "address", address);
	    }

	    result = _base36To16(address.substring(4));

	    while (result.length < 40) {
	      result = "0" + result;
	    }

	    result = getChecksumAddress("0x" + result);
	  } else {
	    logger$h.throwArgumentError("invalid address", "address", address);
	  }

	  return result;
	}
	function isAddress(address) {
	  try {
	    getAddress(address);
	    return true;
	  } catch (error) {}

	  return false;
	}

	function getContractAddress(transaction) {
	  let from = null;

	  try {
	    from = getAddress(transaction.from);
	  } catch (error) {
	    logger$h.throwArgumentError("missing from address", "transaction", transaction);
	  }

	  const nonce = stripZeros(arrayify(BigNumber.from(transaction.nonce).toHexString()));
	  return getAddress(hexDataSlice(keccak256(encode$3([from, nonce])), 12));
	}

	class AddressCoder extends Coder {
	  constructor(localName) {
	    super("address", "address", localName, false);
	  }

	  defaultValue() {
	    return "0x0000000000000000000000000000000000000000";
	  }

	  encode(writer, value) {
	    try {
	      value = getAddress(value);
	    } catch (error) {
	      this._throwError(error.message, value);
	    }

	    return writer.writeValue(value);
	  }

	  decode(reader) {
	    return getAddress(hexZeroPad(reader.readValue().toHexString(), 20));
	  }

	}

	class AnonymousCoder extends Coder {
	  constructor(coder) {
	    super(coder.name, coder.type, undefined, coder.dynamic);
	    this.coder = coder;
	  }

	  defaultValue() {
	    return this.coder.defaultValue();
	  }

	  encode(writer, value) {
	    return this.coder.encode(writer, value);
	  }

	  decode(reader) {
	    return this.coder.decode(reader);
	  }

	}

	const logger$g = new Logger(version$e);
	function pack(writer, coders, values) {
	  let arrayValues = null;

	  if (Array.isArray(values)) {
	    arrayValues = values;
	  } else if (values && typeof values === "object") {
	    let unique = {};
	    arrayValues = coders.map(coder => {
	      const name = coder.localName;

	      if (!name) {
	        logger$g.throwError("cannot encode object for signature with missing names", Logger.errors.INVALID_ARGUMENT, {
	          argument: "values",
	          coder: coder,
	          value: values
	        });
	      }

	      if (unique[name]) {
	        logger$g.throwError("cannot encode object for signature with duplicate names", Logger.errors.INVALID_ARGUMENT, {
	          argument: "values",
	          coder: coder,
	          value: values
	        });
	      }

	      unique[name] = true;
	      return values[name];
	    });
	  } else {
	    logger$g.throwArgumentError("invalid tuple value", "tuple", values);
	  }

	  if (coders.length !== arrayValues.length) {
	    logger$g.throwArgumentError("types/value length mismatch", "tuple", values);
	  }

	  let staticWriter = new Writer(writer.wordSize);
	  let dynamicWriter = new Writer(writer.wordSize);
	  let updateFuncs = [];
	  coders.forEach((coder, index) => {
	    let value = arrayValues[index];

	    if (coder.dynamic) {
	      // Get current dynamic offset (for the future pointer)
	      let dynamicOffset = dynamicWriter.length; // Encode the dynamic value into the dynamicWriter

	      coder.encode(dynamicWriter, value); // Prepare to populate the correct offset once we are done

	      let updateFunc = staticWriter.writeUpdatableValue();
	      updateFuncs.push(baseOffset => {
	        updateFunc(baseOffset + dynamicOffset);
	      });
	    } else {
	      coder.encode(staticWriter, value);
	    }
	  }); // Backfill all the dynamic offsets, now that we know the static length

	  updateFuncs.forEach(func => {
	    func(staticWriter.length);
	  });
	  let length = writer.appendWriter(staticWriter);
	  length += writer.appendWriter(dynamicWriter);
	  return length;
	}
	function unpack(reader, coders) {
	  let values = []; // A reader anchored to this base

	  let baseReader = reader.subReader(0);
	  coders.forEach(coder => {
	    let value = null;

	    if (coder.dynamic) {
	      let offset = reader.readValue();
	      let offsetReader = baseReader.subReader(offset.toNumber());

	      try {
	        value = coder.decode(offsetReader);
	      } catch (error) {
	        // Cannot recover from this
	        if (error.code === Logger.errors.BUFFER_OVERRUN) {
	          throw error;
	        }

	        value = error;
	        value.baseType = coder.name;
	        value.name = coder.localName;
	        value.type = coder.type;
	      }
	    } else {
	      try {
	        value = coder.decode(reader);
	      } catch (error) {
	        // Cannot recover from this
	        if (error.code === Logger.errors.BUFFER_OVERRUN) {
	          throw error;
	        }

	        value = error;
	        value.baseType = coder.name;
	        value.name = coder.localName;
	        value.type = coder.type;
	      }
	    }

	    if (value != undefined) {
	      values.push(value);
	    }
	  }); // We only output named properties for uniquely named coders

	  const uniqueNames = coders.reduce((accum, coder) => {
	    const name = coder.localName;

	    if (name) {
	      if (!accum[name]) {
	        accum[name] = 0;
	      }

	      accum[name]++;
	    }

	    return accum;
	  }, {}); // Add any named parameters (i.e. tuples)

	  coders.forEach((coder, index) => {
	    let name = coder.localName;

	    if (!name || uniqueNames[name] !== 1) {
	      return;
	    }

	    if (name === "length") {
	      name = "_length";
	    }

	    if (values[name] != null) {
	      return;
	    }

	    const value = values[index];

	    if (value instanceof Error) {
	      Object.defineProperty(values, name, {
	        enumerable: true,
	        get: () => {
	          throw value;
	        }
	      });
	    } else {
	      values[name] = value;
	    }
	  });

	  for (let i = 0; i < values.length; i++) {
	    const value = values[i];

	    if (value instanceof Error) {
	      Object.defineProperty(values, i, {
	        enumerable: true,
	        get: () => {
	          throw value;
	        }
	      });
	    }
	  }

	  return Object.freeze(values);
	}
	class ArrayCoder extends Coder {
	  constructor(coder, length, localName) {
	    const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
	    const dynamic = length === -1 || coder.dynamic;
	    super("array", type, localName, dynamic);
	    this.coder = coder;
	    this.length = length;
	  }

	  defaultValue() {
	    // Verifies the child coder is valid (even if the array is dynamic or 0-length)
	    const defaultChild = this.coder.defaultValue();
	    const result = [];

	    for (let i = 0; i < this.length; i++) {
	      result.push(defaultChild);
	    }

	    return result;
	  }

	  encode(writer, value) {
	    if (!Array.isArray(value)) {
	      this._throwError("expected array value", value);
	    }

	    let count = this.length;

	    if (count === -1) {
	      count = value.length;
	      writer.writeValue(value.length);
	    }

	    logger$g.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
	    let coders = [];

	    for (let i = 0; i < value.length; i++) {
	      coders.push(this.coder);
	    }

	    return pack(writer, coders, value);
	  }

	  decode(reader) {
	    let count = this.length;

	    if (count === -1) {
	      count = reader.readValue().toNumber(); // Check that there is *roughly* enough data to ensure
	      // stray random data is not being read as a length. Each
	      // slot requires at least 32 bytes for their value (or 32
	      // bytes as a link to the data). This could use a much
	      // tighter bound, but we are erroring on the side of safety.

	      if (count * 32 > reader._data.length) {
	        logger$g.throwError("insufficient data length", Logger.errors.BUFFER_OVERRUN, {
	          length: reader._data.length,
	          count: count
	        });
	      }
	    }

	    let coders = [];

	    for (let i = 0; i < count; i++) {
	      coders.push(new AnonymousCoder(this.coder));
	    }

	    return reader.coerce(this.name, unpack(reader, coders));
	  }

	}

	class BooleanCoder extends Coder {
	  constructor(localName) {
	    super("bool", "bool", localName, false);
	  }

	  defaultValue() {
	    return false;
	  }

	  encode(writer, value) {
	    return writer.writeValue(value ? 1 : 0);
	  }

	  decode(reader) {
	    return reader.coerce(this.type, !reader.readValue().isZero());
	  }

	}

	class DynamicBytesCoder extends Coder {
	  constructor(type, localName) {
	    super(type, type, localName, true);
	  }

	  defaultValue() {
	    return "0x";
	  }

	  encode(writer, value) {
	    value = arrayify(value);
	    let length = writer.writeValue(value.length);
	    length += writer.writeBytes(value);
	    return length;
	  }

	  decode(reader) {
	    return reader.readBytes(reader.readValue().toNumber(), true);
	  }

	}
	class BytesCoder extends DynamicBytesCoder {
	  constructor(localName) {
	    super("bytes", localName);
	  }

	  decode(reader) {
	    return reader.coerce(this.name, hexlify(super.decode(reader)));
	  }

	}

	class FixedBytesCoder extends Coder {
	  constructor(size, localName) {
	    let name = "bytes" + String(size);
	    super(name, name, localName, false);
	    this.size = size;
	  }

	  defaultValue() {
	    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
	  }

	  encode(writer, value) {
	    let data = arrayify(value);

	    if (data.length !== this.size) {
	      this._throwError("incorrect data length", value);
	    }

	    return writer.writeBytes(data);
	  }

	  decode(reader) {
	    return reader.coerce(this.name, hexlify(reader.readBytes(this.size)));
	  }

	}

	class NullCoder extends Coder {
	  constructor(localName) {
	    super("null", "", localName, false);
	  }

	  defaultValue() {
	    return null;
	  }

	  encode(writer, value) {
	    if (value != null) {
	      this._throwError("not null", value);
	    }

	    return writer.writeBytes([]);
	  }

	  decode(reader) {
	    reader.readBytes(0);
	    return reader.coerce(this.name, null);
	  }

	}

	const AddressZero = "0x0000000000000000000000000000000000000000";

	const NegativeOne$1 = /*#__PURE__*/BigNumber.from(-1);
	const Zero$1 = /*#__PURE__*/BigNumber.from(0);
	const One$1 = /*#__PURE__*/BigNumber.from(1);
	const MaxUint256$1 = /*#__PURE__*/BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

	const HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";

	class NumberCoder extends Coder {
	  constructor(size, signed, localName) {
	    const name = (signed ? "int" : "uint") + size * 8;
	    super(name, name, localName, false);
	    this.size = size;
	    this.signed = signed;
	  }

	  defaultValue() {
	    return 0;
	  }

	  encode(writer, value) {
	    let v = BigNumber.from(value); // Check bounds are safe for encoding

	    let maxUintValue = MaxUint256$1.mask(writer.wordSize * 8);

	    if (this.signed) {
	      let bounds = maxUintValue.mask(this.size * 8 - 1);

	      if (v.gt(bounds) || v.lt(bounds.add(One$1).mul(NegativeOne$1))) {
	        this._throwError("value out-of-bounds", value);
	      }
	    } else if (v.lt(Zero$1) || v.gt(maxUintValue.mask(this.size * 8))) {
	      this._throwError("value out-of-bounds", value);
	    }

	    v = v.toTwos(this.size * 8).mask(this.size * 8);

	    if (this.signed) {
	      v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
	    }

	    return writer.writeValue(v);
	  }

	  decode(reader) {
	    let value = reader.readValue().mask(this.size * 8);

	    if (this.signed) {
	      value = value.fromTwos(this.size * 8);
	    }

	    return reader.coerce(this.name, value);
	  }

	}

	const version$b = "strings/5.7.0";

	const logger$f = new Logger(version$b); ///////////////////////////////

	var UnicodeNormalizationForm;

	(function (UnicodeNormalizationForm) {
	  UnicodeNormalizationForm["current"] = "";
	  UnicodeNormalizationForm["NFC"] = "NFC";
	  UnicodeNormalizationForm["NFD"] = "NFD";
	  UnicodeNormalizationForm["NFKC"] = "NFKC";
	  UnicodeNormalizationForm["NFKD"] = "NFKD";
	})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
	var Utf8ErrorReason;

	(function (Utf8ErrorReason) {
	  // A continuation byte was present where there was nothing to continue
	  // - offset = the index the codepoint began in
	  Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte"; // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
	  // - offset = the index the codepoint began in

	  Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix"; // The string is too short to process the expected codepoint
	  // - offset = the index the codepoint began in

	  Utf8ErrorReason["OVERRUN"] = "string overrun"; // A missing continuation byte was expected but not found
	  // - offset = the index the continuation byte was expected at

	  Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte"; // The computed code point is outside the range for UTF-8
	  // - offset       = start of this codepoint
	  // - badCodepoint = the computed codepoint; outside the UTF-8 range

	  Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range"; // UTF-8 strings may not contain UTF-16 surrogate pairs
	  // - offset       = start of this codepoint
	  // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range

	  Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate"; // The string is an overlong representation
	  // - offset       = start of this codepoint
	  // - badCodepoint = the computed codepoint; already bounds checked

	  Utf8ErrorReason["OVERLONG"] = "overlong representation";
	})(Utf8ErrorReason || (Utf8ErrorReason = {}));

	function errorFunc(reason, offset, bytes, output, badCodepoint) {
	  return logger$f.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
	}

	function ignoreFunc(reason, offset, bytes, output, badCodepoint) {
	  // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
	  if (reason === Utf8ErrorReason.BAD_PREFIX || reason === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
	    let i = 0;

	    for (let o = offset + 1; o < bytes.length; o++) {
	      if (bytes[o] >> 6 !== 0x02) {
	        break;
	      }

	      i++;
	    }

	    return i;
	  } // This byte runs us past the end of the string, so just jump to the end
	  // (but the first byte was read already read and therefore skipped)


	  if (reason === Utf8ErrorReason.OVERRUN) {
	    return bytes.length - offset - 1;
	  } // Nothing to skip


	  return 0;
	}

	function replaceFunc(reason, offset, bytes, output, badCodepoint) {
	  // Overlong representations are otherwise "valid" code points; just non-deistingtished
	  if (reason === Utf8ErrorReason.OVERLONG) {
	    output.push(badCodepoint);
	    return 0;
	  } // Put the replacement character into the output


	  output.push(0xfffd); // Otherwise, process as if ignoring errors

	  return ignoreFunc(reason, offset, bytes);
	} // Common error handing strategies


	const Utf8ErrorFuncs = Object.freeze({
	  error: errorFunc,
	  ignore: ignoreFunc,
	  replace: replaceFunc
	}); // http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499

	function getUtf8CodePoints(bytes, onError) {
	  if (onError == null) {
	    onError = Utf8ErrorFuncs.error;
	  }

	  bytes = arrayify(bytes);
	  const result = [];
	  let i = 0; // Invalid bytes are ignored

	  while (i < bytes.length) {
	    const c = bytes[i++]; // 0xxx xxxx

	    if (c >> 7 === 0) {
	      result.push(c);
	      continue;
	    } // Multibyte; how many bytes left for this character?


	    let extraLength = null;
	    let overlongMask = null; // 110x xxxx 10xx xxxx

	    if ((c & 0xe0) === 0xc0) {
	      extraLength = 1;
	      overlongMask = 0x7f; // 1110 xxxx 10xx xxxx 10xx xxxx
	    } else if ((c & 0xf0) === 0xe0) {
	      extraLength = 2;
	      overlongMask = 0x7ff; // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
	    } else if ((c & 0xf8) === 0xf0) {
	      extraLength = 3;
	      overlongMask = 0xffff;
	    } else {
	      if ((c & 0xc0) === 0x80) {
	        i += onError(Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
	      } else {
	        i += onError(Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
	      }

	      continue;
	    } // Do we have enough bytes in our data?


	    if (i - 1 + extraLength >= bytes.length) {
	      i += onError(Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
	      continue;
	    } // Remove the length prefix from the char


	    let res = c & (1 << 8 - extraLength - 1) - 1;

	    for (let j = 0; j < extraLength; j++) {
	      let nextChar = bytes[i]; // Invalid continuation byte

	      if ((nextChar & 0xc0) != 0x80) {
	        i += onError(Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
	        res = null;
	        break;
	      }
	      res = res << 6 | nextChar & 0x3f;
	      i++;
	    } // See above loop for invalid continuation byte


	    if (res === null) {
	      continue;
	    } // Maximum code point


	    if (res > 0x10ffff) {
	      i += onError(Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
	      continue;
	    } // Reserved for UTF-16 surrogate halves


	    if (res >= 0xd800 && res <= 0xdfff) {
	      i += onError(Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
	      continue;
	    } // Check for overlong sequences (more bytes than needed)


	    if (res <= overlongMask) {
	      i += onError(Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
	      continue;
	    }

	    result.push(res);
	  }

	  return result;
	} // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array


	function toUtf8Bytes(str, form = UnicodeNormalizationForm.current) {
	  if (form != UnicodeNormalizationForm.current) {
	    logger$f.checkNormalize();
	    str = str.normalize(form);
	  }

	  let result = [];

	  for (let i = 0; i < str.length; i++) {
	    const c = str.charCodeAt(i);

	    if (c < 0x80) {
	      result.push(c);
	    } else if (c < 0x800) {
	      result.push(c >> 6 | 0xc0);
	      result.push(c & 0x3f | 0x80);
	    } else if ((c & 0xfc00) == 0xd800) {
	      i++;
	      const c2 = str.charCodeAt(i);

	      if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) {
	        throw new Error("invalid utf-8 string");
	      } // Surrogate Pair


	      const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
	      result.push(pair >> 18 | 0xf0);
	      result.push(pair >> 12 & 0x3f | 0x80);
	      result.push(pair >> 6 & 0x3f | 0x80);
	      result.push(pair & 0x3f | 0x80);
	    } else {
	      result.push(c >> 12 | 0xe0);
	      result.push(c >> 6 & 0x3f | 0x80);
	      result.push(c & 0x3f | 0x80);
	    }
	  }

	  return arrayify(result);
	}
	function _toUtf8String(codePoints) {
	  return codePoints.map(codePoint => {
	    if (codePoint <= 0xffff) {
	      return String.fromCharCode(codePoint);
	    }

	    codePoint -= 0x10000;
	    return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
	  }).join("");
	}
	function toUtf8String(bytes, onError) {
	  return _toUtf8String(getUtf8CodePoints(bytes, onError));
	}
	function toUtf8CodePoints(str, form = UnicodeNormalizationForm.current) {
	  return getUtf8CodePoints(toUtf8Bytes(str, form));
	}

	class StringCoder extends DynamicBytesCoder {
	  constructor(localName) {
	    super("string", localName);
	  }

	  defaultValue() {
	    return "";
	  }

	  encode(writer, value) {
	    return super.encode(writer, toUtf8Bytes(value));
	  }

	  decode(reader) {
	    return toUtf8String(super.decode(reader));
	  }

	}

	class TupleCoder extends Coder {
	  constructor(coders, localName) {
	    let dynamic = false;
	    const types = [];
	    coders.forEach(coder => {
	      if (coder.dynamic) {
	        dynamic = true;
	      }

	      types.push(coder.type);
	    });
	    const type = "tuple(" + types.join(",") + ")";
	    super("tuple", type, localName, dynamic);
	    this.coders = coders;
	  }

	  defaultValue() {
	    const values = [];
	    this.coders.forEach(coder => {
	      values.push(coder.defaultValue());
	    }); // We only output named properties for uniquely named coders

	    const uniqueNames = this.coders.reduce((accum, coder) => {
	      const name = coder.localName;

	      if (name) {
	        if (!accum[name]) {
	          accum[name] = 0;
	        }

	        accum[name]++;
	      }

	      return accum;
	    }, {}); // Add named values

	    this.coders.forEach((coder, index) => {
	      let name = coder.localName;

	      if (!name || uniqueNames[name] !== 1) {
	        return;
	      }

	      if (name === "length") {
	        name = "_length";
	      }

	      if (values[name] != null) {
	        return;
	      }

	      values[name] = values[index];
	    });
	    return Object.freeze(values);
	  }

	  encode(writer, value) {
	    return pack(writer, this.coders, value);
	  }

	  decode(reader) {
	    return reader.coerce(this.name, unpack(reader, this.coders));
	  }

	}

	const logger$e = new Logger(version$e);
	const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
	const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
	class AbiCoder {
	  constructor(coerceFunc) {
	    defineReadOnly(this, "coerceFunc", coerceFunc || null);
	  }

	  _getCoder(param) {
	    switch (param.baseType) {
	      case "address":
	        return new AddressCoder(param.name);

	      case "bool":
	        return new BooleanCoder(param.name);

	      case "string":
	        return new StringCoder(param.name);

	      case "bytes":
	        return new BytesCoder(param.name);

	      case "array":
	        return new ArrayCoder(this._getCoder(param.arrayChildren), param.arrayLength, param.name);

	      case "tuple":
	        return new TupleCoder((param.components || []).map(component => {
	          return this._getCoder(component);
	        }), param.name);

	      case "":
	        return new NullCoder(param.name);
	    } // u?int[0-9]*


	    let match = param.type.match(paramTypeNumber);

	    if (match) {
	      let size = parseInt(match[2] || "256");

	      if (size === 0 || size > 256 || size % 8 !== 0) {
	        logger$e.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
	      }

	      return new NumberCoder(size / 8, match[1] === "int", param.name);
	    } // bytes[0-9]+


	    match = param.type.match(paramTypeBytes);

	    if (match) {
	      let size = parseInt(match[1]);

	      if (size === 0 || size > 32) {
	        logger$e.throwArgumentError("invalid bytes length", "param", param);
	      }

	      return new FixedBytesCoder(size, param.name);
	    }

	    return logger$e.throwArgumentError("invalid type", "type", param.type);
	  }

	  _getWordSize() {
	    return 32;
	  }

	  _getReader(data, allowLoose) {
	    return new Reader(data, this._getWordSize(), this.coerceFunc, allowLoose);
	  }

	  _getWriter() {
	    return new Writer(this._getWordSize());
	  }

	  getDefaultValue(types) {
	    const coders = types.map(type => this._getCoder(ParamType.from(type)));
	    const coder = new TupleCoder(coders, "_");
	    return coder.defaultValue();
	  }

	  encode(types, values) {
	    if (types.length !== values.length) {
	      logger$e.throwError("types/values length mismatch", Logger.errors.INVALID_ARGUMENT, {
	        count: {
	          types: types.length,
	          values: values.length
	        },
	        value: {
	          types: types,
	          values: values
	        }
	      });
	    }

	    const coders = types.map(type => this._getCoder(ParamType.from(type)));
	    const coder = new TupleCoder(coders, "_");

	    const writer = this._getWriter();

	    coder.encode(writer, values);
	    return writer.data;
	  }

	  decode(types, data, loose) {
	    const coders = types.map(type => this._getCoder(ParamType.from(type)));
	    const coder = new TupleCoder(coders, "_");
	    return coder.decode(this._getReader(arrayify(data), loose));
	  }

	}
	const defaultAbiCoder = new AbiCoder();

	function id(text) {
	  return keccak256(toUtf8Bytes(text));
	}

	const version$a = "hash/5.7.0";

	function decode$1(textData) {
	  textData = atob(textData);
	  const data = [];

	  for (let i = 0; i < textData.length; i++) {
	    data.push(textData.charCodeAt(i));
	  }

	  return arrayify(data);
	}
	function encode$2(data) {
	  data = arrayify(data);
	  let textData = "";

	  for (let i = 0; i < data.length; i++) {
	    textData += String.fromCharCode(data[i]);
	  }

	  return btoa(textData);
	}

	/**
	 * MIT License
	 *
	 * Copyright (c) 2021 Andrew Raffensperger
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 *
	 * This is a near carbon-copy of the original source (link below) with the
	 * TypeScript typings added and a few tweaks to make it ES3-compatible.
	 *
	 * See: https://github.com/adraffy/ens-normalize.js
	 */
	// https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
	function flat(array, depth) {
	  if (depth == null) {
	    depth = 1;
	  }

	  const result = [];
	  const forEach = result.forEach;

	  const flatDeep = function (arr, depth) {
	    forEach.call(arr, function (val) {
	      if (depth > 0 && Array.isArray(val)) {
	        flatDeep(val, depth - 1);
	      } else {
	        result.push(val);
	      }
	    });
	  };

	  flatDeep(array, depth);
	  return result;
	}

	function fromEntries(array) {
	  const result = {};

	  for (let i = 0; i < array.length; i++) {
	    const value = array[i];
	    result[value[0]] = value[1];
	  }

	  return result;
	}

	function decode_arithmetic(bytes) {
	  let pos = 0;

	  function u16() {
	    return bytes[pos++] << 8 | bytes[pos++];
	  } // decode the frequency table


	  let symbol_count = u16();
	  let total = 1;
	  let acc = [0, 1]; // first symbol has frequency 1

	  for (let i = 1; i < symbol_count; i++) {
	    acc.push(total += u16());
	  } // skip the sized-payload that the last 3 symbols index into


	  let skip = u16();
	  let pos_payload = pos;
	  pos += skip;
	  let read_width = 0;
	  let read_buffer = 0;

	  function read_bit() {
	    if (read_width == 0) {
	      // this will read beyond end of buffer
	      // but (undefined|0) => zero pad
	      read_buffer = read_buffer << 8 | bytes[pos++];
	      read_width = 8;
	    }

	    return read_buffer >> --read_width & 1;
	  }

	  const N = 31;
	  const FULL = Math.pow(2, N);
	  const HALF = FULL >>> 1;
	  const QRTR = HALF >> 1;
	  const MASK = FULL - 1; // fill register

	  let register = 0;

	  for (let i = 0; i < N; i++) register = register << 1 | read_bit();

	  let symbols = [];
	  let low = 0;
	  let range = FULL; // treat like a float

	  while (true) {
	    let value = Math.floor(((register - low + 1) * total - 1) / range);
	    let start = 0;
	    let end = symbol_count;

	    while (end - start > 1) {
	      // binary search
	      let mid = start + end >>> 1;

	      if (value < acc[mid]) {
	        end = mid;
	      } else {
	        start = mid;
	      }
	    }

	    if (start == 0) break; // first symbol is end mark

	    symbols.push(start);
	    let a = low + Math.floor(range * acc[start] / total);
	    let b = low + Math.floor(range * acc[start + 1] / total) - 1;

	    while (((a ^ b) & HALF) == 0) {
	      register = register << 1 & MASK | read_bit();
	      a = a << 1 & MASK;
	      b = b << 1 & MASK | 1;
	    }

	    while (a & ~b & QRTR) {
	      register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
	      a = a << 1 ^ HALF;
	      b = (b ^ HALF) << 1 | HALF | 1;
	    }

	    low = a;
	    range = 1 + b - a;
	  }

	  let offset = symbol_count - 4;
	  return symbols.map(x => {
	    switch (x - offset) {
	      case 3:
	        return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);

	      case 2:
	        return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);

	      case 1:
	        return offset + bytes[pos_payload++];

	      default:
	        return x - 1;
	    }
	  });
	} // returns an iterator which returns the next symbol

	function read_payload(v) {
	  let pos = 0;
	  return () => v[pos++];
	}
	function read_compressed_payload(bytes) {
	  return read_payload(decode_arithmetic(bytes));
	} // eg. [0,1,2,3...] => [0,-1,1,-2,...]

	function signed(i) {
	  return i & 1 ? ~i >> 1 : i >> 1;
	}

	function read_counts(n, next) {
	  let v = Array(n);

	  for (let i = 0; i < n; i++) v[i] = 1 + next();

	  return v;
	}

	function read_ascending(n, next) {
	  let v = Array(n);

	  for (let i = 0, x = -1; i < n; i++) v[i] = x += 1 + next();

	  return v;
	}

	function read_deltas(n, next) {
	  let v = Array(n);

	  for (let i = 0, x = 0; i < n; i++) v[i] = x += signed(next());

	  return v;
	}

	function read_member_array(next, lookup) {
	  let v = read_ascending(next(), next);
	  let n = next();
	  let vX = read_ascending(n, next);
	  let vN = read_counts(n, next);

	  for (let i = 0; i < n; i++) {
	    for (let j = 0; j < vN[i]; j++) {
	      v.push(vX[i] + j);
	    }
	  }

	  return lookup ? v.map(x => lookup[x]) : v;
	} // returns array of 
	// [x, ys] => single replacement rule
	// [x, ys, n, dx, dx] => linear map

	function read_mapped_map(next) {
	  let ret = [];

	  while (true) {
	    let w = next();
	    if (w == 0) break;
	    ret.push(read_linear_table(w, next));
	  }

	  while (true) {
	    let w = next() - 1;
	    if (w < 0) break;
	    ret.push(read_replacement_table(w, next));
	  }

	  return fromEntries(flat(ret));
	}
	function read_zero_terminated_array(next) {
	  let v = [];

	  while (true) {
	    let i = next();
	    if (i == 0) break;
	    v.push(i);
	  }

	  return v;
	}

	function read_transposed(n, w, next) {
	  let m = Array(n).fill(undefined).map(() => []);

	  for (let i = 0; i < w; i++) {
	    read_deltas(n, next).forEach((x, j) => m[j].push(x));
	  }

	  return m;
	}

	function read_linear_table(w, next) {
	  let dx = 1 + next();
	  let dy = next();
	  let vN = read_zero_terminated_array(next);
	  let m = read_transposed(vN.length, 1 + w, next);
	  return flat(m.map((v, i) => {
	    const x = v[0],
	          ys = v.slice(1); //let [x, ...ys] = v;
	    //return Array(vN[i]).fill().map((_, j) => {

	    return Array(vN[i]).fill(undefined).map((_, j) => {
	      let j_dy = j * dy;
	      return [x + j * dx, ys.map(y => y + j_dy)];
	    });
	  }));
	}

	function read_replacement_table(w, next) {
	  let n = 1 + next();
	  let m = read_transposed(n, 1 + w, next);
	  return m.map(v => [v[0], v.slice(1)]);
	}

	function read_emoji_trie(next) {
	  let sorted = read_member_array(next).sort((a, b) => a - b);
	  return read();

	  function read() {
	    let branches = [];

	    while (true) {
	      let keys = read_member_array(next, sorted);
	      if (keys.length == 0) break;
	      branches.push({
	        set: new Set(keys),
	        node: read()
	      });
	    }

	    branches.sort((a, b) => b.set.size - a.set.size); // sort by likelihood

	    let temp = next();
	    let valid = temp % 3;
	    temp = temp / 3 | 0;
	    let fe0f = !!(temp & 1);
	    temp >>= 1;
	    let save = temp == 1;
	    let check = temp == 2;
	    return {
	      branches,
	      valid,
	      fe0f,
	      save,
	      check
	    };
	  }
	}

	/**
	 * MIT License
	 *
	 * Copyright (c) 2021 Andrew Raffensperger
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 *
	 * This is a near carbon-copy of the original source (link below) with the
	 * TypeScript typings added and a few tweaks to make it ES3-compatible.
	 *
	 * See: https://github.com/adraffy/ens-normalize.js
	 */
	function getData() {
	  return read_compressed_payload(decode$1('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'));
	}

	/**
	 * MIT License
	 *
	 * Copyright (c) 2021 Andrew Raffensperger
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 *
	 * This is a near carbon-copy of the original source (link below) with the
	 * TypeScript typings added and a few tweaks to make it ES3-compatible.
	 *
	 * See: https://github.com/adraffy/ens-normalize.js
	 */
	const r$2 = getData();

	const VALID = new Set(read_member_array(r$2));
	const IGNORED = new Set(read_member_array(r$2));
	const MAPPED = read_mapped_map(r$2);
	const EMOJI_ROOT = read_emoji_trie(r$2); //const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
	//const STOP = 0x2E;

	const HYPHEN = 0x2D;
	const UNDERSCORE = 0x5F;

	function explode_cp(name) {
	  return toUtf8CodePoints(name);
	}

	function filter_fe0f(cps) {
	  return cps.filter(cp => cp != 0xFE0F);
	}

	function ens_normalize_post_check(name) {
	  for (let label of name.split('.')) {
	    let cps = explode_cp(label);

	    try {
	      for (let i = cps.lastIndexOf(UNDERSCORE) - 1; i >= 0; i--) {
	        if (cps[i] !== UNDERSCORE) {
	          throw new Error(`underscore only allowed at start`);
	        }
	      }

	      if (cps.length >= 4 && cps.every(cp => cp < 0x80) && cps[2] === HYPHEN && cps[3] === HYPHEN) {
	        throw new Error(`invalid label extension`);
	      }
	    } catch (err) {
	      throw new Error(`Invalid label "${label}": ${err.message}`);
	    }
	  }

	  return name;
	}
	function ens_normalize(name) {
	  return ens_normalize_post_check(normalize(name, filter_fe0f));
	}

	function normalize(name, emoji_filter) {
	  let input = explode_cp(name).reverse(); // flip for pop

	  let output = [];

	  while (input.length) {
	    let emoji = consume_emoji_reversed(input);

	    if (emoji) {
	      output.push(...emoji_filter(emoji));
	      continue;
	    }

	    let cp = input.pop();

	    if (VALID.has(cp)) {
	      output.push(cp);
	      continue;
	    }

	    if (IGNORED.has(cp)) {
	      continue;
	    }

	    let cps = MAPPED[cp];

	    if (cps) {
	      output.push(...cps);
	      continue;
	    }

	    throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
	  }

	  return ens_normalize_post_check(nfc(String.fromCodePoint(...output)));
	}

	function nfc(s) {
	  return s.normalize('NFC');
	}

	function consume_emoji_reversed(cps, eaten) {
	  var _a;

	  let node = EMOJI_ROOT;
	  let emoji;
	  let saved;
	  let stack = [];
	  let pos = cps.length;
	  if (eaten) eaten.length = 0; // clear input buffer (if needed)

	  while (pos) {
	    let cp = cps[--pos];
	    node = (_a = node.branches.find(x => x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
	    if (!node) break;

	    if (node.save) {
	      // remember
	      saved = cp;
	    } else if (node.check) {
	      // check exclusion
	      if (cp === saved) break;
	    }

	    stack.push(cp);

	    if (node.fe0f) {
	      stack.push(0xFE0F);
	      if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
	    }

	    if (node.valid) {
	      // this is a valid emoji (so far)
	      emoji = stack.slice(); // copy stack

	      if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)

	      if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)

	      cps.length = pos; // truncate
	    }
	  }

	  return emoji;
	}

	const logger$d = new Logger(version$a);
	const Zeros = new Uint8Array(32);
	Zeros.fill(0);

	function checkComponent(comp) {
	  if (comp.length === 0) {
	    throw new Error("invalid ENS name; empty component");
	  }

	  return comp;
	}

	function ensNameSplit(name) {
	  const bytes = toUtf8Bytes(ens_normalize(name));
	  const comps = [];

	  if (name.length === 0) {
	    return comps;
	  }

	  let last = 0;

	  for (let i = 0; i < bytes.length; i++) {
	    const d = bytes[i]; // A separator (i.e. "."); copy this component

	    if (d === 0x2e) {
	      comps.push(checkComponent(bytes.slice(last, i)));
	      last = i + 1;
	    }
	  } // There was a stray separator at the end of the name


	  if (last >= bytes.length) {
	    throw new Error("invalid ENS name; empty component");
	  }

	  comps.push(checkComponent(bytes.slice(last)));
	  return comps;
	}
	function namehash(name) {
	  /* istanbul ignore if */
	  if (typeof name !== "string") {
	    logger$d.throwArgumentError("invalid ENS name; not a string", "name", name);
	  }

	  let result = Zeros;
	  const comps = ensNameSplit(name);

	  while (comps.length) {
	    result = keccak256(concat$1([result, keccak256(comps.pop())]));
	  }

	  return hexlify(result);
	}
	function dnsEncode(name) {
	  return hexlify(concat$1(ensNameSplit(name).map(comp => {
	    // DNS does not allow components over 63 bytes in length
	    if (comp.length > 63) {
	      throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
	    }

	    const bytes = new Uint8Array(comp.length + 1);
	    bytes.set(comp, 1);
	    bytes[0] = bytes.length - 1;
	    return bytes;
	  }))) + "00";
	}

	var __awaiter$7 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$c = new Logger(version$a);
	const padding = new Uint8Array(32);
	padding.fill(0);
	const NegativeOne = BigNumber.from(-1);
	const Zero = BigNumber.from(0);
	const One = BigNumber.from(1);
	const MaxUint256 = BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

	function hexPadRight(value) {
	  const bytes = arrayify(value);
	  const padOffset = bytes.length % 32;

	  if (padOffset) {
	    return hexConcat([bytes, padding.slice(padOffset)]);
	  }

	  return hexlify(bytes);
	}

	const hexTrue = hexZeroPad(One.toHexString(), 32);
	const hexFalse = hexZeroPad(Zero.toHexString(), 32);
	const domainFieldTypes = {
	  name: "string",
	  version: "string",
	  chainId: "uint256",
	  verifyingContract: "address",
	  salt: "bytes32"
	};
	const domainFieldNames = ["name", "version", "chainId", "verifyingContract", "salt"];

	function checkString(key) {
	  return function (value) {
	    if (typeof value !== "string") {
	      logger$c.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
	    }

	    return value;
	  };
	}

	const domainChecks = {
	  name: checkString("name"),
	  version: checkString("version"),
	  chainId: function (value) {
	    try {
	      return BigNumber.from(value).toString();
	    } catch (error) {}

	    return logger$c.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
	  },
	  verifyingContract: function (value) {
	    try {
	      return getAddress(value).toLowerCase();
	    } catch (error) {}

	    return logger$c.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
	  },
	  salt: function (value) {
	    try {
	      const bytes = arrayify(value);

	      if (bytes.length !== 32) {
	        throw new Error("bad length");
	      }

	      return hexlify(bytes);
	    } catch (error) {}

	    return logger$c.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
	  }
	};

	function getBaseEncoder(type) {
	  // intXX and uintXX
	  {
	    const match = type.match(/^(u?)int(\d*)$/);

	    if (match) {
	      const signed = match[1] === "";
	      const width = parseInt(match[2] || "256");

	      if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) {
	        logger$c.throwArgumentError("invalid numeric width", "type", type);
	      }

	      const boundsUpper = MaxUint256.mask(signed ? width - 1 : width);
	      const boundsLower = signed ? boundsUpper.add(One).mul(NegativeOne) : Zero;
	      return function (value) {
	        const v = BigNumber.from(value);

	        if (v.lt(boundsLower) || v.gt(boundsUpper)) {
	          logger$c.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
	        }

	        return hexZeroPad(v.toTwos(256).toHexString(), 32);
	      };
	    }
	  } // bytesXX

	  {
	    const match = type.match(/^bytes(\d+)$/);

	    if (match) {
	      const width = parseInt(match[1]);

	      if (width === 0 || width > 32 || match[1] !== String(width)) {
	        logger$c.throwArgumentError("invalid bytes width", "type", type);
	      }

	      return function (value) {
	        const bytes = arrayify(value);

	        if (bytes.length !== width) {
	          logger$c.throwArgumentError(`invalid length for ${type}`, "value", value);
	        }

	        return hexPadRight(value);
	      };
	    }
	  }

	  switch (type) {
	    case "address":
	      return function (value) {
	        return hexZeroPad(getAddress(value), 32);
	      };

	    case "bool":
	      return function (value) {
	        return !value ? hexFalse : hexTrue;
	      };

	    case "bytes":
	      return function (value) {
	        return keccak256(value);
	      };

	    case "string":
	      return function (value) {
	        return id(value);
	      };
	  }

	  return null;
	}

	function encodeType(name, fields) {
	  return `${name}(${fields.map(({
    name,
    type
  }) => type + " " + name).join(",")})`;
	}

	class TypedDataEncoder {
	  constructor(types) {
	    defineReadOnly(this, "types", Object.freeze(deepCopy(types)));
	    defineReadOnly(this, "_encoderCache", {});
	    defineReadOnly(this, "_types", {}); // Link struct types to their direct child structs

	    const links = {}; // Link structs to structs which contain them as a child

	    const parents = {}; // Link all subtypes within a given struct

	    const subtypes = {};
	    Object.keys(types).forEach(type => {
	      links[type] = {};
	      parents[type] = [];
	      subtypes[type] = {};
	    });

	    for (const name in types) {
	      const uniqueNames = {};
	      types[name].forEach(field => {
	        // Check each field has a unique name
	        if (uniqueNames[field.name]) {
	          logger$c.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
	        }

	        uniqueNames[field.name] = true; // Get the base type (drop any array specifiers)

	        const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];

	        if (baseType === name) {
	          logger$c.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
	        } // Is this a base encoding type?


	        const encoder = getBaseEncoder(baseType);

	        if (encoder) {
	          return;
	        }

	        if (!parents[baseType]) {
	          logger$c.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
	        } // Add linkage


	        parents[baseType].push(name);
	        links[name][baseType] = true;
	      });
	    } // Deduce the primary type


	    const primaryTypes = Object.keys(parents).filter(n => parents[n].length === 0);

	    if (primaryTypes.length === 0) {
	      logger$c.throwArgumentError("missing primary type", "types", types);
	    } else if (primaryTypes.length > 1) {
	      logger$c.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map(t => JSON.stringify(t)).join(", ")}`, "types", types);
	    }

	    defineReadOnly(this, "primaryType", primaryTypes[0]); // Check for circular type references

	    function checkCircular(type, found) {
	      if (found[type]) {
	        logger$c.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
	      }

	      found[type] = true;
	      Object.keys(links[type]).forEach(child => {
	        if (!parents[child]) {
	          return;
	        } // Recursively check children


	        checkCircular(child, found); // Mark all ancestors as having this decendant

	        Object.keys(found).forEach(subtype => {
	          subtypes[subtype][child] = true;
	        });
	      });
	      delete found[type];
	    }

	    checkCircular(this.primaryType, {}); // Compute each fully describe type

	    for (const name in subtypes) {
	      const st = Object.keys(subtypes[name]);
	      st.sort();
	      this._types[name] = encodeType(name, types[name]) + st.map(t => encodeType(t, types[t])).join("");
	    }
	  }

	  getEncoder(type) {
	    let encoder = this._encoderCache[type];

	    if (!encoder) {
	      encoder = this._encoderCache[type] = this._getEncoder(type);
	    }

	    return encoder;
	  }

	  _getEncoder(type) {
	    // Basic encoder type (address, bool, uint256, etc)
	    {
	      const encoder = getBaseEncoder(type);

	      if (encoder) {
	        return encoder;
	      }
	    } // Array

	    const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);

	    if (match) {
	      const subtype = match[1];
	      const subEncoder = this.getEncoder(subtype);
	      const length = parseInt(match[3]);
	      return value => {
	        if (length >= 0 && value.length !== length) {
	          logger$c.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
	        }

	        let result = value.map(subEncoder);

	        if (this._types[subtype]) {
	          result = result.map(keccak256);
	        }

	        return keccak256(hexConcat(result));
	      };
	    } // Struct


	    const fields = this.types[type];

	    if (fields) {
	      const encodedType = id(this._types[type]);
	      return value => {
	        const values = fields.map(({
	          name,
	          type
	        }) => {
	          const result = this.getEncoder(type)(value[name]);

	          if (this._types[type]) {
	            return keccak256(result);
	          }

	          return result;
	        });
	        values.unshift(encodedType);
	        return hexConcat(values);
	      };
	    }

	    return logger$c.throwArgumentError(`unknown type: ${type}`, "type", type);
	  }

	  encodeType(name) {
	    const result = this._types[name];

	    if (!result) {
	      logger$c.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
	    }

	    return result;
	  }

	  encodeData(type, value) {
	    return this.getEncoder(type)(value);
	  }

	  hashStruct(name, value) {
	    return keccak256(this.encodeData(name, value));
	  }

	  encode(value) {
	    return this.encodeData(this.primaryType, value);
	  }

	  hash(value) {
	    return this.hashStruct(this.primaryType, value);
	  }

	  _visit(type, value, callback) {
	    // Basic encoder type (address, bool, uint256, etc)
	    {
	      const encoder = getBaseEncoder(type);

	      if (encoder) {
	        return callback(type, value);
	      }
	    } // Array

	    const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);

	    if (match) {
	      const subtype = match[1];
	      const length = parseInt(match[3]);

	      if (length >= 0 && value.length !== length) {
	        logger$c.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
	      }

	      return value.map(v => this._visit(subtype, v, callback));
	    } // Struct


	    const fields = this.types[type];

	    if (fields) {
	      return fields.reduce((accum, {
	        name,
	        type
	      }) => {
	        accum[name] = this._visit(type, value[name], callback);
	        return accum;
	      }, {});
	    }

	    return logger$c.throwArgumentError(`unknown type: ${type}`, "type", type);
	  }

	  visit(value, callback) {
	    return this._visit(this.primaryType, value, callback);
	  }

	  static from(types) {
	    return new TypedDataEncoder(types);
	  }

	  static getPrimaryType(types) {
	    return TypedDataEncoder.from(types).primaryType;
	  }

	  static hashStruct(name, types, value) {
	    return TypedDataEncoder.from(types).hashStruct(name, value);
	  }

	  static hashDomain(domain) {
	    const domainFields = [];

	    for (const name in domain) {
	      const type = domainFieldTypes[name];

	      if (!type) {
	        logger$c.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
	      }

	      domainFields.push({
	        name,
	        type
	      });
	    }

	    domainFields.sort((a, b) => {
	      return domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name);
	    });
	    return TypedDataEncoder.hashStruct("EIP712Domain", {
	      EIP712Domain: domainFields
	    }, domain);
	  }

	  static encode(domain, types, value) {
	    return hexConcat(["0x1901", TypedDataEncoder.hashDomain(domain), TypedDataEncoder.from(types).hash(value)]);
	  }

	  static hash(domain, types, value) {
	    return keccak256(TypedDataEncoder.encode(domain, types, value));
	  } // Replaces all address types with ENS names with their looked up address


	  static resolveNames(domain, types, value, resolveName) {
	    return __awaiter$7(this, void 0, void 0, function* () {
	      // Make a copy to isolate it from the object passed in
	      domain = shallowCopy(domain); // Look up all ENS names

	      const ensCache = {}; // Do we need to look up the domain's verifyingContract?

	      if (domain.verifyingContract && !isHexString(domain.verifyingContract, 20)) {
	        ensCache[domain.verifyingContract] = "0x";
	      } // We are going to use the encoder to visit all the base values


	      const encoder = TypedDataEncoder.from(types); // Get a list of all the addresses

	      encoder.visit(value, (type, value) => {
	        if (type === "address" && !isHexString(value, 20)) {
	          ensCache[value] = "0x";
	        }

	        return value;
	      }); // Lookup each name

	      for (const name in ensCache) {
	        ensCache[name] = yield resolveName(name);
	      } // Replace the domain verifyingContract if needed


	      if (domain.verifyingContract && ensCache[domain.verifyingContract]) {
	        domain.verifyingContract = ensCache[domain.verifyingContract];
	      } // Replace all ENS names with their address


	      value = encoder.visit(value, (type, value) => {
	        if (type === "address" && ensCache[value]) {
	          return ensCache[value];
	        }

	        return value;
	      });
	      return {
	        domain,
	        value
	      };
	    });
	  }

	  static getPayload(domain, types, value) {
	    // Validate the domain fields
	    TypedDataEncoder.hashDomain(domain); // Derive the EIP712Domain Struct reference type

	    const domainValues = {};
	    const domainTypes = [];
	    domainFieldNames.forEach(name => {
	      const value = domain[name];

	      if (value == null) {
	        return;
	      }

	      domainValues[name] = domainChecks[name](value);
	      domainTypes.push({
	        name,
	        type: domainFieldTypes[name]
	      });
	    });
	    const encoder = TypedDataEncoder.from(types);
	    const typesWithDomain = shallowCopy(types);

	    if (typesWithDomain.EIP712Domain) {
	      logger$c.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
	    } else {
	      typesWithDomain.EIP712Domain = domainTypes;
	    } // Validate the data structures and types


	    encoder.encode(value);
	    return {
	      types: typesWithDomain,
	      domain: domainValues,
	      primaryType: encoder.primaryType,
	      message: encoder.visit(value, (type, value) => {
	        // bytes
	        if (type.match(/^bytes(\d*)/)) {
	          return hexlify(arrayify(value));
	        } // uint or int


	        if (type.match(/^u?int/)) {
	          return BigNumber.from(value).toString();
	        }

	        switch (type) {
	          case "address":
	            return value.toLowerCase();

	          case "bool":
	            return !!value;

	          case "string":
	            if (typeof value !== "string") {
	              logger$c.throwArgumentError(`invalid string`, "value", value);
	            }

	            return value;
	        }

	        return logger$c.throwArgumentError("unsupported type", "type", type);
	      })
	    };
	  }

	}

	const logger$b = new Logger(version$e);
	class LogDescription extends Description {}
	class TransactionDescription extends Description {}
	class ErrorDescription extends Description {}
	class Indexed extends Description {
	  static isIndexed(value) {
	    return !!(value && value._isIndexed);
	  }

	}
	const BuiltinErrors = {
	  "0x08c379a0": {
	    signature: "Error(string)",
	    name: "Error",
	    inputs: ["string"],
	    reason: true
	  },
	  "0x4e487b71": {
	    signature: "Panic(uint256)",
	    name: "Panic",
	    inputs: ["uint256"]
	  }
	};

	function wrapAccessError(property, error) {
	  const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
	  wrap.error = error;
	  return wrap;
	}
	/*
	function checkNames(fragment: Fragment, type: "input" | "output", params: Array<ParamType>): void {
	    params.reduce((accum, param) => {
	        if (param.name) {
	            if (accum[param.name]) {
	                logger.throwArgumentError(`duplicate ${ type } parameter ${ JSON.stringify(param.name) } in ${ fragment.format("full") }`, "fragment", fragment);
	            }
	            accum[param.name] = true;
	        }
	        return accum;
	    }, <{ [ name: string ]: boolean }>{ });
	}
	*/


	class Interface {
	  constructor(fragments) {
	    let abi = [];

	    if (typeof fragments === "string") {
	      abi = JSON.parse(fragments);
	    } else {
	      abi = fragments;
	    }

	    defineReadOnly(this, "fragments", abi.map(fragment => {
	      return Fragment.from(fragment);
	    }).filter(fragment => fragment != null));
	    defineReadOnly(this, "_abiCoder", getStatic(new.target, "getAbiCoder")());
	    defineReadOnly(this, "functions", {});
	    defineReadOnly(this, "errors", {});
	    defineReadOnly(this, "events", {});
	    defineReadOnly(this, "structs", {}); // Add all fragments by their signature

	    this.fragments.forEach(fragment => {
	      let bucket = null;

	      switch (fragment.type) {
	        case "constructor":
	          if (this.deploy) {
	            logger$b.warn("duplicate definition - constructor");
	            return;
	          } //checkNames(fragment, "input", fragment.inputs);


	          defineReadOnly(this, "deploy", fragment);
	          return;

	        case "function":
	          //checkNames(fragment, "input", fragment.inputs);
	          //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
	          bucket = this.functions;
	          break;

	        case "event":
	          //checkNames(fragment, "input", fragment.inputs);
	          bucket = this.events;
	          break;

	        case "error":
	          bucket = this.errors;
	          break;

	        default:
	          return;
	      }

	      let signature = fragment.format();

	      if (bucket[signature]) {
	        logger$b.warn("duplicate definition - " + signature);
	        return;
	      }

	      bucket[signature] = fragment;
	    }); // If we do not have a constructor add a default

	    if (!this.deploy) {
	      defineReadOnly(this, "deploy", ConstructorFragment.from({
	        payable: false,
	        type: "constructor"
	      }));
	    }

	    defineReadOnly(this, "_isInterface", true);
	  }

	  format(format) {
	    if (!format) {
	      format = FormatTypes.full;
	    }

	    if (format === FormatTypes.sighash) {
	      logger$b.throwArgumentError("interface does not support formatting sighash", "format", format);
	    }

	    const abi = this.fragments.map(fragment => fragment.format(format)); // We need to re-bundle the JSON fragments a bit

	    if (format === FormatTypes.json) {
	      return JSON.stringify(abi.map(j => JSON.parse(j)));
	    }

	    return abi;
	  } // Sub-classes can override these to handle other blockchains


	  static getAbiCoder() {
	    return defaultAbiCoder;
	  }

	  static getAddress(address) {
	    return getAddress(address);
	  }

	  static getSighash(fragment) {
	    return hexDataSlice(id(fragment.format()), 0, 4);
	  }

	  static getEventTopic(eventFragment) {
	    return id(eventFragment.format());
	  } // Find a function definition by any means necessary (unless it is ambiguous)


	  getFunction(nameOrSignatureOrSighash) {
	    if (isHexString(nameOrSignatureOrSighash)) {
	      for (const name in this.functions) {
	        if (nameOrSignatureOrSighash === this.getSighash(name)) {
	          return this.functions[name];
	        }
	      }

	      logger$b.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
	    } // It is a bare name, look up the function (will return null if ambiguous)


	    if (nameOrSignatureOrSighash.indexOf("(") === -1) {
	      const name = nameOrSignatureOrSighash.trim();
	      const matching = Object.keys(this.functions).filter(f => f.split("("
	      /* fix:) */
	      )[0] === name);

	      if (matching.length === 0) {
	        logger$b.throwArgumentError("no matching function", "name", name);
	      } else if (matching.length > 1) {
	        logger$b.throwArgumentError("multiple matching functions", "name", name);
	      }

	      return this.functions[matching[0]];
	    } // Normalize the signature and lookup the function


	    const result = this.functions[FunctionFragment.fromString(nameOrSignatureOrSighash).format()];

	    if (!result) {
	      logger$b.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
	    }

	    return result;
	  } // Find an event definition by any means necessary (unless it is ambiguous)


	  getEvent(nameOrSignatureOrTopic) {
	    if (isHexString(nameOrSignatureOrTopic)) {
	      const topichash = nameOrSignatureOrTopic.toLowerCase();

	      for (const name in this.events) {
	        if (topichash === this.getEventTopic(name)) {
	          return this.events[name];
	        }
	      }

	      logger$b.throwArgumentError("no matching event", "topichash", topichash);
	    } // It is a bare name, look up the function (will return null if ambiguous)


	    if (nameOrSignatureOrTopic.indexOf("(") === -1) {
	      const name = nameOrSignatureOrTopic.trim();
	      const matching = Object.keys(this.events).filter(f => f.split("("
	      /* fix:) */
	      )[0] === name);

	      if (matching.length === 0) {
	        logger$b.throwArgumentError("no matching event", "name", name);
	      } else if (matching.length > 1) {
	        logger$b.throwArgumentError("multiple matching events", "name", name);
	      }

	      return this.events[matching[0]];
	    } // Normalize the signature and lookup the function


	    const result = this.events[EventFragment.fromString(nameOrSignatureOrTopic).format()];

	    if (!result) {
	      logger$b.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
	    }

	    return result;
	  } // Find a function definition by any means necessary (unless it is ambiguous)


	  getError(nameOrSignatureOrSighash) {
	    if (isHexString(nameOrSignatureOrSighash)) {
	      const getSighash = getStatic(this.constructor, "getSighash");

	      for (const name in this.errors) {
	        const error = this.errors[name];

	        if (nameOrSignatureOrSighash === getSighash(error)) {
	          return this.errors[name];
	        }
	      }

	      logger$b.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
	    } // It is a bare name, look up the function (will return null if ambiguous)


	    if (nameOrSignatureOrSighash.indexOf("(") === -1) {
	      const name = nameOrSignatureOrSighash.trim();
	      const matching = Object.keys(this.errors).filter(f => f.split("("
	      /* fix:) */
	      )[0] === name);

	      if (matching.length === 0) {
	        logger$b.throwArgumentError("no matching error", "name", name);
	      } else if (matching.length > 1) {
	        logger$b.throwArgumentError("multiple matching errors", "name", name);
	      }

	      return this.errors[matching[0]];
	    } // Normalize the signature and lookup the function


	    const result = this.errors[FunctionFragment.fromString(nameOrSignatureOrSighash).format()];

	    if (!result) {
	      logger$b.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
	    }

	    return result;
	  } // Get the sighash (the bytes4 selector) used by Solidity to identify a function


	  getSighash(fragment) {
	    if (typeof fragment === "string") {
	      try {
	        fragment = this.getFunction(fragment);
	      } catch (error) {
	        try {
	          fragment = this.getError(fragment);
	        } catch (_) {
	          throw error;
	        }
	      }
	    }

	    return getStatic(this.constructor, "getSighash")(fragment);
	  } // Get the topic (the bytes32 hash) used by Solidity to identify an event


	  getEventTopic(eventFragment) {
	    if (typeof eventFragment === "string") {
	      eventFragment = this.getEvent(eventFragment);
	    }

	    return getStatic(this.constructor, "getEventTopic")(eventFragment);
	  }

	  _decodeParams(params, data) {
	    return this._abiCoder.decode(params, data);
	  }

	  _encodeParams(params, values) {
	    return this._abiCoder.encode(params, values);
	  }

	  encodeDeploy(values) {
	    return this._encodeParams(this.deploy.inputs, values || []);
	  }

	  decodeErrorResult(fragment, data) {
	    if (typeof fragment === "string") {
	      fragment = this.getError(fragment);
	    }

	    const bytes = arrayify(data);

	    if (hexlify(bytes.slice(0, 4)) !== this.getSighash(fragment)) {
	      logger$b.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", hexlify(bytes));
	    }

	    return this._decodeParams(fragment.inputs, bytes.slice(4));
	  }

	  encodeErrorResult(fragment, values) {
	    if (typeof fragment === "string") {
	      fragment = this.getError(fragment);
	    }

	    return hexlify(concat$1([this.getSighash(fragment), this._encodeParams(fragment.inputs, values || [])]));
	  } // Decode the data for a function call (e.g. tx.data)


	  decodeFunctionData(functionFragment, data) {
	    if (typeof functionFragment === "string") {
	      functionFragment = this.getFunction(functionFragment);
	    }

	    const bytes = arrayify(data);

	    if (hexlify(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) {
	      logger$b.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", hexlify(bytes));
	    }

	    return this._decodeParams(functionFragment.inputs, bytes.slice(4));
	  } // Encode the data for a function call (e.g. tx.data)


	  encodeFunctionData(functionFragment, values) {
	    if (typeof functionFragment === "string") {
	      functionFragment = this.getFunction(functionFragment);
	    }

	    return hexlify(concat$1([this.getSighash(functionFragment), this._encodeParams(functionFragment.inputs, values || [])]));
	  } // Decode the result from a function call (e.g. from eth_call)


	  decodeFunctionResult(functionFragment, data) {
	    if (typeof functionFragment === "string") {
	      functionFragment = this.getFunction(functionFragment);
	    }

	    let bytes = arrayify(data);
	    let reason = null;
	    let message = "";
	    let errorArgs = null;
	    let errorName = null;
	    let errorSignature = null;

	    switch (bytes.length % this._abiCoder._getWordSize()) {
	      case 0:
	        try {
	          return this._abiCoder.decode(functionFragment.outputs, bytes);
	        } catch (error) {}

	        break;

	      case 4:
	        {
	          const selector = hexlify(bytes.slice(0, 4));
	          const builtin = BuiltinErrors[selector];

	          if (builtin) {
	            errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
	            errorName = builtin.name;
	            errorSignature = builtin.signature;

	            if (builtin.reason) {
	              reason = errorArgs[0];
	            }

	            if (errorName === "Error") {
	              message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
	            } else if (errorName === "Panic") {
	              message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
	            }
	          } else {
	            try {
	              const error = this.getError(selector);
	              errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
	              errorName = error.name;
	              errorSignature = error.format();
	            } catch (error) {}
	          }

	          break;
	        }
	    }

	    return logger$b.throwError("call revert exception" + message, Logger.errors.CALL_EXCEPTION, {
	      method: functionFragment.format(),
	      data: hexlify(data),
	      errorArgs,
	      errorName,
	      errorSignature,
	      reason
	    });
	  } // Encode the result for a function call (e.g. for eth_call)


	  encodeFunctionResult(functionFragment, values) {
	    if (typeof functionFragment === "string") {
	      functionFragment = this.getFunction(functionFragment);
	    }

	    return hexlify(this._abiCoder.encode(functionFragment.outputs, values || []));
	  } // Create the filter for the event with search criteria (e.g. for eth_filterLog)


	  encodeFilterTopics(eventFragment, values) {
	    if (typeof eventFragment === "string") {
	      eventFragment = this.getEvent(eventFragment);
	    }

	    if (values.length > eventFragment.inputs.length) {
	      logger$b.throwError("too many arguments for " + eventFragment.format(), Logger.errors.UNEXPECTED_ARGUMENT, {
	        argument: "values",
	        value: values
	      });
	    }

	    let topics = [];

	    if (!eventFragment.anonymous) {
	      topics.push(this.getEventTopic(eventFragment));
	    }

	    const encodeTopic = (param, value) => {
	      if (param.type === "string") {
	        return id(value);
	      } else if (param.type === "bytes") {
	        return keccak256(hexlify(value));
	      }

	      if (param.type === "bool" && typeof value === "boolean") {
	        value = value ? "0x01" : "0x00";
	      }

	      if (param.type.match(/^u?int/)) {
	        value = BigNumber.from(value).toHexString();
	      } // Check addresses are valid


	      if (param.type === "address") {
	        this._abiCoder.encode(["address"], [value]);
	      }

	      return hexZeroPad(hexlify(value), 32);
	    };

	    values.forEach((value, index) => {
	      let param = eventFragment.inputs[index];

	      if (!param.indexed) {
	        if (value != null) {
	          logger$b.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
	        }

	        return;
	      }

	      if (value == null) {
	        topics.push(null);
	      } else if (param.baseType === "array" || param.baseType === "tuple") {
	        logger$b.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
	      } else if (Array.isArray(value)) {
	        topics.push(value.map(value => encodeTopic(param, value)));
	      } else {
	        topics.push(encodeTopic(param, value));
	      }
	    }); // Trim off trailing nulls

	    while (topics.length && topics[topics.length - 1] === null) {
	      topics.pop();
	    }

	    return topics;
	  }

	  encodeEventLog(eventFragment, values) {
	    if (typeof eventFragment === "string") {
	      eventFragment = this.getEvent(eventFragment);
	    }

	    const topics = [];
	    const dataTypes = [];
	    const dataValues = [];

	    if (!eventFragment.anonymous) {
	      topics.push(this.getEventTopic(eventFragment));
	    }

	    if (values.length !== eventFragment.inputs.length) {
	      logger$b.throwArgumentError("event arguments/values mismatch", "values", values);
	    }

	    eventFragment.inputs.forEach((param, index) => {
	      const value = values[index];

	      if (param.indexed) {
	        if (param.type === "string") {
	          topics.push(id(value));
	        } else if (param.type === "bytes") {
	          topics.push(keccak256(value));
	        } else if (param.baseType === "tuple" || param.baseType === "array") {
	          // @TODO
	          throw new Error("not implemented");
	        } else {
	          topics.push(this._abiCoder.encode([param.type], [value]));
	        }
	      } else {
	        dataTypes.push(param);
	        dataValues.push(value);
	      }
	    });
	    return {
	      data: this._abiCoder.encode(dataTypes, dataValues),
	      topics: topics
	    };
	  } // Decode a filter for the event and the search criteria


	  decodeEventLog(eventFragment, data, topics) {
	    if (typeof eventFragment === "string") {
	      eventFragment = this.getEvent(eventFragment);
	    }

	    if (topics != null && !eventFragment.anonymous) {
	      let topicHash = this.getEventTopic(eventFragment);

	      if (!isHexString(topics[0], 32) || topics[0].toLowerCase() !== topicHash) {
	        logger$b.throwError("fragment/topic mismatch", Logger.errors.INVALID_ARGUMENT, {
	          argument: "topics[0]",
	          expected: topicHash,
	          value: topics[0]
	        });
	      }

	      topics = topics.slice(1);
	    }

	    let indexed = [];
	    let nonIndexed = [];
	    let dynamic = [];
	    eventFragment.inputs.forEach((param, index) => {
	      if (param.indexed) {
	        if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
	          indexed.push(ParamType.fromObject({
	            type: "bytes32",
	            name: param.name
	          }));
	          dynamic.push(true);
	        } else {
	          indexed.push(param);
	          dynamic.push(false);
	        }
	      } else {
	        nonIndexed.push(param);
	        dynamic.push(false);
	      }
	    });
	    let resultIndexed = topics != null ? this._abiCoder.decode(indexed, concat$1(topics)) : null;

	    let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);

	    let result = [];
	    let nonIndexedIndex = 0,
	        indexedIndex = 0;
	    eventFragment.inputs.forEach((param, index) => {
	      if (param.indexed) {
	        if (resultIndexed == null) {
	          result[index] = new Indexed({
	            _isIndexed: true,
	            hash: null
	          });
	        } else if (dynamic[index]) {
	          result[index] = new Indexed({
	            _isIndexed: true,
	            hash: resultIndexed[indexedIndex++]
	          });
	        } else {
	          try {
	            result[index] = resultIndexed[indexedIndex++];
	          } catch (error) {
	            result[index] = error;
	          }
	        }
	      } else {
	        try {
	          result[index] = resultNonIndexed[nonIndexedIndex++];
	        } catch (error) {
	          result[index] = error;
	        }
	      } // Add the keyword argument if named and safe


	      if (param.name && result[param.name] == null) {
	        const value = result[index]; // Make error named values throw on access

	        if (value instanceof Error) {
	          Object.defineProperty(result, param.name, {
	            enumerable: true,
	            get: () => {
	              throw wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
	            }
	          });
	        } else {
	          result[param.name] = value;
	        }
	      }
	    }); // Make all error indexed values throw on access

	    for (let i = 0; i < result.length; i++) {
	      const value = result[i];

	      if (value instanceof Error) {
	        Object.defineProperty(result, i, {
	          enumerable: true,
	          get: () => {
	            throw wrapAccessError(`index ${i}`, value);
	          }
	        });
	      }
	    }

	    return Object.freeze(result);
	  } // Given a transaction, find the matching function fragment (if any) and
	  // determine all its properties and call parameters


	  parseTransaction(tx) {
	    let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());

	    if (!fragment) {
	      return null;
	    }

	    return new TransactionDescription({
	      args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
	      functionFragment: fragment,
	      name: fragment.name,
	      signature: fragment.format(),
	      sighash: this.getSighash(fragment),
	      value: BigNumber.from(tx.value || "0")
	    });
	  } // @TODO
	  //parseCallResult(data: BytesLike): ??
	  // Given an event log, find the matching event fragment (if any) and
	  // determine all its properties and values


	  parseLog(log) {
	    let fragment = this.getEvent(log.topics[0]);

	    if (!fragment || fragment.anonymous) {
	      return null;
	    } // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
	    //        Probably not, because just because it is the only event in the ABI does
	    //        not mean we have the full ABI; maybe just a fragment?


	    return new LogDescription({
	      eventFragment: fragment,
	      name: fragment.name,
	      signature: fragment.format(),
	      topic: this.getEventTopic(fragment),
	      args: this.decodeEventLog(fragment, log.data, log.topics)
	    });
	  }

	  parseError(data) {
	    const hexData = hexlify(data);
	    let fragment = this.getError(hexData.substring(0, 10).toLowerCase());

	    if (!fragment) {
	      return null;
	    }

	    return new ErrorDescription({
	      args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
	      errorFragment: fragment,
	      name: fragment.name,
	      signature: fragment.format(),
	      sighash: this.getSighash(fragment)
	    });
	  }
	  /*
	  static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
	      if (Interface.isInterface(value)) {
	          return value;
	      }
	      if (typeof(value) === "string") {
	          return new Interface(JSON.parse(value));
	      }
	      return new Interface(value);
	  }
	  */


	  static isInterface(value) {
	    return !!(value && value._isInterface);
	  }

	}

	const version$9 = "abstract-provider/5.7.0";

	var __awaiter$6 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$a = new Logger(version$9);
	//    call(transaction: TransactionRequest): Promise<TransactionResponse>;
	//};

	class ForkEvent extends Description {
	  static isForkEvent(value) {
	    return !!(value && value._isForkEvent);
	  }

	}
	// Exported Abstracts

	class Provider {
	  constructor() {
	    logger$a.checkAbstract(new.target, Provider);
	    defineReadOnly(this, "_isProvider", true);
	  }

	  getFeeData() {
	    return __awaiter$6(this, void 0, void 0, function* () {
	      const {
	        block,
	        gasPrice
	      } = yield resolveProperties({
	        block: this.getBlock("latest"),
	        gasPrice: this.getGasPrice().catch(error => {
	          // @TODO: Why is this now failing on Calaveras?
	          //console.log(error);
	          return null;
	        })
	      });
	      let lastBaseFeePerGas = null,
	          maxFeePerGas = null,
	          maxPriorityFeePerGas = null;

	      if (block && block.baseFeePerGas) {
	        // We may want to compute this more accurately in the future,
	        // using the formula "check if the base fee is correct".
	        // See: https://eips.ethereum.org/EIPS/eip-1559
	        lastBaseFeePerGas = block.baseFeePerGas;
	        maxPriorityFeePerGas = BigNumber.from("1500000000");
	        maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
	      }

	      return {
	        lastBaseFeePerGas,
	        maxFeePerGas,
	        maxPriorityFeePerGas,
	        gasPrice
	      };
	    });
	  } // Alias for "on"


	  addListener(eventName, listener) {
	    return this.on(eventName, listener);
	  } // Alias for "off"


	  removeListener(eventName, listener) {
	    return this.off(eventName, listener);
	  }

	  static isProvider(value) {
	    return !!(value && value._isProvider);
	  }

	}

	const version$8 = "abstract-signer/5.7.0";

	var __awaiter$5 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$9 = new Logger(version$8);
	const allowedTransactionKeys$1 = ["accessList", "ccipReadEnabled", "chainId", "customData", "data", "from", "gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "to", "type", "value"];
	const forwardErrors = [Logger.errors.INSUFFICIENT_FUNDS, Logger.errors.NONCE_EXPIRED, Logger.errors.REPLACEMENT_UNDERPRICED];
	class Signer {
	  ///////////////////
	  // Sub-classes MUST call super
	  constructor() {
	    logger$9.checkAbstract(new.target, Signer);
	    defineReadOnly(this, "_isSigner", true);
	  } ///////////////////
	  // Sub-classes MAY override these


	  getBalance(blockTag) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("getBalance");

	      return yield this.provider.getBalance(this.getAddress(), blockTag);
	    });
	  }

	  getTransactionCount(blockTag) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("getTransactionCount");

	      return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
	    });
	  } // Populates "from" if unspecified, and estimates the gas for the transaction


	  estimateGas(transaction) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("estimateGas");

	      const tx = yield resolveProperties(this.checkTransaction(transaction));
	      return yield this.provider.estimateGas(tx);
	    });
	  } // Populates "from" if unspecified, and calls with the transaction


	  call(transaction, blockTag) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("call");

	      const tx = yield resolveProperties(this.checkTransaction(transaction));
	      return yield this.provider.call(tx, blockTag);
	    });
	  } // Populates all fields in a transaction, signs it and sends it to the network


	  sendTransaction(transaction) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("sendTransaction");

	      const tx = yield this.populateTransaction(transaction);
	      const signedTx = yield this.signTransaction(tx);
	      return yield this.provider.sendTransaction(signedTx);
	    });
	  }

	  getChainId() {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("getChainId");

	      const network = yield this.provider.getNetwork();
	      return network.chainId;
	    });
	  }

	  getGasPrice() {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("getGasPrice");

	      return yield this.provider.getGasPrice();
	    });
	  }

	  getFeeData() {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("getFeeData");

	      return yield this.provider.getFeeData();
	    });
	  }

	  resolveName(name) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      this._checkProvider("resolveName");

	      return yield this.provider.resolveName(name);
	    });
	  } // Checks a transaction does not contain invalid keys and if
	  // no "from" is provided, populates it.
	  // - does NOT require a provider
	  // - adds "from" is not present
	  // - returns a COPY (safe to mutate the result)
	  // By default called from: (overriding these prevents it)
	  //   - call
	  //   - estimateGas
	  //   - populateTransaction (and therefor sendTransaction)


	  checkTransaction(transaction) {
	    for (const key in transaction) {
	      if (allowedTransactionKeys$1.indexOf(key) === -1) {
	        logger$9.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
	      }
	    }

	    const tx = shallowCopy(transaction);

	    if (tx.from == null) {
	      tx.from = this.getAddress();
	    } else {
	      // Make sure any provided address matches this signer
	      tx.from = Promise.all([Promise.resolve(tx.from), this.getAddress()]).then(result => {
	        if (result[0].toLowerCase() !== result[1].toLowerCase()) {
	          logger$9.throwArgumentError("from address mismatch", "transaction", transaction);
	        }

	        return result[0];
	      });
	    }

	    return tx;
	  } // Populates ALL keys for a transaction and checks that "from" matches
	  // this Signer. Should be used by sendTransaction but NOT by signTransaction.
	  // By default called from: (overriding these prevents it)
	  //   - sendTransaction
	  //
	  // Notes:
	  //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas


	  populateTransaction(transaction) {
	    return __awaiter$5(this, void 0, void 0, function* () {
	      const tx = yield resolveProperties(this.checkTransaction(transaction));

	      if (tx.to != null) {
	        tx.to = Promise.resolve(tx.to).then(to => __awaiter$5(this, void 0, void 0, function* () {
	          if (to == null) {
	            return null;
	          }

	          const address = yield this.resolveName(to);

	          if (address == null) {
	            logger$9.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
	          }

	          return address;
	        })); // Prevent this error from causing an UnhandledPromiseException

	        tx.to.catch(error => {});
	      } // Do not allow mixing pre-eip-1559 and eip-1559 properties


	      const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;

	      if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) {
	        logger$9.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
	      } else if ((tx.type === 0 || tx.type === 1) && hasEip1559) {
	        logger$9.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
	      }

	      if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) {
	        // Fully-formed EIP-1559 transaction (skip getFeeData)
	        tx.type = 2;
	      } else if (tx.type === 0 || tx.type === 1) {
	        // Explicit Legacy or EIP-2930 transaction
	        // Populate missing gasPrice
	        if (tx.gasPrice == null) {
	          tx.gasPrice = this.getGasPrice();
	        }
	      } else {
	        // We need to get fee data to determine things
	        const feeData = yield this.getFeeData();

	        if (tx.type == null) {
	          // We need to auto-detect the intended type of this transaction...
	          if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
	            // The network supports EIP-1559!
	            // Upgrade transaction from null to eip-1559
	            tx.type = 2;

	            if (tx.gasPrice != null) {
	              // Using legacy gasPrice property on an eip-1559 network,
	              // so use gasPrice as both fee properties
	              const gasPrice = tx.gasPrice;
	              delete tx.gasPrice;
	              tx.maxFeePerGas = gasPrice;
	              tx.maxPriorityFeePerGas = gasPrice;
	            } else {
	              // Populate missing fee data
	              if (tx.maxFeePerGas == null) {
	                tx.maxFeePerGas = feeData.maxFeePerGas;
	              }

	              if (tx.maxPriorityFeePerGas == null) {
	                tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
	              }
	            }
	          } else if (feeData.gasPrice != null) {
	            // Network doesn't support EIP-1559...
	            // ...but they are trying to use EIP-1559 properties
	            if (hasEip1559) {
	              logger$9.throwError("network does not support EIP-1559", Logger.errors.UNSUPPORTED_OPERATION, {
	                operation: "populateTransaction"
	              });
	            } // Populate missing fee data


	            if (tx.gasPrice == null) {
	              tx.gasPrice = feeData.gasPrice;
	            } // Explicitly set untyped transaction to legacy


	            tx.type = 0;
	          } else {
	            // getFeeData has failed us.
	            logger$9.throwError("failed to get consistent fee data", Logger.errors.UNSUPPORTED_OPERATION, {
	              operation: "signer.getFeeData"
	            });
	          }
	        } else if (tx.type === 2) {
	          // Explicitly using EIP-1559
	          // Populate missing fee data
	          if (tx.maxFeePerGas == null) {
	            tx.maxFeePerGas = feeData.maxFeePerGas;
	          }

	          if (tx.maxPriorityFeePerGas == null) {
	            tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
	          }
	        }
	      }

	      if (tx.nonce == null) {
	        tx.nonce = this.getTransactionCount("pending");
	      }

	      if (tx.gasLimit == null) {
	        tx.gasLimit = this.estimateGas(tx).catch(error => {
	          if (forwardErrors.indexOf(error.code) >= 0) {
	            throw error;
	          }

	          return logger$9.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
	            error: error,
	            tx: tx
	          });
	        });
	      }

	      if (tx.chainId == null) {
	        tx.chainId = this.getChainId();
	      } else {
	        tx.chainId = Promise.all([Promise.resolve(tx.chainId), this.getChainId()]).then(results => {
	          if (results[1] !== 0 && results[0] !== results[1]) {
	            logger$9.throwArgumentError("chainId address mismatch", "transaction", transaction);
	          }

	          return results[0];
	        });
	      }

	      return yield resolveProperties(tx);
	    });
	  } ///////////////////
	  // Sub-classes SHOULD leave these alone


	  _checkProvider(operation) {
	    if (!this.provider) {
	      logger$9.throwError("missing provider", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: operation || "_checkProvider"
	      });
	    }
	  }

	  static isSigner(value) {
	    return !!(value && value._isSigner);
	  }

	}
	class VoidSigner extends Signer {
	  constructor(address, provider) {
	    super();
	    defineReadOnly(this, "address", address);
	    defineReadOnly(this, "provider", provider || null);
	  }

	  getAddress() {
	    return Promise.resolve(this.address);
	  }

	  _fail(message, operation) {
	    return Promise.resolve().then(() => {
	      logger$9.throwError(message, Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: operation
	      });
	    });
	  }

	  signMessage(message) {
	    return this._fail("VoidSigner cannot sign messages", "signMessage");
	  }

	  signTransaction(transaction) {
	    return this._fail("VoidSigner cannot sign transactions", "signTransaction");
	  }

	  _signTypedData(domain, types, value) {
	    return this._fail("VoidSigner cannot sign typed data", "signTypedData");
	  }

	  connect(provider) {
	    return new VoidSigner(this.address, provider);
	  }

	}

	var minimalisticAssert$1 = assert$6;

	function assert$6(val, msg) {
	  if (!val) throw new Error(msg || 'Assertion failed');
	}

	assert$6.equal = function assertEqual(l, r, msg) {
	  if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
	};

	var inherits_browser$1 = createCommonjsModule$1(function (module) {
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;

	      var TempCtor = function () {};

	      TempCtor.prototype = superCtor.prototype;
	      ctor.prototype = new TempCtor();
	      ctor.prototype.constructor = ctor;
	    }
	  };
	}
	});

	var inherits_1 = inherits_browser$1;

	function isSurrogatePair(msg, i) {
	  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
	    return false;
	  }

	  if (i < 0 || i + 1 >= msg.length) {
	    return false;
	  }

	  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
	}

	function toArray(msg, enc) {
	  if (Array.isArray(msg)) return msg.slice();
	  if (!msg) return [];
	  var res = [];

	  if (typeof msg === 'string') {
	    if (!enc) {
	      // Inspired by stringToUtf8ByteArray() in closure-library by Google
	      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
	      // Apache License 2.0
	      // https://github.com/google/closure-library/blob/master/LICENSE
	      var p = 0;

	      for (var i = 0; i < msg.length; i++) {
	        var c = msg.charCodeAt(i);

	        if (c < 128) {
	          res[p++] = c;
	        } else if (c < 2048) {
	          res[p++] = c >> 6 | 192;
	          res[p++] = c & 63 | 128;
	        } else if (isSurrogatePair(msg, i)) {
	          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
	          res[p++] = c >> 18 | 240;
	          res[p++] = c >> 12 & 63 | 128;
	          res[p++] = c >> 6 & 63 | 128;
	          res[p++] = c & 63 | 128;
	        } else {
	          res[p++] = c >> 12 | 224;
	          res[p++] = c >> 6 & 63 | 128;
	          res[p++] = c & 63 | 128;
	        }
	      }
	    } else if (enc === 'hex') {
	      msg = msg.replace(/[^a-z0-9]+/ig, '');
	      if (msg.length % 2 !== 0) msg = '0' + msg;

	      for (i = 0; i < msg.length; i += 2) res.push(parseInt(msg[i] + msg[i + 1], 16));
	    }
	  } else {
	    for (i = 0; i < msg.length; i++) res[i] = msg[i] | 0;
	  }

	  return res;
	}

	var toArray_1 = toArray;

	function toHex(msg) {
	  var res = '';

	  for (var i = 0; i < msg.length; i++) res += zero2(msg[i].toString(16));

	  return res;
	}

	var toHex_1 = toHex;

	function htonl(w) {
	  var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
	  return res >>> 0;
	}

	var htonl_1 = htonl;

	function toHex32(msg, endian) {
	  var res = '';

	  for (var i = 0; i < msg.length; i++) {
	    var w = msg[i];
	    if (endian === 'little') w = htonl(w);
	    res += zero8(w.toString(16));
	  }

	  return res;
	}

	var toHex32_1 = toHex32;

	function zero2(word) {
	  if (word.length === 1) return '0' + word;else return word;
	}

	var zero2_1 = zero2;

	function zero8(word) {
	  if (word.length === 7) return '0' + word;else if (word.length === 6) return '00' + word;else if (word.length === 5) return '000' + word;else if (word.length === 4) return '0000' + word;else if (word.length === 3) return '00000' + word;else if (word.length === 2) return '000000' + word;else if (word.length === 1) return '0000000' + word;else return word;
	}

	var zero8_1 = zero8;

	function join32(msg, start, end, endian) {
	  var len = end - start;
	  minimalisticAssert$1(len % 4 === 0);
	  var res = new Array(len / 4);

	  for (var i = 0, k = start; i < res.length; i++, k += 4) {
	    var w;
	    if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
	    res[i] = w >>> 0;
	  }

	  return res;
	}

	var join32_1 = join32;

	function split32(msg, endian) {
	  var res = new Array(msg.length * 4);

	  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
	    var m = msg[i];

	    if (endian === 'big') {
	      res[k] = m >>> 24;
	      res[k + 1] = m >>> 16 & 0xff;
	      res[k + 2] = m >>> 8 & 0xff;
	      res[k + 3] = m & 0xff;
	    } else {
	      res[k + 3] = m >>> 24;
	      res[k + 2] = m >>> 16 & 0xff;
	      res[k + 1] = m >>> 8 & 0xff;
	      res[k] = m & 0xff;
	    }
	  }

	  return res;
	}

	var split32_1 = split32;

	function rotr32$1(w, b) {
	  return w >>> b | w << 32 - b;
	}

	var rotr32_1 = rotr32$1;

	function rotl32$2(w, b) {
	  return w << b | w >>> 32 - b;
	}

	var rotl32_1 = rotl32$2;

	function sum32$3(a, b) {
	  return a + b >>> 0;
	}

	var sum32_1 = sum32$3;

	function sum32_3$1(a, b, c) {
	  return a + b + c >>> 0;
	}

	var sum32_3_1 = sum32_3$1;

	function sum32_4$2(a, b, c, d) {
	  return a + b + c + d >>> 0;
	}

	var sum32_4_1 = sum32_4$2;

	function sum32_5$2(a, b, c, d, e) {
	  return a + b + c + d + e >>> 0;
	}

	var sum32_5_1 = sum32_5$2;

	function sum64$1(buf, pos, ah, al) {
	  var bh = buf[pos];
	  var bl = buf[pos + 1];
	  var lo = al + bl >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  buf[pos] = hi >>> 0;
	  buf[pos + 1] = lo;
	}

	var sum64_1 = sum64$1;

	function sum64_hi$1(ah, al, bh, bl) {
	  var lo = al + bl >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  return hi >>> 0;
	}

	var sum64_hi_1 = sum64_hi$1;

	function sum64_lo$1(ah, al, bh, bl) {
	  var lo = al + bl;
	  return lo >>> 0;
	}

	var sum64_lo_1 = sum64_lo$1;

	function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh, dl) {
	  var carry = 0;
	  var lo = al;
	  lo = lo + bl >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = lo + cl >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = lo + dl >>> 0;
	  carry += lo < dl ? 1 : 0;
	  var hi = ah + bh + ch + dh + carry;
	  return hi >>> 0;
	}

	var sum64_4_hi_1 = sum64_4_hi$1;

	function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh, dl) {
	  var lo = al + bl + cl + dl;
	  return lo >>> 0;
	}

	var sum64_4_lo_1 = sum64_4_lo$1;

	function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var carry = 0;
	  var lo = al;
	  lo = lo + bl >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = lo + cl >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = lo + dl >>> 0;
	  carry += lo < dl ? 1 : 0;
	  lo = lo + el >>> 0;
	  carry += lo < el ? 1 : 0;
	  var hi = ah + bh + ch + dh + eh + carry;
	  return hi >>> 0;
	}

	var sum64_5_hi_1 = sum64_5_hi$1;

	function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var lo = al + bl + cl + dl + el;
	  return lo >>> 0;
	}

	var sum64_5_lo_1 = sum64_5_lo$1;

	function rotr64_hi$1(ah, al, num) {
	  var r = al << 32 - num | ah >>> num;
	  return r >>> 0;
	}

	var rotr64_hi_1 = rotr64_hi$1;

	function rotr64_lo$1(ah, al, num) {
	  var r = ah << 32 - num | al >>> num;
	  return r >>> 0;
	}

	var rotr64_lo_1 = rotr64_lo$1;

	function shr64_hi$1(ah, al, num) {
	  return ah >>> num;
	}

	var shr64_hi_1 = shr64_hi$1;

	function shr64_lo$1(ah, al, num) {
	  var r = ah << 32 - num | al >>> num;
	  return r >>> 0;
	}

	var shr64_lo_1 = shr64_lo$1;

	var utils = {
		inherits: inherits_1,
		toArray: toArray_1,
		toHex: toHex_1,
		htonl: htonl_1,
		toHex32: toHex32_1,
		zero2: zero2_1,
		zero8: zero8_1,
		join32: join32_1,
		split32: split32_1,
		rotr32: rotr32_1,
		rotl32: rotl32_1,
		sum32: sum32_1,
		sum32_3: sum32_3_1,
		sum32_4: sum32_4_1,
		sum32_5: sum32_5_1,
		sum64: sum64_1,
		sum64_hi: sum64_hi_1,
		sum64_lo: sum64_lo_1,
		sum64_4_hi: sum64_4_hi_1,
		sum64_4_lo: sum64_4_lo_1,
		sum64_5_hi: sum64_5_hi_1,
		sum64_5_lo: sum64_5_lo_1,
		rotr64_hi: rotr64_hi_1,
		rotr64_lo: rotr64_lo_1,
		shr64_hi: shr64_hi_1,
		shr64_lo: shr64_lo_1
	};

	function BlockHash$4() {
	  this.pending = null;
	  this.pendingTotal = 0;
	  this.blockSize = this.constructor.blockSize;
	  this.outSize = this.constructor.outSize;
	  this.hmacStrength = this.constructor.hmacStrength;
	  this.padLength = this.constructor.padLength / 8;
	  this.endian = 'big';
	  this._delta8 = this.blockSize / 8;
	  this._delta32 = this.blockSize / 32;
	}

	var BlockHash_1 = BlockHash$4;

	BlockHash$4.prototype.update = function update(msg, enc) {
	  // Convert message to array, pad it, and join into 32bit blocks
	  msg = utils.toArray(msg, enc);
	  if (!this.pending) this.pending = msg;else this.pending = this.pending.concat(msg);
	  this.pendingTotal += msg.length; // Enough data, try updating

	  if (this.pending.length >= this._delta8) {
	    msg = this.pending; // Process pending data in blocks

	    var r = msg.length % this._delta8;
	    this.pending = msg.slice(msg.length - r, msg.length);
	    if (this.pending.length === 0) this.pending = null;
	    msg = utils.join32(msg, 0, msg.length - r, this.endian);

	    for (var i = 0; i < msg.length; i += this._delta32) this._update(msg, i, i + this._delta32);
	  }

	  return this;
	};

	BlockHash$4.prototype.digest = function digest(enc) {
	  this.update(this._pad());
	  minimalisticAssert$1(this.pending === null);
	  return this._digest(enc);
	};

	BlockHash$4.prototype._pad = function pad() {
	  var len = this.pendingTotal;
	  var bytes = this._delta8;
	  var k = bytes - (len + this.padLength) % bytes;
	  var res = new Array(k + this.padLength);
	  res[0] = 0x80;

	  for (var i = 1; i < k; i++) res[i] = 0; // Append length


	  len <<= 3;

	  if (this.endian === 'big') {
	    for (var t = 8; t < this.padLength; t++) res[i++] = 0;

	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = len >>> 24 & 0xff;
	    res[i++] = len >>> 16 & 0xff;
	    res[i++] = len >>> 8 & 0xff;
	    res[i++] = len & 0xff;
	  } else {
	    res[i++] = len & 0xff;
	    res[i++] = len >>> 8 & 0xff;
	    res[i++] = len >>> 16 & 0xff;
	    res[i++] = len >>> 24 & 0xff;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;

	    for (t = 8; t < this.padLength; t++) res[i++] = 0;
	  }

	  return res;
	};

	var common$1 = {
		BlockHash: BlockHash_1
	};

	var rotr32 = utils.rotr32;

	function ft_1$1(s, x, y, z) {
	  if (s === 0) return ch32$1(x, y, z);
	  if (s === 1 || s === 3) return p32(x, y, z);
	  if (s === 2) return maj32$1(x, y, z);
	}

	var ft_1_1 = ft_1$1;

	function ch32$1(x, y, z) {
	  return x & y ^ ~x & z;
	}

	var ch32_1 = ch32$1;

	function maj32$1(x, y, z) {
	  return x & y ^ x & z ^ y & z;
	}

	var maj32_1 = maj32$1;

	function p32(x, y, z) {
	  return x ^ y ^ z;
	}

	var p32_1 = p32;

	function s0_256$1(x) {
	  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
	}

	var s0_256_1 = s0_256$1;

	function s1_256$1(x) {
	  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
	}

	var s1_256_1 = s1_256$1;

	function g0_256$1(x) {
	  return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
	}

	var g0_256_1 = g0_256$1;

	function g1_256$1(x) {
	  return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
	}

	var g1_256_1 = g1_256$1;

	var common = {
		ft_1: ft_1_1,
		ch32: ch32_1,
		maj32: maj32_1,
		p32: p32_1,
		s0_256: s0_256_1,
		s1_256: s1_256_1,
		g0_256: g0_256_1,
		g1_256: g1_256_1
	};

	var rotl32$1 = utils.rotl32;
	var sum32$2 = utils.sum32;
	var sum32_5$1 = utils.sum32_5;
	var ft_1 = common.ft_1;
	var BlockHash$3 = common$1.BlockHash;
	var sha1_K = [0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xCA62C1D6];

	function SHA1() {
	  if (!(this instanceof SHA1)) return new SHA1();
	  BlockHash$3.call(this);
	  this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	  this.W = new Array(80);
	}

	utils.inherits(SHA1, BlockHash$3);
	var _1 = SHA1;
	SHA1.blockSize = 512;
	SHA1.outSize = 160;
	SHA1.hmacStrength = 80;
	SHA1.padLength = 64;

	SHA1.prototype._update = function _update(msg, start) {
	  var W = this.W;

	  for (var i = 0; i < 16; i++) W[i] = msg[start + i];

	  for (; i < W.length; i++) W[i] = rotl32$1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];

	  for (i = 0; i < W.length; i++) {
	    var s = ~~(i / 20);
	    var t = sum32_5$1(rotl32$1(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
	    e = d;
	    d = c;
	    c = rotl32$1(b, 30);
	    b = a;
	    a = t;
	  }

	  this.h[0] = sum32$2(this.h[0], a);
	  this.h[1] = sum32$2(this.h[1], b);
	  this.h[2] = sum32$2(this.h[2], c);
	  this.h[3] = sum32$2(this.h[3], d);
	  this.h[4] = sum32$2(this.h[4], e);
	};

	SHA1.prototype._digest = function digest(enc) {
	  if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
	};

	var sum32$1 = utils.sum32;
	var sum32_4$1 = utils.sum32_4;
	var sum32_5 = utils.sum32_5;
	var ch32 = common.ch32;
	var maj32 = common.maj32;
	var s0_256 = common.s0_256;
	var s1_256 = common.s1_256;
	var g0_256 = common.g0_256;
	var g1_256 = common.g1_256;
	var BlockHash$2 = common$1.BlockHash;
	var sha256_K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];

	function SHA256() {
	  if (!(this instanceof SHA256)) return new SHA256();
	  BlockHash$2.call(this);
	  this.h = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
	  this.k = sha256_K;
	  this.W = new Array(64);
	}

	utils.inherits(SHA256, BlockHash$2);
	var _256 = SHA256;
	SHA256.blockSize = 512;
	SHA256.outSize = 256;
	SHA256.hmacStrength = 192;
	SHA256.padLength = 64;

	SHA256.prototype._update = function _update(msg, start) {
	  var W = this.W;

	  for (var i = 0; i < 16; i++) W[i] = msg[start + i];

	  for (; i < W.length; i++) W[i] = sum32_4$1(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	  var f = this.h[5];
	  var g = this.h[6];
	  var h = this.h[7];
	  minimalisticAssert$1(this.k.length === W.length);

	  for (i = 0; i < W.length; i++) {
	    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
	    var T2 = sum32$1(s0_256(a), maj32(a, b, c));
	    h = g;
	    g = f;
	    f = e;
	    e = sum32$1(d, T1);
	    d = c;
	    c = b;
	    b = a;
	    a = sum32$1(T1, T2);
	  }

	  this.h[0] = sum32$1(this.h[0], a);
	  this.h[1] = sum32$1(this.h[1], b);
	  this.h[2] = sum32$1(this.h[2], c);
	  this.h[3] = sum32$1(this.h[3], d);
	  this.h[4] = sum32$1(this.h[4], e);
	  this.h[5] = sum32$1(this.h[5], f);
	  this.h[6] = sum32$1(this.h[6], g);
	  this.h[7] = sum32$1(this.h[7], h);
	};

	SHA256.prototype._digest = function digest(enc) {
	  if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
	};

	function SHA224() {
	  if (!(this instanceof SHA224)) return new SHA224();
	  _256.call(this);
	  this.h = [0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4];
	}

	utils.inherits(SHA224, _256);
	var _224 = SHA224;
	SHA224.blockSize = 512;
	SHA224.outSize = 224;
	SHA224.hmacStrength = 192;
	SHA224.padLength = 64;

	SHA224.prototype._digest = function digest(enc) {
	  // Just truncate output
	  if (enc === 'hex') return utils.toHex32(this.h.slice(0, 7), 'big');else return utils.split32(this.h.slice(0, 7), 'big');
	};

	var rotr64_hi = utils.rotr64_hi;
	var rotr64_lo = utils.rotr64_lo;
	var shr64_hi = utils.shr64_hi;
	var shr64_lo = utils.shr64_lo;
	var sum64 = utils.sum64;
	var sum64_hi = utils.sum64_hi;
	var sum64_lo = utils.sum64_lo;
	var sum64_4_hi = utils.sum64_4_hi;
	var sum64_4_lo = utils.sum64_4_lo;
	var sum64_5_hi = utils.sum64_5_hi;
	var sum64_5_lo = utils.sum64_5_lo;
	var BlockHash$1 = common$1.BlockHash;
	var sha512_K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];

	function SHA512() {
	  if (!(this instanceof SHA512)) return new SHA512();
	  BlockHash$1.call(this);
	  this.h = [0x6a09e667, 0xf3bcc908, 0xbb67ae85, 0x84caa73b, 0x3c6ef372, 0xfe94f82b, 0xa54ff53a, 0x5f1d36f1, 0x510e527f, 0xade682d1, 0x9b05688c, 0x2b3e6c1f, 0x1f83d9ab, 0xfb41bd6b, 0x5be0cd19, 0x137e2179];
	  this.k = sha512_K;
	  this.W = new Array(160);
	}

	utils.inherits(SHA512, BlockHash$1);
	var _512 = SHA512;
	SHA512.blockSize = 1024;
	SHA512.outSize = 512;
	SHA512.hmacStrength = 192;
	SHA512.padLength = 128;

	SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
	  var W = this.W; // 32 x 32bit words

	  for (var i = 0; i < 32; i++) W[i] = msg[start + i];

	  for (; i < W.length; i += 2) {
	    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2

	    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
	    var c1_hi = W[i - 14]; // i - 7

	    var c1_lo = W[i - 13];
	    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15

	    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
	    var c3_hi = W[i - 32]; // i - 16

	    var c3_lo = W[i - 31];
	    W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
	    W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
	  }
	};

	SHA512.prototype._update = function _update(msg, start) {
	  this._prepareBlock(msg, start);

	  var W = this.W;
	  var ah = this.h[0];
	  var al = this.h[1];
	  var bh = this.h[2];
	  var bl = this.h[3];
	  var ch = this.h[4];
	  var cl = this.h[5];
	  var dh = this.h[6];
	  var dl = this.h[7];
	  var eh = this.h[8];
	  var el = this.h[9];
	  var fh = this.h[10];
	  var fl = this.h[11];
	  var gh = this.h[12];
	  var gl = this.h[13];
	  var hh = this.h[14];
	  var hl = this.h[15];
	  minimalisticAssert$1(this.k.length === W.length);

	  for (var i = 0; i < W.length; i += 2) {
	    var c0_hi = hh;
	    var c0_lo = hl;
	    var c1_hi = s1_512_hi(eh, el);
	    var c1_lo = s1_512_lo(eh, el);
	    var c2_hi = ch64_hi(eh, el, fh, fl, gh);
	    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
	    var c3_hi = this.k[i];
	    var c3_lo = this.k[i + 1];
	    var c4_hi = W[i];
	    var c4_lo = W[i + 1];
	    var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
	    var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
	    c0_hi = s0_512_hi(ah, al);
	    c0_lo = s0_512_lo(ah, al);
	    c1_hi = maj64_hi(ah, al, bh, bl, ch);
	    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
	    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
	    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
	    hh = gh;
	    hl = gl;
	    gh = fh;
	    gl = fl;
	    fh = eh;
	    fl = el;
	    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
	    el = sum64_lo(dl, dl, T1_hi, T1_lo);
	    dh = ch;
	    dl = cl;
	    ch = bh;
	    cl = bl;
	    bh = ah;
	    bl = al;
	    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
	    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
	  }

	  sum64(this.h, 0, ah, al);
	  sum64(this.h, 2, bh, bl);
	  sum64(this.h, 4, ch, cl);
	  sum64(this.h, 6, dh, dl);
	  sum64(this.h, 8, eh, el);
	  sum64(this.h, 10, fh, fl);
	  sum64(this.h, 12, gh, gl);
	  sum64(this.h, 14, hh, hl);
	};

	SHA512.prototype._digest = function digest(enc) {
	  if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
	};

	function ch64_hi(xh, xl, yh, yl, zh) {
	  var r = xh & yh ^ ~xh & zh;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function ch64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = xl & yl ^ ~xl & zl;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function maj64_hi(xh, xl, yh, yl, zh) {
	  var r = xh & yh ^ xh & zh ^ yh & zh;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function maj64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = xl & yl ^ xl & zl ^ yl & zl;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function s0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 28);
	  var c1_hi = rotr64_hi(xl, xh, 2); // 34

	  var c2_hi = rotr64_hi(xl, xh, 7); // 39

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function s0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 28);
	  var c1_lo = rotr64_lo(xl, xh, 2); // 34

	  var c2_lo = rotr64_lo(xl, xh, 7); // 39

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function s1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 14);
	  var c1_hi = rotr64_hi(xh, xl, 18);
	  var c2_hi = rotr64_hi(xl, xh, 9); // 41

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function s1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 14);
	  var c1_lo = rotr64_lo(xh, xl, 18);
	  var c2_lo = rotr64_lo(xl, xh, 9); // 41

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function g0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 1);
	  var c1_hi = rotr64_hi(xh, xl, 8);
	  var c2_hi = shr64_hi(xh, xl, 7);
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function g0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 1);
	  var c1_lo = rotr64_lo(xh, xl, 8);
	  var c2_lo = shr64_lo(xh, xl, 7);
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function g1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 19);
	  var c1_hi = rotr64_hi(xl, xh, 29); // 61

	  var c2_hi = shr64_hi(xh, xl, 6);
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function g1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 19);
	  var c1_lo = rotr64_lo(xl, xh, 29); // 61

	  var c2_lo = shr64_lo(xh, xl, 6);
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0) r += 0x100000000;
	  return r;
	}

	function SHA384() {
	  if (!(this instanceof SHA384)) return new SHA384();
	  _512.call(this);
	  this.h = [0xcbbb9d5d, 0xc1059ed8, 0x629a292a, 0x367cd507, 0x9159015a, 0x3070dd17, 0x152fecd8, 0xf70e5939, 0x67332667, 0xffc00b31, 0x8eb44a87, 0x68581511, 0xdb0c2e0d, 0x64f98fa7, 0x47b5481d, 0xbefa4fa4];
	}

	utils.inherits(SHA384, _512);
	var _384 = SHA384;
	SHA384.blockSize = 1024;
	SHA384.outSize = 384;
	SHA384.hmacStrength = 192;
	SHA384.padLength = 128;

	SHA384.prototype._digest = function digest(enc) {
	  if (enc === 'hex') return utils.toHex32(this.h.slice(0, 12), 'big');else return utils.split32(this.h.slice(0, 12), 'big');
	};

	var sha1 = _1;
	var sha224 = _224;
	var sha256$1 = _256;
	var sha384 = _384;
	var sha512 = _512;

	var sha = {
		sha1: sha1,
		sha224: sha224,
		sha256: sha256$1,
		sha384: sha384,
		sha512: sha512
	};

	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_3 = utils.sum32_3;
	var sum32_4 = utils.sum32_4;
	var BlockHash = common$1.BlockHash;

	function RIPEMD160() {
	  if (!(this instanceof RIPEMD160)) return new RIPEMD160();
	  BlockHash.call(this);
	  this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	  this.endian = 'little';
	}

	utils.inherits(RIPEMD160, BlockHash);
	var ripemd160 = RIPEMD160;
	RIPEMD160.blockSize = 512;
	RIPEMD160.outSize = 160;
	RIPEMD160.hmacStrength = 192;
	RIPEMD160.padLength = 64;

	RIPEMD160.prototype._update = function update(msg, start) {
	  var A = this.h[0];
	  var B = this.h[1];
	  var C = this.h[2];
	  var D = this.h[3];
	  var E = this.h[4];
	  var Ah = A;
	  var Bh = B;
	  var Ch = C;
	  var Dh = D;
	  var Eh = E;

	  for (var j = 0; j < 80; j++) {
	    var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r$1[j] + start], K$1(j)), s$2[j]), E);
	    A = E;
	    E = D;
	    D = rotl32(C, 10);
	    C = B;
	    B = T;
	    T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
	    Ah = Eh;
	    Eh = Dh;
	    Dh = rotl32(Ch, 10);
	    Ch = Bh;
	    Bh = T;
	  }

	  T = sum32_3(this.h[1], C, Dh);
	  this.h[1] = sum32_3(this.h[2], D, Eh);
	  this.h[2] = sum32_3(this.h[3], E, Ah);
	  this.h[3] = sum32_3(this.h[4], A, Bh);
	  this.h[4] = sum32_3(this.h[0], B, Ch);
	  this.h[0] = T;
	};

	RIPEMD160.prototype._digest = function digest(enc) {
	  if (enc === 'hex') return utils.toHex32(this.h, 'little');else return utils.split32(this.h, 'little');
	};

	function f(j, x, y, z) {
	  if (j <= 15) return x ^ y ^ z;else if (j <= 31) return x & y | ~x & z;else if (j <= 47) return (x | ~y) ^ z;else if (j <= 63) return x & z | y & ~z;else return x ^ (y | ~z);
	}

	function K$1(j) {
	  if (j <= 15) return 0x00000000;else if (j <= 31) return 0x5a827999;else if (j <= 47) return 0x6ed9eba1;else if (j <= 63) return 0x8f1bbcdc;else return 0xa953fd4e;
	}

	function Kh(j) {
	  if (j <= 15) return 0x50a28be6;else if (j <= 31) return 0x5c4dd124;else if (j <= 47) return 0x6d703ef3;else if (j <= 63) return 0x7a6d76e9;else return 0x00000000;
	}

	var r$1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];
	var rh = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];
	var s$2 = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];
	var sh = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];

	var ripemd = {
		ripemd160: ripemd160
	};

	function Hmac(hash, key, enc) {
	  if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
	  this.Hash = hash;
	  this.blockSize = hash.blockSize / 8;
	  this.outSize = hash.outSize / 8;
	  this.inner = null;
	  this.outer = null;

	  this._init(utils.toArray(key, enc));
	}

	var hmac = Hmac;

	Hmac.prototype._init = function init(key) {
	  // Shorten key, if needed
	  if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
	  minimalisticAssert$1(key.length <= this.blockSize); // Add padding to key

	  for (var i = key.length; i < this.blockSize; i++) key.push(0);

	  for (i = 0; i < key.length; i++) key[i] ^= 0x36;

	  this.inner = new this.Hash().update(key); // 0x36 ^ 0x5c = 0x6a

	  for (i = 0; i < key.length; i++) key[i] ^= 0x6a;

	  this.outer = new this.Hash().update(key);
	};

	Hmac.prototype.update = function update(msg, enc) {
	  this.inner.update(msg, enc);
	  return this;
	};

	Hmac.prototype.digest = function digest(enc) {
	  this.outer.update(this.inner.digest());
	  return this.outer.digest(enc);
	};

	var hash_1 = createCommonjsModule$1(function (module, exports) {
	var hash = exports;
	hash.utils = utils;
	hash.common = common$1;
	hash.sha = sha;
	hash.ripemd = ripemd;
	hash.hmac = hmac; // Proxy hash functions to the main object

	hash.sha1 = hash.sha.sha1;
	hash.sha256 = hash.sha.sha256;
	hash.sha224 = hash.sha.sha224;
	hash.sha384 = hash.sha.sha384;
	hash.sha512 = hash.sha.sha512;
	hash.ripemd160 = hash.ripemd.ripemd160;
	});

	var hash = hash_1;

	function createCommonjsModule(fn, basedir, module) {
	  return module = {
	    path: basedir,
	    exports: {},
	    require: function (path, base) {
	      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
	    }
	  }, fn(module, module.exports), module.exports;
	}

	function commonjsRequire() {
	  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var minimalisticAssert = assert;

	function assert(val, msg) {
	  if (!val) throw new Error(msg || 'Assertion failed');
	}

	assert.equal = function assertEqual(l, r, msg) {
	  if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
	};

	var utils_1 = createCommonjsModule(function (module, exports) {

	  var utils = exports;

	  function toArray(msg, enc) {
	    if (Array.isArray(msg)) return msg.slice();
	    if (!msg) return [];
	    var res = [];

	    if (typeof msg !== 'string') {
	      for (var i = 0; i < msg.length; i++) res[i] = msg[i] | 0;

	      return res;
	    }

	    if (enc === 'hex') {
	      msg = msg.replace(/[^a-z0-9]+/ig, '');
	      if (msg.length % 2 !== 0) msg = '0' + msg;

	      for (var i = 0; i < msg.length; i += 2) res.push(parseInt(msg[i] + msg[i + 1], 16));
	    } else {
	      for (var i = 0; i < msg.length; i++) {
	        var c = msg.charCodeAt(i);
	        var hi = c >> 8;
	        var lo = c & 0xff;
	        if (hi) res.push(hi, lo);else res.push(lo);
	      }
	    }

	    return res;
	  }

	  utils.toArray = toArray;

	  function zero2(word) {
	    if (word.length === 1) return '0' + word;else return word;
	  }

	  utils.zero2 = zero2;

	  function toHex(msg) {
	    var res = '';

	    for (var i = 0; i < msg.length; i++) res += zero2(msg[i].toString(16));

	    return res;
	  }

	  utils.toHex = toHex;

	  utils.encode = function encode(arr, enc) {
	    if (enc === 'hex') return toHex(arr);else return arr;
	  };
	});
	var utils_1$1 = createCommonjsModule(function (module, exports) {

	  var utils = exports;
	  utils.assert = minimalisticAssert;
	  utils.toArray = utils_1.toArray;
	  utils.zero2 = utils_1.zero2;
	  utils.toHex = utils_1.toHex;
	  utils.encode = utils_1.encode; // Represent num in a w-NAF form

	  function getNAF(num, w, bits) {
	    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
	    naf.fill(0);
	    var ws = 1 << w + 1;
	    var k = num.clone();

	    for (var i = 0; i < naf.length; i++) {
	      var z;
	      var mod = k.andln(ws - 1);

	      if (k.isOdd()) {
	        if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;else z = mod;
	        k.isubn(z);
	      } else {
	        z = 0;
	      }

	      naf[i] = z;
	      k.iushrn(1);
	    }

	    return naf;
	  }

	  utils.getNAF = getNAF; // Represent k1, k2 in a Joint Sparse Form

	  function getJSF(k1, k2) {
	    var jsf = [[], []];
	    k1 = k1.clone();
	    k2 = k2.clone();
	    var d1 = 0;
	    var d2 = 0;
	    var m8;

	    while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
	      // First phase
	      var m14 = k1.andln(3) + d1 & 3;
	      var m24 = k2.andln(3) + d2 & 3;
	      if (m14 === 3) m14 = -1;
	      if (m24 === 3) m24 = -1;
	      var u1;

	      if ((m14 & 1) === 0) {
	        u1 = 0;
	      } else {
	        m8 = k1.andln(7) + d1 & 7;
	        if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;else u1 = m14;
	      }

	      jsf[0].push(u1);
	      var u2;

	      if ((m24 & 1) === 0) {
	        u2 = 0;
	      } else {
	        m8 = k2.andln(7) + d2 & 7;
	        if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;else u2 = m24;
	      }

	      jsf[1].push(u2); // Second phase

	      if (2 * d1 === u1 + 1) d1 = 1 - d1;
	      if (2 * d2 === u2 + 1) d2 = 1 - d2;
	      k1.iushrn(1);
	      k2.iushrn(1);
	    }

	    return jsf;
	  }

	  utils.getJSF = getJSF;

	  function cachedProperty(obj, name, computer) {
	    var key = '_' + name;

	    obj.prototype[name] = function cachedProperty() {
	      return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
	    };
	  }

	  utils.cachedProperty = cachedProperty;

	  function parseBytes(bytes) {
	    return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
	  }

	  utils.parseBytes = parseBytes;

	  function intFromLE(bytes) {
	    return new bn(bytes, 'hex', 'le');
	  }

	  utils.intFromLE = intFromLE;
	});

	var getNAF = utils_1$1.getNAF;
	var getJSF = utils_1$1.getJSF;
	var assert$1 = utils_1$1.assert;

	function BaseCurve(type, conf) {
	  this.type = type;
	  this.p = new bn(conf.p, 16); // Use Montgomery, when there is no fast reduction for the prime

	  this.red = conf.prime ? bn.red(conf.prime) : bn.mont(this.p); // Useful for many curves

	  this.zero = new bn(0).toRed(this.red);
	  this.one = new bn(1).toRed(this.red);
	  this.two = new bn(2).toRed(this.red); // Curve configuration, optional

	  this.n = conf.n && new bn(conf.n, 16);
	  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed); // Temporary arrays

	  this._wnafT1 = new Array(4);
	  this._wnafT2 = new Array(4);
	  this._wnafT3 = new Array(4);
	  this._wnafT4 = new Array(4);
	  this._bitLength = this.n ? this.n.bitLength() : 0; // Generalized Greg Maxwell's trick

	  var adjustCount = this.n && this.p.div(this.n);

	  if (!adjustCount || adjustCount.cmpn(100) > 0) {
	    this.redN = null;
	  } else {
	    this._maxwellTrick = true;
	    this.redN = this.n.toRed(this.red);
	  }
	}

	var base = BaseCurve;

	BaseCurve.prototype.point = function point() {
	  throw new Error('Not implemented');
	};

	BaseCurve.prototype.validate = function validate() {
	  throw new Error('Not implemented');
	};

	BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
	  assert$1(p.precomputed);

	  var doubles = p._getDoubles();

	  var naf = getNAF(k, 1, this._bitLength);
	  var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
	  I /= 3; // Translate into more windowed form

	  var repr = [];
	  var j;
	  var nafW;

	  for (j = 0; j < naf.length; j += doubles.step) {
	    nafW = 0;

	    for (var l = j + doubles.step - 1; l >= j; l--) nafW = (nafW << 1) + naf[l];

	    repr.push(nafW);
	  }

	  var a = this.jpoint(null, null, null);
	  var b = this.jpoint(null, null, null);

	  for (var i = I; i > 0; i--) {
	    for (j = 0; j < repr.length; j++) {
	      nafW = repr[j];
	      if (nafW === i) b = b.mixedAdd(doubles.points[j]);else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
	    }

	    a = a.add(b);
	  }

	  return a.toP();
	};

	BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
	  var w = 4; // Precompute window

	  var nafPoints = p._getNAFPoints(w);

	  w = nafPoints.wnd;
	  var wnd = nafPoints.points; // Get NAF form

	  var naf = getNAF(k, w, this._bitLength); // Add `this`*(N+1) for every w-NAF index

	  var acc = this.jpoint(null, null, null);

	  for (var i = naf.length - 1; i >= 0; i--) {
	    // Count zeroes
	    for (var l = 0; i >= 0 && naf[i] === 0; i--) l++;

	    if (i >= 0) l++;
	    acc = acc.dblp(l);
	    if (i < 0) break;
	    var z = naf[i];
	    assert$1(z !== 0);

	    if (p.type === 'affine') {
	      // J +- P
	      if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
	    } else {
	      // J +- J
	      if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);else acc = acc.add(wnd[-z - 1 >> 1].neg());
	    }
	  }

	  return p.type === 'affine' ? acc.toP() : acc;
	};

	BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
	  var wndWidth = this._wnafT1;
	  var wnd = this._wnafT2;
	  var naf = this._wnafT3; // Fill all arrays

	  var max = 0;
	  var i;
	  var j;
	  var p;

	  for (i = 0; i < len; i++) {
	    p = points[i];

	    var nafPoints = p._getNAFPoints(defW);

	    wndWidth[i] = nafPoints.wnd;
	    wnd[i] = nafPoints.points;
	  } // Comb small window NAFs


	  for (i = len - 1; i >= 1; i -= 2) {
	    var a = i - 1;
	    var b = i;

	    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
	      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
	      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
	      max = Math.max(naf[a].length, max);
	      max = Math.max(naf[b].length, max);
	      continue;
	    }

	    var comb = [points[a],
	    /* 1 */
	    null,
	    /* 3 */
	    null,
	    /* 5 */
	    points[b]
	    /* 7 */
	    ]; // Try to avoid Projective points, if possible

	    if (points[a].y.cmp(points[b].y) === 0) {
	      comb[1] = points[a].add(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].add(points[b].neg());
	    } else {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    }

	    var index = [-3,
	    /* -1 -1 */
	    -1,
	    /* -1 0 */
	    -5,
	    /* -1 1 */
	    -7,
	    /* 0 -1 */
	    0,
	    /* 0 0 */
	    7,
	    /* 0 1 */
	    5,
	    /* 1 -1 */
	    1,
	    /* 1 0 */
	    3
	    /* 1 1 */
	    ];
	    var jsf = getJSF(coeffs[a], coeffs[b]);
	    max = Math.max(jsf[0].length, max);
	    naf[a] = new Array(max);
	    naf[b] = new Array(max);

	    for (j = 0; j < max; j++) {
	      var ja = jsf[0][j] | 0;
	      var jb = jsf[1][j] | 0;
	      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
	      naf[b][j] = 0;
	      wnd[a] = comb;
	    }
	  }

	  var acc = this.jpoint(null, null, null);
	  var tmp = this._wnafT4;

	  for (i = max; i >= 0; i--) {
	    var k = 0;

	    while (i >= 0) {
	      var zero = true;

	      for (j = 0; j < len; j++) {
	        tmp[j] = naf[j][i] | 0;
	        if (tmp[j] !== 0) zero = false;
	      }

	      if (!zero) break;
	      k++;
	      i--;
	    }

	    if (i >= 0) k++;
	    acc = acc.dblp(k);
	    if (i < 0) break;

	    for (j = 0; j < len; j++) {
	      var z = tmp[j];
	      if (z === 0) continue;else if (z > 0) p = wnd[j][z - 1 >> 1];else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
	      if (p.type === 'affine') acc = acc.mixedAdd(p);else acc = acc.add(p);
	    }
	  } // Zeroify references


	  for (i = 0; i < len; i++) wnd[i] = null;

	  if (jacobianResult) return acc;else return acc.toP();
	};

	function BasePoint(curve, type) {
	  this.curve = curve;
	  this.type = type;
	  this.precomputed = null;
	}

	BaseCurve.BasePoint = BasePoint;

	BasePoint.prototype.eq = function
	  /*other*/
	eq() {
	  throw new Error('Not implemented');
	};

	BasePoint.prototype.validate = function validate() {
	  return this.curve.validate(this);
	};

	BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  bytes = utils_1$1.toArray(bytes, enc);
	  var len = this.p.byteLength(); // uncompressed, hybrid-odd, hybrid-even

	  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
	    if (bytes[0] === 0x06) assert$1(bytes[bytes.length - 1] % 2 === 0);else if (bytes[0] === 0x07) assert$1(bytes[bytes.length - 1] % 2 === 1);
	    var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
	    return res;
	  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) {
	    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
	  }

	  throw new Error('Unknown point format');
	};

	BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
	  return this.encode(enc, true);
	};

	BasePoint.prototype._encode = function _encode(compact) {
	  var len = this.curve.p.byteLength();
	  var x = this.getX().toArray('be', len);
	  if (compact) return [this.getY().isEven() ? 0x02 : 0x03].concat(x);
	  return [0x04].concat(x, this.getY().toArray('be', len));
	};

	BasePoint.prototype.encode = function encode(enc, compact) {
	  return utils_1$1.encode(this._encode(compact), enc);
	};

	BasePoint.prototype.precompute = function precompute(power) {
	  if (this.precomputed) return this;
	  var precomputed = {
	    doubles: null,
	    naf: null,
	    beta: null
	  };
	  precomputed.naf = this._getNAFPoints(8);
	  precomputed.doubles = this._getDoubles(4, power);
	  precomputed.beta = this._getBeta();
	  this.precomputed = precomputed;
	  return this;
	};

	BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
	  if (!this.precomputed) return false;
	  var doubles = this.precomputed.doubles;
	  if (!doubles) return false;
	  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
	};

	BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
	  if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
	  var doubles = [this];
	  var acc = this;

	  for (var i = 0; i < power; i += step) {
	    for (var j = 0; j < step; j++) acc = acc.dbl();

	    doubles.push(acc);
	  }

	  return {
	    step: step,
	    points: doubles
	  };
	};

	BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
	  if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
	  var res = [this];
	  var max = (1 << wnd) - 1;
	  var dbl = max === 1 ? null : this.dbl();

	  for (var i = 1; i < max; i++) res[i] = res[i - 1].add(dbl);

	  return {
	    wnd: wnd,
	    points: res
	  };
	};

	BasePoint.prototype._getBeta = function _getBeta() {
	  return null;
	};

	BasePoint.prototype.dblp = function dblp(k) {
	  var r = this;

	  for (var i = 0; i < k; i++) r = r.dbl();

	  return r;
	};

	var inherits_browser = createCommonjsModule(function (module) {
	  if (typeof Object.create === 'function') {
	    // implementation from standard node.js 'util' module
	    module.exports = function inherits(ctor, superCtor) {
	      if (superCtor) {
	        ctor.super_ = superCtor;
	        ctor.prototype = Object.create(superCtor.prototype, {
	          constructor: {
	            value: ctor,
	            enumerable: false,
	            writable: true,
	            configurable: true
	          }
	        });
	      }
	    };
	  } else {
	    // old school shim for old browsers
	    module.exports = function inherits(ctor, superCtor) {
	      if (superCtor) {
	        ctor.super_ = superCtor;

	        var TempCtor = function () {};

	        TempCtor.prototype = superCtor.prototype;
	        ctor.prototype = new TempCtor();
	        ctor.prototype.constructor = ctor;
	      }
	    };
	  }
	});

	var assert$2 = utils_1$1.assert;

	function ShortCurve(conf) {
	  base.call(this, 'short', conf);
	  this.a = new bn(conf.a, 16).toRed(this.red);
	  this.b = new bn(conf.b, 16).toRed(this.red);
	  this.tinv = this.two.redInvm();
	  this.zeroA = this.a.fromRed().cmpn(0) === 0;
	  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0; // If the curve is endomorphic, precalculate beta and lambda

	  this.endo = this._getEndomorphism(conf);
	  this._endoWnafT1 = new Array(4);
	  this._endoWnafT2 = new Array(4);
	}

	inherits_browser(ShortCurve, base);
	var short_1 = ShortCurve;

	ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
	  // No efficient endomorphism
	  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return; // Compute beta and lambda, that lambda * P = (beta * Px; Py)

	  var beta;
	  var lambda;

	  if (conf.beta) {
	    beta = new bn(conf.beta, 16).toRed(this.red);
	  } else {
	    var betas = this._getEndoRoots(this.p); // Choose the smallest beta


	    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
	    beta = beta.toRed(this.red);
	  }

	  if (conf.lambda) {
	    lambda = new bn(conf.lambda, 16);
	  } else {
	    // Choose the lambda that is matching selected beta
	    var lambdas = this._getEndoRoots(this.n);

	    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
	      lambda = lambdas[0];
	    } else {
	      lambda = lambdas[1];
	      assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
	    }
	  } // Get basis vectors, used for balanced length-two representation


	  var basis;

	  if (conf.basis) {
	    basis = conf.basis.map(function (vec) {
	      return {
	        a: new bn(vec.a, 16),
	        b: new bn(vec.b, 16)
	      };
	    });
	  } else {
	    basis = this._getEndoBasis(lambda);
	  }

	  return {
	    beta: beta,
	    lambda: lambda,
	    basis: basis
	  };
	};

	ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
	  // Find roots of for x^2 + x + 1 in F
	  // Root = (-1 +- Sqrt(-3)) / 2
	  //
	  var red = num === this.p ? this.red : bn.mont(num);
	  var tinv = new bn(2).toRed(red).redInvm();
	  var ntinv = tinv.redNeg();
	  var s = new bn(3).toRed(red).redNeg().redSqrt().redMul(tinv);
	  var l1 = ntinv.redAdd(s).fromRed();
	  var l2 = ntinv.redSub(s).fromRed();
	  return [l1, l2];
	};

	ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
	  // aprxSqrt >= sqrt(this.n)
	  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2)); // 3.74
	  // Run EGCD, until r(L + 1) < aprxSqrt

	  var u = lambda;
	  var v = this.n.clone();
	  var x1 = new bn(1);
	  var y1 = new bn(0);
	  var x2 = new bn(0);
	  var y2 = new bn(1); // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)

	  var a0;
	  var b0; // First vector

	  var a1;
	  var b1; // Second vector

	  var a2;
	  var b2;
	  var prevR;
	  var i = 0;
	  var r;
	  var x;

	  while (u.cmpn(0) !== 0) {
	    var q = v.div(u);
	    r = v.sub(q.mul(u));
	    x = x2.sub(q.mul(x1));
	    var y = y2.sub(q.mul(y1));

	    if (!a1 && r.cmp(aprxSqrt) < 0) {
	      a0 = prevR.neg();
	      b0 = x1;
	      a1 = r.neg();
	      b1 = x;
	    } else if (a1 && ++i === 2) {
	      break;
	    }

	    prevR = r;
	    v = u;
	    u = r;
	    x2 = x1;
	    x1 = x;
	    y2 = y1;
	    y1 = y;
	  }

	  a2 = r.neg();
	  b2 = x;
	  var len1 = a1.sqr().add(b1.sqr());
	  var len2 = a2.sqr().add(b2.sqr());

	  if (len2.cmp(len1) >= 0) {
	    a2 = a0;
	    b2 = b0;
	  } // Normalize signs


	  if (a1.negative) {
	    a1 = a1.neg();
	    b1 = b1.neg();
	  }

	  if (a2.negative) {
	    a2 = a2.neg();
	    b2 = b2.neg();
	  }

	  return [{
	    a: a1,
	    b: b1
	  }, {
	    a: a2,
	    b: b2
	  }];
	};

	ShortCurve.prototype._endoSplit = function _endoSplit(k) {
	  var basis = this.endo.basis;
	  var v1 = basis[0];
	  var v2 = basis[1];
	  var c1 = v2.b.mul(k).divRound(this.n);
	  var c2 = v1.b.neg().mul(k).divRound(this.n);
	  var p1 = c1.mul(v1.a);
	  var p2 = c2.mul(v2.a);
	  var q1 = c1.mul(v1.b);
	  var q2 = c2.mul(v2.b); // Calculate answer

	  var k1 = k.sub(p1).sub(p2);
	  var k2 = q1.add(q2).neg();
	  return {
	    k1: k1,
	    k2: k2
	  };
	};

	ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new bn(x, 16);
	  if (!x.red) x = x.toRed(this.red);
	  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point'); // XXX Is there any way to tell if the number is odd without converting it
	  // to non-red form?

	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
	  return this.point(x, y);
	};

	ShortCurve.prototype.validate = function validate(point) {
	  if (point.inf) return true;
	  var x = point.x;
	  var y = point.y;
	  var ax = this.a.redMul(x);
	  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
	  return y.redSqr().redISub(rhs).cmpn(0) === 0;
	};

	ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
	  var npoints = this._endoWnafT1;
	  var ncoeffs = this._endoWnafT2;

	  for (var i = 0; i < points.length; i++) {
	    var split = this._endoSplit(coeffs[i]);

	    var p = points[i];

	    var beta = p._getBeta();

	    if (split.k1.negative) {
	      split.k1.ineg();
	      p = p.neg(true);
	    }

	    if (split.k2.negative) {
	      split.k2.ineg();
	      beta = beta.neg(true);
	    }

	    npoints[i * 2] = p;
	    npoints[i * 2 + 1] = beta;
	    ncoeffs[i * 2] = split.k1;
	    ncoeffs[i * 2 + 1] = split.k2;
	  }

	  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult); // Clean-up references to points and coefficients


	  for (var j = 0; j < i * 2; j++) {
	    npoints[j] = null;
	    ncoeffs[j] = null;
	  }

	  return res;
	};

	function Point(curve, x, y, isRed) {
	  base.BasePoint.call(this, curve, 'affine');

	  if (x === null && y === null) {
	    this.x = null;
	    this.y = null;
	    this.inf = true;
	  } else {
	    this.x = new bn(x, 16);
	    this.y = new bn(y, 16); // Force redgomery representation when loading from JSON

	    if (isRed) {
	      this.x.forceRed(this.curve.red);
	      this.y.forceRed(this.curve.red);
	    }

	    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
	    this.inf = false;
	  }
	}

	inherits_browser(Point, base.BasePoint);

	ShortCurve.prototype.point = function point(x, y, isRed) {
	  return new Point(this, x, y, isRed);
	};

	ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
	  return Point.fromJSON(this, obj, red);
	};

	Point.prototype._getBeta = function _getBeta() {
	  if (!this.curve.endo) return;
	  var pre = this.precomputed;
	  if (pre && pre.beta) return pre.beta;
	  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

	  if (pre) {
	    var curve = this.curve;

	    var endoMul = function (p) {
	      return curve.point(p.x.redMul(curve.endo.beta), p.y);
	    };

	    pre.beta = beta;
	    beta.precomputed = {
	      beta: null,
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(endoMul)
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(endoMul)
	      }
	    };
	  }

	  return beta;
	};

	Point.prototype.toJSON = function toJSON() {
	  if (!this.precomputed) return [this.x, this.y];
	  return [this.x, this.y, this.precomputed && {
	    doubles: this.precomputed.doubles && {
	      step: this.precomputed.doubles.step,
	      points: this.precomputed.doubles.points.slice(1)
	    },
	    naf: this.precomputed.naf && {
	      wnd: this.precomputed.naf.wnd,
	      points: this.precomputed.naf.points.slice(1)
	    }
	  }];
	};

	Point.fromJSON = function fromJSON(curve, obj, red) {
	  if (typeof obj === 'string') obj = JSON.parse(obj);
	  var res = curve.point(obj[0], obj[1], red);
	  if (!obj[2]) return res;

	  function obj2point(obj) {
	    return curve.point(obj[0], obj[1], red);
	  }

	  var pre = obj[2];
	  res.precomputed = {
	    beta: null,
	    doubles: pre.doubles && {
	      step: pre.doubles.step,
	      points: [res].concat(pre.doubles.points.map(obj2point))
	    },
	    naf: pre.naf && {
	      wnd: pre.naf.wnd,
	      points: [res].concat(pre.naf.points.map(obj2point))
	    }
	  };
	  return res;
	};

	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity()) return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
	};

	Point.prototype.isInfinity = function isInfinity() {
	  return this.inf;
	};

	Point.prototype.add = function add(p) {
	  // O + P = P
	  if (this.inf) return p; // P + O = P

	  if (p.inf) return this; // P + P = 2P

	  if (this.eq(p)) return this.dbl(); // P + (-P) = O

	  if (this.neg().eq(p)) return this.curve.point(null, null); // P + Q = O

	  if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
	  var c = this.y.redSub(p.y);
	  if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
	  var nx = c.redSqr().redISub(this.x).redISub(p.x);
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point.prototype.dbl = function dbl() {
	  if (this.inf) return this; // 2P = O

	  var ys1 = this.y.redAdd(this.y);
	  if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
	  var a = this.curve.a;
	  var x2 = this.x.redSqr();
	  var dyinv = ys1.redInvm();
	  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
	  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point.prototype.getX = function getX() {
	  return this.x.fromRed();
	};

	Point.prototype.getY = function getY() {
	  return this.y.fromRed();
	};

	Point.prototype.mul = function mul(k) {
	  k = new bn(k, 16);
	  if (this.isInfinity()) return this;else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);else if (this.curve.endo) return this.curve._endoWnafMulAdd([this], [k]);else return this.curve._wnafMul(this, k);
	};

	Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
	  var points = [this, p2];
	  var coeffs = [k1, k2];
	  if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);else return this.curve._wnafMulAdd(1, points, coeffs, 2);
	};

	Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
	  var points = [this, p2];
	  var coeffs = [k1, k2];
	  if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
	};

	Point.prototype.eq = function eq(p) {
	  return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
	};

	Point.prototype.neg = function neg(_precompute) {
	  if (this.inf) return this;
	  var res = this.curve.point(this.x, this.y.redNeg());

	  if (_precompute && this.precomputed) {
	    var pre = this.precomputed;

	    var negate = function (p) {
	      return p.neg();
	    };

	    res.precomputed = {
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(negate)
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(negate)
	      }
	    };
	  }

	  return res;
	};

	Point.prototype.toJ = function toJ() {
	  if (this.inf) return this.curve.jpoint(null, null, null);
	  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
	  return res;
	};

	function JPoint(curve, x, y, z) {
	  base.BasePoint.call(this, curve, 'jacobian');

	  if (x === null && y === null && z === null) {
	    this.x = this.curve.one;
	    this.y = this.curve.one;
	    this.z = new bn(0);
	  } else {
	    this.x = new bn(x, 16);
	    this.y = new bn(y, 16);
	    this.z = new bn(z, 16);
	  }

	  if (!this.x.red) this.x = this.x.toRed(this.curve.red);
	  if (!this.y.red) this.y = this.y.toRed(this.curve.red);
	  if (!this.z.red) this.z = this.z.toRed(this.curve.red);
	  this.zOne = this.z === this.curve.one;
	}

	inherits_browser(JPoint, base.BasePoint);

	ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
	  return new JPoint(this, x, y, z);
	};

	JPoint.prototype.toP = function toP() {
	  if (this.isInfinity()) return this.curve.point(null, null);
	  var zinv = this.z.redInvm();
	  var zinv2 = zinv.redSqr();
	  var ax = this.x.redMul(zinv2);
	  var ay = this.y.redMul(zinv2).redMul(zinv);
	  return this.curve.point(ax, ay);
	};

	JPoint.prototype.neg = function neg() {
	  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
	};

	JPoint.prototype.add = function add(p) {
	  // O + P = P
	  if (this.isInfinity()) return p; // P + O = P

	  if (p.isInfinity()) return this; // 12M + 4S + 7A

	  var pz2 = p.z.redSqr();
	  var z2 = this.z.redSqr();
	  var u1 = this.x.redMul(pz2);
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y.redMul(pz2.redMul(p.z));
	  var s2 = p.y.redMul(z2.redMul(this.z));
	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);

	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);else return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);
	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(p.z).redMul(h);
	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.mixedAdd = function mixedAdd(p) {
	  // O + P = P
	  if (this.isInfinity()) return p.toJ(); // P + O = P

	  if (p.isInfinity()) return this; // 8M + 3S + 7A

	  var z2 = this.z.redSqr();
	  var u1 = this.x;
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y;
	  var s2 = p.y.redMul(z2).redMul(this.z);
	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);

	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);else return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);
	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(h);
	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.dblp = function dblp(pow) {
	  if (pow === 0) return this;
	  if (this.isInfinity()) return this;
	  if (!pow) return this.dbl();
	  var i;

	  if (this.curve.zeroA || this.curve.threeA) {
	    var r = this;

	    for (i = 0; i < pow; i++) r = r.dbl();

	    return r;
	  } // 1M + 2S + 1A + N * (4S + 5M + 8A)
	  // N = 1 => 6M + 6S + 9A


	  var a = this.curve.a;
	  var tinv = this.curve.tinv;
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr(); // Reuse results

	  var jyd = jy.redAdd(jy);

	  for (i = 0; i < pow; i++) {
	    var jx2 = jx.redSqr();
	    var jyd2 = jyd.redSqr();
	    var jyd4 = jyd2.redSqr();
	    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
	    var t1 = jx.redMul(jyd2);
	    var nx = c.redSqr().redISub(t1.redAdd(t1));
	    var t2 = t1.redISub(nx);
	    var dny = c.redMul(t2);
	    dny = dny.redIAdd(dny).redISub(jyd4);
	    var nz = jyd.redMul(jz);
	    if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
	    jx = nx;
	    jz = nz;
	    jyd = dny;
	  }

	  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
	};

	JPoint.prototype.dbl = function dbl() {
	  if (this.isInfinity()) return this;
	  if (this.curve.zeroA) return this._zeroDbl();else if (this.curve.threeA) return this._threeDbl();else return this._dbl();
	};

	JPoint.prototype._zeroDbl = function _zeroDbl() {
	  var nx;
	  var ny;
	  var nz; // Z = 1

	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 14A
	    // XX = X1^2
	    var xx = this.x.redSqr(); // YY = Y1^2

	    var yy = this.y.redSqr(); // YYYY = YY^2

	    var yyyy = yy.redSqr(); // S = 2 * ((X1 + YY)^2 - XX - YYYY)

	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s); // M = 3 * XX + a; a = 0

	    var m = xx.redAdd(xx).redIAdd(xx); // T = M ^ 2 - 2*S

	    var t = m.redSqr().redISub(s).redISub(s); // 8 * YYYY

	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8); // X3 = T

	    nx = t; // Y3 = M * (S - T) - 8 * YYYY

	    ny = m.redMul(s.redISub(t)).redISub(yyyy8); // Z3 = 2*Y1

	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-dbl-2009-l
	    // 2M + 5S + 13A
	    // A = X1^2
	    var a = this.x.redSqr(); // B = Y1^2

	    var b = this.y.redSqr(); // C = B^2

	    var c = b.redSqr(); // D = 2 * ((X1 + B)^2 - A - C)

	    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
	    d = d.redIAdd(d); // E = 3 * A

	    var e = a.redAdd(a).redIAdd(a); // F = E^2

	    var f = e.redSqr(); // 8 * C

	    var c8 = c.redIAdd(c);
	    c8 = c8.redIAdd(c8);
	    c8 = c8.redIAdd(c8); // X3 = F - 2 * D

	    nx = f.redISub(d).redISub(d); // Y3 = E * (D - X3) - 8 * C

	    ny = e.redMul(d.redISub(nx)).redISub(c8); // Z3 = 2 * Y1 * Z1

	    nz = this.y.redMul(this.z);
	    nz = nz.redIAdd(nz);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype._threeDbl = function _threeDbl() {
	  var nx;
	  var ny;
	  var nz; // Z = 1

	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 15A
	    // XX = X1^2
	    var xx = this.x.redSqr(); // YY = Y1^2

	    var yy = this.y.redSqr(); // YYYY = YY^2

	    var yyyy = yy.redSqr(); // S = 2 * ((X1 + YY)^2 - XX - YYYY)

	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s); // M = 3 * XX + a

	    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a); // T = M^2 - 2 * S

	    var t = m.redSqr().redISub(s).redISub(s); // X3 = T

	    nx = t; // Y3 = M * (S - T) - 8 * YYYY

	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8); // Z3 = 2 * Y1

	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
	    // 3M + 5S
	    // delta = Z1^2
	    var delta = this.z.redSqr(); // gamma = Y1^2

	    var gamma = this.y.redSqr(); // beta = X1 * gamma

	    var beta = this.x.redMul(gamma); // alpha = 3 * (X1 - delta) * (X1 + delta)

	    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
	    alpha = alpha.redAdd(alpha).redIAdd(alpha); // X3 = alpha^2 - 8 * beta

	    var beta4 = beta.redIAdd(beta);
	    beta4 = beta4.redIAdd(beta4);
	    var beta8 = beta4.redAdd(beta4);
	    nx = alpha.redSqr().redISub(beta8); // Z3 = (Y1 + Z1)^2 - gamma - delta

	    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta); // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2

	    var ggamma8 = gamma.redSqr();
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype._dbl = function _dbl() {
	  var a = this.curve.a; // 4M + 6S + 10A

	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();
	  var jx2 = jx.redSqr();
	  var jy2 = jy.redSqr();
	  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
	  var jxd4 = jx.redAdd(jx);
	  jxd4 = jxd4.redIAdd(jxd4);
	  var t1 = jxd4.redMul(jy2);
	  var nx = c.redSqr().redISub(t1.redAdd(t1));
	  var t2 = t1.redISub(nx);
	  var jyd8 = jy2.redSqr();
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  var ny = c.redMul(t2).redISub(jyd8);
	  var nz = jy.redAdd(jy).redMul(jz);
	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.trpl = function trpl() {
	  if (!this.curve.zeroA) return this.dbl().add(this); // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
	  // 5M + 10S + ...
	  // XX = X1^2

	  var xx = this.x.redSqr(); // YY = Y1^2

	  var yy = this.y.redSqr(); // ZZ = Z1^2

	  var zz = this.z.redSqr(); // YYYY = YY^2

	  var yyyy = yy.redSqr(); // M = 3 * XX + a * ZZ2; a = 0

	  var m = xx.redAdd(xx).redIAdd(xx); // MM = M^2

	  var mm = m.redSqr(); // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM

	  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	  e = e.redIAdd(e);
	  e = e.redAdd(e).redIAdd(e);
	  e = e.redISub(mm); // EE = E^2

	  var ee = e.redSqr(); // T = 16*YYYY

	  var t = yyyy.redIAdd(yyyy);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t); // U = (M + E)^2 - MM - EE - T

	  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t); // X3 = 4 * (X1 * EE - 4 * YY * U)

	  var yyu4 = yy.redMul(u);
	  yyu4 = yyu4.redIAdd(yyu4);
	  yyu4 = yyu4.redIAdd(yyu4);
	  var nx = this.x.redMul(ee).redISub(yyu4);
	  nx = nx.redIAdd(nx);
	  nx = nx.redIAdd(nx); // Y3 = 8 * Y1 * (U * (T - U) - E * EE)

	  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny); // Z3 = (Z1 + E)^2 - ZZ - EE

	  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.mul = function mul(k, kbase) {
	  k = new bn(k, kbase);
	  return this.curve._wnafMul(this, k);
	};

	JPoint.prototype.eq = function eq(p) {
	  if (p.type === 'affine') return this.eq(p.toJ());
	  if (this === p) return true; // x1 * z2^2 == x2 * z1^2

	  var z2 = this.z.redSqr();
	  var pz2 = p.z.redSqr();
	  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false; // y1 * z2^3 == y2 * z1^3

	  var z3 = z2.redMul(this.z);
	  var pz3 = pz2.redMul(p.z);
	  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
	};

	JPoint.prototype.eqXToP = function eqXToP(x) {
	  var zs = this.z.redSqr();
	  var rx = x.toRed(this.curve.red).redMul(zs);
	  if (this.x.cmp(rx) === 0) return true;
	  var xc = x.clone();
	  var t = this.curve.redN.redMul(zs);

	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0) return false;
	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0) return true;
	  }
	};

	JPoint.prototype.inspect = function inspect() {
	  if (this.isInfinity()) return '<EC JPoint Infinity>';
	  return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
	};

	JPoint.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};

	var curve_1 = createCommonjsModule(function (module, exports) {

	  var curve = exports;
	  curve.base = base;
	  curve.short = short_1;
	  curve.mont =
	  /*RicMoo:ethers:require(./mont)*/
	  null;
	  curve.edwards =
	  /*RicMoo:ethers:require(./edwards)*/
	  null;
	});
	var curves_1 = createCommonjsModule(function (module, exports) {

	  var curves = exports;
	  var assert = utils_1$1.assert;

	  function PresetCurve(options) {
	    if (options.type === 'short') this.curve = new curve_1.short(options);else if (options.type === 'edwards') this.curve = new curve_1.edwards(options);else this.curve = new curve_1.mont(options);
	    this.g = this.curve.g;
	    this.n = this.curve.n;
	    this.hash = options.hash;
	    assert(this.g.validate(), 'Invalid curve');
	    assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
	  }

	  curves.PresetCurve = PresetCurve;

	  function defineCurve(name, options) {
	    Object.defineProperty(curves, name, {
	      configurable: true,
	      enumerable: true,
	      get: function () {
	        var curve = new PresetCurve(options);
	        Object.defineProperty(curves, name, {
	          configurable: true,
	          enumerable: true,
	          value: curve
	        });
	        return curve;
	      }
	    });
	  }

	  defineCurve('p192', {
	    type: 'short',
	    prime: 'p192',
	    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
	    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
	    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
	    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
	    hash: hash.sha256,
	    gRed: false,
	    g: ['188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012', '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811']
	  });
	  defineCurve('p224', {
	    type: 'short',
	    prime: 'p224',
	    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
	    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
	    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
	    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
	    hash: hash.sha256,
	    gRed: false,
	    g: ['b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21', 'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34']
	  });
	  defineCurve('p256', {
	    type: 'short',
	    prime: null,
	    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
	    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
	    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
	    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
	    hash: hash.sha256,
	    gRed: false,
	    g: ['6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296', '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5']
	  });
	  defineCurve('p384', {
	    type: 'short',
	    prime: null,
	    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'fffffffe ffffffff 00000000 00000000 ffffffff',
	    a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'fffffffe ffffffff 00000000 00000000 fffffffc',
	    b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' + '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
	    n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' + 'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
	    hash: hash.sha384,
	    gRed: false,
	    g: ['aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' + '5502f25d bf55296c 3a545e38 72760ab7', '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' + '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f']
	  });
	  defineCurve('p521', {
	    type: 'short',
	    prime: null,
	    p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff',
	    a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff fffffffc',
	    b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' + '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' + '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
	    n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' + 'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
	    hash: hash.sha512,
	    gRed: false,
	    g: ['000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' + '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' + 'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66', '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' + '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' + '3fad0761 353c7086 a272c240 88be9476 9fd16650']
	  });
	  defineCurve('curve25519', {
	    type: 'mont',
	    prime: 'p25519',
	    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	    a: '76d06',
	    b: '1',
	    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	    hash: hash.sha256,
	    gRed: false,
	    g: ['9']
	  });
	  defineCurve('ed25519', {
	    type: 'edwards',
	    prime: 'p25519',
	    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	    a: '-1',
	    c: '1',
	    // -121665 * (121666^(-1)) (mod P)
	    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
	    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	    hash: hash.sha256,
	    gRed: false,
	    g: ['216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a', // 4/5
	    '6666666666666666666666666666666666666666666666666666666666666658']
	  });
	  var pre;

	  try {
	    pre =
	    /*RicMoo:ethers:require(./precomputed/secp256k1)*/
	    null.crash();
	  } catch (e) {
	    pre = undefined;
	  }

	  defineCurve('secp256k1', {
	    type: 'short',
	    prime: 'k256',
	    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
	    a: '0',
	    b: '7',
	    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
	    h: '1',
	    hash: hash.sha256,
	    // Precomputed endomorphism
	    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
	    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
	    basis: [{
	      a: '3086d221a7d46bcde86c90e49284eb15',
	      b: '-e4437ed6010e88286f547fa90abfe4c3'
	    }, {
	      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
	      b: '3086d221a7d46bcde86c90e49284eb15'
	    }],
	    gRed: false,
	    g: ['79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798', '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8', pre]
	  });
	});

	function HmacDRBG(options) {
	  if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
	  this.hash = options.hash;
	  this.predResist = !!options.predResist;
	  this.outLen = this.hash.outSize;
	  this.minEntropy = options.minEntropy || this.hash.hmacStrength;
	  this._reseed = null;
	  this.reseedInterval = null;
	  this.K = null;
	  this.V = null;
	  var entropy = utils_1.toArray(options.entropy, options.entropyEnc || 'hex');
	  var nonce = utils_1.toArray(options.nonce, options.nonceEnc || 'hex');
	  var pers = utils_1.toArray(options.pers, options.persEnc || 'hex');
	  minimalisticAssert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

	  this._init(entropy, nonce, pers);
	}

	var hmacDrbg = HmacDRBG;

	HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
	  var seed = entropy.concat(nonce).concat(pers);
	  this.K = new Array(this.outLen / 8);
	  this.V = new Array(this.outLen / 8);

	  for (var i = 0; i < this.V.length; i++) {
	    this.K[i] = 0x00;
	    this.V[i] = 0x01;
	  }

	  this._update(seed);

	  this._reseed = 1;
	  this.reseedInterval = 0x1000000000000; // 2^48
	};

	HmacDRBG.prototype._hmac = function hmac() {
	  return new hash.hmac(this.hash, this.K);
	};

	HmacDRBG.prototype._update = function update(seed) {
	  var kmac = this._hmac().update(this.V).update([0x00]);

	  if (seed) kmac = kmac.update(seed);
	  this.K = kmac.digest();
	  this.V = this._hmac().update(this.V).digest();
	  if (!seed) return;
	  this.K = this._hmac().update(this.V).update([0x01]).update(seed).digest();
	  this.V = this._hmac().update(this.V).digest();
	};

	HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
	  // Optional entropy enc
	  if (typeof entropyEnc !== 'string') {
	    addEnc = add;
	    add = entropyEnc;
	    entropyEnc = null;
	  }

	  entropy = utils_1.toArray(entropy, entropyEnc);
	  add = utils_1.toArray(add, addEnc);
	  minimalisticAssert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

	  this._update(entropy.concat(add || []));

	  this._reseed = 1;
	};

	HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
	  if (this._reseed > this.reseedInterval) throw new Error('Reseed is required'); // Optional encoding

	  if (typeof enc !== 'string') {
	    addEnc = add;
	    add = enc;
	    enc = null;
	  } // Optional additional data


	  if (add) {
	    add = utils_1.toArray(add, addEnc || 'hex');

	    this._update(add);
	  }

	  var temp = [];

	  while (temp.length < len) {
	    this.V = this._hmac().update(this.V).digest();
	    temp = temp.concat(this.V);
	  }

	  var res = temp.slice(0, len);

	  this._update(add);

	  this._reseed++;
	  return utils_1.encode(res, enc);
	};

	var assert$3 = utils_1$1.assert;

	function KeyPair(ec, options) {
	  this.ec = ec;
	  this.priv = null;
	  this.pub = null; // KeyPair(ec, { priv: ..., pub: ... })

	  if (options.priv) this._importPrivate(options.priv, options.privEnc);
	  if (options.pub) this._importPublic(options.pub, options.pubEnc);
	}

	var key$1 = KeyPair;

	KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
	  if (pub instanceof KeyPair) return pub;
	  return new KeyPair(ec, {
	    pub: pub,
	    pubEnc: enc
	  });
	};

	KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
	  if (priv instanceof KeyPair) return priv;
	  return new KeyPair(ec, {
	    priv: priv,
	    privEnc: enc
	  });
	};

	KeyPair.prototype.validate = function validate() {
	  var pub = this.getPublic();
	  if (pub.isInfinity()) return {
	    result: false,
	    reason: 'Invalid public key'
	  };
	  if (!pub.validate()) return {
	    result: false,
	    reason: 'Public key is not a point'
	  };
	  if (!pub.mul(this.ec.curve.n).isInfinity()) return {
	    result: false,
	    reason: 'Public key * N != O'
	  };
	  return {
	    result: true,
	    reason: null
	  };
	};

	KeyPair.prototype.getPublic = function getPublic(compact, enc) {
	  // compact is optional argument
	  if (typeof compact === 'string') {
	    enc = compact;
	    compact = null;
	  }

	  if (!this.pub) this.pub = this.ec.g.mul(this.priv);
	  if (!enc) return this.pub;
	  return this.pub.encode(enc, compact);
	};

	KeyPair.prototype.getPrivate = function getPrivate(enc) {
	  if (enc === 'hex') return this.priv.toString(16, 2);else return this.priv;
	};

	KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
	  this.priv = new bn(key, enc || 16); // Ensure that the priv won't be bigger than n, otherwise we may fail
	  // in fixed multiplication method

	  this.priv = this.priv.umod(this.ec.curve.n);
	};

	KeyPair.prototype._importPublic = function _importPublic(key, enc) {
	  if (key.x || key.y) {
	    // Montgomery points only have an `x` coordinate.
	    // Weierstrass/Edwards points on the other hand have both `x` and
	    // `y` coordinates.
	    if (this.ec.curve.type === 'mont') {
	      assert$3(key.x, 'Need x coordinate');
	    } else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') {
	      assert$3(key.x && key.y, 'Need both x and y coordinate');
	    }

	    this.pub = this.ec.curve.point(key.x, key.y);
	    return;
	  }

	  this.pub = this.ec.curve.decodePoint(key, enc);
	}; // ECDH


	KeyPair.prototype.derive = function derive(pub) {
	  if (!pub.validate()) {
	    assert$3(pub.validate(), 'public point not validated');
	  }

	  return pub.mul(this.priv).getX();
	}; // ECDSA


	KeyPair.prototype.sign = function sign(msg, enc, options) {
	  return this.ec.sign(msg, this, enc, options);
	};

	KeyPair.prototype.verify = function verify(msg, signature) {
	  return this.ec.verify(msg, signature, this);
	};

	KeyPair.prototype.inspect = function inspect() {
	  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
	};

	var assert$4 = utils_1$1.assert;

	function Signature(options, enc) {
	  if (options instanceof Signature) return options;
	  if (this._importDER(options, enc)) return;
	  assert$4(options.r && options.s, 'Signature without r or s');
	  this.r = new bn(options.r, 16);
	  this.s = new bn(options.s, 16);
	  if (options.recoveryParam === undefined) this.recoveryParam = null;else this.recoveryParam = options.recoveryParam;
	}

	var signature = Signature;

	function Position() {
	  this.place = 0;
	}

	function getLength(buf, p) {
	  var initial = buf[p.place++];

	  if (!(initial & 0x80)) {
	    return initial;
	  }

	  var octetLen = initial & 0xf; // Indefinite length or overflow

	  if (octetLen === 0 || octetLen > 4) {
	    return false;
	  }

	  var val = 0;

	  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
	    val <<= 8;
	    val |= buf[off];
	    val >>>= 0;
	  } // Leading zeroes


	  if (val <= 0x7f) {
	    return false;
	  }

	  p.place = off;
	  return val;
	}

	function rmPadding(buf) {
	  var i = 0;
	  var len = buf.length - 1;

	  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
	    i++;
	  }

	  if (i === 0) {
	    return buf;
	  }

	  return buf.slice(i);
	}

	Signature.prototype._importDER = function _importDER(data, enc) {
	  data = utils_1$1.toArray(data, enc);
	  var p = new Position();

	  if (data[p.place++] !== 0x30) {
	    return false;
	  }

	  var len = getLength(data, p);

	  if (len === false) {
	    return false;
	  }

	  if (len + p.place !== data.length) {
	    return false;
	  }

	  if (data[p.place++] !== 0x02) {
	    return false;
	  }

	  var rlen = getLength(data, p);

	  if (rlen === false) {
	    return false;
	  }

	  var r = data.slice(p.place, rlen + p.place);
	  p.place += rlen;

	  if (data[p.place++] !== 0x02) {
	    return false;
	  }

	  var slen = getLength(data, p);

	  if (slen === false) {
	    return false;
	  }

	  if (data.length !== slen + p.place) {
	    return false;
	  }

	  var s = data.slice(p.place, slen + p.place);

	  if (r[0] === 0) {
	    if (r[1] & 0x80) {
	      r = r.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }

	  if (s[0] === 0) {
	    if (s[1] & 0x80) {
	      s = s.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }

	  this.r = new bn(r);
	  this.s = new bn(s);
	  this.recoveryParam = null;
	  return true;
	};

	function constructLength(arr, len) {
	  if (len < 0x80) {
	    arr.push(len);
	    return;
	  }

	  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
	  arr.push(octets | 0x80);

	  while (--octets) {
	    arr.push(len >>> (octets << 3) & 0xff);
	  }

	  arr.push(len);
	}

	Signature.prototype.toDER = function toDER(enc) {
	  var r = this.r.toArray();
	  var s = this.s.toArray(); // Pad values

	  if (r[0] & 0x80) r = [0].concat(r); // Pad values

	  if (s[0] & 0x80) s = [0].concat(s);
	  r = rmPadding(r);
	  s = rmPadding(s);

	  while (!s[0] && !(s[1] & 0x80)) {
	    s = s.slice(1);
	  }

	  var arr = [0x02];
	  constructLength(arr, r.length);
	  arr = arr.concat(r);
	  arr.push(0x02);
	  constructLength(arr, s.length);
	  var backHalf = arr.concat(s);
	  var res = [0x30];
	  constructLength(res, backHalf.length);
	  res = res.concat(backHalf);
	  return utils_1$1.encode(res, enc);
	};

	var rand =
	/*RicMoo:ethers:require(brorand)*/
	function () {
	  throw new Error('unsupported');
	};

	var assert$5 = utils_1$1.assert;

	function EC(options) {
	  if (!(this instanceof EC)) return new EC(options); // Shortcut `elliptic.ec(curve-name)`

	  if (typeof options === 'string') {
	    assert$5(Object.prototype.hasOwnProperty.call(curves_1, options), 'Unknown curve ' + options);
	    options = curves_1[options];
	  } // Shortcut for `elliptic.ec(elliptic.curves.curveName)`


	  if (options instanceof curves_1.PresetCurve) options = {
	    curve: options
	  };
	  this.curve = options.curve.curve;
	  this.n = this.curve.n;
	  this.nh = this.n.ushrn(1);
	  this.g = this.curve.g; // Point on curve

	  this.g = options.curve.g;
	  this.g.precompute(options.curve.n.bitLength() + 1); // Hash for function for DRBG

	  this.hash = options.hash || options.curve.hash;
	}

	var ec = EC;

	EC.prototype.keyPair = function keyPair(options) {
	  return new key$1(this, options);
	};

	EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
	  return key$1.fromPrivate(this, priv, enc);
	};

	EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
	  return key$1.fromPublic(this, pub, enc);
	};

	EC.prototype.genKeyPair = function genKeyPair(options) {
	  if (!options) options = {}; // Instantiate Hmac_DRBG

	  var drbg = new hmacDrbg({
	    hash: this.hash,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	    entropy: options.entropy || rand(this.hash.hmacStrength),
	    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
	    nonce: this.n.toArray()
	  });
	  var bytes = this.n.byteLength();
	  var ns2 = this.n.sub(new bn(2));

	  for (;;) {
	    var priv = new bn(drbg.generate(bytes));
	    if (priv.cmp(ns2) > 0) continue;
	    priv.iaddn(1);
	    return this.keyFromPrivate(priv);
	  }
	};

	EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
	  var delta = msg.byteLength() * 8 - this.n.bitLength();
	  if (delta > 0) msg = msg.ushrn(delta);
	  if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);else return msg;
	};

	EC.prototype.sign = function sign(msg, key, enc, options) {
	  if (typeof enc === 'object') {
	    options = enc;
	    enc = null;
	  }

	  if (!options) options = {};
	  key = this.keyFromPrivate(key, enc);
	  msg = this._truncateToN(new bn(msg, 16)); // Zero-extend key to provide enough entropy

	  var bytes = this.n.byteLength();
	  var bkey = key.getPrivate().toArray('be', bytes); // Zero-extend nonce to have the same byte size as N

	  var nonce = msg.toArray('be', bytes); // Instantiate Hmac_DRBG

	  var drbg = new hmacDrbg({
	    hash: this.hash,
	    entropy: bkey,
	    nonce: nonce,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8'
	  }); // Number of bytes to generate

	  var ns1 = this.n.sub(new bn(1));

	  for (var iter = 0;; iter++) {
	    var k = options.k ? options.k(iter) : new bn(drbg.generate(this.n.byteLength()));
	    k = this._truncateToN(k, true);
	    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
	    var kp = this.g.mul(k);
	    if (kp.isInfinity()) continue;
	    var kpX = kp.getX();
	    var r = kpX.umod(this.n);
	    if (r.cmpn(0) === 0) continue;
	    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
	    s = s.umod(this.n);
	    if (s.cmpn(0) === 0) continue;
	    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0); // Use complement of `s`, if it is > `n / 2`

	    if (options.canonical && s.cmp(this.nh) > 0) {
	      s = this.n.sub(s);
	      recoveryParam ^= 1;
	    }

	    return new signature({
	      r: r,
	      s: s,
	      recoveryParam: recoveryParam
	    });
	  }
	};

	EC.prototype.verify = function verify(msg, signature$1, key, enc) {
	  msg = this._truncateToN(new bn(msg, 16));
	  key = this.keyFromPublic(key, enc);
	  signature$1 = new signature(signature$1, 'hex'); // Perform primitive values validation

	  var r = signature$1.r;
	  var s = signature$1.s;
	  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
	  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false; // Validate signature

	  var sinv = s.invm(this.n);
	  var u1 = sinv.mul(msg).umod(this.n);
	  var u2 = sinv.mul(r).umod(this.n);
	  var p;

	  if (!this.curve._maxwellTrick) {
	    p = this.g.mulAdd(u1, key.getPublic(), u2);
	    if (p.isInfinity()) return false;
	    return p.getX().umod(this.n).cmp(r) === 0;
	  } // NOTE: Greg Maxwell's trick, inspired by:
	  // https://git.io/vad3K


	  p = this.g.jmulAdd(u1, key.getPublic(), u2);
	  if (p.isInfinity()) return false; // Compare `p.x` of Jacobian point with `r`,
	  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
	  // inverse of `p.z^2`

	  return p.eqXToP(r);
	};

	EC.prototype.recoverPubKey = function (msg, signature$1, j, enc) {
	  assert$5((3 & j) === j, 'The recovery param is more than two bits');
	  signature$1 = new signature(signature$1, enc);
	  var n = this.n;
	  var e = new bn(msg);
	  var r = signature$1.r;
	  var s = signature$1.s; // A set LSB signifies that the y-coordinate is odd

	  var isYOdd = j & 1;
	  var isSecondKey = j >> 1;
	  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate'); // 1.1. Let x = r + jn.

	  if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);else r = this.curve.pointFromX(r, isYOdd);
	  var rInv = signature$1.r.invm(n);
	  var s1 = n.sub(e).mul(rInv).umod(n);
	  var s2 = s.mul(rInv).umod(n); // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)

	  return this.g.mulAdd(s1, r, s2);
	};

	EC.prototype.getKeyRecoveryParam = function (e, signature$1, Q, enc) {
	  signature$1 = new signature(signature$1, enc);
	  if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;

	  for (var i = 0; i < 4; i++) {
	    var Qprime;

	    try {
	      Qprime = this.recoverPubKey(e, signature$1, i);
	    } catch (e) {
	      continue;
	    }

	    if (Qprime.eq(Q)) return i;
	  }

	  throw new Error('Unable to find valid recovery factor');
	};

	var elliptic_1 = createCommonjsModule(function (module, exports) {

	  var elliptic = exports;
	  elliptic.version =
	  /*RicMoo:ethers*/
	  {
	    version: "6.5.4"
	  }.version;
	  elliptic.utils = utils_1$1;

	  elliptic.rand =
	  /*RicMoo:ethers:require(brorand)*/
	  function () {
	    throw new Error('unsupported');
	  };

	  elliptic.curve = curve_1;
	  elliptic.curves = curves_1; // Protocols

	  elliptic.ec = ec;
	  elliptic.eddsa =
	  /*RicMoo:ethers:require(./elliptic/eddsa)*/
	  null;
	});
	var EC$1 = elliptic_1.ec;

	const version$7 = "signing-key/5.7.0";

	const logger$8 = new Logger(version$7);
	let _curve = null;

	function getCurve() {
	  if (!_curve) {
	    _curve = new EC$1("secp256k1");
	  }

	  return _curve;
	}

	class SigningKey {
	  constructor(privateKey) {
	    defineReadOnly(this, "curve", "secp256k1");
	    defineReadOnly(this, "privateKey", hexlify(privateKey));

	    if (hexDataLength(this.privateKey) !== 32) {
	      logger$8.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
	    }

	    const keyPair = getCurve().keyFromPrivate(arrayify(this.privateKey));
	    defineReadOnly(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
	    defineReadOnly(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
	    defineReadOnly(this, "_isSigningKey", true);
	  }

	  _addPoint(other) {
	    const p0 = getCurve().keyFromPublic(arrayify(this.publicKey));
	    const p1 = getCurve().keyFromPublic(arrayify(other));
	    return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
	  }

	  signDigest(digest) {
	    const keyPair = getCurve().keyFromPrivate(arrayify(this.privateKey));
	    const digestBytes = arrayify(digest);

	    if (digestBytes.length !== 32) {
	      logger$8.throwArgumentError("bad digest length", "digest", digest);
	    }

	    const signature = keyPair.sign(digestBytes, {
	      canonical: true
	    });
	    return splitSignature({
	      recoveryParam: signature.recoveryParam,
	      r: hexZeroPad("0x" + signature.r.toString(16), 32),
	      s: hexZeroPad("0x" + signature.s.toString(16), 32)
	    });
	  }

	  computeSharedSecret(otherKey) {
	    const keyPair = getCurve().keyFromPrivate(arrayify(this.privateKey));
	    const otherKeyPair = getCurve().keyFromPublic(arrayify(computePublicKey(otherKey)));
	    return hexZeroPad("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
	  }

	  static isSigningKey(value) {
	    return !!(value && value._isSigningKey);
	  }

	}
	function recoverPublicKey(digest, signature) {
	  const sig = splitSignature(signature);
	  const rs = {
	    r: arrayify(sig.r),
	    s: arrayify(sig.s)
	  };
	  return "0x" + getCurve().recoverPubKey(arrayify(digest), rs, sig.recoveryParam).encode("hex", false);
	}
	function computePublicKey(key, compressed) {
	  const bytes = arrayify(key);

	  if (bytes.length === 32) {
	    const signingKey = new SigningKey(bytes);

	    if (compressed) {
	      return "0x" + getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
	    }

	    return signingKey.publicKey;
	  } else if (bytes.length === 33) {
	    if (compressed) {
	      return hexlify(bytes);
	    }

	    return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
	  } else if (bytes.length === 65) {
	    if (!compressed) {
	      return hexlify(bytes);
	    }

	    return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
	  }

	  return logger$8.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
	}

	const version$6 = "transactions/5.7.0";

	const logger$7 = new Logger(version$6);
	var TransactionTypes;

	(function (TransactionTypes) {
	  TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
	  TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
	  TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
	})(TransactionTypes || (TransactionTypes = {}));

	function handleAddress(value) {
	  if (value === "0x") {
	    return null;
	  }

	  return getAddress(value);
	}

	function handleNumber(value) {
	  if (value === "0x") {
	    return Zero$1;
	  }

	  return BigNumber.from(value);
	} // Legacy Transaction Fields
	function computeAddress(key) {
	  const publicKey = computePublicKey(key);
	  return getAddress(hexDataSlice(keccak256(hexDataSlice(publicKey, 1)), 12));
	}
	function recoverAddress(digest, signature) {
	  return computeAddress(recoverPublicKey(arrayify(digest), signature));
	}

	function formatNumber(value, name) {
	  const result = stripZeros(BigNumber.from(value).toHexString());

	  if (result.length > 32) {
	    logger$7.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
	  }

	  return result;
	}

	function accessSetify(addr, storageKeys) {
	  return {
	    address: getAddress(addr),
	    storageKeys: (storageKeys || []).map((storageKey, index) => {
	      if (hexDataLength(storageKey) !== 32) {
	        logger$7.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
	      }

	      return storageKey.toLowerCase();
	    })
	  };
	}

	function accessListify(value) {
	  if (Array.isArray(value)) {
	    return value.map((set, index) => {
	      if (Array.isArray(set)) {
	        if (set.length > 2) {
	          logger$7.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
	        }

	        return accessSetify(set[0], set[1]);
	      }

	      return accessSetify(set.address, set.storageKeys);
	    });
	  }

	  const result = Object.keys(value).map(addr => {
	    const storageKeys = value[addr].reduce((accum, storageKey) => {
	      accum[storageKey] = true;
	      return accum;
	    }, {});
	    return accessSetify(addr, Object.keys(storageKeys).sort());
	  });
	  result.sort((a, b) => a.address.localeCompare(b.address));
	  return result;
	}

	function formatAccessList(value) {
	  return accessListify(value).map(set => [set.address, set.storageKeys]);
	}

	function _serializeEip1559(transaction, signature) {
	  // If there is an explicit gasPrice, make sure it matches the
	  // EIP-1559 fees; otherwise they may not understand what they
	  // think they are setting in terms of fee.
	  if (transaction.gasPrice != null) {
	    const gasPrice = BigNumber.from(transaction.gasPrice);
	    const maxFeePerGas = BigNumber.from(transaction.maxFeePerGas || 0);

	    if (!gasPrice.eq(maxFeePerGas)) {
	      logger$7.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
	        gasPrice,
	        maxFeePerGas
	      });
	    }
	  }

	  const fields = [formatNumber(transaction.chainId || 0, "chainId"), formatNumber(transaction.nonce || 0, "nonce"), formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"), formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"), formatNumber(transaction.gasLimit || 0, "gasLimit"), transaction.to != null ? getAddress(transaction.to) : "0x", formatNumber(transaction.value || 0, "value"), transaction.data || "0x", formatAccessList(transaction.accessList || [])];

	  if (signature) {
	    const sig = splitSignature(signature);
	    fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
	    fields.push(stripZeros(sig.r));
	    fields.push(stripZeros(sig.s));
	  }

	  return hexConcat(["0x02", encode$3(fields)]);
	}

	function _serializeEip2930(transaction, signature) {
	  const fields = [formatNumber(transaction.chainId || 0, "chainId"), formatNumber(transaction.nonce || 0, "nonce"), formatNumber(transaction.gasPrice || 0, "gasPrice"), formatNumber(transaction.gasLimit || 0, "gasLimit"), transaction.to != null ? getAddress(transaction.to) : "0x", formatNumber(transaction.value || 0, "value"), transaction.data || "0x", formatAccessList(transaction.accessList || [])];

	  if (signature) {
	    const sig = splitSignature(signature);
	    fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
	    fields.push(stripZeros(sig.r));
	    fields.push(stripZeros(sig.s));
	  }

	  return hexConcat(["0x01", encode$3(fields)]);
	} // Legacy Transactions and EIP-155

	function _parseEipSignature(tx, fields, serialize) {
	  try {
	    const recid = handleNumber(fields[0]).toNumber();

	    if (recid !== 0 && recid !== 1) {
	      throw new Error("bad recid");
	    }

	    tx.v = recid;
	  } catch (error) {
	    logger$7.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
	  }

	  tx.r = hexZeroPad(fields[1], 32);
	  tx.s = hexZeroPad(fields[2], 32);

	  try {
	    const digest = keccak256(serialize(tx));
	    tx.from = recoverAddress(digest, {
	      r: tx.r,
	      s: tx.s,
	      recoveryParam: tx.v
	    });
	  } catch (error) {}
	}

	function _parseEip1559(payload) {
	  const transaction = decode$2(payload.slice(1));

	  if (transaction.length !== 9 && transaction.length !== 12) {
	    logger$7.throwArgumentError("invalid component count for transaction type: 2", "payload", hexlify(payload));
	  }

	  const maxPriorityFeePerGas = handleNumber(transaction[2]);
	  const maxFeePerGas = handleNumber(transaction[3]);
	  const tx = {
	    type: 2,
	    chainId: handleNumber(transaction[0]).toNumber(),
	    nonce: handleNumber(transaction[1]).toNumber(),
	    maxPriorityFeePerGas: maxPriorityFeePerGas,
	    maxFeePerGas: maxFeePerGas,
	    gasPrice: null,
	    gasLimit: handleNumber(transaction[4]),
	    to: handleAddress(transaction[5]),
	    value: handleNumber(transaction[6]),
	    data: transaction[7],
	    accessList: accessListify(transaction[8])
	  }; // Unsigned EIP-1559 Transaction

	  if (transaction.length === 9) {
	    return tx;
	  }

	  tx.hash = keccak256(payload);

	  _parseEipSignature(tx, transaction.slice(9), _serializeEip1559);

	  return tx;
	}

	function _parseEip2930(payload) {
	  const transaction = decode$2(payload.slice(1));

	  if (transaction.length !== 8 && transaction.length !== 11) {
	    logger$7.throwArgumentError("invalid component count for transaction type: 1", "payload", hexlify(payload));
	  }

	  const tx = {
	    type: 1,
	    chainId: handleNumber(transaction[0]).toNumber(),
	    nonce: handleNumber(transaction[1]).toNumber(),
	    gasPrice: handleNumber(transaction[2]),
	    gasLimit: handleNumber(transaction[3]),
	    to: handleAddress(transaction[4]),
	    value: handleNumber(transaction[5]),
	    data: transaction[6],
	    accessList: accessListify(transaction[7])
	  }; // Unsigned EIP-2930 Transaction

	  if (transaction.length === 8) {
	    return tx;
	  }

	  tx.hash = keccak256(payload);

	  _parseEipSignature(tx, transaction.slice(8), _serializeEip2930);

	  return tx;
	} // Legacy Transactions and EIP-155


	function _parse(rawTransaction) {
	  const transaction = decode$2(rawTransaction);

	  if (transaction.length !== 9 && transaction.length !== 6) {
	    logger$7.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
	  }

	  const tx = {
	    nonce: handleNumber(transaction[0]).toNumber(),
	    gasPrice: handleNumber(transaction[1]),
	    gasLimit: handleNumber(transaction[2]),
	    to: handleAddress(transaction[3]),
	    value: handleNumber(transaction[4]),
	    data: transaction[5],
	    chainId: 0
	  }; // Legacy unsigned transaction

	  if (transaction.length === 6) {
	    return tx;
	  }

	  try {
	    tx.v = BigNumber.from(transaction[6]).toNumber();
	  } catch (error) {
	    // @TODO: What makes snese to do? The v is too big
	    return tx;
	  }

	  tx.r = hexZeroPad(transaction[7], 32);
	  tx.s = hexZeroPad(transaction[8], 32);

	  if (BigNumber.from(tx.r).isZero() && BigNumber.from(tx.s).isZero()) {
	    // EIP-155 unsigned transaction
	    tx.chainId = tx.v;
	    tx.v = 0;
	  } else {
	    // Signed Transaction
	    tx.chainId = Math.floor((tx.v - 35) / 2);

	    if (tx.chainId < 0) {
	      tx.chainId = 0;
	    }

	    let recoveryParam = tx.v - 27;
	    const raw = transaction.slice(0, 6);

	    if (tx.chainId !== 0) {
	      raw.push(hexlify(tx.chainId));
	      raw.push("0x");
	      raw.push("0x");
	      recoveryParam -= tx.chainId * 2 + 8;
	    }

	    const digest = keccak256(encode$3(raw));

	    try {
	      tx.from = recoverAddress(digest, {
	        r: hexlify(tx.r),
	        s: hexlify(tx.s),
	        recoveryParam: recoveryParam
	      });
	    } catch (error) {}

	    tx.hash = keccak256(rawTransaction);
	  }

	  tx.type = null;
	  return tx;
	}

	function parse(rawTransaction) {
	  const payload = arrayify(rawTransaction); // Legacy and EIP-155 Transactions

	  if (payload[0] > 0x7f) {
	    return _parse(payload);
	  } // Typed Transaction (EIP-2718)


	  switch (payload[0]) {
	    case 1:
	      return _parseEip2930(payload);

	    case 2:
	      return _parseEip1559(payload);
	  }

	  return logger$7.throwError(`unsupported transaction type: ${payload[0]}`, Logger.errors.UNSUPPORTED_OPERATION, {
	    operation: "parseTransaction",
	    transactionType: payload[0]
	  });
	}

	const version$5 = "contracts/5.7.0";

	var __awaiter$4 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$6 = new Logger(version$5);

	function resolveName(resolver, nameOrPromise) {
	  return __awaiter$4(this, void 0, void 0, function* () {
	    const name = yield nameOrPromise;

	    if (typeof name !== "string") {
	      logger$6.throwArgumentError("invalid address or ENS name", "name", name);
	    } // If it is already an address, just use it (after adding checksum)


	    try {
	      return getAddress(name);
	    } catch (error) {}

	    if (!resolver) {
	      logger$6.throwError("a provider or signer is needed to resolve ENS names", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "resolveName"
	      });
	    }

	    const address = yield resolver.resolveName(name);

	    if (address == null) {
	      logger$6.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
	    }

	    return address;
	  });
	} // Recursively replaces ENS names with promises to resolve the name and resolves all properties


	function resolveAddresses(resolver, value, paramType) {
	  return __awaiter$4(this, void 0, void 0, function* () {
	    if (Array.isArray(paramType)) {
	      return yield Promise.all(paramType.map((paramType, index) => {
	        return resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
	      }));
	    }

	    if (paramType.type === "address") {
	      return yield resolveName(resolver, value);
	    }

	    if (paramType.type === "tuple") {
	      return yield resolveAddresses(resolver, value, paramType.components);
	    }

	    if (paramType.baseType === "array") {
	      if (!Array.isArray(value)) {
	        return Promise.reject(logger$6.makeError("invalid value for array", Logger.errors.INVALID_ARGUMENT, {
	          argument: "value",
	          value
	        }));
	      }

	      return yield Promise.all(value.map(v => resolveAddresses(resolver, v, paramType.arrayChildren)));
	    }

	    return value;
	  });
	}

	function populateTransaction(contract, fragment, args) {
	  return __awaiter$4(this, void 0, void 0, function* () {
	    // If an extra argument is given, it is overrides
	    let overrides = {};

	    if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
	      overrides = shallowCopy(args.pop());
	    } // Make sure the parameter count matches


	    logger$6.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract"); // Populate "from" override (allow promises)

	    if (contract.signer) {
	      if (overrides.from) {
	        // Contracts with a Signer are from the Signer's frame-of-reference;
	        // but we allow overriding "from" if it matches the signer
	        overrides.from = resolveProperties({
	          override: resolveName(contract.signer, overrides.from),
	          signer: contract.signer.getAddress()
	        }).then(check => __awaiter$4(this, void 0, void 0, function* () {
	          if (getAddress(check.signer) !== check.override) {
	            logger$6.throwError("Contract with a Signer cannot override from", Logger.errors.UNSUPPORTED_OPERATION, {
	              operation: "overrides.from"
	            });
	          }

	          return check.override;
	        }));
	      } else {
	        overrides.from = contract.signer.getAddress();
	      }
	    } else if (overrides.from) {
	      overrides.from = resolveName(contract.provider, overrides.from); //} else {
	      // Contracts without a signer can override "from", and if
	      // unspecified the zero address is used
	      //overrides.from = AddressZero;
	    } // Wait for all dependencies to be resolved (prefer the signer over the provider)


	    const resolved = yield resolveProperties({
	      args: resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
	      address: contract.resolvedAddress,
	      overrides: resolveProperties(overrides) || {}
	    }); // The ABI coded transaction

	    const data = contract.interface.encodeFunctionData(fragment, resolved.args);
	    const tx = {
	      data: data,
	      to: resolved.address
	    }; // Resolved Overrides

	    const ro = resolved.overrides; // Populate simple overrides

	    if (ro.nonce != null) {
	      tx.nonce = BigNumber.from(ro.nonce).toNumber();
	    }

	    if (ro.gasLimit != null) {
	      tx.gasLimit = BigNumber.from(ro.gasLimit);
	    }

	    if (ro.gasPrice != null) {
	      tx.gasPrice = BigNumber.from(ro.gasPrice);
	    }

	    if (ro.maxFeePerGas != null) {
	      tx.maxFeePerGas = BigNumber.from(ro.maxFeePerGas);
	    }

	    if (ro.maxPriorityFeePerGas != null) {
	      tx.maxPriorityFeePerGas = BigNumber.from(ro.maxPriorityFeePerGas);
	    }

	    if (ro.from != null) {
	      tx.from = ro.from;
	    }

	    if (ro.type != null) {
	      tx.type = ro.type;
	    }

	    if (ro.accessList != null) {
	      tx.accessList = accessListify(ro.accessList);
	    } // If there was no "gasLimit" override, but the ABI specifies a default, use it


	    if (tx.gasLimit == null && fragment.gas != null) {
	      // Compute the intrinsic gas cost for this transaction
	      // @TODO: This is based on the yellow paper as of Petersburg; this is something
	      // we may wish to parameterize in v6 as part of the Network object. Since this
	      // is always a non-nil to address, we can ignore G_create, but may wish to add
	      // similar logic to the ContractFactory.
	      let intrinsic = 21000;
	      const bytes = arrayify(data);

	      for (let i = 0; i < bytes.length; i++) {
	        intrinsic += 4;

	        if (bytes[i]) {
	          intrinsic += 64;
	        }
	      }

	      tx.gasLimit = BigNumber.from(fragment.gas).add(intrinsic);
	    } // Populate "value" override


	    if (ro.value) {
	      const roValue = BigNumber.from(ro.value);

	      if (!roValue.isZero() && !fragment.payable) {
	        logger$6.throwError("non-payable method cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: "overrides.value",
	          value: overrides.value
	        });
	      }

	      tx.value = roValue;
	    }

	    if (ro.customData) {
	      tx.customData = shallowCopy(ro.customData);
	    }

	    if (ro.ccipReadEnabled) {
	      tx.ccipReadEnabled = !!ro.ccipReadEnabled;
	    } // Remove the overrides


	    delete overrides.nonce;
	    delete overrides.gasLimit;
	    delete overrides.gasPrice;
	    delete overrides.from;
	    delete overrides.value;
	    delete overrides.type;
	    delete overrides.accessList;
	    delete overrides.maxFeePerGas;
	    delete overrides.maxPriorityFeePerGas;
	    delete overrides.customData;
	    delete overrides.ccipReadEnabled; // Make sure there are no stray overrides, which may indicate a
	    // typo or using an unsupported key.

	    const leftovers = Object.keys(overrides).filter(key => overrides[key] != null);

	    if (leftovers.length) {
	      logger$6.throwError(`cannot override ${leftovers.map(l => JSON.stringify(l)).join(",")}`, Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "overrides",
	        overrides: leftovers
	      });
	    }

	    return tx;
	  });
	}

	function buildPopulate(contract, fragment) {
	  return function (...args) {
	    return populateTransaction(contract, fragment, args);
	  };
	}

	function buildEstimate(contract, fragment) {
	  const signerOrProvider = contract.signer || contract.provider;
	  return function (...args) {
	    return __awaiter$4(this, void 0, void 0, function* () {
	      if (!signerOrProvider) {
	        logger$6.throwError("estimate require a provider or signer", Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: "estimateGas"
	        });
	      }

	      const tx = yield populateTransaction(contract, fragment, args);
	      return yield signerOrProvider.estimateGas(tx);
	    });
	  };
	}

	function addContractWait(contract, tx) {
	  const wait = tx.wait.bind(tx);

	  tx.wait = confirmations => {
	    return wait(confirmations).then(receipt => {
	      receipt.events = receipt.logs.map(log => {
	        let event = deepCopy(log);
	        let parsed = null;

	        try {
	          parsed = contract.interface.parseLog(log);
	        } catch (e) {} // Successfully parsed the event log; include it


	        if (parsed) {
	          event.args = parsed.args;

	          event.decode = (data, topics) => {
	            return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
	          };

	          event.event = parsed.name;
	          event.eventSignature = parsed.signature;
	        } // Useful operations


	        event.removeListener = () => {
	          return contract.provider;
	        };

	        event.getBlock = () => {
	          return contract.provider.getBlock(receipt.blockHash);
	        };

	        event.getTransaction = () => {
	          return contract.provider.getTransaction(receipt.transactionHash);
	        };

	        event.getTransactionReceipt = () => {
	          return Promise.resolve(receipt);
	        };

	        return event;
	      });
	      return receipt;
	    });
	  };
	}

	function buildCall(contract, fragment, collapseSimple) {
	  const signerOrProvider = contract.signer || contract.provider;
	  return function (...args) {
	    return __awaiter$4(this, void 0, void 0, function* () {
	      // Extract the "blockTag" override if present
	      let blockTag = undefined;

	      if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
	        const overrides = shallowCopy(args.pop());

	        if (overrides.blockTag != null) {
	          blockTag = yield overrides.blockTag;
	        }

	        delete overrides.blockTag;
	        args.push(overrides);
	      } // If the contract was just deployed, wait until it is mined


	      if (contract.deployTransaction != null) {
	        yield contract._deployed(blockTag);
	      } // Call a node and get the result


	      const tx = yield populateTransaction(contract, fragment, args);
	      const result = yield signerOrProvider.call(tx, blockTag);

	      try {
	        let value = contract.interface.decodeFunctionResult(fragment, result);

	        if (collapseSimple && fragment.outputs.length === 1) {
	          value = value[0];
	        }

	        return value;
	      } catch (error) {
	        if (error.code === Logger.errors.CALL_EXCEPTION) {
	          error.address = contract.address;
	          error.args = args;
	          error.transaction = tx;
	        }

	        throw error;
	      }
	    });
	  };
	}

	function buildSend(contract, fragment) {
	  return function (...args) {
	    return __awaiter$4(this, void 0, void 0, function* () {
	      if (!contract.signer) {
	        logger$6.throwError("sending a transaction requires a signer", Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: "sendTransaction"
	        });
	      } // If the contract was just deployed, wait until it is mined


	      if (contract.deployTransaction != null) {
	        yield contract._deployed();
	      }

	      const txRequest = yield populateTransaction(contract, fragment, args);
	      const tx = yield contract.signer.sendTransaction(txRequest); // Tweak the tx.wait so the receipt has extra properties

	      addContractWait(contract, tx);
	      return tx;
	    });
	  };
	}

	function buildDefault(contract, fragment, collapseSimple) {
	  if (fragment.constant) {
	    return buildCall(contract, fragment, collapseSimple);
	  }

	  return buildSend(contract, fragment);
	}

	function getEventTag$1(filter) {
	  if (filter.address && (filter.topics == null || filter.topics.length === 0)) {
	    return "*";
	  }

	  return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map(topic => {
	    if (Array.isArray(topic)) {
	      return topic.join("|");
	    }

	    return topic;
	  }).join(":") : "");
	}

	class RunningEvent {
	  constructor(tag, filter) {
	    defineReadOnly(this, "tag", tag);
	    defineReadOnly(this, "filter", filter);
	    this._listeners = [];
	  }

	  addListener(listener, once) {
	    this._listeners.push({
	      listener: listener,
	      once: once
	    });
	  }

	  removeListener(listener) {
	    let done = false;
	    this._listeners = this._listeners.filter(item => {
	      if (done || item.listener !== listener) {
	        return true;
	      }

	      done = true;
	      return false;
	    });
	  }

	  removeAllListeners() {
	    this._listeners = [];
	  }

	  listeners() {
	    return this._listeners.map(i => i.listener);
	  }

	  listenerCount() {
	    return this._listeners.length;
	  }

	  run(args) {
	    const listenerCount = this.listenerCount();
	    this._listeners = this._listeners.filter(item => {
	      const argsCopy = args.slice(); // Call the callback in the next event loop

	      setTimeout(() => {
	        item.listener.apply(this, argsCopy);
	      }, 0); // Reschedule it if it not "once"

	      return !item.once;
	    });
	    return listenerCount;
	  }

	  prepareEvent(event) {} // Returns the array that will be applied to an emit


	  getEmit(event) {
	    return [event];
	  }

	}

	class ErrorRunningEvent extends RunningEvent {
	  constructor() {
	    super("error", null);
	  }

	} // @TODO Fragment should inherit Wildcard? and just override getEmit?
	//       or have a common abstract super class, with enough constructor
	//       options to configure both.
	// A Fragment Event will populate all the properties that Wildcard
	// will, and additionally dereference the arguments when emitting


	class FragmentRunningEvent extends RunningEvent {
	  constructor(address, contractInterface, fragment, topics) {
	    const filter = {
	      address: address
	    };
	    let topic = contractInterface.getEventTopic(fragment);

	    if (topics) {
	      if (topic !== topics[0]) {
	        logger$6.throwArgumentError("topic mismatch", "topics", topics);
	      }

	      filter.topics = topics.slice();
	    } else {
	      filter.topics = [topic];
	    }

	    super(getEventTag$1(filter), filter);
	    defineReadOnly(this, "address", address);
	    defineReadOnly(this, "interface", contractInterface);
	    defineReadOnly(this, "fragment", fragment);
	  }

	  prepareEvent(event) {
	    super.prepareEvent(event);
	    event.event = this.fragment.name;
	    event.eventSignature = this.fragment.format();

	    event.decode = (data, topics) => {
	      return this.interface.decodeEventLog(this.fragment, data, topics);
	    };

	    try {
	      event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
	    } catch (error) {
	      event.args = null;
	      event.decodeError = error;
	    }
	  }

	  getEmit(event) {
	    const errors = checkResultErrors(event.args);

	    if (errors.length) {
	      throw errors[0].error;
	    }

	    const args = (event.args || []).slice();
	    args.push(event);
	    return args;
	  }

	} // A Wildcard Event will attempt to populate:
	//  - event            The name of the event name
	//  - eventSignature   The full signature of the event
	//  - decode           A function to decode data and topics
	//  - args             The decoded data and topics


	class WildcardRunningEvent extends RunningEvent {
	  constructor(address, contractInterface) {
	    super("*", {
	      address: address
	    });
	    defineReadOnly(this, "address", address);
	    defineReadOnly(this, "interface", contractInterface);
	  }

	  prepareEvent(event) {
	    super.prepareEvent(event);

	    try {
	      const parsed = this.interface.parseLog(event);
	      event.event = parsed.name;
	      event.eventSignature = parsed.signature;

	      event.decode = (data, topics) => {
	        return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
	      };

	      event.args = parsed.args;
	    } catch (error) {// No matching event
	    }
	  }

	}

	class BaseContract {
	  constructor(addressOrName, contractInterface, signerOrProvider) {
	    // @TODO: Maybe still check the addressOrName looks like a valid address or name?
	    //address = getAddress(address);
	    defineReadOnly(this, "interface", getStatic(new.target, "getInterface")(contractInterface));

	    if (signerOrProvider == null) {
	      defineReadOnly(this, "provider", null);
	      defineReadOnly(this, "signer", null);
	    } else if (Signer.isSigner(signerOrProvider)) {
	      defineReadOnly(this, "provider", signerOrProvider.provider || null);
	      defineReadOnly(this, "signer", signerOrProvider);
	    } else if (Provider.isProvider(signerOrProvider)) {
	      defineReadOnly(this, "provider", signerOrProvider);
	      defineReadOnly(this, "signer", null);
	    } else {
	      logger$6.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
	    }

	    defineReadOnly(this, "callStatic", {});
	    defineReadOnly(this, "estimateGas", {});
	    defineReadOnly(this, "functions", {});
	    defineReadOnly(this, "populateTransaction", {});
	    defineReadOnly(this, "filters", {});
	    {
	      const uniqueFilters = {};
	      Object.keys(this.interface.events).forEach(eventSignature => {
	        const event = this.interface.events[eventSignature];
	        defineReadOnly(this.filters, eventSignature, (...args) => {
	          return {
	            address: this.address,
	            topics: this.interface.encodeFilterTopics(event, args)
	          };
	        });

	        if (!uniqueFilters[event.name]) {
	          uniqueFilters[event.name] = [];
	        }

	        uniqueFilters[event.name].push(eventSignature);
	      });
	      Object.keys(uniqueFilters).forEach(name => {
	        const filters = uniqueFilters[name];

	        if (filters.length === 1) {
	          defineReadOnly(this.filters, name, this.filters[filters[0]]);
	        } else {
	          logger$6.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
	        }
	      });
	    }
	    defineReadOnly(this, "_runningEvents", {});
	    defineReadOnly(this, "_wrappedEmits", {});

	    if (addressOrName == null) {
	      logger$6.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
	    }

	    defineReadOnly(this, "address", addressOrName);

	    if (this.provider) {
	      defineReadOnly(this, "resolvedAddress", resolveName(this.provider, addressOrName));
	    } else {
	      try {
	        defineReadOnly(this, "resolvedAddress", Promise.resolve(getAddress(addressOrName)));
	      } catch (error) {
	        // Without a provider, we cannot use ENS names
	        logger$6.throwError("provider is required to use ENS name as contract address", Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: "new Contract"
	        });
	      }
	    } // Swallow bad ENS names to prevent Unhandled Exceptions


	    this.resolvedAddress.catch(e => {});
	    const uniqueNames = {};
	    const uniqueSignatures = {};
	    Object.keys(this.interface.functions).forEach(signature => {
	      const fragment = this.interface.functions[signature]; // Check that the signature is unique; if not the ABI generation has
	      // not been cleaned or may be incorrectly generated

	      if (uniqueSignatures[signature]) {
	        logger$6.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
	        return;
	      }

	      uniqueSignatures[signature] = true; // Track unique names; we only expose bare named functions if they
	      // are ambiguous

	      {
	        const name = fragment.name;

	        if (!uniqueNames[`%${name}`]) {
	          uniqueNames[`%${name}`] = [];
	        }

	        uniqueNames[`%${name}`].push(signature);
	      }

	      if (this[signature] == null) {
	        defineReadOnly(this, signature, buildDefault(this, fragment, true));
	      } // We do not collapse simple calls on this bucket, which allows
	      // frameworks to safely use this without introspection as well as
	      // allows decoding error recovery.


	      if (this.functions[signature] == null) {
	        defineReadOnly(this.functions, signature, buildDefault(this, fragment, false));
	      }

	      if (this.callStatic[signature] == null) {
	        defineReadOnly(this.callStatic, signature, buildCall(this, fragment, true));
	      }

	      if (this.populateTransaction[signature] == null) {
	        defineReadOnly(this.populateTransaction, signature, buildPopulate(this, fragment));
	      }

	      if (this.estimateGas[signature] == null) {
	        defineReadOnly(this.estimateGas, signature, buildEstimate(this, fragment));
	      }
	    });
	    Object.keys(uniqueNames).forEach(name => {
	      // Ambiguous names to not get attached as bare names
	      const signatures = uniqueNames[name];

	      if (signatures.length > 1) {
	        return;
	      } // Strip off the leading "%" used for prototype protection


	      name = name.substring(1);
	      const signature = signatures[0]; // If overwriting a member property that is null, swallow the error

	      try {
	        if (this[name] == null) {
	          defineReadOnly(this, name, this[signature]);
	        }
	      } catch (e) {}

	      if (this.functions[name] == null) {
	        defineReadOnly(this.functions, name, this.functions[signature]);
	      }

	      if (this.callStatic[name] == null) {
	        defineReadOnly(this.callStatic, name, this.callStatic[signature]);
	      }

	      if (this.populateTransaction[name] == null) {
	        defineReadOnly(this.populateTransaction, name, this.populateTransaction[signature]);
	      }

	      if (this.estimateGas[name] == null) {
	        defineReadOnly(this.estimateGas, name, this.estimateGas[signature]);
	      }
	    });
	  }

	  static getContractAddress(transaction) {
	    return getContractAddress(transaction);
	  }

	  static getInterface(contractInterface) {
	    if (Interface.isInterface(contractInterface)) {
	      return contractInterface;
	    }

	    return new Interface(contractInterface);
	  } // @TODO: Allow timeout?


	  deployed() {
	    return this._deployed();
	  }

	  _deployed(blockTag) {
	    if (!this._deployedPromise) {
	      // If we were just deployed, we know the transaction we should occur in
	      if (this.deployTransaction) {
	        this._deployedPromise = this.deployTransaction.wait().then(() => {
	          return this;
	        });
	      } else {
	        // @TODO: Once we allow a timeout to be passed in, we will wait
	        // up to that many blocks for getCode
	        // Otherwise, poll for our code to be deployed
	        this._deployedPromise = this.provider.getCode(this.address, blockTag).then(code => {
	          if (code === "0x") {
	            logger$6.throwError("contract not deployed", Logger.errors.UNSUPPORTED_OPERATION, {
	              contractAddress: this.address,
	              operation: "getDeployed"
	            });
	          }

	          return this;
	        });
	      }
	    }

	    return this._deployedPromise;
	  } // @TODO:
	  // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
	  // @TODO:
	  // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>


	  fallback(overrides) {
	    if (!this.signer) {
	      logger$6.throwError("sending a transactions require a signer", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "sendTransaction(fallback)"
	      });
	    }

	    const tx = shallowCopy(overrides || {});
	    ["from", "to"].forEach(function (key) {
	      if (tx[key] == null) {
	        return;
	      }

	      logger$6.throwError("cannot override " + key, Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: key
	      });
	    });
	    tx.to = this.resolvedAddress;
	    return this.deployed().then(() => {
	      return this.signer.sendTransaction(tx);
	    });
	  } // Reconnect to a different signer or provider


	  connect(signerOrProvider) {
	    if (typeof signerOrProvider === "string") {
	      signerOrProvider = new VoidSigner(signerOrProvider, this.provider);
	    }

	    const contract = new this.constructor(this.address, this.interface, signerOrProvider);

	    if (this.deployTransaction) {
	      defineReadOnly(contract, "deployTransaction", this.deployTransaction);
	    }

	    return contract;
	  } // Re-attach to a different on-chain instance of this contract


	  attach(addressOrName) {
	    return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
	  }

	  static isIndexed(value) {
	    return Indexed.isIndexed(value);
	  }

	  _normalizeRunningEvent(runningEvent) {
	    // Already have an instance of this event running; we can re-use it
	    if (this._runningEvents[runningEvent.tag]) {
	      return this._runningEvents[runningEvent.tag];
	    }

	    return runningEvent;
	  }

	  _getRunningEvent(eventName) {
	    if (typeof eventName === "string") {
	      // Listen for "error" events (if your contract has an error event, include
	      // the full signature to bypass this special event keyword)
	      if (eventName === "error") {
	        return this._normalizeRunningEvent(new ErrorRunningEvent());
	      } // Listen for any event that is registered


	      if (eventName === "event") {
	        return this._normalizeRunningEvent(new RunningEvent("event", null));
	      } // Listen for any event


	      if (eventName === "*") {
	        return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
	      } // Get the event Fragment (throws if ambiguous/unknown event)


	      const fragment = this.interface.getEvent(eventName);
	      return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment));
	    } // We have topics to filter by...


	    if (eventName.topics && eventName.topics.length > 0) {
	      // Is it a known topichash? (throws if no matching topichash)
	      try {
	        const topic = eventName.topics[0];

	        if (typeof topic !== "string") {
	          throw new Error("invalid topic"); // @TODO: May happen for anonymous events
	        }

	        const fragment = this.interface.getEvent(topic);
	        return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
	      } catch (error) {} // Filter by the unknown topichash


	      const filter = {
	        address: this.address,
	        topics: eventName.topics
	      };
	      return this._normalizeRunningEvent(new RunningEvent(getEventTag$1(filter), filter));
	    }

	    return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
	  }

	  _checkRunningEvents(runningEvent) {
	    if (runningEvent.listenerCount() === 0) {
	      delete this._runningEvents[runningEvent.tag]; // If we have a poller for this, remove it

	      const emit = this._wrappedEmits[runningEvent.tag];

	      if (emit && runningEvent.filter) {
	        this.provider.off(runningEvent.filter, emit);
	        delete this._wrappedEmits[runningEvent.tag];
	      }
	    }
	  } // Subclasses can override this to gracefully recover
	  // from parse errors if they wish


	  _wrapEvent(runningEvent, log, listener) {
	    const event = deepCopy(log);

	    event.removeListener = () => {
	      if (!listener) {
	        return;
	      }

	      runningEvent.removeListener(listener);

	      this._checkRunningEvents(runningEvent);
	    };

	    event.getBlock = () => {
	      return this.provider.getBlock(log.blockHash);
	    };

	    event.getTransaction = () => {
	      return this.provider.getTransaction(log.transactionHash);
	    };

	    event.getTransactionReceipt = () => {
	      return this.provider.getTransactionReceipt(log.transactionHash);
	    }; // This may throw if the topics and data mismatch the signature


	    runningEvent.prepareEvent(event);
	    return event;
	  }

	  _addEventListener(runningEvent, listener, once) {
	    if (!this.provider) {
	      logger$6.throwError("events require a provider or a signer with a provider", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "once"
	      });
	    }

	    runningEvent.addListener(listener, once); // Track this running event and its listeners (may already be there; but no hard in updating)

	    this._runningEvents[runningEvent.tag] = runningEvent; // If we are not polling the provider, start polling

	    if (!this._wrappedEmits[runningEvent.tag]) {
	      const wrappedEmit = log => {
	        let event = this._wrapEvent(runningEvent, log, listener); // Try to emit the result for the parameterized event...


	        if (event.decodeError == null) {
	          try {
	            const args = runningEvent.getEmit(event);
	            this.emit(runningEvent.filter, ...args);
	          } catch (error) {
	            event.decodeError = error.error;
	          }
	        } // Always emit "event" for fragment-base events


	        if (runningEvent.filter != null) {
	          this.emit("event", event);
	        } // Emit "error" if there was an error


	        if (event.decodeError != null) {
	          this.emit("error", event.decodeError, event);
	        }
	      };

	      this._wrappedEmits[runningEvent.tag] = wrappedEmit; // Special events, like "error" do not have a filter

	      if (runningEvent.filter != null) {
	        this.provider.on(runningEvent.filter, wrappedEmit);
	      }
	    }
	  }

	  queryFilter(event, fromBlockOrBlockhash, toBlock) {
	    const runningEvent = this._getRunningEvent(event);

	    const filter = shallowCopy(runningEvent.filter);

	    if (typeof fromBlockOrBlockhash === "string" && isHexString(fromBlockOrBlockhash, 32)) {
	      if (toBlock != null) {
	        logger$6.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
	      }

	      filter.blockHash = fromBlockOrBlockhash;
	    } else {
	      filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
	      filter.toBlock = toBlock != null ? toBlock : "latest";
	    }

	    return this.provider.getLogs(filter).then(logs => {
	      return logs.map(log => this._wrapEvent(runningEvent, log, null));
	    });
	  }

	  on(event, listener) {
	    this._addEventListener(this._getRunningEvent(event), listener, false);

	    return this;
	  }

	  once(event, listener) {
	    this._addEventListener(this._getRunningEvent(event), listener, true);

	    return this;
	  }

	  emit(eventName, ...args) {
	    if (!this.provider) {
	      return false;
	    }

	    const runningEvent = this._getRunningEvent(eventName);

	    const result = runningEvent.run(args) > 0; // May have drained all the "once" events; check for living events

	    this._checkRunningEvents(runningEvent);

	    return result;
	  }

	  listenerCount(eventName) {
	    if (!this.provider) {
	      return 0;
	    }

	    if (eventName == null) {
	      return Object.keys(this._runningEvents).reduce((accum, key) => {
	        return accum + this._runningEvents[key].listenerCount();
	      }, 0);
	    }

	    return this._getRunningEvent(eventName).listenerCount();
	  }

	  listeners(eventName) {
	    if (!this.provider) {
	      return [];
	    }

	    if (eventName == null) {
	      const result = [];

	      for (let tag in this._runningEvents) {
	        this._runningEvents[tag].listeners().forEach(listener => {
	          result.push(listener);
	        });
	      }

	      return result;
	    }

	    return this._getRunningEvent(eventName).listeners();
	  }

	  removeAllListeners(eventName) {
	    if (!this.provider) {
	      return this;
	    }

	    if (eventName == null) {
	      for (const tag in this._runningEvents) {
	        const runningEvent = this._runningEvents[tag];
	        runningEvent.removeAllListeners();

	        this._checkRunningEvents(runningEvent);
	      }

	      return this;
	    } // Delete any listeners


	    const runningEvent = this._getRunningEvent(eventName);

	    runningEvent.removeAllListeners();

	    this._checkRunningEvents(runningEvent);

	    return this;
	  }

	  off(eventName, listener) {
	    if (!this.provider) {
	      return this;
	    }

	    const runningEvent = this._getRunningEvent(eventName);

	    runningEvent.removeListener(listener);

	    this._checkRunningEvents(runningEvent);

	    return this;
	  }

	  removeListener(eventName, listener) {
	    return this.off(eventName, listener);
	  }

	}
	class Contract extends BaseContract {}

	/**
	 * var basex = require("base-x");
	 *
	 * This implementation is heavily based on base-x. The main reason to
	 * deviate was to prevent the dependency of Buffer.
	 *
	 * Contributors:
	 *
	 * base-x encoding
	 * Forked from https://github.com/cryptocoinjs/bs58
	 * Originally written by Mike Hearn for BitcoinJ
	 * Copyright (c) 2011 Google Inc
	 * Ported to JavaScript by Stefan Thomas
	 * Merged Buffer refactorings from base58-native by Stephen Pair
	 * Copyright (c) 2013 BitPay Inc
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright base-x contributors (c) 2016
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the "Software"),
	 * to deal in the Software without restriction, including without limitation
	 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
	 * and/or sell copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.

	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
	 * IN THE SOFTWARE.
	 *
	 */
	class BaseX {
	  constructor(alphabet) {
	    defineReadOnly(this, "alphabet", alphabet);
	    defineReadOnly(this, "base", alphabet.length);
	    defineReadOnly(this, "_alphabetMap", {});
	    defineReadOnly(this, "_leader", alphabet.charAt(0)); // pre-compute lookup table

	    for (let i = 0; i < alphabet.length; i++) {
	      this._alphabetMap[alphabet.charAt(i)] = i;
	    }
	  }

	  encode(value) {
	    let source = arrayify(value);

	    if (source.length === 0) {
	      return "";
	    }

	    let digits = [0];

	    for (let i = 0; i < source.length; ++i) {
	      let carry = source[i];

	      for (let j = 0; j < digits.length; ++j) {
	        carry += digits[j] << 8;
	        digits[j] = carry % this.base;
	        carry = carry / this.base | 0;
	      }

	      while (carry > 0) {
	        digits.push(carry % this.base);
	        carry = carry / this.base | 0;
	      }
	    }

	    let string = ""; // deal with leading zeros

	    for (let k = 0; source[k] === 0 && k < source.length - 1; ++k) {
	      string += this._leader;
	    } // convert digits to a string


	    for (let q = digits.length - 1; q >= 0; --q) {
	      string += this.alphabet[digits[q]];
	    }

	    return string;
	  }

	  decode(value) {
	    if (typeof value !== "string") {
	      throw new TypeError("Expected String");
	    }

	    let bytes = [];

	    if (value.length === 0) {
	      return new Uint8Array(bytes);
	    }

	    bytes.push(0);

	    for (let i = 0; i < value.length; i++) {
	      let byte = this._alphabetMap[value[i]];

	      if (byte === undefined) {
	        throw new Error("Non-base" + this.base + " character");
	      }

	      let carry = byte;

	      for (let j = 0; j < bytes.length; ++j) {
	        carry += bytes[j] * this.base;
	        bytes[j] = carry & 0xff;
	        carry >>= 8;
	      }

	      while (carry > 0) {
	        bytes.push(carry & 0xff);
	        carry >>= 8;
	      }
	    } // deal with leading zeros


	    for (let k = 0; value[k] === this._leader && k < value.length - 1; ++k) {
	      bytes.push(0);
	    }

	    return arrayify(new Uint8Array(bytes.reverse()));
	  }

	}
	new BaseX("abcdefghijklmnopqrstuvwxyz234567");
	const Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
	//console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

	const version$4 = "sha2/5.7.0";

	new Logger(version$4);
	function sha256(data) {
	  return "0x" + hash.sha256().update(arrayify(data)).digest("hex");
	}

	const version$3 = "networks/5.7.0";

	const logger$5 = new Logger(version$3);

	function isRenetworkable(value) {
	  return value && typeof value.renetwork === "function";
	}

	function ethDefaultProvider(network) {
	  const func = function (providers, options) {
	    if (options == null) {
	      options = {};
	    }

	    const providerList = [];

	    if (providers.InfuraProvider && options.infura !== "-") {
	      try {
	        providerList.push(new providers.InfuraProvider(network, options.infura));
	      } catch (error) {}
	    }

	    if (providers.EtherscanProvider && options.etherscan !== "-") {
	      try {
	        providerList.push(new providers.EtherscanProvider(network, options.etherscan));
	      } catch (error) {}
	    }

	    if (providers.AlchemyProvider && options.alchemy !== "-") {
	      try {
	        providerList.push(new providers.AlchemyProvider(network, options.alchemy));
	      } catch (error) {}
	    }

	    if (providers.PocketProvider && options.pocket !== "-") {
	      // These networks are currently faulty on Pocket as their
	      // network does not handle the Berlin hardfork, which is
	      // live on these ones.
	      // @TODO: This goes away once Pocket has upgraded their nodes
	      const skip = ["goerli", "ropsten", "rinkeby"];

	      try {
	        const provider = new providers.PocketProvider(network, options.pocket);

	        if (provider.network && skip.indexOf(provider.network.name) === -1) {
	          providerList.push(provider);
	        }
	      } catch (error) {}
	    }

	    if (providers.CloudflareProvider && options.cloudflare !== "-") {
	      try {
	        providerList.push(new providers.CloudflareProvider(network));
	      } catch (error) {}
	    }

	    if (providers.AnkrProvider && options.ankr !== "-") {
	      try {
	        const skip = ["ropsten"];
	        const provider = new providers.AnkrProvider(network, options.ankr);

	        if (provider.network && skip.indexOf(provider.network.name) === -1) {
	          providerList.push(provider);
	        }
	      } catch (error) {}
	    }

	    if (providerList.length === 0) {
	      return null;
	    }

	    if (providers.FallbackProvider) {
	      let quorum = 1;

	      if (options.quorum != null) {
	        quorum = options.quorum;
	      } else if (network === "homestead") {
	        quorum = 2;
	      }

	      return new providers.FallbackProvider(providerList, quorum);
	    }

	    return providerList[0];
	  };

	  func.renetwork = function (network) {
	    return ethDefaultProvider(network);
	  };

	  return func;
	}

	function etcDefaultProvider(url, network) {
	  const func = function (providers, options) {
	    if (providers.JsonRpcProvider) {
	      return new providers.JsonRpcProvider(url, network);
	    }

	    return null;
	  };

	  func.renetwork = function (network) {
	    return etcDefaultProvider(url, network);
	  };

	  return func;
	}

	const homestead = {
	  chainId: 1,
	  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
	  name: "homestead",
	  _defaultProvider: ethDefaultProvider("homestead")
	};
	const ropsten = {
	  chainId: 3,
	  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
	  name: "ropsten",
	  _defaultProvider: ethDefaultProvider("ropsten")
	};
	const classicMordor = {
	  chainId: 63,
	  name: "classicMordor",
	  _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
	}; // See: https://chainlist.org

	const networks = {
	  unspecified: {
	    chainId: 0,
	    name: "unspecified"
	  },
	  homestead: homestead,
	  mainnet: homestead,
	  morden: {
	    chainId: 2,
	    name: "morden"
	  },
	  ropsten: ropsten,
	  testnet: ropsten,
	  rinkeby: {
	    chainId: 4,
	    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
	    name: "rinkeby",
	    _defaultProvider: ethDefaultProvider("rinkeby")
	  },
	  kovan: {
	    chainId: 42,
	    name: "kovan",
	    _defaultProvider: ethDefaultProvider("kovan")
	  },
	  goerli: {
	    chainId: 5,
	    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
	    name: "goerli",
	    _defaultProvider: ethDefaultProvider("goerli")
	  },
	  kintsugi: {
	    chainId: 1337702,
	    name: "kintsugi"
	  },
	  // ETC (See: #351)
	  classic: {
	    chainId: 61,
	    name: "classic",
	    _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/etc", "classic")
	  },
	  classicMorden: {
	    chainId: 62,
	    name: "classicMorden"
	  },
	  classicMordor: classicMordor,
	  classicTestnet: classicMordor,
	  classicKotti: {
	    chainId: 6,
	    name: "classicKotti",
	    _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/kotti", "classicKotti")
	  },
	  xdai: {
	    chainId: 100,
	    name: "xdai"
	  },
	  matic: {
	    chainId: 137,
	    name: "matic",
	    _defaultProvider: ethDefaultProvider("matic")
	  },
	  maticmum: {
	    chainId: 80001,
	    name: "maticmum"
	  },
	  optimism: {
	    chainId: 10,
	    name: "optimism",
	    _defaultProvider: ethDefaultProvider("optimism")
	  },
	  "optimism-kovan": {
	    chainId: 69,
	    name: "optimism-kovan"
	  },
	  "optimism-goerli": {
	    chainId: 420,
	    name: "optimism-goerli"
	  },
	  arbitrum: {
	    chainId: 42161,
	    name: "arbitrum"
	  },
	  "arbitrum-rinkeby": {
	    chainId: 421611,
	    name: "arbitrum-rinkeby"
	  },
	  "arbitrum-goerli": {
	    chainId: 421613,
	    name: "arbitrum-goerli"
	  },
	  bnb: {
	    chainId: 56,
	    name: "bnb"
	  },
	  bnbt: {
	    chainId: 97,
	    name: "bnbt"
	  }
	};
	/**
	 *  getNetwork
	 *
	 *  Converts a named common networks or chain ID (network ID) to a Network
	 *  and verifies a network is a valid Network..
	 */

	function getNetwork(network) {
	  // No network (null)
	  if (network == null) {
	    return null;
	  }

	  if (typeof network === "number") {
	    for (const name in networks) {
	      const standard = networks[name];

	      if (standard.chainId === network) {
	        return {
	          name: standard.name,
	          chainId: standard.chainId,
	          ensAddress: standard.ensAddress || null,
	          _defaultProvider: standard._defaultProvider || null
	        };
	      }
	    }

	    return {
	      chainId: network,
	      name: "unknown"
	    };
	  }

	  if (typeof network === "string") {
	    const standard = networks[network];

	    if (standard == null) {
	      return null;
	    }

	    return {
	      name: standard.name,
	      chainId: standard.chainId,
	      ensAddress: standard.ensAddress,
	      _defaultProvider: standard._defaultProvider || null
	    };
	  }

	  const standard = networks[network.name]; // Not a standard network; check that it is a valid network in general

	  if (!standard) {
	    if (typeof network.chainId !== "number") {
	      logger$5.throwArgumentError("invalid network chainId", "network", network);
	    }

	    return network;
	  } // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)


	  if (network.chainId !== 0 && network.chainId !== standard.chainId) {
	    logger$5.throwArgumentError("network chainId mismatch", "network", network);
	  } // @TODO: In the next major version add an attach function to a defaultProvider
	  // class and move the _defaultProvider internal to this file (extend Network)


	  let defaultProvider = network._defaultProvider || null;

	  if (defaultProvider == null && standard._defaultProvider) {
	    if (isRenetworkable(standard._defaultProvider)) {
	      defaultProvider = standard._defaultProvider.renetwork(network);
	    } else {
	      defaultProvider = standard._defaultProvider;
	    }
	  } // Standard Network (allow overriding the ENS address)


	  return {
	    name: network.name,
	    chainId: standard.chainId,
	    ensAddress: network.ensAddress || standard.ensAddress || null,
	    _defaultProvider: defaultProvider
	  };
	}

	const version$2 = "web/5.7.0";

	var __awaiter$3 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	function getUrl(href, options) {
	  return __awaiter$3(this, void 0, void 0, function* () {
	    if (options == null) {
	      options = {};
	    }

	    const request = {
	      method: options.method || "GET",
	      headers: options.headers || {},
	      body: options.body || undefined
	    };

	    if (options.skipFetchSetup !== true) {
	      request.mode = "cors"; // no-cors, cors, *same-origin

	      request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached

	      request.credentials = "same-origin"; // include, *same-origin, omit

	      request.redirect = "follow"; // manual, *follow, error

	      request.referrer = "client"; // no-referrer, *client
	    }

	    if (options.fetchOptions != null) {
	      const opts = options.fetchOptions;

	      if (opts.mode) {
	        request.mode = opts.mode;
	      }

	      if (opts.cache) {
	        request.cache = opts.cache;
	      }

	      if (opts.credentials) {
	        request.credentials = opts.credentials;
	      }

	      if (opts.redirect) {
	        request.redirect = opts.redirect;
	      }

	      if (opts.referrer) {
	        request.referrer = opts.referrer;
	      }
	    }

	    const response = yield fetch(href, request);
	    const body = yield response.arrayBuffer();
	    const headers = {};

	    if (response.headers.forEach) {
	      response.headers.forEach((value, key) => {
	        headers[key.toLowerCase()] = value;
	      });
	    } else {
	      response.headers.keys().forEach(key => {
	        headers[key.toLowerCase()] = response.headers.get(key);
	      });
	    }

	    return {
	      headers: headers,
	      statusCode: response.status,
	      statusMessage: response.statusText,
	      body: arrayify(new Uint8Array(body))
	    };
	  });
	}

	var __awaiter$2 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$4 = new Logger(version$2);

	function staller(duration) {
	  return new Promise(resolve => {
	    setTimeout(resolve, duration);
	  });
	}

	function bodyify(value, type) {
	  if (value == null) {
	    return null;
	  }

	  if (typeof value === "string") {
	    return value;
	  }

	  if (isBytesLike(value)) {
	    if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) {
	      try {
	        return toUtf8String(value);
	      } catch (error) {}
	    }

	    return hexlify(value);
	  }

	  return value;
	} // This API is still a work in progress; the future changes will likely be:
	// - ConnectionInfo => FetchDataRequest<T = any>
	// - FetchDataRequest.body? = string | Uint8Array | { contentType: string, data: string | Uint8Array }
	//   - If string => text/plain, Uint8Array => application/octet-stream (if content-type unspecified)
	// - FetchDataRequest.processFunc = (body: Uint8Array, response: FetchDataResponse) => T
	// For this reason, it should be considered internal until the API is finalized


	function _fetchData(connection, body, processFunc) {
	  // How many times to retry in the event of a throttle
	  const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
	  logger$4.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
	  const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
	  const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
	  logger$4.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
	  const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
	  const headers = {};
	  let url = null; // @TODO: Allow ConnectionInfo to override some of these values

	  const options = {
	    method: "GET"
	  };
	  let allow304 = false;
	  let timeout = 2 * 60 * 1000;

	  if (typeof connection === "string") {
	    url = connection;
	  } else if (typeof connection === "object") {
	    if (connection == null || connection.url == null) {
	      logger$4.throwArgumentError("missing URL", "connection.url", connection);
	    }

	    url = connection.url;

	    if (typeof connection.timeout === "number" && connection.timeout > 0) {
	      timeout = connection.timeout;
	    }

	    if (connection.headers) {
	      for (const key in connection.headers) {
	        headers[key.toLowerCase()] = {
	          key: key,
	          value: String(connection.headers[key])
	        };

	        if (["if-none-match", "if-modified-since"].indexOf(key.toLowerCase()) >= 0) {
	          allow304 = true;
	        }
	      }
	    }

	    options.allowGzip = !!connection.allowGzip;

	    if (connection.user != null && connection.password != null) {
	      if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) {
	        logger$4.throwError("basic authentication requires a secure https url", Logger.errors.INVALID_ARGUMENT, {
	          argument: "url",
	          url: url,
	          user: connection.user,
	          password: "[REDACTED]"
	        });
	      }

	      const authorization = connection.user + ":" + connection.password;
	      headers["authorization"] = {
	        key: "Authorization",
	        value: "Basic " + encode$2(toUtf8Bytes(authorization))
	      };
	    }

	    if (connection.skipFetchSetup != null) {
	      options.skipFetchSetup = !!connection.skipFetchSetup;
	    }

	    if (connection.fetchOptions != null) {
	      options.fetchOptions = shallowCopy(connection.fetchOptions);
	    }
	  }

	  const reData = new RegExp("^data:([a-z0-9-]+/[a-z0-9-]+);base64,(.*)$", "i");
	  const dataMatch = url ? url.match(reData) : null;

	  if (dataMatch) {
	    try {
	      const response = {
	        statusCode: 200,
	        statusMessage: "OK",
	        headers: {
	          "content-type": dataMatch[1]
	        },
	        body: decode$1(dataMatch[2])
	      };
	      let result = response.body;

	      if (processFunc) {
	        result = processFunc(response.body, response);
	      }

	      return Promise.resolve(result);
	    } catch (error) {
	      logger$4.throwError("processing response error", Logger.errors.SERVER_ERROR, {
	        body: bodyify(dataMatch[1], dataMatch[2]),
	        error: error,
	        requestBody: null,
	        requestMethod: "GET",
	        url: url
	      });
	    }
	  }

	  if (body) {
	    options.method = "POST";
	    options.body = body;

	    if (headers["content-type"] == null) {
	      headers["content-type"] = {
	        key: "Content-Type",
	        value: "application/octet-stream"
	      };
	    }

	    if (headers["content-length"] == null) {
	      headers["content-length"] = {
	        key: "Content-Length",
	        value: String(body.length)
	      };
	    }
	  }

	  const flatHeaders = {};
	  Object.keys(headers).forEach(key => {
	    const header = headers[key];
	    flatHeaders[header.key] = header.value;
	  });
	  options.headers = flatHeaders;

	  const runningTimeout = function () {
	    let timer = null;
	    const promise = new Promise(function (resolve, reject) {
	      if (timeout) {
	        timer = setTimeout(() => {
	          if (timer == null) {
	            return;
	          }

	          timer = null;
	          reject(logger$4.makeError("timeout", Logger.errors.TIMEOUT, {
	            requestBody: bodyify(options.body, flatHeaders["content-type"]),
	            requestMethod: options.method,
	            timeout: timeout,
	            url: url
	          }));
	        }, timeout);
	      }
	    });

	    const cancel = function () {
	      if (timer == null) {
	        return;
	      }

	      clearTimeout(timer);
	      timer = null;
	    };

	    return {
	      promise,
	      cancel
	    };
	  }();

	  const runningFetch = function () {
	    return __awaiter$2(this, void 0, void 0, function* () {
	      for (let attempt = 0; attempt < attemptLimit; attempt++) {
	        let response = null;

	        try {
	          response = yield getUrl(url, options);

	          if (attempt < attemptLimit) {
	            if (response.statusCode === 301 || response.statusCode === 302) {
	              // Redirection; for now we only support absolute locataions
	              const location = response.headers.location || "";

	              if (options.method === "GET" && location.match(/^https:/)) {
	                url = response.headers.location;
	                continue;
	              }
	            } else if (response.statusCode === 429) {
	              // Exponential back-off throttling
	              let tryAgain = true;

	              if (throttleCallback) {
	                tryAgain = yield throttleCallback(attempt, url);
	              }

	              if (tryAgain) {
	                let stall = 0;
	                const retryAfter = response.headers["retry-after"];

	                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) {
	                  stall = parseInt(retryAfter) * 1000;
	                } else {
	                  stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
	                } //console.log("Stalling 429");


	                yield staller(stall);
	                continue;
	              }
	            }
	          }
	        } catch (error) {
	          response = error.response;

	          if (response == null) {
	            runningTimeout.cancel();
	            logger$4.throwError("missing response", Logger.errors.SERVER_ERROR, {
	              requestBody: bodyify(options.body, flatHeaders["content-type"]),
	              requestMethod: options.method,
	              serverError: error,
	              url: url
	            });
	          }
	        }

	        let body = response.body;

	        if (allow304 && response.statusCode === 304) {
	          body = null;
	        } else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
	          runningTimeout.cancel();
	          logger$4.throwError("bad response", Logger.errors.SERVER_ERROR, {
	            status: response.statusCode,
	            headers: response.headers,
	            body: bodyify(body, response.headers ? response.headers["content-type"] : null),
	            requestBody: bodyify(options.body, flatHeaders["content-type"]),
	            requestMethod: options.method,
	            url: url
	          });
	        }

	        if (processFunc) {
	          try {
	            const result = yield processFunc(body, response);
	            runningTimeout.cancel();
	            return result;
	          } catch (error) {
	            // Allow the processFunc to trigger a throttle
	            if (error.throttleRetry && attempt < attemptLimit) {
	              let tryAgain = true;

	              if (throttleCallback) {
	                tryAgain = yield throttleCallback(attempt, url);
	              }

	              if (tryAgain) {
	                const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt))); //console.log("Stalling callback");

	                yield staller(timeout);
	                continue;
	              }
	            }

	            runningTimeout.cancel();
	            logger$4.throwError("processing response error", Logger.errors.SERVER_ERROR, {
	              body: bodyify(body, response.headers ? response.headers["content-type"] : null),
	              error: error,
	              requestBody: bodyify(options.body, flatHeaders["content-type"]),
	              requestMethod: options.method,
	              url: url
	            });
	          }
	        }

	        runningTimeout.cancel(); // If we had a processFunc, it either returned a T or threw above.
	        // The "body" is now a Uint8Array.

	        return body;
	      }

	      return logger$4.throwError("failed response", Logger.errors.SERVER_ERROR, {
	        requestBody: bodyify(options.body, flatHeaders["content-type"]),
	        requestMethod: options.method,
	        url: url
	      });
	    });
	  }();

	  return Promise.race([runningTimeout.promise, runningFetch]);
	}
	function fetchJson(connection, json, processFunc) {
	  let processJsonFunc = (value, response) => {
	    let result = null;

	    if (value != null) {
	      try {
	        result = JSON.parse(toUtf8String(value));
	      } catch (error) {
	        logger$4.throwError("invalid JSON", Logger.errors.SERVER_ERROR, {
	          body: value,
	          error: error
	        });
	      }
	    }

	    if (processFunc) {
	      result = processFunc(result, response);
	    }

	    return result;
	  }; // If we have json to send, we must
	  // - add content-type of application/json (unless already overridden)
	  // - convert the json to bytes


	  let body = null;

	  if (json != null) {
	    body = toUtf8Bytes(json); // Create a connection with the content-type set for JSON

	    const updated = typeof connection === "string" ? {
	      url: connection
	    } : shallowCopy(connection);

	    if (updated.headers) {
	      const hasContentType = Object.keys(updated.headers).filter(k => k.toLowerCase() === "content-type").length !== 0;

	      if (!hasContentType) {
	        updated.headers = shallowCopy(updated.headers);
	        updated.headers["content-type"] = "application/json";
	      }
	    } else {
	      updated.headers = {
	        "content-type": "application/json"
	      };
	    }

	    connection = updated;
	  }

	  return _fetchData(connection, body, processJsonFunc);
	}
	function poll(func, options) {
	  if (!options) {
	    options = {};
	  }

	  options = shallowCopy(options);

	  if (options.floor == null) {
	    options.floor = 0;
	  }

	  if (options.ceiling == null) {
	    options.ceiling = 10000;
	  }

	  if (options.interval == null) {
	    options.interval = 250;
	  }

	  return new Promise(function (resolve, reject) {
	    let timer = null;
	    let done = false; // Returns true if cancel was successful. Unsuccessful cancel means we're already done.

	    const cancel = () => {
	      if (done) {
	        return false;
	      }

	      done = true;

	      if (timer) {
	        clearTimeout(timer);
	      }

	      return true;
	    };

	    if (options.timeout) {
	      timer = setTimeout(() => {
	        if (cancel()) {
	          reject(new Error("timeout"));
	        }
	      }, options.timeout);
	    }

	    const retryLimit = options.retryLimit;
	    let attempt = 0;

	    function check() {
	      return func().then(function (result) {
	        // If we have a result, or are allowed null then we're done
	        if (result !== undefined) {
	          if (cancel()) {
	            resolve(result);
	          }
	        } else if (options.oncePoll) {
	          options.oncePoll.once("poll", check);
	        } else if (options.onceBlock) {
	          options.onceBlock.once("block", check); // Otherwise, exponential back-off (up to 10s) our next request
	        } else if (!done) {
	          attempt++;

	          if (attempt > retryLimit) {
	            if (cancel()) {
	              reject(new Error("retry limit reached"));
	            }

	            return;
	          }

	          let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));

	          if (timeout < options.floor) {
	            timeout = options.floor;
	          }

	          if (timeout > options.ceiling) {
	            timeout = options.ceiling;
	          }

	          setTimeout(check, timeout);
	        }

	        return null;
	      }, function (error) {
	        if (cancel()) {
	          reject(error);
	        }
	      });
	    }

	    check();
	  });
	}

	var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'; // pre-compute lookup table

	var ALPHABET_MAP = {};

	for (var z = 0; z < ALPHABET.length; z++) {
	  var x = ALPHABET.charAt(z);
	  if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous');
	  ALPHABET_MAP[x] = z;
	}

	function polymodStep(pre) {
	  var b = pre >> 25;
	  return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
	}

	function prefixChk(prefix) {
	  var chk = 1;

	  for (var i = 0; i < prefix.length; ++i) {
	    var c = prefix.charCodeAt(i);
	    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')';
	    chk = polymodStep(chk) ^ c >> 5;
	  }

	  chk = polymodStep(chk);

	  for (i = 0; i < prefix.length; ++i) {
	    var v = prefix.charCodeAt(i);
	    chk = polymodStep(chk) ^ v & 0x1f;
	  }

	  return chk;
	}

	function encode$1(prefix, words, LIMIT) {
	  LIMIT = LIMIT || 90;
	  if (prefix.length + 7 + words.length > LIMIT) throw new TypeError('Exceeds length limit');
	  prefix = prefix.toLowerCase(); // determine chk mod

	  var chk = prefixChk(prefix);
	  if (typeof chk === 'string') throw new Error(chk);
	  var result = prefix + '1';

	  for (var i = 0; i < words.length; ++i) {
	    var x = words[i];
	    if (x >> 5 !== 0) throw new Error('Non 5-bit word');
	    chk = polymodStep(chk) ^ x;
	    result += ALPHABET.charAt(x);
	  }

	  for (i = 0; i < 6; ++i) {
	    chk = polymodStep(chk);
	  }

	  chk ^= 1;

	  for (i = 0; i < 6; ++i) {
	    var v = chk >> (5 - i) * 5 & 0x1f;
	    result += ALPHABET.charAt(v);
	  }

	  return result;
	}

	function __decode(str, LIMIT) {
	  LIMIT = LIMIT || 90;
	  if (str.length < 8) return str + ' too short';
	  if (str.length > LIMIT) return 'Exceeds length limit'; // don't allow mixed case

	  var lowered = str.toLowerCase();
	  var uppered = str.toUpperCase();
	  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str;
	  str = lowered;
	  var split = str.lastIndexOf('1');
	  if (split === -1) return 'No separator character for ' + str;
	  if (split === 0) return 'Missing prefix for ' + str;
	  var prefix = str.slice(0, split);
	  var wordChars = str.slice(split + 1);
	  if (wordChars.length < 6) return 'Data too short';
	  var chk = prefixChk(prefix);
	  if (typeof chk === 'string') return chk;
	  var words = [];

	  for (var i = 0; i < wordChars.length; ++i) {
	    var c = wordChars.charAt(i);
	    var v = ALPHABET_MAP[c];
	    if (v === undefined) return 'Unknown character ' + c;
	    chk = polymodStep(chk) ^ v; // not in the checksum?

	    if (i + 6 >= wordChars.length) continue;
	    words.push(v);
	  }

	  if (chk !== 1) return 'Invalid checksum for ' + str;
	  return {
	    prefix: prefix,
	    words: words
	  };
	}

	function decodeUnsafe() {
	  var res = __decode.apply(null, arguments);

	  if (typeof res === 'object') return res;
	}

	function decode(str) {
	  var res = __decode.apply(null, arguments);

	  if (typeof res === 'object') return res;
	  throw new Error(res);
	}

	function convert(data, inBits, outBits, pad) {
	  var value = 0;
	  var bits = 0;
	  var maxV = (1 << outBits) - 1;
	  var result = [];

	  for (var i = 0; i < data.length; ++i) {
	    value = value << inBits | data[i];
	    bits += inBits;

	    while (bits >= outBits) {
	      bits -= outBits;
	      result.push(value >> bits & maxV);
	    }
	  }

	  if (pad) {
	    if (bits > 0) {
	      result.push(value << outBits - bits & maxV);
	    }
	  } else {
	    if (bits >= inBits) return 'Excess padding';
	    if (value << outBits - bits & maxV) return 'Non-zero padding';
	  }

	  return result;
	}

	function toWordsUnsafe(bytes) {
	  var res = convert(bytes, 8, 5, true);
	  if (Array.isArray(res)) return res;
	}

	function toWords(bytes) {
	  var res = convert(bytes, 8, 5, true);
	  if (Array.isArray(res)) return res;
	  throw new Error(res);
	}

	function fromWordsUnsafe(words) {
	  var res = convert(words, 5, 8, false);
	  if (Array.isArray(res)) return res;
	}

	function fromWords(words) {
	  var res = convert(words, 5, 8, false);
	  if (Array.isArray(res)) return res;
	  throw new Error(res);
	}

	var bech32 = {
	  decodeUnsafe: decodeUnsafe,
	  decode: decode,
	  encode: encode$1,
	  toWordsUnsafe: toWordsUnsafe,
	  toWords: toWords,
	  fromWordsUnsafe: fromWordsUnsafe,
	  fromWords: fromWords
	};

	const version$1 = "providers/5.7.0";

	const logger$3 = new Logger(version$1);
	class Formatter {
	  constructor() {
	    this.formats = this.getDefaultFormats();
	  }

	  getDefaultFormats() {
	    const formats = {};
	    const address = this.address.bind(this);
	    const bigNumber = this.bigNumber.bind(this);
	    const blockTag = this.blockTag.bind(this);
	    const data = this.data.bind(this);
	    const hash = this.hash.bind(this);
	    const hex = this.hex.bind(this);
	    const number = this.number.bind(this);
	    const type = this.type.bind(this);

	    const strictData = v => {
	      return this.data(v, true);
	    };

	    formats.transaction = {
	      hash: hash,
	      type: type,
	      accessList: Formatter.allowNull(this.accessList.bind(this), null),
	      blockHash: Formatter.allowNull(hash, null),
	      blockNumber: Formatter.allowNull(number, null),
	      transactionIndex: Formatter.allowNull(number, null),
	      confirmations: Formatter.allowNull(number, null),
	      from: address,
	      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
	      // must be set
	      gasPrice: Formatter.allowNull(bigNumber),
	      maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
	      maxFeePerGas: Formatter.allowNull(bigNumber),
	      gasLimit: bigNumber,
	      to: Formatter.allowNull(address, null),
	      value: bigNumber,
	      nonce: number,
	      data: data,
	      r: Formatter.allowNull(this.uint256),
	      s: Formatter.allowNull(this.uint256),
	      v: Formatter.allowNull(number),
	      creates: Formatter.allowNull(address, null),
	      raw: Formatter.allowNull(data)
	    };
	    formats.transactionRequest = {
	      from: Formatter.allowNull(address),
	      nonce: Formatter.allowNull(number),
	      gasLimit: Formatter.allowNull(bigNumber),
	      gasPrice: Formatter.allowNull(bigNumber),
	      maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
	      maxFeePerGas: Formatter.allowNull(bigNumber),
	      to: Formatter.allowNull(address),
	      value: Formatter.allowNull(bigNumber),
	      data: Formatter.allowNull(strictData),
	      type: Formatter.allowNull(number),
	      accessList: Formatter.allowNull(this.accessList.bind(this), null)
	    };
	    formats.receiptLog = {
	      transactionIndex: number,
	      blockNumber: number,
	      transactionHash: hash,
	      address: address,
	      topics: Formatter.arrayOf(hash),
	      data: data,
	      logIndex: number,
	      blockHash: hash
	    };
	    formats.receipt = {
	      to: Formatter.allowNull(this.address, null),
	      from: Formatter.allowNull(this.address, null),
	      contractAddress: Formatter.allowNull(address, null),
	      transactionIndex: number,
	      // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
	      root: Formatter.allowNull(hex),
	      gasUsed: bigNumber,
	      logsBloom: Formatter.allowNull(data),
	      blockHash: hash,
	      transactionHash: hash,
	      logs: Formatter.arrayOf(this.receiptLog.bind(this)),
	      blockNumber: number,
	      confirmations: Formatter.allowNull(number, null),
	      cumulativeGasUsed: bigNumber,
	      effectiveGasPrice: Formatter.allowNull(bigNumber),
	      status: Formatter.allowNull(number),
	      type: type
	    };
	    formats.block = {
	      hash: Formatter.allowNull(hash),
	      parentHash: hash,
	      number: number,
	      timestamp: number,
	      nonce: Formatter.allowNull(hex),
	      difficulty: this.difficulty.bind(this),
	      gasLimit: bigNumber,
	      gasUsed: bigNumber,
	      miner: Formatter.allowNull(address),
	      extraData: data,
	      transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
	      baseFeePerGas: Formatter.allowNull(bigNumber)
	    };
	    formats.blockWithTransactions = shallowCopy(formats.block);
	    formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
	    formats.filter = {
	      fromBlock: Formatter.allowNull(blockTag, undefined),
	      toBlock: Formatter.allowNull(blockTag, undefined),
	      blockHash: Formatter.allowNull(hash, undefined),
	      address: Formatter.allowNull(address, undefined),
	      topics: Formatter.allowNull(this.topics.bind(this), undefined)
	    };
	    formats.filterLog = {
	      blockNumber: Formatter.allowNull(number),
	      blockHash: Formatter.allowNull(hash),
	      transactionIndex: number,
	      removed: Formatter.allowNull(this.boolean.bind(this)),
	      address: address,
	      data: Formatter.allowFalsish(data, "0x"),
	      topics: Formatter.arrayOf(hash),
	      transactionHash: hash,
	      logIndex: number
	    };
	    return formats;
	  }

	  accessList(accessList) {
	    return accessListify(accessList || []);
	  } // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
	  // Strict! Used on input.


	  number(number) {
	    if (number === "0x") {
	      return 0;
	    }

	    return BigNumber.from(number).toNumber();
	  }

	  type(number) {
	    if (number === "0x" || number == null) {
	      return 0;
	    }

	    return BigNumber.from(number).toNumber();
	  } // Strict! Used on input.


	  bigNumber(value) {
	    return BigNumber.from(value);
	  } // Requires a boolean, "true" or  "false"; returns a boolean


	  boolean(value) {
	    if (typeof value === "boolean") {
	      return value;
	    }

	    if (typeof value === "string") {
	      value = value.toLowerCase();

	      if (value === "true") {
	        return true;
	      }

	      if (value === "false") {
	        return false;
	      }
	    }

	    throw new Error("invalid boolean - " + value);
	  }

	  hex(value, strict) {
	    if (typeof value === "string") {
	      if (!strict && value.substring(0, 2) !== "0x") {
	        value = "0x" + value;
	      }

	      if (isHexString(value)) {
	        return value.toLowerCase();
	      }
	    }

	    return logger$3.throwArgumentError("invalid hash", "value", value);
	  }

	  data(value, strict) {
	    const result = this.hex(value, strict);

	    if (result.length % 2 !== 0) {
	      throw new Error("invalid data; odd-length - " + value);
	    }

	    return result;
	  } // Requires an address
	  // Strict! Used on input.


	  address(value) {
	    return getAddress(value);
	  }

	  callAddress(value) {
	    if (!isHexString(value, 32)) {
	      return null;
	    }

	    const address = getAddress(hexDataSlice(value, 12));
	    return address === AddressZero ? null : address;
	  }

	  contractAddress(value) {
	    return getContractAddress(value);
	  } // Strict! Used on input.


	  blockTag(blockTag) {
	    if (blockTag == null) {
	      return "latest";
	    }

	    if (blockTag === "earliest") {
	      return "0x0";
	    }

	    switch (blockTag) {
	      case "earliest":
	        return "0x0";

	      case "latest":
	      case "pending":
	      case "safe":
	      case "finalized":
	        return blockTag;
	    }

	    if (typeof blockTag === "number" || isHexString(blockTag)) {
	      return hexValue(blockTag);
	    }

	    throw new Error("invalid blockTag");
	  } // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.


	  hash(value, strict) {
	    const result = this.hex(value, strict);

	    if (hexDataLength(result) !== 32) {
	      return logger$3.throwArgumentError("invalid hash", "value", value);
	    }

	    return result;
	  } // Returns the difficulty as a number, or if too large (i.e. PoA network) null


	  difficulty(value) {
	    if (value == null) {
	      return null;
	    }

	    const v = BigNumber.from(value);

	    try {
	      return v.toNumber();
	    } catch (error) {}

	    return null;
	  }

	  uint256(value) {
	    if (!isHexString(value)) {
	      throw new Error("invalid uint256");
	    }

	    return hexZeroPad(value, 32);
	  }

	  _block(value, format) {
	    if (value.author != null && value.miner == null) {
	      value.miner = value.author;
	    } // The difficulty may need to come from _difficulty in recursed blocks


	    const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
	    const result = Formatter.check(format, value);
	    result._difficulty = difficulty == null ? null : BigNumber.from(difficulty);
	    return result;
	  }

	  block(value) {
	    return this._block(value, this.formats.block);
	  }

	  blockWithTransactions(value) {
	    return this._block(value, this.formats.blockWithTransactions);
	  } // Strict! Used on input.


	  transactionRequest(value) {
	    return Formatter.check(this.formats.transactionRequest, value);
	  }

	  transactionResponse(transaction) {
	    // Rename gas to gasLimit
	    if (transaction.gas != null && transaction.gasLimit == null) {
	      transaction.gasLimit = transaction.gas;
	    } // Some clients (TestRPC) do strange things like return 0x0 for the
	    // 0 address; correct this to be a real address


	    if (transaction.to && BigNumber.from(transaction.to).isZero()) {
	      transaction.to = "0x0000000000000000000000000000000000000000";
	    } // Rename input to data


	    if (transaction.input != null && transaction.data == null) {
	      transaction.data = transaction.input;
	    } // If to and creates are empty, populate the creates from the transaction


	    if (transaction.to == null && transaction.creates == null) {
	      transaction.creates = this.contractAddress(transaction);
	    }

	    if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) {
	      transaction.accessList = [];
	    }

	    const result = Formatter.check(this.formats.transaction, transaction);

	    if (transaction.chainId != null) {
	      let chainId = transaction.chainId;

	      if (isHexString(chainId)) {
	        chainId = BigNumber.from(chainId).toNumber();
	      }

	      result.chainId = chainId;
	    } else {
	      let chainId = transaction.networkId; // geth-etc returns chainId

	      if (chainId == null && result.v == null) {
	        chainId = transaction.chainId;
	      }

	      if (isHexString(chainId)) {
	        chainId = BigNumber.from(chainId).toNumber();
	      }

	      if (typeof chainId !== "number" && result.v != null) {
	        chainId = (result.v - 35) / 2;

	        if (chainId < 0) {
	          chainId = 0;
	        }

	        chainId = parseInt(chainId);
	      }

	      if (typeof chainId !== "number") {
	        chainId = 0;
	      }

	      result.chainId = chainId;
	    } // 0x0000... should actually be null


	    if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") {
	      result.blockHash = null;
	    }

	    return result;
	  }

	  transaction(value) {
	    return parse(value);
	  }

	  receiptLog(value) {
	    return Formatter.check(this.formats.receiptLog, value);
	  }

	  receipt(value) {
	    const result = Formatter.check(this.formats.receipt, value); // RSK incorrectly implemented EIP-658, so we munge things a bit here for it

	    if (result.root != null) {
	      if (result.root.length <= 4) {
	        // Could be 0x00, 0x0, 0x01 or 0x1
	        const value = BigNumber.from(result.root).toNumber();

	        if (value === 0 || value === 1) {
	          // Make sure if both are specified, they match
	          if (result.status != null && result.status !== value) {
	            logger$3.throwArgumentError("alt-root-status/status mismatch", "value", {
	              root: result.root,
	              status: result.status
	            });
	          }

	          result.status = value;
	          delete result.root;
	        } else {
	          logger$3.throwArgumentError("invalid alt-root-status", "value.root", result.root);
	        }
	      } else if (result.root.length !== 66) {
	        // Must be a valid bytes32
	        logger$3.throwArgumentError("invalid root hash", "value.root", result.root);
	      }
	    }

	    if (result.status != null) {
	      result.byzantium = true;
	    }

	    return result;
	  }

	  topics(value) {
	    if (Array.isArray(value)) {
	      return value.map(v => this.topics(v));
	    } else if (value != null) {
	      return this.hash(value, true);
	    }

	    return null;
	  }

	  filter(value) {
	    return Formatter.check(this.formats.filter, value);
	  }

	  filterLog(value) {
	    return Formatter.check(this.formats.filterLog, value);
	  }

	  static check(format, object) {
	    const result = {};

	    for (const key in format) {
	      try {
	        const value = format[key](object[key]);

	        if (value !== undefined) {
	          result[key] = value;
	        }
	      } catch (error) {
	        error.checkKey = key;
	        error.checkValue = object[key];
	        throw error;
	      }
	    }

	    return result;
	  } // if value is null-ish, nullValue is returned


	  static allowNull(format, nullValue) {
	    return function (value) {
	      if (value == null) {
	        return nullValue;
	      }

	      return format(value);
	    };
	  } // If value is false-ish, replaceValue is returned


	  static allowFalsish(format, replaceValue) {
	    return function (value) {
	      if (!value) {
	        return replaceValue;
	      }

	      return format(value);
	    };
	  } // Requires an Array satisfying check


	  static arrayOf(format) {
	    return function (array) {
	      if (!Array.isArray(array)) {
	        throw new Error("not an array");
	      }

	      const result = [];
	      array.forEach(function (value) {
	        result.push(format(value));
	      });
	      return result;
	    };
	  }

	}

	var __awaiter$1 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$2 = new Logger(version$1);
	const MAX_CCIP_REDIRECTS = 10; //////////////////////////////
	// Event Serializeing

	function checkTopic(topic) {
	  if (topic == null) {
	    return "null";
	  }

	  if (hexDataLength(topic) !== 32) {
	    logger$2.throwArgumentError("invalid topic", "topic", topic);
	  }

	  return topic.toLowerCase();
	}

	function serializeTopics(topics) {
	  // Remove trailing null AND-topics; they are redundant
	  topics = topics.slice();

	  while (topics.length > 0 && topics[topics.length - 1] == null) {
	    topics.pop();
	  }

	  return topics.map(topic => {
	    if (Array.isArray(topic)) {
	      // Only track unique OR-topics
	      const unique = {};
	      topic.forEach(topic => {
	        unique[checkTopic(topic)] = true;
	      }); // The order of OR-topics does not matter

	      const sorted = Object.keys(unique);
	      sorted.sort();
	      return sorted.join("|");
	    } else {
	      return checkTopic(topic);
	    }
	  }).join("&");
	}

	function deserializeTopics(data) {
	  if (data === "") {
	    return [];
	  }

	  return data.split(/&/g).map(topic => {
	    if (topic === "") {
	      return [];
	    }

	    const comps = topic.split("|").map(topic => {
	      return topic === "null" ? null : topic;
	    });
	    return comps.length === 1 ? comps[0] : comps;
	  });
	}

	function getEventTag(eventName) {
	  if (typeof eventName === "string") {
	    eventName = eventName.toLowerCase();

	    if (hexDataLength(eventName) === 32) {
	      return "tx:" + eventName;
	    }

	    if (eventName.indexOf(":") === -1) {
	      return eventName;
	    }
	  } else if (Array.isArray(eventName)) {
	    return "filter:*:" + serializeTopics(eventName);
	  } else if (ForkEvent.isForkEvent(eventName)) {
	    logger$2.warn("not implemented");
	    throw new Error("not implemented");
	  } else if (eventName && typeof eventName === "object") {
	    return "filter:" + (eventName.address || "*") + ":" + serializeTopics(eventName.topics || []);
	  }

	  throw new Error("invalid event - " + eventName);
	} //////////////////////////////
	// Helper Object


	function getTime() {
	  return new Date().getTime();
	}

	function stall(duration) {
	  return new Promise(resolve => {
	    setTimeout(resolve, duration);
	  });
	} //////////////////////////////
	// Provider Object

	/**
	 *  EventType
	 *   - "block"
	 *   - "poll"
	 *   - "didPoll"
	 *   - "pending"
	 *   - "error"
	 *   - "network"
	 *   - filter
	 *   - topics array
	 *   - transaction hash
	 */


	const PollableEvents = ["block", "network", "pending", "poll"];
	class Event$1 {
	  constructor(tag, listener, once) {
	    defineReadOnly(this, "tag", tag);
	    defineReadOnly(this, "listener", listener);
	    defineReadOnly(this, "once", once);
	    this._lastBlockNumber = -2;
	    this._inflight = false;
	  }

	  get event() {
	    switch (this.type) {
	      case "tx":
	        return this.hash;

	      case "filter":
	        return this.filter;
	    }

	    return this.tag;
	  }

	  get type() {
	    return this.tag.split(":")[0];
	  }

	  get hash() {
	    const comps = this.tag.split(":");

	    if (comps[0] !== "tx") {
	      return null;
	    }

	    return comps[1];
	  }

	  get filter() {
	    const comps = this.tag.split(":");

	    if (comps[0] !== "filter") {
	      return null;
	    }

	    const address = comps[1];
	    const topics = deserializeTopics(comps[2]);
	    const filter = {};

	    if (topics.length > 0) {
	      filter.topics = topics;
	    }

	    if (address && address !== "*") {
	      filter.address = address;
	    }

	    return filter;
	  }

	  pollable() {
	    return this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0;
	  }

	}

	const coinInfos = {
	  "0": {
	    symbol: "btc",
	    p2pkh: 0x00,
	    p2sh: 0x05,
	    prefix: "bc"
	  },
	  "2": {
	    symbol: "ltc",
	    p2pkh: 0x30,
	    p2sh: 0x32,
	    prefix: "ltc"
	  },
	  "3": {
	    symbol: "doge",
	    p2pkh: 0x1e,
	    p2sh: 0x16
	  },
	  "60": {
	    symbol: "eth",
	    ilk: "eth"
	  },
	  "61": {
	    symbol: "etc",
	    ilk: "eth"
	  },
	  "700": {
	    symbol: "xdai",
	    ilk: "eth"
	  }
	};

	function bytes32ify(value) {
	  return hexZeroPad(BigNumber.from(value).toHexString(), 32);
	} // Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)


	function base58Encode(data) {
	  return Base58.encode(concat$1([data, hexDataSlice(sha256(sha256(data)), 0, 4)]));
	}

	const matcherIpfs = new RegExp("^(ipfs):/\/(.*)$", "i");
	const matchers = [new RegExp("^(https):/\/(.*)$", "i"), new RegExp("^(data):(.*)$", "i"), matcherIpfs, new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")];

	function _parseString(result, start) {
	  try {
	    return toUtf8String(_parseBytes(result, start));
	  } catch (error) {}

	  return null;
	}

	function _parseBytes(result, start) {
	  if (result === "0x") {
	    return null;
	  }

	  const offset = BigNumber.from(hexDataSlice(result, start, start + 32)).toNumber();
	  const length = BigNumber.from(hexDataSlice(result, offset, offset + 32)).toNumber();
	  return hexDataSlice(result, offset + 32, offset + 32 + length);
	} // Trim off the ipfs:// prefix and return the default gateway URL


	function getIpfsLink(link) {
	  if (link.match(/^ipfs:\/\/ipfs\//i)) {
	    link = link.substring(12);
	  } else if (link.match(/^ipfs:\/\//i)) {
	    link = link.substring(7);
	  } else {
	    logger$2.throwArgumentError("unsupported IPFS format", "link", link);
	  }

	  return `https:/\/gateway.ipfs.io/ipfs/${link}`;
	}

	function numPad(value) {
	  const result = arrayify(value);

	  if (result.length > 32) {
	    throw new Error("internal; should not happen");
	  }

	  const padded = new Uint8Array(32);
	  padded.set(result, 32 - result.length);
	  return padded;
	}

	function bytesPad(value) {
	  if (value.length % 32 === 0) {
	    return value;
	  }

	  const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
	  result.set(value);
	  return result;
	} // ABI Encodes a series of (bytes, bytes, ...)


	function encodeBytes(datas) {
	  const result = [];
	  let byteCount = 0; // Add place-holders for pointers as we add items

	  for (let i = 0; i < datas.length; i++) {
	    result.push(null);
	    byteCount += 32;
	  }

	  for (let i = 0; i < datas.length; i++) {
	    const data = arrayify(datas[i]); // Update the bytes offset

	    result[i] = numPad(byteCount); // The length and padded value of data

	    result.push(numPad(data.length));
	    result.push(bytesPad(data));
	    byteCount += 32 + Math.ceil(data.length / 32) * 32;
	  }

	  return hexConcat(result);
	}

	class Resolver {
	  // The resolvedAddress is only for creating a ReverseLookup resolver
	  constructor(provider, address, name, resolvedAddress) {
	    defineReadOnly(this, "provider", provider);
	    defineReadOnly(this, "name", name);
	    defineReadOnly(this, "address", provider.formatter.address(address));
	    defineReadOnly(this, "_resolvedAddress", resolvedAddress);
	  }

	  supportsWildcard() {
	    if (!this._supportsEip2544) {
	      // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
	      this._supportsEip2544 = this.provider.call({
	        to: this.address,
	        data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
	      }).then(result => {
	        return BigNumber.from(result).eq(1);
	      }).catch(error => {
	        if (error.code === Logger.errors.CALL_EXCEPTION) {
	          return false;
	        } // Rethrow the error: link is down, etc. Let future attempts retry.


	        this._supportsEip2544 = null;
	        throw error;
	      });
	    }

	    return this._supportsEip2544;
	  }

	  _fetch(selector, parameters) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // e.g. keccak256("addr(bytes32,uint256)")
	      const tx = {
	        to: this.address,
	        ccipReadEnabled: true,
	        data: hexConcat([selector, namehash(this.name), parameters || "0x"])
	      }; // Wildcard support; use EIP-2544 to resolve the request

	      let parseBytes = false;

	      if (yield this.supportsWildcard()) {
	        parseBytes = true; // selector("resolve(bytes,bytes)")

	        tx.data = hexConcat(["0x9061b923", encodeBytes([dnsEncode(this.name), tx.data])]);
	      }

	      try {
	        let result = yield this.provider.call(tx);

	        if (arrayify(result).length % 32 === 4) {
	          logger$2.throwError("resolver threw error", Logger.errors.CALL_EXCEPTION, {
	            transaction: tx,
	            data: result
	          });
	        }

	        if (parseBytes) {
	          result = _parseBytes(result, 0);
	        }

	        return result;
	      } catch (error) {
	        if (error.code === Logger.errors.CALL_EXCEPTION) {
	          return null;
	        }

	        throw error;
	      }
	    });
	  }

	  _fetchBytes(selector, parameters) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const result = yield this._fetch(selector, parameters);

	      if (result != null) {
	        return _parseBytes(result, 0);
	      }

	      return null;
	    });
	  }

	  _getAddress(coinType, hexBytes) {
	    const coinInfo = coinInfos[String(coinType)];

	    if (coinInfo == null) {
	      logger$2.throwError(`unsupported coin type: ${coinType}`, Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: `getAddress(${coinType})`
	      });
	    }

	    if (coinInfo.ilk === "eth") {
	      return this.provider.formatter.address(hexBytes);
	    }

	    const bytes = arrayify(hexBytes); // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG

	    if (coinInfo.p2pkh != null) {
	      const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);

	      if (p2pkh) {
	        const length = parseInt(p2pkh[1], 16);

	        if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) {
	          return base58Encode(concat$1([[coinInfo.p2pkh], "0x" + p2pkh[2]]));
	        }
	      }
	    } // P2SH: OP_HASH160 <scriptHash> OP_EQUAL


	    if (coinInfo.p2sh != null) {
	      const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);

	      if (p2sh) {
	        const length = parseInt(p2sh[1], 16);

	        if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) {
	          return base58Encode(concat$1([[coinInfo.p2sh], "0x" + p2sh[2]]));
	        }
	      }
	    } // Bech32


	    if (coinInfo.prefix != null) {
	      const length = bytes[1]; // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program

	      let version = bytes[0];

	      if (version === 0x00) {
	        if (length !== 20 && length !== 32) {
	          version = -1;
	        }
	      } else {
	        version = -1;
	      }

	      if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
	        const words = bech32.toWords(bytes.slice(2));
	        words.unshift(version);
	        return bech32.encode(coinInfo.prefix, words);
	      }
	    }

	    return null;
	  }

	  getAddress(coinType) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (coinType == null) {
	        coinType = 60;
	      } // If Ethereum, use the standard `addr(bytes32)`


	      if (coinType === 60) {
	        try {
	          // keccak256("addr(bytes32)")
	          const result = yield this._fetch("0x3b3b57de"); // No address

	          if (result === "0x" || result === HashZero) {
	            return null;
	          }

	          return this.provider.formatter.callAddress(result);
	        } catch (error) {
	          if (error.code === Logger.errors.CALL_EXCEPTION) {
	            return null;
	          }

	          throw error;
	        }
	      } // keccak256("addr(bytes32,uint256")


	      const hexBytes = yield this._fetchBytes("0xf1cb7e06", bytes32ify(coinType)); // No address

	      if (hexBytes == null || hexBytes === "0x") {
	        return null;
	      } // Compute the address


	      const address = this._getAddress(coinType, hexBytes);

	      if (address == null) {
	        logger$2.throwError(`invalid or unsupported coin data`, Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: `getAddress(${coinType})`,
	          coinType: coinType,
	          data: hexBytes
	        });
	      }

	      return address;
	    });
	  }

	  getAvatar() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const linkage = [{
	        type: "name",
	        content: this.name
	      }];

	      try {
	        // test data for ricmoo.eth
	        //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
	        const avatar = yield this.getText("avatar");

	        if (avatar == null) {
	          return null;
	        }

	        for (let i = 0; i < matchers.length; i++) {
	          const match = avatar.match(matchers[i]);

	          if (match == null) {
	            continue;
	          }

	          const scheme = match[1].toLowerCase();

	          switch (scheme) {
	            case "https":
	              linkage.push({
	                type: "url",
	                content: avatar
	              });
	              return {
	                linkage,
	                url: avatar
	              };

	            case "data":
	              linkage.push({
	                type: "data",
	                content: avatar
	              });
	              return {
	                linkage,
	                url: avatar
	              };

	            case "ipfs":
	              linkage.push({
	                type: "ipfs",
	                content: avatar
	              });
	              return {
	                linkage,
	                url: getIpfsLink(avatar)
	              };

	            case "erc721":
	            case "erc1155":
	              {
	                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
	                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
	                linkage.push({
	                  type: scheme,
	                  content: avatar
	                }); // The owner of this name

	                const owner = this._resolvedAddress || (yield this.getAddress());
	                const comps = (match[2] || "").split("/");

	                if (comps.length !== 2) {
	                  return null;
	                }

	                const addr = yield this.provider.formatter.address(comps[0]);
	                const tokenId = hexZeroPad(BigNumber.from(comps[1]).toHexString(), 32); // Check that this account owns the token

	                if (scheme === "erc721") {
	                  // ownerOf(uint256 tokenId)
	                  const tokenOwner = this.provider.formatter.callAddress(yield this.provider.call({
	                    to: addr,
	                    data: hexConcat(["0x6352211e", tokenId])
	                  }));

	                  if (owner !== tokenOwner) {
	                    return null;
	                  }

	                  linkage.push({
	                    type: "owner",
	                    content: tokenOwner
	                  });
	                } else if (scheme === "erc1155") {
	                  // balanceOf(address owner, uint256 tokenId)
	                  const balance = BigNumber.from(yield this.provider.call({
	                    to: addr,
	                    data: hexConcat(["0x00fdd58e", hexZeroPad(owner, 32), tokenId])
	                  }));

	                  if (balance.isZero()) {
	                    return null;
	                  }

	                  linkage.push({
	                    type: "balance",
	                    content: balance.toString()
	                  });
	                } // Call the token contract for the metadata URL


	                const tx = {
	                  to: this.provider.formatter.address(comps[0]),
	                  data: hexConcat([selector, tokenId])
	                };

	                let metadataUrl = _parseString(yield this.provider.call(tx), 0);

	                if (metadataUrl == null) {
	                  return null;
	                }

	                linkage.push({
	                  type: "metadata-url-base",
	                  content: metadataUrl
	                }); // ERC-1155 allows a generic {id} in the URL

	                if (scheme === "erc1155") {
	                  metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
	                  linkage.push({
	                    type: "metadata-url-expanded",
	                    content: metadataUrl
	                  });
	                } // Transform IPFS metadata links


	                if (metadataUrl.match(/^ipfs:/i)) {
	                  metadataUrl = getIpfsLink(metadataUrl);
	                }

	                linkage.push({
	                  type: "metadata-url",
	                  content: metadataUrl
	                }); // Get the token metadata

	                const metadata = yield fetchJson(metadataUrl);

	                if (!metadata) {
	                  return null;
	                }

	                linkage.push({
	                  type: "metadata",
	                  content: JSON.stringify(metadata)
	                }); // Pull the image URL out

	                let imageUrl = metadata.image;

	                if (typeof imageUrl !== "string") {
	                  return null;
	                }

	                if (imageUrl.match(/^(https:\/\/|data:)/i)) {// Allow
	                } else {
	                  // Transform IPFS link to gateway
	                  const ipfs = imageUrl.match(matcherIpfs);

	                  if (ipfs == null) {
	                    return null;
	                  }

	                  linkage.push({
	                    type: "url-ipfs",
	                    content: imageUrl
	                  });
	                  imageUrl = getIpfsLink(imageUrl);
	                }

	                linkage.push({
	                  type: "url",
	                  content: imageUrl
	                });
	                return {
	                  linkage,
	                  url: imageUrl
	                };
	              }
	          }
	        }
	      } catch (error) {}

	      return null;
	    });
	  }

	  getContentHash() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // keccak256("contenthash()")
	      const hexBytes = yield this._fetchBytes("0xbc1c58d1"); // No contenthash

	      if (hexBytes == null || hexBytes === "0x") {
	        return null;
	      } // IPFS (CID: 1, Type: DAG-PB)


	      const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);

	      if (ipfs) {
	        const length = parseInt(ipfs[3], 16);

	        if (ipfs[4].length === length * 2) {
	          return "ipfs:/\/" + Base58.encode("0x" + ipfs[1]);
	        }
	      } // IPNS (CID: 1, Type: libp2p-key)


	      const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);

	      if (ipns) {
	        const length = parseInt(ipns[3], 16);

	        if (ipns[4].length === length * 2) {
	          return "ipns:/\/" + Base58.encode("0x" + ipns[1]);
	        }
	      } // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)


	      const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);

	      if (swarm) {
	        if (swarm[1].length === 32 * 2) {
	          return "bzz:/\/" + swarm[1];
	        }
	      }

	      const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);

	      if (skynet) {
	        if (skynet[1].length === 34 * 2) {
	          // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
	          const urlSafe = {
	            "=": "",
	            "+": "-",
	            "/": "_"
	          };
	          const hash = encode$2("0x" + skynet[1]).replace(/[=+\/]/g, a => urlSafe[a]);
	          return "sia:/\/" + hash;
	        }
	      }

	      return logger$2.throwError(`invalid or unsupported content hash data`, Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "getContentHash()",
	        data: hexBytes
	      });
	    });
	  }

	  getText(key) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // The key encoded as parameter to fetchBytes
	      let keyBytes = toUtf8Bytes(key); // The nodehash consumes the first slot, so the string pointer targets
	      // offset 64, with the length at offset 64 and data starting at offset 96

	      keyBytes = concat$1([bytes32ify(64), bytes32ify(keyBytes.length), keyBytes]); // Pad to word-size (32 bytes)

	      if (keyBytes.length % 32 !== 0) {
	        keyBytes = concat$1([keyBytes, hexZeroPad("0x", 32 - key.length % 32)]);
	      }

	      const hexBytes = yield this._fetchBytes("0x59d1d43c", hexlify(keyBytes));

	      if (hexBytes == null || hexBytes === "0x") {
	        return null;
	      }

	      return toUtf8String(hexBytes);
	    });
	  }

	}
	let defaultFormatter = null;
	let nextPollId = 1;
	class BaseProvider extends Provider {
	  /**
	   *  ready
	   *
	   *  A Promise<Network> that resolves only once the provider is ready.
	   *
	   *  Sub-classes that call the super with a network without a chainId
	   *  MUST set this. Standard named networks have a known chainId.
	   *
	   */
	  constructor(network) {
	    super(); // Events being listened to

	    this._events = [];
	    this._emitted = {
	      block: -2
	    };
	    this.disableCcipRead = false;
	    this.formatter = new.target.getFormatter(); // If network is any, this Provider allows the underlying
	    // network to change dynamically, and we auto-detect the
	    // current network

	    defineReadOnly(this, "anyNetwork", network === "any");

	    if (this.anyNetwork) {
	      network = this.detectNetwork();
	    }

	    if (network instanceof Promise) {
	      this._networkPromise = network; // Squash any "unhandled promise" errors; that do not need to be handled

	      network.catch(error => {}); // Trigger initial network setting (async)

	      this._ready().catch(error => {});
	    } else {
	      const knownNetwork = getStatic(new.target, "getNetwork")(network);

	      if (knownNetwork) {
	        defineReadOnly(this, "_network", knownNetwork);
	        this.emit("network", knownNetwork, null);
	      } else {
	        logger$2.throwArgumentError("invalid network", "network", network);
	      }
	    }

	    this._maxInternalBlockNumber = -1024;
	    this._lastBlockNumber = -2;
	    this._maxFilterBlockRange = 10;
	    this._pollingInterval = 4000;
	    this._fastQueryDate = 0;
	  }

	  _ready() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (this._network == null) {
	        let network = null;

	        if (this._networkPromise) {
	          try {
	            network = yield this._networkPromise;
	          } catch (error) {}
	        } // Try the Provider's network detection (this MUST throw if it cannot)


	        if (network == null) {
	          network = yield this.detectNetwork();
	        } // This should never happen; every Provider sub-class should have
	        // suggested a network by here (or have thrown).


	        if (!network) {
	          logger$2.throwError("no network detected", Logger.errors.UNKNOWN_ERROR, {});
	        } // Possible this call stacked so do not call defineReadOnly again


	        if (this._network == null) {
	          if (this.anyNetwork) {
	            this._network = network;
	          } else {
	            defineReadOnly(this, "_network", network);
	          }

	          this.emit("network", network, null);
	        }
	      }

	      return this._network;
	    });
	  } // This will always return the most recently established network.
	  // For "any", this can change (a "network" event is emitted before
	  // any change is reflected); otherwise this cannot change


	  get ready() {
	    return poll(() => {
	      return this._ready().then(network => {
	        return network;
	      }, error => {
	        // If the network isn't running yet, we will wait
	        if (error.code === Logger.errors.NETWORK_ERROR && error.event === "noNetwork") {
	          return undefined;
	        }

	        throw error;
	      });
	    });
	  } // @TODO: Remove this and just create a singleton formatter


	  static getFormatter() {
	    if (defaultFormatter == null) {
	      defaultFormatter = new Formatter();
	    }

	    return defaultFormatter;
	  } // @TODO: Remove this and just use getNetwork


	  static getNetwork(network) {
	    return getNetwork(network == null ? "homestead" : network);
	  }

	  ccipReadFetch(tx, calldata, urls) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (this.disableCcipRead || urls.length === 0) {
	        return null;
	      }

	      const sender = tx.to.toLowerCase();
	      const data = calldata.toLowerCase();
	      const errorMessages = [];

	      for (let i = 0; i < urls.length; i++) {
	        const url = urls[i]; // URL expansion

	        const href = url.replace("{sender}", sender).replace("{data}", data); // If no {data} is present, use POST; otherwise GET

	        const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
	          data,
	          sender
	        });
	        const result = yield fetchJson({
	          url: href,
	          errorPassThrough: true
	        }, json, (value, response) => {
	          value.status = response.statusCode;
	          return value;
	        });

	        if (result.data) {
	          return result.data;
	        }

	        const errorMessage = result.message || "unknown error"; // 4xx indicates the result is not present; stop

	        if (result.status >= 400 && result.status < 500) {
	          return logger$2.throwError(`response not found during CCIP fetch: ${errorMessage}`, Logger.errors.SERVER_ERROR, {
	            url,
	            errorMessage
	          });
	        } // 5xx indicates server issue; try the next url


	        errorMessages.push(errorMessage);
	      }

	      return logger$2.throwError(`error encountered during CCIP fetch: ${errorMessages.map(m => JSON.stringify(m)).join(", ")}`, Logger.errors.SERVER_ERROR, {
	        urls,
	        errorMessages
	      });
	    });
	  } // Fetches the blockNumber, but will reuse any result that is less
	  // than maxAge old or has been requested since the last request


	  _getInternalBlockNumber(maxAge) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this._ready(); // Allowing stale data up to maxAge old

	      if (maxAge > 0) {
	        // While there are pending internal block requests...
	        while (this._internalBlockNumber) {
	          // ..."remember" which fetch we started with
	          const internalBlockNumber = this._internalBlockNumber;

	          try {
	            // Check the result is not too stale
	            const result = yield internalBlockNumber;

	            if (getTime() - result.respTime <= maxAge) {
	              return result.blockNumber;
	            } // Too old; fetch a new value


	            break;
	          } catch (error) {
	            // The fetch rejected; if we are the first to get the
	            // rejection, drop through so we replace it with a new
	            // fetch; all others blocked will then get that fetch
	            // which won't match the one they "remembered" and loop
	            if (this._internalBlockNumber === internalBlockNumber) {
	              break;
	            }
	          }
	        }
	      }

	      const reqTime = getTime();
	      const checkInternalBlockNumber = resolveProperties({
	        blockNumber: this.perform("getBlockNumber", {}),
	        networkError: this.getNetwork().then(network => null, error => error)
	      }).then(({
	        blockNumber,
	        networkError
	      }) => {
	        if (networkError) {
	          // Unremember this bad internal block number
	          if (this._internalBlockNumber === checkInternalBlockNumber) {
	            this._internalBlockNumber = null;
	          }

	          throw networkError;
	        }

	        const respTime = getTime();
	        blockNumber = BigNumber.from(blockNumber).toNumber();

	        if (blockNumber < this._maxInternalBlockNumber) {
	          blockNumber = this._maxInternalBlockNumber;
	        }

	        this._maxInternalBlockNumber = blockNumber;

	        this._setFastBlockNumber(blockNumber); // @TODO: Still need this?


	        return {
	          blockNumber,
	          reqTime,
	          respTime
	        };
	      });
	      this._internalBlockNumber = checkInternalBlockNumber; // Swallow unhandled exceptions; if needed they are handled else where

	      checkInternalBlockNumber.catch(error => {
	        // Don't null the dead (rejected) fetch, if it has already been updated
	        if (this._internalBlockNumber === checkInternalBlockNumber) {
	          this._internalBlockNumber = null;
	        }
	      });
	      return (yield checkInternalBlockNumber).blockNumber;
	    });
	  }

	  poll() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const pollId = nextPollId++; // Track all running promises, so we can trigger a post-poll once they are complete

	      const runners = [];
	      let blockNumber = null;

	      try {
	        blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
	      } catch (error) {
	        this.emit("error", error);
	        return;
	      }

	      this._setFastBlockNumber(blockNumber); // Emit a poll event after we have the latest (fast) block number


	      this.emit("poll", pollId, blockNumber); // If the block has not changed, meh.

	      if (blockNumber === this._lastBlockNumber) {
	        this.emit("didPoll", pollId);
	        return;
	      } // First polling cycle, trigger a "block" events


	      if (this._emitted.block === -2) {
	        this._emitted.block = blockNumber - 1;
	      }

	      if (Math.abs(this._emitted.block - blockNumber) > 1000) {
	        logger$2.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
	        this.emit("error", logger$2.makeError("network block skew detected", Logger.errors.NETWORK_ERROR, {
	          blockNumber: blockNumber,
	          event: "blockSkew",
	          previousBlockNumber: this._emitted.block
	        }));
	        this.emit("block", blockNumber);
	      } else {
	        // Notify all listener for each block that has passed
	        for (let i = this._emitted.block + 1; i <= blockNumber; i++) {
	          this.emit("block", i);
	        }
	      } // The emitted block was updated, check for obsolete events


	      if (this._emitted.block !== blockNumber) {
	        this._emitted.block = blockNumber;
	        Object.keys(this._emitted).forEach(key => {
	          // The block event does not expire
	          if (key === "block") {
	            return;
	          } // The block we were at when we emitted this event


	          const eventBlockNumber = this._emitted[key]; // We cannot garbage collect pending transactions or blocks here
	          // They should be garbage collected by the Provider when setting
	          // "pending" events

	          if (eventBlockNumber === "pending") {
	            return;
	          } // Evict any transaction hashes or block hashes over 12 blocks
	          // old, since they should not return null anyways


	          if (blockNumber - eventBlockNumber > 12) {
	            delete this._emitted[key];
	          }
	        });
	      } // First polling cycle


	      if (this._lastBlockNumber === -2) {
	        this._lastBlockNumber = blockNumber - 1;
	      } // Find all transaction hashes we are waiting on


	      this._events.forEach(event => {
	        switch (event.type) {
	          case "tx":
	            {
	              const hash = event.hash;
	              let runner = this.getTransactionReceipt(hash).then(receipt => {
	                if (!receipt || receipt.blockNumber == null) {
	                  return null;
	                }

	                this._emitted["t:" + hash] = receipt.blockNumber;
	                this.emit(hash, receipt);
	                return null;
	              }).catch(error => {
	                this.emit("error", error);
	              });
	              runners.push(runner);
	              break;
	            }

	          case "filter":
	            {
	              // We only allow a single getLogs to be in-flight at a time
	              if (!event._inflight) {
	                event._inflight = true; // This is the first filter for this event, so we want to
	                // restrict events to events that happened no earlier than now

	                if (event._lastBlockNumber === -2) {
	                  event._lastBlockNumber = blockNumber - 1;
	                } // Filter from the last *known* event; due to load-balancing
	                // and some nodes returning updated block numbers before
	                // indexing events, a logs result with 0 entries cannot be
	                // trusted and we must retry a range which includes it again


	                const filter = event.filter;
	                filter.fromBlock = event._lastBlockNumber + 1;
	                filter.toBlock = blockNumber; // Prevent fitler ranges from growing too wild, since it is quite
	                // likely there just haven't been any events to move the lastBlockNumber.

	                const minFromBlock = filter.toBlock - this._maxFilterBlockRange;

	                if (minFromBlock > filter.fromBlock) {
	                  filter.fromBlock = minFromBlock;
	                }

	                if (filter.fromBlock < 0) {
	                  filter.fromBlock = 0;
	                }

	                const runner = this.getLogs(filter).then(logs => {
	                  // Allow the next getLogs
	                  event._inflight = false;

	                  if (logs.length === 0) {
	                    return;
	                  }

	                  logs.forEach(log => {
	                    // Only when we get an event for a given block number
	                    // can we trust the events are indexed
	                    if (log.blockNumber > event._lastBlockNumber) {
	                      event._lastBlockNumber = log.blockNumber;
	                    } // Make sure we stall requests to fetch blocks and txs


	                    this._emitted["b:" + log.blockHash] = log.blockNumber;
	                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
	                    this.emit(filter, log);
	                  });
	                }).catch(error => {
	                  this.emit("error", error); // Allow another getLogs (the range was not updated)

	                  event._inflight = false;
	                });
	                runners.push(runner);
	              }

	              break;
	            }
	        }
	      });

	      this._lastBlockNumber = blockNumber; // Once all events for this loop have been processed, emit "didPoll"

	      Promise.all(runners).then(() => {
	        this.emit("didPoll", pollId);
	      }).catch(error => {
	        this.emit("error", error);
	      });
	      return;
	    });
	  } // Deprecated; do not use this


	  resetEventsBlock(blockNumber) {
	    this._lastBlockNumber = blockNumber - 1;

	    if (this.polling) {
	      this.poll();
	    }
	  }

	  get network() {
	    return this._network;
	  } // This method should query the network if the underlying network
	  // can change, such as when connected to a JSON-RPC backend


	  detectNetwork() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      return logger$2.throwError("provider does not support network detection", Logger.errors.UNSUPPORTED_OPERATION, {
	        operation: "provider.detectNetwork"
	      });
	    });
	  }

	  getNetwork() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const network = yield this._ready(); // Make sure we are still connected to the same network; this is
	      // only an external call for backends which can have the underlying
	      // network change spontaneously

	      const currentNetwork = yield this.detectNetwork();

	      if (network.chainId !== currentNetwork.chainId) {
	        // We are allowing network changes, things can get complex fast;
	        // make sure you know what you are doing if you use "any"
	        if (this.anyNetwork) {
	          this._network = currentNetwork; // Reset all internal block number guards and caches

	          this._lastBlockNumber = -2;
	          this._fastBlockNumber = null;
	          this._fastBlockNumberPromise = null;
	          this._fastQueryDate = 0;
	          this._emitted.block = -2;
	          this._maxInternalBlockNumber = -1024;
	          this._internalBlockNumber = null; // The "network" event MUST happen before this method resolves
	          // so any events have a chance to unregister, so we stall an
	          // additional event loop before returning from /this/ call

	          this.emit("network", currentNetwork, network);
	          yield stall(0);
	          return this._network;
	        }

	        const error = logger$2.makeError("underlying network changed", Logger.errors.NETWORK_ERROR, {
	          event: "changed",
	          network: network,
	          detectedNetwork: currentNetwork
	        });
	        this.emit("error", error);
	        throw error;
	      }

	      return network;
	    });
	  }

	  get blockNumber() {
	    this._getInternalBlockNumber(100 + this.pollingInterval / 2).then(blockNumber => {
	      this._setFastBlockNumber(blockNumber);
	    }, error => {});

	    return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
	  }

	  get polling() {
	    return this._poller != null;
	  }

	  set polling(value) {
	    if (value && !this._poller) {
	      this._poller = setInterval(() => {
	        this.poll();
	      }, this.pollingInterval);

	      if (!this._bootstrapPoll) {
	        this._bootstrapPoll = setTimeout(() => {
	          this.poll(); // We block additional polls until the polling interval
	          // is done, to prevent overwhelming the poll function

	          this._bootstrapPoll = setTimeout(() => {
	            // If polling was disabled, something may require a poke
	            // since starting the bootstrap poll and it was disabled
	            if (!this._poller) {
	              this.poll();
	            } // Clear out the bootstrap so we can do another


	            this._bootstrapPoll = null;
	          }, this.pollingInterval);
	        }, 0);
	      }
	    } else if (!value && this._poller) {
	      clearInterval(this._poller);
	      this._poller = null;
	    }
	  }

	  get pollingInterval() {
	    return this._pollingInterval;
	  }

	  set pollingInterval(value) {
	    if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) {
	      throw new Error("invalid polling interval");
	    }

	    this._pollingInterval = value;

	    if (this._poller) {
	      clearInterval(this._poller);
	      this._poller = setInterval(() => {
	        this.poll();
	      }, this._pollingInterval);
	    }
	  }

	  _getFastBlockNumber() {
	    const now = getTime(); // Stale block number, request a newer value

	    if (now - this._fastQueryDate > 2 * this._pollingInterval) {
	      this._fastQueryDate = now;
	      this._fastBlockNumberPromise = this.getBlockNumber().then(blockNumber => {
	        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
	          this._fastBlockNumber = blockNumber;
	        }

	        return this._fastBlockNumber;
	      });
	    }

	    return this._fastBlockNumberPromise;
	  }

	  _setFastBlockNumber(blockNumber) {
	    // Older block, maybe a stale request
	    if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) {
	      return;
	    } // Update the time we updated the blocknumber


	    this._fastQueryDate = getTime(); // Newer block number, use  it

	    if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
	      this._fastBlockNumber = blockNumber;
	      this._fastBlockNumberPromise = Promise.resolve(blockNumber);
	    }
	  }

	  waitForTransaction(transactionHash, confirmations, timeout) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
	    });
	  }

	  _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const receipt = yield this.getTransactionReceipt(transactionHash); // Receipt is already good

	      if ((receipt ? receipt.confirmations : 0) >= confirmations) {
	        return receipt;
	      } // Poll until the receipt is good...


	      return new Promise((resolve, reject) => {
	        const cancelFuncs = [];
	        let done = false;

	        const alreadyDone = function () {
	          if (done) {
	            return true;
	          }

	          done = true;
	          cancelFuncs.forEach(func => {
	            func();
	          });
	          return false;
	        };

	        const minedHandler = receipt => {
	          if (receipt.confirmations < confirmations) {
	            return;
	          }

	          if (alreadyDone()) {
	            return;
	          }

	          resolve(receipt);
	        };

	        this.on(transactionHash, minedHandler);
	        cancelFuncs.push(() => {
	          this.removeListener(transactionHash, minedHandler);
	        });

	        if (replaceable) {
	          let lastBlockNumber = replaceable.startBlock;
	          let scannedBlock = null;

	          const replaceHandler = blockNumber => __awaiter$1(this, void 0, void 0, function* () {
	            if (done) {
	              return;
	            } // Wait 1 second; this is only used in the case of a fault, so
	            // we will trade off a little bit of latency for more consistent
	            // results and fewer JSON-RPC calls


	            yield stall(1000);
	            this.getTransactionCount(replaceable.from).then(nonce => __awaiter$1(this, void 0, void 0, function* () {
	              if (done) {
	                return;
	              }

	              if (nonce <= replaceable.nonce) {
	                lastBlockNumber = blockNumber;
	              } else {
	                // First check if the transaction was mined
	                {
	                  const mined = yield this.getTransaction(transactionHash);

	                  if (mined && mined.blockNumber != null) {
	                    return;
	                  }
	                } // First time scanning. We start a little earlier for some
	                // wiggle room here to handle the eventually consistent nature
	                // of blockchain (e.g. the getTransactionCount was for a
	                // different block)

	                if (scannedBlock == null) {
	                  scannedBlock = lastBlockNumber - 3;

	                  if (scannedBlock < replaceable.startBlock) {
	                    scannedBlock = replaceable.startBlock;
	                  }
	                }

	                while (scannedBlock <= blockNumber) {
	                  if (done) {
	                    return;
	                  }

	                  const block = yield this.getBlockWithTransactions(scannedBlock);

	                  for (let ti = 0; ti < block.transactions.length; ti++) {
	                    const tx = block.transactions[ti]; // Successfully mined!

	                    if (tx.hash === transactionHash) {
	                      return;
	                    } // Matches our transaction from and nonce; its a replacement


	                    if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
	                      if (done) {
	                        return;
	                      } // Get the receipt of the replacement


	                      const receipt = yield this.waitForTransaction(tx.hash, confirmations); // Already resolved or rejected (prolly a timeout)

	                      if (alreadyDone()) {
	                        return;
	                      } // The reason we were replaced


	                      let reason = "replaced";

	                      if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) {
	                        reason = "repriced";
	                      } else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) {
	                        reason = "cancelled";
	                      } // Explain why we were replaced


	                      reject(logger$2.makeError("transaction was replaced", Logger.errors.TRANSACTION_REPLACED, {
	                        cancelled: reason === "replaced" || reason === "cancelled",
	                        reason,
	                        replacement: this._wrapTransaction(tx),
	                        hash: transactionHash,
	                        receipt
	                      }));
	                      return;
	                    }
	                  }

	                  scannedBlock++;
	                }
	              }

	              if (done) {
	                return;
	              }

	              this.once("block", replaceHandler);
	            }), error => {
	              if (done) {
	                return;
	              }

	              this.once("block", replaceHandler);
	            });
	          });

	          if (done) {
	            return;
	          }

	          this.once("block", replaceHandler);
	          cancelFuncs.push(() => {
	            this.removeListener("block", replaceHandler);
	          });
	        }

	        if (typeof timeout === "number" && timeout > 0) {
	          const timer = setTimeout(() => {
	            if (alreadyDone()) {
	              return;
	            }

	            reject(logger$2.makeError("timeout exceeded", Logger.errors.TIMEOUT, {
	              timeout: timeout
	            }));
	          }, timeout);

	          if (timer.unref) {
	            timer.unref();
	          }

	          cancelFuncs.push(() => {
	            clearTimeout(timer);
	          });
	        }
	      });
	    });
	  }

	  getBlockNumber() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      return this._getInternalBlockNumber(0);
	    });
	  }

	  getGasPrice() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const result = yield this.perform("getGasPrice", {});

	      try {
	        return BigNumber.from(result);
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "getGasPrice",
	          result,
	          error
	        });
	      }
	    });
	  }

	  getBalance(addressOrName, blockTag) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const params = yield resolveProperties({
	        address: this._getAddress(addressOrName),
	        blockTag: this._getBlockTag(blockTag)
	      });
	      const result = yield this.perform("getBalance", params);

	      try {
	        return BigNumber.from(result);
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "getBalance",
	          params,
	          result,
	          error
	        });
	      }
	    });
	  }

	  getTransactionCount(addressOrName, blockTag) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const params = yield resolveProperties({
	        address: this._getAddress(addressOrName),
	        blockTag: this._getBlockTag(blockTag)
	      });
	      const result = yield this.perform("getTransactionCount", params);

	      try {
	        return BigNumber.from(result).toNumber();
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "getTransactionCount",
	          params,
	          result,
	          error
	        });
	      }
	    });
	  }

	  getCode(addressOrName, blockTag) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const params = yield resolveProperties({
	        address: this._getAddress(addressOrName),
	        blockTag: this._getBlockTag(blockTag)
	      });
	      const result = yield this.perform("getCode", params);

	      try {
	        return hexlify(result);
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "getCode",
	          params,
	          result,
	          error
	        });
	      }
	    });
	  }

	  getStorageAt(addressOrName, position, blockTag) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const params = yield resolveProperties({
	        address: this._getAddress(addressOrName),
	        blockTag: this._getBlockTag(blockTag),
	        position: Promise.resolve(position).then(p => hexValue(p))
	      });
	      const result = yield this.perform("getStorageAt", params);

	      try {
	        return hexlify(result);
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "getStorageAt",
	          params,
	          result,
	          error
	        });
	      }
	    });
	  } // This should be called by any subclass wrapping a TransactionResponse


	  _wrapTransaction(tx, hash, startBlock) {
	    if (hash != null && hexDataLength(hash) !== 32) {
	      throw new Error("invalid response - sendTransaction");
	    }

	    const result = tx; // Check the hash we expect is the same as the hash the server reported

	    if (hash != null && tx.hash !== hash) {
	      logger$2.throwError("Transaction hash mismatch from Provider.sendTransaction.", Logger.errors.UNKNOWN_ERROR, {
	        expectedHash: tx.hash,
	        returnedHash: hash
	      });
	    }

	    result.wait = (confirms, timeout) => __awaiter$1(this, void 0, void 0, function* () {
	      if (confirms == null) {
	        confirms = 1;
	      }

	      if (timeout == null) {
	        timeout = 0;
	      } // Get the details to detect replacement


	      let replacement = undefined;

	      if (confirms !== 0 && startBlock != null) {
	        replacement = {
	          data: tx.data,
	          from: tx.from,
	          nonce: tx.nonce,
	          to: tx.to,
	          value: tx.value,
	          startBlock
	        };
	      }

	      const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);

	      if (receipt == null && confirms === 0) {
	        return null;
	      } // No longer pending, allow the polling loop to garbage collect this


	      this._emitted["t:" + tx.hash] = receipt.blockNumber;

	      if (receipt.status === 0) {
	        logger$2.throwError("transaction failed", Logger.errors.CALL_EXCEPTION, {
	          transactionHash: tx.hash,
	          transaction: tx,
	          receipt: receipt
	        });
	      }

	      return receipt;
	    });

	    return result;
	  }

	  sendTransaction(signedTransaction) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const hexTx = yield Promise.resolve(signedTransaction).then(t => hexlify(t));
	      const tx = this.formatter.transaction(signedTransaction);

	      if (tx.confirmations == null) {
	        tx.confirmations = 0;
	      }

	      const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);

	      try {
	        const hash = yield this.perform("sendTransaction", {
	          signedTransaction: hexTx
	        });
	        return this._wrapTransaction(tx, hash, blockNumber);
	      } catch (error) {
	        error.transaction = tx;
	        error.transactionHash = tx.hash;
	        throw error;
	      }
	    });
	  }

	  _getTransactionRequest(transaction) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const values = yield transaction;
	      const tx = {};
	      ["from", "to"].forEach(key => {
	        if (values[key] == null) {
	          return;
	        }

	        tx[key] = Promise.resolve(values[key]).then(v => v ? this._getAddress(v) : null);
	      });
	      ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach(key => {
	        if (values[key] == null) {
	          return;
	        }

	        tx[key] = Promise.resolve(values[key]).then(v => v ? BigNumber.from(v) : null);
	      });
	      ["type"].forEach(key => {
	        if (values[key] == null) {
	          return;
	        }

	        tx[key] = Promise.resolve(values[key]).then(v => v != null ? v : null);
	      });

	      if (values.accessList) {
	        tx.accessList = this.formatter.accessList(values.accessList);
	      }

	      ["data"].forEach(key => {
	        if (values[key] == null) {
	          return;
	        }

	        tx[key] = Promise.resolve(values[key]).then(v => v ? hexlify(v) : null);
	      });
	      return this.formatter.transactionRequest(yield resolveProperties(tx));
	    });
	  }

	  _getFilter(filter) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      filter = yield filter;
	      const result = {};

	      if (filter.address != null) {
	        result.address = this._getAddress(filter.address);
	      }

	      ["blockHash", "topics"].forEach(key => {
	        if (filter[key] == null) {
	          return;
	        }

	        result[key] = filter[key];
	      });
	      ["fromBlock", "toBlock"].forEach(key => {
	        if (filter[key] == null) {
	          return;
	        }

	        result[key] = this._getBlockTag(filter[key]);
	      });
	      return this.formatter.filter(yield resolveProperties(result));
	    });
	  }

	  _call(transaction, blockTag, attempt) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (attempt >= MAX_CCIP_REDIRECTS) {
	        logger$2.throwError("CCIP read exceeded maximum redirections", Logger.errors.SERVER_ERROR, {
	          redirects: attempt,
	          transaction
	        });
	      }

	      const txSender = transaction.to;
	      const result = yield this.perform("call", {
	        transaction,
	        blockTag
	      }); // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)

	      if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && hexDataLength(result) % 32 === 4) {
	        try {
	          const data = hexDataSlice(result, 4); // Check the sender of the OffchainLookup matches the transaction

	          const sender = hexDataSlice(data, 0, 32);

	          if (!BigNumber.from(sender).eq(txSender)) {
	            logger$2.throwError("CCIP Read sender did not match", Logger.errors.CALL_EXCEPTION, {
	              name: "OffchainLookup",
	              signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
	              transaction,
	              data: result
	            });
	          } // Read the URLs from the response


	          const urls = [];
	          const urlsOffset = BigNumber.from(hexDataSlice(data, 32, 64)).toNumber();
	          const urlsLength = BigNumber.from(hexDataSlice(data, urlsOffset, urlsOffset + 32)).toNumber();
	          const urlsData = hexDataSlice(data, urlsOffset + 32);

	          for (let u = 0; u < urlsLength; u++) {
	            const url = _parseString(urlsData, u * 32);

	            if (url == null) {
	              logger$2.throwError("CCIP Read contained corrupt URL string", Logger.errors.CALL_EXCEPTION, {
	                name: "OffchainLookup",
	                signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
	                transaction,
	                data: result
	              });
	            }

	            urls.push(url);
	          } // Get the CCIP calldata to forward


	          const calldata = _parseBytes(data, 64); // Get the callbackSelector (bytes4)


	          if (!BigNumber.from(hexDataSlice(data, 100, 128)).isZero()) {
	            logger$2.throwError("CCIP Read callback selector included junk", Logger.errors.CALL_EXCEPTION, {
	              name: "OffchainLookup",
	              signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
	              transaction,
	              data: result
	            });
	          }

	          const callbackSelector = hexDataSlice(data, 96, 100); // Get the extra data to send back to the contract as context

	          const extraData = _parseBytes(data, 128);

	          const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);

	          if (ccipResult == null) {
	            logger$2.throwError("CCIP Read disabled or provided no URLs", Logger.errors.CALL_EXCEPTION, {
	              name: "OffchainLookup",
	              signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
	              transaction,
	              data: result
	            });
	          }

	          const tx = {
	            to: txSender,
	            data: hexConcat([callbackSelector, encodeBytes([ccipResult, extraData])])
	          };
	          return this._call(tx, blockTag, attempt + 1);
	        } catch (error) {
	          if (error.code === Logger.errors.SERVER_ERROR) {
	            throw error;
	          }
	        }
	      }

	      try {
	        return hexlify(result);
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "call",
	          params: {
	            transaction,
	            blockTag
	          },
	          result,
	          error
	        });
	      }
	    });
	  }

	  call(transaction, blockTag) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const resolved = yield resolveProperties({
	        transaction: this._getTransactionRequest(transaction),
	        blockTag: this._getBlockTag(blockTag),
	        ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
	      });
	      return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
	    });
	  }

	  estimateGas(transaction) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const params = yield resolveProperties({
	        transaction: this._getTransactionRequest(transaction)
	      });
	      const result = yield this.perform("estimateGas", params);

	      try {
	        return BigNumber.from(result);
	      } catch (error) {
	        return logger$2.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
	          method: "estimateGas",
	          params,
	          result,
	          error
	        });
	      }
	    });
	  }

	  _getAddress(addressOrName) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      addressOrName = yield addressOrName;

	      if (typeof addressOrName !== "string") {
	        logger$2.throwArgumentError("invalid address or ENS name", "name", addressOrName);
	      }

	      const address = yield this.resolveName(addressOrName);

	      if (address == null) {
	        logger$2.throwError("ENS name not configured", Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: `resolveName(${JSON.stringify(addressOrName)})`
	        });
	      }

	      return address;
	    });
	  }

	  _getBlock(blockHashOrBlockTag, includeTransactions) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      blockHashOrBlockTag = yield blockHashOrBlockTag; // If blockTag is a number (not "latest", etc), this is the block number

	      let blockNumber = -128;
	      const params = {
	        includeTransactions: !!includeTransactions
	      };

	      if (isHexString(blockHashOrBlockTag, 32)) {
	        params.blockHash = blockHashOrBlockTag;
	      } else {
	        try {
	          params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);

	          if (isHexString(params.blockTag)) {
	            blockNumber = parseInt(params.blockTag.substring(2), 16);
	          }
	        } catch (error) {
	          logger$2.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
	        }
	      }

	      return poll(() => __awaiter$1(this, void 0, void 0, function* () {
	        const block = yield this.perform("getBlock", params); // Block was not found

	        if (block == null) {
	          // For blockhashes, if we didn't say it existed, that blockhash may
	          // not exist. If we did see it though, perhaps from a log, we know
	          // it exists, and this node is just not caught up yet.
	          if (params.blockHash != null) {
	            if (this._emitted["b:" + params.blockHash] == null) {
	              return null;
	            }
	          } // For block tags, if we are asking for a future block, we return null


	          if (params.blockTag != null) {
	            if (blockNumber > this._emitted.block) {
	              return null;
	            }
	          } // Retry on the next block


	          return undefined;
	        } // Add transactions


	        if (includeTransactions) {
	          let blockNumber = null;

	          for (let i = 0; i < block.transactions.length; i++) {
	            const tx = block.transactions[i];

	            if (tx.blockNumber == null) {
	              tx.confirmations = 0;
	            } else if (tx.confirmations == null) {
	              if (blockNumber == null) {
	                blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
	              } // Add the confirmations using the fast block number (pessimistic)


	              let confirmations = blockNumber - tx.blockNumber + 1;

	              if (confirmations <= 0) {
	                confirmations = 1;
	              }

	              tx.confirmations = confirmations;
	            }
	          }

	          const blockWithTxs = this.formatter.blockWithTransactions(block);
	          blockWithTxs.transactions = blockWithTxs.transactions.map(tx => this._wrapTransaction(tx));
	          return blockWithTxs;
	        }

	        return this.formatter.block(block);
	      }), {
	        oncePoll: this
	      });
	    });
	  }

	  getBlock(blockHashOrBlockTag) {
	    return this._getBlock(blockHashOrBlockTag, false);
	  }

	  getBlockWithTransactions(blockHashOrBlockTag) {
	    return this._getBlock(blockHashOrBlockTag, true);
	  }

	  getTransaction(transactionHash) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      transactionHash = yield transactionHash;
	      const params = {
	        transactionHash: this.formatter.hash(transactionHash, true)
	      };
	      return poll(() => __awaiter$1(this, void 0, void 0, function* () {
	        const result = yield this.perform("getTransaction", params);

	        if (result == null) {
	          if (this._emitted["t:" + transactionHash] == null) {
	            return null;
	          }

	          return undefined;
	        }

	        const tx = this.formatter.transactionResponse(result);

	        if (tx.blockNumber == null) {
	          tx.confirmations = 0;
	        } else if (tx.confirmations == null) {
	          const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval); // Add the confirmations using the fast block number (pessimistic)

	          let confirmations = blockNumber - tx.blockNumber + 1;

	          if (confirmations <= 0) {
	            confirmations = 1;
	          }

	          tx.confirmations = confirmations;
	        }

	        return this._wrapTransaction(tx);
	      }), {
	        oncePoll: this
	      });
	    });
	  }

	  getTransactionReceipt(transactionHash) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      transactionHash = yield transactionHash;
	      const params = {
	        transactionHash: this.formatter.hash(transactionHash, true)
	      };
	      return poll(() => __awaiter$1(this, void 0, void 0, function* () {
	        const result = yield this.perform("getTransactionReceipt", params);

	        if (result == null) {
	          if (this._emitted["t:" + transactionHash] == null) {
	            return null;
	          }

	          return undefined;
	        } // "geth-etc" returns receipts before they are ready


	        if (result.blockHash == null) {
	          return undefined;
	        }

	        const receipt = this.formatter.receipt(result);

	        if (receipt.blockNumber == null) {
	          receipt.confirmations = 0;
	        } else if (receipt.confirmations == null) {
	          const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval); // Add the confirmations using the fast block number (pessimistic)

	          let confirmations = blockNumber - receipt.blockNumber + 1;

	          if (confirmations <= 0) {
	            confirmations = 1;
	          }

	          receipt.confirmations = confirmations;
	        }

	        return receipt;
	      }), {
	        oncePoll: this
	      });
	    });
	  }

	  getLogs(filter) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      const params = yield resolveProperties({
	        filter: this._getFilter(filter)
	      });
	      const logs = yield this.perform("getLogs", params);
	      logs.forEach(log => {
	        if (log.removed == null) {
	          log.removed = false;
	        }
	      });
	      return Formatter.arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
	    });
	  }

	  getEtherPrice() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      yield this.getNetwork();
	      return this.perform("getEtherPrice", {});
	    });
	  }

	  _getBlockTag(blockTag) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      blockTag = yield blockTag;

	      if (typeof blockTag === "number" && blockTag < 0) {
	        if (blockTag % 1) {
	          logger$2.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
	        }

	        let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
	        blockNumber += blockTag;

	        if (blockNumber < 0) {
	          blockNumber = 0;
	        }

	        return this.formatter.blockTag(blockNumber);
	      }

	      return this.formatter.blockTag(blockTag);
	    });
	  }

	  getResolver(name) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      let currentName = name;

	      while (true) {
	        if (currentName === "" || currentName === ".") {
	          return null;
	        } // Optimization since the eth node cannot change and does
	        // not have a wildcard resolver


	        if (name !== "eth" && currentName === "eth") {
	          return null;
	        } // Check the current node for a resolver


	        const addr = yield this._getResolver(currentName, "getResolver"); // Found a resolver!

	        if (addr != null) {
	          const resolver = new Resolver(this, addr, name); // Legacy resolver found, using EIP-2544 so it isn't safe to use

	          if (currentName !== name && !(yield resolver.supportsWildcard())) {
	            return null;
	          }

	          return resolver;
	        } // Get the parent node


	        currentName = currentName.split(".").slice(1).join(".");
	      }
	    });
	  }

	  _getResolver(name, operation) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (operation == null) {
	        operation = "ENS";
	      }

	      const network = yield this.getNetwork(); // No ENS...

	      if (!network.ensAddress) {
	        logger$2.throwError("network does not support ENS", Logger.errors.UNSUPPORTED_OPERATION, {
	          operation,
	          network: network.name
	        });
	      }

	      try {
	        // keccak256("resolver(bytes32)")
	        const addrData = yield this.call({
	          to: network.ensAddress,
	          data: "0x0178b8bf" + namehash(name).substring(2)
	        });
	        return this.formatter.callAddress(addrData);
	      } catch (error) {// ENS registry cannot throw errors on resolver(bytes32)
	      }

	      return null;
	    });
	  }

	  resolveName(name) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      name = yield name; // If it is already an address, nothing to resolve

	      try {
	        return Promise.resolve(this.formatter.address(name));
	      } catch (error) {
	        // If is is a hexstring, the address is bad (See #694)
	        if (isHexString(name)) {
	          throw error;
	        }
	      }

	      if (typeof name !== "string") {
	        logger$2.throwArgumentError("invalid ENS name", "name", name);
	      } // Get the addr from the resolver


	      const resolver = yield this.getResolver(name);

	      if (!resolver) {
	        return null;
	      }

	      return yield resolver.getAddress();
	    });
	  }

	  lookupAddress(address) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      address = yield address;
	      address = this.formatter.address(address);
	      const node = address.substring(2).toLowerCase() + ".addr.reverse";
	      const resolverAddr = yield this._getResolver(node, "lookupAddress");

	      if (resolverAddr == null) {
	        return null;
	      } // keccak("name(bytes32)")


	      const name = _parseString(yield this.call({
	        to: resolverAddr,
	        data: "0x691f3431" + namehash(node).substring(2)
	      }), 0);

	      const addr = yield this.resolveName(name);

	      if (addr != address) {
	        return null;
	      }

	      return name;
	    });
	  }

	  getAvatar(nameOrAddress) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      let resolver = null;

	      if (isHexString(nameOrAddress)) {
	        // Address; reverse lookup
	        const address = this.formatter.address(nameOrAddress);
	        const node = address.substring(2).toLowerCase() + ".addr.reverse";
	        const resolverAddress = yield this._getResolver(node, "getAvatar");

	        if (!resolverAddress) {
	          return null;
	        } // Try resolving the avatar against the addr.reverse resolver


	        resolver = new Resolver(this, resolverAddress, node);

	        try {
	          const avatar = yield resolver.getAvatar();

	          if (avatar) {
	            return avatar.url;
	          }
	        } catch (error) {
	          if (error.code !== Logger.errors.CALL_EXCEPTION) {
	            throw error;
	          }
	        } // Try getting the name and performing forward lookup; allowing wildcards


	        try {
	          // keccak("name(bytes32)")
	          const name = _parseString(yield this.call({
	            to: resolverAddress,
	            data: "0x691f3431" + namehash(node).substring(2)
	          }), 0);

	          resolver = yield this.getResolver(name);
	        } catch (error) {
	          if (error.code !== Logger.errors.CALL_EXCEPTION) {
	            throw error;
	          }

	          return null;
	        }
	      } else {
	        // ENS name; forward lookup with wildcard
	        resolver = yield this.getResolver(nameOrAddress);

	        if (!resolver) {
	          return null;
	        }
	      }

	      const avatar = yield resolver.getAvatar();

	      if (avatar == null) {
	        return null;
	      }

	      return avatar.url;
	    });
	  }

	  perform(method, params) {
	    return logger$2.throwError(method + " not implemented", Logger.errors.NOT_IMPLEMENTED, {
	      operation: method
	    });
	  }

	  _startEvent(event) {
	    this.polling = this._events.filter(e => e.pollable()).length > 0;
	  }

	  _stopEvent(event) {
	    this.polling = this._events.filter(e => e.pollable()).length > 0;
	  }

	  _addEventListener(eventName, listener, once) {
	    const event = new Event$1(getEventTag(eventName), listener, once);

	    this._events.push(event);

	    this._startEvent(event);

	    return this;
	  }

	  on(eventName, listener) {
	    return this._addEventListener(eventName, listener, false);
	  }

	  once(eventName, listener) {
	    return this._addEventListener(eventName, listener, true);
	  }

	  emit(eventName, ...args) {
	    let result = false;
	    let stopped = [];
	    let eventTag = getEventTag(eventName);
	    this._events = this._events.filter(event => {
	      if (event.tag !== eventTag) {
	        return true;
	      }

	      setTimeout(() => {
	        event.listener.apply(this, args);
	      }, 0);
	      result = true;

	      if (event.once) {
	        stopped.push(event);
	        return false;
	      }

	      return true;
	    });
	    stopped.forEach(event => {
	      this._stopEvent(event);
	    });
	    return result;
	  }

	  listenerCount(eventName) {
	    if (!eventName) {
	      return this._events.length;
	    }

	    let eventTag = getEventTag(eventName);
	    return this._events.filter(event => {
	      return event.tag === eventTag;
	    }).length;
	  }

	  listeners(eventName) {
	    if (eventName == null) {
	      return this._events.map(event => event.listener);
	    }

	    let eventTag = getEventTag(eventName);
	    return this._events.filter(event => event.tag === eventTag).map(event => event.listener);
	  }

	  off(eventName, listener) {
	    if (listener == null) {
	      return this.removeAllListeners(eventName);
	    }

	    const stopped = [];
	    let found = false;
	    let eventTag = getEventTag(eventName);
	    this._events = this._events.filter(event => {
	      if (event.tag !== eventTag || event.listener != listener) {
	        return true;
	      }

	      if (found) {
	        return true;
	      }

	      found = true;
	      stopped.push(event);
	      return false;
	    });
	    stopped.forEach(event => {
	      this._stopEvent(event);
	    });
	    return this;
	  }

	  removeAllListeners(eventName) {
	    let stopped = [];

	    if (eventName == null) {
	      stopped = this._events;
	      this._events = [];
	    } else {
	      const eventTag = getEventTag(eventName);
	      this._events = this._events.filter(event => {
	        if (event.tag !== eventTag) {
	          return true;
	        }

	        stopped.push(event);
	        return false;
	      });
	    }

	    stopped.forEach(event => {
	      this._stopEvent(event);
	    });
	    return this;
	  }

	}

	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	const logger$1 = new Logger(version$1);
	const errorGas = ["call", "estimateGas"];

	function spelunk(value, requireData) {
	  if (value == null) {
	    return null;
	  } // These *are* the droids we're looking for.


	  if (typeof value.message === "string" && value.message.match("reverted")) {
	    const data = isHexString(value.data) ? value.data : null;

	    if (!requireData || data) {
	      return {
	        message: value.message,
	        data
	      };
	    }
	  } // Spelunk further...


	  if (typeof value === "object") {
	    for (const key in value) {
	      const result = spelunk(value[key], requireData);

	      if (result) {
	        return result;
	      }
	    }

	    return null;
	  } // Might be a JSON string we can further descend...


	  if (typeof value === "string") {
	    try {
	      return spelunk(JSON.parse(value), requireData);
	    } catch (error) {}
	  }

	  return null;
	}

	function checkError(method, error, params) {
	  const transaction = params.transaction || params.signedTransaction; // Undo the "convenience" some nodes are attempting to prevent backwards
	  // incompatibility; maybe for v6 consider forwarding reverts as errors

	  if (method === "call") {
	    const result = spelunk(error, true);

	    if (result) {
	      return result.data;
	    } // Nothing descriptive..


	    logger$1.throwError("missing revert data in call exception; Transaction reverted without a reason string", Logger.errors.CALL_EXCEPTION, {
	      data: "0x",
	      transaction,
	      error
	    });
	  }

	  if (method === "estimateGas") {
	    // Try to find something, with a preference on SERVER_ERROR body
	    let result = spelunk(error.body, false);

	    if (result == null) {
	      result = spelunk(error, false);
	    } // Found "reverted", this is a CALL_EXCEPTION


	    if (result) {
	      logger$1.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
	        reason: result.message,
	        method,
	        transaction,
	        error
	      });
	    }
	  } // @TODO: Should we spelunk for message too?


	  let message = error.message;

	  if (error.code === Logger.errors.SERVER_ERROR && error.error && typeof error.error.message === "string") {
	    message = error.error.message;
	  } else if (typeof error.body === "string") {
	    message = error.body;
	  } else if (typeof error.responseText === "string") {
	    message = error.responseText;
	  }

	  message = (message || "").toLowerCase(); // "insufficient funds for gas * price + value + cost(data)"

	  if (message.match(/insufficient funds|base fee exceeds gas limit/i)) {
	    logger$1.throwError("insufficient funds for intrinsic transaction cost", Logger.errors.INSUFFICIENT_FUNDS, {
	      error,
	      method,
	      transaction
	    });
	  } // "nonce too low"


	  if (message.match(/nonce (is )?too low/i)) {
	    logger$1.throwError("nonce has already been used", Logger.errors.NONCE_EXPIRED, {
	      error,
	      method,
	      transaction
	    });
	  } // "replacement transaction underpriced"


	  if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) {
	    logger$1.throwError("replacement fee too low", Logger.errors.REPLACEMENT_UNDERPRICED, {
	      error,
	      method,
	      transaction
	    });
	  } // "replacement transaction underpriced"


	  if (message.match(/only replay-protected/i)) {
	    logger$1.throwError("legacy pre-eip-155 transactions not supported", Logger.errors.UNSUPPORTED_OPERATION, {
	      error,
	      method,
	      transaction
	    });
	  }

	  if (errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted/)) {
	    logger$1.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
	      error,
	      method,
	      transaction
	    });
	  }

	  throw error;
	}

	function timer(timeout) {
	  return new Promise(function (resolve) {
	    setTimeout(resolve, timeout);
	  });
	}

	function getResult(payload) {
	  if (payload.error) {
	    // @TODO: not any
	    const error = new Error(payload.error.message);
	    error.code = payload.error.code;
	    error.data = payload.error.data;
	    throw error;
	  }

	  return payload.result;
	}

	function getLowerCase(value) {
	  if (value) {
	    return value.toLowerCase();
	  }

	  return value;
	}

	const _constructorGuard = {};
	class JsonRpcSigner extends Signer {
	  constructor(constructorGuard, provider, addressOrIndex) {
	    super();

	    if (constructorGuard !== _constructorGuard) {
	      throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
	    }

	    defineReadOnly(this, "provider", provider);

	    if (addressOrIndex == null) {
	      addressOrIndex = 0;
	    }

	    if (typeof addressOrIndex === "string") {
	      defineReadOnly(this, "_address", this.provider.formatter.address(addressOrIndex));
	      defineReadOnly(this, "_index", null);
	    } else if (typeof addressOrIndex === "number") {
	      defineReadOnly(this, "_index", addressOrIndex);
	      defineReadOnly(this, "_address", null);
	    } else {
	      logger$1.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
	    }
	  }

	  connect(provider) {
	    return logger$1.throwError("cannot alter JSON-RPC Signer connection", Logger.errors.UNSUPPORTED_OPERATION, {
	      operation: "connect"
	    });
	  }

	  connectUnchecked() {
	    return new UncheckedJsonRpcSigner(_constructorGuard, this.provider, this._address || this._index);
	  }

	  getAddress() {
	    if (this._address) {
	      return Promise.resolve(this._address);
	    }

	    return this.provider.send("eth_accounts", []).then(accounts => {
	      if (accounts.length <= this._index) {
	        logger$1.throwError("unknown account #" + this._index, Logger.errors.UNSUPPORTED_OPERATION, {
	          operation: "getAddress"
	        });
	      }

	      return this.provider.formatter.address(accounts[this._index]);
	    });
	  }

	  sendUncheckedTransaction(transaction) {
	    transaction = shallowCopy(transaction);
	    const fromAddress = this.getAddress().then(address => {
	      if (address) {
	        address = address.toLowerCase();
	      }

	      return address;
	    }); // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
	    // wishes to use this, it is easy to specify explicitly, otherwise
	    // we look it up for them.

	    if (transaction.gasLimit == null) {
	      const estimate = shallowCopy(transaction);
	      estimate.from = fromAddress;
	      transaction.gasLimit = this.provider.estimateGas(estimate);
	    }

	    if (transaction.to != null) {
	      transaction.to = Promise.resolve(transaction.to).then(to => __awaiter(this, void 0, void 0, function* () {
	        if (to == null) {
	          return null;
	        }

	        const address = yield this.provider.resolveName(to);

	        if (address == null) {
	          logger$1.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
	        }

	        return address;
	      }));
	    }

	    return resolveProperties({
	      tx: resolveProperties(transaction),
	      sender: fromAddress
	    }).then(({
	      tx,
	      sender
	    }) => {
	      if (tx.from != null) {
	        if (tx.from.toLowerCase() !== sender) {
	          logger$1.throwArgumentError("from address mismatch", "transaction", transaction);
	        }
	      } else {
	        tx.from = sender;
	      }

	      const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
	        from: true
	      });
	      return this.provider.send("eth_sendTransaction", [hexTx]).then(hash => {
	        return hash;
	      }, error => {
	        if (typeof error.message === "string" && error.message.match(/user denied/i)) {
	          logger$1.throwError("user rejected transaction", Logger.errors.ACTION_REJECTED, {
	            action: "sendTransaction",
	            transaction: tx
	          });
	        }

	        return checkError("sendTransaction", error, hexTx);
	      });
	    });
	  }

	  signTransaction(transaction) {
	    return logger$1.throwError("signing transactions is unsupported", Logger.errors.UNSUPPORTED_OPERATION, {
	      operation: "signTransaction"
	    });
	  }

	  sendTransaction(transaction) {
	    return __awaiter(this, void 0, void 0, function* () {
	      // This cannot be mined any earlier than any recent block
	      const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval); // Send the transaction

	      const hash = yield this.sendUncheckedTransaction(transaction);

	      try {
	        // Unfortunately, JSON-RPC only provides and opaque transaction hash
	        // for a response, and we need the actual transaction, so we poll
	        // for it; it should show up very quickly
	        return yield poll(() => __awaiter(this, void 0, void 0, function* () {
	          const tx = yield this.provider.getTransaction(hash);

	          if (tx === null) {
	            return undefined;
	          }

	          return this.provider._wrapTransaction(tx, hash, blockNumber);
	        }), {
	          oncePoll: this.provider
	        });
	      } catch (error) {
	        error.transactionHash = hash;
	        throw error;
	      }
	    });
	  }

	  signMessage(message) {
	    return __awaiter(this, void 0, void 0, function* () {
	      const data = typeof message === "string" ? toUtf8Bytes(message) : message;
	      const address = yield this.getAddress();

	      try {
	        return yield this.provider.send("personal_sign", [hexlify(data), address.toLowerCase()]);
	      } catch (error) {
	        if (typeof error.message === "string" && error.message.match(/user denied/i)) {
	          logger$1.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
	            action: "signMessage",
	            from: address,
	            message: data
	          });
	        }

	        throw error;
	      }
	    });
	  }

	  _legacySignMessage(message) {
	    return __awaiter(this, void 0, void 0, function* () {
	      const data = typeof message === "string" ? toUtf8Bytes(message) : message;
	      const address = yield this.getAddress();

	      try {
	        // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
	        return yield this.provider.send("eth_sign", [address.toLowerCase(), hexlify(data)]);
	      } catch (error) {
	        if (typeof error.message === "string" && error.message.match(/user denied/i)) {
	          logger$1.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
	            action: "_legacySignMessage",
	            from: address,
	            message: data
	          });
	        }

	        throw error;
	      }
	    });
	  }

	  _signTypedData(domain, types, value) {
	    return __awaiter(this, void 0, void 0, function* () {
	      // Populate any ENS names (in-place)
	      const populated = yield TypedDataEncoder.resolveNames(domain, types, value, name => {
	        return this.provider.resolveName(name);
	      });
	      const address = yield this.getAddress();

	      try {
	        return yield this.provider.send("eth_signTypedData_v4", [address.toLowerCase(), JSON.stringify(TypedDataEncoder.getPayload(populated.domain, types, populated.value))]);
	      } catch (error) {
	        if (typeof error.message === "string" && error.message.match(/user denied/i)) {
	          logger$1.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
	            action: "_signTypedData",
	            from: address,
	            message: {
	              domain: populated.domain,
	              types,
	              value: populated.value
	            }
	          });
	        }

	        throw error;
	      }
	    });
	  }

	  unlock(password) {
	    return __awaiter(this, void 0, void 0, function* () {
	      const provider = this.provider;
	      const address = yield this.getAddress();
	      return provider.send("personal_unlockAccount", [address.toLowerCase(), password, null]);
	    });
	  }

	}

	class UncheckedJsonRpcSigner extends JsonRpcSigner {
	  sendTransaction(transaction) {
	    return this.sendUncheckedTransaction(transaction).then(hash => {
	      return {
	        hash: hash,
	        nonce: null,
	        gasLimit: null,
	        gasPrice: null,
	        data: null,
	        value: null,
	        chainId: null,
	        confirmations: 0,
	        from: null,
	        wait: confirmations => {
	          return this.provider.waitForTransaction(hash, confirmations);
	        }
	      };
	    });
	  }

	}

	const allowedTransactionKeys = {
	  chainId: true,
	  data: true,
	  gasLimit: true,
	  gasPrice: true,
	  nonce: true,
	  to: true,
	  value: true,
	  type: true,
	  accessList: true,
	  maxFeePerGas: true,
	  maxPriorityFeePerGas: true
	};
	class JsonRpcProvider extends BaseProvider {
	  constructor(url, network) {
	    let networkOrReady = network; // The network is unknown, query the JSON-RPC for it

	    if (networkOrReady == null) {
	      networkOrReady = new Promise((resolve, reject) => {
	        setTimeout(() => {
	          this.detectNetwork().then(network => {
	            resolve(network);
	          }, error => {
	            reject(error);
	          });
	        }, 0);
	      });
	    }

	    super(networkOrReady); // Default URL

	    if (!url) {
	      url = getStatic(this.constructor, "defaultUrl")();
	    }

	    if (typeof url === "string") {
	      defineReadOnly(this, "connection", Object.freeze({
	        url: url
	      }));
	    } else {
	      defineReadOnly(this, "connection", Object.freeze(shallowCopy(url)));
	    }

	    this._nextId = 42;
	  }

	  get _cache() {
	    if (this._eventLoopCache == null) {
	      this._eventLoopCache = {};
	    }

	    return this._eventLoopCache;
	  }

	  static defaultUrl() {
	    return "http:/\/localhost:8545";
	  }

	  detectNetwork() {
	    if (!this._cache["detectNetwork"]) {
	      this._cache["detectNetwork"] = this._uncachedDetectNetwork(); // Clear this cache at the beginning of the next event loop

	      setTimeout(() => {
	        this._cache["detectNetwork"] = null;
	      }, 0);
	    }

	    return this._cache["detectNetwork"];
	  }

	  _uncachedDetectNetwork() {
	    return __awaiter(this, void 0, void 0, function* () {
	      yield timer(0);
	      let chainId = null;

	      try {
	        chainId = yield this.send("eth_chainId", []);
	      } catch (error) {
	        try {
	          chainId = yield this.send("net_version", []);
	        } catch (error) {}
	      }

	      if (chainId != null) {
	        const getNetwork = getStatic(this.constructor, "getNetwork");

	        try {
	          return getNetwork(BigNumber.from(chainId).toNumber());
	        } catch (error) {
	          return logger$1.throwError("could not detect network", Logger.errors.NETWORK_ERROR, {
	            chainId: chainId,
	            event: "invalidNetwork",
	            serverError: error
	          });
	        }
	      }

	      return logger$1.throwError("could not detect network", Logger.errors.NETWORK_ERROR, {
	        event: "noNetwork"
	      });
	    });
	  }

	  getSigner(addressOrIndex) {
	    return new JsonRpcSigner(_constructorGuard, this, addressOrIndex);
	  }

	  getUncheckedSigner(addressOrIndex) {
	    return this.getSigner(addressOrIndex).connectUnchecked();
	  }

	  listAccounts() {
	    return this.send("eth_accounts", []).then(accounts => {
	      return accounts.map(a => this.formatter.address(a));
	    });
	  }

	  send(method, params) {
	    const request = {
	      method: method,
	      params: params,
	      id: this._nextId++,
	      jsonrpc: "2.0"
	    };
	    this.emit("debug", {
	      action: "request",
	      request: deepCopy(request),
	      provider: this
	    }); // We can expand this in the future to any call, but for now these
	    // are the biggest wins and do not require any serializing parameters.

	    const cache = ["eth_chainId", "eth_blockNumber"].indexOf(method) >= 0;

	    if (cache && this._cache[method]) {
	      return this._cache[method];
	    }

	    const result = fetchJson(this.connection, JSON.stringify(request), getResult).then(result => {
	      this.emit("debug", {
	        action: "response",
	        request: request,
	        response: result,
	        provider: this
	      });
	      return result;
	    }, error => {
	      this.emit("debug", {
	        action: "response",
	        error: error,
	        request: request,
	        provider: this
	      });
	      throw error;
	    }); // Cache the fetch, but clear it on the next event loop

	    if (cache) {
	      this._cache[method] = result;
	      setTimeout(() => {
	        this._cache[method] = null;
	      }, 0);
	    }

	    return result;
	  }

	  prepareRequest(method, params) {
	    switch (method) {
	      case "getBlockNumber":
	        return ["eth_blockNumber", []];

	      case "getGasPrice":
	        return ["eth_gasPrice", []];

	      case "getBalance":
	        return ["eth_getBalance", [getLowerCase(params.address), params.blockTag]];

	      case "getTransactionCount":
	        return ["eth_getTransactionCount", [getLowerCase(params.address), params.blockTag]];

	      case "getCode":
	        return ["eth_getCode", [getLowerCase(params.address), params.blockTag]];

	      case "getStorageAt":
	        return ["eth_getStorageAt", [getLowerCase(params.address), hexZeroPad(params.position, 32), params.blockTag]];

	      case "sendTransaction":
	        return ["eth_sendRawTransaction", [params.signedTransaction]];

	      case "getBlock":
	        if (params.blockTag) {
	          return ["eth_getBlockByNumber", [params.blockTag, !!params.includeTransactions]];
	        } else if (params.blockHash) {
	          return ["eth_getBlockByHash", [params.blockHash, !!params.includeTransactions]];
	        }

	        return null;

	      case "getTransaction":
	        return ["eth_getTransactionByHash", [params.transactionHash]];

	      case "getTransactionReceipt":
	        return ["eth_getTransactionReceipt", [params.transactionHash]];

	      case "call":
	        {
	          const hexlifyTransaction = getStatic(this.constructor, "hexlifyTransaction");
	          return ["eth_call", [hexlifyTransaction(params.transaction, {
	            from: true
	          }), params.blockTag]];
	        }

	      case "estimateGas":
	        {
	          const hexlifyTransaction = getStatic(this.constructor, "hexlifyTransaction");
	          return ["eth_estimateGas", [hexlifyTransaction(params.transaction, {
	            from: true
	          })]];
	        }

	      case "getLogs":
	        if (params.filter && params.filter.address != null) {
	          params.filter.address = getLowerCase(params.filter.address);
	        }

	        return ["eth_getLogs", [params.filter]];
	    }

	    return null;
	  }

	  perform(method, params) {
	    return __awaiter(this, void 0, void 0, function* () {
	      // Legacy networks do not like the type field being passed along (which
	      // is fair), so we delete type if it is 0 and a non-EIP-1559 network
	      if (method === "call" || method === "estimateGas") {
	        const tx = params.transaction;

	        if (tx && tx.type != null && BigNumber.from(tx.type).isZero()) {
	          // If there are no EIP-1559 properties, it might be non-EIP-1559
	          if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
	            const feeData = yield this.getFeeData();

	            if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
	              // Network doesn't know about EIP-1559 (and hence type)
	              params = shallowCopy(params);
	              params.transaction = shallowCopy(tx);
	              delete params.transaction.type;
	            }
	          }
	        }
	      }

	      const args = this.prepareRequest(method, params);

	      if (args == null) {
	        logger$1.throwError(method + " not implemented", Logger.errors.NOT_IMPLEMENTED, {
	          operation: method
	        });
	      }

	      try {
	        return yield this.send(args[0], args[1]);
	      } catch (error) {
	        return checkError(method, error, params);
	      }
	    });
	  }

	  _startEvent(event) {
	    if (event.tag === "pending") {
	      this._startPending();
	    }

	    super._startEvent(event);
	  }

	  _startPending() {
	    if (this._pendingFilter != null) {
	      return;
	    }

	    const self = this;
	    const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
	    this._pendingFilter = pendingFilter;
	    pendingFilter.then(function (filterId) {
	      function poll() {
	        self.send("eth_getFilterChanges", [filterId]).then(function (hashes) {
	          if (self._pendingFilter != pendingFilter) {
	            return null;
	          }

	          let seq = Promise.resolve();
	          hashes.forEach(function (hash) {
	            // @TODO: This should be garbage collected at some point... How? When?
	            self._emitted["t:" + hash.toLowerCase()] = "pending";
	            seq = seq.then(function () {
	              return self.getTransaction(hash).then(function (tx) {
	                self.emit("pending", tx);
	                return null;
	              });
	            });
	          });
	          return seq.then(function () {
	            return timer(1000);
	          });
	        }).then(function () {
	          if (self._pendingFilter != pendingFilter) {
	            self.send("eth_uninstallFilter", [filterId]);
	            return;
	          }

	          setTimeout(function () {
	            poll();
	          }, 0);
	          return null;
	        }).catch(error => {});
	      }

	      poll();
	      return filterId;
	    }).catch(error => {});
	  }

	  _stopEvent(event) {
	    if (event.tag === "pending" && this.listenerCount("pending") === 0) {
	      this._pendingFilter = null;
	    }

	    super._stopEvent(event);
	  } // Convert an ethers.js transaction into a JSON-RPC transaction
	  //  - gasLimit => gas
	  //  - All values hexlified
	  //  - All numeric values zero-striped
	  //  - All addresses are lowercased
	  // NOTE: This allows a TransactionRequest, but all values should be resolved
	  //       before this is called
	  // @TODO: This will likely be removed in future versions and prepareRequest
	  //        will be the preferred method for this.


	  static hexlifyTransaction(transaction, allowExtra) {
	    // Check only allowed properties are given
	    const allowed = shallowCopy(allowedTransactionKeys);

	    if (allowExtra) {
	      for (const key in allowExtra) {
	        if (allowExtra[key]) {
	          allowed[key] = true;
	        }
	      }
	    }

	    checkProperties(transaction, allowed);
	    const result = {}; // JSON-RPC now requires numeric values to be "quantity" values

	    ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function (key) {
	      if (transaction[key] == null) {
	        return;
	      }

	      const value = hexValue(BigNumber.from(transaction[key]));

	      if (key === "gasLimit") {
	        key = "gas";
	      }

	      result[key] = value;
	    });
	    ["from", "to", "data"].forEach(function (key) {
	      if (transaction[key] == null) {
	        return;
	      }

	      result[key] = hexlify(transaction[key]);
	    });

	    if (transaction.accessList) {
	      result["accessList"] = accessListify(transaction.accessList);
	    }

	    return result;
	  }

	}

	const logger = new Logger(version$1);
	let _nextId = 1;

	function buildWeb3LegacyFetcher(provider, sendFunc) {
	  const fetcher = "Web3LegacyFetcher";
	  return function (method, params) {
	    const request = {
	      method: method,
	      params: params,
	      id: _nextId++,
	      jsonrpc: "2.0"
	    };
	    return new Promise((resolve, reject) => {
	      this.emit("debug", {
	        action: "request",
	        fetcher,
	        request: deepCopy(request),
	        provider: this
	      });
	      sendFunc(request, (error, response) => {
	        if (error) {
	          this.emit("debug", {
	            action: "response",
	            fetcher,
	            error,
	            request,
	            provider: this
	          });
	          return reject(error);
	        }

	        this.emit("debug", {
	          action: "response",
	          fetcher,
	          request,
	          response,
	          provider: this
	        });

	        if (response.error) {
	          const error = new Error(response.error.message);
	          error.code = response.error.code;
	          error.data = response.error.data;
	          return reject(error);
	        }

	        resolve(response.result);
	      });
	    });
	  };
	}

	function buildEip1193Fetcher(provider) {
	  return function (method, params) {
	    if (params == null) {
	      params = [];
	    }

	    const request = {
	      method,
	      params
	    };
	    this.emit("debug", {
	      action: "request",
	      fetcher: "Eip1193Fetcher",
	      request: deepCopy(request),
	      provider: this
	    });
	    return provider.request(request).then(response => {
	      this.emit("debug", {
	        action: "response",
	        fetcher: "Eip1193Fetcher",
	        request,
	        response,
	        provider: this
	      });
	      return response;
	    }, error => {
	      this.emit("debug", {
	        action: "response",
	        fetcher: "Eip1193Fetcher",
	        request,
	        error,
	        provider: this
	      });
	      throw error;
	    });
	  };
	}

	class Web3Provider extends JsonRpcProvider {
	  constructor(provider, network) {
	    if (provider == null) {
	      logger.throwArgumentError("missing provider", "provider", provider);
	    }

	    let path = null;
	    let jsonRpcFetchFunc = null;
	    let subprovider = null;

	    if (typeof provider === "function") {
	      path = "unknown:";
	      jsonRpcFetchFunc = provider;
	    } else {
	      path = provider.host || provider.path || "";

	      if (!path && provider.isMetaMask) {
	        path = "metamask";
	      }

	      subprovider = provider;

	      if (provider.request) {
	        if (path === "") {
	          path = "eip-1193:";
	        }

	        jsonRpcFetchFunc = buildEip1193Fetcher(provider);
	      } else if (provider.sendAsync) {
	        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
	      } else if (provider.send) {
	        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
	      } else {
	        logger.throwArgumentError("unsupported provider", "provider", provider);
	      }

	      if (!path) {
	        path = "unknown:";
	      }
	    }

	    super(path, network);
	    defineReadOnly(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
	    defineReadOnly(this, "provider", subprovider);
	  }

	  send(method, params) {
	    return this.jsonRpcFetchFunc(method, params);
	  }

	}

	const version = "units/5.7.0";

	new Logger(version);
	const names = ["wei", "kwei", "mwei", "gwei", "szabo", "finney", "ether"]; // Some environments have issues with RegEx that contain back-tracking, so we cannot
	function formatUnits(value, unitName) {
	  if (typeof unitName === "string") {
	    const index = names.indexOf(unitName);

	    if (index !== -1) {
	      unitName = 3 * index;
	    }
	  }

	  return formatFixed(value, unitName != null ? unitName : 18);
	}

	// eslint-disable-next-line es-x/no-object-assign -- safe


	var $assign = Object.assign; // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing

	var defineProperty$2 = Object.defineProperty;
	var concat = functionUncurryThis([].concat); // `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign

	var objectAssign$1 = !$assign || fails(function () {
	  // should have correct order of operations (Edge bug)
	  if (descriptors && $assign({
	    b: 1
	  }, $assign(defineProperty$2({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty$2(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), {
	    b: 2
	  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

	  var A = {};
	  var B = {}; // eslint-disable-next-line es-x/no-symbol -- safe

	  var symbol = Symbol();
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) {
	    B[chr] = chr;
	  });
	  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
	}) ? function assign(target, source) {
	  // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject$1(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  var propertyIsEnumerable = objectPropertyIsEnumerable.f;

	  while (argumentsLength > index) {
	    var S = indexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;

	    while (length > j) {
	      key = keys[j++];
	      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  }

	  return T;
	} : $assign;

	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es-x/no-object-assign -- required for testing


	_export({
	  target: 'Object',
	  stat: true,
	  arity: 2,
	  forced: Object.assign !== objectAssign$1
	}, {
	  assign: objectAssign$1
	});

	var wallet = {
	  address: ""
	};
	var WalletAddressContext = B(wallet.address);

	var config = {
	  production: false,
	  feedbackDetailsMaxEndorsements: 5
	};
	window.addEventListener(EVENT_UTU_CONFIG, function (event) {
	  console.log("UTU SDK received config:", JSON.stringify(event.detail));
	  Object.assign(config, event.detail);
	});
	function getBaseProps(props, componentName) {
	  var apiUrlDefault = config.production ? UTU_API_BASE_URL_PRODUCTION : UTU_API_BASE_URL_TEST;
	  var apiUrl = props[ATTR_API_URL] || undefined || apiUrlDefault;

	  if (!apiUrl) {
	    throw new Error("".concat(ATTR_API_URL, " attribute of ").concat(componentName, " was not set"));
	  }

	  return {
	    apiUrl: apiUrl
	  };
	}
	function getUtuSocialLink() {
	  var socialLinkUrl = config.production ? UTU_SOCIAL_LINK_URL_PRODUCTION : UTU_SOCIAL_LINK_URL_TEST;
	  return {
	    socialLinkUrl: socialLinkUrl
	  };
	}
	function BaseComponent(_ref) {
	  var children = _ref.children,
	      forwardedRef = _ref.forwardedRef,
	      className = _ref.className,
	      style = _ref.style,
	      excludeBootstrap = _ref.excludeBootstrap,
	      excludeFonts = _ref.excludeFonts;
	  return h$2(WalletAddressContext.Provider, {
	    value: wallet.address
	  }, h$2("div", {
	    ref: forwardedRef,
	    className: className
	  }, h$2("style", null, !excludeFonts && h$2(p$1, null, "@import \"https://fonts.googleapis.com/css2?family=Roboto:wght@300;500&display=swap\";"), !excludeBootstrap && h$2(p$1, null, "@import \"https://getbootstrap.com/docs/5.0/dist/css/bootstrap-reboot.min.css\"; @import \"https://getbootstrap.com/docs/5.0/dist/css/bootstrap-grid.min.css\"; @import \"https://getbootstrap.com/docs/5.0/dist/css/bootstrap-utilities.min.css\";"), style), children));
	}

	function useAuth() {
	  var _useState = p(getAccessTokenFromLocalStorage()),
	      _useState2 = _slicedToArray(_useState, 2),
	      accessToken = _useState2[0],
	      setAccessToken = _useState2[1];

	  h$1(function () {
	    function onUtuTokensReady(event) {
	      var access_token = event.detail.access_token;
	      setAccessToken(access_token);
	    }

	    window.addEventListener(EVENT_UTU_IDENTITY_DATA_READY, onUtuTokensReady);
	    return function () {
	      window.removeEventListener(EVENT_UTU_IDENTITY_DATA_READY, onUtuTokensReady);
	    };
	  }, []);
	  return {
	    accessToken: accessToken
	  };
	}
	function addressSignatureVerification() {
	  return _addressSignatureVerification.apply(this, arguments);
	}

	function _addressSignatureVerification() {
	  _addressSignatureVerification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	    var _window;

	    var overrideApiUrl,
	        walletProvider,
	        cookies,
	        utuApiBase,
	        provider,
	        signer,
	        address,
	        signature,
	        _yield$axios$post,
	        data,
	        _args = arguments;

	    return _regeneratorRuntime().wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            overrideApiUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
	            walletProvider = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
	            cookies = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
	            utuApiBase = (overrideApiUrl !== null && overrideApiUrl !== void 0 ? overrideApiUrl : config.production) ? UTU_API_BASE_URL_PRODUCTION : UTU_API_BASE_URL_TEST; // @ts-ignore

	            if (!(!((_window = window) !== null && _window !== void 0 && _window.ethereum) && !walletProvider)) {
	              _context.next = 6;
	              break;
	            }

	            return _context.abrupt("return", null);

	          case 6:
	            // @ts-ignore
	            provider = new Web3Provider(walletProvider || window.ethereum);
	            signer = provider.getSigner();
	            _context.next = 10;
	            return signer.getAddress();

	          case 10:
	            address = _context.sent;
	            _context.next = 13;
	            return signer.signMessage("Sign in at UTU");

	          case 13:
	            signature = _context.sent;
	            _context.next = 16;
	            return axios.post("".concat(utuApiBase).concat(API_VERIFY_ADDRESS), {
	              address: address,
	              signature: signature
	            }, {
	              withCredentials: !!cookies
	            });

	          case 16:
	            _yield$axios$post = _context.sent;
	            data = _yield$axios$post.data;
	            _context.next = 20;
	            return localStorage.setItem(LOCAL_STORAGE_KEY_UTU_IDENTITY_DATA, JSON.stringify(data));

	          case 20:
	            return _context.abrupt("return", data);

	          case 22:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee);
	  }));
	  return _addressSignatureVerification.apply(this, arguments);
	}

	function getAccessTokenFromLocalStorage() {
	  var item = localStorage.getItem(LOCAL_STORAGE_KEY_UTU_IDENTITY_DATA);

	  if (item) {
	    var _JSON$parse = JSON.parse(item),
	        access_token = _JSON$parse.access_token;

	    var _ref = o$1(access_token),
	        exp = _ref.exp;

	    if (isValid(exp)) {
	      return access_token;
	    }
	  }

	  return null;
	}

	function isValid(exp) {
	  return Date.now() < exp * 1000;
	}

	function useWalletConnectApi() {
	  var _useState = p(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      web3Modal = _useState2[0],
	      setWeb3Modal = _useState2[1];

	  h$1(function () {
	    function f() {
	      return _f.apply(this, arguments);
	    }

	    function _f() {
	      _f = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	        var providerOptions, newWeb3Modal;
	        return _regeneratorRuntime().wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                providerOptions = {
	                  burnerconnect: {
	                    package: BurnerConnectProvider,
	                    // required
	                    options: {
	                      defaultNetwork: "100"
	                    }
	                  }
	                };
	                newWeb3Modal = new Web3Modal({
	                  cacheProvider: true,
	                  // very important
	                  network: "mainnet",
	                  providerOptions: providerOptions
	                });
	                setWeb3Modal(newWeb3Modal);

	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee);
	      }));
	      return _f.apply(this, arguments);
	    }

	    f();
	  }, [setWeb3Modal]);
	  return {
	    web3Modal: web3Modal
	  };
	}
	function useRankingApi(apiUrl, sourceUuid, targetType) {
	  var _useAuth = useAuth(),
	      accessToken = _useAuth.accessToken;

	  var _useState3 = p(undefined),
	      _useState4 = _slicedToArray(_useState3, 2),
	      rankingItems = _useState4[0],
	      setRankingItems = _useState4[1];

	  var queryParams = lib.stringify({
	    sourceCriteria: JSON.stringify(createEntityCriteria(sourceUuid)),
	    targetType: targetType
	  });
	  h$1(function () {
	    function f() {
	      return _f2.apply(this, arguments);
	    }

	    function _f2() {
	      _f2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
	        var response;
	        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return axios.get("".concat(apiUrl).concat(CORE_API_BASE).concat(API_RANKING, "?").concat(queryParams), withAuthorizationHeader(accessToken));

	              case 2:
	                response = _context2.sent;
	                setRankingItems(response.data.result);

	              case 4:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2);
	      }));
	      return _f2.apply(this, arguments);
	    }

	    f();
	  }, [setRankingItems, apiUrl, queryParams, accessToken]);
	  return {
	    rankingItems: rankingItems
	  };
	}
	var SubmitStatus;

	(function (SubmitStatus) {
	  SubmitStatus[SubmitStatus["idle"] = 0] = "idle";
	  SubmitStatus[SubmitStatus["submitting"] = 1] = "submitting";
	  SubmitStatus[SubmitStatus["success"] = 2] = "success";
	  SubmitStatus[SubmitStatus["error"] = 3] = "error";
	})(SubmitStatus || (SubmitStatus = {}));

	var SUBMIT_STATUS_RESET_DELAY_MS = 3000;
	/**
	 * Calls the given submitStatusSetter with SubmitStatus.idle after a delay of SUBMIT_STATUS_RESET_DELAY_MS
	 * @param submitStatusSetter
	 */

	function resetSubmitStatusDelayed(submitStatusSetter) {
	  setTimeout(function () {
	    return submitStatusSetter(SubmitStatus.idle);
	  }, SUBMIT_STATUS_RESET_DELAY_MS);
	}
	/**
	 * Use the UTU API to post feedback.
	 * @param apiUrl
	 * @param sourceUuid
	 * @param targetUuid
	 * @param transactionId
	 * @return a function which takes an IFeedbackData parameter and returns a promise which will resolve with an
	 *         unspecified value when the feedback was posted successfully, and will reject otherwise.
	 */


	function useFeedbackApi(apiUrl, sourceUuid, targetUuid, transactionId) {
	  var _useAuth2 = useAuth(),
	      accessToken = _useAuth2.accessToken;

	  var _useState5 = p(SubmitStatus.idle),
	      _useState6 = _slicedToArray(_useState5, 2),
	      submitStatus = _useState6[0],
	      setSubmitStatus = _useState6[1];

	  var sourceCriteria = createEntityCriteria(sourceUuid);
	  var targetCriteria = createEntityCriteria(targetUuid);

	  function sendFeedback(feedbackData) {
	    setSubmitStatus(SubmitStatus.submitting);
	    return axios.post("".concat(apiUrl).concat(CORE_API_BASE).concat(API_FEEDBACK), {
	      sourceCriteria: sourceCriteria,
	      targetCriteria: targetCriteria,
	      transactionId: transactionId,
	      data: feedbackData
	    }, withAuthorizationHeader(accessToken)).then(function (result) {
	      setSubmitStatus(SubmitStatus.success);
	      resetSubmitStatusDelayed(setSubmitStatus);
	      return result;
	    }).catch(function (error) {
	      setSubmitStatus(SubmitStatus.error);
	      resetSubmitStatusDelayed(setSubmitStatus);
	      return error;
	    });
	  }

	  return {
	    sendFeedback: sendFeedback,
	    submitStatus: submitStatus
	  };
	}
	function useBadgesApi(apiUrl) {
	  var _useAuth3 = useAuth(),
	      accessToken = _useAuth3.accessToken;

	  var _useState7 = p([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      badgeSets = _useState8[0],
	      setBadgeSets = _useState8[1];

	  h$1(function () {
	    function f() {
	      return _f3.apply(this, arguments);
	    }

	    function _f3() {
	      _f3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
	        var response;
	        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return axios.get("".concat(apiUrl).concat(CORE_API_BASE).concat(API_BADGES), withAuthorizationHeader(accessToken));

	              case 2:
	                response = _context3.sent;
	                setBadgeSets(response.data.result);

	              case 4:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3);
	      }));
	      return _f3.apply(this, arguments);
	    }

	    f();
	  }, [setBadgeSets, apiUrl, accessToken]);
	  return {
	    badgeSets: badgeSets
	  };
	}
	function useFeedbackSummaryApi(apiUrl, sourceUuid, targetUuid) {
	  var _useAuth4 = useAuth(),
	      accessToken = _useAuth4.accessToken;

	  var _useState9 = p(undefined),
	      _useState10 = _slicedToArray(_useState9, 2),
	      feedbackSummary = _useState10[0],
	      setFeedbackSummary = _useState10[1];
	  var targetCriteria = createEntityCriteria(targetUuid);
	  var queryParams = lib.stringify({
	    // sourceCriteria, don't send for now, there's a bug in the API which then only returns feedback from that
	    // source, but not from their connections
	    targetCriteria: targetCriteria
	  });
	  h$1(function () {
	    function f() {
	      return _f4.apply(this, arguments);
	    }

	    function _f4() {
	      _f4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
	        var response;
	        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return axios.get("".concat(apiUrl).concat(CORE_API_BASE).concat(API_FEEDBACK_SUMMARY, "?").concat(queryParams), withAuthorizationHeader(accessToken));

	              case 2:
	                response = _context4.sent;
	                setFeedbackSummary(response.data.result.data);

	              case 4:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4);
	      }));
	      return _f4.apply(this, arguments);
	    }

	    f();
	  }, [setFeedbackSummary, apiUrl, queryParams, accessToken]);
	  return {
	    feedbackSummary: feedbackSummary
	  };
	}
	function useUploadVideoApi(apiUrl, source) {
	  var _useAuth5 = useAuth(),
	      accessToken = _useAuth5.accessToken;

	  var _useState11 = p({
	    uploading: false
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      status = _useState12[0],
	      setStatus = _useState12[1];

	  h$1(function () {
	    if (!source) return;
	    var wrappedReader = {
	      read: function read() {
	        var result = source.read();
	        return result;
	      }
	    };
	    var options = {
	      resume: false,
	      endpoint: "".concat(apiUrl).concat(UPLOADER_API_BASE, "/upload"),
	      headers: getAuthorizationHeader(accessToken),
	      chunkSize: 28 * 1024,
	      uploadLengthDeferred: true,
	      retryDelays: [0, 3000, 5000, 10000, 20000],
	      metadata: {
	        filename: "webcam.webm",
	        filetype: "video/webm"
	      },
	      onError: function onError() {
	        setStatus({
	          uploading: false,
	          errorMessage: "video was not successfully uploaded "
	        });
	      },
	      onSuccess: function onSuccess() {
	        var publishedVideoUrl = getPublishedVideoUrl(apiUrl, upload.url);
	        var checkVideoInterval = setInterval(function () {
	          axios.head(publishedVideoUrl).then(function () {
	            setStatus({
	              uploading: false,
	              publishedVideoUrl: publishedVideoUrl
	            });
	            clearInterval(checkVideoInterval);
	          }).catch(function () {
	            return setStatus({
	              errorMessage: "Video not yet available."
	            });
	          });
	        }, 500);
	        setStatus({
	          successMessage: "video was successfully uploaded"
	        });
	      }
	    };
	    var upload = new Upload(wrappedReader, options); // Start the upload

	    upload.start();
	    setStatus({
	      uploading: true
	    });
	  }, [accessToken, source]);
	  return status;
	}

	function getPublishedVideoUrl(apiUrl, uploadUrl) {
	  var videoId = uploadUrl.split("/").pop();
	  var publishedUrl = "".concat(apiUrl).concat(VIDEO_PUBLISHED_BASE, "/").concat(videoId);
	  return publishedUrl;
	}

	function createEntityCriteria(uuid) {
	  return {
	    ids: {
	      uuid: uuid
	    }
	  };
	}

	function withAuthorizationHeader(accessToken) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _objectSpread2(_objectSpread2({}, config), {}, {
	    headers: _objectSpread2(_objectSpread2({}, config.headers || {}), getAuthorizationHeader(accessToken))
	  });
	}

	function getAuthorizationHeader(accessToken) {
	  return {
	    "Authorization": "Bearer ".concat(accessToken)
	  };
	}

	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;

	  if (!css || typeof document === 'undefined') {
	    return;
	  }

	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';

	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }

	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z$o = "::slotted(ul) {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}";
	styleInject(css_248z$o);

	function Root(props) {
	  var _getBaseProps = getBaseProps(props, TAG_ROOT),
	      apiUrl = _getBaseProps.apiUrl;

	  var sourceUuid = props[ATTR_SOURCE_UUID];
	  var targetType = props[ATTR_TARGET_TYPE];

	  var _useRankingApi = useRankingApi(apiUrl, sourceUuid, targetType),
	      rankingItems = _useRankingApi.rankingItems;

	  var ref = _();
	  h$1(function () {
	    if (ref.current && rankingItems) {
	      ref.current.data = rankingItems;
	      setTimeout(function () {
	        ref.current.dispatchEvent(new CustomEvent("loaded", {
	          composed: true,
	          detail: {
	            data: rankingItems
	          }
	        }));
	      }, 0);
	    }
	  }, [ref, rankingItems]);
	  return h$2(BaseComponent, {
	    forwardedRef: ref,
	    className: "recommendation-root",
	    style: css_248z$o,
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2("slot", null));
	}

	var bind = functionUncurryThis(functionUncurryThis.bind); // optional / simple context binding

	var functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function
	    /* ...args */
	  () {
	    return fn.apply(that, arguments);
	  };
	};

	var push = functionUncurryThis([].push); // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation

	var createMethod$2 = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_REJECT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject$1($this);
	    var self = indexedObject(O);
	    var boundFunction = functionBindContext(callbackfn, that);
	    var length = lengthOfArrayLike(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;

	    for (; length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);

	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3:
	            return true;
	          // some

	          case 5:
	            return value;
	          // find

	          case 6:
	            return index;
	          // findIndex

	          case 2:
	            push(target, value);
	          // filter
	        } else switch (TYPE) {
	          case 4:
	            return false;
	          // every

	          case 7:
	            push(target, value);
	          // filterReject
	        }
	      }
	    }

	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod$2(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod$2(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod$2(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod$2(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod$2(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod$2(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod$2(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod$2(7)
	};

	var defineProperty$1 = objectDefineProperty.f;

	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype$1 = Array.prototype; // Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
	  defineProperty$1(ArrayPrototype$1, UNSCOPABLES, {
	    configurable: true,
	    value: objectCreate(null)
	  });
	} // add a key to Array.prototype[@@unscopables]


	var addToUnscopables = function (key) {
	  ArrayPrototype$1[UNSCOPABLES][key] = true;
	};

	var $find$1 = arrayIteration.find;



	var FIND = 'find';
	var SKIPS_HOLES = true; // Shouldn't skip holes

	if (FIND in []) Array(1)[FIND](function () {
	  SKIPS_HOLES = false;
	}); // `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find

	_export({
	  target: 'Array',
	  proto: true,
	  forced: SKIPS_HOLES
	}, {
	  find: function find(callbackfn
	  /* , that = undefined */
	  ) {
	    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	addToUnscopables(FIND);

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring


	var objectToString = toStringTagSupport ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};

	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring


	if (!toStringTagSupport) {
	  defineBuiltIn(Object.prototype, 'toString', objectToString, {
	    unsafe: true
	  });
	}

	var getIteratorDirect = function (obj) {
	  return {
	    iterator: obj,
	    next: aCallable(anObject(obj).next)
	  };
	};

	var asyncIteratorClose = function (iterator, method, argument, reject) {
	  try {
	    var returnMethod = getMethod(iterator, 'return');

	    if (returnMethod) {
	      return getBuiltIn('Promise').resolve(functionCall(returnMethod, iterator)).then(function () {
	        method(argument);
	      }, function (error) {
	        reject(error);
	      });
	    }
	  } catch (error2) {
	    return reject(error2);
	  }

	  method(argument);
	};

	// https://github.com/tc39/proposal-array-from-async















	var createMethod$1 = function (TYPE) {
	  var IS_TO_ARRAY = TYPE == 0;
	  var IS_FOR_EACH = TYPE == 1;
	  var IS_EVERY = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  return function (object, fn, target) {
	    var record = getIteratorDirect(object);
	    var Promise = getBuiltIn('Promise');
	    var iterator = record.iterator;
	    var next = record.next;
	    var index = 0;
	    var MAPPING = fn !== undefined;
	    if (MAPPING || !IS_TO_ARRAY) aCallable(fn);
	    return new Promise(function (resolve, reject) {
	      var ifAbruptCloseAsyncIterator = function (error) {
	        asyncIteratorClose(iterator, reject, error, reject);
	      };

	      var loop = function () {
	        try {
	          if (IS_TO_ARRAY && MAPPING) try {
	            doesNotExceedSafeInteger(index);
	          } catch (error5) {
	            ifAbruptCloseAsyncIterator(error5);
	          }
	          Promise.resolve(anObject(functionCall(next, iterator))).then(function (step) {
	            try {
	              if (anObject(step).done) {
	                if (IS_TO_ARRAY) {
	                  target.length = index;
	                  resolve(target);
	                } else resolve(IS_SOME ? false : IS_EVERY || undefined);
	              } else {
	                var value = step.value;

	                try {
	                  if (MAPPING) {
	                    Promise.resolve(IS_TO_ARRAY ? fn(value, index) : fn(value)).then(function (result) {
	                      if (IS_FOR_EACH) {
	                        loop();
	                      } else if (IS_EVERY) {
	                        result ? loop() : asyncIteratorClose(iterator, resolve, false, reject);
	                      } else if (IS_TO_ARRAY) {
	                        try {
	                          target[index++] = result;
	                          loop();
	                        } catch (error4) {
	                          ifAbruptCloseAsyncIterator(error4);
	                        }
	                      } else {
	                        result ? asyncIteratorClose(iterator, resolve, IS_SOME || value, reject) : loop();
	                      }
	                    }, ifAbruptCloseAsyncIterator);
	                  } else {
	                    target[index++] = value;
	                    loop();
	                  }
	                } catch (error3) {
	                  ifAbruptCloseAsyncIterator(error3);
	                }
	              }
	            } catch (error2) {
	              reject(error2);
	            }
	          }, reject);
	        } catch (error) {
	          reject(error);
	        }
	      };

	      loop();
	    });
	  };
	};

	var asyncIteratorIteration = {
	  toArray: createMethod$1(0),
	  forEach: createMethod$1(1),
	  every: createMethod$1(2),
	  some: createMethod$1(3),
	  find: createMethod$1(4)
	};

	var $find = asyncIteratorIteration.find;

	_export({
	  target: 'AsyncIterator',
	  proto: true,
	  real: true,
	  forced: true
	}, {
	  find: function find(fn) {
	    return $find(this, fn);
	  }
	});

	var $TypeError$4 = TypeError;

	var anInstance = function (it, Prototype) {
	  if (objectIsPrototypeOf(Prototype, it)) return it;
	  throw $TypeError$4('Incorrect invocation');
	};

	var correctPrototypeGetter = !fails(function () {
	  function F() {
	    /* empty */
	  }

	  F.prototype.constructor = null; // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing

	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});

	var IE_PROTO = sharedKey('IE_PROTO');
	var $Object = Object;
	var ObjectPrototype = $Object.prototype; // `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es-x/no-object-getprototypeof -- safe

	var objectGetPrototypeOf = correctPrototypeGetter ? $Object.getPrototypeOf : function (O) {
	  var object = toObject$1(O);
	  if (hasOwnProperty_1(object, IE_PROTO)) return object[IE_PROTO];
	  var constructor = object.constructor;

	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  }

	  return object instanceof $Object ? ObjectPrototype : null;
	};

	var ITERATOR$2 = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false; // `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object

	var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;
	/* eslint-disable es-x/no-array-prototype-keys -- safe */

	if ([].keys) {
	  arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
	    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
	  }
	}

	var NEW_ITERATOR_PROTOTYPE = !isObject$2(IteratorPrototype$2) || fails(function () {
	  var test = {}; // FF44- legacy iterators case

	  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
	});
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {}; // `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

	if (!isCallable(IteratorPrototype$2[ITERATOR$2])) {
	  defineBuiltIn(IteratorPrototype$2, ITERATOR$2, function () {
	    return this;
	  });
	}

	var iteratorsCore = {
	  IteratorPrototype: IteratorPrototype$2,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};

	var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;



	var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
	var NativeIterator = global$1.Iterator; // FF56- have non-standard global helper `Iterator`

	var FORCED = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1 // FF44- non-standard `Iterator` passes previous tests
	|| !fails(function () {
	  NativeIterator({});
	});

	var IteratorConstructor = function Iterator() {
	  anInstance(this, IteratorPrototype$1);
	};

	if (!hasOwnProperty_1(IteratorPrototype$1, TO_STRING_TAG$2)) {
	  createNonEnumerableProperty(IteratorPrototype$1, TO_STRING_TAG$2, 'Iterator');
	}

	if (FORCED || !hasOwnProperty_1(IteratorPrototype$1, 'constructor') || IteratorPrototype$1.constructor === Object) {
	  createNonEnumerableProperty(IteratorPrototype$1, 'constructor', IteratorConstructor);
	}

	IteratorConstructor.prototype = IteratorPrototype$1;
	_export({
	  global: true,
	  constructor: true,
	  forced: FORCED
	}, {
	  Iterator: IteratorConstructor
	});

	var iterators = {};

	var ITERATOR$1 = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype; // check on default Array iterator

	var isArrayIteratorMethod = function (it) {
	  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR$1] === it);
	};

	var ITERATOR = wellKnownSymbol('iterator');

	var getIteratorMethod = function (it) {
	  if (!isNullOrUndefined$1(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || iterators[classof(it)];
	};

	var $TypeError$3 = TypeError;

	var getIterator = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
	  throw $TypeError$3(tryToString(argument) + ' is not iterable');
	};

	var iteratorClose = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);

	  try {
	    innerResult = getMethod(iterator, 'return');

	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }

	    innerResult = functionCall(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }

	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};

	var $TypeError$2 = TypeError;

	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};

	var ResultPrototype = Result.prototype;

	var iterate = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = functionBindContext(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;

	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };

	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    }

	    return INTERRUPTED ? fn(value, stop) : fn(value);
	  };

	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw $TypeError$2(tryToString(iterable) + ' is not iterable'); // optimisation for array iterators

	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	      }

	      return new Result(false);
	    }

	    iterator = getIterator(iterable, iterFn);
	  }

	  next = IS_RECORD ? iterable.next : iterator.next;

	  while (!(step = functionCall(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }

	    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	  }

	  return new Result(false);
	};

	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: true
	}, {
	  find: function find(fn) {
	    var record = getIteratorDirect(this);
	    aCallable(fn);
	    return iterate(record, function (value, stop) {
	      if (fn(value)) return stop(value);
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).result;
	  }
	});

	var $map = arrayIteration.map;



	var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map'); // `Array.prototype.map` method
	// https://tc39.es/ecma262/#sec-array.prototype.map
	// with adding support of @@species

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT$1
	}, {
	  map: function map(callbackfn
	  /* , thisArg */
	  ) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var perform = function (exec) {
	  try {
	    return {
	      error: false,
	      value: exec()
	    };
	  } catch (error) {
	    return {
	      error: true,
	      value: error
	    };
	  }
	};

	var defineBuiltIns = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);

	  return target;
	};

	var USE_FUNCTION_CONSTRUCTOR = 'USE_FUNCTION_CONSTRUCTOR';
	var ASYNC_ITERATOR = wellKnownSymbol('asyncIterator');
	var AsyncIterator = global$1.AsyncIterator;
	var PassedAsyncIteratorPrototype = sharedStore.AsyncIteratorPrototype;
	var AsyncIteratorPrototype, prototype;

	if (PassedAsyncIteratorPrototype) {
	  AsyncIteratorPrototype = PassedAsyncIteratorPrototype;
	} else if (isCallable(AsyncIterator)) {
	  AsyncIteratorPrototype = AsyncIterator.prototype;
	} else if (sharedStore[USE_FUNCTION_CONSTRUCTOR] || global$1[USE_FUNCTION_CONSTRUCTOR]) {
	  try {
	    // eslint-disable-next-line no-new-func -- we have no alternatives without usage of modern syntax
	    prototype = objectGetPrototypeOf(objectGetPrototypeOf(objectGetPrototypeOf(Function('return async function*(){}()')())));
	    if (objectGetPrototypeOf(prototype) === Object.prototype) AsyncIteratorPrototype = prototype;
	  } catch (error) {
	    /* empty */
	  }
	}

	if (!AsyncIteratorPrototype) AsyncIteratorPrototype = {};

	if (!isCallable(AsyncIteratorPrototype[ASYNC_ITERATOR])) {
	  defineBuiltIn(AsyncIteratorPrototype, ASYNC_ITERATOR, function () {
	    return this;
	  });
	}

	var asyncIteratorPrototype = AsyncIteratorPrototype;

	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	var createIterResultObject = function (value, done) {
	  return {
	    value: value,
	    done: done
	  };
	};

	var Promise$1 = getBuiltIn('Promise');
	var ASYNC_ITERATOR_HELPER = 'AsyncIteratorHelper';
	var WRAP_FOR_VALID_ASYNC_ITERATOR = 'WrapForValidAsyncIterator';
	var setInternalState$1 = internalState.set;
	var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');

	var createAsyncIteratorProxyPrototype = function (IS_ITERATOR) {
	  var IS_GENERATOR = !IS_ITERATOR;
	  var ASYNC_ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ASYNC_ITERATOR : ASYNC_ITERATOR_HELPER;
	  var getInternalState = internalState.getterFor(ASYNC_ITERATOR_PROXY);

	  var getStateOrEarlyExit = function (that) {
	    var stateCompletion = perform(function () {
	      return getInternalState(that);
	    });
	    var stateError = stateCompletion.error;
	    var state = stateCompletion.value;

	    if (stateError || IS_GENERATOR && state.done) {
	      return {
	        exit: true,
	        value: stateError ? Promise$1.reject(state) : Promise$1.resolve(createIterResultObject(undefined, true))
	      };
	    }

	    return {
	      exit: false,
	      value: state
	    };
	  };

	  var enqueue = function (state, handler) {
	    var task = function () {
	      var promise = handler();

	      if (IS_GENERATOR) {
	        state.awaiting = promise;

	        var clean = function () {
	          if (state.awaiting === promise) state.awaiting = null;
	        };

	        promise.then(clean, clean);
	      }

	      return promise;
	    };

	    return state.awaiting ? state.awaiting = state.awaiting.then(task, task) : task();
	  };

	  var AsyncIteratorProxyPrototype = defineBuiltIns(objectCreate(asyncIteratorPrototype), {
	    next: function next() {
	      var stateCompletion = getStateOrEarlyExit(this);
	      var exit = stateCompletion.exit;
	      var state = stateCompletion.value;
	      return exit ? state : enqueue(state, function () {
	        var handlerCompletion = perform(function () {
	          return anObject(state.nextHandler(Promise$1));
	        });
	        var handlerError = handlerCompletion.error;
	        var value = handlerCompletion.value;
	        if (handlerError) state.done = true;
	        return handlerError ? Promise$1.reject(value) : Promise$1.resolve(value);
	      });
	    },
	    'return': function () {
	      var stateCompletion = getStateOrEarlyExit(this);
	      var exit = stateCompletion.exit;
	      var state = stateCompletion.value;
	      return exit ? state : enqueue(state, function () {
	        state.done = true;
	        var iterator = state.iterator;
	        var innerIterator = state.innerIterator;
	        var returnMethod, result;
	        var completion = perform(function () {
	          if (innerIterator) try {
	            iteratorClose(innerIterator, 'return');
	          } catch (error) {
	            return iteratorClose(iterator, 'throw', error);
	          }
	          return getMethod(iterator, 'return');
	        });
	        returnMethod = result = completion.value;
	        if (completion.error) return Promise$1.reject(result);
	        if (returnMethod === undefined) return Promise$1.resolve(createIterResultObject(undefined, true));
	        completion = perform(function () {
	          return functionCall(returnMethod, iterator);
	        });
	        result = completion.value;
	        if (completion.error) return Promise$1.reject(result);
	        return IS_ITERATOR ? Promise$1.resolve(result) : Promise$1.resolve(result).then(function (resolved) {
	          anObject(resolved);
	          return createIterResultObject(undefined, true);
	        });
	      });
	    }
	  });

	  if (IS_GENERATOR) {
	    createNonEnumerableProperty(AsyncIteratorProxyPrototype, TO_STRING_TAG$1, 'Async Iterator Helper');
	  }

	  return AsyncIteratorProxyPrototype;
	};

	var AsyncIteratorHelperPrototype = createAsyncIteratorProxyPrototype(false);
	var WrapForValidAsyncIteratorPrototype = createAsyncIteratorProxyPrototype(true);

	var asyncIteratorCreateProxy = function (nextHandler, IS_ITERATOR) {
	  var ASYNC_ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ASYNC_ITERATOR : ASYNC_ITERATOR_HELPER;

	  var AsyncIteratorProxy = function AsyncIterator(record, state) {
	    if (state) {
	      state.iterator = record.iterator;
	      state.next = record.next;
	    } else state = record;

	    state.type = ASYNC_ITERATOR_PROXY;
	    state.nextHandler = nextHandler;
	    state.done = false;
	    state.awaiting = null;
	    setInternalState$1(this, state);
	  };

	  AsyncIteratorProxy.prototype = IS_ITERATOR ? WrapForValidAsyncIteratorPrototype : AsyncIteratorHelperPrototype;
	  return AsyncIteratorProxy;
	};

	var AsyncIteratorProxy = asyncIteratorCreateProxy(function (Promise) {
	  var state = this;
	  var iterator = state.iterator;
	  var mapper = state.mapper;
	  return new Promise(function (resolve, reject) {
	    var doneAndReject = function (error) {
	      state.done = true;
	      reject(error);
	    };

	    var ifAbruptCloseAsyncIterator = function (error) {
	      asyncIteratorClose(iterator, doneAndReject, error, doneAndReject);
	    };

	    Promise.resolve(anObject(functionCall(state.next, iterator))).then(function (step) {
	      try {
	        if (anObject(step).done) {
	          state.done = true;
	          resolve(createIterResultObject(undefined, true));
	        } else {
	          var value = step.value;

	          try {
	            Promise.resolve(mapper(value)).then(function (mapped) {
	              resolve(createIterResultObject(mapped, false));
	            }, ifAbruptCloseAsyncIterator);
	          } catch (error2) {
	            ifAbruptCloseAsyncIterator(error2);
	          }
	        }
	      } catch (error) {
	        doneAndReject(error);
	      }
	    }, doneAndReject);
	  });
	});
	_export({
	  target: 'AsyncIterator',
	  proto: true,
	  real: true,
	  forced: true
	}, {
	  map: function map(mapper) {
	    return new AsyncIteratorProxy(getIteratorDirect(this), {
	      mapper: aCallable(mapper)
	    });
	  }
	});

	var IteratorPrototype = iteratorsCore.IteratorPrototype;





	var ITERATOR_HELPER = 'IteratorHelper';
	var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
	var setInternalState = internalState.set;
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');

	var createIteratorProxyPrototype = function (IS_ITERATOR) {
	  var ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
	  var getInternalState = internalState.getterFor(ITERATOR_PROXY);
	  var IteratorProxyPrototype = defineBuiltIns(objectCreate(IteratorPrototype), {
	    next: function next() {
	      var state = getInternalState(this); // for simplification:
	      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
	      //   for `%IteratorHelperPrototype%.next` - just a value

	      if (IS_ITERATOR) return state.nextHandler();

	      try {
	        var result = state.done ? undefined : state.nextHandler();
	        return createIterResultObject(result, state.done);
	      } catch (error) {
	        state.done = true;
	        throw error;
	      }
	    },
	    'return': function () {
	      var state = getInternalState(this);
	      var iterator = state.iterator;
	      state.done = true;

	      if (IS_ITERATOR) {
	        var returnMethod = getMethod(iterator, 'return');
	        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
	      }

	      var innerIterator = state.innerIterator;
	      if (innerIterator) try {
	        iteratorClose(innerIterator, 'return');
	      } catch (error) {
	        return iteratorClose(iterator, 'throw', error);
	      }
	      iteratorClose(iterator, 'return');
	      return createIterResultObject(undefined, true);
	    }
	  });

	  if (!IS_ITERATOR) {
	    createNonEnumerableProperty(IteratorProxyPrototype, TO_STRING_TAG, 'Iterator Helper');
	  }

	  return IteratorProxyPrototype;
	};

	var IteratorHelperPrototype = createIteratorProxyPrototype(false);
	var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);

	var iteratorCreateProxy = function (nextHandler, IS_ITERATOR) {
	  var ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;

	  var IteratorProxy = function Iterator(record, state) {
	    if (state) {
	      state.iterator = record.iterator;
	      state.next = record.next;
	    } else state = record;

	    state.type = ITERATOR_PROXY;
	    state.nextHandler = nextHandler;
	    state.done = false;
	    setInternalState(this, state);
	  };

	  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
	  return IteratorProxy;
	};

	// call something on iterator step with safe closing on error


	var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};

	var IteratorProxy = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var result = anObject(functionCall(this.next, iterator));
	  var done = this.done = !!result.done;
	  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, result.value);
	});
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: true
	}, {
	  map: function map(mapper) {
	    return new IteratorProxy(getIteratorDirect(this), {
	      mapper: aCallable(mapper)
	    });
	  }
	});

	var css_248z$n = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-recommendation {\n  border-radius: 20px;\n  padding-right: 1rem;\n}\n.utu-recommendation-content {\n  display: flex;\n  margin-left: 5px;\n}\n.utu-recommendation-text {\n  align-self: center;\n  margin-left: 20px;\n}\n.utu-recommendation-text-light {\n  color: #000000;\n}\n.utu-recommendation-text-dark {\n  color: #ffffff;\n}\n\n.summary-image-list {\n  display: flex;\n  justify-content: center;\n  margin: 1.5rem 0 1rem 2rem;\n  padding-left: 0;\n  list-style: none;\n}\n.summary-image-item {\n  margin-left: -15px;\n  height: 2.5rem;\n}\n.summary-image-item-light {\n  border: 2px solid rgb(252, 229, 70);\n}\n.summary-image-item-dark {\n  border: 2px solid rgb(252, 229, 70);\n}";
	styleInject(css_248z$n);

	function getRoot(ref) {
	  if (ref && ref.current) {
	    var shadowRoot = ref.current.getRootNode();
	    var rootContainer = shadowRoot.host.closest(TAG_ROOT);

	    if (rootContainer) {
	      return rootContainer.shadowRoot.firstChild;
	    }
	  }

	  return null;
	}

	function getValueFromRoot(ref, targetUuid) {
	  var root = getRoot(ref);

	  if (root && root.data) {
	    return root.data.find(function (item) {
	      return item.entity.uuid === targetUuid;
	    });
	  }

	  return null;
	}

	function Recommendation(props) {
	  var ref = _();
	  var targetUuid = props[ATTR_TARGET_UUID]; // environments

	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1]; // const [isDark, setIsDark] = useState(false);


	  var _useState3 = p(getValueFromRoot(ref, targetUuid)),
	      _useState4 = _slicedToArray(_useState3, 2),
	      rankingItem = _useState4[0],
	      setRankingItem = _useState4[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  } // environment conditionals


	  var envCondition = isDark ? "dark" : "light";
	  h$1(function () {
	    function loaded() {
	      setRankingItem(getValueFromRoot(ref, targetUuid));
	    }

	    if (ref.current && targetUuid) {
	      var root = getRoot(ref);

	      if (root) {
	        root.addEventListener("loaded", loaded);
	      }
	    }

	    return function () {
	      var root = getRoot(ref);

	      if (root) {
	        root.removeEventListener("loaded", loaded);
	      }
	    };
	  }, [ref, targetUuid]);
	  return h$2(BaseComponent, {
	    style: css_248z$n,
	    forwardedRef: ref,
	    className: "utu-recommendation utu-section utu-section-no-border-".concat(envCondition)
	  }, rankingItem && h$2(p$1, null, h$2("div", {
	    className: "utu-recommendation-content"
	  }, h$2("ul", {
	    className: "summary-image-list"
	  }, rankingItem.summaryImages.map(function (image) {
	    return h$2("li", {
	      key: image
	    }, h$2("img", {
	      className: "rounded-circle summary-image-item summary-image-item-".concat(envCondition),
	      src: image,
	      onError: function onError(e) {
	        e.target.onerror = null;
	        e.target.src = "";
	        e.target.className = "";
	        e.target.alt = "";
	      },
	      alt: "profile"
	    }));
	  })), h$2("div", {
	    className: "utu-recommendation-text utu-recommendation-text-".concat(envCondition)
	  }, rankingItem.summaryText))));
	}

	var css_248z$m = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-feedback-form {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  border-bottom: 15px rgb(252, 229, 70) solid;\n  z-index: 1;\n}\n.utu-feedback-form-popup {\n  padding: 0.5rem;\n  border-radius: 15px;\n}\n\n.desktop-view {\n  display: none;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-feedback-form {\n    border-bottom: 0px;\n    z-index: 1;\n    align-items: center;\n    height: 100%;\n  }\n  .mobile-view {\n    display: none;\n  }\n  .desktop-view {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n  .desktop-view-block-1 {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0 4.5rem 0 4.5rem;\n  }\n  .desktop-view-block-1-dark {\n    background-color: #3d3d3c;\n  }\n  .desktop-view-block-1-light {\n    background-color: #fcf8e5;\n  }\n  .desktop-view-block-2 {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n  .desktop-view-block-2-dark {\n    background-color: #3d3d3c;\n  }\n  .desktop-view-block-2-light {\n    background-color: #fcf8e5;\n  }\n  .desktop-view-block-3 {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n  .desktop-view-block-3-dark {\n    background-color: rgb(36, 35, 35);\n  }\n  .desktop-view-block-3-light {\n    background-color: rgb(253, 253, 253);\n  }\n}\n.x-utu-form-badges {\n  text-align: center;\n}\n\n.x-utu-divider {\n  background-color: rgba(189, 195, 199, 0.3);\n  height: 90px;\n  width: 3px;\n}";
	styleInject(css_248z$m);

	var css_248z$l = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.button {\n  cursor: pointer;\n}\n.button:hover {\n  background-color: rgb(253, 253, 253);\n}\n.button:active {\n  transform: translateY(1px);\n}\n\n.badge-set-container {\n  width: 6em;\n  height: 72px;\n}\n.badge-section {\n  display: flex;\n  overflow-x: scroll;\n  white-space: nowrap;\n  padding-top: 2rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.badge-section > div {\n  padding: 1rem;\n}\n.badge-disable {\n  height: 50px;\n  width: 50px;\n  opacity: 0.6;\n}\n.badge-item-text {\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n.badge-text {\n  font-size: 0.7rem;\n}\n.badge-text-h3 {\n  text-align: center;\n}\n.badge-text-h3-light {\n  color: #000000;\n}\n.badge-text-h3-dark {\n  color: #ffffff;\n}\n.badge-img {\n  width: 4rem;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.badge-img-container {\n  display: flex;\n  justify-content: space-around;\n  opacity: 1;\n}\n.badge-img-big {\n  width: 6rem;\n}\n.badge-img-big-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.badge-set-container {\n  padding: 1rem 1rem 1rem 0;\n}\n\n.badge-set-section {\n  display: flex;\n  flex-direction: row;\n  background-color: rgba(255, 221, 51, 0.1);\n  border-radius: 10.07px;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .badge-section {\n    padding-left: 2rem;\n    padding-right: 0;\n  }\n}\n@media only screen and (min-width: 1210px) {\n  .badge-section {\n    padding-top: 0;\n  }\n}";
	styleInject(css_248z$l);

	var css_248z$k = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}";
	styleInject(css_248z$k);

	/* eslint max-len: 0 */
	function Logo() {
	  return h$2("svg", {
	    style: css_248z$k,
	    version: "1.1",
	    id: "Capa_1",
	    xmlns: "http://www.w3.org/2000/svg",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    x: "0px",
	    y: "0px",
	    className: "logo-size",
	    viewBox: "0 0 841.89 401.471",
	    xmlSpace: "preserve"
	  }, h$2("g", {
	    id: "Layer_2"
	  }, h$2("g", {
	    id: "Layer_1-2"
	  }, h$2("path", {
	    fill: "#FFFFFF",
	    d: "M565.858,0c263.37,4.676,263.323,395.802,0,400.243C302.487,395.709,302.532,4.397,565.858,0z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M0.005,224.144v-45.228c-0.005-2.54,2.051-4.603,4.591-4.607c0.019,0,0.038,0,0.057,0 c7.535,0.416,21.79-1.872,27.35,4.176c6.247,4.983,6.239,19.43,0,24.454c-4.912,5.359-15.871,4.127-22.758,4.215v16.991 C9.443,230.176-0.14,230.119,0.005,224.144z M9.26,198.834c6.479-0.119,18.55,1.96,17.854-8.119 c0.695-10.07-11.415-7.999-17.854-8.087V198.834z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M40.041,209.985c-1.848-25.798,36.885-25.901,34.957,0C76.878,235.775,38.241,235.671,40.041,209.985z M48.84,209.985c-1.208,15.847,18.742,15.839,17.534,0c1.232-15.99-18.782-15.99-17.574,0H48.84z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M77.149,195.475c-0.192-4.712,6.936-5.911,8.399-1.479l6.64,19.646l5.352-19.334 c0.498-1.867,2.202-3.156,4.135-3.128c1.851-0.022,3.506,1.146,4.104,2.896l5.352,19.574l6.56-19.646 c0.912-2.96,5.12-3.712,7.199-1.64c4.496,2.079-9.991,30.637-10.11,33.709c-1.112,3.823-7.144,3.384-8.168-0.32l-4.959-17.534 l-4.936,17.43c-0.72,2.308-3.173,3.595-5.479,2.875c-0.419-0.13-0.815-0.322-1.176-0.57 C87.868,226.512,77.678,197.931,77.149,195.475z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M128.201,209.649c-2.473-23.021,33.517-26.27,33.356-3.199c0.288,3.399-0.896,6.831-4.911,6.559h-19.814 c0.392,11.487,13.039,8.592,19.91,4.96C174.181,225.784,126.593,242.11,128.201,209.649z M137.063,205.649h15.854 C153.502,195.499,137.048,195.698,137.063,205.649z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M167.453,224.456c0.472-1.896-1.264-31.637,1.264-31.997c2.704-2.863,7.855-0.416,7.367,3.504 c2.288-6.655,16.919-7.04,11.535,1.823c-5.88,2.776-11.199,0.801-11.535,10.096v16.614 C176.212,230.039,167.325,230.048,167.453,224.456z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M190.963,209.649c-2.464-23.021,33.524-26.27,33.356-3.199c0.296,3.399-0.896,6.831-4.903,6.559h-19.822 c0.4,11.487,13.047,8.592,19.918,4.96C236.95,225.784,189.355,242.11,190.963,209.649z M199.834,205.649h15.854 C216.272,195.499,199.818,195.698,199.834,205.649z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M228.543,209.985c-1.544-14.935,13.255-24.861,25.03-16.11v-18.398c-0.152-3.728,4.848-5.76,7.375-3.048 c2.584-0.136,0.744,39.236,1.264,40.74c0,5.157-1.506,9.116-4.52,11.879C245.75,234.767,226.888,227.248,228.543,209.985z M237.175,209.985c-1.984,13.143,15.998,16.902,16.406,3.199v-11.062C246.79,193.891,236.07,198.986,237.175,209.985 L237.175,209.985z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M287.834,213.169v-37.692c-0.16-3.735,4.84-5.751,7.367-3.048c2.479,1.32,0.8,19.158,1.264,21.446 c5.464-5.088,16.526-3.696,20.838,1.688c5.703,5.728,5.768,23.198-0.191,28.798C307.92,233.959,286.426,228.976,287.834,213.169z M296.465,213.169c-0.855,8.104,9.807,11.679,14.287,5.655c6.839-10.398-2-29.524-14.287-16.727V213.169z"
	  }), h$2("path", {
	    fill: "#BBBBBB",
	    d: "M323.175,243.046c-2.584-2.399-0.681-7.199,2.951-6.983c6.151-0.296,7.447-4.799,10.151-10.631 l-12.303-28.293c-0.211-0.535-0.317-1.105-0.312-1.68c-0.2-4.656,6.848-5.855,8.319-1.601l8.791,22.19l8.8-22.182 c0.928-2.744,5.031-3.656,7.071-1.44c5.095,2.2-13.775,35.325-13.943,38.356C338.413,240.198,331.006,246.95,323.175,243.046z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M710.811,214.345v-18.67c-0.152-3.728,4.871-5.76,7.383-3.048c4.903,6.264-5.039,29.693,8.479,28.941 c4.735,0,7.105-2.399,7.111-7.199v-18.687c-0.136-5.6,8.799-5.6,8.631,0c-0.695,7.199,2.096,23.198-3.031,29.077 C730.688,234.063,708.843,229.567,710.811,214.345z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M766.469,198.259c-2.928-3.288,0.552-7.111,4.376-6.256c0.144-3.455-1.264-10.943,4.264-10.814 c5.495-0.137,4.071,7.391,4.216,10.814c2.76-0.176,7.287-0.248,7.199,3.656c0.104,3.903-4.408,3.879-7.199,3.688 c0.376,1.399-0.96,21.118,0.936,21.462c2.191,1.304,6.008,0.8,5.855,4.472c-0.488,6.151-9.679,3.392-12.143,0.655 c-5.399-3.999-2.4-20.894-3.128-26.589C769.373,199.362,767.533,199.53,766.469,198.259z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M810.137,214.345v-18.67c-0.151-3.728,4.872-5.76,7.384-3.048c4.903,6.264-5.04,29.693,8.479,28.941 c4.736,0,7.106-2.399,7.111-7.199v-18.687c-0.136-5.6,8.8-5.6,8.632,0c-0.696,7.199,2.096,23.198-3.032,29.077 C830.015,234.063,808.169,229.567,810.137,214.345z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M531.155,40.865c45.052,0.8,45.044,67.729,0,68.489C486.104,108.579,486.111,41.665,531.155,40.865z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M444.163,148.855c45.052,0.8,45.044,67.705,0,68.465C399.111,216.545,399.119,149.607,444.163,148.855z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M529.835,248.934c39.845,0.672,39.845,59.898,0,60.57C489.982,308.84,489.991,249.646,529.835,248.934z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M465.257,230.447c31.197,0.528,31.197,46.916,0,47.443C434.084,277.371,434.092,230.991,465.257,230.447z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M511.389,130.457c29.47,0.504,29.461,44.268,0,44.796C481.911,174.677,481.92,130.921,511.389,130.457z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M582.566,101.42c29.469,0.504,29.461,44.308,0,44.795C553.097,145.72,553.104,101.915,582.566,101.42z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M637.921,93.524c29.445,0.504,29.445,44.292,0,44.796C608.628,138.176,608.628,93.66,637.921,93.524z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M656.367,146.224c26.006,0.447,26.006,39.052,0,39.492C630.346,185.268,630.346,146.671,656.367,146.224z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M593.109,264.732c22.525,0.384,22.518,33.86,0,34.236C570.583,298.585,570.583,265.116,593.109,264.732z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M651.096,198.866c22.534,0.384,22.534,33.854,0,34.229C628.554,232.711,628.562,199.25,651.096,198.866z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M437.563,101.42c22.51,0.384,22.51,33.893,0,34.276C415.166,135.593,415.166,101.516,437.563,101.42z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M603.66,56.655c22.526,0.385,22.518,33.854,0,34.237C581.254,90.788,581.254,56.752,603.66,56.655z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M500.838,196.251c22.534,0.384,22.534,33.828,0,34.213C478.296,230.071,478.304,196.627,500.838,196.251z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M632.642,240.99c19.046,0.328,19.046,28.678,0,29.006C613.604,269.644,613.604,241.318,632.642,240.99z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M474.464,64.567c19.062,0.327,19.062,28.637,0,28.957C455.506,93.437,455.506,64.655,474.464,64.567z"
	  }), h$2("path", {
	    fill: "#2B2B2B",
	    d: "M479.744,104.06c19.054,0.319,19.054,28.677,0,28.997C460.762,132.969,460.762,104.14,479.744,104.06z"
	  }), h$2("rect", {
	    x: "474.385",
	    y: "78.803",
	    transform: "matrix(-0.9944 0.1058 -0.1058 -0.9944 961.3718 138.2227)",
	    fill: "#2B2B2B",
	    width: "5.272",
	    height: "31.605"
	  }), h$2("rect", {
	    x: "437.48",
	    y: "126.203",
	    transform: "matrix(-0.9944 0.1058 -0.1058 -0.9944 892.7841 236.662)",
	    fill: "#2B2B2B",
	    width: "5.272",
	    height: "31.606"
	  }), h$2("rect", {
	    x: "490.251",
	    y: "181.519",
	    transform: "matrix(-0.0772 0.997 -0.997 -0.0772 728.7499 -306.1609)",
	    fill: "#2B2B2B",
	    width: "31.605",
	    height: "5.272"
	  }), h$2("rect", {
	    x: "501.348",
	    y: "116.825",
	    transform: "matrix(-0.349 0.9371 -0.9371 -0.349 809.6375 -323.5298)",
	    fill: "#2B2B2B",
	    width: "31.702",
	    height: "5.288"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "500.006,156.966 469.969,166.869 468.312,161.87 498.35,151.959 500.006,156.966 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "474.744,120.346 443.115,121.018 443.003,115.754 474.632,115.082 474.744,120.346 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "591.813,71.87 560.265,72.462 560.152,67.782 591.701,67.183 591.813,71.87 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "499.438,223.992 476.472,245.614 473.248,242.223 496.206,220.601 499.438,223.992 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "625.714,262.309 601.301,282.282 598.316,278.667 622.73,258.701 625.714,262.309 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "587.094,241.286 595.189,271.748 590.669,272.972 582.566,242.511 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "643.904,215.889 612.739,210.985 613.451,206.354 644.616,211.257 643.904,215.889 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "642.568,172.725 612.188,181.22 610.907,176.717 641.289,168.222 642.568,172.725 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "583.342,137.208 579.742,168.518 575.079,168.005 578.679,136.696 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "545.922,177.221 519.204,160.454 521.676,156.479 548.394,173.245 545.922,177.221 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "567.008,111.379 540.29,94.612 542.762,90.637 569.479,107.403 567.008,111.379 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "584.438,112.122 594.733,82.325 599.173,83.829 588.878,113.626 584.438,112.122 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "528.579,261.717 543.498,233.943 547.642,236.143 532.715,263.908 528.579,261.717 \t\t"
	  }), h$2("polygon", {
	    fill: "#2B2B2B",
	    points: "633.905,106.683 609.972,86.141 613.012,82.573 636.945,103.115 633.905,106.683 \t\t"
	  }), h$2("path", {
	    fill: "#FFE535",
	    d: "M575.951,156.759c62.394,1.063,62.394,93.759,0,94.807C513.604,250.502,513.62,157.814,575.951,156.759z"
	  }))));
	}

	/* eslint max-len: 0 */
	function SadPenguin() {
	  return h$2("svg", {
	    xmlns: "http://www.w3.org/2000/svg",
	    id: "svg2",
	    viewBox: "0 0 3000 3000",
	    version: "1.1"
	  }, h$2("defs", {
	    id: "defs34"
	  }), h$2("g", {
	    id: "g3040",
	    transform: "translate(0,-4.4063)"
	  }, h$2("path", {
	    id: "path7",
	    fill: "#fff",
	    d: "m1520.9 2457.6c-502.69 0-910.31 244.27-915.91 546.77h1832.2c-5.5781-302.51-413.58-546.77-916.24-546.77z"
	  }), h$2("path", {
	    id: "path9",
	    fill: "#fff",
	    d: "m2417.1 1351.8c0 305.39-410.34 552.96-916.5 552.96s-916.48-247.57-916.48-552.96 410.32-552.96 916.48-552.96 916.5 247.57 916.5 552.96z"
	  }), h$2("path", {
	    id: "path11",
	    d: "m1813.5 897.94c14.133 1.2188 28.195 3.9609 42.844 7.7109 148.59 37.992 275.55 201.91 310.92 401.37 10.383 58.641 11.273 147.89 1.8281 200.67-23.976 133.95-93.328 232.1-190.05 269.53-39.609 15.328-98.062 19.476-140.27 9.8906-100.69-22.875-200.65-111.8-261.47-232.92-29.578-58.875-58.805-155.11-58.594-192.61-4.4063-27.047-4.8984-30.07-7.3359-69.211-3.7266-13.898 1.8984-87.75 13.547-138.07 25.453-109.66 85.148-193.43 165.16-232.17 40.547-19.641 81.047-27.773 123.42-24.188z"
	  }), h$2("path", {
	    id: "path13",
	    d: "m1435.5 433.59c-191.91 3.1172-378.8 60.586-526.97 163.34-211.9 146.93-352.12 372.73-411.26 663.21-2.7188 13.359-6.1875 31.734-8.0625 40.641-1.875 8.9062-5.7188 31.594-8.0625 50.531-2.3438 18.961-6.3516 50.273-9.1406 69.211-6.5625 44.484-6.6094 206.84 0 247.2 20.203 123.49 42.117 213.66 88.617 364.76 14.133 45.914 17.414 56.93 24.891 84.961 2.0859 7.8047 9.6562 35.156 16.5 60.797 44.016 164.95 47.859 278.65 13.898 386.34-24.867 78.844-64.172 139.27-141.73 216.42-55.57 55.453-118.34 139.12-159.28 223.41h374.25c9.7734-22.594 17.602-46.219 26.367-63.727 56.18-112.08 113.13-190.88 193.73-268.08 106.08-101.62 225.54-162.59 368.04-188.23 39.141-7.0547 161.62-8.2969 200.32-1.8281 210.96 35.226 391.27 147.75 535.41 333.98 42.516 54.938 80.789 119.58 115.34 187.88h787.73c-26.555-57.562-71.719-129.66-126.23-207.28-29.93-42.633-69.656-106.95-91.289-132.56-68.719-81.445-126.59-120.8-168.21-175.9-86.508-79.945-76.219-96.539-74.227-208.99 36-179.16 46.289-513.47 36-782.72 3.7969-78.609-0.4922-119.48-4.5-161.02-14.227-146.77-42.07-234.87-99.609-349.73-45.586-90.961-102.96-169.41-178.36-244.62-84.328-84.141-166.08-142.57-275.74-196.66-133.62-65.906-260.79-99.375-416.02-109.5-27.539-1.7812-54.984-2.2734-82.406-1.8281z"
	  }), h$2("path", {
	    id: "path15",
	    fill: "#333",
	    d: "m1521.2 567.63s-51.422 1268.6-19.031 1801.8c178.76 29.836 260.58 70.336 438.7 215.7 93.234 76.055 266.2 272.65 332.91 419.32h502.43c-46.8-72.3-139.5-212-161.8-238.4-28.476-33.727-67.008-78.984-85.336-100.71-58.219-69-145.27-167.18-180.54-213.87-37.336-36.891-33.586-62.859-32.226-112.43 3.3515-132.66 16.312-651.63 26.742-868.29 3.211-66.609 3.3985-93.703 0-128.91-12.047-124.36-35.836-210.28-84.609-307.62-38.602-77.086-86.977-143.53-150.87-207.28-71.461-71.297-140.72-120.8-233.65-166.62-113.2-55.828-352.66-92.648-352.66-92.648z"
	  }), h$2("path", {
	    id: "path17",
	    fill: "#ec0",
	    d: "m1427.1 1764.9-13.922 14.812c-27.703 29.344-87.352 49.359-179.11 59.906-100.76 11.602-228.89 5.3204-290.3-14.18-30.352-9.6329-38.578-7.9922-45.844 9.4921-22.898 55.219 24.984 159.73 137.55 300.3 71.391 89.156 177.52 196.34 243.94 246.35 25.852 19.477 57.375 34.852 86.766 42.305 23.906 6.0703 165.52 4.875 198.96-1.6406 11.156-2.1797 31.922-6.1172 46.102-8.8829 77.086-14.883 142.05-52.219 255.87-146.79 102.8-85.43 228.87-226.08 262.55-292.95 24.633-48.891 34.805-122.58 20.016-145.15-8.4844-12.938-12.047-13.148-44.578-2.789-31.547 10.031-139.05 20.25-211.9 20.25-30.164 0-78.844-2.8125-108.3-6.3282-85.758-10.195-135.09-27.773-164.02-58.5l-15.188-16.219zm36.867 32.414c22.336 0 34.852 29.086 26.203 61.172-14.812 55.031-50.695 81.656-72.562 53.836-23.977-30.469 10.078-115.01 46.359-115.01zm84.844 0c24.914 0 54.844 47.391 54.844 86.766 0 33.938-25.781 49.57-50.156 30.398-20.086-15.797-37.758-62.555-33.047-87.656 3.1875-17.062 15.188-29.508 28.359-29.508z",
	    style: "fill:#fbc93d;fill-opacity:1"
	  }), h$2("path", {
	    id: "path19",
	    fill: "#fff",
	    d: "m1214 1077.4c35.18-3 68.812 3.7734 102.49 20.062 66.375 32.133 115.8 101.77 136.88 192.54 14.274 71.226 9.3281 172.12 3.6328 189.16-7.6172 58.078-40.664 141.38-77.555 195.59-50.297 73.945-120.91 126.91-188.27 141.12-60.047 12.656-116.41 0.2812-164.84-36.188-72.891-54.914-113.13-153.02-113.16-275.25-0.0234-198.47 115.85-382.52 264.91-420.66 12.188-3.1172 24.164-5.3906 35.906-6.375z"
	  }), h$2("path", {
	    id: "path21",
	    fill: "#fff",
	    d: "m1794.7 1077.4c-35.203-3-68.836 3.7734-102.52 20.062-66.375 32.133-115.8 101.77-136.85 192.54-14.273 71.226-9.3281 172.12-3.6562 189.16 7.6406 58.078 40.688 141.38 77.555 195.59 50.297 73.945 120.94 126.91 188.27 141.12 60.07 12.656 116.44 0.2812 164.86-36.188 72.867-54.914 113.11-153.02 113.13-275.25 0.047-198.47-115.85-382.52-264.91-420.66-12.164-3.1172-24.164-5.3906-35.883-6.375z"
	  }), h$2("path", {
	    id: "path23",
	    d: "m1418.5 1543.2c0 100.97-75.188 182.81-167.91 182.81-92.742 0-167.91-81.844-167.91-182.81 0-100.99 75.164-182.84 167.91-182.84 92.719 0 167.91 81.844 167.91 182.84z"
	  }), h$2("path", {
	    id: "path25",
	    fill: "#fff",
	    d: "m1379.2 1471.6c0 44.25-32.953 80.109-73.57 80.109-40.641 0-73.57-35.859-73.57-80.109s32.93-80.109 73.57-80.109c40.617 0 73.57 35.859 73.57 80.109z"
	  }), h$2("path", {
	    id: "path27",
	    d: "m1922.2 1534.7c0 100.97-75.164 182.84-167.91 182.84-92.742 0-167.91-81.867-167.91-182.84s75.164-182.84 167.91-182.84c92.742 0 167.91 81.867 167.91 182.84z"
	  }), h$2("path", {
	    id: "path29",
	    fill: "#fff",
	    d: "m1885.7 1461.9c0 44.227-32.93 80.109-73.57 80.109-40.641 0-73.57-35.883-73.57-80.109 0-44.25 32.93-80.133 73.57-80.133 40.641 0 73.57 35.883 73.57 80.133z"
	  }), h$2("path", {
	    id: "path31",
	    fill: "#333",
	    d: "m988.2 966.73c37.4-23.23 78.6-34.74 125.2-35.68 91.898-1.8516 186.16 47.531 260.86 136.43 56.133 71.016 107.7 185.86 111.02 208.03-313.95 47.18-354.94 46.289-589.66 335.53-112.24-220.38-87.633-490.31 56.367-616.95 11.742-10.336 23.766-19.641 36.234-27.375z"
	  }), h$2("path", {
	    id: "path33",
	    d: "m2007.8 971.6c-37.383-23.227-78.562-34.734-125.18-35.672-91.875-1.8516-186.16 47.531-260.86 136.43-56.109 71.016-107.67 185.86-111.02 208.03 313.95 47.18 354.94 46.289 589.66 335.53 112.27-220.41 87.633-490.31-56.344-616.95-11.766-10.336-23.789-19.641-36.258-27.375z"
	  }), h$2("path", {
	    id: "path35",
	    d: "m1959.2 2230.3c0 109.1-44.297 197.67-98.836 197.67-54.562 0-98.836-88.57-98.836-197.67 0-109.12 81.562-234.98 102.56-466.22 4.1953 233.11 95.109 357.09 95.109 466.22z",
	    stroke: "#0ff",
	    fill: "#0ff"
	  }), h$2("path", {
	    id: "path37",
	    fill: "#fff",
	    d: "m1929.1 2168.9c0 50.508-21.07 98.273-46.336 98.273s-45.75-40.992-45.75-91.5c0-50.531 34.945-99.75 44.648-206.79 24.562 133.34 48 137.62 47.438 200.02z"
	  }), h$2("path", {
	    id: "path39",
	    fill: "#0ff",
	    d: "m1629.2 1674.7c50.297 73.945 120.94 126.91 188.27 141.12 60.07 12.656 116.44 0.2812 164.86-36.188 36.422-27.445 64.711-65.719 83.883-112.38-111.77 63.492-260.32 60.797-437.02 7.4532z"
	  })));
	} // Original from https://openclipart.org/detail/178504/sad-penguin

	/*
	 <metadata
	 id="metadata29">
	 <rdf:RDF>
	 <cc:Work>
	 <dc:format>image/svg+xml</dc:format>
	 <dc:type
	 rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
	 <cc:license
	 rdf:resource="http://creativecommons.org/licenses/publicdomain/" />
	 <dc:publisher>
	 <cc:Agent
	 rdf:about="http://openclipart.org/">
	 <dc:title>Openclipart</dc:title>
	 </cc:Agent>
	 </dc:publisher>
	 <dc:title>sad penguin</dc:title>
	 <dc:date>2013-05-23T02:08:03</dc:date>
	 <dc:description>A penguin in an outfit reminds us of tux from Linux fame.</dc:description>
	 <dc:source>https://openclipart.org/detail/178504/sad-by-bartm-178504</dc:source>
	 <dc:creator>
	 <cc:Agent>
	 <dc:title>BartM</dc:title>
	 </cc:Agent>
	 </dc:creator>
	 <dc:subject>
	 <rdf:Bag>
	 <rdf:li>animal</rdf:li>
	 <rdf:li>color</rdf:li>
	 <rdf:li>linux</rdf:li>
	 <rdf:li>penguin</rdf:li>
	 <rdf:li>pet</rdf:li>
	 <rdf:li>sad</rdf:li>
	 <rdf:li>tux</rdf:li>
	 </rdf:Bag>
	 </dc:subject>
	 </cc:Work>
	 <cc:License
	 rdf:about="http://creativecommons.org/licenses/publicdomain/">
	 <cc:permits
	 rdf:resource="http://creativecommons.org/ns#Reproduction" />
	 <cc:permits
	 rdf:resource="http://creativecommons.org/ns#Distribution" />
	 <cc:permits
	 rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
	 </cc:License>
	 </rdf:RDF>
	 </metadata>
	 */

	/* eslint max-len: 0 */
	function FlowerPenguin() {
	  return h$2("svg", {
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 3000 3000"
	  }, h$2("path", {
	    fill: "#fff",
	    d: "M1520.9 2453.194c-502.69 0-910.31 244.27-915.91 546.77h1832.2c-5.578-302.51-413.58-546.77-916.24-546.77zM2417.1 1347.394c0 305.39-410.34 552.96-916.5 552.96s-916.48-247.57-916.48-552.96 410.32-552.96 916.48-552.96 916.5 247.57 916.5 552.96z"
	  }), h$2("path", {
	    d: "M1813.5 893.534c14.133 1.219 28.195 3.96 42.844 7.71 148.59 37.993 275.55 201.91 310.92 401.37 10.383 58.642 11.273 147.89 1.828 200.67-23.976 133.95-93.328 232.1-190.05 269.53-39.609 15.329-98.062 19.477-140.27 9.891-100.69-22.875-200.65-111.8-261.47-232.92-29.578-58.875-58.805-155.11-58.594-192.61-4.406-27.047-4.898-30.07-7.336-69.21-3.726-13.899 1.899-87.75 13.547-138.07 25.453-109.66 85.148-193.43 165.16-232.17 40.547-19.642 81.047-27.774 123.42-24.189z"
	  }), h$2("path", {
	    d: "M1435.5 429.184c-191.91 3.117-378.8 60.586-526.97 163.34-211.9 146.93-352.12 372.73-411.26 663.21-2.719 13.359-6.188 31.734-8.063 40.64-1.875 8.907-5.718 31.595-8.062 50.532-2.344 18.96-6.352 50.273-9.14 69.21-6.563 44.485-6.61 206.84 0 247.2 20.202 123.49 42.116 213.66 88.616 364.76 14.133 45.915 17.414 56.93 24.891 84.962 2.086 7.804 9.657 35.156 16.5 60.797 44.016 164.95 47.86 278.65 13.898 386.34-24.867 78.844-64.172 139.27-141.73 216.42-55.57 55.453-118.34 139.12-159.28 223.41h374.25c9.774-22.594 17.602-46.22 26.367-63.727 56.18-112.1 113.13-190.88 193.73-268.08 106.08-101.62 225.54-162.59 368.04-188.23 39.141-7.055 161.62-8.297 200.32-1.828 210.96 35.226 391.27 147.75 535.41 333.98 42.516 54.938 80.79 119.58 115.34 187.88h787.73c-26.555-57.562-71.719-129.66-126.23-207.28-29.93-42.633-69.656-106.95-91.289-132.56-68.719-81.445-126.59-120.8-168.21-175.9-86.508-79.945-76.219-96.54-74.227-208.99 36-179.16 46.29-513.47 36-782.72 3.797-78.61-.492-119.48-4.5-161.02-14.227-146.77-42.07-234.87-99.609-349.73-45.586-90.961-102.96-169.41-178.36-244.62-84.328-84.141-166.08-142.57-275.74-196.66-133.62-65.906-260.79-99.375-416.02-109.5-27.539-1.782-54.984-2.274-82.406-1.829zm-256.3 464.35c42.375-3.586 82.875 4.547 123.42 24.188 79.922 38.672 139.45 122.51 164.79 231.8 17.203 85.758 11.25 207.26 4.406 227.79-9.187 69.914-48.984 170.2-93.398 235.48-60.562 89.039-145.59 152.84-226.66 169.92-72.328 15.258-140.2.328-198.49-43.57-87.75-66.117-136.2-184.27-136.24-331.43-.023-238.97 139.5-460.57 318.98-506.46 14.648-3.75 29.086-6.492 43.195-7.711z"
	  }), h$2("path", {
	    fill: "#333",
	    d: "M1521.2 563.224s-51.422 1268.6-19.031 1801.8c178.76 29.836 260.58 70.336 438.7 215.7 93.234 76.055 266.2 272.65 332.91 419.32h502.43c-46.8-72.3-139.5-212-161.8-238.4-28.476-33.727-67.008-78.984-85.336-100.71-58.219-69-145.27-167.18-180.54-213.87-37.336-36.891-33.586-62.86-32.226-112.43 3.352-132.66 16.312-651.63 26.742-868.29 3.211-66.61 3.398-93.703 0-128.91-12.047-124.36-35.836-210.28-84.609-307.62-38.602-77.086-86.977-143.53-150.87-207.28-71.461-71.297-140.72-120.8-233.65-166.62-113.2-55.828-352.66-92.648-352.66-92.648z"
	  }), h$2("path", {
	    fill: "#fff",
	    d: "M1878.5 1782.294c-81.539-17.203-167.11-81.305-228.02-170.86-44.672-65.648-84.609-166.41-93.844-236.72-6.89-20.648-12.984-142.92 4.289-229.17 25.5-109.92 85.617-194.41 165.98-233.32 54.375-26.297 108.38-31.664 167.34-16.57 416.88 90.492 431.16 973.97-15.75 886.64z"
	  }), h$2("path", {
	    fill: "#ec0",
	    d: "m1427.1 1764.9-13.922 14.812c-27.703 29.344-87.352 49.359-179.11 59.906-100.76 11.602-228.89 5.32-290.3-14.18-30.352-9.633-38.578-7.992-45.844 9.492-22.898 55.22 24.984 159.73 137.55 300.3 71.391 89.156 177.52 196.34 243.94 246.35 25.852 19.477 57.375 34.852 86.766 42.305 23.906 6.07 165.52 4.875 198.96-1.64 11.156-2.18 31.922-6.118 46.102-8.883 77.086-14.883 142.05-52.22 255.87-146.79 102.8-85.43 228.87-226.08 262.55-292.95 24.633-48.891 34.805-122.58 20.016-145.15-8.484-12.938-12.047-13.148-44.578-2.79-31.547 10.032-139.05 20.25-211.9 20.25-30.164 0-78.844-2.812-108.3-6.328-85.758-10.195-135.09-27.773-164.02-58.5l-15.188-16.219zm36.867 32.414c22.336 0 34.852 29.086 26.203 61.172-14.812 55.031-50.695 81.656-72.562 53.836-23.977-30.469 10.078-115.01 46.359-115.01zm84.844 0c24.914 0 54.844 47.391 54.844 86.766 0 33.938-25.781 49.57-50.156 30.398-20.086-15.797-37.758-62.555-33.047-87.656 3.188-17.062 15.188-29.508 28.359-29.508z",
	    style: {
	      fill: "#fbc93d",
	      fillOpacity: 1
	    },
	    transform: "translate(0 -4.406)"
	  }), h$2("path", {
	    d: "M1400.6 1423.694c0 159.16-118.5 288.19-264.66 288.19-146.18 0-264.66-129.02-264.66-288.19 0-159.16 118.48-288.19 264.66-288.19 146.16 0 264.66 129.02 264.66 288.19z"
	  }), h$2("path", {
	    fill: "#fff",
	    d: "M1338.7 1310.794c0 69.75-51.938 126.28-115.97 126.28-64.055 0-115.97-56.531-115.97-126.28 0-69.75 51.914-126.28 115.97-126.28 64.031 0 115.97 56.53 115.97 126.28z"
	  }), h$2("path", {
	    d: "M2158 1423.694c0 159.16-118.48 288.19-264.66 288.19-146.16 0-264.66-129.02-264.66-288.19 0-159.16 118.5-288.19 264.66-288.19 146.18 0 264.66 129.02 264.66 288.19z"
	  }), h$2("path", {
	    fill: "#fff",
	    d: "M2096.1 1310.794c0 69.75-51.914 126.28-115.97 126.28-64.055 0-115.97-56.531-115.97-126.28 0-69.75 51.914-126.28 115.97-126.28 64.055 0 115.97 56.53 115.97 126.28z"
	  }), h$2("path", {
	    d: "M1846 841.894c-46.476-3.961-90.914 4.992-135.4 26.53-87.703 42.446-153.02 134.41-180.82 254.34-18.867 94.103-12.328 227.39-4.828 249.94 319.31-106.43 357.59-127.01 718.45 33.353.047-262.2-153.05-505.36-349.97-555.73-16.102-4.102-31.922-7.125-47.438-8.438z"
	  }), h$2("path", {
	    strokeLinejoin: "round",
	    d: "M2354.1 863.624c-553.64-380.81 28.008-361.78-606.26-139.87-341.25 119.39 46.36 646.29 149.18 299.67 191.09-644.2 352.71-85.148-54.328-619.8-219-287.65-600.33 243.8-238.92 234.47 671.74-17.344 189.98 309.14 572.7-243.19 205.9-297.16-417.4-495.61-296.84-154.78 224.06 633.52-235.31 276.23 408.26 469.52 346.27 103.99 342.37-550.12 55.476-330.14-533.25 408.87-335.41-138.42-320.37 533.37 8.11 361.45 628.99 155.63 331.1-49.242z",
	    stroke: "#f57f05",
	    strokeWidth: 51.801,
	    fill: "#fa9705"
	  }), h$2("path", {
	    strokeLinejoin: "round",
	    d: "M2119.5 611.644c0 62.672-50.812 113.48-113.48 113.48-62.672 0-113.48-50.813-113.48-113.48 0-62.672 50.813-113.48 113.48-113.48 62.672 0 113.48 50.812 113.48 113.48z",
	    stroke: "#f57f05",
	    strokeWidth: 51.801,
	    fill: "#fadc05"
	  }), h$2("path", {
	    fill: "#333",
	    d: "M1154 841.894c46.476-3.961 90.914 4.992 135.4 26.53 87.703 42.446 153.02 134.41 180.82 254.34 18.867 94.103 12.328 227.39 4.828 249.94-319.31-106.43-357.59-127.01-718.45 33.353-.047-262.2 153.05-505.36 349.97-555.73 16.102-4.102 31.922-7.125 47.438-8.438z"
	  }));
	} // Original from https://openclipart.org/detail/178473/flower-by-bartm-178473

	/*
	 <metadata
	 >
	 <rdf:RDF
	 >
	 <cc:Work
	 >
	 <dc:format
	 >image/svg+xml</dc:format
	 >
	 <dc:type
	 rdf:resource="http://purl.org/dc/dcmitype/StillImage"
	 />
	 <cc:license
	 rdf:resource="http://creativecommons.org/licenses/publicdomain/"
	 />
	 <dc:publisher
	 >
	 <cc:Agent
	 rdf:about="http://openclipart.org/"
	 >
	 <dc:title
	 >Openclipart</dc:title
	 >
	 </cc:Agent
	 >
	 </dc:publisher
	 >
	 <dc:title
	 >flower penguin</dc:title
	 >
	 <dc:date
	 >2013-05-23T01:59:09</dc:date
	 >
	 <dc:description
	 >A penguin in an outfit reminds us of tux from Linux fame.</dc:description
	 >
	 <dc:source
	 >https://openclipart.org/detail/178473/flower-by-bartm-178473</dc:source
	 >
	 <dc:creator
	 >
	 <cc:Agent
	 >
	 <dc:title
	 >BartM</dc:title
	 >
	 </cc:Agent
	 >
	 </dc:creator
	 >
	 <dc:subject
	 >
	 <rdf:Bag
	 >
	 <rdf:li
	 >animal</rdf:li
	 >
	 <rdf:li
	 >color</rdf:li
	 >
	 <rdf:li
	 >flower</rdf:li
	 >
	 <rdf:li
	 >linux</rdf:li
	 >
	 <rdf:li
	 >penguin</rdf:li
	 >
	 <rdf:li
	 >pet</rdf:li
	 >
	 <rdf:li
	 >tux</rdf:li
	 >
	 </rdf:Bag
	 >
	 </dc:subject
	 >
	 </cc:Work
	 >
	 <cc:License
	 rdf:about="http://creativecommons.org/licenses/publicdomain/"
	 >
	 <cc:permits
	 rdf:resource="http://creativecommons.org/ns#Reproduction"
	 />
	 <cc:permits
	 rdf:resource="http://creativecommons.org/ns#Distribution"
	 />
	 <cc:permits
	 rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
	 />
	 </cc:License
	 >
	 </rdf:RDF
	 >
	 </metadata
	 >
	 */

	function UttLogo() {
	  return h$2("svg", {
	    className: "utt-balance-logo",
	    version: "1.0",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: "1479.000000pt",
	    height: "1473.000000pt",
	    viewBox: "0 0 1479.000000 1473.000000",
	    preserveAspectRatio: "xMidYMid meet"
	  }, h$2("g", {
	    transform: "translate(0.000000,1473.000000) scale(0.100000,-0.100000)",
	    fill: "#000000",
	    stroke: "none"
	  }, h$2("path", {
	    d: "M7160 13129 c-1271 -39 -2489 -509 -3502 -1351 -163 -135 -568 -540\n-702 -703 -778 -938 -1217 -1991 -1338 -3210 -8 -82 -13 -273 -13 -515 0 -401\n9 -537 56 -845 256 -1708 1264 -3210 2753 -4104 627 -376 1308 -625 2046 -746\n85 -14 158 -21 162 -17 5 5 7 143 6 308 l-3 299 -30 5 -30 5 -3 116 -3 115\n-161 32 c-88 18 -163 30 -167 27 -3 -4 -13 -32 -21 -63 -11 -44 -20 -58 -35\n-60 -18 -2 -533 152 -592 178 -28 12 -29 34 -4 98 l20 49 -123 52 c-67 28\n-127 51 -132 51 -6 0 -21 -23 -34 -50 -13 -28 -29 -55 -36 -61 -9 -7 -89 31\n-291 139 -153 83 -282 156 -287 164 -6 10 2 31 26 70 l36 55 -112 74 c-61 41\n-114 75 -117 77 -4 2 -23 -20 -44 -48 -20 -27 -44 -50 -54 -50 -26 0 -495 386\n-499 411 -3 14 10 35 37 63 l41 42 -99 98 -99 99 -48 -42 c-26 -23 -55 -40\n-63 -39 -15 3 -391 442 -413 482 -9 16 -6 24 18 46 16 14 40 33 53 42 l24 17\n-78 115 -79 115 -51 -29 c-29 -17 -59 -30 -68 -30 -20 0 -311 524 -312 560 0\n20 10 29 50 48 28 13 52 26 54 28 4 4 -97 235 -108 247 -5 4 -34 -2 -65 -14\n-49 -18 -60 -19 -71 -8 -10 11 -125 352 -191 566 -16 52 -5 68 54 78 67 11 67\n9 34 151 l-29 129 -67 -3 c-61 -3 -67 -1 -75 20 -6 13 -26 157 -47 321 -28\n222 -34 301 -26 309 7 7 39 14 73 16 l61 5 -6 45 c-3 24 -6 87 -6 138 l0 94\n-59 0 c-41 0 -62 5 -71 15 -18 22 20 630 41 650 10 9 29 11 69 5 30 -4 56 -7\n57 -6 2 2 43 253 43 266 0 4 -25 14 -55 21 -30 7 -60 18 -65 24 -12 14 140\n609 159 628 8 8 25 7 59 -2 26 -7 53 -14 60 -15 12 -1 101 218 102 250 0 6\n-25 21 -55 33 -38 16 -55 28 -55 41 0 22 255 559 275 579 11 12 22 9 71 -19\n32 -18 60 -28 61 -23 2 5 33 58 68 117 36 60 65 111 65 115 0 3 -23 21 -50 39\n-28 17 -50 38 -50 45 0 20 375 522 393 525 9 2 33 -13 55 -32 22 -20 43 -36\n48 -36 5 0 49 45 98 101 l89 100 -42 43 c-22 23 -41 49 -41 57 0 21 457 439\n480 439 10 0 35 -20 55 -45 l37 -44 106 81 c59 44 109 82 111 84 2 2 -11 25\n-28 52 -17 27 -31 55 -31 64 0 12 493 325 540 342 22 8 34 -3 60 -54 12 -25\n23 -46 25 -48 1 -1 59 25 128 58 l125 61 -23 57 c-24 60 -24 77 3 87 354 137\n578 216 591 208 8 -5 22 -30 30 -55 9 -26 19 -50 23 -53 6 -6 51 5 214 51 l52\n15 -9 37 c-5 20 -9 52 -9 69 0 39 -37 29 338 93 212 37 297 48 307 40 7 -6 16\n-37 19 -71 6 -50 10 -59 24 -55 9 3 69 8 132 11 63 3 130 8 148 11 l32 5 0 64\nc0 35 4 67 10 70 16 10 632 -14 646 -26 8 -7 10 -28 7 -69 -3 -33 -4 -60 -2\n-61 109 -15 300 -39 315 -39 18 0 23 9 33 60 7 33 16 62 22 65 16 11 631 -138\n637 -154 5 -13 -7 -71 -23 -112 -5 -14 15 -24 117 -59 68 -23 128 -44 133 -46\n6 -2 21 23 34 56 13 32 29 61 35 63 14 6 24 1 336 -139 208 -93 260 -120 260\n-136 0 -10 -11 -41 -25 -68 l-25 -49 115 -65 c63 -36 119 -66 124 -66 5 0 24\n23 42 51 25 39 37 50 53 47 32 -7 526 -359 526 -375 0 -8 -16 -34 -36 -58 -20\n-25 -34 -48 -32 -53 1 -5 48 -48 104 -95 l101 -86 44 45 c24 24 50 44 59 44\n20 0 450 -446 450 -467 0 -8 -21 -34 -47 -57 l-46 -42 83 -105 c45 -57 84\n-106 86 -108 2 -2 27 13 56 33 29 20 58 36 65 36 15 0 346 -509 351 -540 3\n-22 -4 -29 -52 -55 -31 -16 -55 -33 -53 -36 1 -3 29 -59 62 -123 43 -83 64\n-115 75 -112 8 2 36 12 61 22 25 9 53 15 61 12 18 -7 253 -582 245 -601 -3 -7\n-33 -22 -67 -32 -53 -16 -61 -22 -57 -39 5 -24 70 -239 74 -245 1 -2 32 3 68\n10 44 9 69 9 75 3 6 -6 38 -149 71 -318 46 -230 58 -310 50 -320 -6 -7 -39\n-17 -73 -20 l-61 -7 6 -57 c3 -31 9 -94 13 -139 l7 -83 72 0 c57 0 74 -3 79\n-16 3 -9 6 -154 6 -324 0 -254 -2 -310 -14 -319 -10 -8 -34 -10 -74 -5 l-60 6\n-6 -38 c-3 -22 -8 -77 -11 -124 -4 -47 -9 -92 -11 -102 -4 -13 8 -18 66 -28\n38 -6 72 -16 76 -21 8 -14 -107 -622 -121 -637 -10 -11 -23 -10 -75 3 -34 9\n-63 15 -65 13 -4 -5 -75 -246 -75 -257 0 -5 27 -19 61 -31 33 -13 63 -29 66\n-36 3 -7 -48 -146 -112 -309 -95 -240 -120 -295 -136 -295 -10 0 -43 11 -72\n24 l-54 23 -62 -125 c-35 -70 -59 -128 -54 -129 30 -10 108 -72 107 -84 -1 -9\n-77 -134 -169 -277 -113 -177 -172 -262 -184 -262 -10 0 -40 16 -66 35 -27 19\n-52 31 -56 27 -29 -30 -159 -205 -159 -212 0 -5 20 -26 45 -47 25 -20 45 -45\n45 -55 0 -16 -405 -453 -437 -472 -11 -6 -29 5 -67 43 l-52 51 -25 -26 c-13\n-14 -59 -56 -102 -92 -74 -62 -77 -66 -62 -86 64 -87 68 -96 55 -112 -27 -31\n-500 -364 -519 -364 -13 0 -31 19 -54 54 l-34 55 -83 -50 c-46 -28 -101 -59\n-122 -70 l-38 -19 31 -61 c17 -34 28 -67 26 -73 -7 -18 -576 -279 -593 -272\n-8 3 -18 16 -23 28 -5 13 -16 39 -24 60 l-15 36 -128 -44 c-71 -25 -130 -46\n-131 -48 -2 -1 4 -25 12 -52 25 -83 22 -91 -37 -108 -159 -45 -567 -138 -580\n-133 -10 3 -20 30 -28 71 -10 54 -16 66 -29 62 -9 -2 -35 -8 -58 -11 l-43 -7\n0 -98 c0 -119 -4 -130 -41 -130 l-29 0 0 -315 0 -316 33 6 c17 3 95 14 172 26\n1061 156 2090 637 2921 1366 465 406 877 907 1193 1448 622 1064 883 2316 741\n3558 -256 2239 -1813 4135 -3971 4836 -630 204 -1271 291 -1979 270z m130\n-259 c15 -15 20 -33 20 -69 0 -42 -4 -53 -26 -70 -35 -27 -59 -26 -89 4 -37\n36 -31 120 9 147 21 14 66 8 86 -12z m201 1 c19 -16 24 -29 24 -69 0 -61 -23\n-92 -70 -92 -56 0 -87 59 -65 124 18 57 67 73 111 37z m191 -59 c-2 -67 0 -74\n18 -79 11 -3 20 -12 20 -20 0 -12 -8 -14 -37 -9 -21 3 -48 6 -60 6 -14 0 -23\n6 -23 15 0 8 9 15 20 15 18 0 20 7 20 55 0 48 -2 55 -20 55 -11 0 -20 5 -20\n10 0 14 39 30 65 27 18 -2 20 -8 17 -75z m-764 23 c5 -82 12 -105 32 -105 11\n0 20 -7 20 -15 0 -11 -12 -15 -44 -15 -24 0 -51 -3 -60 -6 -10 -4 -16 -1 -16\n9 0 8 7 17 15 21 11 4 15 21 15 61 0 52 -1 55 -25 55 -31 0 -33 18 -2 30 44\n18 62 9 65 -35z m148 37 c35 -23 45 -102 18 -140 -11 -16 -25 -22 -54 -22 -29\n0 -43 6 -54 22 -21 30 -21 106 1 130 16 18 68 24 89 10z m778 -24 c25 -36 21\n-104 -9 -133 -30 -30 -54 -31 -89 -4 -20 16 -26 29 -26 60 0 41 14 78 34 91\n24 16 75 8 90 -14z m-1059 -45 c3 -32 7 -65 8 -73 1 -8 11 -15 21 -15 28 0 31\n-23 4 -29 -58 -12 -98 -12 -98 1 0 8 7 16 15 19 16 6 20 50 8 92 -4 17 -11 22\n-24 19 -24 -7 -25 18 -1 32 9 6 27 11 39 11 19 0 22 -7 28 -57z m-140 -33 c7\n-65 9 -70 31 -70 25 0 36 -29 12 -31 -7 0 -34 -4 -60 -8 -37 -6 -48 -5 -53 7\n-3 8 3 16 15 19 21 6 23 17 14 76 -5 27 -12 37 -25 37 -10 0 -20 4 -24 9 -8\n13 24 30 56 31 26 0 27 -3 34 -70z m1494 43 c0 -16 -4 -50 -8 -77 -7 -43 -6\n-49 10 -53 11 -3 19 -11 19 -19 0 -10 -11 -12 -47 -8 -27 3 -54 7 -60 10 -20\n6 -15 24 7 24 19 0 21 7 34 98 2 16 -2 22 -15 22 -11 0 -19 7 -19 15 0 11 11\n15 40 15 37 0 40 -2 39 -27z m157 -28 c20 -31 14 -97 -12 -126 -17 -19 -68\n-26 -91 -11 -33 21 -37 91 -7 140 21 33 87 31 110 -3z m-1931 -19 c38 -57 28\n-128 -21 -146 -52 -20 -104 33 -104 105 0 60 93 91 125 41z m2125 -6 c37 -37\n17 -140 -29 -155 -28 -9 -70 4 -81 25 -17 32 -12 95 11 124 25 32 70 35 99 6z\nm-2357 -21 c30 -14 47 -48 47 -96 0 -47 -24 -73 -66 -73 -44 0 -74 38 -74 94\n0 54 11 68 67 85 1 1 13 -4 26 -10z m2566 -24 c21 -20 17 -92 -6 -123 -27 -36\n-74 -41 -104 -11 -18 18 -20 29 -16 67 9 79 77 115 126 67z m-2699 -65 c14\n-56 19 -65 39 -64 39 1 19 -28 -29 -42 -25 -8 -51 -14 -57 -14 -21 0 -15 27 6\n33 19 5 19 7 4 58 -19 65 -19 65 -37 50 -11 -9 -15 -8 -19 4 -7 16 37 46 63\n42 8 -1 20 -27 30 -67z m2900 10 c24 -24 25 -58 5 -105 -37 -90 -149 -48 -131\n49 4 20 16 46 27 57 25 25 74 24 99 -1z m-3098 -11 c22 -12 48 -66 48 -103 0\n-29 -42 -66 -75 -66 -33 0 -67 43 -72 93 -4 37 -2 48 18 66 25 23 50 27 81 10z\nm3299 -40 c44 -44 2 -159 -58 -159 -29 0 -73 42 -73 70 0 32 26 87 47 99 29\n17 61 13 84 -10z m-3441 -54 c19 -57 25 -65 47 -65 46 0 18 -22 -77 -60 -129\n-51 -140 -54 -140 -39 0 6 7 17 15 23 13 10 13 17 -2 63 -15 47 -19 52 -40 47\n-29 -8 -30 10 -1 30 40 28 53 20 77 -49 20 -56 27 -65 45 -63 11 2 29 11 40\n20 17 16 17 19 1 67 -17 53 -23 59 -42 40 -7 -7 -12 -6 -16 5 -6 15 33 45 60\n46 6 0 21 -29 33 -65z m3648 -44 c12 -33 -8 -99 -35 -118 -49 -37 -120 10\n-107 71 8 42 31 75 57 85 33 12 74 -6 85 -38z m-3904 -51 c23 -57 31 -69 48\n-67 39 4 29 -21 -14 -36 -24 -8 -51 -18 -60 -22 -13 -5 -18 -2 -18 9 0 9 7 19\n15 22 16 7 15 18 -11 81 -13 29 -17 32 -34 23 -14 -7 -20 -7 -20 0 0 5 -1 13\n-2 16 -2 5 59 44 68 44 0 0 13 -31 28 -70z m4081 -5 c14 -13 25 -31 25 -40 0\n-31 -29 -84 -54 -100 -22 -15 -31 -16 -57 -5 -17 7 -35 23 -39 36 -19 49 30\n134 77 134 13 0 35 -11 48 -25z m-4245 -42 c42 -54 34 -127 -15 -139 -47 -12\n-75 4 -97 52 -17 39 -18 50 -8 74 13 30 52 50 83 42 9 -2 26 -16 37 -29z\nm4534 -73 c7 -7 1 -29 -17 -65 -28 -58 -34 -85 -17 -85 6 0 10 -7 10 -16 0 -9\n-6 -14 -12 -11 -81 32 -98 41 -98 54 0 11 7 13 23 9 20 -5 26 1 45 40 26 53\n27 64 7 64 -8 0 -15 7 -15 16 0 13 7 15 32 10 18 -3 37 -11 42 -16z m-4779\n-59 c25 -53 31 -60 52 -55 43 11 25 -22 -26 -46 -51 -24 -91 -19 -56 6 18 13\n18 16 -5 64 -23 50 -33 59 -45 40 -7 -12 -25 -4 -25 11 0 11 61 50 70 44 3 -2\n19 -31 35 -64z m4903 -7 c33 -23 30 -84 -6 -125 -68 -77 -155 -3 -107 91 26\n50 71 64 113 34z m-5090 -40 c28 -19 52 -65 52 -98 0 -27 -41 -66 -70 -66 -51\n0 -105 93 -80 139 20 38 64 49 98 25z m5255 -45 c14 -6 30 -23 36 -36 10 -22\n8 -33 -11 -72 -27 -55 -63 -72 -103 -51 -47 25 -45 91 5 141 32 32 38 34 73\n18z m-5432 -49 c21 -12 59 -79 59 -105 0 -23 -46 -65 -71 -65 -34 0 -89 62\n-89 102 0 38 7 50 35 66 25 14 41 15 66 2z m5608 -51 c17 -6 31 -15 31 -21 0\n-5 -15 -36 -34 -68 -31 -53 -33 -59 -18 -74 28 -28 3 -31 -44 -6 -51 28 -58\n35 -49 50 4 7 12 7 23 1 13 -8 22 0 44 37 32 54 34 62 13 62 -16 0 -20 12 -8\n23 8 9 4 9 42 -4z m-5738 -74 c29 -47 37 -55 56 -50 39 9 26 -18 -22 -48 -47\n-30 -79 -29 -51 2 13 15 12 21 -15 65 -23 36 -33 46 -42 37 -15 -15 -27 -14\n-27 3 0 17 49 58 60 51 4 -2 22 -30 41 -60z m5856 -3 l32 -17 -40 -64 c-37\n-59 -39 -64 -22 -76 12 -10 15 -17 8 -24 -10 -10 -63 17 -99 50 -15 13 4 31\n20 18 17 -14 14 -16 48 38 30 49 32 63 11 63 -16 0 -20 12 -8 23 9 10 14 9 50\n-11z m-6019 -58 c48 -33 67 -108 35 -136 -44 -37 -91 -28 -123 24 -28 46 -26\n82 6 107 32 25 52 26 82 5z m6165 -36 c23 -27 22 -58 -6 -99 -32 -47 -69 -59\n-105 -32 -15 11 -28 30 -30 42 -5 35 18 82 52 102 35 21 63 17 89 -13z m-6294\n-88 c34 -48 46 -59 57 -50 13 12 34 6 34 -9 0 -4 -21 -22 -46 -40 -35 -24 -49\n-30 -58 -21 -8 8 -7 15 5 24 15 10 13 16 -19 60 -31 42 -37 46 -47 32 -11 -14\n-14 -14 -24 -2 -9 11 -5 19 19 40 18 14 33 26 34 26 2 0 22 -27 45 -60z m6461\n-20 c30 -30 25 -73 -11 -115 -36 -41 -77 -47 -109 -15 -24 24 -25 51 -5 90 30\n58 88 77 125 40z m-6561 -61 c35 -49 46 -58 58 -48 9 9 17 9 24 2 8 -8 -4 -22\n-37 -47 -31 -24 -51 -33 -57 -27 -7 7 -6 15 2 25 11 13 7 23 -20 61 -30 42\n-34 44 -50 29 -30 -28 -34 5 -3 37 15 16 30 29 33 29 3 0 26 -28 50 -61z\nm6712 -58 l23 -19 -43 -56 c-35 -47 -40 -60 -30 -72 7 -9 9 -18 3 -24 -5 -5\n-26 4 -51 23 -48 36 -57 63 -19 53 20 -5 30 1 57 35 30 38 31 43 16 54 -17 12\n-13 25 9 25 6 0 22 -8 35 -19z m-6845 -47 c58 -61 39 -134 -34 -134 -73 0\n-121 102 -70 150 33 30 66 25 104 -16z m7042 -110 c35 -24 30 -80 -10 -121\n-37 -38 -74 -43 -106 -13 -26 24 -28 50 -7 90 29 56 80 75 123 44z m-7292 -88\nc60 -60 42 -136 -32 -136 -24 0 -39 9 -63 35 -39 45 -41 86 -5 114 37 29 61\n26 100 -13z m7442 -56 l24 -20 -47 -55 c-40 -46 -45 -57 -35 -70 9 -11 10 -19\n3 -26 -8 -8 -25 1 -57 32 -31 28 -43 46 -37 52 7 7 16 5 27 -4 15 -12 21 -9\n55 31 31 36 36 46 24 53 -8 4 -15 12 -15 17 0 17 34 10 58 -10z m-7603 -70\nc64 -39 71 -124 12 -144 -38 -14 -77 2 -104 43 -29 43 -29 66 2 96 29 30 48\n31 90 5z m7702 -24 l28 -25 -53 -54 c-47 -48 -51 -55 -37 -67 11 -9 13 -16 5\n-24 -11 -11 -90 59 -90 81 0 16 12 17 28 1 10 -10 21 -3 55 30 38 39 40 44 24\n53 -17 10 -15 29 3 29 5 0 22 -11 37 -24z m123 -115 c0 -4 -22 -29 -50 -56\n-33 -33 -47 -52 -40 -59 15 -15 12 -36 -4 -36 -14 0 -76 64 -76 79 0 16 14 21\n27 9 11 -9 22 -3 53 27 36 36 38 40 24 56 -12 13 -12 18 -2 22 13 4 68 -29 68\n-42z m-7948 -29 c38 -38 44 -72 18 -105 -29 -37 -69 -36 -115 4 -45 40 -49 87\n-8 119 33 26 67 20 105 -18z m8041 -74 c18 -24 18 -30 7 -58 -27 -65 -99 -91\n-140 -50 -30 30 -25 67 15 107 43 43 87 43 118 1z m-8223 -48 c5 0 22 -14 39\n-31 53 -53 30 -129 -39 -129 -35 0 -100 59 -100 91 0 44 44 85 78 73 8 -2 17\n-4 22 -4z m8345 -95 c33 -33 31 -59 -7 -100 -43 -45 -76 -52 -111 -25 -45 36\n-33 94 26 130 42 26 63 25 92 -5z m-8430 -107 c30 -36 31 -57 4 -92 -28 -36\n-69 -34 -114 5 -53 47 -45 112 15 131 25 8 68 -12 95 -44z m8570 -54 l24 -26\n-54 -45 c-47 -37 -54 -48 -49 -69 10 -38 -17 -29 -53 19 -32 41 -31 74 1 48\n12 -11 22 -7 56 20 42 34 47 43 30 54 -12 7 -4 25 11 25 6 0 21 -12 34 -26z\nm-8707 -65 c49 -37 56 -40 67 -26 8 12 15 13 23 5 7 -7 1 -24 -26 -59 -36 -49\n-58 -55 -48 -14 5 19 -2 29 -36 54 -40 29 -44 30 -55 14 -10 -12 -16 -14 -24\n-6 -8 8 -6 20 7 42 10 17 23 31 28 31 5 0 34 -19 64 -41z m8785 -37 l28 -29\n-61 -47 c-50 -40 -59 -51 -49 -62 8 -10 9 -18 2 -25 -6 -6 -22 6 -47 37 -23\n31 -33 51 -27 57 7 7 15 6 25 -2 13 -11 23 -7 61 20 41 29 44 34 30 49 -14 15\n-11 30 5 30 3 0 18 -13 33 -28z m-8868 -113 c25 -22 35 -39 35 -60 0 -37 -32\n-69 -70 -69 -40 0 -100 53 -100 89 0 74 72 95 135 40z m9014 -95 c29 -37 26\n-61 -10 -95 -54 -51 -107 -50 -134 1 -20 38 -6 73 37 100 46 28 82 26 107 -6z\nm-9136 -69 c46 -32 57 -67 30 -103 -23 -32 -53 -38 -94 -21 -34 14 -69 54 -69\n79 0 10 9 29 21 44 26 33 63 34 112 1z m9252 -100 c14 -13 25 -33 25 -43 0\n-44 -71 -98 -121 -90 -12 2 -31 15 -42 30 -20 26 -20 30 -5 61 16 33 66 66\n101 67 10 0 29 -11 42 -25z m-9438 -146 c43 -16 73 -49 73 -81 0 -36 -32 -68\n-67 -68 -34 0 -88 31 -103 60 -15 28 2 73 33 88 29 14 31 14 64 1z m9553 -30\nc12 -16 21 -31 19 -33 -2 -1 -32 -20 -67 -40 -53 -32 -61 -40 -51 -53 10 -12\n10 -16 -1 -23 -11 -7 -22 4 -43 40 -16 27 -25 55 -21 61 5 9 11 7 20 -6 13\n-18 15 -18 47 0 60 32 71 43 59 58 -11 13 -7 27 9 27 4 0 17 -14 29 -31z m58\n-116 c51 -44 27 -112 -48 -134 -33 -10 -43 -9 -64 5 -51 33 -43 90 17 126 40\n25 69 25 95 3z m-9687 -50 c70 -42 54 -132 -24 -133 -80 0 -131 71 -91 128 19\n27 73 30 115 5z m-94 -154 c51 -22 53 -22 66 -4 26 35 31 -5 7 -56 -24 -51\n-57 -69 -46 -26 5 20 -1 26 -40 45 -53 26 -64 27 -64 7 0 -8 -7 -15 -15 -15\n-18 0 -19 18 -5 55 12 30 15 30 97 -6z m9878 11 c26 -29 22 -70 -9 -97 -71\n-61 -162 -28 -142 52 14 55 115 85 151 45z m-9944 -137 c56 -24 63 -25 73 -11\n7 10 17 13 24 9 9 -6 7 -20 -10 -59 -23 -52 -56 -74 -45 -29 5 19 -1 25 -41\n42 -25 11 -49 21 -53 23 -4 2 -9 -7 -12 -19 -7 -25 -27 -16 -27 12 0 20 17 59\n25 59 2 0 32 -12 66 -27z m10029 -43 c42 -42 21 -100 -45 -126 -45 -17 -47\n-17 -73 3 -49 36 -39 97 20 126 44 22 74 21 98 -3z m-10072 -120 c42 -26 57\n-57 42 -94 -5 -15 -19 -30 -30 -33 -15 -4 -18 -9 -10 -18 8 -9 5 -27 -9 -61\n-19 -49 -49 -68 -43 -28 2 18 -6 25 -44 38 -58 20 -64 20 -64 1 0 -8 -7 -15\n-15 -15 -18 0 -20 29 -4 63 l11 24 65 -25 c45 -17 68 -21 75 -14 14 14 1 32\n-22 32 -10 0 -32 12 -49 26 -37 31 -40 68 -9 101 26 28 63 29 106 3z m10166\n-79 c28 -31 18 -81 -23 -108 -42 -28 -85 -29 -111 -3 -20 20 -26 65 -12 86 31\n44 116 59 146 25z m66 -191 c20 -20 26 -65 12 -86 -30 -43 -116 -59 -144 -26\n-39 44 -25 91 35 117 45 20 74 18 97 -5z m-10349 -47 c49 -29 52 -82 7 -116\n-33 -25 -84 -17 -123 19 -23 21 -26 31 -21 57 3 18 14 38 23 45 24 17 80 15\n114 -5z m-54 -203 c40 -24 51 -61 29 -94 -19 -30 -47 -40 -90 -32 -44 8 -76\n40 -76 76 0 64 72 90 137 50z m10507 -46 c25 -24 30 -61 12 -88 -18 -29 -77\n-50 -111 -42 -34 9 -59 49 -51 81 13 52 115 85 150 49z m66 -214 c7 -17 10\n-33 7 -37 -4 -3 -35 -13 -69 -23 -53 -15 -63 -21 -62 -39 0 -14 -5 -21 -15\n-19 -15 3 -44 94 -35 110 9 14 21 9 27 -12 5 -19 7 -19 54 -5 26 8 52 15 57\n15 4 0 5 7 2 16 -7 18 1 37 13 29 5 -2 14 -18 21 -35z m-10650 -49 c33 -24 38\n-73 11 -100 -40 -40 -144 -17 -157 35 -20 77 71 118 146 65z m10689 -82 c15\n-44 15 -46 -21 -53 -85 -17 -108 -27 -108 -46 0 -11 -6 -20 -13 -20 -14 0 -41\n95 -31 111 9 16 24 10 24 -11 0 -17 5 -19 33 -13 74 14 82 19 79 41 -5 34 24\n27 37 -9z m-10739 -114 c33 -17 44 -42 34 -79 -19 -78 -174 -54 -174 26 0 17\n7 40 17 50 20 22 82 24 123 3z m10748 -11 c31 -22 31 -88 0 -108 -35 -22 -84\n-29 -110 -15 -31 16 -38 28 -38 67 0 26 6 36 33 52 39 24 84 26 115 4z\nm-10728 -138 c0 -48 -14 -106 -26 -106 -8 0 -14 9 -14 19 0 21 -10 26 -79 36\n-40 7 -43 6 -36 -14 4 -15 2 -21 -9 -21 -19 0 -29 31 -20 65 4 16 12 24 20 21\n7 -3 40 -8 73 -12 53 -6 61 -4 61 10 0 9 7 16 15 16 8 0 15 -6 15 -14z m10773\n-74 c10 -9 17 -29 17 -49 0 -27 -6 -37 -32 -53 -61 -37 -129 -18 -143 41 -16\n66 100 111 158 61z m-10871 -112 c62 -18 79 -82 32 -119 -31 -25 -62 -26 -109\n-7 -71 30 -49 131 30 135 6 1 27 -4 47 -9z m10912 -102 c14 -52 10 -56 -64\n-63 -59 -6 -70 -10 -70 -25 0 -19 -17 -36 -26 -27 -3 3 -8 30 -11 61 -6 56 6\n75 25 40 7 -13 19 -15 64 -9 48 6 55 10 51 26 -4 12 0 19 10 19 8 0 17 -10 21\n-22z m-10899 -123 c30 -30 31 -54 4 -89 -27 -34 -93 -37 -133 -5 -34 27 -36\n81 -4 103 36 25 104 21 133 -9z m10919 -23 c5 -18 7 -34 4 -37 -2 -3 -36 -8\n-74 -12 -61 -7 -69 -11 -72 -30 -2 -13 -7 -23 -13 -23 -10 0 -16 25 -22 83 -3\n37 15 53 27 22 6 -16 60 -20 103 -9 19 5 21 9 12 26 -9 17 -8 19 7 16 11 -2\n22 -17 28 -36z m-10894 -114 c0 -50 -13 -98 -26 -98 -8 0 -14 9 -14 20 0 17\n-7 20 -39 20 -22 0 -46 3 -55 6 -12 4 -16 0 -16 -15 0 -12 -6 -21 -14 -21 -16\n0 -26 32 -19 61 6 20 11 21 76 16 63 -5 70 -4 74 13 7 28 33 25 33 -2z m10902\n-10 c8 -14 12 -35 8 -58 -8 -57 -109 -79 -155 -34 -19 20 -19 78 0 94 36 30\n127 28 147 -2z m-10922 -168 c0 -47 -3 -60 -15 -60 -8 0 -15 9 -15 20 0 18 -7\n20 -59 20 -54 0 -59 -2 -54 -20 4 -14 0 -20 -10 -20 -17 0 -34 60 -23 78 3 5\n37 7 76 4 66 -4 70 -4 70 17 0 12 6 21 15 21 12 0 15 -13 15 -60z m10924 -131\nc32 -25 35 -70 5 -100 -16 -16 -30 -19 -71 -17 -42 2 -55 8 -71 30 -54 72 62\n146 137 87z m-10942 -29 c53 -66 -28 -144 -115 -111 -56 22 -60 100 -7 129 35\n18 101 8 122 -18z m10818 -200 c0 -18 7 -20 61 -20 56 0 60 2 54 20 -4 14 -2\n20 8 20 17 0 27 -21 27 -56 0 -23 -2 -24 -75 -24 -68 0 -75 -2 -75 -20 0 -11\n-7 -20 -15 -20 -12 0 -15 13 -15 60 0 47 3 60 15 60 8 0 15 -9 15 -20z\nm-10800 -34 c0 -7 3 -34 6 -60 6 -37 4 -46 -8 -46 -9 0 -18 8 -20 18 -4 14\n-14 16 -62 14 -51 -4 -57 -6 -53 -23 3 -12 0 -19 -8 -19 -17 0 -21 6 -29 47\nl-7 31 75 7 c65 6 76 10 76 26 0 11 7 19 15 19 8 0 15 -6 15 -14z m10800 -96\nc0 -18 7 -20 59 -20 54 0 59 2 54 20 -4 13 0 20 10 20 15 0 33 -62 22 -80 -3\n-5 -36 -6 -76 -3 -66 6 -70 5 -76 -16 -11 -41 -23 -20 -23 39 0 47 3 60 15 60\n8 0 15 -9 15 -20z m-10790 -59 c0 -16 3 -43 6 -60 5 -24 3 -31 -10 -31 -9 0\n-16 7 -16 15 0 12 -13 15 -61 15 -56 0 -61 -2 -56 -20 6 -22 -10 -37 -23 -24\n-5 5 -12 26 -15 47 l-7 37 45 0 c73 0 107 10 107 31 0 11 7 19 15 19 10 0 15\n-10 15 -29z m10780 -81 c0 -14 7 -20 24 -20 13 0 38 -3 55 -6 27 -6 31 -4 31\n15 0 12 6 21 15 21 11 0 15 -11 15 -41 l0 -42 -75 7 c-71 6 -75 6 -75 -14 0\n-12 -7 -20 -16 -20 -14 0 -16 8 -10 46 3 26 6 53 6 60 0 8 7 14 15 14 8 0 15\n-9 15 -20z m-10765 -32 c2 -7 5 -34 8 -60 3 -37 1 -48 -10 -48 -7 0 -16 7 -19\n15 -6 16 -50 20 -92 8 -17 -4 -22 -11 -19 -24 7 -25 -19 -25 -33 0 -26 50 -6\n71 72 71 49 0 68 9 68 31 0 21 18 26 25 7z m10875 -93 c26 -23 25 -70 0 -95\n-30 -30 -103 -28 -135 5 -32 31 -32 59 1 92 22 22 32 25 70 20 25 -2 54 -13\n64 -22z m-10869 -47 c0 -7 4 -34 8 -60 6 -37 5 -48 -7 -53 -8 -3 -16 3 -19 15\n-6 22 -10 23 -76 14 -41 -6 -45 -9 -36 -25 8 -16 6 -19 -9 -19 -12 0 -22 9\n-26 23 -14 52 -10 55 64 63 65 6 70 8 70 30 0 25 29 35 31 12z m10719 -168 c0\n-20 9 -24 83 -34 32 -4 37 -2 37 15 0 10 7 19 15 19 19 0 21 -68 2 -75 -7 -3\n-41 -1 -76 3 -58 8 -64 7 -68 -9 -3 -11 -11 -19 -19 -19 -10 0 -12 11 -8 48 3\n26 7 53 10 60 6 19 24 14 24 -8z m-10697 -62 c39 -52 -3 -109 -83 -110 -51 -1\n-80 23 -80 67 0 50 37 75 104 72 29 -2 44 -9 59 -29z m10795 -64 c33 -21 31\n-87 -3 -110 -31 -20 -97 -14 -126 12 -37 33 -19 99 31 117 21 7 71 -3 98 -19z\nm-10758 -80 c9 -42 9 -59 1 -67 -9 -9 -13 -6 -18 11 -4 18 -11 22 -27 18 -11\n-2 -37 -8 -57 -11 -30 -6 -36 -10 -32 -26 4 -13 0 -19 -11 -19 -14 0 -38 56\n-30 71 2 3 35 11 74 18 58 11 70 16 65 29 -4 12 8 31 22 32 1 0 7 -25 13 -56z\nm36 -190 c-8 -21 -26 -17 -26 6 0 23 0 23 -65 7 -43 -12 -50 -17 -47 -35 5\n-34 -17 -26 -34 13 -7 19 -14 36 -14 39 0 3 33 12 74 21 59 13 73 20 69 32 -3\n8 0 19 8 24 11 6 17 -3 27 -43 7 -28 11 -57 8 -64z m10574 67 c0 -25 5 -27 63\n-36 39 -6 47 -5 47 9 0 9 7 16 15 16 11 0 15 -11 15 -41 0 -41 0 -41 -32 -35\n-90 18 -117 19 -124 2 -3 -9 -13 -16 -21 -16 -9 0 -13 6 -10 14 3 7 9 34 12\n60 5 29 12 46 21 46 8 0 14 -9 14 -19z m-10545 -195 c37 -56 -7 -118 -84 -120\n-45 -1 -66 14 -76 56 -6 22 -1 33 23 58 25 25 39 30 76 30 37 0 48 -4 61 -24z\nm10613 -61 c17 -21 22 -35 17 -54 -10 -41 -31 -56 -76 -55 -81 3 -127 76 -78\n125 31 31 104 22 137 -16z m-10535 -188 c9 -30 17 -57 17 -60 0 -13 -23 -7\n-35 9 -12 17 -13 17 -103 -12 -10 -3 -10 -9 -2 -24 9 -17 8 -20 -8 -20 -21 0\n-51 55 -38 68 4 4 35 16 69 28 53 18 62 24 59 42 -7 45 25 21 41 -31z m10362\n10 c-5 -20 -1 -24 40 -35 59 -16 75 -15 75 3 0 8 5 15 10 15 15 0 12 -70 -3\n-76 -7 -2 -35 2 -62 11 -63 19 -85 19 -85 0 0 -8 -7 -15 -15 -15 -19 0 -19 0\n1 66 9 33 21 54 30 54 10 0 13 -7 9 -23z m-10330 -128 c25 -72 27 -79 14 -79\n-6 0 -17 7 -24 16 -11 15 -16 15 -63 0 -54 -18 -60 -24 -41 -43 7 -7 6 -12 -5\n-16 -9 -4 -21 2 -31 16 -28 40 -20 54 50 77 57 19 65 25 65 47 0 35 21 24 35\n-18z m10287 -6 c-2 -15 6 -22 39 -32 22 -7 47 -15 54 -17 7 -3 15 4 18 15 8\n33 27 24 27 -11 0 -54 -8 -58 -75 -37 -73 23 -85 23 -85 4 0 -8 -7 -15 -15\n-15 -19 0 -19 15 1 74 16 45 42 60 36 19z m-10233 -138 c12 -31 21 -58 21 -60\n0 -11 -24 -4 -34 10 -10 13 -17 13 -63 -2 -47 -15 -52 -19 -47 -40 8 -29 -10\n-30 -30 -1 -28 40 -20 52 49 77 47 16 65 28 64 40 -5 52 16 39 40 -24z m10266\n21 c86 -36 78 -136 -11 -136 -90 0 -135 70 -79 125 28 29 43 30 90 11z\nm-10215 -196 c20 -20 26 -65 12 -86 -16 -24 -59 -44 -93 -44 -46 0 -72 26 -67\n71 6 64 104 103 148 59z m10080 -4 c0 -18 9 -27 43 -40 53 -20 67 -20 67 -1 0\n16 15 20 24 7 3 -5 1 -25 -5 -45 l-9 -35 -62 24 c-72 28 -88 30 -88 8 0 -9 -6\n-14 -12 -11 -16 5 -14 31 7 80 17 42 35 49 35 13z m-54 -130 c-4 -17 -1 -25\n12 -29 9 -3 34 -12 55 -21 37 -16 39 -16 44 3 3 11 11 17 18 15 10 -4 10 -14\n2 -45 -7 -31 -13 -39 -26 -34 -121 49 -121 49 -136 29 -24 -33 -28 7 -6 59 21\n49 48 66 37 23z m-9952 -47 c53 -41 18 -120 -59 -135 -41 -7 -70 8 -83 43 -19\n55 27 104 104 112 6 0 23 -8 38 -20z m9983 -88 c37 -23 47 -49 34 -84 -21 -54\n-94 -60 -145 -12 -29 27 -33 60 -10 93 19 28 76 30 121 3z m-9878 -112 c20\n-36 7 -75 -32 -99 -46 -29 -91 -26 -116 6 -29 36 -27 50 14 91 30 30 40 34 77\n31 33 -2 45 -8 57 -29z m9792 -72 c42 -28 51 -75 20 -106 -45 -45 -143 -6\n-149 58 -7 68 62 93 129 48z m-9727 -44 c28 -49 28 -96 1 -59 -14 19 -16 19\n-55 1 -47 -21 -66 -40 -50 -50 15 -9 12 -25 -4 -25 -14 0 -56 45 -56 59 0 4\n29 21 65 39 57 28 64 34 56 51 -10 18 -6 31 10 31 4 0 19 -21 33 -47z m91\n-178 c32 -31 31 -57 -2 -95 -20 -22 -40 -33 -69 -37 -36 -5 -43 -2 -63 23 -34\n44 -19 86 44 118 42 22 62 20 90 -9z m9486 -58 c29 -19 34 -29 34 -61 0 -30\n-6 -43 -26 -59 -24 -17 -31 -18 -63 -7 -68 22 -97 89 -56 130 26 26 69 25 111\n-3z m-178 -144 c4 -3 2 -12 -5 -20 -13 -16 -15 -13 39 -47 49 -30 63 -32 63\n-10 0 9 6 14 13 11 15 -5 11 -47 -8 -66 -12 -12 -22 -9 -76 23 -56 33 -62 35\n-74 20 -6 -9 -17 -14 -23 -10 -8 5 -1 23 19 56 30 49 39 57 52 43z m-9140 -75\nc18 -23 18 -30 7 -57 -15 -38 -70 -73 -106 -69 -15 2 -36 15 -47 30 -27 36\n-15 73 33 106 44 30 86 26 113 -10z m9072 -47 c3 -5 1 -12 -5 -16 -18 -11 -11\n-22 40 -53 46 -29 49 -30 55 -11 4 11 11 17 16 14 14 -9 11 -38 -6 -62 l-16\n-22 -62 40 c-57 37 -63 39 -74 23 -8 -11 -17 -14 -23 -8 -6 6 2 27 20 57 30\n46 43 56 55 38z m-8975 -101 c26 -14 41 -62 27 -90 -31 -61 -114 -83 -149 -41\n-34 43 -15 94 47 125 35 18 50 20 75 6z m8965 -41 c41 -36 47 -77 15 -109 -24\n-24 -51 -25 -90 -5 -59 31 -76 82 -38 122 30 32 70 30 113 -8z m-8833 -136\nc31 -28 23 -76 -17 -112 -45 -39 -86 -41 -114 -5 -29 37 -26 61 13 100 38 38\n87 46 118 17z m8634 -17 c-5 -20 1 -30 36 -55 40 -29 44 -30 55 -14 8 11 17\n13 23 7 10 -10 -17 -74 -32 -74 -5 0 -34 19 -65 42 -50 38 -56 40 -67 25 -9\n-12 -16 -13 -24 -5 -8 8 -2 23 21 54 36 49 63 59 53 20z m-76 -93 c0 -5 -4\n-14 -9 -22 -7 -11 3 -24 36 -49 43 -33 47 -34 59 -17 12 17 14 17 20 1 6 -16\n-20 -66 -35 -66 -5 0 -32 18 -60 41 -43 34 -54 39 -67 28 -32 -26 -33 7 -1 48\n29 38 57 56 57 36z m-8430 -53 c40 -40 19 -104 -44 -134 -97 -46 -144 75 -52\n134 40 25 71 25 96 0z m8401 -73 c70 -47 61 -129 -14 -135 -32 -3 -43 2 -72\n31 -40 40 -44 71 -13 104 27 29 56 29 99 0z m-8258 -85 c45 -39 -14 -142 -81\n-142 -33 0 -72 38 -72 70 0 26 39 71 74 85 32 14 51 11 79 -13z m115 -149 c-8\n-10 -14 -10 -24 -2 -10 8 -23 3 -53 -23 -44 -36 -49 -46 -26 -54 12 -5 13 -10\n4 -20 -9 -11 -16 -10 -40 7 -16 11 -29 26 -29 32 0 7 24 33 52 58 46 40 51 48\n39 62 -7 9 -10 21 -6 27 5 8 23 -3 51 -31 34 -33 41 -46 32 -56z m8015 67 c19\n-17 37 -38 39 -48 7 -26 -8 -59 -36 -77 -21 -14 -28 -14 -59 -2 -64 27 -88 96\n-47 137 28 28 64 25 103 -10z m-7896 -162 c34 -32 30 -73 -11 -114 -41 -41\n-77 -44 -112 -8 -33 32 -26 67 21 112 40 37 70 41 102 10z m7673 -48 c60 -42\n62 -118 4 -140 -36 -14 -57 -6 -93 36 -37 41 -39 69 -9 101 26 28 61 29 98 3z\nm-7516 -102 c9 -12 16 -33 16 -45 0 -26 -51 -88 -78 -95 -26 -7 -59 8 -77 36\n-14 21 -14 28 -2 59 28 65 109 91 141 45z m7372 -52 c43 -43 46 -85 7 -116\n-34 -27 -68 -20 -105 21 -36 38 -38 91 -6 113 35 25 67 19 104 -18z m-7200\n-103 c26 -22 40 -41 35 -46 -5 -5 -16 -5 -27 1 -14 8 -24 2 -51 -30 -37 -45\n-40 -53 -17 -62 17 -7 10 -26 -10 -26 -7 0 -25 9 -40 21 l-27 21 46 53 c47 55\n53 71 33 77 -10 4 -4 28 8 28 3 0 25 -17 50 -37z m6985 -17 c-11 -13 -7 -23\n26 -60 34 -40 39 -43 51 -29 8 12 15 14 22 7 12 -12 -23 -64 -42 -64 -6 0 -33\n24 -58 52 -40 45 -50 51 -63 40 -12 -10 -17 -10 -23 -1 -9 16 77 91 90 79 5\n-6 4 -15 -3 -24z m-41 -112 c39 -45 38 -87 -2 -117 -36 -27 -73 -15 -105 32\n-28 42 -29 75 -3 101 32 32 73 26 110 -16z m-6777 -2 c37 -32 4 -118 -54 -142\n-27 -11 -34 -11 -57 7 -49 36 -38 108 23 145 32 19 58 16 88 -10z m6605 -105\nc12 -13 27 -37 33 -55 21 -61 -42 -113 -96 -78 -33 22 -57 61 -57 91 0 61 77\n88 120 42z m-6438 -17 c30 -30 25 -73 -11 -115 -36 -41 -77 -47 -109 -15 -30\n30 -25 73 11 115 36 41 77 47 109 15z m96 -70 c24 -17 44 -35 44 -40 0 -14\n-18 -21 -25 -10 -11 18 -22 11 -53 -37 -30 -46 -31 -48 -11 -58 11 -6 16 -14\n13 -18 -13 -12 -41 -8 -63 11 l-21 17 40 60 c36 53 38 61 24 72 -9 6 -13 16\n-9 22 9 15 11 15 61 -19z m6144 -15 c60 -31 78 -109 34 -144 -33 -26 -54 -26\n-86 -1 -55 43 -60 117 -10 144 34 19 28 19 62 1z m-6010 -75 c13 -10 20 -22\n16 -29 -6 -9 -11 -9 -22 0 -17 14 -14 16 -48 -38 -30 -49 -32 -63 -11 -63 17\n0 20 -16 5 -25 -12 -7 -70 22 -70 36 0 5 16 35 36 65 32 52 34 57 18 68 -9 7\n-14 18 -10 25 8 12 35 -1 86 -39z m96 -56 c24 -14 44 -30 44 -34 0 -14 -15\n-19 -30 -10 -11 7 -21 -3 -42 -38 -32 -55 -34 -62 -12 -62 9 0 14 -6 11 -12\n-5 -16 -47 -12 -66 7 -12 12 -9 22 22 74 30 51 33 62 21 72 -17 14 -18 29 -3\n29 6 0 30 -12 55 -26z m5738 14 c37 -16 70 -87 56 -122 -11 -29 -52 -50 -81\n-41 -10 3 -30 20 -44 36 -34 42 -34 91 1 118 31 24 35 25 68 9z m-5623 -84\nc49 -24 62 -52 22 -46 -15 2 -28 -9 -48 -43 -26 -45 -26 -47 -8 -60 23 -17 12\n-29 -19 -21 -52 14 -53 20 -14 90 29 54 33 68 21 72 -14 6 -22 34 -10 34 3 0\n28 -11 56 -26z m5461 -24 c30 -23 51 -69 46 -101 -2 -12 -15 -31 -29 -42 -37\n-27 -77 -13 -106 39 -29 50 -29 69 2 99 29 30 54 32 87 5z m-5268 -81 c32 -25\n34 -68 5 -115 -25 -40 -62 -53 -98 -33 -62 35 -19 164 55 168 6 1 23 -8 38\n-20z m4987 -59 c44 -24 64 -113 32 -142 -38 -33 -61 -32 -98 5 -27 27 -35 43\n-35 71 0 60 50 93 101 66z m-4788 -44 c49 -19 68 -53 24 -42 -20 5 -26 -1 -45\n-40 -26 -53 -27 -64 -7 -64 8 0 15 -7 15 -16 0 -13 -7 -15 -32 -10 -52 10 -55\n20 -25 81 28 58 34 85 17 85 -5 0 -10 7 -10 16 0 9 3 14 8 12 4 -1 28 -11 55\n-22z m4587 -36 c0 -5 -7 -13 -16 -18 -14 -8 -13 -15 10 -61 24 -45 29 -50 46\n-41 26 14 28 -10 3 -32 -40 -34 -49 -30 -78 38 -25 59 -30 65 -51 60 -42 -11\n-28 23 19 44 47 22 67 25 67 10z m-4381 -56 c21 -15 23 -23 18 -67 -3 -39 -11\n-56 -31 -74 -35 -30 -61 -29 -91 2 -29 28 -31 54 -8 98 29 58 68 72 112 41z\nm4261 -4 c0 -5 -7 -13 -15 -18 -14 -7 -13 -14 5 -57 26 -60 26 -61 44 -46 10\n8 16 9 21 1 9 -14 -2 -28 -36 -45 -29 -16 -30 -16 -43 17 -8 18 -21 50 -29 70\n-12 28 -20 35 -35 31 -39 -10 -32 16 10 36 48 21 78 26 78 11z m-4133 -46 c18\n-8 36 -15 40 -16 40 -7 108 -38 108 -49 0 -9 -8 -13 -21 -11 -18 2 -25 -6 -38\n-44 -20 -58 -20 -64 -1 -64 8 0 15 -7 15 -16 0 -13 -7 -15 -36 -11 -20 3 -39\n9 -42 12 -3 3 5 35 18 72 22 64 23 66 5 79 -36 27 -61 17 -79 -29 -20 -53 -20\n-67 -1 -67 16 0 20 -15 7 -24 -5 -3 -25 -1 -45 5 l-36 10 21 52 c30 76 34 97\n14 97 -17 0 -21 12 -9 23 7 8 26 3 80 -19z m4032 -28 c33 -35 39 -98 12 -125\n-47 -47 -118 -10 -128 68 -4 31 -1 46 12 61 25 28 76 26 104 -4z m-224 -59\nc-18 -14 -18 -15 0 -65 17 -46 21 -51 42 -46 29 8 30 -10 1 -30 -40 -28 -53\n-20 -77 49 -20 55 -27 65 -44 63 -43 -6 -26 21 25 40 55 21 88 14 53 -11z\nm-3480 -42 c29 -28 31 -51 11 -100 -19 -46 -54 -62 -96 -45 -49 20 -54 99 -8\n147 28 30 63 29 93 -2z m3351 -8 c-18 -13 -18 -16 -2 -65 18 -54 24 -60 43\n-41 7 7 12 6 16 -5 7 -18 -46 -51 -67 -43 -7 3 -20 32 -29 66 -15 54 -20 61\n-42 61 -44 0 -27 25 28 41 55 16 84 9 53 -14z m-119 -24 c2 -6 -5 -13 -16 -16\n-18 -4 -19 -6 -3 -60 15 -50 19 -56 39 -50 13 3 23 1 23 -5 0 -14 -21 -29 -51\n-37 -24 -6 -26 -3 -45 62 -17 60 -22 68 -42 65 -42 -6 -23 24 26 40 51 17 64\n17 69 1z m-3034 -25 c39 -45 0 -140 -60 -146 -62 -6 -89 50 -58 123 23 56 79\n67 118 23z m2904 -15 c2 -6 -5 -13 -16 -16 -20 -5 -20 -7 -6 -54 8 -26 15 -52\n15 -56 0 -5 9 -6 19 -2 11 3 22 1 26 -5 6 -10 -61 -47 -70 -38 -3 3 -14 34\n-24 69 -16 55 -21 64 -40 62 -42 -5 -22 26 27 41 51 16 64 16 69 -1z m-2801\n-4 c45 -12 65 -43 22 -37 -18 3 -23 -4 -35 -47 -16 -65 -16 -65 7 -65 14 0 18\n-5 13 -16 -4 -12 -14 -15 -41 -10 -19 3 -36 7 -39 9 -2 3 4 35 14 72 17 63 17\n67 0 76 -9 6 -17 14 -17 19 0 13 21 12 76 -1z m224 -59 c40 -40 16 -143 -37\n-156 -16 -4 -37 -1 -52 7 -22 12 -26 23 -29 67 -3 44 1 56 22 77 30 30 69 32\n96 5z m2360 -22 c40 -66 17 -138 -45 -138 -40 0 -61 18 -74 66 -16 60 12 104\n66 104 27 0 37 -6 53 -32z m-215 -9 c4 -6 -2 -13 -14 -16 -24 -6 -24 -6 -10\n-71 9 -42 13 -49 30 -45 13 4 19 0 19 -11 0 -14 -56 -38 -72 -29 -3 1 -12 35\n-18 74 -10 61 -15 70 -30 66 -10 -3 -21 1 -24 9 -3 9 3 16 17 19 12 2 31 6 42\n8 37 8 54 7 60 -4z m-145 -34 c0 -8 -7 -15 -16 -15 -13 0 -15 -8 -9 -52 9 -65\n10 -67 35 -61 11 3 20 0 20 -5 0 -14 -33 -32 -58 -32 -21 0 -26 12 -37 92 -5\n36 -12 48 -26 50 -31 5 -27 22 6 29 55 12 85 10 85 -6z m-130 -23 c15 -12 24\n-33 27 -65 5 -41 2 -52 -17 -72 -50 -53 -120 -12 -120 70 0 74 57 110 110 67z"
	  }), h$2("path", {
	    d: "M7217 12833 c-6 -33 2 -81 15 -89 27 -17 50 54 32 100 -10 27 -41 19\n-47 -11z"
	  }), h$2("path", {
	    d: "M7425 12837 c-4 -13 -5 -39 -3 -58 2 -26 8 -34 23 -34 18 0 20 7 20\n55 0 44 -3 55 -17 58 -11 2 -19 -5 -23 -21z"
	  }), h$2("path", {
	    d: "M7007 12844 c-9 -9 -9 -67 -1 -88 9 -22 41 -20 47 3 12 49 -21 110\n-46 85z"
	  }), h$2("path", {
	    d: "M7770 12815 c-14 -38 -12 -71 5 -85 24 -20 39 2 39 57 1 37 -3 48\n-16 51 -12 2 -21 -6 -28 -23z"
	  }), h$2("path", {
	    d: "M8216 12758 c-3 -13 -6 -38 -6 -55 0 -26 4 -33 20 -33 14 0 22 11 30\n41 6 23 9 47 6 55 -9 22 -43 17 -50 -8z"
	  }), h$2("path", {
	    d: "M6286 12745 c-3 -8 -4 -21 -2 -27 3 -7 7 -25 10 -40 4 -19 13 -28 26\n-28 21 0 24 8 20 50 -4 51 -40 81 -54 45z"
	  }), h$2("path", {
	    d: "M8420 12725 c-23 -60 -5 -114 28 -82 22 23 22 100 0 105 -12 2 -21\n-6 -28 -23z"
	  }), h$2("path", {
	    d: "M6093 12713 c-30 -11 -3 -113 29 -113 19 0 20 5 15 46 -5 48 -23 75\n-44 67z"
	  }), h$2("path", {
	    d: "M8624 12675 c-18 -45 -15 -79 8 -83 22 -4 40 39 36 82 -4 43 -26 44\n-44 1z"
	  }), h$2("path", {
	    d: "M8824 12615 c-18 -44 -15 -69 9 -73 19 -4 51 57 45 86 -6 33 -38 25\n-54 -13z"
	  }), h$2("path", {
	    d: "M5743 12614 c-9 -24 19 -98 39 -102 26 -5 32 34 11 75 -21 42 -40 53\n-50 27z"
	  }), h$2("path", {
	    d: "M9036 12578 c-19 -32 -27 -71 -17 -87 14 -23 39 -5 52 38 19 63 -5\n96 -35 49z"
	  }), h$2("path", {
	    d: "M9214 12475 c-12 -33 -14 -49 -6 -57 25 -25 62 21 62 78 0 17 -6 24\n-19 24 -14 0 -24 -13 -37 -45z"
	  }), h$2("path", {
	    d: "M9409 12404 c-16 -35 -18 -48 -9 -59 18 -21 37 -7 56 40 29 76 -14\n94 -47 19z"
	  }), h$2("path", {
	    d: "M5160 12385 c0 -39 28 -87 48 -83 12 3 16 12 15 32 -4 60 -63 107\n-63 51z"
	  }), h$2("path", {
	    d: "M9830 12228 c-11 -18 -20 -43 -20 -55 0 -35 34 -29 55 10 33 62 1\n104 -35 45z"
	  }), h$2("path", {
	    d: "M4745 12200 c-8 -12 18 -71 38 -88 37 -31 49 14 17 66 -19 31 -43 41\n-55 22z"
	  }), h$2("path", {
	    d: "M10011 12134 c-23 -29 -25 -74 -5 -81 15 -5 53 48 56 78 4 34 -26 35\n-51 3z"
	  }), h$2("path", {
	    d: "M4570 12086 c0 -27 35 -76 55 -76 25 0 26 19 5 60 -24 46 -60 56 -60\n16z"
	  }), h$2("path", {
	    d: "M4270 11913 c0 -30 38 -83 60 -83 26 0 26 23 -1 66 -22 36 -59 47\n-59 17z"
	  }), h$2("path", {
	    d: "M10420 11878 c-39 -64 -17 -98 30 -48 35 38 40 80 10 80 -12 0 -28\n-13 -40 -32z"
	  }), h$2("path", {
	    d: "M10596 11767 c-28 -36 -33 -62 -15 -72 25 -16 87 73 66 94 -17 17\n-24 14 -51 -22z"
	  }), h$2("path", {
	    d: "M3885 11630 c-8 -13 7 -39 38 -69 47 -43 66 4 22 52 -27 28 -49 34\n-60 17z"
	  }), h$2("path", {
	    d: "M10935 11473 c-22 -34 -23 -39 -9 -53 14 -13 19 -11 50 22 41 45 44\n68 9 68 -17 0 -32 -11 -50 -37z"
	  }), h$2("path", {
	    d: "M3635 11430 c-14 -23 62 -99 85 -85 17 11 11 32 -19 64 -29 31 -55\n39 -66 21z"
	  }), h$2("path", {
	    d: "M3490 11281 c0 -22 67 -84 81 -76 17 11 9 38 -18 67 -31 33 -63 37\n-63 9z"
	  }), h$2("path", {
	    d: "M3345 11140 c-14 -23 41 -80 77 -80 27 0 22 28 -11 61 -30 29 -55 37\n-66 19z"
	  }), h$2("path", {
	    d: "M11394 11046 c-36 -36 -40 -58 -12 -64 21 -4 80 54 76 74 -5 30 -27\n27 -64 -10z"
	  }), h$2("path", {
	    d: "M3203 10984 c-7 -19 43 -74 68 -74 34 0 32 23 -4 57 -41 37 -55 41\n-64 17z"
	  }), h$2("path", {
	    d: "M11520 10890 c-32 -30 -36 -53 -8 -58 21 -4 78 46 78 69 0 29 -33 24\n-70 -11z"
	  }), h$2("path", {
	    d: "M3063 10823 c-8 -20 48 -73 78 -73 32 0 20 40 -20 67 -40 27 -50 28\n-58 6z"
	  }), h$2("path", {
	    d: "M2854 10538 c-9 -15 50 -68 76 -68 34 0 35 22 1 52 -33 29 -65 36\n-77 16z"
	  }), h$2("path", {
	    d: "M11887 10435 c-39 -27 -51 -65 -19 -65 20 0 60 25 79 48 9 11 10 19\n2 29 -15 18 -19 17 -62 -12z"
	  }), h$2("path", {
	    d: "M2740 10360 c0 -22 53 -60 83 -60 30 0 19 37 -17 59 -43 27 -66 27\n-66 1z"
	  }), h$2("path", {
	    d: "M12003 10259 c-38 -24 -45 -59 -12 -59 30 0 79 38 79 61 0 25 -26 24\n-67 -2z"
	  }), h$2("path", {
	    d: "M2584 10106 c-8 -21 9 -41 46 -56 30 -13 60 -8 60 9 0 12 -48 46 -78\n55 -16 5 -24 3 -28 -8z"
	  }), h$2("path", {
	    d: "M12179 9957 c-38 -25 -44 -51 -14 -55 29 -4 85 34 85 58 0 27 -28 26\n-71 -3z"
	  }), h$2("path", {
	    d: "M2477 9923 c-13 -13 -7 -23 26 -43 41 -25 77 -26 77 -2 0 31 -82 67\n-103 45z"
	  }), h$2("path", {
	    d: "M12285 9784 c-41 -21 -59 -40 -51 -53 18 -29 109 9 104 43 -4 26 -17\n29 -53 10z"
	  }), h$2("path", {
	    d: "M12362 9595 c-36 -16 -50 -41 -33 -58 17 -17 104 27 99 51 -4 22 -26\n25 -66 7z"
	  }), h$2("path", {
	    d: "M2277 9483 c-23 -23 26 -63 78 -63 42 0 32 35 -15 54 -45 18 -54 19\n-63 9z"
	  }), h$2("path", {
	    d: "M12438 9394 c-31 -16 -37 -41 -12 -51 24 -9 94 27 94 49 0 23 -42 24\n-82 2z"
	  }), h$2("path", {
	    d: "M12513 9204 c-42 -18 -46 -54 -8 -54 39 0 87 28 83 48 -4 22 -35 24\n-75 6z"
	  }), h$2("path", {
	    d: "M2144 9159 c-9 -14 13 -34 54 -47 64 -21 88 18 27 44 -41 17 -71 18\n-81 3z"
	  }), h$2("path", {
	    d: "M2094 8957 c-9 -24 3 -35 48 -47 33 -9 43 -9 56 3 13 13 11 17 -10\n31 -38 25 -87 31 -94 13z"
	  }), h$2("path", {
	    d: "M12613 8905 c-35 -15 -44 -42 -18 -52 26 -9 107 26 103 46 -4 21 -45\n24 -85 6z"
	  }), h$2("path", {
	    d: "M2005 8650 c-10 -16 3 -29 45 -41 42 -13 70 -7 70 14 0 28 -100 51\n-115 27z"
	  }), h$2("path", {
	    d: "M1964 8446 c-10 -25 8 -38 59 -43 34 -4 45 -2 50 10 8 21 -11 35 -61\n43 -34 5 -43 3 -48 -10z"
	  }), h$2("path", {
	    d: "M12733 8439 c-23 -7 -33 -16 -33 -29 0 -16 7 -20 38 -20 46 0 78 20\n69 44 -7 18 -25 19 -74 5z"
	  }), h$2("path", {
	    d: "M12752 8229 c-13 -5 -22 -14 -20 -21 8 -24 33 -30 76 -19 31 9 42 17\n42 31 0 16 -7 20 -37 19 -21 0 -49 -4 -61 -10z"
	  }), h$2("path", {
	    d: "M1905 8100 c-13 -22 17 -40 66 -40 53 0 67 20 30 40 -25 13 -88 13\n-96 0z"
	  }), h$2("path", {
	    d: "M1884 7896 c-9 -23 3 -33 46 -41 24 -4 41 -1 55 9 28 20 9 37 -49 43\n-37 5 -47 2 -52 -11z"
	  }), h$2("path", {
	    d: "M12813 7753 c-7 -2 -13 -13 -13 -24 0 -16 7 -19 49 -19 49 0 79 18\n66 40 -6 10 -79 13 -102 3z"
	  }), h$2("path", {
	    d: "M12845 7453 c-52 -13 -36 -53 20 -53 46 0 65 9 65 30 0 24 -37 34\n-85 23z"
	  }), h$2("path", {
	    d: "M1870 7415 c-19 -23 -2 -35 50 -35 27 0 52 5 55 10 12 19 -17 40 -55\n40 -21 0 -43 -7 -50 -15z"
	  }), h$2("path", {
	    d: "M12790 6825 c-12 -15 -12 -19 5 -31 26 -19 94 -18 102 2 8 22 -9 35\n-54 41 -29 4 -42 1 -53 -12z"
	  }), h$2("path", {
	    d: "M1962 6559 c-24 -7 -32 -15 -30 -27 3 -13 14 -17 52 -16 50 0 73 18\n54 41 -12 15 -29 15 -76 2z"
	  }), h$2("path", {
	    d: "M12740 6470 c0 -14 11 -22 38 -29 49 -14 57 -14 71 3 19 23 -13 46\n-65 46 -37 0 -44 -3 -44 -20z"
	  }), h$2("path", {
	    d: "M2062 6085 c-19 -8 -32 -20 -30 -27 11 -32 122 -12 116 21 -4 21 -45\n24 -86 6z"
	  }), h$2("path", {
	    d: "M12653 6034 c-8 -21 7 -34 53 -44 38 -9 64 0 64 22 0 11 -62 38 -90\n38 -11 0 -23 -7 -27 -16z"
	  }), h$2("path", {
	    d: "M12517 5594 c-15 -15 -6 -34 24 -49 36 -19 84 -16 84 5 0 23 -92 60\n-108 44z"
	  }), h$2("path", {
	    d: "M2293 5393 c-41 -20 -45 -53 -8 -53 39 0 87 28 83 48 -4 23 -36 25\n-75 5z"
	  }), h$2("path", {
	    d: "M2380 5212 c-45 -22 -49 -58 -6 -55 38 3 78 30 74 51 -4 23 -27 24\n-68 4z"
	  }), h$2("path", {
	    d: "M12339 5134 c-16 -20 4 -41 53 -56 33 -10 41 -9 48 2 20 32 -77 83\n-101 54z"
	  }), h$2("path", {
	    d: "M2458 5023 c-34 -22 -37 -53 -5 -53 29 0 90 37 84 53 -6 19 -49 19\n-79 0z"
	  }), h$2("path", {
	    d: "M12250 4942 c0 -22 49 -52 84 -52 34 0 34 22 0 49 -34 27 -84 28 -84\n3z"
	  }), h$2("path", {
	    d: "M2640 4721 c-44 -23 -54 -61 -16 -61 31 0 87 46 79 65 -7 20 -21 19\n-63 -4z"
	  }), h$2("path", {
	    d: "M12105 4670 c-9 -14 11 -38 48 -56 58 -30 80 12 25 46 -36 22 -63 26\n-73 10z"
	  }), h$2("path", {
	    d: "M2788 4449 c-31 -23 -38 -59 -12 -59 28 0 84 40 84 61 0 26 -37 25\n-72 -2z"
	  }), h$2("path", {
	    d: "M2911 4275 c-32 -27 -39 -49 -20 -60 16 -11 91 43 87 63 -5 27 -33\n25 -67 -3z"
	  }), h$2("path", {
	    d: "M11844 4268 c-10 -16 51 -68 81 -68 34 0 32 23 -6 54 -32 28 -63 33\n-75 14z"
	  }), h$2("path", {
	    d: "M3039 4117 c-40 -27 -52 -67 -20 -67 30 0 86 53 78 73 -8 22 -18 21\n-58 -6z"
	  }), h$2("path", {
	    d: "M3156 3941 c-27 -28 -30 -61 -6 -61 19 0 83 66 76 78 -12 20 -41 13\n-70 -17z"
	  }), h$2("path", {
	    d: "M11559 3894 c-11 -14 -8 -21 24 -50 39 -36 62 -43 70 -20 7 19 -18\n53 -53 71 -25 13 -29 13 -41 -1z"
	  }), h$2("path", {
	    d: "M3301 3794 c-29 -24 -39 -52 -25 -67 10 -10 62 21 80 48 31 47 -6 60\n-55 19z"
	  }), h$2("path", {
	    d: "M11431 3741 c-19 -12 -5 -47 30 -72 31 -22 59 -20 59 5 0 8 -16 28\n-35 45 -41 35 -36 33 -54 22z"
	  }), h$2("path", {
	    d: "M3537 3542 c-33 -34 -36 -62 -6 -62 23 0 82 57 76 74 -7 22 -43 16\n-70 -12z"
	  }), h$2("path", {
	    d: "M11211 3516 c-10 -11 -6 -22 20 -50 34 -39 69 -48 69 -18 0 16 -58\n82 -72 82 -3 0 -11 -6 -17 -14z"
	  }), h$2("path", {
	    d: "M3689 3399 c-33 -35 -37 -57 -12 -66 21 -8 85 60 77 82 -9 24 -33 18\n-65 -16z"
	  }), h$2("path", {
	    d: "M11057 3383 c-22 -21 33 -96 66 -91 33 5 31 26 -6 63 -35 35 -48 41\n-60 28z"
	  }), h$2("path", {
	    d: "M10797 3146 c-6 -16 35 -81 56 -89 14 -5 37 10 37 25 0 13 -62 78\n-75 78 -7 0 -15 -6 -18 -14z"
	  }), h$2("path", {
	    d: "M4024 3101 c-25 -38 -25 -61 -1 -61 20 0 67 53 67 77 0 38 -36 29\n-66 -16z"
	  }), h$2("path", {
	    d: "M10637 3033 c-14 -13 -6 -33 24 -67 52 -59 82 -23 33 41 -24 32 -43\n41 -57 26z"
	  }), h$2("path", {
	    d: "M4206 2990 c-49 -58 -24 -107 26 -51 29 32 35 71 12 78 -6 2 -23 -10\n-38 -27z"
	  }), h$2("path", {
	    d: "M10460 2905 c0 -40 56 -106 74 -88 12 12 6 45 -15 74 -22 31 -59 39\n-59 14z"
	  }), h$2("path", {
	    d: "M10285 2790 c-13 -22 48 -102 71 -93 20 7 17 30 -7 69 -20 33 -51 45\n-64 24z"
	  }), h$2("path", {
	    d: "M10123 2703 c-19 -7 -16 -31 8 -69 25 -41 59 -46 59 -9 0 29 -49 86\n-67 78z"
	  }), h$2("path", {
	    d: "M4840 2578 c-14 -31 -16 -46 -8 -55 16 -20 27 -16 48 20 27 43 26 77\n0 77 -15 0 -27 -12 -40 -42z"
	  }), h$2("path", {
	    d: "M9847 2553 c-22 -21 12 -103 43 -103 26 0 26 35 0 78 -20 32 -30 38\n-43 25z"
	  }), h$2("path", {
	    d: "M5255 2407 c-21 -33 -30 -83 -15 -92 28 -17 79 74 57 103 -14 18 -25\n15 -42 -11z"
	  }), h$2("path", {
	    d: "M9400 2340 c0 -39 28 -92 47 -88 24 4 27 29 9 72 -17 41 -56 52 -56\n16z"
	  }), h$2("path", {
	    d: "M5704 2225 c-26 -63 -3 -113 30 -63 23 36 25 91 3 96 -12 2 -22 -7\n-33 -33z"
	  }), h$2("path", {
	    d: "M5905 2186 c-9 -14 -18 -40 -19 -58 -1 -27 3 -33 19 -33 29 0 54 80\n32 102 -13 14 -17 13 -32 -11z"
	  }), h$2("path", {
	    d: "M6232 2095 c-15 -33 -15 -82 -1 -91 20 -12 42 23 43 68 1 51 -23 64\n-42 23z"
	  }), h$2("path", {
	    d: "M8580 2072 c0 -48 26 -88 46 -71 27 22 6 109 -27 109 -15 0 -19 -7\n-19 -38z"
	  }), h$2("path", {
	    d: "M8107 2024 c-10 -10 -9 -58 3 -88 12 -32 38 -34 46 -3 12 51 -23 116\n-49 91z"
	  }), h$2("path", {
	    d: "M10480 12276 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16\n-11 6 -20 8 -20 6z"
	  }), h$2("path", {
	    d: "M7110 12255 c-8 -2 -68 -7 -132 -10 l-118 -7 0 -44 c0 -37 -4 -46\n-22 -54 -35 -14 -563 -102 -590 -98 -17 2 -25 12 -32 41 -5 20 -12 37 -16 37\n-10 0 -252 -68 -256 -72 -2 -2 2 -21 8 -41 8 -26 8 -41 1 -48 -16 -16 -563\n-220 -581 -217 -14 3 -33 29 -45 61 -3 9 -136 -49 -205 -89 -42 -25 -42 -25\n-27 -54 8 -16 15 -36 15 -44 0 -14 -511 -336 -534 -336 -6 0 -22 14 -36 31\nl-26 30 -107 -81 -107 -82 20 -28 c11 -15 20 -35 20 -44 0 -17 -432 -419 -456\n-424 -9 -2 -28 8 -43 22 l-28 27 -91 -103 -91 -103 29 -23 c17 -13 30 -29 30\n-37 0 -7 -81 -124 -181 -259 -129 -175 -186 -246 -200 -246 -11 0 -31 7 -45\n16 -13 9 -26 15 -28 13 -2 -2 -34 -53 -70 -113 -67 -113 -70 -127 -26 -141 10\n-3 21 -13 24 -22 6 -15 -234 -534 -260 -563 -12 -12 -19 -12 -50 -1 -30 11\n-38 11 -45 0 -8 -13 -89 -235 -89 -244 0 -2 13 -6 29 -10 60 -13 60 -12 -20\n-323 -45 -172 -81 -293 -91 -304 -13 -13 -23 -15 -49 -8 -18 5 -34 9 -35 7 -6\n-7 -43 -261 -38 -268 3 -5 18 -9 33 -9 54 0 54 -3 32 -329 -11 -165 -22 -305\n-26 -311 -3 -5 -24 -10 -46 -10 l-39 0 0 -117 c0 -153 3 -163 43 -157 18 3 38\n1 45 -4 18 -12 95 -612 81 -628 -5 -7 -25 -15 -44 -18 -19 -4 -35 -10 -35 -14\n1 -11 37 -175 50 -220 10 -40 10 -40 46 -30 25 7 39 6 50 -3 18 -14 197 -561\n192 -586 -2 -10 -18 -24 -36 -32 -17 -8 -32 -19 -32 -24 0 -5 23 -62 51 -127\nl52 -119 28 14 c59 31 58 33 213 -248 130 -235 163 -307 139 -307 -5 0 -19 -9\n-32 -19 l-24 -18 43 -64 c24 -35 59 -85 77 -112 l35 -47 28 20 c52 37 39 49\n284 -244 91 -109 166 -206 166 -214 0 -9 -12 -29 -27 -45 l-28 -29 99 -94 98\n-94 19 24 c40 51 43 50 295 -154 129 -106 238 -198 241 -206 3 -7 -5 -25 -16\n-40 -12 -15 -21 -30 -21 -35 0 -10 205 -149 219 -149 5 0 18 14 28 30 9 17 25\n30 35 30 10 0 138 -64 284 -142 l266 -142 -6 -30 c-15 -71 -19 -66 104 -117\n63 -27 118 -49 122 -49 4 0 14 15 22 34 8 18 19 37 25 40 10 6 545 -155 585\n-176 15 -8 17 -17 13 -53 l-6 -43 47 -11 c127 -27 264 -52 267 -49 1 1 5 35 8\n73 l6 70 -62 51 c-54 45 -72 53 -142 68 -438 94 -940 290 -1345 526 -1259 734\n-2107 2010 -2290 3443 -19 155 -40 425 -40 529 l0 58 191 0 c148 0 190 -3 187\n-12 -4 -10 -50 -14 -177 -16 l-173 -2 6 -133 c29 -575 143 -1093 352 -1593\n500 -1202 1469 -2137 2685 -2592 162 -61 433 -141 579 -172 108 -22 128 -33\n212 -104 36 -31 48 -48 48 -68 0 -23 4 -28 25 -28 25 0 25 0 25 98 l0 97 -72\n82 -73 82 -75 16 c-41 9 -133 32 -204 51 -70 19 -138 34 -150 34 -35 0 -359\n111 -381 130 -11 10 -61 36 -111 58 -243 107 -455 225 -699 387 -902 603\n-1553 1520 -1829 2577 -67 254 -119 567 -132 795 l-6 108 86 85 c57 56 89 81\n96 74 6 -6 -17 -36 -70 -89 -93 -92 -89 -72 -65 -303 154 -1493 1037 -2792\n2368 -3483 77 -39 189 -93 250 -120 l112 -49 36 108 36 107 -31 14 c-345 160\n-453 219 -691 377 -244 162 -412 300 -641 528 -336 336 -560 641 -765 1041\n-266 518 -409 1017 -460 1605 -17 196 -6 663 20 855 75 554 240 1054 500 1520\n688 1229 1928 2026 3336 2145 154 13 525 13 680 0 528 -44 1055 -191 1520\n-423 193 -96 273 -143 470 -273 624 -412 1133 -996 1456 -1669 566 -1180 556\n-2537 -28 -3709 -199 -399 -458 -760 -778 -1082 -225 -226 -451 -410 -710\n-576 -460 -296 -1036 -521 -1545 -604 l-105 -17 -87 -86 -88 -86 2 -205 c1\n-154 3 -181 7 -108 l6 97 107 83 107 83 133 24 c906 160 1804 654 2430 1335\n683 742 1085 1641 1175 2624 l16 183 -74 75 c-41 42 -84 80 -96 85 -59 23 -16\n29 199 29 l221 0 -6 -182 c-18 -510 -131 -1036 -331 -1543 -67 -169 -229 -495\n-328 -658 -305 -505 -707 -954 -1173 -1312 -571 -438 -1269 -749 -1979 -880\n-109 -20 -132 -27 -157 -51 -19 -18 -29 -38 -29 -56 0 -24 4 -28 29 -28 33 0\n41 -14 41 -72 l0 -40 48 7 c63 9 64 11 57 55 -5 32 -3 40 12 49 28 15 594 152\n603 146 5 -3 14 -21 20 -40 6 -19 17 -35 23 -35 7 0 65 19 130 42 108 38 118\n43 112 62 -4 12 -8 34 -9 49 -1 27 6 32 129 89 340 158 428 196 440 192 6 -3\n19 -21 28 -40 16 -32 18 -34 39 -21 13 8 67 40 120 71 l97 56 -20 35 c-12 19\n-19 41 -16 48 5 14 490 367 503 367 5 0 22 -14 39 -30 l31 -30 55 46 c29 26\n76 67 102 91 l49 45 -27 28 c-15 15 -25 35 -23 43 4 21 416 457 431 457 6 0\n23 -12 39 -27 15 -14 30 -25 32 -22 2 2 40 51 85 109 l81 105 -31 26 c-22 18\n-31 32 -27 45 6 24 293 481 320 509 18 19 18 19 54 0 42 -23 34 -31 110 118\nl54 107 -34 17 c-20 9 -37 22 -40 29 -5 13 208 562 224 578 7 7 24 6 50 -1\nl40 -10 19 66 c62 213 61 200 21 207 -56 12 -56 12 1 316 29 156 56 293 60\n306 7 18 16 22 52 22 l44 0 7 83 c4 45 9 106 12 135 l6 52 -29 0 c-61 0 -60\n-4 -68 326 -7 334 -8 334 57 334 l31 0 -7 93 c-4 50 -10 111 -13 135 l-6 42\n-43 0 c-23 0 -45 4 -49 10 -11 17 -123 594 -118 607 3 7 22 17 44 23 22 6 37\n16 34 23 -2 6 -20 65 -40 130 -39 128 -36 124 -97 102 -7 -3 -18 -1 -24 3 -15\n9 -234 546 -234 572 0 13 12 26 35 37 l35 17 -61 115 c-34 64 -63 118 -65 120\n-2 3 -21 -3 -41 -13 -35 -16 -37 -16 -54 1 -32 34 -329 496 -329 514 0 9 14\n26 31 36 l30 20 -67 84 c-109 137 -102 132 -132 109 -13 -11 -33 -20 -42 -20\n-20 0 -440 430 -440 451 0 7 11 25 25 39 l25 26 -87 75 c-130 111 -122 107\n-145 76 -11 -15 -28 -27 -39 -27 -20 0 -484 319 -506 348 -11 13 -9 22 7 50\n12 19 20 35 18 37 -8 5 -129 76 -179 104 l-57 31 -21 -35 c-11 -19 -27 -35\n-35 -35 -13 0 -465 198 -537 235 -31 17 -37 42 -18 77 14 27 11 28 -133 77\nl-117 39 -11 -34 c-7 -19 -19 -38 -28 -42 -11 -6 -116 15 -297 58 -154 36\n-288 69 -299 73 -15 6 -18 15 -14 52 3 25 3 45 -1 45 -3 0 -73 9 -155 20 -81\n11 -154 20 -162 20 -9 0 -14 -12 -14 -34 0 -18 -7 -39 -14 -46 -17 -14 -589\n-4 -618 11 -10 6 -18 24 -20 47 -3 31 -7 37 -28 39 -14 0 -32 0 -40 -2z m485\n-225 c538 -28 1007 -129 1495 -321 605 -238 1119 -576 1591 -1048 373 -373\n652 -758 884 -1222 288 -574 474 -1307 479 -1884 l1 -170 -195 -3 c-107 -1\n-201 0 -209 3 -11 4 11 31 73 94 l88 89 -11 138 c-100 1206 -656 2283 -1575\n3053 -1263 1059 -3035 1324 -4561 684 -1357 -570 -2342 -1778 -2629 -3225 -32\n-159 -63 -391 -71 -528 l-7 -105 76 -74 c42 -41 76 -78 76 -83 0 -22 -32 -1\n-102 69 -77 76 -78 78 -78 128 0 27 7 112 15 188 103 976 503 1857 1169 2580\n364 395 840 746 1331 982 1682 810 3695 487 5028 -805 817 -792 1274 -1773\n1362 -2924 l7 -89 -73 -73 -73 -74 168 0 169 0 -6 173 c-23 628 -209 1323\n-508 1897 -565 1083 -1519 1901 -2663 2286 -1348 452 -2817 264 -4003 -512\n-290 -190 -511 -370 -763 -623 -731 -734 -1190 -1667 -1320 -2684 -18 -142\n-40 -423 -40 -509 l0 -38 165 0 c140 0 165 -2 165 -15 0 -13 -27 -15 -181 -15\nl-182 0 7 153 c18 404 75 763 181 1132 326 1136 1088 2120 2115 2730 642 381\n1392 606 2145 644 224 12 253 12 460 1z"
	  }), h$2("path", {
	    d: "M10650 12166 c0 -3 20 -19 45 -36 25 -17 45 -29 45 -26 0 3 -20 19\n-45 36 -25 17 -45 29 -45 26z"
	  }), h$2("path", {
	    d: "M10750 12096 c0 -2 14 -14 30 -26 17 -12 30 -19 30 -16 0 2 -13 14\n-30 26 -16 12 -30 19 -30 16z"
	  }), h$2("path", {
	    d: "M10820 12046 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21\n-21 13z"
	  }), h$2("path", {
	    d: "M10894 11988 c22 -18 94 -77 160 -131 660 -536 1210 -1244 1577\n-2028 288 -618 463 -1264 531 -1969 17 -180 17 -819 0 -1005 -113 -1204 -555\n-2286 -1309 -3205 -155 -188 -360 -406 -524 -556 -215 -197 -243 -224 -169\n-163 187 157 438 404 616 610 1345 1550 1774 3684 1133 5639 -229 698 -587\n1339 -1075 1925 -218 261 -645 669 -895 854 -46 34 -66 47 -45 29z"
	  }), h$2("path", {
	    d: "M7070 11524 c-888 -79 -1638 -376 -2322 -922 -156 -124 -468 -432\n-590 -582 -520 -638 -819 -1330 -930 -2148 -19 -145 -22 -211 -23 -507 0 -357\n6 -440 51 -710 199 -1199 924 -2262 1971 -2885 177 -106 507 -270 543 -270 4\n0 27 55 51 123 23 67 47 125 52 128 5 4 93 -21 196 -55 211 -71 207 -67 172\n-161 -11 -30 -17 -56 -13 -59 15 -9 287 -75 395 -95 60 -12 117 -27 126 -34\n10 -6 88 -74 174 -151 l157 -139 0 -218 0 -219 49 0 c54 0 61 -8 61 -66 0 -34\n1 -35 33 -32 31 3 32 5 35 51 l3 48 77 -3 77 -3 3 -47 c3 -47 4 -48 37 -48 33\n0 34 1 37 48 l3 47 75 0 75 0 3 -48 c3 -46 4 -47 37 -47 33 0 34 1 37 47 3 44\n5 48 33 53 l30 5 5 210 5 210 92 89 92 88 113 19 c168 29 422 94 605 155 1349\n452 2393 1588 2732 2974 88 359 115 590 115 980 1 309 -7 410 -50 680 -177\n1103 -810 2108 -1737 2753 -563 392 -1205 637 -1897 722 -129 16 -674 29 -790\n19z m201 -868 c222 -47 401 -211 474 -435 l17 -53 37 6 c20 3 115 6 212 6\nl177 0 11 29 c19 45 91 111 151 140 44 20 71 25 130 26 95 0 168 -33 234 -106\n87 -97 104 -229 44 -348 -18 -36 -34 -69 -36 -72 -2 -4 45 -48 103 -99 l105\n-92 48 15 c202 64 413 -24 505 -212 30 -62 32 -73 32 -171 -1 -134 -23 -195\n-102 -280 -218 -236 -598 -149 -693 158 -44 140 -9 288 92 398 35 38 39 47 27\n58 -16 14 -156 134 -180 153 -13 11 -23 10 -62 -7 -52 -23 -162 -29 -210 -11\n-21 8 -29 8 -32 -2 -3 -6 -23 -65 -44 -129 l-39 -117 56 -39 c68 -46 135 -139\n158 -219 26 -89 16 -211 -24 -294 -58 -120 -175 -208 -311 -231 l-69 -12 -7\n-75 c-3 -42 -9 -85 -11 -97 -5 -18 2 -22 61 -32 174 -33 359 -134 478 -262 35\n-38 70 -70 76 -70 6 0 101 25 210 56 l199 56 4 82 c3 64 11 96 32 139 35 73\n101 138 174 174 50 25 68 28 152 28 82 0 103 -4 152 -27 207 -97 278 -345 153\n-535 -71 -107 -206 -171 -332 -160 -115 11 -224 79 -280 174 -14 24 -31 42\n-37 40 -6 -3 -88 -26 -181 -51 -94 -26 -178 -49 -187 -52 -16 -5 -15 -11 11\n-62 59 -118 91 -253 91 -383 l0 -76 108 -17 c100 -16 108 -16 117 0 57 94 119\n146 204 170 145 43 298 -26 373 -168 33 -62 33 -203 0 -270 -29 -59 -88 -120\n-144 -150 -62 -33 -212 -33 -279 0 -98 48 -165 144 -177 256 l-7 60 -85 13\nc-121 19 -120 20 -142 -62 -70 -257 -258 -467 -517 -576 -36 -15 -67 -32 -69\n-37 -2 -6 9 -55 23 -109 45 -169 40 -160 87 -167 61 -10 120 -38 167 -81 29\n-26 45 -35 54 -28 133 102 217 178 211 192 -4 9 -9 46 -12 82 -5 85 22 154 85\n209 103 90 248 92 351 4 133 -113 120 -327 -25 -423 -93 -62 -207 -61 -301 3\nl-49 32 -114 -94 c-75 -63 -113 -100 -110 -111 2 -9 4 -52 5 -96 0 -62 -4 -90\n-21 -126 -29 -64 -87 -125 -147 -157 -44 -23 -63 -27 -141 -27 -78 0 -97 4\n-141 27 -89 47 -174 164 -174 240 0 15 -9 18 -58 18 -33 0 -99 3 -149 6 l-89\n7 -13 -59 c-21 -98 -77 -199 -150 -273 -111 -111 -238 -164 -396 -165 -156 0\n-284 53 -396 165 -263 261 -197 711 130 883 91 48 167 66 276 66 l91 0 57 106\nc31 58 57 110 57 116 0 5 -20 32 -44 60 -58 66 -128 202 -162 313 -24 80 -27\n105 -27 235 0 117 4 160 21 224 27 99 78 205 136 284 l45 61 -87 54 c-48 30\n-93 58 -100 62 -9 5 -27 -5 -50 -27 -81 -77 -146 -106 -257 -116 l-70 -7 -12\n-160 c-6 -88 -14 -181 -16 -207 -3 -41 -1 -47 20 -57 41 -19 108 -88 133 -138\n21 -41 25 -62 25 -143 0 -86 -3 -100 -29 -148 -58 -104 -158 -164 -274 -164\n-37 0 -80 5 -95 11 -26 10 -33 8 -75 -28 -26 -22 -70 -63 -99 -93 l-52 -53 34\n-55 c78 -126 84 -282 17 -415 -37 -74 -70 -114 -135 -162 -145 -106 -353 -110\n-503 -9 -136 92 -214 272 -187 432 53 310 414 470 672 298 l34 -23 56 49 c31\n26 71 64 90 84 l34 35 -35 39 c-44 48 -78 137 -78 201 0 162 127 301 293 318\n53 5 57 7 57 32 0 14 7 103 15 196 8 94 15 173 15 176 0 4 -24 18 -54 33 -66\n32 -145 110 -177 174 -13 26 -25 49 -26 51 -2 3 -293 -88 -301 -94 -1 -1 9\n-26 22 -56 45 -97 58 -172 54 -293 -3 -88 -10 -127 -31 -186 -66 -186 -216\n-328 -417 -396 -83 -28 -271 -27 -365 3 -195 62 -354 220 -416 413 -29 90 -36\n244 -15 332 53 225 242 420 456 471 33 8 50 17 49 27 0 8 -6 64 -12 124 l-12\n109 -51 12 c-180 40 -289 219 -239 390 69 238 358 313 531 138 35 -36 84 -123\n84 -150 0 -10 27 -13 100 -13 l99 0 26 54 c28 59 79 110 131 132 33 14 33 15\n27 66 -17 160 -13 152 -63 160 -128 22 -232 160 -217 290 17 138 129 238 267\n238 229 0 353 -265 204 -438 -20 -24 -53 -51 -74 -62 -36 -18 -38 -22 -33 -57\n2 -21 7 -67 11 -102 l7 -64 49 -14 c101 -30 172 -103 196 -203 25 -102 -29\n-226 -124 -285 -68 -41 -168 -47 -245 -15 -64 28 -124 94 -147 162 l-16 50\n-46 -6 c-24 -3 -69 -6 -98 -6 -46 0 -54 -3 -54 -18 0 -11 -14 -47 -31 -81 -34\n-67 -101 -130 -164 -153 -31 -10 -35 -16 -31 -38 3 -14 8 -54 11 -90 3 -36 8\n-82 11 -102 l6 -38 52 0 c122 0 274 -65 379 -160 l66 -61 168 54 168 54 7 78\nc17 186 147 332 331 369 l59 12 79 210 c43 115 78 212 79 215 0 4 -14 12 -31\n19 -55 23 -143 86 -194 138 -175 180 -226 448 -130 683 111 275 422 437 716\n375z m139 -5721 c31 -16 60 -51 60 -72 0 -21 -63 -16 -83 7 -20 24 -60 26 -78\n4 -20 -24 0 -45 66 -71 78 -30 95 -47 95 -95 0 -30 -7 -46 -29 -69 -25 -24\n-37 -29 -81 -29 -61 0 -102 19 -118 55 -18 39 -15 45 20 45 23 0 38 -8 54 -27\n19 -24 25 -26 50 -18 31 11 42 38 25 59 -6 7 -38 23 -71 35 -89 33 -115 87\n-69 145 37 47 104 60 159 31z m1396 -4 c64 -29 89 -72 89 -153 0 -74 -16 -105\n-75 -145 -42 -29 -120 -31 -170 -4 -94 50 -118 177 -47 258 56 63 126 79 203\n44z m844 -11 l0 -30 -60 0 -60 0 0 -40 0 -40 55 0 c54 0 55 0 55 -30 0 -30 -1\n-30 -55 -30 l-55 0 0 -40 0 -40 60 0 60 0 0 -30 0 -30 -95 0 -95 0 0 170 0\n170 95 0 95 0 0 -30z m300 -89 l75 -114 3 117 3 116 29 0 30 0 0 -170 0 -170\n-32 0 c-31 0 -38 8 -103 107 l-70 107 -3 -107 -3 -107 -34 0 -35 0 0 171 0\n170 33 -3 c29 -3 39 -14 107 -117z m-5280 -8 c0 -131 9 -153 63 -153 58 0 67\n19 67 152 l0 118 35 0 35 0 0 -120 c0 -135 -10 -169 -60 -195 -39 -20 -115\n-19 -151 2 -47 28 -59 67 -59 197 l0 116 35 0 35 0 0 -117z m590 92 c0 -23 -4\n-25 -45 -25 l-45 0 0 -140 0 -140 -35 0 -35 0 0 140 0 140 -45 0 c-41 0 -45 2\n-45 25 l0 25 125 0 125 0 0 -25z m210 -92 c0 -131 9 -153 63 -153 58 0 67 19\n67 152 l0 118 35 0 35 0 0 -116 c0 -130 -12 -169 -59 -197 -36 -21 -112 -22\n-152 -1 -46 24 -59 66 -59 199 l0 115 35 0 35 0 0 -117z m800 92 c0 -23 -4\n-25 -45 -25 l-45 0 0 -140 0 -140 -35 0 -35 0 0 140 0 140 -45 0 c-41 0 -45 2\n-45 25 l0 25 125 0 125 0 0 -25z m351 -3 c23 -21 31 -37 32 -64 1 -41 -26 -88\n-54 -95 -18 -5 -18 -8 7 -52 15 -25 34 -56 42 -68 14 -23 13 -23 -26 -23 -40\n0 -42 2 -77 65 -20 36 -43 65 -51 65 -11 0 -14 -16 -14 -65 l0 -65 -35 0 -35\n0 0 165 0 165 90 0 c84 0 92 -2 121 -28z m259 -89 c0 -131 9 -153 63 -153 58\n0 67 19 67 152 l0 118 35 0 35 0 0 -116 c0 -130 -12 -169 -59 -197 -36 -21\n-112 -22 -150 -2 -48 24 -61 68 -61 199 l0 116 35 0 35 0 0 -117z m970 92 c0\n-23 -4 -25 -45 -25 l-45 0 0 -140 0 -140 -30 0 -30 0 0 140 0 140 -45 0 c-41\n0 -45 2 -45 25 l0 25 120 0 120 0 0 -25z m580 0 c0 -23 -4 -25 -45 -25 l-45 0\n0 -140 0 -140 -30 0 -30 0 0 140 0 140 -45 0 c-41 0 -45 2 -45 25 l0 25 120 0\n120 0 0 -25z m680 -47 l1 -73 22 25 c12 14 40 47 62 74 36 43 44 47 77 44 l38\n-3 -66 -78 -66 -78 72 -84 71 -85 -44 0 c-43 0 -46 2 -98 70 -30 38 -57 69\n-61 70 -5 0 -8 -31 -8 -70 l0 -70 -30 0 -30 0 0 165 0 165 30 0 30 0 0 -72z"
	  }), h$2("path", {
	    d: "M7767 9998 c-8 -133 -52 -252 -129 -349 -22 -28 -36 -54 -32 -58 15\n-13 211 -131 217 -131 4 0 27 13 52 29 68 43 160 65 244 58 l69 -6 47 135 46\n135 -37 41 c-46 51 -72 109 -80 181 l-7 57 -192 0 -192 0 -6 -92z"
	  }), h$2("path", {
	    d: "M7495 9513 c-33 -25 -156 -80 -212 -93 -57 -13 -174 -18 -238 -10\nl-39 5 -72 -190 c-40 -105 -73 -198 -73 -207 -1 -11 6 -18 17 -18 38 0 140\n-61 190 -113 113 -120 147 -270 96 -420 -9 -27 -15 -49 -13 -51 13 -11 201\n-126 206 -126 3 0 38 24 77 54 129 99 288 161 471 183 l70 8 12 95 c12 100 11\n110 -13 110 -32 0 -127 56 -174 102 -131 128 -161 325 -75 487 19 36 34 65 32\n66 -1 1 -50 32 -109 68 -59 37 -113 67 -120 67 -7 0 -22 -8 -33 -17z"
	  }), h$2("path", {
	    d: "M7351 6887 l-50 -92 73 -38 c82 -42 163 -117 212 -194 39 -61 84\n-187 84 -236 l0 -35 73 -7 c39 -3 108 -5 151 -3 l79 3 14 42 c19 57 94 138\n157 170 28 14 52 26 53 27 2 1 -9 45 -23 97 -13 52 -29 110 -34 129 l-9 35\n-168 0 c-157 1 -174 3 -253 29 -103 34 -156 61 -243 120 l-66 45 -50 -92z"
	  }), h$2("path", {
	    d: "M8671 4864 c-33 -27 -48 -76 -37 -120 28 -112 196 -91 196 25 0 56\n-15 88 -49 106 -43 22 -75 19 -110 -11z"
	  }), h$2("path", {
	    d: "M6480 4840 l0 -50 40 0 c31 0 43 5 56 25 15 23 15 27 0 50 -13 20\n-25 25 -56 25 l-40 0 0 -50z"
	  }), h$2("path", {
	    d: "M11759 7226 l73 -74 -11 -143 c-94 -1171 -628 -2236 -1511 -3012\n-587 -516 -1300 -865 -2086 -1020 l-171 -34 -97 -77 -96 -77 0 -84 c0 -47 4\n-85 9 -85 6 0 11 -21 13 -47 3 -46 4 -48 36 -51 31 -3 32 -2 32 32 0 52 9 66\n41 66 27 0 29 3 29 38 0 31 7 42 38 68 32 27 56 35 152 53 835 159 1564 504\n2195 1041 151 128 419 400 543 550 493 599 822 1279 976 2020 58 274 96 597\n96 808 l0 102 -167 0 -167 0 73 -74z"
	  }), h$2("path", {
	    d: "M6196 3404 c-9 -26 -14 -49 -12 -51 9 -9 191 -55 339 -86 l156 -32\n125 -114 126 -114 0 -193 c0 -115 4 -194 9 -194 6 0 11 -21 13 -47 3 -46 4\n-48 36 -51 31 -3 32 -2 32 37 0 22 7 46 15 55 12 12 15 51 15 223 l0 208 -142\n125 c-191 168 -186 165 -276 180 -72 11 -367 81 -403 95 -13 5 -20 -4 -33 -41z"
	  }), h$2("path", {
	    d: "M6159 3293 c-27 -70 -24 -74 91 -105 58 -15 159 -39 225 -53 l120\n-26 127 -132 127 -132 0 -112 1 -113 25 0 25 0 0 188 0 188 -116 104 -115 105\n-167 36 c-92 21 -201 46 -242 58 -41 12 -78 21 -83 21 -4 0 -12 -12 -18 -27z"
	  }), h$2("path", {
	    d: "M6112 3153 c-9 -28 -9 -39 0 -44 16 -10 230 -66 326 -85 l81 -17 80\n-91 81 -90 0 -102 c0 -93 2 -102 20 -107 16 -4 20 -14 20 -51 0 -46 0 -46 35\n-46 35 0 35 0 35 45 0 31 5 47 15 51 12 5 15 27 15 113 l-1 106 -119 123 -119\n124 -109 23 c-60 13 -161 37 -225 54 -64 17 -118 31 -120 31 -2 0 -9 -17 -15\n-37z"
	  }), h$2("path", {
	    d: "M11064 2858 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
	  }), h$2("path", {
	    d: "M11004 2808 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
	  }), h$2("path", {
	    d: "M10959 2773 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8\n-17 -17z"
	  }), h$2("path", {
	    d: "M6718 2338 l-3 -83 -30 -5 -30 -5 -3 -306 c-2 -253 0 -308 11 -312 8\n-3 55 -8 106 -12 l91 -8 0 321 0 321 -32 3 -33 3 -3 83 -3 82 -34 0 -34 0 -3\n-82z"
	  }), h$2("path", {
	    d: "M6955 2408 c-3 -7 -6 -44 -7 -83 -3 -68 -4 -70 -30 -73 l-28 -3 0\n-323 0 -323 77 -7 c42 -3 87 -6 100 -6 l23 0 0 330 0 330 -29 0 c-36 0 -41 13\n-41 101 l0 69 -30 0 c-17 0 -33 -6 -35 -12z"
	  }), h$2("path", {
	    d: "M7190 2351 c0 -88 -5 -101 -41 -101 l-29 0 0 -329 0 -329 73 -7 c39\n-3 137 -5 217 -3 l145 3 3 40 c2 22 1 113 -3 203 -7 150 -9 162 -26 162 -28 0\n-23 19 6 26 l26 6 -3 112 -3 111 -30 5 -30 5 -3 83 -3 82 -34 0 -34 0 -3 -82\n-3 -83 -75 0 -75 0 -5 80 -5 80 -32 3 -33 3 0 -70z m301 -350 c20 -16 24 -29\n24 -71 0 -42 -4 -55 -24 -71 -55 -45 -111 -10 -111 71 0 81 56 116 111 71z"
	  }), h$2("path", {
	    d: "M7425 1967 c-4 -13 -5 -39 -3 -58 2 -26 8 -34 23 -34 18 0 20 7 20\n55 0 44 -3 55 -17 58 -11 2 -19 -5 -23 -21z"
	  }), h$2("path", {
	    d: "M7648 2338 l-3 -83 -30 -5 -30 -5 -3 -113 -3 -112 26 0 c16 0 25 -6\n25 -15 0 -8 -9 -15 -20 -15 -22 0 -26 -28 -14 -89 5 -25 10 -30 25 -26 33 11\n22 -22 -11 -34 l-30 -10 0 -120 0 -121 74 0 c40 0 88 3 105 6 l31 7 0 323 0\n323 -32 3 -33 3 -3 83 -3 82 -34 0 -34 0 -3 -82z m122 -322 c0 -7 -10 -16 -21\n-19 -15 -4 -20 -11 -15 -22 3 -9 6 -35 6 -57 0 -36 2 -40 21 -35 15 4 19 1 17\n-11 -2 -11 -17 -19 -41 -23 -37 -6 -37 -6 -37 30 0 72 -11 111 -31 111 -11 0\n-19 6 -19 14 0 10 14 16 43 19 23 2 50 4 60 5 9 1 17 -4 17 -12z"
	  }), h$2("path", {
	    d: "M7885 2408 c-3 -7 -6 -44 -7 -83 -3 -68 -4 -70 -30 -73 l-28 -3 0\n-326 0 -325 73 7 c39 3 84 8 100 11 l27 6 0 314 0 314 -29 0 c-36 0 -41 13\n-41 101 l0 69 -30 0 c-17 0 -33 -6 -35 -12z m92 -395 c22 -33 24 -107 3 -127\n-51 -50 -122 -12 -124 66 -1 58 23 88 70 88 25 0 38 -7 51 -27z"
	  }), h$2("path", {
	    d: "M7900 1961 c0 -49 18 -79 40 -66 11 7 14 73 4 99 -3 9 -15 16 -25 16\n-16 0 -19 -8 -19 -49z"
	  })));
	}

	/* eslint-disable no-nested-ternary */

	/**
	 * A component which renders the given child when the provided SubmitStatus is idle, a spinner when submitting
	 * a success message on success and error message on error.
	 *
	 * @param props
	 * @constructor
	 */
	function SubmitStatusView(props) {
	  var children = props.children,
	      submitStatus = props.submitStatus;

	  switch (submitStatus) {
	    case SubmitStatus.idle:
	      return children;

	    case SubmitStatus.submitting:
	      return h$2("div", {
	        className: "spinner"
	      });

	    case SubmitStatus.success:
	      return h$2("div", {
	        className: "submit-success"
	      }, h$2(FlowerPenguin, null), "Thank you!");

	    default:
	      return h$2("div", {
	        className: "submit-error"
	      }, h$2(SadPenguin, null), "Error.");
	  }
	}

	var _excluded = ["id", "badges", "image"];
	// export default function BadgeSet({ id, badges, ...props } : BadgeSetProps) {
	function BadgeSet(_ref) {
	  var id = _ref.id,
	      badges = _ref.badges,
	      image = _ref.image,
	      props = _objectWithoutProperties(_ref, _excluded);

	  var _useState = p(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedQualifier = _useState2[0],
	      setSelectedQualifier = _useState2[1]; // environments


	  var _useState3 = p(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDark = _useState4[0],
	      setIsDark = _useState4[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  var walletAddress = q$1(WalletAddressContext);

	  if (props[ATTR_SOURCE_UUID] === "address") {
	    props[ATTR_SOURCE_UUID] = walletAddress;
	  }

	  var isSelected = function isSelected(qualifier) {
	    return selectedQualifier === qualifier;
	  };

	  var _getBaseProps = getBaseProps(props, TAG_FEEDBACK_FORM),
	      apiUrl = _getBaseProps.apiUrl;

	  var _useFeedbackApi = useFeedbackApi(apiUrl, props[ATTR_SOURCE_UUID], props[ATTR_TARGET_UUID], props[ATTR_TRANSACTION_ID]),
	      sendFeedback = _useFeedbackApi.sendFeedback,
	      submitStatus = _useFeedbackApi.submitStatus;

	  return h$2(BaseComponent, {
	    style: css_248z$l
	  }, h$2("section", {
	    className: "px-4 py-3 badge-set-section"
	  }, h$2("div", {
	    className: "badge-img-big-section"
	  }, h$2("img", {
	    src: image,
	    className: "badge-img-big",
	    alt: "badges"
	  })), h$2("div", {
	    key: id,
	    className: "badge-set-container"
	  }, h$2("h3", {
	    className: "text-left badge-text-h3 badge-text-h3-".concat(isDark ? "dark" : "light")
	  }, id), h$2(SubmitStatusView, {
	    submitStatus: submitStatus
	  }, h$2("div", {
	    className: "badge-img-container"
	  }, badges.map(function (_ref2) {
	    var qualifier = _ref2.qualifier,
	        data = _ref2.data;
	    return h$2("button", {
	      className: "icon-btn ".concat(isSelected(qualifier) ? "badge-img" : "badge-disable"),
	      type: "button",
	      onClick: function onClick() {
	        var qualifierToSet = isSelected(qualifier) ? "neutral" : qualifier;
	        sendFeedback({
	          badges: _defineProperty$2({}, id, qualifierToSet)
	        });
	        setSelectedQualifier(qualifierToSet);
	      }
	    }, h$2("div", {
	      className: "badge-item-text"
	    }, h$2("img", {
	      src: data.image,
	      className: "badge-img",
	      alt: "badges"
	    })));
	  }))))));
	}

	function Badges(props) {
	  var _getBaseProps = getBaseProps(props, TAG_FEEDBACK_FORM),
	      apiUrl = _getBaseProps.apiUrl;

	  var _useBadgesApi = useBadgesApi(apiUrl),
	      badgeSets = _useBadgesApi.badgeSets; // environments


	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  return h$2(BaseComponent, {
	    className: "utu-section-no-border-".concat(isDark ? "dark" : "light"),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2("div", {
	    className: "d-flex justify-content-center ml-5"
	  }, h$2("div", null, h$2("h3", {
	    className: "mx-5"
	  }, "Award Badges"), h$2("div", {
	    className: "badge-section"
	  }, badgeSets.map(function (_ref) {
	    var id = _ref.id,
	        badges = _ref.badges,
	        image = _ref.image;
	    return h$2(BadgeSet, _extends$1({}, props, {
	      id: id,
	      image: image,
	      badges: badges
	    }));
	  })))));
	}

	function S(n,t){for(var e in t)n[e]=t[e];return n}function g(n,t){for(var e in n)if("__source"!==e&&!(e in t))return !0;for(var r in t)if("__source"!==r&&n[r]!==t[r])return !0;return !1}function C(n){this.props=n;}(C.prototype=new d$2).isPureReactComponent=!0,C.prototype.shouldComponentUpdate=function(n,t){return g(this.props,n)||g(this.state,t)};var w=l$3.__b;l$3.__b=function(n){n.type&&n.type.__f&&n.ref&&(n.props.ref=n.ref,n.ref=null),w&&w(n);};var A=l$3.__e;l$3.__e=function(n,t,e,r){if(n.then)for(var u,o=t;o=o.__;)if((u=o.__c)&&u.__c)return null==t.__e&&(t.__e=e.__e,t.__k=e.__k),u.__c(n,t);A(n,t,e,r);};var O=l$3.unmount;function T(){this.__u=0,this.t=null,this.__b=null;}function L(n){var t=n.__.__c;return t&&t.__a&&t.__a(n)}function D(){this.u=null,this.o=null;}l$3.unmount=function(n){var t=n.__c;t&&t.__R&&t.__R(),t&&!0===n.__h&&(n.type=null),O&&O(n);},(T.prototype=new d$2).__c=function(n,t){var e=t.__c,r=this;null==r.t&&(r.t=[]),r.t.push(e);var u=L(r.__v),o=!1,i=function(){o||(o=!0,e.__R=null,u?u(l):l());};e.__R=i;var l=function(){if(!--r.__u){if(r.state.__a){var n=r.state.__a;r.__v.__k[0]=function n(t,e,r){return t&&(t.__v=null,t.__k=t.__k&&t.__k.map(function(t){return n(t,e,r)}),t.__c&&t.__c.__P===e&&(t.__e&&r.insertBefore(t.__e,t.__d),t.__c.__e=!0,t.__c.__P=r)),t}(n,n.__c.__P,n.__c.__O);}var t;for(r.setState({__a:r.__b=null});t=r.t.pop();)t.forceUpdate();}},c=!0===t.__h;r.__u++||c||r.setState({__a:r.__b=r.__v.__k[0]}),n.then(i,i);},T.prototype.componentWillUnmount=function(){this.t=[];},T.prototype.render=function(n,t){if(this.__b){if(this.__v.__k){var e=document.createElement("div"),r=this.__v.__k[0].__c;this.__v.__k[0]=function n(t,e,r){return t&&(t.__c&&t.__c.__H&&(t.__c.__H.__.forEach(function(n){"function"==typeof n.__c&&n.__c();}),t.__c.__H=null),null!=(t=S({},t)).__c&&(t.__c.__P===r&&(t.__c.__P=e),t.__c=null),t.__k=t.__k&&t.__k.map(function(t){return n(t,e,r)})),t}(this.__b,e,r.__O=r.__P);}this.__b=null;}var u=t.__a&&h$2(p$1,null,n.fallback);return u&&(u.__h=null),[h$2(p$1,null,t.__a?null:n.children),u]};var F=function(n,t,e){if(++e[1]===e[0]&&n.o.delete(t),n.props.revealOrder&&("t"!==n.props.revealOrder[0]||!n.o.size))for(e=n.u;e;){for(;e.length>3;)e.pop()();if(e[1]<e[0])break;n.u=e=e[2];}};(D.prototype=new d$2).__a=function(n){var t=this,e=L(t.__v),r=t.o.get(n);return r[0]++,function(u){var o=function(){t.props.revealOrder?(r.push(u),F(t,n,r)):u();};e?e(o):o();}},D.prototype.render=function(n){this.u=null,this.o=new Map;var t=x$1(n.children);n.revealOrder&&"b"===n.revealOrder[0]&&t.reverse();for(var e=t.length;e--;)this.o.set(t[e],this.u=[1,0,this.u]);return n.children},D.prototype.componentDidUpdate=D.prototype.componentDidMount=function(){var n=this;this.o.forEach(function(t,e){F(n,e,t);});};var W="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,P=/^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,$="undefined"!=typeof document,j$1=function(n){return ("undefined"!=typeof Symbol&&"symbol"==typeof Symbol()?/fil|che|rad/i:/fil|che|ra/i).test(n)};d$2.prototype.isReactComponent={},["componentWillMount","componentWillReceiveProps","componentWillUpdate"].forEach(function(n){Object.defineProperty(d$2.prototype,n,{configurable:!0,get:function(){return this["UNSAFE_"+n]},set:function(t){Object.defineProperty(this,n,{configurable:!0,writable:!0,value:t});}});});var H=l$3.event;function Z(){}function Y(){return this.cancelBubble}function q(){return this.defaultPrevented}l$3.event=function(n){return H&&(n=H(n)),n.persist=Z,n.isPropagationStopped=Y,n.isDefaultPrevented=q,n.nativeEvent=n};var J={configurable:!0,get:function(){return this.class}},K=l$3.vnode;l$3.vnode=function(n){var t=n.type,e=n.props,r=e;if("string"==typeof t){var u=-1===t.indexOf("-");for(var o in r={},e){var i=e[o];$&&"children"===o&&"noscript"===t||"value"===o&&"defaultValue"in e&&null==i||("defaultValue"===o&&"value"in e&&null==e.value?o="value":"download"===o&&!0===i?i="":/ondoubleclick/i.test(o)?o="ondblclick":/^onchange(textarea|input)/i.test(o+t)&&!j$1(e.type)?o="oninput":/^onfocus$/i.test(o)?o="onfocusin":/^onblur$/i.test(o)?o="onfocusout":/^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(o)?o=o.toLowerCase():u&&P.test(o)?o=o.replace(/[A-Z0-9]/g,"-$&").toLowerCase():null===i&&(i=void 0),/^oninput$/i.test(o)&&(o=o.toLowerCase(),r[o]&&(o="oninputCapture")),r[o]=i);}"select"==t&&r.multiple&&Array.isArray(r.value)&&(r.value=x$1(e.children).forEach(function(n){n.props.selected=-1!=r.value.indexOf(n.props.value);})),"select"==t&&null!=r.defaultValue&&(r.value=x$1(e.children).forEach(function(n){n.props.selected=r.multiple?-1!=r.defaultValue.indexOf(n.props.value):r.defaultValue==n.props.value;})),n.props=r,e.class!=e.className&&(J.enumerable="className"in e,null!=e.className&&(r.class=e.className),Object.defineProperty(r,"className",J));}n.$$typeof=W,K&&K(n);};var Q=l$3.__r;l$3.__r=function(n){Q&&Q(n),n.__c;};function en(n){return !!n&&n.$$typeof===W}

	var isHTMLElement = value => value instanceof HTMLElement;

	const EVENTS = {
	  BLUR: 'blur',
	  CHANGE: 'change',
	  INPUT: 'input'
	};
	const VALIDATION_MODE = {
	  onBlur: 'onBlur',
	  onChange: 'onChange',
	  onSubmit: 'onSubmit',
	  onTouched: 'onTouched',
	  all: 'all'
	};
	const SELECT = 'select';
	const UNDEFINED = 'undefined';
	const INPUT_VALIDATION_RULES = {
	  max: 'max',
	  min: 'min',
	  maxLength: 'maxLength',
	  minLength: 'minLength',
	  pattern: 'pattern',
	  required: 'required',
	  validate: 'validate'
	};

	function attachEventListeners({
	  ref
	}, shouldAttachChangeEvent, handleChange) {
	  if (isHTMLElement(ref) && handleChange) {
	    ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
	    ref.addEventListener(EVENTS.BLUR, handleChange);
	  }
	}

	var isNullOrUndefined = value => value == null;

	const isObjectType = value => typeof value === 'object';

	var isObject = value => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);

	var isKey = value => /^\w*$/.test(value);

	var compact = value => value.filter(Boolean);

	var stringToPath = input => compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));

	function set(object, path, value) {
	  let index = -1;
	  const tempPath = isKey(path) ? [path] : stringToPath(path);
	  const length = tempPath.length;
	  const lastIndex = length - 1;

	  while (++index < length) {
	    const key = tempPath[index];
	    let newValue = value;

	    if (index !== lastIndex) {
	      const objValue = object[key];
	      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
	    }

	    object[key] = newValue;
	    object = object[key];
	  }

	  return object;
	}

	var transformToNestObject = (data, value = {}) => {
	  for (const key in data) {
	    !isKey(key) ? set(value, key, data[key]) : value[key] = data[key];
	  }

	  return value;
	};

	var isUndefined = val => val === undefined;

	var get = (obj = {}, path, defaultValue) => {
	  const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
	  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
	};

	var focusOnErrorField = (fields, fieldErrors) => {
	  for (const key in fields) {
	    if (get(fieldErrors, key)) {
	      const field = fields[key];

	      if (field) {
	        if (field.ref.focus && isUndefined(field.ref.focus())) {
	          break;
	        } else if (field.options) {
	          field.options[0].ref.focus();
	          break;
	        }
	      }
	    }
	  }
	};

	var removeAllEventListeners = (ref, validateWithStateUpdate) => {
	  if (isHTMLElement(ref) && ref.removeEventListener) {
	    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
	    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
	    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
	  }
	};

	const defaultReturn = {
	  isValid: false,
	  value: null
	};

	var getRadioValue = options => Array.isArray(options) ? options.reduce((previous, option) => option && option.ref.checked ? {
	  isValid: true,
	  value: option.ref.value
	} : previous, defaultReturn) : defaultReturn;

	var getMultipleSelectValue = options => [...options].filter(({
	  selected
	}) => selected).map(({
	  value
	}) => value);

	var isRadioInput = element => element.type === 'radio';

	var isFileInput = element => element.type === 'file';

	var isCheckBoxInput = element => element.type === 'checkbox';

	var isMultipleSelect = element => element.type === `${SELECT}-multiple`;

	const defaultResult = {
	  value: false,
	  isValid: false
	};
	const validResult = {
	  value: true,
	  isValid: true
	};

	var getCheckboxValue = options => {
	  if (Array.isArray(options)) {
	    if (options.length > 1) {
	      const values = options.filter(option => option && option.ref.checked).map(({
	        ref: {
	          value
	        }
	      }) => value);
	      return {
	        value: values,
	        isValid: !!values.length
	      };
	    }

	    const {
	      checked,
	      value,
	      attributes
	    } = options[0].ref;
	    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === '' ? validResult : {
	      value: value,
	      isValid: true
	    } : validResult : defaultResult;
	  }

	  return defaultResult;
	};

	function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
	  const field = fieldsRef.current[name];

	  if (field) {
	    const {
	      ref: {
	        value,
	        disabled
	      },
	      ref,
	      valueAsNumber,
	      valueAsDate,
	      setValueAs
	    } = field;

	    if (disabled && excludeDisabled) {
	      return;
	    }

	    if (isFileInput(ref)) {
	      return ref.files;
	    }

	    if (isRadioInput(ref)) {
	      return getRadioValue(field.options).value;
	    }

	    if (isMultipleSelect(ref)) {
	      return getMultipleSelectValue(ref.options);
	    }

	    if (isCheckBoxInput(ref)) {
	      return getCheckboxValue(field.options).value;
	    }

	    return shouldKeepRawValue ? value : valueAsNumber ? value === '' ? NaN : +value : valueAsDate ? ref.valueAsDate : setValueAs ? setValueAs(value) : value;
	  }

	  if (shallowFieldsStateRef) {
	    return get(shallowFieldsStateRef.current, name);
	  }
	}

	function isDetached(element) {
	  if (!element) {
	    return true;
	  }

	  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
	    return false;
	  }

	  return isDetached(element.parentNode);
	}

	var isEmptyObject = value => isObject(value) && !Object.keys(value).length;

	var isBoolean = value => typeof value === 'boolean';

	function baseGet(object, updatePath) {
	  const length = updatePath.slice(0, -1).length;
	  let index = 0;

	  while (index < length) {
	    object = isUndefined(object) ? index++ : object[updatePath[index++]];
	  }

	  return object;
	}

	function unset(object, path) {
	  const updatePath = isKey(path) ? [path] : stringToPath(path);
	  const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
	  const key = updatePath[updatePath.length - 1];
	  let previousObjRef;

	  if (childObject) {
	    delete childObject[key];
	  }

	  for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
	    let index = -1;
	    let objectRef;
	    const currentPaths = updatePath.slice(0, -(k + 1));
	    const currentPathsLength = currentPaths.length - 1;

	    if (k > 0) {
	      previousObjRef = object;
	    }

	    while (++index < currentPaths.length) {
	      const item = currentPaths[index];
	      objectRef = objectRef ? objectRef[item] : object[item];

	      if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(data => isObject(data) && !isEmptyObject(data) || isBoolean(data)).length)) {
	        previousObjRef ? delete previousObjRef[item] : delete object[item];
	      }

	      previousObjRef = objectRef;
	    }
	  }

	  return object;
	}

	const isSameRef = (fieldValue, ref) => fieldValue && fieldValue.ref === ref;

	function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
	  const {
	    ref,
	    ref: {
	      name
	    }
	  } = field;
	  const fieldRef = fieldsRef.current[name];

	  if (!shouldUnregister) {
	    const value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
	    !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
	  }

	  if (!ref.type || !fieldRef) {
	    delete fieldsRef.current[name];
	    return;
	  }

	  if (isRadioInput(ref) || isCheckBoxInput(ref)) {
	    if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
	      compact(fieldRef.options).forEach((option = {}, index) => {
	        if (isDetached(option.ref) && isSameRef(option, option.ref) || forceDelete) {
	          removeAllEventListeners(option.ref, handleChange);
	          unset(fieldRef.options, `[${index}]`);
	        }
	      });

	      if (fieldRef.options && !compact(fieldRef.options).length) {
	        delete fieldsRef.current[name];
	      }
	    } else {
	      delete fieldsRef.current[name];
	    }
	  } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
	    removeAllEventListeners(ref, handleChange);
	    delete fieldsRef.current[name];
	  }
	}

	var isPrimitive = value => isNullOrUndefined(value) || !isObjectType(value);

	function deepMerge(target, source) {
	  if (isPrimitive(target) || isPrimitive(source)) {
	    return source;
	  }

	  for (const key in source) {
	    const targetValue = target[key];
	    const sourceValue = source[key];

	    try {
	      target[key] = isObject(targetValue) && isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
	    } catch (_a) {}
	  }

	  return target;
	}

	function deepEqual(object1, object2, isErrorObject) {
	  if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
	    return object1 === object2;
	  }

	  if (!en(object1)) {
	    const keys1 = Object.keys(object1);
	    const keys2 = Object.keys(object2);

	    if (keys1.length !== keys2.length) {
	      return false;
	    }

	    for (const key of keys1) {
	      const val1 = object1[key];

	      if (!(isErrorObject && key === 'ref')) {
	        const val2 = object2[key];

	        if ((isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
	          return false;
	        }
	      }
	    }
	  }

	  return true;
	}

	function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
	  let index = -1;

	  while (++index < values.length) {
	    for (const key in values[index]) {
	      if (Array.isArray(values[index][key])) {
	        !dirtyFields[index] && (dirtyFields[index] = {});
	        dirtyFields[index][key] = [];
	        setDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
	      } else {
	        deepEqual(get(defaultValues[index] || {}, key), values[index][key]) ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), {
	          [key]: true
	        });
	      }
	    }

	    parentNode && !dirtyFields.length && delete parentNode[parentName];
	  }

	  return dirtyFields;
	}

	var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));

	var isString = value => typeof value === 'string';

	var getFieldsValues = (fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) => {
	  const output = {};

	  for (const name in fieldsRef.current) {
	    if (isUndefined(search) || (isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find(data => name.startsWith(data)))) {
	      output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
	    }
	  }

	  return shouldUnregister ? transformToNestObject(output) : deepMerge(shallowFieldsState, transformToNestObject(output));
	};

	var isErrorStateChanged = ({
	  errors,
	  name,
	  error,
	  validFields,
	  fieldsWithValidation
	}) => {
	  const isValid = isUndefined(error);
	  const previousError = get(errors, name);
	  return isValid && !!previousError || !isValid && !deepEqual(previousError, error, true) || isValid && get(fieldsWithValidation, name) && !get(validFields, name);
	};

	var isRegex = value => value instanceof RegExp;

	var getValueAndMessage = validationData => isObject(validationData) && !isRegex(validationData) ? validationData : {
	  value: validationData,
	  message: ''
	};

	var isFunction = value => typeof value === 'function';

	var isMessage = value => isString(value) || en(value);

	function getValidateError(result, ref, type = 'validate') {
	  if (isMessage(result) || isBoolean(result) && !result) {
	    return {
	      type,
	      message: isMessage(result) ? result : '',
	      ref
	    };
	  }
	}

	var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), {
	  types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), {
	    [type]: message || true
	  })
	}) : {};

	var validateField = async (fieldsRef, validateAllFieldCriteria, {
	  ref,
	  ref: {
	    value
	  },
	  options,
	  required,
	  maxLength,
	  minLength,
	  min,
	  max,
	  pattern,
	  validate
	}, shallowFieldsStateRef) => {
	  const name = ref.name;
	  const error = {};
	  const isRadio = isRadioInput(ref);
	  const isCheckBox = isCheckBoxInput(ref);
	  const isRadioOrCheckbox = isRadio || isCheckBox;
	  const isEmpty = value === '';
	  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

	  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
	    const message = exceedMax ? maxLengthMessage : minLengthMessage;
	    error[name] = Object.assign({
	      type: exceedMax ? maxType : minType,
	      message,
	      ref
	    }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
	  };

	  if (required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid)) {
	    const {
	      value,
	      message
	    } = isMessage(required) ? {
	      value: !!required,
	      message: required
	    } : getValueAndMessage(required);

	    if (value) {
	      error[name] = Object.assign({
	        type: INPUT_VALIDATION_RULES.required,
	        message,
	        ref: isRadioOrCheckbox ? ((fieldsRef.current[name].options || [])[0] || {}).ref : ref
	      }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

	      if (!validateAllFieldCriteria) {
	        return error;
	      }
	    }
	  }

	  if ((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '') {
	    let exceedMax;
	    let exceedMin;
	    const maxOutput = getValueAndMessage(max);
	    const minOutput = getValueAndMessage(min);

	    if (!isNaN(value)) {
	      const valueNumber = ref.valueAsNumber || parseFloat(value);

	      if (!isNullOrUndefined(maxOutput.value)) {
	        exceedMax = valueNumber > maxOutput.value;
	      }

	      if (!isNullOrUndefined(minOutput.value)) {
	        exceedMin = valueNumber < minOutput.value;
	      }
	    } else {
	      const valueDate = ref.valueAsDate || new Date(value);

	      if (isString(maxOutput.value)) {
	        exceedMax = valueDate > new Date(maxOutput.value);
	      }

	      if (isString(minOutput.value)) {
	        exceedMin = valueDate < new Date(minOutput.value);
	      }
	    }

	    if (exceedMax || exceedMin) {
	      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

	      if (!validateAllFieldCriteria) {
	        return error;
	      }
	    }
	  }

	  if (isString(value) && !isEmpty && (maxLength || minLength)) {
	    const maxLengthOutput = getValueAndMessage(maxLength);
	    const minLengthOutput = getValueAndMessage(minLength);
	    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && value.length > maxLengthOutput.value;
	    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && value.length < minLengthOutput.value;

	    if (exceedMax || exceedMin) {
	      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);

	      if (!validateAllFieldCriteria) {
	        return error;
	      }
	    }
	  }

	  if (isString(value) && pattern && !isEmpty) {
	    const {
	      value: patternValue,
	      message
	    } = getValueAndMessage(pattern);

	    if (isRegex(patternValue) && !patternValue.test(value)) {
	      error[name] = Object.assign({
	        type: INPUT_VALIDATION_RULES.pattern,
	        message,
	        ref
	      }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));

	      if (!validateAllFieldCriteria) {
	        return error;
	      }
	    }
	  }

	  if (validate) {
	    const fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
	    const validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

	    if (isFunction(validate)) {
	      const result = await validate(fieldValue);
	      const validateError = getValidateError(result, validateRef);

	      if (validateError) {
	        error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

	        if (!validateAllFieldCriteria) {
	          return error;
	        }
	      }
	    } else if (isObject(validate)) {
	      let validationResult = {};

	      for (const [key, validateFunction] of Object.entries(validate)) {
	        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
	          break;
	        }

	        const validateResult = await validateFunction(fieldValue);
	        const validateError = getValidateError(validateResult, validateRef, key);

	        if (validateError) {
	          validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));

	          if (validateAllFieldCriteria) {
	            error[name] = validationResult;
	          }
	        }
	      }

	      if (!isEmptyObject(validationResult)) {
	        error[name] = Object.assign({
	          ref: validateRef
	        }, validationResult);

	        if (!validateAllFieldCriteria) {
	          return error;
	        }
	      }
	    }
	  }

	  return error;
	};

	const getPath = (rootPath, values, paths = []) => {
	  for (const property in values) {
	    const rootName = rootPath + (isObject(values) ? `.${property}` : `[${property}]`);
	    isPrimitive(values[property]) ? paths.push(rootName) : getPath(rootName, values[property], paths);
	  }

	  return paths;
	};

	var assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField) => {
	  let value = undefined;
	  watchFields.add(fieldName);

	  if (!isEmptyObject(fieldValues)) {
	    value = get(fieldValues, fieldName);

	    if (isObject(value) || Array.isArray(value)) {
	      getPath(fieldName, value).forEach(name => watchFields.add(name));
	    }
	  }

	  return isUndefined(value) ? isSingleField ? inputValue : get(inputValue, fieldName) : value;
	};

	var skipValidation = ({
	  isOnBlur,
	  isOnChange,
	  isOnTouch,
	  isTouched,
	  isReValidateOnBlur,
	  isReValidateOnChange,
	  isBlurEvent,
	  isSubmitted,
	  isOnAll
	}) => {
	  if (isOnAll) {
	    return false;
	  } else if (!isSubmitted && isOnTouch) {
	    return !(isTouched || isBlurEvent);
	  } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
	    return !isBlurEvent;
	  } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
	    return isBlurEvent;
	  }

	  return true;
	};

	var getFieldArrayParentName = name => name.substring(0, name.indexOf('['));

	const isMatchFieldArrayName = (name, searchName) => RegExp(`^${searchName}([|.)\\d+`.replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);

	var isNameInFieldArray = (names, name) => [...names].some(current => isMatchFieldArrayName(name, current));

	var isSelectInput = element => element.type === `${SELECT}-one`;

	function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
	  const observer = new MutationObserver(() => {
	    for (const field of Object.values(fieldsRef.current)) {
	      if (field && field.options) {
	        for (const option of field.options) {
	          if (option && option.ref && isDetached(option.ref)) {
	            removeFieldEventListenerAndRef(field);
	          }
	        }
	      } else if (field && isDetached(field.ref)) {
	        removeFieldEventListenerAndRef(field);
	      }
	    }
	  });
	  observer.observe(window.document, {
	    childList: true,
	    subtree: true
	  });
	  return observer;
	}

	var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;

	function cloneObject(data) {
	  var _a;

	  let copy;

	  if (isPrimitive(data) || isWeb && (data instanceof File || isHTMLElement(data))) {
	    return data;
	  }

	  if (!['Set', 'Map', 'Object', 'Date', 'Array'].includes((_a = data.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
	    return data;
	  }

	  if (data instanceof Date) {
	    copy = new Date(data.getTime());
	    return copy;
	  }

	  if (data instanceof Set) {
	    copy = new Set();

	    for (const item of data) {
	      copy.add(item);
	    }

	    return copy;
	  }

	  if (data instanceof Map) {
	    copy = new Map();

	    for (const key of data.keys()) {
	      copy.set(key, cloneObject(data.get(key)));
	    }

	    return copy;
	  }

	  copy = Array.isArray(data) ? [] : {};

	  for (const key in data) {
	    copy[key] = cloneObject(data[key]);
	  }

	  return copy;
	}

	var modeChecker = mode => ({
	  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
	  isOnBlur: mode === VALIDATION_MODE.onBlur,
	  isOnChange: mode === VALIDATION_MODE.onChange,
	  isOnAll: mode === VALIDATION_MODE.all,
	  isOnTouch: mode === VALIDATION_MODE.onTouched
	});

	var isRadioOrCheckboxFunction = ref => isRadioInput(ref) || isCheckBoxInput(ref);

	const isWindowUndefined = typeof window === UNDEFINED;
	const isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;

	function useForm({
	  mode = VALIDATION_MODE.onSubmit,
	  reValidateMode = VALIDATION_MODE.onChange,
	  resolver,
	  context,
	  defaultValues = {},
	  shouldFocusError = true,
	  shouldUnregister = true,
	  criteriaMode
	} = {}) {
	  const fieldsRef = _({});
	  const fieldArrayDefaultValuesRef = _({});
	  const fieldArrayValuesRef = _({});
	  const watchFieldsRef = _(new Set());
	  const useWatchFieldsRef = _({});
	  const useWatchRenderFunctionsRef = _({});
	  const fieldsWithValidationRef = _({});
	  const validFieldsRef = _({});
	  const defaultValuesRef = _(defaultValues);
	  const isUnMount = _(false);
	  const isWatchAllRef = _(false);
	  const handleChangeRef = _();
	  const shallowFieldsStateRef = _({});
	  const resetFieldArrayFunctionRef = _({});
	  const contextRef = _(context);
	  const resolverRef = _(resolver);
	  const fieldArrayNamesRef = _(new Set());
	  const modeRef = _(modeChecker(mode));
	  const {
	    isOnSubmit,
	    isOnTouch
	  } = modeRef.current;
	  const isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;
	  const [formState, setFormState] = p({
	    isDirty: false,
	    isValidating: false,
	    dirtyFields: {},
	    isSubmitted: false,
	    submitCount: 0,
	    touched: {},
	    isSubmitting: false,
	    isSubmitSuccessful: false,
	    isValid: !isOnSubmit,
	    errors: {}
	  });
	  const readFormStateRef = _({
	    isDirty: !isProxyEnabled,
	    dirtyFields: !isProxyEnabled,
	    touched: !isProxyEnabled || isOnTouch,
	    isValidating: !isProxyEnabled,
	    isSubmitting: !isProxyEnabled,
	    isValid: !isProxyEnabled
	  });
	  const formStateRef = _(formState);
	  const observerRef = _();
	  const {
	    isOnBlur: isReValidateOnBlur,
	    isOnChange: isReValidateOnChange
	  } = _(modeChecker(reValidateMode)).current;
	  contextRef.current = context;
	  resolverRef.current = resolver;
	  formStateRef.current = formState;
	  shallowFieldsStateRef.current = shouldUnregister ? {} : isEmptyObject(shallowFieldsStateRef.current) ? cloneObject(defaultValues) : shallowFieldsStateRef.current;
	  const updateFormState = T$1((state = {}) => {
	    if (!isUnMount.current) {
	      formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
	      setFormState(formStateRef.current);
	    }
	  }, []);

	  const updateIsValidating = () => readFormStateRef.current.isValidating && updateFormState({
	    isValidating: true
	  });

	  const shouldRenderBaseOnError = T$1((name, error, shouldRender = false, state = {}, isValid) => {
	    let shouldReRender = shouldRender || isErrorStateChanged({
	      errors: formStateRef.current.errors,
	      error,
	      name,
	      validFields: validFieldsRef.current,
	      fieldsWithValidation: fieldsWithValidationRef.current
	    });
	    const previousError = get(formStateRef.current.errors, name);

	    if (error) {
	      unset(validFieldsRef.current, name);
	      shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
	      set(formStateRef.current.errors, name, error);
	    } else {
	      if (get(fieldsWithValidationRef.current, name) || resolverRef.current) {
	        set(validFieldsRef.current, name, true);
	        shouldReRender = shouldReRender || previousError;
	      }

	      unset(formStateRef.current.errors, name);
	    }

	    if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state) || readFormStateRef.current.isValidating) {
	      updateFormState(Object.assign(Object.assign(Object.assign({}, state), resolverRef.current ? {
	        isValid: !!isValid
	      } : {}), {
	        isValidating: false
	      }));
	    }
	  }, []);
	  const setFieldValue = T$1((name, rawValue) => {
	    const {
	      ref,
	      options
	    } = fieldsRef.current[name];
	    const value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

	    if (isRadioInput(ref)) {
	      (options || []).forEach(({
	        ref: radioRef
	      }) => radioRef.checked = radioRef.value === value);
	    } else if (isFileInput(ref) && !isString(value)) {
	      ref.files = value;
	    } else if (isMultipleSelect(ref)) {
	      [...ref.options].forEach(selectRef => selectRef.selected = value.includes(selectRef.value));
	    } else if (isCheckBoxInput(ref) && options) {
	      options.length > 1 ? options.forEach(({
	        ref: checkboxRef
	      }) => checkboxRef.checked = Array.isArray(value) ? !!value.find(data => data === checkboxRef.value) : value === checkboxRef.value) : options[0].ref.checked = !!value;
	    } else {
	      ref.value = value;
	    }
	  }, []);
	  const isFormDirty = T$1((name, data) => {
	    if (readFormStateRef.current.isDirty) {
	      const formValues = getValues();
	      name && data && set(formValues, name, data);
	      return !deepEqual(formValues, defaultValuesRef.current);
	    }

	    return false;
	  }, []);
	  const updateAndGetDirtyState = T$1((name, shouldRender = true) => {
	    if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
	      const isFieldDirty = !deepEqual(get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
	      const isDirtyFieldExist = get(formStateRef.current.dirtyFields, name);
	      const previousIsDirty = formStateRef.current.isDirty;
	      isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
	      const state = {
	        isDirty: isFormDirty(),
	        dirtyFields: formStateRef.current.dirtyFields
	      };
	      const isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== get(formStateRef.current.dirtyFields, name);
	      isChanged && shouldRender && updateFormState(state);
	      return isChanged ? state : {};
	    }

	    return {};
	  }, []);
	  const executeValidation = T$1(async (name, skipReRender) => {
	    {
	      if (!fieldsRef.current[name]) {
	        console.warn('📋 Field is missing with `name` attribute: ', name);
	        return false;
	      }
	    }

	    const error = (await validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef))[name];
	    shouldRenderBaseOnError(name, error, skipReRender);
	    return isUndefined(error);
	  }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
	  const executeSchemaOrResolverValidation = T$1(async names => {
	    const {
	      errors
	    } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
	    const previousFormIsValid = formStateRef.current.isValid;

	    if (Array.isArray(names)) {
	      const isInputsValid = names.map(name => {
	        const error = get(errors, name);
	        error ? set(formStateRef.current.errors, name, error) : unset(formStateRef.current.errors, name);
	        return !error;
	      }).every(Boolean);
	      updateFormState({
	        isValid: isEmptyObject(errors),
	        isValidating: false
	      });
	      return isInputsValid;
	    } else {
	      const error = get(errors, names);
	      shouldRenderBaseOnError(names, error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
	      return !error;
	    }
	  }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
	  const trigger = T$1(async name => {
	    const fields = name || Object.keys(fieldsRef.current);
	    updateIsValidating();

	    if (resolverRef.current) {
	      return executeSchemaOrResolverValidation(fields);
	    }

	    if (Array.isArray(fields)) {
	      !name && (formStateRef.current.errors = {});
	      const result = await Promise.all(fields.map(async data => await executeValidation(data, null)));
	      updateFormState({
	        isValidating: false
	      });
	      return result.every(Boolean);
	    }

	    return await executeValidation(fields);
	  }, [executeSchemaOrResolverValidation, executeValidation]);
	  const setInternalValues = T$1((name, value, {
	    shouldDirty,
	    shouldValidate
	  }) => {
	    const data = {};
	    set(data, name, value);

	    for (const fieldName of getPath(name, value)) {
	      if (fieldsRef.current[fieldName]) {
	        setFieldValue(fieldName, get(data, fieldName));
	        shouldDirty && updateAndGetDirtyState(fieldName);
	        shouldValidate && trigger(fieldName);
	      }
	    }
	  }, [trigger, setFieldValue, updateAndGetDirtyState]);
	  const setInternalValue = T$1((name, value, config) => {
	    !shouldUnregister && !isPrimitive(value) && set(shallowFieldsStateRef.current, name, Array.isArray(value) ? [...value] : Object.assign({}, value));

	    if (fieldsRef.current[name]) {
	      setFieldValue(name, value);
	      config.shouldDirty && updateAndGetDirtyState(name);
	      config.shouldValidate && trigger(name);
	    } else if (!isPrimitive(value)) {
	      setInternalValues(name, value, config);

	      if (fieldArrayNamesRef.current.has(name)) {
	        const parentName = getFieldArrayParentName(name) || name;
	        set(fieldArrayDefaultValuesRef.current, name, value);
	        resetFieldArrayFunctionRef.current[parentName]({
	          [parentName]: get(fieldArrayDefaultValuesRef.current, parentName)
	        });

	        if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
	          set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
	          updateFormState({
	            isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), {
	              [name]: value
	            }), defaultValuesRef.current)
	          });
	        }
	      }
	    }

	    !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
	  }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);

	  const isFieldWatched = name => isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);

	  const renderWatchedInputs = name => {
	    let found = true;

	    if (!isEmptyObject(useWatchFieldsRef.current)) {
	      for (const key in useWatchFieldsRef.current) {
	        if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
	          useWatchRenderFunctionsRef.current[key]();
	          found = false;
	        }
	      }
	    }

	    return found;
	  };

	  function setValue(name, value, config) {
	    setInternalValue(name, value, config || {});
	    isFieldWatched(name) && updateFormState();
	    renderWatchedInputs(name);
	  }

	  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : async ({
	    type,
	    target
	  }) => {
	    let name = target.name;
	    const field = fieldsRef.current[name];
	    let error;
	    let isValid;

	    if (field) {
	      const isBlurEvent = type === EVENTS.BLUR;
	      const shouldSkipValidation = skipValidation(Object.assign({
	        isBlurEvent,
	        isReValidateOnChange,
	        isReValidateOnBlur,
	        isTouched: !!get(formStateRef.current.touched, name),
	        isSubmitted: formStateRef.current.isSubmitted
	      }, modeRef.current));
	      let state = updateAndGetDirtyState(name, false);
	      let shouldRender = !isEmptyObject(state) || !isBlurEvent && isFieldWatched(name);

	      if (isBlurEvent && !get(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
	        set(formStateRef.current.touched, name, true);
	        state = Object.assign(Object.assign({}, state), {
	          touched: formStateRef.current.touched
	        });
	      }

	      if (!shouldUnregister && isCheckBoxInput(target)) {
	        set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
	      }

	      if (shouldSkipValidation) {
	        !isBlurEvent && renderWatchedInputs(name);
	        return (!isEmptyObject(state) || shouldRender && isEmptyObject(state)) && updateFormState(state);
	      }

	      updateIsValidating();

	      if (resolverRef.current) {
	        const {
	          errors
	        } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
	        const previousFormIsValid = formStateRef.current.isValid;
	        error = get(errors, name);

	        if (isCheckBoxInput(target) && !error && resolverRef.current) {
	          const parentNodeName = getFieldArrayParentName(name);
	          const currentError = get(errors, parentNodeName, {});
	          currentError.type && currentError.message && (error = currentError);

	          if (parentNodeName && (currentError || get(formStateRef.current.errors, parentNodeName))) {
	            name = parentNodeName;
	          }
	        }

	        isValid = isEmptyObject(errors);
	        previousFormIsValid !== isValid && (shouldRender = true);
	      } else {
	        error = (await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef))[name];
	      }

	      !isBlurEvent && renderWatchedInputs(name);
	      shouldRenderBaseOnError(name, error, shouldRender, state, isValid);
	    }
	  };

	  function setFieldArrayDefaultValues(data) {
	    if (!shouldUnregister) {
	      let copy = cloneObject(data);

	      for (const value of fieldArrayNamesRef.current) {
	        if (isKey(value) && !copy[value]) {
	          copy = Object.assign(Object.assign({}, copy), {
	            [value]: []
	          });
	        }
	      }

	      return copy;
	    }

	    return data;
	  }

	  function getValues(payload) {
	    if (isString(payload)) {
	      return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
	    }

	    if (Array.isArray(payload)) {
	      const data = {};

	      for (const name of payload) {
	        set(data, name, getFieldValue(fieldsRef, name, shallowFieldsStateRef));
	      }

	      return data;
	    }

	    return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
	  }

	  const validateResolver = T$1(async (values = {}) => {
	    const newDefaultValues = isEmptyObject(fieldsRef.current) ? defaultValuesRef.current : {};
	    const {
	      errors
	    } = (await resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria)) || {};
	    const isValid = isEmptyObject(errors);
	    formStateRef.current.isValid !== isValid && updateFormState({
	      isValid
	    });
	  }, [isValidateAllFieldCriteria]);
	  const removeFieldEventListener = T$1((field, forceDelete) => {
	    findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);

	    if (shouldUnregister) {
	      unset(validFieldsRef.current, field.ref.name);
	      unset(fieldsWithValidationRef.current, field.ref.name);
	    }
	  }, [shouldUnregister]);
	  const updateWatchedValue = T$1(name => {
	    if (isWatchAllRef.current) {
	      updateFormState();
	    } else {
	      for (const watchField of watchFieldsRef.current) {
	        if (watchField.startsWith(name)) {
	          updateFormState();
	          break;
	        }
	      }

	      renderWatchedInputs(name);
	    }
	  }, []);
	  const removeFieldEventListenerAndRef = T$1((field, forceDelete) => {
	    if (field) {
	      removeFieldEventListener(field, forceDelete);

	      if (shouldUnregister && !compact(field.options || []).length) {
	        unset(formStateRef.current.errors, field.ref.name);
	        set(formStateRef.current.dirtyFields, field.ref.name, true);
	        updateFormState({
	          isDirty: isFormDirty()
	        });
	        readFormStateRef.current.isValid && resolverRef.current && validateResolver();
	        updateWatchedValue(field.ref.name);
	      }
	    }
	  }, [validateResolver, removeFieldEventListener]);

	  function clearErrors(name) {
	    name && (Array.isArray(name) ? name : [name]).forEach(inputName => fieldsRef.current[inputName] && isKey(inputName) ? delete formStateRef.current.errors[inputName] : unset(formStateRef.current.errors, inputName));
	    updateFormState({
	      errors: name ? formStateRef.current.errors : {}
	    });
	  }

	  function setError(name, error) {
	    const ref = (fieldsRef.current[name] || {}).ref;
	    set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
	      ref
	    }));
	    updateFormState({
	      isValid: false
	    });
	    error.shouldFocus && ref && ref.focus && ref.focus();
	  }

	  const watchInternal = T$1((fieldNames, defaultValue, watchId) => {
	    const watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
	    let fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);

	    if (isString(fieldNames)) {
	      const parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;

	      if (fieldArrayNamesRef.current.has(parentNodeName)) {
	        fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
	      }

	      return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(get(defaultValuesRef.current, fieldNames)) ? defaultValue : get(defaultValuesRef.current, fieldNames), true);
	    }

	    const combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;

	    if (Array.isArray(fieldNames)) {
	      return fieldNames.reduce((previous, name) => Object.assign(Object.assign({}, previous), {
	        [name]: assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)
	      }), {});
	    }

	    isWatchAllRef.current = isUndefined(watchId);
	    return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
	  }, []);

	  function watch(fieldNames, defaultValue) {
	    return watchInternal(fieldNames, defaultValue);
	  }

	  function unregister(name) {
	    for (const fieldName of Array.isArray(name) ? name : [name]) {
	      removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
	    }
	  }

	  function registerFieldRef(ref, options = {}) {
	    {
	      if (!ref.name) {
	        return console.warn('📋 Field is missing `name` attribute', ref, `https://react-hook-form.com/api#useForm`);
	      }

	      if (fieldArrayNamesRef.current.has(ref.name.split(/\[\d+\]$/)[0]) && !RegExp(`^${ref.name.split(/\[\d+\]$/)[0]}[\\d+].\\w+`.replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(ref.name)) {
	        return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', ref, 'https://react-hook-form.com/api#useFieldArray');
	      }
	    }

	    const {
	      name,
	      type,
	      value
	    } = ref;
	    const fieldRefAndValidationOptions = Object.assign({
	      ref
	    }, options);
	    const fields = fieldsRef.current;
	    const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
	    const isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

	    const compareRef = currentRef => isWeb && (!isHTMLElement(ref) || currentRef === ref);

	    let field = fields[name];
	    let isEmptyDefaultValue = true;
	    let defaultValue;

	    if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find(option => {
	      return value === option.ref.value && compareRef(option.ref);
	    }) : compareRef(field.ref))) {
	      fields[name] = Object.assign(Object.assign({}, field), options);
	      return;
	    }

	    if (type) {
	      field = isRadioOrCheckbox ? Object.assign({
	        options: [...compact(field && field.options || []), {
	          ref
	        }],
	        ref: {
	          type,
	          name
	        }
	      }, options) : Object.assign({}, fieldRefAndValidationOptions);
	    } else {
	      field = fieldRefAndValidationOptions;
	    }

	    fields[name] = field;
	    const isEmptyUnmountFields = isUndefined(get(shallowFieldsStateRef.current, name));

	    if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
	      defaultValue = get(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
	      isEmptyDefaultValue = isUndefined(defaultValue);

	      if (!isEmptyDefaultValue && !isFieldArray) {
	        setFieldValue(name, defaultValue);
	      }
	    }

	    if (!isEmptyObject(options)) {
	      set(fieldsWithValidationRef.current, name, true);

	      if (!isOnSubmit && readFormStateRef.current.isValid) {
	        validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then(error => {
	          const previousFormIsValid = formStateRef.current.isValid;
	          isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
	          previousFormIsValid !== isEmptyObject(error) && updateFormState();
	        });
	      }
	    }

	    if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
	      !isFieldArray && unset(formStateRef.current.dirtyFields, name);
	    }

	    if (type) {
	      attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
	    }
	  }

	  function register(refOrRegisterOptions, options) {
	    if (!isWindowUndefined) {
	      if (isString(refOrRegisterOptions)) {
	        registerFieldRef({
	          name: refOrRegisterOptions
	        }, options);
	      } else if (isObject(refOrRegisterOptions) && 'name' in refOrRegisterOptions) {
	        registerFieldRef(refOrRegisterOptions, options);
	      } else {
	        return ref => ref && registerFieldRef(ref, refOrRegisterOptions);
	      }
	    }
	  }

	  const handleSubmit = T$1((onValid, onInvalid) => async e => {
	    if (e && e.preventDefault) {
	      e.preventDefault();
	      e.persist();
	    }

	    let fieldErrors = {};
	    let fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
	    readFormStateRef.current.isSubmitting && updateFormState({
	      isSubmitting: true
	    });

	    try {
	      if (resolverRef.current) {
	        const {
	          errors,
	          values
	        } = await resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);
	        formStateRef.current.errors = fieldErrors = errors;
	        fieldValues = values;
	      } else {
	        for (const field of Object.values(fieldsRef.current)) {
	          if (field) {
	            const {
	              name
	            } = field.ref;
	            const fieldError = await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

	            if (fieldError[name]) {
	              set(fieldErrors, name, fieldError[name]);
	              unset(validFieldsRef.current, name);
	            } else if (get(fieldsWithValidationRef.current, name)) {
	              unset(formStateRef.current.errors, name);
	              set(validFieldsRef.current, name, true);
	            }
	          }
	        }
	      }

	      if (isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every(name => name in fieldsRef.current)) {
	        updateFormState({
	          errors: {},
	          isSubmitting: true
	        });
	        await onValid(fieldValues, e);
	      } else {
	        formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
	        onInvalid && (await onInvalid(formStateRef.current.errors, e));
	        shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);
	      }
	    } finally {
	      formStateRef.current.isSubmitting = false;
	      updateFormState({
	        isSubmitted: true,
	        isSubmitting: false,
	        isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
	        submitCount: formStateRef.current.submitCount + 1
	      });
	    }
	  }, [shouldFocusError, isValidateAllFieldCriteria]);

	  const resetRefs = ({
	    errors,
	    isDirty,
	    isSubmitted,
	    touched,
	    isValid,
	    submitCount,
	    dirtyFields
	  }) => {
	    if (!isValid) {
	      validFieldsRef.current = {};
	      fieldsWithValidationRef.current = {};
	    }

	    fieldArrayDefaultValuesRef.current = {};
	    watchFieldsRef.current = new Set();
	    isWatchAllRef.current = false;
	    updateFormState({
	      submitCount: submitCount ? formStateRef.current.submitCount : 0,
	      isDirty: isDirty ? formStateRef.current.isDirty : false,
	      isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
	      isValid: isValid ? formStateRef.current.isValid : false,
	      dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
	      touched: touched ? formStateRef.current.touched : {},
	      errors: errors ? formStateRef.current.errors : {},
	      isSubmitting: false,
	      isSubmitSuccessful: false
	    });
	  };

	  const reset = (values, omitResetState = {}) => {
	    if (isWeb) {
	      for (const field of Object.values(fieldsRef.current)) {
	        if (field) {
	          const {
	            ref,
	            options
	          } = field;
	          const inputRef = isRadioOrCheckboxFunction(ref) && Array.isArray(options) ? options[0].ref : ref;

	          if (isHTMLElement(inputRef)) {
	            try {
	              inputRef.closest('form').reset();
	              break;
	            } catch (_a) {}
	          }
	        }
	      }
	    }

	    fieldsRef.current = {};
	    defaultValuesRef.current = Object.assign({}, values || defaultValuesRef.current);
	    values && renderWatchedInputs('');
	    Object.values(resetFieldArrayFunctionRef.current).forEach(resetFieldArray => isFunction(resetFieldArray) && resetFieldArray());
	    shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values || defaultValuesRef.current);
	    resetRefs(omitResetState);
	  };

	  h$1(() => {
	    resolver && readFormStateRef.current.isValid && validateResolver();
	    observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
	  }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
	  h$1(() => () => {
	    observerRef.current && observerRef.current.disconnect();
	    isUnMount.current = true;

	    {
	      return;
	    }
	  }, []);

	  if (!resolver && readFormStateRef.current.isValid) {
	    formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
	  }

	  const commonProps = {
	    trigger,
	    setValue: T$1(setValue, [setInternalValue, trigger]),
	    getValues: T$1(getValues, []),
	    register: T$1(register, [defaultValuesRef.current]),
	    unregister: T$1(unregister, []),
	    formState: isProxyEnabled ? new Proxy(formState, {
	      get: (obj, prop) => {
	        {
	          if (prop === 'isValid' && isOnSubmit) {
	            console.warn('📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState');
	          }
	        }

	        if (prop in obj) {
	          readFormStateRef.current[prop] = true;
	          return obj[prop];
	        }

	        return undefined;
	      }
	    }) : formState
	  };
	  const control = F$1(() => Object.assign({
	    isFormDirty,
	    updateWatchedValue,
	    shouldUnregister,
	    updateFormState,
	    removeFieldEventListener,
	    watchInternal,
	    mode: modeRef.current,
	    reValidateMode: {
	      isReValidateOnBlur,
	      isReValidateOnChange
	    },
	    validateResolver: resolver ? validateResolver : undefined,
	    fieldsRef,
	    resetFieldArrayFunctionRef,
	    useWatchFieldsRef,
	    useWatchRenderFunctionsRef,
	    fieldArrayDefaultValuesRef,
	    validFieldsRef,
	    fieldsWithValidationRef,
	    fieldArrayNamesRef,
	    readFormStateRef,
	    formStateRef,
	    defaultValuesRef,
	    shallowFieldsStateRef,
	    fieldArrayValuesRef
	  }, commonProps), [defaultValuesRef.current, updateWatchedValue, shouldUnregister, removeFieldEventListener, watchInternal]);
	  return Object.assign({
	    watch,
	    control,
	    handleSubmit,
	    reset: T$1(reset, []),
	    clearErrors: T$1(clearErrors, []),
	    setError: T$1(setError, []),
	    errors: formState.errors
	  }, commonProps);
	}

	const FormContext = B(null);
	FormContext.displayName = 'RHFContext';

	var css_248z$j = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.text-area {\n  width: 100%;\n  border-radius: 10px 10px 0 0;\n}\n.text-input-section {\n  width: 100%;\n}\n.text-input-form {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 2.5rem 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n}\n.text-input-btn {\n  border-radius: 0 0 10px 10px;\n  width: 80vw;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .text-area {\n    width: 90%;\n  }\n  .text-input-form {\n    padding: 2rem 2.5rem;\n    width: 60vw;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .text-input-btn {\n    width: 90%;\n  }\n}\n.x-utu-feedback-text-space {\n  margin-right: 80%;\n}";
	styleInject(css_248z$j);

	/* eslint-disable no-nested-ternary */
	var minLength = 5;
	function FeedbackTextInput(props) {
	  var _props$ATTR_THEME_COL;

	  var envCondition = (_props$ATTR_THEME_COL = props[ATTR_THEME_COLOR]) !== null && _props$ATTR_THEME_COL !== void 0 ? _props$ATTR_THEME_COL : "light";
	  var walletAddress = q$1(WalletAddressContext);

	  if (props[ATTR_SOURCE_UUID] === "address") {
	    props[ATTR_SOURCE_UUID] = walletAddress;
	  }

	  var _getBaseProps = getBaseProps(props, TAG_FEEDBACK_FORM),
	      apiUrl = _getBaseProps.apiUrl;

	  var _useFeedbackApi = useFeedbackApi(apiUrl, props[ATTR_SOURCE_UUID], props[ATTR_TARGET_UUID], props[ATTR_TRANSACTION_ID]),
	      sendFeedback = _useFeedbackApi.sendFeedback,
	      submitStatus = _useFeedbackApi.submitStatus;

	  var _useForm = useForm(),
	      register = _useForm.register,
	      errors = _useForm.errors,
	      handleSubmit = _useForm.handleSubmit;

	  function onSubmit(feedback) {
	    sendFeedback(feedback);
	  }

	  return h$2(BaseComponent, {
	    style: css_248z$j // className={`text-input-form utu-section-no-border-${envCondition}`} 
	    ,
	    className: "d-flex justify-content-center text-input-section utu-section utu-section-no-border-".concat(envCondition),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2("form", {
	    onSubmit: handleSubmit(onSubmit),
	    className: "text-input-form"
	  }, h$2("h3", {
	    className: "x-utu-feedback-text-space"
	  }, "Text Review"), h$2("textarea", {
	    className: "text-area text-area-".concat(envCondition),
	    ref: register({
	      required: true,
	      minLength: minLength
	    }),
	    name: "review",
	    placeholder: "Your text review"
	  }), errors.review && h$2("div", {
	    className: "mt-1 error"
	  }, "* Feedback should be at least ", minLength, " characters long"), h$2(SubmitStatusView, {
	    submitStatus: submitStatus
	  }, h$2("button", {
	    style: {
	      backgroundColor: props[ATTR_BTN_COLOR] === undefined ? null : "".concat(props[ATTR_BTN_COLOR])
	    },
	    className: "text-input-btn btn btn-".concat(envCondition),
	    type: "submit"
	  }, "Submit text review"))));
	}

	var $includes = arrayIncludes.includes;



	 // FF99+ bug


	var BROKEN_ON_SPARSE = fails(function () {
	  return !Array(1).includes();
	}); // `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes

	_export({
	  target: 'Array',
	  proto: true,
	  forced: BROKEN_ON_SPARSE
	}, {
	  includes: function includes(el
	  /* , fromIndex = 0 */
	  ) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	addToUnscopables('includes');

	var $TypeError$1 = TypeError;

	var notARegexp = function (it) {
	  if (isRegexp(it)) {
	    throw $TypeError$1("The method doesn't accept regular expressions");
	  }

	  return it;
	};

	var MATCH = wellKnownSymbol('match');

	var correctIsRegexpLogic = function (METHOD_NAME) {
	  var regexp = /./;

	  try {
	    '/./'[METHOD_NAME](regexp);
	  } catch (error1) {
	    try {
	      regexp[MATCH] = false;
	      return '/./'[METHOD_NAME](regexp);
	    } catch (error2) {
	      /* empty */
	    }
	  }

	  return false;
	};

	var stringIndexOf = functionUncurryThis(''.indexOf); // `String.prototype.includes` method
	// https://tc39.es/ecma262/#sec-string.prototype.includes

	_export({
	  target: 'String',
	  proto: true,
	  forced: !correctIsRegexpLogic('includes')
	}, {
	  includes: function includes(searchString
	  /* , position = 0 */
	  ) {
	    return !!~stringIndexOf(toString$2(requireObjectCoercible(this)), toString$2(notARegexp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var $String = String;
	var $TypeError = TypeError;

	var aPossiblePrototype = function (argument) {
	  if (typeof argument == 'object' || isCallable(argument)) return argument;
	  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
	};

	/* eslint-disable no-proto -- safe */

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es-x/no-object-setprototypeof -- safe


	var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;

	  try {
	    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
	    setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) {
	    /* empty */
	  }

	  return function setPrototypeOf(O, proto) {
	    anObject(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	// makes subclassing work correct for wrapped built-ins


	var inheritIfRequired = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if ( // it can work only with native `setPrototypeOf`
	  objectSetPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	  isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject$2(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};

	// `thisNumberValue` abstract operation
	// https://tc39.es/ecma262/#sec-thisnumbervalue


	var thisNumberValue = functionUncurryThis(1.0.valueOf);

	// a string of all valid unicode whitespaces
	var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var replace = functionUncurryThis(''.replace);
	var whitespace = '[' + whitespaces + ']';
	var ltrim = RegExp('^' + whitespace + whitespace + '*');
	var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

	var createMethod = function (TYPE) {
	  return function ($this) {
	    var string = toString$2(requireObjectCoercible($this));
	    if (TYPE & 1) string = replace(string, ltrim, '');
	    if (TYPE & 2) string = replace(string, rtrim, '');
	    return string;
	  };
	};

	var stringTrim = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod(3)
	};

	var getOwnPropertyNames = objectGetOwnPropertyNames.f;

	var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

	var defineProperty = objectDefineProperty.f;



	var trim = stringTrim.trim;

	var NUMBER = 'Number';
	var NativeNumber = global$1[NUMBER];
	var NumberPrototype = NativeNumber.prototype;
	var TypeError$1 = global$1.TypeError;
	var arraySlice = functionUncurryThis(''.slice);
	var charCodeAt = functionUncurryThis(''.charCodeAt); // `ToNumeric` abstract operation
	// https://tc39.es/ecma262/#sec-tonumeric

	var toNumeric = function (value) {
	  var primValue = toPrimitive(value, 'number');
	  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
	}; // `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber


	var toNumber = function (argument) {
	  var it = toPrimitive(argument, 'number');
	  var first, third, radix, maxCode, digits, length, index, code;
	  if (isSymbol$1(it)) throw TypeError$1('Cannot convert a Symbol value to a number');

	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = charCodeAt(it, 0);

	    if (first === 43 || first === 45) {
	      third = charCodeAt(it, 2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (charCodeAt(it, 1)) {
	        case 66:
	        case 98:
	          radix = 2;
	          maxCode = 49;
	          break;
	        // fast equal of /^0b[01]+$/i

	        case 79:
	        case 111:
	          radix = 8;
	          maxCode = 55;
	          break;
	        // fast equal of /^0o[0-7]+$/i

	        default:
	          return +it;
	      }

	      digits = arraySlice(it, 2);
	      length = digits.length;

	      for (index = 0; index < length; index++) {
	        code = charCodeAt(digits, index); // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols

	        if (code < 48 || code > maxCode) return NaN;
	      }

	      return parseInt(digits, radix);
	    }
	  }

	  return +it;
	}; // `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor


	if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
	  var NumberWrapper = function Number(value) {
	    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
	    var dummy = this; // check on 1..constructor(foo) case

	    return objectIsPrototypeOf(NumberPrototype, dummy) && fails(function () {
	      thisNumberValue(dummy);
	    }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
	  };

	  for (var keys = descriptors ? getOwnPropertyNames(NativeNumber) : ( // ES3:
	  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
	  'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' + // ESNext
	  'fromString,range').split(','), j = 0, key; keys.length > j; j++) {
	    if (hasOwnProperty_1(NativeNumber, key = keys[j]) && !hasOwnProperty_1(NumberWrapper, key)) {
	      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
	    }
	  }

	  NumberWrapper.prototype = NumberPrototype;
	  NumberPrototype.constructor = NumberWrapper;
	  defineBuiltIn(global$1, NUMBER, NumberWrapper, {
	    constructor: true
	  });
	}

	var abi = [
		{
			inputs: [
				{
					internalType: "uint256",
					name: "_mintAmount",
					type: "uint256"
				},
				{
					internalType: "address",
					name: "_oracle",
					type: "address"
				},
				{
					internalType: "string",
					name: "_jobId",
					type: "string"
				},
				{
					internalType: "uint256",
					name: "_fee",
					type: "uint256"
				},
				{
					internalType: "address",
					name: "_link",
					type: "address"
				}
			],
			stateMutability: "nonpayable",
			type: "constructor"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "address",
					name: "_user",
					type: "address"
				},
				{
					indexed: true,
					internalType: "uint256",
					name: "_connectedTypeId",
					type: "uint256"
				},
				{
					indexed: true,
					internalType: "bytes32",
					name: "_connectedUserIdHash",
					type: "bytes32"
				}
			],
			name: "AddConnection",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "address",
					name: "owner",
					type: "address"
				},
				{
					indexed: true,
					internalType: "address",
					name: "spender",
					type: "address"
				},
				{
					indexed: false,
					internalType: "uint256",
					name: "value",
					type: "uint256"
				}
			],
			name: "Approval",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "bytes32",
					name: "id",
					type: "bytes32"
				}
			],
			name: "ChainlinkCancelled",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "bytes32",
					name: "id",
					type: "bytes32"
				}
			],
			name: "ChainlinkFulfilled",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "bytes32",
					name: "id",
					type: "bytes32"
				}
			],
			name: "ChainlinkRequested",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "address",
					name: "_from",
					type: "address"
				},
				{
					indexed: true,
					internalType: "address",
					name: "_to",
					type: "address"
				},
				{
					indexed: false,
					internalType: "uint256",
					name: "_value",
					type: "uint256"
				},
				{
					indexed: false,
					internalType: "string",
					name: "_transactionId",
					type: "string"
				}
			],
			name: "Endorse",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "address",
					name: "previousOwner",
					type: "address"
				},
				{
					indexed: true,
					internalType: "address",
					name: "newOwner",
					type: "address"
				}
			],
			name: "OwnershipTransferred",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: false,
					internalType: "address",
					name: "account",
					type: "address"
				}
			],
			name: "Paused",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "address",
					name: "_user",
					type: "address"
				},
				{
					indexed: true,
					internalType: "uint256",
					name: "_connectedTypeId",
					type: "uint256"
				},
				{
					indexed: true,
					internalType: "bytes32",
					name: "_connectedUserIdHash",
					type: "bytes32"
				}
			],
			name: "RemoveConnection",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: false,
					internalType: "address",
					name: "endorser",
					type: "address"
				},
				{
					indexed: false,
					internalType: "uint256",
					name: "reward",
					type: "uint256"
				}
			],
			name: "RewardPreviousEndorserLevel1",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: false,
					internalType: "address",
					name: "endorser",
					type: "address"
				},
				{
					indexed: false,
					internalType: "uint256",
					name: "reward",
					type: "uint256"
				}
			],
			name: "RewardPreviousEndorserLevel2",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: true,
					internalType: "address",
					name: "from",
					type: "address"
				},
				{
					indexed: true,
					internalType: "address",
					name: "to",
					type: "address"
				},
				{
					indexed: false,
					internalType: "uint256",
					name: "value",
					type: "uint256"
				}
			],
			name: "Transfer",
			type: "event"
		},
		{
			anonymous: false,
			inputs: [
				{
					indexed: false,
					internalType: "address",
					name: "account",
					type: "address"
				}
			],
			name: "Unpaused",
			type: "event"
		},
		{
			inputs: [
			],
			name: "D_lvl1",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "D_lvl2",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "D_n",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "D_o",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "O_n",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "user",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "connectedTypeId",
					type: "uint256"
				},
				{
					internalType: "bytes32",
					name: "connectedUserIdHash",
					type: "bytes32"
				}
			],
			name: "addConnection",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "owner",
					type: "address"
				},
				{
					internalType: "address",
					name: "spender",
					type: "address"
				}
			],
			name: "allowance",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "spender",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				}
			],
			name: "approve",
			outputs: [
				{
					internalType: "bool",
					name: "",
					type: "bool"
				}
			],
			stateMutability: "pure",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "account",
					type: "address"
				}
			],
			name: "balanceOf",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				}
			],
			name: "burn",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "account",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				}
			],
			name: "burnFrom",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
			],
			name: "decimals",
			outputs: [
				{
					internalType: "uint8",
					name: "",
					type: "uint8"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "spender",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "subtractedValue",
					type: "uint256"
				}
			],
			name: "decreaseAllowance",
			outputs: [
				{
					internalType: "bool",
					name: "",
					type: "bool"
				}
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "target",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				},
				{
					internalType: "string",
					name: "transactionId",
					type: "string"
				}
			],
			name: "endorse",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "bytes32",
					name: "_requestId",
					type: "bytes32"
				},
				{
					internalType: "address[]",
					name: "endorsersLevel1",
					type: "address[]"
				},
				{
					internalType: "address[]",
					name: "endorsersLevel2",
					type: "address[]"
				}
			],
			name: "fulfillEndorse",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "spender",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "addedValue",
					type: "uint256"
				}
			],
			name: "increaseAllowance",
			outputs: [
				{
					internalType: "bool",
					name: "",
					type: "bool"
				}
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
			],
			name: "name",
			outputs: [
				{
					internalType: "string",
					name: "",
					type: "string"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "owner",
			outputs: [
				{
					internalType: "address",
					name: "",
					type: "address"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "pause",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
			],
			name: "paused",
			outputs: [
				{
					internalType: "bool",
					name: "",
					type: "bool"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "",
					type: "address"
				},
				{
					internalType: "address",
					name: "",
					type: "address"
				}
			],
			name: "previousEndorserStakes",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "user",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "connectedTypeId",
					type: "uint256"
				}
			],
			name: "removeConnection",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
			],
			name: "renounceOwnership",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				}
			],
			name: "setSocialConnectionReward",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
			],
			name: "socialConnectionReward",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "string",
					name: "source",
					type: "string"
				}
			],
			name: "stringToBytes32",
			outputs: [
				{
					internalType: "bytes32",
					name: "result",
					type: "bytes32"
				}
			],
			stateMutability: "pure",
			type: "function"
		},
		{
			inputs: [
			],
			name: "symbol",
			outputs: [
				{
					internalType: "string",
					name: "",
					type: "string"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "",
					type: "address"
				}
			],
			name: "totalStake",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
			],
			name: "totalSupply",
			outputs: [
				{
					internalType: "uint256",
					name: "",
					type: "uint256"
				}
			],
			stateMutability: "view",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "recipient",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				}
			],
			name: "transfer",
			outputs: [
				{
					internalType: "bool",
					name: "",
					type: "bool"
				}
			],
			stateMutability: "pure",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "sender",
					type: "address"
				},
				{
					internalType: "address",
					name: "recipient",
					type: "address"
				},
				{
					internalType: "uint256",
					name: "amount",
					type: "uint256"
				}
			],
			name: "transferFrom",
			outputs: [
				{
					internalType: "bool",
					name: "",
					type: "bool"
				}
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
				{
					internalType: "address",
					name: "newOwner",
					type: "address"
				}
			],
			name: "transferOwnership",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		},
		{
			inputs: [
			],
			name: "unpause",
			outputs: [
			],
			stateMutability: "nonpayable",
			type: "function"
		}
	];

	var css_248z$i = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.endor-input-form {\n  display: flex;\n  flex-direction: row;\n  justify-items: center;\n  justify-content: center;\n  align-items: center;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.endor-input-form-text-area {\n  height: 3rem;\n  width: 100%;\n  margin-right: 1rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.8rem;\n  align-items: center;\n  align-content: center;\n  background-color: #fcf8e5;\n  overflow: hidden;\n}\n.endor-input-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem 2rem;\n  width: 100%;\n}\n.endor-text {\n  font-size: 1.5rem;\n}\n.endor-text-light {\n  color: black;\n}\n.endor-text-dark {\n  color: white;\n}\n.endor-text-area {\n  display: flex;\n  flex-direction: row;\n}\n.endor-text-info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(252, 229, 70);\n  width: 1rem;\n  height: 1rem;\n  margin-left: 1rem;\n  font-size: 0.8rem;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-left: 0.5rem;\n  transition-timing-function: ease-in-out;\n  transition-duration: 2s;\n  transition: width 2s, height 4s;\n}\n.endor-text-body {\n  font-size: 1rem;\n}\n.endor-text-title {\n  font-size: 1rem;\n}\n.endor-btn {\n  border-radius: 10px;\n}\n\n.endor-utt-balance {\n  display: flex;\n  box-sizing: border-box;\n  width: 10rem;\n  height: 4rem;\n  border-radius: 5px 30px 30px 5px;\n  background-color: rgb(252, 229, 70);\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .endor-input-section {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .endor-input-form {\n    width: 40%;\n    padding: 2rem;\n  }\n  .endor-input-form-text-area {\n    background-color: rgb(253, 253, 253);\n    font-size: 1rem;\n  }\n  .endor-input-form-section {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n  }\n  .endor-text {\n    padding: 2rem;\n    width: 40%;\n  }\n  .endor-text-info {\n    font-size: 1rem;\n  }\n}\n@media only screen and (min-width: 830px) {\n  .endor-input-form-text-area {\n    font-size: 1rem;\n  }\n}\n.utt-balance-logo {\n  justify-items: center;\n  height: 4rem;\n  width: 4rem;\n}\n\n.x-utu-utt-heading-text {\n  margin-top: 7%;\n}";
	styleInject(css_248z$i);

	var _SWITCH_CHAIN_PARAMS, _ADD_CHAIN_PARAMS, _UTT_CONTRACT_ADDRESS;
	/**
	 * Parameter interface definition for wallet_addEthereumChain
	 * Copied from https://docs.metamask.io/guide/rpc-api.html#unrestricted-methods
	 */

	/**
	 * Convers a number to a 0x-prefixed hexadecimal string
	 * @param n
	 */
	function toHexString(n) {
	  return hexStripZeros(hexlify(n));
	}

	var SWITCH_CHAIN_PARAMS = (_SWITCH_CHAIN_PARAMS = {}, _defineProperty$2(_SWITCH_CHAIN_PARAMS, NETWORK_NAME.polygon_mainnet, {
	  chainId: toHexString(137)
	}), _defineProperty$2(_SWITCH_CHAIN_PARAMS, NETWORK_NAME.polygon_mumbai, {
	  chainId: toHexString(80001)
	}), _SWITCH_CHAIN_PARAMS);
	var ADD_CHAIN_PARAMS = (_ADD_CHAIN_PARAMS = {}, _defineProperty$2(_ADD_CHAIN_PARAMS, NETWORK_NAME.polygon_mainnet, {
	  chainId: SWITCH_CHAIN_PARAMS[NETWORK_NAME.polygon_mainnet].chainId,
	  chainName: "Polygon",
	  nativeCurrency: {
	    name: "MATIC",
	    symbol: "MATIC",
	    decimals: 18
	  },
	  rpcUrls: ["https://polygon-rpc.com"],
	  blockExplorerUrls: ["https://polygonscan.com"]
	}), _defineProperty$2(_ADD_CHAIN_PARAMS, NETWORK_NAME.polygon_mumbai, {
	  chainId: SWITCH_CHAIN_PARAMS[NETWORK_NAME.polygon_mumbai].chainId,
	  chainName: "Mumbai",
	  nativeCurrency: {
	    name: "MATIC",
	    symbol: "MATIC",
	    decimals: 18
	  },
	  rpcUrls: ["https://rpc-mumbai.maticvigil.com"],
	  blockExplorerUrls: ["https://mumbai.polygonscan.com"]
	}), _ADD_CHAIN_PARAMS);
	var UTT_CONTRACT_ADDRESS = (_UTT_CONTRACT_ADDRESS = {}, _defineProperty$2(_UTT_CONTRACT_ADDRESS, NETWORK_NAME.polygon_mainnet, "0xbA6de5f4a98d2AEbb289d1136194D05Ee24C426f"), _defineProperty$2(_UTT_CONTRACT_ADDRESS, NETWORK_NAME.polygon_mumbai, "0x19bc90FfBDCaD53c48eF0b08A67B0D2563AEE2a8"), _UTT_CONTRACT_ADDRESS);
	function addNetwork(_x, _x2) {
	  return _addNetwork.apply(this, arguments);
	}

	function _addNetwork() {
	  _addNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(provider, networkName) {
	    var network;
	    return _regeneratorRuntime().wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            network = ADD_CHAIN_PARAMS[networkName];
	            _context.next = 3;
	            return provider.request({
	              method: "wallet_addEthereumChain",
	              params: [network]
	            });

	          case 3:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee);
	  }));
	  return _addNetwork.apply(this, arguments);
	}

	function requestNetworkChange(_x3, _x4) {
	  return _requestNetworkChange.apply(this, arguments);
	}

	function _requestNetworkChange() {
	  _requestNetworkChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(provider, networkName) {
	    var network;
	    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            network = SWITCH_CHAIN_PARAMS[networkName];
	            _context2.next = 3;
	            return provider.request({
	              method: "wallet_switchEthereumChain",
	              params: [network]
	            });

	          case 3:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2);
	  }));
	  return _requestNetworkChange.apply(this, arguments);
	}

	function getDefaultNetworkName() {
	  return config.production ? NETWORK_NAME.polygon_mainnet : NETWORK_NAME.polygon_mumbai;
	}
	function getUTTContractAddress(networkName) {
	  return UTT_CONTRACT_ADDRESS[networkName];
	}

	var css_248z$h = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utt_balance {\n  width: 100%;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  background-color: rgb(252, 229, 70);\n}";
	styleInject(css_248z$h);

	function UttBalance() {
	  var _useWalletConnectApi = useWalletConnectApi(),
	      web3Modal = _useWalletConnectApi.web3Modal;

	  var _useState = p(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      UTTWalletState = _useState2[0],
	      setUTTWalletState = _useState2[1];

	  h$1(function () {
	    var getProvider = /*#__PURE__*/function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	        var provider, network, ethersProvider, userAddress, getContract, walletUTTBalance, UTTBalance;
	        return _regeneratorRuntime().wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return web3Modal.connect();

	              case 2:
	                provider = _context.sent;
	                network = getNetwork();
	                _context.next = 6;
	                return requestNetworkChange(provider, network);

	              case 6:
	                ethersProvider = new Web3Provider(provider);
	                _context.next = 9;
	                return ethersProvider.getSigner().getAddress();

	              case 9:
	                userAddress = _context.sent;
	                getContract = new Contract(UTT_CONTRACT_ADDRESS_TEST, abi, ethersProvider);
	                _context.next = 13;
	                return getContract.balanceOf(userAddress);

	              case 13:
	                walletUTTBalance = _context.sent;
	                UTTBalance = Number(formatUnits(walletUTTBalance, 0) || 0);
	                console.log("walletUTTBalance", UTTBalance);
	                setUTTWalletState(UTTBalance);

	              case 17:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee);
	      }));

	      return function getProvider() {
	        return _ref.apply(this, arguments);
	      };
	    }();

	    getProvider().catch(console.error);
	  });

	  function getNetwork() {
	    return getDefaultNetworkName();
	  }

	  return h$2(BaseComponent, {
	    style: css_248z$h,
	    className: "my-1 utt_balance"
	  }, h$2("h3", null, UTTWalletState));
	}

	function EndorsementForm(props) {
	  var _window, _window2;

	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1];

	  var _useState3 = p(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      txError = _useState4[0],
	      setTxError = _useState4[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  } // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  var _useForm = useForm(),
	      register = _useForm.register,
	      errors = _useForm.errors,
	      handleSubmit = _useForm.handleSubmit; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	  // @ts-ignore


	  if (!((_window = window) !== null && _window !== void 0 && _window.ethereum || (_window2 = window) !== null && _window2 !== void 0 && _window2.web3 || window.utuWeb3Provider) || !props[ATTR_TARGET_UUID] || !isAddress(props[ATTR_TARGET_UUID]) || !props[ATTR_TRANSACTION_ID]) return null;

	  function getProvider() {
	    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	    // @ts-ignore
	    return window.utuWeb3Provider || window.ethereum;
	  }
	  /**
	   * Determines which network to use for endorsements.
	   */


	  function getEndorsementNetwork() {
	    var _props$ATTR_ENDORSEME;

	    return (_props$ATTR_ENDORSEME = props[ATTR_ENDORSEMENT_NETWORK]) !== null && _props$ATTR_ENDORSEME !== void 0 ? _props$ATTR_ENDORSEME : getDefaultNetworkName();
	  }
	  /**
	   * Switches to the given network, adding it if necessary.
	   */


	  function switchNetwork(_x) {
	    return _switchNetwork.apply(this, arguments);
	  }
	  /**
	   * return the UTU contract instance on the given network
	   */


	  function _switchNetwork() {
	    _switchNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(network) {
	      var provider;
	      return _regeneratorRuntime().wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              provider = getProvider();
	              _context.prev = 1;
	              _context.next = 4;
	              return requestNetworkChange(provider, network);

	            case 4:
	              _context.next = 14;
	              break;

	            case 6:
	              _context.prev = 6;
	              _context.t0 = _context["catch"](1);
	              console.log(_context.t0, _context.t0.message);

	              if (!(_context.t0.code === 4902 || _context.t0.message.toLowerCase().includes("unrecognized"))) {
	                _context.next = 14;
	                break;
	              }

	              _context.next = 12;
	              return addNetwork(provider, network);

	            case 12:
	              _context.next = 14;
	              return requestNetworkChange(provider, network);

	            case 14:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, null, [[1, 6]]);
	    }));
	    return _switchNetwork.apply(this, arguments);
	  }

	  function getContractInstance(_x2) {
	    return _getContractInstance.apply(this, arguments);
	  }
	  /**
	   * returns the current connected address
	   */


	  function _getContractInstance() {
	    _getContractInstance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(network) {
	      var UTT_CONTRACT_ADDRESS, web3Provider, signer;
	      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              UTT_CONTRACT_ADDRESS = getUTTContractAddress(network);
	              _context2.next = 3;
	              return new Web3Provider(getProvider());

	            case 3:
	              web3Provider = _context2.sent;
	              signer = web3Provider.getSigner();
	              return _context2.abrupt("return", new Contract(UTT_CONTRACT_ADDRESS, abi, signer));

	            case 6:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2);
	    }));
	    return _getContractInstance.apply(this, arguments);
	  }

	  function getConnectedAddress() {
	    return _getConnectedAddress.apply(this, arguments);
	  }
	  /**
	   * Creates an endorsement transaction
	   * @param address the target address of the endorsement
	   * @param amount the amount of UTT to stake on the endorsement
	   * @param transactionId the business transaction id (might or might not be an Ethereum tx id) to record with the
	   *      endorsement, if any
	   */


	  function _getConnectedAddress() {
	    _getConnectedAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
	      var web3Provider, signer;
	      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.next = 2;
	              return new Web3Provider(getProvider());

	            case 2:
	              web3Provider = _context3.sent;
	              signer = web3Provider.getSigner();
	              return _context3.abrupt("return", signer.getAddress());

	            case 5:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3);
	    }));
	    return _getConnectedAddress.apply(this, arguments);
	  }

	  function endorse(_x3, _x4, _x5) {
	    return _endorse.apply(this, arguments);
	  }

	  function _endorse() {
	    _endorse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(address, amount, transactionId) {
	      var network, contract, connectedAddress, utuBalance, transaction;
	      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              network = getEndorsementNetwork();
	              _context4.next = 3;
	              return switchNetwork(network);

	            case 3:
	              _context4.next = 5;
	              return getContractInstance(network);

	            case 5:
	              contract = _context4.sent;
	              _context4.next = 8;
	              return getConnectedAddress();

	            case 8:
	              connectedAddress = _context4.sent;
	              _context4.next = 11;
	              return contract.balanceOf(connectedAddress);

	            case 11:
	              utuBalance = _context4.sent;

	              if (!(Number(utuBalance) < Number(amount))) {
	                _context4.next = 14;
	                break;
	              }

	              throw new Error("Insufficient UTU tokens");

	            case 14:
	              _context4.next = 16;
	              return contract.endorse(address, String(amount), transactionId);

	            case 16:
	              transaction = _context4.sent;
	              _context4.next = 19;
	              return transaction.wait();

	            case 19:
	              return _context4.abrupt("return", transaction);

	            case 20:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4);
	    }));
	    return _endorse.apply(this, arguments);
	  }

	  function onSubmit(_x6) {
	    return _onSubmit.apply(this, arguments);
	  }

	  function _onSubmit() {
	    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref) {
	      var amount;
	      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              amount = _ref.amount;

	              if (amount) {
	                _context5.next = 3;
	                break;
	              }

	              return _context5.abrupt("return");

	            case 3:
	              setTxError("");
	              _context5.prev = 4;
	              _context5.next = 7;
	              return endorse(props[ATTR_TARGET_UUID], amount, props[ATTR_TRANSACTION_ID]);

	            case 7:
	              _context5.next = 13;
	              break;

	            case 9:
	              _context5.prev = 9;
	              _context5.t0 = _context5["catch"](4);
	              console.log(_context5.t0);
	              setTxError(_context5.t0.data ? _context5.t0.data.message : _context5.t0.message);

	            case 13:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, null, [[4, 9]]);
	    }));
	    return _onSubmit.apply(this, arguments);
	  }

	  var showError = function showError(_ref2) {
	    var amount = _ref2.amount;

	    switch (amount === null || amount === void 0 ? void 0 : amount.type) {
	      case "required":
	        return "Supply a valid token value.";

	      case "min":
	        return "Minimum value supplied should be 1";

	      case "integer":
	        return "Value supplied must be an integer.";

	      default:
	        return "";
	    }
	  };

	  return h$2(BaseComponent, {
	    style: css_248z$i,
	    className: "endor-input-section utu-section utu-section-no-border-".concat(envCondition),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2("section", {
	    className: "endor-input-form-section"
	  }, h$2("div", {
	    className: "endor-utt-balance"
	  }, h$2(UttLogo, null), h$2("div", {
	    className: "x-utu-utt-heading-text"
	  }, h$2("h3", null, "UTT Balance"), h$2(UttBalance, null))), h$2("div", {
	    className: "endor-text endor-text-".concat(envCondition)
	  }, h$2("div", {
	    className: "endor-text-area"
	  }, h$2("p", {
	    className: "endor-text-title"
	  }, "Would you like to Endorse ?"), h$2("p", {
	    className: "endor-text-info",
	    "data-bs-toggle": "tooltip",
	    title: " To endorse, you need to have some UTT in your account. Make sure you have a sufficient balance in your account"
	  }, "i")), h$2("p", {
	    className: "endor-text-body"
	  }, "When you endorse a platform, it means you have personally had a good experience and want to back your rating by staking an amount of UTT (UTU trust token) on the platform.")), h$2("form", {
	    onSubmit: handleSubmit(onSubmit),
	    className: "endor-input-form"
	  }, h$2("div", {
	    style: {
	      flex: 1,
	      marginRight: 20
	    }
	  }, h$2("input", {
	    className: "endor-input-form-text-area endor-input-form-text-area-".concat(envCondition),
	    ref: register({
	      required: true,
	      minLength: 1
	    }),
	    min: "0",
	    type: "number",
	    name: "amount",
	    placeholder: "Your endorsement"
	  }), h$2("div", {
	    className: "mt-1 error"
	  }, errors.amount && "* ".concat(showError(errors))), txError && h$2("div", {
	    className: "mt-1 error"
	  }, txError)), h$2("div", null, h$2("button", {
	    style: {
	      backgroundColor: props[ATTR_BTN_COLOR] === undefined ? null : "".concat(props[ATTR_BTN_COLOR])
	    },
	    className: "endor-btn btn btn-".concat(envCondition),
	    type: "submit"
	  }, "Endorse")))));
	}

	var preact = createCommonjsModule$1(function (module, exports) {
	var n,
	    l,
	    u,
	    t,
	    i,
	    o,
	    r,
	    f = {},
	    e = [],
	    c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;

	function s(n, l) {
	  for (var u in l) n[u] = l[u];

	  return n;
	}

	function a(n) {
	  var l = n.parentNode;
	  l && l.removeChild(n);
	}

	function p(l, u, t) {
	  var i,
	      o,
	      r,
	      f = {};

	  for (r in u) "key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];

	  if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for (r in l.defaultProps) void 0 === f[r] && (f[r] = l.defaultProps[r]);
	  return h(l, f, i, o, null);
	}

	function h(n, t, i, o, r) {
	  var f = {
	    type: n,
	    props: t,
	    key: i,
	    ref: o,
	    __k: null,
	    __: null,
	    __b: 0,
	    __e: null,
	    __d: void 0,
	    __c: null,
	    __h: null,
	    constructor: void 0,
	    __v: null == r ? ++u : r
	  };
	  return null == r && null != l.vnode && l.vnode(f), f;
	}

	function v(n) {
	  return n.children;
	}

	function y(n, l) {
	  this.props = n, this.context = l;
	}

	function d(n, l) {
	  if (null == l) return n.__ ? d(n.__, n.__.__k.indexOf(n) + 1) : null;

	  for (var u; l < n.__k.length; l++) if (null != (u = n.__k[l]) && null != u.__e) return u.__e;

	  return "function" == typeof n.type ? d(n) : null;
	}

	function _(n) {
	  var l, u;

	  if (null != (n = n.__) && null != n.__c) {
	    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) if (null != (u = n.__k[l]) && null != u.__e) {
	      n.__e = n.__c.base = u.__e;
	      break;
	    }

	    return _(n);
	  }
	}

	function k(n) {
	  (!n.__d && (n.__d = !0) && i.push(n) && !x.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || setTimeout)(x);
	}

	function x() {
	  for (var n; x.__r = i.length;) n = i.sort(function (n, l) {
	    return n.__v.__b - l.__v.__b;
	  }), i = [], n.some(function (n) {
	    var l, u, t, i, o, r;
	    n.__d && (o = (i = (l = n).__v).__e, (r = l.__P) && (u = [], (t = s({}, i)).__v = i.__v + 1, I(r, i, t, l.__n, void 0 !== r.ownerSVGElement, null != i.__h ? [o] : null, u, null == o ? d(i) : o, i.__h), T(u, i), i.__e != o && _(i)));
	  });
	}

	function b(n, l, u, t, i, o, r, c, s, a) {
	  var p,
	      y,
	      _,
	      k,
	      x,
	      b,
	      m,
	      A = t && t.__k || e,
	      C = A.length;

	  for (u.__k = [], p = 0; p < l.length; p++) if (null != (k = u.__k[p] = null == (k = l[p]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? h(null, k, null, null, k) : Array.isArray(k) ? h(v, {
	    children: k
	  }, null, null, null) : k.__b > 0 ? h(k.type, k.props, k.key, null, k.__v) : k)) {
	    if (k.__ = u, k.__b = u.__b + 1, null === (_ = A[p]) || _ && k.key == _.key && k.type === _.type) A[p] = void 0;else for (y = 0; y < C; y++) {
	      if ((_ = A[y]) && k.key == _.key && k.type === _.type) {
	        A[y] = void 0;
	        break;
	      }

	      _ = null;
	    }
	    I(n, k, _ = _ || f, i, o, r, c, s, a), x = k.__e, (y = k.ref) && _.ref != y && (m || (m = []), _.ref && m.push(_.ref, null, k), m.push(y, k.__c || x, k)), null != x ? (null == b && (b = x), "function" == typeof k.type && k.__k === _.__k ? k.__d = s = g(k, s, n) : s = w(n, k, _, A, x, s), "function" == typeof u.type && (u.__d = s)) : s && _.__e == s && s.parentNode != n && (s = d(_));
	  }

	  for (u.__e = b, p = C; p--;) null != A[p] && ("function" == typeof u.type && null != A[p].__e && A[p].__e == u.__d && (u.__d = d(t, p + 1)), L(A[p], A[p]));

	  if (m) for (p = 0; p < m.length; p++) z(m[p], m[++p], m[++p]);
	}

	function g(n, l, u) {
	  for (var t, i = n.__k, o = 0; i && o < i.length; o++) (t = i[o]) && (t.__ = n, l = "function" == typeof t.type ? g(t, l, u) : w(u, t, t, i, t.__e, l));

	  return l;
	}

	function w(n, l, u, t, i, o) {
	  var r, f, e;
	  if (void 0 !== l.__d) r = l.__d, l.__d = void 0;else if (null == u || i != o || null == i.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(i), r = null;else {
	    for (f = o, e = 0; (f = f.nextSibling) && e < t.length; e += 2) if (f == i) break n;

	    n.insertBefore(i, o), r = o;
	  }
	  return void 0 !== r ? r : i.nextSibling;
	}

	function m(n, l, u, t, i) {
	  var o;

	  for (o in u) "children" === o || "key" === o || o in l || C(n, o, null, u[o], t);

	  for (o in l) i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || C(n, o, l[o], u[o], t);
	}

	function A(n, l, u) {
	  "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || c.test(l) ? u : u + "px";
	}

	function C(n, l, u, t, i) {
	  var o;

	  n: if ("style" === l) {
	    if ("string" == typeof u) n.style.cssText = u;else {
	      if ("string" == typeof t && (n.style.cssText = t = ""), t) for (l in t) u && l in u || A(n.style, l, "");
	      if (u) for (l in u) t && u[l] === t[l] || A(n.style, l, u[l]);
	    }
	  } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t || n.addEventListener(l, o ? H : $, o) : n.removeEventListener(l, o ? H : $, o);else if ("dangerouslySetInnerHTML" !== l) {
	    if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
	      n[l] = null == u ? "" : u;
	      break n;
	    } catch (n) {}
	    "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
	  }
	}

	function $(n) {
	  this.l[n.type + !1](l.event ? l.event(n) : n);
	}

	function H(n) {
	  this.l[n.type + !0](l.event ? l.event(n) : n);
	}

	function I(n, u, t, i, o, r, f, e, c) {
	  var a,
	      p,
	      h,
	      d,
	      _,
	      k,
	      x,
	      g,
	      w,
	      m,
	      A,
	      C,
	      $,
	      H = u.type;

	  if (void 0 !== u.constructor) return null;
	  null != t.__h && (c = t.__h, e = u.__e = t.__e, u.__h = null, r = [e]), (a = l.__b) && a(u);

	  try {
	    n: if ("function" == typeof H) {
	      if (g = u.props, w = (a = H.contextType) && i[a.__c], m = a ? w ? w.props.value : a.__ : i, t.__c ? x = (p = u.__c = t.__c).__ = p.__E : ("prototype" in H && H.prototype.render ? u.__c = p = new H(g, m) : (u.__c = p = new y(g, m), p.constructor = H, p.render = M), w && w.sub(p), p.props = g, p.state || (p.state = {}), p.context = m, p.__n = i, h = p.__d = !0, p.__h = []), null == p.__s && (p.__s = p.state), null != H.getDerivedStateFromProps && (p.__s == p.state && (p.__s = s({}, p.__s)), s(p.__s, H.getDerivedStateFromProps(g, p.__s))), d = p.props, _ = p.state, h) null == H.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);else {
	        if (null == H.getDerivedStateFromProps && g !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(g, m), !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(g, p.__s, m) || u.__v === t.__v) {
	          p.props = g, p.state = p.__s, u.__v !== t.__v && (p.__d = !1), p.__v = u, u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function (n) {
	            n && (n.__ = u);
	          }), p.__h.length && f.push(p);
	          break n;
	        }

	        null != p.componentWillUpdate && p.componentWillUpdate(g, p.__s, m), null != p.componentDidUpdate && p.__h.push(function () {
	          p.componentDidUpdate(d, _, k);
	        });
	      }
	      if (p.context = m, p.props = g, p.__v = u, p.__P = n, A = l.__r, C = 0, "prototype" in H && H.prototype.render) p.state = p.__s, p.__d = !1, A && A(u), a = p.render(p.props, p.state, p.context);else do {
	        p.__d = !1, A && A(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
	      } while (p.__d && ++C < 25);
	      p.state = p.__s, null != p.getChildContext && (i = s(s({}, i), p.getChildContext())), h || null == p.getSnapshotBeforeUpdate || (k = p.getSnapshotBeforeUpdate(d, _)), $ = null != a && a.type === v && null == a.key ? a.props.children : a, b(n, Array.isArray($) ? $ : [$], u, t, i, o, r, f, e, c), p.base = u.__e, u.__h = null, p.__h.length && f.push(p), x && (p.__E = p.__ = null), p.__e = !1;
	    } else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = j(t.__e, u, t, i, o, r, f, c);

	    (a = l.diffed) && a(u);
	  } catch (n) {
	    u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), l.__e(n, u, t);
	  }
	}

	function T(n, u) {
	  l.__c && l.__c(u, n), n.some(function (u) {
	    try {
	      n = u.__h, u.__h = [], n.some(function (n) {
	        n.call(u);
	      });
	    } catch (n) {
	      l.__e(n, u.__v);
	    }
	  });
	}

	function j(l, u, t, i, o, r, e, c) {
	  var s,
	      p,
	      h,
	      v = t.props,
	      y = u.props,
	      _ = u.type,
	      k = 0;
	  if ("svg" === _ && (o = !0), null != r) for (; k < r.length; k++) if ((s = r[k]) && "setAttribute" in s == !!_ && (_ ? s.localName === _ : 3 === s.nodeType)) {
	    l = s, r[k] = null;
	    break;
	  }

	  if (null == l) {
	    if (null === _) return document.createTextNode(y);
	    l = o ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, y.is && y), r = null, c = !1;
	  }

	  if (null === _) v === y || c && l.data === y || (l.data = y);else {
	    if (r = r && n.call(l.childNodes), p = (v = t.props || f).dangerouslySetInnerHTML, h = y.dangerouslySetInnerHTML, !c) {
	      if (null != r) for (v = {}, k = 0; k < l.attributes.length; k++) v[l.attributes[k].name] = l.attributes[k].value;
	      (h || p) && (h && (p && h.__html == p.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
	    }

	    if (m(l, y, v, o, c), h) u.__k = [];else if (k = u.props.children, b(l, Array.isArray(k) ? k : [k], u, t, i, o && "foreignObject" !== _, r, e, r ? r[0] : t.__k && d(t, 0), c), null != r) for (k = r.length; k--;) null != r[k] && a(r[k]);
	    c || ("value" in y && void 0 !== (k = y.value) && (k !== l.value || "progress" === _ && !k || "option" === _ && k !== v.value) && C(l, "value", k, v.value, !1), "checked" in y && void 0 !== (k = y.checked) && k !== l.checked && C(l, "checked", k, v.checked, !1));
	  }
	  return l;
	}

	function z(n, u, t) {
	  try {
	    "function" == typeof n ? n(u) : n.current = u;
	  } catch (n) {
	    l.__e(n, t);
	  }
	}

	function L(n, u, t) {
	  var i, o;

	  if (l.unmount && l.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || z(i, null, u)), null != (i = n.__c)) {
	    if (i.componentWillUnmount) try {
	      i.componentWillUnmount();
	    } catch (n) {
	      l.__e(n, u);
	    }
	    i.base = i.__P = null;
	  }

	  if (i = n.__k) for (o = 0; o < i.length; o++) i[o] && L(i[o], u, "function" != typeof n.type);
	  t || null == n.__e || a(n.__e), n.__e = n.__d = void 0;
	}

	function M(n, l, u) {
	  return this.constructor(n, u);
	}

	function N(u, t, i) {
	  var o, r, e;
	  l.__ && l.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], I(t, u = (!o && i || t).__k = p(v, null, [u]), r || f, f, void 0 !== t.ownerSVGElement, !o && i ? [i] : r ? null : t.firstChild ? n.call(t.childNodes) : null, e, !o && i ? i : r ? r.__e : t.firstChild, o), T(e, u);
	}

	n = e.slice, l = {
	  __e: function (n, l, u, t) {
	    for (var i, o, r; l = l.__;) if ((i = l.__c) && !i.__) try {
	      if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
	    } catch (l) {
	      n = l;
	    }

	    throw n;
	  }
	}, u = 0, t = function (n) {
	  return null != n && void 0 === n.constructor;
	}, y.prototype.setState = function (n, l) {
	  var u;
	  u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(s({}, u), this.props)), n && s(u, n), null != n && this.__v && (l && this.__h.push(l), k(this));
	}, y.prototype.forceUpdate = function (n) {
	  this.__v && (this.__e = !0, n && this.__h.push(n), k(this));
	}, y.prototype.render = v, i = [], x.__r = 0, r = 0, exports.render = N, exports.hydrate = function n(l, u) {
	  N(l, u, n);
	}, exports.createElement = p, exports.h = p, exports.Fragment = v, exports.createRef = function () {
	  return {
	    current: null
	  };
	}, exports.isValidElement = t, exports.Component = y, exports.cloneElement = function (l, u, t) {
	  var i,
	      o,
	      r,
	      f = s({}, l.props);

	  for (r in u) "key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];

	  return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), h(l.type, f, i || l.key, o || l.ref, null);
	}, exports.createContext = function (n, l) {
	  var u = {
	    __c: l = "__cC" + r++,
	    __: n,
	    Consumer: function (n, l) {
	      return n.children(l);
	    },
	    Provider: function (n) {
	      var u, t;
	      return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function () {
	        return t;
	      }, this.shouldComponentUpdate = function (n) {
	        this.props.value !== n.value && u.some(k);
	      }, this.sub = function (n) {
	        u.push(n);
	        var l = n.componentWillUnmount;

	        n.componentWillUnmount = function () {
	          u.splice(u.indexOf(n), 1), l && l.call(n);
	        };
	      }), n.children;
	    }
	  };
	  return u.Provider.__ = u.Consumer.contextType = u;
	}, exports.toChildArray = function n(l, u) {
	  return u = u || [], null == l || "boolean" == typeof l || (Array.isArray(l) ? l.some(function (l) {
	    n(l, u);
	  }) : u.push(l)), u;
	}, exports.options = l;
	});

	var hooks = createCommonjsModule$1(function (module, exports) {
	var n,
	    t,
	    r,
	    u,
	    o = preact,
	    i = 0,
	    c = [],
	    f = [],
	    e = o.options.__b,
	    a = o.options.__r,
	    v = o.options.diffed,
	    s = o.options.__c,
	    p = o.options.unmount;

	function l(n, r) {
	  o.options.__h && o.options.__h(t, n, i || r), i = 0;
	  var u = t.__H || (t.__H = {
	    __: [],
	    __h: []
	  });
	  return n >= u.__.length && u.__.push({
	    __V: f
	  }), u.__[n];
	}

	function x(n) {
	  return i = 1, m(T, n);
	}

	function m(r, u, o) {
	  var i = l(n++, 2);

	  if (i.t = r, !i.__c && (i.__ = [o ? o(u) : T(void 0, u), function (n) {
	    var t = i.__N ? i.__N[0] : i.__[0],
	        r = i.t(t, n);
	    t !== r && (i.__N = [r, i.__[1]], i.__c.setState({}));
	  }], i.__c = t, !t.u)) {
	    t.u = !0;
	    var c = t.shouldComponentUpdate;

	    t.shouldComponentUpdate = function (n, t, r) {
	      if (!i.__c.__H) return !0;

	      var u = i.__c.__H.__.filter(function (n) {
	        return n.__c;
	      });

	      if (u.every(function (n) {
	        return !n.__N;
	      })) return !c || c.call(this, n, t, r);
	      var o = !1;
	      return u.forEach(function (n) {
	        if (n.__N) {
	          var t = n.__[0];
	          n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (o = !0);
	        }
	      }), !!o && (!c || c.call(this, n, t, r));
	    };
	  }

	  return i.__N || i.__;
	}

	function d(r, u) {
	  var i = l(n++, 4);
	  !o.options.__s && F(i.__H, u) && (i.__ = r, i.o = u, t.__h.push(i));
	}

	function y(t, r) {
	  var u = l(n++, 7);
	  return F(u.__H, r) ? (u.__V = t(), u.o = r, u.__h = t, u.__V) : u.__;
	}

	function h() {
	  for (var n; n = c.shift();) if (n.__P && n.__H) try {
	    n.__H.__h.forEach(q), n.__H.__h.forEach(A), n.__H.__h = [];
	  } catch (t) {
	    n.__H.__h = [], o.options.__e(t, n.__v);
	  }
	}

	o.options.__b = function (n) {
	  t = null, e && e(n);
	}, o.options.__r = function (u) {
	  a && a(u), n = 0;
	  var o = (t = u.__c).__H;
	  o && (r === t ? (o.__h = [], t.__h = [], o.__.forEach(function (n) {
	    n.__N && (n.__ = n.__N), n.__V = f, n.__N = n.o = void 0;
	  })) : (o.__h.forEach(q), o.__h.forEach(A), o.__h = [])), r = t;
	}, o.options.diffed = function (n) {
	  v && v(n);
	  var i = n.__c;
	  i && i.__H && (i.__H.__h.length && (1 !== c.push(i) && u === o.options.requestAnimationFrame || ((u = o.options.requestAnimationFrame) || function (n) {
	    var t,
	        r = function () {
	      clearTimeout(u), _ && cancelAnimationFrame(t), setTimeout(n);
	    },
	        u = setTimeout(r, 100);

	    _ && (t = requestAnimationFrame(r));
	  })(h)), i.__H.__.forEach(function (n) {
	    n.o && (n.__H = n.o), n.__V !== f && (n.__ = n.__V), n.o = void 0, n.__V = f;
	  })), r = t = null;
	}, o.options.__c = function (n, t) {
	  t.some(function (n) {
	    try {
	      n.__h.forEach(q), n.__h = n.__h.filter(function (n) {
	        return !n.__ || A(n);
	      });
	    } catch (r) {
	      t.some(function (n) {
	        n.__h && (n.__h = []);
	      }), t = [], o.options.__e(r, n.__v);
	    }
	  }), s && s(n, t);
	}, o.options.unmount = function (n) {
	  p && p(n);
	  var t,
	      r = n.__c;
	  r && r.__H && (r.__H.__.forEach(function (n) {
	    try {
	      q(n);
	    } catch (n) {
	      t = n;
	    }
	  }), t && o.options.__e(t, r.__v));
	};

	var _ = "function" == typeof requestAnimationFrame;

	function q(n) {
	  var r = t,
	      u = n.__c;
	  "function" == typeof u && (n.__c = void 0, u()), t = r;
	}

	function A(n) {
	  var r = t;
	  n.__c = n.__(), t = r;
	}

	function F(n, t) {
	  return !n || n.length !== t.length || t.some(function (t, r) {
	    return t !== n[r];
	  });
	}

	function T(n, t) {
	  return "function" == typeof t ? t(n) : t;
	}

	exports.useState = x, exports.useReducer = m, exports.useEffect = function (r, u) {
	  var i = l(n++, 3);
	  !o.options.__s && F(i.__H, u) && (i.__ = r, i.o = u, t.__H.__h.push(i));
	}, exports.useLayoutEffect = d, exports.useRef = function (n) {
	  return i = 5, y(function () {
	    return {
	      current: n
	    };
	  }, []);
	}, exports.useImperativeHandle = function (n, t, r) {
	  i = 6, d(function () {
	    return "function" == typeof n ? (n(t()), function () {
	      return n(null);
	    }) : n ? (n.current = t(), function () {
	      return n.current = null;
	    }) : void 0;
	  }, null == r ? r : r.concat(n));
	}, exports.useMemo = y, exports.useCallback = function (n, t) {
	  return i = 8, y(function () {
	    return n;
	  }, t);
	}, exports.useContext = function (r) {
	  var u = t.context[r.__c],
	      o = l(n++, 9);
	  return o.c = r, u ? (null == o.__ && (o.__ = !0, u.sub(t)), u.props.value) : r.__;
	}, exports.useDebugValue = function (n, t) {
	  o.options.useDebugValue && o.options.useDebugValue(t ? t(n) : n);
	}, exports.useErrorBoundary = function (r) {
	  var u = l(n++, 10),
	      o = x();
	  return u.__ = r, t.componentDidCatch || (t.componentDidCatch = function (n) {
	    u.__ && u.__(n), o[1](n);
	  }), [o[0], function () {
	    o[1](void 0);
	  }];
	};
	});

	var compat = createCommonjsModule$1(function (module, exports) {
	var n = hooks,
	    t = preact;

	function e(n, t) {
	  for (var e in t) n[e] = t[e];

	  return n;
	}

	function r(n, t) {
	  for (var e in n) if ("__source" !== e && !(e in t)) return !0;

	  for (var r in t) if ("__source" !== r && n[r] !== t[r]) return !0;

	  return !1;
	}

	function o(n) {
	  this.props = n;
	}

	function u(n, e) {
	  function o(n) {
	    var t = this.props.ref,
	        o = t == n.ref;
	    return !o && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !o : r(this.props, n);
	  }

	  function u(e) {
	    return this.shouldComponentUpdate = o, t.createElement(n, e);
	  }

	  return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
	}

	(o.prototype = new t.Component()).isPureReactComponent = !0, o.prototype.shouldComponentUpdate = function (n, t) {
	  return r(this.props, n) || r(this.state, t);
	};
	var i = t.options.__b;

	t.options.__b = function (n) {
	  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), i && i(n);
	};

	var l = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;

	function c(n) {
	  function t(t) {
	    var r = e({}, t);
	    return delete r.ref, n(r, t.ref || null);
	  }

	  return t.$$typeof = l, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
	}

	var f = function (n, e) {
	  return null == n ? null : t.toChildArray(t.toChildArray(n).map(e));
	},
	    a = {
	  map: f,
	  forEach: f,
	  count: function (n) {
	    return n ? t.toChildArray(n).length : 0;
	  },
	  only: function (n) {
	    var e = t.toChildArray(n);
	    if (1 !== e.length) throw "Children.only";
	    return e[0];
	  },
	  toArray: t.toChildArray
	},
	    s = t.options.__e;

	t.options.__e = function (n, t, e, r) {
	  if (n.then) for (var o, u = t; u = u.__;) if ((o = u.__c) && o.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), o.__c(n, t);
	  s(n, t, e, r);
	};

	var p = t.options.unmount;

	function h() {
	  this.__u = 0, this.t = null, this.__b = null;
	}

	function v(n) {
	  var t = n.__.__c;
	  return t && t.__a && t.__a(n);
	}

	function d(n) {
	  var e, r, o;

	  function u(u) {
	    if (e || (e = n()).then(function (n) {
	      r = n.default || n;
	    }, function (n) {
	      o = n;
	    }), o) throw o;
	    if (!r) throw e;
	    return t.createElement(r, u);
	  }

	  return u.displayName = "Lazy", u.__f = !0, u;
	}

	function x() {
	  this.o = null, this.u = null;
	}

	t.options.unmount = function (n) {
	  var t = n.__c;
	  t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), p && p(n);
	}, (h.prototype = new t.Component()).__c = function (n, t) {
	  var e = t.__c,
	      r = this;
	  null == r.t && (r.t = []), r.t.push(e);

	  var o = v(r.__v),
	      u = !1,
	      i = function () {
	    u || (u = !0, e.__R = null, o ? o(l) : l());
	  };

	  e.__R = i;

	  var l = function () {
	    if (! --r.__u) {
	      if (r.state.__a) {
	        var n = r.state.__a;

	        r.__v.__k[0] = function n(t, e, r) {
	          return t && (t.__v = null, t.__k = t.__k && t.__k.map(function (t) {
	            return n(t, e, r);
	          }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
	        }(n, n.__c.__P, n.__c.__O);
	      }

	      var t;

	      for (r.setState({
	        __a: r.__b = null
	      }); t = r.t.pop();) t.forceUpdate();
	    }
	  },
	      c = !0 === t.__h;

	  r.__u++ || c || r.setState({
	    __a: r.__b = r.__v.__k[0]
	  }), n.then(i, i);
	}, h.prototype.componentWillUnmount = function () {
	  this.t = [];
	}, h.prototype.render = function (n, r) {
	  if (this.__b) {
	    if (this.__v.__k) {
	      var o = document.createElement("div"),
	          u = this.__v.__k[0].__c;

	      this.__v.__k[0] = function n(t, r, o) {
	        return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function (n) {
	          "function" == typeof n.__c && n.__c();
	        }), t.__c.__H = null), null != (t = e({}, t)).__c && (t.__c.__P === o && (t.__c.__P = r), t.__c = null), t.__k = t.__k && t.__k.map(function (t) {
	          return n(t, r, o);
	        })), t;
	      }(this.__b, o, u.__O = u.__P);
	    }

	    this.__b = null;
	  }

	  var i = r.__a && t.createElement(t.Fragment, null, n.fallback);
	  return i && (i.__h = null), [t.createElement(t.Fragment, null, r.__a ? null : n.children), i];
	};

	var m = function (n, t, e) {
	  if (++e[1] === e[0] && n.u.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.u.size)) for (e = n.o; e;) {
	    for (; e.length > 3;) e.pop()();

	    if (e[1] < e[0]) break;
	    n.o = e = e[2];
	  }
	};

	function _(n) {
	  return this.getChildContext = function () {
	    return n.context;
	  }, n.children;
	}

	function y(n) {
	  var e = this,
	      r = n.i;
	  e.componentWillUnmount = function () {
	    t.render(null, e.l), e.l = null, e.i = null;
	  }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
	    nodeType: 1,
	    parentNode: r,
	    childNodes: [],
	    appendChild: function (n) {
	      this.childNodes.push(n), e.i.appendChild(n);
	    },
	    insertBefore: function (n, t) {
	      this.childNodes.push(n), e.i.appendChild(n);
	    },
	    removeChild: function (n) {
	      this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
	    }
	  }), t.render(t.createElement(_, {
	    context: e.context
	  }, n.__v), e.l)) : e.l && e.componentWillUnmount();
	}

	function b(n, e) {
	  var r = t.createElement(y, {
	    __v: n,
	    i: e
	  });
	  return r.containerInfo = e, r;
	}

	(x.prototype = new t.Component()).__a = function (n) {
	  var t = this,
	      e = v(t.__v),
	      r = t.u.get(n);
	  return r[0]++, function (o) {
	    var u = function () {
	      t.props.revealOrder ? (r.push(o), m(t, n, r)) : o();
	    };

	    e ? e(u) : u();
	  };
	}, x.prototype.render = function (n) {
	  this.o = null, this.u = new Map();
	  var e = t.toChildArray(n.children);
	  n.revealOrder && "b" === n.revealOrder[0] && e.reverse();

	  for (var r = e.length; r--;) this.u.set(e[r], this.o = [1, 0, this.o]);

	  return n.children;
	}, x.prototype.componentDidUpdate = x.prototype.componentDidMount = function () {
	  var n = this;
	  this.u.forEach(function (t, e) {
	    m(n, e, t);
	  });
	};

	var S = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
	    g = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
	    C = "undefined" != typeof document,
	    E = function (n) {
	  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
	};

	function w(n, e, r) {
	  return null == e.__k && (e.textContent = ""), t.render(n, e), "function" == typeof r && r(), n ? n.__c : null;
	}

	function R(n, e, r) {
	  return t.hydrate(n, e), "function" == typeof r && r(), n ? n.__c : null;
	}

	t.Component.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (n) {
	  Object.defineProperty(t.Component.prototype, n, {
	    configurable: !0,
	    get: function () {
	      return this["UNSAFE_" + n];
	    },
	    set: function (t) {
	      Object.defineProperty(this, n, {
	        configurable: !0,
	        writable: !0,
	        value: t
	      });
	    }
	  });
	});
	var N = t.options.event;

	function O() {}

	function k() {
	  return this.cancelBubble;
	}

	function A() {
	  return this.defaultPrevented;
	}

	t.options.event = function (n) {
	  return N && (n = N(n)), n.persist = O, n.isPropagationStopped = k, n.isDefaultPrevented = A, n.nativeEvent = n;
	};

	var T,
	    L = {
	  configurable: !0,
	  get: function () {
	    return this.class;
	  }
	},
	    U = t.options.vnode;

	t.options.vnode = function (n) {
	  var e = n.type,
	      r = n.props,
	      o = r;

	  if ("string" == typeof e) {
	    var u = -1 === e.indexOf("-");

	    for (var i in o = {}, r) {
	      var l = r[i];
	      C && "children" === i && "noscript" === e || "value" === i && "defaultValue" in r && null == l || ("defaultValue" === i && "value" in r && null == r.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + e) && !E(r.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : u && g.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), o[i] && (i = "oninputCapture")), o[i] = l);
	    }

	    "select" == e && o.multiple && Array.isArray(o.value) && (o.value = t.toChildArray(r.children).forEach(function (n) {
	      n.props.selected = -1 != o.value.indexOf(n.props.value);
	    })), "select" == e && null != o.defaultValue && (o.value = t.toChildArray(r.children).forEach(function (n) {
	      n.props.selected = o.multiple ? -1 != o.defaultValue.indexOf(n.props.value) : o.defaultValue == n.props.value;
	    })), n.props = o, r.class != r.className && (L.enumerable = "className" in r, null != r.className && (o.class = r.className), Object.defineProperty(o, "className", L));
	  }

	  n.$$typeof = S, U && U(n);
	};

	var D = t.options.__r;

	t.options.__r = function (n) {
	  D && D(n), T = n.__c;
	};

	var I = {
	  ReactCurrentDispatcher: {
	    current: {
	      readContext: function (n) {
	        return T.__n[n.__c].props.value;
	      }
	    }
	  }
	};

	function M(n) {
	  return t.createElement.bind(null, n);
	}

	function F(n) {
	  return !!n && n.$$typeof === S;
	}

	function V(n) {
	  return F(n) ? t.cloneElement.apply(null, arguments) : n;
	}

	function W(n) {
	  return !!n.__k && (t.render(null, n), !0);
	}

	function j(n) {
	  return n && (n.base || 1 === n.nodeType && n) || null;
	}

	var P = function (n, t) {
	  return n(t);
	},
	    $ = function (n, t) {
	  return n(t);
	},
	    z = t.Fragment;

	function B(n) {
	  n();
	}

	function q(n) {
	  return n;
	}

	function H() {
	  return [!1, B];
	}

	var Z = n.useLayoutEffect;

	function Y(t, e) {
	  var r = e(),
	      o = n.useState({
	    s: {
	      __: r,
	      p: e
	    }
	  }),
	      u = o[0].s,
	      i = o[1];
	  return n.useLayoutEffect(function () {
	    u.__ = r, u.p = e, u.__ !== e() && i({
	      s: u
	    });
	  }, [t, r, e]), n.useEffect(function () {
	    return u.__ !== u.p() && i({
	      s: u
	    }), t(function () {
	      u.__ !== u.p() && i({
	        s: u
	      });
	    });
	  }, [t]), r;
	}

	var G = {
	  useState: n.useState,
	  useReducer: n.useReducer,
	  useEffect: n.useEffect,
	  useLayoutEffect: n.useLayoutEffect,
	  useInsertionEffect: Z,
	  useTransition: H,
	  useDeferredValue: q,
	  useSyncExternalStore: Y,
	  startTransition: B,
	  useRef: n.useRef,
	  useImperativeHandle: n.useImperativeHandle,
	  useMemo: n.useMemo,
	  useCallback: n.useCallback,
	  useContext: n.useContext,
	  useDebugValue: n.useDebugValue,
	  version: "17.0.2",
	  Children: a,
	  render: w,
	  hydrate: R,
	  unmountComponentAtNode: W,
	  createPortal: b,
	  createElement: t.createElement,
	  createContext: t.createContext,
	  createFactory: M,
	  cloneElement: V,
	  createRef: t.createRef,
	  Fragment: t.Fragment,
	  isValidElement: F,
	  findDOMNode: j,
	  Component: t.Component,
	  PureComponent: o,
	  memo: u,
	  forwardRef: c,
	  flushSync: $,
	  unstable_batchedUpdates: P,
	  StrictMode: z,
	  Suspense: h,
	  SuspenseList: x,
	  lazy: d,
	  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: I
	};
	Object.keys(n).forEach(function (t) {
	  exports[t] = n[t];
	}), exports.createElement = t.createElement, exports.createContext = t.createContext, exports.createRef = t.createRef, exports.Fragment = t.Fragment, exports.Component = t.Component, exports.startTransition = B, exports.useDeferredValue = q, exports.useTransition = H, exports.useInsertionEffect = Z, exports.useSyncExternalStore = Y, exports.version = "17.0.2", exports.Children = a, exports.render = w, exports.hydrate = R, exports.unmountComponentAtNode = W, exports.createPortal = b, exports.createFactory = M, exports.cloneElement = V, exports.isValidElement = F, exports.findDOMNode = j, exports.PureComponent = o, exports.memo = u, exports.forwardRef = c, exports.flushSync = $, exports.unstable_batchedUpdates = P, exports.StrictMode = z, exports.Suspense = h, exports.SuspenseList = x, exports.lazy = d, exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = I, exports.default = G;
	});

	/** @license React v16.13.1
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var reactIs_development = createCommonjsModule$1(function (module, exports) {

	{
	  (function () {
	    // nor polyfill, then a plain number is used for performance.

	    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	    // (unstable) APIs that have been removed. Can we remove the symbols?

	    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	    function isValidElementType(type) {
	      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	    }

	    function typeOf(object) {
	      if (typeof object === 'object' && object !== null) {
	        var $$typeof = object.$$typeof;

	        switch ($$typeof) {
	          case REACT_ELEMENT_TYPE:
	            var type = object.type;

	            switch (type) {
	              case REACT_ASYNC_MODE_TYPE:
	              case REACT_CONCURRENT_MODE_TYPE:
	              case REACT_FRAGMENT_TYPE:
	              case REACT_PROFILER_TYPE:
	              case REACT_STRICT_MODE_TYPE:
	              case REACT_SUSPENSE_TYPE:
	                return type;

	              default:
	                var $$typeofType = type && type.$$typeof;

	                switch ($$typeofType) {
	                  case REACT_CONTEXT_TYPE:
	                  case REACT_FORWARD_REF_TYPE:
	                  case REACT_LAZY_TYPE:
	                  case REACT_MEMO_TYPE:
	                  case REACT_PROVIDER_TYPE:
	                    return $$typeofType;

	                  default:
	                    return $$typeof;
	                }

	            }

	          case REACT_PORTAL_TYPE:
	            return $$typeof;
	        }
	      }

	      return undefined;
	    } // AsyncMode is deprecated along with isAsyncMode


	    var AsyncMode = REACT_ASYNC_MODE_TYPE;
	    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	    var ContextConsumer = REACT_CONTEXT_TYPE;
	    var ContextProvider = REACT_PROVIDER_TYPE;
	    var Element = REACT_ELEMENT_TYPE;
	    var ForwardRef = REACT_FORWARD_REF_TYPE;
	    var Fragment = REACT_FRAGMENT_TYPE;
	    var Lazy = REACT_LAZY_TYPE;
	    var Memo = REACT_MEMO_TYPE;
	    var Portal = REACT_PORTAL_TYPE;
	    var Profiler = REACT_PROFILER_TYPE;
	    var StrictMode = REACT_STRICT_MODE_TYPE;
	    var Suspense = REACT_SUSPENSE_TYPE;
	    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	    function isAsyncMode(object) {
	      {
	        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	        }
	      }
	      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	    }

	    function isConcurrentMode(object) {
	      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	    }

	    function isContextConsumer(object) {
	      return typeOf(object) === REACT_CONTEXT_TYPE;
	    }

	    function isContextProvider(object) {
	      return typeOf(object) === REACT_PROVIDER_TYPE;
	    }

	    function isElement(object) {
	      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	    }

	    function isForwardRef(object) {
	      return typeOf(object) === REACT_FORWARD_REF_TYPE;
	    }

	    function isFragment(object) {
	      return typeOf(object) === REACT_FRAGMENT_TYPE;
	    }

	    function isLazy(object) {
	      return typeOf(object) === REACT_LAZY_TYPE;
	    }

	    function isMemo(object) {
	      return typeOf(object) === REACT_MEMO_TYPE;
	    }

	    function isPortal(object) {
	      return typeOf(object) === REACT_PORTAL_TYPE;
	    }

	    function isProfiler(object) {
	      return typeOf(object) === REACT_PROFILER_TYPE;
	    }

	    function isStrictMode(object) {
	      return typeOf(object) === REACT_STRICT_MODE_TYPE;
	    }

	    function isSuspense(object) {
	      return typeOf(object) === REACT_SUSPENSE_TYPE;
	    }

	    exports.AsyncMode = AsyncMode;
	    exports.ConcurrentMode = ConcurrentMode;
	    exports.ContextConsumer = ContextConsumer;
	    exports.ContextProvider = ContextProvider;
	    exports.Element = Element;
	    exports.ForwardRef = ForwardRef;
	    exports.Fragment = Fragment;
	    exports.Lazy = Lazy;
	    exports.Memo = Memo;
	    exports.Portal = Portal;
	    exports.Profiler = Profiler;
	    exports.StrictMode = StrictMode;
	    exports.Suspense = Suspense;
	    exports.isAsyncMode = isAsyncMode;
	    exports.isConcurrentMode = isConcurrentMode;
	    exports.isContextConsumer = isContextConsumer;
	    exports.isContextProvider = isContextProvider;
	    exports.isElement = isElement;
	    exports.isForwardRef = isForwardRef;
	    exports.isFragment = isFragment;
	    exports.isLazy = isLazy;
	    exports.isMemo = isMemo;
	    exports.isPortal = isPortal;
	    exports.isProfiler = isProfiler;
	    exports.isStrictMode = isStrictMode;
	    exports.isSuspense = isSuspense;
	    exports.isValidElementType = isValidElementType;
	    exports.typeOf = typeOf;
	  })();
	}
	});

	var reactIs = createCommonjsModule$1(function (module) {

	{
	  module.exports = reactIs_development;
	}
	});

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */

	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
	  if (val === null || val === undefined) {
	    throw new TypeError('Object.assign cannot be called with null or undefined');
	  }

	  return Object(val);
	}

	function shouldUseNative() {
	  try {
	    if (!Object.assign) {
	      return false;
	    } // Detect buggy property enumeration order in older V8 versions.
	    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


	    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

	    test1[5] = 'de';

	    if (Object.getOwnPropertyNames(test1)[0] === '5') {
	      return false;
	    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


	    var test2 = {};

	    for (var i = 0; i < 10; i++) {
	      test2['_' + String.fromCharCode(i)] = i;
	    }

	    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
	      return test2[n];
	    });

	    if (order2.join('') !== '0123456789') {
	      return false;
	    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


	    var test3 = {};
	    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
	      test3[letter] = letter;
	    });

	    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
	      return false;
	    }

	    return true;
	  } catch (err) {
	    // We don't expect any of the above to throw, but better to be safe.
	    return false;
	  }
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	  var from;
	  var to = toObject(target);
	  var symbols;

	  for (var s = 1; s < arguments.length; s++) {
	    from = Object(arguments[s]);

	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }

	    if (getOwnPropertySymbols) {
	      symbols = getOwnPropertySymbols(from);

	      for (var i = 0; i < symbols.length; i++) {
	        if (propIsEnumerable.call(from, symbols[i])) {
	          to[symbols[i]] = from[symbols[i]];
	        }
	      }
	    }
	  }

	  return to;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

	var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

	var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

	var has$1 = has$2;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var printWarning$1 = function () {};

	{
	  var ReactPropTypesSecret = ReactPropTypesSecret$1;

	  var loggedTypeFailures = {};

	  var has = has$1;

	  printWarning$1 = function (text) {
	    var message = 'Warning: ' + text;

	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }

	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {
	      /**/
	    }
	  };
	}
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */


	function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
	  {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }

	        if (error && !(error instanceof Error)) {
	          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
	        }

	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	          var stack = getStack ? getStack() : '';
	          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
	        }
	      }
	    }
	  }
	}
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */


	checkPropTypes$1.resetWarningCache = function () {
	  {
	    loggedTypeFailures = {};
	  }
	};

	var checkPropTypes_1 = checkPropTypes$1;

	var checkPropTypes = checkPropTypes_1;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */











	var printWarning = function () {};

	{
	  printWarning = function (text) {
	    var message = 'Warning: ' + text;

	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }

	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */

	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */


	  var ANONYMOUS = '<<anonymous>>'; // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker
	  };
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */

	  /*eslint-disable no-self-compare*/

	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */


	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data : {};
	    this.stack = '';
	  } // Make `instanceof Error` still work for returned errors.


	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }

	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret$1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;

	          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
	          manualPropTypeWarningCount < 3) {
	            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }

	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }

	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }

	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);

	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
	          expectedType: expectedType
	        });
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }

	      var propValue = props[propName];

	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }

	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

	        if (error instanceof Error) {
	          return error;
	        }
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];

	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];

	      if (!reactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      {
	        if (arguments.length > 1) {
	          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }

	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];

	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);

	        if (type === 'symbol') {
	          return String(value);
	        }

	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }

	      var propValue = props[propName];
	      var propType = getPropType(propValue);

	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }

	      for (var key in propValue) {
	        if (has$1(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') ;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];

	      if (typeof checker !== 'function') {
	        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];

	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);

	        if (checkerResult == null) {
	          return null;
	        }

	        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }

	      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);

	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }

	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];

	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }

	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

	        if (error) {
	          return error;
	        }
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);

	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      } // We need to check all keys in case some are required but missing from props.


	      var allKeys = objectAssign({}, props[propName], shapeTypes);

	      for (var key in allKeys) {
	        var checker = shapeTypes[key];

	        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }

	        if (!checker) {
	          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
	        }

	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

	        if (error) {
	          return error;
	        }
	      }

	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;

	      case 'boolean':
	        return !propValue;

	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }

	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);

	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;

	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;

	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;

	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    } // falsy value can't be a Symbol


	    if (!propValue) {
	      return false;
	    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    } // Fallback for non-spec compliant Symbols which are polyfilled.


	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  } // Equivalent of `typeof` but with special handling for array and regexp.


	  function getPropType(propValue) {
	    var propType = typeof propValue;

	    if (Array.isArray(propValue)) {
	      return 'array';
	    }

	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }

	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }

	    return propType;
	  } // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.


	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }

	    var propType = getPropType(propValue);

	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }

	    return propType;
	  } // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"


	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);

	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;

	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;

	      default:
	        return type;
	    }
	  } // Returns class name of the object, if any.


	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }

	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	  return ReactPropTypes;
	};

	var require$$1 = factoryWithTypeCheckers;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var propTypes = createCommonjsModule$1(function (module) {
	{
	  var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod


	  var throwOnDirectAccess = true;
	  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
	}
	});

	var _propTypes = propTypes;

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2 = _interopRequireDefault(compat);



	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var parentStyles = {
	  overflow: 'hidden',
	  position: 'relative'
	};
	var defaultStyles = {
	  position: 'relative',
	  overflow: 'hidden',
	  cursor: 'pointer',
	  display: 'block',
	  float: 'left'
	};

	var getHalfStarStyles = function getHalfStarStyles(color, uniqueness) {
	  return '\n    .react-stars-' + uniqueness + ':before {\n      position: absolute;\n      overflow: hidden;\n      display: block;\n      z-index: 1;\n      top: 0; left: 0;\n      width: 50%;\n      content: attr(data-forhalf);\n      color: ' + color + ';\n  }';
	};

	var ReactStars = function (_Component) {
	  _inherits(ReactStars, _Component);

	  function ReactStars(props) {
	    _classCallCheck(this, ReactStars); // set defaults


	    var _this = _possibleConstructorReturn(this, (ReactStars.__proto__ || Object.getPrototypeOf(ReactStars)).call(this, props));

	    props = _extends({}, props);
	    _this.state = {
	      uniqueness: (Math.random() + '').replace('.', ''),
	      value: props.value || 0,
	      stars: [],
	      halfStar: {
	        at: Math.floor(props.value),
	        hidden: props.half && props.value % 1 < 0.5
	      }
	    };
	    _this.state.config = {
	      count: props.count,
	      size: props.size,
	      char: props.char,
	      // default color of inactive star
	      color1: props.color1,
	      // color of an active star
	      color2: props.color2,
	      half: props.half,
	      edit: props.edit
	    };
	    return _this;
	  }

	  _createClass(ReactStars, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        stars: this.getStars(this.state.value)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({
	        stars: this.getStars(props.value),
	        value: props.value,
	        halfStar: {
	          at: Math.floor(props.value),
	          hidden: this.state.config.half && props.value % 1 < 0.5
	        }
	      });
	    }
	  }, {
	    key: 'isDecimal',
	    value: function isDecimal(value) {
	      return value % 1 !== 0;
	    }
	  }, {
	    key: 'getRate',
	    value: function getRate() {
	      var stars = void 0;

	      if (this.state.config.half) {
	        stars = Math.floor(this.state.value);
	      } else {
	        stars = Math.round(this.state.value);
	      }

	      return stars;
	    }
	  }, {
	    key: 'getStars',
	    value: function getStars(activeCount) {
	      if (typeof activeCount === 'undefined') {
	        activeCount = this.getRate();
	      }

	      var stars = [];

	      for (var i = 0; i < this.state.config.count; i++) {
	        stars.push({
	          active: i <= activeCount - 1
	        });
	      }

	      return stars;
	    }
	  }, {
	    key: 'mouseOver',
	    value: function mouseOver(event) {
	      var _state = this.state,
	          config = _state.config,
	          halfStar = _state.halfStar;
	      if (!config.edit) return;
	      var index = Number(event.target.getAttribute('data-index'));

	      if (config.half) {
	        var isAtHalf = this.moreThanHalf(event, config.size);
	        halfStar.hidden = isAtHalf;
	        if (isAtHalf) index = index + 1;
	        halfStar.at = index;
	      } else {
	        index = index + 1;
	      }

	      this.setState({
	        stars: this.getStars(index)
	      });
	    }
	  }, {
	    key: 'moreThanHalf',
	    value: function moreThanHalf(event, size) {
	      var target = event.target;
	      var mouseAt = event.clientX - target.getBoundingClientRect().left;
	      mouseAt = Math.round(Math.abs(mouseAt));
	      return mouseAt > size / 2;
	    }
	  }, {
	    key: 'mouseLeave',
	    value: function mouseLeave() {
	      var _state2 = this.state,
	          value = _state2.value,
	          halfStar = _state2.halfStar,
	          config = _state2.config;
	      if (!config.edit) return;

	      if (config.half) {
	        halfStar.hidden = !this.isDecimal(value);
	        halfStar.at = Math.floor(this.state.value);
	      }

	      this.setState({
	        stars: this.getStars()
	      });
	    }
	  }, {
	    key: 'clicked',
	    value: function clicked(event) {
	      var _state3 = this.state,
	          config = _state3.config,
	          halfStar = _state3.halfStar;
	      if (!config.edit) return;
	      var index = Number(event.target.getAttribute('data-index'));
	      var value = void 0;

	      if (config.half) {
	        var isAtHalf = this.moreThanHalf(event, config.size);
	        halfStar.hidden = isAtHalf;
	        if (isAtHalf) index = index + 1;
	        value = isAtHalf ? index : index + .5;
	        halfStar.at = index;
	      } else {
	        value = index = index + 1;
	      }

	      this.setState({
	        value: value,
	        stars: this.getStars(index)
	      });
	      this.props.onChange(value);
	    }
	  }, {
	    key: 'renderHalfStarStyleElement',
	    value: function renderHalfStarStyleElement() {
	      var _state4 = this.state,
	          config = _state4.config,
	          uniqueness = _state4.uniqueness;
	      return _react2.default.createElement('style', {
	        dangerouslySetInnerHTML: {
	          __html: getHalfStarStyles(config.color2, uniqueness)
	        }
	      });
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var _this2 = this;

	      var _state5 = this.state,
	          halfStar = _state5.halfStar,
	          stars = _state5.stars,
	          uniqueness = _state5.uniqueness,
	          config = _state5.config;
	      var color1 = config.color1,
	          color2 = config.color2,
	          size = config.size,
	          char = config.char,
	          half = config.half,
	          edit = config.edit;
	      return stars.map(function (star, i) {
	        var starClass = '';

	        if (half && !halfStar.hidden && halfStar.at === i) {
	          starClass = 'react-stars-' + uniqueness;
	        }

	        var style = _extends({}, defaultStyles, {
	          color: star.active ? color2 : color1,
	          cursor: edit ? 'pointer' : 'default',
	          fontSize: size + 'px'
	        });

	        return _react2.default.createElement('span', {
	          className: starClass,
	          style: style,
	          key: i,
	          'data-index': i,
	          'data-forhalf': char,
	          onMouseOver: _this2.mouseOver.bind(_this2),
	          onMouseMove: _this2.mouseOver.bind(_this2),
	          onMouseLeave: _this2.mouseLeave.bind(_this2),
	          onClick: _this2.clicked.bind(_this2)
	        }, char);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      return _react2.default.createElement('div', {
	        className: className,
	        style: parentStyles
	      }, this.state.config.half ? this.renderHalfStarStyleElement() : '', this.renderStars());
	    }
	  }]);

	  return ReactStars;
	}(compat.Component);

	ReactStars.propTypes = {
	  className: _propTypes2.default.string,
	  edit: _propTypes2.default.bool,
	  half: _propTypes2.default.bool,
	  value: _propTypes2.default.number,
	  count: _propTypes2.default.number,
	  char: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  color1: _propTypes2.default.string,
	  color2: _propTypes2.default.string
	};
	ReactStars.defaultProps = {
	  edit: true,
	  half: true,
	  value: 0,
	  count: 5,
	  char: '★',
	  size: 15,
	  color1: 'gray',
	  color2: '#ffd700',
	  onChange: function onChange() {}
	};
	var _default = ReactStars;

	var css_248z$g = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.star-rating-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  width: 170px;\n}\n\n.utu-star-rating-text {\n  font-size: 1rem;\n  font-weight: bold;\n  color: rgb(252, 229, 70);\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .star-rating-section {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n    padding-left: 1rem;\n    width: 170px;\n  }\n}";
	styleInject(css_248z$g);

	function StarRatingInput(props) {
	  var _useState = p(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      starRatings = _useState2[0],
	      setstarRatings = _useState2[1];

	  var _getBaseProps = getBaseProps(props, TAG_FEEDBACK_FORM),
	      apiUrl = _getBaseProps.apiUrl;

	  var walletAddress = q$1(WalletAddressContext);

	  if (props[ATTR_SOURCE_UUID] === "address") {
	    props[ATTR_SOURCE_UUID] = walletAddress;
	  }

	  var _useFeedbackApi = useFeedbackApi(apiUrl, props[ATTR_SOURCE_UUID], props[ATTR_TARGET_UUID], props[ATTR_TRANSACTION_ID]),
	      sendFeedback = _useFeedbackApi.sendFeedback,
	      submitStatus = _useFeedbackApi.submitStatus; // environments


	  var _useState3 = p(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDark = _useState4[0],
	      setIsDark = _useState4[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  var ratingChanged = function ratingChanged(newRating) {
	    setstarRatings(newRating);
	    sendFeedback({
	      stars: newRating
	    });
	  };

	  return h$2(BaseComponent, {
	    style: css_248z$g,
	    className: "star-rating-section utu-section utu-section-".concat(isDark ? "dark" : "light"),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2(SubmitStatusView, {
	    submitStatus: submitStatus
	  }, h$2(_default, {
	    count: 5,
	    half: false,
	    onChange: ratingChanged,
	    size: 30,
	    color2: "#FFDD33" // color2= {ratingColor}

	  })), h$2("p", {
	    className: "mt-3 mx-2 utu-star-rating-text"
	  }, starRatings, " / 5.0"));
	}

	var bundle$3 = createCommonjsModule$1(function (module, exports) {
	(function (global, factory) {
	  factory(exports) ;
	})(commonjsGlobal, function (exports) {

	  var createAddUniqueNumber = function createAddUniqueNumber(generateUniqueNumber) {
	    return function (set) {
	      var number = generateUniqueNumber(set);
	      set.add(number);
	      return number;
	    };
	  };

	  var createCache = function createCache(lastNumberWeakMap) {
	    return function (collection, nextNumber) {
	      lastNumberWeakMap.set(collection, nextNumber);
	      return nextNumber;
	    };
	  };
	  /*
	   * The value of the constant Number.MAX_SAFE_INTEGER equals (2 ** 53 - 1) but it
	   * is fairly new.
	   */


	  var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER === undefined ? 9007199254740991 : Number.MAX_SAFE_INTEGER;
	  var TWO_TO_THE_POWER_OF_TWENTY_NINE = 536870912;
	  var TWO_TO_THE_POWER_OF_THIRTY = TWO_TO_THE_POWER_OF_TWENTY_NINE * 2;

	  var createGenerateUniqueNumber = function createGenerateUniqueNumber(cache, lastNumberWeakMap) {
	    return function (collection) {
	      var lastNumber = lastNumberWeakMap.get(collection);
	      /*
	       * Let's try the cheapest algorithm first. It might fail to produce a new
	       * number, but it is so cheap that it is okay to take the risk. Just
	       * increase the last number by one or reset it to 0 if we reached the upper
	       * bound of SMIs (which stands for small integers). When the last number is
	       * unknown it is assumed that the collection contains zero based consecutive
	       * numbers.
	       */

	      var nextNumber = lastNumber === undefined ? collection.size : lastNumber < TWO_TO_THE_POWER_OF_THIRTY ? lastNumber + 1 : 0;

	      if (!collection.has(nextNumber)) {
	        return cache(collection, nextNumber);
	      }
	      /*
	       * If there are less than half of 2 ** 30 numbers stored in the collection,
	       * the chance to generate a new random number in the range from 0 to 2 ** 30
	       * is at least 50%. It's benifitial to use only SMIs because they perform
	       * much better in any environment based on V8.
	       */


	      if (collection.size < TWO_TO_THE_POWER_OF_TWENTY_NINE) {
	        while (collection.has(nextNumber)) {
	          nextNumber = Math.floor(Math.random() * TWO_TO_THE_POWER_OF_THIRTY);
	        }

	        return cache(collection, nextNumber);
	      } // Quickly check if there is a theoretical chance to generate a new number.


	      if (collection.size > MAX_SAFE_INTEGER) {
	        throw new Error('Congratulations, you created a collection of unique numbers which uses all available integers!');
	      } // Otherwise use the full scale of safely usable integers.


	      while (collection.has(nextNumber)) {
	        nextNumber = Math.floor(Math.random() * MAX_SAFE_INTEGER);
	      }

	      return cache(collection, nextNumber);
	    };
	  };

	  var LAST_NUMBER_WEAK_MAP = new WeakMap();
	  var cache = createCache(LAST_NUMBER_WEAK_MAP);
	  var generateUniqueNumber = createGenerateUniqueNumber(cache, LAST_NUMBER_WEAK_MAP);
	  var addUniqueNumber = createAddUniqueNumber(generateUniqueNumber);
	  exports.addUniqueNumber = addUniqueNumber;
	  exports.generateUniqueNumber = generateUniqueNumber;
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	});
	});

	const isMessagePort = sender => {
	  return typeof sender.start === 'function';
	};

	const PORT_MAP = new WeakMap();

	const extendBrokerImplementation = partialBrokerImplementation => ({ ...partialBrokerImplementation,
	  connect: ({
	    call
	  }) => {
	    return async () => {
	      const {
	        port1,
	        port2
	      } = new MessageChannel();
	      const portId = await call('connect', {
	        port: port1
	      }, [port1]);
	      PORT_MAP.set(port2, portId);
	      return port2;
	    };
	  },
	  disconnect: ({
	    call
	  }) => {
	    return async port => {
	      const portId = PORT_MAP.get(port);

	      if (portId === undefined) {
	        throw new Error('The given port is not connected.');
	      }

	      await call('disconnect', {
	        portId
	      });
	    };
	  },
	  isSupported: ({
	    call
	  }) => {
	    return () => call('isSupported');
	  }
	});

	const ONGOING_REQUESTS = new WeakMap();

	const createOrGetOngoingRequests = sender => {
	  if (ONGOING_REQUESTS.has(sender)) {
	    // @todo TypeScript needs to be convinced that has() works as expected.
	    return ONGOING_REQUESTS.get(sender);
	  }

	  const ongoingRequests = new Map();
	  ONGOING_REQUESTS.set(sender, ongoingRequests);
	  return ongoingRequests;
	};

	const createBroker = brokerImplementation => {
	  const fullBrokerImplementation = extendBrokerImplementation(brokerImplementation);
	  return sender => {
	    const ongoingRequests = createOrGetOngoingRequests(sender);
	    sender.addEventListener('message', ({
	      data: message
	    }) => {
	      const {
	        id
	      } = message;

	      if (id !== null && ongoingRequests.has(id)) {
	        const {
	          reject,
	          resolve
	        } = ongoingRequests.get(id);
	        ongoingRequests.delete(id);

	        if (message.error === undefined) {
	          resolve(message.result);
	        } else {
	          reject(new Error(message.error.message));
	        }
	      }
	    });

	    if (isMessagePort(sender)) {
	      sender.start();
	    }

	    const call = (method, params = null, transferables = []) => {
	      return new Promise((resolve, reject) => {
	        const id = bundle$3.generateUniqueNumber(ongoingRequests);
	        ongoingRequests.set(id, {
	          reject,
	          resolve
	        });

	        if (params === null) {
	          sender.postMessage({
	            id,
	            method
	          }, transferables);
	        } else {
	          sender.postMessage({
	            id,
	            method,
	            params
	          }, transferables);
	        }
	      });
	    };

	    const notify = (method, params, transferables = []) => {
	      sender.postMessage({
	        id: null,
	        method,
	        params
	      }, transferables);
	    };

	    let functions = {};

	    for (const [key, handler] of Object.entries(fullBrokerImplementation)) {
	      functions = { ...functions,
	        [key]: handler({
	          call,
	          notify
	        })
	      };
	    }

	    return { ...functions
	    };
	  };
	};

	const encoderIds = new Set();
	const wrap$1 = createBroker({
	  encode: ({
	    call
	  }) => {
	    return async (encoderId, timeslice) => {
	      const arrayBuffers = await call('encode', {
	        encoderId,
	        timeslice
	      });
	      encoderIds.delete(encoderId);
	      return arrayBuffers;
	    };
	  },
	  instantiate: ({
	    call
	  }) => {
	    return async (mimeType, sampleRate) => {
	      const encoderId = bundle$3.addUniqueNumber(encoderIds);
	      const port = await call('instantiate', {
	        encoderId,
	        mimeType,
	        sampleRate
	      });
	      return {
	        encoderId,
	        port
	      };
	    };
	  },
	  register: ({
	    call
	  }) => {
	    return port => {
	      return call('register', {
	        port
	      }, [port]);
	    };
	  }
	});
	const load$1 = url => {
	  const worker = new Worker(url);
	  return wrap$1(worker);
	};

	// This is the minified and stringified code of the media-encoder-host-worker package.
	const worker$1 = `(()=>{var e={775:function(e,t,r){!function(e,t,r,n){"use strict";function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(t),s=o(r),i=o(n),c=function(e,t){return void 0===t?e:t.reduce((function(e,t){if("capitalize"===t){var r=e.charAt(0).toUpperCase(),n=e.slice(1);return"".concat(r).concat(n)}return"dashify"===t?s.default(e):"prependIndefiniteArticle"===t?"".concat(i.default(e)," ").concat(e):e}),e)},u=function(e){var t=e.name+e.modifiers.map((function(e){return"\\\\.".concat(e,"\\\\(\\\\)")})).join("");return new RegExp("\\\\$\\\\{".concat(t,"}"),"g")},l=function(e,t){for(var r=/\\\${([^.}]+)((\\.[^(]+\\(\\))*)}/g,n=[],o=r.exec(e);null!==o;){var s={modifiers:[],name:o[1]};if(void 0!==o[3])for(var i=/\\.[^(]+\\(\\)/g,l=i.exec(o[2]);null!==l;)s.modifiers.push(l[0].slice(1,-2)),l=i.exec(o[2]);n.push(s),o=r.exec(e)}var d=n.reduce((function(e,r){return e.map((function(e){return"string"==typeof e?e.split(u(r)).reduce((function(e,n,o){return 0===o?[n]:r.name in t?[].concat(a.default(e),[c(t[r.name],r.modifiers),n]):[].concat(a.default(e),[function(e){return c(e[r.name],r.modifiers)},n])}),[]):[e]})).reduce((function(e,t){return[].concat(a.default(e),a.default(t))}),[])}),[e]);return function(e){return d.reduce((function(t,r){return[].concat(a.default(t),"string"==typeof r?[r]:[r(e)])}),[]).join("")}},d=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=void 0===e.code?void 0:l(e.code,t),n=void 0===e.message?void 0:l(e.message,t);function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=arguments.length>1?arguments[1]:void 0,a=void 0===o&&(t instanceof Error||void 0!==t.code&&"Exception"===t.code.slice(-9))?{cause:t,missingParameters:{}}:{cause:o,missingParameters:t},s=a.cause,i=a.missingParameters,c=void 0===n?new Error:new Error(n(i));return null!==s&&(c.cause=s),void 0!==r&&(c.code=r(i)),void 0!==e.status&&(c.status=e.status),c}return o};e.compile=d,Object.defineProperty(e,"__esModule",{value:!0})}(t,r(106),r(881),r(507))},881:e=>{"use strict";e.exports=(e,t)=>{if("string"!=typeof e)throw new TypeError("expected a string");return e.trim().replace(/([a-z])([A-Z])/g,"$1-$2").replace(/\\W/g,(e=>/[À-ž]/.test(e)?e:"-")).replace(/^-+|-+$/g,"").replace(/-{2,}/g,(e=>t&&t.condense?"-":e)).toLowerCase()}},107:function(e,t){!function(e){"use strict";var t=function(e){return function(t){var r=e(t);return t.add(r),r}},r=function(e){return function(t,r){return e.set(t,r),r}},n=void 0===Number.MAX_SAFE_INTEGER?9007199254740991:Number.MAX_SAFE_INTEGER,o=536870912,a=2*o,s=function(e,t){return function(r){var s=t.get(r),i=void 0===s?r.size:s<a?s+1:0;if(!r.has(i))return e(r,i);if(r.size<o){for(;r.has(i);)i=Math.floor(Math.random()*a);return e(r,i)}if(r.size>n)throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");for(;r.has(i);)i=Math.floor(Math.random()*n);return e(r,i)}},i=new WeakMap,c=r(i),u=s(c,i),l=t(u);e.addUniqueNumber=l,e.generateUniqueNumber=u,Object.defineProperty(e,"__esModule",{value:!0})}(t)},507:e=>{var t=function(e){var t,r,n=/\\w+/.exec(e);if(!n)return"an";var o=(r=n[0]).toLowerCase(),a=["honest","hour","hono"];for(t in a)if(0==o.indexOf(a[t]))return"an";if(1==o.length)return"aedhilmnorsx".indexOf(o)>=0?"an":"a";if(r.match(/(?!FJO|[HLMNS]Y.|RY[EO]|SQU|(F[LR]?|[HL]|MN?|N|RH?|S[CHKLMNPTVW]?|X(YL)?)[AEIOU])[FHLMNRSX][A-Z]/))return"an";var s=[/^e[uw]/,/^onc?e\\b/,/^uni([^nmd]|mo)/,/^u[bcfhjkqrst][aeiou]/];for(t=0;t<s.length;t++)if(o.match(s[t]))return"a";return r.match(/^U[NK][AIEO]/)?"a":r==r.toUpperCase()?"aedhilmnorsx".indexOf(o[0])>=0?"an":"a":"aeiou".indexOf(o[0])>=0||o.match(/^y(b[lor]|cl[ea]|fere|gg|p[ios]|rou|tt)/)?"an":"a"};void 0!==e.exports?e.exports=t:window.indefiniteArticle=t},768:e=>{e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n},e.exports.__esModule=!0,e.exports.default=e.exports},907:(e,t,r)=>{var n=r(768);e.exports=function(e){if(Array.isArray(e))return n(e)},e.exports.__esModule=!0,e.exports.default=e.exports},642:e=>{e.exports=function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)},e.exports.__esModule=!0,e.exports.default=e.exports},344:e=>{e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},106:(e,t,r)=>{var n=r(907),o=r(642),a=r(906),s=r(344);e.exports=function(e){return n(e)||o(e)||a(e)||s()},e.exports.__esModule=!0,e.exports.default=e.exports},906:(e,t,r)=>{var n=r(768);e.exports=function(e,t){if(e){if("string"==typeof e)return n(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(e,t):void 0}},e.exports.__esModule=!0,e.exports.default=e.exports}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var a=t[n]={exports:{}};return e[n].call(a.exports,a,a.exports,r),a.exports}(()=>{"use strict";var e=r(775);const t=-32603,n=-32602,o=-32601,a=(0,e.compile)({message:'The requested method called "\${method}" is not supported.',status:o}),s=(0,e.compile)({message:'The handler of the method called "\${method}" returned no required result.',status:t}),i=(0,e.compile)({message:'The handler of the method called "\${method}" returned an unexpected result.',status:t}),c=(0,e.compile)({message:'The specified parameter called "portId" with the given value "\${portId}" does not identify a port connected to this worker.',status:n}),u=(e,t)=>async r=>{let{data:{id:n,method:o,params:c}}=r;const u=t[o];try{if(void 0===u)throw a({method:o});const t=void 0===c?u():u(c);if(void 0===t)throw s({method:o});const r=t instanceof Promise?await t:t;if(null===n){if(void 0!==r.result)throw i({method:o})}else{if(void 0===r.result)throw i({method:o});const{result:t,transferables:a=[]}=r;e.postMessage({id:n,result:t},a)}}catch(t){const{message:r,status:o=-32603}=t;e.postMessage({error:{code:o,message:r},id:n})}};var l=r(107);const d=new Map,f=(e,t,r)=>({...t,connect:r=>{let{port:n}=r;n.start();const o=e(n,t),a=(0,l.generateUniqueNumber)(d);return d.set(a,(()=>{o(),n.close(),d.delete(a)})),{result:a}},disconnect:e=>{let{portId:t}=e;const r=d.get(t);if(void 0===r)throw c({portId:t.toString()});return r(),{result:null}},isSupported:async()=>{if(await new Promise((e=>{const t=new ArrayBuffer(0),{port1:r,port2:n}=new MessageChannel;r.onmessage=t=>{let{data:r}=t;return e(null!==r)},n.postMessage(t,[t])}))){const e=r();return{result:e instanceof Promise?await e:e}}return{result:!1}}}),p=function(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:()=>!0;const n=f(p,t,r),o=u(e,n);return e.addEventListener("message",o),()=>e.removeEventListener("message",o)},m=e=>{e.onmessage=null,e.close()},h=new WeakMap,g=new WeakMap,v=(e=>{const t=(r=e,{...r,connect:e=>{let{call:t}=e;return async()=>{const{port1:e,port2:r}=new MessageChannel,n=await t("connect",{port:e},[e]);return h.set(r,n),r}},disconnect:e=>{let{call:t}=e;return async e=>{const r=h.get(e);if(void 0===r)throw new Error("The given port is not connected.");await t("disconnect",{portId:r})}},isSupported:e=>{let{call:t}=e;return()=>t("isSupported")}});var r;return e=>{const r=(e=>{if(g.has(e))return g.get(e);const t=new Map;return g.set(e,t),t})(e);e.addEventListener("message",(e=>{let{data:t}=e;const{id:n}=t;if(null!==n&&r.has(n)){const{reject:e,resolve:o}=r.get(n);r.delete(n),void 0===t.error?o(t.result):e(new Error(t.error.message))}})),(e=>"function"==typeof e.start)(e)&&e.start();const n=function(t){let n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];return new Promise(((a,s)=>{const i=(0,l.generateUniqueNumber)(r);r.set(i,{reject:s,resolve:a}),null===n?e.postMessage({id:i,method:t},o):e.postMessage({id:i,method:t,params:n},o)}))},o=function(t,r){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];e.postMessage({id:null,method:t,params:r},n)};let a={};for(const[e,r]of Object.entries(t))a={...a,[e]:r({call:n,notify:o})};return{...a}}})({characterize:e=>{let{call:t}=e;return()=>t("characterize")},encode:e=>{let{call:t}=e;return(e,r)=>t("encode",{recordingId:e,timeslice:r})},record:e=>{let{call:t}=e;return async(e,r,n)=>{await t("record",{recordingId:e,sampleRate:r,typedArrays:n},n.map((e=>{let{buffer:t}=e;return t})))}}}),w=async(e,t)=>{const r=v(t),n=await r.characterize(),o=n.toString();if(e.has(o))throw new Error("There is already an encoder stored which handles exactly the same mime types.");return e.set(o,[n,r]),n},x=new Map,y=(e=>t=>{const r=e.get(t);if(void 0===r)throw new Error("There was no instance of an encoder stored with the given id.");return r})(x),M=((e,t)=>r=>{const n=t(r);return e.delete(r),n})(x,y),b=new Map,E=((e,t)=>r=>{const[n,o,a,s]=t(r);return a?new Promise((t=>{o.onmessage=a=>{let{data:i}=a;0===i.length?(e(o),t(n.encode(r,null))):n.record(r,s,i)}})):n.encode(r,null)})(m,M),A=(e=>t=>{for(const[r,n]of Array.from(e.values()))if(r.test(t))return n;throw new Error("There is no encoder registered which could handle the given mimeType.")})(b),_=((e,t,r)=>(n,o,a)=>{if(t.has(n))throw new Error('There is already an encoder registered with an id called "'.concat(n,'".'));const s=r(o),{port1:i,port2:c}=new MessageChannel,u=[s,i,!0,a];return t.set(n,u),i.onmessage=t=>{let{data:r}=t;0===r.length?(e(i),u[2]=!1):s.record(n,a,r)},c})(m,x,A),I=(e=>(t,r)=>{const[n]=e(t);return n.encode(t,r)})(y);p(self,{encode:async e=>{let{encoderId:t,timeslice:r}=e;const n=null===r?await E(t):await I(t,r);return{result:n,transferables:n}},instantiate:e=>{let{encoderId:t,mimeType:r,sampleRate:n}=e;const o=_(t,r,n);return{result:o,transferables:[o]}},register:async e=>{let{port:t}=e;return{result:await w(b,t)}}})})()})();`; // tslint:disable-line:max-line-length

	const blob$1 = new Blob([worker$1], {
	  type: 'application/javascript; charset=utf-8'
	});
	const url$1 = URL.createObjectURL(blob$1);
	const mediaEncoderHost = load$1(url$1);
	const encode = mediaEncoderHost.encode;
	const instantiate = mediaEncoderHost.instantiate;
	const register$1 = mediaEncoderHost.register;
	URL.revokeObjectURL(url$1);

	const createBlobEventFactory = nativeBlobEventConstructor => {
	  return (type, blobEventInit) => {
	    // Bug #14: Safari does not yet support the BlobEvent.
	    if (nativeBlobEventConstructor === null) {
	      const {
	        data,
	        ...eventInit
	      } = blobEventInit;
	      const fakeBlobEvent = new Event(type, eventInit);
	      fakeBlobEvent.data = data;
	      return fakeBlobEvent;
	    }

	    return new nativeBlobEventConstructor(type, blobEventInit);
	  };
	};

	const createDecodeWebMChunk = (readElementContent, readElementType) => {
	  return (dataView, elementType, channelCount) => {
	    const contents = [];
	    let currentElementType = elementType;
	    let offset = 0;

	    while (offset < dataView.byteLength) {
	      if (currentElementType === null) {
	        const lengthAndType = readElementType(dataView, offset);

	        if (lengthAndType === null) {
	          break;
	        }

	        const {
	          length,
	          type
	        } = lengthAndType;
	        currentElementType = type;
	        offset += length;
	      } else {
	        const contentAndLength = readElementContent(dataView, offset, currentElementType, channelCount);

	        if (contentAndLength === null) {
	          break;
	        }

	        const {
	          content,
	          length
	        } = contentAndLength;
	        currentElementType = null;
	        offset += length;

	        if (content !== null) {
	          contents.push(content);
	        }
	      }
	    }

	    return {
	      contents,
	      currentElementType,
	      offset
	    };
	  };
	};

	const createEventTargetConstructor$1 = (createEventTarget, wrapEventListener) => {
	  return class EventTarget {
	    constructor(nativeEventTarget = null) {
	      this._listeners = new WeakMap();
	      this._nativeEventTarget = nativeEventTarget === null ? createEventTarget() : nativeEventTarget;
	    }

	    addEventListener(type, listener, options) {
	      if (listener !== null) {
	        let wrappedEventListener = this._listeners.get(listener);

	        if (wrappedEventListener === undefined) {
	          wrappedEventListener = wrapEventListener(this, listener);

	          if (typeof listener === 'function') {
	            this._listeners.set(listener, wrappedEventListener);
	          }
	        }

	        this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
	      }
	    }

	    dispatchEvent(event) {
	      return this._nativeEventTarget.dispatchEvent(event);
	    }

	    removeEventListener(type, listener, options) {
	      const wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);

	      this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
	    }

	  };
	};

	const createEventTargetFactory = window => {
	  return () => {
	    if (window === null) {
	      throw new Error('A native EventTarget could not be created.');
	    }

	    return window.document.createElement('p');
	  };
	};

	const createInvalidModificationError = (message = '') => {
	  try {
	    return new DOMException(message, 'InvalidModificationError');
	  } catch (err) {
	    // @todo Edge is the only browser that does not yet allow to construct a DOMException.
	    err.code = 13;
	    err.message = message;
	    err.name = 'InvalidModificationError';
	    return err;
	  }
	};

	const createInvalidStateError$1 = () => {
	  try {
	    return new DOMException('', 'InvalidStateError');
	  } catch (err) {
	    // Bug #122: Edge is the only browser that does not yet allow to construct a DOMException.
	    err.code = 11;
	    err.name = 'InvalidStateError';
	    return err;
	  }
	};

	const createMediaRecorderConstructor = (createNativeMediaRecorder, createNotSupportedError, createWebAudioMediaRecorder, createWebmPcmMediaRecorder, encoderRegexes, eventTargetConstructor, nativeMediaRecorderConstructor) => {
	  return class MediaRecorder extends eventTargetConstructor {
	    constructor(stream, options = {}) {
	      const {
	        mimeType
	      } = options;

	      if (nativeMediaRecorderConstructor !== null && ( // Bug #10: Safari does not yet implement the isTypeSupported() method.
	      mimeType === undefined || nativeMediaRecorderConstructor.isTypeSupported !== undefined && nativeMediaRecorderConstructor.isTypeSupported(mimeType))) {
	        const internalMediaRecorder = createNativeMediaRecorder(nativeMediaRecorderConstructor, stream, options);
	        super(internalMediaRecorder);
	        this._internalMediaRecorder = internalMediaRecorder;
	      } else if (mimeType !== undefined && encoderRegexes.some(regex => regex.test(mimeType))) {
	        super(); // Bug #10: Safari does not yet implement the isTypeSupported() method.

	        if (nativeMediaRecorderConstructor !== null && nativeMediaRecorderConstructor.isTypeSupported !== undefined && nativeMediaRecorderConstructor.isTypeSupported('audio/webm;codecs=pcm')) {
	          this._internalMediaRecorder = createWebmPcmMediaRecorder(this, nativeMediaRecorderConstructor, stream, mimeType);
	        } else {
	          this._internalMediaRecorder = createWebAudioMediaRecorder(this, stream, mimeType);
	        }
	      } else {
	        // This is creating a native MediaRecorder just to provoke it to throw an error.
	        if (nativeMediaRecorderConstructor !== null) {
	          createNativeMediaRecorder(nativeMediaRecorderConstructor, stream, options);
	        }

	        throw createNotSupportedError();
	      }

	      this._ondataavailable = null;
	      this._onerror = null;
	      this._onpause = null;
	      this._onresume = null;
	      this._onstart = null;
	      this._onstop = null;
	    }

	    get mimeType() {
	      return this._internalMediaRecorder.mimeType;
	    }

	    get ondataavailable() {
	      return this._ondataavailable === null ? this._ondataavailable : this._ondataavailable[0];
	    }

	    set ondataavailable(value) {
	      if (this._ondataavailable !== null) {
	        this.removeEventListener('dataavailable', this._ondataavailable[1]);
	      }

	      if (typeof value === 'function') {
	        const boundListener = value.bind(this);
	        this.addEventListener('dataavailable', boundListener);
	        this._ondataavailable = [value, boundListener];
	      } else {
	        this._ondataavailable = null;
	      }
	    }

	    get onerror() {
	      return this._onerror === null ? this._onerror : this._onerror[0];
	    }

	    set onerror(value) {
	      if (this._onerror !== null) {
	        this.removeEventListener('error', this._onerror[1]);
	      }

	      if (typeof value === 'function') {
	        const boundListener = value.bind(this);
	        this.addEventListener('error', boundListener);
	        this._onerror = [value, boundListener];
	      } else {
	        this._onerror = null;
	      }
	    }

	    get onpause() {
	      return this._onpause === null ? this._onpause : this._onpause[0];
	    }

	    set onpause(value) {
	      if (this._onpause !== null) {
	        this.removeEventListener('pause', this._onpause[1]);
	      }

	      if (typeof value === 'function') {
	        const boundListener = value.bind(this);
	        this.addEventListener('pause', boundListener);
	        this._onpause = [value, boundListener];
	      } else {
	        this._onpause = null;
	      }
	    }

	    get onresume() {
	      return this._onresume === null ? this._onresume : this._onresume[0];
	    }

	    set onresume(value) {
	      if (this._onresume !== null) {
	        this.removeEventListener('resume', this._onresume[1]);
	      }

	      if (typeof value === 'function') {
	        const boundListener = value.bind(this);
	        this.addEventListener('resume', boundListener);
	        this._onresume = [value, boundListener];
	      } else {
	        this._onresume = null;
	      }
	    }

	    get onstart() {
	      return this._onstart === null ? this._onstart : this._onstart[0];
	    }

	    set onstart(value) {
	      if (this._onstart !== null) {
	        this.removeEventListener('start', this._onstart[1]);
	      }

	      if (typeof value === 'function') {
	        const boundListener = value.bind(this);
	        this.addEventListener('start', boundListener);
	        this._onstart = [value, boundListener];
	      } else {
	        this._onstart = null;
	      }
	    }

	    get onstop() {
	      return this._onstop === null ? this._onstop : this._onstop[0];
	    }

	    set onstop(value) {
	      if (this._onstop !== null) {
	        this.removeEventListener('stop', this._onstop[1]);
	      }

	      if (typeof value === 'function') {
	        const boundListener = value.bind(this);
	        this.addEventListener('stop', boundListener);
	        this._onstop = [value, boundListener];
	      } else {
	        this._onstop = null;
	      }
	    }

	    get state() {
	      return this._internalMediaRecorder.state;
	    }

	    pause() {
	      return this._internalMediaRecorder.pause();
	    }

	    resume() {
	      return this._internalMediaRecorder.resume();
	    }

	    start(timeslice) {
	      return this._internalMediaRecorder.start(timeslice);
	    }

	    stop() {
	      return this._internalMediaRecorder.stop();
	    }

	    static isTypeSupported(mimeType) {
	      return nativeMediaRecorderConstructor !== null && // Bug #10: Safari does not yet implement the isTypeSupported() method.
	      nativeMediaRecorderConstructor.isTypeSupported !== undefined && nativeMediaRecorderConstructor.isTypeSupported(mimeType) || encoderRegexes.some(regex => regex.test(mimeType));
	    }

	  };
	};

	const createNativeBlobEventConstructor = window => {
	  if (window !== null && window.BlobEvent !== undefined) {
	    return window.BlobEvent;
	  }

	  return null;
	};

	const createNativeMediaRecorderFactory = (createInvalidModificationError, createNotSupportedError) => {
	  return (nativeMediaRecorderConstructor, stream, mediaRecorderOptions) => {
	    const bufferedBlobs = [];
	    const dataAvailableListeners = new WeakMap();
	    const errorListeners = new WeakMap();
	    const nativeMediaRecorder = new nativeMediaRecorderConstructor(stream, mediaRecorderOptions);
	    const stopListeners = new WeakMap();
	    let isActive = true;

	    nativeMediaRecorder.addEventListener = (addEventListener => {
	      return (type, listener, options) => {
	        let patchedEventListener = listener;

	        if (typeof listener === 'function') {
	          if (type === 'dataavailable') {
	            // Bug #7 & #8: Chrome fires the dataavailable and stop events before it fires the error event.
	            patchedEventListener = event => {
	              setTimeout(() => {
	                if (isActive && nativeMediaRecorder.state === 'inactive') {
	                  bufferedBlobs.push(event.data);
	                } else {
	                  if (bufferedBlobs.length > 0) {
	                    const blob = event.data;
	                    Object.defineProperty(event, 'data', {
	                      value: new Blob([...bufferedBlobs, blob], {
	                        type: blob.type
	                      })
	                    });
	                    bufferedBlobs.length = 0;
	                  }

	                  listener.call(nativeMediaRecorder, event);
	                }
	              });
	            };

	            dataAvailableListeners.set(listener, patchedEventListener);
	          } else if (type === 'error') {
	            // Bug #12 & #13: Firefox fires a regular event with an error property.
	            patchedEventListener = event => {
	              // Bug #3 & #4: Chrome throws an error event without any error.
	              if (event.error === undefined) {
	                listener.call(nativeMediaRecorder, new ErrorEvent('error', {
	                  error: createInvalidModificationError()
	                })); // Bug #1 & #2: Firefox throws an error event with an UnknownError.
	              } else if (event.error.name === 'UnknownError') {
	                const message = event.error.message;
	                listener.call(nativeMediaRecorder, new ErrorEvent('error', {
	                  error: createInvalidModificationError(message)
	                }));
	              } else if (event instanceof ErrorEvent) {
	                listener.call(nativeMediaRecorder, event);
	              } else {
	                listener.call(nativeMediaRecorder, new ErrorEvent('error', {
	                  error: event.error
	                }));
	              }
	            };

	            errorListeners.set(listener, patchedEventListener);
	          } else if (type === 'stop') {
	            // Bug #7 & #8: Chrome fires the dataavailable and stop events before it fires the error event.
	            patchedEventListener = event => {
	              isActive = false;
	              setTimeout(() => listener.call(nativeMediaRecorder, event));
	            };

	            stopListeners.set(listener, patchedEventListener);
	          }
	        }

	        return addEventListener.call(nativeMediaRecorder, type, patchedEventListener, options);
	      };
	    })(nativeMediaRecorder.addEventListener);

	    nativeMediaRecorder.dispatchEvent = (dispatchEvent => {
	      // Bug #7 & #8: Chrome fires the dataavailable and stop events before it fires the error event.
	      return event => {
	        let wasActive;
	        setTimeout(() => {
	          wasActive = isActive;
	          isActive = false;
	        });
	        const returnValue = dispatchEvent.call(nativeMediaRecorder, event);
	        setTimeout(() => isActive = wasActive);
	        return returnValue;
	      };
	    })(nativeMediaRecorder.dispatchEvent);

	    nativeMediaRecorder.removeEventListener = (removeEventListener => {
	      return (type, listener, options) => {
	        let patchedEventListener = listener;

	        if (typeof listener === 'function') {
	          if (type === 'dataavailable') {
	            const dataAvailableListener = dataAvailableListeners.get(listener);

	            if (dataAvailableListener !== undefined) {
	              patchedEventListener = dataAvailableListener;
	            }
	          } else if (type === 'error') {
	            const errorListener = errorListeners.get(listener);

	            if (errorListener !== undefined) {
	              patchedEventListener = errorListener;
	            }
	          } else if (type === 'stop') {
	            const stopListener = stopListeners.get(listener);

	            if (stopListener !== undefined) {
	              patchedEventListener = stopListener;
	            }
	          }
	        }

	        return removeEventListener.call(nativeMediaRecorder, type, patchedEventListener, options);
	      };
	    })(nativeMediaRecorder.removeEventListener);

	    nativeMediaRecorder.start = (start => {
	      return timeslice => {
	        /*
	         * Bug #6: Chrome will emit a blob without any data when asked to encode a MediaStream with a video track into an audio
	         * codec.
	         */
	        if (mediaRecorderOptions.mimeType !== undefined && mediaRecorderOptions.mimeType.startsWith('audio/') && stream.getVideoTracks().length > 0) {
	          throw createNotSupportedError();
	        }

	        isActive = timeslice !== undefined;
	        return timeslice === undefined ? start.call(nativeMediaRecorder) : start.call(nativeMediaRecorder, timeslice);
	      };
	    })(nativeMediaRecorder.start);

	    return nativeMediaRecorder;
	  };
	};

	const createNativeMediaRecorderConstructor = window => {
	  if (window === null) {
	    return null;
	  }

	  return window.MediaRecorder === undefined ? null : window.MediaRecorder;
	};

	const createNotSupportedError$1 = () => {
	  try {
	    return new DOMException('', 'NotSupportedError');
	  } catch (err) {
	    // @todo Edge is the only browser that does not yet allow to construct a DOMException.
	    err.code = 9;
	    err.name = 'NotSupportedError';
	    return err;
	  }
	};

	const createReadElementContent = readVariableSizeInteger => {
	  return (dataView, offset, type, channelCount = 2) => {
	    const lengthAndValue = readVariableSizeInteger(dataView, offset);

	    if (lengthAndValue === null) {
	      return lengthAndValue;
	    }

	    const {
	      length,
	      value
	    } = lengthAndValue;

	    if (type === 'master') {
	      return {
	        content: null,
	        length
	      };
	    }

	    if (offset + length + value > dataView.byteLength) {
	      return null;
	    }

	    if (type === 'binary') {
	      const numberOfSamples = (value / Float32Array.BYTES_PER_ELEMENT - 1) / channelCount;
	      const content = Array.from({
	        length: channelCount
	      }, () => new Float32Array(numberOfSamples));

	      for (let i = 0; i < numberOfSamples; i += 1) {
	        const elementOffset = i * channelCount + 1;

	        for (let j = 0; j < channelCount; j += 1) {
	          content[j][i] = dataView.getFloat32(offset + length + (elementOffset + j) * Float32Array.BYTES_PER_ELEMENT, true);
	        }
	      }

	      return {
	        content,
	        length: length + value
	      };
	    }

	    return {
	      content: null,
	      length: length + value
	    };
	  };
	};

	const createReadElementType = readVariableSizeInteger => {
	  return (dataView, offset) => {
	    const lengthAndValue = readVariableSizeInteger(dataView, offset);

	    if (lengthAndValue === null) {
	      return lengthAndValue;
	    }

	    const {
	      length,
	      value
	    } = lengthAndValue;

	    if (value === 35) {
	      return {
	        length,
	        type: 'binary'
	      };
	    }

	    if (value === 46 || value === 97 || value === 88713574 || value === 106212971 || value === 139690087 || value === 172351395 || value === 256095861) {
	      return {
	        length,
	        type: 'master'
	      };
	    }

	    return {
	      length,
	      type: 'unknown'
	    };
	  };
	};

	const createReadVariableSizeInteger = readVariableSizeIntegerLength => {
	  return (dataView, offset) => {
	    const length = readVariableSizeIntegerLength(dataView, offset);

	    if (length === null) {
	      return length;
	    }

	    const firstDataByteOffset = offset + Math.floor((length - 1) / 8);

	    if (firstDataByteOffset + length > dataView.byteLength) {
	      return null;
	    }

	    const firstDataByte = dataView.getUint8(firstDataByteOffset);
	    let value = firstDataByte & (1 << 8 - length % 8) - 1; // tslint:disable-line:no-bitwise

	    for (let i = 1; i < length; i += 1) {
	      value = (value << 8) + dataView.getUint8(firstDataByteOffset + i); // tslint:disable-line:no-bitwise
	    }

	    return {
	      length,
	      value
	    };
	  };
	};

	const observable = Symbol.observable || "@@observable";

	function patch(arg) {
	  if (!Symbol.observable) {
	    if (typeof arg === "function" && arg.prototype && arg.prototype[Symbol.observable]) {
	      arg.prototype[observable] = arg.prototype[Symbol.observable];
	      delete arg.prototype[Symbol.observable];
	    } else {
	      arg[observable] = arg[Symbol.observable];
	      delete arg[Symbol.observable];
	    }
	  }

	  return arg;
	}

	const noop = () => {};

	const rethrow = error => {
	  throw error;
	};

	function toObserver(observer) {
	  if (observer) {
	    if (observer.next && observer.error && observer.complete) {
	      return observer;
	    }

	    return {
	      complete: (observer.complete ?? noop).bind(observer),
	      error: (observer.error ?? rethrow).bind(observer),
	      next: (observer.next ?? noop).bind(observer)
	    };
	  }

	  return {
	    complete: noop,
	    error: rethrow,
	    next: noop
	  };
	}

	const createOn = wrapSubscribeFunction => {
	  return (target, type, options) => wrapSubscribeFunction(observer => {
	    const listener = event => observer.next(event);

	    target.addEventListener(type, listener, options);
	    return () => target.removeEventListener(type, listener, options);
	  });
	};

	const createWrapSubscribeFunction = (patch, toObserver) => {
	  const emptyFunction = () => {}; // tslint:disable-line:no-empty


	  const isNextFunction = args => typeof args[0] === 'function';

	  return innerSubscribe => {
	    const subscribe = (...args) => {
	      const unsubscribe = innerSubscribe(isNextFunction(args) ? toObserver({
	        next: args[0]
	      }) : toObserver(...args));

	      if (unsubscribe !== undefined) {
	        return unsubscribe;
	      }

	      return emptyFunction;
	    };

	    subscribe[Symbol.observable] = () => ({
	      subscribe: (...args) => ({
	        unsubscribe: subscribe(...args)
	      })
	    });

	    return patch(subscribe);
	  };
	};

	const wrapSubscribeFunction = createWrapSubscribeFunction(patch, toObserver);
	const on = createOn(wrapSubscribeFunction);

	var arrayLikeToArray = createCommonjsModule$1(function (module) {
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }

	  return arr2;
	}

	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var arrayWithoutHoles = createCommonjsModule$1(function (module) {
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}

	module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var iterableToArray = createCommonjsModule$1(function (module) {
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}

	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var unsupportedIterableToArray = createCommonjsModule$1(function (module) {
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}

	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var nonIterableSpread = createCommonjsModule$1(function (module) {
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var toConsumableArray = createCommonjsModule$1(function (module) {
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}

	module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	/*!
	 * dashify <https://github.com/jonschlinkert/dashify>
	 *
	 * Copyright (c) 2015-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */

	var dashify = (str, options) => {
	  if (typeof str !== 'string') throw new TypeError('expected a string');
	  return str.trim().replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\W/g, m => /[À-ž]/.test(m) ? m : '-').replace(/^-+|-+$/g, '').replace(/-{2,}/g, m => options && options.condense ? '-' : m).toLowerCase();
	};

	/*
	 * indefinite-article.js v1.0.0, 12-18-2011
	 *
	 * @author: Rodrigo Neri (@rigoneri)
	 *
	 * (The MIT License)
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */

	var indefiniteArticle_1 = createCommonjsModule$1(function (module) {
	var indefiniteArticle = function (phrase) {
	  var i, word; // Getting the first word

	  var match = /\w+/.exec(phrase);
	  if (match) word = match[0];else return "an";
	  var l_word = word.toLowerCase(); // Specific start of words that should be preceeded by 'an'

	  var alt_cases = ["honest", "hour", "hono"];

	  for (i in alt_cases) {
	    if (l_word.indexOf(alt_cases[i]) == 0) return "an";
	  } // Single letter word which should be preceeded by 'an'


	  if (l_word.length == 1) {
	    if ("aedhilmnorsx".indexOf(l_word) >= 0) return "an";else return "a";
	  } // Capital words which should likely be preceeded by 'an'


	  if (word.match(/(?!FJO|[HLMNS]Y.|RY[EO]|SQU|(F[LR]?|[HL]|MN?|N|RH?|S[CHKLMNPTVW]?|X(YL)?)[AEIOU])[FHLMNRSX][A-Z]/)) {
	    return "an";
	  } // Special cases where a word that begins with a vowel should be preceeded by 'a'


	  var regexes = [/^e[uw]/, /^onc?e\b/, /^uni([^nmd]|mo)/, /^u[bcfhjkqrst][aeiou]/];

	  for (i = 0; i < regexes.length; i++) {
	    if (l_word.match(regexes[i])) return "a";
	  } // Special capital words (UK, UN)


	  if (word.match(/^U[NK][AIEO]/)) {
	    return "a";
	  } else if (word == word.toUpperCase()) {
	    if ("aedhilmnorsx".indexOf(l_word[0]) >= 0) return "an";else return "a";
	  } // Basic method of words that begin with a vowel being preceeded by 'an'


	  if ("aeiou".indexOf(l_word[0]) >= 0) return "an"; // Instances where y follwed by specific letters is preceeded by 'an'

	  if (l_word.match(/^y(b[lor]|cl[ea]|fere|gg|p[ios]|rou|tt)/)) return "an";
	  return "a";
	};

	{
	  module.exports = indefiniteArticle;
	}
	});

	var bundle$2 = createCommonjsModule$1(function (module, exports) {
	(function (global, factory) {
	  factory(exports, toConsumableArray, dashify, indefiniteArticle_1) ;
	})(commonjsGlobal, function (exports, _toConsumableArray, dashify, indefiniteArticle) {

	  function _interopDefaultLegacy(e) {
	    return e && typeof e === 'object' && 'default' in e ? e : {
	      'default': e
	    };
	  }

	  var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);

	  var dashify__default = /*#__PURE__*/_interopDefaultLegacy(dashify);

	  var indefiniteArticle__default = /*#__PURE__*/_interopDefaultLegacy(indefiniteArticle);

	  var applyModifiers = function applyModifiers(name, modifiers) {
	    if (modifiers === undefined) {
	      return name;
	    }

	    return modifiers.reduce(function (modifiedName, modifier) {
	      if (modifier === 'capitalize') {
	        var head = modifiedName.charAt(0).toUpperCase();
	        var tail = modifiedName.slice(1);
	        return "".concat(head).concat(tail);
	      }

	      if (modifier === 'dashify') {
	        return dashify__default["default"](modifiedName);
	      }

	      if (modifier === 'prependIndefiniteArticle') {
	        return "".concat(indefiniteArticle__default["default"](modifiedName), " ").concat(modifiedName);
	      }

	      return modifiedName;
	    }, name);
	  };

	  var buildRegex = function buildRegex(variable) {
	    var expression = variable.name + variable.modifiers.map(function (modifier) {
	      return "\\.".concat(modifier, "\\(\\)");
	    }).join('');
	    return new RegExp("\\$\\{".concat(expression, "}"), 'g');
	  };

	  var preRenderString = function preRenderString(string, parameters) {
	    var expressionRegex = /\${([^.}]+)((\.[^(]+\(\))*)}/g;
	    var variables = [];
	    var expressionResult = expressionRegex.exec(string);

	    while (expressionResult !== null) {
	      var variable = {
	        modifiers: [],
	        name: expressionResult[1]
	      };

	      if (expressionResult[3] !== undefined) {
	        var modifiersRegex = /\.[^(]+\(\)/g;
	        var modifiersRegexResult = modifiersRegex.exec(expressionResult[2]);

	        while (modifiersRegexResult !== null) {
	          variable.modifiers.push(modifiersRegexResult[0].slice(1, -2));
	          modifiersRegexResult = modifiersRegex.exec(expressionResult[2]);
	        }
	      }

	      variables.push(variable);
	      expressionResult = expressionRegex.exec(string);
	    }

	    var preRenderedParts = variables.reduce(function (parts, variable) {
	      return parts.map(function (part) {
	        if (typeof part === 'string') {
	          return part.split(buildRegex(variable)).reduce(function (prts, prt, index) {
	            if (index === 0) {
	              return [prt];
	            }

	            if (variable.name in parameters) {
	              return [].concat(_toConsumableArray__default["default"](prts), [applyModifiers(parameters[variable.name], variable.modifiers), prt]);
	            }

	            return [].concat(_toConsumableArray__default["default"](prts), [function (prmtrs) {
	              return applyModifiers(prmtrs[variable.name], variable.modifiers);
	            }, prt]);
	          }, []);
	        }

	        return [part];
	      }).reduce(function (prts, part) {
	        return [].concat(_toConsumableArray__default["default"](prts), _toConsumableArray__default["default"](part));
	      }, []);
	    }, [string]);
	    return function (missingParameters) {
	      return preRenderedParts.reduce(function (renderedParts, preRenderedPart) {
	        if (typeof preRenderedPart === 'string') {
	          return [].concat(_toConsumableArray__default["default"](renderedParts), [preRenderedPart]);
	        }

	        return [].concat(_toConsumableArray__default["default"](renderedParts), [preRenderedPart(missingParameters)]);
	      }, []).join('');
	    };
	  };

	  var compile = function compile(template) {
	    var knownParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var renderCode = template.code === undefined ? undefined : preRenderString(template.code, knownParameters);
	    var renderMessage = template.message === undefined ? undefined : preRenderString(template.message, knownParameters);

	    function render() {
	      var causeOrMissingParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var optionalCause = arguments.length > 1 ? arguments[1] : undefined;
	      var hasNoOptionalCause = optionalCause === undefined && (causeOrMissingParameters instanceof Error || causeOrMissingParameters.code !== undefined && causeOrMissingParameters.code.slice(-9) === 'Exception');

	      var _ref = hasNoOptionalCause ? {
	        cause: causeOrMissingParameters,
	        missingParameters: {}
	      } : {
	        cause: optionalCause,
	        missingParameters: causeOrMissingParameters
	      },
	          cause = _ref.cause,
	          missingParameters = _ref.missingParameters;

	      var err = renderMessage === undefined ? new Error() : new Error(renderMessage(missingParameters));

	      if (cause !== null) {
	        err.cause = cause;
	      }

	      if (renderCode !== undefined) {
	        err.code = renderCode(missingParameters);
	      }

	      if (template.status !== undefined) {
	        err.status = template.status;
	      }

	      return err;
	    }

	    return render;
	  };

	  exports.compile = compile;
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	});
	});

	const JSON_RPC_ERROR_CODES = {
	  INTERNAL_ERROR: -32603,
	  INVALID_PARAMS: -32602,
	  METHOD_NOT_FOUND: -32601
	};
	bundle$2.compile({
	  message: 'The requested method called "${method}" is not supported.',
	  status: JSON_RPC_ERROR_CODES.METHOD_NOT_FOUND
	});
	bundle$2.compile({
	  message: 'The handler of the method called "${method}" returned no required result.',
	  status: JSON_RPC_ERROR_CODES.INTERNAL_ERROR
	});
	bundle$2.compile({
	  message: 'The handler of the method called "${method}" returned an unexpected result.',
	  status: JSON_RPC_ERROR_CODES.INTERNAL_ERROR
	});
	bundle$2.compile({
	  message: 'The specified parameter called "portId" with the given value "${portId}" does not identify a port connected to this worker.',
	  status: JSON_RPC_ERROR_CODES.INVALID_PARAMS
	});

	const createAddRecorderAudioWorkletModule = (blobConstructor, urlConstructor, worklet) => {
	  return async addAudioWorkletModule => {
	    const blob = new blobConstructor([worklet], {
	      type: 'application/javascript; charset=utf-8'
	    });
	    const url = urlConstructor.createObjectURL(blob);

	    try {
	      await addAudioWorkletModule(url);
	    } finally {
	      urlConstructor.revokeObjectURL(url);
	    }
	  };
	};

	const createListener = ongoingRequests => {
	  return ({
	    data: message
	  }) => {
	    const {
	      id
	    } = message;

	    if (id !== null) {
	      const ongoingRequest = ongoingRequests.get(id);

	      if (ongoingRequest !== undefined) {
	        const {
	          reject,
	          resolve
	        } = ongoingRequest;
	        ongoingRequests.delete(id);

	        if (message.error === undefined) {
	          resolve(message.result);
	        } else {
	          reject(new Error(message.error.message));
	        }
	      }
	    }
	  };
	};

	const createPostMessageFactory = generateUniqueNumber => {
	  return (ongoingRequests, port) => {
	    return (message, transferables = []) => {
	      return new Promise((resolve, reject) => {
	        const id = generateUniqueNumber(ongoingRequests);
	        ongoingRequests.set(id, {
	          reject,
	          resolve
	        });
	        port.postMessage({
	          id,
	          ...message
	        }, transferables);
	      });
	    };
	  };
	};

	const createRecorderAudioWorkletNodeFactory = (createListener, createPostMessage, on, validateState) => {
	  return (audioWorkletNodeConstructor, context, options = {}) => {
	    const audioWorkletNode = new audioWorkletNodeConstructor(context, 'recorder-audio-worklet-processor', { ...options,
	      channelCountMode: 'explicit',
	      numberOfInputs: 1,
	      numberOfOutputs: 0
	    });
	    const ongoingRequests = new Map();
	    const postMessage = createPostMessage(ongoingRequests, audioWorkletNode.port);
	    const unsubscribe = on(audioWorkletNode.port, 'message')(createListener(ongoingRequests));
	    audioWorkletNode.port.start();
	    let state = 'inactive';
	    Object.defineProperties(audioWorkletNode, {
	      pause: {
	        get() {
	          return async () => {
	            validateState(['recording'], state);
	            state = 'paused';
	            return postMessage({
	              method: 'pause'
	            });
	          };
	        }

	      },
	      port: {
	        get() {
	          throw new Error("The port of a RecorderAudioWorkletNode can't be accessed.");
	        }

	      },
	      record: {
	        get() {
	          return async encoderPort => {
	            validateState(['inactive'], state);
	            state = 'recording';
	            return postMessage({
	              method: 'record',
	              params: {
	                encoderPort
	              }
	            }, [encoderPort]);
	          };
	        }

	      },
	      resume: {
	        get() {
	          return async () => {
	            validateState(['paused'], state);
	            state = 'recording';
	            return postMessage({
	              method: 'resume'
	            });
	          };
	        }

	      },
	      stop: {
	        get() {
	          return async () => {
	            validateState(['paused', 'recording'], state);
	            state = 'stopped';

	            try {
	              await postMessage({
	                method: 'stop'
	              });
	            } finally {
	              unsubscribe();
	            }
	          };
	        }

	      }
	    });
	    return audioWorkletNode;
	  };
	};

	const validateState = (expectedStates, currentState) => {
	  if (!expectedStates.includes(currentState)) {
	    throw new Error(`Expected the state to be ${expectedStates.map(expectedState => `"${expectedState}"`).join(' or ')} but it was "${currentState}".`);
	  }
	};

	// This is the minified and stringified code of the recorder-audio-worklet-processor package.
	const worklet = `(()=>{"use strict";class e extends AudioWorkletProcessor{constructor(){super(),this._encoderPort=null,this._state="inactive",this.port.onmessage=e=>{let{data:t}=e;"pause"===t.method?"active"===this._state||"recording"===this._state?(this._state="paused",this._sendAcknowledgement(t.id)):this._sendUnexpectedStateError(t.id):"record"===t.method?"inactive"===this._state?(this._encoderPort=t.params.encoderPort,this._state="active",this._sendAcknowledgement(t.id)):this._sendUnexpectedStateError(t.id):"resume"===t.method?"paused"===this._state?(this._state="active",this._sendAcknowledgement(t.id)):this._sendUnexpectedStateError(t.id):"stop"===t.method?"active"!==this._state&&"paused"!==this._state&&"recording"!==this._state||null===this._encoderPort?this._sendUnexpectedStateError(t.id):(this._stop(this._encoderPort),this._sendAcknowledgement(t.id)):"number"==typeof t.id&&this.port.postMessage({error:{code:-32601,message:"The requested method is not supported."},id:t.id})}}process(e){let[t]=e;if("inactive"===this._state||"paused"===this._state)return!0;if("active"===this._state){if(void 0===t)throw new Error("No channelData was received for the first input.");if(0===t.length)return!0;this._state="recording"}if("recording"===this._state&&null!==this._encoderPort){if(void 0===t)throw new Error("No channelData was received for the first input.");if(0!==t.length)return this._encoderPort.postMessage(t,t.map((e=>{let{buffer:t}=e;return t}))),!0;this._stop(this._encoderPort)}return!1}_sendAcknowledgement(e){this.port.postMessage({id:e,result:null})}_sendUnexpectedStateError(e){this.port.postMessage({error:{code:-32603,message:"The internal state does not allow to process the given message."},id:e})}_stop(e){e.postMessage([]),e.close(),this._encoderPort=null,this._state="stopped"}}e.parameterDescriptors=[],registerProcessor("recorder-audio-worklet-processor",e)})();`; // tslint:disable-line:max-line-length

	const addRecorderAudioWorkletModule = createAddRecorderAudioWorkletModule(Blob, URL, worklet);
	const createRecorderAudioWorkletNode = createRecorderAudioWorkletNodeFactory(createListener, createPostMessageFactory(bundle$3.generateUniqueNumber), on, validateState);

	var arrayWithHoles = createCommonjsModule$1(function (module) {
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}

	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var iterableToArrayLimit = createCommonjsModule$1(function (module) {
	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;

	  var _s, _e;

	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var nonIterableRest = createCommonjsModule$1(function (module) {
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var slicedToArray = createCommonjsModule$1(function (module) {
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}

	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var classCallCheck = createCommonjsModule$1(function (module) {
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var createClass = createCommonjsModule$1(function (module) {
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}

	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var bundle$1 = createCommonjsModule$1(function (module, exports) {
	(function (global, factory) {
	  factory(exports, slicedToArray, classCallCheck, createClass) ;
	})(commonjsGlobal, function (exports, _slicedToArray, _classCallCheck, _createClass) {

	  function _interopDefaultLegacy(e) {
	    return e && typeof e === 'object' && 'default' in e ? e : {
	      'default': e
	    };
	  }

	  var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

	  var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);

	  var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

	  var createExtendedExponentialRampToValueAutomationEvent = function createExtendedExponentialRampToValueAutomationEvent(value, endTime, insertTime) {
	    return {
	      endTime: endTime,
	      insertTime: insertTime,
	      type: 'exponentialRampToValue',
	      value: value
	    };
	  };

	  var createExtendedLinearRampToValueAutomationEvent = function createExtendedLinearRampToValueAutomationEvent(value, endTime, insertTime) {
	    return {
	      endTime: endTime,
	      insertTime: insertTime,
	      type: 'linearRampToValue',
	      value: value
	    };
	  };

	  var createSetValueAutomationEvent = function createSetValueAutomationEvent(value, startTime) {
	    return {
	      startTime: startTime,
	      type: 'setValue',
	      value: value
	    };
	  };

	  var createSetValueCurveAutomationEvent = function createSetValueCurveAutomationEvent(values, startTime, duration) {
	    return {
	      duration: duration,
	      startTime: startTime,
	      type: 'setValueCurve',
	      values: values
	    };
	  };

	  var getTargetValueAtTime = function getTargetValueAtTime(time, valueAtStartTime, _ref) {
	    var startTime = _ref.startTime,
	        target = _ref.target,
	        timeConstant = _ref.timeConstant;
	    return target + (valueAtStartTime - target) * Math.exp((startTime - time) / timeConstant);
	  };

	  var isExponentialRampToValueAutomationEvent = function isExponentialRampToValueAutomationEvent(automationEvent) {
	    return automationEvent.type === 'exponentialRampToValue';
	  };

	  var isLinearRampToValueAutomationEvent = function isLinearRampToValueAutomationEvent(automationEvent) {
	    return automationEvent.type === 'linearRampToValue';
	  };

	  var isAnyRampToValueAutomationEvent = function isAnyRampToValueAutomationEvent(automationEvent) {
	    return isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent);
	  };

	  var isSetValueAutomationEvent = function isSetValueAutomationEvent(automationEvent) {
	    return automationEvent.type === 'setValue';
	  };

	  var isSetValueCurveAutomationEvent = function isSetValueCurveAutomationEvent(automationEvent) {
	    return automationEvent.type === 'setValueCurve';
	  };

	  var getValueOfAutomationEventAtIndexAtTime = function getValueOfAutomationEventAtIndexAtTime(automationEvents, index, time, defaultValue) {
	    var automationEvent = automationEvents[index];
	    return automationEvent === undefined ? defaultValue : isAnyRampToValueAutomationEvent(automationEvent) || isSetValueAutomationEvent(automationEvent) ? automationEvent.value : isSetValueCurveAutomationEvent(automationEvent) ? automationEvent.values[automationEvent.values.length - 1] : getTargetValueAtTime(time, getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, automationEvent.startTime, defaultValue), automationEvent);
	  };

	  var getEndTimeAndValueOfPreviousAutomationEvent = function getEndTimeAndValueOfPreviousAutomationEvent(automationEvents, index, currentAutomationEvent, nextAutomationEvent, defaultValue) {
	    return currentAutomationEvent === undefined ? [nextAutomationEvent.insertTime, defaultValue] : isAnyRampToValueAutomationEvent(currentAutomationEvent) ? [currentAutomationEvent.endTime, currentAutomationEvent.value] : isSetValueAutomationEvent(currentAutomationEvent) ? [currentAutomationEvent.startTime, currentAutomationEvent.value] : isSetValueCurveAutomationEvent(currentAutomationEvent) ? [currentAutomationEvent.startTime + currentAutomationEvent.duration, currentAutomationEvent.values[currentAutomationEvent.values.length - 1]] : [currentAutomationEvent.startTime, getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, currentAutomationEvent.startTime, defaultValue)];
	  };

	  var isCancelAndHoldAutomationEvent = function isCancelAndHoldAutomationEvent(automationEvent) {
	    return automationEvent.type === 'cancelAndHold';
	  };

	  var isCancelScheduledValuesAutomationEvent = function isCancelScheduledValuesAutomationEvent(automationEvent) {
	    return automationEvent.type === 'cancelScheduledValues';
	  };

	  var getEventTime = function getEventTime(automationEvent) {
	    if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) {
	      return automationEvent.cancelTime;
	    }

	    if (isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent)) {
	      return automationEvent.endTime;
	    }

	    return automationEvent.startTime;
	  };

	  var getExponentialRampValueAtTime = function getExponentialRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
	    var endTime = _ref.endTime,
	        value = _ref.value;

	    if (valueAtStartTime === value) {
	      return value;
	    }

	    if (0 < valueAtStartTime && 0 < value || valueAtStartTime < 0 && value < 0) {
	      return valueAtStartTime * Math.pow(value / valueAtStartTime, (time - startTime) / (endTime - startTime));
	    }

	    return 0;
	  };

	  var getLinearRampValueAtTime = function getLinearRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
	    var endTime = _ref.endTime,
	        value = _ref.value;
	    return valueAtStartTime + (time - startTime) / (endTime - startTime) * (value - valueAtStartTime);
	  };

	  var interpolateValue = function interpolateValue(values, theoreticIndex) {
	    var lowerIndex = Math.floor(theoreticIndex);
	    var upperIndex = Math.ceil(theoreticIndex);

	    if (lowerIndex === upperIndex) {
	      return values[lowerIndex];
	    }

	    return (1 - (theoreticIndex - lowerIndex)) * values[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * values[upperIndex];
	  };

	  var getValueCurveValueAtTime = function getValueCurveValueAtTime(time, _ref) {
	    var duration = _ref.duration,
	        startTime = _ref.startTime,
	        values = _ref.values;
	    var theoreticIndex = (time - startTime) / duration * (values.length - 1);
	    return interpolateValue(values, theoreticIndex);
	  };

	  var isSetTargetAutomationEvent = function isSetTargetAutomationEvent(automationEvent) {
	    return automationEvent.type === 'setTarget';
	  };

	  var AutomationEventList = /*#__PURE__*/function (_Symbol$iterator) {
	    function AutomationEventList(defaultValue) {
	      _classCallCheck__default["default"](this, AutomationEventList);

	      this._automationEvents = [];
	      this._currenTime = 0;
	      this._defaultValue = defaultValue;
	    }

	    _createClass__default["default"](AutomationEventList, [{
	      key: _Symbol$iterator,
	      value: function value() {
	        return this._automationEvents[Symbol.iterator]();
	      }
	    }, {
	      key: "add",
	      value: function add(automationEvent) {
	        var eventTime = getEventTime(automationEvent);

	        if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) {
	          var index = this._automationEvents.findIndex(function (currentAutomationEvent) {
	            if (isCancelScheduledValuesAutomationEvent(automationEvent) && isSetValueCurveAutomationEvent(currentAutomationEvent)) {
	              return currentAutomationEvent.startTime + currentAutomationEvent.duration >= eventTime;
	            }

	            return getEventTime(currentAutomationEvent) >= eventTime;
	          });

	          var removedAutomationEvent = this._automationEvents[index];

	          if (index !== -1) {
	            this._automationEvents = this._automationEvents.slice(0, index);
	          }

	          if (isCancelAndHoldAutomationEvent(automationEvent)) {
	            var lastAutomationEvent = this._automationEvents[this._automationEvents.length - 1];

	            if (removedAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(removedAutomationEvent)) {
	              if (isSetTargetAutomationEvent(lastAutomationEvent)) {
	                throw new Error('The internal list is malformed.');
	              }

	              var startTime = isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.startTime + lastAutomationEvent.duration : getEventTime(lastAutomationEvent);
	              var startValue = isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.values[lastAutomationEvent.values.length - 1] : lastAutomationEvent.value;
	              var value = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? getExponentialRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent) : getLinearRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent);
	              var truncatedAutomationEvent = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? createExtendedExponentialRampToValueAutomationEvent(value, eventTime, this._currenTime) : createExtendedLinearRampToValueAutomationEvent(value, eventTime, this._currenTime);

	              this._automationEvents.push(truncatedAutomationEvent);
	            }

	            if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) {
	              this._automationEvents.push(createSetValueAutomationEvent(this.getValue(eventTime), eventTime));
	            }

	            if (lastAutomationEvent !== undefined && isSetValueCurveAutomationEvent(lastAutomationEvent) && lastAutomationEvent.startTime + lastAutomationEvent.duration > eventTime) {
	              this._automationEvents[this._automationEvents.length - 1] = createSetValueCurveAutomationEvent(new Float32Array([6, 7]), lastAutomationEvent.startTime, eventTime - lastAutomationEvent.startTime);
	            }
	          }
	        } else {
	          var _index = this._automationEvents.findIndex(function (currentAutomationEvent) {
	            return getEventTime(currentAutomationEvent) > eventTime;
	          });

	          var previousAutomationEvent = _index === -1 ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[_index - 1];

	          if (previousAutomationEvent !== undefined && isSetValueCurveAutomationEvent(previousAutomationEvent) && getEventTime(previousAutomationEvent) + previousAutomationEvent.duration > eventTime) {
	            return false;
	          }

	          var persistentAutomationEvent = isExponentialRampToValueAutomationEvent(automationEvent) ? createExtendedExponentialRampToValueAutomationEvent(automationEvent.value, automationEvent.endTime, this._currenTime) : isLinearRampToValueAutomationEvent(automationEvent) ? createExtendedLinearRampToValueAutomationEvent(automationEvent.value, eventTime, this._currenTime) : automationEvent;

	          if (_index === -1) {
	            this._automationEvents.push(persistentAutomationEvent);
	          } else {
	            if (isSetValueCurveAutomationEvent(automationEvent) && eventTime + automationEvent.duration > getEventTime(this._automationEvents[_index])) {
	              return false;
	            }

	            this._automationEvents.splice(_index, 0, persistentAutomationEvent);
	          }
	        }

	        return true;
	      }
	    }, {
	      key: "flush",
	      value: function flush(time) {
	        var index = this._automationEvents.findIndex(function (currentAutomationEvent) {
	          return getEventTime(currentAutomationEvent) > time;
	        });

	        if (index > 1) {
	          var remainingAutomationEvents = this._automationEvents.slice(index - 1);

	          var firstRemainingAutomationEvent = remainingAutomationEvents[0];

	          if (isSetTargetAutomationEvent(firstRemainingAutomationEvent)) {
	            remainingAutomationEvents.unshift(createSetValueAutomationEvent(getValueOfAutomationEventAtIndexAtTime(this._automationEvents, index - 2, firstRemainingAutomationEvent.startTime, this._defaultValue), firstRemainingAutomationEvent.startTime));
	          }

	          this._automationEvents = remainingAutomationEvents;
	        }
	      }
	    }, {
	      key: "getValue",
	      value: function getValue(time) {
	        if (this._automationEvents.length === 0) {
	          return this._defaultValue;
	        }

	        var indexOfNextEvent = this._automationEvents.findIndex(function (automationEvent) {
	          return getEventTime(automationEvent) > time;
	        });

	        var nextAutomationEvent = this._automationEvents[indexOfNextEvent];
	        var indexOfCurrentEvent = (indexOfNextEvent === -1 ? this._automationEvents.length : indexOfNextEvent) - 1;
	        var currentAutomationEvent = this._automationEvents[indexOfCurrentEvent];

	        if (currentAutomationEvent !== undefined && isSetTargetAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || nextAutomationEvent.insertTime > time)) {
	          return getTargetValueAtTime(time, getValueOfAutomationEventAtIndexAtTime(this._automationEvents, indexOfCurrentEvent - 1, currentAutomationEvent.startTime, this._defaultValue), currentAutomationEvent);
	        }

	        if (currentAutomationEvent !== undefined && isSetValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) {
	          return currentAutomationEvent.value;
	        }

	        if (currentAutomationEvent !== undefined && isSetValueCurveAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || currentAutomationEvent.startTime + currentAutomationEvent.duration > time)) {
	          if (time < currentAutomationEvent.startTime + currentAutomationEvent.duration) {
	            return getValueCurveValueAtTime(time, currentAutomationEvent);
	          }

	          return currentAutomationEvent.values[currentAutomationEvent.values.length - 1];
	        }

	        if (currentAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) {
	          return currentAutomationEvent.value;
	        }

	        if (nextAutomationEvent !== undefined && isExponentialRampToValueAutomationEvent(nextAutomationEvent)) {
	          var _getEndTimeAndValueOf = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue),
	              _getEndTimeAndValueOf2 = _slicedToArray__default["default"](_getEndTimeAndValueOf, 2),
	              startTime = _getEndTimeAndValueOf2[0],
	              value = _getEndTimeAndValueOf2[1];

	          return getExponentialRampValueAtTime(time, startTime, value, nextAutomationEvent);
	        }

	        if (nextAutomationEvent !== undefined && isLinearRampToValueAutomationEvent(nextAutomationEvent)) {
	          var _getEndTimeAndValueOf3 = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue),
	              _getEndTimeAndValueOf4 = _slicedToArray__default["default"](_getEndTimeAndValueOf3, 2),
	              _startTime = _getEndTimeAndValueOf4[0],
	              _value = _getEndTimeAndValueOf4[1];

	          return getLinearRampValueAtTime(time, _startTime, _value, nextAutomationEvent);
	        }

	        return this._defaultValue;
	      }
	    }]);

	    return AutomationEventList;
	  }(Symbol.iterator);

	  var createCancelAndHoldAutomationEvent = function createCancelAndHoldAutomationEvent(cancelTime) {
	    return {
	      cancelTime: cancelTime,
	      type: 'cancelAndHold'
	    };
	  };

	  var createCancelScheduledValuesAutomationEvent = function createCancelScheduledValuesAutomationEvent(cancelTime) {
	    return {
	      cancelTime: cancelTime,
	      type: 'cancelScheduledValues'
	    };
	  };

	  var createExponentialRampToValueAutomationEvent = function createExponentialRampToValueAutomationEvent(value, endTime) {
	    return {
	      endTime: endTime,
	      type: 'exponentialRampToValue',
	      value: value
	    };
	  };

	  var createLinearRampToValueAutomationEvent = function createLinearRampToValueAutomationEvent(value, endTime) {
	    return {
	      endTime: endTime,
	      type: 'linearRampToValue',
	      value: value
	    };
	  };

	  var createSetTargetAutomationEvent = function createSetTargetAutomationEvent(target, startTime, timeConstant) {
	    return {
	      startTime: startTime,
	      target: target,
	      timeConstant: timeConstant,
	      type: 'setTarget'
	    };
	  };

	  exports.AutomationEventList = AutomationEventList;
	  exports.createCancelAndHoldAutomationEvent = createCancelAndHoldAutomationEvent;
	  exports.createCancelScheduledValuesAutomationEvent = createCancelScheduledValuesAutomationEvent;
	  exports.createExponentialRampToValueAutomationEvent = createExponentialRampToValueAutomationEvent;
	  exports.createLinearRampToValueAutomationEvent = createLinearRampToValueAutomationEvent;
	  exports.createSetTargetAutomationEvent = createSetTargetAutomationEvent;
	  exports.createSetValueAutomationEvent = createSetValueAutomationEvent;
	  exports.createSetValueCurveAutomationEvent = createSetValueCurveAutomationEvent;
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	});
	});

	const createAbortError = () => new DOMException('', 'AbortError');

	const createAddActiveInputConnectionToAudioNode = insertElementInSet => {
	  return (activeInputs, source, [output, input, eventListener], ignoreDuplicates) => {
	    insertElementInSet(activeInputs[input], [source, output, eventListener], activeInputConnection => activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
	  };
	};

	const createAddAudioNodeConnections = audioNodeConnectionsStore => {
	  return (audioNode, audioNodeRenderer, nativeAudioNode) => {
	    const activeInputs = [];

	    for (let i = 0; i < nativeAudioNode.numberOfInputs; i += 1) {
	      activeInputs.push(new Set());
	    }

	    audioNodeConnectionsStore.set(audioNode, {
	      activeInputs,
	      outputs: new Set(),
	      passiveInputs: new WeakMap(),
	      renderer: audioNodeRenderer
	    });
	  };
	};

	const createAddAudioParamConnections = audioParamConnectionsStore => {
	  return (audioParam, audioParamRenderer) => {
	    audioParamConnectionsStore.set(audioParam, {
	      activeInputs: new Set(),
	      passiveInputs: new WeakMap(),
	      renderer: audioParamRenderer
	    });
	  };
	};

	const ACTIVE_AUDIO_NODE_STORE = new WeakSet();
	const AUDIO_NODE_CONNECTIONS_STORE = new WeakMap();
	const AUDIO_NODE_STORE = new WeakMap();
	const AUDIO_PARAM_CONNECTIONS_STORE = new WeakMap();
	const AUDIO_PARAM_STORE = new WeakMap();
	const CONTEXT_STORE = new WeakMap();
	const EVENT_LISTENERS = new WeakMap();
	const CYCLE_COUNTERS = new WeakMap(); // This clunky name is borrowed from the spec. :-)

	const NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS = new WeakMap();
	const NODE_TO_PROCESSOR_MAPS = new WeakMap();

	const handler = {
	  construct() {
	    return handler;
	  }

	};
	const isConstructible = constructible => {
	  try {
	    const proxy = new Proxy(constructible, handler);
	    new proxy(); // tslint:disable-line:no-unused-expression
	  } catch {
	    return false;
	  }

	  return true;
	};

	/*
	 * This massive regex tries to cover all the following cases.
	 *
	 * import './path';
	 * import defaultImport from './path';
	 * import { namedImport } from './path';
	 * import { namedImport as renamendImport } from './path';
	 * import * as namespaceImport from './path';
	 * import defaultImport, { namedImport } from './path';
	 * import defaultImport, { namedImport as renamendImport } from './path';
	 * import defaultImport, * as namespaceImport from './path';
	 */
	const IMPORT_STATEMENT_REGEX = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/; // tslint:disable-line:max-line-length

	const splitImportStatements = (source, url) => {
	  const importStatements = [];
	  let sourceWithoutImportStatements = source.replace(/^[\s]+/, '');
	  let result = sourceWithoutImportStatements.match(IMPORT_STATEMENT_REGEX);

	  while (result !== null) {
	    const unresolvedUrl = result[1].slice(1, -1);
	    const importStatementWithResolvedUrl = result[0].replace(/([\s]+)?;?$/, '').replace(unresolvedUrl, new URL(unresolvedUrl, url).toString());
	    importStatements.push(importStatementWithResolvedUrl);
	    sourceWithoutImportStatements = sourceWithoutImportStatements.slice(result[0].length).replace(/^[\s]+/, '');
	    result = sourceWithoutImportStatements.match(IMPORT_STATEMENT_REGEX);
	  }

	  return [importStatements.join(';'), sourceWithoutImportStatements];
	};

	const verifyParameterDescriptors = parameterDescriptors => {
	  if (parameterDescriptors !== undefined && !Array.isArray(parameterDescriptors)) {
	    throw new TypeError('The parameterDescriptors property of given value for processorCtor is not an array.');
	  }
	};

	const verifyProcessorCtor = processorCtor => {
	  if (!isConstructible(processorCtor)) {
	    throw new TypeError('The given value for processorCtor should be a constructor.');
	  }

	  if (processorCtor.prototype === null || typeof processorCtor.prototype !== 'object') {
	    throw new TypeError('The given value for processorCtor should have a prototype.');
	  }
	};

	const createAddAudioWorkletModule = (cacheTestResult, createNotSupportedError, evaluateSource, exposeCurrentFrameAndCurrentTime, fetchSource, getNativeContext, getOrCreateBackupOfflineAudioContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, ongoingRequests, resolvedRequests, testAudioWorkletProcessorPostMessageSupport, window) => {
	  let index = 0;
	  return (context, moduleURL, options = {
	    credentials: 'omit'
	  }) => {
	    const resolvedRequestsOfContext = resolvedRequests.get(context);

	    if (resolvedRequestsOfContext !== undefined && resolvedRequestsOfContext.has(moduleURL)) {
	      return Promise.resolve();
	    }

	    const ongoingRequestsOfContext = ongoingRequests.get(context);

	    if (ongoingRequestsOfContext !== undefined) {
	      const promiseOfOngoingRequest = ongoingRequestsOfContext.get(moduleURL);

	      if (promiseOfOngoingRequest !== undefined) {
	        return promiseOfOngoingRequest;
	      }
	    }

	    const nativeContext = getNativeContext(context); // Bug #59: Safari does not implement the audioWorklet property.

	    const promise = nativeContext.audioWorklet === undefined ? fetchSource(moduleURL).then(([source, absoluteUrl]) => {
	      const [importStatements, sourceWithoutImportStatements] = splitImportStatements(source, absoluteUrl);
	      /*
	       * This is the unminified version of the code used below:
	       *
	       * ```js
	       * ${ importStatements };
	       * ((a, b) => {
	       *     (a[b] = a[b] || [ ]).push(
	       *         (AudioWorkletProcessor, global, registerProcessor, sampleRate, self, window) => {
	       *             ${ sourceWithoutImportStatements }
	       *         }
	       *     );
	       * })(window, '_AWGS');
	       * ```
	       */
	      // tslint:disable-next-line:max-line-length

	      const wrappedSource = `${importStatements};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${sourceWithoutImportStatements}
})})(window,'_AWGS')`; // @todo Evaluating the given source code is a possible security problem.

	      return evaluateSource(wrappedSource);
	    }).then(() => {
	      const evaluateAudioWorkletGlobalScope = window._AWGS.pop();

	      if (evaluateAudioWorkletGlobalScope === undefined) {
	        // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
	        throw new SyntaxError();
	      }

	      exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, () => evaluateAudioWorkletGlobalScope(class AudioWorkletProcessor {}, undefined, (name, processorCtor) => {
	        if (name.trim() === '') {
	          throw createNotSupportedError();
	        }

	        const nodeNameToProcessorConstructorMap = NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS.get(nativeContext);

	        if (nodeNameToProcessorConstructorMap !== undefined) {
	          if (nodeNameToProcessorConstructorMap.has(name)) {
	            throw createNotSupportedError();
	          }

	          verifyProcessorCtor(processorCtor);
	          verifyParameterDescriptors(processorCtor.parameterDescriptors);
	          nodeNameToProcessorConstructorMap.set(name, processorCtor);
	        } else {
	          verifyProcessorCtor(processorCtor);
	          verifyParameterDescriptors(processorCtor.parameterDescriptors);
	          NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS.set(nativeContext, new Map([[name, processorCtor]]));
	        }
	      }, nativeContext.sampleRate, undefined, undefined));
	    }) : Promise.all([fetchSource(moduleURL), Promise.resolve(cacheTestResult(testAudioWorkletProcessorPostMessageSupport, testAudioWorkletProcessorPostMessageSupport))]).then(([[source, absoluteUrl], isSupportingPostMessage]) => {
	      const currentIndex = index + 1;
	      index = currentIndex;
	      const [importStatements, sourceWithoutImportStatements] = splitImportStatements(source, absoluteUrl);
	      /*
	       * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
	       *
	       * This is the unminified version of the code used below.
	       *
	       * ```js
	       * class extends AudioWorkletProcessor {
	       *
	       *     __buffers = new WeakSet();
	       *
	       *     constructor () {
	       *         super();
	       *
	       *         this.port.postMessage = ((postMessage) => {
	       *             return (message, transferables) => {
	       *                 const filteredTransferables = (transferables)
	       *                     ? transferables.filter((transferable) => !this.__buffers.has(transferable))
	       *                     : transferables;
	       *
	       *                 return postMessage.call(this.port, message, filteredTransferables);
	       *              };
	       *         })(this.port.postMessage);
	       *     }
	       * }
	       * ```
	       */

	      const patchedAudioWorkletProcessor = isSupportingPostMessage ? 'AudioWorkletProcessor' : 'class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}';
	      /*
	       * Bug #170: Chrome and Edge do call process() with an array with empty channelData for each input if no input is connected.
	       *
	       * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
	       *
	       * Bug #190: Safari doesn't throw an error when loading an unparsable module.
	       *
	       * This is the unminified version of the code used below:
	       *
	       * ```js
	       * `${ importStatements };
	       * ((AudioWorkletProcessor, registerProcessor) => {${ sourceWithoutImportStatements }
	       * })(
	       *     ${ patchedAudioWorkletProcessor },
	       *     (name, processorCtor) => registerProcessor(name, class extends processorCtor {
	       *
	       *         __collectBuffers = (array) => {
	       *             array.forEach((element) => this.__buffers.add(element.buffer));
	       *         };
	       *
	       *         process (inputs, outputs, parameters) {
	       *             inputs.forEach(this.__collectBuffers);
	       *             outputs.forEach(this.__collectBuffers);
	       *             this.__collectBuffers(Object.values(parameters));
	       *
	       *             return super.process(
	       *                 (inputs.map((input) => input.some((channelData) => channelData.length === 0)) ? [ ] : input),
	       *                 outputs,
	       *                 parameters
	       *             );
	       *         }
	       *
	       *     })
	       * );
	       *
	       * registerProcessor(`__sac${currentIndex}`, class extends AudioWorkletProcessor{
	       *
	       *     process () {
	       *         return false;
	       *     }
	       *
	       * })`
	       * ```
	       */

	      const memberDefinition = isSupportingPostMessage ? '' : '__c = (a) => a.forEach(e=>this.__b.add(e.buffer));';
	      const bufferRegistration = isSupportingPostMessage ? '' : 'i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));';
	      const wrappedSource = `${importStatements};((AudioWorkletProcessor,registerProcessor)=>{${sourceWithoutImportStatements}
})(${patchedAudioWorkletProcessor},(n,p)=>registerProcessor(n,class extends p{${memberDefinition}process(i,o,p){${bufferRegistration}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${currentIndex}',class extends AudioWorkletProcessor{process(){return !1}})`;
	      const blob = new Blob([wrappedSource], {
	        type: 'application/javascript; charset=utf-8'
	      });
	      const url = URL.createObjectURL(blob);
	      return nativeContext.audioWorklet.addModule(url, options).then(() => {
	        if (isNativeOfflineAudioContext(nativeContext)) {
	          return nativeContext;
	        } // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.


	        const backupOfflineAudioContext = getOrCreateBackupOfflineAudioContext(nativeContext);
	        return backupOfflineAudioContext.audioWorklet.addModule(url, options).then(() => backupOfflineAudioContext);
	      }).then(nativeContextOrBackupOfflineAudioContext => {
	        if (nativeAudioWorkletNodeConstructor === null) {
	          throw new SyntaxError();
	        }

	        try {
	          // Bug #190: Safari doesn't throw an error when loading an unparsable module.
	          new nativeAudioWorkletNodeConstructor(nativeContextOrBackupOfflineAudioContext, `__sac${currentIndex}`); // tslint:disable-line:no-unused-expression
	        } catch {
	          throw new SyntaxError();
	        }
	      }).finally(() => URL.revokeObjectURL(url));
	    });

	    if (ongoingRequestsOfContext === undefined) {
	      ongoingRequests.set(context, new Map([[moduleURL, promise]]));
	    } else {
	      ongoingRequestsOfContext.set(moduleURL, promise);
	    }

	    promise.then(() => {
	      const updatedResolvedRequestsOfContext = resolvedRequests.get(context);

	      if (updatedResolvedRequestsOfContext === undefined) {
	        resolvedRequests.set(context, new Set([moduleURL]));
	      } else {
	        updatedResolvedRequestsOfContext.add(moduleURL);
	      }
	    }).finally(() => {
	      const updatedOngoingRequestsOfContext = ongoingRequests.get(context);

	      if (updatedOngoingRequestsOfContext !== undefined) {
	        updatedOngoingRequestsOfContext.delete(moduleURL);
	      }
	    });
	    return promise;
	  };
	};

	const getValueForKey = (map, key) => {
	  const value = map.get(key);

	  if (value === undefined) {
	    throw new Error('A value with the given key could not be found.');
	  }

	  return value;
	};

	const pickElementFromSet = (set, predicate) => {
	  const matchingElements = Array.from(set).filter(predicate);

	  if (matchingElements.length > 1) {
	    throw Error('More than one element was found.');
	  }

	  if (matchingElements.length === 0) {
	    throw Error('No element was found.');
	  }

	  const [matchingElement] = matchingElements;
	  set.delete(matchingElement);
	  return matchingElement;
	};

	const deletePassiveInputConnectionToAudioNode = (passiveInputs, source, output, input) => {
	  const passiveInputConnections = getValueForKey(passiveInputs, source);
	  const matchingConnection = pickElementFromSet(passiveInputConnections, passiveInputConnection => passiveInputConnection[0] === output && passiveInputConnection[1] === input);

	  if (passiveInputConnections.size === 0) {
	    passiveInputs.delete(source);
	  }

	  return matchingConnection;
	};

	const getEventListenersOfAudioNode = audioNode => {
	  return getValueForKey(EVENT_LISTENERS, audioNode);
	};

	const setInternalStateToActive = audioNode => {
	  if (ACTIVE_AUDIO_NODE_STORE.has(audioNode)) {
	    throw new Error('The AudioNode is already stored.');
	  }

	  ACTIVE_AUDIO_NODE_STORE.add(audioNode);
	  getEventListenersOfAudioNode(audioNode).forEach(eventListener => eventListener(true));
	};

	const isAudioWorkletNode = audioNode => {
	  return 'port' in audioNode;
	};

	const setInternalStateToPassive = audioNode => {
	  if (!ACTIVE_AUDIO_NODE_STORE.has(audioNode)) {
	    throw new Error('The AudioNode is not stored.');
	  }

	  ACTIVE_AUDIO_NODE_STORE.delete(audioNode);
	  getEventListenersOfAudioNode(audioNode).forEach(eventListener => eventListener(false));
	};

	const setInternalStateToPassiveWhenNecessary = (audioNode, activeInputs) => {
	  if (!isAudioWorkletNode(audioNode) && activeInputs.every(connections => connections.size === 0)) {
	    setInternalStateToPassive(audioNode);
	  }
	};

	const createAddConnectionToAudioNode = (addActiveInputConnectionToAudioNode, addPassiveInputConnectionToAudioNode, connectNativeAudioNodeToNativeAudioNode, deleteActiveInputConnectionToAudioNode, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getAudioNodeTailTime, getEventListenersOfAudioNode, getNativeAudioNode, insertElementInSet, isActiveAudioNode, isPartOfACycle, isPassiveAudioNode) => {
	  const tailTimeTimeoutIds = new WeakMap();
	  return (source, destination, output, input, isOffline) => {
	    const {
	      activeInputs,
	      passiveInputs
	    } = getAudioNodeConnections(destination);
	    const {
	      outputs
	    } = getAudioNodeConnections(source);
	    const eventListeners = getEventListenersOfAudioNode(source);

	    const eventListener = isActive => {
	      const nativeDestinationAudioNode = getNativeAudioNode(destination);
	      const nativeSourceAudioNode = getNativeAudioNode(source);

	      if (isActive) {
	        const partialConnection = deletePassiveInputConnectionToAudioNode(passiveInputs, source, output, input);
	        addActiveInputConnectionToAudioNode(activeInputs, source, partialConnection, false);

	        if (!isOffline && !isPartOfACycle(source)) {
	          connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
	        }

	        if (isPassiveAudioNode(destination)) {
	          setInternalStateToActive(destination);
	        }
	      } else {
	        const partialConnection = deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input);
	        addPassiveInputConnectionToAudioNode(passiveInputs, input, partialConnection, false);

	        if (!isOffline && !isPartOfACycle(source)) {
	          disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
	        }

	        const tailTime = getAudioNodeTailTime(destination);

	        if (tailTime === 0) {
	          if (isActiveAudioNode(destination)) {
	            setInternalStateToPassiveWhenNecessary(destination, activeInputs);
	          }
	        } else {
	          const tailTimeTimeoutId = tailTimeTimeoutIds.get(destination);

	          if (tailTimeTimeoutId !== undefined) {
	            clearTimeout(tailTimeTimeoutId);
	          }

	          tailTimeTimeoutIds.set(destination, setTimeout(() => {
	            if (isActiveAudioNode(destination)) {
	              setInternalStateToPassiveWhenNecessary(destination, activeInputs);
	            }
	          }, tailTime * 1000));
	        }
	      }
	    };

	    if (insertElementInSet(outputs, [destination, output, input], outputConnection => outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input, true)) {
	      eventListeners.add(eventListener);

	      if (isActiveAudioNode(source)) {
	        addActiveInputConnectionToAudioNode(activeInputs, source, [output, input, eventListener], true);
	      } else {
	        addPassiveInputConnectionToAudioNode(passiveInputs, input, [source, output, eventListener], true);
	      }

	      return true;
	    }

	    return false;
	  };
	};

	const createAddPassiveInputConnectionToAudioNode = insertElementInSet => {
	  return (passiveInputs, input, [source, output, eventListener], ignoreDuplicates) => {
	    const passiveInputConnections = passiveInputs.get(source);

	    if (passiveInputConnections === undefined) {
	      passiveInputs.set(source, new Set([[output, input, eventListener]]));
	    } else {
	      insertElementInSet(passiveInputConnections, [output, input, eventListener], passiveInputConnection => passiveInputConnection[0] === output && passiveInputConnection[1] === input, ignoreDuplicates);
	    }
	  };
	};

	const createAddSilentConnection = createNativeGainNode => {
	  return (nativeContext, nativeAudioScheduledSourceNode) => {
	    const nativeGainNode = createNativeGainNode(nativeContext, {
	      channelCount: 1,
	      channelCountMode: 'explicit',
	      channelInterpretation: 'discrete',
	      gain: 0
	    });
	    nativeAudioScheduledSourceNode.connect(nativeGainNode).connect(nativeContext.destination);

	    const disconnect = () => {
	      nativeAudioScheduledSourceNode.removeEventListener('ended', disconnect);
	      nativeAudioScheduledSourceNode.disconnect(nativeGainNode);
	      nativeGainNode.disconnect();
	    };

	    nativeAudioScheduledSourceNode.addEventListener('ended', disconnect);
	  };
	};

	const createAddUnrenderedAudioWorkletNode = getUnrenderedAudioWorkletNodes => {
	  return (nativeContext, audioWorkletNode) => {
	    getUnrenderedAudioWorkletNodes(nativeContext).add(audioWorkletNode);
	  };
	};

	const isOwnedByContext = (nativeAudioNode, nativeContext) => {
	  return nativeAudioNode.context === nativeContext;
	};

	const testAudioBufferCopyChannelMethodsOutOfBoundsSupport = nativeAudioBuffer => {
	  try {
	    nativeAudioBuffer.copyToChannel(new Float32Array(1), 0, -1);
	  } catch {
	    return false;
	  }

	  return true;
	};

	const createIndexSizeError = () => new DOMException('', 'IndexSizeError');

	const wrapAudioBufferGetChannelDataMethod = audioBuffer => {
	  audioBuffer.getChannelData = (getChannelData => {
	    return channel => {
	      try {
	        return getChannelData.call(audioBuffer, channel);
	      } catch (err) {
	        if (err.code === 12) {
	          throw createIndexSizeError();
	        }

	        throw err;
	      }
	    };
	  })(audioBuffer.getChannelData);
	};

	const DEFAULT_OPTIONS$3 = {
	  numberOfChannels: 1
	};
	const createAudioBufferConstructor = (audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds) => {
	  let nativeOfflineAudioContext = null;
	  return class AudioBuffer {
	    constructor(options) {
	      if (nativeOfflineAudioContextConstructor === null) {
	        throw new Error('Missing the native OfflineAudioContext constructor.');
	      }

	      const {
	        length,
	        numberOfChannels,
	        sampleRate
	      } = { ...DEFAULT_OPTIONS$3,
	        ...options
	      };

	      if (nativeOfflineAudioContext === null) {
	        nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
	      }
	      /*
	       * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
	       * factory function. But since Firefox also supports the constructor everything should be fine.
	       */


	      const audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
	        length,
	        numberOfChannels,
	        sampleRate
	      }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate); // Bug #99: Safari does not throw an error when the numberOfChannels is zero.

	      if (audioBuffer.numberOfChannels === 0) {
	        throw createNotSupportedError();
	      } // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
	      // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.


	      if (typeof audioBuffer.copyFromChannel !== 'function') {
	        wrapAudioBufferCopyChannelMethods(audioBuffer);
	        wrapAudioBufferGetChannelDataMethod(audioBuffer); // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
	      } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, () => testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) {
	        wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
	      }

	      audioBufferStore.add(audioBuffer);
	      /*
	       * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
	       * (Offline)AudioContexts.
	       */

	      return audioBuffer;
	    }

	    static [Symbol.hasInstance](instance) {
	      return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === AudioBuffer.prototype || audioBufferStore.has(instance);
	    }

	  };
	};

	const MOST_NEGATIVE_SINGLE_FLOAT = -3.4028234663852886e38;
	const MOST_POSITIVE_SINGLE_FLOAT = -MOST_NEGATIVE_SINGLE_FLOAT;

	const isActiveAudioNode = audioNode => ACTIVE_AUDIO_NODE_STORE.has(audioNode);

	const DEFAULT_OPTIONS$2 = {
	  buffer: null,
	  channelCount: 2,
	  channelCountMode: 'max',
	  channelInterpretation: 'speakers',
	  // Bug #149: Safari does not yet support the detune AudioParam.
	  loop: false,
	  loopEnd: 0,
	  loopStart: 0,
	  playbackRate: 1
	};
	const createAudioBufferSourceNodeConstructor = (audioNodeConstructor, createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener) => {
	  return class AudioBufferSourceNode extends audioNodeConstructor {
	    constructor(context, options) {
	      const nativeContext = getNativeContext(context);
	      const mergedOptions = { ...DEFAULT_OPTIONS$2,
	        ...options
	      };
	      const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, mergedOptions);
	      const isOffline = isNativeOfflineAudioContext(nativeContext);
	      const audioBufferSourceNodeRenderer = isOffline ? createAudioBufferSourceNodeRenderer() : null;
	      super(context, false, nativeAudioBufferSourceNode, audioBufferSourceNodeRenderer);
	      this._audioBufferSourceNodeRenderer = audioBufferSourceNodeRenderer;
	      this._isBufferNullified = false;
	      this._isBufferSet = mergedOptions.buffer !== null;
	      this._nativeAudioBufferSourceNode = nativeAudioBufferSourceNode;
	      this._onended = null; // Bug #73: Safari does not export the correct values for maxValue and minValue.

	      this._playbackRate = createAudioParam(this, isOffline, nativeAudioBufferSourceNode.playbackRate, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
	    }

	    get buffer() {
	      if (this._isBufferNullified) {
	        return null;
	      }

	      return this._nativeAudioBufferSourceNode.buffer;
	    }

	    set buffer(value) {
	      this._nativeAudioBufferSourceNode.buffer = value; // Bug #72: Only Chrome & Edge do not allow to reassign the buffer yet.

	      if (value !== null) {
	        if (this._isBufferSet) {
	          throw createInvalidStateError();
	        }

	        this._isBufferSet = true;
	      }
	    }

	    get loop() {
	      return this._nativeAudioBufferSourceNode.loop;
	    }

	    set loop(value) {
	      this._nativeAudioBufferSourceNode.loop = value;
	    }

	    get loopEnd() {
	      return this._nativeAudioBufferSourceNode.loopEnd;
	    }

	    set loopEnd(value) {
	      this._nativeAudioBufferSourceNode.loopEnd = value;
	    }

	    get loopStart() {
	      return this._nativeAudioBufferSourceNode.loopStart;
	    }

	    set loopStart(value) {
	      this._nativeAudioBufferSourceNode.loopStart = value;
	    }

	    get onended() {
	      return this._onended;
	    }

	    set onended(value) {
	      const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
	      this._nativeAudioBufferSourceNode.onended = wrappedListener;
	      const nativeOnEnded = this._nativeAudioBufferSourceNode.onended;
	      this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
	    }

	    get playbackRate() {
	      return this._playbackRate;
	    }

	    start(when = 0, offset = 0, duration) {
	      this._nativeAudioBufferSourceNode.start(when, offset, duration);

	      if (this._audioBufferSourceNodeRenderer !== null) {
	        this._audioBufferSourceNodeRenderer.start = duration === undefined ? [when, offset] : [when, offset, duration];
	      }

	      if (this.context.state !== 'closed') {
	        setInternalStateToActive(this);

	        const resetInternalStateToPassive = () => {
	          this._nativeAudioBufferSourceNode.removeEventListener('ended', resetInternalStateToPassive);

	          if (isActiveAudioNode(this)) {
	            setInternalStateToPassive(this);
	          }
	        };

	        this._nativeAudioBufferSourceNode.addEventListener('ended', resetInternalStateToPassive);
	      }
	    }

	    stop(when = 0) {
	      this._nativeAudioBufferSourceNode.stop(when);

	      if (this._audioBufferSourceNodeRenderer !== null) {
	        this._audioBufferSourceNodeRenderer.stop = when;
	      }
	    }

	  };
	};

	const createAudioBufferSourceNodeRendererFactory = (connectAudioParam, createNativeAudioBufferSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode) => {
	  return () => {
	    const renderedNativeAudioBufferSourceNodes = new WeakMap();
	    let start = null;
	    let stop = null;

	    const createAudioBufferSourceNode = async (proxy, nativeOfflineAudioContext) => {
	      let nativeAudioBufferSourceNode = getNativeAudioNode(proxy);
	      /*
	       * If the initially used nativeAudioBufferSourceNode was not constructed on the same OfflineAudioContext it needs to be created
	       * again.
	       */

	      const nativeAudioBufferSourceNodeIsOwnedByContext = isOwnedByContext(nativeAudioBufferSourceNode, nativeOfflineAudioContext);

	      if (!nativeAudioBufferSourceNodeIsOwnedByContext) {
	        const options = {
	          buffer: nativeAudioBufferSourceNode.buffer,
	          channelCount: nativeAudioBufferSourceNode.channelCount,
	          channelCountMode: nativeAudioBufferSourceNode.channelCountMode,
	          channelInterpretation: nativeAudioBufferSourceNode.channelInterpretation,
	          // Bug #149: Safari does not yet support the detune AudioParam.
	          loop: nativeAudioBufferSourceNode.loop,
	          loopEnd: nativeAudioBufferSourceNode.loopEnd,
	          loopStart: nativeAudioBufferSourceNode.loopStart,
	          playbackRate: nativeAudioBufferSourceNode.playbackRate.value
	        };
	        nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, options);

	        if (start !== null) {
	          nativeAudioBufferSourceNode.start(...start);
	        }

	        if (stop !== null) {
	          nativeAudioBufferSourceNode.stop(stop);
	        }
	      }

	      renderedNativeAudioBufferSourceNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode);

	      if (!nativeAudioBufferSourceNodeIsOwnedByContext) {
	        // Bug #149: Safari does not yet support the detune AudioParam.
	        await renderAutomation(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
	      } else {
	        // Bug #149: Safari does not yet support the detune AudioParam.
	        await connectAudioParam(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
	      }

	      await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioBufferSourceNode);
	      return nativeAudioBufferSourceNode;
	    };

	    return {
	      set start(value) {
	        start = value;
	      },

	      set stop(value) {
	        stop = value;
	      },

	      render(proxy, nativeOfflineAudioContext) {
	        const renderedNativeAudioBufferSourceNode = renderedNativeAudioBufferSourceNodes.get(nativeOfflineAudioContext);

	        if (renderedNativeAudioBufferSourceNode !== undefined) {
	          return Promise.resolve(renderedNativeAudioBufferSourceNode);
	        }

	        return createAudioBufferSourceNode(proxy, nativeOfflineAudioContext);
	      }

	    };
	  };
	};

	const isAudioBufferSourceNode = audioNode => {
	  return 'playbackRate' in audioNode;
	};

	const isBiquadFilterNode = audioNode => {
	  return 'frequency' in audioNode && 'gain' in audioNode;
	};

	const isConstantSourceNode = audioNode => {
	  return 'offset' in audioNode;
	};

	const isGainNode = audioNode => {
	  return !('frequency' in audioNode) && 'gain' in audioNode;
	};

	const isOscillatorNode = audioNode => {
	  return 'detune' in audioNode && 'frequency' in audioNode;
	};

	const isStereoPannerNode = audioNode => {
	  return 'pan' in audioNode;
	};

	const getAudioNodeConnections = audioNode => {
	  return getValueForKey(AUDIO_NODE_CONNECTIONS_STORE, audioNode);
	};

	const getAudioParamConnections = audioParam => {
	  return getValueForKey(AUDIO_PARAM_CONNECTIONS_STORE, audioParam);
	};

	const deactivateActiveAudioNodeInputConnections = (audioNode, trace) => {
	  const {
	    activeInputs
	  } = getAudioNodeConnections(audioNode);
	  activeInputs.forEach(connections => connections.forEach(([source]) => {
	    if (!trace.includes(audioNode)) {
	      deactivateActiveAudioNodeInputConnections(source, [...trace, audioNode]);
	    }
	  }));
	  const audioParams = isAudioBufferSourceNode(audioNode) ? [// Bug #149: Safari does not yet support the detune AudioParam.
	  audioNode.playbackRate] : isAudioWorkletNode(audioNode) ? Array.from(audioNode.parameters.values()) : isBiquadFilterNode(audioNode) ? [audioNode.Q, audioNode.detune, audioNode.frequency, audioNode.gain] : isConstantSourceNode(audioNode) ? [audioNode.offset] : isGainNode(audioNode) ? [audioNode.gain] : isOscillatorNode(audioNode) ? [audioNode.detune, audioNode.frequency] : isStereoPannerNode(audioNode) ? [audioNode.pan] : [];

	  for (const audioParam of audioParams) {
	    const audioParamConnections = getAudioParamConnections(audioParam);

	    if (audioParamConnections !== undefined) {
	      audioParamConnections.activeInputs.forEach(([source]) => deactivateActiveAudioNodeInputConnections(source, trace));
	    }
	  }

	  if (isActiveAudioNode(audioNode)) {
	    setInternalStateToPassive(audioNode);
	  }
	};

	const deactivateAudioGraph = context => {
	  deactivateActiveAudioNodeInputConnections(context.destination, []);
	};

	const isValidLatencyHint = latencyHint => {
	  return latencyHint === undefined || typeof latencyHint === 'number' || typeof latencyHint === 'string' && (latencyHint === 'balanced' || latencyHint === 'interactive' || latencyHint === 'playback');
	};

	const createAudioDestinationNodeConstructor = (audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode) => {
	  return class AudioDestinationNode extends audioNodeConstructor {
	    constructor(context, channelCount) {
	      const nativeContext = getNativeContext(context);
	      const isOffline = isNativeOfflineAudioContext(nativeContext);
	      const nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
	      const audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
	      super(context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer);
	      this._isNodeOfNativeOfflineAudioContext = isOffline;
	      this._nativeAudioDestinationNode = nativeAudioDestinationNode;
	    }

	    get channelCount() {
	      return this._nativeAudioDestinationNode.channelCount;
	    }

	    set channelCount(value) {
	      // Bug #52: Chrome, Edge & Safari do not throw an exception at all.
	      // Bug #54: Firefox does throw an IndexSizeError.
	      if (this._isNodeOfNativeOfflineAudioContext) {
	        throw createInvalidStateError();
	      } // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.


	      if (value > this._nativeAudioDestinationNode.maxChannelCount) {
	        throw createIndexSizeError();
	      }

	      this._nativeAudioDestinationNode.channelCount = value;
	    }

	    get channelCountMode() {
	      return this._nativeAudioDestinationNode.channelCountMode;
	    }

	    set channelCountMode(value) {
	      // Bug #53: No browser does throw an exception yet.
	      if (this._isNodeOfNativeOfflineAudioContext) {
	        throw createInvalidStateError();
	      }

	      this._nativeAudioDestinationNode.channelCountMode = value;
	    }

	    get maxChannelCount() {
	      return this._nativeAudioDestinationNode.maxChannelCount;
	    }

	  };
	};

	const createAudioDestinationNodeRenderer = renderInputsOfAudioNode => {
	  const renderedNativeAudioDestinationNodes = new WeakMap();

	  const createAudioDestinationNode = async (proxy, nativeOfflineAudioContext) => {
	    const nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
	    renderedNativeAudioDestinationNodes.set(nativeOfflineAudioContext, nativeAudioDestinationNode);
	    await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
	    return nativeAudioDestinationNode;
	  };

	  return {
	    render(proxy, nativeOfflineAudioContext) {
	      const renderedNativeAudioDestinationNode = renderedNativeAudioDestinationNodes.get(nativeOfflineAudioContext);

	      if (renderedNativeAudioDestinationNode !== undefined) {
	        return Promise.resolve(renderedNativeAudioDestinationNode);
	      }

	      return createAudioDestinationNode(proxy, nativeOfflineAudioContext);
	    }

	  };
	};

	const createAudioListenerFactory = (createAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeScriptProcessorNode, createNotSupportedError, getFirstSample, isNativeOfflineAudioContext, overwriteAccessors) => {
	  return (context, nativeContext) => {
	    const nativeListener = nativeContext.listener; // Bug #117: Only Chrome & Edge support the new interface already.

	    const createFakeAudioParams = () => {
	      const buffer = new Float32Array(1);
	      const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
	        channelCount: 1,
	        channelCountMode: 'explicit',
	        channelInterpretation: 'speakers',
	        numberOfInputs: 9
	      });
	      const isOffline = isNativeOfflineAudioContext(nativeContext);
	      let isScriptProcessorNodeCreated = false;
	      let lastOrientation = [0, 0, -1, 0, 1, 0];
	      let lastPosition = [0, 0, 0];

	      const createScriptProcessorNode = () => {
	        if (isScriptProcessorNodeCreated) {
	          return;
	        }

	        isScriptProcessorNodeCreated = true;
	        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 9, 0); // tslint:disable-next-line:deprecation

	        scriptProcessorNode.onaudioprocess = ({
	          inputBuffer
	        }) => {
	          const orientation = [getFirstSample(inputBuffer, buffer, 0), getFirstSample(inputBuffer, buffer, 1), getFirstSample(inputBuffer, buffer, 2), getFirstSample(inputBuffer, buffer, 3), getFirstSample(inputBuffer, buffer, 4), getFirstSample(inputBuffer, buffer, 5)];

	          if (orientation.some((value, index) => value !== lastOrientation[index])) {
	            nativeListener.setOrientation(...orientation); // tslint:disable-line:deprecation

	            lastOrientation = orientation;
	          }

	          const positon = [getFirstSample(inputBuffer, buffer, 6), getFirstSample(inputBuffer, buffer, 7), getFirstSample(inputBuffer, buffer, 8)];

	          if (positon.some((value, index) => value !== lastPosition[index])) {
	            nativeListener.setPosition(...positon); // tslint:disable-line:deprecation

	            lastPosition = positon;
	          }
	        };

	        channelMergerNode.connect(scriptProcessorNode);
	      };

	      const createSetOrientation = index => value => {
	        if (value !== lastOrientation[index]) {
	          lastOrientation[index] = value;
	          nativeListener.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
	        }
	      };

	      const createSetPosition = index => value => {
	        if (value !== lastPosition[index]) {
	          lastPosition[index] = value;
	          nativeListener.setPosition(...lastPosition); // tslint:disable-line:deprecation
	        }
	      };

	      const createFakeAudioParam = (input, initialValue, setValue) => {
	        const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
	          channelCount: 1,
	          channelCountMode: 'explicit',
	          channelInterpretation: 'discrete',
	          offset: initialValue
	        });
	        constantSourceNode.connect(channelMergerNode, 0, input); // @todo This should be stopped when the context is closed.

	        constantSourceNode.start();
	        Object.defineProperty(constantSourceNode.offset, 'defaultValue', {
	          get() {
	            return initialValue;
	          }

	        });
	        /*
	         * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and
	         * minValue for GainNodes.
	         */

	        const audioParam = createAudioParam({
	          context
	        }, isOffline, constantSourceNode.offset, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
	        overwriteAccessors(audioParam, 'value', get => () => get.call(audioParam), set => value => {
	          try {
	            set.call(audioParam, value);
	          } catch (err) {
	            if (err.code !== 9) {
	              throw err;
	            }
	          }

	          createScriptProcessorNode();

	          if (isOffline) {
	            // Bug #117: Using setOrientation() and setPosition() doesn't work with an OfflineAudioContext.
	            setValue(value);
	          }
	        });

	        audioParam.cancelAndHoldAtTime = (cancelAndHoldAtTime => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = cancelAndHoldAtTime.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.cancelAndHoldAtTime);

	        audioParam.cancelScheduledValues = (cancelScheduledValues => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = cancelScheduledValues.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.cancelScheduledValues);

	        audioParam.exponentialRampToValueAtTime = (exponentialRampToValueAtTime => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = exponentialRampToValueAtTime.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.exponentialRampToValueAtTime);

	        audioParam.linearRampToValueAtTime = (linearRampToValueAtTime => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = linearRampToValueAtTime.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.linearRampToValueAtTime);

	        audioParam.setTargetAtTime = (setTargetAtTime => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = setTargetAtTime.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.setTargetAtTime);

	        audioParam.setValueAtTime = (setValueAtTime => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = setValueAtTime.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.setValueAtTime);

	        audioParam.setValueCurveAtTime = (setValueCurveAtTime => {
	          if (isOffline) {
	            return () => {
	              throw createNotSupportedError();
	            };
	          }

	          return (...args) => {
	            const value = setValueCurveAtTime.apply(audioParam, args);
	            createScriptProcessorNode();
	            return value;
	          };
	        })(audioParam.setValueCurveAtTime);

	        return audioParam;
	      };

	      return {
	        forwardX: createFakeAudioParam(0, 0, createSetOrientation(0)),
	        forwardY: createFakeAudioParam(1, 0, createSetOrientation(1)),
	        forwardZ: createFakeAudioParam(2, -1, createSetOrientation(2)),
	        positionX: createFakeAudioParam(6, 0, createSetPosition(0)),
	        positionY: createFakeAudioParam(7, 0, createSetPosition(1)),
	        positionZ: createFakeAudioParam(8, 0, createSetPosition(2)),
	        upX: createFakeAudioParam(3, 0, createSetOrientation(3)),
	        upY: createFakeAudioParam(4, 1, createSetOrientation(4)),
	        upZ: createFakeAudioParam(5, 0, createSetOrientation(5))
	      };
	    };

	    const {
	      forwardX,
	      forwardY,
	      forwardZ,
	      positionX,
	      positionY,
	      positionZ,
	      upX,
	      upY,
	      upZ
	    } = nativeListener.forwardX === undefined ? createFakeAudioParams() : nativeListener;
	    return {
	      get forwardX() {
	        return forwardX;
	      },

	      get forwardY() {
	        return forwardY;
	      },

	      get forwardZ() {
	        return forwardZ;
	      },

	      get positionX() {
	        return positionX;
	      },

	      get positionY() {
	        return positionY;
	      },

	      get positionZ() {
	        return positionZ;
	      },

	      get upX() {
	        return upX;
	      },

	      get upY() {
	        return upY;
	      },

	      get upZ() {
	        return upZ;
	      }

	    };
	  };
	};

	const isAudioNode = audioNodeOrAudioParam => {
	  return 'context' in audioNodeOrAudioParam;
	};

	const isAudioNodeOutputConnection = outputConnection => {
	  return isAudioNode(outputConnection[0]);
	};

	const insertElementInSet = (set, element, predicate, ignoreDuplicates) => {
	  for (const lmnt of set) {
	    if (predicate(lmnt)) {
	      if (ignoreDuplicates) {
	        return false;
	      }

	      throw Error('The set contains at least one similar element.');
	    }
	  }

	  set.add(element);
	  return true;
	};

	const addActiveInputConnectionToAudioParam = (activeInputs, source, [output, eventListener], ignoreDuplicates) => {
	  insertElementInSet(activeInputs, [source, output, eventListener], activeInputConnection => activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
	};

	const addPassiveInputConnectionToAudioParam = (passiveInputs, [source, output, eventListener], ignoreDuplicates) => {
	  const passiveInputConnections = passiveInputs.get(source);

	  if (passiveInputConnections === undefined) {
	    passiveInputs.set(source, new Set([[output, eventListener]]));
	  } else {
	    insertElementInSet(passiveInputConnections, [output, eventListener], passiveInputConnection => passiveInputConnection[0] === output, ignoreDuplicates);
	  }
	};

	const isNativeAudioNodeFaker = nativeAudioNodeOrNativeAudioNodeFaker => {
	  return 'inputs' in nativeAudioNodeOrNativeAudioNodeFaker;
	};

	const connectNativeAudioNodeToNativeAudioNode = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input) => {
	  if (isNativeAudioNodeFaker(nativeDestinationAudioNode)) {
	    const fakeNativeDestinationAudioNode = nativeDestinationAudioNode.inputs[input];
	    nativeSourceAudioNode.connect(fakeNativeDestinationAudioNode, output, 0);
	    return [fakeNativeDestinationAudioNode, output, 0];
	  }

	  nativeSourceAudioNode.connect(nativeDestinationAudioNode, output, input);
	  return [nativeDestinationAudioNode, output, input];
	};

	const deleteActiveInputConnection = (activeInputConnections, source, output) => {
	  for (const activeInputConnection of activeInputConnections) {
	    if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
	      activeInputConnections.delete(activeInputConnection);
	      return activeInputConnection;
	    }
	  }

	  return null;
	};

	const deleteActiveInputConnectionToAudioParam = (activeInputs, source, output) => {
	  return pickElementFromSet(activeInputs, activeInputConnection => activeInputConnection[0] === source && activeInputConnection[1] === output);
	};

	const deleteEventListenerOfAudioNode = (audioNode, eventListener) => {
	  const eventListeners = getEventListenersOfAudioNode(audioNode);

	  if (!eventListeners.delete(eventListener)) {
	    throw new Error('Missing the expected event listener.');
	  }
	};

	const deletePassiveInputConnectionToAudioParam = (passiveInputs, source, output) => {
	  const passiveInputConnections = getValueForKey(passiveInputs, source);
	  const matchingConnection = pickElementFromSet(passiveInputConnections, passiveInputConnection => passiveInputConnection[0] === output);

	  if (passiveInputConnections.size === 0) {
	    passiveInputs.delete(source);
	  }

	  return matchingConnection;
	};

	const disconnectNativeAudioNodeFromNativeAudioNode = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input) => {
	  if (isNativeAudioNodeFaker(nativeDestinationAudioNode)) {
	    nativeSourceAudioNode.disconnect(nativeDestinationAudioNode.inputs[input], output, 0);
	  } else {
	    nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
	  }
	};

	const getNativeAudioNode = audioNode => {
	  return getValueForKey(AUDIO_NODE_STORE, audioNode);
	};

	const getNativeAudioParam = audioParam => {
	  return getValueForKey(AUDIO_PARAM_STORE, audioParam);
	};

	const isPartOfACycle = audioNode => {
	  return CYCLE_COUNTERS.has(audioNode);
	};

	const isPassiveAudioNode = audioNode => {
	  return !ACTIVE_AUDIO_NODE_STORE.has(audioNode);
	};

	const testAudioNodeDisconnectMethodSupport = (nativeAudioContext, nativeAudioWorkletNodeConstructor) => {
	  return new Promise(resolve => {
	    /*
	     * This bug existed in Safari up until v14.0.2. Since AudioWorklets were not supported in Safari until v14.1 the presence of the
	     * constructor for an AudioWorkletNode can be used here to skip the test.
	     */
	    if (nativeAudioWorkletNodeConstructor !== null) {
	      resolve(true);
	    } else {
	      const analyzer = nativeAudioContext.createScriptProcessor(256, 1, 1); // tslint:disable-line deprecation

	      const dummy = nativeAudioContext.createGain(); // Bug #95: Safari does not play one sample buffers.

	      const ones = nativeAudioContext.createBuffer(1, 2, 44100);
	      const channelData = ones.getChannelData(0);
	      channelData[0] = 1;
	      channelData[1] = 1;
	      const source = nativeAudioContext.createBufferSource();
	      source.buffer = ones;
	      source.loop = true;
	      source.connect(analyzer).connect(nativeAudioContext.destination);
	      source.connect(dummy);
	      source.disconnect(dummy); // tslint:disable-next-line:deprecation

	      analyzer.onaudioprocess = event => {
	        const chnnlDt = event.inputBuffer.getChannelData(0); // tslint:disable-line deprecation

	        if (Array.prototype.some.call(chnnlDt, sample => sample === 1)) {
	          resolve(true);
	        } else {
	          resolve(false);
	        }

	        source.stop();
	        analyzer.onaudioprocess = null; // tslint:disable-line:deprecation

	        source.disconnect(analyzer);
	        analyzer.disconnect(nativeAudioContext.destination);
	      };

	      source.start();
	    }
	  });
	};

	const visitEachAudioNodeOnce = (cycles, visitor) => {
	  const counts = new Map();

	  for (const cycle of cycles) {
	    for (const audioNode of cycle) {
	      const count = counts.get(audioNode);
	      counts.set(audioNode, count === undefined ? 1 : count + 1);
	    }
	  }

	  counts.forEach((count, audioNode) => visitor(audioNode, count));
	};

	const isNativeAudioNode$1 = nativeAudioNodeOrAudioParam => {
	  return 'context' in nativeAudioNodeOrAudioParam;
	};

	const wrapAudioNodeDisconnectMethod = nativeAudioNode => {
	  const connections = new Map();

	  nativeAudioNode.connect = (connect => {
	    // tslint:disable-next-line:invalid-void no-inferrable-types
	    return (destination, output = 0, input = 0) => {
	      const returnValue = isNativeAudioNode$1(destination) ? connect(destination, output, input) : connect(destination, output); // Save the new connection only if the calls to connect above didn't throw an error.

	      const connectionsToDestination = connections.get(destination);

	      if (connectionsToDestination === undefined) {
	        connections.set(destination, [{
	          input,
	          output
	        }]);
	      } else {
	        if (connectionsToDestination.every(connection => connection.input !== input || connection.output !== output)) {
	          connectionsToDestination.push({
	            input,
	            output
	          });
	        }
	      }

	      return returnValue;
	    };
	  })(nativeAudioNode.connect.bind(nativeAudioNode));

	  nativeAudioNode.disconnect = (disconnect => {
	    return (destinationOrOutput, output, input) => {
	      disconnect.apply(nativeAudioNode);

	      if (destinationOrOutput === undefined) {
	        connections.clear();
	      } else if (typeof destinationOrOutput === 'number') {
	        for (const [destination, connectionsToDestination] of connections) {
	          const filteredConnections = connectionsToDestination.filter(connection => connection.output !== destinationOrOutput);

	          if (filteredConnections.length === 0) {
	            connections.delete(destination);
	          } else {
	            connections.set(destination, filteredConnections);
	          }
	        }
	      } else if (connections.has(destinationOrOutput)) {
	        if (output === undefined) {
	          connections.delete(destinationOrOutput);
	        } else {
	          const connectionsToDestination = connections.get(destinationOrOutput);

	          if (connectionsToDestination !== undefined) {
	            const filteredConnections = connectionsToDestination.filter(connection => connection.output !== output && (connection.input !== input || input === undefined));

	            if (filteredConnections.length === 0) {
	              connections.delete(destinationOrOutput);
	            } else {
	              connections.set(destinationOrOutput, filteredConnections);
	            }
	          }
	        }
	      }

	      for (const [destination, connectionsToDestination] of connections) {
	        connectionsToDestination.forEach(connection => {
	          if (isNativeAudioNode$1(destination)) {
	            nativeAudioNode.connect(destination, connection.output, connection.input);
	          } else {
	            nativeAudioNode.connect(destination, connection.output);
	          }
	        });
	      }
	    };
	  })(nativeAudioNode.disconnect);
	};

	const addConnectionToAudioParamOfAudioContext = (source, destination, output, isOffline) => {
	  const {
	    activeInputs,
	    passiveInputs
	  } = getAudioParamConnections(destination);
	  const {
	    outputs
	  } = getAudioNodeConnections(source);
	  const eventListeners = getEventListenersOfAudioNode(source);

	  const eventListener = isActive => {
	    const nativeAudioNode = getNativeAudioNode(source);
	    const nativeAudioParam = getNativeAudioParam(destination);

	    if (isActive) {
	      const partialConnection = deletePassiveInputConnectionToAudioParam(passiveInputs, source, output);
	      addActiveInputConnectionToAudioParam(activeInputs, source, partialConnection, false);

	      if (!isOffline && !isPartOfACycle(source)) {
	        nativeAudioNode.connect(nativeAudioParam, output);
	      }
	    } else {
	      const partialConnection = deleteActiveInputConnectionToAudioParam(activeInputs, source, output);
	      addPassiveInputConnectionToAudioParam(passiveInputs, partialConnection, false);

	      if (!isOffline && !isPartOfACycle(source)) {
	        nativeAudioNode.disconnect(nativeAudioParam, output);
	      }
	    }
	  };

	  if (insertElementInSet(outputs, [destination, output], outputConnection => outputConnection[0] === destination && outputConnection[1] === output, true)) {
	    eventListeners.add(eventListener);

	    if (isActiveAudioNode(source)) {
	      addActiveInputConnectionToAudioParam(activeInputs, source, [output, eventListener], true);
	    } else {
	      addPassiveInputConnectionToAudioParam(passiveInputs, [source, output, eventListener], true);
	    }

	    return true;
	  }

	  return false;
	};

	const deleteInputConnectionOfAudioNode = (source, destination, output, input) => {
	  const {
	    activeInputs,
	    passiveInputs
	  } = getAudioNodeConnections(destination);
	  const activeInputConnection = deleteActiveInputConnection(activeInputs[input], source, output);

	  if (activeInputConnection === null) {
	    const passiveInputConnection = deletePassiveInputConnectionToAudioNode(passiveInputs, source, output, input);
	    return [passiveInputConnection[2], false];
	  }

	  return [activeInputConnection[2], true];
	};

	const deleteInputConnectionOfAudioParam = (source, destination, output) => {
	  const {
	    activeInputs,
	    passiveInputs
	  } = getAudioParamConnections(destination);
	  const activeInputConnection = deleteActiveInputConnection(activeInputs, source, output);

	  if (activeInputConnection === null) {
	    const passiveInputConnection = deletePassiveInputConnectionToAudioParam(passiveInputs, source, output);
	    return [passiveInputConnection[1], false];
	  }

	  return [activeInputConnection[2], true];
	};

	const deleteInputsOfAudioNode = (source, isOffline, destination, output, input) => {
	  const [listener, isActive] = deleteInputConnectionOfAudioNode(source, destination, output, input);

	  if (listener !== null) {
	    deleteEventListenerOfAudioNode(source, listener);

	    if (isActive && !isOffline && !isPartOfACycle(source)) {
	      disconnectNativeAudioNodeFromNativeAudioNode(getNativeAudioNode(source), getNativeAudioNode(destination), output, input);
	    }
	  }

	  if (isActiveAudioNode(destination)) {
	    const {
	      activeInputs
	    } = getAudioNodeConnections(destination);
	    setInternalStateToPassiveWhenNecessary(destination, activeInputs);
	  }
	};

	const deleteInputsOfAudioParam = (source, isOffline, destination, output) => {
	  const [listener, isActive] = deleteInputConnectionOfAudioParam(source, destination, output);

	  if (listener !== null) {
	    deleteEventListenerOfAudioNode(source, listener);

	    if (isActive && !isOffline && !isPartOfACycle(source)) {
	      getNativeAudioNode(source).disconnect(getNativeAudioParam(destination), output);
	    }
	  }
	};

	const deleteAnyConnection = (source, isOffline) => {
	  const audioNodeConnectionsOfSource = getAudioNodeConnections(source);
	  const destinations = [];

	  for (const outputConnection of audioNodeConnectionsOfSource.outputs) {
	    if (isAudioNodeOutputConnection(outputConnection)) {
	      deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
	    } else {
	      deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
	    }

	    destinations.push(outputConnection[0]);
	  }

	  audioNodeConnectionsOfSource.outputs.clear();
	  return destinations;
	};

	const deleteConnectionAtOutput = (source, isOffline, output) => {
	  const audioNodeConnectionsOfSource = getAudioNodeConnections(source);
	  const destinations = [];

	  for (const outputConnection of audioNodeConnectionsOfSource.outputs) {
	    if (outputConnection[1] === output) {
	      if (isAudioNodeOutputConnection(outputConnection)) {
	        deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
	      } else {
	        deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
	      }

	      destinations.push(outputConnection[0]);
	      audioNodeConnectionsOfSource.outputs.delete(outputConnection);
	    }
	  }

	  return destinations;
	};

	const deleteConnectionToDestination = (source, isOffline, destination, output, input) => {
	  const audioNodeConnectionsOfSource = getAudioNodeConnections(source);
	  return Array.from(audioNodeConnectionsOfSource.outputs).filter(outputConnection => outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input)).map(outputConnection => {
	    if (isAudioNodeOutputConnection(outputConnection)) {
	      deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
	    } else {
	      deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
	    }

	    audioNodeConnectionsOfSource.outputs.delete(outputConnection);
	    return outputConnection[0];
	  });
	};

	const createAudioNodeConstructor = (addAudioNodeConnections, addConnectionToAudioNode, cacheTestResult, createIncrementCycleCounter, createIndexSizeError, createInvalidAccessError, createNotSupportedError, decrementCycleCounter, detectCycles, eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor) => {
	  return class AudioNode extends eventTargetConstructor {
	    constructor(context, isActive, nativeAudioNode, audioNodeRenderer) {
	      super(nativeAudioNode);
	      this._context = context;
	      this._nativeAudioNode = nativeAudioNode;
	      const nativeContext = getNativeContext(context); // Bug #12: Safari does not support to disconnect a specific destination.

	      if (isNativeAudioContext(nativeContext) && true !== cacheTestResult(testAudioNodeDisconnectMethodSupport, () => {
	        return testAudioNodeDisconnectMethodSupport(nativeContext, nativeAudioWorkletNodeConstructor);
	      })) {
	        wrapAudioNodeDisconnectMethod(nativeAudioNode);
	      }

	      AUDIO_NODE_STORE.set(this, nativeAudioNode);
	      EVENT_LISTENERS.set(this, new Set());

	      if (context.state !== 'closed' && isActive) {
	        setInternalStateToActive(this);
	      }

	      addAudioNodeConnections(this, audioNodeRenderer, nativeAudioNode);
	    }

	    get channelCount() {
	      return this._nativeAudioNode.channelCount;
	    }

	    set channelCount(value) {
	      this._nativeAudioNode.channelCount = value;
	    }

	    get channelCountMode() {
	      return this._nativeAudioNode.channelCountMode;
	    }

	    set channelCountMode(value) {
	      this._nativeAudioNode.channelCountMode = value;
	    }

	    get channelInterpretation() {
	      return this._nativeAudioNode.channelInterpretation;
	    }

	    set channelInterpretation(value) {
	      this._nativeAudioNode.channelInterpretation = value;
	    }

	    get context() {
	      return this._context;
	    }

	    get numberOfInputs() {
	      return this._nativeAudioNode.numberOfInputs;
	    }

	    get numberOfOutputs() {
	      return this._nativeAudioNode.numberOfOutputs;
	    } // tslint:disable-next-line:invalid-void


	    connect(destination, output = 0, input = 0) {
	      // Bug #174: Safari does expose a wrong numberOfOutputs for MediaStreamAudioDestinationNodes.
	      if (output < 0 || output >= this._nativeAudioNode.numberOfOutputs) {
	        throw createIndexSizeError();
	      }

	      const nativeContext = getNativeContext(this._context);
	      const isOffline = isNativeOfflineAudioContext(nativeContext);

	      if (isNativeAudioNode(destination) || isNativeAudioParam(destination)) {
	        throw createInvalidAccessError();
	      }

	      if (isAudioNode(destination)) {
	        const nativeDestinationAudioNode = getNativeAudioNode(destination);

	        try {
	          const connection = connectNativeAudioNodeToNativeAudioNode(this._nativeAudioNode, nativeDestinationAudioNode, output, input);
	          const isPassive = isPassiveAudioNode(this);

	          if (isOffline || isPassive) {
	            this._nativeAudioNode.disconnect(...connection);
	          }

	          if (this.context.state !== 'closed' && !isPassive && isPassiveAudioNode(destination)) {
	            setInternalStateToActive(destination);
	          }
	        } catch (err) {
	          // Bug #41: Safari does not throw the correct exception so far.
	          if (err.code === 12) {
	            throw createInvalidAccessError();
	          }

	          throw err;
	        }

	        const isNewConnectionToAudioNode = addConnectionToAudioNode(this, destination, output, input, isOffline); // Bug #164: Only Firefox detects cycles so far.

	        if (isNewConnectionToAudioNode) {
	          const cycles = detectCycles([this], destination);
	          visitEachAudioNodeOnce(cycles, createIncrementCycleCounter(isOffline));
	        }

	        return destination;
	      }

	      const nativeAudioParam = getNativeAudioParam(destination);
	      /*
	       * Bug #73, #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
	       * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
	       * Safari. In addition to that the maxValue property is used to only detect the affected versions below v14.0.2.
	       */

	      if (nativeAudioParam.name === 'playbackRate' && nativeAudioParam.maxValue === 1024) {
	        throw createNotSupportedError();
	      }

	      try {
	        this._nativeAudioNode.connect(nativeAudioParam, output);

	        if (isOffline || isPassiveAudioNode(this)) {
	          this._nativeAudioNode.disconnect(nativeAudioParam, output);
	        }
	      } catch (err) {
	        // Bug #58: Safari doesn't throw an InvalidAccessError yet.
	        if (err.code === 12) {
	          throw createInvalidAccessError();
	        }

	        throw err;
	      }

	      const isNewConnectionToAudioParam = addConnectionToAudioParamOfAudioContext(this, destination, output, isOffline); // Bug #164: Only Firefox detects cycles so far.

	      if (isNewConnectionToAudioParam) {
	        const cycles = detectCycles([this], destination);
	        visitEachAudioNodeOnce(cycles, createIncrementCycleCounter(isOffline));
	      }
	    }

	    disconnect(destinationOrOutput, output, input) {
	      let destinations;
	      const nativeContext = getNativeContext(this._context);
	      const isOffline = isNativeOfflineAudioContext(nativeContext);

	      if (destinationOrOutput === undefined) {
	        destinations = deleteAnyConnection(this, isOffline);
	      } else if (typeof destinationOrOutput === 'number') {
	        if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) {
	          throw createIndexSizeError();
	        }

	        destinations = deleteConnectionAtOutput(this, isOffline, destinationOrOutput);
	      } else {
	        if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) {
	          throw createIndexSizeError();
	        }

	        if (isAudioNode(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) {
	          throw createIndexSizeError();
	        }

	        destinations = deleteConnectionToDestination(this, isOffline, destinationOrOutput, output, input);

	        if (destinations.length === 0) {
	          throw createInvalidAccessError();
	        }
	      } // Bug #164: Only Firefox detects cycles so far.


	      for (const destination of destinations) {
	        const cycles = detectCycles([this], destination);
	        visitEachAudioNodeOnce(cycles, decrementCycleCounter);
	      }
	    }

	  };
	};

	const createAudioParamFactory = (addAudioParamConnections, audioParamAudioNodeStore, audioParamStore, createAudioParamRenderer, createCancelAndHoldAutomationEvent, createCancelScheduledValuesAutomationEvent, createExponentialRampToValueAutomationEvent, createLinearRampToValueAutomationEvent, createSetTargetAutomationEvent, createSetValueAutomationEvent, createSetValueCurveAutomationEvent, nativeAudioContextConstructor, setValueAtTimeUntilPossible) => {
	  return (audioNode, isAudioParamOfOfflineAudioContext, nativeAudioParam, maxValue = null, minValue = null) => {
	    const automationEventList = new bundle$1.AutomationEventList(nativeAudioParam.defaultValue);
	    const audioParamRenderer = isAudioParamOfOfflineAudioContext ? createAudioParamRenderer(automationEventList) : null;
	    const audioParam = {
	      get defaultValue() {
	        return nativeAudioParam.defaultValue;
	      },

	      get maxValue() {
	        return maxValue === null ? nativeAudioParam.maxValue : maxValue;
	      },

	      get minValue() {
	        return minValue === null ? nativeAudioParam.minValue : minValue;
	      },

	      get value() {
	        return nativeAudioParam.value;
	      },

	      set value(value) {
	        nativeAudioParam.value = value; // Bug #98: Firefox & Safari do not yet treat the value setter like a call to setValueAtTime().

	        audioParam.setValueAtTime(value, audioNode.context.currentTime);
	      },

	      cancelAndHoldAtTime(cancelTime) {
	        // Bug #28: Firefox & Safari do not yet implement cancelAndHoldAtTime().
	        if (typeof nativeAudioParam.cancelAndHoldAtTime === 'function') {
	          if (audioParamRenderer === null) {
	            automationEventList.flush(audioNode.context.currentTime);
	          }

	          automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
	          nativeAudioParam.cancelAndHoldAtTime(cancelTime);
	        } else {
	          const previousLastEvent = Array.from(automationEventList).pop();

	          if (audioParamRenderer === null) {
	            automationEventList.flush(audioNode.context.currentTime);
	          }

	          automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
	          const currentLastEvent = Array.from(automationEventList).pop();
	          nativeAudioParam.cancelScheduledValues(cancelTime);

	          if (previousLastEvent !== currentLastEvent && currentLastEvent !== undefined) {
	            if (currentLastEvent.type === 'exponentialRampToValue') {
	              nativeAudioParam.exponentialRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
	            } else if (currentLastEvent.type === 'linearRampToValue') {
	              nativeAudioParam.linearRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
	            } else if (currentLastEvent.type === 'setValue') {
	              nativeAudioParam.setValueAtTime(currentLastEvent.value, currentLastEvent.startTime);
	            } else if (currentLastEvent.type === 'setValueCurve') {
	              nativeAudioParam.setValueCurveAtTime(currentLastEvent.values, currentLastEvent.startTime, currentLastEvent.duration);
	            }
	          }
	        }

	        return audioParam;
	      },

	      cancelScheduledValues(cancelTime) {
	        if (audioParamRenderer === null) {
	          automationEventList.flush(audioNode.context.currentTime);
	        }

	        automationEventList.add(createCancelScheduledValuesAutomationEvent(cancelTime));
	        nativeAudioParam.cancelScheduledValues(cancelTime);
	        return audioParam;
	      },

	      exponentialRampToValueAtTime(value, endTime) {
	        // Bug #45: Safari does not throw an error yet.
	        if (value === 0) {
	          throw new RangeError();
	        } // Bug #187: Safari does not throw an error yet.


	        if (!Number.isFinite(endTime) || endTime < 0) {
	          throw new RangeError();
	        }

	        if (audioParamRenderer === null) {
	          automationEventList.flush(audioNode.context.currentTime);
	        }

	        automationEventList.add(createExponentialRampToValueAutomationEvent(value, endTime));
	        nativeAudioParam.exponentialRampToValueAtTime(value, endTime);
	        return audioParam;
	      },

	      linearRampToValueAtTime(value, endTime) {
	        if (audioParamRenderer === null) {
	          automationEventList.flush(audioNode.context.currentTime);
	        }

	        automationEventList.add(createLinearRampToValueAutomationEvent(value, endTime));
	        nativeAudioParam.linearRampToValueAtTime(value, endTime);
	        return audioParam;
	      },

	      setTargetAtTime(target, startTime, timeConstant) {
	        if (audioParamRenderer === null) {
	          automationEventList.flush(audioNode.context.currentTime);
	        }

	        automationEventList.add(createSetTargetAutomationEvent(target, startTime, timeConstant));
	        nativeAudioParam.setTargetAtTime(target, startTime, timeConstant);
	        return audioParam;
	      },

	      setValueAtTime(value, startTime) {
	        if (audioParamRenderer === null) {
	          automationEventList.flush(audioNode.context.currentTime);
	        }

	        automationEventList.add(createSetValueAutomationEvent(value, startTime));
	        nativeAudioParam.setValueAtTime(value, startTime);
	        return audioParam;
	      },

	      setValueCurveAtTime(values, startTime, duration) {
	        // Bug 183: Safari only accepts a Float32Array.
	        const convertedValues = values instanceof Float32Array ? values : new Float32Array(values);
	        /*
	         * Bug #152: Safari does not correctly interpolate the values of the curve.
	         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the
	         * existence of the webkitAudioContext is used as a workaround here.
	         */

	        if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') {
	          const endTime = startTime + duration;
	          const sampleRate = audioNode.context.sampleRate;
	          const firstSample = Math.ceil(startTime * sampleRate);
	          const lastSample = Math.floor(endTime * sampleRate);
	          const numberOfInterpolatedValues = lastSample - firstSample;
	          const interpolatedValues = new Float32Array(numberOfInterpolatedValues);

	          for (let i = 0; i < numberOfInterpolatedValues; i += 1) {
	            const theoreticIndex = (convertedValues.length - 1) / duration * ((firstSample + i) / sampleRate - startTime);
	            const lowerIndex = Math.floor(theoreticIndex);
	            const upperIndex = Math.ceil(theoreticIndex);
	            interpolatedValues[i] = lowerIndex === upperIndex ? convertedValues[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * convertedValues[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * convertedValues[upperIndex];
	          }

	          if (audioParamRenderer === null) {
	            automationEventList.flush(audioNode.context.currentTime);
	          }

	          automationEventList.add(createSetValueCurveAutomationEvent(interpolatedValues, startTime, duration));
	          nativeAudioParam.setValueCurveAtTime(interpolatedValues, startTime, duration);
	          const timeOfLastSample = lastSample / sampleRate;

	          if (timeOfLastSample < endTime) {
	            setValueAtTimeUntilPossible(audioParam, interpolatedValues[interpolatedValues.length - 1], timeOfLastSample);
	          }

	          setValueAtTimeUntilPossible(audioParam, convertedValues[convertedValues.length - 1], endTime);
	        } else {
	          if (audioParamRenderer === null) {
	            automationEventList.flush(audioNode.context.currentTime);
	          }

	          automationEventList.add(createSetValueCurveAutomationEvent(convertedValues, startTime, duration));
	          nativeAudioParam.setValueCurveAtTime(convertedValues, startTime, duration);
	        }

	        return audioParam;
	      }

	    };
	    audioParamStore.set(audioParam, nativeAudioParam);
	    audioParamAudioNodeStore.set(audioParam, audioNode);
	    addAudioParamConnections(audioParam, audioParamRenderer);
	    return audioParam;
	  };
	};

	const createAudioParamRenderer = automationEventList => {
	  return {
	    replay(audioParam) {
	      for (const automationEvent of automationEventList) {
	        if (automationEvent.type === 'exponentialRampToValue') {
	          const {
	            endTime,
	            value
	          } = automationEvent;
	          audioParam.exponentialRampToValueAtTime(value, endTime);
	        } else if (automationEvent.type === 'linearRampToValue') {
	          const {
	            endTime,
	            value
	          } = automationEvent;
	          audioParam.linearRampToValueAtTime(value, endTime);
	        } else if (automationEvent.type === 'setTarget') {
	          const {
	            startTime,
	            target,
	            timeConstant
	          } = automationEvent;
	          audioParam.setTargetAtTime(target, startTime, timeConstant);
	        } else if (automationEvent.type === 'setValue') {
	          const {
	            startTime,
	            value
	          } = automationEvent;
	          audioParam.setValueAtTime(value, startTime);
	        } else if (automationEvent.type === 'setValueCurve') {
	          const {
	            duration,
	            startTime,
	            values
	          } = automationEvent;
	          audioParam.setValueCurveAtTime(values, startTime, duration);
	        } else {
	          throw new Error("Can't apply an unknown automation.");
	        }
	      }
	    }

	  };
	};

	class ReadOnlyMap {
	  constructor(parameters) {
	    this._map = new Map(parameters);
	  }

	  get size() {
	    return this._map.size;
	  }

	  entries() {
	    return this._map.entries();
	  }

	  forEach(callback, thisArg = null) {
	    return this._map.forEach((value, key) => callback.call(thisArg, value, key, this));
	  }

	  get(name) {
	    return this._map.get(name);
	  }

	  has(name) {
	    return this._map.has(name);
	  }

	  keys() {
	    return this._map.keys();
	  }

	  values() {
	    return this._map.values();
	  }

	}

	const DEFAULT_OPTIONS$1 = {
	  channelCount: 2,
	  // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
	  channelCountMode: 'explicit',
	  channelInterpretation: 'speakers',
	  numberOfInputs: 1,
	  numberOfOutputs: 1,
	  parameterData: {},
	  processorOptions: {}
	};
	const createAudioWorkletNodeConstructor = (addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener) => {
	  return class AudioWorkletNode extends audioNodeConstructor {
	    constructor(context, name, options) {
	      var _a;

	      const nativeContext = getNativeContext(context);
	      const isOffline = isNativeOfflineAudioContext(nativeContext);
	      const mergedOptions = sanitizeAudioWorkletNodeOptions({ ...DEFAULT_OPTIONS$1,
	        ...options
	      }); // Bug #191: Safari doesn't throw an error if the options aren't clonable.

	      testAudioWorkletNodeOptionsClonability(mergedOptions);
	      const nodeNameToProcessorConstructorMap = NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS.get(nativeContext);
	      const processorConstructor = nodeNameToProcessorConstructorMap === null || nodeNameToProcessorConstructorMap === void 0 ? void 0 : nodeNameToProcessorConstructorMap.get(name); // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.

	      const nativeContextOrBackupOfflineAudioContext = isOffline || nativeContext.state !== 'closed' ? nativeContext : (_a = getBackupOfflineAudioContext(nativeContext)) !== null && _a !== void 0 ? _a : nativeContext;
	      const nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContextOrBackupOfflineAudioContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, mergedOptions);
	      const audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorConstructor) : null;
	      /*
	       * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
	       * returns false.
	       */

	      super(context, true, nativeAudioWorkletNode, audioWorkletNodeRenderer);
	      const parameters = [];
	      nativeAudioWorkletNode.parameters.forEach((nativeAudioParam, nm) => {
	        const audioParam = createAudioParam(this, isOffline, nativeAudioParam);
	        parameters.push([nm, audioParam]);
	      });
	      this._nativeAudioWorkletNode = nativeAudioWorkletNode;
	      this._onprocessorerror = null;
	      this._parameters = new ReadOnlyMap(parameters);
	      /*
	       * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to
	       * the destination.
	       */

	      if (isOffline) {
	        addUnrenderedAudioWorkletNode(nativeContext, this);
	      }

	      const {
	        activeInputs
	      } = getAudioNodeConnections(this);
	      setActiveAudioWorkletNodeInputs(nativeAudioWorkletNode, activeInputs);
	    }

	    get onprocessorerror() {
	      return this._onprocessorerror;
	    }

	    set onprocessorerror(value) {
	      const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
	      this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
	      const nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
	      this._onprocessorerror = nativeOnProcessorError !== null && nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
	    }

	    get parameters() {
	      if (this._parameters === null) {
	        // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
	        return this._nativeAudioWorkletNode.parameters;
	      }

	      return this._parameters;
	    }

	    get port() {
	      return this._nativeAudioWorkletNode.port;
	    }

	  };
	};

	function copyFromChannel(audioBuffer, // @todo There is currently no way to define something like { [ key: number | string ]: Float32Array }
	parent, key, channelNumber, bufferOffset) {
	  if (typeof audioBuffer.copyFromChannel === 'function') {
	    // The byteLength will be 0 when the ArrayBuffer was transferred.
	    if (parent[key].byteLength === 0) {
	      parent[key] = new Float32Array(128);
	    }

	    audioBuffer.copyFromChannel(parent[key], channelNumber, bufferOffset); // Bug #5: Safari does not support copyFromChannel().
	  } else {
	    const channelData = audioBuffer.getChannelData(channelNumber); // The byteLength will be 0 when the ArrayBuffer was transferred.

	    if (parent[key].byteLength === 0) {
	      parent[key] = channelData.slice(bufferOffset, bufferOffset + 128);
	    } else {
	      const slicedInput = new Float32Array(channelData.buffer, bufferOffset * Float32Array.BYTES_PER_ELEMENT, 128);
	      parent[key].set(slicedInput);
	    }
	  }
	}

	const copyToChannel = (audioBuffer, parent, key, channelNumber, bufferOffset) => {
	  if (typeof audioBuffer.copyToChannel === 'function') {
	    // The byteLength will be 0 when the ArrayBuffer was transferred.
	    if (parent[key].byteLength !== 0) {
	      audioBuffer.copyToChannel(parent[key], channelNumber, bufferOffset);
	    } // Bug #5: Safari does not support copyToChannel().

	  } else {
	    // The byteLength will be 0 when the ArrayBuffer was transferred.
	    if (parent[key].byteLength !== 0) {
	      audioBuffer.getChannelData(channelNumber).set(parent[key], bufferOffset);
	    }
	  }
	};

	const createNestedArrays = (x, y) => {
	  const arrays = [];

	  for (let i = 0; i < x; i += 1) {
	    const array = [];
	    const length = typeof y === 'number' ? y : y[i];

	    for (let j = 0; j < length; j += 1) {
	      array.push(new Float32Array(128));
	    }

	    arrays.push(array);
	  }

	  return arrays;
	};

	const getAudioWorkletProcessor = (nativeOfflineAudioContext, proxy) => {
	  const nodeToProcessorMap = getValueForKey(NODE_TO_PROCESSOR_MAPS, nativeOfflineAudioContext);
	  const nativeAudioWorkletNode = getNativeAudioNode(proxy);
	  return getValueForKey(nodeToProcessorMap, nativeAudioWorkletNode);
	};

	const processBuffer = async (proxy, renderedBuffer, nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime) => {
	  // Ceil the length to the next full render quantum.
	  // Bug #17: Safari does not yet expose the length.
	  const length = renderedBuffer === null ? Math.ceil(proxy.context.length / 128) * 128 : renderedBuffer.length;
	  const numberOfInputChannels = options.channelCount * options.numberOfInputs;
	  const numberOfOutputChannels = outputChannelCount.reduce((sum, value) => sum + value, 0);
	  const processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, nativeOfflineAudioContext.sampleRate);

	  if (processorConstructor === undefined) {
	    throw new Error('Missing the processor constructor.');
	  }

	  const audioNodeConnections = getAudioNodeConnections(proxy);
	  const audioWorkletProcessor = await getAudioWorkletProcessor(nativeOfflineAudioContext, proxy);
	  const inputs = createNestedArrays(options.numberOfInputs, options.channelCount);
	  const outputs = createNestedArrays(options.numberOfOutputs, outputChannelCount);
	  const parameters = Array.from(proxy.parameters.keys()).reduce((prmtrs, name) => ({ ...prmtrs,
	    [name]: new Float32Array(128)
	  }), {});

	  for (let i = 0; i < length; i += 128) {
	    if (options.numberOfInputs > 0 && renderedBuffer !== null) {
	      for (let j = 0; j < options.numberOfInputs; j += 1) {
	        for (let k = 0; k < options.channelCount; k += 1) {
	          copyFromChannel(renderedBuffer, inputs[j], k, k, i);
	        }
	      }
	    }

	    if (processorConstructor.parameterDescriptors !== undefined && renderedBuffer !== null) {
	      processorConstructor.parameterDescriptors.forEach(({
	        name
	      }, index) => {
	        copyFromChannel(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
	      });
	    }

	    for (let j = 0; j < options.numberOfInputs; j += 1) {
	      for (let k = 0; k < outputChannelCount[j]; k += 1) {
	        // The byteLength will be 0 when the ArrayBuffer was transferred.
	        if (outputs[j][k].byteLength === 0) {
	          outputs[j][k] = new Float32Array(128);
	        }
	      }
	    }

	    try {
	      const potentiallyEmptyInputs = inputs.map((input, index) => {
	        if (audioNodeConnections.activeInputs[index].size === 0) {
	          return [];
	        }

	        return input;
	      });
	      const activeSourceFlag = exposeCurrentFrameAndCurrentTime(i / nativeOfflineAudioContext.sampleRate, nativeOfflineAudioContext.sampleRate, () => audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));

	      if (processedBuffer !== null) {
	        for (let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1) {
	          for (let k = 0; k < outputChannelCount[j]; k += 1) {
	            copyToChannel(processedBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
	          }

	          outputChannelSplitterNodeOutput += outputChannelCount[j];
	        }
	      }

	      if (!activeSourceFlag) {
	        break;
	      }
	    } catch (error) {
	      proxy.dispatchEvent(new ErrorEvent('processorerror', {
	        colno: error.colno,
	        filename: error.filename,
	        lineno: error.lineno,
	        message: error.message
	      }));
	      break;
	    }
	  }

	  return processedBuffer;
	};

	const createAudioWorkletNodeRendererFactory = (connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext) => {
	  return (name, options, processorConstructor) => {
	    const renderedNativeAudioNodes = new WeakMap();
	    let processedBufferPromise = null;

	    const createAudioNode = async (proxy, nativeOfflineAudioContext) => {
	      let nativeAudioWorkletNode = getNativeAudioNode(proxy);
	      let nativeOutputNodes = null;
	      const nativeAudioWorkletNodeIsOwnedByContext = isOwnedByContext(nativeAudioWorkletNode, nativeOfflineAudioContext);
	      const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount); // Bug #61: Only Chrome, Edge & Firefox have an implementation of the AudioWorkletNode yet.

	      if (nativeAudioWorkletNodeConstructor === null) {
	        const numberOfOutputChannels = outputChannelCount.reduce((sum, value) => sum + value, 0);
	        const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
	          channelCount: Math.max(1, numberOfOutputChannels),
	          channelCountMode: 'explicit',
	          channelInterpretation: 'discrete',
	          numberOfOutputs: Math.max(1, numberOfOutputChannels)
	        });
	        const outputChannelMergerNodes = [];

	        for (let i = 0; i < proxy.numberOfOutputs; i += 1) {
	          outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
	            channelCount: 1,
	            channelCountMode: 'explicit',
	            channelInterpretation: 'speakers',
	            numberOfInputs: outputChannelCount[i]
	          }));
	        }

	        const outputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
	          channelCount: options.channelCount,
	          channelCountMode: options.channelCountMode,
	          channelInterpretation: options.channelInterpretation,
	          gain: 1
	        });
	        outputGainNode.connect = connectMultipleOutputs.bind(null, outputChannelMergerNodes);
	        outputGainNode.disconnect = disconnectMultipleOutputs.bind(null, outputChannelMergerNodes);
	        nativeOutputNodes = [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode];
	      } else if (!nativeAudioWorkletNodeIsOwnedByContext) {
	        nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
	      }

	      renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeOutputNodes === null ? nativeAudioWorkletNode : nativeOutputNodes[2]);

	      if (nativeOutputNodes !== null) {
	        if (processedBufferPromise === null) {
	          if (processorConstructor === undefined) {
	            throw new Error('Missing the processor constructor.');
	          }

	          if (nativeOfflineAudioContextConstructor === null) {
	            throw new Error('Missing the native OfflineAudioContext constructor.');
	          } // Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.


	          const numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
	          const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
	          const numberOfChannels = numberOfInputChannels + numberOfParameters;

	          const renderBuffer = async () => {
	            const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(numberOfChannels, // Ceil the length to the next full render quantum.
	            // Bug #17: Safari does not yet expose the length.
	            Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
	            const gainNodes = [];
	            const inputChannelSplitterNodes = [];

	            for (let i = 0; i < options.numberOfInputs; i += 1) {
	              gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
	                channelCount: options.channelCount,
	                channelCountMode: options.channelCountMode,
	                channelInterpretation: options.channelInterpretation,
	                gain: 1
	              }));
	              inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
	                channelCount: options.channelCount,
	                channelCountMode: 'explicit',
	                channelInterpretation: 'discrete',
	                numberOfOutputs: options.channelCount
	              }));
	            }

	            const constantSourceNodes = await Promise.all(Array.from(proxy.parameters.values()).map(async audioParam => {
	              const constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
	                channelCount: 1,
	                channelCountMode: 'explicit',
	                channelInterpretation: 'discrete',
	                offset: audioParam.value
	              });
	              await renderAutomation(partialOfflineAudioContext, audioParam, constantSourceNode.offset);
	              return constantSourceNode;
	            }));
	            const inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
	              channelCount: 1,
	              channelCountMode: 'explicit',
	              channelInterpretation: 'speakers',
	              numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
	            });

	            for (let i = 0; i < options.numberOfInputs; i += 1) {
	              gainNodes[i].connect(inputChannelSplitterNodes[i]);

	              for (let j = 0; j < options.channelCount; j += 1) {
	                inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
	              }
	            }

	            for (const [index, constantSourceNode] of constantSourceNodes.entries()) {
	              constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
	              constantSourceNode.start(0);
	            }

	            inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
	            await Promise.all(gainNodes.map(gainNode => renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode)));
	            return renderNativeOfflineAudioContext(partialOfflineAudioContext);
	          };

	          processedBufferPromise = processBuffer(proxy, numberOfChannels === 0 ? null : await renderBuffer(), nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime);
	        }

	        const processedBuffer = await processedBufferPromise;
	        const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
	          buffer: null,
	          channelCount: 2,
	          channelCountMode: 'max',
	          channelInterpretation: 'speakers',
	          loop: false,
	          loopEnd: 0,
	          loopStart: 0,
	          playbackRate: 1
	        });
	        const [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode] = nativeOutputNodes;

	        if (processedBuffer !== null) {
	          audioBufferSourceNode.buffer = processedBuffer;
	          audioBufferSourceNode.start(0);
	        }

	        audioBufferSourceNode.connect(outputChannelSplitterNode);

	        for (let i = 0, outputChannelSplitterNodeOutput = 0; i < proxy.numberOfOutputs; i += 1) {
	          const outputChannelMergerNode = outputChannelMergerNodes[i];

	          for (let j = 0; j < outputChannelCount[i]; j += 1) {
	            outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
	          }

	          outputChannelSplitterNodeOutput += outputChannelCount[i];
	        }

	        return outputGainNode;
	      }

	      if (!nativeAudioWorkletNodeIsOwnedByContext) {
	        for (const [nm, audioParam] of proxy.parameters.entries()) {
	          await renderAutomation(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
	          nativeAudioWorkletNode.parameters.get(nm));
	        }
	      } else {
	        for (const [nm, audioParam] of proxy.parameters.entries()) {
	          await connectAudioParam(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
	          nativeAudioWorkletNode.parameters.get(nm));
	        }
	      }

	      await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioWorkletNode);
	      return nativeAudioWorkletNode;
	    };

	    return {
	      render(proxy, nativeOfflineAudioContext) {
	        deleteUnrenderedAudioWorkletNode(nativeOfflineAudioContext, proxy);
	        const renderedNativeAudioWorkletNodeOrGainNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);

	        if (renderedNativeAudioWorkletNodeOrGainNode !== undefined) {
	          return Promise.resolve(renderedNativeAudioWorkletNodeOrGainNode);
	        }

	        return createAudioNode(proxy, nativeOfflineAudioContext);
	      }

	    };
	  };
	};

	const createCacheTestResult = (ongoingTests, testResults) => {
	  return (tester, test) => {
	    const cachedTestResult = testResults.get(tester);

	    if (cachedTestResult !== undefined) {
	      return cachedTestResult;
	    }

	    const ongoingTest = ongoingTests.get(tester);

	    if (ongoingTest !== undefined) {
	      return ongoingTest;
	    }

	    try {
	      const synchronousTestResult = test();

	      if (synchronousTestResult instanceof Promise) {
	        ongoingTests.set(tester, synchronousTestResult);
	        return synchronousTestResult.catch(() => false).then(finalTestResult => {
	          ongoingTests.delete(tester);
	          testResults.set(tester, finalTestResult);
	          return finalTestResult;
	        });
	      }

	      testResults.set(tester, synchronousTestResult);
	      return synchronousTestResult;
	    } catch {
	      testResults.set(tester, false);
	      return false;
	    }
	  };
	};

	const createConnectAudioParam = renderInputsOfAudioParam => {
	  return (nativeOfflineAudioContext, audioParam, nativeAudioParam) => {
	    return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
	  };
	};

	const createConnectMultipleOutputs = createIndexSizeError => {
	  return (outputAudioNodes, destination, output = 0, input = 0) => {
	    const outputAudioNode = outputAudioNodes[output];

	    if (outputAudioNode === undefined) {
	      throw createIndexSizeError();
	    }

	    if (isNativeAudioNode$1(destination)) {
	      return outputAudioNode.connect(destination, 0, input);
	    }

	    return outputAudioNode.connect(destination, 0);
	  };
	};

	const DEFAULT_OPTIONS = {
	  channelCount: 2,
	  channelCountMode: 'max',
	  channelInterpretation: 'speakers',
	  offset: 1
	};
	const createConstantSourceNodeConstructor = (audioNodeConstructor, createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener) => {
	  return class ConstantSourceNode extends audioNodeConstructor {
	    constructor(context, options) {
	      const nativeContext = getNativeContext(context);
	      const mergedOptions = { ...DEFAULT_OPTIONS,
	        ...options
	      };
	      const nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
	      const isOffline = isNativeOfflineAudioContext(nativeContext);
	      const constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
	      super(context, false, nativeConstantSourceNode, constantSourceNodeRenderer);
	      this._constantSourceNodeRenderer = constantSourceNodeRenderer;
	      this._nativeConstantSourceNode = nativeConstantSourceNode;
	      /*
	       * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and minValue
	       * for GainNodes.
	       */

	      this._offset = createAudioParam(this, isOffline, nativeConstantSourceNode.offset, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
	      this._onended = null;
	    }

	    get offset() {
	      return this._offset;
	    }

	    get onended() {
	      return this._onended;
	    }

	    set onended(value) {
	      const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
	      this._nativeConstantSourceNode.onended = wrappedListener;
	      const nativeOnEnded = this._nativeConstantSourceNode.onended;
	      this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
	    }

	    start(when = 0) {
	      this._nativeConstantSourceNode.start(when);

	      if (this._constantSourceNodeRenderer !== null) {
	        this._constantSourceNodeRenderer.start = when;
	      }

	      if (this.context.state !== 'closed') {
	        setInternalStateToActive(this);

	        const resetInternalStateToPassive = () => {
	          this._nativeConstantSourceNode.removeEventListener('ended', resetInternalStateToPassive);

	          if (isActiveAudioNode(this)) {
	            setInternalStateToPassive(this);
	          }
	        };

	        this._nativeConstantSourceNode.addEventListener('ended', resetInternalStateToPassive);
	      }
	    }

	    stop(when = 0) {
	      this._nativeConstantSourceNode.stop(when);

	      if (this._constantSourceNodeRenderer !== null) {
	        this._constantSourceNodeRenderer.stop = when;
	      }
	    }

	  };
	};

	const createConstantSourceNodeRendererFactory = (connectAudioParam, createNativeConstantSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode) => {
	  return () => {
	    const renderedNativeConstantSourceNodes = new WeakMap();
	    let start = null;
	    let stop = null;

	    const createConstantSourceNode = async (proxy, nativeOfflineAudioContext) => {
	      let nativeConstantSourceNode = getNativeAudioNode(proxy);
	      /*
	       * If the initially used nativeConstantSourceNode was not constructed on the same OfflineAudioContext it needs to be created
	       * again.
	       */

	      const nativeConstantSourceNodeIsOwnedByContext = isOwnedByContext(nativeConstantSourceNode, nativeOfflineAudioContext);

	      if (!nativeConstantSourceNodeIsOwnedByContext) {
	        const options = {
	          channelCount: nativeConstantSourceNode.channelCount,
	          channelCountMode: nativeConstantSourceNode.channelCountMode,
	          channelInterpretation: nativeConstantSourceNode.channelInterpretation,
	          offset: nativeConstantSourceNode.offset.value
	        };
	        nativeConstantSourceNode = createNativeConstantSourceNode(nativeOfflineAudioContext, options);

	        if (start !== null) {
	          nativeConstantSourceNode.start(start);
	        }

	        if (stop !== null) {
	          nativeConstantSourceNode.stop(stop);
	        }
	      }

	      renderedNativeConstantSourceNodes.set(nativeOfflineAudioContext, nativeConstantSourceNode);

	      if (!nativeConstantSourceNodeIsOwnedByContext) {
	        await renderAutomation(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
	      } else {
	        await connectAudioParam(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
	      }

	      await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConstantSourceNode);
	      return nativeConstantSourceNode;
	    };

	    return {
	      set start(value) {
	        start = value;
	      },

	      set stop(value) {
	        stop = value;
	      },

	      render(proxy, nativeOfflineAudioContext) {
	        const renderedNativeConstantSourceNode = renderedNativeConstantSourceNodes.get(nativeOfflineAudioContext);

	        if (renderedNativeConstantSourceNode !== undefined) {
	          return Promise.resolve(renderedNativeConstantSourceNode);
	        }

	        return createConstantSourceNode(proxy, nativeOfflineAudioContext);
	      }

	    };
	  };
	};

	const createConvertNumberToUnsignedLong = unit32Array => {
	  return value => {
	    unit32Array[0] = value;
	    return unit32Array[0];
	  };
	};

	const createDecrementCycleCounter = (connectNativeAudioNodeToNativeAudioNode, cycleCounters, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, getNativeContext, isActiveAudioNode, isNativeOfflineAudioContext) => {
	  return (audioNode, count) => {
	    const cycleCounter = cycleCounters.get(audioNode);

	    if (cycleCounter === undefined) {
	      throw new Error('Missing the expected cycle count.');
	    }

	    const nativeContext = getNativeContext(audioNode.context);
	    const isOffline = isNativeOfflineAudioContext(nativeContext);

	    if (cycleCounter === count) {
	      cycleCounters.delete(audioNode);

	      if (!isOffline && isActiveAudioNode(audioNode)) {
	        const nativeSourceAudioNode = getNativeAudioNode(audioNode);
	        const {
	          outputs
	        } = getAudioNodeConnections(audioNode);

	        for (const output of outputs) {
	          if (isAudioNodeOutputConnection(output)) {
	            const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
	            connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
	          } else {
	            const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
	            nativeSourceAudioNode.connect(nativeDestinationAudioParam, output[1]);
	          }
	        }
	      }
	    } else {
	      cycleCounters.set(audioNode, cycleCounter - count);
	    }
	  };
	};

	const createDeleteActiveInputConnectionToAudioNode = pickElementFromSet => {
	  return (activeInputs, source, output, input) => {
	    return pickElementFromSet(activeInputs[input], activeInputConnection => activeInputConnection[0] === source && activeInputConnection[1] === output);
	  };
	};

	const createDeleteUnrenderedAudioWorkletNode = getUnrenderedAudioWorkletNodes => {
	  return (nativeContext, audioWorkletNode) => {
	    getUnrenderedAudioWorkletNodes(nativeContext).delete(audioWorkletNode);
	  };
	};

	const isDelayNode = audioNode => {
	  return 'delayTime' in audioNode;
	};

	const createDetectCycles = (audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey) => {
	  return function detectCycles(chain, nextLink) {
	    const audioNode = isAudioNode(nextLink) ? nextLink : getValueForKey(audioParamAudioNodeStore, nextLink);

	    if (isDelayNode(audioNode)) {
	      return [];
	    }

	    if (chain[0] === audioNode) {
	      return [chain];
	    }

	    if (chain.includes(audioNode)) {
	      return [];
	    }

	    const {
	      outputs
	    } = getAudioNodeConnections(audioNode);
	    return Array.from(outputs).map(outputConnection => detectCycles([...chain, audioNode], outputConnection[0])).reduce((mergedCycles, nestedCycles) => mergedCycles.concat(nestedCycles), []);
	  };
	};

	const getOutputAudioNodeAtIndex = (createIndexSizeError, outputAudioNodes, output) => {
	  const outputAudioNode = outputAudioNodes[output];

	  if (outputAudioNode === undefined) {
	    throw createIndexSizeError();
	  }

	  return outputAudioNode;
	};

	const createDisconnectMultipleOutputs = createIndexSizeError => {
	  return (outputAudioNodes, destinationOrOutput = undefined, output = undefined, input = 0) => {
	    if (destinationOrOutput === undefined) {
	      return outputAudioNodes.forEach(outputAudioNode => outputAudioNode.disconnect());
	    }

	    if (typeof destinationOrOutput === 'number') {
	      return getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, destinationOrOutput).disconnect();
	    }

	    if (isNativeAudioNode$1(destinationOrOutput)) {
	      if (output === undefined) {
	        return outputAudioNodes.forEach(outputAudioNode => outputAudioNode.disconnect(destinationOrOutput));
	      }

	      if (input === undefined) {
	        return getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
	      }

	      return getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0, input);
	    }

	    if (output === undefined) {
	      return outputAudioNodes.forEach(outputAudioNode => outputAudioNode.disconnect(destinationOrOutput));
	    }

	    return getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
	  };
	};

	const createEvaluateSource = window => {
	  return source => new Promise((resolve, reject) => {
	    if (window === null) {
	      // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
	      reject(new SyntaxError());
	      return;
	    }

	    const head = window.document.head;

	    if (head === null) {
	      // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
	      reject(new SyntaxError());
	    } else {
	      const script = window.document.createElement('script'); // @todo Safari doesn't like URLs with a type of 'application/javascript; charset=utf-8'.

	      const blob = new Blob([source], {
	        type: 'application/javascript'
	      });
	      const url = URL.createObjectURL(blob);
	      const originalOnErrorHandler = window.onerror;

	      const removeErrorEventListenerAndRevokeUrl = () => {
	        window.onerror = originalOnErrorHandler;
	        URL.revokeObjectURL(url);
	      };

	      window.onerror = (message, src, lineno, colno, error) => {
	        // @todo Edge thinks the source is the one of the html document.
	        if (src === url || src === window.location.href && lineno === 1 && colno === 1) {
	          removeErrorEventListenerAndRevokeUrl();
	          reject(error);
	          return false;
	        }

	        if (originalOnErrorHandler !== null) {
	          return originalOnErrorHandler(message, src, lineno, colno, error);
	        }
	      };

	      script.onerror = () => {
	        removeErrorEventListenerAndRevokeUrl(); // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.

	        reject(new SyntaxError());
	      };

	      script.onload = () => {
	        removeErrorEventListenerAndRevokeUrl();
	        resolve();
	      };

	      script.src = url;
	      script.type = 'module';
	      head.appendChild(script);
	    }
	  });
	};

	const createEventTargetConstructor = wrapEventListener => {
	  return class EventTarget {
	    constructor(_nativeEventTarget) {
	      this._nativeEventTarget = _nativeEventTarget;
	      this._listeners = new WeakMap();
	    }

	    addEventListener(type, listener, options) {
	      if (listener !== null) {
	        let wrappedEventListener = this._listeners.get(listener);

	        if (wrappedEventListener === undefined) {
	          wrappedEventListener = wrapEventListener(this, listener);

	          if (typeof listener === 'function') {
	            this._listeners.set(listener, wrappedEventListener);
	          }
	        }

	        this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
	      }
	    }

	    dispatchEvent(event) {
	      return this._nativeEventTarget.dispatchEvent(event);
	    }

	    removeEventListener(type, listener, options) {
	      const wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);

	      this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
	    }

	  };
	};

	const createExposeCurrentFrameAndCurrentTime = window => {
	  return (currentTime, sampleRate, fn) => {
	    Object.defineProperties(window, {
	      currentFrame: {
	        configurable: true,

	        get() {
	          return Math.round(currentTime * sampleRate);
	        }

	      },
	      currentTime: {
	        configurable: true,

	        get() {
	          return currentTime;
	        }

	      }
	    });

	    try {
	      return fn();
	    } finally {
	      if (window !== null) {
	        delete window.currentFrame;
	        delete window.currentTime;
	      }
	    }
	  };
	};

	const createFetchSource = createAbortError => {
	  return async url => {
	    try {
	      const response = await fetch(url);

	      if (response.ok) {
	        return [await response.text(), response.url];
	      }
	    } catch {// Ignore errors.
	    } // tslint:disable-line:no-empty


	    throw createAbortError();
	  };
	};

	const createGetActiveAudioWorkletNodeInputs = (activeAudioWorkletNodeInputsStore, getValueForKey) => {
	  return nativeAudioWorkletNode => getValueForKey(activeAudioWorkletNodeInputsStore, nativeAudioWorkletNode);
	};

	const createGetAudioNodeRenderer = getAudioNodeConnections => {
	  return audioNode => {
	    const audioNodeConnections = getAudioNodeConnections(audioNode);

	    if (audioNodeConnections.renderer === null) {
	      throw new Error('Missing the renderer of the given AudioNode in the audio graph.');
	    }

	    return audioNodeConnections.renderer;
	  };
	};

	const createGetAudioNodeTailTime = audioNodeTailTimeStore => {
	  return audioNode => {
	    var _a;

	    return (_a = audioNodeTailTimeStore.get(audioNode)) !== null && _a !== void 0 ? _a : 0;
	  };
	};

	const createGetAudioParamRenderer = getAudioParamConnections => {
	  return audioParam => {
	    const audioParamConnections = getAudioParamConnections(audioParam);

	    if (audioParamConnections.renderer === null) {
	      throw new Error('Missing the renderer of the given AudioParam in the audio graph.');
	    }

	    return audioParamConnections.renderer;
	  };
	};

	const createGetBackupOfflineAudioContext = backupOfflineAudioContextStore => {
	  return nativeContext => {
	    return backupOfflineAudioContextStore.get(nativeContext);
	  };
	};

	const createInvalidStateError = () => new DOMException('', 'InvalidStateError');

	const createGetNativeContext = contextStore => {
	  return context => {
	    const nativeContext = contextStore.get(context);

	    if (nativeContext === undefined) {
	      throw createInvalidStateError();
	    }

	    return nativeContext;
	  };
	};

	const createGetOrCreateBackupOfflineAudioContext = (backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor) => {
	  return nativeContext => {
	    let backupOfflineAudioContext = backupOfflineAudioContextStore.get(nativeContext);

	    if (backupOfflineAudioContext !== undefined) {
	      return backupOfflineAudioContext;
	    }

	    if (nativeOfflineAudioContextConstructor === null) {
	      throw new Error('Missing the native OfflineAudioContext constructor.');
	    } // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.


	    backupOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
	    backupOfflineAudioContextStore.set(nativeContext, backupOfflineAudioContext);
	    return backupOfflineAudioContext;
	  };
	};

	const createGetUnrenderedAudioWorkletNodes = unrenderedAudioWorkletNodeStore => {
	  return nativeContext => {
	    const unrenderedAudioWorkletNodes = unrenderedAudioWorkletNodeStore.get(nativeContext);

	    if (unrenderedAudioWorkletNodes === undefined) {
	      throw new Error('The context has no set of AudioWorkletNodes.');
	    }

	    return unrenderedAudioWorkletNodes;
	  };
	};

	const createInvalidAccessError = () => new DOMException('', 'InvalidAccessError');

	const createIncrementCycleCounterFactory = (cycleCounters, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode) => {
	  return isOffline => {
	    return (audioNode, count) => {
	      const cycleCounter = cycleCounters.get(audioNode);

	      if (cycleCounter === undefined) {
	        if (!isOffline && isActiveAudioNode(audioNode)) {
	          const nativeSourceAudioNode = getNativeAudioNode(audioNode);
	          const {
	            outputs
	          } = getAudioNodeConnections(audioNode);

	          for (const output of outputs) {
	            if (isAudioNodeOutputConnection(output)) {
	              const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
	              disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
	            } else {
	              const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
	              nativeSourceAudioNode.disconnect(nativeDestinationAudioParam, output[1]);
	            }
	          }
	        }

	        cycleCounters.set(audioNode, count);
	      } else {
	        cycleCounters.set(audioNode, cycleCounter + count);
	      }
	    };
	  };
	};

	const createIsNativeAudioContext = nativeAudioContextConstructor => {
	  return anything => {
	    return nativeAudioContextConstructor !== null && anything instanceof nativeAudioContextConstructor;
	  };
	};

	const createIsNativeAudioNode = window => {
	  return anything => {
	    return window !== null && typeof window.AudioNode === 'function' && anything instanceof window.AudioNode;
	  };
	};

	const createIsNativeAudioParam = window => {
	  return anything => {
	    return window !== null && typeof window.AudioParam === 'function' && anything instanceof window.AudioParam;
	  };
	};

	const createIsNativeOfflineAudioContext = nativeOfflineAudioContextConstructor => {
	  return anything => {
	    return nativeOfflineAudioContextConstructor !== null && anything instanceof nativeOfflineAudioContextConstructor;
	  };
	};

	const createIsSecureContext = window => window !== null && window.isSecureContext;

	const createMediaStreamAudioSourceNodeConstructor = (audioNodeConstructor, createNativeMediaStreamAudioSourceNode, getNativeContext, isNativeOfflineAudioContext) => {
	  return class MediaStreamAudioSourceNode extends audioNodeConstructor {
	    constructor(context, options) {
	      const nativeContext = getNativeContext(context);
	      const nativeMediaStreamAudioSourceNode = createNativeMediaStreamAudioSourceNode(nativeContext, options); // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.

	      if (isNativeOfflineAudioContext(nativeContext)) {
	        throw new TypeError();
	      }

	      super(context, true, nativeMediaStreamAudioSourceNode, null);
	      this._nativeMediaStreamAudioSourceNode = nativeMediaStreamAudioSourceNode;
	    }

	    get mediaStream() {
	      return this._nativeMediaStreamAudioSourceNode.mediaStream;
	    }

	  };
	};

	const createMinimalAudioContextConstructor = (createInvalidStateError, createNotSupportedError, createUnknownError, minimalBaseAudioContextConstructor, nativeAudioContextConstructor) => {
	  return class MinimalAudioContext extends minimalBaseAudioContextConstructor {
	    constructor(options = {}) {
	      if (nativeAudioContextConstructor === null) {
	        throw new Error('Missing the native AudioContext constructor.');
	      }

	      let nativeAudioContext;

	      try {
	        nativeAudioContext = new nativeAudioContextConstructor(options);
	      } catch (err) {
	        // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
	        if (err.code === 12 && err.message === 'sampleRate is not in range') {
	          throw createNotSupportedError();
	        }

	        throw err;
	      } // Bug #131 Safari returns null when there are four other AudioContexts running already.


	      if (nativeAudioContext === null) {
	        throw createUnknownError();
	      } // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.


	      if (!isValidLatencyHint(options.latencyHint)) {
	        throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
	      } // Bug #150 Safari does not support setting the sampleRate.


	      if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) {
	        throw createNotSupportedError();
	      }

	      super(nativeAudioContext, 2);
	      const {
	        latencyHint
	      } = options;
	      const {
	        sampleRate
	      } = nativeAudioContext; // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.

	      this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate :
	      /*
	       * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
	       * ScriptProcessorNode.
	       */
	      Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
	      this._nativeAudioContext = nativeAudioContext; // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.

	      if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
	        this._nativeGainNode = nativeAudioContext.createGain();
	        this._nativeOscillatorNode = nativeAudioContext.createOscillator();
	        this._nativeGainNode.gain.value = 1e-37;

	        this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);

	        this._nativeOscillatorNode.start();
	      } else {
	        this._nativeGainNode = null;
	        this._nativeOscillatorNode = null;
	      }

	      this._state = null;
	      /*
	       * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
	       * to 'running'.
	       */

	      if (nativeAudioContext.state === 'running') {
	        this._state = 'suspended';

	        const revokeState = () => {
	          if (this._state === 'suspended') {
	            this._state = null;
	          }

	          nativeAudioContext.removeEventListener('statechange', revokeState);
	        };

	        nativeAudioContext.addEventListener('statechange', revokeState);
	      }
	    }

	    get baseLatency() {
	      return this._baseLatency;
	    }

	    get state() {
	      return this._state !== null ? this._state : this._nativeAudioContext.state;
	    }

	    close() {
	      // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
	      if (this.state === 'closed') {
	        return this._nativeAudioContext.close().then(() => {
	          throw createInvalidStateError();
	        });
	      } // Bug #34: If the state was set to suspended before it should be revoked now.


	      if (this._state === 'suspended') {
	        this._state = null;
	      }

	      return this._nativeAudioContext.close().then(() => {
	        if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
	          this._nativeOscillatorNode.stop();

	          this._nativeGainNode.disconnect();

	          this._nativeOscillatorNode.disconnect();
	        }

	        deactivateAudioGraph(this);
	      });
	    }

	    resume() {
	      if (this._state === 'suspended') {
	        return new Promise((resolve, reject) => {
	          const resolvePromise = () => {
	            this._nativeAudioContext.removeEventListener('statechange', resolvePromise);

	            if (this._nativeAudioContext.state === 'running') {
	              resolve();
	            } else {
	              this.resume().then(resolve, reject);
	            }
	          };

	          this._nativeAudioContext.addEventListener('statechange', resolvePromise);
	        });
	      }

	      return this._nativeAudioContext.resume().catch(err => {
	        // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
	        // Bug #56: Safari invokes the catch handler but without an error.
	        if (err === undefined || err.code === 15) {
	          throw createInvalidStateError();
	        }

	        throw err;
	      });
	    }

	    suspend() {
	      return this._nativeAudioContext.suspend().catch(err => {
	        // Bug #56: Safari invokes the catch handler but without an error.
	        if (err === undefined) {
	          throw createInvalidStateError();
	        }

	        throw err;
	      });
	    }

	  };
	};

	const createMinimalBaseAudioContextConstructor = (audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener) => {
	  return class MinimalBaseAudioContext extends eventTargetConstructor {
	    constructor(_nativeContext, numberOfChannels) {
	      super(_nativeContext);
	      this._nativeContext = _nativeContext;
	      CONTEXT_STORE.set(this, _nativeContext);

	      if (isNativeOfflineAudioContext(_nativeContext)) {
	        unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
	      }

	      this._destination = new audioDestinationNodeConstructor(this, numberOfChannels);
	      this._listener = createAudioListener(this, _nativeContext);
	      this._onstatechange = null;
	    }

	    get currentTime() {
	      return this._nativeContext.currentTime;
	    }

	    get destination() {
	      return this._destination;
	    }

	    get listener() {
	      return this._listener;
	    }

	    get onstatechange() {
	      return this._onstatechange;
	    }

	    set onstatechange(value) {
	      const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
	      this._nativeContext.onstatechange = wrappedListener;
	      const nativeOnStateChange = this._nativeContext.onstatechange;
	      this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
	    }

	    get sampleRate() {
	      return this._nativeContext.sampleRate;
	    }

	    get state() {
	      return this._nativeContext.state;
	    }

	  };
	};

	const testPromiseSupport = nativeContext => {
	  // This 12 numbers represent the 48 bytes of an empty WAVE file with a single sample.
	  const uint32Array = new Uint32Array([1179011410, 40, 1163280727, 544501094, 16, 131073, 44100, 176400, 1048580, 1635017060, 4, 0]);

	  try {
	    // Bug #1: Safari requires a successCallback.
	    const promise = nativeContext.decodeAudioData(uint32Array.buffer, () => {// Ignore the success callback.
	    });

	    if (promise === undefined) {
	      return false;
	    }

	    promise.catch(() => {// Ignore rejected errors.
	    });
	    return true;
	  } catch {// Ignore errors.
	  }

	  return false;
	};

	const createMonitorConnections = (insertElementInSet, isNativeAudioNode) => {
	  return (nativeAudioNode, whenConnected, whenDisconnected) => {
	    const connections = new Set();

	    nativeAudioNode.connect = (connect => {
	      // tslint:disable-next-line:invalid-void no-inferrable-types
	      return (destination, output = 0, input = 0) => {
	        const wasDisconnected = connections.size === 0;

	        if (isNativeAudioNode(destination)) {
	          // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
	          connect.call(nativeAudioNode, destination, output, input);
	          insertElementInSet(connections, [destination, output, input], connection => connection[0] === destination && connection[1] === output && connection[2] === input, true);

	          if (wasDisconnected) {
	            whenConnected();
	          }

	          return destination;
	        }

	        connect.call(nativeAudioNode, destination, output);
	        insertElementInSet(connections, [destination, output], connection => connection[0] === destination && connection[1] === output, true);

	        if (wasDisconnected) {
	          whenConnected();
	        }

	        return;
	      };
	    })(nativeAudioNode.connect);

	    nativeAudioNode.disconnect = (disconnect => {
	      return (destinationOrOutput, output, input) => {
	        const wasConnected = connections.size > 0;

	        if (destinationOrOutput === undefined) {
	          disconnect.apply(nativeAudioNode);
	          connections.clear();
	        } else if (typeof destinationOrOutput === 'number') {
	          // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
	          disconnect.call(nativeAudioNode, destinationOrOutput);

	          for (const connection of connections) {
	            if (connection[1] === destinationOrOutput) {
	              connections.delete(connection);
	            }
	          }
	        } else {
	          if (isNativeAudioNode(destinationOrOutput)) {
	            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
	            disconnect.call(nativeAudioNode, destinationOrOutput, output, input);
	          } else {
	            // @todo TypeScript cannot infer the overloaded signature with 2 arguments yet.
	            disconnect.call(nativeAudioNode, destinationOrOutput, output);
	          }

	          for (const connection of connections) {
	            if (connection[0] === destinationOrOutput && (output === undefined || connection[1] === output) && (input === undefined || connection[2] === input)) {
	              connections.delete(connection);
	            }
	          }
	        }

	        const isDisconnected = connections.size === 0;

	        if (wasConnected && isDisconnected) {
	          whenDisconnected();
	        }
	      };
	    })(nativeAudioNode.disconnect);

	    return nativeAudioNode;
	  };
	};

	const assignNativeAudioNodeOption = (nativeAudioNode, options, option) => {
	  const value = options[option];

	  if (value !== undefined && value !== nativeAudioNode[option]) {
	    nativeAudioNode[option] = value;
	  }
	};

	const assignNativeAudioNodeOptions = (nativeAudioNode, options) => {
	  assignNativeAudioNodeOption(nativeAudioNode, options, 'channelCount');
	  assignNativeAudioNodeOption(nativeAudioNode, options, 'channelCountMode');
	  assignNativeAudioNodeOption(nativeAudioNode, options, 'channelInterpretation');
	};

	const createNativeAudioBufferConstructor = window => {
	  if (window === null) {
	    return null;
	  }

	  if (window.hasOwnProperty('AudioBuffer')) {
	    return window.AudioBuffer;
	  }

	  return null;
	};

	const assignNativeAudioNodeAudioParamValue = (nativeAudioNode, options, audioParam) => {
	  const value = options[audioParam];

	  if (value !== undefined && value !== nativeAudioNode[audioParam].value) {
	    nativeAudioNode[audioParam].value = value;
	  }
	};

	const wrapAudioBufferSourceNodeStartMethodConsecutiveCalls = nativeAudioBufferSourceNode => {
	  nativeAudioBufferSourceNode.start = (start => {
	    let isScheduled = false;
	    return (when = 0, offset = 0, duration) => {
	      if (isScheduled) {
	        throw createInvalidStateError();
	      }

	      start.call(nativeAudioBufferSourceNode, when, offset, duration);
	      isScheduled = true;
	    };
	  })(nativeAudioBufferSourceNode.start);
	};

	const wrapAudioScheduledSourceNodeStartMethodNegativeParameters = nativeAudioScheduledSourceNode => {
	  nativeAudioScheduledSourceNode.start = (start => {
	    return (when = 0, offset = 0, duration) => {
	      if (typeof duration === 'number' && duration < 0 || offset < 0 || when < 0) {
	        throw new RangeError("The parameters can't be negative.");
	      } // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.


	      start.call(nativeAudioScheduledSourceNode, when, offset, duration);
	    };
	  })(nativeAudioScheduledSourceNode.start);
	};

	const wrapAudioScheduledSourceNodeStopMethodNegativeParameters = nativeAudioScheduledSourceNode => {
	  nativeAudioScheduledSourceNode.stop = (stop => {
	    return (when = 0) => {
	      if (when < 0) {
	        throw new RangeError("The parameter can't be negative.");
	      }

	      stop.call(nativeAudioScheduledSourceNode, when);
	    };
	  })(nativeAudioScheduledSourceNode.stop);
	};

	const createNativeAudioBufferSourceNodeFactory = (addSilentConnection, cacheTestResult, testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, testAudioBufferSourceNodeStartMethodOffsetClampingSupport, testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioBufferSourceNodeStartMethodOffsetClampling, wrapAudioBufferSourceNodeStopMethodNullifiedBuffer, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls) => {
	  return (nativeContext, options) => {
	    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
	    assignNativeAudioNodeOptions(nativeAudioBufferSourceNode, options);
	    assignNativeAudioNodeAudioParamValue(nativeAudioBufferSourceNode, options, 'playbackRate');
	    assignNativeAudioNodeOption(nativeAudioBufferSourceNode, options, 'buffer'); // Bug #149: Safari does not yet support the detune AudioParam.

	    assignNativeAudioNodeOption(nativeAudioBufferSourceNode, options, 'loop');
	    assignNativeAudioNodeOption(nativeAudioBufferSourceNode, options, 'loopEnd');
	    assignNativeAudioNodeOption(nativeAudioBufferSourceNode, options, 'loopStart'); // Bug #69: Safari does allow calls to start() of an already scheduled AudioBufferSourceNode.

	    if (!cacheTestResult(testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, () => testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport(nativeContext))) {
	      wrapAudioBufferSourceNodeStartMethodConsecutiveCalls(nativeAudioBufferSourceNode);
	    } // Bug #154 & #155: Safari does not handle offsets which are equal to or greater than the duration of the buffer.


	    if (!cacheTestResult(testAudioBufferSourceNodeStartMethodOffsetClampingSupport, () => testAudioBufferSourceNodeStartMethodOffsetClampingSupport(nativeContext))) {
	      wrapAudioBufferSourceNodeStartMethodOffsetClampling(nativeAudioBufferSourceNode);
	    } // Bug #162: Safari does throw an error when stop() is called on an AudioBufferSourceNode which has no buffer assigned to it.


	    if (!cacheTestResult(testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, () => testAudioBufferSourceNodeStopMethodNullifiedBufferSupport(nativeContext))) {
	      wrapAudioBufferSourceNodeStopMethodNullifiedBuffer(nativeAudioBufferSourceNode, nativeContext);
	    } // Bug #44: Safari does not throw a RangeError yet.


	    if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, () => testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) {
	      wrapAudioScheduledSourceNodeStartMethodNegativeParameters(nativeAudioBufferSourceNode);
	    } // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.


	    if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, () => testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) {
	      wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeAudioBufferSourceNode, nativeContext);
	    } // Bug #44: Only Firefox does not throw a RangeError yet.


	    if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, () => testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) {
	      wrapAudioScheduledSourceNodeStopMethodNegativeParameters(nativeAudioBufferSourceNode);
	    } // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.


	    addSilentConnection(nativeContext, nativeAudioBufferSourceNode);
	    return nativeAudioBufferSourceNode;
	  };
	};

	const createNativeAudioContextConstructor = window => {
	  if (window === null) {
	    return null;
	  }

	  if (window.hasOwnProperty('AudioContext')) {
	    return window.AudioContext;
	  }

	  return window.hasOwnProperty('webkitAudioContext') ? window.webkitAudioContext : null;
	};

	const createNativeAudioDestinationNodeFactory = (createNativeGainNode, overwriteAccessors) => {
	  return (nativeContext, channelCount, isNodeOfNativeOfflineAudioContext) => {
	    const nativeAudioDestinationNode = nativeContext.destination; // Bug #132: Safari does not have the correct channelCount.

	    if (nativeAudioDestinationNode.channelCount !== channelCount) {
	      try {
	        nativeAudioDestinationNode.channelCount = channelCount;
	      } catch {// Bug #169: Safari throws an error on each attempt to change the channelCount.
	      }
	    } // Bug #83: Safari does not have the correct channelCountMode.


	    if (isNodeOfNativeOfflineAudioContext && nativeAudioDestinationNode.channelCountMode !== 'explicit') {
	      nativeAudioDestinationNode.channelCountMode = 'explicit';
	    } // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.


	    if (nativeAudioDestinationNode.maxChannelCount === 0) {
	      Object.defineProperty(nativeAudioDestinationNode, 'maxChannelCount', {
	        value: channelCount
	      });
	    } // Bug #168: No browser does yet have an AudioDestinationNode with an output.


	    const gainNode = createNativeGainNode(nativeContext, {
	      channelCount,
	      channelCountMode: nativeAudioDestinationNode.channelCountMode,
	      channelInterpretation: nativeAudioDestinationNode.channelInterpretation,
	      gain: 1
	    });
	    overwriteAccessors(gainNode, 'channelCount', get => () => get.call(gainNode), set => value => {
	      set.call(gainNode, value);

	      try {
	        nativeAudioDestinationNode.channelCount = value;
	      } catch (err) {
	        // Bug #169: Safari throws an error on each attempt to change the channelCount.
	        if (value > nativeAudioDestinationNode.maxChannelCount) {
	          throw err;
	        }
	      }
	    });
	    overwriteAccessors(gainNode, 'channelCountMode', get => () => get.call(gainNode), set => value => {
	      set.call(gainNode, value);
	      nativeAudioDestinationNode.channelCountMode = value;
	    });
	    overwriteAccessors(gainNode, 'channelInterpretation', get => () => get.call(gainNode), set => value => {
	      set.call(gainNode, value);
	      nativeAudioDestinationNode.channelInterpretation = value;
	    });
	    Object.defineProperty(gainNode, 'maxChannelCount', {
	      get: () => nativeAudioDestinationNode.maxChannelCount
	    }); // @todo This should be disconnected when the context is closed.

	    gainNode.connect(nativeAudioDestinationNode);
	    return gainNode;
	  };
	};

	const createNativeAudioWorkletNodeConstructor = window => {
	  if (window === null) {
	    return null;
	  }

	  return window.hasOwnProperty('AudioWorkletNode') ? window.AudioWorkletNode : null;
	};

	const testClonabilityOfAudioWorkletNodeOptions = audioWorkletNodeOptions => {
	  const {
	    port1
	  } = new MessageChannel();

	  try {
	    // This will throw an error if the audioWorkletNodeOptions are not clonable.
	    port1.postMessage(audioWorkletNodeOptions);
	  } finally {
	    port1.close();
	  }
	};

	const createNativeAudioWorkletNodeFactory = (createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections) => {
	  return (nativeContext, baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, options) => {
	    if (nativeAudioWorkletNodeConstructor !== null) {
	      try {
	        const nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeContext, name, options);
	        const patchedEventListeners = new Map();
	        let onprocessorerror = null;
	        Object.defineProperties(nativeAudioWorkletNode, {
	          /*
	           * Bug #61: Overwriting the property accessors for channelCount and channelCountMode is necessary as long as some
	           * browsers have no native implementation to achieve a consistent behavior.
	           */
	          channelCount: {
	            get: () => options.channelCount,
	            set: () => {
	              throw createInvalidStateError();
	            }
	          },
	          channelCountMode: {
	            get: () => 'explicit',
	            set: () => {
	              throw createInvalidStateError();
	            }
	          },
	          // Bug #156: Chrome and Edge do not yet fire an ErrorEvent.
	          onprocessorerror: {
	            get: () => onprocessorerror,
	            set: value => {
	              if (typeof onprocessorerror === 'function') {
	                nativeAudioWorkletNode.removeEventListener('processorerror', onprocessorerror);
	              }

	              onprocessorerror = typeof value === 'function' ? value : null;

	              if (typeof onprocessorerror === 'function') {
	                nativeAudioWorkletNode.addEventListener('processorerror', onprocessorerror);
	              }
	            }
	          }
	        });

	        nativeAudioWorkletNode.addEventListener = (addEventListener => {
	          return (...args) => {
	            if (args[0] === 'processorerror') {
	              const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;

	              if (unpatchedEventListener !== null) {
	                const patchedEventListener = patchedEventListeners.get(args[1]);

	                if (patchedEventListener !== undefined) {
	                  args[1] = patchedEventListener;
	                } else {
	                  args[1] = event => {
	                    // Bug #178: Chrome and Edge do fire an event of type error.
	                    if (event.type === 'error') {
	                      Object.defineProperties(event, {
	                        type: {
	                          value: 'processorerror'
	                        }
	                      });
	                      unpatchedEventListener(event);
	                    } else {
	                      unpatchedEventListener(new ErrorEvent(args[0], { ...event
	                      }));
	                    }
	                  };

	                  patchedEventListeners.set(unpatchedEventListener, args[1]);
	                }
	              }
	            } // Bug #178: Chrome and Edge do fire an event of type error.


	            addEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
	            return addEventListener.call(nativeAudioWorkletNode, ...args);
	          };
	        })(nativeAudioWorkletNode.addEventListener);

	        nativeAudioWorkletNode.removeEventListener = (removeEventListener => {
	          return (...args) => {
	            if (args[0] === 'processorerror') {
	              const patchedEventListener = patchedEventListeners.get(args[1]);

	              if (patchedEventListener !== undefined) {
	                patchedEventListeners.delete(args[1]);
	                args[1] = patchedEventListener;
	              }
	            } // Bug #178: Chrome and Edge do fire an event of type error.


	            removeEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
	            return removeEventListener.call(nativeAudioWorkletNode, args[0], args[1], args[2]);
	          };
	        })(nativeAudioWorkletNode.removeEventListener);
	        /*
	         * Bug #86: Chrome and Edge do not invoke the process() function if the corresponding AudioWorkletNode is unconnected but
	         * has an output.
	         */


	        if (options.numberOfOutputs !== 0) {
	          const nativeGainNode = createNativeGainNode(nativeContext, {
	            channelCount: 1,
	            channelCountMode: 'explicit',
	            channelInterpretation: 'discrete',
	            gain: 0
	          });
	          nativeAudioWorkletNode.connect(nativeGainNode).connect(nativeContext.destination);

	          const whenConnected = () => nativeGainNode.disconnect();

	          const whenDisconnected = () => nativeGainNode.connect(nativeContext.destination); // @todo Disconnect the connection when the process() function of the AudioWorkletNode returns false.


	          return monitorConnections(nativeAudioWorkletNode, whenConnected, whenDisconnected);
	        }

	        return nativeAudioWorkletNode;
	      } catch (err) {
	        // Bug #60: Chrome & Edge throw an InvalidStateError instead of a NotSupportedError.
	        if (err.code === 11) {
	          throw createNotSupportedError();
	        }

	        throw err;
	      }
	    } // Bug #61: Only Chrome & Edge have an implementation of the AudioWorkletNode yet.


	    if (processorConstructor === undefined) {
	      throw createNotSupportedError();
	    }

	    testClonabilityOfAudioWorkletNodeOptions(options);
	    return createNativeAudioWorkletNodeFaker(nativeContext, baseLatency, processorConstructor, options);
	  };
	};

	const computeBufferSize = (baseLatency, sampleRate) => {
	  if (baseLatency === null) {
	    return 512;
	  }

	  return Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(baseLatency * sampleRate)))));
	};

	const cloneAudioWorkletNodeOptions = audioWorkletNodeOptions => {
	  return new Promise((resolve, reject) => {
	    const {
	      port1,
	      port2
	    } = new MessageChannel();

	    port1.onmessage = ({
	      data
	    }) => {
	      port1.close();
	      port2.close();
	      resolve(data);
	    };

	    port1.onmessageerror = ({
	      data
	    }) => {
	      port1.close();
	      port2.close();
	      reject(data);
	    }; // This will throw an error if the audioWorkletNodeOptions are not clonable.


	    port2.postMessage(audioWorkletNodeOptions);
	  });
	};

	const createAudioWorkletProcessorPromise = async (processorConstructor, audioWorkletNodeOptions) => {
	  const clonedAudioWorkletNodeOptions = await cloneAudioWorkletNodeOptions(audioWorkletNodeOptions);
	  return new processorConstructor(clonedAudioWorkletNodeOptions);
	};

	const createAudioWorkletProcessor = (nativeContext, nativeAudioWorkletNode, processorConstructor, audioWorkletNodeOptions) => {
	  let nodeToProcessorMap = NODE_TO_PROCESSOR_MAPS.get(nativeContext);

	  if (nodeToProcessorMap === undefined) {
	    nodeToProcessorMap = new WeakMap();
	    NODE_TO_PROCESSOR_MAPS.set(nativeContext, nodeToProcessorMap);
	  }

	  const audioWorkletProcessorPromise = createAudioWorkletProcessorPromise(processorConstructor, audioWorkletNodeOptions);
	  nodeToProcessorMap.set(nativeAudioWorkletNode, audioWorkletProcessorPromise);
	  return audioWorkletProcessorPromise;
	};

	const createNativeAudioWorkletNodeFakerFactory = (connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections) => {
	  return (nativeContext, baseLatency, processorConstructor, options) => {
	    if (options.numberOfInputs === 0 && options.numberOfOutputs === 0) {
	      throw createNotSupportedError();
	    }

	    const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount); // @todo Check if any of the channelCount values is greater than the implementation's maximum number of channels.

	    if (outputChannelCount.some(channelCount => channelCount < 1)) {
	      throw createNotSupportedError();
	    }

	    if (outputChannelCount.length !== options.numberOfOutputs) {
	      throw createIndexSizeError();
	    } // Bug #61: This is not part of the standard but required for the faker to work.


	    if (options.channelCountMode !== 'explicit') {
	      throw createNotSupportedError();
	    }

	    const numberOfInputChannels = options.channelCount * options.numberOfInputs;
	    const numberOfOutputChannels = outputChannelCount.reduce((sum, value) => sum + value, 0);
	    const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length; // Bug #61: This is not part of the standard but required for the faker to work.

	    if (numberOfInputChannels + numberOfParameters > 6 || numberOfOutputChannels > 6) {
	      throw createNotSupportedError();
	    }

	    const messageChannel = new MessageChannel();
	    const gainNodes = [];
	    const inputChannelSplitterNodes = [];

	    for (let i = 0; i < options.numberOfInputs; i += 1) {
	      gainNodes.push(createNativeGainNode(nativeContext, {
	        channelCount: options.channelCount,
	        channelCountMode: options.channelCountMode,
	        channelInterpretation: options.channelInterpretation,
	        gain: 1
	      }));
	      inputChannelSplitterNodes.push(createNativeChannelSplitterNode(nativeContext, {
	        channelCount: options.channelCount,
	        channelCountMode: 'explicit',
	        channelInterpretation: 'discrete',
	        numberOfOutputs: options.channelCount
	      }));
	    }

	    const constantSourceNodes = [];

	    if (processorConstructor.parameterDescriptors !== undefined) {
	      for (const {
	        defaultValue,
	        maxValue,
	        minValue,
	        name
	      } of processorConstructor.parameterDescriptors) {
	        const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
	          channelCount: 1,
	          channelCountMode: 'explicit',
	          channelInterpretation: 'discrete',
	          offset: options.parameterData[name] !== undefined ? options.parameterData[name] : defaultValue === undefined ? 0 : defaultValue
	        });
	        Object.defineProperties(constantSourceNode.offset, {
	          defaultValue: {
	            get: () => defaultValue === undefined ? 0 : defaultValue
	          },
	          maxValue: {
	            get: () => maxValue === undefined ? MOST_POSITIVE_SINGLE_FLOAT : maxValue
	          },
	          minValue: {
	            get: () => minValue === undefined ? MOST_NEGATIVE_SINGLE_FLOAT : minValue
	          }
	        });
	        constantSourceNodes.push(constantSourceNode);
	      }
	    }

	    const inputChannelMergerNode = createNativeChannelMergerNode(nativeContext, {
	      channelCount: 1,
	      channelCountMode: 'explicit',
	      channelInterpretation: 'speakers',
	      numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
	    });
	    const bufferSize = computeBufferSize(baseLatency, nativeContext.sampleRate);
	    const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, numberOfInputChannels + numberOfParameters, // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
	    Math.max(1, numberOfOutputChannels));
	    const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
	      channelCount: Math.max(1, numberOfOutputChannels),
	      channelCountMode: 'explicit',
	      channelInterpretation: 'discrete',
	      numberOfOutputs: Math.max(1, numberOfOutputChannels)
	    });
	    const outputChannelMergerNodes = [];

	    for (let i = 0; i < options.numberOfOutputs; i += 1) {
	      outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeContext, {
	        channelCount: 1,
	        channelCountMode: 'explicit',
	        channelInterpretation: 'speakers',
	        numberOfInputs: outputChannelCount[i]
	      }));
	    }

	    for (let i = 0; i < options.numberOfInputs; i += 1) {
	      gainNodes[i].connect(inputChannelSplitterNodes[i]);

	      for (let j = 0; j < options.channelCount; j += 1) {
	        inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
	      }
	    }

	    const parameterMap = new ReadOnlyMap(processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.map(({
	      name
	    }, index) => {
	      const constantSourceNode = constantSourceNodes[index];
	      constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
	      constantSourceNode.start(0);
	      return [name, constantSourceNode.offset];
	    }));
	    inputChannelMergerNode.connect(scriptProcessorNode);
	    let channelInterpretation = options.channelInterpretation;
	    let onprocessorerror = null; // Bug #87: Expose at least one output to make this node connectable.

	    const outputAudioNodes = options.numberOfOutputs === 0 ? [scriptProcessorNode] : outputChannelMergerNodes;
	    const nativeAudioWorkletNodeFaker = {
	      get bufferSize() {
	        return bufferSize;
	      },

	      get channelCount() {
	        return options.channelCount;
	      },

	      set channelCount(_) {
	        // Bug #61: This is not part of the standard but required for the faker to work.
	        throw createInvalidStateError();
	      },

	      get channelCountMode() {
	        return options.channelCountMode;
	      },

	      set channelCountMode(_) {
	        // Bug #61: This is not part of the standard but required for the faker to work.
	        throw createInvalidStateError();
	      },

	      get channelInterpretation() {
	        return channelInterpretation;
	      },

	      set channelInterpretation(value) {
	        for (const gainNode of gainNodes) {
	          gainNode.channelInterpretation = value;
	        }

	        channelInterpretation = value;
	      },

	      get context() {
	        return scriptProcessorNode.context;
	      },

	      get inputs() {
	        return gainNodes;
	      },

	      get numberOfInputs() {
	        return options.numberOfInputs;
	      },

	      get numberOfOutputs() {
	        return options.numberOfOutputs;
	      },

	      get onprocessorerror() {
	        return onprocessorerror;
	      },

	      set onprocessorerror(value) {
	        if (typeof onprocessorerror === 'function') {
	          nativeAudioWorkletNodeFaker.removeEventListener('processorerror', onprocessorerror);
	        }

	        onprocessorerror = typeof value === 'function' ? value : null;

	        if (typeof onprocessorerror === 'function') {
	          nativeAudioWorkletNodeFaker.addEventListener('processorerror', onprocessorerror);
	        }
	      },

	      get parameters() {
	        return parameterMap;
	      },

	      get port() {
	        return messageChannel.port2;
	      },

	      addEventListener(...args) {
	        return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
	      },

	      connect: connectMultipleOutputs.bind(null, outputAudioNodes),
	      disconnect: disconnectMultipleOutputs.bind(null, outputAudioNodes),

	      dispatchEvent(...args) {
	        return scriptProcessorNode.dispatchEvent(args[0]);
	      },

	      removeEventListener(...args) {
	        return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
	      }

	    };
	    const patchedEventListeners = new Map();

	    messageChannel.port1.addEventListener = (addEventListener => {
	      return (...args) => {
	        if (args[0] === 'message') {
	          const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;

	          if (unpatchedEventListener !== null) {
	            const patchedEventListener = patchedEventListeners.get(args[1]);

	            if (patchedEventListener !== undefined) {
	              args[1] = patchedEventListener;
	            } else {
	              args[1] = event => {
	                exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, () => unpatchedEventListener(event));
	              };

	              patchedEventListeners.set(unpatchedEventListener, args[1]);
	            }
	          }
	        }

	        return addEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
	      };
	    })(messageChannel.port1.addEventListener);

	    messageChannel.port1.removeEventListener = (removeEventListener => {
	      return (...args) => {
	        if (args[0] === 'message') {
	          const patchedEventListener = patchedEventListeners.get(args[1]);

	          if (patchedEventListener !== undefined) {
	            patchedEventListeners.delete(args[1]);
	            args[1] = patchedEventListener;
	          }
	        }

	        return removeEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
	      };
	    })(messageChannel.port1.removeEventListener);

	    let onmessage = null;
	    Object.defineProperty(messageChannel.port1, 'onmessage', {
	      get: () => onmessage,
	      set: value => {
	        if (typeof onmessage === 'function') {
	          messageChannel.port1.removeEventListener('message', onmessage);
	        }

	        onmessage = typeof value === 'function' ? value : null;

	        if (typeof onmessage === 'function') {
	          messageChannel.port1.addEventListener('message', onmessage);
	          messageChannel.port1.start();
	        }
	      }
	    });
	    processorConstructor.prototype.port = messageChannel.port1;
	    let audioWorkletProcessor = null;
	    const audioWorkletProcessorPromise = createAudioWorkletProcessor(nativeContext, nativeAudioWorkletNodeFaker, processorConstructor, options);
	    audioWorkletProcessorPromise.then(dWrkltPrcssr => audioWorkletProcessor = dWrkltPrcssr);
	    const inputs = createNestedArrays(options.numberOfInputs, options.channelCount);
	    const outputs = createNestedArrays(options.numberOfOutputs, outputChannelCount);
	    const parameters = processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.reduce((prmtrs, {
	      name
	    }) => ({ ...prmtrs,
	      [name]: new Float32Array(128)
	    }), {});
	    let isActive = true;

	    const disconnectOutputsGraph = () => {
	      if (options.numberOfOutputs > 0) {
	        scriptProcessorNode.disconnect(outputChannelSplitterNode);
	      }

	      for (let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1) {
	        const outputChannelMergerNode = outputChannelMergerNodes[i];

	        for (let j = 0; j < outputChannelCount[i]; j += 1) {
	          outputChannelSplitterNode.disconnect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
	        }

	        outputChannelSplitterNodeOutput += outputChannelCount[i];
	      }
	    };

	    const activeInputIndexes = new Map(); // tslint:disable-next-line:deprecation

	    scriptProcessorNode.onaudioprocess = ({
	      inputBuffer,
	      outputBuffer
	    }) => {
	      if (audioWorkletProcessor !== null) {
	        const activeInputs = getActiveAudioWorkletNodeInputs(nativeAudioWorkletNodeFaker);

	        for (let i = 0; i < bufferSize; i += 128) {
	          for (let j = 0; j < options.numberOfInputs; j += 1) {
	            for (let k = 0; k < options.channelCount; k += 1) {
	              copyFromChannel(inputBuffer, inputs[j], k, k, i);
	            }
	          }

	          if (processorConstructor.parameterDescriptors !== undefined) {
	            processorConstructor.parameterDescriptors.forEach(({
	              name
	            }, index) => {
	              copyFromChannel(inputBuffer, parameters, name, numberOfInputChannels + index, i);
	            });
	          }

	          for (let j = 0; j < options.numberOfInputs; j += 1) {
	            for (let k = 0; k < outputChannelCount[j]; k += 1) {
	              // The byteLength will be 0 when the ArrayBuffer was transferred.
	              if (outputs[j][k].byteLength === 0) {
	                outputs[j][k] = new Float32Array(128);
	              }
	            }
	          }

	          try {
	            const potentiallyEmptyInputs = inputs.map((input, index) => {
	              const activeInput = activeInputs[index];

	              if (activeInput.size > 0) {
	                activeInputIndexes.set(index, bufferSize / 128);
	                return input;
	              }

	              const count = activeInputIndexes.get(index);

	              if (count === undefined) {
	                return [];
	              }

	              if (input.every(channelData => channelData.every(sample => sample === 0))) {
	                if (count === 1) {
	                  activeInputIndexes.delete(index);
	                } else {
	                  activeInputIndexes.set(index, count - 1);
	                }
	              }

	              return input;
	            });
	            const activeSourceFlag = exposeCurrentFrameAndCurrentTime(nativeContext.currentTime + i / nativeContext.sampleRate, nativeContext.sampleRate, () => audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
	            isActive = activeSourceFlag;

	            for (let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1) {
	              for (let k = 0; k < outputChannelCount[j]; k += 1) {
	                copyToChannel(outputBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
	              }

	              outputChannelSplitterNodeOutput += outputChannelCount[j];
	            }
	          } catch (error) {
	            isActive = false;
	            nativeAudioWorkletNodeFaker.dispatchEvent(new ErrorEvent('processorerror', {
	              colno: error.colno,
	              filename: error.filename,
	              lineno: error.lineno,
	              message: error.message
	            }));
	          }

	          if (!isActive) {
	            for (let j = 0; j < options.numberOfInputs; j += 1) {
	              gainNodes[j].disconnect(inputChannelSplitterNodes[j]);

	              for (let k = 0; k < options.channelCount; k += 1) {
	                inputChannelSplitterNodes[i].disconnect(inputChannelMergerNode, k, j * options.channelCount + k);
	              }
	            }

	            if (processorConstructor.parameterDescriptors !== undefined) {
	              const length = processorConstructor.parameterDescriptors.length;

	              for (let j = 0; j < length; j += 1) {
	                const constantSourceNode = constantSourceNodes[j];
	                constantSourceNode.disconnect(inputChannelMergerNode, 0, numberOfInputChannels + j);
	                constantSourceNode.stop();
	              }
	            }

	            inputChannelMergerNode.disconnect(scriptProcessorNode);
	            scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation

	            if (isConnected) {
	              disconnectOutputsGraph();
	            } else {
	              disconnectFakeGraph();
	            }

	            break;
	          }
	        }
	      }
	    };

	    let isConnected = false; // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.

	    const nativeGainNode = createNativeGainNode(nativeContext, {
	      channelCount: 1,
	      channelCountMode: 'explicit',
	      channelInterpretation: 'discrete',
	      gain: 0
	    });

	    const connectFakeGraph = () => scriptProcessorNode.connect(nativeGainNode).connect(nativeContext.destination);

	    const disconnectFakeGraph = () => {
	      scriptProcessorNode.disconnect(nativeGainNode);
	      nativeGainNode.disconnect();
	    };

	    const whenConnected = () => {
	      if (isActive) {
	        disconnectFakeGraph();

	        if (options.numberOfOutputs > 0) {
	          scriptProcessorNode.connect(outputChannelSplitterNode);
	        }

	        for (let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1) {
	          const outputChannelMergerNode = outputChannelMergerNodes[i];

	          for (let j = 0; j < outputChannelCount[i]; j += 1) {
	            outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
	          }

	          outputChannelSplitterNodeOutput += outputChannelCount[i];
	        }
	      }

	      isConnected = true;
	    };

	    const whenDisconnected = () => {
	      if (isActive) {
	        connectFakeGraph();
	        disconnectOutputsGraph();
	      }

	      isConnected = false;
	    };

	    connectFakeGraph();
	    return monitorConnections(nativeAudioWorkletNodeFaker, whenConnected, whenDisconnected);
	  };
	};

	const createNativeChannelMergerNodeFactory = (nativeAudioContextConstructor, wrapChannelMergerNode) => {
	  return (nativeContext, options) => {
	    const nativeChannelMergerNode = nativeContext.createChannelMerger(options.numberOfInputs);
	    /*
	     * Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
	     * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
	     * the webkitAudioContext is used as a workaround here.
	     */

	    if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') {
	      wrapChannelMergerNode(nativeContext, nativeChannelMergerNode);
	    }

	    assignNativeAudioNodeOptions(nativeChannelMergerNode, options);
	    return nativeChannelMergerNode;
	  };
	};

	const wrapChannelSplitterNode = channelSplitterNode => {
	  const channelCount = channelSplitterNode.numberOfOutputs; // Bug #97: Safari does not throw an error when attempting to change the channelCount to something other than its initial value.

	  Object.defineProperty(channelSplitterNode, 'channelCount', {
	    get: () => channelCount,
	    set: value => {
	      if (value !== channelCount) {
	        throw createInvalidStateError();
	      }
	    }
	  }); // Bug #30: Safari does not throw an error when attempting to change the channelCountMode to something other than explicit.

	  Object.defineProperty(channelSplitterNode, 'channelCountMode', {
	    get: () => 'explicit',
	    set: value => {
	      if (value !== 'explicit') {
	        throw createInvalidStateError();
	      }
	    }
	  }); // Bug #32: Safari does not throw an error when attempting to change the channelInterpretation to something other than discrete.

	  Object.defineProperty(channelSplitterNode, 'channelInterpretation', {
	    get: () => 'discrete',
	    set: value => {
	      if (value !== 'discrete') {
	        throw createInvalidStateError();
	      }
	    }
	  });
	};

	const createNativeChannelSplitterNode = (nativeContext, options) => {
	  const nativeChannelSplitterNode = nativeContext.createChannelSplitter(options.numberOfOutputs); // Bug #96: Safari does not have the correct channelCount.
	  // Bug #29: Safari does not have the correct channelCountMode.
	  // Bug #31: Safari does not have the correct channelInterpretation.

	  assignNativeAudioNodeOptions(nativeChannelSplitterNode, options); // Bug #29, #30, #31, #32, #96 & #97: Only Chrome, Edge & Firefox partially support the spec yet.

	  wrapChannelSplitterNode(nativeChannelSplitterNode);
	  return nativeChannelSplitterNode;
	};

	const createNativeConstantSourceNodeFactory = (addSilentConnection, cacheTestResult, createNativeConstantSourceNodeFaker, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport) => {
	  return (nativeContext, options) => {
	    // Bug #62: Safari does not support ConstantSourceNodes.
	    if (nativeContext.createConstantSource === undefined) {
	      return createNativeConstantSourceNodeFaker(nativeContext, options);
	    }

	    const nativeConstantSourceNode = nativeContext.createConstantSource();
	    assignNativeAudioNodeOptions(nativeConstantSourceNode, options);
	    assignNativeAudioNodeAudioParamValue(nativeConstantSourceNode, options, 'offset'); // Bug #44: Safari does not throw a RangeError yet.

	    if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, () => testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) {
	      wrapAudioScheduledSourceNodeStartMethodNegativeParameters(nativeConstantSourceNode);
	    } // Bug #44: Only Firefox does not throw a RangeError yet.


	    if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, () => testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) {
	      wrapAudioScheduledSourceNodeStopMethodNegativeParameters(nativeConstantSourceNode);
	    } // Bug #175: Safari will not fire an ended event if the ConstantSourceNode is unconnected.


	    addSilentConnection(nativeContext, nativeConstantSourceNode);
	    return nativeConstantSourceNode;
	  };
	};

	const interceptConnections = (original, interceptor) => {
	  original.connect = interceptor.connect.bind(interceptor);
	  original.disconnect = interceptor.disconnect.bind(interceptor);
	  return original;
	};

	const createNativeConstantSourceNodeFakerFactory = (addSilentConnection, createNativeAudioBufferSourceNode, createNativeGainNode, monitorConnections) => {
	  return (nativeContext, {
	    offset,
	    ...audioNodeOptions
	  }) => {
	    const audioBuffer = nativeContext.createBuffer(1, 2, 44100);
	    const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
	      buffer: null,
	      channelCount: 2,
	      channelCountMode: 'max',
	      channelInterpretation: 'speakers',
	      loop: false,
	      loopEnd: 0,
	      loopStart: 0,
	      playbackRate: 1
	    });
	    const gainNode = createNativeGainNode(nativeContext, { ...audioNodeOptions,
	      gain: offset
	    }); // Bug #5: Safari does not support copyFromChannel() and copyToChannel().

	    const channelData = audioBuffer.getChannelData(0); // Bug #95: Safari does not play or loop one sample buffers.

	    channelData[0] = 1;
	    channelData[1] = 1;
	    audioBufferSourceNode.buffer = audioBuffer;
	    audioBufferSourceNode.loop = true;
	    const nativeConstantSourceNodeFaker = {
	      get bufferSize() {
	        return undefined;
	      },

	      get channelCount() {
	        return gainNode.channelCount;
	      },

	      set channelCount(value) {
	        gainNode.channelCount = value;
	      },

	      get channelCountMode() {
	        return gainNode.channelCountMode;
	      },

	      set channelCountMode(value) {
	        gainNode.channelCountMode = value;
	      },

	      get channelInterpretation() {
	        return gainNode.channelInterpretation;
	      },

	      set channelInterpretation(value) {
	        gainNode.channelInterpretation = value;
	      },

	      get context() {
	        return gainNode.context;
	      },

	      get inputs() {
	        return [];
	      },

	      get numberOfInputs() {
	        return audioBufferSourceNode.numberOfInputs;
	      },

	      get numberOfOutputs() {
	        return gainNode.numberOfOutputs;
	      },

	      get offset() {
	        return gainNode.gain;
	      },

	      get onended() {
	        return audioBufferSourceNode.onended;
	      },

	      set onended(value) {
	        audioBufferSourceNode.onended = value;
	      },

	      addEventListener(...args) {
	        return audioBufferSourceNode.addEventListener(args[0], args[1], args[2]);
	      },

	      dispatchEvent(...args) {
	        return audioBufferSourceNode.dispatchEvent(args[0]);
	      },

	      removeEventListener(...args) {
	        return audioBufferSourceNode.removeEventListener(args[0], args[1], args[2]);
	      },

	      start(when = 0) {
	        audioBufferSourceNode.start.call(audioBufferSourceNode, when);
	      },

	      stop(when = 0) {
	        audioBufferSourceNode.stop.call(audioBufferSourceNode, when);
	      }

	    };

	    const whenConnected = () => audioBufferSourceNode.connect(gainNode);

	    const whenDisconnected = () => audioBufferSourceNode.disconnect(gainNode); // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.


	    addSilentConnection(nativeContext, audioBufferSourceNode);
	    return monitorConnections(interceptConnections(nativeConstantSourceNodeFaker, gainNode), whenConnected, whenDisconnected);
	  };
	};

	const createNativeGainNode = (nativeContext, options) => {
	  const nativeGainNode = nativeContext.createGain();
	  assignNativeAudioNodeOptions(nativeGainNode, options);
	  assignNativeAudioNodeAudioParamValue(nativeGainNode, options, 'gain');
	  return nativeGainNode;
	};

	const createNativeMediaStreamAudioSourceNode = (nativeAudioContext, {
	  mediaStream
	}) => {
	  const audioStreamTracks = mediaStream.getAudioTracks();
	  /*
	   * Bug #151: Safari does not use the audio track as input anymore if it gets removed from the mediaStream after construction.
	   * Bug #159: Safari picks the first audio track if the MediaStream has more than one audio track.
	   */

	  audioStreamTracks.sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
	  const filteredAudioStreamTracks = audioStreamTracks.slice(0, 1);
	  const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(new MediaStream(filteredAudioStreamTracks));
	  /*
	   * Bug #151 & #159: The given mediaStream gets reconstructed before it gets passed to the native node which is why the accessor needs
	   * to be overwritten as it would otherwise expose the reconstructed version.
	   */

	  Object.defineProperty(nativeMediaStreamAudioSourceNode, 'mediaStream', {
	    value: mediaStream
	  });
	  return nativeMediaStreamAudioSourceNode;
	};

	const createNativeOfflineAudioContextConstructor = window => {
	  if (window === null) {
	    return null;
	  }

	  if (window.hasOwnProperty('OfflineAudioContext')) {
	    return window.OfflineAudioContext;
	  }

	  return window.hasOwnProperty('webkitOfflineAudioContext') ? window.webkitOfflineAudioContext : null;
	};

	const createNativeScriptProcessorNode = (nativeContext, bufferSize, numberOfInputChannels, numberOfOutputChannels) => {
	  return nativeContext.createScriptProcessor(bufferSize, numberOfInputChannels, numberOfOutputChannels); // tslint:disable-line deprecation
	};

	const createNotSupportedError = () => new DOMException('', 'NotSupportedError');

	const createRenderAutomation = (getAudioParamRenderer, renderInputsOfAudioParam) => {
	  return (nativeOfflineAudioContext, audioParam, nativeAudioParam) => {
	    const audioParamRenderer = getAudioParamRenderer(audioParam);
	    audioParamRenderer.replay(nativeAudioParam);
	    return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
	  };
	};

	const createRenderInputsOfAudioNode = (getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle) => {
	  return async (audioNode, nativeOfflineAudioContext, nativeAudioNode) => {
	    const audioNodeConnections = getAudioNodeConnections(audioNode);
	    await Promise.all(audioNodeConnections.activeInputs.map((connections, input) => Array.from(connections).map(async ([source, output]) => {
	      const audioNodeRenderer = getAudioNodeRenderer(source);
	      const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
	      const destination = audioNode.context.destination;

	      if (!isPartOfACycle(source) && (audioNode !== destination || !isPartOfACycle(audioNode))) {
	        renderedNativeAudioNode.connect(nativeAudioNode, output, input);
	      }
	    })).reduce((allRenderingPromises, renderingPromises) => [...allRenderingPromises, ...renderingPromises], []));
	  };
	};

	const createRenderInputsOfAudioParam = (getAudioNodeRenderer, getAudioParamConnections, isPartOfACycle) => {
	  return async (audioParam, nativeOfflineAudioContext, nativeAudioParam) => {
	    const audioParamConnections = getAudioParamConnections(audioParam);
	    await Promise.all(Array.from(audioParamConnections.activeInputs).map(async ([source, output]) => {
	      const audioNodeRenderer = getAudioNodeRenderer(source);
	      const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);

	      if (!isPartOfACycle(source)) {
	        renderedNativeAudioNode.connect(nativeAudioParam, output);
	      }
	    }));
	  };
	};

	const createRenderNativeOfflineAudioContext = (cacheTestResult, createNativeGainNode, createNativeScriptProcessorNode, testOfflineAudioContextCurrentTimeSupport) => {
	  return nativeOfflineAudioContext => {
	    // Bug #21: Safari does not support promises yet.
	    if (cacheTestResult(testPromiseSupport, () => testPromiseSupport(nativeOfflineAudioContext))) {
	      // Bug #158: Chrome and Edge do not advance currentTime if it is not accessed while rendering the audio.
	      return Promise.resolve(cacheTestResult(testOfflineAudioContextCurrentTimeSupport, testOfflineAudioContextCurrentTimeSupport)).then(isOfflineAudioContextCurrentTimeSupported => {
	        if (!isOfflineAudioContextCurrentTimeSupported) {
	          const scriptProcessorNode = createNativeScriptProcessorNode(nativeOfflineAudioContext, 512, 0, 1);

	          nativeOfflineAudioContext.oncomplete = () => {
	            scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation

	            scriptProcessorNode.disconnect();
	          };

	          scriptProcessorNode.onaudioprocess = () => nativeOfflineAudioContext.currentTime; // tslint:disable-line:deprecation


	          scriptProcessorNode.connect(nativeOfflineAudioContext.destination);
	        }

	        return nativeOfflineAudioContext.startRendering();
	      });
	    }

	    return new Promise(resolve => {
	      // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
	      const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
	        channelCount: 1,
	        channelCountMode: 'explicit',
	        channelInterpretation: 'discrete',
	        gain: 0
	      });

	      nativeOfflineAudioContext.oncomplete = event => {
	        gainNode.disconnect();
	        resolve(event.renderedBuffer);
	      };

	      gainNode.connect(nativeOfflineAudioContext.destination);
	      nativeOfflineAudioContext.startRendering();
	    });
	  };
	};

	const createSetActiveAudioWorkletNodeInputs = activeAudioWorkletNodeInputsStore => {
	  return (nativeAudioWorkletNode, activeInputs) => {
	    activeAudioWorkletNodeInputsStore.set(nativeAudioWorkletNode, activeInputs);
	  };
	};

	// Bug #33: Safari exposes an AudioBuffer but it can't be used as a constructor.
	const createTestAudioBufferConstructorSupport = nativeAudioBufferConstructor => {
	  return () => {
	    if (nativeAudioBufferConstructor === null) {
	      return false;
	    }

	    try {
	      new nativeAudioBufferConstructor({
	        length: 1,
	        sampleRate: 44100
	      }); // tslint:disable-line:no-unused-expression
	    } catch {
	      return false;
	    }

	    return true;
	  };
	};

	// Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
	const createTestAudioWorkletProcessorPostMessageSupport = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor) => {
	  return async () => {
	    // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
	    if (nativeAudioWorkletNodeConstructor === null) {
	      return true;
	    }

	    if (nativeOfflineAudioContextConstructor === null) {
	      return false;
	    }

	    const blob = new Blob(['class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'], {
	      type: 'application/javascript; charset=utf-8'
	    }); // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.

	    const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
	    const url = URL.createObjectURL(blob);
	    let isEmittingMessageEvents = false;
	    let isEmittingProcessorErrorEvents = false;

	    try {
	      await offlineAudioContext.audioWorklet.addModule(url);
	      const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
	        numberOfOutputs: 0
	      });
	      const oscillator = offlineAudioContext.createOscillator();

	      audioWorkletNode.port.onmessage = () => isEmittingMessageEvents = true;

	      audioWorkletNode.onprocessorerror = () => isEmittingProcessorErrorEvents = true;

	      oscillator.connect(audioWorkletNode);
	      oscillator.start(0);
	      await offlineAudioContext.startRendering();
	    } catch {// Ignore errors.
	    } finally {
	      URL.revokeObjectURL(url);
	    }

	    return isEmittingMessageEvents && !isEmittingProcessorErrorEvents;
	  };
	};

	const createTestOfflineAudioContextCurrentTimeSupport = (createNativeGainNode, nativeOfflineAudioContextConstructor) => {
	  return () => {
	    if (nativeOfflineAudioContextConstructor === null) {
	      return Promise.resolve(false);
	    }

	    const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100); // Bug #48: Safari does not render an OfflineAudioContext without any connected node.

	    const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
	      channelCount: 1,
	      channelCountMode: 'explicit',
	      channelInterpretation: 'discrete',
	      gain: 0
	    }); // Bug #21: Safari does not support promises yet.

	    return new Promise(resolve => {
	      nativeOfflineAudioContext.oncomplete = () => {
	        gainNode.disconnect();
	        resolve(nativeOfflineAudioContext.currentTime !== 0);
	      };

	      nativeOfflineAudioContext.startRendering();
	    });
	  };
	};

	const createUnknownError = () => new DOMException('', 'UnknownError');

	const createWindow$1 = () => typeof window === 'undefined' ? null : window;

	const createWrapAudioBufferCopyChannelMethods = (convertNumberToUnsignedLong, createIndexSizeError) => {
	  return audioBuffer => {
	    audioBuffer.copyFromChannel = (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0) => {
	      const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
	      const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);

	      if (channelNumber >= audioBuffer.numberOfChannels) {
	        throw createIndexSizeError();
	      }

	      const audioBufferLength = audioBuffer.length;
	      const channelData = audioBuffer.getChannelData(channelNumber);
	      const destinationLength = destination.length;

	      for (let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < destinationLength; i += 1) {
	        destination[i] = channelData[i + bufferOffset];
	      }
	    };

	    audioBuffer.copyToChannel = (source, channelNumberAsNumber, bufferOffsetAsNumber = 0) => {
	      const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
	      const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);

	      if (channelNumber >= audioBuffer.numberOfChannels) {
	        throw createIndexSizeError();
	      }

	      const audioBufferLength = audioBuffer.length;
	      const channelData = audioBuffer.getChannelData(channelNumber);
	      const sourceLength = source.length;

	      for (let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < sourceLength; i += 1) {
	        channelData[i + bufferOffset] = source[i];
	      }
	    };
	  };
	};

	const createWrapAudioBufferCopyChannelMethodsOutOfBounds = convertNumberToUnsignedLong => {
	  return audioBuffer => {
	    audioBuffer.copyFromChannel = (copyFromChannel => {
	      return (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0) => {
	        const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
	        const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);

	        if (bufferOffset < audioBuffer.length) {
	          return copyFromChannel.call(audioBuffer, destination, channelNumber, bufferOffset);
	        }
	      };
	    })(audioBuffer.copyFromChannel);

	    audioBuffer.copyToChannel = (copyToChannel => {
	      return (source, channelNumberAsNumber, bufferOffsetAsNumber = 0) => {
	        const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
	        const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);

	        if (bufferOffset < audioBuffer.length) {
	          return copyToChannel.call(audioBuffer, source, channelNumber, bufferOffset);
	        }
	      };
	    })(audioBuffer.copyToChannel);
	  };
	};

	const createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer = overwriteAccessors => {
	  return (nativeAudioBufferSourceNode, nativeContext) => {
	    const nullifiedBuffer = nativeContext.createBuffer(1, 1, 44100);

	    if (nativeAudioBufferSourceNode.buffer === null) {
	      nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
	    }

	    overwriteAccessors(nativeAudioBufferSourceNode, 'buffer', get => () => {
	      const value = get.call(nativeAudioBufferSourceNode);
	      return value === nullifiedBuffer ? null : value;
	    }, set => value => {
	      return set.call(nativeAudioBufferSourceNode, value === null ? nullifiedBuffer : value);
	    });
	  };
	};

	const createWrapChannelMergerNode = (createInvalidStateError, monitorConnections) => {
	  return (nativeContext, channelMergerNode) => {
	    // Bug #15: Safari does not return the default properties.
	    channelMergerNode.channelCount = 1;
	    channelMergerNode.channelCountMode = 'explicit'; // Bug #16: Safari does not throw an error when setting a different channelCount or channelCountMode.

	    Object.defineProperty(channelMergerNode, 'channelCount', {
	      get: () => 1,
	      set: () => {
	        throw createInvalidStateError();
	      }
	    });
	    Object.defineProperty(channelMergerNode, 'channelCountMode', {
	      get: () => 'explicit',
	      set: () => {
	        throw createInvalidStateError();
	      }
	    }); // Bug #20: Safari requires a connection of any kind to treat the input signal correctly.

	    const audioBufferSourceNode = nativeContext.createBufferSource();

	    const whenConnected = () => {
	      const length = channelMergerNode.numberOfInputs;

	      for (let i = 0; i < length; i += 1) {
	        audioBufferSourceNode.connect(channelMergerNode, 0, i);
	      }
	    };

	    const whenDisconnected = () => audioBufferSourceNode.disconnect(channelMergerNode);

	    monitorConnections(channelMergerNode, whenConnected, whenDisconnected);
	  };
	};

	const getFirstSample = (audioBuffer, buffer, channelNumber) => {
	  // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
	  if (audioBuffer.copyFromChannel === undefined) {
	    return audioBuffer.getChannelData(channelNumber)[0];
	  }

	  audioBuffer.copyFromChannel(buffer, channelNumber);
	  return buffer[0];
	};

	const overwriteAccessors = (object, property, createGetter, createSetter) => {
	  let prototype = object;

	  while (!prototype.hasOwnProperty(property)) {
	    prototype = Object.getPrototypeOf(prototype);
	  }

	  const {
	    get,
	    set
	  } = Object.getOwnPropertyDescriptor(prototype, property);
	  Object.defineProperty(object, property, {
	    get: createGetter(get),
	    set: createSetter(set)
	  });
	};

	const sanitizeAudioWorkletNodeOptions = options => {
	  return { ...options,
	    outputChannelCount: options.outputChannelCount !== undefined ? options.outputChannelCount : options.numberOfInputs === 1 && options.numberOfOutputs === 1 ?
	    /*
	     * Bug #61: This should be the computedNumberOfChannels, but unfortunately that is almost impossible to fake. That's why
	     * the channelCountMode is required to be 'explicit' as long as there is not a native implementation in every browser. That
	     * makes sure the computedNumberOfChannels is equivilant to the channelCount which makes it much easier to compute.
	     */
	    [options.channelCount] : Array.from({
	      length: options.numberOfOutputs
	    }, () => 1)
	  };
	};

	const setValueAtTimeUntilPossible = (audioParam, value, startTime) => {
	  try {
	    audioParam.setValueAtTime(value, startTime);
	  } catch (err) {
	    if (err.code !== 9) {
	      throw err;
	    }

	    setValueAtTimeUntilPossible(audioParam, value, startTime + 1e-7);
	  }
	};

	const testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport = nativeContext => {
	  const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
	  nativeAudioBufferSourceNode.start();

	  try {
	    nativeAudioBufferSourceNode.start();
	  } catch {
	    return true;
	  }

	  return false;
	};

	const testAudioBufferSourceNodeStartMethodOffsetClampingSupport = nativeContext => {
	  const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
	  const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
	  nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;

	  try {
	    nativeAudioBufferSourceNode.start(0, 1);
	  } catch {
	    return false;
	  }

	  return true;
	};

	const testAudioBufferSourceNodeStopMethodNullifiedBufferSupport = nativeContext => {
	  const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
	  nativeAudioBufferSourceNode.start();

	  try {
	    nativeAudioBufferSourceNode.stop();
	  } catch {
	    return false;
	  }

	  return true;
	};

	const testAudioScheduledSourceNodeStartMethodNegativeParametersSupport = nativeContext => {
	  const nativeAudioBufferSourceNode = nativeContext.createOscillator();

	  try {
	    nativeAudioBufferSourceNode.start(-1);
	  } catch (err) {
	    return err instanceof RangeError;
	  }

	  return false;
	};

	const testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport = nativeContext => {
	  const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
	  const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
	  nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
	  nativeAudioBufferSourceNode.start();
	  nativeAudioBufferSourceNode.stop();

	  try {
	    nativeAudioBufferSourceNode.stop();
	    return true;
	  } catch {
	    return false;
	  }
	};

	const testAudioScheduledSourceNodeStopMethodNegativeParametersSupport = nativeContext => {
	  const nativeAudioBufferSourceNode = nativeContext.createOscillator();

	  try {
	    nativeAudioBufferSourceNode.stop(-1);
	  } catch (err) {
	    return err instanceof RangeError;
	  }

	  return false;
	};

	const testAudioWorkletNodeOptionsClonability = audioWorkletNodeOptions => {
	  const {
	    port1,
	    port2
	  } = new MessageChannel();

	  try {
	    // This will throw an error if the audioWorkletNodeOptions are not clonable.
	    port1.postMessage(audioWorkletNodeOptions);
	  } finally {
	    port1.close();
	    port2.close();
	  }
	};

	const wrapAudioBufferSourceNodeStartMethodOffsetClamping = nativeAudioBufferSourceNode => {
	  nativeAudioBufferSourceNode.start = (start => {
	    return (when = 0, offset = 0, duration) => {
	      const buffer = nativeAudioBufferSourceNode.buffer; // Bug #154: Safari does not clamp the offset if it is equal to or greater than the duration of the buffer.

	      const clampedOffset = buffer === null ? offset : Math.min(buffer.duration, offset); // Bug #155: Safari does not handle the offset correctly if it would cause the buffer to be not be played at all.

	      if (buffer !== null && clampedOffset > buffer.duration - 0.5 / nativeAudioBufferSourceNode.context.sampleRate) {
	        start.call(nativeAudioBufferSourceNode, when, 0, 0);
	      } else {
	        start.call(nativeAudioBufferSourceNode, when, clampedOffset, duration);
	      }
	    };
	  })(nativeAudioBufferSourceNode.start);
	};

	const wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls = (nativeAudioScheduledSourceNode, nativeContext) => {
	  const nativeGainNode = nativeContext.createGain();
	  nativeAudioScheduledSourceNode.connect(nativeGainNode);

	  const disconnectGainNode = (disconnect => {
	    return () => {
	      // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
	      disconnect.call(nativeAudioScheduledSourceNode, nativeGainNode);
	      nativeAudioScheduledSourceNode.removeEventListener('ended', disconnectGainNode);
	    };
	  })(nativeAudioScheduledSourceNode.disconnect);

	  nativeAudioScheduledSourceNode.addEventListener('ended', disconnectGainNode);
	  interceptConnections(nativeAudioScheduledSourceNode, nativeGainNode);

	  nativeAudioScheduledSourceNode.stop = (stop => {
	    let isStopped = false;
	    return (when = 0) => {
	      if (isStopped) {
	        try {
	          stop.call(nativeAudioScheduledSourceNode, when);
	        } catch {
	          nativeGainNode.gain.setValueAtTime(0, when);
	        }
	      } else {
	        stop.call(nativeAudioScheduledSourceNode, when);
	        isStopped = true;
	      }
	    };
	  })(nativeAudioScheduledSourceNode.stop);
	};

	const wrapEventListener$1 = (target, eventListener) => {
	  return event => {
	    const descriptor = {
	      value: target
	    };
	    Object.defineProperties(event, {
	      currentTarget: descriptor,
	      target: descriptor
	    });

	    if (typeof eventListener === 'function') {
	      return eventListener.call(target, event);
	    }

	    return eventListener.handleEvent.call(target, event);
	  };
	};

	const addActiveInputConnectionToAudioNode = createAddActiveInputConnectionToAudioNode(insertElementInSet);
	const addPassiveInputConnectionToAudioNode = createAddPassiveInputConnectionToAudioNode(insertElementInSet);
	const deleteActiveInputConnectionToAudioNode = createDeleteActiveInputConnectionToAudioNode(pickElementFromSet);
	const audioNodeTailTimeStore = new WeakMap();
	const getAudioNodeTailTime = createGetAudioNodeTailTime(audioNodeTailTimeStore);
	const cacheTestResult = createCacheTestResult(new Map(), new WeakMap());
	const window$2 = createWindow$1();
	const getAudioNodeRenderer = createGetAudioNodeRenderer(getAudioNodeConnections);
	const renderInputsOfAudioNode = createRenderInputsOfAudioNode(getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle);
	const getNativeContext = createGetNativeContext(CONTEXT_STORE);
	const nativeOfflineAudioContextConstructor = createNativeOfflineAudioContextConstructor(window$2);
	const isNativeOfflineAudioContext = createIsNativeOfflineAudioContext(nativeOfflineAudioContextConstructor);
	const audioParamAudioNodeStore = new WeakMap();
	const eventTargetConstructor = createEventTargetConstructor(wrapEventListener$1);
	const nativeAudioContextConstructor = createNativeAudioContextConstructor(window$2);
	const isNativeAudioContext = createIsNativeAudioContext(nativeAudioContextConstructor);
	const isNativeAudioNode = createIsNativeAudioNode(window$2);
	const isNativeAudioParam = createIsNativeAudioParam(window$2);
	const nativeAudioWorkletNodeConstructor = createNativeAudioWorkletNodeConstructor(window$2);
	const audioNodeConstructor = createAudioNodeConstructor(createAddAudioNodeConnections(AUDIO_NODE_CONNECTIONS_STORE), createAddConnectionToAudioNode(addActiveInputConnectionToAudioNode, addPassiveInputConnectionToAudioNode, connectNativeAudioNodeToNativeAudioNode, deleteActiveInputConnectionToAudioNode, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getAudioNodeTailTime, getEventListenersOfAudioNode, getNativeAudioNode, insertElementInSet, isActiveAudioNode, isPartOfACycle, isPassiveAudioNode), cacheTestResult, createIncrementCycleCounterFactory(CYCLE_COUNTERS, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode), createIndexSizeError, createInvalidAccessError, createNotSupportedError, createDecrementCycleCounter(connectNativeAudioNodeToNativeAudioNode, CYCLE_COUNTERS, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, getNativeContext, isActiveAudioNode, isNativeOfflineAudioContext), createDetectCycles(audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey), eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor);
	const audioBufferStore = new WeakSet();
	const nativeAudioBufferConstructor = createNativeAudioBufferConstructor(window$2);
	const convertNumberToUnsignedLong = createConvertNumberToUnsignedLong(new Uint32Array(1));
	const wrapAudioBufferCopyChannelMethods = createWrapAudioBufferCopyChannelMethods(convertNumberToUnsignedLong, createIndexSizeError);
	const wrapAudioBufferCopyChannelMethodsOutOfBounds = createWrapAudioBufferCopyChannelMethodsOutOfBounds(convertNumberToUnsignedLong);
	const audioBufferConstructor = createAudioBufferConstructor(audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, createTestAudioBufferConstructorSupport(nativeAudioBufferConstructor), wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds);
	const addSilentConnection = createAddSilentConnection(createNativeGainNode);
	const renderInputsOfAudioParam = createRenderInputsOfAudioParam(getAudioNodeRenderer, getAudioParamConnections, isPartOfACycle);
	const connectAudioParam = createConnectAudioParam(renderInputsOfAudioParam);
	const createNativeAudioBufferSourceNode = createNativeAudioBufferSourceNodeFactory(addSilentConnection, cacheTestResult, testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, testAudioBufferSourceNodeStartMethodOffsetClampingSupport, testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioBufferSourceNodeStartMethodOffsetClamping, createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer(overwriteAccessors), wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls);
	const renderAutomation = createRenderAutomation(createGetAudioParamRenderer(getAudioParamConnections), renderInputsOfAudioParam);
	const createAudioBufferSourceNodeRenderer = createAudioBufferSourceNodeRendererFactory(connectAudioParam, createNativeAudioBufferSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode);
	const createAudioParam = createAudioParamFactory(createAddAudioParamConnections(AUDIO_PARAM_CONNECTIONS_STORE), audioParamAudioNodeStore, AUDIO_PARAM_STORE, createAudioParamRenderer, bundle$1.createCancelAndHoldAutomationEvent, bundle$1.createCancelScheduledValuesAutomationEvent, bundle$1.createExponentialRampToValueAutomationEvent, bundle$1.createLinearRampToValueAutomationEvent, bundle$1.createSetTargetAutomationEvent, bundle$1.createSetValueAutomationEvent, bundle$1.createSetValueCurveAutomationEvent, nativeAudioContextConstructor, setValueAtTimeUntilPossible);
	const audioBufferSourceNodeConstructor = createAudioBufferSourceNodeConstructor(audioNodeConstructor, createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener$1);
	const audioDestinationNodeConstructor = createAudioDestinationNodeConstructor(audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNodeFactory(createNativeGainNode, overwriteAccessors), getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode);
	const monitorConnections = createMonitorConnections(insertElementInSet, isNativeAudioNode);
	const wrapChannelMergerNode = createWrapChannelMergerNode(createInvalidStateError, monitorConnections);
	const createNativeChannelMergerNode = createNativeChannelMergerNodeFactory(nativeAudioContextConstructor, wrapChannelMergerNode);
	const createNativeConstantSourceNodeFaker = createNativeConstantSourceNodeFakerFactory(addSilentConnection, createNativeAudioBufferSourceNode, createNativeGainNode, monitorConnections);
	const createNativeConstantSourceNode = createNativeConstantSourceNodeFactory(addSilentConnection, cacheTestResult, createNativeConstantSourceNodeFaker, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport);
	const createConstantSourceNodeRenderer = createConstantSourceNodeRendererFactory(connectAudioParam, createNativeConstantSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode);
	const constantSourceNodeConstructor = createConstantSourceNodeConstructor(audioNodeConstructor, createAudioParam, createConstantSourceNodeRenderer, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener$1);
	const renderNativeOfflineAudioContext = createRenderNativeOfflineAudioContext(cacheTestResult, createNativeGainNode, createNativeScriptProcessorNode, createTestOfflineAudioContextCurrentTimeSupport(createNativeGainNode, nativeOfflineAudioContextConstructor));
	const createAudioListener = createAudioListenerFactory(createAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeScriptProcessorNode, createNotSupportedError, getFirstSample, isNativeOfflineAudioContext, overwriteAccessors);
	const unrenderedAudioWorkletNodeStore = new WeakMap();
	const minimalBaseAudioContextConstructor = createMinimalBaseAudioContextConstructor(audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener$1);
	const isSecureContext = createIsSecureContext(window$2);
	const exposeCurrentFrameAndCurrentTime = createExposeCurrentFrameAndCurrentTime(window$2);
	const backupOfflineAudioContextStore = new WeakMap();
	const getOrCreateBackupOfflineAudioContext = createGetOrCreateBackupOfflineAudioContext(backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor); // The addAudioWorkletModule() function is only available in a SecureContext.

	const addAudioWorkletModule = isSecureContext ? createAddAudioWorkletModule(cacheTestResult, createNotSupportedError, createEvaluateSource(window$2), exposeCurrentFrameAndCurrentTime, createFetchSource(createAbortError), getNativeContext, getOrCreateBackupOfflineAudioContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, new WeakMap(), new WeakMap(), createTestAudioWorkletProcessorPostMessageSupport(nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor), // @todo window is guaranteed to be defined because isSecureContext checks that as well.
	window$2) : undefined;
	const mediaStreamAudioSourceNodeConstructor = createMediaStreamAudioSourceNodeConstructor(audioNodeConstructor, createNativeMediaStreamAudioSourceNode, getNativeContext, isNativeOfflineAudioContext);
	const getUnrenderedAudioWorkletNodes = createGetUnrenderedAudioWorkletNodes(unrenderedAudioWorkletNodeStore);
	const addUnrenderedAudioWorkletNode = createAddUnrenderedAudioWorkletNode(getUnrenderedAudioWorkletNodes);
	const connectMultipleOutputs = createConnectMultipleOutputs(createIndexSizeError);
	const deleteUnrenderedAudioWorkletNode = createDeleteUnrenderedAudioWorkletNode(getUnrenderedAudioWorkletNodes);
	const disconnectMultipleOutputs = createDisconnectMultipleOutputs(createIndexSizeError);
	const activeAudioWorkletNodeInputsStore = new WeakMap();
	const getActiveAudioWorkletNodeInputs = createGetActiveAudioWorkletNodeInputs(activeAudioWorkletNodeInputsStore, getValueForKey);
	const createNativeAudioWorkletNodeFaker = createNativeAudioWorkletNodeFakerFactory(connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections);
	const createNativeAudioWorkletNode = createNativeAudioWorkletNodeFactory(createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections);
	const createAudioWorkletNodeRenderer = createAudioWorkletNodeRendererFactory(connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext);
	const getBackupOfflineAudioContext = createGetBackupOfflineAudioContext(backupOfflineAudioContextStore);
	const setActiveAudioWorkletNodeInputs = createSetActiveAudioWorkletNodeInputs(activeAudioWorkletNodeInputsStore); // The AudioWorkletNode constructor is only available in a SecureContext.

	const audioWorkletNodeConstructor = isSecureContext ? createAudioWorkletNodeConstructor(addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener$1) : undefined;
	const minimalAudioContextConstructor = createMinimalAudioContextConstructor(createInvalidStateError, createNotSupportedError, createUnknownError, minimalBaseAudioContextConstructor, nativeAudioContextConstructor);

	const ERROR_MESSAGE = 'Missing AudioWorklet support. Maybe this is not running in a secure context.'; // @todo This should live in a separate file.

	const createPromisedAudioNodesEncoderIdAndPort = async (audioBuffer, audioContext, channelCount, mediaStream, mimeType) => {
	  const {
	    encoderId,
	    port
	  } = await instantiate(mimeType, audioContext.sampleRate);

	  if (audioWorkletNodeConstructor === undefined) {
	    throw new Error(ERROR_MESSAGE);
	  }

	  const audioBufferSourceNode = new audioBufferSourceNodeConstructor(audioContext, {
	    buffer: audioBuffer
	  });
	  const mediaStreamAudioSourceNode = new mediaStreamAudioSourceNodeConstructor(audioContext, {
	    mediaStream
	  });
	  const recorderAudioWorkletNode = createRecorderAudioWorkletNode(audioWorkletNodeConstructor, audioContext, {
	    channelCount
	  });
	  return {
	    audioBufferSourceNode,
	    encoderId,
	    mediaStreamAudioSourceNode,
	    port,
	    recorderAudioWorkletNode
	  };
	};

	const createWebAudioMediaRecorderFactory = (createBlobEvent, createInvalidModificationError, createInvalidStateError, createNotSupportedError) => {
	  return (eventTarget, mediaStream, mimeType) => {
	    var _a;

	    const sampleRate = (_a = mediaStream.getAudioTracks()[0]) === null || _a === void 0 ? void 0 : _a.getSettings().sampleRate;
	    const audioContext = new minimalAudioContextConstructor({
	      latencyHint: 'playback',
	      sampleRate
	    });
	    const length = Math.max(1024, Math.ceil(audioContext.baseLatency * audioContext.sampleRate));
	    const audioBuffer = new audioBufferConstructor({
	      length,
	      sampleRate: audioContext.sampleRate
	    });
	    const bufferedArrayBuffers = [];
	    const promisedAudioWorkletModule = addRecorderAudioWorkletModule(url => {
	      if (addAudioWorkletModule === undefined) {
	        throw new Error(ERROR_MESSAGE);
	      }

	      return addAudioWorkletModule(audioContext, url);
	    });
	    let abortRecording = null;
	    let intervalId = null;
	    let promisedAudioNodesAndEncoderId = null;
	    let promisedPartialRecording = null;
	    let isAudioContextRunning = true;

	    const dispatchDataAvailableEvent = arrayBuffers => {
	      eventTarget.dispatchEvent(createBlobEvent('dataavailable', {
	        data: new Blob(arrayBuffers, {
	          type: mimeType
	        })
	      }));
	    };

	    const requestNextPartialRecording = async (encoderId, timeslice) => {
	      const arrayBuffers = await encode(encoderId, timeslice);

	      if (promisedAudioNodesAndEncoderId === null) {
	        bufferedArrayBuffers.push(...arrayBuffers);
	      } else {
	        dispatchDataAvailableEvent(arrayBuffers);
	        promisedPartialRecording = requestNextPartialRecording(encoderId, timeslice);
	      }
	    };

	    const resume = () => {
	      isAudioContextRunning = true;
	      return audioContext.resume();
	    };

	    const stop = () => {
	      if (promisedAudioNodesAndEncoderId === null) {
	        return;
	      }

	      if (abortRecording !== null) {
	        mediaStream.removeEventListener('addtrack', abortRecording);
	        mediaStream.removeEventListener('removetrack', abortRecording);
	      }

	      if (intervalId !== null) {
	        clearTimeout(intervalId);
	      }

	      promisedAudioNodesAndEncoderId.then(async ({
	        constantSourceNode,
	        encoderId,
	        mediaStreamAudioSourceNode,
	        recorderAudioWorkletNode
	      }) => {
	        if (promisedPartialRecording !== null) {
	          promisedPartialRecording.catch(() => {
	            /* @todo Only catch the errors caused by a duplicate call to encode. */
	          });
	          promisedPartialRecording = null;
	        }

	        await recorderAudioWorkletNode.stop();
	        mediaStreamAudioSourceNode.disconnect(recorderAudioWorkletNode);
	        constantSourceNode.stop();
	        const arrayBuffers = await encode(encoderId, null);

	        if (promisedAudioNodesAndEncoderId === null) {
	          await suspend();
	        }

	        dispatchDataAvailableEvent([...bufferedArrayBuffers, ...arrayBuffers]);
	        bufferedArrayBuffers.length = 0;
	        eventTarget.dispatchEvent(new Event('stop'));
	      });
	      promisedAudioNodesAndEncoderId = null;
	    };

	    const suspend = () => {
	      isAudioContextRunning = false;
	      return audioContext.suspend();
	    };

	    suspend();
	    return {
	      get mimeType() {
	        return mimeType;
	      },

	      get state() {
	        return promisedAudioNodesAndEncoderId === null ? 'inactive' : isAudioContextRunning ? 'recording' : 'paused';
	      },

	      pause() {
	        if (promisedAudioNodesAndEncoderId === null) {
	          throw createInvalidStateError();
	        }

	        if (isAudioContextRunning) {
	          suspend();
	          eventTarget.dispatchEvent(new Event('pause'));
	        }
	      },

	      resume() {
	        if (promisedAudioNodesAndEncoderId === null) {
	          throw createInvalidStateError();
	        }

	        if (!isAudioContextRunning) {
	          resume();
	          eventTarget.dispatchEvent(new Event('resume'));
	        }
	      },

	      start(timeslice) {
	        var _a;

	        if (promisedAudioNodesAndEncoderId !== null) {
	          throw createInvalidStateError();
	        }

	        if (mediaStream.getVideoTracks().length > 0) {
	          throw createNotSupportedError();
	        }

	        eventTarget.dispatchEvent(new Event('start'));
	        const audioTracks = mediaStream.getAudioTracks(); // @todo TypeScript v4.4.2 removed the channelCount property from the MediaTrackSettings interface.

	        const channelCount = audioTracks.length === 0 ? 2 : (_a = audioTracks[0].getSettings().channelCount) !== null && _a !== void 0 ? _a : 2;
	        promisedAudioNodesAndEncoderId = Promise.all([resume(), promisedAudioWorkletModule.then(() => createPromisedAudioNodesEncoderIdAndPort(audioBuffer, audioContext, channelCount, mediaStream, mimeType))]).then(async ([, {
	          audioBufferSourceNode,
	          encoderId,
	          mediaStreamAudioSourceNode,
	          port,
	          recorderAudioWorkletNode
	        }]) => {
	          mediaStreamAudioSourceNode.connect(recorderAudioWorkletNode);
	          await new Promise(resolve => {
	            audioBufferSourceNode.onended = resolve;
	            audioBufferSourceNode.connect(recorderAudioWorkletNode);
	            audioBufferSourceNode.start(audioContext.currentTime + length / audioContext.sampleRate);
	          });
	          audioBufferSourceNode.disconnect(recorderAudioWorkletNode); // Bug #17: Safari does throttle the processing on hidden tabs if there is no active audio output.

	          const constantSourceNode = new constantSourceNodeConstructor(audioContext, {
	            offset: 0
	          });

	          constantSourceNode.onended = () => constantSourceNode.disconnect();

	          constantSourceNode.connect(audioContext.destination);
	          constantSourceNode.start();
	          await recorderAudioWorkletNode.record(port);

	          if (timeslice !== undefined) {
	            promisedPartialRecording = requestNextPartialRecording(encoderId, timeslice);
	          }

	          return {
	            constantSourceNode,
	            encoderId,
	            mediaStreamAudioSourceNode,
	            recorderAudioWorkletNode
	          };
	        });
	        const tracks = mediaStream.getTracks();

	        abortRecording = () => {
	          stop();
	          eventTarget.dispatchEvent(new ErrorEvent('error', {
	            error: createInvalidModificationError()
	          }));
	        };

	        mediaStream.addEventListener('addtrack', abortRecording);
	        mediaStream.addEventListener('removetrack', abortRecording);
	        intervalId = setInterval(() => {
	          const currentTracks = mediaStream.getTracks();

	          if ((currentTracks.length !== tracks.length || currentTracks.some((track, index) => track !== tracks[index])) && abortRecording !== null) {
	            abortRecording();
	          }
	        }, 1000);
	      },

	      stop
	    };
	  };
	};

	var bundle = createCommonjsModule$1(function (module, exports) {
	(function (global, factory) {
	  factory(exports, slicedToArray, classCallCheck, createClass) ;
	})(commonjsGlobal, function (exports, _slicedToArray, _classCallCheck, _createClass) {

	  function _interopDefaultLegacy(e) {
	    return e && typeof e === 'object' && 'default' in e ? e : {
	      'default': e
	    };
	  }

	  var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

	  var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);

	  var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

	  function _createForOfIteratorHelper(o, allowArrayLike) {
	    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

	    if (!it) {
	      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	        if (it) o = it;
	        var i = 0;

	        var F = function F() {};

	        return {
	          s: F,
	          n: function n() {
	            if (i >= o.length) return {
	              done: true
	            };
	            return {
	              done: false,
	              value: o[i++]
	            };
	          },
	          e: function e(_e) {
	            throw _e;
	          },
	          f: F
	        };
	      }

	      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	    }

	    var normalCompletion = true,
	        didErr = false,
	        err;
	    return {
	      s: function s() {
	        it = it.call(o);
	      },
	      n: function n() {
	        var step = it.next();
	        normalCompletion = step.done;
	        return step;
	      },
	      e: function e(_e2) {
	        didErr = true;
	        err = _e2;
	      },
	      f: function f() {
	        try {
	          if (!normalCompletion && it["return"] != null) it["return"]();
	        } finally {
	          if (didErr) throw err;
	        }
	      }
	    };
	  }

	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }

	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;

	    for (var i = 0, arr2 = new Array(len); i < len; i++) {
	      arr2[i] = arr[i];
	    }

	    return arr2;
	  }

	  var MultiBufferDataView = /*#__PURE__*/function () {
	    function MultiBufferDataView(buffers) {
	      var byteOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var byteLength = arguments.length > 2 ? arguments[2] : undefined;

	      _classCallCheck__default["default"](this, MultiBufferDataView);

	      if (byteOffset < 0 || byteLength !== undefined && byteLength < 0) {
	        throw new RangeError();
	      }

	      var availableBytes = buffers.reduce(function (length, buffer) {
	        return length + buffer.byteLength;
	      }, 0);

	      if (byteOffset > availableBytes || byteLength !== undefined && byteOffset + byteLength > availableBytes) {
	        throw new RangeError();
	      }

	      var dataViews = [];
	      var effectiveByteLength = byteLength === undefined ? availableBytes - byteOffset : byteLength;
	      var truncatedBuffers = [];
	      var consumedByteLength = 0;
	      var truncatedByteOffset = byteOffset;

	      var _iterator = _createForOfIteratorHelper(buffers),
	          _step;

	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var buffer = _step.value;

	          if (truncatedBuffers.length === 0) {
	            if (buffer.byteLength > truncatedByteOffset) {
	              consumedByteLength = buffer.byteLength - truncatedByteOffset;
	              var byteLengthOfDataView = consumedByteLength > effectiveByteLength ? effectiveByteLength : consumedByteLength;
	              dataViews.push(new DataView(buffer, truncatedByteOffset, byteLengthOfDataView));
	              truncatedBuffers.push(buffer);
	            } else {
	              truncatedByteOffset -= buffer.byteLength;
	            }
	          } else if (consumedByteLength < effectiveByteLength) {
	            consumedByteLength += buffer.byteLength;

	            var _byteLengthOfDataView = consumedByteLength > effectiveByteLength ? buffer.byteLength - consumedByteLength + effectiveByteLength : buffer.byteLength;

	            dataViews.push(new DataView(buffer, 0, _byteLengthOfDataView));
	            truncatedBuffers.push(buffer);
	          }
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }

	      this._buffers = truncatedBuffers;
	      this._byteLength = effectiveByteLength;
	      this._byteOffset = truncatedByteOffset;
	      this._dataViews = dataViews;
	      this._internalBuffer = new DataView(new ArrayBuffer(8));
	    }

	    _createClass__default["default"](MultiBufferDataView, [{
	      key: "buffers",
	      get: function get() {
	        return this._buffers;
	      }
	    }, {
	      key: "byteLength",
	      get: function get() {
	        return this._byteLength;
	      }
	    }, {
	      key: "byteOffset",
	      get: function get() {
	        return this._byteOffset;
	      }
	    }, {
	      key: "getFloat32",
	      value: function getFloat32(byteOffset, littleEndian) {
	        this._internalBuffer.setUint8(0, this.getUint8(byteOffset + 0));

	        this._internalBuffer.setUint8(1, this.getUint8(byteOffset + 1));

	        this._internalBuffer.setUint8(2, this.getUint8(byteOffset + 2));

	        this._internalBuffer.setUint8(3, this.getUint8(byteOffset + 3));

	        return this._internalBuffer.getFloat32(0, littleEndian);
	      }
	    }, {
	      key: "getFloat64",
	      value: function getFloat64(byteOffset, littleEndian) {
	        this._internalBuffer.setUint8(0, this.getUint8(byteOffset + 0));

	        this._internalBuffer.setUint8(1, this.getUint8(byteOffset + 1));

	        this._internalBuffer.setUint8(2, this.getUint8(byteOffset + 2));

	        this._internalBuffer.setUint8(3, this.getUint8(byteOffset + 3));

	        this._internalBuffer.setUint8(4, this.getUint8(byteOffset + 4));

	        this._internalBuffer.setUint8(5, this.getUint8(byteOffset + 5));

	        this._internalBuffer.setUint8(6, this.getUint8(byteOffset + 6));

	        this._internalBuffer.setUint8(7, this.getUint8(byteOffset + 7));

	        return this._internalBuffer.getFloat64(0, littleEndian);
	      }
	    }, {
	      key: "getInt16",
	      value: function getInt16(byteOffset, littleEndian) {
	        this._internalBuffer.setUint8(0, this.getUint8(byteOffset + 0));

	        this._internalBuffer.setUint8(1, this.getUint8(byteOffset + 1));

	        return this._internalBuffer.getInt16(0, littleEndian);
	      }
	    }, {
	      key: "getInt32",
	      value: function getInt32(byteOffset, littleEndian) {
	        this._internalBuffer.setUint8(0, this.getUint8(byteOffset + 0));

	        this._internalBuffer.setUint8(1, this.getUint8(byteOffset + 1));

	        this._internalBuffer.setUint8(2, this.getUint8(byteOffset + 2));

	        this._internalBuffer.setUint8(3, this.getUint8(byteOffset + 3));

	        return this._internalBuffer.getInt32(0, littleEndian);
	      }
	    }, {
	      key: "getInt8",
	      value: function getInt8(byteOffset) {
	        var _this$_findDataViewWi = this._findDataViewWithOffset(byteOffset),
	            _this$_findDataViewWi2 = _slicedToArray__default["default"](_this$_findDataViewWi, 2),
	            dataView = _this$_findDataViewWi2[0],
	            byteOffsetOfDataView = _this$_findDataViewWi2[1];

	        return dataView.getInt8(byteOffset - byteOffsetOfDataView);
	      }
	    }, {
	      key: "getUint16",
	      value: function getUint16(byteOffset, littleEndian) {
	        this._internalBuffer.setUint8(0, this.getUint8(byteOffset + 0));

	        this._internalBuffer.setUint8(1, this.getUint8(byteOffset + 1));

	        return this._internalBuffer.getUint16(0, littleEndian);
	      }
	    }, {
	      key: "getUint32",
	      value: function getUint32(byteOffset, littleEndian) {
	        this._internalBuffer.setUint8(0, this.getUint8(byteOffset + 0));

	        this._internalBuffer.setUint8(1, this.getUint8(byteOffset + 1));

	        this._internalBuffer.setUint8(2, this.getUint8(byteOffset + 2));

	        this._internalBuffer.setUint8(3, this.getUint8(byteOffset + 3));

	        return this._internalBuffer.getUint32(0, littleEndian);
	      }
	    }, {
	      key: "getUint8",
	      value: function getUint8(byteOffset) {
	        var _this$_findDataViewWi3 = this._findDataViewWithOffset(byteOffset),
	            _this$_findDataViewWi4 = _slicedToArray__default["default"](_this$_findDataViewWi3, 2),
	            dataView = _this$_findDataViewWi4[0],
	            byteOffsetOfDataView = _this$_findDataViewWi4[1];

	        return dataView.getUint8(byteOffset - byteOffsetOfDataView);
	      }
	    }, {
	      key: "setFloat32",
	      value: function setFloat32(byteOffset, value, littleEndian) {
	        this._internalBuffer.setFloat32(0, value, littleEndian);

	        this.setUint8(byteOffset, this._internalBuffer.getUint8(0));
	        this.setUint8(byteOffset + 1, this._internalBuffer.getUint8(1));
	        this.setUint8(byteOffset + 2, this._internalBuffer.getUint8(2));
	        this.setUint8(byteOffset + 3, this._internalBuffer.getUint8(3));
	      }
	    }, {
	      key: "setFloat64",
	      value: function setFloat64(byteOffset, value, littleEndian) {
	        this._internalBuffer.setFloat64(0, value, littleEndian);

	        this.setUint8(byteOffset, this._internalBuffer.getUint8(0));
	        this.setUint8(byteOffset + 1, this._internalBuffer.getUint8(1));
	        this.setUint8(byteOffset + 2, this._internalBuffer.getUint8(2));
	        this.setUint8(byteOffset + 3, this._internalBuffer.getUint8(3));
	        this.setUint8(byteOffset + 4, this._internalBuffer.getUint8(4));
	        this.setUint8(byteOffset + 5, this._internalBuffer.getUint8(5));
	        this.setUint8(byteOffset + 6, this._internalBuffer.getUint8(6));
	        this.setUint8(byteOffset + 7, this._internalBuffer.getUint8(7));
	      }
	    }, {
	      key: "setInt16",
	      value: function setInt16(byteOffset, value, littleEndian) {
	        this._internalBuffer.setInt16(0, value, littleEndian);

	        this.setUint8(byteOffset, this._internalBuffer.getUint8(0));
	        this.setUint8(byteOffset + 1, this._internalBuffer.getUint8(1));
	      }
	    }, {
	      key: "setInt32",
	      value: function setInt32(byteOffset, value, littleEndian) {
	        this._internalBuffer.setInt32(0, value, littleEndian);

	        this.setUint8(byteOffset, this._internalBuffer.getUint8(0));
	        this.setUint8(byteOffset + 1, this._internalBuffer.getUint8(1));
	        this.setUint8(byteOffset + 2, this._internalBuffer.getUint8(2));
	        this.setUint8(byteOffset + 3, this._internalBuffer.getUint8(3));
	      }
	    }, {
	      key: "setInt8",
	      value: function setInt8(byteOffset, value) {
	        var _this$_findDataViewWi5 = this._findDataViewWithOffset(byteOffset),
	            _this$_findDataViewWi6 = _slicedToArray__default["default"](_this$_findDataViewWi5, 2),
	            dataView = _this$_findDataViewWi6[0],
	            byteOffsetOfDataView = _this$_findDataViewWi6[1];

	        dataView.setInt8(byteOffset - byteOffsetOfDataView, value);
	      }
	    }, {
	      key: "setUint16",
	      value: function setUint16(byteOffset, value, littleEndian) {
	        this._internalBuffer.setUint16(0, value, littleEndian);

	        this.setUint8(byteOffset, this._internalBuffer.getUint8(0));
	        this.setUint8(byteOffset + 1, this._internalBuffer.getUint8(1));
	      }
	    }, {
	      key: "setUint32",
	      value: function setUint32(byteOffset, value, littleEndian) {
	        this._internalBuffer.setUint32(0, value, littleEndian);

	        this.setUint8(byteOffset, this._internalBuffer.getUint8(0));
	        this.setUint8(byteOffset + 1, this._internalBuffer.getUint8(1));
	        this.setUint8(byteOffset + 2, this._internalBuffer.getUint8(2));
	        this.setUint8(byteOffset + 3, this._internalBuffer.getUint8(3));
	      }
	    }, {
	      key: "setUint8",
	      value: function setUint8(byteOffset, value) {
	        var _this$_findDataViewWi7 = this._findDataViewWithOffset(byteOffset),
	            _this$_findDataViewWi8 = _slicedToArray__default["default"](_this$_findDataViewWi7, 2),
	            dataView = _this$_findDataViewWi8[0],
	            byteOffsetOfDataView = _this$_findDataViewWi8[1];

	        dataView.setUint8(byteOffset - byteOffsetOfDataView, value);
	      }
	    }, {
	      key: "_findDataViewWithOffset",
	      value: function _findDataViewWithOffset(byteOffset) {
	        var byteOffsetOfDataView = 0;

	        var _iterator2 = _createForOfIteratorHelper(this._dataViews),
	            _step2;

	        try {
	          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	            var dataView = _step2.value;
	            var byteOffsetOfNextDataView = byteOffsetOfDataView + dataView.byteLength;

	            if (byteOffset >= byteOffsetOfDataView && byteOffset < byteOffsetOfNextDataView) {
	              return [dataView, byteOffsetOfDataView];
	            }

	            byteOffsetOfDataView = byteOffsetOfNextDataView;
	          }
	        } catch (err) {
	          _iterator2.e(err);
	        } finally {
	          _iterator2.f();
	        }

	        throw new RangeError();
	      }
	    }]);

	    return MultiBufferDataView;
	  }();

	  exports.MultiBufferDataView = MultiBufferDataView;
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	});
	});

	const createWebmPcmMediaRecorderFactory = (createBlobEvent, createInvalidModificationError, createNotSupportedError, decodeWebMChunk, readVariableSizeInteger) => {
	  return (eventTarget, nativeMediaRecorderConstructor, mediaStream, mimeType) => {
	    const audioTracks = mediaStream.getAudioTracks();
	    const bufferedArrayBuffers = []; // @todo TypeScript v4.4.2 removed the channelCount property from the MediaTrackSettings interface.

	    const channelCount = audioTracks.length === 0 ? undefined : audioTracks[0].getSettings().channelCount;
	    const nativeMediaRecorder = new nativeMediaRecorderConstructor(mediaStream, {
	      mimeType: 'audio/webm;codecs=pcm'
	    });
	    const sampleRate = audioTracks.length === 0 ? undefined : audioTracks[0].getSettings().sampleRate;
	    let promisedPartialRecording = null;

	    let stopRecording = () => {}; // tslint:disable-line:no-empty


	    const dispatchDataAvailableEvent = arrayBuffers => {
	      eventTarget.dispatchEvent(createBlobEvent('dataavailable', {
	        data: new Blob(arrayBuffers, {
	          type: mimeType
	        })
	      }));
	    };

	    const requestNextPartialRecording = async (encoderId, timeslice) => {
	      const arrayBuffers = await encode(encoderId, timeslice);

	      if (nativeMediaRecorder.state === 'inactive') {
	        bufferedArrayBuffers.push(...arrayBuffers);
	      } else {
	        dispatchDataAvailableEvent(arrayBuffers);
	        promisedPartialRecording = requestNextPartialRecording(encoderId, timeslice);
	      }
	    };

	    const stop = () => {
	      if (nativeMediaRecorder.state === 'inactive') {
	        return;
	      }

	      if (promisedPartialRecording !== null) {
	        promisedPartialRecording.catch(() => {
	          /* @todo Only catch the errors caused by a duplicate call to encode. */
	        });
	        promisedPartialRecording = null;
	      }

	      stopRecording();

	      stopRecording = () => {}; // tslint:disable-line:no-empty


	      nativeMediaRecorder.stop();
	    };

	    nativeMediaRecorder.addEventListener('error', () => {
	      stop(); // Bug #3 & #4: Chrome throws an error event without any error.

	      eventTarget.dispatchEvent(new ErrorEvent('error', {
	        error: createInvalidModificationError()
	      }));
	    });
	    nativeMediaRecorder.addEventListener('start', () => eventTarget.dispatchEvent(new Event('start')));
	    return {
	      get mimeType() {
	        return mimeType;
	      },

	      get state() {
	        return nativeMediaRecorder.state;
	      },

	      pause() {
	        return nativeMediaRecorder.pause();
	      },

	      resume() {
	        return nativeMediaRecorder.resume();
	      },

	      start(timeslice) {
	        /*
	         * Bug #6: Chrome will emit a blob without any data when asked to encode a MediaStream with a video track into an audio
	         * codec.
	         */
	        if (mediaStream.getVideoTracks().length > 0) {
	          throw createNotSupportedError();
	        }

	        if (nativeMediaRecorder.state === 'inactive') {
	          if (sampleRate === undefined) {
	            throw new Error('The sampleRate is not defined.');
	          }

	          let isRecording = false;
	          let isStopped = false; // Bug #9: Chrome sometimes fires more than one dataavailable event while being inactive.

	          let pendingInvocations = 0;
	          let promisedDataViewElementTypeEncoderIdAndPort = instantiate(mimeType, sampleRate);

	          stopRecording = () => {
	            isStopped = true;
	          };

	          const removeEventListener = on(nativeMediaRecorder, 'dataavailable')(({
	            data
	          }) => {
	            pendingInvocations += 1;
	            promisedDataViewElementTypeEncoderIdAndPort = promisedDataViewElementTypeEncoderIdAndPort.then(async ({
	              dataView = null,
	              elementType = null,
	              encoderId,
	              port
	            }) => {
	              const arrayBuffer = await data.arrayBuffer();
	              pendingInvocations -= 1;
	              const currentDataView = dataView === null ? new bundle.MultiBufferDataView([arrayBuffer]) : new bundle.MultiBufferDataView([...dataView.buffers, arrayBuffer], dataView.byteOffset);

	              if (!isRecording && nativeMediaRecorder.state === 'recording' && !isStopped) {
	                const lengthAndValue = readVariableSizeInteger(currentDataView, 0);

	                if (lengthAndValue === null) {
	                  return {
	                    dataView: currentDataView,
	                    elementType,
	                    encoderId,
	                    port
	                  };
	                }

	                const {
	                  value
	                } = lengthAndValue;

	                if (value !== 172351395) {
	                  return {
	                    dataView,
	                    elementType,
	                    encoderId,
	                    port
	                  };
	                }

	                isRecording = true;
	              }

	              const {
	                currentElementType,
	                offset,
	                contents
	              } = decodeWebMChunk(currentDataView, elementType, channelCount);
	              const remainingDataView = offset < currentDataView.byteLength ? new bundle.MultiBufferDataView(currentDataView.buffers, currentDataView.byteOffset + offset) : null;
	              contents.forEach(content => port.postMessage(content, content.map(({
	                buffer
	              }) => buffer)));

	              if (pendingInvocations === 0 && (nativeMediaRecorder.state === 'inactive' || isStopped)) {
	                encode(encoderId, null).then(arrayBuffers => {
	                  dispatchDataAvailableEvent([...bufferedArrayBuffers, ...arrayBuffers]);
	                  bufferedArrayBuffers.length = 0;
	                  eventTarget.dispatchEvent(new Event('stop'));
	                });
	                port.postMessage([]);
	                port.close();
	                removeEventListener();
	              }

	              return {
	                dataView: remainingDataView,
	                elementType: currentElementType,
	                encoderId,
	                port
	              };
	            });
	          });

	          if (timeslice !== undefined) {
	            promisedDataViewElementTypeEncoderIdAndPort.then(({
	              encoderId
	            }) => promisedPartialRecording = requestNextPartialRecording(encoderId, timeslice));
	          }
	        }

	        nativeMediaRecorder.start(100);
	      },

	      stop
	    };
	  };
	};

	const createWindow = () => typeof window === 'undefined' ? null : window;

	const readVariableSizeIntegerLength = (dataView, offset) => {
	  if (offset >= dataView.byteLength) {
	    return null;
	  }

	  const byte = dataView.getUint8(offset);

	  if (byte > 127) {
	    return 1;
	  }

	  if (byte > 63) {
	    return 2;
	  }

	  if (byte > 31) {
	    return 3;
	  }

	  if (byte > 15) {
	    return 4;
	  }

	  if (byte > 7) {
	    return 5;
	  }

	  if (byte > 3) {
	    return 6;
	  }

	  if (byte > 1) {
	    return 7;
	  }

	  if (byte > 0) {
	    return 8;
	  }

	  const length = readVariableSizeIntegerLength(dataView, offset + 1);
	  return length === null ? null : length + 8;
	};

	const wrapEventListener = (target, eventListener) => {
	  return event => {
	    const descriptor = {
	      value: target
	    };
	    Object.defineProperties(event, {
	      currentTarget: descriptor,
	      target: descriptor
	    });

	    if (typeof eventListener === 'function') {
	      return eventListener.call(target, event);
	    }

	    return eventListener.handleEvent.call(target, event);
	  };
	};

	const encoderRegexes = [];
	const window$1 = createWindow();
	const nativeBlobEventConstructor = createNativeBlobEventConstructor(window$1);
	const createBlobEvent = createBlobEventFactory(nativeBlobEventConstructor);
	const createWebAudioMediaRecorder = createWebAudioMediaRecorderFactory(createBlobEvent, createInvalidModificationError, createInvalidStateError$1, createNotSupportedError$1);
	const readVariableSizeInteger = createReadVariableSizeInteger(readVariableSizeIntegerLength);
	const readElementContent = createReadElementContent(readVariableSizeInteger);
	const readElementType = createReadElementType(readVariableSizeInteger);
	const decodeWebMChunk = createDecodeWebMChunk(readElementContent, readElementType);
	const createWebmPcmMediaRecorder = createWebmPcmMediaRecorderFactory(createBlobEvent, createInvalidModificationError, createNotSupportedError$1, decodeWebMChunk, readVariableSizeInteger);
	const createEventTarget = createEventTargetFactory(window$1);
	const nativeMediaRecorderConstructor = createNativeMediaRecorderConstructor(window$1);
	const createNativeMediaRecorder = createNativeMediaRecorderFactory(createInvalidModificationError, createNotSupportedError$1);
	const mediaRecorderConstructor = createMediaRecorderConstructor(createNativeMediaRecorder, createNotSupportedError$1, createWebAudioMediaRecorder, createWebmPcmMediaRecorder, encoderRegexes, createEventTargetConstructor$1(createEventTarget, wrapEventListener), nativeMediaRecorderConstructor);
	const register = async port => {
	  encoderRegexes.push(await register$1(port));
	};

	const wrap = createBroker({
	  characterize: ({
	    call
	  }) => {
	    return () => call('characterize');
	  },
	  encode: ({
	    call
	  }) => {
	    return (recordingId, timeslice) => {
	      return call('encode', {
	        recordingId,
	        timeslice
	      });
	    };
	  },
	  record: ({
	    call
	  }) => {
	    return async (recordingId, sampleRate, typedArrays) => {
	      await call('record', {
	        recordingId,
	        sampleRate,
	        typedArrays
	      }, typedArrays.map(({
	        buffer
	      }) => buffer));
	    };
	  }
	});
	const load = url => {
	  const worker = new Worker(url);
	  return wrap(worker);
	};

	// This is the minified and stringified code of the extendable-media-recorder-wav-encoder-worker package.
	const worker = `(()=>{var e={775:function(e,t,r){!function(e,t,r,n){"use strict";function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(t),a=o(r),i=o(n),u=function(e,t){return void 0===t?e:t.reduce((function(e,t){if("capitalize"===t){var r=e.charAt(0).toUpperCase(),n=e.slice(1);return"".concat(r).concat(n)}return"dashify"===t?a.default(e):"prependIndefiniteArticle"===t?"".concat(i.default(e)," ").concat(e):e}),e)},c=function(e){var t=e.name+e.modifiers.map((function(e){return"\\\\.".concat(e,"\\\\(\\\\)")})).join("");return new RegExp("\\\\$\\\\{".concat(t,"}"),"g")},l=function(e,t){for(var r=/\\\${([^.}]+)((\\.[^(]+\\(\\))*)}/g,n=[],o=r.exec(e);null!==o;){var a={modifiers:[],name:o[1]};if(void 0!==o[3])for(var i=/\\.[^(]+\\(\\)/g,l=i.exec(o[2]);null!==l;)a.modifiers.push(l[0].slice(1,-2)),l=i.exec(o[2]);n.push(a),o=r.exec(e)}var d=n.reduce((function(e,r){return e.map((function(e){return"string"==typeof e?e.split(c(r)).reduce((function(e,n,o){return 0===o?[n]:r.name in t?[].concat(s.default(e),[u(t[r.name],r.modifiers),n]):[].concat(s.default(e),[function(e){return u(e[r.name],r.modifiers)},n])}),[]):[e]})).reduce((function(e,t){return[].concat(s.default(e),s.default(t))}),[])}),[e]);return function(e){return d.reduce((function(t,r){return[].concat(s.default(t),"string"==typeof r?[r]:[r(e)])}),[]).join("")}},d=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=void 0===e.code?void 0:l(e.code,t),n=void 0===e.message?void 0:l(e.message,t);function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=arguments.length>1?arguments[1]:void 0,s=void 0===o&&(t instanceof Error||void 0!==t.code&&"Exception"===t.code.slice(-9))?{cause:t,missingParameters:{}}:{cause:o,missingParameters:t},a=s.cause,i=s.missingParameters,u=void 0===n?new Error:new Error(n(i));return null!==a&&(u.cause=a),void 0!==r&&(u.code=r(i)),void 0!==e.status&&(u.status=e.status),u}return o};e.compile=d,Object.defineProperty(e,"__esModule",{value:!0})}(t,r(106),r(881),r(507))},881:e=>{"use strict";e.exports=(e,t)=>{if("string"!=typeof e)throw new TypeError("expected a string");return e.trim().replace(/([a-z])([A-Z])/g,"$1-$2").replace(/\\W/g,(e=>/[À-ž]/.test(e)?e:"-")).replace(/^-+|-+$/g,"").replace(/-{2,}/g,(e=>t&&t.condense?"-":e)).toLowerCase()}},107:function(e,t){!function(e){"use strict";var t=function(e){return function(t){var r=e(t);return t.add(r),r}},r=function(e){return function(t,r){return e.set(t,r),r}},n=void 0===Number.MAX_SAFE_INTEGER?9007199254740991:Number.MAX_SAFE_INTEGER,o=536870912,s=2*o,a=function(e,t){return function(r){var a=t.get(r),i=void 0===a?r.size:a<s?a+1:0;if(!r.has(i))return e(r,i);if(r.size<o){for(;r.has(i);)i=Math.floor(Math.random()*s);return e(r,i)}if(r.size>n)throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");for(;r.has(i);)i=Math.floor(Math.random()*n);return e(r,i)}},i=new WeakMap,u=r(i),c=a(u,i),l=t(c);e.addUniqueNumber=l,e.generateUniqueNumber=c,Object.defineProperty(e,"__esModule",{value:!0})}(t)},507:e=>{var t=function(e){var t,r,n=/\\w+/.exec(e);if(!n)return"an";var o=(r=n[0]).toLowerCase(),s=["honest","hour","hono"];for(t in s)if(0==o.indexOf(s[t]))return"an";if(1==o.length)return"aedhilmnorsx".indexOf(o)>=0?"an":"a";if(r.match(/(?!FJO|[HLMNS]Y.|RY[EO]|SQU|(F[LR]?|[HL]|MN?|N|RH?|S[CHKLMNPTVW]?|X(YL)?)[AEIOU])[FHLMNRSX][A-Z]/))return"an";var a=[/^e[uw]/,/^onc?e\\b/,/^uni([^nmd]|mo)/,/^u[bcfhjkqrst][aeiou]/];for(t=0;t<a.length;t++)if(o.match(a[t]))return"a";return r.match(/^U[NK][AIEO]/)?"a":r==r.toUpperCase()?"aedhilmnorsx".indexOf(o[0])>=0?"an":"a":"aeiou".indexOf(o[0])>=0||o.match(/^y(b[lor]|cl[ea]|fere|gg|p[ios]|rou|tt)/)?"an":"a"};void 0!==e.exports?e.exports=t:window.indefiniteArticle=t},768:e=>{e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n},e.exports.__esModule=!0,e.exports.default=e.exports},907:(e,t,r)=>{var n=r(768);e.exports=function(e){if(Array.isArray(e))return n(e)},e.exports.__esModule=!0,e.exports.default=e.exports},642:e=>{e.exports=function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)},e.exports.__esModule=!0,e.exports.default=e.exports},344:e=>{e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},106:(e,t,r)=>{var n=r(907),o=r(642),s=r(906),a=r(344);e.exports=function(e){return n(e)||o(e)||s(e)||a()},e.exports.__esModule=!0,e.exports.default=e.exports},906:(e,t,r)=>{var n=r(768);e.exports=function(e,t){if(e){if("string"==typeof e)return n(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(e,t):void 0}},e.exports.__esModule=!0,e.exports.default=e.exports}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var s=t[n]={exports:{}};return e[n].call(s.exports,s,s.exports,r),s.exports}(()=>{"use strict";var e=r(775);const t=-32603,n=-32602,o=-32601,s=(0,e.compile)({message:'The requested method called "\${method}" is not supported.',status:o}),a=(0,e.compile)({message:'The handler of the method called "\${method}" returned no required result.',status:t}),i=(0,e.compile)({message:'The handler of the method called "\${method}" returned an unexpected result.',status:t}),u=(0,e.compile)({message:'The specified parameter called "portId" with the given value "\${portId}" does not identify a port connected to this worker.',status:n}),c=(e,t)=>async r=>{let{data:{id:n,method:o,params:u}}=r;const c=t[o];try{if(void 0===c)throw s({method:o});const t=void 0===u?c():c(u);if(void 0===t)throw a({method:o});const r=t instanceof Promise?await t:t;if(null===n){if(void 0!==r.result)throw i({method:o})}else{if(void 0===r.result)throw i({method:o});const{result:t,transferables:s=[]}=r;e.postMessage({id:n,result:t},s)}}catch(t){const{message:r,status:o=-32603}=t;e.postMessage({error:{code:o,message:r},id:n})}};var l=r(107);const d=new Map,f=(e,t,r)=>({...t,connect:r=>{let{port:n}=r;n.start();const o=e(n,t),s=(0,l.generateUniqueNumber)(d);return d.set(s,(()=>{o(),n.close(),d.delete(s)})),{result:s}},disconnect:e=>{let{portId:t}=e;const r=d.get(t);if(void 0===r)throw u({portId:t.toString()});return r(),{result:null}},isSupported:async()=>{if(await new Promise((e=>{const t=new ArrayBuffer(0),{port1:r,port2:n}=new MessageChannel;r.onmessage=t=>{let{data:r}=t;return e(null!==r)},n.postMessage(t,[t])}))){const e=r();return{result:e instanceof Promise?await e:e}}return{result:!1}}}),p=function(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:()=>!0;const n=f(p,t,r),o=c(e,n);return e.addEventListener("message",o),()=>e.removeEventListener("message",o)},m=e=>e.reduce(((e,t)=>e+t.length),0),h=(e,t)=>{const r=[];let n=0;e:for(;n<t;){const t=e.length;for(let o=0;o<t;o+=1){const t=e[o];void 0===r[o]&&(r[o]=[]);const s=t.shift();if(void 0===s)break e;r[o].push(s),0===o&&(n+=s.length)}}if(n>t){const o=n-t;r.forEach(((t,r)=>{const n=t.pop(),s=n.length-o;t.push(n.subarray(0,s)),e[r].unshift(n.subarray(s))}))}return r},v=new Map,g=(e=>(t,r,n)=>{const o=e.get(t);if(void 0===o){const o={channelDataArrays:n.map((e=>[e])),isComplete:!0,sampleRate:r};return e.set(t,o),o}return o.channelDataArrays.forEach(((e,t)=>e.push(n[t]))),o})(v),x=((e,t)=>(r,n,o,s)=>{const a=o>>3,i="subsequent"===n?0:44,u=r.length,c=e(r[0]),l=new ArrayBuffer(c*u*a+i),d=new DataView(l);return"subsequent"!==n&&t(d,o,u,"complete"===n?c:Number.POSITIVE_INFINITY,s),r.forEach(((e,t)=>{let r=i+t*a;e.forEach((e=>{const t=e.length;for(let n=0;n<t;n+=1){const t=e[n];d.setInt16(r,t<0?32768*Math.max(-1,t):32767*Math.min(1,t),!0),r+=u*a}}))})),[l]})(m,((e,t,r,n,o)=>{const s=t>>3,a=Math.min(n*r*s,4294967251);e.setUint32(0,1380533830),e.setUint32(4,a+36,!0),e.setUint32(8,1463899717),e.setUint32(12,1718449184),e.setUint32(16,16,!0),e.setUint16(20,1,!0),e.setUint16(22,r,!0),e.setUint32(24,o,!0),e.setUint32(28,o*r*s,!0),e.setUint16(32,r*s,!0),e.setUint16(34,t,!0),e.setUint32(36,1684108385),e.setUint32(40,a,!0)})),w=new Map;p(self,{characterize:()=>({result:/^audio\\/wav$/}),encode:e=>{let{recordingId:t,timeslice:r}=e;const n=w.get(t);void 0!==n&&(w.delete(t),n.reject(new Error("Another request was made to initiate an encoding.")));const o=v.get(t);if(null!==r){if(void 0===o||m(o.channelDataArrays[0])*(1e3/o.sampleRate)<r)return new Promise(((e,n)=>{w.set(t,{reject:n,resolve:e,timeslice:r})}));const e=h(o.channelDataArrays,Math.ceil(r*(o.sampleRate/1e3))),n=x(e,o.isComplete?"initial":"subsequent",16,o.sampleRate);return o.isComplete=!1,{result:n,transferables:n}}if(void 0!==o){const e=x(o.channelDataArrays,o.isComplete?"complete":"subsequent",16,o.sampleRate);return v.delete(t),{result:e,transferables:e}}return{result:[],transferables:[]}},record:e=>{let{recordingId:t,sampleRate:r,typedArrays:n}=e;const o=g(t,r,n),s=w.get(t);if(void 0!==s&&m(o.channelDataArrays[0])*(1e3/r)>=s.timeslice){const e=h(o.channelDataArrays,Math.ceil(s.timeslice*(r/1e3))),n=x(e,o.isComplete?"initial":"subsequent",16,r);o.isComplete=!1,w.delete(t),s.resolve({result:n,transferables:n})}return{result:null}}})})()})();`; // tslint:disable-line:max-line-length

	const blob = new Blob([worker], {
	  type: 'application/javascript; charset=utf-8'
	});
	const url = URL.createObjectURL(blob);
	const extendableMediaRecorderWavEncoder = load(url);
	const connect = extendableMediaRecorderWavEncoder.connect;
	URL.revokeObjectURL(url);

	var c$1;!function(e){e.AbortError="media_aborted",e.NotAllowedError="permission_denied",e.NotFoundError="no_specified_media_found",e.NotReadableError="media_in_use",e.OverconstrainedError="invalid_media_constraints",e.TypeError="no_constraints",e.NONE="",e.NO_RECORDER="recorder_error";}(c$1||(c$1={}));var a$1=function(){function e(){this.blobProperties=void 0,this.url=null,this.blob=new Blob,this.mediaChunks=[];}var r=e.prototype;return r.setBlobProperties=function(e){this.blobProperties=e;},r.storeChunk=function(e){this.mediaChunks.push(e);},r.stop=function(){var e=new Blob(this.mediaChunks,this.blobProperties),r=URL.createObjectURL(e);this.blob=e,this.url=r;},r.getUrl=function(){return this.url},r.getBlob=function(){return this.blob},e}();function s$1(s){var d=s.audio,l=void 0===d||d,f=s.video,v=void 0!==f&&f,p$1=s.onStop,h=void 0===p$1?function(){return null}:p$1,m=s.onStart,b=void 0===m?function(){return null}:m,g=s.blobPropertyBag,w=s.screen,y=void 0!==w&&w,P=s.mediaRecorderOptions,R=void 0===P?void 0:P,E=s.customMediaStream,k=void 0===E?null:E,M=s.stopStreamsOnStop,T=void 0===M||M,O=s.askPermissionOnMount,S=void 0!==O&&O,_$1=s.videoStorageFactory,j=void 0===_$1?function(){return new a$1}:_$1,N=s.timeslice,U=void 0===N?void 0:N,B=_(null),A=_(null),D=_(null),C=p("idle"),L=C[0],x=C[1],F=p(!1),V=F[0],q=F[1],I=p(void 0),z=I[0],G=I[1],H=p("NONE"),J=H[0],K=H[1];h$1(function(){!function(){try{Promise.resolve(connect()).then(function(r){return Promise.resolve(register(r)).then(function(){})});}catch(e){return Promise.reject(e)}}();},[]);var Q=!1,W=T$1(function(){try{x("acquiring_media");var e={audio:"boolean"==typeof l?!!l:l,video:"boolean"==typeof v?!!v:v},r=null,n=function(n,t){try{var o=function(n,t){try{var o=function(){function n(){x("idle");}var t=function(){if(k)r=k;else {var n=y?Promise.resolve(window.navigator.mediaDevices.getDisplayMedia({video:v||!0})).then(function(e){function n(){D.current=r;}(r=e).getVideoTracks()[0].addEventListener("ended",function(){re();});var t=function(){if(l)return Promise.resolve(window.navigator.mediaDevices.getUserMedia({audio:l})).then(function(e){e.getAudioTracks().forEach(function(e){var n;return null==(n=r)?void 0:n.addTrack(e)});})}();return t&&t.then?t.then(n):n()}):Promise.resolve(window.navigator.mediaDevices.getUserMedia(e)).then(function(e){r=e;});if(n&&n.then)return n.then(function(){})}}();return t&&t.then?t.then(n):n()}();}catch(e){return t(e)}return o&&o.then?o.then(void 0,t):o}(0,function(e){K(e.name),x("idle");});}catch(e){return t(!0,e)}return o&&o.then?o.then(t.bind(null,!1),t.bind(null,!0)):t(!1,o)}(0,function(e,n){if(D.current=r,e)throw n;return n});return Promise.resolve(n&&n.then?n.then(function(){}):void 0)}catch(e){return Promise.reject(e)}},[l,v,y]);h$1(function(){if(!window.MediaRecorder)throw new Error("Unsupported Browser");if(y&&!window.navigator.mediaDevices.getDisplayMedia)throw new Error("This browser doesn't support screen capturing");var e=function(e){var r=navigator.mediaDevices.getSupportedConstraints(),n=Object.keys(e).filter(function(e){return !r[e]});n.length>0&&console.error("The constraints "+n.join(",")+" doesn't support on this browser. Please check your ReactMediaRecorder component.");};return "object"==typeof l&&e(l),"object"==typeof v&&e(v),R&&R.mimeType&&(MediaRecorder.isTypeSupported(R.mimeType)||console.error("The specified MIME type you supplied for MediaRecorder doesn't support this browser")),!D.current&&S&&W(),function(){D.current&&D.current.getTracks().forEach(function(e){return e.clone().stop()});}},[l,y,v,W,R,S]);var X=function(e){var r,n=e.data;if(!Q){var t,o=Object.assign({type:n.type},g||(v?{type:"video/mp4"}:{type:"audio/wav"}));null==(t=A.current)||t.setBlobProperties(o),Q=!0;}null==(r=A.current)||r.storeChunk(n);},Y=function(){b();},Z=function(){var e,r,n,t;null==(e=A.current)||e.stop();var o=null!=(r=null==(n=A.current)?void 0:n.getUrl())?r:void 0;x("stopped"),G(o),h(o,null==(t=A.current)?void 0:t.getBlob());},$=function(e){q(e),D.current&&D.current.getAudioTracks().forEach(function(r){return r.enabled=!e});},ee=function(){D.current&&D.current.getTracks().forEach(function(e){return e.stop()});},re=function(){try{return B.current&&"inactive"!==B.current.state&&(x("stopping"),B.current.stop()),T&&ee(),Promise.resolve()}catch(e){return Promise.reject(e)}};return {error:c$1[J],muteAudio:function(){return $(!0)},unMuteAudio:function(){return $(!1)},startRecording:function(){try{var e=function(){return function(){if(D.current){var e=function(){D.current.active&&(A.current=j(),Q=!1,B.current=new mediaRecorderConstructor(D.current,R||void 0),B.current.ondataavailable=X,B.current.onstop=Z,B.current.onstart=Y,B.current.onerror=function(){K("NO_RECORDER"),x("idle");},B.current.start(U),x("recording"));},n=D.current.getTracks().some(function(e){return "ended"===e.readyState}),t=function(){if(n)return Promise.resolve(W()).then(function(){})}();return t&&t.then?t.then(e):e()}}()};K("NONE");var n=function(){if(!D.current)return Promise.resolve(W()).then(function(){})}();return Promise.resolve(n&&n.then?n.then(e):e())}catch(e){return Promise.reject(e)}},pauseRecording:function(){B.current&&"recording"===B.current.state&&(x("paused"),B.current.pause());},resumeRecording:function(){B.current&&"paused"===B.current.state&&(x("recording"),B.current.resume());},stopRecording:re,stopStream:ee,getMediaStream:W,mediaBlobUrl:z,status:L,isAudioMuted:V,previewStream:D.current?new MediaStream(D.current.getVideoTracks()):null,previewAudioStream:D.current?new MediaStream(D.current.getAudioTracks()):null,clearBlobUrl:function(){z&&URL.revokeObjectURL(z),G(void 0),x("idle");}}}

	var e=0;function t(t){return "__private_"+e+++"_"+t}function i(e,t){if(!Object.prototype.hasOwnProperty.call(e,t))throw new TypeError("attempted to use private field on non-instance");return e}var r=function(e){this.value=e;},n=t("head"),o=t("end"),u=function(){function e(){Object.defineProperty(this,n,{writable:!0,value:void 0}),Object.defineProperty(this,o,{writable:!0,value:void 0});}var t=e.prototype;return t.enqueue=function(e){var t=new r(e);i(this,o)[o]?(i(this,o)[o].next=t,i(this,o)[o]=t):i(this,n)[n]=i(this,o)[o]=t;},t.dequeue=function(){var e=i(this,n)[n];return i(this,n)[n]=null==e?void 0:e.next,i(this,n)[n]||(i(this,o)[o]=void 0),null==e?void 0:e.value},e}();function s(e){return {done:!1,value:e}}var h={done:!0},a=t("chunkQueue"),l=t("resolveQueue"),v=t("isInProgress"),c=t("isLocked"),d=function(){function e(){Object.defineProperty(this,a,{writable:!0,value:void 0}),Object.defineProperty(this,l,{writable:!0,value:void 0}),Object.defineProperty(this,v,{writable:!0,value:void 0}),Object.defineProperty(this,c,{writable:!0,value:void 0}),this.url=null,i(this,a)[a]=new u,i(this,l)[l]=new u,i(this,v)[v]=!0,i(this,c)[c]=!1;}var t=e.prototype;return t.setUrl=function(e){this.url=e;},t.setBlobProperties=function(e){this.blobProperties=e;},t.storeChunk=function(e){i(this,v)[v]=!0;var t=i(this,l)[l].dequeue();t?t(s(e)):i(this,a)[a].enqueue(e);},t.stop=function(){i(this,v)[v]=!1;},t.reset=function(){i(this,v)[v]=!0,i(this,a)[a]=new u,i(this,l)[l]=new u,i(this,c)[c]=!1;},t.getUrl=function(){return this.url},t.getBlob=function(){},t.getReader=function(){if(i(this,c)[c])throw new Error("ReadableStorage is locked.");i(this,c)[c]=!0;var e=this;return {read:function(){var t=i(e,a)[a].dequeue();return t?Promise.resolve(s(t)):i(e,v)[v]?new Promise(function(t){return i(e,l)[l].enqueue(t)}):Promise.resolve(h)}}},e}();

	var css_248z$f = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.popup {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 2;\n  overflow: scroll;\n}\n.popup-container {\n  z-index: 1001;\n  width: 100%;\n}\n.popup-container-dark {\n  background: rgb(36, 35, 35);\n}\n.popup-container-light {\n  background: rgb(253, 253, 253);\n}\n.popup .icon-btn-popup {\n  padding: 10px;\n  font-size: 1.2em;\n  border: none;\n  background: none;\n}\n.popup .icon-btn-popup.btn-overlay {\n  z-index: 1001;\n}\n.popup .icon-btn-popup-light {\n  color: #000000;\n}\n.popup .icon-btn-popup-dark {\n  color: #ffffff;\n}\n.popup .background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(229, 229, 229, 0.95);\n  min-width: 100%;\n  min-height: 100%;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .popup {\n    min-width: 100%;\n    min-height: 100%;\n  }\n  .popup-container {\n    align-items: center;\n    min-width: 100%;\n    min-height: 100%;\n  }\n  .popup-container-content {\n    align-items: center;\n    margin-top: 4%;\n  }\n}";
	styleInject(css_248z$f);

	function PopUp(_ref) {
	  var onClose = _ref.onClose,
	      children = _ref.children,
	      closeButtonOverlay = _ref.closeButtonOverlay,
	      themeColor = _ref.themeColor;

	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1]; // const [isDark, setIsDark] = useState(false);


	  if (themeColor === "dark") {
	    setIsDark(true);
	  } // environment conditionals


	  var envCondition = isDark ? "dark" : "light";
	  return h$2(BaseComponent, {
	    style: css_248z$f,
	    className: "popup"
	  }, h$2("div", {
	    className: "popup-container popup-container-".concat(envCondition)
	  }, h$2("div", {
	    className: "popup-container-content d-flex justify-content-center"
	  }, h$2("button", {
	    type: "button",
	    className: "icon-btn-popup icon-btn-popup-".concat(envCondition, " ").concat(closeButtonOverlay && "btn-overlay"),
	    onClick: onClose
	  }, "\xD7")), children), h$2("div", {
	    onClick: onClose,
	    className: "background"
	  }));
	}

	var css_248z$e = "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);\n.trust-video {\n  border: none;\n  width: 100%;\n  height: auto;\n  transform: rotateY(180deg);\n  -webkit-transform: rotateY(180deg); /* Safari and Chrome */\n  -moz-transform: rotateY(180deg); /* Firefox */\n}\n.trust-video-wrapper {\n  width: 100%;\n  margin-top: -80%;\n  align-items: center;\n}\n.trust-video-wrapper:hover .trust-video-controls {\n  visibility: visible;\n  opacity: 1;\n}\n.trust-video-msg {\n  display: flex;\n  align-items: center;\n}\n.trust-video-controls {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  margin-top: 35%;\n  transform: translate(0, -50%);\n  padding-left: 36px;\n  border-radius: 10px;\n  height: 4em;\n  align-items: center;\n  justify-content: space-between;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.25s ease-out;\n  display: none;\n}\n.trust-video-controls.show {\n  display: flex;\n}\n.trust-video-play {\n  border-color: transparent;\n  transition: 0.3s;\n  font-size: 3em;\n  margin: auto;\n  line-height: 1.5em;\n  width: 3em;\n  height: 3em;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  background-color: #ffdd33;\n  border-radius: 50%;\n  font: normal normal normal 18px/1 FontAwesome;\n}\n.trust-video-play:before {\n  content: \"\\f04b\";\n}\n.trust-video-play.paused:before {\n  content: \"\\f04c\";\n}\n.trust-video-volume {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  border-radius: 20%;\n  line-height: 1.5em;\n  width: 2em;\n  height: 1.5em;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  left: 20px;\n}\n.trust-video-volume:before {\n  content: \"\\f028\";\n}\n.trust-video-volume.off:before {\n  content: \"\\f026\";\n}\n.trust-video-fullscreen {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  line-height: 2.5rem;\n  width: 3em;\n  border-radius: 20%;\n  height: 2.5rem;\n  margin-right: 5%;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  right: 20px;\n}\n.trust-video-fullscreen:before {\n  content: \"\\f065\";\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .trust-video-wrapper {\n    margin-top: 20%;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .trust-video {\n    border: none;\n    width: 70%;\n  }\n}";
	styleInject(css_248z$e);

	var Player = (function (videoUrl, preview, previewStream) {
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      controlsVisible = _useState2[0],
	      setControlsVisible = _useState2[1];

	  var videoRef = _(null);
	  var playBtnRef = _(null);
	  var muteBtnRef = _(null); // const [size, setSize] = useState({width: 0, height: 0});

	  s$3(function () {
	    function updateSize() {// setSize({width: window.innerWidth, height: window.innerHeight});
	    }

	    window.addEventListener("resize", updateSize);
	    return function () {
	      return window.removeEventListener("resize", updateSize);
	    };
	  }, []);

	  var play = /*#__PURE__*/function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	      return _regeneratorRuntime().wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              getDuration();

	              if (!videoRef.current.paused) {
	                _context.next = 7;
	                break;
	              }

	              _context.next = 4;
	              return videoRef.current.play();

	            case 4:
	              playBtnRef.current.classList.add("paused");
	              _context.next = 9;
	              break;

	            case 7:
	              videoRef.current.pause();
	              playBtnRef.current.classList.remove("paused");

	            case 9:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee);
	    }));

	    return function play() {
	      return _ref.apply(this, arguments);
	    };
	  }();

	  var getDuration = function getDuration() {
	    var dur = videoRef.current.duration;
	    dur = Number(dur.toFixed()); // const formatted = "";
	    // setLength(dur);
	    // setFormattedLength(formatted);

	    return dur;
	  };

	  var mute = function mute() {
	    videoRef.current.muted = !videoRef.current.muted;

	    if (videoRef.current.muted) {
	      muteBtnRef.current.classList.add("off");
	    } else {
	      muteBtnRef.current.classList.remove("off");
	    }
	  };

	  var fullScreen = /*#__PURE__*/function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
	      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return videoRef.current.requestFullscreen();

	            case 2:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2);
	    }));

	    return function fullScreen() {
	      return _ref2.apply(this, arguments);
	    };
	  }();

	  h$1(function () {
	    if (videoRef.current) {
	      setControlsVisible(true);
	    }
	  }, [videoUrl]);

	  var Preview = function Preview(_ref3) {
	    var stream = _ref3.stream;
	    var previewRef = _(null);
	    h$1(function () {
	      if (previewRef.current && stream && preview) {
	        previewRef.current.srcObject = stream;
	      }
	    }, [stream]);

	    if (!stream) {
	      return null;
	    }

	    if (!stream.active) {
	      return h$2("div", {
	        className: "trust-video-msg"
	      }, h$2("p", null, "No video preview to show at the moment. Please hold on!!"));
	    }

	    return h$2("video", {
	      className: "trust-video preview-video",
	      id: "trustVideoPreview",
	      ref: previewRef,
	      autoPlay: true
	    }, h$2("track", {
	      kind: "captions"
	    }));
	  };

	  var VideoSrc = function VideoSrc() {
	    if (videoUrl) {
	      return h$2("video", {
	        className: "trust-video",
	        id: "trustVideo",
	        ref: videoRef,
	        autoPlay: true
	      }, h$2("source", {
	        className: "trust-video",
	        src: videoUrl,
	        type: "video/mp4"
	      }), h$2("source", {
	        src: videoUrl,
	        type: "video/webm"
	      }), h$2("track", {
	        kind: "captions"
	      }));
	    }

	    return h$2(Preview, {
	      stream: previewStream
	    });
	  };

	  return h$2("div", {
	    className: "d-flex justify-content-center mt-4 trust-video-wrapper"
	  }, h$2(VideoSrc, null), h$2("div", {
	    className: "trust-video-controls ".concat(controlsVisible && "show")
	  }, h$2("button", {
	    ref: muteBtnRef,
	    type: "button",
	    className: "trust-video-volume trust-video-control ".concat(videoRef.current && videoRef.current.muted && "off"),
	    onClick: mute
	  }, " "), !preview && h$2("button", {
	    ref: playBtnRef,
	    type: "button",
	    className: "trust-video-play trust-video-control paused",
	    onClick: play
	  }, " "), h$2("div", {
	    className: "trust-video-progress"
	  }), !preview && h$2("button", {
	    type: "button",
	    className: "trust-video-fullscreen trust-video-control",
	    onClick: fullScreen
	  }, " ")), h$2("section", {
	    className: "logo-video-section"
	  }, h$2("div", {
	    className: "logo-video-position"
	  }, h$2(Logo, null))));
	});

	var css_248z$d = ".spinner {\n  -webkit-transform-origin: 50% 65%;\n  transform-origin: 50% 65%;\n}\n\n@-webkit-keyframes dash {\n  to {\n    stroke-dashoffset: 136;\n  }\n}\n@keyframes dash {\n  to {\n    stroke-dashoffset: 136;\n  }\n}\n@-webkit-keyframes rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}";
	styleInject(css_248z$d);

	/* eslint max-len: 0 */
	function videoIcon$1() {
	  return h$2("svg", {
	    style: css_248z$d,
	    className: "spinner",
	    id: "goo-loader",
	    width: "90",
	    height: "90",
	    "aria-label": "audio-loading"
	  }, h$2("filter", {
	    id: "fancy-goo"
	  }, h$2("feGaussianBlur", {
	    in: "SourceGraphic",
	    stdDeviation: "6",
	    result: "blur"
	  }), h$2("feColorMatrix", {
	    in: "blur",
	    mode: "matrix",
	    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
	    result: "goo"
	  }), h$2("feComposite", {
	    in: "SourceGraphic",
	    in2: "goo",
	    operator: "atop"
	  })), h$2("g", {
	    filter: "url(#fancy-goo)"
	  }, h$2("animateTransform", {
	    id: "mainAnim",
	    attributeName: "transform",
	    attributeType: "XML",
	    type: "rotate",
	    from: "0 50 50",
	    to: "359 50 50",
	    dur: "1.2s",
	    repeatCount: "indefinite"
	  }), h$2("circle", {
	    cx: "50%",
	    cy: "40",
	    r: "11"
	  }, h$2("animate", {
	    id: "cAnim1",
	    attributeType: "XML",
	    attributeName: "cy",
	    dur: "0.6s",
	    begin: "0;cAnim1.end+0.2s",
	    calcMode: "spline",
	    values: "40;20;40",
	    keyTimes: "0;0.3;1",
	    keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
	  })), h$2("circle", {
	    cx: "50%",
	    cy: "60",
	    r: "11"
	  }, h$2("animate", {
	    id: "cAnim2",
	    attributeType: "XML",
	    attributeName: "cy",
	    dur: "0.6s",
	    begin: "0.4s;cAnim2.end+0.2s",
	    calcMode: "spline",
	    values: "60;80;60",
	    keyTimes: "0;0.3;1",
	    keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
	  }))));
	}

	var css_248z$c = "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);\nbody {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.trust-video {\n  border: none;\n  width: 100%;\n  height: auto;\n  transform: rotateY(180deg);\n  -webkit-transform: rotateY(180deg); /* Safari and Chrome */\n  -moz-transform: rotateY(180deg); /* Firefox */\n}\n.trust-video-wrapper {\n  width: 100%;\n  margin-top: -80%;\n  align-items: center;\n}\n.trust-video-wrapper:hover .trust-video-controls {\n  visibility: visible;\n  opacity: 1;\n}\n.trust-video-msg {\n  display: flex;\n  align-items: center;\n}\n.trust-video-controls {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  margin-top: 35%;\n  transform: translate(0, -50%);\n  padding-left: 36px;\n  border-radius: 10px;\n  height: 4em;\n  align-items: center;\n  justify-content: space-between;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.25s ease-out;\n  display: none;\n}\n.trust-video-controls.show {\n  display: flex;\n}\n.trust-video-play {\n  border-color: transparent;\n  transition: 0.3s;\n  font-size: 3em;\n  margin: auto;\n  line-height: 1.5em;\n  width: 3em;\n  height: 3em;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  background-color: #ffdd33;\n  border-radius: 50%;\n  font: normal normal normal 18px/1 FontAwesome;\n}\n.trust-video-play:before {\n  content: \"\\f04b\";\n}\n.trust-video-play.paused:before {\n  content: \"\\f04c\";\n}\n.trust-video-volume {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  border-radius: 20%;\n  line-height: 1.5em;\n  width: 2em;\n  height: 1.5em;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  left: 20px;\n}\n.trust-video-volume:before {\n  content: \"\\f028\";\n}\n.trust-video-volume.off:before {\n  content: \"\\f026\";\n}\n.trust-video-fullscreen {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  line-height: 2.5rem;\n  width: 3em;\n  border-radius: 20%;\n  height: 2.5rem;\n  margin-right: 5%;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  right: 20px;\n}\n.trust-video-fullscreen:before {\n  content: \"\\f065\";\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .trust-video-wrapper {\n    margin-top: 20%;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .trust-video {\n    border: none;\n    width: 70%;\n  }\n}\n.utu-screen-recording {\n  width: 100%;\n  height: 100vh;\n  margin: 5% auto 0;\n  position: relative;\n  z-index: 1;\n  justify-content: center;\n}\n\n.btn-round {\n  border: none;\n  margin: 5px 0;\n  width: 6rem;\n  height: 6rem;\n  border: none;\n  font-size: 9px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n.btn-round-light {\n  background-color: rgb(252, 229, 70);\n}\n.btn-round-dark {\n  background-color: rgb(252, 229, 70);\n}\n.btn-round-loading {\n  position: absolute;\n  bottom: 5.5rem;\n}\n.btn-round-spinner-light {\n  fill: #000000;\n}\n.btn-round-spinner-dark {\n  fill: #000000;\n}\n.btn-round-play {\n  width: 4rem;\n  margin-left: 0.5rem;\n}\n.btn-round-play-light {\n  fill: #000000;\n}\n.btn-round-play-dark {\n  fill: #000000;\n}\n.btn-round-stop {\n  position: absolute;\n  bottom: 17rem;\n}\n.btn-round-stop-light {\n  fill: #000000;\n}\n.btn-round-stop-dark {\n  fill: #000000;\n}\n.btn-round-text-light {\n  color: #000000;\n}\n.btn-round-text-dark {\n  color: #000000;\n}\n.btn-container {\n  display: flex;\n  z-index: 0;\n  justify-content: center;\n}\n.btn-stop-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 5px;\n}\n.btn-stop-icon-light {\n  background: #000000;\n}\n.btn-stop-icon-dark {\n  background: #000000;\n}\n\n.video-recorder {\n  padding-top: 0;\n  padding-bottom: 4rem;\n  height: fit-content;\n}\n\n.video-container {\n  display: flex;\n  justify-content: center;\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n.response-message {\n  height: 3rem;\n  line-height: 3rem;\n  width: 100%;\n}\n\n.x-utu-video-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .video-recorder {\n    padding-bottom: 4rem;\n    height: fit-content;\n    background-color: rgb(253, 253, 253) !important;\n  }\n  .utu-screen-recording {\n    max-height: 80rem;\n    min-width: 20rem;\n    width: 27rem;\n    height: 43rem;\n    margin: 5% auto 0;\n    z-index: 1;\n    justify-content: center;\n    border-bottom-left-radius: 2%;\n    border-bottom-right-radius: 2%;\n    border-bottom: 13px rgb(252, 229, 70) solid;\n  }\n  .btn-round-stop {\n    bottom: 2.5rem;\n  }\n  .video-container {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n}";
	styleInject(css_248z$c);

	function RecordIcon() {
	  // environments
	  var _useState = p(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0];
	      _useState2[1];

	  return h$2("svg", {
	    className: "video-icon video-icon-".concat(isDark ? "dark" : "light"),
	    viewBox: "0 0 512 512"
	  }, h$2("path", {
	    d: "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm0 32c70.7 0 128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
	  }));
	}

	new MediaStream();
	function Recorder(props) {
	  /**
	   * Holds the active reader retrieved from ReadableStorage.getReader() while a video is recording, or null while no
	   * video is recording.
	   */
	  var _useState = p(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeReader = _useState2[0],
	      setActiveReader = _useState2[1];

	  var _useState3 = p(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      videoUploading = _useState4[0],
	      setVideoUploading = _useState4[1];

	  var _useState5 = p(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1]; // environments


	  var _useState7 = p(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isDark = _useState8[0],
	      setIsDark = _useState8[1];

	  var walletAddress = q$1(WalletAddressContext);

	  if (props[ATTR_SOURCE_UUID] === "address") {
	    props[ATTR_SOURCE_UUID] = walletAddress;
	  }

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  var _getBaseProps = getBaseProps(props, TAG_FEEDBACK_FORM),
	      apiUrl = _getBaseProps.apiUrl; // environment conditionals


	  var envCondition = isDark ? "dark" : "light";
	  var constraints = {
	    // set user env var
	    height: 810,
	    width: 432,
	    frameRate: 24,
	    facingMode: "user"
	  };

	  var _useUploadVideoApi = useUploadVideoApi(apiUrl, activeReader),
	      publishedVideoUrl = _useUploadVideoApi.publishedVideoUrl,
	      successMessage = _useUploadVideoApi.successMessage,
	      errorMessage = _useUploadVideoApi.errorMessage;

	  var _useFeedbackApi = useFeedbackApi(apiUrl, props[ATTR_SOURCE_UUID], props[ATTR_TARGET_UUID], props[ATTR_TRANSACTION_ID]),
	      sendFeedback = _useFeedbackApi.sendFeedback;

	  var sendFeedbackOnce = T$1(function () {
	    return publishedVideoUrl && sendFeedback({
	      video: publishedVideoUrl
	    });
	  }, [sendFeedback, publishedVideoUrl]);
	  sendFeedbackOnce();

	  var VideoSrc = function VideoSrc(status, previewStream) {
	    if (publishedVideoUrl) {
	      return Player(publishedVideoUrl, false);
	    }

	    return Player(null, true, previewStream);
	  };

	  function videoStorageFactory() {
	    var storage = new d();
	    setActiveReader(storage.getReader());
	    return storage;
	  }

	  var _useReactMediaRecorde = s$1({
	    audio: true,
	    video: constraints,
	    videoStorageFactory: videoStorageFactory,
	    timeslice: 1000,
	    stopStreamsOnStop: false
	  }),
	      status = _useReactMediaRecorde.status,
	      startRecording = _useReactMediaRecorde.startRecording,
	      stopRecording = _useReactMediaRecorde.stopRecording,
	      getMediaStream = _useReactMediaRecorde.getMediaStream,
	      stopStream = _useReactMediaRecorde.stopStream,
	      previewStream = _useReactMediaRecorde.previewStream;

	  var isLoading = loading || ['stopping', 'acquiring_media'].includes(status);
	  var isReady = (status === 'idle' || status === 'stopped') && !isLoading;
	  var isRecording = status === 'recording';

	  var onStop = /*#__PURE__*/function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	      return _regeneratorRuntime().wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setLoading(true);
	              _context.next = 3;
	              return stopRecording();

	            case 3:
	              setActiveReader(null);
	              setVideoUploading(!videoUploading);
	              setLoading(false);

	            case 6:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee);
	    }));

	    return function onStop() {
	      return _ref.apply(this, arguments);
	    };
	  }();

	  var onClose = /*#__PURE__*/function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
	      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return onStop();

	            case 2:
	              stopStream();
	              props.onClose();

	            case 4:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2);
	    }));

	    return function onClose() {
	      return _ref2.apply(this, arguments);
	    };
	  }();

	  h$1(function () {
	    getMediaStream();
	    return function () {
	      stopStream();
	    };
	  }, []);
	  return h$2("div", {
	    className: "d-flex justify-content-center"
	  }, h$2("div", {
	    className: "text-center"
	  }, h$2("div", {
	    className: "btn-container"
	  }, h$2(PopUp, {
	    closeButtonOverlay: true,
	    onClose: onClose
	  }, h$2(BaseComponent, {
	    style: css_248z$c,
	    className: "utu-screen-recording d-flex flex-column align-items-center justify-content-center"
	  }, VideoSrc(status, previewStream), isRecording && h$2("button", {
	    type: "button",
	    className: "m-1 btn-round-stop btn-round-stop-".concat(envCondition, " btn-round btn-round-").concat(envCondition),
	    onClick: onStop
	  }, h$2("div", {
	    className: "btn-stop-icon btn-stop-icon-".concat(envCondition)
	  })), isReady && !publishedVideoUrl && h$2("button", {
	    type: "button",
	    className: "m-1 btn-round-stop btn-round-stop-".concat(envCondition, " btn-round btn-round-").concat(envCondition),
	    onClick: function onClick() {
	      startRecording();
	    }
	  }, h$2(RecordIcon, null)), isLoading && h$2("button", {
	    type: "button",
	    className: "m-1 btn-round-loading btn-round btn-round-".concat(envCondition)
	  }, h$2("div", {
	    className: "mb-2 mr-2 btn-round-spinner btn-round-spinner-".concat(envCondition)
	  }, h$2(videoIcon$1, null))), h$2("div", {
	    className: "video-msg d-flex align-items-center"
	  }, successMessage && h$2("h3", {
	    className: "response-message my-4 text-white bg-success"
	  }, " ", successMessage, " "), errorMessage && h$2("h3", {
	    className: "response-message my-4 text-white bg-danger"
	  }, " ", errorMessage, " ")), h$2("section", {
	    className: "logo-position-video"
	  }, h$2(Logo, null)))))));
	}

	function videoIcon() {
	  // environments
	  var _useState = p(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0];
	      _useState2[1];

	  return h$2("svg", {
	    className: "video-icon video-icon-".concat(isDark ? "dark" : "light"),
	    viewBox: "0 0 42 32",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, h$2("path", {
	    d: "M40.9471 1.06475C40.7407 0.94333 40.5061 0.877933 40.2666 0.875039C40.0271 0.872145 39.7911  0.931854 39.5817 1.04825L29.25 6.7875V6.5675C29.2482 5.05808 28.6477 3.61102 27.5802 2.54382C26.5128  1.47663 25.0655 0.876459 23.5561 0.875004H6.06887C4.55921 0.87646 3.1118 1.47682 2.04431 2.54431C0.976812  3.6118 0.376456 5.05922 0.375 6.56888V25.4311C0.376456 26.9408 0.976812 28.3882 2.04431 29.4557C3.1118  30.5232 4.55921 31.1235 6.06887 31.125H23.5561C25.0658 31.1235 26.5132 30.5232 27.5807 29.4557C28.6482  28.3882 29.2485 26.9408 29.25 25.4311V25.2125L39.5817 30.9531C39.7912 31.0696 40.0274 31.1293 40.267  31.1263C40.5065 31.1234 40.7412 31.0579 40.9477 30.9363C41.1541 30.8147 41.3253 30.6413 41.4441  30.4332C41.5629 30.2251 41.6252 29.9896 41.625 29.75V2.25C41.625 2.01052 41.5625 1.77518 41.4436  1.56729C41.3247 1.3594 41.1535 1.18617 40.9471 1.06475ZM26.5 25.4311C26.4993 26.2117 26.1889 26.96  25.637 27.512C25.085 28.0639 24.3367 28.3743 23.5561 28.375H6.06887C5.28833 28.3743 4.53997 28.0639  3.98805 27.512C3.43612 26.96 3.12573 26.2117 3.125 25.4311V6.56888C3.12573 5.78834 3.43612 5.03998  3.98805 4.48805C4.53997 3.93612 5.28833 3.62573 6.06887 3.625H23.5561C24.3367 3.62573 25.085 3.93612 25.637  4.48805C26.1889 5.03998 26.4993 5.78834 26.5 6.56888V25.4311ZM38.875 27.4125L29.25 22.0638V9.93488L38.875  4.5875V27.4125Z"
	  }));
	}

	function RecordVideo(props) {
	  /**
	   * Holds the active reader retrieved from ReadableStorage.getReader() while a video is recording, or null while no
	   * video is recording.
	   */
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      videoVisible = _useState2[0],
	      setVideoVisible = _useState2[1]; // environments


	  var _useState3 = p(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDark = _useState4[0],
	      setIsDark = _useState4[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  } // environment conditionals


	  var envCondition = isDark ? "dark" : "light";
	  return h$2(BaseComponent, {
	    style: css_248z$c,
	    className: "video-container utu-section utu-section-".concat(envCondition)
	  }, h$2("div", {
	    className: "x-utu-video-wrapper"
	  }, h$2("button", {
	    type: "button",
	    style: {
	      backgroundColor: props[ATTR_BTN_COLOR] === undefined ? null : "".concat(props[ATTR_BTN_COLOR])
	    },
	    className: "btn-round btn-round-".concat(envCondition),
	    onClick: function onClick() {
	      setVideoVisible(true);
	    }
	  }, h$2(videoIcon, null)), h$2("p", {
	    className: "mx-3 mt-3 btn-round-text-".concat(envCondition)
	  }, " ", h$2("b", null, "RECORD YOUR STORY"), " "), videoVisible && h$2(Recorder, _extends$1({}, props, {
	    onClose: function onClose() {
	      setVideoVisible(false);
	    }
	  }))));
	}

	function FeedbackForm(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }
	  /* eslint-disable react/jsx-props-no-spreading */


	  return h$2(BaseComponent, {
	    style: css_248z$m,
	    className: "utu-feedback-form"
	  }, h$2("div", {
	    className: "mobile-view"
	  }, h$2(RecordVideo, props), h$2("div", {
	    className: "x-utu-divider"
	  }), h$2(StarRatingInput, props), h$2(Badges, props), h$2(FeedbackTextInput, props), h$2(EndorsementForm, props), h$2("section", {
	    className: "logo-section-mobile"
	  }, h$2("div", {
	    className: "logo-position-mobile"
	  }, h$2(Logo, null)))), h$2("div", {
	    className: "desktop-view"
	  }, h$2("div", {
	    className: "desktop-view-block-1 desktop-view-block-1-".concat(isDark ? "dark" : "light")
	  }, h$2(RecordVideo, props), h$2("div", {
	    className: "x-utu-divider"
	  }), h$2(StarRatingInput, props)), h$2("div", {
	    className: "mb-3"
	  }, h$2(Badges, props)), h$2("div", {
	    className: "desktop-view-block-2 desktop-view-block-2-".concat(isDark ? "dark" : "light")
	  }, h$2(FeedbackTextInput, props)), h$2("div", {
	    className: "desktop-view-block-3 desktop-view-block-3-".concat(isDark ? "dark" : "light")
	  }, h$2(EndorsementForm, props)), h$2("section", {
	    className: "logo-section"
	  }, h$2("div", {
	    className: "logo-position"
	  }, h$2(Logo, null)))));
	}

	var css_248z$b = "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);\n.trust-video {\n  border: none;\n  width: 100%;\n  height: auto;\n  transform: rotateY(180deg);\n  -webkit-transform: rotateY(180deg); /* Safari and Chrome */\n  -moz-transform: rotateY(180deg); /* Firefox */\n}\n.trust-video-wrapper {\n  width: 100%;\n  margin-top: -80%;\n  align-items: center;\n}\n.trust-video-wrapper:hover .trust-video-controls {\n  visibility: visible;\n  opacity: 1;\n}\n.trust-video-msg {\n  display: flex;\n  align-items: center;\n}\n.trust-video-controls {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  margin-top: 35%;\n  transform: translate(0, -50%);\n  padding-left: 36px;\n  border-radius: 10px;\n  height: 4em;\n  align-items: center;\n  justify-content: space-between;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.25s ease-out;\n  display: none;\n}\n.trust-video-controls.show {\n  display: flex;\n}\n.trust-video-play {\n  border-color: transparent;\n  transition: 0.3s;\n  font-size: 3em;\n  margin: auto;\n  line-height: 1.5em;\n  width: 3em;\n  height: 3em;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  background-color: #ffdd33;\n  border-radius: 50%;\n  font: normal normal normal 18px/1 FontAwesome;\n}\n.trust-video-play:before {\n  content: \"\\f04b\";\n}\n.trust-video-play.paused:before {\n  content: \"\\f04c\";\n}\n.trust-video-volume {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  border-radius: 20%;\n  line-height: 1.5em;\n  width: 2em;\n  height: 1.5em;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  left: 20px;\n}\n.trust-video-volume:before {\n  content: \"\\f028\";\n}\n.trust-video-volume.off:before {\n  content: \"\\f026\";\n}\n.trust-video-fullscreen {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  line-height: 2.5rem;\n  width: 3em;\n  border-radius: 20%;\n  height: 2.5rem;\n  margin-right: 5%;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  right: 20px;\n}\n.trust-video-fullscreen:before {\n  content: \"\\f065\";\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .trust-video-wrapper {\n    margin-top: 20%;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .trust-video {\n    border: none;\n    width: 70%;\n  }\n}\nbody {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-feedback-details {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  width: 100vw;\n  position: relative;\n  z-index: 1;\n  justify-content: start;\n  border-bottom: 15px rgb(252, 229, 70) solid;\n}\n.utu-feedback-details-details {\n  justify-content: start;\n  max-height: 40rem;\n}\n.utu-feedback-details-video-popup {\n  justify-content: center;\n  max-height: 80rem;\n  height: 43rem;\n}\n\n.mobile-view {\n  visibility: visible;\n}\n\n.desktop-view {\n  display: none;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-feedback-details {\n    border-bottom: 0;\n    z-index: 1;\n    align-items: center;\n  }\n  .mobile-view {\n    display: none;\n  }\n  .desktop-view {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n  .desktop-view-block-1 {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    margin: 1rem 0;\n  }\n  .desktop-view-block-1-dark {\n    background-color: #3d3d3c;\n  }\n  .desktop-view-block-1-light {\n    background-color: #fcf8e5;\n  }\n  .desktop-view-block-2 {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    margin: 1rem 0;\n  }\n  .desktop-view-block-2-dark {\n    background-color: #3d3d3c;\n  }\n  .desktop-view-block-2-light {\n    background-color: #fcf8e5;\n  }\n}";
	styleInject(css_248z$b);

	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	var max = Math.max; // `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT
	}, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject(this);
	    var length = lengthOfArrayLike(O);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

	    var Constructor, result, n;

	    if (isArray$5(O)) {
	      Constructor = O.constructor; // cross-realm fallback

	      if (isConstructor(Constructor) && (Constructor === $Array || isArray$5(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject$2(Constructor)) {
	        Constructor = Constructor[SPECIES];
	        if (Constructor === null) Constructor = undefined;
	      }

	      if (Constructor === $Array || Constructor === undefined) {
	        return arraySlice$1(O, k, fin);
	      }
	    }

	    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));

	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

	    result.length = n;
	    return result;
	  }
	});

	var css_248z$a = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.endor-avatar {\n  width: 2rem;\n}\n\n.endorsement-body {\n  display: flex;\n}\n\n.truncate-text {\n  display: inline-block;\n  max-width: 5rem;\n  vertical-align: bottom;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.endor-text {\n  justify-content: space-around;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  font-size: 1rem;\n  align-items: center;\n}\n.endor-text-light {\n  color: black;\n}\n.endor-text-dark {\n  color: white;\n}\n.endor-text-section {\n  width: 100%;\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n  align-items: center;\n}\n.endor-text-stakes-item {\n  font-size: 1.5rem;\n}\n.endor-text-stakes-item-light {\n  color: black;\n}\n.endor-text-stakes-item-dark {\n  color: white;\n}\n.endor-text-stakes-item-2 {\n  font-size: 1rem;\n}\n.endor-text-stakes-item-2-light {\n  color: black;\n}\n.endor-text-stakes-item-2-dark {\n  color: white;\n}\n.endor-text-contacts-section {\n  padding-left: 2rem;\n  padding-right: 2rem;\n  font-size: 0.7rem;\n  width: 27em;\n  text-align: left;\n}\n.endor-text-contacts-section-light {\n  color: black;\n}\n.endor-text-contacts-section-dark {\n  color: white;\n}\n.endor-text-contacts-body {\n  font-size: 1rem;\n  margin-top: 0.5em;\n}\n.endor-text-image-item {\n  margin-left: -15px;\n  height: 4rem;\n  border-radius: 50%;\n}\n.endor-text-image-item-light {\n  border: 2px solid rgb(252, 229, 70);\n}\n.endor-text-image-item-dark {\n  border: 2px solid rgb(252, 229, 70);\n}";
	styleInject(css_248z$a);

	// const minLength = 5;
	var CONNECTION_TYPE_REF = {
	  //  twitter: "Your Twitter connection",
	  //  telegram: "Your Telegram contact"
	  twitter: "Twitter user",
	  telegram: "Telegram user"
	};
	var DEFAULT_CONNECTION_REF = "User";

	function getConnectionInfo(entity) {
	  if (!entity) return {
	    ref: "Someone"
	  }; // eslint-disable-next-line no-restricted-syntax

	  for (var key in CONNECTION_TYPE_REF) {
	    if (entity.properties[key]) {
	      return {
	        ref: CONNECTION_TYPE_REF[key],
	        name: entity.properties[key].name
	      };
	    }
	  } // No connection type was found, return default


	  return {
	    ref: DEFAULT_CONNECTION_REF,
	    name: entity.name
	  };
	}

	var SELF_INFO = {
	  ref: "You"
	};

	function getEndorsementTextBody(userUuid, endorsementInfo) {
	  var _connectionInfo$name, _endorsementInfo$endo;

	  var endorser = endorsementInfo.source;
	  var isSelf = endorser.uuid === userUuid;
	  var connectionInfo = isSelf ? SELF_INFO : getConnectionInfo(endorser);
	  var has = isSelf ? "have" : "has";
	  return h$2("p", {
	    className: "endor-text-contacts-body "
	  }, connectionInfo.ref, "\xA0", ((_connectionInfo$name = connectionInfo.name) === null || _connectionInfo$name === void 0 ? void 0 : _connectionInfo$name.length) > 0 && h$2("span", {
	    className: "truncate-text"
	  }, h$2("b", null, connectionInfo.name), "\xA0"), has, " endorsed ", h$2("b", {
	    className: "mx-1"
	  }, (_endorsementInfo$endo = endorsementInfo.endorsement) === null || _endorsementInfo$endo === void 0 ? void 0 : _endorsementInfo$endo.value, " UTT"));
	}

	function EndorsementsList(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  } // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  if (!props.feedbackSummary) {
	    return h$2(p$1, null);
	  }

	  var endorsements = props.feedbackSummary.endorsements;

	  if (!endorsements) {
	    return h$2(p$1, null);
	  }

	  var displayEndorsements = endorsements.slice(0, config.feedbackDetailsMaxEndorsements); // image

	  var img = displayEndorsements.map(function (i) {
	    var _i$source;

	    return (_i$source = i.source) === null || _i$source === void 0 ? void 0 : _i$source.image;
	  });

	  var endorImg = function endorImg() {
	    return h$2("img", {
	      className: "endor-text-image-item endor-text-image-item-".concat(envCondition),
	      src: img,
	      alt: "endorsment",
	      onError: function onError(e) {
	        e.target.onerror = null;
	        e.target.src = "";
	        e.target.className = "";
	        e.target.alt = "";
	      }
	    });
	  };

	  return h$2(BaseComponent, {
	    style: css_248z$a,
	    className: "endor-text-input-section utu-text-section-".concat(envCondition),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2("section", {
	    className: "endor-text-section utu-section-".concat(envCondition)
	  }, h$2("div", {
	    className: "endor-text endor-text-".concat(envCondition)
	  }, displayEndorsements.map(function (i) {
	    var _i$endorsement;

	    return h$2("div", {
	      className: "py-3 px-5 endorsement-body"
	    }, h$2("div", {
	      className: "endor-text-img"
	    }, endorImg()), h$2("div", {
	      className: "endor-text-contacts-section"
	    }, getEndorsementTextBody(props[ATTR_SOURCE_UUID], i)), h$2("div", {
	      className: "endor-text-stakes"
	    }, h$2("div", {
	      className: "endor-text-stakes-item"
	    }, h$2("b", null, (_i$endorsement = i.endorsement) === null || _i$endorsement === void 0 ? void 0 : _i$endorsement.value)), h$2("div", {
	      className: "endor-text-stakes-item-2"
	    }, h$2("b", null, "staked"))));
	  }))));
	}

	var css_248z$9 = ".stars-section {\n  display: flex;\n  justify-content: center;\n}\n.stars-text {\n  font-size: 0.8rem;\n  align-self: center;\n  text-align: left;\n  width: 12rem;\n}\n.stars-align {\n  display: flex;\n  align-items: center;\n  margin-top: 1.4rem;\n  margin-bottom: 1.4rem;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .stars-section {\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex;\n    justify-content: left;\n  }\n}";
	styleInject(css_248z$9);

	function StarRatingShow(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1]; // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  if (!props.feedbackSummary) {
	    return h$2(p$1, null);
	  } // star rating


	  var stars = props.feedbackSummary.stars.avg;
	  return h$2(BaseComponent, {
	    style: css_248z$9
	  }, h$2("section", {
	    className: "stars-section utu-section-".concat(envCondition)
	  }, h$2("div", {
	    className: "stars-align"
	  }, h$2(_default, {
	    count: 5,
	    value: stars,
	    size: 30,
	    color2: "#FFDD33",
	    edit: false,
	    className: "px-4"
	  }))));
	}

	var FAILS_ON_PRIMITIVES = fails(function () {
	  objectKeys(1);
	}); // `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys

	_export({
	  target: 'Object',
	  stat: true,
	  forced: FAILS_ON_PRIMITIVES
	}, {
	  keys: function keys(it) {
	    return objectKeys(toObject$1(it));
	  }
	});

	var css_248z$8 = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.badge-section {\n  padding-left: 1rem;\n  width: 40%;\n}\n\n.badge-container {\n  display: flex;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  box-sizing: border-box;\n}\n.badge-img {\n  border-radius: 50%;\n  height: 4rem;\n  width: 4rem;\n  margin-bottom: 0.5rem;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.badge-counter {\n  border-radius: 50%;\n  border: 1px rgb(235, 232, 232) solid;\n  height: 1rem;\n  width: 1rem;\n  font-size: 0.6rem;\n  justify-self: center;\n}\n.badge-counter-light {\n  background-color: rgb(253, 253, 253);\n  color: #000000;\n}\n.badge-counter-dark {\n  background-color: rgb(36, 35, 35);\n  color: #ffffff;\n}\n.badge-title {\n  padding-bottom: 0.5rem;\n  font-size: 0.7rem;\n}\n.badge-title-dark {\n  color: #ffffff;\n}\n.badge-title-light {\n  color: #000000;\n}\n.badge-counter-align {\n  align-items: center;\n}\n.badge-section {\n  display: flex;\n  justify-content: center;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  width: 100%;\n}\n.badge-spacing {\n  display: flex;\n  flex-direction: column;\n  margin-right: 0.5rem;\n  margin-left: 0.5rem;\n  padding-bottom: 3rem;\n  padding-top: 3rem;\n}\n.badge-position-child {\n  position: relative;\n  top: 2.6rem;\n  right: 1.3rem;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .badge-section {\n    width: 40%;\n  }\n}";
	styleInject(css_248z$8);

	function BadgesShow$1(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1]; // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  if (!props.feedbackSummary) {
	    return h$2(p$1, null);
	  } // fet badges and keys


	  var fbBadges = props.feedbackSummary.badges;
	  var keys = Object.keys(fbBadges); // returns the badge with image, counter and title

	  var badgeGroup = keys.map(function (key, i) {
	    var badges = fbBadges[key];
	    var badgeKeys = Object.keys(badges);
	    return badgeKeys.map(function (badgeKey) {
	      return h$2("div", {
	        key: badgeKey,
	        className: "badge-spacing"
	      }, h$2("div", {
	        className: "badge-container"
	      }, h$2("img", {
	        className: "badge-img",
	        src: badges[badgeKey].badge.image,
	        alt: "person face"
	      }), h$2("div", {
	        className: "badge-counter badge-counter-".concat(envCondition, " badge-position-child")
	      }, badges[badgeKey].count)), h$2("div", {
	        className: "badge-title badge-title-".concat(envCondition)
	      }, keys[i]));
	    });
	  });
	  return h$2(BaseComponent, {
	    style: css_248z$8,
	    className: "badge-section utu-section-no-border-".concat(isDark ? "dark" : "light"),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, h$2("section", {
	    className: "badge-section utu-section utu-section-".concat(envCondition)
	  }, badgeGroup));
	}

	var css_248z$7 = ".avatar-no-video {\n  width: 6rem;\n  height: 6rem;\n}";
	styleInject(css_248z$7);

	function Avatar(_ref) {
	  var props = Object.assign({}, _ref);

	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  return h$2("svg", {
	    style: css_248z$7,
	    version: "1.1",
	    id: "Capa_1",
	    xmlns: "http://www.w3.org/2000/svg",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    x: "4.5rem",
	    y: "4.5rem",
	    className: "avatar-no-video-".concat(isDark ? "dark" : "light"),
	    viewBox: "0 0 490.1 490.1",
	    xmlSpace: "preserve"
	  }, h$2("g", null, h$2("g", null, h$2("path", {
	    d: "M245,261.75c71.9,0,131.4-57.3,131.4-130.3S316.9,0.05,245,0.05s-131.4,57.3-131.4,130.3S173.1,261.75,245,261.75z M245,40.75c50,0,90.7,40.7,90.7,89.7s-40.7,89.6-90.7,89.6s-90.7-40.7-90.7-89.7S195,40.75,245,40.75z"
	  }), h$2("path", {
	    d: "M333.6,274.25c-8.3-2.1-16.7,0-21.9,6.3l-66.7,76.1l-66.7-76.1c-5.2-6.3-14.6-8.3-21.9-6.3C61.5,305.55,0,382.65,0,469.15 c0,11.5,9.4,20.9,20.9,20.9h448.3c11.5,0,20.9-9.4,20.9-20.9C490,382.65,428.5,305.55,333.6,274.25z M42.7,449.35 c8.4-57.3,50.1-106.3,114.7-131.3l73,83.4c7.3,9.4,22.9,9.4,30.2,0l73-83.4c63.6,25,106.4,75,114.7,131.3H42.7z"
	  }))));
	}

	var css_248z$6 = "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);\n.trust-video {\n  border: none;\n  width: 100%;\n  height: auto;\n  transform: rotateY(180deg);\n  -webkit-transform: rotateY(180deg); /* Safari and Chrome */\n  -moz-transform: rotateY(180deg); /* Firefox */\n}\n.trust-video-wrapper {\n  width: 100%;\n  margin-top: -80%;\n  align-items: center;\n}\n.trust-video-wrapper:hover .trust-video-controls {\n  visibility: visible;\n  opacity: 1;\n}\n.trust-video-msg {\n  display: flex;\n  align-items: center;\n}\n.trust-video-controls {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  margin-top: 35%;\n  transform: translate(0, -50%);\n  padding-left: 36px;\n  border-radius: 10px;\n  height: 4em;\n  align-items: center;\n  justify-content: space-between;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.25s ease-out;\n  display: none;\n}\n.trust-video-controls.show {\n  display: flex;\n}\n.trust-video-play {\n  border-color: transparent;\n  transition: 0.3s;\n  font-size: 3em;\n  margin: auto;\n  line-height: 1.5em;\n  width: 3em;\n  height: 3em;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  background-color: #ffdd33;\n  border-radius: 50%;\n  font: normal normal normal 18px/1 FontAwesome;\n}\n.trust-video-play:before {\n  content: \"\\f04b\";\n}\n.trust-video-play.paused:before {\n  content: \"\\f04c\";\n}\n.trust-video-volume {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  border-radius: 20%;\n  line-height: 1.5em;\n  width: 2em;\n  height: 1.5em;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  left: 20px;\n}\n.trust-video-volume:before {\n  content: \"\\f028\";\n}\n.trust-video-volume.off:before {\n  content: \"\\f026\";\n}\n.trust-video-fullscreen {\n  border-color: transparent;\n  color: rgba(43, 51, 63, 0.7);\n  font-size: 3em;\n  line-height: 2.5rem;\n  width: 3em;\n  border-radius: 20%;\n  height: 2.5rem;\n  margin-right: 5%;\n  font: normal normal normal 18px/1 FontAwesome;\n  background-color: rgba(255, 221, 51, 0.7);\n  right: 20px;\n}\n.trust-video-fullscreen:before {\n  content: \"\\f065\";\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .trust-video-wrapper {\n    margin-top: 20%;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .trust-video {\n    border: none;\n    width: 70%;\n  }\n}\nbody {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.feedback-details-profile {\n  cursor: pointer;\n}\n\n.utu-feedback {\n  position: relative;\n  width: 50%;\n  margin: auto;\n}\n\n.avatar-img {\n  border-radius: 50%;\n  height: 2rem;\n  border: 1px rgb(155, 152, 152) solid;\n}\n.avatar-img-top {\n  height: 5rem;\n  border-radius: 50%;\n  border: 4px solid rgb(252, 229, 70);\n}\n.avatar-img-top:not(:first-child) {\n  margin-left: -15px;\n}\n.avatar-img-top-video {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 2rem;\n  padding-top: 2rem;\n}\n.avatar-img-text {\n  font-size: 0.8rem;\n  text-align: left;\n  width: 19rem;\n}\n.avatar-no-img {\n  width: 6rem;\n  border-radius: 50%;\n  padding: 1.5rem;\n}\n.avatar-no-img-no-vid {\n  padding: 5px !important;\n}\n.avatar-no-img-light {\n  background-color: rgb(252, 229, 70);\n  border: 4px solid rgb(252, 229, 70);\n}\n.avatar-no-img-dark {\n  background-color: rgb(252, 229, 70);\n  border: 4px solid rgb(252, 229, 70);\n}\n.avatar-no-video-dark {\n  fill: #000000;\n}\n.avatar-no-video-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .avatar-img-top-video {\n    padding-bottom: 4rem;\n    padding-top: 4rem;\n  }\n  .avatar-no-img {\n    margin-bottom: 1rem;\n    margin-top: 0.5rem;\n  }\n}";
	styleInject(css_248z$6);

	function VideoShow(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1]; // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  if (!props.feedbackSummary) {
	    return h$2(p$1, null);
	  } // top image and video


	  var UserImageVideo = function UserImageVideo(_ref) {
	    var image = _ref.image,
	        url = _ref.url;

	    var _useState3 = p(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        videoVisible = _useState4[0],
	        setVideoVisible = _useState4[1];

	    return h$2("div", null, h$2("div", {
	      className: "feedback-details-profile",
	      onClick: function onClick() {
	        setVideoVisible(!videoVisible);
	      }
	    }, !image ? h$2("div", {
	      className: "ml-5 avatar-no-img avatar-no-img-".concat(envCondition)
	    }, h$2(Avatar, props)) : h$2("img", {
	      className: "avatar-img-top",
	      src: image,
	      alt: "person face"
	    })), videoVisible && url && h$2(PopUp, {
	      closeButtonOverlay: true,
	      onClose: function onClose() {
	        return setVideoVisible(false);
	      }
	    }, h$2(BaseComponent, {
	      style: css_248z$6,
	      className: "utu-feedback utu-feedback-video-popup"
	    }, Player(url, false), h$2("div", {
	      className: "logo-position-player"
	    }, h$2(Logo, null)))));
	  };

	  var video = props.feedbackSummary.video;
	  return h$2(BaseComponent, {
	    style: css_248z$6,
	    className: "video-section utu-section-no-border-".concat(isDark ? "dark" : "light"),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, video && h$2("section", {
	    className: "avatar-img-top-video \n          ".concat(video.url ? "utu-section-".concat(envCondition) : "")
	  }, !video.url ? h$2("div", {
	    className: "ml-5 avatar-no-img avatar-no-img-".concat(envCondition)
	  }, h$2(Avatar, props)) : h$2("div", {
	    className: "avatar-img-top-video"
	  }, h$2(UserImageVideo, {
	    url: video.url,
	    image: video.image
	  }))));
	}

	var css_248z$5 = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.video-avatar {\n  width: 2rem;\n}\n\n.video-placeholder {\n  height: 2rem;\n}\n\n.review-section {\n  width: 100vw;\n  display: flex;\n  white-space: nowrap;\n  overflow-x: scroll;\n}\n.review-text {\n  display: flex;\n  flex-direction: column;\n}\n.review-text-sum {\n  display: flex;\n  text-align: left;\n  padding-left: 1rem;\n  font-size: 1rem;\n  align-items: center;\n  margin: 0 8px;\n  white-space: pre-line;\n  width: 50px;\n  inline-size: 100%;\n  font-weight: bold;\n}\n.review-text-cont {\n  display: flex;\n  text-align: left;\n  padding-left: 1rem;\n  font-size: 1rem;\n  align-items: center;\n  margin: 0 8px;\n  white-space: pre-line;\n  width: 50px;\n  inline-size: 100%;\n}\n.review-text-dark {\n  color: #ffffff;\n}\n.review-text-light {\n  color: #000000;\n}\n.review-card {\n  font-size: 0.7rem;\n  display: flex;\n  padding: 1.5rem;\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n  justify-content: space-around;\n}\n.review-card-group {\n  width: 30rem;\n  display: flex;\n  padding: 2rem 2.5rem 2rem 1.5rem;\n  background-color: rgba(255, 221, 51, 0.15);\n  align-items: center;\n}\n.review-img {\n  border-radius: 50%;\n  height: 3rem;\n  border: 1px rgb(155, 152, 152) solid;\n}\n\n.onerror-review-img {\n  border-radius: 50%;\n  height: 3rem;\n  border: 1px rgb(155, 152, 152) solid;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .review-section {\n    width: 30%;\n    display: flex;\n    white-space: nowrap;\n    overflow-x: scroll;\n  }\n  .review-text-dark {\n    color: rgb(36, 35, 35);\n  }\n  .review-text-light {\n    color: #000000;\n  }\n  .review-card {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n    display: flex;\n    justify-content: center;\n    max-width: 100%;\n    overflow: hidden;\n    word-wrap: break-word !important;\n  }\n}";
	styleInject(css_248z$5);

	function BadgesShow(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1]; // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  if (!props.feedbackSummary) {
	    return h$2(p$1, null);
	  } // review
	  // const fbReviewImg = props.feedbackSummary.review?.image;
	  // const fbReviewContent = props.feedbackSummary.review?.content;


	  var fbReview = props.feedbackSummary.reviews;
	  console.log(fbReview);
	  return h$2(BaseComponent, {
	    style: css_248z$5,
	    className: "review-section utu-section-no-border-".concat(isDark ? "dark" : "light"),
	    excludeBootstrap: true,
	    excludeFonts: true
	  }, fbReview ? fbReview.map(function (rev) {
	    return h$2("section", null, h$2("div", {
	      className: "review-card utu-section-no-border-mid-".concat(envCondition)
	    }, h$2("div", {
	      className: "review-card-group"
	    }, rev.image ? h$2("img", {
	      className: "review-img",
	      src: rev.image,
	      onError: function onError(e) {
	        e.target.onerror = null;
	        e.target.src = "";
	        e.target.className = "";
	        e.target.alt = "";
	      },
	      alt: "person face"
	    }) : h$2("div", {
	      className: "ml-5 video-avatar"
	    }, h$2(Avatar, props)), h$2("div", {
	      className: "review-text"
	    }, h$2("div", {
	      className: "review-text-sum review-text-".concat(envCondition)
	    }, rev.summary), h$2("div", {
	      className: "review-text-cont review-text-".concat(envCondition)
	    }, rev.content)))));
	  }) : null);
	}

	function FeedbackDetails(props) {
	  // environments
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDark = _useState2[0],
	      setIsDark = _useState2[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  var _getBaseProps = getBaseProps(props, TAG_FEEDBACK_DETAILS_POPUP),
	      apiUrl = _getBaseProps.apiUrl;

	  var sourceUuid = props[ATTR_SOURCE_UUID];
	  var targetUuid = props[ATTR_TARGET_UUID];

	  var _useFeedbackSummaryAp = useFeedbackSummaryApi(apiUrl, sourceUuid, targetUuid),
	      feedbackSummary = _useFeedbackSummaryAp.feedbackSummary;

	  return h$2(BaseComponent, {
	    style: css_248z$b,
	    className: "utu-feedback-details"
	  }, h$2("div", {
	    className: "mobile-view"
	  }, h$2(VideoShow, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(StarRatingShow, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(BadgesShow$1, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(EndorsementsList, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(BadgesShow, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2("section", {
	    className: "logo-section"
	  }, h$2("div", {
	    className: "logo-position"
	  }, h$2(Logo, null)))), h$2("div", {
	    className: "desktop-view"
	  }, h$2("div", {
	    className: "desktop-view-block-1 desktop-view-block-1-".concat(isDark ? "dark" : "light")
	  }, h$2(VideoShow, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(StarRatingShow, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(BadgesShow, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  }))), h$2("div", {
	    className: "desktop-view-block-2 desktop-view-block-2-".concat(isDark ? "dark" : "light")
	  }, h$2(BadgesShow$1, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  })), h$2(EndorsementsList, _extends$1({}, props, {
	    feedbackSummary: feedbackSummary
	  }))), h$2("section", {
	    className: "logo-section"
	  }, h$2("div", {
	    className: "logo-position-details"
	  }, h$2(Logo, null)))));
	}

	var css_248z$4 = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-feedback-details-popup {\n  padding: 0.5rem;\n  border-radius: 15px;\n}\n\n.utu-feedback-form-popup {\n  padding: 0.5rem;\n}";
	styleInject(css_248z$4);

	function FeedbackPopup(props) {
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      popUpVisible = _useState2[0],
	      setPopUpVisible = _useState2[1]; // environments


	  var _useState3 = p(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDark = _useState4[0],
	      setIsDark = _useState4[1]; // environment conditionals


	  var envCondition = isDark ? "dark" : "light";

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  }

	  return h$2(BaseComponent, {
	    style: css_248z$4,
	    className: "d-flex flex-column align-items-strath justify-content-center \n    utu-feedback-details-popup utu-section utu-section-no-border-".concat(envCondition)
	  }, h$2("button", {
	    type: "button",
	    style: {
	      backgroundColor: props[ATTR_BTN_COLOR] === undefined ? null : "".concat(props[ATTR_BTN_COLOR])
	    },
	    className: "btn btn-".concat(envCondition, " x-utu-border-radius"),
	    onClick: function onClick() {
	      return setPopUpVisible(true);
	    }
	  }, "Show Feedback Details"), popUpVisible && h$2(PopUp, _extends$1({
	    onClose: function onClose() {
	      return setPopUpVisible(false);
	    }
	  }, props), h$2(FeedbackDetails, props)));
	}

	function FeedbackFormPopup(props) {
	  var _useState = p(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      popUpVisible = _useState2[0],
	      setPopUpVisible = _useState2[1]; // environments


	  var _useState3 = p(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDark = _useState4[0],
	      setIsDark = _useState4[1];

	  if (props[ATTR_THEME_COLOR] === "dark") {
	    setIsDark(true);
	  } // environment conditionals


	  var envCondition = isDark ? "dark" : "light";
	  return h$2(BaseComponent, {
	    style: css_248z$m,
	    className: "d-flex flex-column align-items-stretch justify-content-center\n      utu-feedback-form-popup utu-section utu-section-no-border-".concat(envCondition)
	  }, h$2("button", {
	    type: "button",
	    style: {
	      backgroundColor: props[ATTR_BTN_COLOR] === undefined ? null : "".concat(props[ATTR_BTN_COLOR])
	    },
	    className: "btn btn-".concat(envCondition, " x-utu-border-radius"),
	    onClick: function onClick() {
	      return setPopUpVisible(true);
	    }
	  }, "Give feedback"), popUpVisible && h$2(PopUp, _extends$1({
	    onClose: function onClose() {
	      return setPopUpVisible(false);
	    }
	  }, props), h$2(FeedbackForm, props)));
	} // style={{backgroundColor: `${props[ATTR_BTN_COLOR]} || yellow ` }}

	var css_248z$3 = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-Header {\n  width: 100vw;\n  padding: 2rem 3rem;\n  background-color: #fcf8e5;\n  display: flex;\n  justify-content: center;\n}";
	styleInject(css_248z$3);

	function Header() {
	  return h$2(BaseComponent, {
	    style: css_248z$3
	  }, h$2("section", {
	    className: "utu-Header utu-section"
	  }, h$2("h3", null, " Feedback From Your Network ")));
	}

	var css_248z$2 = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-app-link {\n  width: 100%;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  background-color: rgb(252, 229, 70);\n  border: none;\n}\n\na {\n  text-decoration: none;\n  color: black;\n}\n\na :hover {\n  color: black;\n}";
	styleInject(css_248z$2);

	function UtuAppSocialLink() {
	  var _getUtuSocialLink = getUtuSocialLink(),
	      socialLinkUrl = _getUtuSocialLink.socialLinkUrl;

	  return h$2(BaseComponent, {
	    style: css_248z$2
	  }, h$2("button", {
	    className: "utu-app-link btn",
	    type: "button"
	  }, h$2("a", {
	    href: socialLinkUrl,
	    target: "_blank",
	    rel: "noreferrer"
	  }, " ", h$2("h3", {
	    className: "mt-1"
	  }, "Connect to earn"), " ")));
	}

	var css_248z$1 = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.utu-wallet-connect {\n  width: 100%;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  background-color: #fcf8e5;\n}\n\n.text-input-btn {\n  width: 100%;\n  background-color: rgb(252, 229, 70);\n}";
	styleInject(css_248z$1);

	function WalletConnect() {
	  var _useWalletConnectApi = useWalletConnectApi(),
	      web3Modal = _useWalletConnectApi.web3Modal;

	  function connectWallet() {
	    return _connectWallet.apply(this, arguments);
	  }

	  function _connectWallet() {
	    _connectWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	      var provider, ethersProvider, userAddress;
	      return _regeneratorRuntime().wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return web3Modal.connect();

	            case 2:
	              provider = _context.sent;
	              ethersProvider = new Web3Provider(provider);
	              _context.next = 6;
	              return ethersProvider.getSigner().getAddress();

	            case 6:
	              userAddress = _context.sent;
	              wallet.address = userAddress;

	            case 8:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee);
	    }));
	    return _connectWallet.apply(this, arguments);
	  }

	  return h$2(BaseComponent, {
	    style: css_248z$1,
	    className: "utu-wallet-connect"
	  }, h$2("section", {
	    className: "py-2 px-2 wallet-connect-section"
	  }, h$2("p", {
	    className: "utu-wallet-connect-text"
	  }, "See UTU trust signals from your network"), h$2("div", null, h$2("button", {
	    onClick: connectWallet,
	    className: "mt-3 text-input-btn btn",
	    type: "submit"
	  }, "Connect Wallet"))));
	}

	var css_248z = "body {\n  overflow: scroll;\n}\n\nh3 {\n  text-transform: capitalize;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.error {\n  color: #e80054;\n}\n\n:host {\n  margin: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: #000000;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  50% {\n    transform: rotate(180deg);\n    border-top-color: rgb(252, 229, 70);\n    border-bottom-color: rgb(155, 152, 152);\n    border-right-color: transparent;\n    border-left-color: transparent;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 21px;\n  height: 21px;\n  display: inline-block;\n  border: 3px solid rgb(252, 229, 70);\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s infinite;\n  margin: 12px;\n}\n\n.utu-section {\n  width: 100%;\n}\n.utu-section-light {\n  border-bottom: 1px solid rgb(155, 152, 152);\n  background: rgb(253, 253, 253);\n}\n.utu-section-dark {\n  border-bottom: 1px solid rgb(235, 232, 232);\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-dark {\n  background: rgb(36, 35, 35);\n}\n.utu-section-no-border-mid-light {\n  background: rgb(253, 253, 253);\n}\n.utu-section-no-border-mid-dark {\n  background: #494949;\n}\n\n.btn {\n  padding: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.btn-light {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-dark {\n  background-color: rgb(252, 229, 70);\n  color: #000000 !important;\n}\n.btn-round {\n  color: white !important;\n}\n.btn-round-text {\n  color: white !important;\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: Roboto, system-ui, -apple-system, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.icon-btn svg {\n  width: 60px;\n  height: 60px;\n}\n\nbutton.p {\n  color: white;\n}\n\n.submit-result, .submit-error, .submit-success {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n}\n.submit-result svg, .submit-error svg, .submit-success svg {\n  width: 45px;\n  height: 45px;\n  margin: auto;\n}\n\n.logo-position {\n  position: absolute;\n  top: -1rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-details {\n  position: absolute;\n  top: -2rem;\n  right: 6rem;\n  z-index: 0;\n  width: 0.5rem;\n}\n.logo-position-player {\n  position: absolute;\n  bottom: -0.5rem;\n  left: 22rem;\n  z-index: 0;\n  display: none;\n  width: 0.5rem;\n}\n.logo-position-mobile {\n  position: absolute;\n  top: -1rem;\n  right: 4rem;\n  z-index: 2;\n  width: 0.5rem;\n}\n.logo-section {\n  position: relative;\n}\n.logo-section-mobile {\n  position: relative;\n}\n.logo-size {\n  width: 3rem;\n}\n.logo-video-section {\n  position: relative;\n}\n.logo-video-position {\n  position: absolute;\n  z-index: 0;\n  display: none;\n  width: 5rem;\n  left: 21rem;\n  top: 35.6rem;\n}\n\n.text-area {\n  resize: vertical;\n  min-height: 8rem;\n  border-radius: 10px;\n  border: none;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 0.9rem;\n  background-color: rgba(255, 221, 51, 0.1);\n}\n\nsvg.video-icon {\n  width: 3rem;\n  height: 2.4rem;\n}\nsvg.video-icon-dark {\n  fill: #000000;\n}\nsvg.video-icon-light {\n  fill: #000000;\n}\n\n/* ----------- Large screens ----------- */\n@media only screen and (min-width: 768px) {\n  .utu-section {\n    width: 100%;\n  }\n  .utu-section-light {\n    border-bottom: 0;\n    background-color: #fcf8e5;\n  }\n  .utu-section-dark {\n    border-bottom: 0;\n    background: rgb(36, 35, 35);\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-dark {\n    background-color: #3d3d3c;\n  }\n  .utu-section-no-border-mid-light {\n    background-color: #fcf8e5;\n  }\n  .utu-section-no-border-mid-dark {\n    background-color: #3d3d3c;\n  }\n  .text-area {\n    background-color: rgba(255, 221, 51, 0.1);\n  }\n  .logo-position-video {\n    top: 41.2rem;\n    position: absolute;\n    left: 21rem;\n  }\n  .logo-section {\n    position: relative;\n  }\n}\n.x-utu-border-radius {\n  border-radius: 15px;\n}\n\n.x-utu-Disconnect-wallet-btn {\n  width: 100%;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  background-color: #fcf8e5;\n}\n\n.text-input-btn {\n  width: 100%;\n  background-color: rgb(252, 229, 70);\n}";
	styleInject(css_248z);

	function DisconnectWallet() {
	  var _useWalletConnectApi = useWalletConnectApi(),
	      web3Modal = _useWalletConnectApi.web3Modal;

	  function disconnectWallet() {
	    return _disconnectWallet.apply(this, arguments);
	  }

	  function _disconnectWallet() {
	    _disconnectWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	      var provider;
	      return _regeneratorRuntime().wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return web3Modal.cachedProvider;

	            case 2:
	              provider = _context.sent;
	              _context.next = 5;
	              return web3Modal.clearCachedProvider();

	            case 5:
	              if (!(provider !== null && provider !== void 0 && provider.disconnect && typeof provider.disconnect === "function")) {
	                _context.next = 8;
	                break;
	              }

	              _context.next = 8;
	              return provider.disconnect();

	            case 8:
	              if (!(provider !== null && provider !== void 0 && provider.close && typeof provider.close === "function")) {
	                _context.next = 11;
	                break;
	              }

	              _context.next = 11;
	              return provider.close();

	            case 11:
	              _context.next = 13;
	              return localStorage.removeItem("walletconnect");

	            case 13:
	              window.location.reload();

	            case 14:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee);
	    }));
	    return _disconnectWallet.apply(this, arguments);
	  }

	  return h$2(BaseComponent, {
	    style: css_248z
	  }, h$2("section", {
	    className: "py-2 px-2 x-utu-Disconnect-wallet-btn"
	  }, h$2("div", null, h$2("button", {
	    onClick: disconnectWallet,
	    className: "mt-3 text-input-btn btn",
	    type: "submit"
	  }, "Disconnect Wallet"))));
	}

	window.addEventListener(EVENT_UTU_IDENTITY_DATA_READY, function (event) {
	  localStorage.setItem(LOCAL_STORAGE_KEY_UTU_IDENTITY_DATA, JSON.stringify(event.detail));
	});
	register$2(Header, TAG_HEADER, [], {
	  shadow: true
	});
	register$2(UtuAppSocialLink, TAG_UTU_APP_LINK, [], {
	  shadow: true
	});
	register$2(WalletConnect, TAG_WALLET_CONNECT, [], {
	  shadow: true
	});
	register$2(DisconnectWallet, TAG_WALLET_DISCONNECT, [], {
	  shadow: true
	});
	register$2(UttBalance, TAG_UTT_BALANCE, [], {
	  shadow: true
	});
	register$2(Root, TAG_ROOT, [ATTR_API_URL, ATTR_SOURCE_UUID, ATTR_TARGET_TYPE, ATTR_TARGET_UUIDS], {
	  shadow: true
	});
	register$2(Recommendation, TAG_RECOMMENDATION, [ATTR_TARGET_UUID], {
	  shadow: true
	});
	register$2(FeedbackForm, TAG_FEEDBACK_FORM, [ATTR_API_URL, ATTR_SOURCE_UUID, ATTR_TARGET_UUID, ATTR_TRANSACTION_ID, ATTR_ENDORSEMENT_NETWORK], {
	  shadow: true
	});
	register$2(FeedbackFormPopup, TAG_FEEDBACK_FORM_POPUP, [ATTR_API_URL, ATTR_SOURCE_UUID, ATTR_TARGET_UUID, ATTR_TRANSACTION_ID, ATTR_ENDORSEMENT_NETWORK, ATTR_BTN_COLOR], {
	  shadow: true
	});
	register$2(FeedbackPopup, TAG_FEEDBACK_DETAILS_POPUP, [ATTR_API_URL, ATTR_BTN_COLOR], {
	  shadow: true
	});
	register$2(FeedbackDetails, TAG_FEEDBACK_DETAILS, [ATTR_API_URL, ATTR_SOURCE_UUID, ATTR_TARGET_UUID], {
	  shadow: true
	});

	exports.addressSignatureVerification = addressSignatureVerification;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.js.map
